import React, { useState, useEffect, useRef } from "react";
import {
  NavigationContainer,
  createNavigationContainerRef,
} from "@react-navigation/native";

const navigationRef = createNavigationContainerRef<any>();
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  TextInput,
  Alert,
  ScrollView,
  FlatList,
  Image,
  ImageBackground,
  Animated,
  Easing,
  Dimensions,
  Linking,
  ActivityIndicator,
  Modal,
  Switch,
  Platform,
  KeyboardAvoidingView,
  BackHandler,
} from "react-native";
import { SafeAreaProvider, SafeAreaView } from "react-native-safe-area-context";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { initializeApp, getApps, getApp } from "firebase/app";

// Import React Native Firebase or Web Firebase based on platform
const isWeb = Platform.OS === "web";

// For React Native, we'll use ONLY the web SDK for both auth and Firestore
// This ensures they work together properly (same auth state)
// We'll use AsyncStorage for persistence instead of native modules

// Import web SDK
import {
  getAuth as getAuthWeb,
  initializeAuth,
  browserLocalPersistence,
  indexedDBLocalPersistence,
  GoogleAuthProvider,
  signInWithPopup,
  browserPopupRedirectResolver,
  getReactNativePersistence as _getRNPersistenceFromWrapper,
} from "firebase/auth";

// IMPORTANT: `firebase/auth` (the wrapper package) does NOT export
// `getReactNativePersistence` in its React Native / ESM / CJS bundles — only
// the scoped `@firebase/auth` package exposes it via its `react-native`
// conditional entry. If we only rely on the wrapper import, the function is
// `undefined` at runtime, `initializeAuth` throws, and auth silently falls
// back to in-memory persistence → user is signed out after every app restart.
// Resolve the real function from whichever source actually has it.
let getReactNativePersistence: any = _getRNPersistenceFromWrapper;
if (typeof getReactNativePersistence !== "function" && Platform.OS !== "web") {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const scoped = require("@firebase/auth");
    if (typeof scoped.getReactNativePersistence === "function") {
      getReactNativePersistence = scoped.getReactNativePersistence;
    }
  } catch (_e) {
    /* fall through */
  }
}
if (typeof getReactNativePersistence !== "function" && Platform.OS !== "web") {
  try {
    // Last-resort: the RN-specific build inside @firebase/auth.
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const rnBundle = require("@firebase/auth/dist/rn/index.js");
    if (typeof rnBundle.getReactNativePersistence === "function") {
      getReactNativePersistence = rnBundle.getReactNativePersistence;
    }
  } catch (_e) {
    /* fall through */
  }
}
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  collection,
  getDocs,
  addDoc,
  query as dbQuery,
  orderBy,
  limit,
  where,
  startAfter,
  getCountFromServer,
  arrayUnion,
  onSnapshot,
  deleteDoc,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import * as ImagePicker from "expo-image-picker";
import * as DocumentPicker from "expo-document-picker";
import TelegramChannelsScreen from "./src/screens/TelegramChannelsScreen";
import AnnouncementsScreen from "./src/screens/AnnouncementsScreen";
import PaymentScreen from "./src/screens/PaymentScreen";
import UnauthorizedScreen from "./src/screens/UnauthorizedScreen";
import { FEATURES } from "./src/config/features";
import AdBanner from "./src/components/AdBanner";
import { useJobSearch } from "./src/hooks/useAlgoliaSearch";
import BankConfigurationContent from "./src/components/BankConfigurationContent";
import PaymentRequestsContent from "./src/components/PaymentRequestsContent";
import ScrapeHistoryContent from "./src/components/ScrapeHistoryContent";
import UserDetailModal, {
  pickAvatarUrl,
} from "./src/components/UserDetailModal";
import Icon from "@expo/vector-icons/MaterialIcons";
import { useAppFonts, fonts } from "./src/utils/fonts";
import { setupProductionLogging } from "./src/utils/logger";
import { useNotificationPermission } from "./src/hooks/useNotificationPermission";

// recharts is web-only (uses DOM APIs); lazy-load to avoid crash on React Native
let PieChart: any,
  Pie: any,
  Cell: any,
  ResponsiveContainer: any,
  BarChart: any,
  Bar: any,
  XAxis: any,
  YAxis: any,
  CartesianGrid: any,
  Tooltip: any,
  Legend: any,
  AreaChart: any,
  Area: any,
  RadialBarChart: any,
  RadialBar: any,
  ScatterChart: any,
  Scatter: any,
  ZAxis: any;
if (Platform.OS === "web") {
  const recharts = require("recharts");
  ({
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    AreaChart,
    Area,
    RadialBarChart,
    RadialBar,
    ScatterChart,
    Scatter,
    ZAxis,
  } = recharts);
}

// Suppress console output in production builds
setupProductionLogging();

// Wrap GoogleSignin in try-catch to prevent crash on load (only for native)
let GoogleSignin: any = null;
if (Platform.OS !== "web") {
  try {
    const googleSigninModule = require("@react-native-google-signin/google-signin");
    GoogleSignin = googleSigninModule.GoogleSignin;
    console.log("✅ GoogleSignin module loaded successfully");
  } catch (e) {
    console.error("❌ GoogleSignin module not available:", e);
    console.error(
      "Please ensure @react-native-google-signin/google-signin is properly installed",
    );
  }
}

// Firebase configuration - use different config for web vs native
const firebaseConfig = isWeb
  ? {
      // Web config
      apiKey: "AIzaSyB5xT3pwzhqPqs4ulx9rtgWne39Pxr2H3Q",
      authDomain: "nibjobs-dev.firebaseapp.com",
      projectId: "nibjobs-dev",
      storageBucket: "nibjobs-dev.firebasestorage.app",
      messagingSenderId: "921124469397",
      appId: "1:921124469397:web:fbfe41c7f0eff695a9f99c",
      measurementId: "G-427ZVFZS6G",
    }
  : {
      // Android/iOS config
      apiKey: "AIzaSyCYYavl-JsiPGcFhWSw7vGMPCbVhqt5pBQ",
      authDomain: "nibjobs-dev.firebaseapp.com",
      projectId: "nibjobs-dev",
      storageBucket: "nibjobs-dev.firebasestorage.app",
      messagingSenderId: "921124469397",
      appId: "1:921124469397:android:4dcb0020fee8cb5ca9f99c",
    };

// Initialize Firebase with proper persistence
// Store globally to persist across hot reloads
if (!(global as any).__firebaseInitialized) {
  console.log("🔥 Initializing Firebase for first time");

  if (isWeb) {
    // Web - use standard firebase/auth with IndexedDB persistence
    const app = initializeApp(firebaseConfig);
    try {
      (global as any).__firebaseAuth = initializeAuth(app, {
        persistence: [indexedDBLocalPersistence, browserLocalPersistence],
      });
      console.log("🔥 Web auth initialized with IndexedDB persistence");
    } catch (error) {
      console.warn("Web auth init failed:", error);
      (global as any).__firebaseAuth = getAuthWeb(app);
    }
    (global as any).__firebaseApp = app;
  } else {
    // React Native - use Web SDK with AsyncStorage persistence.
    // Use getApp() if Firebase was already initialized (e.g. after Fast Refresh),
    // to avoid triggering a duplicate-app error.
    const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
    (global as any).__firebaseApp = app;

    // If `getReactNativePersistence` isn't available, warn loudly.
    if (typeof getReactNativePersistence !== "function") {
      console.error(
        "❌ getReactNativePersistence is not available. Auth state WILL NOT persist across app restarts.",
      );
    }

    try {
      (global as any).__firebaseAuth = initializeAuth(app, {
        persistence: getReactNativePersistence(AsyncStorage),
      });
      console.log(
        "🔥 React Native auth initialized with AsyncStorage persistence via Web SDK",
      );
    } catch (error: any) {
      // auth/already-initialized is expected after Fast Refresh — the existing
      // auth instance already has the correct persistence settings, so reuse it.
      if (error?.code === "auth/already-initialized") {
        (global as any).__firebaseAuth = getAuthWeb(app);
        console.log(
          "🔥 Reusing existing Firebase auth instance (Fast Refresh)",
        );
      } else {
        console.error("❌ React Native auth init failed:", error);
        (global as any).__firebaseAuth = getAuthWeb(app);
      }
    }
  }

  (global as any).__firebaseInitialized = true;
} else {
  console.log("🔥 Reusing existing Firebase instances");
}

const app = (global as any).__firebaseApp;
const auth = (global as any).__firebaseAuth;
console.log("🔥 Platform.OS:", Platform.OS);
console.log("🔥 isWeb:", isWeb);
console.log("🔥 Firebase auth active:", !!auth);

// Initialize Firestore, Functions, and Storage using Web SDK for all platforms
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);

// Fire-and-forget engagement tracking for the superadmin dashboard.
// Job views are counted once per job per app session so refreshes don't inflate them.
const trackedJobViews = new Set<string>();
const trackInteraction = (
  type: "job_view" | "apply_click" | "job_save" | "daily_active",
  jobId?: string,
) => {
  if (type === "job_view" && jobId) {
    if (trackedJobViews.has(jobId)) return;
    trackedJobViews.add(jobId);
  }
  httpsCallable(functions, "trackInteraction")({ type, jobId }).catch((err) =>
    console.warn("trackInteraction failed:", err?.message),
  );
};

// Auth wrapper functions - using web SDK for all platforms now
const signInWithEmailAndPassword = async (
  authInstance: any,
  email: string,
  password: string,
) => {
  const { signInWithEmailAndPassword: webSignIn } = require("firebase/auth");
  return webSignIn(authInstance, email, password);
};

const createUserWithEmailAndPassword = async (
  authInstance: any,
  email: string,
  password: string,
) => {
  const {
    createUserWithEmailAndPassword: webCreate,
  } = require("firebase/auth");
  return webCreate(authInstance, email, password);
};

const signInWithCredential = async (authInstance: any, credential: any) => {
  const { signInWithCredential: webSignInCred } = require("firebase/auth");
  return webSignInCred(authInstance, credential);
};

const onAuthStateChanged = (
  authInstance: any,
  callback: (user: any) => void,
) => {
  const { onAuthStateChanged: webOnAuth } = require("firebase/auth");
  return webOnAuth(authInstance, callback);
};

const signOut = async (authInstance: any) => {
  const { signOut: webSignOut } = require("firebase/auth");
  return webSignOut(authInstance);
};

const sendEmailVerification = async (user: any, actionCodeSettings?: any) => {
  const { sendEmailVerification: webSendVerif } = require("firebase/auth");
  return webSendVerif(user, actionCodeSettings);
};

const sendPasswordResetEmail = async (authInstance: any, email: string) => {
  const { sendPasswordResetEmail: webResetEmail } = require("firebase/auth");
  return webResetEmail(authInstance, email);
};

// Remove the timestamp conversion functions since we're using web SDK for everything now

// Firebase operations counter for dev tools
const FirebaseOpsContext = React.createContext<{
  reads: number;
  writes: number;
  incrementReads: (count?: number) => void;
  incrementWrites: (count?: number) => void;
  reset: () => void;
}>({
  reads: 0,
  writes: 0,
  incrementReads: () => {},
  incrementWrites: () => {},
  reset: () => {},
});

// ─── Global Custom Alert Modal ─────────────────────────────────────────
type AlertType = "success" | "error" | "warning" | "info";

interface AppAlertState {
  visible: boolean;
  type: AlertType;
  title: string;
  message: string;
  buttonText?: string;
  onClose?: () => void;
}

const AppAlertContext = React.createContext<{
  showAlert: (
    type: AlertType,
    title: string,
    message: string,
    options?: { buttonText?: string; onClose?: () => void },
  ) => void;
}>({ showAlert: () => {} });

const useAppAlert = () => React.useContext(AppAlertContext);

function AppAlertModal({
  state,
  onDismiss,
  isDarkMode,
}: {
  state: AppAlertState;
  onDismiss: () => void;
  isDarkMode: boolean;
}) {
  const scaleAnim = React.useRef(new Animated.Value(0)).current;
  const opacityAnim = React.useRef(new Animated.Value(0)).current;

  React.useEffect(() => {
    if (state.visible) {
      Animated.parallel([
        Animated.spring(scaleAnim, {
          toValue: 1,
          useNativeDriver: true,
          tension: 100,
          friction: 8,
        }),
        Animated.timing(opacityAnim, {
          toValue: 1,
          duration: 200,
          useNativeDriver: true,
        }),
      ]).start();
    } else {
      scaleAnim.setValue(0);
      opacityAnim.setValue(0);
    }
  }, [state.visible]);

  if (!state.visible) return null;

  const iconMap: Record<
    AlertType,
    { name: string; bg: string; color: string }
  > = {
    success: {
      name: "check-circle",
      bg: isDarkMode ? "rgba(16,185,129,0.15)" : "#ECFDF5",
      color: "#10B981",
    },
    error: {
      name: "error",
      bg: isDarkMode ? "rgba(239,68,68,0.15)" : "#FEF2F2",
      color: "#EF4444",
    },
    warning: {
      name: "warning",
      bg: isDarkMode ? "rgba(245,158,11,0.15)" : "#FFFBEB",
      color: "#F59E0B",
    },
    info: {
      name: "info",
      bg: isDarkMode ? "rgba(59,130,246,0.15)" : "#EFF6FF",
      color: "#3B82F6",
    },
  };

  const icon = iconMap[state.type] || iconMap.info;
  const bgColor = isDarkMode ? "#1A1D23" : "#FFFFFF";
  const textColor = isDarkMode ? "#F9FAFB" : "#111827";
  const subTextColor = isDarkMode ? "#9CA3AF" : "#6B7280";

  const handleDismiss = () => {
    Animated.parallel([
      Animated.timing(scaleAnim, {
        toValue: 0,
        duration: 150,
        useNativeDriver: true,
      }),
      Animated.timing(opacityAnim, {
        toValue: 0,
        duration: 150,
        useNativeDriver: true,
      }),
    ]).start(() => {
      onDismiss();
      state.onClose?.();
    });
  };

  return (
    <Modal
      transparent
      visible={state.visible}
      animationType="none"
      statusBarTranslucent
    >
      <TouchableOpacity
        activeOpacity={1}
        onPress={handleDismiss}
        style={{
          flex: 1,
          backgroundColor: "rgba(0,0,0,0.5)",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
        }}
      >
        <Animated.View
          style={{
            opacity: opacityAnim,
            transform: [{ scale: scaleAnim }],
            width: "100%",
            maxWidth: 400,
          }}
        >
          <TouchableOpacity
            activeOpacity={1}
            onPress={(e) => e.stopPropagation()}
          >
            <View
              style={{
                backgroundColor: bgColor,
                borderRadius: 20,
                padding: 28,
                alignItems: "center",
                ...Platform.select({
                  web: { boxShadow: "0 25px 50px rgba(0,0,0,0.25)" },
                  ios: {
                    shadowColor: "#000",
                    shadowOffset: { width: 0, height: 12 },
                    shadowOpacity: 0.25,
                    shadowRadius: 25,
                  },
                  android: { elevation: 25 },
                }),
              }}
            >
              {/* Icon */}
              <View
                style={{
                  width: 72,
                  height: 72,
                  borderRadius: 36,
                  backgroundColor: icon.bg,
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 20,
                }}
              >
                <Icon name={icon.name as any} size={36} color={icon.color} />
              </View>

              {/* Title */}
              <Text
                style={{
                  fontSize: 20,
                  fontWeight: "700",
                  fontFamily: fonts.bold,
                  color: textColor,
                  textAlign: "center",
                  marginBottom: 10,
                }}
              >
                {state.title}
              </Text>

              {/* Message */}
              <Text
                style={{
                  fontSize: 14,
                  lineHeight: 22,
                  fontFamily: fonts.regular,
                  color: subTextColor,
                  textAlign: "center",
                  marginBottom: 24,
                  paddingHorizontal: 8,
                }}
              >
                {state.message}
              </Text>

              {/* Button */}
              <TouchableOpacity
                onPress={handleDismiss}
                style={{
                  width: "100%",
                  paddingVertical: 14,
                  borderRadius: 12,
                  backgroundColor: icon.color,
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 15,
                    fontWeight: "700",
                    fontFamily: fonts.bold,
                    color: "#FFFFFF",
                  }}
                >
                  {state.buttonText || "OK"}
                </Text>
              </TouchableOpacity>
            </View>
          </TouchableOpacity>
        </Animated.View>
      </TouchableOpacity>
    </Modal>
  );
}

// Brand colors - Updated with modern palette
const lightColors = {
  beeYellow: "#F4C430",
  honeyGold: "#D4AF37",
  darkYellow: "#B8860B",
  deepNavy: "#000000",
  charcoal: "#2C2C2C",
  cream: "#FFF9E6",
  white: "#FFFFFF",
  warmGray: "#6B6B6B",
  lightGray: "#F5F5F5",
  softBlue: "#FF8C42", // Dark orange accent for light theme
  success: "#27AE60",
  danger: "#E74C3C",
  error: "#E74C3C",
  lightPeach: "#FFE5CC",
  buttonTextOnYellow: "#78350F", // Dark orange text for yellow buttons
  // Modern sidebar colors
  sidebarBg: "#F8FAFC", // Light gray-blue
  sidebarText: "#475569", // Slate gray
  sidebarTextActive: "#0F172A", // Dark slate
  sidebarAccent: "#FF8C42", // Dark orange accent
  sidebarAccentLight: "#FFF5E6", // Light orange variant
  sidebarBorder: "#E2E8F0", // Subtle border
  sidebarHover: "#F1F5F9", // Hover state
  // Admin panel surface colors (shared across all admin views)
  adminHeaderBg: "#1E293B", // Dark slab header, same tone in both themes
  adminPageBg: "#F1F5F9",
  adminCardBg: "#FFFFFF",
  adminCardAltBg: "#F9FAFB",
  adminBorder: "#E2E8F0",
  adminMuted: "#64748B",
};

// Dark theme colors
const darkColors = {
  beeYellow: "#B45309",
  honeyGold: "#92400E",
  darkYellow: "#78350F",
  deepNavy: "#E2E8F0",
  charcoal: "#F8F9FA",
  cream: "#1A1D23",
  white: "#0F1114",
  warmGray: "#9CA3AF",
  lightGray: "#1F2937",
  softBlue: "#FF8C42", // Dark orange accent for dark theme
  success: "#10B981",
  danger: "#F87171",
  error: "#F87171",
  lightPeach: "#3A2E28",
  buttonTextOnYellow: "#FFFFFF", // White text for dark orange buttons in dark mode
  // Modern sidebar colors (dark)
  sidebarBg: "#1F2937",
  sidebarText: "#9CA3AF",
  sidebarTextActive: "#F9FAFB",
  sidebarAccent: "#FF8C42", // Dark orange accent
  sidebarAccentLight: "#3A2E28", // Dark orange light variant
  sidebarBorder: "#374151",
  sidebarHover: "#374151",
  // Admin panel surface colors (shared across all admin views)
  adminHeaderBg: "#0D1424", // Dark slab header, darker still in dark mode
  adminPageBg: "#0F172A",
  adminCardBg: "#161F2E",
  adminCardAltBg: "#111827",
  adminBorder: "#1E293B",
  adminMuted: "#94A3B8",
};

// Shared admin panel accent used for section labels, KPI card top-borders,
// and sidebar active-category dots. Distinct from sidebarAccent (the single
// unified primary-action color) so buttons stay recognizable amid these.
const ADMIN_CATEGORY_ACCENTS: Record<string, string> = {
  OVERVIEW: "#6366F1",
  CONTENT: "#10B981",
  MANAGEMENT: "#F59E0B",
  FINANCIAL: "#EC4899",
  SUPPORT: "#14B8A6",
  COMMUNICATION: "#8B5CF6",
  SYSTEM: "#64748B",
};

// CVD-safe palette for the Analytics dashboard's data-encoding colors
// (stat-tile accents, role/tier bars, the signup trend chart). `categorical`
// is a fixed-order 4-hue slice of an 8-hue palette validated for adjacent
// colorblind separation (ΔE >= 8) and contrast in both themes — reused in
// the same order everywhere it appears so an entity's color stays stable
// across sections. `tierRamp` is a single-hue ordinal ramp (light -> dark)
// for the subscription ladder, where lightness itself carries the tier
// order. `deemphasis`/`accent` drive the trend chart's emphasis treatment
// (history in gray, the current period in the accent).
const ANALYTICS_PALETTE = {
  light: {
    categorical: ["#2a78d6", "#eb6834", "#1baf7a", "#eda100"],
    tierRamp: ["#86b6ef", "#3987e5", "#256abf", "#104281"],
    green: "#008300",
    violet: "#4a3aa7",
    deemphasis: "#CBD5E1",
    accent: "#2a78d6",
  },
  dark: {
    categorical: ["#3987e5", "#d95926", "#199e70", "#c98500"],
    tierRamp: ["#86b6ef", "#5598e7", "#2a78d6", "#184f95"],
    green: "#008300",
    violet: "#9085e9",
    deemphasis: "#334155",
    accent: "#3987e5",
  },
};

// Same validated 8-hue set, for Market Insights. `categorical` (all 8
// slots, CVD-checked) is for pie/donut charts breaking a whole into a
// handful of named shares. `rankAccent` + `deemphasis` are for magnitude
// charts (ranked bars/lines/areas) — those categories are nominal and
// unordered, so per the data-viz method every real bar gets ONE color
// (never a rainbow-per-bar value-ramp); only the synthetic "Others"
// bucket breaks from that, in the de-emphasis gray, since it isn't a
// real peer entity.
const INSIGHTS_PALETTE = {
  light: {
    categorical: [
      "#2a78d6",
      "#eb6834",
      "#1baf7a",
      "#eda100",
      "#e87ba4",
      "#008300",
      "#4a3aa7",
      "#e34948",
    ],
    rankAccent: "#2a78d6",
    deemphasis: "#CBD5E1",
  },
  dark: {
    categorical: [
      "#3987e5",
      "#d95926",
      "#199e70",
      "#c98500",
      "#d55181",
      "#008300",
      "#9085e9",
      "#e66767",
    ],
    rankAccent: "#3987e5",
    deemphasis: "#334155",
  },
};

// Shared badge style (role/status/subscription/verification pills) used across
// every admin content view so mobile-card and desktop-table paths render the
// same concept identically.
function getAdminBadgeStyle(color: string, isDarkMode: boolean) {
  return {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
    backgroundColor: `${color}${isDarkMode ? "26" : "18"}`,
    alignSelf: "flex-start" as const,
    borderWidth: 1,
    borderColor: `${color}55`,
  };
}
function getAdminBadgeTextStyle(color: string) {
  return {
    fontSize: 11,
    fontFamily: fonts.medium,
    fontWeight: "600" as const,
    color,
    textTransform: "capitalize" as const,
    letterSpacing: 0.2,
  };
}
// Shared card shadow (matches the existing AnalyticsContent StatCard pattern)
// for admin cards/modals that need elevation on both web and native.
function getAdminCardShadow(isDarkMode: boolean) {
  return Platform.select({
    web: {
      boxShadow: isDarkMode
        ? "0 2px 12px rgba(0,0,0,0.3)"
        : "0 2px 12px rgba(0,0,0,0.07)",
    },
    default: {
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.08,
      shadowRadius: 8,
      elevation: 3,
    },
  });
}

// Subscription Plans Configuration
const SUBSCRIPTION_PLANS = [
  {
    id: "free",
    name: "Free",
    priceMonthly: 0,
    priceYearly: 0,
    icon: "star-outline",
    color: "#808080",
    popular: false,
    buttonText: "Get Started",
    features: [
      {
        text: "3 custom job notifications per day on mobile app",
        enabled: true,
      },
      { text: "Basic job search and browsing", enabled: true },
      { text: "Cannot post job ads", enabled: false },
      { text: "Limited to 3 notifications daily", enabled: false },
    ],
    adsEnabled: true,
  },
  {
    id: "standard",
    name: "Standard",
    priceMonthly: 299,
    priceYearly: 2990,
    icon: "star",
    color: "#F4C430",
    popular: true,
    buttonText: "Choose Standard",
    features: [
      { text: "Up to 50 custom job notifications per day", enabled: true },
      { text: "Priority in search results", enabled: true },
      { text: "Advanced filtering options", enabled: true },
      { text: "Resume visibility boost", enabled: true },
      { text: "Cannot post job ads", enabled: false },
    ],
    adsEnabled: false,
  },
  {
    id: "pro",
    name: "Pro",
    priceMonthly: 4999,
    priceYearly: 49990,
    icon: "verified",
    color: "#7C3AED",
    popular: false,
    buttonText: "Choose Pro",
    features: [
      { text: "Post unlimited job ads", enabled: true },
      { text: "Accept and manage resumes", enabled: true },
      { text: "Detailed job market statistics", enabled: true },
      { text: "Applicant tracking system", enabled: true },
      { text: "Company branding & logo display", enabled: true },
      { text: "Featured job placements", enabled: true },
      { text: "Priority support & account manager", enabled: true },
    ],
    adsEnabled: false,
  },
  {
    id: "enterprise",
    name: "Enterprise",
    priceMonthly: 15000,
    priceYearly: 150000,
    icon: "business",
    color: "#1A365D",
    popular: false,
    buttonText: "Choose Enterprise",
    features: [
      { text: "Post unlimited job ads", enabled: true },
      { text: "Accept and manage resumes", enabled: true },
      { text: "Detailed job market statistics", enabled: true },
      { text: "Applicant tracking system", enabled: true },
      { text: "Company branding & logo display", enabled: true },
      { text: "Featured job placements", enabled: true },
      { text: "Priority support & account manager", enabled: true },
    ],
    adsEnabled: false,
  },
];

// ─────────────────────────────────────────────────────────
// Subscription Plan Permissions
// ─────────────────────────────────────────────────────────
const DEFAULT_PLAN_PERMISSIONS: Record<string, Record<string, boolean>> = {
  free: {
    canViewJobDetails: true,
    canApplyToJob: true,
    canCreateJobs: false,
    canViewTalentPool: false,
    canSaveJobs: true,
    canViewAnalytics: false,
    canManageApplications: false,
    canFeaturedListings: false,
    canAccessCompanyBranding: false,
  },
  standard: {
    canViewJobDetails: true,
    canApplyToJob: true,
    canCreateJobs: false,
    canViewTalentPool: false,
    canSaveJobs: true,
    canViewAnalytics: false,
    canManageApplications: false,
    canFeaturedListings: false,
    canAccessCompanyBranding: false,
  },
  pro: {
    canViewJobDetails: true,
    canApplyToJob: true,
    canCreateJobs: true,
    canViewTalentPool: true,
    canSaveJobs: true,
    canViewAnalytics: true,
    canManageApplications: true,
    canFeaturedListings: true,
    canAccessCompanyBranding: true,
  },
  enterprise: {
    canViewJobDetails: true,
    canApplyToJob: true,
    canCreateJobs: true,
    canViewTalentPool: true,
    canSaveJobs: true,
    canViewAnalytics: true,
    canManageApplications: true,
    canFeaturedListings: true,
    canAccessCompanyBranding: true,
  },
};

const PERMISSION_LABELS: { key: string; label: string; description: string }[] =
  [
    {
      key: "canViewJobDetails",
      label: "View Job Details",
      description: "Can view full job listing details",
    },
    {
      key: "canApplyToJob",
      label: "Apply to Jobs",
      description: "Can submit job applications",
    },
    {
      key: "canCreateJobs",
      label: "Post Job Listings",
      description: "Can create and publish job listings",
    },
    {
      key: "canViewTalentPool",
      label: "View Talent Pool",
      description: "Can browse candidate profiles",
    },
    {
      key: "canSaveJobs",
      label: "Save / Bookmark Jobs",
      description: "Can bookmark and save job listings",
    },
    {
      key: "canViewAnalytics",
      label: "Analytics Dashboard",
      description: "Can view hiring analytics and reports",
    },
    {
      key: "canManageApplications",
      label: "Manage Applications",
      description: "Can review and respond to applicants",
    },
    {
      key: "canFeaturedListings",
      label: "Featured Listings",
      description: "Job listings appear highlighted in search",
    },
    {
      key: "canAccessCompanyBranding",
      label: "Company Branding",
      description: "Can upload logo and customise company profile",
    },
  ];

// Multi-language translations
const translations = {
  en: {
    appTitle: "NibJobs",
    searchPlaceholder: "Search jobs...",
    login: "Login",
    signUp: "Sign Up",
    exploreChannels: "Multiple Job Sources",
    swipeHint: "← Swipe to explore more channels →",
    recentJobs: "Recent Jobs",
    jobsFound: "jobs found",
    loading: "Loading jobs...",
    categories: "Categories",
    contractType: "Contract Type",
    location: "Location",
    remoteJobs: "Remote Jobs",
    clearFilters: "Clear Filters",
    adminLogin: "Administrator Login",
    email: "Email",
    password: "Password",
    loginButton: "Login",
    loginError: "Please enter email and password",
    invalidCredentials: "Invalid email or password",
    telegramChannel: "Telegram Channel",
    members: "members",
    darkMode: "Dark Mode",
    language: "Language",
    downloadPlayStore: "Play Store",
    downloadAppStore: "App Store",
    // Jobs page
    employmentType: "Employment Type",
    workMode: "Work Mode",
    fullTime: "Full-time",
    partTime: "Part-time",
    contract: "Contract",
    remote: "Remote",
    onSite: "On-site",
    hybrid: "Hybrid",
    applyNow: "Apply Now",
    shareJob: "Share Job",
    viewDetails: "View Details",
    salaryRange: "Salary Range",
    posted: "Posted",
    ago: "ago",
    noJobsFound: "No jobs found",
    filterJobs: "Filter Jobs",
    sortBy: "Sort By",
    clearAll: "Clear All",
    // Companies page
    companies: "Companies",
    viewAll: "View All",
    noCompaniesFound: "No companies found",
    // Settings page
    settings: "Settings",
    profile: "Profile",
    notifications: "Notifications",
    theme: "Theme",
    logout: "Logout",
    about: "About",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    // Bookmarks
    bookmarks: "Bookmarks",
    bookmark: "Bookmark",
    save: "Save",
    saved: "Saved",
    remove: "Remove",
    // Common
    jobs: "Jobs",
    search: "Search",
    filter: "Filter",
    apply: "Apply",
    company: "Company",
    salary: "Salary",
    description: "Description",
    requirements: "Requirements",
    // Hero Section
    heroBadge: "🚀 Ethiopia's #1 Job Platform",
    heroSubtitle:
      "Ethiopia's Leading Job Platform - Connecting Talent with Opportunity",
    heroDescription:
      "Connect with 500+ leading companies and explore 10,000+ opportunities across Ethiopia.",
    desktopHeroFind: "Find Your",
    desktopHeroDreamJob: "Dream Job",
    desktopHeroExplore: "Explore opportunities across",
    desktopHeroTopCategories: "top categories with",
    desktopHeroActivePositions: "active positions in Ethiopia.",
    desktopSearchPlaceholder: "Search jobs, skills, or companies...",
    desktopViewAll: "View All →",
    getStartedFree: "Get Started Free",
    getItOnGooglePlay: "GET IT ON",
    googlePlay: "Google Play",
    searchJobsPlaceholder: "Search for jobs, companies, or keywords",
    trendingTags: "Trending:",
    remoteWork: "Remote Work",
    techJobs: "Tech Jobs",
    marketing: "Marketing",
    sales: "Sales",
    engineering: "Engineering",
    statsJobs: "Jobs",
    statsCompanies: "Companies",
    statsProfessionals: "Professionals",
    telegramChannelsTitle: "📢 Telegram Job Channels",
    telegramChannelsSubtitle:
      "Stay updated with the latest job postings from verified channels",
    viewChannel: "View Channel",
    categoriesTitle: "🎯 Browse by Category",
    categoriesSubtitle: "Find opportunities in your field",
    viewAllCategories: "View All Categories",
    featuredCompaniesTitle: "🏢 Featured Companies",
    featuredCompaniesSubtitle: "Top employers hiring now",
    viewAllCompanies: "View All Companies",
    openPositions: "Open Positions",
    whyChooseTitle: "Why Choose NibJobs?",
    whyChooseSubtitle: "Your trusted partner in career growth",
    verifiedJobsTitle: "Verified Jobs",
    verifiedJobsDesc: "All job postings are verified for authenticity",
    multiChannelTitle: "Multiple Sources",
    multiChannelDesc: "Access jobs from Telegram channels and direct employers",
    realTimeTitle: "Real-time Updates",
    realTimeDesc: "Get instant notifications for new opportunities",
    easyApplicationTitle: "Easy Application",
    easyApplicationDesc: "Apply to multiple jobs with one profile",
    readyToStartTitle: "Ready to Start Your Journey?",
    readyToStartDesc:
      "Join thousands of professionals who found their dream jobs",
    footerAbout: "About NibJobs",
    footerAboutDesc:
      "NibJobs is Ethiopia's leading job platform, connecting talented professionals with top employers across the country.",
    footerJobSeekers: "For Job Seekers",
    footerQuickLinks: "Quick Links",
    footerBrowseJobs: "Browse Jobs",
    footerJobAlerts: "Job Alerts",
    footerCareerAdvice: "Career Advice",
    footerResumeTips: "Resume Tips",
    footerCompanies: "Companies",
    footerCategories: "Categories",
    footerTelegram: "Telegram Channels",
    footerForEmployers: "For Employers",
    footerPostJob: "Post a Job",
    footerEmployerDashboard: "Employer Dashboard",
    footerPricing: "Pricing",
    footerRecruitmentTips: "Recruitment Tips",
    footerCompany: "Company",
    footerContact: "Contact",
    footerPrivacy: "Privacy Policy",
    footerTerms: "Terms of Service",
    footerSupport: "Support",
    footerHelpCenter: "Help Center",
    footerContactUs: "Contact Us",
    footerFAQ: "FAQ",
    footerCopyright: "© 2025 NibJobs. All rights reserved.",
    footerPrivacyShort: "Privacy",
    footerTermsShort: "Terms",
    footerCookies: "Cookies",
    footerPricingPlans: "Pricing Plans",
    home: "Home",
    allJobs: "All Jobs",
    channels: "Channels",
    more: "More",
    // About Us Section
    aboutUsLabel: "About Us",
    aboutUsTitle: "About NibJobs",
    aboutUsSubtitle: "Connecting Ethiopia's Talent with Opportunities",
    aboutUsDesc:
      "NibJobs is Ethiopia's premier job portal, dedicated to bridging the gap between talented professionals and exciting career opportunities across the nation.",
    topCompanies: "Top Companies",
    topCompaniesDesc:
      "Connect with leading employers across various industries",
    instantAlerts: "Instant Alerts",
    instantAlertsDesc: "Get notified immediately when relevant jobs are posted",
    multilingual: "Multilingual",
    multilingualDesc: "Available in English, Amharic, Tigrinya, and Oromiffa",
    // Opportunities Section
    latestOpportunities: "Latest Opportunities",
    latestOpportunitiesSubtitle: "Fresh jobs posted today",
    viewAllJobs: "View All Jobs",
    // How It Works Section
    processLabel: "Process",
    howItWorksTitle: "How It Works",
    howItWorksSubtitle: "Get hired in 3 simple steps",
    step1: "Search",
    step1Desc:
      "Browse thousands of jobs from verified companies across Ethiopia",
    step2: "Apply",
    step2Desc: "Submit your application with one click using your profile",
    step3: "Get Hired",
    step3Desc: "Connect with employers and land your dream job",
    // Popular Categories Section
    popularCategoriesLabel: "Categories",
    popularCategoriesTitle: "Popular Categories",
    popularCategoriesSubtitle: "Explore opportunities by field",
    // Success Stories Section
    storiesLabel: "Stories",
    successStoriesTitle: "Success Stories",
    successStoriesSubtitle: "Real people, real success with NibJobs",
    readMore: "Read More",
    // Plans Section
    plansLabel: "Plans",
    chooseYourPlan: "Choose Your Plan",
    chooseYourPlanSubtitle: "Select the perfect plan for your needs",
    free: "Free",
    premium: "Premium",
    enterprise: "Enterprise",
    perMonth: "/month",
    mostPopular: "Most Popular",
    getStarted: "Get Started",
    contactUs: "Contact Us",
    // Never Miss Section
    neverMissLabel: "Subscribe",
    neverMissTitle: "Never Miss an Opportunity",
    neverMissSubtitle: "Get job alerts delivered directly to your inbox",
    emailPlaceholder: "Enter your email",
    subscribe: "Subscribe",
    // Login Page
    loginTagline:
      "Ethiopia's premier job platform connecting talent with opportunity",
    loginActiveJobsLabel: "10,000+ Active Jobs",
    loginActiveJobsDesc: "Curated opportunities",
    loginTopCompaniesLabel: "500+ Top Companies",
    loginTopCompaniesDesc: "Leading employers",
    loginInstantAlertsLabel: "Instant Alerts",
    loginInstantAlertsDesc: "Never miss a chance",
    // FAQ Section
    faqLabel: "FAQ",
    faqTitle: "Frequently Asked Questions",
    faqSubtitle: "Find answers to common questions about NibJobs",
    faq1Q: "Is NibJobs free to use?",
    faq1A:
      "Yes! Job seekers can browse and apply to jobs completely free. We also offer premium features for enhanced visibility.",
    faq2Q: "How do I apply for a job?",
    faq2A:
      "Simply create an account, complete your profile, and click 'Apply' on any job listing. Some jobs may redirect you to the company's application page.",
    faq3Q: "How often are new jobs posted?",
    faq3A:
      "New jobs are posted daily! Enable job alerts to get notified when positions matching your preferences become available.",
    faq4Q: "Can I save jobs for later?",
    faq4A:
      "Yes! Click the bookmark icon on any job listing to save it to your favorites. Access saved jobs anytime from your profile.",
    // Resume Tips
    resumeTipsTitle: "Resume Tips",
    resumeTipsHero: "Create a Standout Resume",
    resumeTipsHeroDesc:
      "Professional guidance for crafting resumes that get noticed",
    resumeFormatting: "Resume Formatting",
    resumeFormattingText:
      "• Use a clean, professional layout\n• Keep it concise (1-2 pages maximum)\n• Use consistent formatting and fonts\n• Include proper contact information\n• Save as PDF for universal compatibility",
    resumeKeySections: "Key Sections to Include",
    resumeKeySectionsText:
      "Professional Summary: A brief overview of your experience and career objectives\n\nWork Experience: List relevant positions with measurable achievements\n\nEducation: Include degrees, certifications, and relevant coursework\n\nSkills: Highlight both technical and soft skills\n\nAchievements: Showcase awards, recognitions, and notable accomplishments",
    resumeWritingTips: "Writing Tips",
    resumeWritingTipsText:
      "• Use action verbs (achieved, managed, developed, led)\n• Quantify achievements with numbers and metrics\n• Tailor your resume for each job application\n• Proofread carefully for errors\n• Keep language professional and concise",
    resumeMistakes: "Common Mistakes to Avoid",
    resumeMistakesText:
      "✗ Including irrelevant personal information\n✗ Using unprofessional email addresses\n✗ Listing duties instead of achievements\n✗ Having spelling or grammatical errors\n✗ Using generic, one-size-fits-all resumes",
    uploadResume: "Upload Your Resume",
    // Login Screen
    signInTitle: "Welcome Back",
    signInSubtitle: "Sign in to access your account",
    emailAddress: "Email Address",
    passwordLabel: "Password",
    forgotPassword: "Forgot Password?",
    signInButton: "Sign In",
    signingIn: "Signing In...",
    orContinueWith: "OR CONTINUE WITH",
    signInWithGoogle: "Sign in with Google",
    dontHaveAccount: "Don't have an account? ",
    signUpLink: "Sign Up",
    backToHome: "Back to Home",
    // Signup Screen
    createAccount: "Create Account",
    joinNibJobs: "Join NibJobs and find your dream job",
    fullName: "Full Name",
    confirmPassword: "Confirm Password",
    signUpButton: "Sign Up",
    signingUp: "Signing Up...",
    signUpWithGoogle: "Sign up with Google",
    alreadyHaveAccount: "Already have an account? ",
    signInLink: "Sign In",
    // Verification Screen
    checkYourEmail: "Check Your Email",
    verificationEmailSent: "Verification Email Sent!",
    verificationSentTo: "We've sent a verification email to:",
    checkInboxSpam:
      "Please check your inbox (and spam folder) and click the verification link to activate your account.",
    goToLogin: "Go to Login",
    // Privacy Policy
    privacyTitle: "Privacy Policy",
    lastUpdated: "Last updated:",
    privacySection1Title: "1. Information We Collect",
    privacySection1Text:
      "We collect information you provide directly to us when using NibJobs. This includes your name, email address, phone number, resume, and job preferences. We also collect information about your usage of the app and the jobs you view or apply to.",
    privacySection2Title: "2. How We Use Your Information",
    privacySection2Text:
      "We use the information we collect to provide, maintain, and improve our services. This includes matching you with relevant job opportunities, communicating with you about jobs and our services, and analyzing usage patterns to enhance the user experience.",
    privacySection3Title: "3. Information Sharing",
    privacySection3Text:
      "We share your information with employers when you apply to their job postings. We do not sell your personal information to third parties. We may share aggregated, non-personally identifiable information with partners and service providers who help us operate our platform.",
    privacySection4Title: "4. Data Security",
    privacySection4Text:
      "We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no internet transmission is completely secure, and we cannot guarantee absolute security.",
    privacySection5Title: "5. Your Rights",
    privacySection5Text:
      "You have the right to access, update, or delete your personal information at any time through your account settings. You can also opt out of certain communications. If you have any concerns about how we handle your data, please contact us.",
    privacySection6Title: "6. Contact Us",
    privacySection6Text:
      "If you have any questions about this Privacy Policy or our data practices, please contact us at privacy@nibjobs.com. We will respond to your inquiry as soon as possible.",
    // Additional Home Page Texts
    categoriesLabel: "Categories",
    testimonialsLabel: "Testimonials",
    pricingPlansLabel: "Pricing Plans",
    faqLabel2: "FAQ",
    jobsText: "jobs",
    viewAllJobsButton: "View All Jobs",
    loginAndViewMore: "Login and View More Jobs",
    loadingJobs: "Loading jobs...",
    manageAlerts: "Manage Alerts",
    signUpForAlerts: "Sign Up for Alerts",
    signUpToAccessAll:
      "Please sign up to access all features and browse all jobs. Signing up is completely free!",
    signUpForJobAlerts: "Sign up to receive personalized job alerts!",
    playStoreDownload: "Google Play",
    getItOn: "GET IT ON",
    popularBadge: "POPULAR",
    freePlanDesc: "Perfect for job seekers starting their career journey",
    standardPlanDesc:
      "Ideal for professionals looking to advance their careers",
    proName: "Pro",
    proPlanDesc: "For growing teams and ambitious professionals",
    enterprisePlanDesc: "For businesses and recruitment agencies",
    freeFeature1: "Browse unlimited job listings",
    freeFeature2: "Apply to jobs with one click",
    freeFeature3: "Save up to 10 favorite jobs",
    freeFeature4: "Basic job alerts",
    standardFeature1: "Everything in Free",
    standardFeature2: "Priority application status",
    standardFeature3: "Advanced job alerts",
    standardFeature4: "Resume builder access",
    standardFeature5: "Unlimited job saves",
    proFeature1: "Post unlimited job ads",
    proFeature2: "Accept and manage resumes",
    proFeature3: "Detailed job market statistics",
    proFeature4: "Applicant tracking system",
    proFeature5: "Company branding & logo display",
    proFeature6: "Featured job placements",
    proFeature7: "Priority support & account manager",
    enterpriseFeature1: "Everything in Standard",
    enterpriseFeature2: "Post unlimited jobs",
    enterpriseFeature3: "Featured company profile",
    enterpriseFeature4: "Access to talent pool",
    enterpriseFeature5: "Analytics dashboard",
    enterpriseFeature6: "Priority support",
    enterpriseFeature7: "Custom integrations",
    orYearly: "Or",
    perYear: "/year",
    // Mobile Landing Page
    mobileSignIn: "Sign In",
    mobileActiveJobs: "Active Jobs",
    mobileThousandsJobs: "Thousands of Jobs",
    mobileHeroLine1: "Find your",
    mobileHeroHighlight: "dream job",
    mobileHeroLine2: "today.",
    mobileHeroDesc:
      "Jobs from 50+ Telegram channels and companies, all in one place — free, with no broker fees.",
    mobileHeroPerkFree: "Free",
    mobileHeroPerkNoBroker: "No brokers",
    mobileHeroPerkAlerts: "Instant alerts",
    mobileHeroNoAccount: "No account yet?",
    mobileHeroSignUp: "Sign up free",
    mobileHeroSearchButton: "Search",
    liveJobsLabel: "LIVE",
    liveJobsUpdated: "Updated every day",
    liveJobsCaption: "open jobs waiting for you",
    mobileSearchPlaceholder: "Search jobs, companies...",
    mobileBrowseAll: "Browse All Jobs",
    mobileCreateAccount: "Create Free Account",
    mobileTopCategories: "Top Categories",
    mobileLatestOpenings: "Latest Openings",
    mobileSeeAll: "See All →",
    mobileGetApp: "Get the NibJobs App",
    mobileGetAppDesc:
      "Apply to jobs instantly, get real-time notifications, and track your applications on the go.",
    mobileFeatureAlerts: "Instant Alerts",
    mobileFeatureApply: "Easy Apply",
    mobileFeatureTrack: "Track Status",
    mobileGetItOn: "GET IT ON",
    mobileGooglePlay: "Google Play",
    mobileStatsJobs: "Jobs",
    mobileStatsCategories: "Categories",
    mobileStatsCompanies: "Companies",
    mobileWhyLoveUs: "Why Job Seekers Love Us",
    mobileUpdatedDaily: "Updated Daily",
    mobileUpdatedDailyDesc:
      "Fresh job listings from top Ethiopian employers, every day.",
    mobileSmartAlerts: "Smart Alerts",
    mobileSmartAlertsDesc: "Get notified the moment a job matches your skills.",
    mobileTrustedCompanies: "Trusted Companies",
    mobileTrustedCompaniesDesc: "All employers are verified for your safety.",
    mobileReadyTitle: "Ready to find your next role?",
    mobileReadyDesc: "Join thousands of job seekers across Ethiopia.",
    mobileStartBrowsing: "Start Browsing Jobs",
    mobileFooterPrivacy: "Privacy",
    mobileFooterTerms: "Terms",
    mobileFooterJobs: "Jobs",
    mobileFooterCopyright: "© {year} NibJobs. All rights reserved.",
    // Auth Screen translations
    resetPassword: "Reset Password",
    resetPasswordSubtitle:
      "Enter your email address and we'll send you a link to reset your password",
    sendResetLink: "Send Reset Link",
    sendingReset: "Sending...",
    backToLogin: "Back to Login",
    forgotTagline: "Don't worry — it happens to the best of us.",
    forgotSecureReset: "Secure password reset",
    forgotCheckInbox: "Check your inbox",
    forgotAccountSafe: "Your account is safe",
    signupTagline:
      "Join thousands of professionals finding their dream jobs in Ethiopia.",
    signupThousandsJobs: "Thousands of job listings",
    signupInstantAlerts: "Instant job alerts",
    signupVerifiedEmployers: "Verified employers only",
    emailSentTitle: "Email Sent!",
    resetSentTo: "We've sent a password reset link to",
    checkInboxForReset:
      "Check your inbox and click the link to reset your password.",
    enterEmailError: "Please enter your email address",
    noAccountFoundError: "No account found with this email address",
    resetEmailFailedError: "Failed to send reset email. Please try again.",
    verificationLinkSentTo: "We've sent a verification link to",
    emailStep1Title: "Check Your Email",
    emailStep1Desc: "We've sent a verification link to your email address",
    emailStep2Title: "Click the Link",
    emailStep2Desc: "Click the verification link in your email",
    emailStep3Title: "Start Exploring",
    emailStep3Desc: "Sign in to find your dream job!",
    browseJobs: "Browse Jobs",
    passwordStrength: "Password strength",
    passwordsMatch: "\u2713 Passwords match",
    passwordStrengthWeak: "Weak",
    passwordStrengthStrong: "Strong",
    passwordStrengthVeryStrong: "Very Strong",
    fullNameRequired: "Full name is required",
    passwordsDoNotMatch: "Passwords do not match",
    // Settings Page translations
    settingsAccountSection: "Account",
    settingsPreferencesSection: "Preferences",
    settingsAccountActionsSection: "Account Actions",
    settingsPortfolioLabel: "Portfolio",
    settingsPortfolioSubtitle: "CV, skills & experience",
    settingsAccountSubtitle: "Profile & security",
    settingsJobInterestsLabel: "Job Interests",
    settingsJobInterestsSubtitle: "Categories & preferences",
    settingsPreferencesSubtitle: "Theme & language",
    settingsNotificationsSubtitle: "Manage alerts",
    settingsPrivacyLabel: "Privacy & Security",
    settingsPrivacySubtitle: "Data & permissions",
    settingsSubscriptionLabel: "Subscription",
    settingsHelpLabel: "Help & Support",
    settingsHelpSubtitle: "FAQs & contact",
    settingsLogoutSubtitle: "Sign out of your account",
    editProfileButton: "Edit Profile",
    editChipLabel: "Edit",
    jobSeekerLabel: "Job Seeker",
    savedJobsCount: "saved",
    personalInfoSection: "Personal Information",
    displayNameLabel: "Display Name",
    displayNamePlaceholder: "Your full name",
    usernameLabel: "Username",
    checkingAvailability: "Checking...",
    usernameAvailableText: "\u2713 Available",
    usernameTakenText: "\u2717 Taken",
    dateOfBirthLabel: "Date of Birth",
    bioLabel: "Bio",
    bioPlaceholder: "Tell employers about yourself...",
    contactSection: "Contact",
    phoneNumberLabel: "Phone Number",
    socialLinksSection: "Social Links",
    addCoverPhotoLabel: "Add Cover Photo",
    changeCoverPhotoLabel: "Change",
    savingText: "Saving...",
    saveChangesLabel: "Save Changes",
    profileLinkSection: "Profile Link",
    copyLinkLabel: "Copy Link",
    previewLabel: "Preview",
    cvResumeSection: "CV / Resume",
    cvUploadedText: "CV uploaded",
    cvPdfDocLabel: "PDF / DOC",
    cvUploadButton: "Upload CV",
    cvUploadingText: "Uploading\u2026",
    cvReplaceButton: "Replace",
    professionalInfoSection: "Professional Info",
    jobTitleLabel: "Job Title",
    yearsOfExperienceLabel: "Years of Experience",
    aboutSection: "About",
    skillsLabel: "Skills",
    educationLabel: "Education",
    keyAchievementsLabel: "Key Achievements",
    linksSection: "Links",
    portfolioWebsiteLabel: "Portfolio Website",
    savePortfolioButton: "Save Portfolio",
    profilePreviewTitle: "Profile Preview",
    asSeenByOthers: "As seen by others",
    appearanceSection: "Appearance",
    darkModeEnabled: "Dark theme enabled",
    lightModeEnabled: "Light theme enabled",
    emailNotificationsLabel: "Email Notifications",
    emailNotificationsSubtitle: "Receive updates via email",
    pushNotificationsLabel: "Push Notifications",
    pushNotificationsSubtitle: "Get instant alerts on your device",
    jobAlertsLabel: "Job Alerts",
    jobAlertsSubtitle: "New jobs matching your interests",
    applicationUpdatesLabel: "Application Updates",
    applicationUpdatesSubtitle: "Status changes on your applications",
    profileVisibilitySection: "Profile Visibility",
    visibilityPublic: "Public",
    visibilityPublicSubtitle: "Anyone can view your profile",
    visibilityConnectionsOnly: "Connections Only",
    visibilityConnectionsOnlySubtitle: "Only your connections can view",
    visibilityPrivate: "Private",
    visibilityPrivateSubtitle: "Profile hidden from others",
    contactMessagingSection: "Contact & Messaging",
    showEmailLabel: "Show Email",
    showEmailSubtitle: "Display email on your public profile",
    allowMessagingLabel: "Allow Messaging",
    allowMessagingSubtitle: "Recruiters can send you messages",
    interestsHintText:
      "Select 1 category, multiple subcategories, and tags to personalize your job recommendations",
    yourInterestsSection: "Your Interests",
    categoryLabel: "Category",
    subcategoriesLabel: "Subcategories",
    tagsLabel: "Tags",
    subcategoriesSection: "Subcategories",
    saveJobInterestsButton: "Save Job Interests",
    faqsMenuTitle: "FAQs",
    faqsMenuSubtitle: "Common questions answered",
    contactSupportTitle: "Contact Support",
    contactSupportSubtitle: "Get help from our team",
    sendFeedbackTitle: "Send Feedback",
    sendFeedbackSubtitle: "Help us improve",
    privacyPolicySubtitle: "How we protect your data",
    termsOfServiceSubtitle: "Our usage terms",
    needImmediateHelpText: "Need immediate help?",
    frequentlyAskedQuestionsLabel: "Frequently Asked Questions",
    stillHaveQuestionsText: "Still have questions?",
    messageSectionHeader: "Message",
    subjectFieldLabel: "Subject",
    subjectFieldPlaceholder: "What can we help you with?",
    messageFieldPlaceholder: "Describe your issue or question in detail...",
    sendingText: "Sending...",
    sendMessageButton: "Send Message",
    otherWaysToReachLabel: "Other Ways to Reach Us",
    messageSentText: "Message sent!",
    messageReplyTimeText: "We'll get back to you within 24\u201348 hours.",
    supportHoursLabel: "Support Hours",
    supportHoursText: "Mon\u2013Fri, 9 AM \u2013 6 PM EAT",
    accountSettingsTitle: "Account Settings",
    // Help FAQs
    helpFaq1Q: "How do I create an account?",
    helpFaq1A:
      'Click on the "Sign Up" button in the top right corner and fill in your details. You can also sign up using your Google account for faster registration.',
    helpFaq2Q: "How do I apply for a job?",
    helpFaq2A:
      'Browse available jobs, click on a job that interests you, and click the "Apply" button. Make sure your profile and CV are up to date before applying.',
    helpFaq3Q: "Can I edit my application after submitting?",
    helpFaq3A:
      "Once submitted, applications cannot be edited. Please ensure all information is correct before submitting. You can contact the employer directly if you need to update your application.",
    helpFaq4Q: "How do I upload my CV?",
    helpFaq4A:
      'Go to Settings > Portfolio, and click on "Upload CV". You can upload PDF, DOC, or DOCX files up to 5MB in size.',
    helpFaq5Q: "What subscription plans are available?",
    helpFaq5A:
      "We offer Free, Standard, and Enterprise plans. Visit the Subscription section in Settings to view detailed features and pricing for each plan.",
    helpFaq6Q: "How do I cancel my subscription?",
    helpFaq6A:
      'Go to Settings > Subscription and click on "Manage Subscription". You can cancel your subscription at any time, and it will remain active until the end of your billing period.',
    helpFaq7Q: "How do job alerts work?",
    helpFaq7A:
      "Job alerts notify you when new jobs matching your criteria are posted. Set up your preferences in Settings > Notifications to receive alerts via email or push notifications.",
    helpFaq8Q: "Can I save jobs for later?",
    helpFaq8A:
      "Yes! Click the bookmark icon on any job listing to save it. Access your saved jobs from the Bookmarks section in the main menu.",
    helpFaq9Q: "How do I change my language preference?",
    helpFaq9A:
      "Go to Settings > Preferences and select your preferred language. We support English, Amharic, Tigrinya, and Oromiffa.",
    helpFaq10Q: "Is my data secure?",
    helpFaq10A:
      "Yes, we take data security seriously. All personal information is encrypted and stored securely. Read our Privacy Policy for more details.",
    // Feedback form
    feedbackCategoryLabel: "Category",
    feedbackRatingLabel: "Rating (optional)",
    yourFeedbackLabel: "Your Feedback",
    feedbackPlaceholder: "Tell us what you think...",
    submitFeedbackButton: "Submit Feedback",
    submittingText: "Submitting...",
    feedbackSubmittedTitle: "Feedback submitted!",
    feedbackThankYouText: "Thank you for helping us improve NibJobs.",
    feedbackErrorText: "Please select a category and provide feedback",
    messageSendFailed:
      "Failed to send message. Please try again or contact us directly at support@nibjobs.com",
    feedbackSubmitFailed: "Failed to submit feedback. Please try again.",
    feedbackCategoryFeatureRequest: "Feature Request",
    feedbackCategoryBugReport: "Bug Report",
    feedbackCategoryUserExperience: "User Experience",
    feedbackCategoryPerformance: "Performance",
    feedbackCategoryOther: "Other",
    // Contact form
    fullNamePlaceholder: "Enter your full name",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    // Subscription / Pick a plan page
    pickAPlan: "Pick a plan",
    upgradeAnytimeCancelAnytime: "Upgrade anytime · Cancel anytime",
    billingMonthly: "Monthly",
    billingYearly: "Yearly",
    loadingPlans: "Loading plans…",
    planActiveBadge: "Active",
    planPopularBadge: "POPULAR",
    planPriceFree: "Free",
    planPricePerMo: "/mo",
    planPricePerYr: "/yr",
    planSavesPercent: "Saves {percent}% vs monthly",
    planCurrentPlanCta: "Current plan",
    planSwitchToFree: "Switch to Free",
    planGetName: "Get {name}",
    planSecureCheckout: "Secure checkout",
    planCancelAnytime: "Cancel anytime",
    plan247Support: "24/7 support",
    loginRequiredTitle: "Login Required",
    loginRequiredMessage: "Please log in to upgrade your subscription plan.",
    downgradeToFreeTitle: "Downgrade to Free",
    downgradeToFreeMessage: "Are you sure you want to switch to the Free plan?",
    planSwitchedToFree: "Switched to Free plan",
    planFailedToSwitch: "Failed to switch plan",
    cancelButton: "Cancel",
    confirmButton: "Confirm",
    successTitle: "Success",
    errorTitle: "Error",
    // Bottom nav labels
    navJobs: "Jobs",
    navSaved: "Saved",
    navAlerts: "Alerts",
    newLabel: "new",
    markAllRead: "Mark all read",
    noNotificationsTitle: "No notifications yet",
    noNotificationsDesc: "We'll let you know when something new arrives.",
    viewAllNotifications: "View all notifications",
    navProfile: "Profile",
    navDashboard: "Dashboard",
    // Toolbar
    lightMode: "Light Mode",
    // Terms of Service body
    termsSection1Title: "1. Acceptance of Terms",
    termsSection1Text:
      "By accessing and using NibJobs, you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.",
    termsSection2Title: "2. Use of Service",
    termsSection2Text:
      "NibJobs provides a platform for job seekers to find employment opportunities and for employers to post job listings. You agree to use our service only for lawful purposes and in accordance with these terms.",
    termsSection3Title: "3. User Accounts",
    termsSection3Text:
      "You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You must provide accurate and complete information when creating your account.",
    termsSection4Title: "4. Content and Conduct",
    termsSection4Text:
      "You are solely responsible for the content you post on NibJobs. You agree not to post content that is illegal, harmful, threatening, abusive, defamatory, or otherwise objectionable.",
    termsSection5Title: "5. Intellectual Property",
    termsSection5Text:
      "All content, features, and functionality on NibJobs are owned by us and are protected by copyright, trademark, and other intellectual property laws.",
    termsSection6Title: "6. Limitation of Liability",
    termsSection6Text:
      "NibJobs shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our service.",
    termsSection7Title: "7. Changes to Terms",
    termsSection7Text:
      "We reserve the right to modify these terms at any time. We will notify users of significant changes via email or through the app.",
    termsSection8Title: "8. Contact Information",
    termsSection8Text:
      "For questions about these Terms of Service, please contact us at legal@nibjobs.com",
    // Company Dashboard
    cdDashboard: "Dashboard",
    cdAnalytics: "Analytics",
    cdJobPostings: "Job Postings",
    cdApplications: "Applications",
    cdTalentPool: "Talent Pool",
    cdCompanyProfile: "Company Profile",
    cdAccountSettings: "Account Settings",
    cdAnalyticsInsights: "Analytics & insights",
    cdManageYourJobs: "Manage your jobs",
    cdReviewCandidates: "Review candidates",
    cdDiscoverTalent: "Discover top talent",
    cdUpdateDetails: "Update your details",
    cdLoadingDashboard: "Loading dashboard...",
    cdOverview: "OVERVIEW",
    cdHiring: "HIRING",
    cdSettings: "SETTINGS",
    cdBrowseJobs: "Browse Jobs",
    cdSignOut: "Sign Out",
    cdVerified: "Verified",
    cdVerifiedCompany: "Verified Company",
    cdVerificationRejected: "Verification Rejected",
    cdVerificationPending: "Pending Verification",
    cdCompanyAccount: "Company Account",
    cdSwitchView: "Switch View",
    cdCandidateView: "Candidate View",
    cdPostJob: "Post a Job",
    cdActiveJobs: "Active Jobs",
    cdTotalApplicants: "Total Applicants",
    cdPendingReviews: "Pending Reviews",
    cdAvgPerJob: "Avg / Job",
    cdTotalJobs: "Total Jobs",
    cdToReview: "To Review",
    cdReviewed: "Reviewed",
    cdPending: "Pending",
    cdTotal: "Total",
    cdApplicationsPerPosting: "applications per posting",
    cdStillActive: "still active",
    cdPendingApplications: "pending applications",
    cdProcessedSoFar: "processed so far",
    cdPostYourFirstJob: "Post Your First Job",
    cdFirstJobDesc:
      "Connect with talented professionals by creating your first job posting.",
    cdCreateJobPosting: "Create Job Posting",
    cdQuickActions: "Quick Actions",
    cdApplicationPipeline: "Application Pipeline",
    cdPostNewJob: "Post New Job",
    cdViewApplications: "View Applications",
    cdBrowseCandidates: "Browse Candidates",
    cdEditProfile: "Edit Profile",
    cdLoadingApplications: "Loading applications...",
    cdSearchApplications: "Search by name, email, or job title...",
    cdNoApplicationsFound: "No Applications Found",
    cdTryAdjustingFilters: "Try adjusting your filters or search query",
    cdApplicationsWillAppear:
      "Applications will appear here when candidates apply",
    cdShortlist: "Shortlist",
    cdReject: "Reject",
    cdAccept: "Accept",
    cdViewDetails: "View Details",
    cdApplicationDetails: "Application Details",
    cdContactInfo: "Contact Info",
    cdApplicantInfo: "Applicant Information",
    cdProfessionalOverview: "Professional Overview",
    cdLoadingJobs: "Loading jobs...",
    cdManageJobListings: "Manage your active job listings",
    cdCreateJob: "Create Job",
    cdActive: "Active",
    cdPaused: "Paused",
    cdNoJobsYet: "No Jobs Posted Yet",
    cdFirstJobPostingDesc:
      "Create your first job posting to start attracting talented candidates.",
    cdCreateFirstJob: "Create Your First Job",
    cdApplicants: "Applicants",
    cdEditJobPosting: "Edit Job Posting",
    cdCreateNewJob: "Create New Job",
    cdUpdateJobDetails: "Update your job posting details",
    cdFillNewOpening: "Fill in the details to post a new opening",
    cdBasicInformation: "Basic Information",
    cdJobTitle: "Job Title",
    cdCategory: "Category",
    cdContractType: "Contract Type",
    cdLocationCompensation: "Location & Compensation",
    cdRemoteWorkAvailable: "Remote Work Available",
    cdMonthlySalary: "Monthly Salary (Birr)",
    cdJobDetails: "Job Details",
    cdJobDescription: "Job Description",
    cdRequirements: "Requirements",
    cdKeyResponsibilities: "Key Responsibilities",
    cdSkillsTags: "Skills & Tags",
    cdJobTitleRequired: "Job title is required",
    cdCategoryRequired: "Category is required",
    cdLocationRequired: "Location is required",
    cdSkillsRequired: "At least one skill/tag is required",
    cdSearchCandidates: "Search name, role, skills\u2026",
    cdFound: "found",
    cdLoadingCandidates: "Loading candidates...",
    cdNoResultsFound: "No results found",
    cdNoCandidatesYet: "No candidates yet",
    cdTryDifferentSearch: "Try a different search or clear filters",
    cdCandidatesWillAppear: "Candidates will appear here once they register",
    cdCompanyNameLabel: "Company Name",
    cdDescriptionLabel: "Description",
    cdIndustryLabel: "Industry",
    cdCompanySizeLabel: "Company Size",
    cdFoundedYearLabel: "Founded Year",
    cdAboutCompany: "About Company",
    cdContactInformation: "Contact Information",
    cdSizeLabel: "Size",
    cdFoundedLabel: "Founded",
    cdYourCompanyVerified: "Your company has been verified",
    cdContactSupportInfo: "Please contact support for more info",
    cdUnderReview: "Under review by administrators",
    cdActiveDashboard: "Active Dashboard",
    cdDeleteJobPosting: "Delete Job Posting",
    cdDeleteJobConfirm: "Are you sure you want to delete this job posting?",
    cdJobUpdated: "Job updated successfully!",
    cdJobPosted: "Job posted successfully!",
    cdYearsExp: "yrs exp",
    // Mobile Drawer
    drawerTagline: "Find your next opportunity",
    drawerMyAccount: "My Account",
    drawerSavedJobs: "Saved Jobs",
    drawerMyApplications: "My Applications",
    drawerPostJob: "Post a Job",
    drawerMyJobPosts: "My Job Posts",
    drawerAnalytics: "Analytics",
    drawerRegisterCompany: "Register your company",
    drawerExplore: "Explore",
    drawerBrowseJobs: "Browse Jobs",
    drawerPreferences: "Preferences",
    drawerSubscription: "Subscription",
    drawerAboutNibJobs: "About NibJobs",
    drawerSignOutTitle: "Sign Out?",
    drawerSignOutDesc:
      "You will be signed out of your account and returned to the home screen.",
    drawerClose: "Close",
    drawerVersion: "Version",
    drawerPlatform: "Platform",
    drawerCountry: "Country",
    drawerWebsite: "Website",
    drawerSupport: "Support",
    drawerAboutTagline:
      "Ethiopia\u2019s leading job platform \u2014 connecting talented professionals with top employers.",
    // Confirmation modals
    confirmAction: "Confirm",
    areYouSure: "Are you sure?",
    deleteConfirmTitle: "Delete?",
    cannotBeUndone: "This action cannot be undone.",
    logoutConfirmTitle: "Logout Confirmation",
    logoutConfirmMessage:
      "Are you sure you want to logout? You will need to sign in again to access your account.",
    // Action buttons
    continueButton: "Continue",
    previousButton: "Previous",
    nextButton: "Next",
    backButton: "Back",
    applyButton: "Apply",
    submitApplicationButton: "Submit Application",
    postJobButton: "Post Job",
    browseMoreJobs: "Browse More Jobs",
    goBack: "Go Back",
    notNow: "Not now",
    // Application flow
    applyForPosition: "Apply for Position",
    applicationStatus: "Application Status",
    stepLabel: "Step",
    ofLabel: "of",
    personalInfoStep: "Personal Info",
    professionalStep: "Professional",
    coverLetterStep: "Cover Letter",
    personalInformationSection: "Personal Information",
    professionalLinksSubtitle:
      "Share your online presence and work samples (optional)",
    coverLetterSubtitle:
      "Tell the employer why you are a great fit for this position",
    coverLetterTip:
      "Tip: A personalized cover letter increases your chances of getting noticed",
    // Application filters / statuses
    statusAll: "All",
    statusPending: "Pending",
    statusReviewed: "Reviewed",
    statusShortlisted: "Shortlisted",
    statusAccepted: "Accepted",
    statusRejected: "Rejected",
    filterByStatus: "Filter by status",
    // Company profile / registration
    companyNameLabel: "Company Name",
    companyDescriptionLabel: "Company Description",
    companyEmailLabel: "Company Email",
    companyPhoneLabel: "Company Phone",
    addressLabel: "Address",
    cityLabel: "City",
    websiteLabel: "Website",
    industryLabel: "Industry",
    companySizeLabel: "Company Size",
    uploadLogo: "Upload Logo",
    // Subscription (mobile)
    subscriptionPlansTitle: "Subscription Plans",
    getStartedBtn: "Get Started",
    chooseStandardBtn: "Choose Standard",
    chooseProBtn: "Choose Pro",
    chooseEnterpriseBtn: "Choose Enterprise",
    // App bar titles / misc
    emailVerificationRequired: "Email Verification Required",
    emailNotVerified: "Email Not Verified",
    resetPasswordTitle: "Reset Password",
    resetPasswordSubtitleMobile:
      "We will send reset instructions to your email",
    jobNotFoundTitle: "Job Not Found",
    somethingWentWrong: "Something Went Wrong",
    manageJobListings: "Manage your job listings, applications, and analytics",
    // Verification steps
    verifyStep1Title: "Open Your Email",
    verifyStep1Desc: "Check your inbox and spam folder",
    verifyStep2Title: "Click the Link",
    verifyStep2Desc: "Tap the verification link in the email",
    verifyStep3Title: "Start Exploring",
    verifyStep3Desc: "Sign in and find your dream job!",
    locationLabel: "Location",
    updateJobButton: "Update Job",
    remoteWorkSubtitle: "Allow employees to work remotely",
    selectedCountLabel: "Selected",
    searchApplicationsPlaceholder: "Search applications...",
    noApplicationsYet: "No Applications Yet",
    jobRoleLabel: "Role",
    saveChangesButton: "Save Changes",
  },
  am: {
    // Amharic
    appTitle: "ንብ ስራዎች",
    searchPlaceholder: "ስራዎችን ይፈልጉ...",
    login: "ግባ",
    signUp: "መመዝገብ",
    exploreChannels: "🚀 የቴሌግራም ቻናሎችን አስሱ",
    swipeHint: "← ተጨማሪ ቻናሎችን ለማስሳት ይንሸራተቱ →",
    recentJobs: "የቅርብ ጊዜ ስራዎች",
    jobsFound: "ስራዎች ተገኝተዋል",
    loading: "ስራዎች በመጫን ላይ...",
    categories: "ምድቦች",
    contractType: "የኮንትራት አይነት",
    location: "አካባቢ",
    remoteJobs: "የርቀት ስራዎች",
    clearFilters: "ማጣሪያዎችን አጽዳ",
    adminLogin: "የአስተዳዳሪ መግቢያ",
    email: "ኢሜይል",
    password: "የይለፍ ቃል",
    loginButton: "ግባ",
    loginError: "እባክዎ ኢሜይል እና የይለፍ ቃል ያስገቡ",
    invalidCredentials: "ልክ ያልሆነ ኢሜይል ወይም የይለፍ ቃል",
    telegramChannel: "የቴሌግራም ቻናል",
    members: "አባላት",
    darkMode: "ጨለማ ገጽታ",
    language: "ቋንቋ",
    downloadPlayStore: "ፕሌይ ስቶር",
    downloadAppStore: "አፕ ስቶር",
    // Jobs page
    employmentType: "የቅጥር አይነት",
    workMode: "የስራ ዘዴ",
    fullTime: "ሙሉ ጊዜ",
    partTime: "የትርፍ ጊዜ",
    contract: "ውል",
    remote: "ርቀት",
    onSite: "በቦታው",
    hybrid: "ድብልቅ",
    applyNow: "አሁን ያመልክቱ",
    shareJob: "ስራ አጋራ",
    viewDetails: "ዝርዝር ይመልከቱ",
    salaryRange: "የደመወዝ ክልል",
    posted: "የተለጠፈ",
    ago: "በፊት",
    noJobsFound: "ምንም ስራዎች አልተገኙም",
    filterJobs: "ስራዎችን አጣራ",
    sortBy: "ደርድር በ",
    clearAll: "ሁሉንም አጽዳ",
    // Companies page
    companies: "ኩባንያዎች",
    viewAll: "ሁሉንም ይመልከቱ",
    noCompaniesFound: "ምንም ኩባንያዎች አልተገኙም",
    // Settings page
    settings: "ቅንብሮች",
    profile: "መገለጫ",
    notifications: "ማሳወቂያዎች",
    theme: "ገጽታ",
    logout: "ውጣ",
    about: "ስለ",
    privacy: "የግላዊነት ፖሊሲ",
    terms: "የአገልግሎት ውል",
    // Bookmarks
    bookmarks: "የተቀመጡ",
    bookmark: "ምልክት አድርግ",
    save: "አስቀምጥ",
    saved: "ተቀምጧል",
    remove: "አስወግድ",
    // Common
    jobs: "ስራዎች",
    search: "ፈልግ",
    filter: "አጣራ",
    apply: "ያመልክቱ",
    company: "ኩባንያ",
    salary: "ደመወዝ",
    description: "መግለጫ",
    requirements: "መስፈርቶች",
    // Hero Section
    heroBadge: "🚀 የኢትዮጵያ #1 የስራ መድረክ",
    heroSubtitle: "የኢትዮጵያ መሪ የስራ መድረክ - ተሰጥኦ ከእድል ጋር ማገናኘት",
    heroDescription: "ከ500+ መሪ ኩባንያዎች ጋር ይገናኙ እና በኢትዮጵያ 10,000+ እድሎችን ያስሱ።",
    desktopHeroFind: "የህልም ስራዎን",
    desktopHeroDreamJob: "ያግኙ",
    desktopHeroExplore: "በ",
    desktopHeroTopCategories: "+ ዋና ምድቦች ውስጥ ከ",
    desktopHeroActivePositions: "+ ንቁ የስራ ቦታዎች ያስሱ።",
    desktopSearchPlaceholder: "ስራዎችን፣ ክህሎቶችን ወይም ኩባንያዎችን ይፈልጉ...",
    desktopViewAll: "ሁሉንም ይመልከቱ →",
    getStartedFree: "በነጻ ይጀምሩ",
    getItOnGooglePlay: "ያግኙት በ",
    googlePlay: "Google Play",
    searchJobsPlaceholder: "ስራዎችን፣ ኩባንያዎችን ወይም ቁልፍ ቃላትን ይፈልጉ",
    trendingTags: "በትራንድ:",
    remoteWork: "የርቀት ስራ",
    techJobs: "የቴክኖሎጂ ስራዎች",
    marketing: "ማርኬቲንግ",
    sales: "ሽያጭ",
    engineering: "ምህንድስና",
    statsJobs: "ስራዎች",
    statsCompanies: "ኩባንያዎች",
    statsProfessionals: "ባለሙያዎች",
    telegramChannelsTitle: "📢 የቴሌግራም የስራ ቻናሎች",
    telegramChannelsSubtitle: "ከተረጋገጡ ቻናሎች የቅርብ ጊዜ የስራ መልዕክቶችን ይከታተሉ",
    viewChannel: "ቻናል ይመልከቱ",
    categoriesTitle: "🎯 በምድብ ያስሱ",
    categoriesSubtitle: "በእርስዎ መስክ እድሎችን ያግኙ",
    viewAllCategories: "ሁሉንም ምድቦች ይመልከቱ",
    featuredCompaniesTitle: "🏢 ተለይተው የቀረቡ ኩባንያዎች",
    featuredCompaniesSubtitle: "አሁን የሚቀጥሩ ከፍተኛ ቀጣሪዎች",
    viewAllCompanies: "ሁሉንም ኩባንያዎች ይመልከቱ",
    openPositions: "ክፍት ቦታዎች",
    whyChooseTitle: "ለምን NibJobs ይምረጡ?",
    whyChooseSubtitle: "በሙያ እድገትዎ ላይ የታመነ አጋርዎ",
    verifiedJobsTitle: "የተረጋገጡ ስራዎች",
    verifiedJobsDesc: "ሁሉም የስራ መልዕክቶች ለእውነተኝነት ተረጋግጠዋል",
    multiChannelTitle: "በርካታ ምንጮች",
    multiChannelDesc: "ስራዎችን ከቴሌግራም ቻናሎች እና ቀጥተኛ ቀጣሪዎች ያግኙ",
    realTimeTitle: "የእውነተኛ-ጊዜ ማሻሻያዎች",
    realTimeDesc: "ለአዳዲስ እድሎች ፈጣን ማሳወቂያዎችን ያግኙ",
    easyApplicationTitle: "ቀላል ማመልከቻ",
    easyApplicationDesc: "በአንድ መገለጫ ለብዙ ስራዎች ያመልክቱ",
    readyToStartTitle: "ጉዞዎን ለመጀመር ዝግጁ ነዎት?",
    readyToStartDesc: "የህልማቸውን ስራዎች ያገኙ በሺዎች የሚቆጠሩ ባለሙያዎች ይቀላቀሉ",
    footerAbout: "ስለ NibJobs",
    footerAboutDesc:
      "NibJobs የኢትዮጵያ መሪ የስራ መድረክ ነው፣ ተሰጥኦ ያላቸውን ባለሙያዎች ከከፍተኛ ቀጣሪዎች ጋር በሀገሪቱ ውስጥ ያገናኛል።",
    footerJobSeekers: "ለስራ ፈላጊዎች",
    footerQuickLinks: "ፈጣን አገናኞች",
    footerBrowseJobs: "ስራዎችን ያስሱ",
    footerJobAlerts: "የስራ ማንቂያዎች",
    footerCareerAdvice: "የስራ ምክር",
    footerResumeTips: "የሪዙሜ ምክሮች",
    footerCompanies: "ኩባንያዎች",
    footerCategories: "ምድቦች",
    footerTelegram: "የቴሌግራም ቻናሎች",
    footerForEmployers: "ለቀጣሪዎች",
    footerPostJob: "ስራ ያስተዋውቁ",
    footerEmployerDashboard: "የቀጣሪ ዳሽቦርድ",
    footerPricing: "ዋጋ አሰጣጥ",
    footerRecruitmentTips: "የቅጥር ምክሮች",
    footerCompany: "ኩባንያ",
    footerContact: "ያግኙን",
    footerPrivacy: "የግላዊነት ፖሊሲ",
    footerTerms: "የአገልግሎት ውል",
    footerSupport: "ድጋፍ",
    footerHelpCenter: "የእገዛ ማእከል",
    footerContactUs: "ያግኙን",
    footerFAQ: "ተደጋግሞ የሚጠየቁ ጥያቄዎች",
    footerCopyright: "© 2025 NibJobs። ሁሉም መብቶች የተጠበቁ ናቸው።",
    footerPrivacyShort: "ግላዊነት",
    footerTermsShort: "ውሎች",
    footerCookies: "ኩኪዎች",
    footerPricingPlans: "የዋጋ እቅዶች",
    home: "ዋና ገጽ",
    allJobs: "ሁሉም ስራዎች",
    channels: "ቻናሎች",
    more: "ተጨማሪ",
    // About Us Section
    aboutUsLabel: "ስለእኛ",
    aboutUsTitle: "ስለ NibJobs",
    aboutUsSubtitle: "የኢትዮጵያን ተሰጥኦ ከእድሎች ጋር ማገናኘት",
    aboutUsDesc:
      "NibJobs የኢትዮጵያ ዋና የስራ መግቢያ በር ነው፣ በተሰጥዖ ባለሙያዎች እና በሀገሪቱ ውስጥ አስደሳች የስራ እድሎች መካከል ያለውን ክፍተት ለመድፈን የተወሰነ።",
    topCompanies: "ከፍተኛ ኩባንያዎች",
    topCompaniesDesc: "በተለያዩ ኢንዱስትሪዎች ውስጥ ካሉ መሪ ቀጣሪዎች ጋር ይገናኙ",
    instantAlerts: "ፈጣን ማሳወቂያዎች",
    instantAlertsDesc: "ተዛማጅ ስራዎች ሲለጠፉ ወዲያውኑ ማሳወቂያ ይቀበሉ",
    multilingual: "ባለብዙ ቋንቋ",
    multilingualDesc: "በእንግሊዝኛ፣ አማርኛ፣ ትግርኛ እና ኦሮምኛ ይገኛል",
    // Opportunities Section
    latestOpportunities: "የቅርብ ጊዜ እድሎች",
    latestOpportunitiesSubtitle: "ዛሬ የተለጠፉ አዳዲስ ስራዎች",
    viewAllJobs: "ሁሉንም ስራዎች ይመልከቱ",
    // How It Works Section
    processLabel: "ሂደት",
    howItWorksTitle: "እንዴት ይሰራል",
    howItWorksSubtitle: "በ3 ቀላል ደረጃዎች ይቀጠሩ",
    step1: "ይፈልጉ",
    step1Desc: "በኢትዮጵያ ውስጥ ካሉ የተረጋገጡ ኩባንያዎች በሺዎች የሚቆጠሩ ስራዎችን ያስሱ",
    step2: "ያመልክቱ",
    step2Desc: "መገለጫዎን በመጠቀም በአንድ ጠቅታ ማመልከቻዎን ያስገቡ",
    step3: "ይቀጠሩ",
    step3Desc: "ከቀጣሪዎች ጋር ይገናኙ እና የህልምዎን ስራ ያግኙ",
    // Popular Categories Section
    popularCategoriesLabel: "ምድቦች",
    popularCategoriesTitle: "ታዋቂ ምድቦች",
    popularCategoriesSubtitle: "እድሎችን በመስክ ያስሱ",
    // Success Stories Section
    storiesLabel: "ታሪኮች",
    successStoriesTitle: "የስኬት ታሪኮች",
    successStoriesSubtitle: "እውነተኛ ሰዎች፣ በNibJobs እውነተኛ ስኬት",
    readMore: "ተጨማሪ ያንብቡ",
    // Plans Section
    plansLabel: "እቅዶች",
    chooseYourPlan: "እቅድዎን ይምረጡ",
    chooseYourPlanSubtitle: "ለፍላጎትዎ ትክክለኛውን እቅድ ይምረጡ",
    free: "ነጻ",
    premium: "ፕሪሚየም",
    enterprise: "ኢንተርፕራይዝ",
    perMonth: "/ወር",
    mostPopular: "በጣም ታዋቂ",
    getStarted: "ይጀምሩ",
    contactUs: "ያግኙን",
    // Never Miss Section
    neverMissLabel: "ይመዝገቡ",
    neverMissTitle: "ምንም እድል አያመልጥዎት",
    neverMissSubtitle: "የስራ ማንቂያዎችን በቀጥታ ወደ ኢሜልዎ ይቀበሉ",
    emailPlaceholder: "ኢሜልዎን ያስገቡ",
    subscribe: "ይመዝገቡ",
    // Login Page
    loginTagline: "ተሰጥኦን ከዕድሎች ጋር የሚያገናኝ የኢትዮጵያ ቀዳሚ የሥራ መፈለጊያ",
    loginActiveJobsLabel: "10,000+ ክፍት ሥራዎች",
    loginActiveJobsDesc: "የተጣሩ ዕድሎች",
    loginTopCompaniesLabel: "500+ ምርጥ ኩባንያዎች",
    loginTopCompaniesDesc: "መሪ ቀጣሪዎች",
    loginInstantAlertsLabel: "ፈጣን ማሳወቂያዎች",
    loginInstantAlertsDesc: "ምንም እድል አያመልጥዎት",
    // FAQ Section
    faqLabel: "ተደጋግሞ የሚጠየቁ ጥያቄዎች",
    faqTitle: "ተደጋግሞ የሚጠየቁ ጥያቄዎች",
    faqSubtitle: "ስለ NibJobs ለተለመዱ ጥያቄዎች መልሶችን ያግኙ",
    faq1Q: "ንብ ስራዎች በነጻ ነው የሚገኘው?",
    faq1A:
      "አዎ! ስራ ፈላጊዎች ስራዎችን በነጻ መመልከት እና ማመልከት ይችላሉ። እንዲሁም ለተሻሻለ ታይነት ፕሪሚየም ባህሪያትን እናቀርባለን።",
    faq2Q: "ለስራ እንዴት ማመልከት እችላለሁ?",
    faq2A:
      "በቀላሉ መለያ ይፍጠሩ፣ መግለጫዎን ያጠናቅቁ እና በማንኛውም የስራ ዝርዝር ላይ 'ማመልከቻ' የሚለውን ይጫኑ። አንዳንድ ስራዎች ወደ ኩባንያው የማመልከቻ ገጽ ሊያዞሩዎት ይችላሉ።",
    faq3Q: "አዳዲስ ስራዎች ምን ያህል ጊዜ ይለቀቃሉ?",
    faq3A:
      "አዳዲስ ስራዎች በየቀኑ ይለቀቃሉ! ከምርጫዎ ጋር የሚዛመዱ ቦታዎች ሲገኙ ማሳወቂያ ለማግኘት የስራ ማንቂያዎችን ያንቁ።",
    faq4Q: "ስራዎችን ንድህሪት ላስቀምጥ እችላለሁ?",
    faq4A:
      "አዎ! በማንኛውም የስራ ዝርዝር ላይ የመጽሐፍ ምልክት አይቆን ጠቅ በማድረግ ወደ ተወዳጆችዎ ያስቀምጡ። የተቀመጡ ስራዎችን በማንኛውም ጊዜ ከመግለጫዎ ይድረሱባቸው።",
    // Resume Tips
    resumeTipsTitle: "የሪዙሜ ምክሮች",
    resumeTipsHero: "ተለይቶ የሚታይ ሪዙሜ ይፍጠሩ",
    resumeTipsHeroDesc: "ትኩረት የሚስቡ ሪዙሜዎችን ለመስራት ሙያዊ መመሪያ",
    resumeFormatting: "የሪዙሜ አቀራረብ",
    resumeFormattingText:
      "• ንጹህ እና ሙያዊ አቀማመጥ ይጠቀሙ\n• አጭር ያድርጉት (ከ1-2 ገጾች በላይ አይሁን)\n• ተከታታይ አቀራረብ እና ፊደሎች ይጠቀሙ\n• ትክክለኛ የመገናኛ መረጃ ያካትቱ\n• ለሁለንተናዊ ተጣጣሚነት እንደ PDF ያስቀምጡ",
    resumeKeySections: "ዋና ክፍሎች",
    resumeKeySectionsText:
      "ሙያዊ ማጠቃለያ: የእርስዎ ልምድ እና የስራ ግቦች አጭር መግለጫ\n\nየስራ ልምድ: ሊለካ የሚችል ስኬት ያላቸውን ቦታዎች ዘርዝር\n\nትምህርት: ዲግሪዎች፣ የምስክር ወረቀቶች እና ተዛማጅ ትምህርቶች ያካትቱ\n\nክህሎቶች: ሁለቱንም ቴክኒካዊ እና ለስላሳ ክህሎቶች አግላ\n\nስኬቶች: ሽልማቶች፣ እውቅናዎች እና ታዋቂ ስኬቶችን አሳይ",
    resumeWritingTips: "የመጻፍ ምክሮች",
    resumeWritingTipsText:
      "• የድርጊት ግሶች ይጠቀሙ (አሳካለሁ፣ አስተዳደረኩ፣ ሰራሁ፣ መሪኝሁ)\n• ስኬቶችን በቁጥሮች እና መለኪያዎች ይለኩ\n• ለእያንዳንዱ የስራ ማመልከቻ ሪዙሜህን አስተካክል\n• ስህተቶችን በጥንቃቄ አረጋግጥ\n• ቋንቋ ሙያዊ እና አጭር እንዲሆን ያድርጉ",
    resumeMistakes: "መራቅ ያለባቸው የተለመዱ ስህተቶች",
    resumeMistakesText:
      "✗ ተዛማጅ ያልሆነ የግል መረጃ ማካተት\n✗ ሙያዊ ያልሆኑ የኢሜይል አድራሻዎችን መጠቀም\n✗ ስኬቶችን ሳይሆን ተግባራትን መዘርዘር\n✗ የፊደል ወይም ሰዋስው ስህተቶች መኖር\n✗ አጠቃላይ፣ ለሁሉም የሚሆን ሪዙሜ መጠቀም",
    uploadResume: "ሪዙሜዎን ይስቀሉ",
    // Login Screen
    signInTitle: "እንኳን ደህና መጡ",
    signInSubtitle: "ወደ መለያዎ ይግቡ",
    emailAddress: "የኢሜል አድራሻ",
    forgotPassword: "የይለፍ ቃል ረሱት?",
    signInButton: "ግባ",
    signingIn: "በመግባት ላይ...",
    orContinueWith: "ወይም ይቀጥሉ ከ",
    signInWithGoogle: "በGoogle ግባ",
    dontHaveAccount: "መለያ የለዎትም? ",
    signUpLink: "ይመዝገቡ",
    backToHome: "ወደ መነሻ ተመለስ",
    // Signup Screen
    createAccountTitle: "መለያ ይፍጠሩ",
    createAccountSubtitle: "ኒብጆብስን ይቀላቀሉና የህልምዎን ስራ ያግኙ",
    joinMessage: "ሁሉንም ባህሪያት ለመድረስ እባክዎ ይመዝገቡ እና ወደ የስራ እድሎች አለም ይቀላቀሉ።",
    fullName: "ሙሉ ስም",
    confirmPassword: "የይለፍ ቃል አረጋግጥ",
    createAccount: "መለያ ፍጠር",
    creatingAccount: "መለያ በመፍጠር ላይ...",
    alreadyHaveAccount: "መለያ አለዎት? ",
    signInLink: "ግባ",
    // Verification
    checkYourEmail: "ኢሜልዎን ያረጋግጡ",
    verificationSent: "የማረጋገጫ ኢሜል ተልኳል!",
    verificationMessage:
      "የማረጋገጫ ኢሜል ወደ መለያዎ ተልኳል። እባክዎ ኢሜልዎን ያረጋግጡ እና የማረጋገጫ አገናኝን ጠቅ ያድርጉ።",
    verificationEmail: "ኢሜል አድራሻ",
    goToLogin: "ወደ ግባ ይሂዱ",
    // Errors
    fillAllFields: "እባክዎ ሁሉንም መስኮች ይሙሉ",
    passwordsDontMatch: "የይለፍ ቃሎች አይዛመዱም",
    passwordTooShort: "የይለፍ ቃል ቢያንስ 6 ፊደላት መሆን አለበት",
    emailInUse: "ይህ ኢሜል አስቀድሞ ተመዝግቧል",
    invalidEmail: "ልክ ያልሆነ የኢሜል አድራሻ",
    weakPassword: "የይለፍ ቃል በጣም ደካማ ነው",
    accountExists: "በዚህ ኢሜል መለያ አስቀድሞ አለ",
    signupFailed: "ምዝገባ አልተሳካም። እባክዎ እንደገና ይሞክሩ።",
    loginFailed: "መግባት አልተሳካም። እባክዎ ማረጋገጫዎን ያረጋግጡ።",
    // Pricing Section
    popularBadge: "ታዋቂ",
    perYear: "/አመት",
    orYearly: "ወይም",
    choosePlan: "እቅድ ይምረጡ",
    freePlanDesc: "ለመጀመር ፍጹም",
    standardPlanDesc: "ለንቁ የስራ ፈላጊዎች ምርጥ",
    proName: "ፕሮ",
    proPlanDesc: "ለሚያድጉ ቡድኖች እና ታታሪ ባለሙያዎች",
    enterprisePlanDesc: "ለቀጣሪዎች እና ለቅጥር ሰራተኞች",
    freeFeature1: "በሞባይል መተግበሪያ በቀን 3 ብጁ የስራ ማሳወቂያዎች",
    freeFeature2: "መሰረታዊ የስራ ፍለጋ እና ማሰስ",
    freeFeature3: "የስራ ማስታወቂያ መለጠፍ አይችሉም",
    freeFeature4: "በቀን ወደ 3 ማሳወቂያዎች ብቻ የተገደበ",
    standardFeature1: "በቀን እስከ 50 ብጁ የስራ ማሳወቂያዎች",
    standardFeature2: "በፍለጋ ውጤቶች ውስጥ ቅድሚያ",
    standardFeature3: "የላቀ የማጣሪያ አማራጮች",
    standardFeature4: "የሪዙሜ ታይነት መጨመር",
    standardFeature5: "የስራ ማስታወቂያ መለጠፍ አይችሉም",
    proFeature1: "ያልተገደቡ የስራ ማስታወቂያዎች ለጥፍ",
    proFeature2: "ሪዙሜዎችን ተቀበል እና አስተዳድር",
    proFeature3: "ዝርዝር የስራ ገበያ አከታታዮች",
    proFeature4: "የአመልካች ክትትል ስርዓት",
    proFeature5: "የኩባንያ ምርት ስም እና አርማ ማሳያ",
    proFeature6: "ተለይተው የቀረቡ የስራ ቦታዎች",
    proFeature7: "ቅድሚያ የሚሰጥ ድጋፍ እና የመለያ አስተዳዳሪ",
    enterpriseFeature1: "ያልተገደቡ የስራ ማስታወቂያዎች ለጥፍ",
    enterpriseFeature2: "ሪዙሜዎችን ተቀበል እና አስተዳድር",
    enterpriseFeature3: "ዝርዝር የስራ ገበያ አከታታዮች",
    enterpriseFeature4: "የአመልካች ክትትል ስርዓት",
    enterpriseFeature5: "የኩባንያ ምርት ስም እና አርማ ማሳያ",
    enterpriseFeature6: "ተለይተው የቀረቡ የስራ ቦታዎች",
    enterpriseFeature7: "ቅድሚያ የሚሰጥ ድጋፍ እና የመለያ አስተዳዳሪ",
    privacyTitle: "የግላዊነት ፖሊሲ",
    lastUpdated: "መጨረሻ የዘመነበት፡",
    privacySection1Title: "1. የምንሰበስበው መረጃ",
    privacySection1Text:
      "NibJobsን ሲጠቀሙ በቀጥታ የሚሰጡንን መረጃ እንሰበስባለን። ይህም ስምዎን፣ የኢሜል አድራሻዎን፣ የስልክ ቁጥርዎን፣ ሪዙሜዎን እና የስራ ምርጫዎችዎን ያካትታል። እንዲሁም የመተግበሪያውን አጠቃቀምዎን እና የሚመለከቷቸውን ወይም ለሚያመለክቷቸውን ስራዎች መረጃ እንሰበስባለን።",
    privacySection2Title: "2. መረጃዎን እንዴት እንጠቀማለን",
    privacySection2Text:
      "የምንሰበስበውን መረጃ አገልግሎቶቻችንን ለመስጠት፣ ለመጠበቅ እና ለማሻሻል እንጠቀማለን። ይህም ከተገቢ የስራ እድሎች ጋር ማገናኘትዎን፣ ስለ ስራዎች እና አገልግሎቶቻችን እርስዎን ማነጋገርን፣ እና የተጠቃሚውን ልምድ ለማሻሻል የአጠቃቀም ቅጦችን መተንተንን ያካትታል።",
    privacySection3Title: "3. መረጃ ማጋራት",
    privacySection3Text:
      "ለስራ ማስታወቂያቸው ሲያመለክቱ መረጃዎን ከቀጣሪዎች ጋር እናጋራለን። የግል መረጃዎን ለሶስተኛ ወገኖች አንሸጥም። ፕላትፎርማችንን እንድንሰራ የሚረዱንን አጋሮች እና አገልግሎት ሰጪዎች ጋር የተደመረ፣ በግል የማይታወቅ መረጃ ልናጋራ እንችላለን።",
    privacySection4Title: "4. የመረጃ ደህንነት",
    privacySection4Text:
      "የግል መረጃዎን ያልተፈቀደ መዳረሻ፣ ለውጥ፣ መግለጫ ወይም ውድመት ለመከላከል ተገቢ ቴክኒካል እና ድርጅታዊ የደህንነት እርምጃዎችን እንተገብራለን። ሆኖም፣ ምንም የኢንተርኔት ማስተላለፍ ሙሉ በሙሉ ደህንነቱ የተጠበቀ አይደለም እና ፍጹም ደህንነትን ማረጋገጥ አንችልም።",
    privacySection5Title: "5. መብቶችዎ",
    privacySection5Text:
      "በማንኛውም ጊዜ በመለያ ቅንብሮችዎ በኩል የግል መረጃዎን የማግኘት፣ የማዘመን ወይም የመሰረዝ መብት አለዎት። እንዲሁም ከአንዳንድ መግባባቶች መውጣት ይችላሉ። ስለ መረጃዎ አያያዝ ላይ ስጋት ካለዎ፣ እባክዎ ያግኙን።",
    privacySection6Title: "6. ያግኙን",
    privacySection6Text:
      "ስለዚህ የግላዊነት ፖሊሲ ወይም የመረጃ አያያዝ ልምዶቻችንን ማንኛውም ጥያቄ ካለዎ፣ እባክዎ በ privacy@nibjobs.com ያግኙን። ለጥያቄዎ በተቻለ ፍጥነት ምላሽ እንሰጣለን።",
    // Additional Home Page Texts
    categoriesLabel: "ምድቦች",
    testimonialsLabel: "ምስክርነቶች",
    pricingPlansLabel: "የዋጋ እቅዶች",
    faqLabel2: "ጥያቄ እና መልስ",
    jobsText: "ስራዎች",
    viewAllJobsButton: "ሁሉንም ስራዎች ይመልከቱ",
    loginAndViewMore: "ይግቡ እና ተጨማሪ ስራዎችን ይመልከቱ",
    loadingJobs: "ስራዎች በመጫን ላይ...",
    manageAlerts: "ማስታወቂያዎችን ያስተዳድሩ",
    signUpForAlerts: "ለማስታወቂያዎች ይመዝገቡ",
    signUpToAccessAll:
      "ሁሉንም ባህሪያት ለመድረስ እና ሁሉንም ስራዎች ለማስሰስ እባክዎ ይመዝገቡ። መመዝገብ ሙሉ በሙሉ ነፃ ነው!",
    signUpForJobAlerts: "ለግል የተበጁ የስራ ማስታወቂያዎችን ለመቀበል ይመዝገቡ!",
    playStoreDownload: "ጉግል ፕሌይ",
    getItOn: "ያግኙት በ",
    // Mobile Landing Page
    mobileSignIn: "ግባ",
    mobileActiveJobs: "ክፍት የስራ ቦታዎች",
    mobileThousandsJobs: "በሺዎች የሚቆጠሩ ስራዎች",
    mobileHeroLine1: "የህልምዎን ስራ",
    mobileHeroHighlight: "ዛሬውኑ",
    mobileHeroLine2: "ያግኙ።",
    mobileHeroDesc:
      "ከ50 በላይ የቴሌግራም ቻናሎችና ድርጅቶች የሚወጡ ስራዎች በአንድ ቦታ — በነጻ፣ ያለ ደላላ።",
    mobileHeroPerkFree: "በነጻ",
    mobileHeroPerkNoBroker: "ያለ ደላላ",
    mobileHeroPerkAlerts: "ፈጣን ማሳወቂያ",
    mobileHeroNoAccount: "አካውንት የለዎትም?",
    mobileHeroSignUp: "በነጻ ይመዝገቡ",
    mobileHeroSearchButton: "ፈልግ",
    liveJobsLabel: "በቀጥታ",
    liveJobsUpdated: "በየቀኑ ይታደሳል",
    liveJobsCaption: "ክፍት የስራ ቦታዎች እርስዎን እየጠበቁ ነው",
    mobileSearchPlaceholder: "ስራዎችን፣ ኩባንያዎችን ይፈልጉ...",
    mobileBrowseAll: "ሁሉንም ስራዎች ያስሱ",
    mobileCreateAccount: "በነጻ መለያ ይፍጠሩ",
    mobileTopCategories: "ዋና ምድቦች",
    mobileLatestOpenings: "የቅርብ ጊዜ ክፍት ቦታዎች",
    mobileSeeAll: "ሁሉንም ይመልከቱ →",
    mobileGetApp: "የNibJobs መተግበሪያን ያግኙ",
    mobileGetAppDesc:
      "ለስራ ወዲያውኑ ያመልክቱ፣ የእውነተኛ ጊዜ ማሳወቂያዎችን ያግኙ እና ማመልከቻዎችዎን በየትኛውም ቦታ ይከታተሉ።",
    mobileFeatureAlerts: "ፈጣን ማሳወቂያ",
    mobileFeatureApply: "ቀላል ማመልከቻ",
    mobileFeatureTrack: "ሁኔታ ክትትል",
    mobileGetItOn: "ያግኙት በ",
    mobileGooglePlay: "ጉግል ፕሌይ",
    mobileStatsJobs: "ስራዎች",
    mobileStatsCategories: "ምድቦች",
    mobileStatsCompanies: "ኩባንያዎች",
    mobileWhyLoveUs: "ስራ ፈላጊዎች ለምን ይወዱናል",
    mobileUpdatedDaily: "በየቀኑ ይዘመናል",
    mobileUpdatedDailyDesc: "ከምርጥ የኢትዮጵያ ቀጣሪዎች ዘወትር አዳዲስ የስራ ዝርዝሮች።",
    mobileSmartAlerts: "ብልጥ ማሳወቂያዎች",
    mobileSmartAlertsDesc: "ከክህሎትዎ ጋር የሚዛመድ ስራ ሲገኝ ወዲያውኑ ይወቁ።",
    mobileTrustedCompanies: "የታመኑ ኩባንያዎች",
    mobileTrustedCompaniesDesc: "ሁሉም ቀጣሪዎች ለደህንነትዎ ተረጋግጠዋል።",
    mobileReadyTitle: "ቀጣዩን ሚናዎን ለማግኘት ዝግጁ ነዎት?",
    mobileReadyDesc: "በመላ ኢትዮጵያ በሺዎች የሚቆጠሩ ስራ ፈላጊዎችን ይቀላቀሉ።",
    mobileStartBrowsing: "ስራዎችን ማሰስ ይጀምሩ",
    mobileFooterPrivacy: "ግላዊነት",
    mobileFooterTerms: "ውሎች",
    mobileFooterJobs: "ስራዎች",
    mobileFooterCopyright: "© {year} NibJobs። ሁሉም መብቶች የተጠበቁ ናቸው።",
    // Auth Screen (Amharic)
    resetPassword: "የይለፍ ቃል ዳግም ያስጀምሩ",
    resetPasswordSubtitle:
      "የኢሜይል አድራሻዎን ያስገቡ እና የይለፍ ቃልዎን ዳግም ለማስጀምር ጥቅሰትሜ ሰከረ ያስፈልጋ ሰከ",
    sendResetLink: "የዳግም ማስጀምሪያ ሰከ ላክ",
    sendingReset: "እየተላለፈ...",
    backToLogin: "ወደ ግቢያ ተመለስ",
    forgotTagline: "አትጨነቁ — ይሄ ለብዙዎቻቸን ይሆናል።",
    forgotSecureReset: "ደህንነት ያለው የይለፍ ቃል ዳግም ማስጀምር",
    forgotCheckInbox: "የደረሰኝ ሳጥንዎን ይፈትሹ",
    forgotAccountSafe: "መለያዎ ደህን ነው",
    signupTagline: "በኢትዮጵያ ምርጥ ሥራዎች ዕድሎ ለሚፈልጉ (ምርጥ) ሞያዊ ሰዎች ይቀላቀሉ።",
    signupThousandsJobs: "ዘላቂ የሥራ ዕድሎች",
    signupInstantAlerts: "ፈጣን የሥራ ማሳወቂያዎች",
    signupVerifiedEmployers: "የተረጋገጡ ቀጣሪዎች ብቻ",
    emailSentTitle: "ኢሜይል ተልኳል!",
    resetSentTo: "የይለፍ ቃልዎን ዳግም ለማስጀምር",
    checkInboxForReset: "የደረሰኝ ሳጥን ይፈትሹ እና ሰከ ይጫኑ",
    enterEmailError: "እባክዎ የኢሜይል አድራሻዎን ያስገቡ",
    noAccountFoundError: "ከዚህ ኢሜይል ጋር መለያ አልተገኘም",
    resetEmailFailedError: "ዳግም ኢሜይል ለመላክ አልተሳካም። እባክዎ ዳግም ይሞክሩ።",
    verificationLinkSentTo: "የምክር ሰከ ተልኳል",
    emailStep1Title: "ኢሜይልዎን ይፈትሹ",
    emailStep1Desc: "የምክር ሰከ ወደ ኢሜይልዎ ተልኳል",
    emailStep2Title: "ሰከ ይጫኑ",
    emailStep2Desc: "ኢሜይልዎ ላይ ያለውን ሰከ ይጫኑ",
    emailStep3Title: "ማሰስ ይጀምሩ",
    emailStep3Desc: "ሥራ ለማግኘት ይግቡ!",
    browseJobs: "ሥራዎችን ይቃኙ",
    passwordStrength: "የይለፍ ቃል ኃይል",
    passwordsMatch: "\u2713 የይለፍ ቃሎች ተዛምደዋል",
    passwordStrengthWeak: "ደካማ",
    passwordStrengthStrong: "ጠንካራ",
    passwordStrengthVeryStrong: "በጣም ጠንካራ",
    fullNameRequired: "ሙሉ ስም ያስፈልጋል",
    passwordsDoNotMatch: "የይለፍ ቃሎች አይዛመዱም",
    // Settings Page (Amharic)
    settingsAccountSection: "መለያ",
    settingsPreferencesSection: "ምርጫዎች",
    settingsAccountActionsSection: "የመለያ ተግባሮች",
    settingsPortfolioLabel: "ፖርትፎሊዮ",
    settingsPortfolioSubtitle: "ሲቪ፣ ክህሎቶች & ልምድ",
    settingsAccountSubtitle: "ፕሮፋይል & ደሕንነት",
    settingsJobInterestsLabel: "የሥራ ፍላጎቶች",
    settingsJobInterestsSubtitle: "ምድቦች & ምርጫዎች",
    settingsPreferencesSubtitle: "ገጽታ & ቋንቋ",
    settingsNotificationsSubtitle: "ማሳወቂያዎን ያስተዳድሩ",
    settingsPrivacyLabel: "ግሉዊነት & ደሕንነት",
    settingsPrivacySubtitle: "ዳታ & ፍቃዶች",
    settingsSubscriptionLabel: "ደንበኝነት",
    settingsHelpLabel: "እገዛ & ድጋፍ",
    settingsHelpSubtitle: "ጥያቄዎች & ግንኙነት",
    settingsLogoutSubtitle: "ከመለያዎ ይውጡ",
    editProfileButton: "ፕሮፋይል አርትዕ",
    editChipLabel: "አርትዕ",
    jobSeekerLabel: "ሥራ ፈላጊ",
    savedJobsCount: "ተቀምጧል",
    personalInfoSection: "የግል መረጃ",
    displayNameLabel: "ስም",
    displayNamePlaceholder: "ሙሉ ስምዎ",
    usernameLabel: "የተጠቃሚ ስም",
    checkingAvailability: "እየተፈተሸ...",
    usernameAvailableText: "\u2713 ይገኛል",
    usernameTakenText: "\u2717 ተወስዷል",
    dateOfBirthLabel: "የልደት ቀን",
    bioLabel: "ባዮ",
    bioPlaceholder: "ለቀጣሪዎ ስለ ራስዎ ይናገሩ...",
    contactSection: "ግንኙነት",
    phoneNumberLabel: "ስልክ ቁጥር",
    socialLinksSection: "ማህበራዊ አገናኞች",
    addCoverPhotoLabel: "የሽፋን ፎቶ ጨምር",
    changeCoverPhotoLabel: "ቀይር",
    savingText: "እየተቀመጠ...",
    saveChangesLabel: "ለውጦችን አስቀምጥ",
    profileLinkSection: "የፕሮፋይል አገናኝ",
    copyLinkLabel: "አገናኝ ቅዳ",
    previewLabel: "ቅድሜ ዕይታ",
    cvResumeSection: "ሲቪ / ሬዙሜ",
    cvUploadedText: "ሲቪ ተሰቅሏል",
    cvPdfDocLabel: "PDF / DOC",
    cvUploadButton: "ሲቪ ስቀል",
    cvUploadingText: "እየተሰቀለ...",
    cvReplaceButton: "ተካ",
    professionalInfoSection: "ሙያዊ መረጃ",
    jobTitleLabel: "የሥራ ማዕረግ",
    yearsOfExperienceLabel: "የልምድ ዓመታት",
    aboutSection: "ስለ",
    skillsLabel: "ክህሎቶች",
    educationLabel: "ትምህርት",
    keyAchievementsLabel: "ዋና ስኬቶች",
    linksSection: "አገናኞች",
    portfolioWebsiteLabel: "የፖርትፎሊዮ ድር-ገጽ",
    savePortfolioButton: "ፖርትፎሊዮ አስቀምጥ",
    profilePreviewTitle: "ፕሮፋይል ቅድሜ ዕይታ",
    asSeenByOthers: "ሌሎች እንደሚያዩት",
    appearanceSection: "ቅርጽ",
    darkModeEnabled: "ጨለማ ገጽታ ነቅቷል",
    lightModeEnabled: "ብርሃን ገጽታ ነቅቷል",
    emailNotificationsLabel: "የኢሜይል ማሳወቂያዎች",
    emailNotificationsSubtitle: "ዝማኔዎችን በኢሜይል ይቀበሉ",
    pushNotificationsLabel: "የፑሽ ማሳወቂያዎች",
    pushNotificationsSubtitle: "ፈጣን ማሳወቂያዎችን ይቀበሉ",
    jobAlertsLabel: "የሥራ ማሳወቂያዎች",
    jobAlertsSubtitle: "ፍላጎቶዎን የሚያሟሉ አዲስ ሥራዎች",
    applicationUpdatesLabel: "የማመልከቻ ዝማኔዎች",
    applicationUpdatesSubtitle: "በማመልከቻዎ ላይ ያሉ ለውጦች",
    profileVisibilitySection: "የፕሮፋይል ታይነት",
    visibilityPublic: "ይፋዊ",
    visibilityPublicSubtitle: "ማንም ፕሮፋይልዎን ማየት ይችላል",
    visibilityConnectionsOnly: "ግንኙነቶች ብቻ",
    visibilityConnectionsOnlySubtitle: "ግንኙነቶዎ ብቻ ማየት ይችሉ",
    visibilityPrivate: "ግለሰባዊ",
    visibilityPrivateSubtitle: "ፕሮፋይልዎ ለሌሎች ይደበቃል",
    contactMessagingSection: "ግንኙነት & መልዕክቶች",
    showEmailLabel: "ኢሜይል አሳይ",
    showEmailSubtitle: "ኢሜይልዎን ይፋዊ ፕሮፋይልዎ ላይ አሳይ",
    allowMessagingLabel: "መልዕክቶችን ፍቀድ",
    allowMessagingSubtitle: "ቀጣሪዎ መልዕክቶችን ሊኮሉ ይችሉ",
    interestsHintText: "ምክሮዎን ለማሰፍረም 1 ምድብ፣ ብዙ ንዑስ ምድቦች፣ ቁልፍ ቃሎችን ይምረጡ",
    yourInterestsSection: "ፍላጎቶዎ",
    categoryLabel: "ምድብ",
    subcategoriesLabel: "ንዑስ ምድቦች",
    tagsLabel: "ቁልፍ ቃሎች",
    subcategoriesSection: "ንዑስ ምድቦች",
    saveJobInterestsButton: "የሥራ ፍላጎቶችን አስቀምጥ",
    faqsMenuTitle: "ዋና ዋና ጥያቄዎች",
    faqsMenuSubtitle: "ተለምዷዊ ጥያቄዎች ተመልሰዋል",
    contactSupportTitle: "ድጋፍ ያግኙ",
    contactSupportSubtitle: "ከቡድናችን እርዳታ ያግኙ",
    sendFeedbackTitle: "አስተያየት ላክ",
    sendFeedbackSubtitle: "ለማሻሻል ይርዱን",
    privacyPolicySubtitle: "ዳታዎን እንዴት እንጠብቃለን",
    termsOfServiceSubtitle: "የአገልጎሉ ሁኔቶችን",
    needImmediateHelpText: "ወዲያዉኑ እርዳታ ያስፈልጎታል?",
    frequentlyAskedQuestionsLabel: "ዋና ዋና ጥያቄዎች",
    stillHaveQuestionsText: "ጥያቄዎ አሁንም አለ?",
    messageSectionHeader: "መልዕክት",
    subjectFieldLabel: "ርዕሰ ጉዳይ",
    subjectFieldPlaceholder: "ስለ ምን ልንረዳዎ እንቻለን?",
    messageFieldPlaceholder: "ጉዳዩን ወይም ጥያቄዎን በዝርዝር ይጻፉ...",
    sendingText: "እየተላለፈ...",
    sendMessageButton: "መልዕክት ላክ",
    otherWaysToReachLabel: "ሌሎች የግንኙነት ዘዴዎ",
    messageSentText: "መልዕክቱ ተልኳል!",
    messageReplyTimeText: "ወደ 24-48 ሰዓት ባሉው ጊዜ ምላሽ እናቀርባለን፡",
    supportHoursLabel: "የድጋፍ ሰዓቶ",
    supportHoursText: "ሰኞ-አርብ፣ ጠ.9 - ሰ.6 EAT",
    accountSettingsTitle: "የመለያ ቅንብሮ",
    // Help FAQs
    helpFaq1Q: "እንዴት መለያ ልፍጠር?",
    helpFaq1A:
      'በላይኛው ቀኝ ጥግ ላይ "ይመዝገቡ" ቁልፍ ጠቅ ያድርጉ እና ዝርዝሮችዎን ይሙሉ። ለፈጣን ምዝገባ Google መለያዎን ሊጠቀሙ ይችላሉ።',
    helpFaq2Q: "ለስራ እንዴት ማመልከት እችላለሁ?",
    helpFaq2A:
      'የሚያስደስቶን ስራ ጠቅ ያድርጉ እናም "ያመልክቱ" ቁልፍ ይጫኑ። ከማመልከቱ በፊት ፕሮፋይልዎ እና ሪዙሜዎ ዘመናዊ መሆናቸውን ያረጋግጡ።',
    helpFaq3Q: "ካስረከቡ በኋላ ማመልከቻዬን ማርትዕ እችላለሁ?",
    helpFaq3A:
      "አንዴ ካስገቡ፣ ማመልከቻዎችን ማርትዕ አይቻልም። ከማስረከቡ በፊት መረጃ ሁሉ ትክክል መሆኑን ያረጋግጡ። ማመልከቻዎን ለማዘመን ቀጣሪውን ቀጥታ ማነጋገር ይችላሉ።",
    helpFaq4Q: "ሪዙሜዬን እንዴት ስቀልዕ?",
    helpFaq4A:
      'ቅንብሮች > ፖርትፎሊዮ ይሂዱ እናም "ሪዙሜ ስቀልዕ" ጠቅ ያድርጉ። እስከ 5MB PDF፣ DOC ወይም DOCX ፋይሎችን ሊስቀሉ ይችላሉ።',
    helpFaq5Q: "ምን ምን የደንበኝነት ምዝገባ እቅዶች አሉ?",
    helpFaq5A:
      "ነጻ፣ መደበኛ እና ኢንተርፕራይዝ እቅዶችን እናቀርባለን። ዝርዝር ባህሪያትና ዋጋ ለማወቅ ቅንብሮች > ደንበኝነት ምዝገባ ይጎብኙ።",
    helpFaq6Q: "ደንበኝነት ምዝገባዬን እንዴት ልሰርዝ?",
    helpFaq6A:
      'ቅንብሮች > ደንበኝነት ምዝገባ ይሂዱ እናም "ደንበኝነት ምዝገባ አስተዳድር" ጠቅ ያድርጉ። ደንበኝነት ምዝገባዎን በፈለጉ ጊዜ ሰርዝ ይችላሉ።',
    helpFaq7Q: "የስራ ማንቂያዎች እንዴት ይሰራሉ?",
    helpFaq7A:
      "መስፈርትዎን የሚያሟሉ አዳዲስ ስራዎች ሲለጠፉ የስራ ማንቂያዎች ያሳውቁዎታል። ቅንብሮች > ማሳወቂያዎች ውስጥ ምርጫዎን ያዘጋጁ።",
    helpFaq8Q: "ስራዎችን ለኋላ ማስቀመጥ እችላለሁ?",
    helpFaq8A:
      "አዎ! በማንኛውም የስራ ዝርዝር ላይ የቡክማርክ አዶ ጠቅ ያድርጉ። ተቀምጠው ያሉ ስራዎችን ከዋናው ምናሌ ቡክማርክ ክፍል ውስጥ ያግኙ።",
    helpFaq9Q: "ቋንቋ ምርጫዬን እንዴት ልቀይር?",
    helpFaq9A:
      "ቅንብሮች > ምርጫዎች ይሂዱ እናም የሚፈልጉትን ቋንቋ ይምረጡ። እንግሊዝኛ፣ አማርኛ፣ ትግርኛ እና ኦሮምኛ ይደገፋሉ።",
    helpFaq10Q: "ዳታዬ ደህንነቱ የተጠበቀ ነው?",
    helpFaq10A:
      "አዎ፣ የዳታ ደህንነትን ቁም ስጠን እንወስዳለን። ሁሉም የግል መረጃ ተጠብቆ ተቀምጧል። ዝርዝር ለማወቅ የግላዊነት ፖሊሲዎን ያንብቡ።",
    // Feedback form
    feedbackCategoryLabel: "ምድብ",
    feedbackRatingLabel: "ደረጃ (አማራጭ)",
    yourFeedbackLabel: "አስተያይትዎ",
    feedbackPlaceholder: "ሀሳብዎን ያካፍሉን...",
    submitFeedbackButton: "አስተያየት ላክ",
    submittingText: "እየላከ...",
    feedbackSubmittedTitle: "አስተያየቱ ቀርቧል!",
    feedbackThankYouText: "NibJobs ን ለማሻሻል ላሳወቁን እናመሰግናለን።",
    feedbackErrorText: "እባክዎ ምድብ ይምረጡ እና አስተያየት ያስገቡ",
    messageSendFailed:
      "መልዕክት መላክ አልተሳካም። እባክዎ እንደገና ይሞክሩ ወይም በቀጥታ በsupport@nibjobs.com ያግኙን",
    feedbackSubmitFailed: "አስተያየት ማስገባት አልተሳካም። እባክዎ እንደገና ይሞክሩ።",
    feedbackCategoryFeatureRequest: "ባህሪ ጥያቄ",
    feedbackCategoryBugReport: "ስህተት ሪፖርት",
    feedbackCategoryUserExperience: "የተጠቃሚ ልምድ",
    feedbackCategoryPerformance: "አፈጻጸም",
    feedbackCategoryOther: "ሌሎ",
    // Contact form
    fullNamePlaceholder: "ሙሉ ስምዎን ያስገቡ",
    privacyPolicy: "የግላዊነት ፖሊሲ",
    termsOfService: "የአገልግሎት ውል",
    // Subscription / Pick a plan page
    pickAPlan: "እቅድ ይምረጡ",
    upgradeAnytimeCancelAnytime: "በማንኛውም ጊዜ ያሻሽሉ · በማንኛውም ጊዜ ይሰርዙ",
    billingMonthly: "ወርሃዊ",
    billingYearly: "ዓመታዊ",
    loadingPlans: "እቅዶች በመጫን ላይ…",
    planActiveBadge: "ንቁ",
    planPopularBadge: "ታዋቂ",
    planPriceFree: "ነጻ",
    planPricePerMo: "/ወር",
    planPricePerYr: "/አመት",
    planSavesPercent: "ከወርሃዊ {percent}% ያቆጥባል",
    planCurrentPlanCta: "አሁናዊ እቅድ",
    planSwitchToFree: "ወደ ነጻ ቀይር",
    planGetName: "{name} ያግኙ",
    planSecureCheckout: "ደህንነቱ የተጠበቀ ክፍያ",
    planCancelAnytime: "በማንኛውም ጊዜ ይሰርዙ",
    plan247Support: "24/7 ድጋፍ",
    loginRequiredTitle: "መግቢያ ያስፈልጋል",
    loginRequiredMessage: "የደንበኝነት ምዝገባ ዕቅድዎን ለማሻሻል እባክዎ ይግቡ።",
    downgradeToFreeTitle: "ወደ ነጻ ዝቅ ማድረግ",
    downgradeToFreeMessage: "ወደ ነጻ ዕቅድ መቀየር ይፈልጋሉ?",
    planSwitchedToFree: "ወደ ነጻ ዕቅድ ተቀይሯል",
    planFailedToSwitch: "ዕቅድ መቀየር አልተሳካም",
    cancelButton: "ሰርዝ",
    confirmButton: "አረጋግጥ",
    successTitle: "ተሳክቷል",
    errorTitle: "ስህተት",
    // Bottom nav labels
    navJobs: "ስራዎች",
    navSaved: "የተቀመጡ",
    navAlerts: "ማስታወቂያዎች",
    newLabel: "አዲስ",
    markAllRead: "ሁሉንም በምንባብ ምልከት አድርግ",
    noNotificationsTitle: "የለም ማስታወቂያ",
    noNotificationsDesc: "አዲስ ነገር ሲመጣ እንነግርዎታልኔ",
    viewAllNotifications: "ሁሉንም ማስታወቂያዎች ይመልከቱ",
    navProfile: "መገለጫ",
    navDashboard: "ዳሽቦርድ",
    // Toolbar
    lightMode: "ብርሃን ገጽታ",
    // Terms of Service body
    termsSection1Title: "1. ውሎችን መቀበል",
    termsSection1Text:
      "NibJobsን በመድረስ እና በመጠቀም፣ እነዚህን የአገልግሎት ውሎች ያካሉ መሆናቸውን ይቀበላሉ። ከእነዚህ ውሎች ጋር ካልተስማሙ፣ አገልግሎቶቻችንን እባክዎ አይጠቀሙ።",
    termsSection2Title: "2. አገልግሎቱን ስለ መጠቀም",
    termsSection2Text:
      "NibJobs ስራ ፈላጊዎች የቅጥር እድሎችን እንዲያገኙ እና ቀጣሪዎች የስራ ዝርዝሮችን እንዲለጥፉ የሚያስችል ፕላትፎርም ያቀርባል። አገልግሎቱን ህጋዊ ዓላማዎች ብቻ እና ከእነዚህ ውሎች ጋር በሚጣጣም ሁኔታ ለመጠቀም ይስማማሉ።",
    termsSection3Title: "3. የተጠቃሚ መለያዎች",
    termsSection3Text:
      "የመለያ ማረጋገጫዎትን ሚስጥራዊነት ለመጠበቅ እና በመለያዎ ስር ለሚካሄዱ ሁሉም እንቅስቃሴዎች ተጠያቂ ነዎት። መለያ ሲፈጥሩ ትክክለኛ እና ሙሉ መረጃ መስጠት አለበዎት።",
    termsSection4Title: "4. ይዘት እና ጠባይ",
    termsSection4Text:
      "NibJobs ላይ ለሚለጥፏቸው ይዘቶች ብቸኛ ኃላፊ ነዎት። ህገ-ወጥ፣ ጎጂ፣ አስፈሪ፣ ስድብ፣ ስም-አጥፍ ወይም ሌላ ቅሬታ የሚቀሰቅስ ይዘት እንዳይለጥፉ ይስማማሉ።",
    termsSection5Title: "5. የአዕምሯዊ ንብረት",
    termsSection5Text:
      "NibJobs ላይ ያሉ ሁሉም ይዘቶች፣ ባህሪያት እና ተግባራት በኛ ባለቤትነት ሲሆን በቅጂ መብት፣ የንግድ ምልክት እና ሌሎች የአዕምሯዊ ንብረት ህጎች የተጠበቁ ናቸው።",
    termsSection6Title: "6. የተጠያቂነት ወሰን",
    termsSection6Text:
      "NibJobs አገልግሎቱን ከመጠቀምዎ ምክንያት ለሚደርስ ቀጥታ ያልሆነ፣ ድንገተኛ፣ ልዩ፣ ውጤታዊ ወይም ቅጣታዊ ጉዳት ተጠያቂ አይሆንም።",
    termsSection7Title: "7. ውሎችን ስለ መቀየር",
    termsSection7Text:
      "ውሎቹን በማንኛውም ጊዜ ለማሻሻል መብቱን ተጠቅሷል። ጉልህ ለውጦችን ለተጠቃሚዎች በኢሜል ወይም በመተግበሪያ በኩል እናሳዋቃለን።",
    termsSection8Title: "8. የመገናኛ ዝርዝሮች",
    termsSection8Text: "ስለዚህ የአገልግሎት ውሎች ጥያቄ ካለዎ፣ እባክዎ legal@nibjobs.com ያግኙን",
    // Company Dashboard
    cdDashboard: "ዳሽቦርድ",
    cdAnalytics: "ትንታኔ",
    cdJobPostings: "የስራ ዝርዝሮች",
    cdApplications: "ማመልከቻዎች",
    cdTalentPool: "የተሰጥኦ ማጠራቀሚያ",
    cdCompanyProfile: "የኩባንያ ፕሮፋይል",
    cdAccountSettings: "የመለያ ቅንብሮች",
    cdAnalyticsInsights: "ትንታኔ እና ግንዛቤዎች",
    cdManageYourJobs: "ስራዎችዎን ያስተዳድሩ",
    cdReviewCandidates: "እጩዎችን ይገምግሙ",
    cdDiscoverTalent: "ከፍተኛ ተሰጥኦ ያለቸውን ያግኙ",
    cdUpdateDetails: "ዝርዝሮችዎን ያዘምኑ",
    cdLoadingDashboard: "ዳሽቦርድ በመጫን ላይ...",
    cdOverview: "አጠቃላይ እይታ",
    cdHiring: "ቅጥር",
    cdSettings: "ቅንብሮች",
    cdBrowseJobs: "ስራዎችን ያስሱ",
    cdSignOut: "ይውጡ",
    cdVerified: "ተረጋግጧል",
    cdVerifiedCompany: "የተረጋገጠ ኩባንያ",
    cdVerificationRejected: "ማረጋገጫ ተቀባይነት አላገኘም",
    cdVerificationPending: "ማረጋገጫ በሂደት ላይ",
    cdCompanyAccount: "የኩባንያ መለያ",
    cdSwitchView: "እይታ ቀይር",
    cdCandidateView: "የእጩ እይታ",
    cdPostJob: "ስራ ለጥፍ",
    cdActiveJobs: "ንቁ ስራዎች",
    cdTotalApplicants: "አጠቃላይ አመልካቾች",
    cdPendingReviews: "በሂደት ያሉ ግምገማዎች",
    cdAvgPerJob: "በስራ አማካኝ",
    cdTotalJobs: "አጠቃላይ ስራዎች",
    cdToReview: "ለግምገማ",
    cdReviewed: "ተገምግሟል",
    cdPending: "በሂደት ላይ",
    cdTotal: "ጠቅላላ",
    cdApplicationsPerPosting: "ማመልከቻዎች በዝርዝር",
    cdStillActive: "አሁንም ንቁ",
    cdPendingApplications: "በሂደት ያሉ ማመልከቻዎች",
    cdProcessedSoFar: "እስካሁን የተካሄዱ",
    cdPostYourFirstJob: "የመጀመሪያ ስራዎን ይለጥፉ",
    cdFirstJobDesc: "የመጀመሪያ ስራ ዝርዝርዎን በመፍጠር ከተሰጥኦ ባለሙያዎች ጋር ይገናኙ።",
    cdCreateJobPosting: "የስራ ዝርዝር ፍጠር",
    cdQuickActions: "ፈጣን ድርጊቶች",
    cdApplicationPipeline: "የማመልከቻ ቧንቧ",
    cdPostNewJob: "አዲስ ስራ ለጥፍ",
    cdViewApplications: "ማመልከቻዎች ይመልከቱ",
    cdBrowseCandidates: "እጩዎችን ያስሱ",
    cdEditProfile: "ፕሮፋይል ያርትዑ",
    cdLoadingApplications: "ማመልከቻዎች በመጫን ላይ...",
    cdSearchApplications: "በስም፣ ኢሜል ወይም የስራ ርዕስ ይፈልጉ...",
    cdNoApplicationsFound: "ምንም ማመልከቻዎች አልተገኙም",
    cdTryAdjustingFilters: "ማጣሪያዎቹን ወይም ፍለጋ ጥያቄዎን ያስተካክሉ",
    cdApplicationsWillAppear: "እጩዎች ሲያመለክቱ ማመልከቻዎች ይታያሉ",
    cdShortlist: "አጭሩ ዝርዝር",
    cdReject: "ውድቅ ያድርጉ",
    cdAccept: "ይቀበሉ",
    cdViewDetails: "ዝርዝር ይመልከቱ",
    cdApplicationDetails: "ዝርዝረ ማመልከቻ",
    cdContactInfo: "የመገናኛ ዝርዝሮች",
    cdApplicantInfo: "የአመልካቹ ዝርዝሮች",
    cdProfessionalOverview: "ሙያዊ አጠቃላይ",
    cdLoadingJobs: "ስራዎች በመጫን ላይ...",
    cdManageJobListings: "ንቁ ስራ ዝርዝሮችዎን ያስተዳድሩ",
    cdCreateJob: "ስራ ፍጠር",
    cdActive: "ንቁ",
    cdPaused: "ታግዷል",
    cdNoJobsYet: "ምንም ስራዎች አልተለጠፉም",
    cdFirstJobPostingDesc: "ከተሰጥኦ ባለሙያዎች ጋር ለመገናኘት የመጀመሪያ ስራ ዝርዝርዎን ይፍጠሩ።",
    cdCreateFirstJob: "የመጀመሪያ ስራዎን ይፍጠሩ",
    cdApplicants: "አመልካቾች",
    cdEditJobPosting: "ስራ ዝርዝር ያርትዑ",
    cdCreateNewJob: "አዲስ ስራ ፍጠር",
    cdUpdateJobDetails: "የስራ ዝርዝር ዝርዝሮችዎን ያዘምኑ",
    cdFillNewOpening: "አዲስ ክፍት ቦታ ለመለጠፍ ዝርዝሩን ይሙሉ",
    cdBasicInformation: "መሰረታዊ ዝርዝሮች",
    cdJobTitle: "የስራ ርዕስ",
    cdCategory: "ምድብ",
    cdContractType: "የኮንትራት አይነት",
    cdLocationCompensation: "ቦታ እና ክፍያ",
    cdRemoteWorkAvailable: "ርቀት ስራ ይቻላል",
    cdMonthlySalary: "ወርሃዊ ደመወዝ (ብር)",
    cdJobDetails: "የስራ ዝርዝሮች",
    cdJobDescription: "የስራ ገለጻ",
    cdRequirements: "ቅድመ ሁኔታዎች",
    cdKeyResponsibilities: "ዋና ኃላፊነቶች",
    cdSkillsTags: "ክህሎቶች እና መለያ ቃላት",
    cdJobTitleRequired: "የስራ ርዕስ ያስፈልጋል",
    cdCategoryRequired: "ምድብ ያስፈልጋል",
    cdLocationRequired: "ቦታ ያስፈልጋል",
    cdSkillsRequired: "ቢያንስ አንድ ክህሎት/መለያ ቃል ያስፈልጋል",
    cdSearchCandidates: "ስም፣ ሙያ፣ ክህሎቶችን ይፈልጉ\u2026",
    cdFound: "ተገኝቷል",
    cdLoadingCandidates: "እጩዎች በመጫን ላይ...",
    cdNoResultsFound: "ምንም ውጤቶች አልተገኙም",
    cdNoCandidatesYet: "እጩዎች እስካሁን የሉም",
    cdTryDifferentSearch: "ሌላ ፍለጋ ይሞክሩ ወይም ማጣሪያዎቹን ያጽዱ",
    cdCandidatesWillAppear: "እጩዎቹ ሲመዘገቡ ይታያሉ",
    cdCompanyNameLabel: "የኩባንያ ስም",
    cdDescriptionLabel: "ገለጻ",
    cdIndustryLabel: "ኢንዱስትሪ",
    cdCompanySizeLabel: "የኩባንያ መጠን",
    cdFoundedYearLabel: "የተቋቋመበት ዓመት",
    cdAboutCompany: "ስለ ኩባንያ",
    cdContactInformation: "የዕድ ያሁ ዝርዝሮች",
    cdSizeLabel: "መጠን",
    cdFoundedLabel: "ተቋቁሟል",
    cdYourCompanyVerified: "ኩባንያዎ ተረጋግጧል",
    cdContactSupportInfo: "ተጨማሪ ዝርዝር ለማግኘት ድጋፍ ያግኙ",
    cdUnderReview: "በአስተዳዳሪዎች ግምገማ ላይ ነው",
    cdActiveDashboard: "ንቁ ዳሽቦርድ",
    cdDeleteJobPosting: "የስራ ዝርዝር ሰርዝ",
    cdDeleteJobConfirm: "ይህን የስራ ዝርዝር ለመሰረዝ እርግጠኛ ነዎት?",
    cdJobUpdated: "ስራ ዝርዝር በተሳካ ሁኔታ ተዘምኗል!",
    cdJobPosted: "ስራ ዝርዝር በተሳካ ሁኔታ ተለጥፏል!",
    cdYearsExp: "ዓ.ልምድ",
    // Mobile Drawer
    drawerTagline: "ቀጣዩን እድሎ ያግኙ",
    drawerMyAccount: "የኔ መለያ",
    drawerSavedJobs: "የተቀመጡ ስራዎች",
    drawerMyApplications: "ማመልከቻዎቼ",
    drawerPostJob: "ስራ ይለጥፉ",
    drawerMyJobPosts: "የስራ ዝርዝሮቼ",
    drawerAnalytics: "ትንታኔ",
    drawerRegisterCompany: "ኩባንያዎን ያስመዝግቡ",
    drawerExplore: "ያስሱ",
    drawerBrowseJobs: "ስራዎችን ያስሱ",
    drawerPreferences: "ምርጫዎች",
    drawerSubscription: "የደንበኝነት ምዝገባ",
    drawerAboutNibJobs: "ስለ NibJobs",
    drawerSignOutTitle: "ይውጡ?",
    drawerSignOutDesc: "ከመለያዎ ይወጣሉ እና ወደ መነሻ ገጽ ይመለሳሉ።",
    drawerClose: "ዝጋ",
    drawerVersion: "ስሪት",
    drawerPlatform: "መድረክ",
    drawerCountry: "ሀገር",
    drawerWebsite: "ድረ-ገጽ",
    drawerSupport: "ድጋፍ",
    drawerAboutTagline:
      "የኢትዮጵያ ግንባር ቀደም የስራ ፕላትፎርም — ሙሉ ባለሙያዎችን ከምርጥ ቀጣሪዎቻቸው ጋር ማገናኘት።",
    // Confirmation modals
    confirmAction: "አረጋግጥ",
    areYouSure: "እርግጠኛ ነዎት?",
    deleteConfirmTitle: "ይሰረዝ?",
    cannotBeUndone: "ይህ እርምጃ መቀልበስ አይችልም።",
    logoutConfirmTitle: "የመውጣት ማረጋገጫ",
    logoutConfirmMessage:
      "መውጣት እንደሚፈልጉ እርግጠኛ ነዎት? መለያዎን ለመድረስ እንደገና መግባት ያስፈልግዎታል።",
    // Action buttons
    continueButton: "ቀጥል",
    previousButton: "ቀዳሚ",
    nextButton: "ቀጣይ",
    backButton: "ተመለስ",
    applyButton: "አመልክት",
    submitApplicationButton: "ማመልከቻ አስገባ",
    postJobButton: "ስራ ለጥፍ",
    browseMoreJobs: "ተጨማሪ ስራዎችን ይመልከቱ",
    goBack: "ተመለስ",
    notNow: "አሁን አይደለም",
    // Application flow
    applyForPosition: "ለቦታው አመልክት",
    applicationStatus: "የማመልከቻ ሁኔታ",
    stepLabel: "ደረጃ",
    ofLabel: "ከ",
    personalInfoStep: "የግል መረጃ",
    professionalStep: "ሙያዊ",
    coverLetterStep: "የመግቢያ ደብዳቤ",
    personalInformationSection: "የግል መረጃ",
    professionalLinksSubtitle: "የመስመር ላይ መገኘትዎን እና የስራ ናሙናዎችዎን ያጋሩ (አማራጭ)",
    coverLetterSubtitle: "ለዚህ ቦታ ለምን ተስማሚ እንደሆኑ ለቀጣሪው ይንገሩ",
    coverLetterTip: "ጠቃሚ ምክር፦ የተበጀ የመግቢያ ደብዳቤ የመታየት እድልዎን ያሳድጋል",
    // Application filters / statuses
    statusAll: "ሁሉም",
    statusPending: "በመጠበቅ ላይ",
    statusReviewed: "የታየ",
    statusShortlisted: "የተመረጠ",
    statusAccepted: "ተቀባይነት ያገኘ",
    statusRejected: "ውድቅ የሆነ",
    filterByStatus: "በሁኔታ ያጣሩ",
    // Company profile / registration
    companyNameLabel: "የድርጅቱ ስም",
    companyDescriptionLabel: "የድርጅት መግለጫ",
    companyEmailLabel: "የድርጅት ኢሜይል",
    companyPhoneLabel: "የድርጅት ስልክ",
    addressLabel: "አድራሻ",
    cityLabel: "ከተማ",
    websiteLabel: "ድረ-ገጽ",
    industryLabel: "ዘርፍ",
    companySizeLabel: "የድርጅት መጠን",
    uploadLogo: "አርማ ስቀል",
    // Subscription (mobile)
    subscriptionPlansTitle: "የደንበኝነት እቅዶች",
    getStartedBtn: "ጀምር",
    chooseStandardBtn: "መደበኛ ምረጥ",
    chooseProBtn: "ፕሮ ምረጥ",
    chooseEnterpriseBtn: "ኢንተርፕራይዝ ምረጥ",
    // App bar titles / misc
    emailVerificationRequired: "የኢሜይል ማረጋገጫ ያስፈልጋል",
    emailNotVerified: "ኢሜይል አልተረጋገጠም",
    resetPasswordTitle: "የይለፍ ቃል ዳግም አስጀምር",
    resetPasswordSubtitleMobile: "የዳግም ማስጀመር መመሪያዎችን ወደ ኢሜይልዎ እንልክልዎታለን",
    jobNotFoundTitle: "ስራው አልተገኘም",
    somethingWentWrong: "ችግር ተፈጥሯል",
    manageJobListings: "የስራ ዝርዝሮችዎን፣ ማመልከቻዎችዎን እና ትንታኔዎችን ያስተዳድሩ",
    // Verification steps
    verifyStep1Title: "ኢሜይልዎን ይክፈቱ",
    verifyStep1Desc: "የመልእክት ሳጥንዎን እና የስፓም አቃፊዎን ይፈትሹ",
    verifyStep2Title: "አገናኙን ይጫኑ",
    verifyStep2Desc: "በኢሜይሉ ውስጥ ያለውን የማረጋገጫ አገናኝ ይንኩ",
    verifyStep3Title: "መቃኘት ይጀምሩ",
    verifyStep3Desc: "ግቡና የሚወዱትን ስራ ያግኙ!",
    locationLabel: "ቦታ",
    updateJobButton: "ስራ አዘምን",
    remoteWorkSubtitle: "ሠራተኞች ከርቀት እንዲሰሩ ይፍቀዱ",
    selectedCountLabel: "የተመረጡ",
    searchApplicationsPlaceholder: "ማመልከቻዎችን ይፈልጉ...",
    noApplicationsYet: "እስካሁን ማመልከቻዎች የሉም",
    jobRoleLabel: "ሚና",
    saveChangesButton: "ለውጦችን አስቀምጥ",
  },
  ti: {
    // Mobile Landing Page hero
    mobileSignIn: "እቶ",
    mobileActiveJobs: "ክፉታት ስራሕቲ",
    mobileThousandsJobs: "ኣሽሓት ስራሕቲ",
    mobileHeroLine1: "ናይ ሕልምኻ ስራሕ",
    mobileHeroHighlight: "ሎሚ",
    mobileHeroLine2: "ርኸብ።",
    mobileHeroDesc:
      "ካብ 50 ንላዕሊ ቻነላት ቴሌግራምን ትካላትን ዝወጹ ስራሕቲ ኣብ ሓደ ቦታ — ብነጻ፣ ብዘይ ደላላይ።",
    mobileHeroPerkFree: "ብነጻ",
    mobileHeroPerkNoBroker: "ብዘይ ደላላይ",
    mobileHeroPerkAlerts: "ቅልጡፍ መተሓሳሰቢ",
    mobileHeroNoAccount: "ኣካውንት የብልካን?",
    mobileHeroSignUp: "ብነጻ ተመዝገብ",
    mobileHeroSearchButton: "ድለ",
    liveJobsLabel: "ብቐጥታ",
    liveJobsUpdated: "መዓልታዊ ይሕደስ",
    liveJobsCaption: "ክፉታት ስራሕቲ ንዓኻ ይጽበዩ ኣለዉ",
    mobileSearchPlaceholder: "ስራሕቲ፣ ትካላት ድለ...",
    mobileBrowseAll: "ኩሉ ስራሕቲ ርአ",
    // Tigrigna
    appTitle: "ንብ ስራሕቲ",
    searchPlaceholder: "ስራሕቲ ድለ...",
    login: "እተ",
    signUp: "ምዝገባ",
    exploreChannels: "🚀 የቴሌግራም መርሔታት ርኣ",
    swipeHint: "← ተወሳኺ መርሔታት ንምርኣይ ኣንሸራሽር →",
    recentJobs: "ናይ ሓዳሽ ስራሕቲ",
    jobsFound: "ስራሕቲ ተረኺቦም",
    loading: "ስራሕቲ ይጽዓኑ ኣለዉ...",
    categories: "ምድባት",
    contractType: "ዓይነት ሰንዱ",
    location: "ቦታ",
    remoteJobs: "ናይ ርሑቕ ስራሕቲ",
    clearFilters: "መጻርያታት ሰርዝ",
    adminLogin: "ናይ ኣመሓዳሪ መእተዊ",
    email: "ኢመይል",
    password: "መሕለፊ ቃል",
    loginButton: "እተ",
    loginError: "ኢመይልን መሕለፊ ቃልን ኣእቱ",
    invalidCredentials: "ዘይቅኑዕ ኢመይል ወይ መሕለፊ ቃል",
    telegramChannel: "የቴሌግራም መርሔ",
    members: "ኣባላት",
    darkMode: "ጸልማት ገጽታ",
    language: "ቋንቋ",
    downloadPlayStore: "ፕሌይ ስቶር",
    downloadAppStore: "አፕ ስቶር",
    // Jobs page
    employmentType: "ዓይነት ስራሕ",
    workMode: "ኣገባብ ስራሕ",
    fullTime: "ምሉእ ግዜ",
    partTime: "ክፋል ግዜ",
    contract: "ሰንዲ",
    remote: "ርሑቕ",
    onSite: "ኣብ ቦታኡ",
    hybrid: "ተደሚሩ",
    applyNow: "ሕጂ ኣመልክት",
    shareJob: "ስራሕ ኣካፍል",
    viewDetails: "ዝርዝር ርኣይ",
    salaryRange: "ደሞዝ መጠን",
    posted: "ተለጢፉ",
    ago: "ቅድሚ",
    noJobsFound: "ስራሕቲ ኣይተረኸበን",
    filterJobs: "ስራሕቲ ምርጫ",
    sortBy: "ደርድር ብ",
    clearAll: "ኩሉ ሰርዝ",
    // Companies page
    companies: "ትካላት",
    viewAll: "ኩሉ ርኣይ",
    noCompaniesFound: "ትካላት ኣይተረኸቡን",
    // Settings page
    settings: "ኣወሃህባ",
    profile: "መግለጺ",
    notifications: "መጠንቀቕታ",
    theme: "ገጽታ",
    logout: "ውጻእ",
    about: "ብዛዕባ",
    privacy: "ፖሊሲ ፕራይቨሲ",
    terms: "ውዕል ኣገልግሎት",
    // Bookmarks
    bookmarks: "ዝተቐመጡ",
    bookmark: "ምልክት ግበር",
    save: "ኣቐምጥ",
    saved: "ተቐሚጡ",
    remove: "ኣልግስ",
    // Common
    jobs: "ስራሕቲ",
    search: "ድለ",
    filter: "ምርጫ",
    apply: "ኣመልክት",
    company: "ትካል",
    salary: "ደሞዝ",
    description: "መግለጺ",
    requirements: "ረቛሒታት",
    // Hero Section
    heroBadge: "🚀 ናይ ኢትዮጵያ #1 ናይ ስራሕ መድረኽ",
    heroSubtitle: "ናይ ኢትዮጵያ መሪ ናይ ስራሕ መድረኽ - ተሰጦኦ ምስ እድል ምትእስሳር",
    heroDescription: "ምስ 500+ መሪ ትካላት ተራኸቡ እናሆ ኣብ ኢትዮጵያ 10,000+ እድላት ርእዩ።",
    getStartedFree: "ብነጻ ጀምር",
    getItOnGooglePlay: "ተቐበሎ ኣብ",
    googlePlay: "Google Play",
    searchJobsPlaceholder: "ስራሕቲ፣ ትካላት ወይ ቁልፊ ቃላት ድለ",
    trendingTags: "ኣብ ትራንድ:",
    remoteWork: "ናይ ርሑቕ ስራሕ",
    techJobs: "ናይ ቴክኖሎጂ ስራሕቲ",
    marketing: "ማርኬቲንግ",
    sales: "ሽያጭ",
    engineering: "ምህንድስና",
    statsJobs: "ስራሕቲ",
    statsCompanies: "ትካላት",
    statsProfessionals: "ሞያውያን",
    telegramChannelsTitle: "📢 ናይ ቴሌግራም ናይ ስራሕ መርሔታት",
    telegramChannelsSubtitle: "ካብ ዝተረጋገጹ መርሔታት ናይ ቀረባ ናይ ስራሕ መልእኽትታት ተኸታተል",
    viewChannel: "መርሔ ርኣይ",
    categoriesTitle: "🎯 ብምድብ ርኣይ",
    categoriesSubtitle: "ኣብ መዳይካ እድላት ረኽብ",
    viewAllCategories: "ኩሉ ምድባት ርኣይ",
    featuredCompaniesTitle: "🏢 ተመርጾም ዝቐረቡ ትካላት",
    featuredCompaniesSubtitle: "ሕጂ ዝቐጽሩ ዓበይቲ ቀጻሪታት",
    viewAllCompanies: "ኩሉ ትካላት ርኣይ",
    openPositions: "ክፉት ቦታታት",
    whyChooseTitle: "ስለምንታይ NibJobs ትምረጽ?",
    whyChooseSubtitle: "ኣብ ዕብየት ሞያኻ ዝተኣማመነ መጻምድትኻ",
    verifiedJobsTitle: "ዝተረጋገጹ ስራሕቲ",
    verifiedJobsDesc: "ኩሎም ናይ ስራሕ መልእኽትታት ንእውነተኝነት ተረጋጊጾም",
    multiChannelTitle: "ብዙሓት ምንጭታት",
    multiChannelDesc: "ስራሕቲ ካብ ቴሌግራም መርሔታትን ቀጥተኛ ቀጻሪታትን ተቐበል",
    realTimeTitle: "ናይ ሓቂ-ግዜ ምዕባለታት",
    realTimeDesc: "ንሓደስቲ እድላት ቅልጡፍ መጠንቀቕታ ተቐበል",
    easyApplicationTitle: "ቀሊል ምልኣት",
    easyApplicationDesc: "ብሓደ መግለጺ ንብዙሓት ስራሕቲ ኣመልክት",
    readyToStartTitle: "ጉዕዞኻ ንምጅማር ድልዩ ዲኻ?",
    readyToStartDesc: "ናይ ሕልሞም ስራሕቲ ዝረኸቡ ብኣሽሓት ዝቁጸሩ ሞያውያን ተጸምብር",
    footerAbout: "ብዛዕባ NibJobs",
    footerAboutDesc:
      "NibJobs ናይ ኢትዮጵያ መሪ ናይ ስራሕ መድረኽ እዩ፣ ተሰጥኦ ዘለዎም ሞያውያን ምስ ዓበይቲ ቀጻሪታት ኣብ ሃገር ውሽጢ የራኽብ።",
    footerJobSeekers: "ንስራሕ ደላይቲ",
    footerQuickLinks: "ቅልጡፍ ኣገናዕታት",
    footerBrowseJobs: "ስራሕቲ ርኣይ",
    footerJobAlerts: "ናይ ስራሕ ማዕቀቢ",
    footerCareerAdvice: "ናይ ስራሕ ምኽሪ",
    footerResumeTips: "ናይ ሪዙሜ ምዕዱል",
    footerCompanies: "ትካላት",
    footerCategories: "ምድባት",
    footerTelegram: "ናይ ቴሌግራም መርሔታት",
    footerForEmployers: "ንቀጻሪታት",
    footerPostJob: "ስራሕ ኣፍልጥ",
    footerEmployerDashboard: "ናይ ቀጻሪ ዳሽቦርድ",
    footerPricing: "ዋጋ መውሰኒ",
    footerRecruitmentTips: "ናይ ቅጥር ምዕዱል",
    footerCompany: "ትካል",
    footerContact: "ተራኸበና",
    footerPrivacy: "ፖሊሲ ፕራይቨሲ",
    footerTerms: "ውዕል ኣገልግሎት",
    footerSupport: "ደገፍ",
    footerHelpCenter: "ናይ ሓገዝ ማእከል",
    footerContactUs: "ተራኸበና",
    footerFAQ: "ተደጋጋሚ ሕቶታት",
    footerCopyright: "© 2025 NibJobs። ኩሉ መሰላት ተሓሪዞም።",
    footerPrivacyShort: "ውልቃዊነት",
    footerTermsShort: "ውዕላት",
    footerCookies: "ኩኪታት",
    footerPricingPlans: "ናይ ዋጋ ዕጥናት",
    home: "ቤት",
    allJobs: "ኩሉ ስራሕቲ",
    channels: "መርሔታት",
    more: "ተወሳኺ",
    // About Us Section
    aboutUsLabel: "ብዛዕባና",
    aboutUsTitle: "ብዛዕባ NibJobs",
    aboutUsSubtitle: "ናይ ኢትዮጵያ ተሰጥኦ ምስ እድላት ምትእስሳር",
    aboutUsDesc:
      "NibJobs ናይ ኢትዮጵያ ቀዳማይ ናይ ስራሕ መግቢ በር እዩ፣ ኣብ መንጎ ተሰጥኦ ዘለዎም ሞያውያን ከምኡ'ውን ኣብ ሃገር ውሽጢ ዘሎ መሳጢ ናይ ስራሕ እድላት ዘሎ ክፍተት ንምድፋእ ዝተዓለመ።",
    topCompanies: "ዓበይቲ ትካላት",
    topCompaniesDesc: "ኣብ ዝተፈላለዩ ኢንዱስትሪታት ምስ መሪ ቀጻሪታት ተራኸቡ",
    instantAlerts: "ቅልጡፍ መጠንቀቕታ",
    instantAlertsDesc: "ተዛማዲ ስራሕቲ ክለጠፉ ብቕልጡፍ መጠንቀቕታ ተቐበሉ",
    multilingual: "ብዙሕ ቋንቋ",
    multilingualDesc: "ብእንግሊዝኛ፣ ኣምሓርኛ፣ ትግርኛን ኦሮምኛን ይርከብ",
    // Opportunities Section
    latestOpportunities: "ናይ ቀረባ እድላት",
    latestOpportunitiesSubtitle: "ሎሚ ዝተለጠፉ ሓደስቲ ስራሕቲ",
    viewAllJobs: "ኩሉ ስራሕቲ ርኣይ",
    // How It Works Section
    processLabel: "ሂደት",
    howItWorksTitle: "ከመይ ይሰርሕ",
    howItWorksSubtitle: "ብ3 ቀሊል ስጉምትታት ተቐጸር",
    step1: "ድለ",
    step1Desc: "ኣብ ኢትዮጵያ ካብ ዝተረጋገጹ ትካላት ብኣሽሓት ዝቑጸሩ ስራሕቲ ርኣይ",
    step2: "ኣመልክት",
    step2Desc: "መግለጺኻ ብምጥቃም ብሓደ ጠዊቕካ ምልኣትካ ኣእቱ",
    step3: "ተቐጸር",
    step3Desc: "ምስ ቀጻሪታት ተራኸብ እሞ ናይ ሕልምኻ ስራሕ ረኽብ",
    // Popular Categories Section
    popularCategoriesLabel: "ምድባት",
    popularCategoriesTitle: "ተፈታውያን ምድባት",
    popularCategoriesSubtitle: "እድላት ብመዳይ ርኣይ",
    // Success Stories Section
    storiesLabel: "ታሪኻት",
    successStoriesTitle: "ናይ ዓወት ታሪኻት",
    successStoriesSubtitle: "ሓቀኛ ሰባት፣ ምስ NibJobs ሓቀኛ ዓወት",
    readMore: "ተወሳኺ ኣንብብ",
    // Plans Section
    plansLabel: "መደባት",
    chooseYourPlan: "መደብካ ምረጽ",
    chooseYourPlanSubtitle: "ንድሌትካ ትኽክለኛ መደብ ምረጽ",
    free: "ናጻ",
    premium: "ፕሪሚየም",
    enterprise: "ኢንተርፕራይዝ",
    perMonth: "/ወርሒ",
    mostPopular: "ብዙሕ ተፈታዊ",
    getStarted: "ጀምር",
    contactUs: "ተራኸበና",
    // Never Miss Section
    neverMissLabel: "ምዝገባ",
    neverMissTitle: "ምንም እድል ኣይገድፈካ",
    neverMissSubtitle: "ናይ ስራሕ ማዕቀብቲ ብቐጥታ ናብ ኢመይልካ ተቐበል",
    emailPlaceholder: "ኢመይልካ ኣእቱ",
    subscribe: "ተመዝገብ",
    // Login Page
    loginTagline: "ተሰጥኦ ምስ ዕድላት ዘራኽብ ቀዳማይ ናይ ኢትዮጵያ መዓልቦ ስራሕ",
    loginActiveJobsLabel: "10,000+ ናይ ስራሕ ሃለዋ",
    loginActiveJobsDesc: "ዝተዳለዉ ዕድላት",
    loginTopCompaniesLabel: "500+ ዓበይቲ ትካላት",
    loginTopCompaniesDesc: "መሪ ቀጻሪታት",
    loginInstantAlertsLabel: "ቅልጡፍ መጠንቀቕታ",
    loginInstantAlertsDesc: "ምንም ዕድል ኣይሓልፈካ",
    // FAQ Section
    faqLabel: "ተደጋጋሚ ሕቶታት",
    faqTitle: "ተደጋጋሚ ሕቶታት",
    faqSubtitle: "ብዛዕባ NibJobs ንተለምዶ ሕቶታት መልስታት ረኽብ",
    faq1Q: "ንብ ስራሕቲ ብነጻ ድዩ ዝርከብ?",
    faq1A:
      "እወ! ስራሕ ደላይቲ ስራሕቲን ብነጻ ክርእዩን ክመልእኡን ይኽእሉ። ብተወሳኺ ንዕቀ ርኣይነት ፕሪሚየም ባህርያት ንህብ።",
    faq2Q: "ንስራሕ ብኸመይ ክመልእ እኽእል?",
    faq2A:
      "ብቀሊሉ መለለያ ፍጠር፣ መግለጺካ ዛዝም እናበልካ ኣብ ዝኾነ ናይ ስራሕ ዝርዝር 'መልእ' ዝብል ጠውቕ። ገለ ስራሕቲ ናብ መተግበሪ ገጽ ናይቲ ትካል ከዞሩካ ይኽእሉ።",
    faq3Q: "ሓደስቲ ስራሕቲ ክንደይ ጊዜ ይለቀቑ?",
    faq3A:
      "ሓደስቲ ስራሕቲ መዓልታዊ ይለቀቑ! ምስ ምርጫኻ ዝዛመዱ ቦታታት ከለዉ ምልክታት ንምርካብ ናይ ስራሕ ማዕቀቢ አንቕሕ።",
    faq4Q: "ስራሕቲ ንድሕሪት ኦል ካእ ክኽእል?",
    faq4A:
      "እወ! ኣብ ዝኾነ ናይ ስራሕ ዝርዝር ላይ icon bookmark ጠቕ በማድረግ ናብ ምርጫኻ ኦል ካእ። ዝተቀመጡ ስራሕቲ ኣብ ዝኾነ ጊዜ ካብ መግለጺካ ቀቀብዶም።",
    // Resume Tips
    resumeTipsTitle: "ናይ ሪዙሜ ምዕዱል",
    resumeTipsHero: "ተለይቲ ሪዙሜ ፍጠር",
    resumeTipsHeroDesc: "ትኩረት ዝስሑቡ ሪዙሜታት ንምስራሕ ሞያዊ መምርሒ",
    resumeFormatting: "ናይ ሪዙሜ አቀራረባ",
    resumeFormattingText:
      "• ፅሩይን ሞያውን አቀማምጣ ተጠቐም\n• ሓጺር አድርግ (ካብ 1-2 ገጻት ልዕሊ አይኹን)\n• ተጸጻተለይቲ አቀራረባን ቅርጺ ፊደላትን ተጠቐም\n• ቅኑዕ ናይ ርክብ ሓበሬታ አካትት\n• ንሓፈሻዊ ተሓባበርነት እንደ PDF አቀምጥ",
    resumeKeySections: "ቀንዲ ክፍልታት",
    resumeKeySectionsText:
      "ሞያዊ ጽማቕ: ናይ ተመክሮኻን ናይ ስራሕ እላማታትካን ሓጺር መግለጺ\n\nናይ ስራሕ ተመክሮ: ክምዘን ዝኽእል ዓወት ዘለዎም ስራሕቲ ዝርዝር\n\nትምህርቲ: ዲግሪታት፣ ምስክር ወረቀታትን ተዛማዲ ትምህርትታትን አካትት\n\nክእለታት: ክልቲኦም ቴክኒካውን ልሱልሱን ክእለታት አግሊሕ\n\nዓወታት: ሽልማታት፣ እውነታትን ታዋቂ ዓወታትን አርኢ",
    resumeWritingTips: "ናይ ጽሑፍ ምዕዱላት",
    resumeWritingTipsText:
      "• ናይ ተግባር ግሳት ተጠቐም (ሰሪሕ፣ አስተዳዲረ፣ ሰርሕ፣ መሪሕ)\n• ዓወታት ብቁጽርታትን መለኪታትን መዘን\n• ንነፍሲ ወከፍ ናይ ስራሕ መመልከቲ ሪዙሜካ አስተካክል\n• ገደጋታት ብጽንቃቀ አረጋግጽ\n• ቋንቋ ሞያውን ሓጺርን ይኹን አድርግ",
    resumeMistakes: "ክትርሓቑ ዘለካም ልሙዳት ገደጋታት",
    resumeMistakesText:
      "✗ ዘይተዛመደ ናይ ውልቂ ሓበሬታ ምእታው\n✗ ዘይሞያዊ ናይ ኢመይል አድራሻታት ምጥቃም\n✗ ዓወታት ዘይኮነስ ስራሕቲ ምዝርዛር\n✗ ናይ ፊደልን ሰዋስውን ገደጋታት ምሕላው\n✗ ሓፈሻዊ፣ ንኹሉ ዝውንን ሪዙሜ ምጥቃም",
    uploadResume: "ሪዙሜካ ስቀል",
    // Login Screen
    signInTitle: "እንቋዕ ደሓን መጻእካ",
    signInSubtitle: "ናብ መለያኻ እተ",
    emailAddress: "ናይ ኢመይል አድራሻ",
    forgotPassword: "የእተ ቃል ረሲዕካ?",
    signInButton: "እተ",
    signingIn: "በመግባት ላይ...",
    orContinueWith: "ወይም ይቀጥሉ ከ",
    signInWithGoogle: "በGoogle እተ",
    dontHaveAccount: "መለያ የለካን? ",
    signUpLink: "ተመዝገብ",
    backToHome: "ናብ መበገሲ ተመለስ",
    // Signup Screen
    createAccountTitle: "መለያ ፍጠር",
    createAccountSubtitle: "ኒብጆብስ ተሳተፍ ናይ ህልምካ ስራሕ ረክብ",
    joinMessage: "ንመሉእ ባህርያት ንምብጻሕ እባኻ ተመዝገብ ናብ ዓለም ናይ ስራሕ እድላት ተሳተፍ።",
    fullName: "ሙሉእ ስም",
    confirmPassword: "የእተ ቃል አረጋግጽ",
    createAccount: "መለያ ፍጠር",
    creatingAccount: "መለያ ብምፍጣር ላይ...",
    alreadyHaveAccount: "መለያ አለካ? ",
    signInLink: "እተ",
    // Verification
    checkYourEmail: "ኢመይልካ አረጋግጽ",
    verificationSent: "ናይ ምርግጋጽ ኢመይል ተለአኸ!",
    verificationMessage:
      "ናይ ምርግጋጽ ኢመይል ናብ መለያካ ተለአኸ። እባኻ ኢመይልካ አረጋግጽ ናይ ምርግጋጽ አገናኝ ጠውቕ።",
    verificationEmail: "ኢመይል አድራሻ",
    goToLogin: "ናብ እተ ሂድ",
    // Errors
    fillAllFields: "እባኻ ኩሎም መስከት ምላእ",
    passwordsDontMatch: "የእተ ቃላት አይዛመዱን",
    passwordTooShort: "የእተ ቃል ብያንስ 6 ፊደላት መሆን አለበት",
    emailInUse: "እዚ ኢመይል አስቀድሞ ተመዝጊቡ",
    invalidEmail: "ትክክል ዘይኮነ ናይ ኢመይል አድራሻ",
    weakPassword: "የእተ ቃል በጣም ደካማ እዩ",
    accountExists: "በዚ ኢመይል መለያ አስቀድሞ አሎ",
    signupFailed: "ምዝገባ አይሰለጠን። እባኻ እንደገና ሞክር።",
    loginFailed: "መግባት አይሰለጠን። እባኻ ማረጋገጫካ አረጋግጽ።",
    // Pricing Section
    popularBadge: "ታዋቂ",
    perYear: "/ዓመት",
    orYearly: "ወይ",
    choosePlan: "መርሕሰግብሪ ምረጽ",
    freePlanDesc: "ንምጅማር ፍጹም",
    standardPlanDesc: "ንንቡር ስራሕ ደላይቲ ምርጫ",
    proName: "ፕሮ",
    proPlanDesc: "ንዕቢ ዘለዎ ጋንታታትን ብቑዓ ሞያተኛታትን",
    enterprisePlanDesc: "ንቐጻሪት ንቅጥር ሰራሕተኛታትን",
    freeFeature1: "ብመዓልቲ 3 ብሕታዊ ናይ ስራሕ መጠንቀቒታ አብ ሞባይል መተግበሪ",
    freeFeature2: "መሰረታዊ ናይ ስራሕ ምድላይን ምዕዳምን",
    freeFeature3: "ናይ ስራሕ ማስታወቂያ ምድራግ አይከአልን",
    freeFeature4: "ናብ 3 መጠንቀቒታ ብመዓልቲ ጥራይ ዝተደረተ",
    standardFeature1: "አብ መዓልቲ ክሳብ 50 ብሕታዊ ናይ ስራሕ መጠንቀቒታ",
    standardFeature2: "አብ ውጽኢታት ምድላይ ቅድሚያ",
    standardFeature3: "ዝለዓለ ናይ ምሽራይ አማራጺታት",
    standardFeature4: "ናይ ረዚዩመ ርኡይነት ምውሳኽ",
    standardFeature5: "ናይ ስራሕ ማስታወቂያ ምድራግ አይከአልን",
    proFeature1: "ዘይተደረተ ናይ ስራሕ ማስታወቂያታት ድርግ",
    proFeature2: "ረዚዩመታት ተቐበልን አመሓድርን",
    proFeature3: "ዝርዝር ናይ ስራሕ ገበያ ስታትስቲክስ",
    proFeature4: "ናይ አመልካቲ ምክትታል ስርዓት",
    proFeature5: "ናይ ትካል ምርት ስምን ሎጎን ምርኢት",
    proFeature6: "ተለይቶም ዝቐረቡ ናይ ስራሕ ቦታታት",
    proFeature7: "ቅድሚያ ዝወሃቦ ደገፍን ናይ መለያ አመሓዳሪን",
    enterpriseFeature1: "ዘይተደረተ ናይ ስራሕ ማስታወቂያታት ድርግ",
    enterpriseFeature2: "ረዚዩመታት ተቐበልን አመሓድርን",
    enterpriseFeature3: "ዝርዝር ናይ ስራሕ ገበያ ስታትስቲክስ",
    enterpriseFeature4: "ናይ አመልካቲ ምክትታል ስርዓት",
    enterpriseFeature5: "ናይ ትካል ምርት ስምን ሎጎን ምርኢት",
    enterpriseFeature6: "ተለይቶም ዝቐረቡ ናይ ስራሕ ቦታታት",
    enterpriseFeature7: "ቅድሚያ ዝወሃቦ ደገፍን ናይ መለያ አመሓዳሪን",
    privacyTitle: "ናይ ውልቃዊነት ፖሊሲ",
    lastUpdated: "ናይ መወዳእታ ምዕራፍ፡",
    privacySection1Title: "1. እንሰብስቦ ዘለና ሓበሬታ",
    privacySection1Text:
      "NibJobsን ክትጥቀም ከለኻ ብቀጥታ ትህበና ሓበሬታ ንእከብ። እዚ ስምካ፣ ናይ ኢመይል አድራሻካ፣ ናይ ቴለፎን ቁጽሪካ፣ ሪዙመ ናይ ስራሕ ምርጫታትካን የጸምልል። ከምኡውን ናይቲ መተግበሪ ጥቕሚ ትርእዮም ወይ ትመልክተሎም ስራሕቲ ሓበሬታ ንእከብ።",
    privacySection2Title: "2. ሓበሬታኻ ከመይ ገርና ንጥቀም",
    privacySection2Text:
      "እንሰብስቦ ሓበሬታ አገልግሎትና ንምሃብ፣ ንምሕላውን ንምምሕያሽን ንጥቀም። እዚ ምስ ተመጣጣኒ ናይ ስራሕ እድላት ምትሕሓዝካ፣ ብዛዕባ ስራሕትን አገልግሎትናን ምዝራርብ፣ ከምኡውን ናይ ተጠቃሚ ተመክሮ ንምምሕያሽ ናይ ጥቕሚ ቅዳሔታት ምትንታን የጸምልል።",
    privacySection3Title: "3. ሓበሬታ ምክፍፋል",
    privacySection3Text:
      "ንስራሕ መግለጺኦም ከተመልክት ከለኻ ሓበሬታኻ ምስ አሰራሕቲ ንከፍፍል። ውልቃዊ ሓበሬታኻ ንሳልሳይ ወገናት አይንሸይጥን። መድረኽናን ዕቱግ ጽሕሚና ናብቲቲን ምስ ዝተጠቓመ፣ ብውልቃዊ ዘይፍለጥ ሓበሬታ ክንከፍፍል ንኽእል።",
    privacySection4Title: "4. ናይ መረጃ ድሕነት",
    privacySection4Text:
      "ውልቃዊ ሓበሬታኻ ካብ ዘይተፈቐደ ምእታው፣ ንውጢ፣ ምግላጽ ወይ ምድምሳስ ንምክልኻል ተመጣጣኒ ቴክኒካውን ውድባውን ናይ ድሕነት ስጕምትታትን ንትግበር። ግን፣ ዝኾነ ናይ ኢንተርነት ምግላጽ ሙሉ ብሙሉ ድሕንነቱ ዝተሓለወ አይኮነን፣ ሙሉ ብሙሉ ድሕነት ክንዋግእ አይንኸእልን።",
    privacySection5Title: "5. መስልሓትካ",
    privacySection5Text:
      "ብዝኾነ ግዜ ብናይ መለያ ቕንጥብጣባትካ ብምግባር ውልቃዊ ሓበሬታኻ ንምርካብ፣ ንምምሕዳስ ወይ ንምድምሳስ መስል አለካ። ከምኡውን ካብ ገለ ርክባት ክትወጽእ ትኸእል። ብዛዕባ ሓበሬታኻ አያያይና ስክፍታ እንተሃልዩካ፣ ብኻኻ ርከበና።",
    privacySection6Title: "6. ርከበና",
    privacySection6Text:
      "ብዛዕባ'ዚ ናይ ውልቃዊነት ፖሊሲ ወይ ናይ መረጃ አያያይ ልምድታትና ዝኾነ ሕቶ እንተሃልዩካ፣ ብኻኻ ብ privacy@nibjobs.com ርከበና። ንሕቶኻ ብዝተኻእለ መጠን ብፍጥነት መልሲ ክንህብ ኢና።",
    // Additional Home Page Texts
    categoriesLabel: "ምድባት",
    testimonialsLabel: "ምስክርነታት",
    pricingPlansLabel: "ናይ ዋጋ መደባት",
    faqLabel2: "ተደጋጋሚ ሕቶታት",
    jobsText: "ስራሕቲ",
    viewAllJobsButton: "ኩሉ ስራሕቲ ርአይ",
    loginAndViewMore: "ኣትው ተወሳኺ ስራሕቲ ርአይ",
    loadingJobs: "ስራሕቲ ይጽዕን ኣሎ...",
    manageAlerts: "ምልክታት ኣማሓድር",
    signUpForAlerts: "ንምልክታት ተመዝገብ",
    signUpToAccessAll:
      "ንዅሉ ባህርያት ንኽትረኽቦምን ንዅሉ ስራሕቲ ንኽትርኣዮምን ብኻኻ ተመዝገብ። ምዝገባ ምሉእ ብምሉእ ነጻ እዩ!",
    signUpForJobAlerts: "ናይ ውልቂ ናይ ስራሕ ምልክታት ንኽትቅበል ተመዝገብ!",
    playStoreDownload: "ጉግል ፕሌይ",
    getItOn: "ኣምጽኣ ካብ",
    // Auth Screen (Tigrigna)
    resetPassword: "ፓስወርድ ኣስሐዲስ",
    resetPasswordSubtitle: "ናይ ኢሜይል ኣድራሻኻ ኣእቱ፡ ፓስወርድ ዳግም ንምጅማር ሊንክ ንሰድደልካ",
    sendResetLink: "ሰደዳ ሊንክ ሊኣኽ",
    sendingReset: "ይሰደድ ኣሎ...",
    backToLogin: "ናብ ምእታው",
    forgotTagline: "ኣይሸበር — ንዅሉ ዘጋጥሞ ነዋሕ ኣሎ።",
    forgotSecureReset: "ዝጸናዕ ናይ ፓስወርድ ዳግምጅማር",
    forgotCheckInbox: "ናይ ኢሜይልካ ሳጹን ርአ",
    forgotAccountSafe: "ሕሳብካ ዝጸናዕ ኣሎ",
    signupTagline: "ብኢትዮጵያ ሕልሚ ስራሕ ዝደሉ ሽሕ ሙያዊ ሰብ ምሳና ተሓባበር።",
    signupThousandsJobs: "ሽሕ ናይ ስራሕ ዕድላት",
    signupInstantAlerts: "ቅልጡፍ ናይ ስራሕ መጠንቀቕታ",
    signupVerifiedEmployers: "ዝተረጋገጹ ቀጻሪታት ጥራሕ",
    emailSentTitle: "ኢሜይል ተሰዲዱ!",
    resetSentTo: "ናብ ኣድራሻ ዝተሰደደ",
    checkInboxForReset: "ናይ ኢሜይልካ ሳጹን ርአ ሊንክ ጠዊቅካ ፓስወርድ ኣሓዲስ",
    enterEmailError: "ህቡብ ናይ ኢሜይል ኣድራሻኻ ኣቕርብ",
    noAccountFoundError: "ብዚ ኢሜይል ኣድራሻ ሕሳብ ኣይተነጽረን",
    resetEmailFailedError: "ናይ ዳግምጅማር ኢሜይል ልኣኽ ኣይተኻእለን። ደጊምካ ፈትን።",
    verificationLinkSentTo: "ናይ ምክር ሊንክ ተሰዲዱ",
    emailStep1Title: "ናይ ኢሜይልካ ርአ",
    emailStep1Desc: "ናይ ምክር ሊንክ ማ ኣይሞ",
    emailStep2Title: "ሊንክ ጠዊቓ",
    emailStep2Desc: "ኣብ ኢሜይልካ ዘሎ ናይ ምክር ሊንክ ጠዊቕ",
    emailStep3Title: "ልካእ ጀምር",
    emailStep3Desc: "ኣቲኸ ናይ ሕልሚ ስራሕካ ርኸበ!",
    browseJobs: "ስራሕቲ ድሌ",
    passwordStrength: "ዓቕሚ ፓስወርድ",
    passwordsMatch: "\u2713 ፓስወርድታት ኣዛሚዶም",
    passwordStrengthWeak: "ወዕለ",
    passwordStrengthStrong: "ሓይሉ",
    passwordStrengthVeryStrong: "ብምሉእ ሓይሉ",
    fullNameRequired: "ሙሉእ ስም የድሊ",
    passwordsDoNotMatch: "ፓስወርድታት ኣይሳሓሞምን",
    // Settings Page (Tigrigna)
    settingsAccountSection: "ሕሳብ",
    settingsPreferencesSection: "ምርጫ",
    settingsAccountActionsSection: "ናይ ሕሳብ ስርሓ",
    settingsPortfolioLabel: "ፖርትፎሊዮ",
    settingsPortfolioSubtitle: "ሲቪ፡ ክእለታ & ተሞኩሮ",
    settingsAccountSubtitle: "ፕሮፋይል & ጸጥታ",
    settingsJobInterestsLabel: "ናይ ስራሕ ድሌ",
    settingsJobInterestsSubtitle: "ምድባ & ምርጫ",
    settingsPreferencesSubtitle: "ምርኣይ & ቋንቋ",
    settingsNotificationsSubtitle: "ምልክታ ምቅርራብ",
    settingsPrivacyLabel: "ሕቡእነ & ጸጥታ",
    settingsPrivacySubtitle: "ዳታ & ፍቃድ",
    settingsSubscriptionLabel: "ሰብስክሪፕሽን",
    settingsHelpLabel: "ሓገዝ & ደገፍ",
    settingsHelpSubtitle: "ሕቶታ & ምርኣይ",
    settingsLogoutSubtitle: "ካብ ሕሳብካ ወጻ",
    editProfileButton: "ፕሮፋይል ኣርትዕ",
    editChipLabel: "ኣርትዕ",
    jobSeekerLabel: "ስራሕ ደላዪ",
    savedJobsCount: "ተዓቂቡ",
    personalInfoSection: "ናይ ውልቂ ሓበሬታ",
    displayNameLabel: "ስም",
    displayNamePlaceholder: "ሙሉእ ስምካ",
    usernameLabel: "ናይ ተጠቃሚ ስም",
    checkingAvailability: "ይፈትሽ ኣሎ...",
    usernameAvailableText: "\u2713 ይርከብ",
    usernameTakenText: "\u2717 ተወሲዱ",
    dateOfBirthLabel: "ዕለተ ልደት",
    bioLabel: "ባዮ",
    bioPlaceholder: "ንቐጻሊ ዛዕባካ ንገር...",
    contactSection: "ምርኣይ",
    phoneNumberLabel: "ቁጽሪ ተለፎን",
    socialLinksSection: "ናይ ማሕበራዊ ሚዲያ ሊንከ",
    addCoverPhotoLabel: "ናይ ሽፋን ስእሊ ወስኽ",
    changeCoverPhotoLabel: "ቀይር",
    savingText: "ይዕቀብ ኣሎ...",
    saveChangesLabel: "ለወጥ ዓቅብ",
    profileLinkSection: "ናይ ፕሮፋይል ሊንክ",
    copyLinkLabel: "ሊንክ ቅዳሕ",
    previewLabel: "ቅድሚ ምርኣይ",
    cvResumeSection: "ሲቪ / ሬዚሜ",
    cvUploadedText: "ሲቪ ሰቒሉ",
    cvPdfDocLabel: "PDF / DOC",
    cvUploadButton: "ሲቪ ሰቅሎ",
    cvUploadingText: "ይሰቕሎ ኣሎ...",
    cvReplaceButton: "ተካእ",
    professionalInfoSection: "ሞያዊ ሓበሬታ",
    jobTitleLabel: "ናይ ስራሕ ማዕርግ",
    yearsOfExperienceLabel: "ዓምታ ተሞኩሮ",
    aboutSection: "ዛዕባ",
    skillsLabel: "ክእለታ",
    educationLabel: "ትምህርቲ",
    keyAchievementsLabel: "ቀዳማይ ዓወታ",
    linksSection: "ሊንከ",
    portfolioWebsiteLabel: "ናይ ፖርትፎሊዮ ዌብሳይት",
    savePortfolioButton: "ፖርትፎሊዮ ዓቅብ",
    profilePreviewTitle: "ናይ ፕሮፋይል ቅድሚ ምርኣይ",
    asSeenByOthers: "ካልኦ ከም ዝርእዩኻ",
    appearanceSection: "ምርኣይ",
    darkModeEnabled: "ጸሊም ቀለም ነቒሑ",
    lightModeEnabled: "ብርሃን ቀለም ነቒሑ",
    emailNotificationsLabel: "ናይ ኢሜይል ምልክቲ",
    emailNotificationsSubtitle: "ዝሓሰሱ ዜናዊ ብኢሜይል ተቐበሉ",
    pushNotificationsLabel: "ናይ ፑሽ ምልክቲ",
    pushNotificationsSubtitle: "ቀልጠፍ ዝሆነ ምልክቲ",
    jobAlertsLabel: "ናይ ስራሕ ምልክቲ",
    jobAlertsSubtitle: "ምስ ዝሰምዕካ ዓይነ ዝሓሰሱ ስራሕ",
    applicationUpdatesLabel: "ዝሓሰሱ ዜናዊ",
    applicationUpdatesSubtitle: "ምልዋጥ ኣብ ምልካዕካ",
    profileVisibilitySection: "ናይ ፕሮፋይል ርብያ",
    visibilityPublic: "ሃፈሻዊ",
    visibilityPublicSubtitle: "ዝዀነ ሰብ ፕሮፋይልካ ክርኢ ይኽእል",
    visibilityConnectionsOnly: "ዝተኣሳሰሩ ጥራይ",
    visibilityConnectionsOnlySubtitle: "ዝተኣሳሰሩ ጥራይ ክርኢ ይኽእሉ",
    visibilityPrivate: "ሕቡእ",
    visibilityPrivateSubtitle: "ፕሮፋይልካ ካልኦ ዝሕብኢ",
    contactMessagingSection: "ምርኣይ & ሜሳጅ",
    showEmailLabel: "ኢሜይል ኣርኢ",
    showEmailSubtitle: "ኢሜይልካ ሃፈሻዊ ኣርኢ",
    allowMessagingLabel: "ሜሳጅ ፍቃድ",
    allowMessagingSubtitle: "ቀጻሊ ሜሳጅ ይሰደሉ",
    interestsHintText: "ናይ ስራሕ ምምሕዳር ንምሕጋዝ 1 ምድቢ፡ ብዙሕ ንዑስ ምድቢ፡ ቁልፊ ቃሎ ምረጽ",
    yourInterestsSection: "ድሌታኻ",
    categoryLabel: "ምድቢ",
    subcategoriesLabel: "ንዑስ ምድቢ",
    tagsLabel: "ቁልፊ ቃሎ",
    subcategoriesSection: "ንዑስ ምድቢ",
    saveJobInterestsButton: "ናይ ስራሕ ድሌ ዓቅብ",
    faqsMenuTitle: "ቀዋሚ ሕቶታ",
    faqsMenuSubtitle: "ሕቶታ ተምሂሮም",
    contactSupportTitle: "ደገፍ ርከብ",
    contactSupportSubtitle: "ካብ ቡድና ሓገዝ ርከብ",
    sendFeedbackTitle: "ርኢቶ ሊኣኽ",
    sendFeedbackSubtitle: "ንምምሕሻ ሓግዘ",
    privacyPolicySubtitle: "ዳታካ ከም ዝሕልዉ",
    termsOfServiceSubtitle: "ናይ ኣጠቃቕማ ዉዑዮና",
    needImmediateHelpText: "ቀልጠፍ ሓገዝ ይደሊ?",
    frequentlyAskedQuestionsLabel: "ቀዋሚ ሕቶታ",
    stillHaveQuestionsText: "ሕቶ ኣሎዋ?",
    messageSectionHeader: "ሜሳጅ",
    subjectFieldLabel: "ናይ ርዕሲ ጉዳይ",
    subjectFieldPlaceholder: "ዓይነ ሓገዝ ትደሊ?",
    messageFieldPlaceholder: "ጉዳዩ ወይ ሕቶ ብምዝርዝር ሃበ...",
    sendingText: "ይሊኣኽ ኣሎ...",
    sendMessageButton: "ሜሳጅ ሊኣኽ",
    otherWaysToReachLabel: "ካልኦ ናይ ምርኣይ ኣገልጋይ",
    messageSentText: "ሜሳጅ ተሰዲዱ!",
    messageReplyTimeText: "ኣብ ዉሽጢ 24-48 ሰዓ ምላሽ ኣቕርቦ።",
    supportHoursLabel: "ሰዓታ ደገፍ",
    supportHoursText: "ሰኑይ-ዓርቢ፡ 9 ሰ.ቅ - 6 ሰ.ድ EAT",
    accountSettingsTitle: "ናይ ሕሳብ ቅንብር",
    // Help FAQs
    helpFaq1Q: "መለለያ ምኽፋት ብኸምይ?",
    helpFaq1A:
      'ኣብ ላዕሊ የማናዊ ጥኒ "ምዝገባ" ጠዊቐ ዝርዝርካ ምልእ። ቅልጡፍ ምዝገባ ንGoogle መለለያካ ምጥቃም ትኽእል።',
    helpFaq2Q: "ንስራሕ ብኸምይ ከምልእ ኽእለ?",
    helpFaq2A:
      'ዝሳጎጀካ ስራሕ ጠዊቐ "ምልኣ" ቁልፊ ጠዊቕ። ቅድሜ ምምላእ፣ ፕሮፋይልካን ሲቪካን ሓደሽ ምዃኑ ኣረጋግጽ።',
    helpFaq3Q: "ድሕሪ ምሳቐ ምልኣ ምቕያሩ ይካኣል?",
    helpFaq3A:
      "ምስ ቐረበ ምልኣ ናቱ ምቕያር ኣይካኣልን። ቅድሜ ምሳቐ ሓበሬታ ኩሉ ቅኑዕ ምዃኑ ኣረጋግጽ። ምልኣካ ንምሕዳስ ቀጥታ ንቀጣሪ ተወሳሰቦ።",
    helpFaq4Q: "ሲቪ ብኸምይ ሰቐለ?",
    helpFaq4A:
      'ቅንብሮ > ፖርትፎሊዮ ኬድካ "ሲቪ ሰቐልካ" ጠዊቐ። PDF፣ DOC ወይ DOCX ናብ 5MB ዝብስ ፋይሎ ሰቐልካ ትኽእል።',
    helpFaq5Q: "ክንደይ ምዝገባ መደብ ኣሎ?",
    helpFaq5A:
      "ነጻ፣ ሰርዓዊ ናዕቢ፣ ናዕቢ ኢንተርፕራይዝ ንህብ። ዝርዝር ባህርያትን ዋጋን ምርኣይ ቅንብሮ > ምዝገባ ብጻሕ።",
    helpFaq6Q: "ምዝገባ ብኸምይ ሰርዘ?",
    helpFaq6A: 'ቅንብሮ > ምዝገባ ኬድካ "ምዝገባ ምምሕዳር" ጠዊቐ። ምዝገባካ ኣብ ዝኾነ ጊዜ ምሰርዞ ትኽእል።',
    helpFaq7Q: "ናይ ስራሕ ምልክታ ብኸምይ ይሰርሕ?",
    helpFaq7A:
      "ናይ ስራሕ ምልክታ ምስ መዐቀብካ ዝዛመዱ ሓደስቲ ስራሕቲ ምስ ቐረቡ ይፈልጠካ። ቅንብሮ > ምልክታ ውስጢ ምርጫካ ኣዘጋጅ።",
    helpFaq8Q: "ስራሕቲ ቆሊፍካ ክትዓቅቦ ትኽእለ?",
    helpFaq8A:
      "እወ! ኣብ ዝኾነ ናይ ስራሕ ዝርዝር bookmark ጠዊቐ። ዝተዓቶዱ ስራሕቲ ካብ ዋናዊ ምናሌ ቡክማርክ ክፍሊ ዉስጢ ርካቦም።",
    helpFaq9Q: "ናይ ቋንቋ ምርጫ ብኸምይ ቀይረ?",
    helpFaq9A: "ቅንብሮ > ምርጫ ኬድካ ዝምርጽ ቋንቋ ምረጽ። እንግሊዝ፣ ኣምሓርኛ፣ ትግርኛን ኦሮምኛን ንደግፍ።",
    helpFaq10Q: "ዳታይ ሓፂን ድዩ?",
    helpFaq10A:
      "እወ፣ ድሕነት ዳታ ብቁምነገር ንስዕባ። ኩሉ ዕቤተ-ሓደጋ ሓበሬ ብምስጢር ተዓቂቡ ኣሎ። ዝርዝር ናይ ምስጢርነት ፖሊሲ ኣንብብ።",
    // Feedback form
    feedbackCategoryLabel: "ምድቢ",
    feedbackRatingLabel: "ደረጃ (ናይ ምርጫ)",
    yourFeedbackLabel: "ርኢቶካ",
    feedbackPlaceholder: "ሓሳብካ ሃበ...",
    submitFeedbackButton: "ርኢቶ ስደድ",
    submittingText: "ይሰዳ ኣሎ...",
    feedbackSubmittedTitle: "ርኢቶ ቀሪቡ!",
    feedbackThankYouText: "NibJobs ንምምሕሻ ዝሓለፍካ ሓገዝ ኣመስጊና።",
    feedbackErrorText: "እባ ምድቢ ምረጽ እናበልካ ርኢቶ ህብ",
    messageSendFailed:
      "መልእኽቲ ምስዳድ ኣይተሳኸዐን። በጃኹም ደጊምኩም ፈትኑ ወይ ብቐጥታ ብsupport@nibjobs.com ርኸቡና",
    feedbackSubmitFailed: "ርኢቶ ምቕራብ ኣይተሳኸዐን። በጃኹም ደጊምኩም ፈትኑ።",
    feedbackCategoryFeatureRequest: "ሕቶ ባህሪ",
    feedbackCategoryBugReport: "ናይ ጌጋ ራፖርት",
    feedbackCategoryUserExperience: "ናይ ተጠቃሚ ፍርፍር",
    feedbackCategoryPerformance: "ፍጻሜ",
    feedbackCategoryOther: "ካሊ",
    // Contact form
    fullNamePlaceholder: "ሙሉእ ስምካ ኣእቱ",
    privacyPolicy: "ፖሊሲ ፕራይቨሲ",
    termsOfService: "ውዕል ኣገልግሎት",
    // Subscription / Pick a plan page
    pickAPlan: "ፕላን ምረጽ",
    upgradeAnytimeCancelAnytime: "ኣብ ዝኾነ ጊዜ ዘደልዮ ፕላን ምምራጽ · ኣብ ዝኾነ ጊዜ ሰርዝ",
    billingMonthly: "ወርሓዊ",
    billingYearly: "ዓመታዊ",
    loadingPlans: "ፕላናት ይጽዓኑ ኣለዉ…",
    planActiveBadge: "ንጡፍ",
    planPopularBadge: "ታዋቂ",
    planPriceFree: "ናጻ",
    planPricePerMo: "/ወርሒ",
    planPricePerYr: "/ዓመት",
    planSavesPercent: "ካብ ወርሓዊ {percent}% ይቆጥብ",
    planCurrentPlanCta: "ሕሉፍ ፕላን",
    planSwitchToFree: "ናብ ናጻ ቀይር",
    planGetName: "{name} ምዕዳግ",
    planSecureCheckout: "ውሑስ ክፍሊት",
    planCancelAnytime: "ኣብ ዝኾነ ጊዜ ሰርዝ",
    plan247Support: "24/7 ደገፍ",
    loginRequiredTitle: "ምእታው የድሊ",
    loginRequiredMessage: "ናትካ ናይ ምምዝጋብ ፕላን ንምሻሻል እባክካ እተ።",
    downgradeToFreeTitle: "ናብ ናጻ ምቕናስ",
    downgradeToFreeMessage: "ናብ ናጻ ፕላን ክሰጋገር ትደሊ ዲኻ?",
    planSwitchedToFree: "ናብ ናጻ ፕላን ተሰጊሩ",
    planFailedToSwitch: "ፕላን ምቕያር ኣይሰለጠን",
    cancelButton: "ሰርዝ",
    confirmButton: "ኣረጋግጽ",
    successTitle: "ተሳሊጡ",
    errorTitle: "ስሕተት",
    // Bottom nav labels
    navJobs: "ስራሕቲ",
    navSaved: "ዝተዓቶዱ",
    navAlerts: "መጠንቀቕታ",
    newLabel: "ሓዲሽ",
    markAllRead: "ኩሎም ነቐፌታ ከም ተነበቡ ምልክት",
    noNotificationsTitle: "ክሳብ ሕጂ ዝኾነ መጠንቀቕታ የለን",
    noNotificationsDesc: "ሓዲሽ ክመጽእ እንከሎ ክንሕብረካ ኢና።",
    viewAllNotifications: "ኩሎም መጠንቀቕታታት ርአ",
    navProfile: "መግለጺ",
    navDashboard: "ዳሽቦርድ",
    // Toolbar
    lightMode: "ብሩህ ዓዲ",
    // Terms of Service body
    termsSection1Title: "1. ምቅባል ውዕሎ",
    termsSection1Text:
      "NibJobs ብምምእታውን ብምጥቃምን፣ ናይ ኣገልግሎት ውዕሎ ትቅበሎን ብዑን ከምዘለካ ትሰማምዕን። ምስዚ ውዕሎ ዘይትሰማማዕ እንተኾነ፣ ኣገልግሎታትና ከምዘይጠቐምካ ይሕተት።",
    termsSection2Title: "2. ናይ ኣገልግሎት ምጥቃም",
    termsSection2Text:
      "NibJobs ስራሕ ፈለጥቲ ናይ ቅጥዓ ዕድላት ንምርካብ ከምኡ ናይ ቀጠርቲ ናይ ስራሕ ዝርዝር ንምለጣፍ ዘኽእሎም ፕላትፎርም ይህብ። ኣገልግሎቱ ንሕጋዊ ዓላማ ጥራሕን ምስ'ዚ ውዕሎ ብዝሳዓብ መንገዲን ምጥቃም ትሰማምዕ።",
    termsSection3Title: "3. ናይ ተጠቃሚ ሕሳቦ",
    termsSection3Text:
      "ናይ ሕሳብካ ምስጢርነት ምሕላው ከምኡ ኣብ ሕሳብካ ዝካሄዱ ኩሎ ዘይምቅርካ ተሓታቲ ኢካ። ሕሳብ ክፈትሕ ከሎካ ቅኑዕን ምሉእን ሓበሬ ምሃብ ኣለካ።",
    termsSection4Title: "4. ዝርዝርን ጠባይን",
    termsSection4Text:
      "NibJobs ዝለጥፎ ዝርዝር ብሙሉእ ንስካ ተሓታቲ ኢካ። ሕጋዊ ዘይኮነ፣ ጎዳኢ፣ ዝፈራርሕ፣ ዘጥቅዕ፣ ስም ዘበላሽዉ ወይ ካሊእ ዘሸግር ዝርዝር ዘይምለጣፍ ትሰማምዕ።",
    termsSection5Title: "5. ናይ ዕሸራ ንብረት",
    termsSection5Text:
      "NibJobs ዘሎ ኩሉ ዝርዝር፣ ባህርያትን ተግባርን ናትና ዋናነት ኮይኑ ብናይ ቅዳሕ መሰል፣ ናይ ንግዲ ምልክትን ካሊኦ ናይ ዕሸራ ንብረት ሕጊታትን ዝሕሎ ኢዩ።",
    termsSection6Title: "6. ኣደራት ወሰን",
    termsSection6Text:
      "NibJobs ካብ ኣጠቃቅማካ ኣብ ዝፍጠር ቀጥታ ዘይኮነ፣ ዘይተጸበኻዮ፣ ፍሉይ፣ ሳዕቤናዊ ወይ ቅጻዊ ጉዳት ተሓታቲ ኣይኮነን።",
    termsSection7Title: "7. ናይ ውዕሎ ለውጢ",
    termsSection7Text:
      "ውዕሎ ኣብ ዝኾነ ጊዜ ናይ ምቅያሩ መሰሉ ዝሓዘ ኢዩ። ኣገዳሲ ለውጢ ምስ ዝህሉ ናብ ተጠቀምቲ ብኢሜይል ወይ ብኣፕ ነፍልጥ።",
    termsSection8Title: "8. ናይ ምቅርቃር ሓበሬ",
    termsSection8Text: "ስለዚ ናይ ኣገልግሎት ውዕሎ ሕቶ ምስ ዝህሉካ፣ legal@nibjobs.com ተወሳሰቦ",
    // Company Dashboard
    cdDashboard: "ዳሽቦርድ",
    cdAnalytics: "ትንታኔ",
    cdJobPostings: "ናይ ስራሕ ዝርዝር",
    cdApplications: "ምልኣታት",
    cdTalentPool: "ናይ ተሰጦ ጸብለቕ",
    cdCompanyProfile: "ናይ ትካሉ ፕሮፋይል",
    cdAccountSettings: "ናይ ሕሳብ ቅንብር",
    cdAnalyticsInsights: "ትንታኔን ፍልጠትን",
    cdManageYourJobs: "ስራሕካ ምሕደሩ",
    cdReviewCandidates: "ተወዳደርቲ ምግምጋም",
    cdDiscoverTalent: "ልዑል ሞያ ምርካብ",
    cdUpdateDetails: "ዝርዝርካ ምሕዳስ",
    cdLoadingDashboard: "ዳሽቦርድ ይጽዓን ኣሎ...",
    cdOverview: "ሓፈሻዊ ርኢቶ",
    cdHiring: "ምቅጣር",
    cdSettings: "ቅንብር",
    cdBrowseJobs: "ስራሕቲ ምርካብ",
    cdSignOut: "ምውጻእ",
    cdVerified: "ተረጋጊጹ",
    cdVerifiedCompany: "ዝተረጋገጸ ትካሉ",
    cdVerificationRejected: "ምርግጋጽ ኣይተቐበለን",
    cdVerificationPending: "ምርግጋጽ ኣብ ሂደት",
    cdCompanyAccount: "ናይ ትካሉ ሕሳብ",
    cdSwitchView: "ርኢቶ ምቕያር",
    cdCandidateView: "ናይ ፈለጢ ርኢቶ",
    cdPostJob: "ስራሕ ለጥፍ",
    cdActiveJobs: "ንጡፋት ስራሕቲ",
    cdTotalApplicants: "ጠቕላላ ጠለብ ዝሃቡ",
    cdPendingReviews: "ኣብ ሂደት ዘሎ ግምጋም",
    cdAvgPerJob: "አኳ. ብስራሕ",
    cdTotalJobs: "ጠቕላላ ስራሕቲ",
    cdToReview: "ንግምጋም",
    cdReviewed: "ዝተገምገሙ",
    cdPending: "ኣብ ሂደት",
    cdTotal: "ጠቕላላ",
    cdApplicationsPerPosting: "ምልኣታት ብዝርዝር",
    cdStillActive: "ኣሁን ድማ ንጡፍ",
    cdPendingApplications: "ኣብ ሂደት ምልኣታት",
    cdProcessedSoFar: "ክሳብ ሕጂ ዝካሄዱ",
    cdPostYourFirstJob: "ቀዳማይ ስራሕካ ለጥፍ",
    cdFirstJobDesc: "ቀዳማይ ናይ ስራሕ ዝርዝርካ ፈጢርካ ምስ ተሰጦ ዘለዎ ሞያዊ ሰብ ምዝምዛን።",
    cdCreateJobPosting: "ናይ ስራሕ ዝርዝር ምፍጣር",
    cdQuickActions: "ቅልጡፍ ተዳዊ",
    cdApplicationPipeline: "ናይ ምልኣ ቧምቧ",
    cdPostNewJob: "ሓዲሽ ስራሕ ምለጣፍ",
    cdViewApplications: "ምልኣታት ምርኣይ",
    cdBrowseCandidates: "ተወዳደርቲ ምርካብ",
    cdEditProfile: "ፕሮፋይል ምስራሕ",
    cdLoadingApplications: "ምልኣታት ይጽዓናለዉ...",
    cdSearchApplications: "ብስም፣ ኢሜይል ወይ ናይ ስራሕ ርዕሲ ድለ...",
    cdNoApplicationsFound: "ምልኣታት ኣይተረኸቡን",
    cdTryAdjustingFilters: "ምጻሪያ ወይ ናይ ፍለጋ ሕቶ ኣስተካኽሎ",
    cdApplicationsWillAppear: "ተወዳደርቲ ምልኦ ምስ ዘቕርቡ ምልኣታት ይርዩ",
    cdShortlist: "ቀዳሞ ዝርዝር",
    cdReject: "ምእጋድ",
    cdAccept: "ምቕባል",
    cdViewDetails: "ዝርዝር ምርኣይ",
    cdApplicationDetails: "ናይ ምልኣ ዝርዝር",
    cdContactInfo: "ናይ ምቅርቃር ዝርዝር",
    cdApplicantInfo: "ናይ ምልካ ዝርዝር",
    cdProfessionalOverview: "ሞያዊ ሓፈሻዊ",
    cdLoadingJobs: "ስራሕቲ ይጽዓናለዉ...",
    cdManageJobListings: "ንጡፋት ናይ ስራሕ ዝርዝርካ ምሕደሩ",
    cdCreateJob: "ስራሕ ምፍጣር",
    cdActive: "ንጡፍ",
    cdPaused: "ዝቋረጸ",
    cdNoJobsYet: "ዝተለጠፈ ስራሕ የለን",
    cdFirstJobPostingDesc: "ተሰጦ ዘለዎ ሞያዊ ሰብ ንምርካብ ቀዳማይ ናይ ስራሕ ዝርዝርካ ፍጠር።",
    cdCreateFirstJob: "ቀዳማይ ስራሕካ ፍጠር",
    cdApplicants: "ምልካ ዝሃቡ",
    cdEditJobPosting: "ናይ ስራሕ ዝርዝር ምስራሕ",
    cdCreateNewJob: "ሓዲሽ ስራሕ ፍጠር",
    cdUpdateJobDetails: "ናይ ስራሕ ዝርዝር ዝርዝርካ ምሕዳስ",
    cdFillNewOpening: "ሓዲሽ ናይ ስራሕ ክፍቲ ሌጥፍ ዝርዝሩ ምልኣ",
    cdBasicInformation: "ሓፈሻዊ ሓበሬ",
    cdJobTitle: "ናይ ስራሕ ርዕሲ",
    cdCategory: "ምድቢ",
    cdContractType: "ዓይነት ሰሚዕ",
    cdLocationCompensation: "ቦታን ክፍሊትን",
    cdRemoteWorkAvailable: "ናይ ርሑቕ ስራሕ ይካኣ",
    cdMonthlySalary: "ወርሓዊ ደሞዝ (ብር)",
    cdJobDetails: "ናይ ስራሕ ዝርዝር",
    cdJobDescription: "ናይ ስራሕ ገለጻ",
    cdRequirements: "ቅድሚ ሕቶ",
    cdKeyResponsibilities: "ዋና ሓላፍነታት",
    cdSkillsTags: "ክእሎታትን ምልክታትን",
    cdJobTitleRequired: "ናይ ስራሕ ርዕሲ ይሕተ",
    cdCategoryRequired: "ምድቢ ይሕተ",
    cdLocationRequired: "ቦታ ይሕተ",
    cdSkillsRequired: "ቢያንስ ሓንቲ ክእሎ/ምልክት ይሕተ",
    cdSearchCandidates: "ስም፣ ሙያ፣ ክእሎታት ድለ\u2026",
    cdFound: "ተረኺቡ",
    cdLoadingCandidates: "ተወዳደርቲ ይጽዓናለዉ...",
    cdNoResultsFound: "ውጽኢት ኣይተረኸበን",
    cdNoCandidatesYet: "ተወዳደርቲ ክሳብ ሕጂ የለን",
    cdTryDifferentSearch: "ካሊእ ፍለጋ ፈትን ወይ ምጻሪያ ሰርዝ",
    cdCandidatesWillAppear: "ተወዳደርቲ ምስ ዝምዝገቡ ይርዩ",
    cdCompanyNameLabel: "ናይ ትካሉ ስም",
    cdDescriptionLabel: "ገለጻ",
    cdIndustryLabel: "ኢንዱስትሪ",
    cdCompanySizeLabel: "ናይ ትካሉ ዓቐን",
    cdFoundedYearLabel: "ናይ ምምስራት ዓመ",
    cdAboutCompany: "ብዛዕባ ትካሉ",
    cdContactInformation: "ናይ ምቅርቃር ዝርዝር",
    cdSizeLabel: "ዓቐን",
    cdFoundedLabel: "ቀዳሚ",
    cdYourCompanyVerified: "ትካልካ ተረጋጊጹ",
    cdContactSupportInfo: "ዝያዳ ሓበሬ ንምርካብ ድጋፍ ተወሳሰቦ",
    cdUnderReview: "ብኣቃሪ ዝካሄድ ግምጋም",
    cdActiveDashboard: "ንጡፍ ዳሽቦርድ",
    cdDeleteJobPosting: "ናይ ስራሕ ዝርዝር ምሰራዝ",
    cdDeleteJobConfirm: "ናይ ስራሕ ዝርዝር ምሰራዝ ዘረጋግጽ ዲካ?",
    cdJobUpdated: "ናይ ስራሕ ዝርዝር ብዓወት ሓዲሹ!",
    cdJobPosted: "ናይ ስራሕ ዝርዝር ብዓወት ተለጢፉ!",
    cdYearsExp: "ዓ.ልምዲ",
    // Mobile Drawer
    drawerTagline: "ዕድልካ ዝቀጽሉ ርካሕ",
    drawerMyAccount: "ናተይ ሕሳብ",
    drawerSavedJobs: "ዝተቐምጡ ስራሕቲ",
    drawerMyApplications: "ምልኣታተይ",
    drawerPostJob: "ስራሕ ኣለጥፍ",
    drawerMyJobPosts: "ናተይ ዝርዝር ስራሕ",
    drawerAnalytics: "ኣናሊቲክስ",
    drawerRegisterCompany: "ትካልካ ምዝገባ ግበር",
    drawerExplore: "ምርምር",
    drawerBrowseJobs: "ስራሕቲ ምርምር",
    drawerPreferences: "ምርጫታት",
    drawerSubscription: "ምዝገባ",
    drawerAboutNibJobs: "ብዛዕባ NibJobs",
    drawerSignOutTitle: "ምውጻእ?",
    drawerSignOutDesc: "ካብ ሕሳብካ ወጺእካ ናብ ቀዳማይ ገጽ ትምለስ።",
    drawerClose: "ዕጾ",
    drawerVersion: "ቅዲ",
    drawerPlatform: "ፕላትፎርም",
    drawerCountry: "ሃገር",
    drawerWebsite: "ዌብሳይት",
    drawerSupport: "ደገፍ",
    drawerAboutTagline:
      "ቀዳማይ ናይ ኢትዮጵያ ናይ ስራሕ ፕላትፎርም — ዝሰልጠኑ ሞያውያን ምስ ዝሓሸ ኣስራሒ ዘራኽብ።",
    // Confirmation modals
    confirmAction: "ኣረጋግጽ",
    areYouSure: "ርግጸኛ ዲኻ?",
    deleteConfirmTitle: "ይደምሰስ?",
    cannotBeUndone: "እዚ ተግባር ክምለስ ኣይክእልን።",
    logoutConfirmTitle: "ናይ ምውጻእ መረጋገጺ",
    logoutConfirmMessage: "ክትወጽእ ርግጸኛ ዲኻ? ናብ ሕሳብካ ንኽትበጽሕ እንደገና ክትኣቱ የድልየካ።",
    // Action buttons
    continueButton: "ቀጽል",
    previousButton: "ቀዳማይ",
    nextButton: "ቀጺሉ",
    backButton: "ተመለስ",
    applyButton: "ኣመልክት",
    submitApplicationButton: "ምልክታ ኣእቱ",
    postJobButton: "ስራሕ ለጥፍ",
    browseMoreJobs: "ተወሳኺ ስራሕቲ ርአ",
    goBack: "ተመለስ",
    notNow: "ሕጂ ኣይኮነን",
    // Application flow
    applyForPosition: "ነቲ ስራሕ ኣመልክት",
    applicationStatus: "ኩነታት ምልክታ",
    stepLabel: "ደረጃ",
    ofLabel: "ካብ",
    personalInfoStep: "ውልቃዊ ሓበሬታ",
    professionalStep: "ሞያዊ",
    coverLetterStep: "መእተዊ ደብዳቤ",
    personalInformationSection: "ውልቃዊ ሓበሬታ",
    professionalLinksSubtitle: "ናይ ኦንላይን ህላወኻን ናይ ስራሕ ኣብነታትካን ኣካፍል (ኣማራጺ)",
    coverLetterSubtitle: "ነዚ ቦታ ስለምንታይ ዝበቅዕ ምዃንካ ነቲ ኣስራሒ ንገሮ",
    coverLetterTip: "ምኽሪ፦ ዝተበቀ መእተዊ ደብዳቤ ዕድልካ ከዛይድ ይኽእል",
    // Application filters / statuses
    statusAll: "ኩሉ",
    statusPending: "ኣብ ምጽባይ",
    statusReviewed: "ዝተረኣየ",
    statusShortlisted: "ዝተመርጸ",
    statusAccepted: "ዝተቐበለ",
    statusRejected: "ዝተነጽገ",
    filterByStatus: "ብኩነታት ፍለ",
    // Company profile / registration
    companyNameLabel: "ስም ትካል",
    companyDescriptionLabel: "መግለጺ ትካል",
    companyEmailLabel: "ኢመይል ትካል",
    companyPhoneLabel: "ስልኪ ትካል",
    addressLabel: "ኣድራሻ",
    cityLabel: "ከተማ",
    websiteLabel: "ድሕረ-ገጽ",
    industryLabel: "ዓውዲ",
    companySizeLabel: "ዓቐን ትካል",
    uploadLogo: "ኣርማ ሰቅል",
    // Subscription (mobile)
    subscriptionPlansTitle: "ናይ ደንበኝነት ዕቅዳት",
    getStartedBtn: "ጀምር",
    chooseStandardBtn: "ስታንዳርድ ምረጽ",
    chooseProBtn: "ፕሮ ምረጽ",
    chooseEnterpriseBtn: "ኢንተርፕራይዝ ምረጽ",
    // App bar titles / misc
    emailVerificationRequired: "ናይ ኢመይል መረጋገጺ የድሊ",
    emailNotVerified: "ኢመይል ኣይተረጋገጸን",
    resetPasswordTitle: "ናይ ይሕለፍ ቃል ዳግም ኣጀምር",
    resetPasswordSubtitleMobile: "ናይ ዳግም ምምራሕ መምርሒ ናብ ኢመይልካ ክንሰደልካ",
    jobNotFoundTitle: "ስራሕ ኣይተረኽበን",
    somethingWentWrong: "ጸገም ተፈጢሩ",
    manageJobListings: "ናይ ስራሕ ዝርዝራትካ፣ ምልክታታትካን ትንታነታትን ምሓዝ",
    // Verification steps
    verifyStep1Title: "ኢመይልካ ክፈት",
    verifyStep1Desc: "ናይ መልእኽቲ ሳጹንን ኣብ ኡኡ ድማ ናይ ስፓም ኣቃፊ ፈትሽ",
    verifyStep2Title: "መራኸቢ ጠውቕ",
    verifyStep2Desc: "ኣብቲ ኢመይል ዝርከብ ናይ መረጋገጺ መራኸቢ ተንክፍ",
    verifyStep3Title: "ምቅላል ጀምር",
    verifyStep3Desc: "ኣቱ ከምኡውን ናይ ሕልምኻ ስራሕ ርኸብ!",
    locationLabel: "ቦታ",
    updateJobButton: "ስራሕ ኣሕድስ",
    remoteWorkSubtitle: "ሰራሕተኛታት ካብ ርሑቕ ክሰርሑ ፍቐድ",
    selectedCountLabel: "ዝተመርጹ",
    searchApplicationsPlaceholder: "መመልከቲታት ድለ...",
    noApplicationsYet: "ክሳብ ሕጂ መመልከቲታት የለዉን",
    jobRoleLabel: "ተራ",
    saveChangesButton: "ለውጥታት ዓቅብ",
  },
  or: {
    // Mobile Landing Page hero
    mobileSignIn: "Seeni",
    mobileActiveJobs: "Hojiiwwan Banaa",
    mobileThousandsJobs: "Hojiiwwan Kumaan Lakkaa'aman",
    mobileHeroLine1: "Hojii abjuu keetii",
    mobileHeroHighlight: "har'uma",
    mobileHeroLine2: "argadhu.",
    mobileHeroDesc:
      "Hojiiwwan chaanaalota Telegram 50 ol fi dhaabbilee irraa, bakka tokkotti — bilisaan, gidduu-galeessa malee.",
    mobileHeroPerkFree: "Bilisaan",
    mobileHeroPerkNoBroker: "Gidduu-galeessa malee",
    mobileHeroPerkAlerts: "Beeksisa ariifataa",
    mobileHeroNoAccount: "Herrega hin qabduu?",
    mobileHeroSignUp: "Bilisaan galmaa'i",
    mobileHeroSearchButton: "Barbaadi",
    liveJobsLabel: "KALLATTIIN",
    liveJobsUpdated: "Guyyaa guyyaan haaromfama",
    liveJobsCaption: "hojiiwwan banaa si eeggachaa jiran",
    mobileSearchPlaceholder: "Hojii, dhaabbilee barbaadi...",
    mobileBrowseAll: "Hojiiwwan Hunda Ilaali",
    // Oromifa
    appTitle: "Niib Hojii",
    searchPlaceholder: "Hojii barbaadi...",
    login: "Seeni",
    signUp: "Galmaa'i",
    exploreChannels: "🚀 Chaanalii Telegram qoradhaa",
    swipeHint: "← Chaanalii dabalataa argachuuf garagali →",
    recentJobs: "Hojii Yeroo Dhiyoo",
    jobsFound: "hojiin argame",
    loading: "Hojiin ni fe'ama...",
    categories: "Gosa",
    contractType: "Gosa Kontraata",
    location: "Bakka",
    remoteJobs: "Hojii Fagoo",
    clearFilters: "Calalchiisa haqxi",
    adminLogin: "Seensa Bulchiinsa",
    email: "Imeelii",
    password: "Jecha Icciitii",
    loginButton: "Seeni",
    loginError: "Imeelii fi jecha icciitii galchi",
    invalidCredentials: "Imeelii ykn jecha icciitii dogoggoraa",
    telegramChannel: "Chaanalii Telegram",
    members: "miseensa",
    darkMode: "Haala Dukkana",
    language: "Afaan",
    downloadPlayStore: "Play Store",
    downloadAppStore: "App Store",
    // Jobs page
    employmentType: "Gosa Hojii",
    workMode: "Akkaataa Hojii",
    fullTime: "Guutuu Yeroo",
    partTime: "Yeroo Muraasa",
    contract: "Kontraata",
    remote: "Fagoo",
    onSite: "Bakka Hojii irratti",
    hybrid: "Walitti makame",
    applyNow: "Amma iyyannaa galchi",
    shareJob: "Hojii qoodaa",
    viewDetails: "Bal'ina ilaali",
    salaryRange: "Hangi Mindaa",
    posted: "Maxxanfame",
    ago: "dura",
    noJobsFound: "Hojiin hin argamne",
    filterJobs: "Hojii filannoo",
    sortBy: "Tartiiba",
    clearAll: "Hunda haqxi",
    // Companies page
    companies: "Dhaabbilee",
    viewAll: "Hunda ilaali",
    noCompaniesFound: "Dhaabbilee hin argamne",
    // Settings page
    settings: "Qindaa'ina",
    profile: "Ibsa",
    notifications: "Beeksisa",
    theme: "Bifa",
    logout: "Ba'i",
    about: "Waa'ee",
    privacy: "Imaammata Dhuunfaa",
    terms: "Waliigaltee Tajaajila",
    // Bookmarks
    bookmarks: "Kan Kuufaman",
    bookmark: "Mallattoo godhi",
    save: "Kuufadhu",
    saved: "Kuufameera",
    remove: "Haqi",
    // Common
    jobs: "Hojii",
    search: "Barbaadi",
    filter: "Filannoo",
    apply: "Iyyannaa galchi",
    company: "Dhaabbata",
    salary: "Mindaa",
    description: "Ibsa",
    requirements: "Ulaagaalee",
    // Hero Section
    heroBadge: "🚀 Waltajjii Hojii #1 Itiyoophiyaa",
    heroSubtitle:
      "Waltajjii Hojii Dura Itiyoophiyaa - Dandeettii fi Carraa Walitti Fiduu",
    heroDescription:
      "Dhaabbilee dura 500+ waliin wal qunnamuu fi Itiyoophiyaa keessatti carraa 10,000+ qoradhaa.",
    getStartedFree: "Bilisa Ta'een Jalqabi",
    getItOnGooglePlay: "Argadhu irraa",
    googlePlay: "Google Play",
    searchJobsPlaceholder: "Hojii, dhaabbilee ykn jecha ijoo barbaadi",
    trendingTags: "Trending keessa:",
    remoteWork: "Hojii Fagoo",
    techJobs: "Hojii Teknooloojii",
    marketing: "Gabaa",
    sales: "Gurgurtaa",
    engineering: "Injinariingii",
    statsJobs: "Hojii",
    statsCompanies: "Dhaabbilee",
    statsProfessionals: "Ogeeyyii",
    telegramChannelsTitle: "📢 Chaanalii Hojii Telegram",
    telegramChannelsSubtitle:
      "Ergaa hojii haaraa chaanalii mirkaneeffaman irraa hordofaa",
    viewChannel: "Chaanalii ilaali",
    categoriesTitle: "🎯 Gosa Gosinaan Qoradhaa",
    categoriesSubtitle: "Carraa damee keessan keessatti argadhaa",
    viewAllCategories: "Gosa Hunda Ilaali",
    featuredCompaniesTitle: "🏢 Dhaabbilee Filataman",
    featuredCompaniesSubtitle: "Qacartoota gurguddoo ammaa qaxaraa jiran",
    viewAllCompanies: "Dhaabbilee Hunda Ilaali",
    openPositions: "Bakka Banaa",
    whyChooseTitle: "Maaliif NibJobs Filatta?",
    whyChooseSubtitle: "Hiriyaa amanamaa guddina hojii keessanii",
    verifiedJobsTitle: "Hojii Mirkaneeffame",
    verifiedJobsDesc: "Ergaan hojii hunduu dhugummaaf mirkaneeffameera",
    multiChannelTitle: "Maddoota Hedduu",
    multiChannelDesc:
      "Hojii chaanalii Telegram fi qacartoota kallattiidhaan argadhaa",
    realTimeTitle: "Fooyya'iinsa Yeroo-Dhugaa",
    realTimeDesc: "Carraa haaraaf beeksisa saffisaa argadhaa",
    easyApplicationTitle: "Iyyannaa Salphaa",
    easyApplicationDesc: "Ibsa tokkoon hojii hedduuf iyyannoo galchaa",
    readyToStartTitle: "Imala Kee Jalqabuuf Qophii Dha?",
    readyToStartDesc:
      "Hojii abjuu isaanii argatan ogeeyyii kumaataman waliin makamaa",
    footerAbout: "Waa'ee NibJobs",
    footerAboutDesc:
      "NibJobs waltajjii hojii dura Itiyoophiyaa, ogeeyyii dandeettii qaban qacartoota gurguddoo waliin biyya keessatti walitti fida.",
    footerJobSeekers: "Barbaadtoota Hojiif",
    footerQuickLinks: "Geessituuwwan Saffisaa",
    footerBrowseJobs: "Hojii Qoradhaa",
    footerJobAlerts: "Beeksisa Hojii",
    footerCareerAdvice: "Gorsa Carraa",
    footerResumeTips: "Gorsawwan Resume",
    footerCompanies: "Dhaabbilee",
    footerCategories: "Gosaalee",
    footerTelegram: "Chaanalii Telegram",
    footerForEmployers: "Qacartootaaf",
    footerPostJob: "Hojii Maxxansaa",
    footerEmployerDashboard: "Dashboard Qacaraa",
    footerPricing: "Gatii",
    footerRecruitmentTips: "Gorsawwan Qacarsiisaa",
    footerCompany: "Dhaabbata",
    footerContact: "Nu Quunnamaa",
    footerPrivacy: "Imaammata Dhuunfaa",
    footerTerms: "Waliigaltee Tajaajila",
    footerSupport: "Deggara",
    footerHelpCenter: "Giddugala Gargaarsa",
    footerContactUs: "Nu Quunnamaa",
    footerFAQ: "Gaaffii Yeroo Hedduu Gaafataman",
    footerCopyright: "© 2025 NibJobs. Mirga hunda ni eegama.",
    footerPrivacyShort: "Icciitii",
    footerTermsShort: "Waliigaltee",
    footerCookies: "Kuukii",
    footerPricingPlans: "Karooraa Gatii",
    home: "Mana",
    allJobs: "Hojii Hunda",
    channels: "Chaanalota",
    more: "Dabalataa",
    // About Us Section
    aboutUsLabel: "Waa'ee Keenya",
    aboutUsTitle: "Waa'ee NibJobs",
    aboutUsSubtitle: "Dandeettii Itiyoophiyaa Carraa waliin walitti Fiduu",
    aboutUsDesc:
      "NibJobs waltajjii hojii dura Itiyoophiyaa, ogeeyyii dandeettii qaban fi carraa hojii hawwataa biyya keessatti walitti fiduuf kan kaa'ate dha.",
    topCompanies: "Dhaabbilee Gurguddoo",
    topCompaniesDesc:
      "Qacartoota dura industirii garaagaraa keessatti argaman waliin wal qunnamaa",
    instantAlerts: "Beeksisa Saffisaa",
    instantAlertsDesc:
      "Hojiin wal-qabataa yeroo maxxanfamu battalumatti beeksisa argadhu",
    multilingual: "Afaan Hedduu",
    multilingualDesc:
      "Afaan Ingilizii, Amaariffaa, Tigrinya fi Afaan Oromootiin ni argama",
    // Opportunities Section
    latestOpportunities: "Carraa Haaraa",
    latestOpportunitiesSubtitle: "Hojiin har'a maxxanfame",
    viewAllJobs: "Hojii Hunda Ilaali",
    // How It Works Section
    processLabel: "Adeemsa",
    howItWorksTitle: "Akkamitti Hojjeta",
    howItWorksSubtitle: "Tartiiba salphaa 3tiin qacaramaa",
    step1: "Barbaadi",
    step1Desc:
      "Itiyoophiyaa keessatti dhaabbilee mirkaneeffaman irraa hojii kumaatamaan lakkaa'aman qoradhaa",
    step2: "Iyyannoo Galchi",
    step2Desc: "Ibsa kee fayyadamuun iyyannoo kee tuqaatuma tokkoon galchi",
    step3: "Qacaramaa",
    step3Desc: "Qacartoota waliin wal qunnamuu fi hojii abjuu kee argadhu",
    // Popular Categories Section
    popularCategoriesLabel: "Gosaalee",
    popularCategoriesTitle: "Gosaalee Jaallatamoo",
    popularCategoriesSubtitle: "Carraa damee gosinaan qoradhaa",
    // Success Stories Section
    storiesLabel: "Seenaa",
    successStoriesTitle: "Seenaa Milkaa'inaa",
    successStoriesSubtitle: "Namoonni dhugaa, NibJobs waliin milkaa'ina dhugaa",
    readMore: "Dabalataan Dubbisi",
    // Plans Section
    plansLabel: "Karooraalee",
    chooseYourPlan: "Karooraa Kee Filadhu",
    chooseYourPlanSubtitle: "Fedhii keetiif karooraa sirrii filadhu",
    free: "Bilisa",
    premium: "Piriimiiyeemii",
    enterprise: "Intarpiraayizii",
    perMonth: "/ji'a",
    mostPopular: "Baay'ee Jaallatamaa",
    getStarted: "Jalqabi",
    contactUs: "Nu Quunnamaa",
    // Never Miss Section
    neverMissLabel: "Galmaa'uu",
    neverMissTitle: "Carraa Tokko Hin Dhabin",
    neverMissSubtitle:
      "Beeksisa hojii kallattiidhaan gara imeelii keetti argadhu",
    emailPlaceholder: "Imeelii kee galchi",
    subscribe: "Galmaa'i",
    // Login Page
    loginTagline:
      "Dandeettii carraalee waliin wal qunnamsiisu, Platform hojii duraa Itoophiyaa",
    loginActiveJobsLabel: "Hojiilee 10,000+ Banaa",
    loginActiveJobsDesc: "Carraalee filataman",
    loginTopCompaniesLabel: "Dhaabbilee 500+ Gurguddoo",
    loginTopCompaniesDesc: "Qacartoota dursaa",
    loginInstantAlertsLabel: "Beeksisa Saffisaa",
    loginInstantAlertsDesc: "Carraa tokko hin dhabin",
    // FAQ Section
    faqLabel: "Gaaffii Yeroo Hedduu Gaafataman",
    faqTitle: "Gaaffii Yeroo Hedduu Gaafataman",
    faqSubtitle: "Waa'ee NibJobs gaaffii beekamoo ta'aniif deebii argadhu",
    faq1Q: "NibJobs bilisaan ni argama?",
    faq1A:
      "Eeyyee! Barbaadtonni hojii hojii bilisaan ilaaluu fi itti dhiyeessuu ni danda'u. Akkasumas mul'ina fooyya'aa ta'eef amaloota premium ni kennina.",
    faq2Q: "Hojii akkamittan itti dhiyeessuu danda'a?",
    faq2A:
      "Salphaatti account uumuu, profile kee xumurii fi tarree hojii kamiyyuu irratti 'Apply' jechuun cuqaasi. Hojiin tokko tokko gara fuula application dhaabbatichaa si geessuu danda'a.",
    faq3Q: "Yeroo hammamitti hojiin haaraan maxxanfama?",
    faq3A:
      "Hojiin haaraan guyyaa guyyaan ni maxxanfama! Bakka filannoo kee wajjin walsimu yommuu argamu beeksisa argachuuf job alerts bansiisi.",
    faq4Q: "Hojii booda'atti ol kaa'uu nan danda'aa?",
    faq4A:
      "Eeyyee! Tarree hojii kamiyyuu irratti icon bookmark cuqaasuun gara filannoo keetti ol kaa'i. Hojii ol ka'e yeroo kamiyyuu profile kee irraa qaqqabadhu.",
    // Resume Tips
    resumeTipsTitle: "Gorsawwan Resume",
    resumeTipsHero: "Resume Adda Ta'e Uumi",
    resumeTipsHeroDesc: "Resume xiyyeeffannoo argatu uumuuf qajeelfama ogummaa",
    resumeFormatting: "Bifa Resume",
    resumeFormattingText:
      "• Teessuma qulqulluu fi ogummaa fayyadami\n• Gabaabaa ta'uu qaba (fuula 1-2 hin caalu)\n• Bifa fi qubee walsimaa fayyadami\n• Odeeffannoo quunnamtii sirrii hammatii\n• Walsimummaa hundaaf akka PDF olkaa'i",
    resumeKeySections: "Kutaalee Ijoo",
    resumeKeySectionsText:
      "Cuunfaa Ogummaa: Muuxannoo fi galma hojii kee gabaabduu ibsi\n\nMuuxannoo Hojii: Sadarkaa bu'aa safaramuu danda'u qabu tarreessi\n\nBarnoota: Digrii, ragaa fi barnoota walsimu hammatii\n\nDandeettii: Dandeettii tekinikaalaa fi lallaafaa lachuu calaqqisiisi\n\nMilkaa'ina: Badhaasa, beekamtii fi milkaa'ina beekamaa agarsiisi",
    resumeWritingTips: "Gorsawwan Barreeffamaa",
    resumeWritingTipsText:
      "• Gochawwan gochaa fayyadami (galmeesse, bulche, hojjete, hoogganee)\n• Milkaa'ina lakkoofsa fi safartuuwwan safari\n• Iyyata hojii hundaaf resume kee sirreessi\n• Dogoggora of eeggannoodhaan mirkaneessi\n• Afaan ogummaa fi gabaabaa akka ta'u godhi",
    resumeMistakes: "Dogoggora Beekamoo Irraa Fagaachuu Qabdu",
    resumeMistakesText:
      "✗ Odeeffannoo dhuunfaa barbaachisaa hin taane hammatuu\n✗ Teessoo email ogummaa hin qabne fayyadamuu\n✗ Milkaa'ina osoo hin taane hojii tarreessuu\n✗ Dogoggora qubee ykn caasimaa qabaachuu\n✗ Resume waliigalaa, hundaaf simannaa tokko fayyadamuu",
    uploadResume: "Resume Kee Ol Kaa'i",
    // Login Screen
    signInTitle: "Baga Nagaan Dhuftan",
    signInSubtitle: "Gara herrega keessaniitti seenaa",
    emailAddress: "Teessoo Email",
    forgotPassword: "Jecha Icciitii Irraanfattan?",
    signInButton: "Seeni",
    signingIn: "Seenaa jira...",
    orContinueWith: "Yookaan itti fufaa waliin",
    signInWithGoogle: "Google waliin seeni",
    dontHaveAccount: "Herrega hin qabdu? ",
    signUpLink: "Galmaa'aa",
    backToHome: "Gara Manaatti Deebi'i",
    // Signup Screen
    createAccountTitle: "Herrega Uumaa",
    createAccountSubtitle:
      "NibJobs irratti makamaa hojii abjuu keessan argadhaa",
    joinMessage:
      "Amaloota mara argachuuf mee galmaa'aa fi gara addunyaa carraa hojiitti makamaa.",
    fullName: "Maqaa Guutuu",
    confirmPassword: "Jecha Icciitii Mirkaneessi",
    createAccount: "Herrega Uumaa",
    creatingAccount: "Herrega uumaa jira...",
    alreadyHaveAccount: "Duraan herrega qabduu? ",
    signInLink: "Seeni",
    // Verification
    checkYourEmail: "Email Keessan Mirkaneessaa",
    verificationSent: "Email Mirkaneessaa Ergameera!",
    verificationMessage:
      "Email mirkaneessaa gara herrega keessaniitti ergameera. Mee email keessan mirkaneessaatii link mirkaneessaa cuqaasaa.",
    verificationEmail: "teessoo email",
    goToLogin: "Gara Seenaa Deemaa",
    // Errors
    fillAllFields: "Mee bakkoota hunda guutaa",
    passwordsDontMatch: "Jecha icciitiin wal hin simu",
    passwordTooShort: "Jecha icciitii yoo xiqqaate qubee 6 ta'uu qaba",
    emailInUse: "Email kun duraan galmeeffameera",
    invalidEmail: "Teessoo email sirrii miti",
    weakPassword: "Jecha icciitii baay'ee dadhabaa dha",
    accountExists: "Herregni email kanaan duraan jira",
    signupFailed: "Galmaa'uun hin milkoofne. Mee irra deebi'ii yaali.",
    loginFailed: "Seenuun hin milkoofne. Mee ragaa keessan mirkaneessaa.",
    // Pricing Section
    popularBadge: "Beekamaa",
    perYear: "/waggaa",
    orYearly: "yookaan",
    choosePlan: "Karoora Filadhaa",
    freePlanDesc: "Jalqabuuf ga'aa",
    standardPlanDesc: "Barbaachitoota hojii sochii qabuuf filatamaa",
    proName: "Proo",
    proPlanDesc: "Garee guddataa fi ogeeyyii hawwii qabaniif",
    enterprisePlanDesc: "Qacartoota hojii fi qacarsiisotaaf",
    freeFeature1:
      "Guyyaa guyyaan beeksisa hojii dhuunfaa 3 appii mobaayilaa irratti",
    freeFeature2: "Barbaachaa fi sakatta'insa hojii bu'uraa",
    freeFeature3: "Beeksisa hojii maxxansuu hin danda'amu",
    freeFeature4: "Guyyaa guyyaan beeksisa 3 qofa irratti daangeffame",
    standardFeature1: "Guyyaa guyyaan hanga beeksisa hojii dhuunfaa 50",
    standardFeature2: "Bu'aa barbaachaa keessatti dura ta'uu",
    standardFeature3: "Filannoo calalchiisaa ol'aanaa",
    standardFeature4: "Mul'ina resume guddisuu",
    standardFeature5: "Beeksisa hojii maxxansuu hin danda'amu",
    proFeature1: "Beeksisa hojii daangaa hin qabne maxxansaa",
    proFeature2: "Resume fudhachuun bulchaa",
    proFeature3: "Istaatistiksii gabaa hojii bal'aa",
    proFeature4: "Sirna hordoffii iyyattoota",
    proFeature5: "Maqaa daldalaatii fi agarsiisa asxaa",
    proFeature6: "Bakka hojii adda ta'e",
    proFeature7: "Deeggarsa dura ta'ee fi bulchaa herregaa",
    enterpriseFeature1: "Beeksisa hojii daangaa hin qabne maxxansaa",
    enterpriseFeature2: "Resume fudhachuun bulchaa",
    enterpriseFeature3: "Istaatistiksii gabaa hojii bal'aa",
    enterpriseFeature4: "Sirna hordoffii iyyattoota",
    enterpriseFeature5: "Maqaa daldalaatii fi agarsiisa asxaa",
    enterpriseFeature6: "Bakka hojii adda ta'e",
    enterpriseFeature7: "Deeggarsa dura ta'ee fi bulchaa herregaa",
    privacyTitle: "Imaammata Icciitii",
    lastUpdated: "Yeroo dhumaa haaromfame:",
    privacySection1Title: "1. Odeeffannoo Walitti Qabnu",
    privacySection1Text:
      "NibJobs fayyadamuu keessan irratti kallattiin nuu kennitan odeeffannoo walitti qabna. Kunis maqaa keessan, teessoo email keessan, lakkoofsa bilbilaa keessan, resume fi filannoo hojii keessanii of keessaa qaba. Akkasumas fayyadama application keessanii fi hojiiwwan ilaaltanii fi itti iyyattan odeeffannoo walitti qabna.",
    privacySection2Title: "2. Odeeffannoo Keessan Akkamitti Fayyadamna",
    privacySection2Text:
      "Odeeffannoo walitti qabnu tajaajila keenya kennuuf, kunuunsuuf fi fooyyessuuf fayyadamna. Kunis carraa hojii barbaachisaa ta'e waliin isin wal qunnamsiisuu, waa'ee hojiiwwanii fi tajaajila keenyaa isinitti himuun, akkasumas muuxannoo fayyadamtootaa fooyyessuuf akkaataa fayyadama xiinxaluun of keessaa qaba.",
    privacySection3Title: "3. Odeeffannoo Qooduun",
    privacySection3Text:
      "Beeksisa hojii isaanii itti iyyattan odeeffannoo keessan ergiftoota hojii waliin qoodna. Odeeffannoo dhuunfaa keessan namoota sadaffaaf hin gurgurru. Odeeffannoo walitti qabame, kan dhuunfaan hin beekamne kan hiriyootaafi tajaajiltoota waltajjii keenya hojjechuuf nu gargaaran waliin qooduu nidandeenya.",
    privacySection4Title: "4. Nageenya Deetaa",
    privacySection4Text:
      "Odeeffannoo dhuunfaa keessan seensa hin hayyamne, jijjiirama, ibsaa fi balleessuu irraa eeguuf tarkaanfiiwwan nageenyaa teeknikaa fi gurmaa'inaa barbaachisoo ta'an hojiirra oolchina. Haa ta'u malee, dabarsa interneetii guutummaan guututti nageenya qabu hin jiru, nageenyaa guutuu mirkaneessuu hin dandeenyu.",
    privacySection5Title: "5. Mirga Keessan",
    privacySection5Text:
      "Yeroo kamuu settings account keessan keessatti odeeffannoo dhuunfaa keessan argachuu, haaromsuun ykn haquuf mirga qabdu. Akkasumas qunnamtii muraasa irraa ba'uu dandeessu. Waa'ee odeeffannoo keessan akkamitti akka qabnu yaaddoo yoo qabdan, mee nu quunnamaa.",
    privacySection6Title: "6. Nu Quunnamaa",
    privacySection6Text:
      "Waa'ee Imaammata Icciitii kanaa ykn amala deetaa keenyaa gaaffii kamiyyuu yoo qabdan, mee privacy@nibjobs.com irratti nu quunnamaa. Gaaffii keessaniif dafanii deebii kennina.",
    // Additional Home Page Texts
    categoriesLabel: "Ramaddii",
    testimonialsLabel: "Ragaalee",
    pricingPlansLabel: "Karoora Gatii",
    faqLabel2: "Gaaffii Yeroo Baay'ee Gaafataman",
    jobsText: "hojii",
    viewAllJobsButton: "Hojii Hunda Ilaali",
    loginAndViewMore: "Seenuudhaan Hojii Dabalataa Ilaali",
    loadingJobs: "Hojii fe'aa jira...",
    manageAlerts: "Beeksisawwan Bulchi",
    signUpForAlerts: "Beeksisawwaniif Galmaa'i",
    signUpToAccessAll:
      "Amaloota hunda argachuu fi hojii hunda ilaaluuf maaloo galmaa'aa. Galmaa'uun guutummaan guutuutti bilisa!",
    signUpForJobAlerts:
      "Beeksisa hojii dhuunfaaf mijataa ta'e argachuuf galmaa'aa!",
    playStoreDownload: "Google Play",
    getItOn: "IRRATTI ARGADHU",
    // Auth Screen (Oromifa)
    resetPassword: "Jecha Icciitii Haaressi",
    resetPasswordSubtitle:
      "Teessoo email kee galchi, link jecha icciitii haaressuuf erguuf",
    sendResetLink: "Hidhaa Haaressa Ergi",
    sendingReset: "Ergama jira...",
    backToLogin: "Gara Seenaa Deebi'i",
    forgotTagline: "Yaaddoo hin qabaatin — namoota hundaanuu ta'a.",
    forgotSecureReset: "Jecha icciitii nagaan haaressa",
    forgotCheckInbox: "Kaartaa fuundura kee ilaali",
    forgotAccountSafe: "Herrega kee nagaa dha",
    signupTagline:
      "Ogeeyyii kuma hedduutti makamu, hojii hawwii isaanii Itoophiyaa keessatti argatan.",
    signupThousandsJobs: "Maxxansaalee hojii kuma heddu",
    signupInstantAlerts: "Beeksisa hojii saffisaa",
    signupVerifiedEmployers: "Qacartoota mirkaneeffaman qofa",
    emailSentTitle: "Email Ergameera!",
    resetSentTo: "Hidhaa jecha icciitii haaressuuf gara",
    checkInboxForReset:
      "Kaartaa fuundura kee kunuunsi hidhaa cuqaasitii jecha icciitii haaressi.",
    enterEmailError: "Teessoo email kee galchi",
    noAccountFoundError: "Herrega email kanaan hin argamne",
    resetEmailFailedError:
      "Email haaressa erguun hin milkoofne. Irra deebi'ii yaali.",
    verificationLinkSentTo: "Hidhaa mirkaneessaa gara",
    emailStep1Title: "Email Keessan Ilaali",
    emailStep1Desc: "Hidhaa mirkaneessaa email keessanitti ergineerra",
    emailStep2Title: "Hidhaa Cuqaasi",
    emailStep2Desc: "Hidhaa mirkaneessaa email keessaa cuqaasi",
    emailStep3Title: "Qorachuu Jalqabi",
    emailStep3Desc: "Seeni hojii abjuu kee argadhu!",
    browseJobs: "Hojii Qori",
    passwordStrength: "Jabina jecha icciitii",
    passwordsMatch: "\u2713 Jechoonni icciitii walsimu",
    passwordStrengthWeak: "Laafaa",
    passwordStrengthStrong: "Jabaa",
    passwordStrengthVeryStrong: "Baay'ee Jabaa",
    fullNameRequired: "Maqaa guutuu barbaachisaa dha",
    passwordsDoNotMatch: "Jechoonni icciitii wal hin simu",
    // Settings Page (Oromifa)
    settingsAccountSection: "Herrega",
    settingsPreferencesSection: "Filannoo",
    settingsAccountActionsSection: "Hojiiwwan Herregaa",
    settingsPortfolioLabel: "Portfolio",
    settingsPortfolioSubtitle: "CV, dandeettii & muuxannoo",
    settingsAccountSubtitle: "Profile & nageenya",
    settingsJobInterestsLabel: "Fedhii Hojii",
    settingsJobInterestsSubtitle: "Kutaawwan & filannoo",
    settingsPreferencesSubtitle: "Fakkaataa & afaan",
    settingsNotificationsSubtitle: "Beeksisawwan bulchi",
    settingsPrivacyLabel: "Dhuunfaa & Nageenya",
    settingsPrivacySubtitle: "Daataa & hayyama",
    settingsSubscriptionLabel: "Subscription",
    settingsHelpLabel: "Gargaarsa & Deggeersa",
    settingsHelpSubtitle: "Gaaffii & qunnamtii",
    settingsLogoutSubtitle: "Herreega kee keessaa ba'i",
    editProfileButton: "Profile Gulaali",
    editChipLabel: "Gulaali",
    jobSeekerLabel: "Hojii Barbaadu",
    savedJobsCount: "kuufame",
    personalInfoSection: "Odeeffannoo Dhuunfaa",
    displayNameLabel: "Maqaa",
    displayNamePlaceholder: "Maqaa guutuu kee",
    usernameLabel: "Maqaa Fayyadamaa",
    checkingAvailability: "Ilaalaa jira...",
    usernameAvailableText: "\u2713 Argama",
    usernameTakenText: "\u2717 Fudhatame",
    dateOfBirthLabel: "Guyyaa Dhalootaa",
    bioLabel: "Bio",
    bioPlaceholder: "Ergamtootaaf of himi...",
    contactSection: "Qunnamtii",
    phoneNumberLabel: "Lakkoofsa Bilbilaa",
    socialLinksSection: "Bakka Marsaalee Hawaasaa",
    addCoverPhotoLabel: "Suuraa Haguugaa Dabalee",
    changeCoverPhotoLabel: "Jijjiiri",
    savingText: "Kuufama jira...",
    saveChangesLabel: "Jijjiirama Kuufi",
    profileLinkSection: "Hidhaa Profile",
    copyLinkLabel: "Hidhaa Copy Godhi",
    previewLabel: "Ilaalbi",
    cvResumeSection: "CV / Resume",
    cvUploadedText: "CV fe'ameera",
    cvPdfDocLabel: "PDF / DOC",
    cvUploadButton: "CV Fe'i",
    cvUploadingText: "Fe'amaa jira\u2026",
    cvReplaceButton: "Bakka Bu'i",
    professionalInfoSection: "Odeeffannoo Ogummaa",
    jobTitleLabel: "Maqaa Hojii",
    yearsOfExperienceLabel: "Waggaalee Muuxannoo",
    aboutSection: "Waa'ee",
    skillsLabel: "Dandeettii",
    educationLabel: "Barnootaa",
    keyAchievementsLabel: "Firii Guddaa",
    linksSection: "Hidhaalee",
    portfolioWebsiteLabel: "Marsariitii Portfolio",
    savePortfolioButton: "Portfolio Kuufi",
    profilePreviewTitle: "Ilaalbi Profile",
    asSeenByOthers: "Akka waan namooti argu",
    appearanceSection: "Fakkaataa",
    darkModeEnabled: "Haala dukkana banameera",
    lightModeEnabled: "Haala iftii banameera",
    emailNotificationsLabel: "Beeksisa Email",
    emailNotificationsSubtitle: "Haaroomsawwan email dhaan fudhadhu",
    pushNotificationsLabel: "Beeksisa Push",
    pushNotificationsSubtitle: "Beeksisa hatattamaa fudhadhu",
    jobAlertsLabel: "Beeksisa Hojii",
    jobAlertsSubtitle: "Hojii fedhii keetiin wal simuu haaraa",
    applicationUpdatesLabel: "Haaroomsa Iyyata",
    applicationUpdatesSubtitle: "Jijjiiramawwan iyyata kee irratti",
    profileVisibilitySection: "Mul'ina Profile",
    visibilityPublic: "Hayyama",
    visibilityPublicSubtitle: "Namni kamiyyuu profile kee arguu danda'a",
    visibilityConnectionsOnly: "Walqunnamtii Qofaa",
    visibilityConnectionsOnlySubtitle: "Walqunnamtiin qofaa arguu danda'u",
    visibilityPrivate: "Dhuunfaa",
    visibilityPrivateSubtitle: "Profile kee namoota biraa irraa dhokfama",
    contactMessagingSection: "Qunnamtii & Ergaa",
    showEmailLabel: "Email Agarsiisi",
    showEmailSubtitle: "Email kee profile irratti agarsiisi",
    allowMessagingLabel: "Ergaa Hayyami",
    allowMessagingSubtitle: "Ergamtootni ergaa siif erguu danda'u",
    interestsHintText:
      "Gorsa hojii siif ifteessuuf kutaa 1, hunda'oota xixiqqoo, maakiiwwan filaa",
    yourInterestsSection: "Fedhiiwwan Kee",
    categoryLabel: "Kutaa",
    subcategoriesLabel: "Hunda'oota Xixiqqoo",
    tagsLabel: "Maakiiwwan",
    subcategoriesSection: "Hunda'oota Xixiqqoo",
    saveJobInterestsButton: "Fedhii Hojii Kuufi",
    faqsMenuTitle: "Gaaffii Yeroo Yeroo",
    faqsMenuSubtitle: "Gaaffii dansaan deebi'e",
    contactSupportTitle: "Deggeersa Argadhu",
    contactSupportSubtitle: "Gargaarsa gareen kee",
    sendFeedbackTitle: "Yaada Ergi",
    sendFeedbackSubtitle: "Fooyyessuuf gargaari",
    privacyPolicySubtitle: "Akka daataa kee tiikfinu",
    termsOfServiceSubtitle: "Heerota fayyadama keenyaa",
    needImmediateHelpText: "Gargaarsa hatattamaa barbaaddaa?",
    frequentlyAskedQuestionsLabel: "Gaaffii Yeroo Yeroo",
    stillHaveQuestionsText: "Gaaffiin kee jiraa?",
    messageSectionHeader: "Ergaa",
    subjectFieldLabel: "Mata Duree",
    subjectFieldPlaceholder: "Waa'ee maalii gargaaruuf ni dandeenya?",
    messageFieldPlaceholder: "Rakkoo ykn gaaffii kee gadi fageessii...",
    sendingText: "Ergama jira...",
    sendMessageButton: "Ergaa Ergi",
    otherWaysToReachLabel: "Karaalee Biroo Quunnamuuf",
    messageSentText: "Ergaan ergameera!",
    messageReplyTimeText: "Sa'aatii 24\u201348 keessatti deebi'a kenninaa.",
    supportHoursLabel: "Sa'aatii Deggeersaa",
    supportHoursText:
      "Wiixata\u2013Jimaata, 9 dura guyyaa \u2013 6 booda guyyaa EAT",
    accountSettingsTitle: "Qindaa'ina Herregaa",
    // Help FAQs
    helpFaq1Q: "Akkamittan herrega uumuu danda'a?",
    helpFaq1A:
      "Giddugaleettii mirgaa irratti \"Galmaa'i\" cuqaasuun gubbuu kee guuti. Galmaa'insa hatattamaa ta'eef herrega Google-tiin galmaa'uus ni danda'ita.",
    helpFaq2Q: "Hojii akkamittan itti dhiyeessuu danda'a?",
    helpFaq2A:
      'Tarree hojii ilaali, hojii si hawwatu cuqaasi, "Apply" jedhu cuqaasi. Hojii dhiyeessuuf dura profile fi CV kee haaromsi.',
    helpFaq3Q: "Dhiyeessuu booda iyyaata koo jijjiiruun ni danda'amaa?",
    helpFaq3A:
      "Erga dhiyeesseen iyyaatni jijjiiramuu hin danda'u. Dhiyeessuuf dura odeeffannoon hundi sirri ta'uu isaa mirkaneeffadhu. Iyyaata kee haaromsuuf qaccaraan si quunnamuu ni danda'a.",
    helpFaq4Q: "CV koo akkamittan fe'uu danda'a?",
    helpFaq4A:
      "Settings > Portfolio dhaqii \"CV Fe'i\" cuqaasi. PDF, DOC ykn DOCX faayilii hanga 5MB fe'uu ni danda'ita.",
    helpFaq5Q: "Karoora miseensummaa maaltu jira?",
    helpFaq5A:
      "Bilisaa, Idilee, fi Enterprise karoorota ni kennina. Amaloota fi gatii jijjiiramaan ilaaluuf Settings > Miseensummaa daawwadhu.",
    helpFaq6Q: "Miseensummaa koo akkamittan haquun danda'a?",
    helpFaq6A:
      'Settings > Miseensummaa dhaqii "Miseensummaa Bulchi" cuqaasi. Miseensummaa kee yeroo barbaaddetti haquu ni danda\'ita.',
    helpFaq7Q: "Beeksisni hojii akkamitti hojjata?",
    helpFaq7A:
      "Beeksisni hojii sirna kee wajjin wal simu yommuu maxxanfamu si beeksisa. Settings > Beeksisawwan keessatti filannoo kee qopheessi.",
    helpFaq8Q: "Hojii booda'aaf ol kaa'uu nan danda'aa?",
    helpFaq8A:
      "Eeyyee! Tarree hojii kamiyyuu irratti icon bookmark cuqaasi. Hojii ol ka'e gara Bookmarks imaluun argadhu.",
    helpFaq9Q: "Filannoo afaanii koo akkamittan jijjiiruu danda'a?",
    helpFaq9A:
      "Settings > Filannoo dhaqii afaan barbaaddu fili. Afaan Inglizii, Amaaric, Tigrinya, fi Oromifaa ni deeggartu.",
    helpFaq10Q: "Daataan koo nageenya qabeessaa?",
    helpFaq10A:
      "Eeyyee, nageenyi daataa nu biratti murteessaadha. Odeeffannoon dhuunfaa hundi icciitiin tiksame jira. Bal'inaan Imaammata Dhuunfaa dubbisi.",
    // Feedback form
    feedbackCategoryLabel: "Kutaa",
    feedbackRatingLabel: "Gatii (dirqama miti)",
    yourFeedbackLabel: "Yaada Kee",
    feedbackPlaceholder: "Waa yaaddu nuuf himi...",
    submitFeedbackButton: "Yaada Dhiyeessi",
    submittingText: "Dhiyeessama jira...",
    feedbackSubmittedTitle: "Yaadi dhiyeeffameera!",
    feedbackThankYouText: "NibJobs fooyyessuuf yaada kee ergiteef galatoomaa.",
    feedbackErrorText: "Maaloo kutaa fili fi yaada kee kenni",
    messageSendFailed:
      "Ergaa erguu hin dandeenye. Maaloo irra deebi'aa yaalaa ykn kallattiidhaan support@nibjobs.com irratti nu quunnamaa",
    feedbackSubmitFailed:
      "Yaada galchuun hin milkoofne. Maaloo irra deebi'aa yaalaa.",
    feedbackCategoryFeatureRequest: "Gaaffii Amaloota",
    feedbackCategoryBugReport: "Gabaasa Dogoggora",
    feedbackCategoryUserExperience: "Muuxannoo Fayyadamaa",
    feedbackCategoryPerformance: "Raawwii",
    feedbackCategoryOther: "Biraa",
    // Contact form
    fullNamePlaceholder: "Maqaa guutuu kee galchi",
    privacyPolicy: "Imaammata Dhuunfaa",
    termsOfService: "Waliigaltee Tajaajila",
    // Subscription / Pick a plan page
    pickAPlan: "Karoora filadhu",
    upgradeAnytimeCancelAnytime:
      "Yeroo kamiyyuu foddadhu · Yeroo kamiyyuu haquu",
    billingMonthly: "Ji'ootiin",
    billingYearly: "Waggootiin",
    loadingPlans: "Karoori ni fe'ama…",
    planActiveBadge: "Hojjachaa jira",
    planPopularBadge: "Beekamaa",
    planPriceFree: "Bilisaan",
    planPricePerMo: "/ji'a",
    planPricePerYr: "/Waggaa",
    planSavesPercent: "Ji'ootiin walbiratti {percent}% qusata",
    planCurrentPlanCta: "Karoora ammaa",
    planSwitchToFree: "Gara bilisaatti jijjiiri",
    planGetName: "{name} argadhu",
    planSecureCheckout: "Kaffalee nageenya qabu",
    planCancelAnytime: "Yeroo kamiyyuu haquu",
    plan247Support: "Gargaarsa 24/7",
    loginRequiredTitle: "Seenuu Barbaachisa",
    loginRequiredMessage: "Karoora miseensummaa foyyeessuuf maaloo seeni.",
    downgradeToFreeTitle: "Gara Bilisaatti Gad Buusuu",
    downgradeToFreeMessage: "Gara karoora bilisaatti jijjiiruu barbaaddaa?",
    planSwitchedToFree: "Gara karoora bilisaatti jijjiirameera",
    planFailedToSwitch: "Karoora jijjiiruun hin milkoofne",
    cancelButton: "Haquu",
    confirmButton: "Mirkaneessi",
    successTitle: "Milkaa'e",
    errorTitle: "Dogoggora",
    // Bottom nav labels
    navJobs: "Hojii",
    navSaved: "Olkaayame",
    navAlerts: "Beeksisawwan",
    newLabel: "haaraa",
    markAllRead: "Hunda dubbifame jedhiitu",
    noNotificationsTitle: "Beeksisni hin jiru",
    noNotificationsDesc: "Wanti haaraan yommuu dhufu si beeksifna.",
    viewAllNotifications: "Beeksisawwan hunda ilaali",
    navProfile: "Profile",
    navDashboard: "Dashboard",
    // Toolbar
    lightMode: "Haala Iftii",
    // Terms of Service body
    termsSection1Title: "1. Waliigalteewwan Fudhachuu",
    termsSection1Text:
      "NibJobs irra qaqqabuudhaan fi fayyadamuudhaan, Waliigalteewwan Tajaajila kana fudhachuudhaan walitti galtee akka qabdu ni mirkaneessita. Waliigalteewwan kana waliin yoo hin walii hin galtiin, mee tajaajila keenya hin fayyadamin.",
    termsSection2Title: "2. Tajaajila Fayyadamuu",
    termsSection2Text:
      "NibJobs barbaadtoonni hojii carraa hojii argachuuf fi qacartoota maxxansa hojii baasiisuuf gargaaru waltajjii ni kenna. Tajaajila keenya kaayyoo seeraan ala hin taanef qofa fi waliigaltee kana waliin walsimuun fayyadamuu waliigaltuu.",
    termsSection3Title: "3. Herregaalee Fayyadamaa",
    termsSection3Text:
      "Icciitii ragaa herrega keessan tiiksuuf fi hojiileen hunda herrega keessan jalatti ta'aniif itti gaafatamaa dha. Herrega uumuu yeroo odeeffannoo sirrii fi guutuu kennuu qabdu.",
    termsSection4Title: "4. Qabiyyee fi Amalli",
    termsSection4Text:
      "NibJobs irratti maxxanfamtu qabiyyeef kophummaadhaan itti gaafatamaa ta'aa. Seeraan ala, miidhaadha, sodaachisaa, salphisaa, dubbii miidhaa ykn kkf hin ta'in qabiyyee maxxansuuf hin waliigaltu.",
    termsSection5Title: "5. Qabeenya Sammuu",
    termsSection5Text:
      "NibJobs irratti qabiyyee, amaloota fi hojiin hundi kan keenya ta'ee mirga maxxansa, mallattoo daldalaafi seeraalee qabeenya sammuu birootiin ni eegama.",
    termsSection6Title: "6. Itti Gaafatamummaa Daangaa",
    termsSection6Text:
      "NibJobs tajaajila keessan fayyadamuun madda ta'e miidhaadha kallattiin hin ta'in, yeroo sanatti, addaa, bu'aadha ykn adabbii kamiif itti gaafatamaa hin ta'u.",
    termsSection7Title: "7. Waliigalteewwan Jijjiiruu",
    termsSection7Text:
      "Waliigalteewwan yeroo kamiyyuu jijjiiruu mirga ni qabna. Jijjiirama guguddaa fayyadamtootaaf email ykn app dhaan beeksisna.",
    termsSection8Title: "8. Odeeffannoo Quunnamtii",
    termsSection8Text:
      "Waa'ee Waliigaltee Tajaajila kanaa gaaffii yoo qabdan, mee legal@nibjobs.com nu quunnamaa",
    // Company Dashboard
    cdDashboard: "Dashboard",
    cdAnalytics: "Xiinxala",
    cdJobPostings: "Maxxansa Hojii",
    cdApplications: "Iyyaannoolee",
    cdTalentPool: "Kuufama Dandeettii",
    cdCompanyProfile: "Profile Dhaabbataa",
    cdAccountSettings: "Qindaa'ina Herregaa",
    cdAnalyticsInsights: "Xiinxala fi beekumsa",
    cdManageYourJobs: "Hojiiwwan kee bulchi",
    cdReviewCandidates: "Dorgomtoota ilaalii",
    cdDiscoverTalent: "Dandeettii ol'aanaa argadhu",
    cdUpdateDetails: "Odeeffannoo haaromsi",
    cdLoadingDashboard: "Dashboard fe'aa jira...",
    cdOverview: "ILAALBI WALIIGALAA",
    cdHiring: "QACARAA",
    cdSettings: "QINDAA'INA",
    cdBrowseJobs: "Hojii Qori",
    cdSignOut: "Bahudu",
    cdVerified: "Mirkaneeffame",
    cdVerifiedCompany: "Dhaabbata Mirkaneeffame",
    cdVerificationRejected: "Mirkaneessaan Dideera",
    cdVerificationPending: "Mirkaneessaan Eegamaa",
    cdCompanyAccount: "Herrega Dhaabbataa",
    cdSwitchView: "Ilaalbi Jijjiiri",
    cdCandidateView: "Ilaalbi Dorgomtootaa",
    cdPostJob: "Hojii Maxxansi",
    cdActiveJobs: "Hojii Hojjatamaa",
    cdTotalApplicants: "Iyyattuu Waliigalaa",
    cdPendingReviews: "Ilaalbi Eegamaa",
    cdAvgPerJob: "Avg / Hojii",
    cdTotalJobs: "Hojii Waliigalaa",
    cdToReview: "Ilaaluf",
    cdReviewed: "Ilaalame",
    cdPending: "Eegamaa",
    cdTotal: "Waliigalaa",
    cdApplicationsPerPosting: "Iyyaannoo maxxansa tokkoof",
    cdStillActive: "Ammallee hojjatamaa",
    cdPendingApplications: "Iyyaannoo eegamaa",
    cdProcessedSoFar: "Hanga ammaa xumurameera",
    cdPostYourFirstJob: "Hojii Kee Jalqabaa Maxxansi",
    cdFirstJobDesc:
      "Maxxansa hojii jalqabaa kee uumuun ogeeyyii dandeettii qaban waliin wal qunnamii.",
    cdCreateJobPosting: "Maxxansa Hojii Uumaa",
    cdQuickActions: "Tarkaanfii Hatattamaa",
    cdApplicationPipeline: "Gurguddaa Iyyaannoo",
    cdPostNewJob: "Hojii Haaraa Maxxansi",
    cdViewApplications: "Iyyaannoolee Ilaali",
    cdBrowseCandidates: "Dorgomtoota Qori",
    cdEditProfile: "Profile Gulaali",
    cdLoadingApplications: "Iyyaannooleen ni fe'ama...",
    cdSearchApplications: "Maqaa, email, ykn maqaa hojiin barbaadi...",
    cdNoApplicationsFound: "Iyyaannooleen Hin Argamne",
    cdTryAdjustingFilters: "Calalchiisaawwan ykn gaaffii barbaachaa sirressi",
    cdApplicationsWillAppear:
      "Dorgomtoonni iyyannoo erguman iyyaannooleen mul'atu",
    cdShortlist: "Tarree Gabaabaa",
    cdReject: "Diduu",
    cdAccept: "Fudhachuu",
    cdViewDetails: "Odeeffannoo Bal'aa Ilaali",
    cdApplicationDetails: "Odeeffannoo Iyyaannoo",
    cdContactInfo: "Odeeffannoo Quunnamtii",
    cdApplicantInfo: "Odeeffannoo Iyyattuu",
    cdProfessionalOverview: "Cuunfaa Ogummaa",
    cdLoadingJobs: "Hojiin ni fe'ama...",
    cdManageJobListings: "Tarreewwan hojii hojjatamaa bulchi",
    cdCreateJob: "Hojii Uumaa",
    cdActive: "Hojjatamaa",
    cdPaused: "Dhaaabbate",
    cdNoJobsYet: "Hojiin Maxxanfame Hin Jiru",
    cdFirstJobPostingDesc:
      "Ogeeyyii dandeettii qaban hawwachuuf maxxansa hojii jalqabaa kee uumii.",
    cdCreateFirstJob: "Hojii Jalqabaa Kee Uumii",
    cdApplicants: "Iyyattootni",
    cdEditJobPosting: "Maxxansa Hojii Gulaalee",
    cdCreateNewJob: "Hojii Haaraa Uumii",
    cdUpdateJobDetails: "Odeeffannoo Maxxansa Hojii Haaromsi",
    cdFillNewOpening: "Bakki Hojii Haaraa Banaa Maxxansuuf Odeeffannoo Guuti",
    cdBasicInformation: "Odeeffannoo Bu'uuraa",
    cdJobTitle: "Maqaa Hojii",
    cdCategory: "Gosa",
    cdContractType: "Gosa Kontraataa",
    cdLocationCompensation: "Bakka fi Beenyaa",
    cdRemoteWorkAvailable: "Hojii Fagoo Ni Danda'ama",
    cdMonthlySalary: "Mindaa Ji'aa (Birrii)",
    cdJobDetails: "Odeeffannoo Hojii",
    cdJobDescription: "Ibsa Hojii",
    cdRequirements: "Gaaffii",
    cdKeyResponsibilities: "Itti Gaafatamummaa Ijoo",
    cdSkillsTags: "Dandeettii fi Maakiiwwan",
    cdJobTitleRequired: "Maqaan hojii barbaachisaa dha",
    cdCategoryRequired: "Gosi barbaachisaa dha",
    cdLocationRequired: "Bakki barbaachisaa dha",
    cdSkillsRequired: "Yoo xiqqaate dandeettii/maakii tokko barbaachisaa dha",
    cdSearchCandidates: "Maqaa, gahee, dandeettii barbaadi\u2026",
    cdFound: "Argame",
    cdLoadingCandidates: "Dorgomtoonni ni fe'amu...",
    cdNoResultsFound: "Bu'aan Hin Argamne",
    cdNoCandidatesYet: "Dorgomtoonni ammayyuu hin jiran",
    cdTryDifferentSearch: "Barbaachaa biraa yaalii ykn calalchiisaa haqii",
    cdCandidatesWillAppear: "Dorgomtoonni galmaa'an booda mul'atu",
    cdCompanyNameLabel: "Maqaa Dhaabbataa",
    cdDescriptionLabel: "Ibsa",
    cdIndustryLabel: "Industirii",
    cdCompanySizeLabel: "Hanga Dhaabbataa",
    cdFoundedYearLabel: "Waggaa Hundeffame",
    cdAboutCompany: "Waa'ee Dhaabbataa",
    cdContactInformation: "Odeeffannoo Quunnamtii",
    cdSizeLabel: "Hanga",
    cdFoundedLabel: "Hundeeffame",
    cdYourCompanyVerified: "Dhaabbanni kee mirkaneeffameera",
    cdContactSupportInfo: "Odeeffannoo dabalataa argachuuf deggersa quunnamii",
    cdUnderReview: "Bulchiinsaan ilaalamaa jira",
    cdActiveDashboard: "Dashboard Hojjatamaa",
    cdDeleteJobPosting: "Maxxansa Hojii Haquu",
    cdDeleteJobConfirm: "Maxxansa hojii kana haquuf mirkaneeffatta?",
    cdJobUpdated: "Maxxansni hojii milkaa'inaan haaromfameera!",
    cdJobPosted: "Maxxansni hojii milkaa'inaan maxxanfameera!",
    cdYearsExp: "waggaa muux.",
    // Mobile Drawer
    drawerTagline: "Carraa kee itti aantu argadhu",
    drawerMyAccount: "Herreega koo",
    drawerSavedJobs: "Hojiwwan olkaa'aman",
    drawerMyApplications: "Iyyaannoolee koo",
    drawerPostJob: "Hojii maxxansi",
    drawerMyJobPosts: "Maxxansalee hojii koo",
    drawerAnalytics: "Xiinxala",
    drawerRegisterCompany: "Dhaabbata kee galmeessi",
    drawerExplore: "Qoro",
    drawerBrowseJobs: "Hojiwwan ilaali",
    drawerPreferences: "Filmaataalee",
    drawerSubscription: "Subscription",
    drawerAboutNibJobs: "NibJobs waa\u2019ee",
    drawerSignOutTitle: "Ba\u2019i?",
    drawerSignOutDesc:
      "Herreega keetii irraa bahuun gara fuula jalqabaatti deebi\u2019uu dandeessa.",
    drawerClose: "Cufi",
    drawerVersion: "Faayila",
    drawerPlatform: "Teessoo",
    drawerCountry: "Biyya",
    drawerWebsite: "Marsariitii",
    drawerSupport: "Deggersaa",
    drawerAboutTagline:
      "Teessoo hojii kan Itoophiyaa kan duraati — ogeeyyii gahumsa qaban waliin hojjetaa jabaa walitti fiduu.",
    // Confirmation modals
    confirmAction: "Mirkaneessi",
    areYouSure: "Mirkanaa'aadhaa?",
    deleteConfirmTitle: "Haqi?",
    cannotBeUndone: "Gochi kun deebi'uu hin danda'u.",
    logoutConfirmTitle: "Mirkaneessa Ba'uu",
    logoutConfirmMessage:
      "Ba'uu barbaaddaa? Gara herrega keessaniitti deebi'uuf irra deebiin seenuu qabdu.",
    // Action buttons
    continueButton: "Itti fufi",
    previousButton: "Duraa",
    nextButton: "Itti aanu",
    backButton: "Deebi'i",
    applyButton: "Iyyadhu",
    submitApplicationButton: "Iyyata Galchi",
    postJobButton: "Hojii Maxxansi",
    browseMoreJobs: "Hojiiwwan Dabalataa Ilaali",
    goBack: "Deebi'i",
    notNow: "Amma miti",
    // Application flow
    applyForPosition: "Gara Hojii Kanaatti Iyyadhu",
    applicationStatus: "Haala Iyyataa",
    stepLabel: "Tarkaanfii",
    ofLabel: "irraa",
    personalInfoStep: "Odeeffannoo Dhuunfaa",
    professionalStep: "Ogummaa",
    coverLetterStep: "Xalayaa Seensaa",
    personalInformationSection: "Odeeffannoo Dhuunfaa",
    professionalLinksSubtitle:
      "Jiraachuu keessan onlaayinii fi fakkeenya hojii keessan hiraadhaa (filannoo)",
    coverLetterSubtitle: "Maaliif bakka kanatti akka argamtan kaayyeffataadhaa",
    coverLetterTip:
      "Yaada: Xalayaan seensaa adda ta'e carraa mul'achuu keessan dabala",
    // Application filters / statuses
    statusAll: "Hundumaa",
    statusPending: "Eeggataa",
    statusReviewed: "Ilaallamee",
    statusShortlisted: "Filatame",
    statusAccepted: "Fudhatame",
    statusRejected: "Didame",
    filterByStatus: "Haalaan calaluu",
    // Company profile / registration
    companyNameLabel: "Maqaa Dhaabbataa",
    companyDescriptionLabel: "Ibsa Dhaabbataa",
    companyEmailLabel: "Imeelii Dhaabbataa",
    companyPhoneLabel: "Bilbila Dhaabbataa",
    addressLabel: "Teessoo",
    cityLabel: "Magaalaa",
    websiteLabel: "Marsariitii",
    industryLabel: "Damee",
    companySizeLabel: "Guddina Dhaabbataa",
    uploadLogo: "Loogoo Ol-fe'i",
    // Subscription (mobile)
    subscriptionPlansTitle: "Karoora Gabbatees",
    getStartedBtn: "Jalqabi",
    chooseStandardBtn: "Istaandarsii Filadhu",
    chooseProBtn: "Proo Filadhu",
    chooseEnterpriseBtn: "Intarpraayizii Filadhu",
    // App bar titles / misc
    emailVerificationRequired: "Mirkaneessuun Imeelii Barbaachisaadha",
    emailNotVerified: "Imeeliin Hin Mirkanoofne",
    resetPasswordTitle: "Jecha Darbii Haaromsi",
    resetPasswordSubtitleMobile:
      "Qajeelfama haaromsuu gara imeelii keessaniitti ni erginaa",
    jobNotFoundTitle: "Hojiin Hin Argamne",
    somethingWentWrong: "Dogoggorri Uumame",
    manageJobListings:
      "Tarreeffama hojii, iyyataawwan fi qorannoo keessan bulchaa",
    // Verification steps
    verifyStep1Title: "Imeelii Keessan Banaa",
    verifyStep1Desc: "Saanduqa ergamaa fi galmee spam keessan ilaalaa",
    verifyStep2Title: "Hidhaa Cuqaasaa",
    verifyStep2Desc: "Hidhaa mirkaneessaa imeelii keessaa tuqaa",
    verifyStep3Title: "Qorachuu Jalqabaa",
    verifyStep3Desc: "Seenaa fi hojii abjuu keessanii argadhaa!",
    locationLabel: "Bakka",
    updateJobButton: "Hojii Haaromsi",
    remoteWorkSubtitle:
      "Hojjettoonni fagoo irraa hojjechuu akka dandaʼan hayyamii",
    selectedCountLabel: "Kan Filatamee",
    searchApplicationsPlaceholder: "Iyyattoota barbaadi...",
    noApplicationsYet: "Hanga ammaatti Iyyattoonni Hin Jiran",
    jobRoleLabel: "Gahee",
    saveChangesButton: "Jijjiirama Olkaaʼi",
  },
};

// Helper function to get current colors based on theme
const getColors = (isDarkMode: boolean) =>
  isDarkMode ? darkColors : lightColors;

// Reusable Mobile App Bar Component
const MobileAppBar = ({
  navigation,
  title = "",
  showSearch = true,
  onSearchChange,
  searchValue = "",
  isDarkMode = false,
  colors,
  user,
  userData,
  currentLanguage = "en",
  onLanguageChange,
  onThemeToggle,
  showBackButton = false,
  languageOptions = [
    { code: "en", label: "English" },
    { code: "am", label: "አማርኛ" },
    { code: "ti", label: "ትግርኛ" },
    { code: "or", label: "Afaan Oromoo" },
  ],
}: any) => {
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const [searchText, setSearchText] = useState(searchValue);

  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;

  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 480;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  useEffect(() => {
    setSearchText(searchValue);
  }, [searchValue]);

  const handleSearchSubmit = () => {
    if (onSearchChange) {
      onSearchChange(searchText);
    }
  };

  const getCurrentLanguage = () => {
    return (
      languageOptions.find((lang: any) => lang.code === currentLanguage) ||
      languageOptions[0]
    );
  };

  const handleLanguageChange = (langCode: string) => {
    if (onLanguageChange) {
      onLanguageChange(langCode);
    }
    setIsLanguageDropdownOpen(false);
  };

  return (
    <>
      <View
        style={[
          styles.modernHeader,
          {
            backgroundColor: isDarkMode ? "#1F2937" : colors.white,
            borderBottomColor: isDarkMode
              ? "rgba(255,255,255,0.1)"
              : "rgba(0,0,0,0.08)",
          },
        ]}
      >
        <View style={styles.modernHeaderContent}>
          {/* Left Section */}
          <View style={styles.modernLogoSection}>
            {isMobile && !showBackButton && (
              <TouchableOpacity
                style={[
                  styles.modernIconButton,
                  {
                    backgroundColor: isDarkMode ? "#2C2F36" : colors.lightGray,
                  },
                ]}
                onPress={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                <Icon
                  name={isMobileMenuOpen ? "close" : "menu"}
                  size={24}
                  color={isDarkMode ? "#F3F4F6" : colors.deepNavy}
                />
              </TouchableOpacity>
            )}

            {isMobile && showBackButton && (
              <TouchableOpacity
                style={[
                  styles.modernIconButton,
                  {
                    backgroundColor: isDarkMode ? "#2C2F36" : colors.lightGray,
                  },
                ]}
                onPress={() =>
                  navigation.canGoBack()
                    ? navigation.goBack()
                    : navigation.navigate("Jobs")
                }
              >
                <Icon
                  name="arrow-back"
                  size={24}
                  color={isDarkMode ? "#F3F4F6" : colors.deepNavy}
                />
              </TouchableOpacity>
            )}

            {!isSearchExpanded && (
              <TouchableOpacity
                style={styles.modernLogoContainer}
                onPress={() => navigation.navigate("Home")}
              >
                <View style={styles.modernLogoBadge}>
                  <Image
                    source={require("./assets/favicon.png")}
                    style={styles.modernLogo}
                  />
                </View>
                {title && isMobile && (
                  <Text
                    style={[styles.modernBrandText, { color: colors.deepNavy }]}
                  >
                    {title}
                  </Text>
                )}
              </TouchableOpacity>
            )}
          </View>

          {/* Right Actions */}
          <View style={styles.modernHeaderRight}>
            {isMobile && showSearch ? (
              <>
                {isSearchExpanded ? (
                  <View
                    style={[
                      styles.expandedSearchContainer,
                      { backgroundColor: colors.lightGray },
                    ]}
                  >
                    <TextInput
                      style={[
                        styles.expandedSearchInput,
                        { color: colors.deepNavy },
                      ]}
                      placeholder="Search..."
                      value={searchText}
                      onChangeText={setSearchText}
                      onSubmitEditing={handleSearchSubmit}
                      autoFocus
                      placeholderTextColor={colors.warmGray}
                    />
                    <TouchableOpacity
                      style={styles.expandedSearchClose}
                      onPress={() => {
                        setIsSearchExpanded(false);
                        setSearchText(searchValue);
                      }}
                    >
                      <Icon name="close" size={20} color={colors.deepNavy} />
                    </TouchableOpacity>
                  </View>
                ) : (
                  <View style={styles.mobileHeaderActions}>
                    <TouchableOpacity
                      style={[
                        styles.modernIconButton,
                        {
                          backgroundColor: isDarkMode
                            ? "#2C2F36"
                            : colors.lightGray,
                        },
                      ]}
                      onPress={() => setIsSearchExpanded(true)}
                    >
                      <Icon
                        name="search"
                        size={24}
                        color={isDarkMode ? colors.white : colors.deepNavy}
                      />
                    </TouchableOpacity>

                    <TouchableOpacity
                      style={[
                        styles.modernIconButton,
                        {
                          backgroundColor: isDarkMode
                            ? "#2C2F36"
                            : colors.lightGray,
                        },
                      ]}
                      onPress={() => setIsMoreMenuOpen(!isMoreMenuOpen)}
                    >
                      <Icon
                        name="more-vert"
                        size={24}
                        color={isDarkMode ? colors.white : colors.deepNavy}
                      />
                    </TouchableOpacity>
                  </View>
                )}
              </>
            ) : isMobile ? (
              <TouchableOpacity
                style={[
                  styles.modernIconButton,
                  {
                    backgroundColor: isDarkMode ? "#2C2F36" : colors.lightGray,
                  },
                ]}
                onPress={() => setIsMoreMenuOpen(!isMoreMenuOpen)}
              >
                <Icon
                  name="more-vert"
                  size={24}
                  color={isDarkMode ? colors.white : colors.deepNavy}
                />
              </TouchableOpacity>
            ) : null}
          </View>
        </View>
      </View>

      {/* Mobile Menu - Using Shared Drawer Component */}
      <MobileDrawer
        visible={isMobileMenuOpen && isMobile}
        onClose={() => setIsMobileMenuOpen(false)}
        navigation={navigation}
        user={user}
        userData={userData}
        isDarkMode={isDarkMode}
        toggleTheme={toggleTheme}
        currentLanguage={currentLanguage}
      />

      {/* More Menu Dropdown */}
      {isMoreMenuOpen && isMobile && (
        <View style={styles.fullScreenDropdownOverlay}>
          <TouchableOpacity
            style={styles.fullScreenTouchArea}
            onPress={() => setIsMoreMenuOpen(false)}
            activeOpacity={1}
          />
          <View
            style={[
              styles.moreMenuDropdown,
              {
                backgroundColor: colors.white,
                borderColor: colors.lightGray,
                top: 60,
                right: 16,
              },
            ]}
          >
            <TouchableOpacity
              style={styles.moreMenuItem}
              onPress={() => {
                setIsMoreMenuOpen(false);
                setIsLanguageDropdownOpen(true);
              }}
            >
              <Icon name="language" size={20} color={colors.deepNavy} />
              <Text style={[styles.moreMenuText, { color: colors.deepNavy }]}>
                {t.language}
              </Text>
              <Text
                style={[
                  styles.moreMenuSecondaryText,
                  { color: colors.warmGray },
                ]}
              >
                {getCurrentLanguage().code.toUpperCase()}
              </Text>
            </TouchableOpacity>

            {onThemeToggle && (
              <>
                <View
                  style={[
                    styles.moreMenuDivider,
                    { backgroundColor: colors.lightGray },
                  ]}
                />
                <TouchableOpacity
                  style={styles.moreMenuItem}
                  onPress={() => {
                    setIsMoreMenuOpen(false);
                    onThemeToggle();
                  }}
                >
                  <Icon
                    name={isDarkMode ? "wb-sunny" : "nightlight-round"}
                    size={20}
                    color={colors.deepNavy}
                  />
                  <Text
                    style={[styles.moreMenuText, { color: colors.deepNavy }]}
                  >
                    {isDarkMode ? t.lightMode : t.darkMode}
                  </Text>
                </TouchableOpacity>
              </>
            )}

            {user && (
              <>
                <View
                  style={[
                    styles.moreMenuDivider,
                    { backgroundColor: colors.lightGray },
                  ]}
                />
                <TouchableOpacity
                  style={styles.moreMenuItem}
                  onPress={() => {
                    setIsMoreMenuOpen(false);
                    const userRole = userData?.role || "user";
                    if (userRole === "superadmin" || userRole === "admin") {
                      navigation.navigate("AdminPanel");
                    } else if (userRole === "company") {
                      navigation.navigate("CompanyDashboard");
                    } else {
                      navigation.navigate("Settings");
                    }
                  }}
                >
                  <Icon name="dashboard" size={20} color={colors.deepNavy} />
                  <Text
                    style={[styles.moreMenuText, { color: colors.deepNavy }]}
                  >
                    {t.cdDashboard}
                  </Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.moreMenuItem}
                  onPress={async () => {
                    setIsMoreMenuOpen(false);
                    await signOut(auth);
                    navigation.navigate("Home");
                  }}
                >
                  <Text style={[styles.moreMenuText, { color: colors.danger }]}>
                    {t.logout}
                  </Text>
                </TouchableOpacity>
              </>
            )}
          </View>
        </View>
      )}

      {/* Language Dropdown */}
      {isLanguageDropdownOpen && isMobile && (
        <View style={styles.fullScreenDropdownOverlay}>
          <TouchableOpacity
            style={styles.fullScreenTouchArea}
            onPress={() => setIsLanguageDropdownOpen(false)}
            activeOpacity={1}
          />
          <View
            style={[
              styles.moreMenuDropdown,
              {
                backgroundColor: colors.white,
                borderColor: colors.lightGray,
                top: 60,
                right: 16,
              },
            ]}
          >
            {languageOptions.map((language: any, index: number) => (
              <TouchableOpacity
                key={language.code}
                style={[
                  styles.moreMenuItem,
                  currentLanguage === language.code && {
                    backgroundColor: colors.cream,
                  },
                ]}
                onPress={() => handleLanguageChange(language.code)}
              >
                <Text
                  style={[
                    styles.moreMenuText,
                    { color: colors.deepNavy, flex: 1 },
                  ]}
                >
                  {language.label}
                </Text>
                {currentLanguage === language.code && (
                  <Icon name="check" size={20} color={colors.beeYellow} />
                )}
              </TouchableOpacity>
            ))}
          </View>
        </View>
      )}
    </>
  );
};

// Shared Mobile Drawer Component
const MobileDrawer = ({
  visible,
  onClose,
  navigation,
  user,
  userData,
  isDarkMode,
  toggleTheme,
  currentView = "candidate",
  currentLanguage = "en",
}: any) => {
  const [showLogoutModal, setShowLogoutModal] = React.useState(false);
  const [showAboutModal, setShowAboutModal] = React.useState(false);
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const accent = "#F4C430"; // beeYellow

  const go = (screen: string) => {
    onClose();
    navigation.navigate(screen);
  };

  const Row = ({
    icon,
    iconColor = muted,
    label,
    onPress,
    danger = false,
    right = null,
  }: any) => (
    <TouchableOpacity
      onPress={onPress}
      style={{
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: 12,
        paddingHorizontal: 20,
        gap: 14,
      }}
      activeOpacity={0.6}
    >
      <View
        style={{
          width: 34,
          height: 34,
          borderRadius: 9,
          backgroundColor: danger ? "#FEF2F215" : `${iconColor}22`,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon name={icon} size={18} color={danger ? "#EF4444" : iconColor} />
      </View>
      <Text
        style={{
          flex: 1,
          fontSize: 15,
          fontFamily: fonts.regular,
          color: danger ? "#EF4444" : primary,
        }}
      >
        {label}
      </Text>
      {right || <Icon name="chevron-right" size={16} color={border} />}
    </TouchableOpacity>
  );

  const SectionLabel = ({ label }: any) => (
    <Text
      style={{
        fontSize: 11,
        fontFamily: fonts.medium,
        color: muted,
        letterSpacing: 0.8,
        textTransform: "uppercase",
        paddingHorizontal: 20,
        paddingTop: 20,
        paddingBottom: 6,
      }}
    >
      {label}
    </Text>
  );

  const Divider = () => (
    <View
      style={{ height: 1, backgroundColor: border, marginHorizontal: 20 }}
    />
  );

  return (
    <Modal
      visible={visible}
      animationType="slide"
      transparent={true}
      onRequestClose={onClose}
    >
      <View style={{ flex: 1, flexDirection: "row" }}>
        {/* Backdrop */}
        <TouchableOpacity
          style={{ flex: 1, backgroundColor: "rgba(0,0,0,0.4)" }}
          activeOpacity={1}
          onPress={onClose}
        />

        {/* Drawer panel */}
        <View style={{ width: 300, height: "100%", backgroundColor: bg }}>
          {/* ── HEADER ── */}
          <View
            style={{
              paddingTop: 52,
              paddingBottom: 20,
              paddingHorizontal: 20,
              backgroundColor: surface,
              borderBottomWidth: 1,
              borderBottomColor: border,
            }}
          >
            <TouchableOpacity
              onPress={onClose}
              style={{ position: "absolute", top: 52, right: 16, padding: 4 }}
              hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
            >
              <Icon name="close" size={22} color={muted} />
            </TouchableOpacity>

            {user ? (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                  marginTop: 4,
                }}
              >
                {userData?.profilePicture ? (
                  <Image
                    source={{ uri: userData.profilePicture }}
                    style={{ width: 48, height: 48, borderRadius: 24 }}
                  />
                ) : (
                  <View
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 24,
                      backgroundColor: accent,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 20,
                        fontFamily: fonts.bold,
                        color: "#1A1D23",
                      }}
                    >
                      {(userData?.displayName ||
                        user.email ||
                        "U")[0].toUpperCase()}
                    </Text>
                  </View>
                )}
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 16,
                      fontFamily: fonts.semiBold,
                      color: primary,
                    }}
                    numberOfLines={1}
                  >
                    {userData?.displayName ||
                      user.email?.split("@")[0] ||
                      "User"}
                  </Text>
                  <Text
                    style={{
                      fontSize: 13,
                      fontFamily: fonts.regular,
                      color: muted,
                      marginTop: 1,
                    }}
                    numberOfLines={1}
                  >
                    {user.email}
                  </Text>
                  {(() => {
                    const planIdRaw = (
                      userData?.subscriptionPlan ||
                      userData?.subscriptionId ||
                      "free"
                    )
                      .toString()
                      .toLowerCase();
                    const planColors: Record<
                      string,
                      { bg: string; fg: string }
                    > = {
                      free: { bg: "#6B728022", fg: "#6B7280" },
                      standard: { bg: "#3B82F622", fg: "#3B82F6" },
                      pro: {
                        bg: "#F4C43022",
                        fg: isDarkMode ? "#F4C430" : "#B68A00",
                      },
                      enterprise: { bg: "#8B5CF622", fg: "#8B5CF6" },
                    };
                    const planKey = planColors[planIdRaw] ? planIdRaw : "free";
                    const planLabel =
                      planKey.charAt(0).toUpperCase() + planKey.slice(1);
                    const pc = planColors[planKey];
                    const isCompany = userData?.role === "company";
                    const roleLabel = isCompany ? t.company : t.jobSeekerLabel;
                    const roleColor = isCompany ? "#10B981" : "#3B82F6";
                    const roleIcon = isCompany ? "business" : "person";
                    return (
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 6,
                          marginTop: 6,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 4,
                            paddingHorizontal: 8,
                            paddingVertical: 3,
                            borderRadius: 999,
                            backgroundColor: `${roleColor}22`,
                          }}
                        >
                          <Icon name={roleIcon} size={11} color={roleColor} />
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.semiBold,
                              color: roleColor,
                            }}
                            numberOfLines={1}
                          >
                            {roleLabel}
                          </Text>
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 4,
                            paddingHorizontal: 8,
                            paddingVertical: 3,
                            borderRadius: 999,
                            backgroundColor: pc.bg,
                          }}
                        >
                          <Icon
                            name={planKey === "free" ? "star-outline" : "star"}
                            size={11}
                            color={pc.fg}
                          />
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.semiBold,
                              color: pc.fg,
                            }}
                            numberOfLines={1}
                          >
                            {planLabel}
                          </Text>
                        </View>
                      </View>
                    );
                  })()}
                </View>
              </View>
            ) : (
              <View style={{ marginTop: 4 }}>
                <Text
                  style={{
                    fontSize: 22,
                    fontFamily: fonts.bold,
                    color: primary,
                  }}
                >
                  NibJobs
                </Text>
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.regular,
                    color: muted,
                    marginTop: 2,
                  }}
                >
                  {t.drawerTagline}
                </Text>
              </View>
            )}
          </View>

          {/* ── CONTENT ── */}
          <ScrollView showsVerticalScrollIndicator={false} style={{ flex: 1 }}>
            {/* Guest: Login / Sign Up */}
            {!user && (
              <View style={{ padding: 20, gap: 10 }}>
                <TouchableOpacity
                  onPress={() => go("Login")}
                  style={{
                    backgroundColor: accent,
                    paddingVertical: 13,
                    borderRadius: 12,
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.semiBold,
                      color: "#1A1D23",
                    }}
                  >
                    {t.login}
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => go("Signup")}
                  style={{
                    borderWidth: 1.5,
                    borderColor: border,
                    paddingVertical: 13,
                    borderRadius: 12,
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.semiBold,
                      color: primary,
                    }}
                  >
                    {t.createAccount}
                  </Text>
                </TouchableOpacity>
              </View>
            )}

            {/* Logged-in: MY ACCOUNT */}
            {user && (
              <>
                <SectionLabel label={t.drawerMyAccount} />
                <Row
                  icon="person-outline"
                  iconColor="#3B82F6"
                  label={t.profile}
                  onPress={() => go("Settings")}
                />
                <Divider />
                <Row
                  icon="bookmark-outline"
                  iconColor="#F4C430"
                  label={t.drawerSavedJobs}
                  onPress={() => go("Bookmarks")}
                />
                <Divider />
                <Row
                  icon="notifications-none"
                  iconColor="#8B5CF6"
                  label={t.notifications}
                  onPress={() => go("Notifications")}
                />
                {userData?.role === "user" && (
                  <>
                    <Divider />
                    <Row
                      icon="favorite-border"
                      iconColor="#E74C3C"
                      label={t.settingsJobInterestsLabel}
                      onPress={() => {
                        onClose();
                        navigation.navigate("SettingsInterests", {
                          user: { uid: user.uid, email: user.email },
                          userData: userData || {},
                        });
                      }}
                    />
                    <Divider />
                    <Row
                      icon="description"
                      iconColor="#10B981"
                      label={t.drawerMyApplications}
                      onPress={() => go("Applications")}
                    />
                  </>
                )}
              </>
            )}

            {/* Company-only section */}
            {user && userData?.role === "company" && (
              <>
                <SectionLabel label={t.company} />
                <Row
                  icon="add-circle-outline"
                  iconColor="#10B981"
                  label={t.drawerPostJob}
                  onPress={() => go("CompanyDashboard")}
                />
                <Divider />
                <Row
                  icon="work-outline"
                  iconColor="#F59E0B"
                  label={t.drawerMyJobPosts}
                  onPress={() => go("CompanyDashboard")}
                />
                <Divider />
                <Row
                  icon="analytics"
                  iconColor="#3B82F6"
                  label={t.drawerAnalytics}
                  onPress={() => go("CompanyDashboard")}
                />
              </>
            )}

            {/* Become a Company banner */}
            {user && userData?.role === "user" && (
              <TouchableOpacity
                onPress={() => go("CompanyRegistration")}
                style={{
                  margin: 16,
                  marginTop: 20,
                  borderWidth: 1,
                  borderColor: border,
                  borderRadius: 14,
                  padding: 14,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                  backgroundColor: surface,
                }}
              >
                <View
                  style={{
                    width: 38,
                    height: 38,
                    borderRadius: 10,
                    backgroundColor: "#1A1D23",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name="business" size={20} color="#FFFFFF" />
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.semiBold,
                      color: primary,
                    }}
                  >
                    {t.drawerPostJob}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.regular,
                      color: muted,
                      marginTop: 1,
                    }}
                  >
                    {t.drawerRegisterCompany}
                  </Text>
                </View>
                <Icon name="arrow-forward" size={18} color={muted} />
              </TouchableOpacity>
            )}

            {/* EXPLORE */}
            <SectionLabel label={t.drawerExplore} />
            <Row
              icon="search"
              iconColor="#6366F1"
              label={t.drawerBrowseJobs}
              onPress={() => go("Jobs")}
            />
            <Divider />
            <Row
              icon="corporate-fare"
              iconColor="#0EA5E9"
              label={t.companies}
              onPress={() => go("Companies")}
            />

            {/* SETTINGS */}
            <SectionLabel label={t.settings} />
            <Row
              icon="tune"
              iconColor="#F97316"
              label={t.drawerPreferences}
              onPress={() => go("Settings")}
            />
            <Divider />

            {/* Theme switcher */}
            <TouchableOpacity
              onPress={toggleTheme}
              style={{
                flexDirection: "row",
                alignItems: "center",
                paddingVertical: 12,
                paddingHorizontal: 20,
                gap: 14,
              }}
              activeOpacity={0.6}
            >
              <View
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 9,
                  backgroundColor: isDarkMode ? "#F4C43022" : "#1A1D2322",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name={isDarkMode ? "wb-sunny" : "nightlight-round"}
                  size={18}
                  color={isDarkMode ? "#F4C430" : "#1A1D23"}
                />
              </View>
              <Text
                style={{
                  flex: 1,
                  fontSize: 15,
                  fontFamily: fonts.regular,
                  color: primary,
                }}
              >
                {isDarkMode ? t.lightMode : t.darkMode}
              </Text>
              {/* Toggle pill */}
              <View
                style={{
                  width: 46,
                  height: 26,
                  borderRadius: 13,
                  backgroundColor: isDarkMode ? "#F4C430" : `${border}`,
                  borderWidth: 1,
                  borderColor: isDarkMode ? "#F4C430" : border,
                  justifyContent: "center",
                  paddingHorizontal: 3,
                }}
              >
                <View
                  style={{
                    width: 20,
                    height: 20,
                    borderRadius: 10,
                    backgroundColor: isDarkMode ? "#1A1D23" : muted,
                    alignSelf: isDarkMode ? "flex-end" : "flex-start",
                  }}
                />
              </View>
            </TouchableOpacity>
            <Divider />
            <Row
              icon="language"
              iconColor="#10B981"
              label={t.language}
              onPress={() => go("Settings")}
            />
            <Divider />
            {FEATURES.PRICING_ENABLED && (
              <>
                <Row
                  icon="star-outline"
                  iconColor="#F4C430"
                  label={t.drawerSubscription}
                  onPress={() => go("SettingsSubscription")}
                />
                <Divider />
              </>
            )}
            <Row
              icon="info-outline"
              iconColor="#6B7280"
              label={t.drawerAboutNibJobs}
              onPress={() => setShowAboutModal(true)}
            />

            {/* Logout */}
            {user && (
              <View style={{ marginTop: 8, marginBottom: 32 }}>
                <Divider />
                <Row
                  icon="logout"
                  label={t.logout}
                  danger
                  right={<View />}
                  onPress={() => setShowLogoutModal(true)}
                />
              </View>
            )}

            {!user && <View style={{ height: 32 }} />}
          </ScrollView>
        </View>
      </View>

      {/* ── About NibJobs Modal ── */}
      <Modal
        visible={showAboutModal}
        transparent
        animationType="fade"
        onRequestClose={() => setShowAboutModal(false)}
      >
        <View
          style={{
            flex: 1,
            backgroundColor: "rgba(0,0,0,0.6)",
            justifyContent: "flex-end",
          }}
        >
          <View
            style={{
              backgroundColor: isDarkMode ? "#13161C" : "#FFFFFF",
              borderTopLeftRadius: 28,
              borderTopRightRadius: 28,
              paddingBottom: 40,
              overflow: "hidden",
            }}
          >
            {/* drag handle */}
            <View
              style={{ alignItems: "center", paddingTop: 12, paddingBottom: 4 }}
            >
              <View
                style={{
                  width: 38,
                  height: 4,
                  borderRadius: 2,
                  backgroundColor: isDarkMode ? "#2E3140" : "#E5E7EB",
                }}
              />
            </View>

            {/* Logo + wordmark */}
            <View
              style={{
                alignItems: "center",
                paddingTop: 24,
                paddingBottom: 20,
              }}
            >
              <View
                style={{
                  width: 72,
                  height: 72,
                  borderRadius: 20,
                  backgroundColor: "#1A1D23",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 14,
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: 4 },
                  shadowOpacity: 0.25,
                  shadowRadius: 12,
                  elevation: 8,
                }}
              >
                <Text
                  style={{
                    fontSize: 30,
                    fontFamily: fonts.bold,
                    color: "#F4C430",
                  }}
                >
                  N
                </Text>
              </View>
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 1 }}
              >
                <Text
                  style={{
                    fontSize: 24,
                    fontFamily: fonts.regular,
                    color: isDarkMode ? "#94A3B8" : "#64748B",
                  }}
                >
                  Nib
                </Text>
                <Text
                  style={{
                    fontSize: 24,
                    fontFamily: fonts.bold,
                    color: isDarkMode ? "#F1F5F9" : "#0F172A",
                  }}
                >
                  Jobs
                </Text>
              </View>
              {/* Yellow underline accent */}
              <View
                style={{
                  width: 36,
                  height: 3,
                  borderRadius: 2,
                  backgroundColor: "#F4C430",
                  marginTop: 4,
                }}
              />
            </View>

            {/* Info rows */}
            <View
              style={{
                marginHorizontal: 20,
                borderRadius: 16,
                backgroundColor: isDarkMode ? "#1A1D26" : "#F8F9FC",
                borderWidth: 1,
                borderColor: isDarkMode ? "#1E2028" : "#EBEBF0",
                overflow: "hidden",
              }}
            >
              {[
                { label: t.drawerVersion, value: "2.0.93", icon: "tag" },
                {
                  label: t.drawerPlatform,
                  value: "Android",
                  icon: "phone-android",
                },
                { label: t.drawerCountry, value: "Ethiopia", icon: "public" },
                {
                  label: t.drawerWebsite,
                  value: "nibjobs.com",
                  icon: "language",
                },
                {
                  label: t.drawerSupport,
                  value: "support@nibjobs.com",
                  icon: "mail-outline",
                },
              ].map((row, i, arr) => (
                <View
                  key={row.label}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingHorizontal: 16,
                    paddingVertical: 13,
                    borderBottomWidth: i < arr.length - 1 ? 1 : 0,
                    borderBottomColor: isDarkMode ? "#1E2028" : "#EBEBF0",
                  }}
                >
                  <Icon
                    name={row.icon}
                    size={16}
                    color={isDarkMode ? "#6B7280" : "#9CA3AF"}
                    style={{ marginRight: 12 }}
                  />
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 14,
                      fontFamily: fonts.medium,
                      color: isDarkMode ? "#9CA3AF" : "#64748B",
                    }}
                  >
                    {row.label}
                  </Text>
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.bold,
                      color: isDarkMode ? "#F1F5F9" : "#0F172A",
                    }}
                  >
                    {row.value}
                  </Text>
                </View>
              ))}
            </View>

            {/* Tagline */}
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.regular,
                color: isDarkMode ? "#4B5563" : "#94A3B8",
                textAlign: "center",
                marginTop: 20,
                paddingHorizontal: 32,
                lineHeight: 19,
              }}
            >
              {t.drawerAboutTagline}
            </Text>

            {/* Close button */}
            <TouchableOpacity
              onPress={() => setShowAboutModal(false)}
              activeOpacity={0.75}
              style={{
                marginTop: 20,
                marginHorizontal: 20,
                backgroundColor: isDarkMode ? "#1E2230" : "#F1F5F9",
                borderRadius: 14,
                paddingVertical: 14,
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.bold,
                  color: isDarkMode ? "#F1F5F9" : "#0F172A",
                }}
              >
                {t.drawerClose}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      {/* ── Logout Confirmation Modal ── */}
      <Modal
        visible={showLogoutModal}
        transparent
        animationType="fade"
        onRequestClose={() => setShowLogoutModal(false)}
      >
        <View
          style={{
            flex: 1,
            backgroundColor: "rgba(0,0,0,0.55)",
            justifyContent: "center",
            alignItems: "center",
            padding: 28,
          }}
        >
          <View
            style={{
              width: "100%",
              maxWidth: 360,
              backgroundColor: isDarkMode ? "#161F2E" : "#FFFFFF",
              borderRadius: 20,
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <View
              style={{
                paddingHorizontal: 24,
                paddingTop: 28,
                paddingBottom: 16,
                alignItems: "center",
              }}
            >
              <View
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: 16,
                  backgroundColor: "#EF444418",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 14,
                }}
              >
                <Icon name="logout" size={26} color="#EF4444" />
              </View>
              <Text
                style={{
                  fontSize: 18,
                  fontFamily: fonts.bold,
                  fontWeight: "700",
                  color: isDarkMode ? "#F9FAFB" : "#0F172A",
                  marginBottom: 8,
                }}
              >
                {t.drawerSignOutTitle}
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.regular,
                  color: isDarkMode ? "#94A3B8" : "#64748B",
                  textAlign: "center",
                  lineHeight: 20,
                }}
              >
                {t.drawerSignOutDesc}
              </Text>
            </View>
            {/* Actions */}
            <View
              style={{
                flexDirection: "row",
                gap: 10,
                paddingHorizontal: 20,
                paddingBottom: 24,
                paddingTop: 8,
              }}
            >
              <TouchableOpacity
                onPress={() => setShowLogoutModal(false)}
                style={{
                  flex: 1,
                  paddingVertical: 12,
                  borderRadius: 11,
                  backgroundColor: isDarkMode ? "#1E293B" : "#F1F5F9",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    fontWeight: "600",
                    color: isDarkMode ? "#94A3B8" : "#64748B",
                  }}
                >
                  {t.cancelButton}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={async () => {
                  setShowLogoutModal(false);
                  onClose();
                  await signOut(auth);
                  navigation.navigate("Jobs");
                }}
                style={{
                  flex: 1,
                  paddingVertical: 12,
                  borderRadius: 11,
                  backgroundColor: "#EF4444",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    fontWeight: "600",
                    color: "#FFFFFF",
                  }}
                >
                  {t.cdSignOut}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </Modal>
  );
};

const BOTTOM_NAV_HEIGHT = Platform.OS === "ios" ? 80 : 64;

// Modern Loading Screen Component
const ModernLoadingScreen = ({
  message = "Loading...",
  isDarkMode = false,
  showLogo = true,
}: {
  message?: string;
  isDarkMode?: boolean;
  showLogo?: boolean;
}) => {
  const spinAnim = useRef(new Animated.Value(0)).current;
  const fadeAnim = useRef(new Animated.Value(0)).current;
  const scaleAnim = useRef(new Animated.Value(0.88)).current;

  useEffect(() => {
    // Spin ring
    Animated.loop(
      Animated.timing(spinAnim, {
        toValue: 1,
        duration: 900,
        useNativeDriver: true,
        easing: Easing.linear,
      }),
    ).start();
    // Fade + scale in
    Animated.parallel([
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 400,
        useNativeDriver: true,
      }),
      Animated.spring(scaleAnim, {
        toValue: 1,
        friction: 7,
        useNativeDriver: true,
      }),
    ]).start();
  }, []);

  const spin = spinAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ["0deg", "360deg"],
  });
  const bg = isDarkMode ? "#0F1117" : "#F8FAFC";
  const primary = isDarkMode ? "#F9FAFB" : "#0F172A";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";

  return (
    <View
      style={{
        flex: 1,
        backgroundColor: bg,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Animated.View
        style={{
          alignItems: "center",
          opacity: fadeAnim,
          transform: [{ scale: scaleAnim }],
        }}
      >
        {/* Spinning ring + icon */}
        <View
          style={{
            width: 80,
            height: 80,
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 28,
          }}
        >
          {/* Outer spinning ring */}
          <Animated.View
            style={{
              position: "absolute",
              width: 80,
              height: 80,
              borderRadius: 40,
              borderWidth: 3,
              borderColor: "#F4C430",
              borderTopColor: "transparent",
              transform: [{ rotate: spin }],
            }}
          />
          {/* Inner static circle */}
          <View
            style={{
              width: 54,
              height: 54,
              borderRadius: 27,
              backgroundColor: isDarkMode ? "#1A1D23" : "#FFFBEB",
              alignItems: "center",
              justifyContent: "center",
              borderWidth: 1,
              borderColor: isDarkMode ? "#2C2F36" : "#FEF3C7",
            }}
          >
            <Icon name="work-outline" size={24} color="#F4C430" />
          </View>
        </View>

        {/* Message */}
        <Text
          style={{
            fontSize: 16,
            fontFamily: fonts.semiBold,
            color: primary,
            marginBottom: 6,
          }}
        >
          {message}
        </Text>
        <Text style={{ fontSize: 12, fontFamily: fonts.regular, color: muted }}>
          NibJobs · Ethiopia's Job Platform
        </Text>
      </Animated.View>
    </View>
  );
};

// Inline Loading Component for content areas
const InlineLoadingIndicator = ({
  message = "Loading...",
  isDarkMode = false,
}: {
  message?: string;
  isDarkMode?: boolean;
}) => {
  const [dot1] = useState(new Animated.Value(0));
  const [dot2] = useState(new Animated.Value(0));
  const [dot3] = useState(new Animated.Value(0));

  useEffect(() => {
    const bounce = (dot: Animated.Value, delay: number) =>
      Animated.loop(
        Animated.sequence([
          Animated.delay(delay),
          Animated.timing(dot, {
            toValue: -7,
            duration: 280,
            useNativeDriver: true,
            easing: Easing.out(Easing.quad),
          }),
          Animated.timing(dot, {
            toValue: 0,
            duration: 280,
            useNativeDriver: true,
            easing: Easing.in(Easing.quad),
          }),
          Animated.delay(Math.max(0, 560 - delay)),
        ]),
      );
    bounce(dot1, 0).start();
    bounce(dot2, 140).start();
    bounce(dot3, 280).start();
  }, []);

  const dotColor = isDarkMode ? "#F4C430" : "#1A1D23";
  const textColor = isDarkMode ? "#6B7280" : "#9CA3AF";

  return (
    <View style={{ paddingVertical: 52, alignItems: "center" }}>
      <View style={{ flexDirection: "row", gap: 10, marginBottom: 14 }}>
        {[dot1, dot2, dot3].map((dot, i) => (
          <Animated.View
            key={i}
            style={{
              width: 8,
              height: 8,
              borderRadius: 4,
              backgroundColor: dotColor,
              transform: [{ translateY: dot }],
            }}
          />
        ))}
      </View>
      {!!message && (
        <Text
          style={{
            fontSize: 13,
            fontFamily: fonts.medium,
            color: textColor,
            letterSpacing: 0.2,
          }}
        >
          {message}
        </Text>
      )}
    </View>
  );
};

// Full-screen loading indicator (replaces scattered ActivityIndicator + Text blocks)
const FullScreenLoader = ({
  message,
  isDarkMode = false,
}: {
  message?: string;
  isDarkMode?: boolean;
}) => {
  const [dot1] = useState(new Animated.Value(0));
  const [dot2] = useState(new Animated.Value(0));
  const [dot3] = useState(new Animated.Value(0));

  useEffect(() => {
    const bounce = (dot: Animated.Value, delay: number) =>
      Animated.loop(
        Animated.sequence([
          Animated.delay(delay),
          Animated.timing(dot, {
            toValue: -9,
            duration: 300,
            useNativeDriver: true,
            easing: Easing.out(Easing.quad),
          }),
          Animated.timing(dot, {
            toValue: 0,
            duration: 300,
            useNativeDriver: true,
            easing: Easing.in(Easing.quad),
          }),
          Animated.delay(Math.max(0, 600 - delay)),
        ]),
      );
    bounce(dot1, 0).start();
    bounce(dot2, 150).start();
    bounce(dot3, 300).start();
  }, []);

  const dotColor = isDarkMode ? "#F4C430" : "#1A1D23";
  const textColor = isDarkMode ? "#6B7280" : "#9CA3AF";

  return (
    <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
      <View
        style={{
          flexDirection: "row",
          gap: 12,
          marginBottom: message ? 16 : 0,
        }}
      >
        {[dot1, dot2, dot3].map((dot, i) => (
          <Animated.View
            key={i}
            style={{
              width: 10,
              height: 10,
              borderRadius: 5,
              backgroundColor: dotColor,
              transform: [{ translateY: dot }],
            }}
          />
        ))}
      </View>
      {!!message && (
        <Text
          style={{
            fontSize: 14,
            fontFamily: fonts.medium,
            color: textColor,
            letterSpacing: 0.2,
          }}
        >
          {message}
        </Text>
      )}
    </View>
  );
};

// Skeleton Loader for Job Cards
const SkeletonJobCard = ({
  isDarkMode = false,
  viewMode = "grid",
  isMobile = false,
}: {
  isDarkMode?: boolean;
  viewMode?: "grid" | "list";
  isMobile?: boolean;
}) => {
  const [shimmerValue] = useState(new Animated.Value(0));

  useEffect(() => {
    Animated.loop(
      Animated.timing(shimmerValue, {
        toValue: 1,
        duration: 1500,
        easing: Easing.ease,
        useNativeDriver: true,
      }),
    ).start();
  }, []);

  const shimmerTranslate = shimmerValue.interpolate({
    inputRange: [0, 1],
    outputRange: [-300, 300],
  });

  const bgColor = isDarkMode ? "#1F2937" : "#FFFFFF";
  const shimmerColor = isDarkMode
    ? "rgba(255, 255, 255, 0.05)"
    : "rgba(0, 0, 0, 0.03)";
  const skeletonColor = isDarkMode ? "#374151" : "#E5E7EB";

  return (
    <View
      style={{
        backgroundColor: bgColor,
        borderRadius: 16,
        padding: 12,
        marginBottom: 16,
        minHeight: 320,
        width: isMobile ? "100%" : viewMode === "grid" ? "48%" : "100%",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
        elevation: 2,
        overflow: "hidden",
        borderWidth: 1,
        borderColor: isDarkMode ? "#2C2F36" : "#F3F4F6",
      }}
    >
      {/* Shimmer overlay */}
      <Animated.View
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          transform: [{ translateX: shimmerTranslate }],
        }}
      >
        <View
          style={{
            width: 100,
            height: "100%",
            backgroundColor: shimmerColor,
            transform: [{ skewX: "-20deg" }],
          }}
        />
      </Animated.View>

      {/* Badges Container */}
      <View
        style={{ flexDirection: "row", gap: 6, marginBottom: 8, minHeight: 20 }}
      >
        <View
          style={{
            height: 20,
            width: 50,
            backgroundColor: skeletonColor,
            borderRadius: 10,
          }}
        />
      </View>

      {/* Header - Company Info */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "flex-start",
          gap: 10,
          marginBottom: 12,
        }}
      >
        <View
          style={{
            width: 44,
            height: 44,
            borderRadius: 10,
            backgroundColor: skeletonColor,
          }}
        />
        <View style={{ flex: 1 }}>
          <View
            style={{
              height: 16,
              backgroundColor: skeletonColor,
              borderRadius: 4,
              marginBottom: 6,
              width: "70%",
            }}
          />
          <View
            style={{
              height: 12,
              backgroundColor: skeletonColor,
              borderRadius: 4,
              width: "50%",
            }}
          />
        </View>
        <View
          style={{
            width: 32,
            height: 32,
            borderRadius: 8,
            backgroundColor: skeletonColor,
          }}
        />
      </View>

      {/* Title Container */}
      <View style={{ marginBottom: 12, paddingHorizontal: 4 }}>
        <View
          style={{
            height: 18,
            backgroundColor: skeletonColor,
            borderRadius: 4,
            marginBottom: 6,
            width: "90%",
          }}
        />
        <View
          style={{
            height: 18,
            backgroundColor: skeletonColor,
            borderRadius: 4,
            marginBottom: 8,
            width: "75%",
          }}
        />
        <View
          style={{
            height: 22,
            width: 80,
            backgroundColor: skeletonColor,
            borderRadius: 11,
          }}
        />
      </View>

      {/* Info Grid - 4 cells in 2x2 */}
      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          gap: 8,
          marginBottom: 10,
          paddingHorizontal: 4,
        }}
      >
        {[1, 2, 3, 4].map((i) => (
          <View
            key={i}
            style={{
              width: "48%",
              flexDirection: "row",
              gap: 6,
              alignItems: "center",
            }}
          >
            <View
              style={{
                width: 16,
                height: 16,
                borderRadius: 8,
                backgroundColor: skeletonColor,
              }}
            />
            <View style={{ flex: 1 }}>
              <View
                style={{
                  height: 10,
                  backgroundColor: skeletonColor,
                  borderRadius: 4,
                  marginBottom: 4,
                  width: "60%",
                }}
              />
              <View
                style={{
                  height: 12,
                  backgroundColor: skeletonColor,
                  borderRadius: 4,
                  width: "80%",
                }}
              />
            </View>
          </View>
        ))}
      </View>

      {/* Salary Section */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 8,
          padding: 10,
          backgroundColor: isDarkMode ? "#2C2F36" : "#FFF8E7",
          borderRadius: 8,
          marginBottom: 10,
          borderLeftWidth: 3,
          borderLeftColor: skeletonColor,
        }}
      >
        <View
          style={{
            width: 20,
            height: 20,
            borderRadius: 10,
            backgroundColor: skeletonColor,
          }}
        />
        <View
          style={{
            height: 16,
            backgroundColor: skeletonColor,
            borderRadius: 4,
            flex: 1,
          }}
        />
      </View>

      {/* Skills Tags */}
      <View
        style={{
          flexDirection: "row",
          gap: 6,
          marginBottom: 10,
          flexWrap: "wrap",
          paddingHorizontal: 4,
        }}
      >
        {[60, 70, 55].map((width, i) => (
          <View
            key={i}
            style={{
              height: 24,
              width,
              backgroundColor: skeletonColor,
              borderRadius: 12,
            }}
          />
        ))}
      </View>

      {/* Footer - Apply Button */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 8,
          marginTop: "auto",
          paddingTop: 10,
        }}
      >
        <View
          style={{
            height: 12,
            width: 70,
            backgroundColor: skeletonColor,
            borderRadius: 4,
          }}
        />
        <View
          style={{
            height: 36,
            flex: 1,
            backgroundColor: skeletonColor,
            borderRadius: 8,
            marginLeft: "auto",
          }}
        />
      </View>
    </View>
  );
};

// Shared Bottom Navigation Bar Component
const BottomNavBar = ({
  navigation,
  activeRoute,
  isDarkMode,
  user,
  userData,
  currentLanguage = "en",
}: any) => {
  const dimensions = Dimensions.get("window");
  const isMobile = Platform.OS !== "web" || dimensions.width < 768;
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;

  // Self-managed unread notification badge count
  const [unreadCount, setUnreadCount] = useState(0);
  useEffect(() => {
    if (!user || user.isAnonymous) return;
    const q = dbQuery(
      collection(db, "users", user.uid, "notifications"),
      where("read", "==", false),
    );
    const unsub = onSnapshot(
      q,
      (snap) => setUnreadCount(snap.size),
      () => {},
    );
    return unsub;
  }, [user?.uid]);

  // Don't render on desktop
  if (!isMobile) return null;

  const colors = isDarkMode
    ? {
        bar: "#1C1F26",
        shadow: "#000000",
        text: "#6B7280",
        activeText: "#FFFFFF",
        activePill: "#F4C430",
        activePillText: "#1A1D23",
        dot: "#EF4444",
      }
    : {
        bar: "#FFFFFF",
        shadow: "#000000",
        text: "#9CA3AF",
        activeText: "#1A1D23",
        activePill: "#F4C430",
        activePillText: "#1A1D23",
        dot: "#EF4444",
      };

  const isJobSeeker =
    !!user && !user.isAnonymous && userData?.role !== "company";
  const isInterestsActive = activeRoute === "SettingsInterests";
  const interestCatCount = (userData?.interestedCategories || []).length;
  const interestTagCount = (userData?.interestedTags || []).length;
  const interestTotalCount = interestCatCount + interestTagCount;

  const allNavItems =
    userData?.role === "company"
      ? [
          {
            route: "Jobs",
            icon: "work",
            iconOutline: "work-outline",
            label: t.navJobs,
          },
          {
            route: "CompanyDashboard",
            icon: "dashboard",
            iconOutline: "dashboard",
            label: t.navDashboard,
          },
          {
            route: "Notifications",
            icon: "notifications",
            iconOutline: "notifications-none",
            label: t.navAlerts,
          },
          {
            route: "Settings",
            icon: "person",
            iconOutline: "person-outline",
            label: t.navProfile,
          },
        ]
      : [
          {
            route: "Jobs",
            icon: "work",
            iconOutline: "work-outline",
            label: t.navJobs,
          },
          {
            route: "Bookmarks",
            icon: "bookmark",
            iconOutline: "bookmark-outline",
            label: t.navSaved,
          },
          {
            route: "Notifications",
            icon: "notifications",
            iconOutline: "notifications-none",
            label: t.navAlerts,
          },
        ];

  const renderNavItem = (item: any) => {
    const isActive =
      activeRoute === item.route ||
      (item.route === "Settings" &&
        activeRoute?.startsWith?.("Settings") &&
        activeRoute !== "SettingsInterests") ||
      (item.route === "CompanyDashboard" && activeRoute === "CompanyDashboard");
    return (
      <TouchableOpacity
        key={item.route}
        style={{ flex: 1, alignItems: "center", justifyContent: "center" }}
        onPress={() => navigation.navigate(item.route)}
        activeOpacity={0.7}
      >
        {isActive ? (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              backgroundColor: colors.activePill,
              borderRadius: 20,
              paddingHorizontal: 14,
              paddingVertical: 8,
              gap: 6,
            }}
          >
            <Icon name={item.icon} size={20} color={colors.activePillText} />
            <Text
              style={{
                fontSize: 13,
                fontWeight: "700",
                color: colors.activePillText,
                letterSpacing: 0.2,
              }}
            >
              {item.label}
            </Text>
            {item.route === "Notifications" && unreadCount > 0 && (
              <View
                style={{
                  backgroundColor: "#EF4444",
                  borderRadius: 8,
                  minWidth: 18,
                  height: 18,
                  justifyContent: "center",
                  alignItems: "center",
                  paddingHorizontal: 4,
                  marginLeft: 2,
                }}
              >
                <Text
                  style={{ fontSize: 10, color: "#FFFFFF", fontWeight: "800" }}
                >
                  {unreadCount > 99 ? "99+" : unreadCount}
                </Text>
              </View>
            )}
          </View>
        ) : (
          <View style={{ position: "relative", padding: 8 }}>
            <Icon name={item.iconOutline} size={24} color={colors.text} />
            {item.route === "Notifications" && unreadCount > 0 && (
              <View
                style={{
                  position: "absolute",
                  top: 4,
                  right: 4,
                  backgroundColor: colors.dot,
                  borderRadius: 6,
                  minWidth: 14,
                  height: 14,
                  justifyContent: "center",
                  alignItems: "center",
                  paddingHorizontal: 2,
                }}
              >
                <Text
                  style={{ fontSize: 8, color: "#FFFFFF", fontWeight: "800" }}
                >
                  {unreadCount > 99 ? "99+" : unreadCount}
                </Text>
              </View>
            )}
          </View>
        )}
      </TouchableOpacity>
    );
  };

  const pillStyle = {
    backgroundColor: colors.bar,
    borderRadius: 32,
    flexDirection: "row" as const,
    alignItems: "center" as const,
    paddingVertical: 10,
    paddingHorizontal: 8,
    shadowColor: colors.shadow,
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: isDarkMode ? 0.5 : 0.15,
    shadowRadius: 24,
    elevation: 20,
    width: "100%" as const,
  };

  // Job seekers: 3 items left | FAB right
  if (isJobSeeker) {
    return (
      <View
        style={{
          position: "absolute",
          bottom: Platform.OS === "ios" ? 24 : 12,
          left: 20,
          right: 20,
        }}
      >
        {/* FAB — floats above the right end of the pill */}
        <TouchableOpacity
          onPress={() =>
            navigation.navigate("SettingsInterests", {
              user: { uid: user.uid, email: user.email },
              userData: userData || {},
            })
          }
          activeOpacity={0.8}
          style={{
            position: "absolute",
            top: -26,
            right: 4,
            width: 52,
            height: 52,
            borderRadius: 26,
            backgroundColor: isInterestsActive ? "#E11D48" : colors.activePill,
            alignItems: "center",
            justifyContent: "center",
            shadowColor: isInterestsActive ? "#E11D48" : colors.activePill,
            shadowOffset: { width: 0, height: 6 },
            shadowOpacity: 0.5,
            shadowRadius: 14,
            elevation: 14,
            zIndex: 10,
            borderWidth: 3,
            borderColor: colors.bar,
          }}
        >
          <Icon
            name={isInterestsActive ? "favorite" : "favorite-border"}
            size={22}
            color={isInterestsActive ? "#FFFFFF" : "#1A1D23"}
          />
          {/* Count badge */}
          {interestTotalCount > 0 && (
            <View
              style={{
                position: "absolute",
                top: -4,
                right: -4,
                backgroundColor: isInterestsActive ? "#FFFFFF" : "#E11D48",
                borderRadius: 10,
                minWidth: 20,
                height: 20,
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 4,
                borderWidth: 2,
                borderColor: colors.bar,
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  color: isInterestsActive ? "#E11D48" : "#FFFFFF",
                  fontWeight: "800",
                  lineHeight: 14,
                }}
              >
                {interestTotalCount > 99 ? "99+" : interestTotalCount}
              </Text>
            </View>
          )}
        </TouchableOpacity>

        {/* Pill — all 3 items + right spacer so FAB doesn't overlap last icon */}
        <View style={pillStyle}>
          {allNavItems.map(renderNavItem)}
          <View style={{ width: 52 }} />
        </View>
      </View>
    );
  }

  // Company / guest: normal flat layout
  return (
    <View
      style={{
        position: "absolute",
        bottom: Platform.OS === "ios" ? 24 : 12,
        left: 20,
        right: 20,
        ...pillStyle,
      }}
    >
      {allNavItems.map(renderNavItem)}
    </View>
  );
};

// Logout Confirmation Modal Component
const LogoutConfirmationModal = ({
  visible,
  onConfirm,
  onCancel,
  isDarkMode,
  currentLanguage = "en",
}: {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  isDarkMode: boolean;
  currentLanguage?: string;
}) => {
  if (!visible) return null;

  const colors = isDarkMode ? darkColors : lightColors;
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onCancel}
    >
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0,0,0,0.6)",
          justifyContent: "center",
          alignItems: "center",
          padding: 20,
        }}
      >
        <View
          style={{
            backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
            borderRadius: 20,
            padding: 28,
            width: "100%",
            maxWidth: 400,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 8 },
            shadowOpacity: 0.3,
            shadowRadius: 20,
            elevation: 10,
          }}
        >
          {/* Icon */}
          <View
            style={{
              width: 56,
              height: 56,
              borderRadius: 16,
              backgroundColor: isDarkMode
                ? "rgba(239,68,68,0.15)"
                : "rgba(239,68,68,0.1)",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 20,
              alignSelf: "center",
            }}
          >
            <Icon name="logout" size={28} color="#EF4444" />
          </View>

          {/* Title */}
          <Text
            style={{
              fontFamily: fonts.bold,
              fontSize: 22,
              color: isDarkMode ? "#F9FAFB" : "#111827",
              textAlign: "center",
              marginBottom: 10,
              letterSpacing: -0.5,
            }}
          >
            {t.logoutConfirmTitle}
          </Text>

          {/* Message */}
          <Text
            style={{
              fontFamily: fonts.regular,
              fontSize: 15,
              color: isDarkMode ? "#9CA3AF" : "#6B7280",
              textAlign: "center",
              lineHeight: 22,
              marginBottom: 28,
            }}
          >
            {t.logoutConfirmMessage}
          </Text>

          {/* Buttons */}
          <View style={{ flexDirection: "row", gap: 12 }}>
            <TouchableOpacity
              onPress={onCancel}
              style={{
                flex: 1,
                backgroundColor: isDarkMode
                  ? "rgba(255,255,255,0.08)"
                  : "rgba(0,0,0,0.05)",
                paddingVertical: 14,
                borderRadius: 12,
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontFamily: fonts.semibold,
                  fontSize: 15,
                  color: isDarkMode ? "#E5E7EB" : "#374151",
                }}
              >
                {t.cancelButton}
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={onConfirm}
              style={{
                flex: 1,
                backgroundColor: "#EF4444",
                paddingVertical: 14,
                borderRadius: 12,
                alignItems: "center",
                shadowColor: "#EF4444",
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: 0.3,
                shadowRadius: 8,
                elevation: 4,
              }}
            >
              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: 15,
                  color: "#FFFFFF",
                }}
              >
                {t.logout}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

// ─────────────────────────────────────────────────────────
// useSubscriptionPermissions
// Live-listens to Firestore subscriptionPlans/{planId} for permission flags.
// ─────────────────────────────────────────────────────────
function useSubscriptionPermissions(subscriptionPlan?: string | null) {
  const planId = (subscriptionPlan || "free").toLowerCase();
  const planDefaults =
    DEFAULT_PLAN_PERMISSIONS[planId] || DEFAULT_PLAN_PERMISSIONS.free;
  const [permissions, setPermissions] = useState<Record<string, boolean>>({
    ...planDefaults,
  });

  useEffect(() => {
    const normalizedId = (subscriptionPlan || "free").toLowerCase();
    const defaults =
      DEFAULT_PLAN_PERMISSIONS[normalizedId] || DEFAULT_PLAN_PERMISSIONS.free;
    const planRef = doc(db, "subscriptionPlans", normalizedId);
    const unsubscribe = onSnapshot(
      planRef,
      (snap) => {
        if (snap.exists()) {
          const data = snap.data();
          if (data.permissions && Object.keys(data.permissions).length > 0) {
            // Merge: plan defaults first, then Firestore overrides
            setPermissions({ ...defaults, ...data.permissions });
          } else {
            setPermissions({ ...defaults });
          }
        } else {
          setPermissions({ ...defaults });
        }
      },
      () => {
        setPermissions({ ...defaults });
      },
    );
    return () => unsubscribe();
  }, [planId]);

  const hasPermission = (flag: string): boolean => {
    if (flag in permissions) return permissions[flag];
    // Fall back to plan defaults, not true
    return planDefaults[flag] ?? false;
  };
  return { permissions, hasPermission };
}

// ─────────────────────────────────────────────────────────
// SubscriptionUpgradeModal
// ─────────────────────────────────────────────────────────
const PLAN_ORDER = ["free", "standard", "pro", "enterprise"];
const PLAN_META: Record<
  string,
  { name: string; color: string; features: string[] }
> = {
  standard: {
    name: "Standard",
    color: "#F4C430",
    features: [
      "Up to 50 custom job notifications per day",
      "Priority in search results",
      "Advanced filtering options",
      "Resume visibility boost",
      "Ad-free experience",
    ],
  },
  pro: {
    name: "Pro",
    color: "#7C3AED",
    features: [
      "Post unlimited job ads",
      "Accept and manage resumes",
      "Detailed job market statistics",
      "Applicant tracking system",
      "Company branding & logo display",
      "Featured job placements",
      "Priority support & account manager",
    ],
  },
  enterprise: {
    name: "Enterprise",
    color: "#1A365D",
    features: [
      "Post unlimited job ads",
      "Access Talent Pool",
      "Analytics dashboard",
      "Manage applications",
      "Company branding",
    ],
  },
};

function getNextTier(currentPlan?: string | null): {
  id: string;
  name: string;
  color: string;
  features: string[];
} {
  const plan = (currentPlan || "free").toLowerCase();
  const idx = PLAN_ORDER.indexOf(plan);
  // Pick the next tier up, or enterprise if already at top / unknown
  const nextId =
    idx >= 0 && idx < PLAN_ORDER.length - 1
      ? PLAN_ORDER[idx + 1]
      : "enterprise";
  return { id: nextId, ...(PLAN_META[nextId] || PLAN_META.enterprise) };
}

function SubscriptionUpgradeModal({
  visible,
  onClose,
  featureLabel,
  navigation,
  isDarkMode,
  currentPlan,
  currentLanguage = "en",
}: any) {
  const colors = isDarkMode ? darkColors : lightColors;
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const tier = getNextTier(currentPlan);
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <TouchableOpacity
        style={{
          flex: 1,
          backgroundColor: "rgba(0,0,0,0.55)",
          justifyContent: "center",
          alignItems: "center",
        }}
        activeOpacity={1}
        onPress={onClose}
      >
        <TouchableOpacity
          activeOpacity={1}
          style={{
            width: "88%",
            maxWidth: 420,
            backgroundColor: isDarkMode ? "#1F2937" : "#FFFFFF",
            borderRadius: 20,
            padding: 28,
            alignItems: "center",
          }}
        >
          <View
            style={{
              width: 64,
              height: 64,
              borderRadius: 20,
              backgroundColor: isDarkMode
                ? `${tier.color}22`
                : `${tier.color}18`,
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 16,
            }}
          >
            <Icon name="lock" size={32} color={tier.color} />
          </View>
          <Text
            style={{
              fontSize: 20,
              fontFamily: fonts.bold,
              color: isDarkMode ? "#F3F4F6" : "#111827",
              marginBottom: 8,
              textAlign: "center",
            }}
          >
            {tier.name} Feature
          </Text>
          <Text
            style={{
              fontSize: 14,
              fontFamily: fonts.regular,
              color: isDarkMode ? "#9CA3AF" : "#6B7280",
              textAlign: "center",
              marginBottom: 20,
              lineHeight: 22,
            }}
          >
            {featureLabel
              ? `"${featureLabel}" requires`
              : "This feature requires"}{" "}
            the {tier.name} plan or higher.
          </Text>
          {tier.features.map((f: string, i: number) => (
            <View
              key={i}
              style={{
                flexDirection: "row",
                alignItems: "center",
                alignSelf: "flex-start",
                marginBottom: 8,
              }}
            >
              <Icon
                name="check-circle"
                size={16}
                color="#10B981"
                style={{ marginRight: 8 }}
              />
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.regular,
                  color: isDarkMode ? "#D1D5DB" : "#374151",
                }}
              >
                {f}
              </Text>
            </View>
          ))}
          <TouchableOpacity
            onPress={() => {
              onClose();
              navigation?.navigate("SettingsSubscription");
            }}
            style={{
              marginTop: 20,
              width: "100%",
              backgroundColor: tier.color,
              borderRadius: 12,
              paddingVertical: 14,
              alignItems: "center",
            }}
          >
            <Text
              style={{ fontSize: 15, fontFamily: fonts.bold, color: "#FFFFFF" }}
            >
              Upgrade to {tier.name}
            </Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={onClose} style={{ marginTop: 12 }}>
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.regular,
                color: isDarkMode ? "#9CA3AF" : "#6B7280",
              }}
            >
              {t.notNow}
            </Text>
          </TouchableOpacity>
        </TouchableOpacity>
      </TouchableOpacity>
    </Modal>
  );
}

// Login Screen
function LoginScreen({ navigation, route, currentLanguage }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const initialEmail = route?.params?.prefillEmail || "";
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [rememberMe, setRememberMe] = useState(true);

  // Responsive design
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 480;
  const isTablet = dimensions.width >= 480 && dimensions.width < 768;
  const isDesktop = dimensions.width >= 768;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  // On Android, pressing hardware back from Login exits the app instead of showing Home
  useEffect(() => {
    if (Platform.OS === "android") {
      const backHandler = BackHandler.addEventListener(
        "hardwareBackPress",
        () => {
          BackHandler.exitApp();
          return true;
        },
      );
      return () => backHandler.remove();
    }
  }, []);

  const handleLogin = async () => {
    if (!email || !password) {
      setErrorMessage(t.fillAllFields || "Please fill in all fields");
      return;
    }

    setErrorMessage(""); // Clear any previous errors
    setLoading(true);
    try {
      // Set persistence based on Remember Me
      if (Platform.OS === "web") {
        const {
          setPersistence: webSetPersistence,
          browserLocalPersistence: localPersist,
          browserSessionPersistence: sessionPersist,
        } = require("firebase/auth");
        await webSetPersistence(
          auth,
          rememberMe ? localPersist : sessionPersist,
        );
      }
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password,
      );
      const user = userCredential.user;

      // Reload user to get latest email verification status
      await user.reload();
      const updatedUser = auth.currentUser;

      // Check if email is verified
      if (!updatedUser?.emailVerified) {
        // User hasn't verified their email
        // Don't sign out - keep them signed in to resend verification
        navigation.navigate("VerificationRequired", {
          userEmail: email,
          keepSignedIn: true,
        });
        setLoading(false);
        return;
      }

      // Update isVerified in Firestore if email is verified but DB shows false
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists()) {
        const userData = userDoc.data();

        console.log("User data from Firestore:", {
          role: userData.role,
          isVerified: userData.isVerified,
          isActive: userData.isActive,
        });

        // Update isVerified if it's false but email is verified
        if (!userData.isVerified && updatedUser.emailVerified) {
          await updateDoc(doc(db, "users", user.uid), {
            isVerified: true,
            updatedAt: new Date(),
          });
          userData.isVerified = true; // Update local reference so redirect logic below sees correct value
          console.log("✅ Updated isVerified to true in Firestore");
        }

        // Check user role and redirect accordingly
        if (userData.role === "superadmin") {
          console.log("Navigating to AdminPanel");
          navigation.replace("AdminPanel");
        } else if (userData.isVerified && userData.isActive) {
          // Check if profile setup is complete
          if (!userData.profileSetupComplete && userData.role === "user") {
            console.log("Navigating to ProfileSetup");
            navigation.replace("ProfileSetup", { userId: user.uid });
          } else {
            // Verified and active users go to Jobs page
            console.log("Navigating to Jobs page");
            navigation.replace("Jobs");
          }
        } else if (!userData.isActive) {
          Alert.alert(
            "Account Inactive",
            "Your account has been deactivated. Please contact support.",
          );
          await signOut(auth);
        } else {
          Alert.alert("Access Denied", "Please verify your email to continue");
          await signOut(auth);
        }
      } else {
        console.error("User profile not found in Firestore");
        Alert.alert("Error", "User profile not found");
        await signOut(auth);
      }
    } catch (error: any) {
      console.error("Login error:", error);

      // Provide user-friendly error messages
      let errorMessage = "An unexpected error occurred. Please try again.";

      if (error.code) {
        switch (error.code) {
          case "auth/invalid-email":
            errorMessage = "Invalid email address. Please check and try again.";
            break;
          case "auth/user-disabled":
            errorMessage =
              "This account has been disabled. Please contact support.";
            break;
          case "auth/user-not-found":
            errorMessage =
              "No account found with this email. Please sign up first.";
            break;
          case "auth/wrong-password":
            errorMessage = "Incorrect password. Please try again.";
            break;
          case "auth/invalid-credential":
            errorMessage =
              "Invalid email or password. Please check your credentials and try again.";
            break;
          case "auth/too-many-requests":
            errorMessage =
              "Too many failed login attempts. Please try again later or reset your password.";
            break;
          case "auth/network-request-failed":
            errorMessage =
              "Network error. Please check your internet connection.";
            break;
          case "auth/operation-not-allowed":
            errorMessage =
              "Email/password login is not enabled. Please contact support.";
            break;
          case "auth/weak-password":
            errorMessage =
              "Password is too weak. Please use a stronger password.";
            break;
          default:
            // For any other error codes, show a generic message
            errorMessage = error.message || errorMessage;
        }
      } else {
        errorMessage = error.message || errorMessage;
      }

      setErrorMessage(errorMessage);
    }
    setLoading(false);
  };

  const handleGoogleLogin = async () => {
    try {
      let user;

      if (Platform.OS === "web") {
        // Web: Use signInWithPopup
        console.log("🌐 Using web Google Sign-In for login");

        // Use the global auth instance
        const authInstance = auth;
        console.log("Auth instance:", authInstance);

        const provider = new GoogleAuthProvider();
        provider.addScope("profile");
        provider.addScope("email");
        provider.setCustomParameters({
          prompt: "select_account",
        });

        console.log("Calling signInWithPopup with explicit resolver...");
        const result = await signInWithPopup(
          authInstance,
          provider,
          browserPopupRedirectResolver,
        );
        console.log("Sign-in successful:", result);
        user = result.user;
      } else {
        // Mobile: Use native Google Sign-In
        if (!GoogleSignin) {
          console.error("GoogleSignin is null - module failed to load");
          Alert.alert(
            "Setup Required",
            "Google Sign-In is not properly configured for mobile. Please rebuild the app or use email/password sign-in.",
            [{ text: "OK", style: "default" }],
          );
          return;
        }

        console.log("Checking Play Services...");
        await GoogleSignin.hasPlayServices();
        console.log("Initiating Google Sign-In...");
        const userInfo = await GoogleSignin.signIn();
        console.log(
          "Google Sign-In successful, userInfo:",
          JSON.stringify(userInfo, null, 2),
        );

        // Extract idToken from the response (check both possible locations)
        const idToken = userInfo.data?.idToken || userInfo.idToken;
        console.log("Extracted idToken:", idToken ? "present" : "missing");

        if (!idToken) {
          throw new Error("No ID token received from Google Sign-In");
        }

        console.log("Creating Firebase credential...");
        const googleCredential = GoogleAuthProvider.credential(idToken);
        const result = await signInWithCredential(auth, googleCredential);
        user = result.user;
      }

      // User signed in successfully
      console.log("Google Sign-In successful:", user.uid);

      // Reload user to get latest email verification status
      await user.reload();
      const updatedUser = auth.currentUser;

      // Check if email is verified (Google accounts are usually auto-verified)
      if (!updatedUser?.emailVerified) {
        Alert.alert(
          "Email Not Verified",
          "Please verify your email before signing in. Check your inbox for the verification link.",
          [{ text: "OK" }],
        );
        await signOut(auth);
        return;
      }

      // Check user profile and navigate accordingly
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists()) {
        const userData = userDoc.data();

        // Update isVerified in Firestore if email is verified but DB shows false
        if (!userData.isVerified && updatedUser.emailVerified) {
          await updateDoc(doc(db, "users", user.uid), {
            isVerified: true,
            updatedAt: new Date(),
          });
          userData.isVerified = true; // Update local reference so redirect logic below sees correct value
          console.log("✅ Updated isVerified to true in Firestore");
        }

        // Check if account is active
        if (!userData.isActive) {
          Alert.alert(
            "Account Inactive",
            "Your account has been deactivated. Please contact support.",
          );
          await signOut(auth);
          return;
        }

        // Check user role and redirect accordingly
        if (userData.role === "superadmin") {
          console.log("Navigating to AdminPanel");
          navigation.replace("AdminPanel");
        } else if (userData.isVerified && userData.isActive) {
          // Check if profile setup is complete
          if (!userData.profileSetupComplete && userData.role === "user") {
            console.log("Navigating to ProfileSetup for Google user");
            navigation.replace("ProfileSetup", { userId: user.uid });
          } else {
            console.log("Navigating to Jobs page");
            navigation.replace("Jobs");
          }
        } else {
          console.log("Navigating to Jobs page");
          navigation.replace("Jobs");
        }
      } else {
        // New Google user - create user profile with notification settings enabled
        console.log("New Google user, creating profile...");

        // Generate username from display name or email
        const displayName =
          user.displayName || user.email?.split("@")[0] || "User";
        const generatedUsername = await generateUniqueUsername(displayName);

        await setDoc(doc(db, "users", user.uid), {
          uid: user.uid,
          email: user.email,
          displayName: displayName,
          username: generatedUsername,
          role: "user",
          subscriptionId: "free",
          subscriptionStatus: "active",
          subscriptionStartDate: new Date(),
          subscriptionEndDate: null,
          isVerified: updatedUser.emailVerified || true, // Google accounts are usually verified
          isActive: true,
          lastLogin: new Date(),
          permissions: [],
          profile: {
            avatar: user.photoURL || "",
            bio: "",
            phone: "",
          },
          fcmTokens: [],
          selectedCategories: [],
          selectedTags: [],
          interestedTags: [],
          // Notification preferences - enabled by default for better user engagement
          isNotificationsEnabled: true,
          isPushNotificationsEnabled: true,
          isEmailNotificationsEnabled: true,
          emailNotifications: true,
          pushNotifications: true,
          jobAlerts: true,
          applicationUpdates: true,
          notificationPreferences: {
            newJobs: true,
            applicationUpdates: true,
          },
          profileSetupComplete: false,
          createdAt: new Date(),
          updatedAt: new Date(),
        });

        console.log("✅ User profile created for Google user");
        console.log("Navigating to ProfileSetup for new Google user");
        navigation.replace("ProfileSetup", { userId: user.uid });
      }
    } catch (error: any) {
      console.error("Google Login Error:", error);

      // Handle different error cases
      if (error.code === "auth/account-exists-with-different-credential") {
        const emailFromError = error.customData?.email || error.email || "";
        Alert.alert(
          "Account Exists",
          "An account already exists with this email. Please sign in using your email and password.",
          [
            { text: "Cancel", style: "cancel" },
            {
              text: "Go to Login",
              onPress: () =>
                navigation.navigate("Login", { prefillEmail: emailFromError }),
            },
          ],
        );
      } else if (error.code === "-5") {
        // User cancelled the sign-in
        console.log("User cancelled Google Sign-In");
      } else {
        Alert.alert(
          "Google Login Failed",
          error.message || "An error occurred during Google Sign-In",
        );
      }
    }
  };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: "#FAFBFC" }}>
      {isDesktop ? (
        /* ── Desktop: Modern Two-Column Layout ────────────────────────────────── */
        <View
          style={{
            flex: 1,
            flexDirection: "row",
            minHeight: dimensions.height,
          }}
        >
          {/* Brand Panel - Modern Gradient */}
          <View
            style={{
              width: "48%",
              background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
              justifyContent: "center",
              alignItems: "center",
              padding: 64,
              position: "relative",
            }}
          >
            {/* Decorative Elements */}
            <View
              style={{
                position: "absolute",
                top: 40,
                right: 40,
                width: 120,
                height: 120,
                borderRadius: 60,
                backgroundColor: "rgba(244,196,48,0.08)",
              }}
            />
            <View
              style={{
                position: "absolute",
                bottom: 60,
                left: 60,
                width: 80,
                height: 80,
                borderRadius: 40,
                backgroundColor: "rgba(244,196,48,0.06)",
              }}
            />

            {/* Logo with modern styling */}
            <View
              style={{
                width: 96,
                height: 96,
                borderRadius: 28,
                background: "linear-gradient(135deg, #F4C430 0%, #F59E0B 100%)",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 32,
                shadowColor: "#F4C430",
                shadowOffset: { width: 0, height: 12 },
                shadowOpacity: 0.4,
                shadowRadius: 24,
                elevation: 12,
              }}
            >
              <Image
                source={require("./assets/favicon.png")}
                style={{ width: 60, height: 60 }}
                resizeMode="contain"
              />
            </View>

            <Text
              style={{
                fontSize: 44,
                fontFamily: fonts.bold,
                color: "#FFFFFF",
                marginBottom: 12,
                letterSpacing: -1,
              }}
            >
              NibJobs
            </Text>
            <Text
              style={{
                fontSize: 18,
                fontFamily: fonts.regular,
                color: "#94A3B8",
                textAlign: "center",
                lineHeight: 28,
                maxWidth: 380,
                marginBottom: 56,
              }}
            >
              {t.loginTagline}
            </Text>

            {/* Feature cards */}
            <View style={{ gap: 16, width: "100%", maxWidth: 340 }}>
              {[
                {
                  icon: "work",
                  label: t.loginActiveJobsLabel,
                  desc: t.loginActiveJobsDesc,
                },
                {
                  icon: "business",
                  label: t.loginTopCompaniesLabel,
                  desc: t.loginTopCompaniesDesc,
                },
                {
                  icon: "notifications-active",
                  label: t.loginInstantAlertsLabel,
                  desc: t.loginInstantAlertsDesc,
                },
              ].map((f, i) => (
                <View
                  key={i}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 16,
                    backgroundColor: "rgba(255,255,255,0.05)",
                    padding: 18,
                    borderRadius: 16,
                    borderWidth: 1,
                    borderColor: "rgba(255,255,255,0.08)",
                  }}
                >
                  <View
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 14,
                      backgroundColor: "rgba(244,196,48,0.15)",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name={f.icon} size={24} color="#F4C430" />
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 16,
                        fontFamily: fonts.semiBold,
                        color: "#F1F5F9",
                      }}
                    >
                      {f.label}
                    </Text>
                    <Text
                      style={{ fontSize: 13, color: "#64748B", marginTop: 2 }}
                    >
                      {f.desc}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          </View>

          {/* Form Panel - Modern Card-Based */}
          <ScrollView
            style={{ flex: 1, backgroundColor: "#FAFBFC" }}
            contentContainerStyle={{
              flexGrow: 1,
              justifyContent: "center",
              alignItems: "center",
              paddingHorizontal: 64,
              paddingVertical: 60,
            }}
            showsVerticalScrollIndicator={false}
            keyboardShouldPersistTaps="handled"
          >
            <View style={{ width: "100%", maxWidth: 480 }}>
              {/* Modern Header */}
              <View style={{ alignItems: "center", marginBottom: 40 }}>
                <View
                  style={{
                    width: 64,
                    height: 64,
                    borderRadius: 18,
                    background:
                      "linear-gradient(135deg, #F4C430 0%, #F59E0B 100%)",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 24,
                    shadowColor: "#F4C430",
                    shadowOffset: { width: 0, height: 8 },
                    shadowOpacity: 0.25,
                    shadowRadius: 16,
                    elevation: 8,
                  }}
                >
                  <Image
                    source={require("./assets/favicon.png")}
                    style={{ width: 40, height: 40 }}
                    resizeMode="contain"
                  />
                </View>
                <Text
                  style={{
                    fontSize: 32,
                    fontFamily: fonts.bold,
                    color: "#0F172A",
                    marginBottom: 8,
                    letterSpacing: -0.5,
                  }}
                >
                  {t.signInTitle}
                </Text>
                <Text
                  style={{
                    fontSize: 16,
                    color: "#64748B",
                    textAlign: "center",
                    lineHeight: 24,
                  }}
                >
                  {t.signInSubtitle}
                </Text>
              </View>

              {/* Error Banner */}
              {errorMessage && (
                <View
                  style={{
                    backgroundColor: "#FEE2E2",
                    borderRadius: 14,
                    padding: 16,
                    marginBottom: 24,
                    flexDirection: "row",
                    alignItems: "flex-start",
                    gap: 12,
                    borderWidth: 1,
                    borderColor: "#FCA5A5",
                  }}
                >
                  <Icon name="error-outline" size={22} color="#DC2626" />
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 14,
                      color: "#991B1B",
                      lineHeight: 20,
                    }}
                  >
                    {errorMessage}
                  </Text>
                  <TouchableOpacity
                    onPress={() => setErrorMessage("")}
                    style={{ padding: 2 }}
                  >
                    <Icon name="close" size={18} color="#DC2626" />
                  </TouchableOpacity>
                </View>
              )}
              {/* Modern Form Card */}
              <View
                style={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: 20,
                  padding: 32,
                  shadowColor: "#0F172A",
                  shadowOffset: { width: 0, height: 4 },
                  shadowOpacity: 0.08,
                  shadowRadius: 24,
                  elevation: 4,
                  borderWidth: 1,
                  borderColor: "#E2E8F0",
                }}
              >
                {/* Email Input */}
                <View style={{ marginBottom: 20 }}>
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.semiBold,
                      color: "#1E293B",
                      marginBottom: 8,
                    }}
                  >
                    {t.emailAddress}
                  </Text>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      backgroundColor: "#F8FAFC",
                      borderRadius: 12,
                      paddingHorizontal: 16,
                      paddingVertical: 14,
                      borderWidth: 1.5,
                      borderColor: email ? "#F4C430" : "#E2E8F0",
                    }}
                  >
                    <Icon
                      name="email"
                      size={20}
                      color={email ? "#F4C430" : "#94A3B8"}
                      style={{ marginRight: 12 }}
                    />
                    <TextInput
                      style={{
                        flex: 1,
                        fontSize: 15,
                        fontFamily: fonts.regular,
                        color: "#0F172A",
                      }}
                      value={email}
                      onChangeText={setEmail}
                      placeholder="you@example.com"
                      placeholderTextColor="#94A3B8"
                      keyboardType="email-address"
                      autoCapitalize="none"
                    />
                  </View>
                </View>

                {/* Password Input */}
                <View style={{ marginBottom: 12 }}>
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.semiBold,
                      color: "#1E293B",
                      marginBottom: 8,
                    }}
                  >
                    {t.password}
                  </Text>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      backgroundColor: "#F8FAFC",
                      borderRadius: 12,
                      paddingHorizontal: 16,
                      paddingVertical: 14,
                      borderWidth: 1.5,
                      borderColor: password ? "#F4C430" : "#E2E8F0",
                    }}
                  >
                    <Icon
                      name="lock"
                      size={20}
                      color={password ? "#F4C430" : "#94A3B8"}
                      style={{ marginRight: 12 }}
                    />
                    <TextInput
                      style={{
                        flex: 1,
                        fontSize: 15,
                        fontFamily: fonts.regular,
                        color: "#0F172A",
                      }}
                      value={password}
                      onChangeText={setPassword}
                      placeholder="Enter your password"
                      placeholderTextColor="#94A3B8"
                      secureTextEntry={!showPassword}
                    />
                    <TouchableOpacity
                      onPress={() => setShowPassword(!showPassword)}
                      style={{ padding: 4 }}
                    >
                      <Icon
                        name={showPassword ? "visibility" : "visibility-off"}
                        size={20}
                        color="#94A3B8"
                      />
                    </TouchableOpacity>
                  </View>
                </View>

                {/* Remember Me + Forgot Password row */}
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 24,
                  }}
                >
                  <TouchableOpacity
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 8,
                    }}
                    onPress={() => setRememberMe(!rememberMe)}
                  >
                    <View
                      style={{
                        width: 18,
                        height: 18,
                        borderRadius: 4,
                        borderWidth: 2,
                        borderColor: rememberMe ? "#F4C430" : "#CBD5E1",
                        backgroundColor: rememberMe ? "#F4C430" : "transparent",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {rememberMe && (
                        <Icon name="check" size={12} color="#1A1D23" />
                      )}
                    </View>
                    <Text
                      style={{
                        fontSize: 14,
                        fontFamily: fonts.regular,
                        color: "#475569",
                      }}
                    >
                      Remember me
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => navigation.navigate("ForgotPassword")}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontFamily: fonts.semiBold,
                        color: "#F59E0B",
                      }}
                    >
                      {t.forgotPassword}
                    </Text>
                  </TouchableOpacity>
                </View>

                {/* Sign In Button */}
                <TouchableOpacity
                  style={[
                    {
                      background: loading
                        ? "#CBD5E1"
                        : "linear-gradient(135deg, #F4C430 0%, #F59E0B 100%)",
                      paddingVertical: 16,
                      borderRadius: 12,
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      shadowColor: loading ? "transparent" : "#F4C430",
                      shadowOffset: { width: 0, height: 6 },
                      shadowOpacity: 0.3,
                      shadowRadius: 12,
                      elevation: 6,
                    },
                  ]}
                  onPress={handleLogin}
                  disabled={loading}
                >
                  {loading ? (
                    <View style={styles.authButtonContent}>
                      <ActivityIndicator
                        size="small"
                        color="#1A1D23"
                        style={{ marginRight: 8 }}
                      />
                      <Text style={styles.authPrimaryButtonText}>
                        {t.signingIn}
                      </Text>
                    </View>
                  ) : (
                    <View style={styles.authButtonContent}>
                      <Text style={styles.authPrimaryButtonText}>
                        {t.signInButton}
                      </Text>
                      <Icon name="arrow-forward" size={20} color="#1A1D23" />
                    </View>
                  )}
                </TouchableOpacity>
                <View style={styles.authDivider}>
                  <View style={styles.authDividerLine} />
                  <Text style={styles.authDividerText}>{t.orContinueWith}</Text>
                  <View style={styles.authDividerLine} />
                </View>
                <TouchableOpacity
                  style={styles.authGoogleButton}
                  onPress={handleGoogleLogin}
                >
                  <View style={styles.googleIconContainer}>
                    <Text style={styles.googleIconText}>G</Text>
                  </View>
                  <Text style={styles.authGoogleButtonText}>
                    {t.signInWithGoogle}
                  </Text>
                </TouchableOpacity>
                <View style={styles.authFooterLink}>
                  <Text style={styles.authFooterLinkText}>
                    {t.dontHaveAccount}
                  </Text>
                  <TouchableOpacity
                    onPress={() => navigation.navigate("Signup")}
                  >
                    <Text style={styles.authFooterLinkHighlight}>
                      {" "}
                      {t.signUpLink}
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
              <TouchableOpacity
                style={styles.authBackButton}
                onPress={() => navigation.navigate("Home")}
              >
                <Icon
                  name="arrow-back"
                  size={18}
                  color={lightColors.warmGray}
                />
                <Text style={styles.authBackButtonText}>{t.backToHome}</Text>
              </TouchableOpacity>
            </View>
          </ScrollView>
        </View>
      ) : (
        /* Mobile */
        <KeyboardAvoidingView
          style={{ flex: 1, backgroundColor: "#F8FAFC" }}
          behavior={Platform.OS === "ios" ? "padding" : undefined}
        >
          {/* Dark header — matches side menu */}
          <View
            style={{
              backgroundColor: "#0F1117",
              paddingTop: 52,
              paddingBottom: 28,
              paddingHorizontal: 20,
              alignItems: "center",
            }}
          >
            <TouchableOpacity
              onPress={() => navigation.replace("Jobs")}
              style={{ position: "absolute", top: 52, left: 16, padding: 8 }}
            >
              <Icon name="arrow-back" size={22} color="#6B7280" />
            </TouchableOpacity>
            <View
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                backgroundColor: "#F4C430",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 12,
              }}
            >
              <Image
                source={require("./assets/favicon.png")}
                style={{ width: 28, height: 28 }}
                resizeMode="contain"
              />
            </View>
            <Text
              style={{
                fontSize: 22,
                fontFamily: fonts.bold,
                color: "#F9FAFB",
                marginBottom: 3,
              }}
            >
              {t.signInTitle}
            </Text>
            <Text
              style={{ fontSize: 13, color: "#6B7280", textAlign: "center" }}
            >
              {t.signInSubtitle}
            </Text>
          </View>
          {/* Form */}
          <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={{
              paddingHorizontal: 20,
              paddingTop: 22,
              paddingBottom: 20,
            }}
            showsVerticalScrollIndicator={false}
            keyboardShouldPersistTaps="handled"
          >
            {errorMessage ? (
              <View
                style={{
                  backgroundColor: "#FEF2F2",
                  borderRadius: 10,
                  padding: 12,
                  marginBottom: 14,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 8,
                  borderWidth: 1,
                  borderColor: "#FCA5A5",
                }}
              >
                <Icon name="error-outline" size={16} color="#DC2626" />
                <Text style={{ flex: 1, fontSize: 13, color: "#991B1B" }}>
                  {errorMessage}
                </Text>
                <TouchableOpacity onPress={() => setErrorMessage("")}>
                  <Icon name="close" size={15} color="#DC2626" />
                </TouchableOpacity>
              </View>
            ) : null}
            {/* Email */}
            <View
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: 12,
                flexDirection: "row",
                alignItems: "center",
                paddingHorizontal: 14,
                paddingVertical: 13,
                gap: 10,
                borderWidth: 1,
                borderColor: email ? "#F4C430" : "#E5E7EB",
                marginBottom: 10,
              }}
            >
              <Icon
                name="email"
                size={18}
                color={email ? "#F4C430" : "#9CA3AF"}
              />
              <TextInput
                style={{
                  flex: 1,
                  fontSize: 15,
                  fontFamily: fonts.regular,
                  color: "#0F172A",
                  padding: 0,
                }}
                value={email}
                onChangeText={setEmail}
                placeholder={t.emailAddress}
                placeholderTextColor="#9CA3AF"
                keyboardType="email-address"
                autoCapitalize="none"
              />
            </View>
            {/* Password */}
            <View
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: 12,
                flexDirection: "row",
                alignItems: "center",
                paddingHorizontal: 14,
                paddingVertical: 13,
                gap: 10,
                borderWidth: 1,
                borderColor: password ? "#F4C430" : "#E5E7EB",
                marginBottom: 6,
              }}
            >
              <Icon
                name="lock"
                size={18}
                color={password ? "#F4C430" : "#9CA3AF"}
              />
              <TextInput
                style={{
                  flex: 1,
                  fontSize: 15,
                  fontFamily: fonts.regular,
                  color: "#0F172A",
                  padding: 0,
                }}
                value={password}
                onChangeText={setPassword}
                placeholder={t.password}
                placeholderTextColor="#9CA3AF"
                secureTextEntry={!showPassword}
              />
              <TouchableOpacity
                onPress={() => setShowPassword(!showPassword)}
                hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
              >
                <Icon
                  name={showPassword ? "visibility" : "visibility-off"}
                  size={18}
                  color="#9CA3AF"
                />
              </TouchableOpacity>
            </View>
            {/* Remember Me + Forgot Password row */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingVertical: 8,
                marginBottom: 16,
              }}
            >
              <TouchableOpacity
                style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
                onPress={() => setRememberMe(!rememberMe)}
              >
                <View
                  style={{
                    width: 16,
                    height: 16,
                    borderRadius: 4,
                    borderWidth: 2,
                    borderColor: rememberMe ? "#F4C430" : "#D1D5DB",
                    backgroundColor: rememberMe ? "#F4C430" : "transparent",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {rememberMe && (
                    <Icon name="check" size={10} color="#1A1D23" />
                  )}
                </View>
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.regular,
                    color: "#6B7280",
                  }}
                >
                  Remember me
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => navigation.navigate("ForgotPassword")}
              >
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.semiBold,
                    color: "#F4C430",
                  }}
                >
                  {t.forgotPassword}
                </Text>
              </TouchableOpacity>
            </View>
            {/* Sign In */}
            <TouchableOpacity
              style={[
                {
                  backgroundColor: "#F4C430",
                  paddingVertical: 13,
                  borderRadius: 12,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  marginBottom: 18,
                },
                loading && { opacity: 0.6 },
              ]}
              onPress={handleLogin}
              disabled={loading}
            >
              {loading ? (
                <>
                  <ActivityIndicator size="small" color="#1A1D23" />
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.bold,
                      color: "#1A1D23",
                    }}
                  >
                    {t.signingIn}
                  </Text>
                </>
              ) : (
                <>
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.bold,
                      color: "#1A1D23",
                    }}
                  >
                    {t.signInButton}
                  </Text>
                  <Icon name="arrow-forward" size={16} color="#1A1D23" />
                </>
              )}
            </TouchableOpacity>
            {/* Divider */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 14,
                gap: 10,
              }}
            >
              <View
                style={{ flex: 1, height: 1, backgroundColor: "#E5E7EB" }}
              />
              <Text
                style={{
                  fontSize: 11,
                  color: "#9CA3AF",
                  fontFamily: fonts.semiBold,
                  letterSpacing: 0.8,
                }}
              >
                {t.orContinueWith}
              </Text>
              <View
                style={{ flex: 1, height: 1, backgroundColor: "#E5E7EB" }}
              />
            </View>
            {/* Google */}
            <TouchableOpacity
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#FFFFFF",
                paddingVertical: 13,
                borderRadius: 12,
                borderWidth: 1,
                borderColor: "#E5E7EB",
                gap: 10,
                marginBottom: 22,
              }}
              onPress={handleGoogleLogin}
            >
              <View style={styles.googleIconContainer}>
                <Text style={styles.googleIconText}>G</Text>
              </View>
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.semiBold,
                  color: "#1A1D23",
                }}
              >
                {t.signInWithGoogle}
              </Text>
            </TouchableOpacity>
            {/* Sign up link */}
            <View style={{ flexDirection: "row", justifyContent: "center" }}>
              <Text style={{ fontSize: 14, color: "#6B7280" }}>
                {t.dontHaveAccount}
              </Text>
              <TouchableOpacity onPress={() => navigation.navigate("Signup")}>
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    color: "#0F172A",
                  }}
                >
                  {" "}
                  {t.signUpLink}
                </Text>
              </TouchableOpacity>
            </View>
          </ScrollView>
        </KeyboardAvoidingView>
      )}
    </SafeAreaView>
  );
}

// Verification Required Screen
function VerificationRequiredScreen({
  route,
  navigation,
  currentLanguage = "en",
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const { userEmail, keepSignedIn } = route.params || {};
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  // Sign out when navigating back to login or home
  const handleBackToLogin = async () => {
    if (auth.currentUser) {
      await signOut(auth);
    }
    navigation.navigate("Login");
  };

  const handleBackToHome = async () => {
    if (auth.currentUser) {
      await signOut(auth);
    }
    Platform.OS !== "web"
      ? navigation.replace("Jobs")
      : navigation.navigate("Home");
  };

  const handleResendEmail = async () => {
    if (!userEmail) {
      Alert.alert("Error", "Email address is required");
      return;
    }

    setLoading(true);

    try {
      const user = auth.currentUser;

      if (!user) {
        Alert.alert(
          "Error",
          "You need to be signed in to resend verification email. Please try logging in again.",
        );
        setLoading(false);
        navigation.navigate("Login");
        return;
      }

      // Send verification email with action code settings
      const isProduction = window.location.hostname !== "localhost";
      const redirectUrl = isProduction
        ? "https://nibjobs-dev.web.app/login"
        : "http://localhost:19006/login";

      await sendEmailVerification(user, {
        url: redirectUrl,
        handleCodeInApp: false,
      });

      setEmailSent(true);

      Alert.alert(
        "Email Sent!",
        `A new verification email has been sent to ${userEmail}. Please check your inbox and spam folder.`,
        [{ text: "OK" }],
      );
    } catch (error: any) {
      console.error("Error resending verification email:", error);

      let errorMessage = "Failed to send verification email. Please try again.";

      if (error.code === "auth/too-many-requests") {
        errorMessage =
          "Too many requests. Please wait a moment before trying again.";
      }

      Alert.alert("Error", errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView contentContainerStyle={styles.loginContainer}>
        <View style={styles.loginHeader}>
          <Image
            source={require("./assets/favicon.png")}
            style={styles.loginLogoImage}
          />
          <Text style={styles.loginTitle}>NibJobs</Text>
          <Text style={styles.loginSubtitle}>
            {t.emailVerificationRequired}
          </Text>
        </View>

        <View style={styles.loginForm}>
          <View style={styles.verificationMessageContainer}>
            <Icon
              name="mail-outline"
              size={64}
              color={lightColors.beeYellow}
              style={{ marginBottom: 20 }}
            />
            <Text style={styles.verificationTitle}>{t.emailNotVerified}</Text>
            <Text style={styles.verificationMessage}>
              Your email address has not been verified yet.
            </Text>
            {userEmail && (
              <Text style={styles.verificationEmail}>{userEmail}</Text>
            )}
            <Text style={styles.verificationMessage}>
              Please check your inbox (and spam folder) for the verification
              email and click the link to verify your account.
            </Text>

            {emailSent && (
              <View style={styles.successMessageContainer}>
                <Icon
                  name="check-circle"
                  size={20}
                  color={lightColors.success}
                  style={{ marginRight: 8 }}
                />
                <Text style={styles.successMessageText}>
                  Verification email sent! Check your inbox.
                </Text>
              </View>
            )}

            <TouchableOpacity
              style={[
                styles.modernLoginButton,
                loading && styles.buttonDisabled,
              ]}
              onPress={handleResendEmail}
              disabled={loading}
            >
              <View style={styles.buttonContent}>
                {loading ? (
                  <ActivityIndicator
                    size="small"
                    color={lightColors.deepNavy}
                  />
                ) : (
                  <>
                    <Icon
                      name="email"
                      size={20}
                      color={lightColors.deepNavy}
                      style={{ marginRight: 8 }}
                    />
                    <Text style={styles.modernLoginButtonText}>
                      Resend Verification Email
                    </Text>
                  </>
                )}
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              style={[styles.modernSecondaryButton, { marginTop: 40 }]}
              onPress={handleBackToLogin}
            >
              <Text style={styles.modernSecondaryButtonText}>
                Back to Login
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.backToHome}
              onPress={handleBackToHome}
            >
              <Icon name="arrow-back" size={16} color={lightColors.softBlue} />
              <Text style={styles.backToHomeText}>Back to Home</Text>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

// Forgot Password Screen
function ForgotPasswordScreen({ navigation, currentLanguage = "en" }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  // Responsive design
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 480;
  const isTablet = dimensions.width >= 480 && dimensions.width < 768;
  const isDesktop = dimensions.width >= 768;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  const handleResetPassword = async () => {
    if (!email) {
      Alert.alert("Error", "Please enter your email address");
      return;
    }

    setLoading(true);
    try {
      const actionCodeSettings = {
        url: `${window.location.origin}/login`,
        handleCodeInApp: false,
      };

      await sendPasswordResetEmail(auth, email, actionCodeSettings);
      setEmailSent(true);
    } catch (error: any) {
      if (error.code === "auth/user-not-found") {
        Alert.alert("Error", "No account found with this email address");
      } else if (error.code === "auth/invalid-email") {
        Alert.alert("Error", "Invalid email address");
      } else {
        Alert.alert(
          "Error",
          error.message || "Failed to send password reset email",
        );
      }
    }
    setLoading(false);
  };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: "#F9FAFB" }}>
      {isDesktop ? (
        /* ── Desktop: Two-Column Layout ────────────────────────────────── */
        <View
          style={{
            flex: 1,
            flexDirection: "row",
            minHeight: dimensions.height,
          }}
        >
          {/* Brand Panel */}
          <View
            style={{
              width: "44%",
              backgroundColor: "#1A1D23",
              justifyContent: "center",
              alignItems: "center",
              padding: 56,
            }}
          >
            <View
              style={{
                width: 80,
                height: 80,
                borderRadius: 24,
                backgroundColor: "#F4C430",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 28,
              }}
            >
              <Image
                source={require("./assets/favicon.png")}
                style={{ width: 50, height: 50 }}
                resizeMode="contain"
              />
            </View>
            <Text
              style={{
                fontSize: 40,
                fontFamily: fonts.bold,
                color: "#FFFFFF",
                marginBottom: 10,
                letterSpacing: -0.5,
              }}
            >
              NibJobs
            </Text>
            <Text
              style={{
                fontSize: 17,
                fontFamily: fonts.regular,
                color: "#9CA3AF",
                textAlign: "center",
                lineHeight: 27,
                maxWidth: 340,
              }}
            >
              {t.forgotTagline}
            </Text>
            <View
              style={{ marginTop: 48, gap: 20, width: "100%", maxWidth: 300 }}
            >
              {[
                { icon: "lock-reset", label: t.forgotSecureReset },
                { icon: "email", label: t.forgotCheckInbox },
                { icon: "verified-user", label: t.forgotAccountSafe },
              ].map((f, i) => (
                <View
                  key={i}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 14,
                  }}
                >
                  <View
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 12,
                      backgroundColor: "rgba(244,196,48,0.15)",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name={f.icon} size={20} color="#F4C430" />
                  </View>
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.regular,
                      color: "#D1D5DB",
                    }}
                  >
                    {f.label}
                  </Text>
                </View>
              ))}
            </View>
          </View>

          {/* Form Panel */}
          <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={{
              flexGrow: 1,
              justifyContent: "center",
              alignItems: "center",
              paddingHorizontal: 60,
              paddingVertical: 60,
            }}
            showsVerticalScrollIndicator={false}
            keyboardShouldPersistTaps="handled"
          >
            <View style={{ width: "100%", maxWidth: 440 }}>
              {emailSent ? (
                <View style={{ alignItems: "center" }}>
                  <View
                    style={{
                      width: 80,
                      height: 80,
                      borderRadius: 40,
                      backgroundColor: "rgba(244,196,48,0.15)",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 24,
                    }}
                  >
                    <Icon name="mark-email-read" size={40} color="#F4C430" />
                  </View>
                  <Text
                    style={{
                      fontSize: 26,
                      fontFamily: fonts.bold,
                      color: "#1A1D23",
                      marginBottom: 10,
                      textAlign: "center",
                    }}
                  >
                    Email Sent!
                  </Text>
                  <Text
                    style={{
                      fontSize: 15,
                      color: "#9CA3AF",
                      textAlign: "center",
                      lineHeight: 22,
                      marginBottom: 8,
                    }}
                  >
                    We've sent reset instructions to:
                  </Text>
                  <View
                    style={{
                      backgroundColor: "#F9FAFB",
                      borderRadius: 12,
                      paddingHorizontal: 20,
                      paddingVertical: 10,
                      borderWidth: 1,
                      borderColor: "#F0F0F0",
                      marginBottom: 32,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 15,
                        fontFamily: fonts.semiBold,
                        color: "#1A1D23",
                      }}
                    >
                      {email}
                    </Text>
                  </View>
                  <Text
                    style={{
                      fontSize: 14,
                      color: "#9CA3AF",
                      textAlign: "center",
                      lineHeight: 22,
                      marginBottom: 32,
                    }}
                  >
                    {t.checkInboxForReset}
                  </Text>
                  <TouchableOpacity
                    style={[styles.authPrimaryButton, { width: "100%" }]}
                    onPress={() => navigation.navigate("Login")}
                  >
                    <View style={styles.authButtonContent}>
                      <Text style={styles.authPrimaryButtonText}>
                        {t.backToLogin}
                      </Text>
                      <Icon name="arrow-forward" size={20} color="#1A1D23" />
                    </View>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={styles.authBackButton}
                    onPress={() => navigation.navigate("Home")}
                  >
                    <Icon
                      name="arrow-back"
                      size={18}
                      color={lightColors.warmGray}
                    />
                    <Text style={styles.authBackButtonText}>
                      {t.backToHome}
                    </Text>
                  </TouchableOpacity>
                </View>
              ) : (
                <>
                  <View style={styles.authHeaderSection}>
                    <View style={styles.authLogoContainer}>
                      <Image
                        source={require("./assets/favicon.png")}
                        style={styles.authLogoImage}
                        resizeMode="contain"
                      />
                    </View>
                    <Text style={styles.authTitle}>{t.resetPasswordTitle}</Text>
                    <Text style={styles.authSubtitle}>
                      {t.resetPasswordSubtitle}
                    </Text>
                  </View>
                  <View style={styles.authFormCard}>
                    <View style={styles.floatingInputContainer}>
                      <View
                        style={[
                          styles.floatingInputWrapper,
                          email && styles.floatingInputFocused,
                        ]}
                      >
                        <Icon
                          name="email"
                          size={20}
                          color={
                            email ? lightColors.beeYellow : lightColors.warmGray
                          }
                          style={styles.floatingInputIcon}
                        />
                        <View style={styles.floatingInputTextContainer}>
                          {email ? (
                            <Text style={styles.floatingLabel}>
                              {t.emailAddress}
                            </Text>
                          ) : null}
                          <TextInput
                            style={styles.floatingInput}
                            value={email}
                            onChangeText={setEmail}
                            placeholder={email ? "" : t.emailAddress}
                            placeholderTextColor={lightColors.warmGray}
                            keyboardType="email-address"
                            autoCapitalize="none"
                          />
                        </View>
                      </View>
                    </View>
                    <TouchableOpacity
                      style={[
                        styles.authPrimaryButton,
                        loading && styles.authButtonDisabled,
                      ]}
                      onPress={handleResetPassword}
                      disabled={loading}
                    >
                      {loading ? (
                        <View style={styles.authButtonContent}>
                          <ActivityIndicator
                            size="small"
                            color="#1A1D23"
                            style={{ marginRight: 8 }}
                          />
                          <Text style={styles.authPrimaryButtonText}>
                            {t.sendingReset}
                          </Text>
                        </View>
                      ) : (
                        <View style={styles.authButtonContent}>
                          <Text style={styles.authPrimaryButtonText}>
                            {t.sendResetLink}
                          </Text>
                          <Icon
                            name="arrow-forward"
                            size={20}
                            color="#1A1D23"
                          />
                        </View>
                      )}
                    </TouchableOpacity>
                    <View style={styles.authFooterLink}>
                      <TouchableOpacity
                        onPress={() => navigation.navigate("Login")}
                      >
                        <Text style={styles.authFooterLinkHighlight}>
                          {t.backToLogin}
                        </Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                  <TouchableOpacity
                    style={styles.authBackButton}
                    onPress={() => navigation.navigate("Home")}
                  >
                    <Icon
                      name="arrow-back"
                      size={18}
                      color={lightColors.warmGray}
                    />
                    <Text style={styles.authBackButtonText}>
                      {t.backToHome}
                    </Text>
                  </TouchableOpacity>
                </>
              )}
            </View>
          </ScrollView>
        </View>
      ) : /* Mobile: Clean Layout */
      emailSent ? (
        <ScrollView
          style={{ flex: 1, backgroundColor: "#F9FAFB" }}
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "center",
            paddingHorizontal: 28,
            paddingVertical: 48,
          }}
          showsVerticalScrollIndicator={false}
        >
          <View style={{ alignItems: "center" }}>
            <View
              style={{
                width: 88,
                height: 88,
                borderRadius: 28,
                backgroundColor: "rgba(244,196,48,0.12)",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 28,
                borderWidth: 1.5,
                borderColor: "rgba(244,196,48,0.25)",
              }}
            >
              <Icon name="mark-email-read" size={44} color="#F4C430" />
            </View>
            <Text
              style={{
                fontSize: 26,
                fontFamily: fonts.bold,
                color: "#1A1D23",
                marginBottom: 10,
                textAlign: "center",
              }}
            >
              Email Sent!
            </Text>
            <Text
              style={{
                fontSize: 15,
                color: "#9CA3AF",
                textAlign: "center",
                lineHeight: 24,
                marginBottom: 12,
              }}
            >
              Reset instructions sent to:
            </Text>
            <View
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: 14,
                paddingHorizontal: 22,
                paddingVertical: 12,
                borderWidth: 1,
                borderColor: "#E5E7EB",
                marginBottom: 16,
              }}
            >
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.semiBold,
                  color: "#1A1D23",
                }}
              >
                {email}
              </Text>
            </View>
            <Text
              style={{
                fontSize: 14,
                color: "#9CA3AF",
                textAlign: "center",
                lineHeight: 23,
                marginBottom: 36,
                paddingHorizontal: 8,
              }}
            >
              {t.checkInboxForReset}
            </Text>
            <TouchableOpacity
              style={{
                backgroundColor: "#F4C430",
                paddingVertical: 16,
                borderRadius: 14,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                width: "100%",
                marginBottom: 16,
                shadowColor: "#F4C430",
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: 0.3,
                shadowRadius: 10,
                elevation: 4,
              }}
              onPress={() => navigation.navigate("Login")}
            >
              <Text
                style={{
                  fontSize: 16,
                  fontFamily: fonts.bold,
                  color: "#1A1D23",
                }}
              >
                {t.backToLogin}
              </Text>
              <Icon name="arrow-forward" size={18} color="#1A1D23" />
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                paddingVertical: 12,
              }}
              onPress={() =>
                Platform.OS !== "web"
                  ? navigation.replace("Jobs")
                  : navigation.navigate("Home")
              }
            >
              <Icon name="arrow-back" size={16} color="#9CA3AF" />
              <Text style={{ fontSize: 14, color: "#9CA3AF", marginLeft: 6 }}>
                {Platform.OS !== "web" ? "Browse Jobs" : t.backToHome}
              </Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      ) : (
        /* Mobile: compact dark-panel form */
        <KeyboardAvoidingView
          style={{ flex: 1, backgroundColor: "#F8FAFC" }}
          behavior={Platform.OS === "ios" ? "padding" : undefined}
        >
          {/* Dark header — matches side menu */}
          <View
            style={{
              backgroundColor: "#0F1117",
              paddingTop: 52,
              paddingBottom: 28,
              paddingHorizontal: 20,
              alignItems: "center",
            }}
          >
            <TouchableOpacity
              onPress={() => navigation.navigate("Login")}
              style={{ position: "absolute", top: 52, left: 16, padding: 8 }}
            >
              <Icon name="arrow-back" size={22} color="#6B7280" />
            </TouchableOpacity>
            <View
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                backgroundColor: "#F4C430",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 12,
              }}
            >
              <Icon name="lock-reset" size={24} color="#0F172A" />
            </View>
            <Text
              style={{
                fontSize: 22,
                fontFamily: fonts.bold,
                color: "#F9FAFB",
                marginBottom: 3,
              }}
            >
              {t.resetPasswordTitle}
            </Text>
            <Text
              style={{ fontSize: 13, color: "#6B7280", textAlign: "center" }}
            >
              {t.resetPasswordSubtitleMobile}
            </Text>
          </View>
          {/* Form — no scroll needed, just email + button */}
          <View
            style={{
              flex: 1,
              paddingHorizontal: 20,
              paddingTop: 24,
              justifyContent: "space-between",
              paddingBottom: 28,
            }}
          >
            <View>
              <View
                style={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: 12,
                  flexDirection: "row",
                  alignItems: "center",
                  paddingHorizontal: 14,
                  paddingVertical: 13,
                  gap: 10,
                  borderWidth: 1,
                  borderColor: email ? "#F4C430" : "#E5E7EB",
                  marginBottom: 16,
                }}
              >
                <Icon
                  name="email"
                  size={18}
                  color={email ? "#F4C430" : "#9CA3AF"}
                />
                <TextInput
                  style={{
                    flex: 1,
                    fontSize: 15,
                    fontFamily: fonts.regular,
                    color: "#0F172A",
                    padding: 0,
                  }}
                  value={email}
                  onChangeText={setEmail}
                  placeholder={t.emailAddress}
                  placeholderTextColor="#9CA3AF"
                  keyboardType="email-address"
                  autoCapitalize="none"
                />
              </View>
              <TouchableOpacity
                style={[
                  {
                    backgroundColor: "#F4C430",
                    paddingVertical: 13,
                    borderRadius: 12,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 8,
                  },
                  loading && { opacity: 0.6 },
                ]}
                onPress={handleResetPassword}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <ActivityIndicator size="small" color="#1A1D23" />
                    <Text
                      style={{
                        fontSize: 15,
                        fontFamily: fonts.bold,
                        color: "#1A1D23",
                      }}
                    >
                      {t.sendingReset}
                    </Text>
                  </>
                ) : (
                  <>
                    <Text
                      style={{
                        fontSize: 15,
                        fontFamily: fonts.bold,
                        color: "#1A1D23",
                      }}
                    >
                      {t.sendResetLink}
                    </Text>
                    <Icon name="arrow-forward" size={16} color="#1A1D23" />
                  </>
                )}
              </TouchableOpacity>
            </View>
            <TouchableOpacity
              onPress={() => navigation.navigate("Login")}
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                paddingVertical: 12,
              }}
            >
              <Icon name="arrow-back" size={16} color="#6B7280" />
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.medium,
                  color: "#6B7280",
                  marginLeft: 6,
                }}
              >
                {t.backToLogin}
              </Text>
            </TouchableOpacity>
          </View>
        </KeyboardAvoidingView>
      )}
    </SafeAreaView>
  );
}

// Signup Screen
function SignupScreen({ navigation, route, currentLanguage }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [fullName, setFullName] = useState("");
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [nameError, setNameError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [resending, setResending] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  // Responsive design
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 480;
  const isTablet = dimensions.width >= 480 && dimensions.width < 768;
  const isDesktop = dimensions.width >= 768;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  // Countdown timer for resend cooldown
  useEffect(() => {
    if (resendCooldown <= 0) return;
    const timer = setTimeout(() => setResendCooldown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [resendCooldown]);

  const handleResendEmail = async () => {
    if (resending || resendCooldown > 0) return;
    setResending(true);
    try {
      const resendFn = httpsCallable(functions, "resendVerificationEmail");
      await resendFn({ email: userEmail });
      setResendCooldown(60);
      Alert.alert(
        "Email Sent",
        "A new verification email has been sent. Please check your inbox and spam folder.",
      );
    } catch (error: any) {
      const msg =
        error?.message ||
        "Failed to resend verification email. Please try again.";
      Alert.alert("Error", msg);
    } finally {
      setResending(false);
    }
  };

  // Get message from navigation params if available
  const message = route?.params?.message;

  const handlePasswordChange = (text: string) => {
    setPassword(text);
    if (confirmPassword && text !== confirmPassword) {
      setPasswordError("Passwords do not match");
    } else {
      setPasswordError("");
    }
  };

  // Check password match in real-time
  const handleConfirmPasswordChange = (text: string) => {
    setConfirmPassword(text);
    if (text && password && text !== password) {
      setPasswordError("Passwords do not match");
    } else {
      setPasswordError("");
    }
  };

  // Generate username from full name (simple random, no database check to avoid permission issues)
  const generateUsernameFromName = (name: string) => {
    // Remove spaces and special characters, convert to lowercase
    const cleanName = name.replace(/[^a-zA-Z0-9]/g, "").toLowerCase() || "user";
    // Add random 6-digit number for uniqueness
    const randomNum = Math.floor(100000 + Math.random() * 900000);
    return `${cleanName}${randomNum}`;
  };

  // Simplified - no longer checks database (avoid permission issues during signup)
  const generateUniqueUsername = async (baseName: string) => {
    return generateUsernameFromName(baseName);
  };

  const handleSignup = async () => {
    setErrorMessage(""); // Clear any previous errors
    setNameError(""); // Clear name error

    // Validate full name
    if (!fullName || !fullName.trim()) {
      const errorMsg = "Full name is required";
      setNameError(errorMsg);
      setErrorMessage(errorMsg);
      return;
    }

    if (!email || !password) {
      setErrorMessage(t.fillAllFields);
      Alert.alert("Missing Information", t.fillAllFields);
      return;
    }

    if (password !== confirmPassword) {
      const errorMsg =
        "Passwords do not match. Please make sure both password fields contain the same password.";
      setErrorMessage(errorMsg);
      setPasswordError(errorMsg);
      Alert.alert("Passwords Do Not Match", errorMsg);
      return;
    }

    if (password.length < 6) {
      setErrorMessage("Password must be at least 6 characters.");
      Alert.alert(
        "Password Too Short",
        "Password must be at least 6 characters.",
      );
      return;
    }

    setLoading(true);
    try {
      console.log("🔄 Creating user account for:", email);
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password,
      );
      const user = userCredential.user;

      // Send email verification
      console.log("📧 Sending verification email to:", user.email);
      try {
        const actionCodeSettings = {
          url: `${window.location.origin}/login`, // Redirect to login page after verification
          handleCodeInApp: false,
        };
        await sendEmailVerification(user, actionCodeSettings);
        console.log("✅ Verification email sent successfully!");
      } catch (emailError: any) {
        console.error("❌ Failed to send verification email:", emailError);
      }

      // Create user document in Firestore matching superadmin schema
      console.log("💾 Creating user profile in Firestore...");

      // Generate unique username from full name
      const generatedUsername = await generateUniqueUsername(fullName);

      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        email: email,
        displayName: fullName,
        username: generatedUsername,
        role: "user",
        subscriptionId: "free",
        subscriptionStatus: "active",
        subscriptionStartDate: new Date(),
        subscriptionEndDate: null,
        isVerified: false,
        isActive: true,
        lastLogin: new Date(),
        permissions: [],
        profile: {
          avatar: "",
          bio: "",
          phone: "",
        },
        fcmTokens: [],
        selectedCategories: [],
        selectedTags: [],
        interestedTags: [],
        // Notification preferences - enabled by default for better user engagement
        isNotificationsEnabled: true,
        isPushNotificationsEnabled: true,
        isEmailNotificationsEnabled: true,
        emailNotifications: true,
        pushNotifications: true,
        jobAlerts: true,
        applicationUpdates: true,
        notificationPreferences: {
          newJobs: true,
          applicationUpdates: true,
        },
        profileSetupComplete: false,
        createdAt: new Date(),
        updatedAt: new Date(),
      });
      console.log("✅ User profile created in Firestore");

      // Navigate to the dedicated verification screen (user stays signed in so they can resend)
      navigation.replace("VerificationRequired", {
        userEmail: email,
        keepSignedIn: true,
      });
    } catch (error: any) {
      console.error("❌ Signup failed:", error);
      console.log("Error code:", error.code);
      console.log("Error message:", error.message);

      let errorMsg = "";
      if (error.code === "auth/email-already-in-use") {
        errorMsg =
          t.emailInUse ||
          "This email is already registered. Please use a different email or sign in.";
        console.log("Setting email in use error:", errorMsg);
      } else if (error.code === "auth/invalid-email") {
        errorMsg = t.invalidEmail || "Invalid email address";
      } else if (error.code === "auth/weak-password") {
        errorMsg = t.weakPassword || "Password is too weak";
      } else if (error.code === "auth/operation-not-allowed") {
        errorMsg = t.signupFailed || "Signup failed. Please try again.";
      } else {
        errorMsg =
          error.message || t.signupFailed || "Signup failed. Please try again.";
      }

      console.log("Final error message to display:", errorMsg);
      setErrorMessage(errorMsg);

      // Scroll to top to ensure error banner is visible
      if (typeof window !== "undefined") {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }, 100);
      }
    }
    setLoading(false);
  };

  const handleGoogleSignup = async () => {
    setErrorMessage(""); // Clear any previous errors

    try {
      console.log("🔵 Starting Google Sign-In...");
      console.log("Auth instance:", auth);
      console.log("Auth config:", auth?.config);
      let user;
      let authInstance = auth; // Use module-level auth by default

      if (Platform.OS === "web") {
        // Web: Use signInWithPopup
        console.log("🌐 Using web Google Sign-In");

        // Use the global auth instance
        authInstance = auth;
        console.log("Fresh auth instance:", authInstance);

        const provider = new GoogleAuthProvider();
        // Optional: Add custom parameters if needed
        provider.setCustomParameters({
          prompt: "select_account",
        });

        console.log("Provider created:", provider);
        console.log("Calling signInWithPopup with explicit resolver...");
        const result = await signInWithPopup(
          authInstance,
          provider,
          browserPopupRedirectResolver,
        );
        console.log("Sign-in successful:", result);
        user = result.user;
      } else {
        // Mobile: Use native Google Sign-In
        console.log("📱 Using mobile Google Sign-In");
        if (!GoogleSignin) {
          Alert.alert("Error", "Google Sign-In is not available");
          return;
        }
        await GoogleSignin.hasPlayServices();
        const userInfo = await GoogleSignin.signIn();
        console.log(
          "✅ Got user info from Google Sign-In:",
          JSON.stringify(userInfo, null, 2),
        );

        // Extract idToken from the response (check both possible locations)
        const idToken = userInfo.data?.idToken || userInfo.idToken;
        console.log("Extracted idToken:", idToken ? "present" : "missing");

        if (!idToken) {
          throw new Error("No ID token received from Google Sign-In");
        }

        console.log("🔑 Creating Google credential");
        const googleCredential = GoogleAuthProvider.credential(idToken);
        console.log("🔥 Signing in with Firebase...");
        const result = await signInWithCredential(auth, googleCredential);
        user = result.user;
        console.log("✅ Signed in with Firebase:", user.uid);
      }

      // Create or update user document (avoid permission issues with getDoc)
      console.log("👤 Creating/updating user document...");

      // Wait a bit for auth state to propagate
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Verify auth state
      const currentUser = authInstance.currentUser;
      console.log("Current authenticated user:", currentUser?.uid);
      if (!currentUser) {
        throw new Error("User not authenticated after sign-in");
      }

      const userDocRef = doc(db, "users", user.uid);

      // Check if user already exists. If this check fails we must not guess
      // "new user" — that would reset an existing account's role/subscription.
      const existingUserDoc = await getDoc(userDocRef);
      const isNewUser = !existingUserDoc.exists();

      if (!isNewUser) {
        // Existing account: only record the sign-in, never reset profile data
        await updateDoc(userDocRef, {
          isVerified: true, // Google users are pre-verified
          lastLogin: new Date(),
          updatedAt: new Date(),
        });
        console.log("✅ Existing user signed in with Google");
        const existingData = existingUserDoc.data();
        if (existingData?.role === "superadmin") {
          navigation.replace("AdminPanel");
        } else if (
          !existingData?.profileSetupComplete &&
          existingData?.role === "user"
        ) {
          navigation.replace("ProfileSetup", { userId: user.uid });
        } else {
          navigation.replace("Jobs");
        }
        return;
      }

      // Generate username from Google display name
      const displayName = user.displayName || "User";
      const generatedUsername = await generateUniqueUsername(displayName);
      console.log("📝 Generated username:", generatedUsername);

      // Create the new user document
      const userData = {
        uid: user.uid,
        email: user.email || "",
        displayName: user.displayName || "User",
        username: generatedUsername,
        role: "user",
        subscriptionId: "free",
        subscriptionStatus: "active",
        subscriptionStartDate: new Date(),
        subscriptionEndDate: null,
        isVerified: true, // Google users are pre-verified
        isActive: true,
        lastLogin: new Date(),
        permissions: [],
        profile: {
          avatar: user.photoURL || "",
          bio: "",
          phone: "",
        },
        fcmTokens: [],
        selectedCategories: [],
        selectedTags: [],
        interestedTags: [],
        // Notification preferences - enabled by default for better user engagement
        isNotificationsEnabled: true,
        isPushNotificationsEnabled: true,
        isEmailNotificationsEnabled: true,
        emailNotifications: true,
        pushNotifications: true,
        jobAlerts: true,
        applicationUpdates: true,
        notificationPreferences: {
          newJobs: true,
          applicationUpdates: true,
        },
        profileSetupComplete: false,
        createdAt: new Date(),
        updatedAt: new Date(),
      };
      console.log("💾 Attempting to save user data to Firestore...");
      console.log("User UID:", user.uid);
      console.log("Auth UID:", authInstance.currentUser?.uid);
      console.log("User data to save:", JSON.stringify(userData, null, 2));

      try {
        // Use merge to create if doesn't exist or update if exists
        await setDoc(
          userDocRef,
          {
            ...userData,
            lastLogin: new Date(),
            updatedAt: new Date(),
          },
          { merge: true },
        );
        console.log("✅ User document created/updated successfully");
        Alert.alert("Success", "Signed in with Google successfully!");
      } catch (firestoreError: any) {
        console.error("❌ Firestore error:", firestoreError);
        console.error("Error code:", firestoreError.code);
        console.error("Error message:", firestoreError.message);
        throw firestoreError;
      }

      // Check if profile setup is complete for existing users
      const finalUserDoc = await getDoc(userDocRef);
      const finalUserData = finalUserDoc.data();

      if (
        !finalUserData?.profileSetupComplete &&
        finalUserData?.role === "user"
      ) {
        console.log("Navigating to ProfileSetup for Google user");
        navigation.replace("ProfileSetup", { userId: user.uid });
      } else {
        // Navigate to Jobs page after successful sign-in
        navigation.replace("Jobs");
      }
    } catch (error: any) {
      console.error("❌ Google Signup Error:", error);
      console.error("Error code:", error.code);
      console.error("Error message:", error.message);

      // Handle different error cases
      if (error.code === "auth/account-exists-with-different-credential") {
        setErrorMessage(
          "An account already exists with this email. Please sign in using your original method (email/password).",
        );
      } else if (error.code === "auth/popup-closed-by-user") {
        setErrorMessage("Sign-in cancelled. Please try again.");
      } else if (error.code === "auth/popup-blocked") {
        setErrorMessage(
          "Pop-up blocked by browser. Please enable pop-ups and try again.",
        );
      } else if (error.code === "-5") {
        // User cancelled the sign-in on mobile
        console.log("User cancelled Google Sign-In");
        setErrorMessage("");
      } else if (
        error.code === "permission-denied" ||
        error.message?.includes("Missing or insufficient permissions")
      ) {
        setErrorMessage(
          "Permission denied. Please try again or contact support.",
        );
        console.error("Firestore permission denied - check security rules");
      } else {
        setErrorMessage(
          error.message || "Google sign-in failed. Please try again.",
        );
      }
    }
  };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: "#F9FAFB" }}>
      {emailSent ? (
        // ── Verification Email Sent ─────────────────────────────────────
        <ScrollView
          style={{ flex: 1, backgroundColor: "#F9FAFB" }}
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: "center",
            paddingHorizontal: 28,
            paddingVertical: 40,
          }}
          showsVerticalScrollIndicator={false}
        >
          <View style={{ alignItems: "center" }}>
            <View
              style={{
                width: 96,
                height: 96,
                borderRadius: 28,
                backgroundColor: "rgba(244,196,48,0.12)",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 28,
                borderWidth: 1.5,
                borderColor: "rgba(244,196,48,0.25)",
              }}
            >
              <Icon name="mark-email-read" size={52} color="#F4C430" />
            </View>
            <Text
              style={{
                fontSize: 26,
                fontFamily: fonts.bold,
                color: "#1A1D23",
                marginBottom: 10,
                textAlign: "center",
              }}
            >
              Check Your Email!
            </Text>
            <Text
              style={{
                fontSize: 15,
                color: "#9CA3AF",
                textAlign: "center",
                lineHeight: 22,
                marginBottom: 16,
              }}
            >
              We've sent a verification link to
            </Text>
            <View
              style={{
                backgroundColor: "#F8FAFB",
                borderRadius: 14,
                paddingHorizontal: 22,
                paddingVertical: 12,
                borderWidth: 1,
                borderColor: "#E5E7EB",
                marginBottom: 28,
              }}
            >
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.semiBold,
                  color: "#1A1D23",
                }}
              >
                {userEmail}
              </Text>
            </View>
            {[
              { num: "1", title: t.verifyStep1Title, desc: t.verifyStep1Desc },
              { num: "2", title: t.verifyStep2Title, desc: t.verifyStep2Desc },
              { num: "3", title: t.verifyStep3Title, desc: t.verifyStep3Desc },
            ].map((step, i) => (
              <View
                key={i}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  width: "100%",
                  maxWidth: 340,
                  marginBottom: 16,
                }}
              >
                <View
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 18,
                    backgroundColor: "#F4C430",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: 16,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.bold,
                      color: "#1A1D23",
                    }}
                  >
                    {step.num}
                  </Text>
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.semiBold,
                      color: "#1A1D23",
                    }}
                  >
                    {step.title}
                  </Text>
                  <Text
                    style={{ fontSize: 13, color: "#9CA3AF", marginTop: 2 }}
                  >
                    {step.desc}
                  </Text>
                </View>
              </View>
            ))}
            <TouchableOpacity
              style={[
                styles.authPrimaryButton,
                {
                  width: "100%",
                  maxWidth: 360,
                  marginTop: 16,
                  backgroundColor: resending ? "#D1D5DB" : undefined,
                },
              ]}
              onPress={handleResendEmail}
              disabled={resending || resendCooldown > 0}
            >
              <View style={styles.authButtonContent}>
                <Icon name="send" size={20} color="#1A1D23" />
                <Text style={styles.authPrimaryButtonText}>
                  {resending
                    ? "Sending..."
                    : resendCooldown > 0
                    ? `Resend Email (${resendCooldown}s)`
                    : "Resend Verification Email"}
                </Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={[
                styles.authPrimaryButton,
                {
                  width: "100%",
                  maxWidth: 360,
                  marginTop: 8,
                  backgroundColor: "#F3F4F6",
                },
              ]}
              onPress={() => navigation.replace("Login")}
            >
              <View style={styles.authButtonContent}>
                <Icon name="login" size={20} color="#1A1D23" />
                <Text style={styles.authPrimaryButtonText}>{t.goToLogin}</Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.authBackButton, { marginTop: 8 }]}
              onPress={() =>
                Platform.OS !== "web"
                  ? navigation.replace("Jobs")
                  : navigation.navigate("Home")
              }
            >
              <Icon name="arrow-back" size={18} color={lightColors.warmGray} />
              <Text style={styles.authBackButtonText}>
                {Platform.OS !== "web" ? "Browse Jobs" : t.backToHome}
              </Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      ) : isDesktop ? (
        // ── Desktop: Two-Column Layout ──────────────────────────────────
        <View
          style={{
            flex: 1,
            flexDirection: "row",
            minHeight: dimensions.height,
            backgroundColor: "#FFFFFF",
          }}
        >
          {/* Brand Panel */}
          <View
            style={{
              width: "44%",
              backgroundColor: "#1A1D23",
              justifyContent: "center",
              alignItems: "center",
              padding: 56,
            }}
          >
            <View
              style={{
                width: 80,
                height: 80,
                borderRadius: 24,
                backgroundColor: "#F4C430",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 28,
              }}
            >
              <Image
                source={require("./assets/favicon.png")}
                style={{ width: 50, height: 50 }}
                resizeMode="contain"
              />
            </View>
            <Text
              style={{
                fontSize: 40,
                fontFamily: fonts.bold,
                color: "#FFFFFF",
                marginBottom: 10,
                letterSpacing: -0.5,
              }}
            >
              NibJobs
            </Text>
            <Text
              style={{
                fontSize: 17,
                fontFamily: fonts.regular,
                color: "#9CA3AF",
                textAlign: "center",
                lineHeight: 27,
                maxWidth: 340,
              }}
            >
              {t.signupTagline}
            </Text>
            <View
              style={{ marginTop: 48, gap: 20, width: "100%", maxWidth: 300 }}
            >
              {[
                { icon: "work", label: t.signupThousandsJobs },
                { icon: "notifications-active", label: t.signupInstantAlerts },
                { icon: "verified-user", label: t.signupVerifiedEmployers },
              ].map((f, i) => (
                <View
                  key={i}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 14,
                  }}
                >
                  <View
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 12,
                      backgroundColor: "rgba(244,196,48,0.15)",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name={f.icon} size={20} color="#F4C430" />
                  </View>
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.regular,
                      color: "#D1D5DB",
                    }}
                  >
                    {f.label}
                  </Text>
                </View>
              ))}
            </View>
          </View>

          {/* Form Panel */}
          <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={{
              flexGrow: 1,
              justifyContent: "center",
              alignItems: "center",
              paddingHorizontal: 60,
              paddingVertical: 60,
            }}
            showsVerticalScrollIndicator={false}
            keyboardShouldPersistTaps="handled"
          >
            <View style={{ width: "100%", maxWidth: 440 }}>
              <View style={styles.authHeaderSection}>
                <View style={styles.authLogoContainer}>
                  <Image
                    source={require("./assets/favicon.png")}
                    style={styles.authLogoImage}
                    resizeMode="contain"
                  />
                </View>
                <Text style={styles.authTitle}>{t.createAccountTitle}</Text>
                <Text style={styles.authSubtitle}>
                  {t.createAccountSubtitle}
                </Text>
              </View>
              {message && (
                <View style={styles.authInfoBanner}>
                  <Icon name="info" size={24} color={lightColors.deepNavy} />
                  <Text style={styles.authInfoBannerText}>{message}</Text>
                </View>
              )}
              {errorMessage && (
                <View style={styles.authErrorBanner}>
                  <Icon name="error" size={24} color="#dc2626" />
                  <View style={{ flex: 1 }}>
                    <Text style={styles.authErrorBannerText}>
                      {errorMessage}
                    </Text>
                  </View>
                  <TouchableOpacity onPress={() => setErrorMessage("")}>
                    <Icon name="close" size={20} color="#dc2626" />
                  </TouchableOpacity>
                </View>
              )}
              <View style={styles.authFormCard}>
                <View style={styles.floatingInputContainer}>
                  <View
                    style={[
                      styles.floatingInputWrapper,
                      fullName && styles.floatingInputFocused,
                    ]}
                  >
                    <Icon
                      name="person"
                      size={20}
                      color={
                        fullName ? lightColors.beeYellow : lightColors.warmGray
                      }
                      style={styles.floatingInputIcon}
                    />
                    <View style={styles.floatingInputTextContainer}>
                      {fullName ? (
                        <Text style={styles.floatingLabel}>{t.fullName}</Text>
                      ) : null}
                      <TextInput
                        style={styles.floatingInput}
                        value={fullName}
                        onChangeText={(text) => {
                          setFullName(text);
                          if (nameError) setNameError("");
                        }}
                        placeholder={fullName ? "" : t.fullName}
                        placeholderTextColor={lightColors.warmGray}
                        autoCapitalize="words"
                      />
                    </View>
                  </View>
                  {nameError && (
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 6,
                        paddingLeft: 12,
                      }}
                    >
                      <Icon name="error" size={16} color="#dc2626" />
                      <Text
                        style={{
                          color: "#dc2626",
                          fontSize: 13,
                          marginLeft: 6,
                          flex: 1,
                        }}
                      >
                        {nameError}
                      </Text>
                    </View>
                  )}
                </View>
                <View style={styles.floatingInputContainer}>
                  <View
                    style={[
                      styles.floatingInputWrapper,
                      email && styles.floatingInputFocused,
                    ]}
                  >
                    <Icon
                      name="email"
                      size={20}
                      color={
                        email ? lightColors.beeYellow : lightColors.warmGray
                      }
                      style={styles.floatingInputIcon}
                    />
                    <View style={styles.floatingInputTextContainer}>
                      {email ? (
                        <Text style={styles.floatingLabel}>
                          {t.emailAddress}
                        </Text>
                      ) : null}
                      <TextInput
                        style={styles.floatingInput}
                        value={email}
                        onChangeText={setEmail}
                        placeholder={email ? "" : t.emailAddress}
                        placeholderTextColor={lightColors.warmGray}
                        keyboardType="email-address"
                        autoCapitalize="none"
                      />
                    </View>
                  </View>
                </View>
                <View style={styles.floatingInputContainer}>
                  <View
                    style={[
                      styles.floatingInputWrapper,
                      password && styles.floatingInputFocused,
                    ]}
                  >
                    <Icon
                      name="lock"
                      size={20}
                      color={
                        password ? lightColors.beeYellow : lightColors.warmGray
                      }
                      style={styles.floatingInputIcon}
                    />
                    <View style={styles.floatingInputTextContainer}>
                      {password ? (
                        <Text style={styles.floatingLabel}>{t.password}</Text>
                      ) : null}
                      <TextInput
                        style={styles.floatingInput}
                        value={password}
                        onChangeText={handlePasswordChange}
                        placeholder={password ? "" : t.password}
                        placeholderTextColor={lightColors.warmGray}
                        secureTextEntry={!showPassword}
                      />
                    </View>
                    <TouchableOpacity
                      onPress={() => setShowPassword(!showPassword)}
                      style={{ padding: 8 }}
                    >
                      <Icon
                        name={showPassword ? "visibility" : "visibility-off"}
                        size={20}
                        color={lightColors.warmGray}
                      />
                    </TouchableOpacity>
                  </View>
                </View>
                <View style={styles.floatingInputContainer}>
                  <View
                    style={[
                      styles.floatingInputWrapper,
                      confirmPassword && styles.floatingInputFocused,
                      passwordError
                        ? { borderColor: "#dc2626", borderWidth: 2 }
                        : {},
                    ]}
                  >
                    <Icon
                      name="lock-open"
                      size={20}
                      color={
                        confirmPassword
                          ? lightColors.beeYellow
                          : lightColors.warmGray
                      }
                      style={styles.floatingInputIcon}
                    />
                    <View style={styles.floatingInputTextContainer}>
                      {confirmPassword ? (
                        <Text style={styles.floatingLabel}>
                          {t.confirmPassword}
                        </Text>
                      ) : null}
                      <TextInput
                        style={styles.floatingInput}
                        value={confirmPassword}
                        onChangeText={handleConfirmPasswordChange}
                        placeholder={confirmPassword ? "" : t.confirmPassword}
                        placeholderTextColor={lightColors.warmGray}
                        secureTextEntry={!showConfirmPassword}
                      />
                    </View>
                    <TouchableOpacity
                      onPress={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      style={{ padding: 8 }}
                    >
                      <Icon
                        name={
                          showConfirmPassword ? "visibility" : "visibility-off"
                        }
                        size={20}
                        color={lightColors.warmGray}
                      />
                    </TouchableOpacity>
                  </View>
                  {passwordError && (
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginTop: 6,
                        paddingLeft: 12,
                      }}
                    >
                      <Icon name="error" size={16} color="#dc2626" />
                      <Text
                        style={{
                          color: "#dc2626",
                          fontSize: 13,
                          marginLeft: 6,
                          flex: 1,
                        }}
                      >
                        {passwordError}
                      </Text>
                    </View>
                  )}
                  {!passwordError &&
                    confirmPassword &&
                    password &&
                    confirmPassword === password && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginTop: 6,
                          paddingLeft: 12,
                        }}
                      >
                        <Icon name="check-circle" size={16} color="#16a34a" />
                        <Text
                          style={{
                            color: "#16a34a",
                            fontSize: 13,
                            marginLeft: 6,
                          }}
                        >
                          Passwords match!
                        </Text>
                      </View>
                    )}
                </View>
                <TouchableOpacity
                  style={[
                    styles.authPrimaryButton,
                    (loading ||
                      password !== confirmPassword ||
                      !fullName.trim() ||
                      !email) &&
                      styles.authButtonDisabled,
                  ]}
                  onPress={handleSignup}
                  disabled={
                    loading ||
                    password !== confirmPassword ||
                    !fullName.trim() ||
                    !email
                  }
                >
                  {loading ? (
                    <View style={styles.authButtonContent}>
                      <ActivityIndicator
                        size="small"
                        color="#1A1D23"
                        style={{ marginRight: 8 }}
                      />
                      <Text style={styles.authPrimaryButtonText}>
                        {t.creatingAccount}
                      </Text>
                    </View>
                  ) : (
                    <View style={styles.authButtonContent}>
                      <Text style={styles.authPrimaryButtonText}>
                        {t.createAccount}
                      </Text>
                      <Icon name="arrow-forward" size={20} color="#1A1D23" />
                    </View>
                  )}
                </TouchableOpacity>
                <View style={styles.authDivider}>
                  <View style={styles.authDividerLine} />
                  <Text style={styles.authDividerText}>{t.orContinueWith}</Text>
                  <View style={styles.authDividerLine} />
                </View>
                <TouchableOpacity
                  style={styles.authGoogleButton}
                  onPress={handleGoogleSignup}
                >
                  <View style={styles.googleIconContainer}>
                    <Text style={styles.googleIconText}>G</Text>
                  </View>
                  <Text style={styles.authGoogleButtonText}>
                    {t.signInWithGoogle}
                  </Text>
                </TouchableOpacity>
                <View style={styles.authFooterLink}>
                  <Text style={styles.authFooterLinkText}>
                    {t.alreadyHaveAccount}
                  </Text>
                  <TouchableOpacity
                    onPress={() => navigation.navigate("Login")}
                  >
                    <Text style={styles.authFooterLinkHighlight}>
                      {t.signInLink}
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
              <TouchableOpacity
                style={styles.authBackButton}
                onPress={() => navigation.navigate("Home")}
              >
                <Icon
                  name="arrow-back"
                  size={18}
                  color={lightColors.warmGray}
                />
                <Text style={styles.authBackButtonText}>{t.backToHome}</Text>
              </TouchableOpacity>
            </View>
          </ScrollView>
        </View>
      ) : (
        /* Mobile */
        <KeyboardAvoidingView
          style={{ flex: 1, backgroundColor: "#F8FAFC" }}
          behavior={Platform.OS === "ios" ? "padding" : undefined}
        >
          {/* Dark header — matches side menu */}
          <View
            style={{
              backgroundColor: "#0F1117",
              paddingTop: 52,
              paddingBottom: 24,
              paddingHorizontal: 20,
              alignItems: "center",
            }}
          >
            <TouchableOpacity
              onPress={() => navigation.navigate("Login")}
              style={{ position: "absolute", top: 52, left: 16, padding: 8 }}
            >
              <Icon name="arrow-back" size={22} color="#6B7280" />
            </TouchableOpacity>
            <View
              style={{
                width: 44,
                height: 44,
                borderRadius: 12,
                backgroundColor: "#F4C430",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 12,
              }}
            >
              <Image
                source={require("./assets/favicon.png")}
                style={{ width: 28, height: 28 }}
                resizeMode="contain"
              />
            </View>
            <Text
              style={{
                fontSize: 22,
                fontFamily: fonts.bold,
                color: "#F9FAFB",
                marginBottom: 3,
              }}
            >
              {t.createAccountTitle}
            </Text>
            <Text
              style={{ fontSize: 13, color: "#6B7280", textAlign: "center" }}
            >
              {t.createAccountSubtitle}
            </Text>
          </View>
          {/* Form */}
          <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={{
              paddingHorizontal: 20,
              paddingTop: 18,
              paddingBottom: 24,
            }}
            showsVerticalScrollIndicator={false}
            keyboardShouldPersistTaps="handled"
          >
            {message ? (
              <View style={[styles.authInfoBanner, { marginBottom: 12 }]}>
                <Icon name="info" size={18} color={lightColors.deepNavy} />
                <Text style={styles.authInfoBannerText}>{message}</Text>
              </View>
            ) : null}
            {errorMessage ? (
              <View
                style={{
                  backgroundColor: "#FEF2F2",
                  borderRadius: 10,
                  padding: 12,
                  marginBottom: 12,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 8,
                  borderWidth: 1,
                  borderColor: "#FCA5A5",
                }}
              >
                <Icon name="error-outline" size={16} color="#DC2626" />
                <Text style={{ flex: 1, fontSize: 13, color: "#991B1B" }}>
                  {errorMessage}
                </Text>
                <TouchableOpacity onPress={() => setErrorMessage("")}>
                  <Icon name="close" size={15} color="#DC2626" />
                </TouchableOpacity>
              </View>
            ) : null}
            {/* Full Name */}
            <View
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: 12,
                flexDirection: "row",
                alignItems: "center",
                paddingHorizontal: 14,
                paddingVertical: 13,
                gap: 10,
                borderWidth: 1,
                borderColor: fullName ? "#F4C430" : "#E5E7EB",
                marginBottom: nameError ? 4 : 10,
              }}
            >
              <Icon
                name="person"
                size={18}
                color={fullName ? "#F4C430" : "#9CA3AF"}
              />
              <TextInput
                style={{
                  flex: 1,
                  fontSize: 15,
                  fontFamily: fonts.regular,
                  color: "#0F172A",
                  padding: 0,
                }}
                value={fullName}
                onChangeText={(text) => {
                  setFullName(text);
                  if (nameError) setNameError("");
                }}
                placeholder={t.fullName}
                placeholderTextColor="#9CA3AF"
                autoCapitalize="words"
              />
            </View>
            {nameError ? (
              <Text
                style={{
                  fontSize: 12,
                  color: "#DC2626",
                  marginBottom: 8,
                  marginLeft: 4,
                }}
              >
                {nameError}
              </Text>
            ) : null}
            {/* Email */}
            <View
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: 12,
                flexDirection: "row",
                alignItems: "center",
                paddingHorizontal: 14,
                paddingVertical: 13,
                gap: 10,
                borderWidth: 1,
                borderColor: email ? "#F4C430" : "#E5E7EB",
                marginBottom: 10,
              }}
            >
              <Icon
                name="email"
                size={18}
                color={email ? "#F4C430" : "#9CA3AF"}
              />
              <TextInput
                style={{
                  flex: 1,
                  fontSize: 15,
                  fontFamily: fonts.regular,
                  color: "#0F172A",
                  padding: 0,
                }}
                value={email}
                onChangeText={setEmail}
                placeholder={t.emailAddress}
                placeholderTextColor="#9CA3AF"
                keyboardType="email-address"
                autoCapitalize="none"
              />
            </View>
            {/* Password */}
            <View
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: 12,
                flexDirection: "row",
                alignItems: "center",
                paddingHorizontal: 14,
                paddingVertical: 13,
                gap: 10,
                borderWidth: 1,
                borderColor: password ? "#F4C430" : "#E5E7EB",
                marginBottom: password ? 6 : 10,
              }}
            >
              <Icon
                name="lock"
                size={18}
                color={password ? "#F4C430" : "#9CA3AF"}
              />
              <TextInput
                style={{
                  flex: 1,
                  fontSize: 15,
                  fontFamily: fonts.regular,
                  color: "#0F172A",
                  padding: 0,
                }}
                value={password}
                onChangeText={handlePasswordChange}
                placeholder={t.password}
                placeholderTextColor="#9CA3AF"
                secureTextEntry={!showPassword}
              />
              <TouchableOpacity
                onPress={() => setShowPassword(!showPassword)}
                hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
              >
                <Icon
                  name={showPassword ? "visibility" : "visibility-off"}
                  size={18}
                  color="#9CA3AF"
                />
              </TouchableOpacity>
            </View>

            {/* Confirm Password */}
            <View
              style={{
                backgroundColor: "#FFFFFF",
                borderRadius: 12,
                flexDirection: "row",
                alignItems: "center",
                paddingHorizontal: 14,
                paddingVertical: 13,
                gap: 10,
                borderWidth: 1,
                borderColor: passwordError
                  ? "#EF4444"
                  : confirmPassword
                  ? "#F4C430"
                  : "#E5E7EB",
                marginBottom: 4,
              }}
            >
              <Icon
                name="lock-open"
                size={18}
                color={
                  passwordError
                    ? "#EF4444"
                    : confirmPassword
                    ? "#F4C430"
                    : "#9CA3AF"
                }
              />
              <TextInput
                style={{
                  flex: 1,
                  fontSize: 15,
                  fontFamily: fonts.regular,
                  color: "#0F172A",
                  padding: 0,
                }}
                value={confirmPassword}
                onChangeText={handleConfirmPasswordChange}
                placeholder={t.confirmPassword}
                placeholderTextColor="#9CA3AF"
                secureTextEntry={!showConfirmPassword}
              />
              <TouchableOpacity
                onPress={() => setShowConfirmPassword(!showConfirmPassword)}
                hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
              >
                <Icon
                  name={showConfirmPassword ? "visibility" : "visibility-off"}
                  size={18}
                  color="#9CA3AF"
                />
              </TouchableOpacity>
            </View>
            {passwordError ? (
              <Text
                style={{
                  fontSize: 12,
                  color: "#DC2626",
                  marginBottom: 12,
                  marginLeft: 4,
                }}
              >
                {passwordError}
              </Text>
            ) : null}
            {!passwordError &&
            confirmPassword &&
            password === confirmPassword ? (
              <Text
                style={{
                  fontSize: 12,
                  color: "#10B981",
                  marginBottom: 12,
                  marginLeft: 4,
                }}
              >
                ✓ Passwords match
              </Text>
            ) : (
              <View style={{ marginBottom: 12 }} />
            )}
            {/* Create Account */}
            <TouchableOpacity
              style={[
                {
                  backgroundColor: "#F4C430",
                  paddingVertical: 13,
                  borderRadius: 12,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  marginBottom: 16,
                },
                (loading ||
                  password !== confirmPassword ||
                  !fullName.trim() ||
                  !email) && { opacity: 0.5 },
              ]}
              onPress={handleSignup}
              disabled={
                loading ||
                password !== confirmPassword ||
                !fullName.trim() ||
                !email
              }
            >
              {loading ? (
                <>
                  <ActivityIndicator size="small" color="#1A1D23" />
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.bold,
                      color: "#1A1D23",
                    }}
                  >
                    {t.creatingAccount}
                  </Text>
                </>
              ) : (
                <>
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.bold,
                      color: "#1A1D23",
                    }}
                  >
                    {t.createAccount}
                  </Text>
                  <Icon name="arrow-forward" size={16} color="#1A1D23" />
                </>
              )}
            </TouchableOpacity>
            {/* Divider */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 14,
                gap: 10,
              }}
            >
              <View
                style={{ flex: 1, height: 1, backgroundColor: "#E5E7EB" }}
              />
              <Text
                style={{
                  fontSize: 11,
                  color: "#9CA3AF",
                  fontFamily: fonts.semiBold,
                  letterSpacing: 0.8,
                }}
              >
                {t.orContinueWith}
              </Text>
              <View
                style={{ flex: 1, height: 1, backgroundColor: "#E5E7EB" }}
              />
            </View>
            {/* Google */}
            <TouchableOpacity
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#FFFFFF",
                paddingVertical: 13,
                borderRadius: 12,
                borderWidth: 1,
                borderColor: "#E5E7EB",
                gap: 10,
                marginBottom: 20,
              }}
              onPress={handleGoogleSignup}
            >
              <View style={styles.googleIconContainer}>
                <Text style={styles.googleIconText}>G</Text>
              </View>
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.semiBold,
                  color: "#1A1D23",
                }}
              >
                {t.signInWithGoogle}
              </Text>
            </TouchableOpacity>
            {/* Sign in link */}
            <View style={{ flexDirection: "row", justifyContent: "center" }}>
              <Text style={{ fontSize: 14, color: "#6B7280" }}>
                {t.alreadyHaveAccount}
              </Text>
              <TouchableOpacity onPress={() => navigation.navigate("Login")}>
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    color: "#0F172A",
                  }}
                >
                  {" "}
                  {t.signInLink}
                </Text>
              </TouchableOpacity>
            </View>
          </ScrollView>
        </KeyboardAvoidingView>
      )}
    </SafeAreaView>
  );
}

// Job Details Screen
function JobDetailsScreen({
  route,
  navigation,
  isDarkMode,
  toggleTheme,
  currentLanguage = "en",
  setCurrentLanguage,
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const { id } = route.params;
  const [job, setJob] = useState<any>(null);
  const [relatedJobs, setRelatedJobs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [jobNotFound, setJobNotFound] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState<string[]>([]);
  const [hasApplied, setHasApplied] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState<string | null>(
    null,
  );
  const [upgradeModal, setUpgradeModal] = useState<{
    visible: boolean;
    featureLabel?: string;
  }>({ visible: false });
  const [quickApplying, setQuickApplying] = useState(false);
  const { showAlert: showAppAlert } = useAppAlert();

  // Language states for toolbar
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);

  // Search functionality for toolbar
  const [searchText, setSearchText] = useState("");

  // Responsive design
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;
  const isTablet = dimensions.width >= 768 && dimensions.width < 1024;
  const isDesktop = dimensions.width >= 1024;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  // Listen to auth state for toolbar
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        setUser(authUser);
        // Fetch bookmarked jobs and user data
        const userDoc = await getDoc(doc(db, "users", authUser.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          setUserData(data);
          setBookmarkedJobs(data.bookmarkedJobs || []);
          setIsSaved(data.bookmarkedJobs?.includes(id) || false);
        }
      } else {
        setUser(null);
        setUserData(null);
        setBookmarkedJobs([]);
      }
    });

    return unsubscribe;
  }, [id]);

  const jobDetailPermission = useSubscriptionPermissions(
    userData?.subscriptionPlan || userData?.subscriptionId,
  );

  const colors = isDarkMode ? darkColors : lightColors;

  // Simple helper functions
  const handleLogin = () => navigation.navigate("Login");

  // Helper function to get matched tags between user preferences and job tags
  const getMatchedTags = () => {
    if (!userData || !job) return [];
    const userTags = userData.interestedTags || [];
    const jobTags = job.tags || [];
    return jobTags.filter((tag: string) => userTags.includes(tag));
  };

  const dynamicStyles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.white,
    },
  });

  useEffect(() => {
    const fetchJobDetails = async () => {
      try {
        setLoading(true);
        setJobNotFound(false);
        setFetchError(false);
        setJob(null);
        // Fetch job details
        const jobDoc = await getDoc(doc(db, "jobs", id));
        if (jobDoc.exists()) {
          const jobData = { id: jobDoc.id, ...jobDoc.data() };
          trackInteraction("job_view", id);
          setJob(jobData);

          // Debug: Log available image fields
          console.log("Available image fields:", {
            sourceImageUrl: jobData.sourceImageUrl,
            sourceChannelImageUrl: jobData.sourceChannelImageUrl,
            channelImageUrl: jobData.channelImageUrl,
          });

          // Check if job is saved
          const currentUser = auth.currentUser;
          if (currentUser) {
            const userDoc = await getDoc(doc(db, "users", currentUser.uid));
            const savedJobs = userDoc.data()?.savedJobs || [];
            setIsSaved(savedJobs.includes(id));

            // Check if user has already applied to this job
            const applicationsQuery = dbQuery(
              collection(db, "applications"),
              where("jobId", "==", id),
              where("applicantId", "==", currentUser.uid),
              limit(1),
            );
            const applicationsSnapshot = await getDocs(applicationsQuery);
            if (!applicationsSnapshot.empty) {
              setHasApplied(true);
              const applicationData = applicationsSnapshot.docs[0].data();
              setApplicationStatus(applicationData.status || "pending");
            } else {
              setHasApplied(false);
              setApplicationStatus(null);
            }
          }

          // Fetch related jobs (same category, limit 5)
          if ((jobData as any).category || (jobData as any).categoryId) {
            const relatedQuery = dbQuery(
              collection(db, "jobs"),
              orderBy("createdAt", "desc"),
              limit(6),
            );
            const relatedSnapshot = await getDocs(relatedQuery);
            const related = relatedSnapshot.docs
              .map((doc) => ({ id: doc.id, ...(doc.data() as any) }))
              .filter(
                (j: any) =>
                  j.id !== id &&
                  (j.category === (jobData as any).category ||
                    j.categoryId === (jobData as any).categoryId),
              )
              .slice(0, 5);
            setRelatedJobs(related);
          }
        } else {
          setJobNotFound(true);
        }
      } catch (error) {
        console.error("Error fetching job:", error);
        setFetchError(true);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchJobDetails();
    }
  }, [id]);

  const handleSaveJob = async () => {
    const currentUser = auth.currentUser;
    if (!currentUser) {
      showAppAlert("warning", "Login Required", "Please login to save jobs.");
      return;
    }

    if (!jobDetailPermission.hasPermission("canSaveJobs")) {
      setUpgradeModal({ visible: true, featureLabel: "Save / Bookmark Jobs" });
      return;
    }

    try {
      const userRef = doc(db, "users", currentUser.uid);
      const userDoc = await getDoc(userRef);

      if (!userDoc.exists()) {
        // Create user document if it doesn't exist
        if (isSaved) {
          // If trying to unsave but doc doesn't exist, just update state
          setIsSaved(false);
          return;
        }
        trackInteraction("job_save", id);
        await setDoc(userRef, {
          savedJobs: [id],
          email: currentUser.email,
          createdAt: new Date(),
        });
        setIsSaved(true);
        showAppAlert(
          "success",
          "Job Saved",
          "Job has been saved to your bookmarks.",
        );
        return;
      }

      const savedJobs = userDoc.data()?.savedJobs || [];

      if (isSaved) {
        // Remove from saved jobs
        await updateDoc(userRef, {
          savedJobs: savedJobs.filter((jobId: string) => jobId !== id),
        });
        setIsSaved(false);
        showAppAlert(
          "success",
          "Bookmark Removed",
          "Job removed from your saved jobs.",
        );
      } else {
        // Add to saved jobs
        trackInteraction("job_save", id);
        await updateDoc(userRef, {
          savedJobs: [...savedJobs, id],
        });
        setIsSaved(true);
        showAppAlert(
          "success",
          "Job Saved",
          "Job has been saved to your bookmarks.",
        );
      }
    } catch (error) {
      console.error("Error saving job:", error);
      showAppAlert(
        "error",
        "Save Failed",
        "Failed to save job. Please try again.",
      );
    }
  };

  const handleShareJob = async () => {
    const jobUrl = `https://nibjobs.com/job/${id}`;
    const message = `Check out this job: ${job.title} at ${job.company}\n${jobUrl}`;

    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({
          title: job.title,
          text: message,
          url: jobUrl,
        });
      } catch (error) {
        console.log("Error sharing:", error);
      }
    } else {
      // Fallback: copy to clipboard
      showAppAlert("info", "Share Job", `Job URL: ${jobUrl}`);
    }
  };

  const handleApply = async () => {
    if (!job) return;

    if (!jobDetailPermission.hasPermission("canApplyToJob")) {
      setUpgradeModal({ visible: true, featureLabel: "Apply to Jobs" });
      return;
    }

    // Check if this is a company-created job (not from Telegram)
    const isCompanyJob =
      job.jobSource === "company" || (job.companyId && !job.telegramMessageUrl);

    if (isCompanyJob) {
      // For company jobs, use Quick Apply
      if (!auth.currentUser) {
        showAppAlert(
          "warning",
          "Login Required",
          "Please login to apply for this job.",
          {
            buttonText: "Go to Login",
            onClose: () =>
              navigation.navigate("Login", {
                returnTo: "JobDetails",
                jobId: job.id,
              }),
          },
        );
        return;
      }

      // Check if user has already applied
      if (hasApplied) {
        const statusText = applicationStatus
          ? ` (Status: ${applicationStatus})`
          : "";
        showAppAlert(
          "info",
          "Already Applied",
          `You have already applied to this job${statusText}.`,
        );
        return;
      }

      // Check if job is still active/open
      if (job.isActive === false) {
        showAppAlert(
          "warning",
          "Job Closed",
          "This job posting is no longer accepting applications.",
        );
        return;
      }

      // Quick Apply: check profile completeness
      try {
        setQuickApplying(true);
        const userDocSnap = await getDoc(
          doc(db, "users", auth.currentUser.uid),
        );
        if (!userDocSnap.exists()) {
          showAppAlert(
            "warning",
            "Profile Incomplete",
            "Please complete your profile before applying.",
            {
              buttonText: "Go to Profile",
              onClose: () => navigation.navigate("Profile"),
            },
          );
          return;
        }
        const uData = userDocSnap.data();
        const profile = uData.profile || {};
        const portfolio = uData.portfolio || {};

        const fullName = (uData.displayName || profile.fullName || "").trim();
        const email = (uData.email || auth.currentUser.email || "").trim();
        const phone = (uData.phoneNumber || profile.phone || "").trim();
        const resumeUrl = (portfolio.cvUrl || profile.resumeUrl || "").trim();

        // Profile must have: name, email, phone, and resume
        const missing: string[] = [];
        if (!fullName) missing.push("Full Name");
        if (!email) missing.push("Email");
        if (!phone) missing.push("Phone Number");
        if (!resumeUrl) missing.push("Resume / CV");

        if (missing.length > 0) {
          showAppAlert(
            "warning",
            "Profile Incomplete",
            `Please add the following before applying:\n\n• ${missing.join(
              "\n• ",
            )}\n\nGo to your Profile to update these details.`,
          );
          setQuickApplying(false);
          return;
        }

        // Profile is complete → submit application directly
        const applicationData = {
          jobId: job.id,
          jobTitle: job.title,
          companyId: job.companyId,
          companyName: job.company,
          applicantId: auth.currentUser.uid,
          applicantName: fullName,
          applicantEmail: email,
          applicantPhone: phone,
          applicantAddress: profile.address || null,
          applicantPortfolio:
            portfolio.portfolioUrl || uData.socialLinks?.portfolio || null,
          applicantLinkedIn:
            portfolio.linkedin || uData.socialLinks?.linkedin || null,
          applicantGitHub:
            portfolio.github || uData.socialLinks?.github || null,
          applicantTwitter: uData.socialLinks?.twitter || null,
          applicantInstagram: uData.socialLinks?.instagram || null,
          resumeUrl: resumeUrl || null,
          coverLetter: null,
          // Additional applicant profile data
          applicantBio: profile.bio || null,
          applicantJobTitle: portfolio.jobTitle || null,
          applicantCompany: portfolio.company || null,
          applicantSkills: portfolio.skills || null,
          applicantEducation: portfolio.education || null,
          applicantExperience: portfolio.experience || null,
          applicantAchievements: portfolio.achievements || null,
          applicantPhotoURL: uData.photoURL || uData.profilePicture || null,
          applicantDateOfBirth: uData.dateOfBirth || null,
          applicantInterestedTags: uData.interestedTags || null,
          status: "pending",
          appliedAt: new Date(),
          updatedAt: new Date(),
        };

        console.log(`📝 [Quick Apply] Submitting application:
   Job: ${job.title} (ID: ${job.id})
   Company: ${job.company} (ID: ${job.companyId})
   Applicant: ${fullName} (ID: ${auth.currentUser.uid})`);

        await addDoc(collection(db, "applications"), applicationData);
        console.log("✅ [Quick Apply] Application saved to Firestore");

        // Notify the company via Cloud Function (also increments applicationCount server-side)
        try {
          const notifyNewApplicationFn = httpsCallable(
            functions,
            "notifyNewApplication",
          );
          notifyNewApplicationFn({
            companyId: job.companyId,
            jobId: job.id,
            jobTitle: job.title,
            applicantName: fullName,
            applicantEmail: email,
            applicantPhone: phone,
            resumeUrl: resumeUrl || null,
          }).catch((err) =>
            console.error("Notify new application error:", err),
          );
        } catch (e) {
          console.error("Error calling notifyNewApplication:", e);
        }

        setHasApplied(true);
        setApplicationStatus("pending");

        showAppAlert(
          "success",
          "Application Submitted!",
          `You've applied to "${job.title}" at ${job.company} via Quick Apply.\n\nThe company has been notified and will review your profile. You'll receive a notification when they respond.\n\nGood luck! 🎉`,
        );
      } catch (error) {
        console.error("Error with Quick Apply:", error);
        showAppAlert(
          "error",
          "Application Failed",
          "Failed to submit application. Please try again.",
        );
      } finally {
        setQuickApplying(false);
      }
      return;
    }

    // For Telegram jobs, open Telegram message URL
    trackInteraction("apply_click", job.id);
    const telegramUrl =
      job.telegramMessageUrl || job.telegramLink || "https://t.me/nibjobseth";

    try {
      const supported = await Linking.canOpenURL(telegramUrl);
      if (supported) {
        await Linking.openURL(telegramUrl);
      } else {
        // Fallback to window.open for web
        if (typeof window !== "undefined") {
          window.open(telegramUrl, "_blank");
        } else {
          Alert.alert("Error", "Unable to open Telegram link");
        }
      }
    } catch (error) {
      console.error("Error opening Telegram link:", error);
      Alert.alert("Error", "Failed to open Telegram link");
    }
  };

  const formatDate = (date: any) => {
    if (!date) return "Recently posted";
    if (date.seconds) {
      return new Date(date.seconds * 1000).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    }
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const getTimeAgo = (date: any) => {
    if (!date) return "Recently";
    const dateObj = date.seconds
      ? new Date(date.seconds * 1000)
      : new Date(date);
    const seconds = Math.floor(
      (new Date().getTime() - dateObj.getTime()) / 1000,
    );

    let interval = seconds / 31536000;
    if (interval > 1) return Math.floor(interval) + " years ago";
    interval = seconds / 2592000;
    if (interval > 1) return Math.floor(interval) + " months ago";
    interval = seconds / 86400;
    if (interval > 1) return Math.floor(interval) + " days ago";
    interval = seconds / 3600;
    if (interval > 1) return Math.floor(interval) + " hours ago";
    interval = seconds / 60;
    if (interval > 1) return Math.floor(interval) + " minutes ago";
    return "Just now";
  };

  if (loading || (!job && !jobNotFound && !fetchError)) {
    return (
      <ModernLoadingScreen
        message="Loading job details..."
        isDarkMode={isDarkMode}
      />
    );
  }

  // Job not found or deleted
  if (jobNotFound || fetchError) {
    return (
      <SafeAreaView
        style={[
          styles.container,
          { backgroundColor: isDarkMode ? "#0A0C0F" : "#F9FAFB", flex: 1 },
        ]}
      >
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "center",
            paddingHorizontal: 24,
            paddingVertical: 48,
          }}
        >
          <View
            style={{
              width: 120,
              height: 120,
              borderRadius: 60,
              backgroundColor: isDarkMode
                ? "rgba(252, 165, 165, 0.12)"
                : "#FEF2F2",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 24,
            }}
          >
            <Icon
              name={jobNotFound ? "search-off" : "error-outline"}
              size={56}
              color={isDarkMode ? "#FCA5A5" : "#E74C3C"}
            />
          </View>
          <Text
            style={{
              fontSize: 28,
              fontWeight: "700",
              color: isDarkMode ? "#F9FAFB" : "#1F2937",
              marginBottom: 12,
              textAlign: "center",
            }}
          >
            {jobNotFound ? t.jobNotFoundTitle : t.somethingWentWrong}
          </Text>
          <Text
            style={{
              fontSize: 16,
              lineHeight: 24,
              color: isDarkMode ? "#B8BFC8" : "#6B7280",
              textAlign: "center",
              marginBottom: 32,
              maxWidth: 400,
              paddingHorizontal: 16,
            }}
          >
            {jobNotFound
              ? "This job posting may have been removed, expired, or the link might be incorrect. Don't worry — there are plenty of other opportunities waiting for you!"
              : "We couldn't load this job right now. Please check your connection and try again."}
          </Text>
          <View style={{ width: "100%", maxWidth: 380, gap: 14 }}>
            <TouchableOpacity
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                paddingVertical: 16,
                paddingHorizontal: 24,
                borderRadius: 14,
                backgroundColor: isDarkMode ? "#FBBF24" : "#F4C430",
              }}
              onPress={() => {
                if (Platform.OS === "web" && typeof window !== "undefined") {
                  window.history.replaceState({}, document.title, "/jobs");
                }
                navigation.navigate("Jobs" as never);
              }}
              activeOpacity={0.8}
            >
              <Icon
                name="work"
                size={22}
                color={isDarkMode ? "#0F172A" : "#78350F"}
                style={{ marginRight: 10 }}
              />
              <Text
                style={{
                  fontSize: 17,
                  fontWeight: "700",
                  color: isDarkMode ? "#0F172A" : "#78350F",
                }}
              >
                Browse Jobs
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                paddingVertical: 16,
                paddingHorizontal: 24,
                borderRadius: 14,
                backgroundColor: isDarkMode ? "#FB923C" : "#FF8C42",
              }}
              onPress={() => {
                if (Platform.OS === "web" && typeof window !== "undefined") {
                  window.history.replaceState({}, document.title, "/");
                }
                navigation.navigate("Home" as never);
              }}
              activeOpacity={0.8}
            >
              <Icon
                name="home"
                size={22}
                color="#FFFFFF"
                style={{ marginRight: 10 }}
              />
              <Text
                style={{ fontSize: 17, fontWeight: "700", color: "#FFFFFF" }}
              >
                Go to Home
              </Text>
            </TouchableOpacity>
            {fetchError && (
              <TouchableOpacity
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingVertical: 15,
                  paddingHorizontal: 24,
                  borderRadius: 14,
                  borderWidth: 2,
                  borderColor: isDarkMode
                    ? "rgba(251, 191, 36, 0.3)"
                    : "#E5E7EB",
                  backgroundColor: isDarkMode
                    ? "rgba(251, 191, 36, 0.08)"
                    : "transparent",
                }}
                onPress={() => {
                  setFetchError(false);
                  setLoading(true);
                  setJob(null);
                  // Re-trigger fetch by updating nothing — the useEffect depends on [id]
                  const fetchJobDetails = async () => {
                    try {
                      const jobDoc = await getDoc(doc(db, "jobs", id));
                      if (jobDoc.exists()) {
                        setJob({ id: jobDoc.id, ...jobDoc.data() });
                      } else {
                        setJobNotFound(true);
                      }
                    } catch (error) {
                      setFetchError(true);
                    } finally {
                      setLoading(false);
                    }
                  };
                  fetchJobDetails();
                }}
                activeOpacity={0.7}
              >
                <Icon
                  name="refresh"
                  size={22}
                  color={isDarkMode ? "#F9FAFB" : "#1F2937"}
                  style={{ marginRight: 10 }}
                />
                <Text
                  style={{
                    fontSize: 16,
                    fontWeight: "600",
                    color: isDarkMode ? "#F9FAFB" : "#1F2937",
                  }}
                >
                  Try Again
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </ScrollView>
      </SafeAreaView>
    );
  }

  // Gate: check canViewJobDetails permission
  if (!jobDetailPermission.hasPermission("canViewJobDetails")) {
    return (
      <SafeAreaView
        style={[
          styles.container,
          { backgroundColor: isDarkMode ? "#0D0D0F" : "#F9FAFB" },
        ]}
      >
        <SubscriptionUpgradeModal
          visible={true}
          featureLabel="View Job Details"
          currentPlan={userData?.subscriptionPlan || userData?.subscriptionId}
          onClose={() => {
            if (navigation.canGoBack()) {
              navigation.goBack();
            } else {
              navigation.navigate("Jobs");
            }
          }}
          navigation={navigation}
          isDarkMode={isDarkMode}
        />
      </SafeAreaView>
    );
  }

  // Determine if this is a company job or telegram job
  const isCompanyJob =
    job.jobSource === "company" || (job.companyId && !job.telegramMessageUrl);

  return (
    <SafeAreaView
      style={[
        styles.container,
        { backgroundColor: isDarkMode ? "#0D0D0F" : "#F9FAFB" },
      ]}
    >
      <SubscriptionUpgradeModal
        visible={upgradeModal.visible}
        featureLabel={upgradeModal.featureLabel}
        currentPlan={userData?.subscriptionPlan || userData?.subscriptionId}
        onClose={() => setUpgradeModal({ visible: false })}
        navigation={navigation}
        isDarkMode={isDarkMode}
      />
      {/* Minimal Mobile Header */}
      {isMobile ? (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            paddingHorizontal: 20,
            paddingVertical: 16,
            backgroundColor: isDarkMode
              ? "rgba(26,29,35,0.95)"
              : "rgba(255,255,255,0.98)",
            borderBottomWidth: 1,
            borderBottomColor: isDarkMode
              ? "rgba(255,255,255,0.05)"
              : "rgba(0,0,0,0.05)",
            backdropFilter: "blur(10px)",
          }}
        >
          <TouchableOpacity
            onPress={() => {
              if (navigation.canGoBack()) {
                navigation.goBack();
              } else {
                navigation.navigate("Jobs");
              }
            }}
            hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              backgroundColor: isDarkMode
                ? "rgba(255,255,255,0.08)"
                : "rgba(0,0,0,0.04)",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon
              name="arrow-back"
              size={20}
              color={isDarkMode ? "#F3F4F6" : colors.deepNavy}
            />
          </TouchableOpacity>

          <View style={{ flex: 1 }} />

          <View style={{ flexDirection: "row", gap: 10 }}>
            <TouchableOpacity
              onPress={handleSaveJob}
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                backgroundColor: isSaved
                  ? colors.beeYellow + "20"
                  : isDarkMode
                  ? "rgba(255,255,255,0.08)"
                  : "rgba(0,0,0,0.04)",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                name={isSaved ? "bookmark" : "bookmark-border"}
                size={20}
                color={
                  isSaved
                    ? colors.beeYellow
                    : isDarkMode
                    ? "#F3F4F6"
                    : colors.deepNavy
                }
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={handleShareJob}
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                backgroundColor: isDarkMode
                  ? "rgba(255,255,255,0.08)"
                  : "rgba(0,0,0,0.04)",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                name="share"
                size={20}
                color={isDarkMode ? "#F3F4F6" : colors.deepNavy}
              />
            </TouchableOpacity>
          </View>
        </View>
      ) : (
        /* Desktop Header */
        <View
          style={[
            styles.jobsToolbar,
            {
              backgroundColor: colors.white,
              borderBottomColor: colors.lightGray,
            },
          ]}
        >
          <View style={styles.jobsToolbarLeft}>
            <TouchableOpacity onPress={() => navigation.navigate("Home")}>
              <Image
                source={require("./assets/favicon.png")}
                style={styles.toolbarLogo}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <TouchableOpacity
              style={[
                styles.toolbarNavButton,
                {
                  borderBottomWidth: 3,
                  borderBottomColor: colors.beeYellow,
                  paddingBottom: 8,
                },
              ]}
              onPress={() => navigation.navigate("Jobs")}
            >
              <Text
                style={[
                  styles.toolbarNavButtonText,
                  {
                    color: colors.deepNavy,
                    fontWeight: "700",
                    fontFamily: fonts.bold,
                  },
                ]}
              >
                {t.navJobs}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.toolbarNavButton, { opacity: 0.6 }]}
              onPress={() => navigation.navigate("Companies")}
            >
              <Text
                style={[
                  styles.toolbarNavButtonText,
                  { color: colors.deepNavy },
                ]}
              >
                {t.companies}
              </Text>
            </TouchableOpacity>
          </View>
          <View style={styles.jobsToolbarRight}>
            {/* Alerts & Language - Desktop only */}
            {user && (
              <NotificationsBell
                navigation={navigation}
                isDarkMode={isDarkMode}
                currentLanguage={currentLanguage}
              />
            )}
            <DesktopLanguageSelector
              currentLanguage={currentLanguage}
              setCurrentLanguage={setCurrentLanguage}
              isDarkMode={isDarkMode}
            />
            {(() => {
              if (!user) return null;
              const subscriptionId = (
                userData?.subscriptionId ||
                userData?.subscriptionPlan ||
                "free"
              ).toLowerCase();
              const plan =
                SUBSCRIPTION_PLANS.find((p) => p.id === subscriptionId) ||
                SUBSCRIPTION_PLANS[0];
              const isFree = plan.id === "free";
              const badgeColors = {
                free: { bg: "#6B7280", text: "#FFFFFF" },
                standard: { bg: "#D97706", text: "#FFFFFF" },
                pro: { bg: "#7C3AED", text: "#FFFFFF" },
                enterprise: { bg: "#1E3A8A", text: "#FFFFFF" },
              };
              const colors_badge =
                badgeColors[plan.id as keyof typeof badgeColors] ||
                badgeColors.free;
              return (
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 12,
                    marginRight: 12,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      backgroundColor: colors_badge.bg,
                      paddingHorizontal: 14,
                      paddingVertical: 8,
                      borderRadius: 20,
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 2 },
                      shadowOpacity: 0.2,
                      shadowRadius: 4,
                      elevation: 3,
                    }}
                  >
                    <Icon
                      name={plan.icon}
                      size={16}
                      color={colors_badge.text}
                    />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.bold,
                        color: colors_badge.text,
                        fontWeight: "700",
                        marginLeft: 6,
                        letterSpacing: 0.3,
                      }}
                    >
                      {plan.name.toUpperCase()}
                    </Text>
                  </View>
                  {isFree && (
                    <TouchableOpacity
                      onPress={() =>
                        navigation.navigate("SettingsSubscription")
                      }
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        backgroundColor: colors.beeYellow,
                        paddingHorizontal: 12,
                        paddingVertical: 6,
                        borderRadius: 12,
                        gap: 4,
                      }}
                    >
                      <Icon
                        name="arrow-upward"
                        size={14}
                        color={colors.deepNavy}
                      />
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: fonts.regular,
                          color: colors.deepNavy,
                          fontWeight: "600",
                        }}
                      >
                        Upgrade
                      </Text>
                    </TouchableOpacity>
                  )}
                </View>
              );
            })()}
            <TouchableOpacity
              style={styles.toolbarThemeToggle}
              onPress={toggleTheme}
            >
              <Icon
                name={isDarkMode ? "wb-sunny" : "nightlight-round"}
                size={20}
                color={colors.deepNavy}
              />
            </TouchableOpacity>
          </View>
        </View>
      )}

      <ScrollView
        style={{ flex: 1 }}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: isMobile ? 100 : 40 }}
      >
        {/* Hero Section */}
        <View
          style={{
            backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
            paddingHorizontal: isMobile ? 20 : 40,
            paddingVertical: isMobile ? 24 : 32,
            marginHorizontal: isMobile ? 0 : 40,
            marginTop: isMobile ? 0 : 24,
            borderRadius: isMobile ? 0 : 16,
            ...(isMobile
              ? {}
              : {
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: 2 },
                  shadowOpacity: 0.05,
                  shadowRadius: 8,
                  elevation: 2,
                }),
          }}
        >
          {/* Company Info Row */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 16,
            }}
          >
            {job.sourceImageUrl ? (
              <Image
                source={{ uri: job.sourceImageUrl }}
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: 12,
                  backgroundColor: isDarkMode ? "#2C2F36" : "#F3F4F6",
                }}
                resizeMode="cover"
              />
            ) : (
              <View
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: 12,
                  backgroundColor: isDarkMode ? "#2C2F36" : "#FEF3C7",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="business" size={28} color={colors.beeYellow} />
              </View>
            )}
            <View style={{ flex: 1, marginLeft: 14 }}>
              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: 15,
                  color: isDarkMode ? "#9CA3AF" : colors.warmGray,
                  marginBottom: 2,
                }}
              >
                {job.company}
              </Text>
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 6 }}
              >
                <Icon
                  name="schedule"
                  size={14}
                  color={isDarkMode ? "#6B7280" : colors.warmGray}
                />
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 13,
                    color: isDarkMode ? "#6B7280" : colors.warmGray,
                  }}
                >
                  {getTimeAgo(job.postedDate || job.createdAt)}
                </Text>
              </View>
            </View>
          </View>

          {/* Job Title */}
          <Text
            style={{
              fontFamily: fonts.bold,
              fontSize: isMobile ? 22 : 28,
              color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
              lineHeight: isMobile ? 28 : 36,
              marginBottom: 16,
            }}
          >
            {job.title}
          </Text>

          {/* Quick Info Pills */}
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 8,
              marginBottom: 20,
            }}
          >
            {job.location && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: isDarkMode ? "#2C2F36" : "#F3F4F6",
                  paddingHorizontal: 12,
                  paddingVertical: 6,
                  borderRadius: 20,
                  gap: 5,
                }}
              >
                <Icon
                  name="location-on"
                  size={14}
                  color={isDarkMode ? "#F87171" : "#EF4444"}
                />
                <Text
                  style={{
                    fontFamily: fonts.medium,
                    fontSize: 13,
                    color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                  }}
                >
                  {job.location}
                </Text>
              </View>
            )}
            {job.contractType && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: isDarkMode ? "#2C2F36" : "#F3F4F6",
                  paddingHorizontal: 12,
                  paddingVertical: 6,
                  borderRadius: 20,
                  gap: 5,
                }}
              >
                <Icon
                  name="work-outline"
                  size={14}
                  color={isDarkMode ? "#60A5FA" : "#3B82F6"}
                />
                <Text
                  style={{
                    fontFamily: fonts.medium,
                    fontSize: 13,
                    color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                  }}
                >
                  {job.contractType}
                </Text>
              </View>
            )}
            {job.isRemote && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: isDarkMode ? "#064E3B" : "#D1FAE5",
                  paddingHorizontal: 12,
                  paddingVertical: 6,
                  borderRadius: 20,
                  gap: 5,
                }}
              >
                <Icon name="home" size={14} color="#10B981" />
                <Text
                  style={{
                    fontFamily: fonts.medium,
                    fontSize: 13,
                    color: "#10B981",
                  }}
                >
                  Remote
                </Text>
              </View>
            )}
          </View>

          {/* Salary Highlight */}
          {job.salary && (
            <View
              style={{
                backgroundColor: isDarkMode ? "#064E3B" : "#ECFDF5",
                paddingHorizontal: 16,
                paddingVertical: 12,
                borderRadius: 12,
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
              }}
            >
              <View
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 18,
                  backgroundColor: isDarkMode ? "#10B981" : "#A7F3D0",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name="payments"
                  size={18}
                  color={isDarkMode ? "#FFFFFF" : "#059669"}
                />
              </View>
              <View>
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 12,
                    color: isDarkMode ? "#A7F3D0" : "#059669",
                  }}
                >
                  Salary
                </Text>
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: 16,
                    color: isDarkMode ? "#FFFFFF" : "#047857",
                  }}
                >
                  {job.salary}
                </Text>
              </View>
            </View>
          )}

          {/* Application Status Badge */}
          {hasApplied && isCompanyJob && (
            <View
              style={{
                marginTop: 16,
                backgroundColor: isDarkMode ? "#1E3A5F" : "#DBEAFE",
                paddingHorizontal: 16,
                paddingVertical: 12,
                borderRadius: 12,
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
              }}
            >
              <Icon name="check-circle" size={20} color="#3B82F6" />
              <Text
                style={{
                  fontFamily: fonts.medium,
                  fontSize: 14,
                  color: "#3B82F6",
                }}
              >
                You applied • Status:{" "}
                {applicationStatus?.charAt(0).toUpperCase() +
                  applicationStatus?.slice(1)}
              </Text>
            </View>
          )}
        </View>

        {/* Ad between job header and content */}
        <AdBanner variant="detail" />

        {/* Content Sections */}
        <View
          style={{
            paddingHorizontal: isMobile ? 16 : 40,
            marginTop: 16,
            gap: 16,
          }}
        >
          {/* Description */}
          {job.description && (
            <View
              style={{
                backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
                borderRadius: 16,
                padding: isMobile ? 20 : 24,
                ...(isMobile
                  ? {}
                  : {
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 1 },
                      shadowOpacity: 0.03,
                      shadowRadius: 4,
                      elevation: 1,
                    }),
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 14,
                }}
              >
                <View
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    backgroundColor: isDarkMode ? "#2C2F36" : "#F3F4F6",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon
                    name="description"
                    size={18}
                    color={isDarkMode ? "#E5E7EB" : colors.deepNavy}
                  />
                </View>
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: 16,
                    color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                  }}
                >
                  Description
                </Text>
              </View>
              <Text
                style={{
                  fontFamily: fonts.regular,
                  fontSize: 14,
                  lineHeight: 22,
                  color: isDarkMode ? "#9CA3AF" : "#4B5563",
                }}
              >
                {job.description}
              </Text>
            </View>
          )}

          {/* Requirements */}
          {job.requirements && (
            <View
              style={{
                backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
                borderRadius: 16,
                padding: isMobile ? 20 : 24,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 14,
                }}
              >
                <View
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    backgroundColor: isDarkMode ? "#2C2F36" : "#F3F4F6",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon
                    name="checklist"
                    size={18}
                    color={isDarkMode ? "#E5E7EB" : colors.deepNavy}
                  />
                </View>
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: 16,
                    color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                  }}
                >
                  Requirements
                </Text>
              </View>
              <Text
                style={{
                  fontFamily: fonts.regular,
                  fontSize: 14,
                  lineHeight: 22,
                  color: isDarkMode ? "#9CA3AF" : "#4B5563",
                }}
              >
                {job.requirements}
              </Text>
            </View>
          )}

          {/* Responsibilities */}
          {job.responsibilities && (
            <View
              style={{
                backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
                borderRadius: 16,
                padding: isMobile ? 20 : 24,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 14,
                }}
              >
                <View
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    backgroundColor: isDarkMode ? "#2C2F36" : "#F3F4F6",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon
                    name="assignment"
                    size={18}
                    color={isDarkMode ? "#E5E7EB" : colors.deepNavy}
                  />
                </View>
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: 16,
                    color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                  }}
                >
                  Responsibilities
                </Text>
              </View>
              <Text
                style={{
                  fontFamily: fonts.regular,
                  fontSize: 14,
                  lineHeight: 22,
                  color: isDarkMode ? "#9CA3AF" : "#4B5563",
                }}
              >
                {job.responsibilities}
              </Text>
            </View>
          )}

          {/* Skills/Tags */}
          {job.tags && job.tags.length > 0 && (
            <View
              style={{
                backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
                borderRadius: 16,
                padding: isMobile ? 20 : 24,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 10,
                  marginBottom: 14,
                }}
              >
                <View
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    backgroundColor: isDarkMode ? "#2C2F36" : "#F3F4F6",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon
                    name="label"
                    size={18}
                    color={isDarkMode ? "#E5E7EB" : colors.deepNavy}
                  />
                </View>
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: 16,
                    color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                  }}
                >
                  Skills & Tags
                </Text>
              </View>
              <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}>
                {job.tags.map((tag: string, index: number) => {
                  const isMatched = userData?.interestedTags?.includes(tag);
                  return (
                    <View
                      key={index}
                      style={{
                        backgroundColor: isMatched
                          ? isDarkMode
                            ? "#422006"
                            : "#FEF3C7"
                          : isDarkMode
                          ? "#2C2F36"
                          : "#F3F4F6",
                        paddingHorizontal: 12,
                        paddingVertical: 6,
                        borderRadius: 16,
                        borderWidth: isMatched ? 1 : 0,
                        borderColor: colors.beeYellow,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: fonts.medium,
                          fontSize: 13,
                          color: isMatched
                            ? colors.beeYellow
                            : isDarkMode
                            ? "#E5E7EB"
                            : colors.deepNavy,
                        }}
                      >
                        {isMatched && "✓ "}
                        {tag}
                      </Text>
                    </View>
                  );
                })}
              </View>
            </View>
          )}

          {/* Job Source */}
          <View
            style={{
              backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
              borderRadius: 16,
              padding: isMobile ? 20 : 24,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
                marginBottom: 14,
              }}
            >
              <View
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  backgroundColor: isDarkMode ? "#2C2F36" : "#F3F4F6",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name="source"
                  size={18}
                  color={isDarkMode ? "#E5E7EB" : colors.deepNavy}
                />
              </View>
              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: 16,
                  color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                }}
              >
                Source
              </Text>
            </View>
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 12 }}
            >
              {isCompanyJob ? (
                <>
                  <View
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 22,
                      backgroundColor: colors.beeYellow + "20",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text style={{ fontSize: 20 }}>🐝</Text>
                  </View>
                  <View>
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 14,
                        color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                      }}
                    >
                      NibJobs
                    </Text>
                    <Text
                      style={{
                        fontFamily: fonts.regular,
                        fontSize: 12,
                        color: isDarkMode ? "#6B7280" : colors.warmGray,
                      }}
                    >
                      Posted directly by company
                    </Text>
                  </View>
                </>
              ) : (
                <>
                  <View
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 22,
                      backgroundColor: "#E3F2FD",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name="send" size={20} color="#0088CC" />
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 14,
                        color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                      }}
                    >
                      {job.jobSource || "Telegram Channel"}
                    </Text>
                    <Text
                      style={{
                        fontFamily: fonts.regular,
                        fontSize: 12,
                        color: isDarkMode ? "#6B7280" : colors.warmGray,
                      }}
                    >
                      Sourced from Telegram
                    </Text>
                  </View>
                  {(job.telegramMessageUrl || job.telegramLink) && (
                    <TouchableOpacity
                      onPress={() =>
                        Linking.openURL(
                          job.telegramMessageUrl || job.telegramLink,
                        )
                      }
                      style={{
                        backgroundColor: "#0088CC",
                        paddingHorizontal: 12,
                        paddingVertical: 8,
                        borderRadius: 8,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: fonts.medium,
                          fontSize: 12,
                          color: "#FFFFFF",
                        }}
                      >
                        View Post
                      </Text>
                    </TouchableOpacity>
                  )}
                </>
              )}
            </View>
          </View>

          {/* Login Prompt for Non-Authenticated Users */}
          {!user && (
            <View
              style={{
                backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
                borderRadius: 16,
                padding: isMobile ? 20 : 24,
                borderWidth: 1,
                borderColor: colors.beeYellow + "40",
              }}
            >
              <View style={{ alignItems: "center", marginBottom: 16 }}>
                <View
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: 24,
                    backgroundColor: colors.beeYellow + "20",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 12,
                  }}
                >
                  <Icon name="person" size={24} color={colors.beeYellow} />
                </View>
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: 16,
                    color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                    marginBottom: 4,
                  }}
                >
                  Want to save this job?
                </Text>
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 13,
                    color: isDarkMode ? "#6B7280" : colors.warmGray,
                    textAlign: "center",
                  }}
                >
                  Create an account to save jobs and get personalized
                  recommendations
                </Text>
              </View>
              <TouchableOpacity
                onPress={() => navigation.navigate("Signup")}
                style={{
                  backgroundColor: colors.beeYellow,
                  paddingVertical: 14,
                  borderRadius: 12,
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: 14,
                    color: colors.deepNavy,
                  }}
                >
                  Sign In or Create Account
                </Text>
              </TouchableOpacity>
            </View>
          )}

          {/* Related Jobs */}
          {relatedJobs.length > 0 && (
            <View style={{ marginTop: 8 }}>
              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: 18,
                  color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                  marginBottom: 14,
                }}
              >
                Similar Jobs
              </Text>
              <ScrollView
                horizontal
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={{ gap: 12 }}
              >
                {relatedJobs.map((relatedJob: any) => (
                  <TouchableOpacity
                    key={relatedJob.id}
                    onPress={() =>
                      navigation.push("JobDetails", { id: relatedJob.id })
                    }
                    style={{
                      width: 260,
                      backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
                      borderRadius: 14,
                      padding: 16,
                      borderWidth: 1,
                      borderColor: isDarkMode ? "#2C2F36" : "#E5E7EB",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10,
                        marginBottom: 10,
                      }}
                    >
                      {relatedJob.sourceImageUrl ? (
                        <Image
                          source={{ uri: relatedJob.sourceImageUrl }}
                          style={{ width: 36, height: 36, borderRadius: 8 }}
                          resizeMode="cover"
                        />
                      ) : (
                        <View
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: 8,
                            backgroundColor: isDarkMode ? "#2C2F36" : "#FEF3C7",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon
                            name="business"
                            size={18}
                            color={colors.beeYellow}
                          />
                        </View>
                      )}
                      <Text
                        style={{
                          flex: 1,
                          fontFamily: fonts.medium,
                          fontSize: 12,
                          color: isDarkMode ? "#9CA3AF" : colors.warmGray,
                        }}
                        numberOfLines={1}
                      >
                        {relatedJob.company}
                      </Text>
                    </View>
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 14,
                        color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                        marginBottom: 8,
                      }}
                      numberOfLines={2}
                    >
                      {relatedJob.title}
                    </Text>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 12,
                      }}
                    >
                      {relatedJob.location && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 4,
                          }}
                        >
                          <Icon
                            name="location-on"
                            size={12}
                            color={isDarkMode ? "#6B7280" : colors.warmGray}
                          />
                          <Text
                            style={{
                              fontFamily: fonts.regular,
                              fontSize: 11,
                              color: isDarkMode ? "#6B7280" : colors.warmGray,
                            }}
                            numberOfLines={1}
                          >
                            {relatedJob.location}
                          </Text>
                        </View>
                      )}
                      <Text
                        style={{
                          fontFamily: fonts.regular,
                          fontSize: 11,
                          color: isDarkMode ? "#6B7280" : colors.warmGray,
                        }}
                      >
                        {getTimeAgo(
                          relatedJob.postedDate || relatedJob.createdAt,
                        )}
                      </Text>
                    </View>
                  </TouchableOpacity>
                ))}
              </ScrollView>
            </View>
          )}

          {/* Footer Info */}
          <View
            style={{
              alignItems: "center",
              paddingVertical: 24,
              paddingBottom: 100,
              gap: 8,
            }}
          >
            <Text
              style={{
                fontFamily: fonts.regular,
                fontSize: 12,
                color: isDarkMode ? "#4B5563" : "#9CA3AF",
              }}
            >
              Job ID: {job.id.substring(0, 8)} • Posted{" "}
              {formatDate(job.createdAt)}
            </Text>
            <Text
              style={{
                fontFamily: fonts.regular,
                fontSize: 11,
                color: isDarkMode ? "#4B5563" : "#9CA3AF",
              }}
            >
              © 2024 NibJobs - Connecting Ethiopia's Talent
            </Text>
          </View>
        </View>

        {/* Ad above the footer, before apply button */}
        <AdBanner variant="detail" />
      </ScrollView>

      {/* Sticky Apply Button */}
      <View
        style={{
          position: "absolute",
          bottom: isMobile ? 56 : 60,
          left: 0,
          right: 0,
          backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
          paddingHorizontal: 16,
          paddingVertical: 12,
          paddingBottom: 12,
          borderTopWidth: 1,
          borderTopColor: isDarkMode ? "#2C2F36" : "#E5E7EB",
          zIndex: 100,
        }}
      >
        <TouchableOpacity
          onPress={handleApply}
          disabled={(hasApplied && isCompanyJob) || quickApplying}
          style={{
            backgroundColor:
              hasApplied && isCompanyJob
                ? "#10B981"
                : quickApplying
                ? "#9CA3AF"
                : colors.beeYellow,
            paddingVertical: 16,
            borderRadius: 14,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
          }}
        >
          {quickApplying ? (
            <>
              <ActivityIndicator size="small" color={colors.deepNavy} />
              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: 16,
                  color: colors.deepNavy,
                }}
              >
                Applying...
              </Text>
            </>
          ) : hasApplied && isCompanyJob ? (
            <>
              <Icon name="check-circle" size={20} color="#FFFFFF" />
              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: 16,
                  color: "#FFFFFF",
                }}
              >
                Applied
              </Text>
            </>
          ) : isCompanyJob ? (
            <>
              <Icon name="flash-on" size={20} color={colors.deepNavy} />
              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: 16,
                  color: colors.deepNavy,
                }}
              >
                Quick Apply
              </Text>
            </>
          ) : (
            <>
              <Icon name="send" size={20} color={colors.deepNavy} />
              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: 16,
                  color: colors.deepNavy,
                }}
              >
                Apply on Telegram
              </Text>
            </>
          )}
        </TouchableOpacity>
      </View>

      {/* Bottom Navigation Bar */}
      <BottomNavBar
        navigation={navigation}
        activeRoute="JobDetails"
        isDarkMode={isDarkMode}
        user={user}
        userData={userData}
        currentLanguage={currentLanguage}
      />
    </SafeAreaView>
  );
}

// Job Application Screen - For applying to company-created jobs
function JobApplicationScreen({
  route,
  navigation,
  isDarkMode,
  currentLanguage = "en",
}: any) {
  const { jobId } = route.params || {};
  const [job, setJob] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [activeStep, setActiveStep] = useState(1);
  const [hasApplied, setHasApplied] = useState(false);
  const [existingApplication, setExistingApplication] = useState<any>(null);
  const { showAlert: showAppAlert } = useAppAlert();
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;

  // User profile data (pre-populated)
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [portfolio, setPortfolio] = useState("");
  const [linkedIn, setLinkedIn] = useState("");
  const [github, setGitHub] = useState("");
  const [coverLetter, setCoverLetter] = useState("");
  const [resumeUrl, setResumeUrl] = useState("");

  // Validation errors
  const [errors, setErrors] = useState<any>({});

  const colors = isDarkMode ? darkColors : lightColors;
  const scrollViewRef = useRef<any>(null);

  useEffect(() => {
    loadJobAndUserData();
  }, [jobId]);

  const loadJobAndUserData = async () => {
    try {
      setLoading(true);

      // Load job details
      const jobDoc = await getDoc(doc(db, "jobs", jobId));
      if (jobDoc.exists()) {
        setJob({ id: jobDoc.id, ...jobDoc.data() });
      } else {
        showAppAlert(
          "error",
          "Job Not Found",
          "The job you are looking for could not be found.",
          { onClose: () => navigation.goBack() },
        );
        return;
      }

      // Check if user has already applied
      if (auth.currentUser) {
        const applicationsQuery = dbQuery(
          collection(db, "applications"),
          where("jobId", "==", jobId),
          where("applicantId", "==", auth.currentUser.uid),
          limit(1),
        );
        const applicationsSnapshot = await getDocs(applicationsQuery);

        if (!applicationsSnapshot.empty) {
          setHasApplied(true);
          setExistingApplication({
            id: applicationsSnapshot.docs[0].id,
            ...applicationsSnapshot.docs[0].data(),
          });
        } else {
          // Load user profile data and pre-populate form
          const userDoc = await getDoc(doc(db, "users", auth.currentUser.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            const profile = userData.profile || {};

            setFullName(profile.fullName || userData.displayName || "");
            setEmail(userData.email || auth.currentUser.email || "");
            setPhone(profile.phone || "");
            setAddress(profile.address || "");
            setPortfolio(profile.portfolio || "");
            setLinkedIn(profile.linkedIn || "");
            setGitHub(profile.github || "");
            setResumeUrl(profile.resumeUrl || "");
          }
        }
      }
    } catch (error) {
      console.error("Error loading data:", error);
      showAppAlert(
        "error",
        "Loading Failed",
        "Failed to load application form. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    const newErrors: any = {};

    if (!fullName.trim()) {
      newErrors.fullName = "Full name is required";
    }

    if (!email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Invalid email format";
    }

    if (!phone.trim()) {
      newErrors.phone = "Phone number is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      showAppAlert(
        "warning",
        "Missing Fields",
        "Please fill in all required fields before submitting.",
      );
      return;
    }

    try {
      setSubmitting(true);

      // Create application document
      const applicationData = {
        jobId: job.id,
        jobTitle: job.title,
        companyId: job.companyId,
        companyName: job.company,
        applicantId: auth.currentUser?.uid,
        applicantName: fullName,
        applicantEmail: email,
        applicantPhone: phone,
        applicantAddress: address || null,
        applicantPortfolio: portfolio || null,
        applicantLinkedIn: linkedIn || null,
        applicantGitHub: github || null,
        resumeUrl: resumeUrl || null,
        coverLetter: coverLetter || null,
        status: "pending",
        appliedAt: new Date(),
        updatedAt: new Date(),
      };

      await addDoc(collection(db, "applications"), applicationData);

      // Update job application count
      await updateDoc(doc(db, "jobs", job.id), {
        applicationCount: (job.applicationCount || 0) + 1,
      });

      // Show success message with more details
      if (Platform.OS === "web") {
        showAppAlert(
          "success",
          "Application Submitted!",
          `Your application for "${job.title}" at ${job.company} has been submitted.\n\nWhat's next?\n• The company will review your application\n• You'll receive an email confirmation at ${email}\n• Check your application status in your profile\n\nGood luck! 🎉`,
        );
      } else {
        showAppAlert(
          "success",
          "Application Submitted!",
          "Application submitted successfully! Check your email for confirmation.",
        );
      }

      navigation.goBack();
    } catch (error) {
      console.error("Error submitting application:", error);
      showAppAlert(
        "error",
        "Submission Failed",
        "Failed to submit application. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <ModernLoadingScreen
        message="Loading application form..."
        isDarkMode={isDarkMode}
      />
    );
  }

  if (!job) {
    return (
      <View style={[styles.errorContainer, { backgroundColor: colors.white }]}>
        <Text style={[styles.errorText, { color: colors.danger }]}>
          Job not found
        </Text>
      </View>
    );
  }

  // Already applied screen
  if (hasApplied && existingApplication) {
    return (
      <SafeAreaView
        style={[styles.container, { backgroundColor: colors.lightGray }]}
      >
        <View
          style={[
            styles.modernToolbar,
            {
              backgroundColor: colors.white,
              borderBottomColor: colors.lightGray,
            },
          ]}
        >
          <TouchableOpacity
            onPress={() => navigation.goBack()}
            style={styles.modernToolbarBackButton}
          >
            <Icon name="arrow-back" size={24} color={colors.deepNavy} />
          </TouchableOpacity>
          <Text style={[styles.modernToolbarTitle, { color: colors.deepNavy }]}>
            {t.applicationStatus}
          </Text>
          <View style={{ width: 40 }} />
        </View>

        <ScrollView
          style={styles.applicationFormContainer}
          contentContainerStyle={{ alignItems: "center", paddingTop: 60 }}
        >
          <View
            style={[
              styles.applyAlreadyAppliedCard,
              { backgroundColor: colors.white },
            ]}
          >
            <View
              style={[
                styles.applyAlreadyAppliedIcon,
                { backgroundColor: colors.success + "20" },
              ]}
            >
              <Icon name="check-circle" size={64} color={colors.success} />
            </View>

            <Text
              style={[
                styles.applyAlreadyAppliedTitle,
                { color: colors.deepNavy },
              ]}
            >
              Application Submitted!
            </Text>

            <Text
              style={[
                styles.applyAlreadyAppliedMessage,
                { color: colors.warmGray },
              ]}
            >
              You've already applied for this position on{" "}
              {existingApplication.appliedAt?.toDate
                ? new Date(
                    existingApplication.appliedAt.toDate(),
                  ).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : "recently"}
              .
            </Text>

            <View
              style={[
                styles.applyStatusBadge,
                {
                  backgroundColor:
                    existingApplication.status === "pending"
                      ? colors.warmGray + "20"
                      : existingApplication.status === "reviewed"
                      ? colors.softBlue + "20"
                      : existingApplication.status === "shortlisted"
                      ? colors.beeYellow + "20"
                      : existingApplication.status === "accepted"
                      ? colors.success + "20"
                      : colors.danger + "20",
                },
              ]}
            >
              <Icon
                name={
                  existingApplication.status === "pending"
                    ? "schedule"
                    : existingApplication.status === "reviewed"
                    ? "visibility"
                    : existingApplication.status === "shortlisted"
                    ? "star"
                    : existingApplication.status === "accepted"
                    ? "check-circle"
                    : "cancel"
                }
                size={20}
                color={
                  existingApplication.status === "pending"
                    ? colors.warmGray
                    : existingApplication.status === "reviewed"
                    ? colors.softBlue
                    : existingApplication.status === "shortlisted"
                    ? colors.beeYellow
                    : existingApplication.status === "accepted"
                    ? colors.success
                    : colors.danger
                }
              />
              <Text
                style={[
                  styles.applyStatusBadgeText,
                  {
                    color:
                      existingApplication.status === "pending"
                        ? colors.warmGray
                        : existingApplication.status === "reviewed"
                        ? colors.softBlue
                        : existingApplication.status === "shortlisted"
                        ? colors.beeYellow
                        : existingApplication.status === "accepted"
                        ? colors.success
                        : colors.danger,
                  },
                ]}
              >
                Status:{" "}
                {existingApplication.status.charAt(0).toUpperCase() +
                  existingApplication.status.slice(1)}
              </Text>
            </View>

            <View
              style={[styles.applyInfoBox, { backgroundColor: colors.cream }]}
            >
              <Icon name="info" size={18} color={colors.beeYellow} />
              <Text style={[styles.applyInfoText, { color: colors.deepNavy }]}>
                {existingApplication.status === "pending" &&
                  "The company is reviewing your application. You'll be notified of any updates."}
                {existingApplication.status === "reviewed" &&
                  "Your application has been reviewed by the company."}
                {existingApplication.status === "shortlisted" &&
                  "Congratulations! You've been shortlisted. The company may contact you soon."}
                {existingApplication.status === "accepted" &&
                  "Congratulations! Your application has been accepted. The company will contact you with next steps."}
                {existingApplication.status === "rejected" &&
                  "Thank you for your interest. While this didn't work out, keep applying to other opportunities."}
              </Text>
            </View>

            <TouchableOpacity
              style={[
                styles.applyBackToJobsButton,
                { backgroundColor: colors.beeYellow },
              ]}
              onPress={() => navigation.navigate("Jobs")}
            >
              <Icon name="work" size={20} color={colors.deepNavy} />
              <Text
                style={[
                  styles.applyBackToJobsButtonText,
                  { color: colors.deepNavy },
                ]}
              >
                {t.browseMoreJobs}
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[
                styles.applyGoBackButton,
                { borderColor: colors.lightGray },
              ]}
              onPress={() => navigation.goBack()}
            >
              <Text
                style={[
                  styles.applyGoBackButtonText,
                  { color: colors.deepNavy },
                ]}
              >
                {t.goBack}
              </Text>
            </TouchableOpacity>
          </View>
        </ScrollView>
      </SafeAreaView>
    );
  }

  const steps = [
    { number: 1, title: t.personalInfoStep, icon: "person" },
    { number: 2, title: t.professionalStep, icon: "work" },
    { number: 3, title: t.coverLetterStep, icon: "description" },
  ];

  const scrollToTop = () => {
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({ y: 0, animated: true });
    }
  };

  const goToNextStep = () => {
    if (activeStep === 1) {
      // Validate step 1
      const newErrors: any = {};
      if (!fullName.trim()) newErrors.fullName = "Full name is required";
      if (!email.trim()) newErrors.email = "Email is required";
      else if (!/\S+@\S+\.\S+/.test(email))
        newErrors.email = "Invalid email format";
      if (!phone.trim()) newErrors.phone = "Phone number is required";

      setErrors(newErrors);
      if (Object.keys(newErrors).length === 0) {
        setActiveStep(2);
        scrollToTop();
      } else {
        showAppAlert(
          "warning",
          "Missing Fields",
          "Please fill in all required fields before continuing.",
        );
      }
    } else if (activeStep === 2) {
      setActiveStep(3);
      scrollToTop();
    }
  };

  const goToPrevStep = () => {
    if (activeStep > 1) {
      setActiveStep(activeStep - 1);
      scrollToTop();
    }
  };

  return (
    <SafeAreaView
      style={[styles.container, { backgroundColor: colors.lightGray }]}
    >
      {/* Modern Header with Progress */}
      <View style={[styles.applyHeader, { backgroundColor: colors.white }]}>
        <TouchableOpacity
          onPress={() => navigation.goBack()}
          style={styles.applyHeaderBack}
        >
          <Icon name="close" size={26} color={colors.deepNavy} />
        </TouchableOpacity>

        <View style={styles.applyHeaderContent}>
          <Text style={[styles.applyHeaderTitle, { color: colors.deepNavy }]}>
            {t.applyForPosition}
          </Text>
          <Text
            style={[styles.applyHeaderSubtitle, { color: colors.warmGray }]}
          >
            {t.stepLabel} {activeStep} {t.ofLabel} 3
          </Text>
        </View>

        {/* Progress Bar */}
        <View
          style={[
            styles.applyProgressContainer,
            { backgroundColor: colors.lightGray },
          ]}
        >
          <View
            style={[
              styles.applyProgressBar,
              {
                backgroundColor: colors.beeYellow,
                width: `${(activeStep / 3) * 100}%`,
              },
            ]}
          />
        </View>
      </View>

      {/* Step Indicators */}
      <View
        style={[styles.applyStepsContainer, { backgroundColor: colors.white }]}
      >
        {steps.map((step) => (
          <View key={step.number} style={styles.applyStepItem}>
            <View
              style={[
                styles.applyStepCircle,
                {
                  backgroundColor:
                    activeStep >= step.number
                      ? colors.beeYellow
                      : colors.lightGray,
                  borderColor:
                    activeStep === step.number
                      ? colors.beeYellow
                      : colors.lightGray,
                },
              ]}
            >
              {activeStep > step.number ? (
                <Icon name="check" size={18} color={colors.deepNavy} />
              ) : (
                <Icon
                  name={step.icon}
                  size={18}
                  color={
                    activeStep === step.number
                      ? colors.deepNavy
                      : colors.warmGray
                  }
                />
              )}
            </View>
            <Text
              style={[
                styles.applyStepText,
                {
                  color:
                    activeStep === step.number
                      ? colors.deepNavy
                      : colors.warmGray,
                },
              ]}
            >
              {step.title}
            </Text>
          </View>
        ))}
      </View>

      <ScrollView
        ref={scrollViewRef}
        style={styles.applicationFormContainer}
        showsVerticalScrollIndicator={false}
      >
        {/* Job Info Card - Modern Design */}
        <View style={[styles.applyJobCard, { backgroundColor: colors.white }]}>
          <View
            style={[
              styles.applyJobCardHeader,
              { backgroundColor: colors.cream },
            ]}
          >
            <View
              style={[
                styles.applyJobIcon,
                { backgroundColor: colors.beeYellow },
              ]}
            >
              <Icon name="work" size={24} color={colors.white} />
            </View>
            <View style={{ flex: 1 }}>
              <Text style={[styles.applyJobTitle, { color: colors.deepNavy }]}>
                {job.title}
              </Text>
              <Text
                style={[styles.applyJobCompany, { color: colors.warmGray }]}
              >
                {job.company}
              </Text>
            </View>
          </View>
          <View style={styles.applyJobMeta}>
            <View style={styles.applyJobMetaItem}>
              <Icon name="business-center" size={16} color={colors.beeYellow} />
              <Text
                style={[styles.applyJobMetaText, { color: colors.warmGray }]}
              >
                {job.contractType}
              </Text>
            </View>
            <View style={styles.applyJobMetaItem}>
              <Icon name="location-on" size={16} color={colors.beeYellow} />
              <Text
                style={[styles.applyJobMetaText, { color: colors.warmGray }]}
              >
                {job.location}
              </Text>
            </View>
            {job.salary && (
              <View style={styles.applyJobMetaItem}>
                <Icon name="payments" size={16} color={colors.beeYellow} />
                <Text
                  style={[styles.applyJobMetaText, { color: colors.warmGray }]}
                >
                  {job.salary}
                </Text>
              </View>
            )}
          </View>
        </View>

        {/* Step 1: Personal Information */}
        {activeStep === 1 && (
          <View
            style={[styles.applyFormSection, { backgroundColor: colors.white }]}
          >
            <View style={styles.applySectionHeader}>
              <View
                style={[
                  styles.applySectionIcon,
                  { backgroundColor: colors.cream },
                ]}
              >
                <Icon name="person" size={20} color={colors.beeYellow} />
              </View>
              <View style={{ flex: 1 }}>
                <Text
                  style={[styles.applySectionTitle, { color: colors.deepNavy }]}
                >
                  {t.personalInformationSection}
                </Text>
                <Text
                  style={[
                    styles.applySectionSubtitle,
                    { color: colors.warmGray },
                  ]}
                >
                  We've pre-filled this form with your profile information. You
                  can edit any field before submitting.
                </Text>
              </View>
            </View>

            {/* Full Name */}
            <View style={styles.applyFormGroup}>
              <Text style={[styles.applyFormLabel, { color: colors.deepNavy }]}>
                <Icon name="badge" size={14} color={colors.beeYellow} /> Full
                Name <Text style={{ color: colors.danger }}>*</Text>
              </Text>
              <View
                style={[
                  styles.applyInputContainer,
                  {
                    borderColor: errors.fullName
                      ? colors.danger
                      : fullName
                      ? colors.success
                      : colors.lightGray,
                    backgroundColor: colors.white,
                  },
                ]}
              >
                <TextInput
                  style={[styles.applyInput, { color: colors.deepNavy }]}
                  value={fullName}
                  onChangeText={setFullName}
                  placeholder="Enter your full name"
                  placeholderTextColor={colors.warmGray}
                />
                {fullName && (
                  <Icon name="check-circle" size={20} color={colors.success} />
                )}
              </View>
              {errors.fullName && (
                <View style={styles.applyErrorContainer}>
                  <Icon name="error" size={14} color={colors.danger} />
                  <Text
                    style={[styles.applyFormError, { color: colors.danger }]}
                  >
                    {errors.fullName}
                  </Text>
                </View>
              )}
            </View>

            {/* Email */}
            <View style={styles.applyFormGroup}>
              <Text style={[styles.applyFormLabel, { color: colors.deepNavy }]}>
                <Icon name="email" size={14} color={colors.beeYellow} /> Email{" "}
                <Text style={{ color: colors.danger }}>*</Text>
              </Text>
              <View
                style={[
                  styles.applyInputContainer,
                  {
                    borderColor: errors.email
                      ? colors.danger
                      : email && /\S+@\S+\.\S+/.test(email)
                      ? colors.success
                      : colors.lightGray,
                    backgroundColor: colors.white,
                  },
                ]}
              >
                <TextInput
                  style={[styles.applyInput, { color: colors.deepNavy }]}
                  value={email}
                  onChangeText={setEmail}
                  placeholder="your.email@example.com"
                  placeholderTextColor={colors.warmGray}
                  keyboardType="email-address"
                  autoCapitalize="none"
                />
                {email && /\S+@\S+\.\S+/.test(email) && (
                  <Icon name="check-circle" size={20} color={colors.success} />
                )}
              </View>
              {errors.email && (
                <View style={styles.applyErrorContainer}>
                  <Icon name="error" size={14} color={colors.danger} />
                  <Text
                    style={[styles.applyFormError, { color: colors.danger }]}
                  >
                    {errors.email}
                  </Text>
                </View>
              )}
            </View>

            {/* Phone */}
            <View style={styles.applyFormGroup}>
              <Text style={[styles.applyFormLabel, { color: colors.deepNavy }]}>
                <Icon name="phone" size={14} color={colors.beeYellow} /> Phone
                Number <Text style={{ color: colors.danger }}>*</Text>
              </Text>
              <View
                style={[
                  styles.applyInputContainer,
                  {
                    borderColor: errors.phone
                      ? colors.danger
                      : phone
                      ? colors.success
                      : colors.lightGray,
                    backgroundColor: colors.white,
                  },
                ]}
              >
                <TextInput
                  style={[styles.applyInput, { color: colors.deepNavy }]}
                  value={phone}
                  onChangeText={setPhone}
                  placeholder="+251 900 000 000"
                  placeholderTextColor={colors.warmGray}
                  keyboardType="phone-pad"
                />
                {phone && (
                  <Icon name="check-circle" size={20} color={colors.success} />
                )}
              </View>
              {errors.phone && (
                <View style={styles.applyErrorContainer}>
                  <Icon name="error" size={14} color={colors.danger} />
                  <Text
                    style={[styles.applyFormError, { color: colors.danger }]}
                  >
                    {errors.phone}
                  </Text>
                </View>
              )}
            </View>

            {/* Address */}
            <View style={styles.applyFormGroup}>
              <Text style={[styles.applyFormLabel, { color: colors.deepNavy }]}>
                <Icon name="location-on" size={14} color={colors.beeYellow} />{" "}
                Address
              </Text>
              <View
                style={[
                  styles.applyInputContainer,
                  {
                    borderColor: colors.lightGray,
                    backgroundColor: colors.white,
                  },
                ]}
              >
                <TextInput
                  style={[styles.applyInput, { color: colors.deepNavy }]}
                  value={address}
                  onChangeText={setAddress}
                  placeholder="City, Country"
                  placeholderTextColor={colors.warmGray}
                />
              </View>
            </View>
          </View>
        )}

        {/* Step 2: Professional Links */}
        {activeStep === 2 && (
          <View
            style={[styles.applyFormSection, { backgroundColor: colors.white }]}
          >
            <View style={styles.applySectionHeader}>
              <View
                style={[
                  styles.applySectionIcon,
                  { backgroundColor: colors.cream },
                ]}
              >
                <Icon name="work" size={20} color={colors.beeYellow} />
              </View>
              <View style={{ flex: 1 }}>
                <Text
                  style={[styles.applySectionTitle, { color: colors.deepNavy }]}
                >
                  Professional Links
                </Text>
                <Text
                  style={[
                    styles.applySectionSubtitle,
                    { color: colors.warmGray },
                  ]}
                >
                  {t.professionalLinksSubtitle}
                </Text>
              </View>
            </View>

            {/* Portfolio */}
            <View style={styles.applyFormGroup}>
              <Text style={[styles.applyFormLabel, { color: colors.deepNavy }]}>
                <Icon name="language" size={14} color={colors.beeYellow} />{" "}
                Portfolio/Website
              </Text>
              <View
                style={[
                  styles.applyInputContainer,
                  {
                    borderColor: colors.lightGray,
                    backgroundColor: colors.white,
                  },
                ]}
              >
                <TextInput
                  style={[styles.applyInput, { color: colors.deepNavy }]}
                  value={portfolio}
                  onChangeText={setPortfolio}
                  placeholder="https://yourportfolio.com"
                  placeholderTextColor={colors.warmGray}
                  autoCapitalize="none"
                  keyboardType="url"
                />
                {portfolio && (
                  <Icon name="link" size={20} color={colors.softBlue} />
                )}
              </View>
            </View>

            {/* LinkedIn */}
            <View style={styles.applyFormGroup}>
              <Text style={[styles.applyFormLabel, { color: colors.deepNavy }]}>
                <Icon name="work" size={14} color={colors.beeYellow} /> LinkedIn
              </Text>
              <View
                style={[
                  styles.applyInputContainer,
                  {
                    borderColor: colors.lightGray,
                    backgroundColor: colors.white,
                  },
                ]}
              >
                <TextInput
                  style={[styles.applyInput, { color: colors.deepNavy }]}
                  value={linkedIn}
                  onChangeText={setLinkedIn}
                  placeholder="https://linkedin.com/in/yourprofile"
                  placeholderTextColor={colors.warmGray}
                  autoCapitalize="none"
                  keyboardType="url"
                />
                {linkedIn && (
                  <Icon name="link" size={20} color={colors.softBlue} />
                )}
              </View>
            </View>

            {/* GitHub */}
            <View style={styles.applyFormGroup}>
              <Text style={[styles.applyFormLabel, { color: colors.deepNavy }]}>
                <Icon name="code" size={14} color={colors.beeYellow} /> GitHub
              </Text>
              <View
                style={[
                  styles.applyInputContainer,
                  {
                    borderColor: colors.lightGray,
                    backgroundColor: colors.white,
                  },
                ]}
              >
                <TextInput
                  style={[styles.applyInput, { color: colors.deepNavy }]}
                  value={github}
                  onChangeText={setGitHub}
                  placeholder="https://github.com/yourusername"
                  placeholderTextColor={colors.warmGray}
                  autoCapitalize="none"
                  keyboardType="url"
                />
                {github && (
                  <Icon name="link" size={20} color={colors.softBlue} />
                )}
              </View>
            </View>

            {/* Resume URL */}
            <View style={styles.applyFormGroup}>
              <Text style={[styles.applyFormLabel, { color: colors.deepNavy }]}>
                <Icon name="description" size={14} color={colors.beeYellow} />{" "}
                Resume/CV URL
              </Text>
              <View
                style={[
                  styles.applyInputContainer,
                  {
                    borderColor: colors.lightGray,
                    backgroundColor: colors.white,
                  },
                ]}
              >
                <TextInput
                  style={[styles.applyInput, { color: colors.deepNavy }]}
                  value={resumeUrl}
                  onChangeText={setResumeUrl}
                  placeholder="https://drive.google.com/your-resume"
                  placeholderTextColor={colors.warmGray}
                  autoCapitalize="none"
                  keyboardType="url"
                />
                {resumeUrl && (
                  <Icon name="link" size={20} color={colors.softBlue} />
                )}
              </View>
              <View style={styles.applyHintContainer}>
                <Icon name="info" size={14} color={colors.warmGray} />
                <Text
                  style={[styles.applyFormHint, { color: colors.warmGray }]}
                >
                  Link to your resume on Google Drive, Dropbox, or similar
                </Text>
              </View>
            </View>
          </View>
        )}

        {/* Step 3: Cover Letter */}
        {activeStep === 3 && (
          <View
            style={[styles.applyFormSection, { backgroundColor: colors.white }]}
          >
            <View style={styles.applySectionHeader}>
              <View
                style={[
                  styles.applySectionIcon,
                  { backgroundColor: colors.cream },
                ]}
              >
                <Icon name="description" size={20} color={colors.beeYellow} />
              </View>
              <View style={{ flex: 1 }}>
                <Text
                  style={[styles.applySectionTitle, { color: colors.deepNavy }]}
                >
                  Cover Letter
                </Text>
                <Text
                  style={[
                    styles.applySectionSubtitle,
                    { color: colors.warmGray },
                  ]}
                >
                  {t.coverLetterSubtitle}
                </Text>
              </View>
            </View>

            <View style={styles.applyFormGroup}>
              <View
                style={[
                  styles.applyTextareaContainer,
                  {
                    borderColor: colors.lightGray,
                    backgroundColor: colors.white,
                  },
                ]}
              >
                <TextInput
                  style={[styles.applyTextarea, { color: colors.deepNavy }]}
                  value={coverLetter}
                  onChangeText={setCoverLetter}
                  placeholder="Dear Hiring Manager,\n\nI am writing to express my strong interest in the position...\n\nI believe my skills and experience make me an excellent fit because...\n\nThank you for considering my application.\n\nBest regards"
                  placeholderTextColor={colors.warmGray}
                  multiline
                  numberOfLines={12}
                  textAlignVertical="top"
                />
              </View>
              <View style={styles.applyCoverLetterInfo}>
                <View style={styles.applyCoverLetterFooter}>
                  <Icon name="lightbulb" size={14} color={colors.beeYellow} />
                  <Text
                    style={[styles.applyFormHint, { color: colors.warmGray }]}
                  >
                    {t.coverLetterTip}
                  </Text>
                </View>
                <Text
                  style={[styles.applyCharCounter, { color: colors.warmGray }]}
                >
                  {coverLetter.length} characters
                </Text>
              </View>
            </View>
          </View>
        )}

        {/* Navigation Buttons */}
        <View style={styles.applyNavigationButtons}>
          {activeStep > 1 && (
            <TouchableOpacity
              style={[
                styles.applyBackButton,
                { borderColor: colors.lightGray },
              ]}
              onPress={goToPrevStep}
              disabled={submitting}
            >
              <Icon name="arrow-back" size={20} color={colors.deepNavy} />
              <Text
                style={[styles.applyBackButtonText, { color: colors.deepNavy }]}
              >
                {t.previousButton}
              </Text>
            </TouchableOpacity>
          )}

          {activeStep < 3 ? (
            <TouchableOpacity
              style={[
                styles.applyNextButton,
                {
                  backgroundColor: colors.beeYellow,
                  flex: activeStep === 1 ? 1 : 1,
                },
              ]}
              onPress={goToNextStep}
            >
              <Text
                style={[styles.applyNextButtonText, { color: colors.deepNavy }]}
              >
                {t.continueButton}
              </Text>
              <Icon name="arrow-forward" size={20} color={colors.deepNavy} />
            </TouchableOpacity>
          ) : (
            <TouchableOpacity
              style={[
                styles.applySubmitButton,
                {
                  backgroundColor: submitting
                    ? colors.lightGray
                    : colors.success,
                  opacity: submitting ? 0.6 : 1,
                },
              ]}
              onPress={handleSubmit}
              disabled={submitting}
            >
              {submitting ? (
                <>
                  <ActivityIndicator size="small" color={colors.white} />
                  <Text
                    style={[
                      styles.applySubmitButtonText,
                      { color: colors.white },
                    ]}
                  >
                    Submitting...
                  </Text>
                </>
              ) : (
                <>
                  <Icon name="send" size={20} color={colors.white} />
                  <Text
                    style={[
                      styles.applySubmitButtonText,
                      { color: colors.white },
                    ]}
                  >
                    {t.submitApplicationButton}
                  </Text>
                </>
              )}
            </TouchableOpacity>
          )}
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

// Jobs Screen - For verified and active users
function JobsScreen({
  navigation,
  route,
  isDarkMode,
  toggleTheme,
  currentLanguage = "en",
  setCurrentLanguage,
}: any) {
  const firebaseOps = React.useContext(FirebaseOpsContext);
  const { showAlert: showAppAlert } = useAppAlert();

  // Algolia search hook - replaces Firestore queries
  const {
    query: algoliaQuery,
    setQuery: setAlgoliaQuery,
    results: algoliaResults,
    loading: algoliaLoading,
    error: algoliaError,
    totalHits,
    page: algoliaPage,
    filters: algoliaFilters,
    setFilters: setAlgoliaFilters,
    nextPage: algoliaNextPage,
    prevPage: algoliaPrevPage,
    refresh: algoliaRefresh,
  } = useJobSearch();

  // Keep your original state for UI
  const [jobs, setJobs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [actualSearchQuery, setActualSearchQuery] = useState("");
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState<string[]>(
    [],
  );
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [selectedJobType, setSelectedJobType] = useState("");
  const [selectedRemote, setSelectedRemote] = useState("");
  const [selectedSalary, setSelectedSalary] = useState("");
  // "1month" | "3months" | "older" — default matches the 3-month window used elsewhere
  const [selectedPostedDate, setSelectedPostedDate] = useState("3months");
  const [categories, setCategories] = useState<any[]>([]);
  const [user, setUser] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState<string[]>([]);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const languageButtonRef = useRef<any>(null);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    right: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalJobs, setTotalJobs] = useState(0);
  const [lastVisible, setLastVisible] = useState<any>(null);
  const [firstVisible, setFirstVisible] = useState<any>(null);
  const [pageCache, setPageCache] = useState<Map<number, any>>(new Map());
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [upgradeModal, setUpgradeModal] = useState<{
    visible: boolean;
    featureLabel?: string;
  }>({ visible: false });

  // Sync Algolia results with your UI state
  useEffect(() => {
    setJobs(algoliaResults);
    setTotalJobs(totalHits);
    setLoading(algoliaLoading);
  }, [algoliaResults, totalHits, algoliaLoading]);

  // Sync search query with Algolia query (only when actualSearchQuery changes)
  useEffect(() => {
    setAlgoliaQuery(actualSearchQuery);
  }, [actualSearchQuery]);

  // Handle search submission
  const handleSearch = () => {
    setActualSearchQuery(searchText);
  };

  // Sync your filters with Algolia filters
  useEffect(() => {
    const newFilters: any = {};

    // Map categories
    if (selectedCategories.length > 0 || selectedSubcategories.length > 0) {
      newFilters.categories = [...selectedCategories, ...selectedSubcategories];
    }

    // Map tags
    if (selectedTags.length > 0) {
      newFilters.tags = selectedTags;
    }

    // Map contract type
    if (selectedJobType) {
      newFilters.contractTypes = [selectedJobType];
    }

    // Map remote filter
    if (selectedRemote === "Remote") {
      newFilters.isRemote = true;
    } else if (selectedRemote === "On-site") {
      newFilters.isRemote = false;
    } else {
      newFilters.isRemote = null;
    }

    // Map salary filter
    if (selectedSalary === "With Salary") {
      newFilters.hasSalary = true;
    } else if (selectedSalary === "Without Salary") {
      newFilters.hasSalary = false;
    } else {
      newFilters.hasSalary = null;
    }

    // Map posted-date filter — "older" removes the cutoff entirely (shows jobs of any age)
    if (selectedPostedDate === "1month") {
      newFilters.postedWithinDays = 30;
    } else if (selectedPostedDate === "3months") {
      newFilters.postedWithinDays = 90;
    } else {
      newFilters.postedWithinDays = null;
    }

    setAlgoliaFilters(newFilters);
  }, [
    selectedCategories,
    selectedSubcategories,
    selectedTags,
    selectedJobType,
    selectedRemote,
    selectedSalary,
    selectedPostedDate,
  ]);

  // Collapsible filter states
  const [categoriesExpanded, setCategoriesExpanded] = useState(true);
  const [subcategoriesExpanded, setSubcategoriesExpanded] = useState(true);
  const [tagsExpanded, setTagsExpanded] = useState(true);
  const [employmentTypeExpanded, setEmploymentTypeExpanded] = useState(true);
  const [workModeExpanded, setWorkModeExpanded] = useState(true);
  const [salaryExpanded, setSalaryExpanded] = useState(true);
  const [postedDateExpanded, setPostedDateExpanded] = useState(true);

  // View mode state for grid/list toggle
  const [viewMode, setViewMode] = useState<"grid" | "list">("grid");

  // Responsive design
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = Platform.OS !== "web" || dimensions.width < 768;
  const isTablet = dimensions.width >= 768 && dimensions.width < 1024;
  const isDesktop = dimensions.width >= 1024;

  // Mobile filter menu state
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  // Mobile navigation menu state
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  // New filter enhancements
  const [tagSearchQuery, setTagSearchQuery] = useState("");
  const [showFilterPresets, setShowFilterPresets] = useState(false);
  const [savedPresets, setSavedPresets] = useState<any[]>([]);

  // Mobile app bar states
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  const jobsPerPage = 12;

  const colors = isDarkMode ? darkColors : lightColors;
  const t = translations[currentLanguage as keyof typeof translations];

  const languageOptions = [
    { code: "en", label: "English" },
    { code: "am", label: "አማርኛ" },
    { code: "ti", label: "ትግርኛ" },
    { code: "or", label: "Afaan Oromoo" },
  ];

  const getCurrentLanguage = () => {
    return (
      languageOptions.find((lang) => lang.code === currentLanguage) ||
      languageOptions[0]
    );
  };

  const toggleLanguageDropdown = () => {
    if (!showLanguageMenu && languageButtonRef.current) {
      languageButtonRef.current.measureInWindow(
        (x: number, y: number, width: number, height: number) => {
          setDropdownPosition({
            top: y + height + 5,
            right:
              typeof window !== "undefined" ? window.innerWidth - x - width : 0,
          });
        },
      );
    }
    setShowLanguageMenu(!showLanguageMenu);
  };

  const changeLanguage = async (langCode: string) => {
    if (setCurrentLanguage) setCurrentLanguage(langCode);
    setSelectedLanguage(
      languageOptions.find((lang) => lang.code === langCode)?.label ||
        "English",
    );
    setShowLanguageMenu(false);
    try {
      await AsyncStorage.setItem("selectedLanguage", langCode);
    } catch (error) {
      console.error("Error saving language preference:", error);
    }
  };

  // Track if user preferences have been applied
  const [userPreferencesApplied, setUserPreferencesApplied] = useState(false);
  const [filtersInitialized, setFiltersInitialized] = useState(false);
  const [urlHasFilters, setUrlHasFilters] = useState(false);

  // Handle /category/:categorySlug route - auto-select category by slug
  useEffect(() => {
    const categorySlug = route?.params?.categorySlug;
    if (!categorySlug || categories.length === 0) return;
    const slugify = (s: string) =>
      (s || "")
        .toLowerCase()
        .trim()
        .replace(/&/g, "and")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-|-$/g, "");
    const normalizedSlug = slugify(categorySlug);
    const match = categories.find(
      (c: any) =>
        slugify(c.name) === normalizedSlug || slugify(c.id) === normalizedSlug,
    );
    if (match?.name) {
      setSelectedCategories([match.name]);
      setUrlHasFilters(true);
    }
  }, [route?.params?.categorySlug, categories]);

  // Load filters from URL on mount
  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      let hasUrlFilters = false;

      const categories = params.get("categories");
      if (categories) {
        setSelectedCategories(categories.split(",").filter(Boolean));
        hasUrlFilters = true;
      }

      const subcategories = params.get("subcategories");
      if (subcategories)
        setSelectedSubcategories(subcategories.split(",").filter(Boolean));

      const tags = params.get("tags");
      if (tags) {
        setSelectedTags(tags.split(",").filter(Boolean));
        hasUrlFilters = true;
      }

      const jobType = params.get("jobType");
      if (jobType) {
        setSelectedJobType(jobType);
        hasUrlFilters = true;
      }

      const remote = params.get("remote");
      if (remote) {
        setSelectedRemote(remote);
        hasUrlFilters = true;
      }

      const salary = params.get("salary");
      if (salary) {
        setSelectedSalary(salary);
        hasUrlFilters = true;
      }

      const postedDate = params.get("postedDate");
      if (postedDate) {
        setSelectedPostedDate(postedDate);
        hasUrlFilters = true;
      }

      const search = params.get("search");
      if (search) {
        setSearchText(search);
        hasUrlFilters = true;
      }

      setUrlHasFilters(hasUrlFilters);
    }
    setFiltersInitialized(true);
  }, []);

  // Update URL whenever filters change
  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const params = new URLSearchParams();

      if (selectedCategories.length > 0)
        params.set("categories", selectedCategories.join(","));
      if (selectedSubcategories.length > 0)
        params.set("subcategories", selectedSubcategories.join(","));
      if (selectedTags.length > 0) params.set("tags", selectedTags.join(","));
      if (selectedJobType) params.set("jobType", selectedJobType);
      if (selectedRemote) params.set("remote", selectedRemote);
      if (selectedSalary) params.set("salary", selectedSalary);
      if (selectedPostedDate !== "3months")
        params.set("postedDate", selectedPostedDate);
      if (searchText) params.set("search", searchText);

      const newUrl = params.toString()
        ? `${window.location.pathname}?${params.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
  }, [
    selectedCategories,
    selectedSubcategories,
    selectedTags,
    selectedJobType,
    selectedRemote,
    selectedSalary,
    selectedPostedDate,
    searchText,
  ]);

  useEffect(() => {
    // Wait for URL filters to be parsed first
    if (!filtersInitialized) return;

    const initializeScreen = async () => {
      try {
        // Load saved language label for display
        const savedLanguage = await AsyncStorage.getItem("selectedLanguage");
        if (savedLanguage) {
          setSelectedLanguage(
            languageOptions.find((lang) => lang.code === savedLanguage)
              ?.label || "English",
          );
        }

        await fetchCategories();

        // Check if user is already logged in and apply preferences
        const currentUser = auth.currentUser;
        if (currentUser && !urlHasFilters && !userPreferencesApplied) {
          try {
            const userDoc = await getDoc(doc(db, "users", currentUser.uid));
            if (userDoc.exists()) {
              const data = userDoc.data();
              setUser(currentUser);
              setUserData(data);
              setBookmarkedJobs(data.savedJobs || []);

              if (data.interestedCategory) {
                setSelectedCategories([data.interestedCategory]);
              }
              if (
                data.interestedSubcategories &&
                data.interestedSubcategories.length > 0
              ) {
                setSelectedSubcategories(data.interestedSubcategories);
              }
              if (data.interestedTags && data.interestedTags.length > 0) {
                setSelectedTags(data.interestedTags);
              }

              setUserPreferencesApplied(true);

              // Algolia will automatically fetch when filter states update
            }
          } catch (error) {
            console.error("Error fetching user preferences:", error);
          }
        }

        // Set search text if passed from route params
        const initialSearchQuery = route?.params?.searchQuery;
        if (initialSearchQuery) {
          setSearchText(initialSearchQuery);
        }
        // Algolia will automatically fetch when searchText updates
      } catch (error) {
        console.error("Error initializing Jobs screen:", error);
      }
    };

    // Set search text if passed from home page BEFORE initializing
    if (route?.params?.searchQuery) {
      setSearchText(route.params.searchQuery);
    }

    initializeScreen();

    // Listen to auth state changes (for login/logout during session)
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        setUser(authUser);
        // Fetch bookmarked jobs and user data
        try {
          const userDoc = await getDoc(doc(db, "users", authUser.uid));
          if (userDoc.exists()) {
            const data = userDoc.data();
            setUserData(data);
            setBookmarkedJobs(data.bookmarkedJobs || []);

            // Only apply user preferences if NO URL filters and not already applied
            if (!urlHasFilters && !userPreferencesApplied) {
              if (data.interestedCategory) {
                setSelectedCategories([data.interestedCategory]);
              }
              if (
                data.interestedSubcategories &&
                data.interestedSubcategories.length > 0
              ) {
                setSelectedSubcategories(data.interestedSubcategories);
              }
              if (data.interestedTags && data.interestedTags.length > 0) {
                setSelectedTags(data.interestedTags);
              }

              setUserPreferencesApplied(true);
              // Algolia will automatically fetch when filter states update
            }
          }
        } catch (error) {
          console.error("Error fetching bookmarked jobs:", error);
        }
      } else {
        setUser(null);
        setUserData(null);
        setBookmarkedJobs([]);
        setUserPreferencesApplied(false);
      }
    });

    return unsubscribe;
  }, [route?.params?.searchQuery, filtersInitialized, urlHasFilters]);

  const jobsPermission = useSubscriptionPermissions(
    userData?.subscriptionPlan || userData?.subscriptionId,
  );

  const handleToggleBookmark = async (jobId: string) => {
    if (!user) {
      Alert.alert("Authentication Required", "Please sign up to bookmark jobs");
      navigation.navigate("Signup");
      return;
    }

    if (!jobsPermission.hasPermission("canSaveJobs")) {
      setUpgradeModal({ visible: true, featureLabel: "Save / Bookmark Jobs" });
      return;
    }

    try {
      const userRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userRef);
      const currentBookmarks = userDoc.data()?.savedJobs || [];

      if (currentBookmarks.includes(jobId)) {
        // Remove bookmark
        await updateDoc(userRef, {
          savedJobs: currentBookmarks.filter((id: string) => id !== jobId),
        });
        setBookmarkedJobs(
          currentBookmarks.filter((id: string) => id !== jobId),
        );
      } else {
        // Add bookmark
        trackInteraction("job_save", jobId);
        await updateDoc(userRef, {
          savedJobs: [...currentBookmarks, jobId],
        });
        setBookmarkedJobs([...currentBookmarks, jobId]);
      }
    } catch (error) {
      console.error("Error toggling bookmark:", error);
      showAppAlert(
        "error",
        "Bookmark Error",
        "Failed to update bookmark. Please try again.",
      );
    }
  };

  // Algolia handles refetching automatically via filter sync above
  // No separate refetch useEffect needed

  // Algolia handles all fetching automatically via useEffect hooks above
  // Legacy function signatures kept for compatibility with UI
  const fetchTotalCount = async () => {
    // No-op: Algolia provides totalHits directly
  };

  const fetchJobs = async () => {
    // No-op: Algolia auto-fetches via filter/query changes
  };

  const fetchCategories = async () => {
    try {
      const categoriesCollection = collection(db, "categories");
      const categoriesSnapshot = await getDocs(
        dbQuery(categoriesCollection, limit(200)),
      );
      firebaseOps.incrementReads(categoriesSnapshot.size);
      const categoriesData = categoriesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(categoriesData);
      if (categoriesData.length > 0) {
        const topLevel = categoriesData.filter((c: any) => c.level === 0);
        // eslint-disable-next-line no-console
        console.log(
          "Categories loaded:",
          categoriesData.length,
          "Top level:",
          topLevel.length,
          "Sample:",
          categoriesData[0],
        );
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setShowLogoutModal(false);
      navigation.replace("Home");
    } catch (error) {
      console.error("Logout error:", error);
      Alert.alert("Error", "Failed to logout. Please try again.");
    }
  };

  // Pagination calculations - using Algolia pagination
  const hasNextPage = algoliaPage * 20 < totalHits; // Assuming 20 items per page
  const hasPrevPage = algoliaPage > 0;

  const handlePageChange = (page: number) => {
    const direction = page > currentPage ? "next" : "prev";
    if (direction === "next") {
      algoliaNextPage();
    } else {
      algoliaPrevPage();
    }
    setCurrentPage(page);
  };

  // Helper function to get matched tags between user preferences and job tags
  const getMatchedTags = (job: any) => {
    if (!userData || !selectedTags || selectedTags.length === 0) return [];
    const jobTags = job.tags || [];
    return jobTags.filter((tag: string) => selectedTags.includes(tag));
  };

  // Helper function to get all match reasons for a job
  const getMatchReasons = (job: any) => {
    if (!userData) return null;

    const matches: {
      type: string;
      value: string;
      icon: string;
      color: string;
    }[] = [];

    // Check category match
    if (
      userData.interestedCategory &&
      job.categoryPath === userData.interestedCategory
    ) {
      const category = categories.find(
        (c) => c.path === userData.interestedCategory,
      );
      if (category) {
        matches.push({
          type: "Category",
          value: category.name,
          icon: "category",
          color: colors.softBlue,
        });
      }
    }

    // Check subcategory match
    if (
      userData.interestedSubcategories &&
      userData.interestedSubcategories.length > 0
    ) {
      const matchedSubcategory = userData.interestedSubcategories.find(
        (sub: string) => job.categoryPath === sub,
      );
      if (matchedSubcategory) {
        const subcategory = categories.find(
          (c) => c.path === matchedSubcategory,
        );
        if (subcategory) {
          matches.push({
            type: "Subcategory",
            value: subcategory.name,
            icon: "folder",
            color: colors.honeyGold,
          });
        }
      }
    }

    // Check tag matches
    if (userData.interestedTags && userData.interestedTags.length > 0) {
      const jobTags = job.tags || [];
      const matchedTags = jobTags.filter((tag: string) =>
        userData.interestedTags.includes(tag),
      );
      if (matchedTags.length > 0) {
        matches.push({
          type: "Skills",
          value: matchedTags.join(", "),
          icon: "local-offer",
          color: colors.beeYellow,
        });
      }
    }

    return matches.length > 0 ? matches : null;
  };

  const renderJobCard = ({ item: job }: any) => {
    const matchedTags = getMatchedTags(job);
    const matchReasons = getMatchReasons(job);
    // Algolia hits store createdAt as epoch ms; older data may still arrive as a
    // Firestore Timestamp-shaped object, so handle both.
    const jobPostedMs = (() => {
      const raw = job.createdAt ?? job.postedDate;
      if (raw === null || raw === undefined) return null;
      if (typeof raw === "number") return raw;
      if (typeof raw.seconds === "number") return raw.seconds * 1000;
      if (typeof raw._seconds === "number") return raw._seconds * 1000;
      const parsed = new Date(raw).getTime();
      return Number.isNaN(parsed) ? null : parsed;
    })();
    const isNew =
      jobPostedMs !== null &&
      Date.now() - jobPostedMs < 7 * 24 * 60 * 60 * 1000;
    // Jobs older than 3 months are only reachable via the "More than 3 months"
    // Posted Date filter — flag them so the card can show how old they are.
    const isOld =
      jobPostedMs !== null &&
      Date.now() - jobPostedMs > 90 * 24 * 60 * 60 * 1000;
    const jobAgeLabel = (() => {
      if (!isOld || jobPostedMs === null) return null;
      const days = Math.floor((Date.now() - jobPostedMs) / (24 * 60 * 60 * 1000));
      const months = Math.floor(days / 30);
      if (months < 12) return `${months} month${months === 1 ? "" : "s"} ago`;
      const years = Math.floor(months / 12);
      return `${years} year${years === 1 ? "" : "s"} ago`;
    })();
    const isUrgent =
      job.deadline &&
      new Date(job.deadline).getTime() - Date.now() < 3 * 24 * 60 * 60 * 1000;

    // ── Compact mobile card ──────────────────────────────────────────────────
    if (isMobile) {
      return (
        <TouchableOpacity
          style={[
            styles.modernJobCard,
            {
              backgroundColor: colors.white,
              minHeight: 0,
              marginHorizontal: 0,
              marginBottom: 10,
            },
          ]}
          activeOpacity={0.8}
          onPress={() => navigation.navigate("JobDetails", { id: job.id, job })}
        >
          {/* Top row: avatar + title + bookmark */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              padding: 12,
              gap: 10,
            }}
          >
            <View
              style={[
                styles.companyAvatar,
                {
                  backgroundColor: `${colors.deepNavy}10`,
                  width: 38,
                  height: 38,
                  borderRadius: 8,
                },
              ]}
            >
              {job.companyLogo ? (
                <Image
                  source={{ uri: job.companyLogo }}
                  style={{ width: 38, height: 38, borderRadius: 8 }}
                />
              ) : (
                <Text
                  style={[
                    styles.companyInitialLarge,
                    { color: colors.deepNavy, fontSize: 15 },
                  ]}
                >
                  {(job.company || "C").charAt(0).toUpperCase()}
                </Text>
              )}
            </View>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.bold,
                  color: colors.deepNavy,
                  lineHeight: 18,
                }}
                numberOfLines={2}
              >
                {job.title || "Job Title"}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  color: colors.warmGray,
                  fontFamily: fonts.medium,
                  marginTop: 1,
                }}
                numberOfLines={1}
              >
                {job.company || "Company"}
              </Text>
            </View>
            <TouchableOpacity
              style={{ padding: 4 }}
              onPress={(e) => {
                e.stopPropagation();
                handleToggleBookmark(job.id);
              }}
            >
              <Icon
                name={
                  bookmarkedJobs.includes(job.id)
                    ? "bookmark"
                    : "bookmark-border"
                }
                size={20}
                color={colors.beeYellow}
              />
            </TouchableOpacity>
          </View>

          {/* Chips row: type · location · experience */}
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              paddingHorizontal: 12,
              paddingBottom: 8,
              gap: 6,
            }}
          >
            {(job.contractType || job.isRemote !== undefined) && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: "#6366F112",
                  paddingHorizontal: 7,
                  paddingVertical: 3,
                  borderRadius: 5,
                  gap: 3,
                }}
              >
                <Icon name="work-outline" size={11} color="#6366F1" />
                <Text
                  style={{
                    fontSize: 11,
                    color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                    fontFamily: fonts.medium,
                  }}
                >
                  {job.contractType || "Full-time"}
                </Text>
              </View>
            )}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: "#6366F112",
                paddingHorizontal: 7,
                paddingVertical: 3,
                borderRadius: 5,
                gap: 3,
              }}
            >
              <Icon name="location-on" size={11} color="#6366F1" />
              <Text
                style={{
                  fontSize: 11,
                  color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                  fontFamily: fonts.medium,
                }}
                numberOfLines={1}
              >
                {job.isRemote ? "Remote" : job.location || "N/A"}
              </Text>
            </View>
            {job.experienceLevel && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: "#6366F112",
                  paddingHorizontal: 7,
                  paddingVertical: 3,
                  borderRadius: 5,
                  gap: 3,
                }}
              >
                <Icon name="school" size={11} color="#6366F1" />
                <Text
                  style={{
                    fontSize: 11,
                    color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                    fontFamily: fonts.medium,
                  }}
                  numberOfLines={1}
                >
                  {job.experienceLevel}
                </Text>
              </View>
            )}
            {isOld && jobAgeLabel && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: `${colors.warmGray}20`,
                  paddingHorizontal: 7,
                  paddingVertical: 3,
                  borderRadius: 5,
                  gap: 3,
                }}
              >
                <Icon name="schedule" size={11} color={colors.warmGray} />
                <Text
                  style={{
                    fontSize: 11,
                    color: colors.warmGray,
                    fontFamily: fonts.medium,
                  }}
                  numberOfLines={1}
                >
                  {jobAgeLabel}
                </Text>
              </View>
            )}
            {(isNew || isUrgent || job.featured) && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: isUrgent
                    ? `${colors.error}15`
                    : isNew
                    ? `${colors.success}15`
                    : `${colors.beeYellow}25`,
                  paddingHorizontal: 7,
                  paddingVertical: 3,
                  borderRadius: 5,
                }}
              >
                <Text
                  style={{
                    fontSize: 10,
                    fontFamily: fonts.bold,
                    color: isUrgent
                      ? colors.error
                      : isNew
                      ? colors.success
                      : colors.deepNavy,
                  }}
                >
                  {isUrgent ? "URGENT" : isNew ? "NEW" : "⭐"}
                </Text>
              </View>
            )}
          </View>

          {/* Footer: salary (if any) + apply button */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              paddingHorizontal: 12,
              paddingBottom: 10,
              gap: 8,
            }}
          >
            {job.salary ? (
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.bold,
                  color: colors.deepNavy,
                }}
                numberOfLines={1}
              >
                {job.salary}
                {job.salaryPeriod ? ` / ${job.salaryPeriod}` : ""}
              </Text>
            ) : (
              <Text
                style={{
                  fontSize: 11,
                  color: colors.warmGray,
                  fontFamily: fonts.regular,
                }}
              >
                {jobAgeLabel
                  ? jobAgeLabel
                  : jobPostedMs !== null
                  ? new Date(jobPostedMs).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                    })
                  : "Recently posted"}
              </Text>
            )}
            <TouchableOpacity
              style={[
                styles.applyButton,
                {
                  backgroundColor: colors.deepNavy,
                  paddingHorizontal: 10,
                  paddingVertical: 7,
                },
              ]}
              onPress={(e) => {
                e.stopPropagation();
                navigation.navigate("JobDetails", { id: job.id, job });
              }}
            >
              <Text
                style={[
                  styles.applyButtonText,
                  { color: colors.white, fontSize: 11 },
                ]}
              >
                {t.applyButton}
              </Text>
              <Icon name="arrow-forward" size={13} color={colors.white} />
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      );
    }

    // ── Full desktop / tablet card ───────────────────────────────────────────
    return (
      <TouchableOpacity
        style={[
          styles.modernJobCard,
          { backgroundColor: colors.white },
          viewMode === "list" && styles.modernJobCardList,
        ]}
        activeOpacity={0.8}
        onPress={() => navigation.navigate("JobDetails", { id: job.id, job })}
      >
        {/* Status Badges */}
        <View style={styles.badgesContainer}>
          {isNew && (
            <View
              style={[
                styles.statusBadge,
                { backgroundColor: `${colors.success}20` },
              ]}
            >
              <Text style={[styles.statusBadgeText, { color: colors.success }]}>
                NEW
              </Text>
            </View>
          )}
          {isUrgent && (
            <View
              style={[
                styles.statusBadge,
                { backgroundColor: `${colors.error}20` },
              ]}
            >
              <Text style={[styles.statusBadgeText, { color: colors.error }]}>
                URGENT
              </Text>
            </View>
          )}
          {job.featured && (
            <View
              style={[
                styles.statusBadge,
                { backgroundColor: `${colors.beeYellow}30` },
              ]}
            >
              <Text
                style={[styles.statusBadgeText, { color: colors.deepNavy }]}
              >
                ⭐ FEATURED
              </Text>
            </View>
          )}
          {isOld && jobAgeLabel && (
            <View
              style={[
                styles.statusBadge,
                { backgroundColor: `${colors.warmGray}25` },
              ]}
            >
              <Text
                style={[styles.statusBadgeText, { color: colors.warmGray }]}
              >
                {jobAgeLabel.toUpperCase()}
              </Text>
            </View>
          )}
        </View>

        {/* Header with Company Info */}
        <View style={styles.cardHeader}>
          <View style={styles.companyInfo}>
            <View
              style={[
                styles.companyAvatar,
                { backgroundColor: `${colors.deepNavy}10` },
              ]}
            >
              {job.companyLogo ? (
                <Image
                  source={{ uri: job.companyLogo }}
                  style={styles.companyLogoImage}
                />
              ) : (
                <Text
                  style={[
                    styles.companyInitialLarge,
                    { color: colors.deepNavy },
                  ]}
                >
                  {(job.company || "C").charAt(0).toUpperCase()}
                </Text>
              )}
            </View>
            <View style={styles.companyDetails}>
              <Text
                style={[styles.companyNameLarge, { color: colors.deepNavy }]}
                numberOfLines={1}
              >
                {job.company || "Company Name"}
              </Text>
              <View style={styles.companyMeta}>
                {job.companySize && (
                  <Text style={[styles.metaText, { color: colors.warmGray }]}>
                    👥 {job.companySize} employees
                  </Text>
                )}
                {job.industry && (
                  <>
                    {job.companySize && (
                      <Text
                        style={[styles.metaDivider, { color: colors.warmGray }]}
                      >
                        •
                      </Text>
                    )}
                    <Text style={[styles.metaText, { color: colors.warmGray }]}>
                      {job.industry}
                    </Text>
                  </>
                )}
              </View>
            </View>
          </View>
          <TouchableOpacity
            style={styles.bookmarkButton}
            onPress={(e) => {
              e.stopPropagation();
              handleToggleBookmark(job.id);
            }}
          >
            <Icon
              name={
                bookmarkedJobs.includes(job.id) ? "bookmark" : "bookmark-border"
              }
              size={22}
              color={colors.beeYellow}
            />
          </TouchableOpacity>
        </View>

        {/* Job Title & Category */}
        <View style={styles.titleContainer}>
          <Text
            style={[styles.jobTitleModern, { color: colors.deepNavy }]}
            numberOfLines={2}
          >
            {job.title || "Job Title"}
          </Text>
          {job.category && (
            <View
              style={[
                styles.categoryPill,
                { backgroundColor: `${colors.softBlue}30` },
              ]}
            >
              <Text
                style={[styles.categoryPillText, { color: colors.deepNavy }]}
              >
                {job.category}
              </Text>
            </View>
          )}
        </View>

        {/* Key Information Grid */}
        <View style={styles.infoGrid}>
          <View style={styles.infoCell}>
            <View
              style={{
                width: 30,
                height: 30,
                borderRadius: 8,
                backgroundColor: "#6366F112",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon name="work-outline" size={16} color="#6366F1" />
            </View>
            <View style={styles.infoCellContent}>
              <Text style={[styles.infoCellLabel, { color: colors.warmGray }]}>
                Type
              </Text>
              <Text
                style={[styles.infoCellValue, { color: colors.deepNavy }]}
                numberOfLines={1}
              >
                {job.contractType || "Full-time"}
              </Text>
            </View>
          </View>

          <View style={styles.infoCell}>
            <View
              style={{
                width: 30,
                height: 30,
                borderRadius: 8,
                backgroundColor: "#6366F112",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon name="location-on" size={16} color="#6366F1" />
            </View>
            <View style={styles.infoCellContent}>
              <Text style={[styles.infoCellLabel, { color: colors.warmGray }]}>
                Location
              </Text>
              <Text
                style={[styles.infoCellValue, { color: colors.deepNavy }]}
                numberOfLines={1}
              >
                {job.isRemote ? "🌍 Remote" : job.location || "N/A"}
              </Text>
            </View>
          </View>

          <View style={styles.infoCell}>
            <View
              style={{
                width: 30,
                height: 30,
                borderRadius: 8,
                backgroundColor: "#6366F112",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon name="school" size={16} color="#6366F1" />
            </View>
            <View style={styles.infoCellContent}>
              <Text style={[styles.infoCellLabel, { color: colors.warmGray }]}>
                Experience
              </Text>
              <Text
                style={[styles.infoCellValue, { color: colors.deepNavy }]}
                numberOfLines={1}
              >
                {job.experienceLevel || "Not specified"}
              </Text>
            </View>
          </View>

          {job.deadline && (
            <View style={styles.infoCell}>
              <View
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 8,
                  backgroundColor: isUrgent ? "#EF444415" : "#6366F112",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name="event"
                  size={16}
                  color={isUrgent ? "#EF4444" : "#6366F1"}
                />
              </View>
              <View style={styles.infoCellContent}>
                <Text
                  style={[styles.infoCellLabel, { color: colors.warmGray }]}
                >
                  Deadline
                </Text>
                <Text
                  style={[
                    styles.infoCellValue,
                    { color: isUrgent ? colors.error : colors.deepNavy },
                  ]}
                  numberOfLines={1}
                >
                  {new Date(job.deadline).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                  })}
                </Text>
              </View>
            </View>
          )}
        </View>

        {/* Salary Section - Prominent */}
        {job.salary && (
          <View
            style={[
              styles.salarySection,
              {
                backgroundColor: `${colors.beeYellow}15`,
                borderLeftColor: colors.beeYellow,
              },
            ]}
          >
            <Icon name="payments" size={20} color={colors.deepNavy} />
            <Text style={[styles.salaryAmount, { color: colors.deepNavy }]}>
              {job.salary}
            </Text>
            {job.salaryPeriod && (
              <Text style={[styles.salaryPeriod, { color: colors.warmGray }]}>
                / {job.salaryPeriod}
              </Text>
            )}
          </View>
        )}

        {/* Skills & Tags */}
        {job.skills && job.skills.length > 0 && (
          <View style={styles.skillsContainer}>
            <Text style={[styles.skillsLabel, { color: colors.warmGray }]}>
              Required Skills:
            </Text>
            <View style={styles.skillsRow}>
              {job.skills.slice(0, 4).map((skill: string, index: number) => (
                <View
                  key={index}
                  style={[
                    styles.skillTag,
                    { backgroundColor: `${colors.deepNavy}08` },
                  ]}
                >
                  <Text
                    style={[styles.skillTagText, { color: colors.deepNavy }]}
                  >
                    {skill}
                  </Text>
                </View>
              ))}
              {job.skills.length > 4 && (
                <View
                  style={[
                    styles.skillTag,
                    { backgroundColor: `${colors.warmGray}20` },
                  ]}
                >
                  <Text
                    style={[styles.skillTagText, { color: colors.warmGray }]}
                  >
                    +{job.skills.length - 4}
                  </Text>
                </View>
              )}
            </View>
          </View>
        )}

        {/* Description Preview */}
        {job.description && (
          <Text
            style={[styles.descriptionPreview, { color: colors.warmGray }]}
            numberOfLines={2}
          >
            {job.description}
          </Text>
        )}

        {/* Footer with Stats and CTA */}
        <View
          style={[
            styles.cardFooter,
            { borderTopColor: `${colors.lightGray}50` },
          ]}
        >
          <View style={styles.statsContainer}>
            <View style={styles.statChip}>
              <Icon name="visibility" size={14} color="#6366F1" />
              <Text style={[styles.statChipText, { color: colors.warmGray }]}>
                {job.views || 0}
              </Text>
            </View>
            <View style={styles.statChip}>
              <Icon name="people" size={14} color="#6366F1" />
              <Text style={[styles.statChipText, { color: colors.warmGray }]}>
                {job.applicationCount || 0} applied
              </Text>
            </View>
            <View style={styles.statChip}>
              <Icon name="schedule" size={14} color="#6366F1" />
              <Text style={[styles.statChipText, { color: colors.warmGray }]}>
                {jobAgeLabel
                  ? jobAgeLabel
                  : jobPostedMs !== null
                  ? new Date(jobPostedMs).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                    })
                  : "Recent"}
              </Text>
            </View>
          </View>

          <TouchableOpacity
            style={[styles.applyButton, { backgroundColor: colors.deepNavy }]}
            onPress={(e) => {
              e.stopPropagation();
              navigation.navigate("JobDetails", { id: job.id, job });
            }}
          >
            <Text style={[styles.applyButtonText, { color: colors.white }]}>
              Apply Now
            </Text>
            <Icon name="arrow-forward" size={16} color={colors.white} />
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <SafeAreaView
      style={[
        styles.container,
        { backgroundColor: isDarkMode ? "#0F1117" : colors.white },
      ]}
    >
      <SubscriptionUpgradeModal
        visible={upgradeModal.visible}
        featureLabel={upgradeModal.featureLabel}
        currentPlan={userData?.subscriptionPlan || userData?.subscriptionId}
        onClose={() => setUpgradeModal({ visible: false })}
        navigation={navigation}
        isDarkMode={isDarkMode}
      />
      {/* Header Toolbar */}
      <View
        style={[
          styles.jobsToolbar,
          {
            backgroundColor: isDarkMode ? "#0F1117" : colors.white,
            borderBottomColor: isDarkMode ? "#1E2027" : "#F0F0F0",
          },
        ]}
      >
        {/* ── MOBILE APP BAR ── */}
        {isMobile &&
          (() => {
            const activeFilterCount =
              selectedCategories.length +
              selectedSubcategories.length +
              selectedTags.length +
              (selectedJobType ? 1 : 0) +
              (selectedRemote ? 1 : 0) +
              (selectedSalary ? 1 : 0) +
              (selectedPostedDate !== "3months" ? 1 : 0);
            const iconColor = isDarkMode ? "#9CA3AF" : "#6B7280";
            const titleColor = isDarkMode ? "#F9FAFB" : colors.deepNavy;
            return isSearchExpanded ? (
              /* Search expanded — full-width input row */
              <View
                style={{
                  flex: 1,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    setIsSearchExpanded(false);
                    setSearchText("");
                  }}
                  hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
                >
                  <Icon name="arrow-back" size={22} color={titleColor} />
                </TouchableOpacity>
                <TextInput
                  style={{
                    flex: 1,
                    fontSize: 16,
                    fontFamily: fonts.regular,
                    color: titleColor,
                    padding: 0,
                  }}
                  placeholder="Search jobs…"
                  placeholderTextColor={iconColor}
                  value={searchText}
                  onChangeText={setSearchText}
                  onSubmitEditing={handleSearch}
                  returnKeyType="search"
                  autoFocus
                />
                {searchText.length > 0 && (
                  <TouchableOpacity
                    onPress={() => setSearchText("")}
                    hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
                  >
                    <Icon name="close" size={20} color={iconColor} />
                  </TouchableOpacity>
                )}
              </View>
            ) : (
              /* Default — [menu] [title] ── [search] [filter] */
              <>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    flex: 1,
                    gap: 10,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => setShowMobileMenu(true)}
                    hitSlop={{ top: 8, bottom: 8, left: 4, right: 8 }}
                  >
                    <Icon name="menu" size={24} color={titleColor} />
                  </TouchableOpacity>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Image
                      source={require("./assets/favicon.png")}
                      style={{ width: 26, height: 26, borderRadius: 6 }}
                      resizeMode="contain"
                    />
                    <View>
                      <Text
                        style={{
                          fontSize: 17,
                          fontFamily: fonts.bold,
                          color: titleColor,
                          letterSpacing: 0.1,
                          lineHeight: 20,
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: fonts.regular,
                            color: isDarkMode ? "#9CA3AF" : "#94A3B8",
                          }}
                        >
                          Nib
                        </Text>
                        Jobs
                      </Text>
                      <View
                        style={{
                          height: 2.5,
                          width: 32,
                          backgroundColor: "#F4C430",
                          borderRadius: 2,
                        }}
                      />
                    </View>
                  </View>
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <TouchableOpacity
                    onPress={() => setIsSearchExpanded(true)}
                    style={{ padding: 8 }}
                    hitSlop={{ top: 4, bottom: 4, left: 4, right: 4 }}
                  >
                    <Icon name="search" size={22} color={iconColor} />
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => setShowMobileFilters(true)}
                    style={{ padding: 8 }}
                    hitSlop={{ top: 4, bottom: 4, left: 4, right: 4 }}
                  >
                    <Icon
                      name="tune"
                      size={22}
                      color={
                        activeFilterCount > 0 ? colors.beeYellow : iconColor
                      }
                    />
                    {activeFilterCount > 0 && (
                      <View
                        style={{
                          position: "absolute",
                          top: 5,
                          right: 5,
                          backgroundColor: colors.beeYellow,
                          borderRadius: 5,
                          minWidth: 14,
                          height: 14,
                          alignItems: "center",
                          justifyContent: "center",
                          paddingHorizontal: 2,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 8,
                            fontFamily: fonts.bold,
                            color: colors.deepNavy,
                            lineHeight: 14,
                          }}
                        >
                          {activeFilterCount}
                        </Text>
                      </View>
                    )}
                  </TouchableOpacity>
                </View>
              </>
            );
          })()}

        {/* ── DESKTOP APP BAR ── */}
        {!isMobile && (
          <View style={styles.jobsToolbarLeft}>
            <TouchableOpacity onPress={() => navigation.navigate("Home")}>
              <Image
                source={require("./assets/favicon.png")}
                style={styles.toolbarLogo}
                resizeMode="contain"
              />
            </TouchableOpacity>

            <TouchableOpacity
              style={[
                styles.toolbarNavButton,
                {
                  borderBottomWidth: 3,
                  borderBottomColor: colors.beeYellow,
                  paddingBottom: 8,
                },
              ]}
              onPress={() => navigation.navigate("Jobs")}
            >
              <Text
                style={[
                  styles.toolbarNavButtonText,
                  {
                    color: colors.deepNavy,
                    fontWeight: "700",
                    fontFamily: fonts.bold,
                  },
                ]}
              >
                {t.navJobs}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.toolbarNavButton, { opacity: 0.6 }]}
              onPress={() => navigation.navigate("Companies")}
            >
              <Text
                style={[
                  styles.toolbarNavButtonText,
                  { color: colors.deepNavy },
                ]}
              >
                {t.companies}
              </Text>
            </TouchableOpacity>
            {user && userData?.role === "user" && (
              <TouchableOpacity
                style={[
                  styles.toolbarNavButton,
                  {
                    backgroundColor: "#374151",
                    paddingHorizontal: 16,
                    borderRadius: 8,
                  },
                ]}
                onPress={() => navigation.navigate("CompanyRegistration")}
              >
                <Text
                  style={[
                    styles.toolbarNavButtonText,
                    { color: "#FFFFFF", fontWeight: "600" },
                  ]}
                >
                  {t.cdPostJob}
                </Text>
              </TouchableOpacity>
            )}
            {user &&
              userData?.role === "company" &&
              userData?.companyProfile && (
                <TouchableOpacity
                  style={[
                    styles.toolbarNavButton,
                    {
                      backgroundColor: "#374151",
                      paddingHorizontal: 16,
                      borderRadius: 8,
                    },
                  ]}
                  onPress={() => navigation.navigate("CompanyDashboard")}
                >
                  <Text
                    style={[
                      styles.toolbarNavButtonText,
                      { color: "#FFFFFF", fontWeight: "600" },
                    ]}
                  >
                    {t.cdPostJob}
                  </Text>
                </TouchableOpacity>
              )}
            {user && (
              <TouchableOpacity
                onPress={() => navigation.navigate("Bookmarks")}
                style={{
                  width: 38,
                  height: 38,
                  borderRadius: 10,
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 4,
                }}
                activeOpacity={0.7}
                hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
              >
                <Icon
                  name="bookmark-border"
                  size={22}
                  color={colors.deepNavy}
                />
              </TouchableOpacity>
            )}
            <View
              style={[
                styles.toolbarSearchContainer,
                { backgroundColor: colors.lightGray },
              ]}
            >
              <Icon name="search" size={18} color={colors.warmGray} />
              <TextInput
                style={[styles.toolbarSearchInput, { color: colors.deepNavy }]}
                placeholder="Search jobs..."
                placeholderTextColor={colors.warmGray}
                value={searchText}
                onChangeText={setSearchText}
                onSubmitEditing={handleSearch}
                returnKeyType="search"
              />
              {searchText && (
                <TouchableOpacity
                  style={{
                    backgroundColor: "transparent",
                    paddingHorizontal: 16,
                    paddingVertical: 8,
                    borderRadius: 8,
                    marginLeft: 8,
                    borderWidth: 1,
                    borderColor: colors.lightGray,
                  }}
                  onPress={handleSearch}
                >
                  <Text
                    style={{
                      fontFamily: fonts.medium,
                      fontSize: 14,
                      color: colors.warmGray,
                    }}
                  >
                    Search
                  </Text>
                </TouchableOpacity>
              )}
            </View>
          </View>
        )}

        <View
          style={[styles.jobsToolbarRight, isMobile && { display: "none" }]}
        >
          {/* Alerts & Language - Desktop only */}
          {!isMobile && user && (
            <NotificationsBell
              navigation={navigation}
              isDarkMode={isDarkMode}
              currentLanguage={currentLanguage}
            />
          )}
          {!isMobile && (
            <DesktopLanguageSelector
              currentLanguage={currentLanguage}
              setCurrentLanguage={setCurrentLanguage}
              isDarkMode={isDarkMode}
            />
          )}
          {/* Theme Toggle Switch - Desktop only */}
          {!isMobile && (
            <TouchableOpacity
              style={styles.toolbarThemeToggle}
              onPress={toggleTheme}
            >
              <View
                style={[
                  styles.themeToggleTrack,
                  {
                    backgroundColor: isDarkMode
                      ? colors.deepNavy
                      : colors.lightGray,
                  },
                ]}
              >
                <Icon
                  name="wb-sunny"
                  size={14}
                  color={isDarkMode ? colors.warmGray : colors.beeYellow}
                  style={styles.themeToggleIconLeft}
                />
                <View
                  style={[
                    styles.themeToggleKnob,
                    { backgroundColor: colors.white },
                    isDarkMode && styles.themeToggleKnobActive,
                  ]}
                >
                  <Icon
                    name={isDarkMode ? "nightlight-round" : "wb-sunny"}
                    size={12}
                    color={isDarkMode ? colors.deepNavy : colors.beeYellow}
                  />
                </View>
                <Icon
                  name="nightlight-round"
                  size={14}
                  color={isDarkMode ? colors.beeYellow : colors.warmGray}
                  style={styles.themeToggleIconRight}
                />
              </View>
            </TouchableOpacity>
          )}

          {!isMobile &&
            (user ? (
              <UserMenu
                navigation={navigation}
                user={user}
                userData={userData}
                isDarkMode={isDarkMode}
                currentLanguage={currentLanguage}
              />
            ) : (
              <>
                <TouchableOpacity
                  style={[
                    styles.toolbarLoginButton,
                    { borderColor: colors.deepNavy },
                  ]}
                  onPress={() => navigation.navigate("Login")}
                >
                  <Text
                    style={[
                      styles.toolbarLoginButtonText,
                      { color: colors.deepNavy },
                    ]}
                  >
                    Login
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={[
                    styles.toolbarSignupButton,
                    { backgroundColor: colors.beeYellow },
                  ]}
                  onPress={() => navigation.navigate("Signup")}
                >
                  <Text
                    style={[
                      styles.toolbarSignupButtonText,
                      { color: colors.buttonTextOnYellow },
                    ]}
                  >
                    Sign Up
                  </Text>
                </TouchableOpacity>
              </>
            ))}
        </View>
      </View>

      <ScrollView
        style={[
          styles.jobsPageContainer,
          { backgroundColor: isDarkMode ? "#1A1D23" : colors.cream },
        ]}
        contentContainerStyle={{ width: "100%", maxWidth: "100vw" }}
        horizontal={false}
        showsHorizontalScrollIndicator={false}
      >
        {/* Main Content Area with Sidebar */}
        <View
          style={[
            styles.jobsContentWithSidebar,
            { flexDirection: isMobile ? "column" : "row" },
          ]}
        >
          {/* Premium Filter Sidebar - Desktop only */}
          {!isMobile && (
            <View
              style={[
                styles.filterSidebar,
                {
                  backgroundColor: isDarkMode ? "#0D0F12" : colors.white,
                  borderRadius: 20,
                  padding: 24,
                  shadowColor: isDarkMode ? "#000" : colors.deepNavy,
                  shadowOffset: { width: 0, height: 8 },
                  shadowOpacity: isDarkMode ? 0.3 : 0.08,
                  shadowRadius: 24,
                  elevation: 8,
                  borderWidth: 1,
                  borderColor: isDarkMode ? "#1E2128" : "#F0F0F0",
                },
              ]}
            >
              {/* Premium Header */}
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                  paddingBottom: 20,
                  borderBottomWidth: 2,
                  borderBottomColor: isDarkMode ? "#1E2128" : "#F5F5F5",
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <View
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 12,
                      backgroundColor: isDarkMode
                        ? colors.beeYellow + "20"
                        : colors.beeYellow + "15",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Icon
                      name="tune"
                      size={24}
                      color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                    />
                  </View>
                  <View>
                    <Text
                      style={{
                        fontSize: 20,
                        fontWeight: "800",
                        color: isDarkMode ? colors.white : colors.deepNavy,
                        fontFamily: fonts.bold,
                      }}
                    >
                      Filters
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,
                        color: isDarkMode ? "#8B92A8" : colors.warmGray,
                        marginTop: 2,
                      }}
                    >
                      Refine your search
                    </Text>
                  </View>
                </View>

                {/* Active filters count badge */}
                {(() => {
                  const activeFilters =
                    selectedCategories.length +
                    selectedSubcategories.length +
                    selectedTags.length +
                    (selectedJobType ? 1 : 0) +
                    (selectedRemote ? 1 : 0) +
                    (selectedSalary ? 1 : 0) +
              (selectedPostedDate !== "3months" ? 1 : 0);
                  return activeFilters > 0 ? (
                    <View
                      style={{
                        backgroundColor: colors.beeYellow,
                        paddingHorizontal: 10,
                        paddingVertical: 5,
                        borderRadius: 20,
                        minWidth: 28,
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          color: colors.buttonTextOnYellow,
                          fontSize: 13,
                          fontWeight: "800",
                          fontFamily: fonts.bold,
                        }}
                      >
                        {activeFilters}
                      </Text>
                    </View>
                  ) : null;
                })()}
              </View>

              {/* Clear All Filters */}
              {selectedCategories.length +
                selectedSubcategories.length +
                selectedTags.length +
                (selectedJobType ? 1 : 0) +
                (selectedRemote ? 1 : 0) +
                (selectedSalary ? 1 : 0) +
              (selectedPostedDate !== "3months" ? 1 : 0) >
                0 && (
                <TouchableOpacity
                  style={{
                    backgroundColor: isDarkMode
                      ? colors.beeYellow + "18"
                      : colors.beeYellow,
                    borderRadius: 14,
                    paddingVertical: 14,
                    paddingHorizontal: 18,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 10,
                    marginBottom: 20,
                    shadowColor: colors.beeYellow,
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: isDarkMode ? 0.2 : 0.15,
                    shadowRadius: 8,
                    elevation: 3,
                  }}
                  onPress={() => {
                    setSelectedCategories([]);
                    setSelectedSubcategories([]);
                    setSelectedTags([]);
                    setSelectedJobType("");
                    setSelectedRemote("");
                    setSelectedSalary("");
                    setSelectedPostedDate("3months");
                    setTagSearchQuery("");
                  }}
                  activeOpacity={0.8}
                >
                  <Icon
                    name="refresh"
                    size={18}
                    color={
                      isDarkMode ? colors.beeYellow : colors.buttonTextOnYellow
                    }
                  />
                  <Text
                    style={{
                      color: isDarkMode
                        ? colors.beeYellow
                        : colors.buttonTextOnYellow,
                      fontSize: 15,
                      fontWeight: "700",
                      fontFamily: fonts.bold,
                    }}
                  >
                    Reset All Filters
                  </Text>
                </TouchableOpacity>
              )}

              {/* Categories Filter - Premium Card Style */}
              <View
                style={{
                  backgroundColor: isDarkMode
                    ? "#12151A"
                    : `${colors.beeYellow}08`,
                  borderRadius: 16,
                  overflow: "hidden",
                  marginBottom: 16,
                  borderWidth: 1,
                  borderColor: isDarkMode ? "#1E2128" : `${colors.beeYellow}25`,
                }}
              >
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 16,
                    backgroundColor: isDarkMode ? "#161921" : colors.white,
                  }}
                  onPress={() => setCategoriesExpanded(!categoriesExpanded)}
                  activeOpacity={0.8}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                      flex: 1,
                    }}
                  >
                    <View
                      style={{
                        width: 38,
                        height: 38,
                        borderRadius: 10,
                        backgroundColor: isDarkMode
                          ? colors.beeYellow + "22"
                          : colors.beeYellow + "20",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        name="category"
                        size={20}
                        color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                      />
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 15,
                          fontWeight: "700",
                          color: isDarkMode ? "#E8EDF5" : colors.deepNavy,
                          fontFamily: fonts.bold,
                        }}
                      >
                        Categories
                      </Text>
                      {selectedCategories.length > 0 && (
                        <Text
                          style={{
                            fontSize: 12,
                            color: isDarkMode
                              ? colors.beeYellow
                              : colors.warmGray,
                            marginTop: 2,
                          }}
                          numberOfLines={1}
                        >
                          {selectedCategories.length} selected
                        </Text>
                      )}
                    </View>
                    {selectedCategories.length > 0 && (
                      <View
                        style={{
                          backgroundColor: colors.beeYellow,
                          paddingHorizontal: 8,
                          paddingVertical: 4,
                          borderRadius: 8,
                          minWidth: 24,
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={{
                            color: colors.buttonTextOnYellow,
                            fontSize: 11,
                            fontWeight: "800",
                            fontFamily: fonts.bold,
                          }}
                        >
                          {selectedCategories.length}
                        </Text>
                      </View>
                    )}
                  </View>
                  <Icon
                    name={categoriesExpanded ? "expand-less" : "expand-more"}
                    size={24}
                    color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                  />
                </TouchableOpacity>
                {categoriesExpanded && (
                  <View
                    style={{
                      padding: 12,
                      gap: 8,
                      backgroundColor: isDarkMode ? "#0D0F12" : "#FAFAFA",
                    }}
                  >
                    <ScrollView
                      style={{ maxHeight: 280 }}
                      showsVerticalScrollIndicator={false}
                    >
                      {categories
                        .filter((c) => c.level === 0)
                        .map((category) => (
                          <TouchableOpacity
                            key={category.id}
                            style={{
                              backgroundColor: selectedCategories.includes(
                                category.path,
                              )
                                ? isDarkMode
                                  ? colors.beeYellow
                                  : colors.deepNavy
                                : isDarkMode
                                ? "#161921"
                                : colors.white,
                              borderRadius: 12,
                              padding: 14,
                              marginBottom: 8,
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              borderWidth: 1,
                              borderColor: selectedCategories.includes(
                                category.path,
                              )
                                ? isDarkMode
                                  ? colors.beeYellow
                                  : colors.deepNavy
                                : isDarkMode
                                ? "#1E2128"
                                : "#E8E8E8",
                            }}
                            onPress={() => {
                              if (selectedCategories.includes(category.path)) {
                                // Deselect category and clear its subcategories and tags
                                setSelectedCategories(
                                  selectedCategories.filter(
                                    (c) => c !== category.path,
                                  ),
                                );
                                setSelectedSubcategories([]);
                                setSelectedTags([]);
                              } else {
                                // Select category and auto-select all subcategories and all tags
                                setSelectedCategories([category.path]);

                                // Find all subcategories under this category
                                const subcats = categories.filter(
                                  (c) =>
                                    c.level === 1 &&
                                    c.path &&
                                    c.path.startsWith(category.path + "/"),
                                );
                                setSelectedSubcategories(
                                  subcats.map((s) => s.path),
                                );

                                // Collect all tags from category and its subcategories
                                const allTags = new Set<string>();
                                if (category.tags) {
                                  category.tags.forEach((tag: string) =>
                                    allTags.add(tag),
                                  );
                                }
                                subcats.forEach((subcat) => {
                                  if (subcat.tags) {
                                    subcat.tags.forEach((tag: string) =>
                                      allTags.add(tag),
                                    );
                                  }
                                });

                                // Select all tags (no limit with Algolia)
                                setSelectedTags(Array.from(allTags));
                              }
                            }}
                            activeOpacity={0.7}
                          >
                            <Text
                              style={{
                                fontSize: 14,
                                fontWeight: selectedCategories.includes(
                                  category.path,
                                )
                                  ? "700"
                                  : "500",
                                color: selectedCategories.includes(
                                  category.path,
                                )
                                  ? isDarkMode
                                    ? colors.buttonTextOnYellow
                                    : colors.white
                                  : isDarkMode
                                  ? "#E8EDF5"
                                  : colors.deepNavy,
                                flex: 1,
                                fontFamily: selectedCategories.includes(
                                  category.path,
                                )
                                  ? fonts.bold
                                  : fonts.regular,
                              }}
                            >
                              {category.name}
                            </Text>
                            {selectedCategories.includes(category.path) && (
                              <View
                                style={{
                                  width: 22,
                                  height: 22,
                                  borderRadius: 11,
                                  backgroundColor: isDarkMode
                                    ? colors.buttonTextOnYellow
                                    : colors.white,
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Icon
                                  name="check"
                                  size={14}
                                  color={
                                    isDarkMode
                                      ? colors.beeYellow
                                      : colors.deepNavy
                                  }
                                />
                              </View>
                            )}
                          </TouchableOpacity>
                        ))}
                    </ScrollView>
                  </View>
                )}
              </View>

              {/* Subcategories Filter */}
              {selectedCategories.length > 0 && (
                <View style={styles.filterGroupSimple}>
                  <TouchableOpacity
                    style={styles.filterGroupHeaderSimple}
                    onPress={() =>
                      setSubcategoriesExpanded(!subcategoriesExpanded)
                    }
                  >
                    <Text
                      style={[
                        styles.filterGroupLabelSimple,
                        { color: isDarkMode ? "#D1D5DB" : "#374151" },
                      ]}
                    >
                      Subcategories{" "}
                      {selectedSubcategories.length > 0 &&
                        `(${selectedSubcategories.length})`}
                    </Text>
                    <Icon
                      name={
                        subcategoriesExpanded
                          ? "keyboard-arrow-up"
                          : "keyboard-arrow-down"
                      }
                      size={20}
                      color={isDarkMode ? "#9CA3AF" : "#6B7280"}
                    />
                  </TouchableOpacity>
                  {subcategoriesExpanded && (
                    <View style={styles.filterOptionsSimple}>
                      {categories
                        .filter((c) =>
                          selectedCategories.includes(c.parentPath),
                        )
                        .map((subcategory) => (
                          <TouchableOpacity
                            key={subcategory.id}
                            style={styles.filterCheckboxRow}
                            onPress={() => {
                              if (
                                selectedSubcategories.includes(subcategory.path)
                              ) {
                                // Deselect subcategory and its tags
                                setSelectedSubcategories(
                                  selectedSubcategories.filter(
                                    (s) => s !== subcategory.path,
                                  ),
                                );
                                // Remove tags associated with this subcategory
                                if (subcategory.tags) {
                                  setSelectedTags(
                                    selectedTags.filter(
                                      (t) => !subcategory.tags.includes(t),
                                    ),
                                  );
                                }
                              } else {
                                // Select subcategory and automatically select all its tags
                                setSelectedSubcategories([
                                  ...selectedSubcategories,
                                  subcategory.path,
                                ]);
                                if (
                                  subcategory.tags &&
                                  subcategory.tags.length > 0
                                ) {
                                  setSelectedTags([
                                    ...new Set([
                                      ...selectedTags,
                                      ...subcategory.tags,
                                    ]),
                                  ]);
                                }
                              }
                            }}
                            activeOpacity={0.7}
                          >
                            <View
                              style={[
                                styles.checkbox,
                                {
                                  borderColor: isDarkMode
                                    ? "#4B5563"
                                    : "#D1D5DB",
                                },
                                selectedSubcategories.includes(
                                  subcategory.path,
                                ) && {
                                  backgroundColor: isDarkMode
                                    ? colors.beeYellow
                                    : colors.deepNavy,
                                  borderColor: isDarkMode
                                    ? colors.beeYellow
                                    : colors.deepNavy,
                                },
                              ]}
                            >
                              {selectedSubcategories.includes(
                                subcategory.path,
                              ) && (
                                <Icon
                                  name="check"
                                  size={14}
                                  color={colors.white}
                                />
                              )}
                            </View>
                            <Text
                              style={[
                                styles.checkboxLabel,
                                { color: isDarkMode ? "#E5E7EB" : "#1F2937" },
                              ]}
                            >
                              {subcategory.name}
                            </Text>
                          </TouchableOpacity>
                        ))}
                    </View>
                  )}
                </View>
              )}

              {/* Tags Filter */}
              {(selectedCategories.length > 0 ||
                selectedSubcategories.length > 0) && (
                <View style={styles.filterGroupSimple}>
                  <TouchableOpacity
                    style={styles.filterGroupHeaderSimple}
                    onPress={() => setTagsExpanded(!tagsExpanded)}
                  >
                    <Text
                      style={[
                        styles.filterGroupLabelSimple,
                        { color: isDarkMode ? "#D1D5DB" : "#374151" },
                      ]}
                    >
                      Tags{" "}
                      {selectedTags.length > 0 && `(${selectedTags.length})`}
                    </Text>
                    <Icon
                      name={
                        tagsExpanded
                          ? "keyboard-arrow-up"
                          : "keyboard-arrow-down"
                      }
                      size={20}
                      color={isDarkMode ? "#9CA3AF" : "#6B7280"}
                    />
                  </TouchableOpacity>
                  {tagsExpanded && (
                    <View style={styles.filterOptionsSimple}>
                      {/* Tag Search */}
                      <View
                        style={[
                          styles.simpleSearchInput,
                          {
                            backgroundColor: isDarkMode ? "#1F2937" : "#F9FAFB",
                            borderColor: isDarkMode ? "#374151" : "#E5E7EB",
                          },
                        ]}
                      >
                        <Icon
                          name="search"
                          size={16}
                          color={isDarkMode ? "#6B7280" : "#9CA3AF"}
                        />
                        <TextInput
                          style={[
                            styles.searchInputField,
                            { color: isDarkMode ? "#E5E7EB" : "#111827" },
                          ]}
                          placeholder="Search..."
                          placeholderTextColor={
                            isDarkMode ? "#6B7280" : "#9CA3AF"
                          }
                          value={tagSearchQuery}
                          onChangeText={setTagSearchQuery}
                        />
                      </View>

                      <View style={styles.tagsContainer}>
                        {(() => {
                          const allTags = new Set<string>();
                          selectedCategories.forEach((catPath) => {
                            const cat = categories.find(
                              (c) => c.path === catPath,
                            );
                            if (cat?.tags)
                              cat.tags.forEach((tag: string) =>
                                allTags.add(tag),
                              );
                          });
                          selectedSubcategories.forEach((subPath) => {
                            const sub = categories.find(
                              (c) => c.path === subPath,
                            );
                            if (sub?.tags)
                              sub.tags.forEach((tag: string) =>
                                allTags.add(tag),
                              );
                          });

                          const filteredTags = Array.from(allTags).filter(
                            (tag) =>
                              tag
                                .toLowerCase()
                                .includes(tagSearchQuery.toLowerCase()),
                          );

                          if (filteredTags.length === 0) {
                            return (
                              <Text
                                style={[
                                  styles.noTagsTextSimple,
                                  { color: isDarkMode ? "#6B7280" : "#9CA3AF" },
                                ]}
                              >
                                {tagSearchQuery
                                  ? "No matching tags"
                                  : "No tags available"}
                              </Text>
                            );
                          }

                          return (
                            <>
                              {filteredTags.map((tag) => (
                                <TouchableOpacity
                                  key={tag}
                                  style={[
                                    styles.simpleTagChip,
                                    {
                                      backgroundColor: selectedTags.includes(
                                        tag,
                                      )
                                        ? isDarkMode
                                          ? colors.beeYellow
                                          : colors.deepNavy
                                        : isDarkMode
                                        ? "#1F2937"
                                        : "#F3F4F6",
                                      borderColor: selectedTags.includes(tag)
                                        ? isDarkMode
                                          ? colors.beeYellow
                                          : colors.deepNavy
                                        : isDarkMode
                                        ? "#374151"
                                        : "#E5E7EB",
                                    },
                                  ]}
                                  onPress={() => {
                                    if (selectedTags.includes(tag)) {
                                      setSelectedTags(
                                        selectedTags.filter((t) => t !== tag),
                                      );
                                    } else {
                                      // No limit with Algolia!
                                      setSelectedTags([...selectedTags, tag]);
                                    }
                                  }}
                                >
                                  <Text
                                    style={[
                                      styles.simpleTagText,
                                      {
                                        color: selectedTags.includes(tag)
                                          ? colors.white
                                          : isDarkMode
                                          ? "#D1D5DB"
                                          : "#4B5563",
                                      },
                                    ]}
                                  >
                                    {tag}
                                  </Text>
                                </TouchableOpacity>
                              ))}
                            </>
                          );
                        })()}
                      </View>
                    </View>
                  )}
                </View>
              )}

              {/* Employment Type Filter */}
              <View style={styles.filterGroupSimple}>
                <TouchableOpacity
                  style={styles.filterGroupHeaderSimple}
                  onPress={() =>
                    setEmploymentTypeExpanded(!employmentTypeExpanded)
                  }
                >
                  <Text
                    style={[
                      styles.filterGroupLabelSimple,
                      { color: isDarkMode ? "#D1D5DB" : "#374151" },
                    ]}
                  >
                    Employment Type {selectedJobType && "(1)"}
                  </Text>
                  <Icon
                    name={
                      employmentTypeExpanded
                        ? "keyboard-arrow-up"
                        : "keyboard-arrow-down"
                    }
                    size={20}
                    color={isDarkMode ? "#9CA3AF" : "#6B7280"}
                  />
                </TouchableOpacity>
                {employmentTypeExpanded && (
                  <View style={styles.filterOptionsSimple}>
                    {[
                      { label: "Full-time", value: "Full-time" },
                      { label: "Part-time", value: "Part-time" },
                      { label: "Contract", value: "Contract" },
                      { label: "Freelance", value: "Freelance" },
                      { label: "Internship", value: "Internship" },
                    ].map((option) => (
                      <TouchableOpacity
                        key={option.value}
                        style={styles.filterCheckboxRow}
                        onPress={() =>
                          setSelectedJobType(
                            selectedJobType === option.value
                              ? ""
                              : option.value,
                          )
                        }
                        activeOpacity={0.7}
                      >
                        <View
                          style={[
                            styles.checkbox,
                            { borderColor: isDarkMode ? "#4B5563" : "#D1D5DB" },
                            selectedJobType === option.value && {
                              backgroundColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                              borderColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                            },
                          ]}
                        >
                          {selectedJobType === option.value && (
                            <Icon name="check" size={14} color={colors.white} />
                          )}
                        </View>
                        <Text
                          style={[
                            styles.checkboxLabel,
                            { color: isDarkMode ? "#E5E7EB" : "#1F2937" },
                          ]}
                        >
                          {option.label}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>

              {/* Work Mode Filter */}
              <View style={styles.filterGroupSimple}>
                <TouchableOpacity
                  style={styles.filterGroupHeaderSimple}
                  onPress={() => setWorkModeExpanded(!workModeExpanded)}
                >
                  <Text
                    style={[
                      styles.filterGroupLabelSimple,
                      { color: isDarkMode ? "#D1D5DB" : "#374151" },
                    ]}
                  >
                    Work Mode {selectedRemote && "(1)"}
                  </Text>
                  <Icon
                    name={
                      workModeExpanded
                        ? "keyboard-arrow-up"
                        : "keyboard-arrow-down"
                    }
                    size={20}
                    color={isDarkMode ? "#9CA3AF" : "#6B7280"}
                  />
                </TouchableOpacity>
                {workModeExpanded && (
                  <View style={styles.filterOptionsSimple}>
                    {[
                      { label: "Remote", value: "Remote" },
                      { label: "On-site", value: "On-site" },
                    ].map((mode) => (
                      <TouchableOpacity
                        key={mode.value}
                        style={styles.filterCheckboxRow}
                        onPress={() =>
                          setSelectedRemote(
                            selectedRemote === mode.value ? "" : mode.value,
                          )
                        }
                        activeOpacity={0.7}
                      >
                        <View
                          style={[
                            styles.checkbox,
                            { borderColor: isDarkMode ? "#4B5563" : "#D1D5DB" },
                            selectedRemote === mode.value && {
                              backgroundColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                              borderColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                            },
                          ]}
                        >
                          {selectedRemote === mode.value && (
                            <Icon name="check" size={14} color={colors.white} />
                          )}
                        </View>
                        <Text
                          style={[
                            styles.checkboxLabel,
                            { color: isDarkMode ? "#E5E7EB" : "#1F2937" },
                          ]}
                        >
                          {mode.label}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>

              {/* Salary Filter */}
              <View style={styles.filterGroupSimple}>
                <TouchableOpacity
                  style={styles.filterGroupHeaderSimple}
                  onPress={() => setSalaryExpanded(!salaryExpanded)}
                >
                  <Text
                    style={[
                      styles.filterGroupLabelSimple,
                      { color: isDarkMode ? "#D1D5DB" : "#374151" },
                    ]}
                  >
                    Salary {selectedSalary && "(1)"}
                  </Text>
                  <Icon
                    name={
                      salaryExpanded
                        ? "keyboard-arrow-up"
                        : "keyboard-arrow-down"
                    }
                    size={20}
                    color={isDarkMode ? "#9CA3AF" : "#6B7280"}
                  />
                </TouchableOpacity>
                {salaryExpanded && (
                  <View style={styles.filterOptionsSimple}>
                    {[
                      { label: "With Salary", value: "With Salary" },
                      { label: "Without Salary", value: "Without Salary" },
                    ].map((option) => (
                      <TouchableOpacity
                        key={option.value}
                        style={styles.filterCheckboxRow}
                        onPress={() =>
                          setSelectedSalary(
                            selectedSalary === option.value ? "" : option.value,
                          )
                        }
                        activeOpacity={0.7}
                      >
                        <View
                          style={[
                            styles.checkbox,
                            { borderColor: isDarkMode ? "#4B5563" : "#D1D5DB" },
                            selectedSalary === option.value && {
                              backgroundColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                              borderColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                            },
                          ]}
                        >
                          {selectedSalary === option.value && (
                            <Icon name="check" size={14} color={colors.white} />
                          )}
                        </View>
                        <Text
                          style={[
                            styles.checkboxLabel,
                            { color: isDarkMode ? "#E5E7EB" : "#1F2937" },
                          ]}
                        >
                          {option.label}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>

              {/* Posted Date Filter */}
              <View style={styles.filterGroupSimple}>
                <TouchableOpacity
                  style={styles.filterGroupHeaderSimple}
                  onPress={() => setPostedDateExpanded(!postedDateExpanded)}
                >
                  <Text
                    style={[
                      styles.filterGroupLabelSimple,
                      { color: isDarkMode ? "#D1D5DB" : "#374151" },
                    ]}
                  >
                    Posted Date{" "}
                    {selectedPostedDate !== "3months" && "(1)"}
                  </Text>
                  <Icon
                    name={
                      postedDateExpanded
                        ? "keyboard-arrow-up"
                        : "keyboard-arrow-down"
                    }
                    size={20}
                    color={isDarkMode ? "#9CA3AF" : "#6B7280"}
                  />
                </TouchableOpacity>
                {postedDateExpanded && (
                  <View style={styles.filterOptionsSimple}>
                    {[
                      { label: "Past month", value: "1month" },
                      { label: "Past 3 months", value: "3months" },
                      { label: "More than 3 months", value: "older" },
                    ].map((option) => (
                      <TouchableOpacity
                        key={option.value}
                        style={styles.filterCheckboxRow}
                        onPress={() => setSelectedPostedDate(option.value)}
                        activeOpacity={0.7}
                      >
                        <View
                          style={[
                            styles.checkbox,
                            { borderColor: isDarkMode ? "#4B5563" : "#D1D5DB" },
                            selectedPostedDate === option.value && {
                              backgroundColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                              borderColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                            },
                          ]}
                        >
                          {selectedPostedDate === option.value && (
                            <Icon name="check" size={14} color={colors.white} />
                          )}
                        </View>
                        <Text
                          style={[
                            styles.checkboxLabel,
                            { color: isDarkMode ? "#E5E7EB" : "#1F2937" },
                          ]}
                        >
                          {option.label}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>
            </View>
          )}

          {/* Jobs Grid */}
          <View style={[styles.jobsGridSection, { flex: 1 }]}>
            {/* Guest Login Banner */}
            {!user && (
              <View
                style={{
                  marginHorizontal: isMobile ? 12 : 0,
                  marginBottom: 12,
                  marginTop: 0,
                  borderRadius: 12,
                  overflow: "hidden",
                  backgroundColor: isDarkMode ? "#161920" : "#FFFDF5",
                  borderWidth: 1,
                  borderColor: isDarkMode ? "#F4C43030" : "#F4C43050",
                  flexDirection: "row",
                  alignItems: "center",
                  paddingVertical: 10,
                  paddingLeft: 12,
                  paddingRight: 10,
                  gap: 10,
                }}
              >
                {/* Left accent bar */}
                <View
                  style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: 3,
                    backgroundColor: "#F4C430",
                    borderTopLeftRadius: 12,
                    borderBottomLeftRadius: 12,
                  }}
                />
                <Icon
                  name="lock-outline"
                  size={16}
                  color={isDarkMode ? "#F4C430" : "#B45309"}
                  style={{ marginLeft: 6 }}
                />
                <Text
                  style={{
                    flex: 1,
                    fontSize: 13,
                    fontFamily: fonts.regular,
                    color: isDarkMode ? "#D1D5DB" : "#374151",
                  }}
                >
                  <Text
                    style={{
                      fontFamily: fonts.semiBold,
                      color: isDarkMode ? "#F9FAFB" : "#0F172A",
                    }}
                  >
                    Sign in
                  </Text>{" "}
                  to save jobs, get alerts & more
                </Text>
                <TouchableOpacity
                  activeOpacity={0.85}
                  onPress={() => navigation.navigate("Signup")}
                  style={{
                    backgroundColor: "#F4C430",
                    paddingHorizontal: 13,
                    paddingVertical: 6,
                    borderRadius: 18,
                    flexShrink: 0,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.bold,
                      color: "#0F172A",
                    }}
                  >
                    Sign Up
                  </Text>
                </TouchableOpacity>
              </View>
            )}
            {/* Results Header with Sorting */}
            {!isMobile && (
              <View
                style={[styles.resultsHeader, { flexDirection: "row", gap: 0 }]}
              >
                <View style={[styles.resultsLeftSection, { flex: 1 }]}>
                  {(selectedCategories.length > 0 ||
                    selectedSubcategories.length > 0 ||
                    selectedTags.length > 0 ||
                    selectedJobType ||
                    selectedRemote ||
                    selectedSalary) && (
                    <ScrollView
                      horizontal
                      showsHorizontalScrollIndicator={false}
                      style={{ maxHeight: 70 }}
                      contentContainerStyle={styles.activeFiltersRow}
                    >
                      {selectedCategories.map((cat) => {
                        const category = categories.find((c) => c.path === cat);
                        return (
                          <View
                            key={cat}
                            style={[
                              styles.activeFilterChip,
                              { backgroundColor: `${colors.deepNavy}15` },
                            ]}
                          >
                            <Text
                              style={[
                                styles.activeFilterText,
                                { color: colors.deepNavy },
                              ]}
                            >
                              {category?.name || cat}
                            </Text>
                            <TouchableOpacity
                              onPress={() =>
                                setSelectedCategories(
                                  selectedCategories.filter((c) => c !== cat),
                                )
                              }
                            >
                              <Icon
                                name="close"
                                size={14}
                                color={colors.deepNavy}
                              />
                            </TouchableOpacity>
                          </View>
                        );
                      })}
                      {selectedSubcategories.map((sub) => {
                        const subcategory = categories.find(
                          (c) => c.path === sub,
                        );
                        return (
                          <View
                            key={sub}
                            style={[
                              styles.activeFilterChip,
                              { backgroundColor: `${colors.softBlue}15` },
                            ]}
                          >
                            <Text
                              style={[
                                styles.activeFilterText,
                                { color: colors.softBlue },
                              ]}
                            >
                              {subcategory?.name || sub}
                            </Text>
                            <TouchableOpacity
                              onPress={() =>
                                setSelectedSubcategories(
                                  selectedSubcategories.filter(
                                    (s) => s !== sub,
                                  ),
                                )
                              }
                            >
                              <Icon
                                name="close"
                                size={14}
                                color={colors.softBlue}
                              />
                            </TouchableOpacity>
                          </View>
                        );
                      })}
                      {selectedTags.map((tag) => (
                        <View
                          key={tag}
                          style={[
                            styles.activeFilterChip,
                            { backgroundColor: `${colors.success}15` },
                          ]}
                        >
                          <Text
                            style={[
                              styles.activeFilterText,
                              { color: colors.success },
                            ]}
                          >
                            {tag}
                          </Text>
                          <TouchableOpacity
                            onPress={() =>
                              setSelectedTags(
                                selectedTags.filter((t) => t !== tag),
                              )
                            }
                          >
                            <Icon
                              name="close"
                              size={14}
                              color={colors.success}
                            />
                          </TouchableOpacity>
                        </View>
                      ))}
                      {selectedJobType && (
                        <View
                          style={[
                            styles.activeFilterChip,
                            { backgroundColor: `${colors.deepNavy}15` },
                          ]}
                        >
                          <Text
                            style={[
                              styles.activeFilterText,
                              { color: colors.deepNavy },
                            ]}
                          >
                            {selectedJobType}
                          </Text>
                          <TouchableOpacity
                            onPress={() => setSelectedJobType("")}
                          >
                            <Icon
                              name="close"
                              size={14}
                              color={colors.deepNavy}
                            />
                          </TouchableOpacity>
                        </View>
                      )}
                      {selectedRemote && (
                        <View
                          style={[
                            styles.activeFilterChip,
                            { backgroundColor: `${colors.deepNavy}15` },
                          ]}
                        >
                          <Text
                            style={[
                              styles.activeFilterText,
                              { color: colors.deepNavy },
                            ]}
                          >
                            {selectedRemote}
                          </Text>
                          <TouchableOpacity
                            onPress={() => setSelectedRemote("")}
                          >
                            <Icon
                              name="close"
                              size={14}
                              color={colors.deepNavy}
                            />
                          </TouchableOpacity>
                        </View>
                      )}
                      {selectedSalary && (
                        <View
                          style={[
                            styles.activeFilterChip,
                            { backgroundColor: `${colors.deepNavy}15` },
                          ]}
                        >
                          <Text
                            style={[
                              styles.activeFilterText,
                              { color: colors.deepNavy },
                            ]}
                          >
                            {selectedSalary}
                          </Text>
                          <TouchableOpacity
                            onPress={() => setSelectedSalary("")}
                          >
                            <Icon
                              name="close"
                              size={14}
                              color={colors.deepNavy}
                            />
                          </TouchableOpacity>
                        </View>
                      )}
                      {selectedPostedDate !== "3months" && (
                        <View
                          style={[
                            styles.activeFilterChip,
                            { backgroundColor: `${colors.deepNavy}15` },
                          ]}
                        >
                          <Text
                            style={[
                              styles.activeFilterText,
                              { color: colors.deepNavy },
                            ]}
                          >
                            {selectedPostedDate === "1month"
                              ? "Past month"
                              : "More than 3 months"}
                          </Text>
                          <TouchableOpacity
                            onPress={() => setSelectedPostedDate("3months")}
                          >
                            <Icon
                              name="close"
                              size={14}
                              color={colors.deepNavy}
                            />
                          </TouchableOpacity>
                        </View>
                      )}
                    </ScrollView>
                  )}
                </View>
                <View style={styles.resultsRightSection}>
                  {!isMobile && (
                    <View style={styles.sortContainer}>
                      <Icon name="sort" size={18} color={colors.warmGray} />
                      <Text
                        style={[styles.sortLabel, { color: colors.warmGray }]}
                      >
                        {t.sortBy}
                      </Text>
                      <TouchableOpacity style={styles.sortButton}>
                        <Text
                          style={[
                            styles.sortButtonText,
                            { color: isDarkMode ? "#000000" : colors.deepNavy },
                          ]}
                        >
                          Most Recent
                        </Text>
                        <Icon
                          name="arrow-drop-down"
                          size={20}
                          color={isDarkMode ? "#000000" : colors.deepNavy}
                        />
                      </TouchableOpacity>
                    </View>
                  )}
                  {!isMobile && (
                    <View style={styles.viewToggle}>
                      <TouchableOpacity
                        style={[
                          styles.viewToggleButton,
                          {
                            backgroundColor:
                              viewMode === "grid"
                                ? colors.deepNavy
                                : colors.cream,
                          },
                        ]}
                        onPress={() => setViewMode("grid")}
                      >
                        <Icon
                          name="grid-view"
                          size={18}
                          color={
                            viewMode === "grid" ? colors.white : colors.deepNavy
                          }
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={[
                          styles.viewToggleButton,
                          {
                            backgroundColor:
                              viewMode === "list"
                                ? colors.deepNavy
                                : colors.cream,
                          },
                        ]}
                        onPress={() => setViewMode("list")}
                      >
                        <Icon
                          name="view-list"
                          size={18}
                          color={
                            viewMode === "list" ? colors.white : colors.deepNavy
                          }
                        />
                      </TouchableOpacity>
                    </View>
                  )}
                </View>
              </View>
            )}

            {loading ? (
              isMobile ? (
                // ── Mobile loading: centered icon + spinner ──
                <View
                  style={{
                    flex: 1,
                    paddingVertical: 80,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <View
                    style={[
                      styles.loadingIconCircle,
                      { backgroundColor: `${colors.beeYellow}20` },
                    ]}
                  >
                    <Icon name="work" size={48} color={colors.beeYellow} />
                  </View>
                  <ActivityIndicator
                    size="large"
                    color={colors.beeYellow}
                    style={{ marginBottom: 16 }}
                  />
                  <Text
                    style={[
                      styles.loadingTitle,
                      { color: isDarkMode ? colors.white : colors.deepNavy },
                    ]}
                  >
                    Loading Jobs
                  </Text>
                  <Text
                    style={[styles.loadingSubtitle, { color: colors.warmGray }]}
                  >
                    Finding opportunities for you...
                  </Text>
                </View>
              ) : (
                <View style={styles.modernLoadingContainer}>
                  <View
                    style={[
                      styles.loadingIconCircle,
                      { backgroundColor: `${colors.beeYellow}20` },
                    ]}
                  >
                    <Icon name="work" size={48} color={colors.beeYellow} />
                  </View>
                  <Text
                    style={[
                      styles.loadingTitle,
                      { color: isDarkMode ? colors.white : colors.deepNavy },
                    ]}
                  >
                    Loading Jobs
                  </Text>
                  <Text
                    style={[styles.loadingSubtitle, { color: colors.warmGray }]}
                  >
                    Please wait...
                  </Text>
                </View>
              )
            ) : jobs.length === 0 ? (
              <View style={styles.modernEmptyState}>
                <View
                  style={[
                    styles.emptyStateIcon,
                    { backgroundColor: colors.cream },
                  ]}
                >
                  <Icon name="work-off" size={48} color={colors.warmGray} />
                </View>
                <Text
                  style={[styles.emptyStateTitle, { color: colors.deepNavy }]}
                >
                  No jobs found
                </Text>
                <Text
                  style={[
                    styles.emptyStateDescription,
                    { color: colors.warmGray },
                  ]}
                >
                  Try adjusting your filters or search terms to find more
                  opportunities
                </Text>
                <TouchableOpacity
                  style={[
                    styles.emptyStateButton,
                    { backgroundColor: colors.deepNavy },
                  ]}
                  onPress={() => {
                    setSearchText("");
                    setSelectedCategories([]);
                    setSelectedSubcategories([]);
                    setSelectedTags([]);
                    setSelectedJobType("");
                    setSelectedRemote("");
                    setSelectedSalary("");
                    setSelectedPostedDate("3months");
                  }}
                >
                  <Text
                    style={[
                      styles.emptyStateButtonText,
                      { color: colors.white },
                    ]}
                  >
                    Clear all filters
                  </Text>
                </TouchableOpacity>
              </View>
            ) : (
              <View>
                <AdBanner variant="feed" />
                <FlatList
                  data={jobs}
                  renderItem={renderJobCard}
                  keyExtractor={(item) =>
                    item.id || item.objectID || String(Math.random())
                  }
                  numColumns={isMobile ? 1 : viewMode === "grid" ? 2 : 1}
                  key={isMobile ? "mobile-single" : viewMode}
                  showsVerticalScrollIndicator={false}
                  contentContainerStyle={styles.modernJobsGrid}
                  scrollEnabled={true}
                  nestedScrollEnabled={true}
                  columnWrapperStyle={
                    !isMobile && viewMode === "grid"
                      ? styles.modernJobsRow
                      : undefined
                  }
                  ListFooterComponent={<AdBanner variant="feed" />}
                  ListHeaderComponent={
                    jobs.length > 0 &&
                    jobs.length < 5 &&
                    (selectedCategories.length > 0 ||
                      selectedTags.length > 0 ||
                      selectedJobType ||
                      selectedRemote ||
                      selectedSalary ||
                      (searchText && searchText.trim().length > 0)) ? (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "flex-start",
                          backgroundColor: isDarkMode ? "#1A1F2E" : "#FFFBEB",
                          borderWidth: 1,
                          borderColor: isDarkMode ? "#2E3348" : "#FDE68A",
                          borderRadius: 10,
                          marginHorizontal: isMobile ? 12 : 0,
                          marginBottom: 10,
                          marginTop: 6,
                          paddingHorizontal: 12,
                          paddingVertical: 10,
                          gap: 9,
                        }}
                      >
                        <Icon
                          name="lightbulb-outline"
                          size={18}
                          color="#F4C430"
                          style={{ marginTop: 1 }}
                        />
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontFamily: fonts.semiBold,
                              fontSize: 13,
                              color: isDarkMode ? "#F4C430" : "#92400E",
                              marginBottom: 2,
                            }}
                          >
                            Tip: Only a few results
                          </Text>
                          <Text
                            style={{
                              fontFamily: fonts.regular,
                              fontSize: 12.5,
                              color: isDarkMode ? "#B0BACE" : "#78350F",
                              lineHeight: 18,
                            }}
                          >
                            You have active filters applied. Try clearing or
                            adjusting your filters to see more job
                            opportunities.
                          </Text>
                          <TouchableOpacity
                            onPress={() => {
                              setSearchText("");
                              setSelectedCategories([]);
                              setSelectedSubcategories([]);
                              setSelectedTags([]);
                              setSelectedJobType("");
                              setSelectedRemote("");
                              setSelectedSalary("");
                              setSelectedPostedDate("3months");
                            }}
                            style={{
                              marginTop: 7,
                              alignSelf: "flex-start",
                              paddingHorizontal: 10,
                              paddingVertical: 4,
                              backgroundColor: "#F4C430",
                              borderRadius: 6,
                            }}
                          >
                            <Text
                              style={{
                                fontFamily: fonts.semiBold,
                                fontSize: 12,
                                color: "#1A1A1A",
                              }}
                            >
                              Clear filters
                            </Text>
                          </TouchableOpacity>
                        </View>
                      </View>
                    ) : null
                  }
                />

                <AdBanner variant="feed" />

                {/* Modern Pagination - Simplified */}
                {(hasNextPage || hasPrevPage) && (
                  <View
                    style={[
                      styles.modernPagination,
                      { backgroundColor: colors.white },
                    ]}
                  >
                    <TouchableOpacity
                      style={[
                        styles.modernPaginationButton,
                        { borderColor: colors.lightGray },
                        !hasPrevPage && styles.modernPaginationButtonDisabled,
                      ]}
                      onPress={() => handlePageChange(currentPage - 1)}
                      disabled={!hasPrevPage}
                    >
                      <Icon
                        name="chevron-left"
                        size={20}
                        color={!hasPrevPage ? colors.warmGray : colors.deepNavy}
                      />
                      <Text
                        style={[
                          styles.modernPaginationButtonText,
                          {
                            color: !hasPrevPage
                              ? colors.warmGray
                              : colors.deepNavy,
                          },
                        ]}
                      >
                        Previous
                      </Text>
                    </TouchableOpacity>

                    <View style={styles.modernPaginationNumbers}>
                      <Text
                        style={[
                          styles.modernPageNumberText,
                          { color: colors.deepNavy, fontWeight: "600" },
                        ]}
                      >
                        Page {currentPage}
                      </Text>
                    </View>

                    <TouchableOpacity
                      style={[
                        styles.modernPaginationButton,
                        { borderColor: colors.lightGray },
                        !hasNextPage && styles.modernPaginationButtonDisabled,
                      ]}
                      onPress={() => handlePageChange(currentPage + 1)}
                      disabled={!hasNextPage}
                    >
                      <Text
                        style={[
                          styles.modernPaginationButtonText,
                          {
                            color: !hasNextPage
                              ? colors.warmGray
                              : colors.deepNavy,
                          },
                        ]}
                      >
                        Next
                      </Text>
                      <Icon
                        name="chevron-right"
                        size={20}
                        color={!hasNextPage ? colors.warmGray : colors.deepNavy}
                      />
                    </TouchableOpacity>
                  </View>
                )}
              </View>
            )}
          </View>
        </View>
      </ScrollView>

      {/* Mobile Filters Modal */}
      <Modal
        visible={showMobileFilters}
        animationType="slide"
        transparent={false}
        onRequestClose={() => setShowMobileFilters(false)}
      >
        <SafeAreaView
          style={[
            styles.mobileFiltersModal,
            { backgroundColor: isDarkMode ? "#0A0C10" : "#FFFFFF" },
          ]}
        >
          {/* ── Header ── */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              paddingHorizontal: 20,
              paddingTop: 16,
              paddingBottom: 14,
              borderBottomWidth: 1,
              borderBottomColor: isDarkMode ? "#1E2027" : "#F0F1F3",
              backgroundColor: isDarkMode ? "#0A0C10" : "#FFFFFF",
            }}
          >
            <TouchableOpacity
              onPress={() => setShowMobileFilters(false)}
              style={{
                width: 36,
                height: 36,
                borderRadius: 18,
                backgroundColor: isDarkMode ? "#1A1D23" : "#F3F4F6",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                name="arrow-back"
                size={20}
                color={isDarkMode ? "#E2E8F0" : colors.deepNavy}
              />
            </TouchableOpacity>
            <View style={{ alignItems: "center" }}>
              <Text
                style={{
                  fontSize: 17,
                  fontFamily: fonts.bold,
                  color: isDarkMode ? "#E2E8F0" : colors.deepNavy,
                  letterSpacing: -0.3,
                }}
              >
                Filters
              </Text>
              {selectedCategories.length +
                selectedSubcategories.length +
                selectedTags.length +
                (selectedJobType ? 1 : 0) +
                (selectedRemote ? 1 : 0) +
                (selectedSalary ? 1 : 0) +
              (selectedPostedDate !== "3months" ? 1 : 0) >
                0 && (
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.medium,
                    color: colors.beeYellow,
                    marginTop: 1,
                  }}
                >
                  {selectedCategories.length +
                    selectedSubcategories.length +
                    selectedTags.length +
                    (selectedJobType ? 1 : 0) +
                    (selectedRemote ? 1 : 0) +
                    (selectedSalary ? 1 : 0) +
              (selectedPostedDate !== "3months" ? 1 : 0)}{" "}
                  active
                </Text>
              )}
            </View>
            <TouchableOpacity
              onPress={() => {
                setSelectedCategories([]);
                setSelectedSubcategories([]);
                setSelectedTags([]);
                setSelectedJobType("");
                setSelectedRemote("");
                setSelectedSalary("");
                setSelectedPostedDate("3months");
                setTagSearchQuery("");
              }}
              style={{
                width: 36,
                height: 36,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.semiBold,
                  color:
                    selectedCategories.length +
                      selectedSubcategories.length +
                      selectedTags.length +
                      (selectedJobType ? 1 : 0) +
                      (selectedRemote ? 1 : 0) +
                      (selectedSalary ? 1 : 0) +
              (selectedPostedDate !== "3months" ? 1 : 0) >
                    0
                      ? "#EF4444"
                      : "transparent",
                }}
              >
                Reset
              </Text>
            </TouchableOpacity>
          </View>

          <ScrollView
            style={{ flex: 1 }}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{
              paddingHorizontal: 20,
              paddingTop: 20,
              paddingBottom: 120,
            }}
          >
            {/* ── Quick Toggles ── */}
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.bold,
                color: isDarkMode ? "#6B7280" : "#9CA3AF",
                textTransform: "uppercase",
                letterSpacing: 1,
                marginBottom: 10,
              }}
            >
              Quick Filters
            </Text>
            <View style={{ flexDirection: "row", gap: 8, marginBottom: 28 }}>
              {[
                {
                  label: "Remote",
                  icon: "home",
                  active: selectedRemote === "Remote",
                  onPress: () =>
                    setSelectedRemote(
                      selectedRemote === "Remote" ? "" : "Remote",
                    ),
                },
                {
                  label: "Has Salary",
                  icon: "payments",
                  active: selectedSalary === "With Salary",
                  onPress: () =>
                    setSelectedSalary(
                      selectedSalary === "With Salary" ? "" : "With Salary",
                    ),
                },
                {
                  label: "Full-time",
                  icon: "work",
                  active: selectedJobType === "Full-time",
                  onPress: () =>
                    setSelectedJobType(
                      selectedJobType === "Full-time" ? "" : "Full-time",
                    ),
                },
              ].map((q) => (
                <TouchableOpacity
                  key={q.label}
                  onPress={q.onPress}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 5,
                    paddingHorizontal: 13,
                    paddingVertical: 8,
                    borderRadius: 20,
                    backgroundColor: q.active
                      ? colors.deepNavy
                      : isDarkMode
                      ? "#1A1D23"
                      : "#F3F4F6",
                    borderWidth: 1.5,
                    borderColor: q.active ? colors.beeYellow : "transparent",
                  }}
                >
                  <Icon
                    name={q.icon}
                    size={13}
                    color={
                      q.active
                        ? colors.beeYellow
                        : isDarkMode
                        ? "#9CA3AF"
                        : "#6B7280"
                    }
                  />
                  <Text
                    style={{
                      fontSize: 13,
                      fontFamily: fonts.semiBold,
                      color: q.active
                        ? colors.white
                        : isDarkMode
                        ? "#D1D5DB"
                        : colors.deepNavy,
                    }}
                  >
                    {q.label}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>

            {/* ── Employment Type ── */}
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.bold,
                color: isDarkMode ? "#6B7280" : "#9CA3AF",
                textTransform: "uppercase",
                letterSpacing: 1,
                marginBottom: 10,
              }}
            >
              Job Type
            </Text>
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 8,
                marginBottom: 28,
              }}
            >
              {[
                "",
                "Full-time",
                "Part-time",
                "Contract",
                "Freelance",
                "Internship",
              ].map((type) => {
                const label = type === "" ? "Any" : type;
                const active = selectedJobType === type;
                return (
                  <TouchableOpacity
                    key={label}
                    onPress={() => setSelectedJobType(type)}
                    style={{
                      paddingHorizontal: 16,
                      paddingVertical: 9,
                      borderRadius: 20,
                      backgroundColor: active
                        ? colors.beeYellow
                        : isDarkMode
                        ? "#1A1D23"
                        : "#F3F4F6",
                      borderWidth: 1.5,
                      borderColor: active ? colors.beeYellow : "transparent",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: active ? fonts.bold : fonts.medium,
                        color: active
                          ? colors.deepNavy
                          : isDarkMode
                          ? "#D1D5DB"
                          : colors.deepNavy,
                      }}
                    >
                      {label}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>

            {/* ── Work Mode ── */}
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.bold,
                color: isDarkMode ? "#6B7280" : "#9CA3AF",
                textTransform: "uppercase",
                letterSpacing: 1,
                marginBottom: 10,
              }}
            >
              Work Mode
            </Text>
            <View style={{ flexDirection: "row", gap: 8, marginBottom: 28 }}>
              {[
                { label: "Any", value: "", icon: "public" },
                { label: "Remote", value: "Remote", icon: "home" },
                { label: "On-site", value: "On-site", icon: "business" },
              ].map((m) => {
                const active = selectedRemote === m.value;
                return (
                  <TouchableOpacity
                    key={m.label}
                    onPress={() => setSelectedRemote(m.value)}
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 5,
                      paddingVertical: 10,
                      borderRadius: 10,
                      backgroundColor: active
                        ? colors.deepNavy
                        : isDarkMode
                        ? "#1A1D23"
                        : "#F3F4F6",
                    }}
                  >
                    <Icon
                      name={m.icon}
                      size={14}
                      color={
                        active
                          ? colors.beeYellow
                          : isDarkMode
                          ? "#9CA3AF"
                          : "#6B7280"
                      }
                    />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: active ? fonts.bold : fonts.medium,
                        color: active
                          ? colors.white
                          : isDarkMode
                          ? "#D1D5DB"
                          : colors.deepNavy,
                      }}
                    >
                      {m.label}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>

            {/* ── Salary ── */}
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.bold,
                color: isDarkMode ? "#6B7280" : "#9CA3AF",
                textTransform: "uppercase",
                letterSpacing: 1,
                marginBottom: 10,
              }}
            >
              Salary
            </Text>
            <View style={{ flexDirection: "row", gap: 8, marginBottom: 28 }}>
              {[
                { label: "All Jobs", value: "" },
                { label: "Listed", value: "With Salary" },
                { label: "Unlisted", value: "Without Salary" },
              ].map((s) => {
                const active = selectedSalary === s.value;
                return (
                  <TouchableOpacity
                    key={s.label}
                    onPress={() => setSelectedSalary(s.value)}
                    style={{
                      flex: 1,
                      alignItems: "center",
                      paddingVertical: 10,
                      borderRadius: 10,
                      backgroundColor: active
                        ? colors.deepNavy
                        : isDarkMode
                        ? "#1A1D23"
                        : "#F3F4F6",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: active ? fonts.bold : fonts.medium,
                        color: active
                          ? colors.white
                          : isDarkMode
                          ? "#D1D5DB"
                          : colors.deepNavy,
                      }}
                    >
                      {s.label}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>

            {/* ── Posted Date ── */}
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.bold,
                color: isDarkMode ? "#6B7280" : "#9CA3AF",
                textTransform: "uppercase",
                letterSpacing: 1,
                marginBottom: 10,
              }}
            >
              Posted Date
            </Text>
            <View style={{ flexDirection: "row", gap: 8, marginBottom: 28 }}>
              {[
                { label: "Past Month", value: "1month" },
                { label: "Past 3 Months", value: "3months" },
                { label: "3+ Months", value: "older" },
              ].map((d) => {
                const active = selectedPostedDate === d.value;
                return (
                  <TouchableOpacity
                    key={d.value}
                    onPress={() => setSelectedPostedDate(d.value)}
                    style={{
                      flex: 1,
                      alignItems: "center",
                      paddingVertical: 10,
                      borderRadius: 10,
                      backgroundColor: active
                        ? colors.deepNavy
                        : isDarkMode
                        ? "#1A1D23"
                        : "#F3F4F6",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: active ? fonts.bold : fonts.medium,
                        color: active
                          ? colors.white
                          : isDarkMode
                          ? "#D1D5DB"
                          : colors.deepNavy,
                      }}
                    >
                      {d.label}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>

            {/* ── Categories ── */}
            <TouchableOpacity
              onPress={() => setCategoriesExpanded(!categoriesExpanded)}
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 6 }}
              >
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    color: isDarkMode ? "#6B7280" : "#9CA3AF",
                    textTransform: "uppercase",
                    letterSpacing: 1,
                  }}
                >
                  Category
                </Text>
                {selectedCategories.length > 0 && (
                  <View
                    style={{
                      backgroundColor: colors.beeYellow,
                      borderRadius: 8,
                      paddingHorizontal: 6,
                      paddingVertical: 1,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 10,
                        fontFamily: fonts.bold,
                        color: colors.deepNavy,
                      }}
                    >
                      {selectedCategories.length}
                    </Text>
                  </View>
                )}
              </View>
              <Icon
                name={categoriesExpanded ? "expand-less" : "expand-more"}
                size={18}
                color={isDarkMode ? "#6B7280" : "#9CA3AF"}
              />
            </TouchableOpacity>
            {categoriesExpanded && (
              <View style={{ gap: 6, marginBottom: 20 }}>
                {categories
                  .filter((c) => c.level === 0)
                  .map((category) => {
                    const active = selectedCategories.includes(category.path);
                    return (
                      <TouchableOpacity
                        key={category.id}
                        onPress={() => {
                          if (active) {
                            setSelectedCategories(
                              selectedCategories.filter(
                                (c) => c !== category.path,
                              ),
                            );
                            setSelectedSubcategories([]);
                            setSelectedTags([]);
                          } else {
                            setSelectedCategories([category.path]);
                            setSelectedSubcategories([]);
                            setSelectedTags([]);
                          }
                        }}
                        activeOpacity={0.7}
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          paddingVertical: 12,
                          paddingHorizontal: 14,
                          borderRadius: 10,
                          backgroundColor: active
                            ? isDarkMode
                              ? colors.beeYellow
                              : colors.deepNavy
                            : isDarkMode
                            ? "#1A1D23"
                            : "#F8F9FA",
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: active ? fonts.bold : fonts.medium,
                            color: active
                              ? isDarkMode
                                ? colors.deepNavy
                                : colors.white
                              : isDarkMode
                              ? "#D1D5DB"
                              : colors.deepNavy,
                          }}
                        >
                          {category.name}
                        </Text>
                        {active && (
                          <Icon
                            name="check"
                            size={16}
                            color={isDarkMode ? colors.deepNavy : colors.white}
                          />
                        )}
                      </TouchableOpacity>
                    );
                  })}
              </View>
            )}

            {/* ── Subcategories ── */}
            {selectedCategories.length > 0 && (
              <>
                <TouchableOpacity
                  onPress={() =>
                    setSubcategoriesExpanded(!subcategoriesExpanded)
                  }
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 10,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: fonts.bold,
                        color: isDarkMode ? "#6B7280" : "#9CA3AF",
                        textTransform: "uppercase",
                        letterSpacing: 1,
                      }}
                    >
                      Subcategory
                    </Text>
                    {selectedSubcategories.length > 0 && (
                      <View
                        style={{
                          backgroundColor: colors.beeYellow,
                          borderRadius: 8,
                          paddingHorizontal: 6,
                          paddingVertical: 1,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 10,
                            fontFamily: fonts.bold,
                            color: colors.deepNavy,
                          }}
                        >
                          {selectedSubcategories.length}
                        </Text>
                      </View>
                    )}
                  </View>
                  <Icon
                    name={subcategoriesExpanded ? "expand-less" : "expand-more"}
                    size={18}
                    color={isDarkMode ? "#6B7280" : "#9CA3AF"}
                  />
                </TouchableOpacity>
                {subcategoriesExpanded && (
                  <View style={{ gap: 6, marginBottom: 20 }}>
                    {categories
                      .filter((c) => selectedCategories.includes(c.parentPath))
                      .map((subcategory) => {
                        const active = selectedSubcategories.includes(
                          subcategory.path,
                        );
                        return (
                          <TouchableOpacity
                            key={subcategory.id}
                            onPress={() => {
                              if (active) {
                                setSelectedSubcategories(
                                  selectedSubcategories.filter(
                                    (s) => s !== subcategory.path,
                                  ),
                                );
                                if (subcategory.tags) {
                                  setSelectedTags(
                                    selectedTags.filter(
                                      (t) => !subcategory.tags.includes(t),
                                    ),
                                  );
                                }
                              } else {
                                setSelectedSubcategories([
                                  ...selectedSubcategories,
                                  subcategory.path,
                                ]);
                                if (
                                  subcategory.tags &&
                                  subcategory.tags.length > 0
                                ) {
                                  setSelectedTags([
                                    ...new Set([
                                      ...selectedTags,
                                      ...subcategory.tags,
                                    ]),
                                  ]);
                                }
                              }
                            }}
                            activeOpacity={0.7}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                              paddingVertical: 12,
                              paddingHorizontal: 14,
                              borderRadius: 10,
                              backgroundColor: active
                                ? isDarkMode
                                  ? colors.beeYellow
                                  : colors.deepNavy
                                : isDarkMode
                                ? "#1A1D23"
                                : "#F8F9FA",
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 14,
                                fontFamily: active ? fonts.bold : fonts.medium,
                                color: active
                                  ? isDarkMode
                                    ? colors.deepNavy
                                    : colors.white
                                  : isDarkMode
                                  ? "#D1D5DB"
                                  : colors.deepNavy,
                              }}
                            >
                              {subcategory.name}
                            </Text>
                            {active && (
                              <Icon
                                name="check"
                                size={16}
                                color={
                                  isDarkMode ? colors.deepNavy : colors.white
                                }
                              />
                            )}
                          </TouchableOpacity>
                        );
                      })}
                  </View>
                )}
              </>
            )}

            {/* ── Tags ── */}
            {(selectedCategories.length > 0 ||
              selectedSubcategories.length > 0) && (
              <>
                <TouchableOpacity
                  onPress={() => setTagsExpanded(!tagsExpanded)}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 10,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: fonts.bold,
                        color: isDarkMode ? "#6B7280" : "#9CA3AF",
                        textTransform: "uppercase",
                        letterSpacing: 1,
                      }}
                    >
                      Skills & Tags
                    </Text>
                    {selectedTags.length > 0 && (
                      <View
                        style={{
                          backgroundColor: colors.beeYellow,
                          borderRadius: 8,
                          paddingHorizontal: 6,
                          paddingVertical: 1,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 10,
                            fontFamily: fonts.bold,
                            color: colors.deepNavy,
                          }}
                        >
                          {selectedTags.length}
                        </Text>
                      </View>
                    )}
                  </View>
                  <Icon
                    name={tagsExpanded ? "expand-less" : "expand-more"}
                    size={18}
                    color={isDarkMode ? "#6B7280" : "#9CA3AF"}
                  />
                </TouchableOpacity>
                {tagsExpanded && (
                  <View style={{ marginBottom: 20 }}>
                    {/* Tag Search */}
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 8,
                        backgroundColor: isDarkMode ? "#1A1D23" : "#F3F4F6",
                        borderRadius: 10,
                        paddingHorizontal: 12,
                        paddingVertical: 10,
                        marginBottom: 12,
                      }}
                    >
                      <Icon
                        name="search"
                        size={16}
                        color={isDarkMode ? "#6B7280" : "#9CA3AF"}
                      />
                      <TextInput
                        style={{
                          flex: 1,
                          fontSize: 14,
                          fontFamily: fonts.regular,
                          color: isDarkMode ? "#E2E8F0" : colors.deepNavy,
                          padding: 0,
                        }}
                        placeholder="Search tags..."
                        placeholderTextColor={
                          isDarkMode ? "#6B7280" : "#9CA3AF"
                        }
                        value={tagSearchQuery}
                        onChangeText={setTagSearchQuery}
                      />
                      {tagSearchQuery.length > 0 && (
                        <TouchableOpacity onPress={() => setTagSearchQuery("")}>
                          <Icon
                            name="close"
                            size={14}
                            color={isDarkMode ? "#6B7280" : "#9CA3AF"}
                          />
                        </TouchableOpacity>
                      )}
                    </View>
                    <View
                      style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}
                    >
                      {(() => {
                        const allTags = new Set<string>();
                        selectedCategories.forEach((catPath) => {
                          const cat = categories.find(
                            (c) => c.path === catPath,
                          );
                          if (cat?.tags)
                            cat.tags.forEach((tag: string) => allTags.add(tag));
                        });
                        selectedSubcategories.forEach((subPath) => {
                          const sub = categories.find(
                            (c) => c.path === subPath,
                          );
                          if (sub?.tags)
                            sub.tags.forEach((tag: string) => allTags.add(tag));
                        });
                        const filteredTags = Array.from(allTags).filter((tag) =>
                          tag
                            .toLowerCase()
                            .includes(tagSearchQuery.toLowerCase()),
                        );
                        if (filteredTags.length === 0) {
                          return (
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.regular,
                                color: isDarkMode ? "#6B7280" : colors.warmGray,
                                paddingVertical: 8,
                              }}
                            >
                              {tagSearchQuery
                                ? "No tags match"
                                : "No tags available"}
                            </Text>
                          );
                        }
                        return filteredTags.map((tag) => {
                          const active = selectedTags.includes(tag);
                          return (
                            <TouchableOpacity
                              key={tag}
                              onPress={() => {
                                if (active) {
                                  setSelectedTags(
                                    selectedTags.filter((t) => t !== tag),
                                  );
                                } else {
                                  setSelectedTags([...selectedTags, tag]);
                                }
                              }}
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 4,
                                paddingHorizontal: 12,
                                paddingVertical: 7,
                                borderRadius: 16,
                                backgroundColor: active
                                  ? colors.deepNavy
                                  : isDarkMode
                                  ? "#1A1D23"
                                  : "#F3F4F6",
                                borderWidth: active ? 1.5 : 0,
                                borderColor: active
                                  ? colors.beeYellow
                                  : "transparent",
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 12,
                                  fontFamily: active
                                    ? fonts.bold
                                    : fonts.medium,
                                  color: active
                                    ? colors.white
                                    : isDarkMode
                                    ? "#D1D5DB"
                                    : colors.deepNavy,
                                }}
                              >
                                {tag}
                              </Text>
                              {active && (
                                <Icon
                                  name="check"
                                  size={11}
                                  color={colors.beeYellow}
                                />
                              )}
                            </TouchableOpacity>
                          );
                        });
                      })()}
                    </View>
                  </View>
                )}
              </>
            )}
          </ScrollView>

          {/* ── Footer: Apply Button ── */}
          <View
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              padding: 16,
              backgroundColor: isDarkMode ? "#0A0C10" : "#FFFFFF",
              borderTopWidth: 1,
              borderTopColor: isDarkMode ? "#1E2027" : "#F0F1F3",
            }}
          >
            <TouchableOpacity
              style={{
                backgroundColor: colors.beeYellow,
                borderRadius: 14,
                paddingVertical: 15,
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                gap: 8,
              }}
              onPress={() => setShowMobileFilters(false)}
            >
              <Icon name="check" size={18} color={colors.deepNavy} />
              <Text
                style={{
                  fontSize: 16,
                  fontFamily: fonts.bold,
                  color: colors.deepNavy,
                }}
              >
                Show Results
              </Text>
            </TouchableOpacity>
          </View>
        </SafeAreaView>
      </Modal>

      {/* Mobile Navigation Menu - Using Shared Drawer Component */}
      <MobileDrawer
        visible={showMobileMenu}
        onClose={() => setShowMobileMenu(false)}
        navigation={navigation}
        user={user}
        userData={userData}
        isDarkMode={isDarkMode}
        toggleTheme={toggleTheme}
        currentView="candidate"
        currentLanguage={currentLanguage}
      />

      {/* Language dropdown overlay (same as HomeScreen) */}
      {showLanguageMenu && (
        <View style={styles.fullScreenDropdownOverlay}>
          <TouchableOpacity
            style={styles.fullScreenTouchArea}
            onPress={() => setShowLanguageMenu(false)}
            activeOpacity={1}
          />
          <View
            style={[
              styles.absoluteLanguageDropdown,
              { top: dropdownPosition.top, right: dropdownPosition.right },
            ]}
          >
            {languageOptions.map((language, index) => (
              <TouchableOpacity
                key={language.code}
                style={[
                  styles.languageOption,
                  currentLanguage === language.code &&
                    styles.languageOptionActive,
                  index === languageOptions.length - 1 && {
                    borderBottomWidth: 0,
                  },
                ]}
                onPress={() => changeLanguage(language.code)}
              >
                <Text style={styles.languageLabel}>{language.label}</Text>
                {currentLanguage === language.code && (
                  <Icon name="check" size={16} color={colors.beeYellow} />
                )}
              </TouchableOpacity>
            ))}
          </View>
        </View>
      )}

      {/* Bottom Navigation Bar */}
      <BottomNavBar
        navigation={navigation}
        activeRoute="Jobs"
        isDarkMode={isDarkMode}
        user={user}
        userData={userData}
        currentLanguage={currentLanguage}
      />

      {/* Logout Confirmation Modal */}
      <LogoutConfirmationModal
        visible={showLogoutModal}
        onConfirm={handleLogout}
        onCancel={() => setShowLogoutModal(false)}
        isDarkMode={isDarkMode}
        currentLanguage={currentLanguage}
      />
    </SafeAreaView>
  );
}

// Companies Screen - Full Implementation
function CompaniesScreen({
  navigation,
  route,
  isDarkMode,
  toggleTheme,
  currentLanguage = "en",
  setCurrentLanguage,
}: any) {
  const firebaseOps = React.useContext(FirebaseOpsContext);
  const [companies, setCompanies] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [actualSearchQuery, setActualSearchQuery] = useState("");
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [selectedSector, setSelectedSector] = useState("");
  const [selectedVerification, setSelectedVerification] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedCompanySize, setSelectedCompanySize] = useState("");
  const [industries, setIndustries] = useState<string[]>([]);
  const [sectors, setSectors] = useState<string[]>([]);
  const [locations, setLocations] = useState<string[]>([]);
  const [user, setUser] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const languageButtonRef = useRef<any>(null);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    right: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [allCompanies, setAllCompanies] = useState<any[]>([]); // Store all companies for client-side pagination
  const [filteredCompanies, setFilteredCompanies] = useState<any[]>([]); // Filtered companies

  // Collapsible filter states
  const [industryExpanded, setIndustryExpanded] = useState(true);
  const [sectorExpanded, setSectorExpanded] = useState(false);
  const [verificationExpanded, setVerificationExpanded] = useState(false);
  const [locationExpanded, setLocationExpanded] = useState(false);
  const [companySizeExpanded, setCompanySizeExpanded] = useState(false);

  // View mode state for grid/list toggle
  const [viewMode, setViewMode] = useState<"grid" | "list">("grid");
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // Responsive design
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;
  const isTablet = dimensions.width >= 768 && dimensions.width < 1024;
  const isDesktop = dimensions.width >= 1024;

  // Mobile filter menu state
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  // Mobile navigation menu state
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  const companiesPerPage = 12;

  const colors = isDarkMode ? darkColors : lightColors;
  const t = translations[currentLanguage as keyof typeof translations];

  const languageOptions = [
    { code: "en", label: "English" },
    { code: "am", label: "አማርኛ" },
    { code: "ti", label: "ትግርኛ" },
    { code: "or", label: "Afaan Oromoo" },
  ];

  const getCurrentLanguage = () => {
    return (
      languageOptions.find((lang) => lang.code === currentLanguage) ||
      languageOptions[0]
    );
  };

  const toggleLanguageDropdown = () => {
    if (!showLanguageMenu && languageButtonRef.current) {
      languageButtonRef.current.measureInWindow(
        (x: number, y: number, width: number, height: number) => {
          setDropdownPosition({
            top: y + height + 5,
            right:
              typeof window !== "undefined" ? window.innerWidth - x - width : 0,
          });
        },
      );
    }
    setShowLanguageMenu(!showLanguageMenu);
  };

  const changeLanguage = async (langCode: string) => {
    if (setCurrentLanguage) setCurrentLanguage(langCode);
    setSelectedLanguage(
      languageOptions.find((lang) => lang.code === langCode)?.label ||
        "English",
    );
    setShowLanguageMenu(false);
    try {
      await AsyncStorage.setItem("selectedLanguage", langCode);
    } catch (error) {
      console.error("Error saving language preference:", error);
    }
  };

  // Load filters from URL on mount
  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);

      const industry = params.get("industry");
      if (industry) setSelectedIndustry(industry);

      const sector = params.get("sector");
      if (sector) setSelectedSector(sector);

      const verification = params.get("verification");
      if (verification) setSelectedVerification(verification);

      const search = params.get("search");
      if (search) setSearchText(search);
    }
  }, []);

  // Update URL whenever filters change
  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const params = new URLSearchParams();

      if (selectedIndustry) params.set("industry", selectedIndustry);
      if (selectedSector) params.set("sector", selectedSector);
      if (selectedVerification)
        params.set("verification", selectedVerification);
      if (searchText) params.set("search", searchText);

      const newUrl = params.toString()
        ? `${window.location.pathname}?${params.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
  }, [selectedIndustry, selectedSector, selectedVerification, searchText]);

  useEffect(() => {
    const initializeScreen = async () => {
      try {
        // Load saved language label for display
        const savedLanguage = await AsyncStorage.getItem("selectedLanguage");
        if (savedLanguage) {
          setSelectedLanguage(
            languageOptions.find((lang) => lang.code === savedLanguage)
              ?.label || "English",
          );
        }
      } catch (error) {
        console.error("Error loading language:", error);
      }
    };

    initializeScreen();

    // Set search text if passed from home page
    if (route?.params?.searchQuery) {
      setSearchText(route.params.searchQuery);
    }

    // Listen to auth state
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        setUser(authUser);
        try {
          const userDoc = await getDoc(doc(db, "users", authUser.uid));
          if (userDoc.exists()) {
            const data = userDoc.data();
            setUserData(data);
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      } else {
        setUser(null);
        setUserData(null);
      }
    });

    return unsubscribe;
  }, [route?.params?.searchQuery]);

  // Fetch data when component mounts (allow guest access)
  useEffect(() => {
    console.log("📊 Fetching companies data...");
    fetchAllCompanies();
    fetchIndustries();
    fetchSectors();
    fetchLocations();
  }, []);

  // Apply filters whenever they change or companies data changes
  useEffect(() => {
    if (allCompanies.length > 0) {
      applyFiltersAndPagination();
    }
  }, [
    allCompanies,
    selectedIndustry,
    selectedSector,
    selectedVerification,
    selectedLocation,
    selectedCompanySize,
    actualSearchQuery,
  ]);

  // Handle search submission
  const handleSearch = () => {
    setActualSearchQuery(searchText);
  };

  // Fetch all companies (both registered and telegram) upfront
  const fetchAllCompanies = async () => {
    setLoading(true);
    try {
      console.log("📊 Fetching all companies...");
      const allCompaniesData: any[] = [];

      // 1. Fetch verified registered companies (limited to 12 for performance)
      const usersCollection = collection(db, "users");
      const registeredQuery = dbQuery(
        usersCollection,
        where("role", "==", "company"),
        where("companyProfile.verificationStatus", "==", "approved"),
        limit(12),
      );

      const registeredSnapshot = await getDocs(registeredQuery);
      firebaseOps.incrementReads(registeredSnapshot.size);

      registeredSnapshot.docs.forEach((doc) => {
        allCompaniesData.push({
          id: doc.id,
          ...doc.data(),
          source: "registered",
        });
      });
      console.log("📊 Registered companies:", registeredSnapshot.size);

      // 2. Fetch companies from Telegram jobs (limited to 12 recent jobs for performance)
      try {
        const jobsCollection = collection(db, "jobs");
        const jobsQuery = dbQuery(
          jobsCollection,
          orderBy("postedDate", "desc"),
          limit(12),
        );

        const jobsSnapshot = await getDocs(jobsQuery);
        firebaseOps.incrementReads(jobsSnapshot.size);
        console.log("📊 Telegram jobs checked:", jobsSnapshot.size);

        // Extract unique companies from jobs
        const telegramCompaniesMap = new Map<string, any>();
        jobsSnapshot.docs.forEach((doc) => {
          const jobData = doc.data();
          const companyName = jobData.company || jobData.companyName;

          if (
            companyName &&
            typeof companyName === "string" &&
            companyName.trim()
          ) {
            const normalizedName = companyName.trim();

            if (!telegramCompaniesMap.has(normalizedName)) {
              telegramCompaniesMap.set(normalizedName, {
                id: `telegram_${normalizedName
                  .replace(/\s+/g, "_")
                  .toLowerCase()}`,
                role: "company",
                companyProfile: {
                  companyName: normalizedName,
                  verificationStatus: "telegram",
                  industry:
                    jobData.industry || jobData.category || "Not specified",
                  sector: jobData.sector || "Not specified",
                  city: jobData.location || "Not specified",
                },
                source: "telegram",
                createdAt: jobData.postedDate || new Date(),
              });
            }
          }
        });

        const telegramCompanies = Array.from(telegramCompaniesMap.values());
        allCompaniesData.push(...telegramCompanies);
        console.log(
          "📊 Added",
          telegramCompanies.length,
          "companies from Telegram",
        );
      } catch (error) {
        console.error("Error fetching Telegram companies:", error);
      }

      console.log("📊 Total companies loaded:", allCompaniesData.length);
      setAllCompanies(allCompaniesData);
    } catch (error: any) {
      console.error("❌ Error fetching companies:", error);
      if (error?.code === "permission-denied") {
        Alert.alert(
          "Permission Error",
          "Unable to load companies due to insufficient permissions.",
          [{ text: "OK" }],
        );
      }
      setAllCompanies([]);
    } finally {
      setLoading(false);
    }
  };

  // Apply filters and pagination to the full company list
  const applyFiltersAndPagination = () => {
    let filtered = [...allCompanies];

    // Apply verification filter
    if (selectedVerification) {
      filtered = filtered.filter(
        (company: any) =>
          company.companyProfile?.verificationStatus === selectedVerification,
      );
    }

    // Apply industry filter
    if (selectedIndustry) {
      filtered = filtered.filter(
        (company: any) => company.companyProfile?.industry === selectedIndustry,
      );
    }

    // Apply sector filter
    if (selectedSector) {
      filtered = filtered.filter(
        (company: any) => company.companyProfile?.sector === selectedSector,
      );
    }

    // Apply location filter
    if (selectedLocation) {
      filtered = filtered.filter(
        (company: any) => company.companyProfile?.city === selectedLocation,
      );
    }

    // Apply company size filter
    if (selectedCompanySize) {
      filtered = filtered.filter((company: any) => {
        const size =
          company.companyProfile?.companySize ||
          company.companyProfile?.size ||
          "";
        return size === selectedCompanySize;
      });
    }

    // Apply search filter
    if (actualSearchQuery) {
      const searchLower = actualSearchQuery.toLowerCase();
      filtered = filtered.filter((company: any) => {
        const companyProfile = company.companyProfile || {};
        return (
          companyProfile.companyName?.toLowerCase().includes(searchLower) ||
          companyProfile.industry?.toLowerCase().includes(searchLower) ||
          companyProfile.city?.toLowerCase().includes(searchLower) ||
          companyProfile.companyDescription?.toLowerCase().includes(searchLower)
        );
      });
    }

    console.log("📊 Filtered companies:", filtered.length);
    setFilteredCompanies(filtered);

    // Reset to page 1 when filters change
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  const fetchIndustries = async () => {
    try {
      console.log("🏭 Fetching industries...");
      const usersCollection = collection(db, "users");
      // Simple query - just get companies
      const companiesQuery = dbQuery(
        usersCollection,
        where("role", "==", "company"),
        where("companyProfile.verificationStatus", "==", "approved"),
      );
      const companiesSnapshot = await getDocs(companiesQuery);

      const industriesSet = new Set<string>();
      companiesSnapshot.docs.forEach((doc) => {
        const data = doc.data();
        // Include industries from all companies (approved, pending, rejected)
        if (data.companyProfile?.industry) {
          industriesSet.add(data.companyProfile.industry);
        }
      });

      const industriesList = Array.from(industriesSet).sort();
      console.log("✅ Industries found:", industriesList.length);
      setIndustries(industriesList);
    } catch (error: any) {
      console.error("❌ Error fetching industries:", error);
    }
  };

  const fetchSectors = async () => {
    try {
      console.log("🏢 Fetching sectors...");
      const usersCollection = collection(db, "users");
      const companiesQuery = dbQuery(
        usersCollection,
        where("role", "==", "company"),
        where("companyProfile.verificationStatus", "==", "approved"),
      );
      const companiesSnapshot = await getDocs(companiesQuery);

      const sectorsSet = new Set<string>();
      companiesSnapshot.docs.forEach((doc) => {
        const data = doc.data();
        if (data.companyProfile?.sector) {
          sectorsSet.add(data.companyProfile.sector);
        }
      });

      const sectorsList = Array.from(sectorsSet).sort();
      console.log("✅ Sectors found:", sectorsList.length);
      setSectors(sectorsList);
    } catch (error: any) {
      console.error("❌ Error fetching sectors:", error);
      if (error?.code === "permission-denied") {
        console.error("🚫 Firestore permissions denied for industries query.");
        Alert.alert(
          "Permission Error",
          "Unable to load industries. Please check if you are logged in.",
          [{ text: "OK" }],
        );
      }
      setIndustries([]);
    }
  };

  const fetchLocations = async () => {
    try {
      console.log("📍 Fetching locations...");
      const usersCollection = collection(db, "users");
      const companiesQuery = dbQuery(
        usersCollection,
        where("role", "==", "company"),
        where("companyProfile.verificationStatus", "==", "approved"),
      );
      const companiesSnapshot = await getDocs(companiesQuery);

      const locationsSet = new Set<string>();
      companiesSnapshot.docs.forEach((doc) => {
        const data = doc.data();
        if (data.companyProfile?.city) {
          locationsSet.add(data.companyProfile.city);
        }
      });

      const locationsList = Array.from(locationsSet).sort();
      console.log("✅ Locations found:", locationsList.length);
      setLocations(locationsList);
    } catch (error: any) {
      console.error("❌ Error fetching locations:", error);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      setShowLogoutModal(false);
      navigation.replace("Home");
    } catch (error) {
      console.error("Logout error:", error);
      Alert.alert("Error", "Failed to logout. Please try again.");
    }
  };

  // Pagination calculations - client-side pagination
  const totalPages = Math.ceil(filteredCompanies.length / companiesPerPage);
  const startIndex = (currentPage - 1) * companiesPerPage;
  const endIndex = startIndex + companiesPerPage;
  const paginatedCompanies = filteredCompanies.slice(startIndex, endIndex);

  // Update companies state with paginated data
  useEffect(() => {
    setCompanies(paginatedCompanies);
    setLoading(false);
  }, [currentPage, filteredCompanies]);

  const hasNextPage = currentPage < totalPages;
  const hasPrevPage = currentPage > 1;

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    // Scroll to top when page changes
    if (Platform.OS === "web" && typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const renderCompanyCard = ({ item: company }: any) => {
    const companyProfile = company.companyProfile || {};
    const isFeatured = companyProfile.verificationStatus === "approved";
    const isTelegramCompany = company.source === "telegram";
    const isNew =
      company.createdAt &&
      Date.now() - company.createdAt.seconds * 1000 < 7 * 24 * 60 * 60 * 1000;
    const jobCount = company.activeJobCount || company.totalJobs || 0;
    const initial = companyProfile.companyName?.charAt(0)?.toUpperCase() || "C";

    if (isMobile) {
      // ── Full-width minimal list row ──
      return (
        <TouchableOpacity
          activeOpacity={0.6}
          onPress={() =>
            navigation.navigate("CompanyDetails", { companyId: company.id })
          }
          style={{
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: isDarkMode ? "#13161C" : "#FFFFFF",
            paddingHorizontal: 16,
            paddingVertical: 14,
            borderBottomWidth: 1,
            borderBottomColor: isDarkMode ? "#1E2028" : "#F0F1F5",
          }}
        >
          {/* Verified left accent */}
          {isFeatured && (
            <View
              style={{
                position: "absolute",
                left: 0,
                top: 8,
                bottom: 8,
                width: 3,
                borderRadius: 3,
                backgroundColor: "#F4C430",
              }}
            />
          )}

          {/* Circular logo */}
          <View
            style={{
              width: 50,
              height: 50,
              borderRadius: 25,
              backgroundColor: isDarkMode ? "#1E2230" : "#F0F4FF",
              overflow: "hidden",
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 0,
            }}
          >
            {companyProfile.logoUrl ? (
              <Image
                source={{ uri: companyProfile.logoUrl }}
                style={{ width: "100%", height: "100%" }}
                resizeMode="cover"
              />
            ) : (
              <Text
                style={{
                  fontSize: 20,
                  fontFamily: fonts.bold,
                  color: isDarkMode ? "#818CF8" : "#6366F1",
                }}
              >
                {initial}
              </Text>
            )}
          </View>

          {/* Info */}
          <View style={{ flex: 1, marginLeft: 13, gap: 2 }}>
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 6 }}
            >
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.bold,
                  color: isDarkMode ? "#F1F5F9" : "#0F172A",
                  flex: 1,
                }}
                numberOfLines={1}
              >
                {companyProfile.companyName || "Company"}
              </Text>
              {isNew && (
                <View
                  style={{
                    backgroundColor: "#10B981",
                    paddingHorizontal: 6,
                    paddingVertical: 2,
                    borderRadius: 5,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 9,
                      fontFamily: fonts.bold,
                      color: "#fff",
                    }}
                  >
                    NEW
                  </Text>
                </View>
              )}
            </View>

            <Text
              style={{
                fontSize: 12,
                fontFamily: fonts.regular,
                color: isDarkMode ? "#6B7280" : "#94A3B8",
              }}
              numberOfLines={1}
            >
              {[companyProfile.industry, companyProfile.city]
                .filter(Boolean)
                .join(" · ")}
            </Text>
          </View>

          {/* Right: jobs count + chevron */}
          <View style={{ alignItems: "flex-end", gap: 4, marginLeft: 10 }}>
            {jobCount > 0 ? (
              <View
                style={{
                  backgroundColor: isDarkMode ? "#0D2018" : "#ECFDF5",
                  paddingHorizontal: 9,
                  paddingVertical: 4,
                  borderRadius: 20,
                }}
              >
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    color: "#10B981",
                  }}
                >
                  {jobCount} {jobCount === 1 ? "job" : "jobs"}
                </Text>
              </View>
            ) : (
              <View style={{ width: 10 }} />
            )}
            <Icon
              name="chevron-right"
              size={16}
              color={isDarkMode ? "#374151" : "#D1D5DB"}
            />
          </View>
        </TouchableOpacity>
      );
    }

    // ── Desktop / tablet card (original design preserved) ──
    return (
      <TouchableOpacity
        style={[
          styles.modernJobCard,
          {
            backgroundColor: colors.white,
            borderRadius: 18,
            overflow: "hidden",
            shadowColor: colors.deepNavy,
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.06,
            shadowRadius: 8,
            elevation: 2,
          },
          viewMode === "list" && styles.modernJobCardList,
        ]}
        activeOpacity={0.7}
        onPress={() =>
          navigation.navigate("CompanyDetails", { companyId: company.id })
        }
      >
        {/* Colored Header Section */}
        <View
          style={{
            backgroundColor: isFeatured
              ? colors.beeYellow
              : `${colors.deepNavy}95`,
            paddingTop: 32,
            paddingBottom: 54,
            paddingHorizontal: 18,
            position: "relative",
          }}
        >
          <View
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              flexDirection: "row",
              gap: 6,
            }}
          >
            {isNew && (
              <View
                style={{
                  backgroundColor: colors.white,
                  paddingHorizontal: 8,
                  paddingVertical: 4,
                  borderRadius: 6,
                }}
              >
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "700",
                    color: colors.success,
                  }}
                >
                  NEW
                </Text>
              </View>
            )}
            {isTelegramCompany && (
              <View
                style={{
                  backgroundColor: colors.white,
                  paddingHorizontal: 6,
                  paddingVertical: 4,
                  borderRadius: 6,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 3,
                }}
              >
                <Icon name="send" size={10} color={colors.softBlue} />
              </View>
            )}
          </View>
          <Text
            style={{
              fontSize: 20,
              fontWeight: "800",
              color: isFeatured ? colors.deepNavy : colors.white,
              marginBottom: 6,
            }}
            numberOfLines={1}
          >
            {companyProfile.companyName || "Company Name"}
          </Text>
          {companyProfile.industry && (
            <Text
              style={{
                fontSize: 13,
                color: isFeatured
                  ? `${colors.deepNavy}80`
                  : `${colors.white}85`,
                fontWeight: "500",
              }}
              numberOfLines={1}
            >
              {companyProfile.industry}
            </Text>
          )}
        </View>
        <View
          style={{
            position: "absolute",
            top: 80,
            left: 18,
            width: 80,
            height: 80,
            borderRadius: 16,
            backgroundColor: colors.white,
            justifyContent: "center",
            alignItems: "center",
            shadowColor: colors.deepNavy,
            shadowOffset: { width: 0, height: 3 },
            shadowOpacity: 0.15,
            shadowRadius: 6,
            elevation: 4,
            borderWidth: 4,
            borderColor: colors.white,
            overflow: "hidden",
          }}
        >
          {companyProfile.logoUrl ? (
            <Image
              source={{ uri: companyProfile.logoUrl }}
              style={{ width: "100%", height: "100%" }}
              resizeMode="cover"
            />
          ) : (
            <Text
              style={{
                fontSize: 34,
                fontWeight: "800",
                color: colors.deepNavy,
              }}
            >
              {initial}
            </Text>
          )}
          {isFeatured && (
            <View
              style={{
                position: "absolute",
                bottom: -3,
                right: -3,
                backgroundColor: colors.success,
                borderRadius: 12,
                padding: 4,
                borderWidth: 2,
                borderColor: colors.white,
              }}
            >
              <Icon name="verified" size={12} color={colors.white} />
            </View>
          )}
        </View>
        <View
          style={{ paddingTop: 52, paddingHorizontal: 18, paddingBottom: 18 }}
        >
          <View style={{ gap: 10 }}>
            <View style={{ flexDirection: "row", gap: 10 }}>
              {companyProfile.city && (
                <View
                  style={{
                    flex: 1,
                    backgroundColor: `${colors.softBlue}08`,
                    padding: 12,
                    borderRadius: 12,
                    gap: 6,
                  }}
                >
                  <Icon name="location-on" size={16} color={colors.softBlue} />
                  <View>
                    <Text
                      style={{
                        fontSize: 10,
                        color: colors.warmGray,
                        fontWeight: "600",
                        marginBottom: 2,
                      }}
                    >
                      Location
                    </Text>
                    <Text
                      style={{
                        fontSize: 13,
                        color: colors.deepNavy,
                        fontWeight: "700",
                      }}
                      numberOfLines={1}
                    >
                      {companyProfile.city}
                    </Text>
                  </View>
                </View>
              )}
              {companyProfile.companySize && (
                <View
                  style={{
                    flex: 1,
                    backgroundColor: `${colors.deepNavy}06`,
                    padding: 12,
                    borderRadius: 12,
                    gap: 6,
                  }}
                >
                  <Icon name="people" size={16} color={colors.deepNavy} />
                  <View>
                    <Text
                      style={{
                        fontSize: 10,
                        color: colors.warmGray,
                        fontWeight: "600",
                        marginBottom: 2,
                      }}
                    >
                      Team Size
                    </Text>
                    <Text
                      style={{
                        fontSize: 13,
                        color: colors.deepNavy,
                        fontWeight: "700",
                      }}
                      numberOfLines={1}
                    >
                      {companyProfile.companySize}
                    </Text>
                  </View>
                </View>
              )}
            </View>
            {jobCount > 0 && (
              <View
                style={{
                  backgroundColor: `${colors.success}08`,
                  padding: 14,
                  borderRadius: 12,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <View
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: 10,
                      backgroundColor: colors.success,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Icon name="work" size={18} color={colors.white} />
                  </View>
                  <View>
                    <Text
                      style={{
                        fontSize: 10,
                        color: colors.warmGray,
                        fontWeight: "600",
                        marginBottom: 2,
                      }}
                    >
                      Open Positions
                    </Text>
                    <Text
                      style={{
                        fontSize: 16,
                        color: colors.success,
                        fontWeight: "800",
                      }}
                    >
                      {jobCount} {jobCount === 1 ? "Job" : "Jobs"}
                    </Text>
                  </View>
                </View>
                <Icon name="chevron-right" size={22} color={colors.success} />
              </View>
            )}
          </View>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <SafeAreaView
      style={[
        styles.container,
        { backgroundColor: isDarkMode ? "#0F1117" : colors.white },
      ]}
    >
      {/* Header Toolbar */}
      <View
        style={[
          styles.jobsToolbar,
          {
            backgroundColor: isDarkMode ? "#0F1117" : colors.white,
            borderBottomColor: isDarkMode ? "#1E2027" : "#F0F0F0",
          },
        ]}
      >
        {/* ── MOBILE APP BAR ── */}
        {isMobile &&
          (() => {
            const activeFilterCount =
              (selectedIndustry ? 1 : 0) +
              (selectedSector ? 1 : 0) +
              (selectedVerification ? 1 : 0) +
              (selectedLocation ? 1 : 0) +
              (selectedCompanySize ? 1 : 0);
            const iconColor = isDarkMode ? "#9CA3AF" : "#6B7280";
            const titleColor = isDarkMode ? "#F9FAFB" : colors.deepNavy;
            return isSearchExpanded ? (
              <View
                style={{
                  flex: 1,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                }}
              >
                <TouchableOpacity
                  onPress={() => {
                    setIsSearchExpanded(false);
                    setSearchText("");
                  }}
                  hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
                >
                  <Icon name="arrow-back" size={22} color={titleColor} />
                </TouchableOpacity>
                <TextInput
                  style={{
                    flex: 1,
                    fontSize: 16,
                    fontFamily: fonts.regular,
                    color: titleColor,
                    padding: 0,
                  }}
                  placeholder="Search companies…"
                  placeholderTextColor={iconColor}
                  value={searchText}
                  onChangeText={setSearchText}
                  onSubmitEditing={handleSearch}
                  returnKeyType="search"
                  autoFocus
                />
                {searchText.length > 0 && (
                  <TouchableOpacity
                    onPress={() => {
                      setSearchText("");
                      setActualSearchQuery("");
                    }}
                    hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
                  >
                    <Icon name="close" size={20} color={iconColor} />
                  </TouchableOpacity>
                )}
              </View>
            ) : (
              <>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    flex: 1,
                    gap: 10,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => setShowMobileMenu(true)}
                    hitSlop={{ top: 8, bottom: 8, left: 4, right: 8 }}
                  >
                    <Icon name="menu" size={24} color={titleColor} />
                  </TouchableOpacity>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Image
                      source={require("./assets/favicon.png")}
                      style={{ width: 26, height: 26, borderRadius: 6 }}
                      resizeMode="contain"
                    />
                    <View>
                      <Text
                        style={{
                          fontSize: 17,
                          fontFamily: fonts.bold,
                          color: titleColor,
                          letterSpacing: 0.1,
                          lineHeight: 20,
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: fonts.regular,
                            color: isDarkMode ? "#9CA3AF" : "#94A3B8",
                          }}
                        >
                          Nib
                        </Text>
                        Jobs
                      </Text>
                      <View
                        style={{
                          height: 2.5,
                          width: 32,
                          backgroundColor: "#F4C430",
                          borderRadius: 2,
                        }}
                      />
                    </View>
                  </View>
                </View>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <TouchableOpacity
                    onPress={() => setIsSearchExpanded(true)}
                    style={{ padding: 8 }}
                    hitSlop={{ top: 4, bottom: 4, left: 4, right: 4 }}
                  >
                    <Icon name="search" size={22} color={iconColor} />
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => setShowMobileFilters(true)}
                    style={{ padding: 8 }}
                    hitSlop={{ top: 4, bottom: 4, left: 4, right: 4 }}
                  >
                    <Icon
                      name="tune"
                      size={22}
                      color={activeFilterCount > 0 ? "#F4C430" : iconColor}
                    />
                    {activeFilterCount > 0 && (
                      <View
                        style={{
                          position: "absolute",
                          top: 5,
                          right: 5,
                          backgroundColor: "#F4C430",
                          borderRadius: 5,
                          minWidth: 14,
                          height: 14,
                          alignItems: "center",
                          justifyContent: "center",
                          paddingHorizontal: 2,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 8,
                            fontFamily: fonts.bold,
                            color: colors.deepNavy,
                            lineHeight: 14,
                          }}
                        >
                          {activeFilterCount}
                        </Text>
                      </View>
                    )}
                  </TouchableOpacity>
                </View>
              </>
            );
          })()}

        <View
          style={[
            styles.jobsToolbarLeft,
            isMobile && { display: "none" as any },
          ]}
        >
          {!isMobile && (
            <TouchableOpacity onPress={() => navigation.navigate("Home")}>
              <Image
                source={require("./assets/favicon.png")}
                style={styles.toolbarLogo}
                resizeMode="contain"
              />
            </TouchableOpacity>
          )}
          {!isMobile && (
            <>
              <TouchableOpacity
                style={[styles.toolbarNavButton, { opacity: 0.6 }]}
                onPress={() => navigation.navigate("Jobs")}
              >
                <Text
                  style={[
                    styles.toolbarNavButtonText,
                    { color: colors.deepNavy },
                  ]}
                >
                  {t.navJobs}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[
                  styles.toolbarNavButton,
                  {
                    borderBottomWidth: 3,
                    borderBottomColor: colors.beeYellow,
                    paddingBottom: 8,
                  },
                ]}
                onPress={() => navigation.navigate("Companies")}
              >
                <Text
                  style={[
                    styles.toolbarNavButtonText,
                    {
                      color: colors.deepNavy,
                      fontWeight: "700",
                      fontFamily: fonts.bold,
                    },
                  ]}
                >
                  {t.companies}
                </Text>
              </TouchableOpacity>
              {user && userData?.role === "user" && (
                <TouchableOpacity
                  style={[
                    styles.toolbarNavButton,
                    {
                      backgroundColor: "#374151",
                      paddingHorizontal: 16,
                      borderRadius: 8,
                    },
                  ]}
                  onPress={() => navigation.navigate("CompanyRegistration")}
                >
                  <Text
                    style={[
                      styles.toolbarNavButtonText,
                      { color: "#FFFFFF", fontWeight: "600" },
                    ]}
                  >
                    {t.cdPostJob}
                  </Text>
                </TouchableOpacity>
              )}
              {user &&
                userData?.role === "company" &&
                userData?.companyProfile && (
                  <TouchableOpacity
                    style={[
                      styles.toolbarNavButton,
                      {
                        backgroundColor: "#374151",
                        paddingHorizontal: 16,
                        borderRadius: 8,
                      },
                    ]}
                    onPress={() => navigation.navigate("CompanyDashboard")}
                  >
                    <Text
                      style={[
                        styles.toolbarNavButtonText,
                        { color: "#FFFFFF", fontWeight: "600" },
                      ]}
                    >
                      {t.cdPostJob}
                    </Text>
                  </TouchableOpacity>
                )}
              {user && (
                <TouchableOpacity
                  onPress={() => navigation.navigate("Bookmarks")}
                  style={{
                    width: 38,
                    height: 38,
                    borderRadius: 10,
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: 4,
                  }}
                  activeOpacity={0.7}
                  hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
                >
                  <Icon
                    name="bookmark-border"
                    size={22}
                    color={colors.deepNavy}
                  />
                </TouchableOpacity>
              )}
            </>
          )}

          {/* Search Bar - Hidden on mobile */}
          {!isMobile && (
            <View
              style={[
                styles.toolbarSearchContainer,
                { backgroundColor: colors.lightGray },
              ]}
            >
              <Icon name="search" size={18} color={colors.warmGray} />
              <TextInput
                style={[styles.toolbarSearchInput, { color: colors.deepNavy }]}
                placeholder="Search companies..."
                placeholderTextColor={colors.warmGray}
                value={searchText}
                onChangeText={setSearchText}
                onSubmitEditing={handleSearch}
                returnKeyType="search"
              />
              {searchText && (
                <TouchableOpacity
                  style={{
                    backgroundColor: "transparent",
                    paddingHorizontal: 16,
                    paddingVertical: 8,
                    borderRadius: 8,
                    marginLeft: 8,
                    borderWidth: 1,
                    borderColor: colors.lightGray,
                  }}
                  onPress={handleSearch}
                >
                  <Text
                    style={{
                      fontFamily: fonts.medium,
                      fontSize: 14,
                      color: colors.warmGray,
                    }}
                  >
                    Search
                  </Text>
                </TouchableOpacity>
              )}
            </View>
          )}
        </View>

        <View style={styles.jobsToolbarRight}>
          {/* Alerts & Language - Desktop only */}
          {!isMobile && user && (
            <NotificationsBell
              navigation={navigation}
              isDarkMode={isDarkMode}
              currentLanguage={currentLanguage}
            />
          )}
          {!isMobile && (
            <DesktopLanguageSelector
              currentLanguage={currentLanguage}
              setCurrentLanguage={setCurrentLanguage}
              isDarkMode={isDarkMode}
            />
          )}
          {/* Theme Toggle Switch - Hidden on mobile */}
          {!isMobile && (
            <TouchableOpacity
              style={styles.toolbarThemeToggle}
              onPress={toggleTheme}
            >
              <View
                style={[
                  styles.themeToggleTrack,
                  {
                    backgroundColor: isDarkMode
                      ? colors.deepNavy
                      : colors.lightGray,
                  },
                ]}
              >
                <Icon
                  name="wb-sunny"
                  size={14}
                  color={isDarkMode ? colors.warmGray : colors.beeYellow}
                  style={styles.themeToggleIconLeft}
                />
                <View
                  style={[
                    styles.themeToggleKnob,
                    { backgroundColor: colors.white },
                    isDarkMode && styles.themeToggleKnobActive,
                  ]}
                >
                  <Icon
                    name={isDarkMode ? "nightlight-round" : "wb-sunny"}
                    size={12}
                    color={isDarkMode ? colors.deepNavy : colors.beeYellow}
                  />
                </View>
                <Icon
                  name="nightlight-round"
                  size={14}
                  color={isDarkMode ? colors.beeYellow : colors.warmGray}
                  style={styles.themeToggleIconRight}
                />
              </View>
            </TouchableOpacity>
          )}

          {!isMobile &&
            (user ? (
              <UserMenu
                navigation={navigation}
                user={user}
                userData={userData}
                isDarkMode={isDarkMode}
                currentLanguage={currentLanguage}
              />
            ) : (
              <>
                <TouchableOpacity
                  style={[
                    styles.toolbarLoginButton,
                    { borderColor: colors.deepNavy },
                  ]}
                  onPress={() => navigation.navigate("Login")}
                >
                  <Text
                    style={[
                      styles.toolbarLoginButtonText,
                      { color: colors.deepNavy },
                    ]}
                  >
                    Login
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={[
                    styles.toolbarSignupButton,
                    { backgroundColor: colors.beeYellow },
                  ]}
                  onPress={() => navigation.navigate("Signup")}
                >
                  <Text
                    style={[
                      styles.toolbarSignupButtonText,
                      { color: colors.buttonTextOnYellow },
                    ]}
                  >
                    Sign Up
                  </Text>
                </TouchableOpacity>
              </>
            ))}
        </View>
      </View>

      <ScrollView
        style={[
          styles.jobsPageContainer,
          { backgroundColor: isDarkMode ? "#0F1117" : "#FFFFFF" },
        ]}
        contentContainerStyle={{ width: "100%", maxWidth: "100vw" }}
        horizontal={false}
        showsHorizontalScrollIndicator={false}
      >
        {/* Industry Pills - Hidden */}
        {false && industries.length > 0 && (
          <View
            style={[
              styles.categoriesSection,
              { backgroundColor: colors.white },
            ]}
          >
            <ScrollView
              horizontal
              showsHorizontalScrollIndicator={false}
              contentContainerStyle={styles.categoriesScrollContent}
            >
              <TouchableOpacity
                style={[
                  styles.categoryPill,
                  {
                    backgroundColor: colors.lightGray,
                    borderColor: colors.lightGray,
                  },
                  !selectedIndustry && {
                    backgroundColor: isDarkMode
                      ? colors.beeYellow
                      : colors.deepNavy,
                  },
                ]}
                onPress={() => setSelectedIndustry("")}
              >
                <Icon
                  name="apps"
                  size={16}
                  color={
                    !selectedIndustry
                      ? isDarkMode
                        ? colors.buttonTextOnYellow
                        : colors.white
                      : colors.deepNavy
                  }
                />
                <Text
                  style={[
                    styles.categoryPillText,
                    { color: colors.deepNavy },
                    !selectedIndustry && {
                      color: isDarkMode
                        ? colors.buttonTextOnYellow
                        : colors.white,
                      fontWeight: "600",
                    },
                  ]}
                >
                  All Companies
                </Text>
              </TouchableOpacity>
              {industries.map((industry) => (
                <TouchableOpacity
                  key={industry}
                  style={[
                    styles.categoryPill,
                    {
                      backgroundColor: colors.lightGray,
                      borderColor: colors.lightGray,
                    },
                    selectedIndustry === industry && {
                      backgroundColor: isDarkMode
                        ? colors.beeYellow
                        : colors.deepNavy,
                    },
                  ]}
                  onPress={() => setSelectedIndustry(industry)}
                >
                  <Text
                    style={[
                      styles.categoryPillText,
                      { color: colors.deepNavy },
                      selectedIndustry === industry && {
                        color: isDarkMode
                          ? colors.buttonTextOnYellow
                          : colors.white,
                        fontWeight: "600",
                      },
                    ]}
                  >
                    {industry}
                  </Text>
                </TouchableOpacity>
              ))}
            </ScrollView>
          </View>
        )}

        {/* Main Content Area with Sidebar */}
        <View
          style={[
            styles.jobsContentWithSidebar,
            { flexDirection: isMobile ? "column" : "row" },
          ]}
        >
          {/* Mobile Filter Button - Hidden (FAB is used instead) */}
          {false && isMobile && (
            <TouchableOpacity
              style={[
                styles.mobileFilterButton,
                { backgroundColor: colors.beeYellow },
              ]}
              onPress={() => setShowMobileFilters(true)}
            >
              <Icon name="filter-list" size={20} color={colors.deepNavy} />
              <Text
                style={[
                  styles.mobileFilterButtonText,
                  { color: colors.deepNavy },
                ]}
              >
                Filters
                {(() => {
                  const count =
                    (selectedIndustry ? 1 : 0) +
                    (selectedSector ? 1 : 0) +
                    (selectedVerification ? 1 : 0) +
                    (selectedLocation ? 1 : 0) +
                    (selectedCompanySize ? 1 : 0);
                  return count > 0 ? ` (${count})` : "";
                })()}
              </Text>
            </TouchableOpacity>
          )}

          {/* Premium Filter Sidebar - Desktop only */}
          {!isMobile && (
            <View
              style={[
                styles.filterSidebar,
                {
                  backgroundColor: isDarkMode ? "#0D0F12" : colors.white,
                  borderRadius: 20,
                  padding: 24,
                  shadowColor: isDarkMode ? "#000" : colors.deepNavy,
                  shadowOffset: { width: 0, height: 8 },
                  shadowOpacity: isDarkMode ? 0.3 : 0.08,
                  shadowRadius: 24,
                  elevation: 8,
                  borderWidth: 1,
                  borderColor: isDarkMode ? "#1E2128" : "#F0F0F0",
                },
              ]}
            >
              {/* Premium Header */}
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                  paddingBottom: 20,
                  borderBottomWidth: 2,
                  borderBottomColor: isDarkMode ? "#1E2128" : "#F5F5F5",
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <View
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 12,
                      backgroundColor: isDarkMode
                        ? colors.beeYellow + "20"
                        : colors.beeYellow + "15",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Icon
                      name="tune"
                      size={24}
                      color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                    />
                  </View>
                  <View>
                    <Text
                      style={{
                        fontSize: 20,
                        fontWeight: "800",
                        color: isDarkMode ? colors.white : colors.deepNavy,
                        fontFamily: fonts.bold,
                      }}
                    >
                      Filters
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,
                        color: isDarkMode ? "#8B92A8" : colors.warmGray,
                        marginTop: 2,
                      }}
                    >
                      Refine your search
                    </Text>
                  </View>
                </View>

                {/* Active filters count badge */}
                {(() => {
                  const activeFilters = [
                    selectedIndustry,
                    selectedSector,
                    selectedVerification,
                    selectedLocation,
                    selectedCompanySize,
                  ].filter(Boolean).length;
                  return activeFilters > 0 ? (
                    <View
                      style={{
                        backgroundColor: colors.beeYellow,
                        paddingHorizontal: 10,
                        paddingVertical: 5,
                        borderRadius: 20,
                        minWidth: 28,
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          color: colors.buttonTextOnYellow,
                          fontSize: 13,
                          fontWeight: "800",
                          fontFamily: fonts.bold,
                        }}
                      >
                        {activeFilters}
                      </Text>
                    </View>
                  ) : null;
                })()}
              </View>

              {/* Clear All Filters */}
              {(selectedIndustry ||
                selectedSector ||
                selectedVerification ||
                selectedLocation ||
                selectedCompanySize) && (
                <TouchableOpacity
                  style={{
                    backgroundColor: isDarkMode
                      ? colors.beeYellow + "18"
                      : colors.beeYellow,
                    borderRadius: 14,
                    paddingVertical: 14,
                    paddingHorizontal: 18,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 10,
                    marginBottom: 20,
                    shadowColor: colors.beeYellow,
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: isDarkMode ? 0.2 : 0.15,
                    shadowRadius: 8,
                    elevation: 3,
                  }}
                  onPress={() => {
                    setSelectedIndustry("");
                    setSelectedSector("");
                    setSelectedVerification("");
                    setSelectedLocation("");
                    setSelectedCompanySize("");
                  }}
                  activeOpacity={0.8}
                >
                  <Icon
                    name="refresh"
                    size={18}
                    color={
                      isDarkMode ? colors.beeYellow : colors.buttonTextOnYellow
                    }
                  />
                  <Text
                    style={{
                      color: isDarkMode
                        ? colors.beeYellow
                        : colors.buttonTextOnYellow,
                      fontSize: 15,
                      fontWeight: "700",
                      fontFamily: fonts.bold,
                    }}
                  >
                    Reset All Filters
                  </Text>
                </TouchableOpacity>
              )}

              {/* Industry Filter - Premium Card Style */}
              <View
                style={{
                  backgroundColor: isDarkMode
                    ? "#12151A"
                    : `${colors.beeYellow}08`,
                  borderRadius: 16,
                  overflow: "hidden",
                  marginBottom: 16,
                  borderWidth: 1,
                  borderColor: isDarkMode ? "#1E2128" : `${colors.beeYellow}25`,
                }}
              >
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 16,
                    backgroundColor: isDarkMode ? "#161921" : colors.white,
                  }}
                  onPress={() => setIndustryExpanded(!industryExpanded)}
                  activeOpacity={0.8}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                      flex: 1,
                    }}
                  >
                    <View
                      style={{
                        width: 38,
                        height: 38,
                        borderRadius: 10,
                        backgroundColor: isDarkMode
                          ? colors.beeYellow + "22"
                          : colors.beeYellow + "20",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        name="work"
                        size={20}
                        color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                      />
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 15,
                          fontWeight: "700",
                          color: isDarkMode ? "#E8EDF5" : colors.deepNavy,
                          fontFamily: fonts.bold,
                        }}
                      >
                        Industry
                      </Text>
                      {selectedIndustry && (
                        <Text
                          style={{
                            fontSize: 12,
                            color: isDarkMode
                              ? colors.beeYellow
                              : colors.warmGray,
                            marginTop: 2,
                          }}
                          numberOfLines={1}
                        >
                          {selectedIndustry}
                        </Text>
                      )}
                    </View>
                    {selectedIndustry && (
                      <View
                        style={{
                          backgroundColor: colors.beeYellow,
                          paddingHorizontal: 8,
                          paddingVertical: 4,
                          borderRadius: 8,
                          minWidth: 24,
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={{
                            color: colors.buttonTextOnYellow,
                            fontSize: 11,
                            fontWeight: "800",
                            fontFamily: fonts.bold,
                          }}
                        >
                          1
                        </Text>
                      </View>
                    )}
                  </View>
                  <Icon
                    name={industryExpanded ? "expand-less" : "expand-more"}
                    size={24}
                    color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                  />
                </TouchableOpacity>
                {industryExpanded && (
                  <View
                    style={{
                      padding: 12,
                      gap: 8,
                      backgroundColor: isDarkMode ? "#0D0F12" : "#FAFAFA",
                    }}
                  >
                    <ScrollView
                      style={{ maxHeight: 280 }}
                      showsVerticalScrollIndicator={false}
                    >
                      {industries.map((industry) => (
                        <TouchableOpacity
                          key={industry}
                          style={{
                            backgroundColor:
                              selectedIndustry === industry
                                ? isDarkMode
                                  ? colors.beeYellow
                                  : colors.deepNavy
                                : isDarkMode
                                ? "#161921"
                                : colors.white,
                            borderRadius: 12,
                            padding: 14,
                            marginBottom: 8,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            borderWidth: 1,
                            borderColor:
                              selectedIndustry === industry
                                ? isDarkMode
                                  ? colors.beeYellow
                                  : colors.deepNavy
                                : isDarkMode
                                ? "#1E2128"
                                : "#E8E8E8",
                          }}
                          onPress={() =>
                            setSelectedIndustry(
                              selectedIndustry === industry ? "" : industry,
                            )
                          }
                          activeOpacity={0.7}
                        >
                          <Text
                            style={{
                              fontSize: 14,
                              fontWeight:
                                selectedIndustry === industry ? "700" : "500",
                              color:
                                selectedIndustry === industry
                                  ? isDarkMode
                                    ? colors.buttonTextOnYellow
                                    : colors.white
                                  : isDarkMode
                                  ? "#E8EDF5"
                                  : colors.deepNavy,
                              flex: 1,
                              fontFamily:
                                selectedIndustry === industry
                                  ? fonts.bold
                                  : fonts.regular,
                            }}
                          >
                            {industry}
                          </Text>
                          {selectedIndustry === industry && (
                            <View
                              style={{
                                width: 22,
                                height: 22,
                                borderRadius: 11,
                                backgroundColor: isDarkMode
                                  ? colors.buttonTextOnYellow
                                  : colors.white,
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Icon
                                name="check"
                                size={14}
                                color={
                                  isDarkMode
                                    ? colors.beeYellow
                                    : colors.deepNavy
                                }
                              />
                            </View>
                          )}
                        </TouchableOpacity>
                      ))}
                    </ScrollView>
                  </View>
                )}
              </View>

              {/* Location Filter - Premium Card Style */}
              <View
                style={{
                  backgroundColor: isDarkMode
                    ? "#12151A"
                    : `${colors.success}08`,
                  borderRadius: 16,
                  overflow: "hidden",
                  marginBottom: 16,
                  borderWidth: 1,
                  borderColor: isDarkMode ? "#1E2128" : `${colors.success}25`,
                }}
              >
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 16,
                    backgroundColor: isDarkMode ? "#161921" : colors.white,
                  }}
                  onPress={() => setLocationExpanded(!locationExpanded)}
                  activeOpacity={0.8}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                      flex: 1,
                    }}
                  >
                    <View
                      style={{
                        width: 38,
                        height: 38,
                        borderRadius: 10,
                        backgroundColor: isDarkMode
                          ? colors.success + "22"
                          : colors.success + "20",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        name="location-on"
                        size={20}
                        color={isDarkMode ? colors.success : colors.success}
                      />
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 15,
                          fontWeight: "700",
                          color: isDarkMode ? "#E8EDF5" : colors.deepNavy,
                          fontFamily: fonts.bold,
                        }}
                      >
                        Location
                      </Text>
                      {selectedLocation && (
                        <Text
                          style={{
                            fontSize: 12,
                            color: isDarkMode
                              ? colors.success
                              : colors.warmGray,
                            marginTop: 2,
                          }}
                          numberOfLines={1}
                        >
                          {selectedLocation}
                        </Text>
                      )}
                    </View>
                    {selectedLocation && (
                      <View
                        style={{
                          backgroundColor: colors.success,
                          paddingHorizontal: 8,
                          paddingVertical: 4,
                          borderRadius: 8,
                          minWidth: 24,
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={{
                            color: colors.white,
                            fontSize: 11,
                            fontWeight: "800",
                            fontFamily: fonts.bold,
                          }}
                        >
                          1
                        </Text>
                      </View>
                    )}
                  </View>
                  <Icon
                    name={locationExpanded ? "expand-less" : "expand-more"}
                    size={24}
                    color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                  />
                </TouchableOpacity>
                {locationExpanded && (
                  <View
                    style={{
                      padding: 12,
                      gap: 8,
                      backgroundColor: isDarkMode ? "#0D0F12" : "#FAFAFA",
                    }}
                  >
                    <ScrollView
                      style={{ maxHeight: 280 }}
                      showsVerticalScrollIndicator={false}
                    >
                      {locations.map((location) => (
                        <TouchableOpacity
                          key={location}
                          style={{
                            backgroundColor:
                              selectedLocation === location
                                ? isDarkMode
                                  ? colors.success
                                  : colors.success
                                : isDarkMode
                                ? "#161921"
                                : colors.white,
                            borderRadius: 12,
                            padding: 14,
                            marginBottom: 8,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            borderWidth: 1,
                            borderColor:
                              selectedLocation === location
                                ? isDarkMode
                                  ? colors.success
                                  : colors.success
                                : isDarkMode
                                ? "#1E2128"
                                : "#E8E8E8",
                          }}
                          onPress={() =>
                            setSelectedLocation(
                              selectedLocation === location ? "" : location,
                            )
                          }
                          activeOpacity={0.7}
                        >
                          <Text
                            style={{
                              fontSize: 14,
                              fontWeight:
                                selectedLocation === location ? "700" : "500",
                              color:
                                selectedLocation === location
                                  ? colors.white
                                  : isDarkMode
                                  ? "#E8EDF5"
                                  : colors.deepNavy,
                              flex: 1,
                              fontFamily:
                                selectedLocation === location
                                  ? fonts.bold
                                  : fonts.regular,
                            }}
                          >
                            {location}
                          </Text>
                          {selectedLocation === location && (
                            <View
                              style={{
                                width: 22,
                                height: 22,
                                borderRadius: 11,
                                backgroundColor: colors.white,
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Icon
                                name="check"
                                size={14}
                                color={colors.success}
                              />
                            </View>
                          )}
                        </TouchableOpacity>
                      ))}
                    </ScrollView>
                  </View>
                )}
              </View>

              {/* Company Size Filter - Premium Card Style */}
              <View
                style={{
                  backgroundColor: isDarkMode
                    ? "#12151A"
                    : `${colors.softBlue}08`,
                  borderRadius: 16,
                  overflow: "hidden",
                  marginBottom: 16,
                  borderWidth: 1,
                  borderColor: isDarkMode ? "#1E2128" : `${colors.softBlue}25`,
                }}
              >
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 16,
                    backgroundColor: isDarkMode ? "#161921" : colors.white,
                  }}
                  onPress={() => setCompanySizeExpanded(!companySizeExpanded)}
                  activeOpacity={0.8}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                      flex: 1,
                    }}
                  >
                    <View
                      style={{
                        width: 38,
                        height: 38,
                        borderRadius: 10,
                        backgroundColor: isDarkMode
                          ? colors.softBlue + "22"
                          : colors.softBlue + "20",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        name="people"
                        size={20}
                        color={isDarkMode ? colors.softBlue : colors.softBlue}
                      />
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 15,
                          fontWeight: "700",
                          color: isDarkMode ? "#E8EDF5" : colors.deepNavy,
                          fontFamily: fonts.bold,
                        }}
                      >
                        Company Size
                      </Text>
                      {selectedCompanySize && (
                        <Text
                          style={{
                            fontSize: 12,
                            color: isDarkMode
                              ? colors.softBlue
                              : colors.warmGray,
                            marginTop: 2,
                          }}
                          numberOfLines={1}
                        >
                          {selectedCompanySize} employees
                        </Text>
                      )}
                    </View>
                    {selectedCompanySize && (
                      <View
                        style={{
                          backgroundColor: colors.softBlue,
                          paddingHorizontal: 8,
                          paddingVertical: 4,
                          borderRadius: 8,
                          minWidth: 24,
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={{
                            color: colors.white,
                            fontSize: 11,
                            fontWeight: "800",
                            fontFamily: fonts.bold,
                          }}
                        >
                          1
                        </Text>
                      </View>
                    )}
                  </View>
                  <Icon
                    name={companySizeExpanded ? "expand-less" : "expand-more"}
                    size={24}
                    color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                  />
                </TouchableOpacity>
                {companySizeExpanded && (
                  <View
                    style={{
                      padding: 12,
                      gap: 8,
                      backgroundColor: isDarkMode ? "#0D0F12" : "#FAFAFA",
                    }}
                  >
                    {[
                      { label: "1-10 employees", value: "1-10" },
                      { label: "11-50 employees", value: "11-50" },
                      { label: "51-200 employees", value: "51-200" },
                      { label: "201-500 employees", value: "201-500" },
                      { label: "501-1000 employees", value: "501-1000" },
                      { label: "1000+ employees", value: "1000+" },
                    ].map((size) => (
                      <TouchableOpacity
                        key={size.value}
                        style={{
                          backgroundColor:
                            selectedCompanySize === size.value
                              ? isDarkMode
                                ? colors.softBlue
                                : colors.softBlue
                              : isDarkMode
                              ? "#161921"
                              : colors.white,
                          borderRadius: 12,
                          padding: 14,
                          marginBottom: 8,
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderWidth: 1,
                          borderColor:
                            selectedCompanySize === size.value
                              ? isDarkMode
                                ? colors.softBlue
                                : colors.softBlue
                              : isDarkMode
                              ? "#1E2128"
                              : "#E8E8E8",
                        }}
                        onPress={() =>
                          setSelectedCompanySize(
                            selectedCompanySize === size.value
                              ? ""
                              : size.value,
                          )
                        }
                        activeOpacity={0.7}
                      >
                        <Text
                          style={{
                            fontSize: 14,
                            fontWeight:
                              selectedCompanySize === size.value
                                ? "700"
                                : "500",
                            color:
                              selectedCompanySize === size.value
                                ? colors.white
                                : isDarkMode
                                ? "#E8EDF5"
                                : colors.deepNavy,
                            flex: 1,
                            fontFamily:
                              selectedCompanySize === size.value
                                ? fonts.bold
                                : fonts.regular,
                          }}
                        >
                          {size.label}
                        </Text>
                        {selectedCompanySize === size.value && (
                          <View
                            style={{
                              width: 22,
                              height: 22,
                              borderRadius: 11,
                              backgroundColor: colors.white,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              name="check"
                              size={14}
                              color={colors.softBlue}
                            />
                          </View>
                        )}
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>

              {/* Sector Filter - Premium Card Style */}
              <View
                style={{
                  backgroundColor: isDarkMode
                    ? "#12151A"
                    : `${colors.honeyGold}08`,
                  borderRadius: 16,
                  overflow: "hidden",
                  marginBottom: 16,
                  borderWidth: 1,
                  borderColor: isDarkMode ? "#1E2128" : `${colors.honeyGold}25`,
                }}
              >
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 16,
                    backgroundColor: isDarkMode ? "#161921" : colors.white,
                  }}
                  onPress={() => setSectorExpanded(!sectorExpanded)}
                  activeOpacity={0.8}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                      flex: 1,
                    }}
                  >
                    <View
                      style={{
                        width: 38,
                        height: 38,
                        borderRadius: 10,
                        backgroundColor: isDarkMode
                          ? colors.honeyGold + "22"
                          : colors.honeyGold + "20",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        name="business-center"
                        size={20}
                        color={isDarkMode ? colors.honeyGold : colors.honeyGold}
                      />
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 15,
                          fontWeight: "700",
                          color: isDarkMode ? "#E8EDF5" : colors.deepNavy,
                          fontFamily: fonts.bold,
                        }}
                      >
                        Sector
                      </Text>
                      {selectedSector && (
                        <Text
                          style={{
                            fontSize: 12,
                            color: isDarkMode
                              ? colors.honeyGold
                              : colors.warmGray,
                            marginTop: 2,
                          }}
                          numberOfLines={1}
                        >
                          {selectedSector}
                        </Text>
                      )}
                    </View>
                    {selectedSector && (
                      <View
                        style={{
                          backgroundColor: colors.honeyGold,
                          paddingHorizontal: 8,
                          paddingVertical: 4,
                          borderRadius: 8,
                          minWidth: 24,
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={{
                            color: colors.white,
                            fontSize: 11,
                            fontWeight: "800",
                            fontFamily: fonts.bold,
                          }}
                        >
                          1
                        </Text>
                      </View>
                    )}
                  </View>
                  <Icon
                    name={sectorExpanded ? "expand-less" : "expand-more"}
                    size={24}
                    color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                  />
                </TouchableOpacity>
                {sectorExpanded && (
                  <View
                    style={{
                      padding: 12,
                      gap: 8,
                      backgroundColor: isDarkMode ? "#0D0F12" : "#FAFAFA",
                    }}
                  >
                    <ScrollView
                      style={{ maxHeight: 280 }}
                      showsVerticalScrollIndicator={false}
                    >
                      {sectors.map((sector) => (
                        <TouchableOpacity
                          key={sector}
                          style={{
                            backgroundColor:
                              selectedSector === sector
                                ? isDarkMode
                                  ? colors.honeyGold
                                  : colors.honeyGold
                                : isDarkMode
                                ? "#161921"
                                : colors.white,
                            borderRadius: 12,
                            padding: 14,
                            marginBottom: 8,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            borderWidth: 1,
                            borderColor:
                              selectedSector === sector
                                ? isDarkMode
                                  ? colors.honeyGold
                                  : colors.honeyGold
                                : isDarkMode
                                ? "#1E2128"
                                : "#E8E8E8",
                          }}
                          onPress={() =>
                            setSelectedSector(
                              selectedSector === sector ? "" : sector,
                            )
                          }
                          activeOpacity={0.7}
                        >
                          <Text
                            style={{
                              fontSize: 14,
                              fontWeight:
                                selectedSector === sector ? "700" : "500",
                              color:
                                selectedSector === sector
                                  ? colors.white
                                  : isDarkMode
                                  ? "#E8EDF5"
                                  : colors.deepNavy,
                              flex: 1,
                              fontFamily:
                                selectedSector === sector
                                  ? fonts.bold
                                  : fonts.regular,
                            }}
                          >
                            {sector}
                          </Text>
                          {selectedSector === sector && (
                            <View
                              style={{
                                width: 22,
                                height: 22,
                                borderRadius: 11,
                                backgroundColor: colors.white,
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Icon
                                name="check"
                                size={14}
                                color={colors.honeyGold}
                              />
                            </View>
                          )}
                        </TouchableOpacity>
                      ))}
                    </ScrollView>
                  </View>
                )}
              </View>

              {/* Verification Status Filter - Premium Card Style */}
              <View
                style={{
                  backgroundColor: isDarkMode ? "#12151A" : `${colors.cream}95`,
                  borderRadius: 16,
                  overflow: "hidden",
                  marginBottom: 16,
                  borderWidth: 1,
                  borderColor: isDarkMode ? "#1E2128" : `${colors.lightGray}40`,
                }}
              >
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: 16,
                    backgroundColor: isDarkMode ? "#161921" : colors.white,
                  }}
                  onPress={() => setVerificationExpanded(!verificationExpanded)}
                  activeOpacity={0.8}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                      flex: 1,
                    }}
                  >
                    <View
                      style={{
                        width: 38,
                        height: 38,
                        borderRadius: 10,
                        backgroundColor: isDarkMode
                          ? colors.success + "22"
                          : colors.success + "20",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        name="verified"
                        size={20}
                        color={isDarkMode ? colors.success : colors.success}
                      />
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 15,
                          fontWeight: "700",
                          color: isDarkMode ? "#E8EDF5" : colors.deepNavy,
                          fontFamily: fonts.bold,
                        }}
                      >
                        Verification
                      </Text>
                      {selectedVerification && (
                        <Text
                          style={{
                            fontSize: 12,
                            color: isDarkMode
                              ? colors.success
                              : colors.warmGray,
                            marginTop: 2,
                          }}
                          numberOfLines={1}
                        >
                          {selectedVerification === "approved"
                            ? "Verified"
                            : selectedVerification === "telegram"
                            ? "From Telegram"
                            : "Pending"}
                        </Text>
                      )}
                    </View>
                    {selectedVerification && (
                      <View
                        style={{
                          backgroundColor: colors.success,
                          paddingHorizontal: 8,
                          paddingVertical: 4,
                          borderRadius: 8,
                          minWidth: 24,
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={{
                            color: colors.white,
                            fontSize: 11,
                            fontWeight: "800",
                            fontFamily: fonts.bold,
                          }}
                        >
                          1
                        </Text>
                      </View>
                    )}
                  </View>
                  <Icon
                    name={verificationExpanded ? "expand-less" : "expand-more"}
                    size={24}
                    color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                  />
                </TouchableOpacity>
                {verificationExpanded && (
                  <View
                    style={{
                      padding: 12,
                      gap: 8,
                      backgroundColor: isDarkMode ? "#0D0F12" : "#FAFAFA",
                    }}
                  >
                    {[
                      {
                        label: "Verified",
                        value: "approved",
                        icon: "verified",
                        color: colors.success,
                      },
                      {
                        label: "From Telegram",
                        value: "telegram",
                        icon: "send",
                        color: colors.softBlue,
                      },
                    ].map((status) => (
                      <TouchableOpacity
                        key={status.value}
                        style={{
                          backgroundColor:
                            selectedVerification === status.value
                              ? isDarkMode
                                ? status.color
                                : status.color
                              : isDarkMode
                              ? "#161921"
                              : colors.white,
                          borderRadius: 12,
                          padding: 14,
                          marginBottom: 8,
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderWidth: 1,
                          borderColor:
                            selectedVerification === status.value
                              ? isDarkMode
                                ? status.color
                                : status.color
                              : isDarkMode
                              ? "#1E2128"
                              : "#E8E8E8",
                        }}
                        onPress={() =>
                          setSelectedVerification(
                            selectedVerification === status.value
                              ? ""
                              : status.value,
                          )
                        }
                        activeOpacity={0.7}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 10,
                            flex: 1,
                          }}
                        >
                          <View
                            style={{
                              width: 32,
                              height: 32,
                              borderRadius: 8,
                              backgroundColor:
                                selectedVerification === status.value
                                  ? "rgba(255, 255, 255, 0.2)"
                                  : isDarkMode
                                  ? "#1E2128"
                                  : `${status.color}15`,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Icon
                              name={status.icon}
                              size={18}
                              color={
                                selectedVerification === status.value
                                  ? colors.white
                                  : status.color
                              }
                            />
                          </View>
                          <Text
                            style={{
                              fontSize: 14,
                              fontWeight:
                                selectedVerification === status.value
                                  ? "700"
                                  : "500",
                              color:
                                selectedVerification === status.value
                                  ? colors.white
                                  : isDarkMode
                                  ? "#E8EDF5"
                                  : colors.deepNavy,
                              fontFamily:
                                selectedVerification === status.value
                                  ? fonts.bold
                                  : fonts.regular,
                            }}
                          >
                            {status.label}
                          </Text>
                        </View>
                        {selectedVerification === status.value && (
                          <View
                            style={{
                              width: 22,
                              height: 22,
                              borderRadius: 11,
                              backgroundColor: colors.white,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Icon name="check" size={14} color={status.color} />
                          </View>
                        )}
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>
            </View>
          )}

          {/* Companies Grid */}
          <View style={styles.jobsGridSection}>
            {/* Results Header with Sorting - desktop only */}
            {!isMobile && (
              <View style={styles.resultsHeader}>
                <View style={styles.resultsLeftSection}>
                  {(selectedIndustry ||
                    selectedSector ||
                    selectedVerification ||
                    selectedLocation ||
                    selectedCompanySize) && (
                    <View style={styles.activeFiltersRow}>
                      {selectedIndustry && (
                        <View
                          style={[
                            styles.activeFilterChip,
                            {
                              backgroundColor: `${colors.beeYellow}20`,
                              borderColor: colors.beeYellow,
                              borderWidth: 1,
                            },
                          ]}
                        >
                          <Icon name="work" size={14} color={colors.deepNavy} />
                          <Text
                            style={[
                              styles.activeFilterText,
                              { color: colors.deepNavy },
                            ]}
                          >
                            {selectedIndustry}
                          </Text>
                          <TouchableOpacity
                            onPress={() => setSelectedIndustry("")}
                          >
                            <Icon
                              name="close"
                              size={14}
                              color={colors.deepNavy}
                            />
                          </TouchableOpacity>
                        </View>
                      )}
                      {selectedLocation && (
                        <View
                          style={[
                            styles.activeFilterChip,
                            {
                              backgroundColor: `${colors.success}20`,
                              borderColor: colors.success,
                              borderWidth: 1,
                            },
                          ]}
                        >
                          <Icon
                            name="location-on"
                            size={14}
                            color={colors.deepNavy}
                          />
                          <Text
                            style={[
                              styles.activeFilterText,
                              { color: colors.deepNavy },
                            ]}
                          >
                            {selectedLocation}
                          </Text>
                          <TouchableOpacity
                            onPress={() => setSelectedLocation("")}
                          >
                            <Icon
                              name="close"
                              size={14}
                              color={colors.deepNavy}
                            />
                          </TouchableOpacity>
                        </View>
                      )}
                      {selectedCompanySize && (
                        <View
                          style={[
                            styles.activeFilterChip,
                            {
                              backgroundColor: `${colors.softBlue}20`,
                              borderColor: colors.softBlue,
                              borderWidth: 1,
                            },
                          ]}
                        >
                          <Icon
                            name="people"
                            size={14}
                            color={colors.deepNavy}
                          />
                          <Text
                            style={[
                              styles.activeFilterText,
                              { color: colors.deepNavy },
                            ]}
                          >
                            {selectedCompanySize}
                          </Text>
                          <TouchableOpacity
                            onPress={() => setSelectedCompanySize("")}
                          >
                            <Icon
                              name="close"
                              size={14}
                              color={colors.deepNavy}
                            />
                          </TouchableOpacity>
                        </View>
                      )}
                      {selectedSector && (
                        <View
                          style={[
                            styles.activeFilterChip,
                            {
                              backgroundColor: `${colors.honeyGold}20`,
                              borderColor: colors.honeyGold,
                              borderWidth: 1,
                            },
                          ]}
                        >
                          <Icon
                            name="business-center"
                            size={14}
                            color={colors.deepNavy}
                          />
                          <Text
                            style={[
                              styles.activeFilterText,
                              { color: colors.deepNavy },
                            ]}
                          >
                            {selectedSector}
                          </Text>
                          <TouchableOpacity
                            onPress={() => setSelectedSector("")}
                          >
                            <Icon
                              name="close"
                              size={14}
                              color={colors.deepNavy}
                            />
                          </TouchableOpacity>
                        </View>
                      )}
                      {selectedVerification && (
                        <View
                          style={[
                            styles.activeFilterChip,
                            {
                              backgroundColor: `${colors.deepNavy}15`,
                              borderColor: colors.deepNavy,
                              borderWidth: 1,
                            },
                          ]}
                        >
                          <Icon
                            name="verified"
                            size={14}
                            color={colors.deepNavy}
                          />
                          <Text
                            style={[
                              styles.activeFilterText,
                              { color: colors.deepNavy },
                            ]}
                          >
                            {selectedVerification === "approved"
                              ? "Verified"
                              : selectedVerification === "telegram"
                              ? "From Telegram"
                              : "Pending"}
                          </Text>
                          <TouchableOpacity
                            onPress={() => setSelectedVerification("")}
                          >
                            <Icon
                              name="close"
                              size={14}
                              color={colors.deepNavy}
                            />
                          </TouchableOpacity>
                        </View>
                      )}
                    </View>
                  )}
                </View>
                {!isMobile && (
                  <View style={styles.resultsRightSection}>
                    <View style={styles.sortContainer}>
                      <Icon name="sort" size={18} color={colors.warmGray} />
                      <Text
                        style={[styles.sortLabel, { color: colors.warmGray }]}
                      >
                        {t.sortBy}
                      </Text>
                      <TouchableOpacity style={styles.sortButton}>
                        <Text
                          style={[
                            styles.sortButtonText,
                            { color: isDarkMode ? "#000000" : colors.deepNavy },
                          ]}
                        >
                          Most Recent
                        </Text>
                        <Icon
                          name="arrow-drop-down"
                          size={20}
                          color={isDarkMode ? "#000000" : colors.deepNavy}
                        />
                      </TouchableOpacity>
                    </View>
                    <View style={styles.viewToggle}>
                      <TouchableOpacity
                        style={[
                          styles.viewToggleButton,
                          {
                            backgroundColor:
                              viewMode === "grid"
                                ? colors.deepNavy
                                : colors.cream,
                          },
                        ]}
                        onPress={() => setViewMode("grid")}
                      >
                        <Icon
                          name="grid-view"
                          size={18}
                          color={
                            viewMode === "grid" ? colors.white : colors.deepNavy
                          }
                        />
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={[
                          styles.viewToggleButton,
                          {
                            backgroundColor:
                              viewMode === "list"
                                ? colors.deepNavy
                                : colors.cream,
                          },
                        ]}
                        onPress={() => setViewMode("list")}
                      >
                        <Icon
                          name="view-list"
                          size={18}
                          color={
                            viewMode === "list" ? colors.white : colors.deepNavy
                          }
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                )}
              </View>
            )}

            {loading ? (
              isMobile ? (
                // ── Mobile skeleton rows matching the company list style ──
                <View
                  style={{
                    borderTopWidth: 1,
                    borderTopColor: isDarkMode ? "#1E2028" : "#F0F1F5",
                  }}
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => {
                    const shimmer = isDarkMode ? "#1E2230" : "#F0F1F5";
                    const shimmerDark = isDarkMode ? "#252935" : "#E5E7EC";
                    return (
                      <View
                        key={i}
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          backgroundColor: isDarkMode ? "#13161C" : "#FFFFFF",
                          paddingHorizontal: 16,
                          paddingVertical: 14,
                          borderBottomWidth: 1,
                          borderBottomColor: isDarkMode ? "#1E2028" : "#F0F1F5",
                        }}
                      >
                        {/* Circular logo */}
                        <View
                          style={{
                            width: 50,
                            height: 50,
                            borderRadius: 25,
                            backgroundColor: shimmer,
                            flexShrink: 0,
                          }}
                        />
                        {/* Text lines */}
                        <View style={{ flex: 1, marginLeft: 13, gap: 8 }}>
                          <View
                            style={{
                              height: 14,
                              width: `${55 + (i % 3) * 10}%`,
                              borderRadius: 6,
                              backgroundColor: shimmer,
                            }}
                          />
                          <View
                            style={{
                              height: 11,
                              width: `${35 + (i % 4) * 8}%`,
                              borderRadius: 6,
                              backgroundColor: shimmerDark,
                            }}
                          />
                        </View>
                        {/* Jobs pill */}
                        <View
                          style={{
                            width: 52,
                            height: 26,
                            borderRadius: 20,
                            backgroundColor: shimmerDark,
                            marginLeft: 10,
                          }}
                        />
                      </View>
                    );
                  })}
                </View>
              ) : (
                <View style={styles.modernLoadingContainer}>
                  <View
                    style={[
                      styles.loadingIconCircle,
                      { backgroundColor: `${colors.softBlue}20` },
                    ]}
                  >
                    <Icon name="business" size={48} color={colors.softBlue} />
                  </View>
                  <Text
                    style={[
                      styles.loadingTitle,
                      { color: isDarkMode ? colors.white : colors.deepNavy },
                    ]}
                  >
                    Loading Companies
                  </Text>
                  <Text
                    style={[styles.loadingSubtitle, { color: colors.warmGray }]}
                  >
                    Please wait...
                  </Text>
                </View>
              )
            ) : companies.length === 0 ? (
              <View style={styles.modernEmptyState}>
                <View
                  style={[
                    styles.emptyStateIcon,
                    { backgroundColor: colors.cream },
                  ]}
                >
                  <Icon
                    name="business-center"
                    size={48}
                    color={colors.warmGray}
                  />
                </View>
                <Text
                  style={[styles.emptyStateTitle, { color: colors.deepNavy }]}
                >
                  No companies found
                </Text>
                <Text
                  style={[
                    styles.emptyStateDescription,
                    { color: colors.warmGray },
                  ]}
                >
                  Try adjusting your filters or search terms to find more
                  companies
                </Text>
                <TouchableOpacity
                  style={[
                    styles.emptyStateButton,
                    { backgroundColor: colors.deepNavy },
                  ]}
                  onPress={() => {
                    setSearchText("");
                    setSelectedIndustry("");
                    setSelectedVerification("");
                  }}
                >
                  <Text
                    style={[
                      styles.emptyStateButtonText,
                      { color: colors.white },
                    ]}
                  >
                    Clear all filters
                  </Text>
                </TouchableOpacity>
              </View>
            ) : (
              <View
                style={
                  isMobile
                    ? {
                        borderTopWidth: 1,
                        borderTopColor: isDarkMode ? "#1E2028" : "#F0F1F5",
                      }
                    : {}
                }
              >
                <AdBanner variant="feed" />
                <FlatList
                  data={companies}
                  renderItem={renderCompanyCard}
                  keyExtractor={(item) => item.id}
                  numColumns={isMobile ? 1 : viewMode === "grid" ? 2 : 1}
                  key={isMobile ? "mobile-list" : viewMode}
                  showsVerticalScrollIndicator={false}
                  contentContainerStyle={
                    isMobile ? { paddingBottom: 20 } : styles.modernJobsGrid
                  }
                  scrollEnabled={false}
                  columnWrapperStyle={
                    !isMobile && viewMode === "grid"
                      ? styles.modernJobsRow
                      : undefined
                  }
                  ListFooterComponent={<AdBanner variant="feed" />}
                />

                <AdBanner variant="feed" />

                {/* Modern Pagination */}
                {filteredCompanies.length > companiesPerPage && (
                  <View
                    style={[
                      styles.modernPagination,
                      { backgroundColor: colors.white },
                    ]}
                  >
                    <TouchableOpacity
                      style={[
                        styles.modernPaginationButton,
                        { borderColor: colors.lightGray },
                        !hasPrevPage && styles.modernPaginationButtonDisabled,
                      ]}
                      onPress={() => handlePageChange(currentPage - 1)}
                      disabled={!hasPrevPage}
                    >
                      <Icon
                        name="chevron-left"
                        size={20}
                        color={!hasPrevPage ? colors.warmGray : colors.deepNavy}
                      />
                      <Text
                        style={[
                          styles.modernPaginationButtonText,
                          {
                            color: !hasPrevPage
                              ? colors.warmGray
                              : colors.deepNavy,
                          },
                        ]}
                      >
                        Previous
                      </Text>
                    </TouchableOpacity>

                    <View style={styles.modernPaginationNumbers}>
                      <Text
                        style={[
                          styles.modernPageNumberText,
                          { color: colors.deepNavy, fontWeight: "600" },
                        ]}
                      >
                        Page {currentPage} of {totalPages}
                      </Text>
                      <Text
                        style={[
                          styles.modernPaginationInfo,
                          { color: colors.warmGray, fontSize: 12 },
                        ]}
                      >
                        Showing {startIndex + 1}-
                        {Math.min(endIndex, filteredCompanies.length)} of{" "}
                        {filteredCompanies.length} companies
                      </Text>
                    </View>

                    <TouchableOpacity
                      style={[
                        styles.modernPaginationButton,
                        { borderColor: colors.lightGray },
                        !hasNextPage && styles.modernPaginationButtonDisabled,
                      ]}
                      onPress={() => handlePageChange(currentPage + 1)}
                      disabled={!hasNextPage}
                    >
                      <Text
                        style={[
                          styles.modernPaginationButtonText,
                          {
                            color: !hasNextPage
                              ? colors.warmGray
                              : colors.deepNavy,
                          },
                        ]}
                      >
                        Next
                      </Text>
                      <Icon
                        name="chevron-right"
                        size={20}
                        color={!hasNextPage ? colors.warmGray : colors.deepNavy}
                      />
                    </TouchableOpacity>
                  </View>
                )}
              </View>
            )}
          </View>
        </View>
      </ScrollView>

      {/* Mobile Navigation Menu - Using Shared Drawer Component */}
      <MobileDrawer
        visible={isMobile && showMobileMenu}
        onClose={() => setShowMobileMenu(false)}
        navigation={navigation}
        user={user}
        userData={userData}
        isDarkMode={isDarkMode}
        toggleTheme={toggleTheme}
        currentView="candidate"
        currentLanguage={currentLanguage}
      />

      {/* Mobile Filters Modal */}
      {isMobile && showMobileFilters && (
        <Modal
          visible={showMobileFilters}
          animationType="slide"
          transparent={false}
          onRequestClose={() => setShowMobileFilters(false)}
        >
          <View
            style={[
              styles.mobileFiltersModal,
              { backgroundColor: isDarkMode ? "#0A0C0F" : colors.background },
            ]}
          >
            <View
              style={[
                styles.mobileFiltersHeader,
                {
                  backgroundColor: isDarkMode ? "#0F1114" : colors.white,
                  borderBottomColor: isDarkMode ? "#2C2F36" : colors.lightGray,
                },
              ]}
            >
              <TouchableOpacity onPress={() => setShowMobileFilters(false)}>
                <Icon
                  name="close"
                  size={24}
                  color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                />
              </TouchableOpacity>
              <Text
                style={[
                  styles.mobileFiltersTitle,
                  { color: isDarkMode ? "#E2E8F0" : colors.deepNavy },
                ]}
              >
                Filters
              </Text>
              <TouchableOpacity
                onPress={() => {
                  setSelectedIndustry("");
                  setSelectedSector("");
                  setSelectedVerification("");
                  setSelectedLocation("");
                  setSelectedCompanySize("");
                }}
              >
                <Text
                  style={[
                    styles.mobileFiltersClear,
                    { color: isDarkMode ? colors.beeYellow : colors.deepNavy },
                  ]}
                >
                  Clear All
                </Text>
              </TouchableOpacity>
            </View>

            <ScrollView
              style={styles.mobileFiltersContent}
              showsVerticalScrollIndicator={false}
            >
              {/* Industry Filter */}
              <View
                style={[
                  styles.filterGroup,
                  {
                    backgroundColor: isDarkMode
                      ? "#0F1114"
                      : `${colors.beeYellow}08`,
                    borderColor: isDarkMode
                      ? "#2C2F36"
                      : `${colors.lightGray}60`,
                  },
                ]}
              >
                <TouchableOpacity
                  style={styles.filterGroupHeader}
                  onPress={() => setIndustryExpanded(!industryExpanded)}
                >
                  <View style={styles.filterGroupTitleContainer}>
                    <View
                      style={[
                        styles.filterGroupIconCircle,
                        {
                          backgroundColor: isDarkMode
                            ? "#1A1D23"
                            : `${colors.beeYellow}20`,
                        },
                      ]}
                    >
                      <Icon
                        name="work"
                        size={18}
                        color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                      />
                    </View>
                    <Text
                      style={[
                        styles.filterGroupTitle,
                        { color: isDarkMode ? "#E2E8F0" : colors.deepNavy },
                      ]}
                    >
                      Industry
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.expandIconCircle,
                      {
                        backgroundColor: isDarkMode
                          ? "#1A1D23"
                          : colors.lightGray,
                      },
                    ]}
                  >
                    <Icon
                      name={industryExpanded ? "expand-less" : "expand-more"}
                      size={20}
                      color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                    />
                  </View>
                </TouchableOpacity>
                {industryExpanded && (
                  <View
                    style={[
                      styles.filterOptions,
                      {
                        backgroundColor: isDarkMode ? "#0F1114" : "transparent",
                      },
                    ]}
                  >
                    {industries.map((industry) => (
                      <TouchableOpacity
                        key={industry}
                        style={[
                          styles.filterOption,
                          {
                            backgroundColor: isDarkMode
                              ? "#1A1D23"
                              : colors.white,
                            borderColor: isDarkMode ? "#2C2F36" : "#E5E7EB",
                            borderWidth: 1,
                          },
                          selectedIndustry === industry && [
                            styles.filterOptionActive,
                            {
                              backgroundColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                              borderColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                            },
                          ],
                        ]}
                        onPress={() =>
                          setSelectedIndustry(
                            selectedIndustry === industry ? "" : industry,
                          )
                        }
                        activeOpacity={0.7}
                      >
                        <Text
                          style={[
                            styles.filterOptionText,
                            { color: isDarkMode ? "#E2E8F0" : colors.deepNavy },
                            selectedIndustry === industry && {
                              color: isDarkMode
                                ? colors.buttonTextOnYellow
                                : colors.white,
                              fontFamily: fonts.bold,
                            },
                          ]}
                        >
                          {industry}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>

              {/* Location Filter */}
              <View
                style={[
                  styles.filterGroup,
                  {
                    backgroundColor: isDarkMode
                      ? "#0F1114"
                      : `${colors.success}08`,
                    borderColor: isDarkMode
                      ? "#2C2F36"
                      : `${colors.lightGray}60`,
                  },
                ]}
              >
                <TouchableOpacity
                  style={styles.filterGroupHeader}
                  onPress={() => setLocationExpanded(!locationExpanded)}
                >
                  <View style={styles.filterGroupTitleContainer}>
                    <View
                      style={[
                        styles.filterGroupIconCircle,
                        {
                          backgroundColor: isDarkMode
                            ? "#1A1D23"
                            : `${colors.success}20`,
                        },
                      ]}
                    >
                      <Icon
                        name="location-on"
                        size={18}
                        color={isDarkMode ? colors.beeYellow : colors.success}
                      />
                    </View>
                    <Text
                      style={[
                        styles.filterGroupTitle,
                        { color: isDarkMode ? "#E2E8F0" : colors.deepNavy },
                      ]}
                    >
                      Location
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.expandIconCircle,
                      {
                        backgroundColor: isDarkMode
                          ? "#1A1D23"
                          : colors.lightGray,
                      },
                    ]}
                  >
                    <Icon
                      name={locationExpanded ? "expand-less" : "expand-more"}
                      size={20}
                      color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                    />
                  </View>
                </TouchableOpacity>
                {locationExpanded && (
                  <View
                    style={[
                      styles.filterOptions,
                      {
                        backgroundColor: isDarkMode ? "#0F1114" : "transparent",
                        maxHeight: 200,
                      },
                    ]}
                  >
                    <ScrollView showsVerticalScrollIndicator={false}>
                      {locations.map((location) => (
                        <TouchableOpacity
                          key={location}
                          style={[
                            styles.filterOption,
                            {
                              backgroundColor: isDarkMode
                                ? "#1A1D23"
                                : colors.white,
                              borderColor: isDarkMode ? "#2C2F36" : "#E5E7EB",
                              borderWidth: 1,
                            },
                            selectedLocation === location && [
                              styles.filterOptionActive,
                              {
                                backgroundColor: isDarkMode
                                  ? colors.beeYellow
                                  : colors.success,
                                borderColor: isDarkMode
                                  ? colors.beeYellow
                                  : colors.success,
                              },
                            ],
                          ]}
                          onPress={() =>
                            setSelectedLocation(
                              selectedLocation === location ? "" : location,
                            )
                          }
                          activeOpacity={0.7}
                        >
                          <Text
                            style={[
                              styles.filterOptionText,
                              {
                                color: isDarkMode ? "#E2E8F0" : colors.deepNavy,
                              },
                              selectedLocation === location && {
                                color: isDarkMode
                                  ? colors.buttonTextOnYellow
                                  : colors.white,
                                fontFamily: fonts.bold,
                              },
                            ]}
                          >
                            {location}
                          </Text>
                        </TouchableOpacity>
                      ))}
                    </ScrollView>
                  </View>
                )}
              </View>

              {/* Company Size Filter */}
              <View
                style={[
                  styles.filterGroup,
                  {
                    backgroundColor: isDarkMode
                      ? "#0F1114"
                      : `${colors.softBlue}08`,
                    borderColor: isDarkMode
                      ? "#2C2F36"
                      : `${colors.lightGray}60`,
                  },
                ]}
              >
                <TouchableOpacity
                  style={styles.filterGroupHeader}
                  onPress={() => setCompanySizeExpanded(!companySizeExpanded)}
                >
                  <View style={styles.filterGroupTitleContainer}>
                    <View
                      style={[
                        styles.filterGroupIconCircle,
                        {
                          backgroundColor: isDarkMode
                            ? "#1A1D23"
                            : `${colors.softBlue}20`,
                        },
                      ]}
                    >
                      <Icon
                        name="people"
                        size={18}
                        color={isDarkMode ? colors.beeYellow : colors.softBlue}
                      />
                    </View>
                    <Text
                      style={[
                        styles.filterGroupTitle,
                        { color: isDarkMode ? "#E2E8F0" : colors.deepNavy },
                      ]}
                    >
                      Company Size
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.expandIconCircle,
                      {
                        backgroundColor: isDarkMode
                          ? "#1A1D23"
                          : colors.lightGray,
                      },
                    ]}
                  >
                    <Icon
                      name={companySizeExpanded ? "expand-less" : "expand-more"}
                      size={20}
                      color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                    />
                  </View>
                </TouchableOpacity>
                {companySizeExpanded && (
                  <View
                    style={[
                      styles.filterOptions,
                      {
                        backgroundColor: isDarkMode ? "#0F1114" : "transparent",
                      },
                    ]}
                  >
                    {[
                      { label: "1-10 employees", value: "1-10" },
                      { label: "11-50 employees", value: "11-50" },
                      { label: "51-200 employees", value: "51-200" },
                      { label: "201-500 employees", value: "201-500" },
                      { label: "501-1000 employees", value: "501-1000" },
                      { label: "1000+ employees", value: "1000+" },
                    ].map((size) => (
                      <TouchableOpacity
                        key={size.value}
                        style={[
                          styles.filterOption,
                          {
                            backgroundColor: isDarkMode
                              ? "#1A1D23"
                              : colors.white,
                            borderColor: isDarkMode ? "#2C2F36" : "#E5E7EB",
                            borderWidth: 1,
                          },
                          selectedCompanySize === size.value && [
                            styles.filterOptionActive,
                            {
                              backgroundColor: isDarkMode
                                ? colors.beeYellow
                                : colors.softBlue,
                              borderColor: isDarkMode
                                ? colors.beeYellow
                                : colors.softBlue,
                            },
                          ],
                        ]}
                        onPress={() =>
                          setSelectedCompanySize(
                            selectedCompanySize === size.value
                              ? ""
                              : size.value,
                          )
                        }
                        activeOpacity={0.7}
                      >
                        <Text
                          style={[
                            styles.filterOptionText,
                            { color: isDarkMode ? "#E2E8F0" : colors.deepNavy },
                            selectedCompanySize === size.value && {
                              color: isDarkMode
                                ? colors.buttonTextOnYellow
                                : colors.white,
                              fontFamily: fonts.bold,
                            },
                          ]}
                        >
                          {size.label}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>

              {/* Sector Filter */}
              <View
                style={[
                  styles.filterGroup,
                  {
                    backgroundColor: isDarkMode
                      ? "#0F1114"
                      : `${colors.honeyGold}08`,
                    borderColor: isDarkMode
                      ? "#2C2F36"
                      : `${colors.lightGray}60`,
                  },
                ]}
              >
                <TouchableOpacity
                  style={styles.filterGroupHeader}
                  onPress={() => setSectorExpanded(!sectorExpanded)}
                >
                  <View style={styles.filterGroupTitleContainer}>
                    <View
                      style={[
                        styles.filterGroupIconCircle,
                        {
                          backgroundColor: isDarkMode
                            ? "#1A1D23"
                            : `${colors.honeyGold}20`,
                        },
                      ]}
                    >
                      <Icon
                        name="business-center"
                        size={18}
                        color={isDarkMode ? colors.beeYellow : colors.honeyGold}
                      />
                    </View>
                    <Text
                      style={[
                        styles.filterGroupTitle,
                        { color: isDarkMode ? "#E2E8F0" : colors.deepNavy },
                      ]}
                    >
                      Sector
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.expandIconCircle,
                      {
                        backgroundColor: isDarkMode
                          ? "#1A1D23"
                          : colors.lightGray,
                      },
                    ]}
                  >
                    <Icon
                      name={sectorExpanded ? "expand-less" : "expand-more"}
                      size={20}
                      color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                    />
                  </View>
                </TouchableOpacity>
                {sectorExpanded && (
                  <View
                    style={[
                      styles.filterOptions,
                      {
                        backgroundColor: isDarkMode ? "#0F1114" : "transparent",
                      },
                    ]}
                  >
                    {sectors.map((sector) => (
                      <TouchableOpacity
                        key={sector}
                        style={[
                          styles.filterOption,
                          {
                            backgroundColor: isDarkMode
                              ? "#1A1D23"
                              : colors.white,
                            borderColor: isDarkMode ? "#2C2F36" : "#E5E7EB",
                            borderWidth: 1,
                          },
                          selectedSector === sector && [
                            styles.filterOptionActive,
                            {
                              backgroundColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                              borderColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                            },
                          ],
                        ]}
                        onPress={() =>
                          setSelectedSector(
                            selectedSector === sector ? "" : sector,
                          )
                        }
                        activeOpacity={0.7}
                      >
                        <Text
                          style={[
                            styles.filterOptionText,
                            { color: isDarkMode ? "#E2E8F0" : colors.deepNavy },
                            selectedSector === sector && {
                              color: colors.white,
                              fontFamily: fonts.bold,
                            },
                          ]}
                        >
                          {sector}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>

              {/* Verification Status Filter */}
              <View
                style={[
                  styles.filterGroup,
                  {
                    backgroundColor: isDarkMode
                      ? "#0F1114"
                      : `${colors.cream}80`,
                    borderColor: isDarkMode
                      ? "#2C2F36"
                      : `${colors.lightGray}60`,
                  },
                ]}
              >
                <TouchableOpacity
                  style={styles.filterGroupHeader}
                  onPress={() => setVerificationExpanded(!verificationExpanded)}
                >
                  <View style={styles.filterGroupTitleContainer}>
                    <View
                      style={[
                        styles.filterGroupIconCircle,
                        {
                          backgroundColor: isDarkMode
                            ? "#1A1D23"
                            : `${colors.success}20`,
                        },
                      ]}
                    >
                      <Icon
                        name="verified"
                        size={18}
                        color={isDarkMode ? colors.beeYellow : colors.success}
                      />
                    </View>
                    <Text
                      style={[
                        styles.filterGroupTitle,
                        { color: isDarkMode ? "#E2E8F0" : colors.deepNavy },
                      ]}
                    >
                      Verification Status
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.expandIconCircle,
                      {
                        backgroundColor: isDarkMode
                          ? "#1A1D23"
                          : colors.lightGray,
                      },
                    ]}
                  >
                    <Icon
                      name={
                        verificationExpanded ? "expand-less" : "expand-more"
                      }
                      size={20}
                      color={isDarkMode ? colors.beeYellow : colors.deepNavy}
                    />
                  </View>
                </TouchableOpacity>
                {verificationExpanded && (
                  <View
                    style={[
                      styles.filterOptions,
                      {
                        backgroundColor: isDarkMode ? "#0F1114" : "transparent",
                      },
                    ]}
                  >
                    {[
                      { label: "All Status", value: "", icon: "business" },
                      {
                        label: "Verified",
                        value: "approved",
                        icon: "verified",
                      },
                    ].map((status) => (
                      <TouchableOpacity
                        key={status.value}
                        style={[
                          styles.filterOption,
                          {
                            backgroundColor: isDarkMode
                              ? "#1A1D23"
                              : colors.white,
                            borderColor: isDarkMode ? "#2C2F36" : "#E5E7EB",
                            borderWidth: 1,
                          },
                          selectedVerification === status.value && [
                            styles.filterOptionActive,
                            {
                              backgroundColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                              borderColor: isDarkMode
                                ? colors.beeYellow
                                : colors.deepNavy,
                            },
                          ],
                        ]}
                        onPress={() =>
                          setSelectedVerification(
                            selectedVerification === status.value
                              ? ""
                              : status.value,
                          )
                        }
                        activeOpacity={0.7}
                      >
                        <Text
                          style={[
                            styles.filterOptionText,
                            { color: isDarkMode ? "#e2e8f0" : colors.deepNavy },
                            selectedVerification === status.value && {
                              color: colors.white,
                              fontFamily: fonts.bold,
                            },
                          ]}
                        >
                          {status.label}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>
            </ScrollView>

            <View
              style={[
                styles.mobileFiltersFooter,
                {
                  backgroundColor: isDarkMode ? "#0F1114" : colors.white,
                  borderTopColor: isDarkMode ? "#2C2F36" : colors.lightGray,
                },
              ]}
            >
              <TouchableOpacity
                style={[
                  styles.mobileFiltersApply,
                  {
                    backgroundColor: isDarkMode
                      ? colors.beeYellow
                      : colors.deepNavy,
                  },
                ]}
                onPress={() => setShowMobileFilters(false)}
              >
                <Text
                  style={[
                    styles.mobileFiltersApplyText,
                    { color: isDarkMode ? "#000000" : colors.white },
                  ]}
                >
                  Apply Filters ({filteredCompanies.length} results)
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </Modal>
      )}

      {/* Language dropdown overlay */}
      {showLanguageMenu && (
        <View style={styles.fullScreenDropdownOverlay}>
          <TouchableOpacity
            style={styles.fullScreenTouchArea}
            onPress={() => setShowLanguageMenu(false)}
            activeOpacity={1}
          />
          <View
            style={[
              styles.absoluteLanguageDropdown,
              { top: dropdownPosition.top, right: dropdownPosition.right },
            ]}
          >
            {languageOptions.map((language, index) => (
              <TouchableOpacity
                key={language.code}
                style={[
                  styles.languageOption,
                  currentLanguage === language.code &&
                    styles.languageOptionActive,
                  index === languageOptions.length - 1 && {
                    borderBottomWidth: 0,
                  },
                ]}
                onPress={() => changeLanguage(language.code)}
              >
                <Text style={styles.languageLabel}>{language.label}</Text>
                {currentLanguage === language.code && (
                  <Icon name="check" size={16} color={colors.beeYellow} />
                )}
              </TouchableOpacity>
            ))}
          </View>
        </View>
      )}

      {/* Bottom Navigation Bar */}
      <BottomNavBar
        navigation={navigation}
        activeRoute="Companies"
        isDarkMode={isDarkMode}
        user={user}
        userData={userData}
        currentLanguage={currentLanguage}
      />

      {/* FAB - Filter Companies (Mobile only) */}
      {isMobile && (
        <TouchableOpacity
          style={[
            styles.fab,
            {
              backgroundColor: isDarkMode ? colors.deepNavy : colors.beeYellow,
            },
          ]}
          onPress={() => setShowMobileFilters(true)}
          activeOpacity={0.8}
        >
          <Icon
            name="tune"
            size={24}
            color={isDarkMode ? colors.white : colors.deepNavy}
          />
        </TouchableOpacity>
      )}

      {/* Logout Confirmation Modal */}
      <LogoutConfirmationModal
        visible={showLogoutModal}
        onConfirm={handleLogout}
        onCancel={() => setShowLogoutModal(false)}
        isDarkMode={isDarkMode}
        currentLanguage={currentLanguage}
      />
    </SafeAreaView>
  );
}

// Company Details Screen - Shows company info and their jobs
function CompanyDetailsScreen({
  route,
  navigation,
  isDarkMode,
  toggleTheme,
  currentLanguage = "en",
  setCurrentLanguage,
}: any) {
  const { companyId } = route.params;
  const { showAlert: showAppAlert } = useAppAlert();
  const [company, setCompany] = useState<any>(null);
  const [companyJobs, setCompanyJobs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [companyLoading, setCompanyLoading] = useState(true);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const [activeTab, setActiveTab] = useState<"about" | "jobs">("jobs");
  const isMobile = dimensions.width < 768;

  // Toolbar states
  const [user, setUser] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const [bookmarkedJobs, setBookmarkedJobs] = useState<string[]>([]);
  const languageButtonRef = useRef<any>(null);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    right: 0,
  });

  const colors = isDarkMode ? darkColors : lightColors;
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const companyProfile = company?.companyProfile || {};

  const languageOptions = [
    { code: "en", label: "English" },
    { code: "am", label: "አማርኛ" },
    { code: "ti", label: "ትግርኛ" },
    { code: "or", label: "Afaan Oromoo" },
  ];

  const getCurrentLanguage = () => {
    return (
      languageOptions.find((lang) => lang.code === currentLanguage) ||
      languageOptions[0]
    );
  };

  const toggleLanguageDropdown = () => {
    if (!showLanguageMenu && languageButtonRef.current) {
      languageButtonRef.current.measureInWindow(
        (x: number, y: number, width: number, height: number) => {
          setDropdownPosition({
            top: y + height + 5,
            right:
              typeof window !== "undefined" ? window.innerWidth - x - width : 0,
          });
        },
      );
    }
    setShowLanguageMenu(!showLanguageMenu);
  };

  const changeLanguage = async (langCode: string) => {
    setCurrentLanguage(langCode);
    setSelectedLanguage(
      languageOptions.find((lang) => lang.code === langCode)?.label ||
        "English",
    );
    setShowLanguageMenu(false);
    try {
      await AsyncStorage.setItem("selectedLanguage", langCode);
    } catch (error) {
      console.error("Error saving language preference:", error);
    }
  };

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        const userDoc = await getDoc(doc(db, "users", firebaseUser.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          setUserData(data);
          setBookmarkedJobs(data.savedJobs || []);
        }
      } else {
        setUserData(null);
        setBookmarkedJobs([]);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    fetchCompanyData();
  }, [companyId]);

  useEffect(() => {
    if (company) {
      fetchCompanyJobs();
    }
  }, [company]);

  const fetchCompanyData = async () => {
    try {
      setCompanyLoading(true);

      // Check if it's a telegram company (starts with 'telegram_')
      if (companyId.startsWith("telegram_")) {
        // For telegram companies, we need to fetch from jobs and reconstruct
        const jobsCollection = collection(db, "jobs");
        const jobsQuery = dbQuery(
          jobsCollection,
          orderBy("postedDate", "desc"),
          limit(500),
        );
        const jobsSnapshot = await getDocs(jobsQuery);

        // Extract company from jobs
        const jobData = jobsSnapshot.docs.map((doc) => doc.data());

        // Find the company data from any job by matching the normalized ID
        for (const job of jobData) {
          const jobCompany = job.company || job.companyName;
          if (
            jobCompany &&
            typeof jobCompany === "string" &&
            jobCompany.trim()
          ) {
            const normalizedJobCompanyId = `telegram_${jobCompany
              .trim()
              .replace(/\s+/g, "_")
              .toLowerCase()}`;

            // Check if this job's company matches the requested companyId
            if (normalizedJobCompanyId === companyId) {
              // Reconstruct telegram company
              setCompany({
                id: companyId,
                role: "company",
                companyProfile: {
                  companyName: jobCompany.trim(),
                  verificationStatus: "telegram",
                  industry: job.industry || job.category || "Not specified",
                  sector: job.sector || "Not specified",
                  city: job.location || "Not specified",
                },
                source: "telegram",
                createdAt: job.postedDate || new Date(),
              });
              break;
            }
          }
        }
      } else {
        // For regular companies, fetch from users collection
        const companyDoc = await getDoc(doc(db, "users", companyId));
        // Only verified companies have a public page
        if (
          companyDoc.exists() &&
          companyDoc.data()?.companyProfile?.verificationStatus === "approved"
        ) {
          setCompany({ id: companyDoc.id, ...companyDoc.data() });
        }
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    } finally {
      setCompanyLoading(false);
    }
  };

  const companyDetailPermission = useSubscriptionPermissions(
    userData?.subscriptionPlan || userData?.subscriptionId,
  );
  const [upgradeModal, setUpgradeModal] = useState<{
    visible: boolean;
    featureLabel?: string;
  }>({ visible: false });

  const handleToggleBookmark = async (jobId: string) => {
    if (!user) {
      showAppAlert(
        "warning",
        "Authentication Required",
        "Please sign up to bookmark jobs.",
        { onClose: () => navigation.navigate("Signup") },
      );
      return;
    }

    if (!companyDetailPermission.hasPermission("canSaveJobs")) {
      setUpgradeModal({ visible: true, featureLabel: "Save / Bookmark Jobs" });
      return;
    }

    try {
      const userRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userRef);
      const currentBookmarks = userDoc.data()?.savedJobs || [];

      if (currentBookmarks.includes(jobId)) {
        // Remove bookmark
        await updateDoc(userRef, {
          savedJobs: currentBookmarks.filter((id: string) => id !== jobId),
        });
        setBookmarkedJobs(
          currentBookmarks.filter((id: string) => id !== jobId),
        );
      } else {
        // Add bookmark
        trackInteraction("job_save", jobId);
        await updateDoc(userRef, {
          savedJobs: [...currentBookmarks, jobId],
        });
        setBookmarkedJobs([...currentBookmarks, jobId]);
      }
    } catch (error) {
      console.error("Error toggling bookmark:", error);
      showAppAlert(
        "error",
        "Bookmark Error",
        "Failed to update bookmark. Please try again.",
      );
    }
  };

  const fetchCompanyJobs = async () => {
    try {
      setLoading(true);

      let jobs: any[] = [];

      // Check if this is a telegram company
      if (company.source === "telegram") {
        // For telegram companies, query by company name
        const companyName = company.companyProfile?.companyName;
        if (companyName) {
          // Fetch jobs matching the company name with proper query
          // Note: Since we can't query both 'company' and 'companyName' fields at once,
          // we'll fetch recent jobs and filter (but with a reasonable limit)
          const jobsCollection = collection(db, "jobs");
          const jobsQuery = dbQuery(
            jobsCollection,
            orderBy("postedDate", "desc"),
            limit(1000),
          );
          const jobsSnapshot = await getDocs(jobsQuery);

          // Filter jobs that match the company name
          jobs = jobsSnapshot.docs
            .map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }))
            .filter((job: any) => {
              const jobCompany = job.company || job.companyName;
              return jobCompany && jobCompany.trim() === companyName.trim();
            })
            .sort((a: any, b: any) => {
              // Sort by postedDate (newest first)
              const aDate = a.postedDate?.seconds || a.createdAt?.seconds || 0;
              const bDate = b.postedDate?.seconds || b.createdAt?.seconds || 0;
              return bDate - aDate;
            });
        }
      } else {
        // For regular companies, query by companyId
        const jobsQuery = query(
          collection(db, "jobs"),
          where("companyId", "==", companyId),
          orderBy("createdAt", "desc"),
        );

        const jobsSnapshot = await getDocs(jobsQuery);
        jobs = jobsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
      }

      setCompanyJobs(jobs);
    } catch (error) {
      console.error("Error fetching company jobs:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderJobCard = ({ item: job }: any) => {
    const isFeatured = job.featured === true;
    const isNew =
      job.createdAt &&
      Date.now() - job.createdAt.seconds * 1000 < 7 * 24 * 60 * 60 * 1000;
    const isTelegramJob = job.source === "telegram";

    // Format posted date
    const getPostedTime = () => {
      if (!job.createdAt && !job.postedDate) return "Recently";
      const date = job.createdAt
        ? new Date(job.createdAt.seconds * 1000)
        : new Date(job.postedDate.seconds * 1000);
      const now = new Date();
      const diffMs = now.getTime() - date.getTime();
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

      if (diffDays === 0) return "Today";
      if (diffDays === 1) return "Yesterday";
      if (diffDays < 7) return `${diffDays}d ago`;
      if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
      return date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });
    };

    return (
      <TouchableOpacity
        style={{
          backgroundColor: colors.white,
          borderRadius: 16,
          padding: 20,
          marginBottom: 12,
          borderWidth: 1,
          borderColor: isFeatured ? colors.beeYellow : `${colors.lightGray}30`,
          ...Platform.select({
            ios: {
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 2 },
              shadowOpacity: 0.08,
              shadowRadius: 8,
            },
            android: {
              elevation: 3,
            },
            web: {
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            },
          }),
        }}
        activeOpacity={0.7}
        onPress={() => navigation.navigate("JobDetails", { id: job.id })}
      >
        {/* Header: Title + Badges */}
        <View style={{ marginBottom: 16 }}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: 8,
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontWeight: "700",
                color: colors.deepNavy,
                flex: 1,
                marginRight: 12,
                lineHeight: 24,
              }}
              numberOfLines={2}
            >
              {job.title || "Job Title"}
            </Text>
            <TouchableOpacity
              style={{
                width: 36,
                height: 36,
                borderRadius: 18,
                backgroundColor: `${colors.beeYellow}15`,
                alignItems: "center",
                justifyContent: "center",
              }}
              onPress={(e) => {
                e.stopPropagation();
                handleToggleBookmark(job.id);
              }}
            >
              <Icon
                name={
                  bookmarkedJobs.includes(job.id)
                    ? "bookmark"
                    : "bookmark-border"
                }
                size={18}
                color={colors.beeYellow}
              />
            </TouchableOpacity>
          </View>

          {/* Badges Row */}
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 6,
              marginTop: 8,
            }}
          >
            {isNew && (
              <View
                style={{
                  backgroundColor: `${colors.success}15`,
                  paddingHorizontal: 8,
                  paddingVertical: 3,
                  borderRadius: 6,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 3,
                }}
              >
                <View
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: 3,
                    backgroundColor: colors.success,
                  }}
                />
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "700",
                    color: colors.success,
                  }}
                >
                  NEW
                </Text>
              </View>
            )}
            {isFeatured && (
              <View
                style={{
                  backgroundColor: `${colors.beeYellow}25`,
                  paddingHorizontal: 8,
                  paddingVertical: 3,
                  borderRadius: 6,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 3,
                }}
              >
                <Icon name="star" size={10} color={colors.deepNavy} />
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "700",
                    color: colors.deepNavy,
                  }}
                >
                  FEATURED
                </Text>
              </View>
            )}
            {isTelegramJob && (
              <View
                style={{
                  backgroundColor: `${colors.softBlue}15`,
                  paddingHorizontal: 8,
                  paddingVertical: 3,
                  borderRadius: 6,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 3,
                }}
              >
                <Icon name="send" size={9} color={colors.softBlue} />
                <Text
                  style={{
                    fontSize: 10,
                    fontWeight: "700",
                    color: colors.softBlue,
                  }}
                >
                  TELEGRAM
                </Text>
              </View>
            )}
          </View>
        </View>

        {/* Info Chips Grid - 2x2 */}
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            gap: 8,
            marginBottom: 16,
          }}
        >
          {/* Job Type */}
          <View
            style={{
              flex: 1,
              minWidth: "45%",
              flexDirection: "row",
              alignItems: "center",
              gap: 8,
              backgroundColor: `${colors.deepNavy}06`,
              paddingHorizontal: 12,
              paddingVertical: 10,
              borderRadius: 10,
            }}
          >
            <Icon name="work-outline" size={16} color={colors.deepNavy} />
            <Text
              style={{
                fontSize: 13,
                fontWeight: "600",
                color: colors.deepNavy,
                flex: 1,
              }}
              numberOfLines={1}
            >
              {job.type || "Full-time"}
            </Text>
          </View>

          {/* Experience */}
          {job.experienceLevel && (
            <View
              style={{
                flex: 1,
                minWidth: "45%",
                flexDirection: "row",
                alignItems: "center",
                gap: 8,
                backgroundColor: `${colors.deepNavy}06`,
                paddingHorizontal: 12,
                paddingVertical: 10,
                borderRadius: 10,
              }}
            >
              <Icon name="school" size={16} color={colors.deepNavy} />
              <Text
                style={{
                  fontSize: 13,
                  fontWeight: "600",
                  color: colors.deepNavy,
                  flex: 1,
                }}
                numberOfLines={1}
              >
                {job.experienceLevel}
              </Text>
            </View>
          )}

          {/* Location */}
          {job.location && (
            <View
              style={{
                flex: 1,
                minWidth: "45%",
                flexDirection: "row",
                alignItems: "center",
                gap: 8,
                backgroundColor: `${colors.deepNavy}06`,
                paddingHorizontal: 12,
                paddingVertical: 10,
                borderRadius: 10,
              }}
            >
              <Icon name="place" size={16} color={colors.deepNavy} />
              <Text
                style={{
                  fontSize: 13,
                  fontWeight: "600",
                  color: colors.deepNavy,
                  flex: 1,
                }}
                numberOfLines={1}
              >
                {job.location}
              </Text>
            </View>
          )}

          {/* Posted Time */}
          <View
            style={{
              flex: 1,
              minWidth: "45%",
              flexDirection: "row",
              alignItems: "center",
              gap: 8,
              backgroundColor: `${colors.deepNavy}06`,
              paddingHorizontal: 12,
              paddingVertical: 10,
              borderRadius: 10,
            }}
          >
            <Icon name="schedule" size={16} color={colors.deepNavy} />
            <Text
              style={{
                fontSize: 13,
                fontWeight: "600",
                color: colors.deepNavy,
                flex: 1,
              }}
              numberOfLines={1}
            >
              {getPostedTime()}
            </Text>
          </View>
        </View>

        {/* Salary Banner */}
        {job.salary && (
          <View
            style={{
              backgroundColor: `${colors.success}10`,
              paddingHorizontal: 14,
              paddingVertical: 10,
              borderRadius: 10,
              marginBottom: 16,
              borderLeftWidth: 3,
              borderLeftColor: colors.success,
              flexDirection: "row",
              alignItems: "center",
              gap: 10,
            }}
          >
            <Icon name="payments" size={20} color={colors.success} />
            <Text
              style={{
                fontSize: 15,
                fontWeight: "700",
                color: colors.success,
                flex: 1,
              }}
            >
              {job.salary}
            </Text>
          </View>
        )}

        {/* Description */}
        {job.description && (
          <Text
            style={{
              fontSize: 13,
              lineHeight: 20,
              color: colors.warmGray,
              marginBottom: 16,
            }}
            numberOfLines={2}
          >
            {job.description}
          </Text>
        )}

        {/* Skills Tags */}
        {job.skills && job.skills.length > 0 && (
          <View style={{ marginBottom: 16 }}>
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 6 }}>
              {job.skills.slice(0, 4).map((skill: string, index: number) => (
                <View
                  key={index}
                  style={{
                    backgroundColor: `${colors.beeYellow}20`,
                    paddingHorizontal: 10,
                    paddingVertical: 5,
                    borderRadius: 8,
                    borderWidth: 1,
                    borderColor: `${colors.beeYellow}40`,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 11,
                      fontWeight: "600",
                      color: colors.deepNavy,
                    }}
                  >
                    {skill}
                  </Text>
                </View>
              ))}
              {job.skills.length > 4 && (
                <View
                  style={{
                    backgroundColor: `${colors.warmGray}15`,
                    paddingHorizontal: 10,
                    paddingVertical: 5,
                    borderRadius: 8,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 11,
                      fontWeight: "600",
                      color: colors.warmGray,
                    }}
                  >
                    +{job.skills.length - 4} more
                  </Text>
                </View>
              )}
            </View>
          </View>
        )}

        {/* Footer: Stats + Action */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: 16,
            borderTopWidth: 1,
            borderTopColor: `${colors.lightGray}20`,
          }}
        >
          {/* Stats */}
          <View style={{ flexDirection: "row", gap: 16 }}>
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 5 }}
            >
              <Icon name="visibility" size={15} color={colors.warmGray} />
              <Text
                style={{
                  fontSize: 12,
                  fontWeight: "600",
                  color: colors.warmGray,
                }}
              >
                {job.views || 0}
              </Text>
            </View>
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 5 }}
            >
              <Icon name="people-outline" size={15} color={colors.warmGray} />
              <Text
                style={{
                  fontSize: 12,
                  fontWeight: "600",
                  color: colors.warmGray,
                }}
              >
                {job.applicationCount || 0}
              </Text>
            </View>
          </View>

          {/* Apply Button */}
          <TouchableOpacity
            style={{
              backgroundColor: colors.deepNavy,
              paddingHorizontal: 20,
              paddingVertical: 10,
              borderRadius: 10,
              flexDirection: "row",
              alignItems: "center",
              gap: 6,
            }}
            onPress={(e) => {
              e.stopPropagation();
              navigation.navigate("JobDetails", { id: job.id });
            }}
          >
            <Text
              style={{ fontSize: 13, fontWeight: "700", color: colors.white }}
            >
              View Job
            </Text>
            <Icon name="arrow-forward" size={14} color={colors.white} />
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: colors.cream }]}>
      <SubscriptionUpgradeModal
        visible={upgradeModal.visible}
        featureLabel={upgradeModal.featureLabel}
        currentPlan={userData?.subscriptionPlan || userData?.subscriptionId}
        onClose={() => setUpgradeModal({ visible: false })}
        navigation={navigation}
        isDarkMode={isDarkMode}
      />
      {/* Header Toolbar */}
      <View
        style={[
          styles.jobsToolbar,
          {
            backgroundColor: isDarkMode ? "#0F1117" : colors.white,
            borderBottomColor: isDarkMode ? "#1E2027" : colors.lightGray,
          },
        ]}
      >
        {isMobile ? (
          /* ── MOBILE APP BAR: back + wordmark ── */
          <View
            style={{
              flex: 1,
              flexDirection: "row",
              alignItems: "center",
              gap: 10,
            }}
          >
            <TouchableOpacity
              onPress={() =>
                navigation.canGoBack()
                  ? navigation.goBack()
                  : navigation.navigate("Companies")
              }
              hitSlop={{ top: 8, bottom: 8, left: 4, right: 8 }}
            >
              <Icon
                name="arrow-back"
                size={24}
                color={isDarkMode ? "#F9FAFB" : colors.deepNavy}
              />
            </TouchableOpacity>
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
            >
              <Image
                source={require("./assets/favicon.png")}
                style={{ width: 26, height: 26, borderRadius: 6 }}
                resizeMode="contain"
              />
              <View>
                <Text
                  style={{
                    fontSize: 17,
                    fontFamily: fonts.bold,
                    color: isDarkMode ? "#F9FAFB" : colors.deepNavy,
                    letterSpacing: 0.1,
                    lineHeight: 20,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: fonts.regular,
                      color: isDarkMode ? "#9CA3AF" : "#94A3B8",
                    }}
                  >
                    Nib
                  </Text>
                  Jobs
                </Text>
                <View
                  style={{
                    height: 2.5,
                    width: 32,
                    backgroundColor: "#F4C430",
                    borderRadius: 2,
                  }}
                />
              </View>
            </View>
          </View>
        ) : (
          /* ── DESKTOP TOOLBAR (original) ── */
          <>
            <View style={styles.jobsToolbarLeft}>
              {/* Mobile Menu Button */}
              {isMobile && (
                <TouchableOpacity
                  onPress={() => setShowMobileMenu(true)}
                  style={styles.mobileMenuButton}
                >
                  <Icon name="menu" size={24} color={colors.deepNavy} />
                </TouchableOpacity>
              )}

              {/* Logo - Hidden when search expanded on mobile */}
              {!(isMobile && isSearchExpanded) && !isMobile && (
                <TouchableOpacity onPress={() => navigation.navigate("Home")}>
                  <Image
                    source={require("./assets/favicon.png")}
                    style={styles.toolbarLogo}
                    resizeMode="contain"
                  />
                </TouchableOpacity>
              )}

              {/* Desktop Navigation */}
              {!isMobile && (
                <>
                  <TouchableOpacity
                    style={styles.toolbarNavButton}
                    onPress={() => navigation.navigate("Jobs")}
                  >
                    <Text
                      style={[
                        styles.toolbarNavButtonText,
                        { color: colors.deepNavy },
                      ]}
                    >
                      {t.navJobs}
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={styles.toolbarNavButton}
                    onPress={() => navigation.navigate("Companies")}
                  >
                    <Text
                      style={[
                        styles.toolbarNavButtonText,
                        { color: colors.deepNavy },
                      ]}
                    >
                      {t.companies}
                    </Text>
                  </TouchableOpacity>
                  {user && userData?.role === "user" && (
                    <TouchableOpacity
                      style={[
                        styles.toolbarNavButton,
                        {
                          backgroundColor: "#374151",
                          paddingHorizontal: 16,
                          borderRadius: 8,
                        },
                      ]}
                      onPress={() => navigation.navigate("CompanyRegistration")}
                    >
                      <Text
                        style={[
                          styles.toolbarNavButtonText,
                          { color: "#FFFFFF", fontWeight: "600" },
                        ]}
                      >
                        {t.cdPostJob}
                      </Text>
                    </TouchableOpacity>
                  )}
                  {user &&
                    userData?.role === "company" &&
                    userData?.companyProfile && (
                      <TouchableOpacity
                        style={[
                          styles.toolbarNavButton,
                          {
                            backgroundColor: "#374151",
                            paddingHorizontal: 16,
                            borderRadius: 8,
                          },
                        ]}
                        onPress={() => navigation.navigate("CompanyDashboard")}
                      >
                        <Text
                          style={[
                            styles.toolbarNavButtonText,
                            { color: "#FFFFFF", fontWeight: "600" },
                          ]}
                        >
                          {t.cdPostJob}
                        </Text>
                      </TouchableOpacity>
                    )}
                  {user && (
                    <TouchableOpacity
                      style={[
                        styles.toolbarNavButton,
                        styles.toolbarBookmarksButton,
                      ]}
                      onPress={() => navigation.navigate("Bookmarks")}
                    >
                      <Icon
                        name="bookmark"
                        size={18}
                        color={colors.beeYellow}
                      />
                      <Text
                        style={[
                          styles.toolbarNavButtonText,
                          { color: colors.deepNavy, marginLeft: 4 },
                        ]}
                      >
                        {t.bookmarks}
                      </Text>
                    </TouchableOpacity>
                  )}
                </>
              )}

              {/* Search Bar - Hidden on mobile */}
              {!isMobile && (
                <View
                  style={[
                    styles.toolbarSearchContainer,
                    { backgroundColor: colors.lightGray },
                  ]}
                >
                  <Icon name="search" size={18} color={colors.warmGray} />
                  <TextInput
                    style={[
                      styles.toolbarSearchInput,
                      { color: colors.deepNavy },
                    ]}
                    placeholder="Search companies..."
                    placeholderTextColor={colors.warmGray}
                    value={searchText}
                    onChangeText={setSearchText}
                  />
                </View>
              )}

              {/* Language Selector - Hidden on mobile */}
              {!isMobile && (
                <View style={styles.toolbarLanguageContainer}>
                  <TouchableOpacity
                    ref={languageButtonRef}
                    style={[
                      styles.toolbarLanguageButton,
                      { backgroundColor: colors.lightGray },
                    ]}
                    onPress={toggleLanguageDropdown}
                  >
                    <Icon name="language" size={20} color={colors.deepNavy} />
                    <Text
                      style={[
                        styles.toolbarLanguageText,
                        { color: colors.deepNavy },
                      ]}
                    >
                      {getCurrentLanguage().code.toUpperCase()}
                    </Text>
                    <Icon
                      name={showLanguageMenu ? "expand-less" : "expand-more"}
                      size={20}
                      color={colors.deepNavy}
                    />
                  </TouchableOpacity>
                </View>
              )}
            </View>

            <View style={styles.jobsToolbarRight}>
              {/* Mobile Search - Expandable */}
              {isMobile && (
                <>
                  {isSearchExpanded ? (
                    <View style={styles.expandedSearchContainer}>
                      <TextInput
                        style={styles.expandedSearchInput}
                        placeholder="Search companies..."
                        value={searchText}
                        onChangeText={setSearchText}
                        autoFocus
                        placeholderTextColor={colors.warmGray}
                      />
                      <TouchableOpacity
                        style={styles.expandedSearchClose}
                        onPress={() => {
                          setIsSearchExpanded(false);
                          setSearchText("");
                        }}
                      >
                        <Icon name="close" size={20} color={colors.deepNavy} />
                      </TouchableOpacity>
                    </View>
                  ) : (
                    <View style={styles.mobileHeaderActions}>
                      <TouchableOpacity
                        style={[
                          styles.modernIconButton,
                          {
                            backgroundColor: isDarkMode
                              ? "#2C2F36"
                              : colors.lightGray,
                          },
                        ]}
                        onPress={() => setIsSearchExpanded(true)}
                      >
                        <Icon
                          name="search"
                          size={24}
                          color={isDarkMode ? colors.white : colors.deepNavy}
                        />
                      </TouchableOpacity>

                      <TouchableOpacity
                        style={[
                          styles.modernIconButton,
                          {
                            backgroundColor: isDarkMode
                              ? "#2C2F36"
                              : colors.lightGray,
                          },
                        ]}
                        onPress={() => setIsMoreMenuOpen(!isMoreMenuOpen)}
                      >
                        <Icon
                          name="more-vert"
                          size={24}
                          color={isDarkMode ? colors.white : colors.deepNavy}
                        />
                      </TouchableOpacity>
                    </View>
                  )}
                </>
              )}

              {/* Alerts & Language - Desktop only */}
              {!isMobile && user && (
                <NotificationsBell
                  navigation={navigation}
                  isDarkMode={isDarkMode}
                  currentLanguage={currentLanguage}
                />
              )}
              {!isMobile && (
                <DesktopLanguageSelector
                  currentLanguage={currentLanguage}
                  setCurrentLanguage={setCurrentLanguage}
                  isDarkMode={isDarkMode}
                />
              )}
              {/* Theme Toggle Switch - Hidden on mobile */}
              {!isMobile && (
                <TouchableOpacity
                  style={styles.toolbarThemeToggle}
                  onPress={toggleTheme}
                >
                  <View
                    style={[
                      styles.themeToggleTrack,
                      {
                        backgroundColor: isDarkMode
                          ? colors.deepNavy
                          : colors.lightGray,
                      },
                    ]}
                  >
                    <Icon
                      name="wb-sunny"
                      size={14}
                      color={isDarkMode ? colors.warmGray : colors.beeYellow}
                      style={styles.themeToggleIconLeft}
                    />
                    <View
                      style={[
                        styles.themeToggleKnob,
                        { backgroundColor: colors.white },
                        isDarkMode && styles.themeToggleKnobActive,
                      ]}
                    >
                      <Icon
                        name={isDarkMode ? "nightlight-round" : "wb-sunny"}
                        size={12}
                        color={isDarkMode ? colors.deepNavy : colors.beeYellow}
                      />
                    </View>
                    <Icon
                      name="nightlight-round"
                      size={14}
                      color={isDarkMode ? colors.beeYellow : colors.warmGray}
                      style={styles.themeToggleIconRight}
                    />
                  </View>
                </TouchableOpacity>
              )}

              {!isMobile &&
                (user ? (
                  <>
                    {userData?.profilePicture ? (
                      <Image
                        source={{ uri: userData.profilePicture }}
                        style={styles.toolbarProfilePicture}
                      />
                    ) : (
                      <View
                        style={[
                          styles.toolbarProfilePlaceholder,
                          { backgroundColor: colors.beeYellow },
                        ]}
                      >
                        <Icon name="person" size={20} color={colors.deepNavy} />
                      </View>
                    )}
                    <View
                      style={{
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <Text
                        style={[
                          styles.toolbarUserName,
                          { color: colors.deepNavy },
                        ]}
                      >
                        {user.email?.split("@")[0]}
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                          marginTop: 2,
                        }}
                      >
                        {(() => {
                          const subscriptionId = (
                            userData?.subscriptionId ||
                            userData?.subscriptionPlan ||
                            "free"
                          ).toLowerCase();
                          const plan =
                            SUBSCRIPTION_PLANS.find(
                              (p) => p.id === subscriptionId,
                            ) || SUBSCRIPTION_PLANS[0];
                          const isFree = plan.id === "free";
                          const badgeColors = {
                            free: { bg: "#6B7280", text: "#FFFFFF" },
                            standard: { bg: "#D97706", text: "#FFFFFF" },
                            pro: { bg: "#7C3AED", text: "#FFFFFF" },
                            enterprise: { bg: "#1E3A8A", text: "#FFFFFF" },
                          };
                          const colors_badge =
                            badgeColors[plan.id as keyof typeof badgeColors] ||
                            badgeColors.free;
                          return (
                            <>
                              <View
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  backgroundColor: colors_badge.bg,
                                  paddingHorizontal: 8,
                                  paddingVertical: 2,
                                  borderRadius: 12,
                                }}
                              >
                                <Icon
                                  name={plan.icon}
                                  size={12}
                                  color={colors_badge.text}
                                />
                                <Text
                                  style={{
                                    fontSize: 11,
                                    fontFamily: fonts.regular,
                                    color: colors_badge.text,
                                    fontWeight: "600",
                                    marginLeft: 4,
                                  }}
                                >
                                  {plan.name}
                                </Text>
                              </View>
                              {isFree && (
                                <TouchableOpacity
                                  onPress={() =>
                                    navigation.navigate("SettingsSubscription")
                                  }
                                  style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    backgroundColor: "#10B981",
                                    paddingHorizontal: 8,
                                    paddingVertical: 2,
                                    borderRadius: 12,
                                    gap: 3,
                                  }}
                                >
                                  <Icon
                                    name="arrow-upward"
                                    size={10}
                                    color="#FFFFFF"
                                  />
                                  <Text
                                    style={{
                                      fontSize: 10,
                                      fontFamily: fonts.regular,
                                      color: "#FFFFFF",
                                      fontWeight: "600",
                                    }}
                                  >
                                    Upgrade
                                  </Text>
                                </TouchableOpacity>
                              )}
                            </>
                          );
                        })()}
                      </View>
                    </View>
                    <View style={{ width: 12 }} />
                    <TouchableOpacity
                      style={styles.toolbarSettingsButton}
                      onPress={() => navigation.navigate("Settings")}
                    >
                      <Icon name="settings" size={24} color={colors.deepNavy} />
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={styles.toolbarLogoutButton}
                      onPress={async () => {
                        await signOut(auth);
                        navigation.replace("Home");
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.danger,
                          fontFamily: fonts.medium,
                        }}
                      >
                        Logout
                      </Text>
                    </TouchableOpacity>
                  </>
                ) : (
                  <>
                    <TouchableOpacity
                      style={[
                        styles.toolbarLoginButton,
                        { borderColor: colors.deepNavy },
                      ]}
                      onPress={() => navigation.navigate("Login")}
                    >
                      <Text
                        style={[
                          styles.toolbarLoginButtonText,
                          { color: colors.deepNavy },
                        ]}
                      >
                        Login
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={[
                        styles.toolbarSignupButton,
                        { backgroundColor: colors.beeYellow },
                      ]}
                      onPress={() => navigation.navigate("Signup")}
                    >
                      <Text
                        style={[
                          styles.toolbarSignupButtonText,
                          { color: colors.buttonTextOnYellow },
                        ]}
                      >
                        Sign Up
                      </Text>
                    </TouchableOpacity>
                  </>
                ))}
            </View>
          </>
        )}
      </View>

      {/* Language Dropdown */}
      {showLanguageMenu && !isMobile && (
        <View
          style={[
            styles.languageDropdown,
            {
              position: "fixed" as any,
              top: dropdownPosition.top,
              right: dropdownPosition.right,
              backgroundColor: colors.white,
              zIndex: 1000,
            },
          ]}
        >
          {languageOptions.map((lang) => (
            <TouchableOpacity
              key={lang.code}
              style={[
                styles.languageOption,
                currentLanguage === lang.code && {
                  backgroundColor: `${colors.beeYellow}20`,
                },
              ]}
              onPress={() => changeLanguage(lang.code)}
            >
              <Text
                style={[
                  styles.languageOptionText,
                  {
                    color:
                      currentLanguage === lang.code
                        ? colors.deepNavy
                        : colors.warmGray,
                  },
                ]}
              >
                {lang.label}
              </Text>
              {currentLanguage === lang.code && (
                <Icon name="check" size={18} color={colors.deepNavy} />
              )}
            </TouchableOpacity>
          ))}
        </View>
      )}

      {/* More Menu Dropdown */}
      {isMoreMenuOpen && isMobile && (
        <View style={styles.fullScreenDropdownOverlay}>
          <TouchableOpacity
            style={styles.fullScreenTouchArea}
            onPress={() => setIsMoreMenuOpen(false)}
            activeOpacity={1}
          />
          <View
            style={[
              styles.moreMenuDropdown,
              { top: 60, right: 16, backgroundColor: colors.white },
            ]}
          >
            <TouchableOpacity
              style={styles.moreMenuItem}
              onPress={() => {
                setIsMoreMenuOpen(false);
                toggleTheme();
              }}
            >
              <Icon
                name={isDarkMode ? "wb-sunny" : "nightlight-round"}
                size={20}
                color={colors.deepNavy}
              />
              <Text style={[styles.moreMenuText, { color: colors.deepNavy }]}>
                {isDarkMode ? "Light Mode" : "Dark Mode"}
              </Text>
            </TouchableOpacity>

            <View
              style={[
                styles.moreMenuDivider,
                { backgroundColor: colors.lightGray },
              ]}
            />

            <TouchableOpacity
              style={styles.moreMenuItem}
              onPress={() => {
                setIsMoreMenuOpen(false);
                toggleLanguageDropdown();
              }}
            >
              <Icon name="language" size={20} color={colors.deepNavy} />
              <Text style={[styles.moreMenuText, { color: colors.deepNavy }]}>
                Language
              </Text>
              <Text
                style={[
                  styles.moreMenuSecondaryText,
                  { color: colors.warmGray },
                ]}
              >
                {getCurrentLanguage().code.toUpperCase()}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      )}

      {companyLoading ? (
        <FullScreenLoader
          message="Loading company details..."
          isDarkMode={isDarkMode}
        />
      ) : !company ? (
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            padding: 40,
          }}
        >
          <Icon name="business-center" size={80} color={colors.warmGray} />
          <Text
            style={{
              fontSize: 20,
              fontWeight: "700",
              color: colors.deepNavy,
              marginTop: 20,
            }}
          >
            Company Not Found
          </Text>
          <Text
            style={{
              fontSize: 14,
              color: colors.warmGray,
              marginTop: 8,
              textAlign: "center",
            }}
          >
            The company you're looking for could not be found.
          </Text>
          <TouchableOpacity
            style={{
              backgroundColor: colors.deepNavy,
              paddingHorizontal: 24,
              paddingVertical: 12,
              borderRadius: 10,
              marginTop: 24,
            }}
            onPress={() => navigation.goBack()}
          >
            <Text
              style={{ fontSize: 14, fontWeight: "700", color: colors.white }}
            >
              Go Back
            </Text>
          </TouchableOpacity>
        </View>
      ) : (
        <ScrollView style={{ flex: 1 }} showsVerticalScrollIndicator={false}>
          {/* Hero Section with Cover & Logo */}
          <View style={{ backgroundColor: colors.white }}>
            {/* Cover Image */}
            <View
              style={{
                height: 160,
                backgroundColor: `${colors.deepNavy}15`,
                position: "relative",
                overflow: "hidden",
              }}
            >
              {companyProfile.coverUrl ? (
                <Image
                  source={{ uri: companyProfile.coverUrl }}
                  style={{ width: "100%", height: "100%" }}
                  resizeMode="cover"
                />
              ) : (
                <View
                  style={{
                    width: "100%",
                    height: "100%",
                    background: `linear-gradient(135deg, ${colors.deepNavy}20 0%, ${colors.beeYellow}20 100%)`,
                    backgroundColor: `${colors.deepNavy}10`,
                  }}
                />
              )}
            </View>

            {/* Company Logo & Basic Info */}
            <View style={{ paddingHorizontal: 20, paddingBottom: 20 }}>
              {/* Logo - Overlapping cover */}
              <View
                style={{
                  width: 100,
                  height: 100,
                  borderRadius: 20,
                  backgroundColor: colors.white,
                  marginTop: -50,
                  borderWidth: 4,
                  borderColor: colors.white,
                  alignItems: "center",
                  justifyContent: "center",
                  ...Platform.select({
                    ios: {
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 4 },
                      shadowOpacity: 0.15,
                      shadowRadius: 12,
                    },
                    android: {
                      elevation: 8,
                    },
                    web: {
                      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    },
                  }),
                }}
              >
                {companyProfile.logoUrl ? (
                  <Image
                    source={{ uri: companyProfile.logoUrl }}
                    style={{ width: 92, height: 92, borderRadius: 16 }}
                    resizeMode="cover"
                  />
                ) : (
                  <View
                    style={{
                      width: 92,
                      height: 92,
                      borderRadius: 16,
                      backgroundColor: `${colors.deepNavy}10`,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 36,
                        fontWeight: "700",
                        color: colors.deepNavy,
                      }}
                    >
                      {companyProfile.companyName?.charAt(0)?.toUpperCase() ||
                        "C"}
                    </Text>
                  </View>
                )}
              </View>

              {/* Company Name & Verification */}
              <View
                style={{
                  marginTop: 16,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <Text
                  style={{
                    fontSize: 24,
                    fontWeight: "700",
                    color: colors.deepNavy,
                    flex: 1,
                  }}
                >
                  {companyProfile.companyName || "Company Name"}
                </Text>
                {companyProfile.verificationStatus === "verified" && (
                  <View
                    style={{
                      backgroundColor: `${colors.success}15`,
                      paddingHorizontal: 10,
                      paddingVertical: 4,
                      borderRadius: 12,
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 4,
                    }}
                  >
                    <Icon name="verified" size={16} color={colors.success} />
                    <Text
                      style={{
                        fontSize: 11,
                        fontWeight: "600",
                        color: colors.success,
                      }}
                    >
                      VERIFIED
                    </Text>
                  </View>
                )}
                {company.source === "telegram" && (
                  <View
                    style={{
                      backgroundColor: `${colors.softBlue}15`,
                      paddingHorizontal: 10,
                      paddingVertical: 4,
                      borderRadius: 12,
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 4,
                    }}
                  >
                    <Icon name="send" size={14} color={colors.softBlue} />
                    <Text
                      style={{
                        fontSize: 11,
                        fontWeight: "600",
                        color: colors.softBlue,
                      }}
                    >
                      TELEGRAM
                    </Text>
                  </View>
                )}
              </View>

              {/* Industry & Location */}
              <View
                style={{
                  marginTop: 8,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 16,
                }}
              >
                {companyProfile.industry && (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <Icon name="business" size={16} color={colors.warmGray} />
                    <Text style={{ fontSize: 14, color: colors.warmGray }}>
                      {companyProfile.industry}
                    </Text>
                  </View>
                )}
                {companyProfile.city && (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <Icon
                      name="location-on"
                      size={16}
                      color={colors.warmGray}
                    />
                    <Text style={{ fontSize: 14, color: colors.warmGray }}>
                      {companyProfile.city}
                      {companyProfile.country
                        ? `, ${companyProfile.country}`
                        : ""}
                    </Text>
                  </View>
                )}
              </View>

              {/* Stats Row */}
              <View
                style={{
                  marginTop: 20,
                  flexDirection: "row",
                  gap: 12,
                  paddingTop: 20,
                  borderTopWidth: 1,
                  borderTopColor: `${colors.lightGray}30`,
                }}
              >
                {/* Jobs Count */}
                <View style={{ flex: 1, alignItems: "center" }}>
                  <Text
                    style={{
                      fontSize: 24,
                      fontWeight: "700",
                      color: colors.deepNavy,
                    }}
                  >
                    {companyJobs.length}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color: colors.warmGray,
                      marginTop: 2,
                    }}
                  >
                    Open Jobs
                  </Text>
                </View>

                {/* Employees */}
                {companyProfile.size && (
                  <View style={{ flex: 1, alignItems: "center" }}>
                    <Text
                      style={{
                        fontSize: 24,
                        fontWeight: "700",
                        color: colors.deepNavy,
                      }}
                    >
                      {companyProfile.size}
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,
                        color: colors.warmGray,
                        marginTop: 2,
                      }}
                    >
                      Employees
                    </Text>
                  </View>
                )}

                {/* Founded */}
                {companyProfile.founded && (
                  <View style={{ flex: 1, alignItems: "center" }}>
                    <Text
                      style={{
                        fontSize: 24,
                        fontWeight: "700",
                        color: colors.deepNavy,
                      }}
                    >
                      {companyProfile.founded}
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,
                        color: colors.warmGray,
                        marginTop: 2,
                      }}
                    >
                      Founded
                    </Text>
                  </View>
                )}
              </View>

              {/* Social Links */}
              {(companyProfile.linkedin ||
                companyProfile.facebook ||
                companyProfile.twitter ||
                companyProfile.website) && (
                <View
                  style={{
                    marginTop: 20,
                    flexDirection: "row",
                    gap: 12,
                    justifyContent: "center",
                  }}
                >
                  {companyProfile.linkedin && (
                    <TouchableOpacity
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: 22,
                        backgroundColor: "#0077B5",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onPress={() => {
                        if (Platform.OS === "web") {
                          window.open(
                            companyProfile.linkedin.startsWith("http")
                              ? companyProfile.linkedin
                              : `https://${companyProfile.linkedin}`,
                            "_blank",
                          );
                        }
                      }}
                    >
                      <Text
                        style={{
                          color: "#fff",
                          fontSize: 18,
                          fontWeight: "700",
                        }}
                      >
                        in
                      </Text>
                    </TouchableOpacity>
                  )}

                  {companyProfile.facebook && (
                    <TouchableOpacity
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: 22,
                        backgroundColor: "#1877F2",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onPress={() => {
                        if (Platform.OS === "web") {
                          window.open(
                            companyProfile.facebook.startsWith("http")
                              ? companyProfile.facebook
                              : `https://${companyProfile.facebook}`,
                            "_blank",
                          );
                        }
                      }}
                    >
                      <Text
                        style={{
                          color: "#fff",
                          fontSize: 18,
                          fontWeight: "700",
                        }}
                      >
                        f
                      </Text>
                    </TouchableOpacity>
                  )}

                  {companyProfile.twitter && (
                    <TouchableOpacity
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: 22,
                        backgroundColor: "#1DA1F2",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onPress={() => {
                        if (Platform.OS === "web") {
                          window.open(
                            companyProfile.twitter.startsWith("http")
                              ? companyProfile.twitter
                              : `https://${companyProfile.twitter}`,
                            "_blank",
                          );
                        }
                      }}
                    >
                      <Text
                        style={{
                          color: "#fff",
                          fontSize: 18,
                          fontWeight: "700",
                        }}
                      >
                        𝕏
                      </Text>
                    </TouchableOpacity>
                  )}

                  {companyProfile.website && (
                    <TouchableOpacity
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: 22,
                        backgroundColor: colors.deepNavy,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onPress={() => {
                        if (Platform.OS === "web") {
                          window.open(
                            companyProfile.website.startsWith("http")
                              ? companyProfile.website
                              : `https://${companyProfile.website}`,
                            "_blank",
                          );
                        }
                      }}
                    >
                      <Icon name="language" size={20} color={colors.white} />
                    </TouchableOpacity>
                  )}
                </View>
              )}
            </View>
          </View>

          {/* Tab Navigation */}
          <View
            style={{
              backgroundColor: colors.white,
              marginTop: 8,
              flexDirection: "row",
              borderBottomWidth: 1,
              borderBottomColor: `${colors.lightGray}30`,
            }}
          >
            <TouchableOpacity
              style={{
                flex: 1,
                paddingVertical: 16,
                alignItems: "center",
                borderBottomWidth: 3,
                borderBottomColor:
                  activeTab === "about" ? colors.beeYellow : "transparent",
              }}
              onPress={() => setActiveTab("about")}
            >
              <Text
                style={{
                  fontSize: 15,
                  fontWeight: activeTab === "about" ? "700" : "500",
                  color:
                    activeTab === "about" ? colors.deepNavy : colors.warmGray,
                }}
              >
                About
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={{
                flex: 1,
                paddingVertical: 16,
                alignItems: "center",
                borderBottomWidth: 3,
                borderBottomColor:
                  activeTab === "jobs" ? colors.beeYellow : "transparent",
              }}
              onPress={() => setActiveTab("jobs")}
            >
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 6 }}
              >
                <Text
                  style={{
                    fontSize: 15,
                    fontWeight: activeTab === "jobs" ? "700" : "500",
                    color:
                      activeTab === "jobs" ? colors.deepNavy : colors.warmGray,
                  }}
                >
                  Jobs
                </Text>
                {companyJobs.length > 0 && (
                  <View
                    style={{
                      backgroundColor:
                        activeTab === "jobs"
                          ? colors.beeYellow
                          : `${colors.warmGray}20`,
                      paddingHorizontal: 8,
                      paddingVertical: 2,
                      borderRadius: 10,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 11,
                        fontWeight: "700",
                        color:
                          activeTab === "jobs"
                            ? colors.deepNavy
                            : colors.warmGray,
                      }}
                    >
                      {companyJobs.length}
                    </Text>
                  </View>
                )}
              </View>
            </TouchableOpacity>
          </View>

          {/* Tab Content */}
          {activeTab === "about" ? (
            <View
              style={{
                padding: 20,
                backgroundColor: colors.white,
                marginTop: 8,
              }}
            >
              {/* About Section */}
              {companyProfile.companyDescription && (
                <View style={{ marginBottom: 24 }}>
                  <Text
                    style={{
                      fontSize: 18,
                      fontWeight: "700",
                      color: colors.deepNavy,
                      marginBottom: 12,
                    }}
                  >
                    About Us
                  </Text>
                  <Text
                    style={{
                      fontSize: 14,
                      lineHeight: 22,
                      color: colors.warmGray,
                    }}
                  >
                    {companyProfile.companyDescription}
                  </Text>
                </View>
              )}

              {/* Company Details Grid */}
              <View style={{ marginBottom: 24 }}>
                <Text
                  style={{
                    fontSize: 18,
                    fontWeight: "700",
                    color: colors.deepNavy,
                    marginBottom: 16,
                  }}
                >
                  Company Details
                </Text>

                <View style={{ gap: 12 }}>
                  {/* Sector */}
                  {companyProfile.sector && (
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        padding: 16,
                        backgroundColor: `${colors.deepNavy}05`,
                        borderRadius: 12,
                        gap: 12,
                      }}
                    >
                      <View
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: 20,
                          backgroundColor: colors.white,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon
                          name="category"
                          size={20}
                          color={colors.deepNavy}
                        />
                      </View>
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            color: colors.warmGray,
                            marginBottom: 2,
                          }}
                        >
                          Sector
                        </Text>
                        <Text
                          style={{
                            fontSize: 14,
                            fontWeight: "600",
                            color: colors.deepNavy,
                          }}
                        >
                          {companyProfile.sector}
                        </Text>
                      </View>
                    </View>
                  )}

                  {/* Phone */}
                  {companyProfile.phone && (
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        padding: 16,
                        backgroundColor: `${colors.deepNavy}05`,
                        borderRadius: 12,
                        gap: 12,
                      }}
                    >
                      <View
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: 20,
                          backgroundColor: colors.white,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon name="phone" size={20} color={colors.deepNavy} />
                      </View>
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            color: colors.warmGray,
                            marginBottom: 2,
                          }}
                        >
                          Phone
                        </Text>
                        <Text
                          style={{
                            fontSize: 14,
                            fontWeight: "600",
                            color: colors.deepNavy,
                          }}
                        >
                          {companyProfile.phone}
                        </Text>
                      </View>
                    </View>
                  )}

                  {/* Email */}
                  {companyProfile.email && (
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        padding: 16,
                        backgroundColor: `${colors.deepNavy}05`,
                        borderRadius: 12,
                        gap: 12,
                      }}
                    >
                      <View
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: 20,
                          backgroundColor: colors.white,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon name="email" size={20} color={colors.deepNavy} />
                      </View>
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            color: colors.warmGray,
                            marginBottom: 2,
                          }}
                        >
                          Email
                        </Text>
                        <Text
                          style={{
                            fontSize: 14,
                            fontWeight: "600",
                            color: colors.deepNavy,
                          }}
                        >
                          {companyProfile.email}
                        </Text>
                      </View>
                    </View>
                  )}

                  {/* Address */}
                  {companyProfile.address && (
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        padding: 16,
                        backgroundColor: `${colors.deepNavy}05`,
                        borderRadius: 12,
                        gap: 12,
                      }}
                    >
                      <View
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: 20,
                          backgroundColor: colors.white,
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon
                          name="location-on"
                          size={20}
                          color={colors.deepNavy}
                        />
                      </View>
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            color: colors.warmGray,
                            marginBottom: 2,
                          }}
                        >
                          Address
                        </Text>
                        <Text
                          style={{
                            fontSize: 14,
                            fontWeight: "600",
                            color: colors.deepNavy,
                          }}
                        >
                          {companyProfile.address}
                        </Text>
                      </View>
                    </View>
                  )}

                  {/* Specializations */}
                  {companyProfile.specializations &&
                    companyProfile.specializations.length > 0 && (
                      <View
                        style={{
                          padding: 16,
                          backgroundColor: `${colors.deepNavy}05`,
                          borderRadius: 12,
                          gap: 12,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 12,
                          }}
                        >
                          <View
                            style={{
                              width: 40,
                              height: 40,
                              borderRadius: 20,
                              backgroundColor: colors.white,
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Icon
                              name="stars"
                              size={20}
                              color={colors.deepNavy}
                            />
                          </View>
                          <Text
                            style={{
                              fontSize: 12,
                              color: colors.warmGray,
                              flex: 1,
                            }}
                          >
                            Specializations
                          </Text>
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 8,
                            marginLeft: 52,
                          }}
                        >
                          {companyProfile.specializations.map(
                            (spec: string, index: number) => (
                              <View
                                key={index}
                                style={{
                                  backgroundColor: colors.white,
                                  paddingHorizontal: 12,
                                  paddingVertical: 6,
                                  borderRadius: 8,
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 12,
                                    fontWeight: "600",
                                    color: colors.deepNavy,
                                  }}
                                >
                                  {spec}
                                </Text>
                              </View>
                            ),
                          )}
                        </View>
                      </View>
                    )}
                </View>
              </View>
            </View>
          ) : (
            /* Jobs Tab */
            <View style={{ padding: 16, backgroundColor: colors.cream }}>
              {loading ? (
                <View style={{ gap: 12 }}>
                  {[1, 2, 3].map((item) => (
                    <View
                      key={item}
                      style={{
                        backgroundColor: colors.white,
                        borderRadius: 16,
                        padding: 20,
                        borderWidth: 1,
                        borderColor: `${colors.lightGray}30`,
                        ...Platform.select({
                          ios: {
                            shadowColor: "#000",
                            shadowOffset: { width: 0, height: 2 },
                            shadowOpacity: 0.08,
                            shadowRadius: 8,
                          },
                          android: {
                            elevation: 3,
                          },
                          web: {
                            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                          },
                        }),
                      }}
                    >
                      {/* Animated skeleton header */}
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                          marginBottom: 16,
                        }}
                      >
                        <View style={{ flex: 1, marginRight: 12 }}>
                          {/* Title skeleton */}
                          <View
                            style={{
                              height: 24,
                              backgroundColor: `${colors.deepNavy}10`,
                              borderRadius: 6,
                              marginBottom: 8,
                              width: "85%",
                            }}
                          />
                          <View
                            style={{
                              height: 24,
                              backgroundColor: `${colors.deepNavy}10`,
                              borderRadius: 6,
                              width: "60%",
                            }}
                          />

                          {/* Badges skeleton */}
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 6,
                              marginTop: 12,
                            }}
                          >
                            <View
                              style={{
                                height: 18,
                                width: 50,
                                backgroundColor: `${colors.deepNavy}10`,
                                borderRadius: 6,
                              }}
                            />
                            <View
                              style={{
                                height: 18,
                                width: 70,
                                backgroundColor: `${colors.deepNavy}10`,
                                borderRadius: 6,
                              }}
                            />
                          </View>
                        </View>

                        {/* Bookmark button skeleton */}
                        <View
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: 18,
                            backgroundColor: `${colors.deepNavy}10`,
                          }}
                        />
                      </View>

                      {/* Info chips skeleton */}
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                          marginBottom: 16,
                        }}
                      >
                        {[1, 2, 3, 4].map((chip) => (
                          <View
                            key={chip}
                            style={{
                              flex: 1,
                              minWidth: "45%",
                              height: 40,
                              backgroundColor: `${colors.deepNavy}06`,
                              borderRadius: 10,
                            }}
                          />
                        ))}
                      </View>

                      {/* Description skeleton */}
                      <View style={{ marginBottom: 16 }}>
                        <View
                          style={{
                            height: 16,
                            backgroundColor: `${colors.deepNavy}08`,
                            borderRadius: 4,
                            marginBottom: 6,
                            width: "100%",
                          }}
                        />
                        <View
                          style={{
                            height: 16,
                            backgroundColor: `${colors.deepNavy}08`,
                            borderRadius: 4,
                            width: "80%",
                          }}
                        />
                      </View>

                      {/* Skills skeleton */}
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 6,
                          marginBottom: 16,
                        }}
                      >
                        {[1, 2, 3].map((skill) => (
                          <View
                            key={skill}
                            style={{
                              height: 26,
                              width: 60,
                              backgroundColor: `${colors.beeYellow}15`,
                              borderRadius: 8,
                            }}
                          />
                        ))}
                      </View>

                      {/* Footer skeleton */}
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingTop: 16,
                          borderTopWidth: 1,
                          borderTopColor: `${colors.lightGray}20`,
                        }}
                      >
                        <View style={{ flexDirection: "row", gap: 16 }}>
                          <View
                            style={{
                              height: 20,
                              width: 40,
                              backgroundColor: `${colors.deepNavy}10`,
                              borderRadius: 4,
                            }}
                          />
                          <View
                            style={{
                              height: 20,
                              width: 40,
                              backgroundColor: `${colors.deepNavy}10`,
                              borderRadius: 4,
                            }}
                          />
                        </View>

                        <View
                          style={{
                            height: 36,
                            width: 100,
                            backgroundColor: `${colors.deepNavy}15`,
                            borderRadius: 10,
                          }}
                        />
                      </View>
                    </View>
                  ))}

                  {/* Loading text */}
                  <View
                    style={{
                      alignItems: "center",
                      marginTop: 20,
                      marginBottom: 10,
                    }}
                  >
                    <ActivityIndicator size="small" color={colors.beeYellow} />
                    <Text
                      style={{
                        fontSize: 13,
                        color: colors.warmGray,
                        marginTop: 12,
                      }}
                    >
                      Loading jobs...
                    </Text>
                  </View>
                </View>
              ) : companyJobs.length > 0 ? (
                <FlatList
                  data={companyJobs}
                  renderItem={renderJobCard}
                  keyExtractor={(item) => item.id}
                  numColumns={isMobile ? 1 : 2}
                  key={isMobile ? "one-column" : "two-columns"}
                  showsVerticalScrollIndicator={false}
                  contentContainerStyle={styles.modernJobsGrid}
                  scrollEnabled={false}
                  columnWrapperStyle={
                    !isMobile ? styles.modernJobsRow : undefined
                  }
                />
              ) : (
                <View style={[styles.emptyState, { padding: 60 }]}>
                  <Icon name="work-outline" size={64} color={colors.warmGray} />
                  <Text
                    style={[
                      styles.emptyStateText,
                      { color: colors.warmGray, marginTop: 16 },
                    ]}
                  >
                    No open positions at the moment
                  </Text>
                  <Text
                    style={{
                      fontSize: 13,
                      color: colors.warmGray,
                      marginTop: 8,
                      textAlign: "center",
                    }}
                  >
                    Check back later for new opportunities
                  </Text>
                </View>
              )}
            </View>
          )}
        </ScrollView>
      )}
    </SafeAreaView>
  );
}

// Bookmarks Screen - Modern Design
function BookmarksScreen({
  navigation,
  isDarkMode,
  toggleTheme,
  currentLanguage = "en",
  setCurrentLanguage,
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const { showAlert: showAppAlert } = useAppAlert();
  const [user, setUser] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = Platform.OS !== "web" || dimensions.width < 768;
  const languageButtonRef = useRef<any>(null);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    right: 0,
  });
  const colors = isDarkMode ? darkColors : lightColors;

  const bookmarkedJobIds = bookmarkedJobs.map((j: any) => j.id);

  const toggleLanguageDropdown = () => {
    if (languageButtonRef.current && languageButtonRef.current.measure) {
      languageButtonRef.current.measure(
        (
          _x: number,
          _y: number,
          _w: number,
          h: number,
          px: number,
          py: number,
        ) => {
          setDropdownPosition({
            top: (py || 0) + (h || 0) + 4,
            right: Math.max(
              20,
              Dimensions.get("window").width - (px || 0) - (_w || 0),
            ),
          });
        },
      );
    }
    setShowLanguageMenu((v) => !v);
  };
  const getCurrentLanguage = () => {
    const map: any = {
      en: { code: "en", label: "English" },
      am: { code: "am", label: "አማርኛ" },
      ti: { code: "ti", label: "ትግርኛ" },
      or: { code: "or", label: "Afaan Oromoo" },
    };
    return map[currentLanguage] || map.en;
  };

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  useEffect(() => {
    let authInitialized = false;
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      // First call may be null before persistence restores — wait before redirecting
      if (!authUser && !authInitialized) {
        authInitialized = true;
        // Give AsyncStorage persistence 500ms to restore the session
        await new Promise((resolve) => setTimeout(resolve, 500));
        // Check again after delay
        if (auth.currentUser) {
          // Session was restored, don't redirect
          return;
        }
      }

      if (authUser) {
        setUser(authUser);
        // Fetch user data and bookmarked jobs
        const userDoc = await getDoc(doc(db, "users", authUser.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          setUserData(data);
          const bookmarkedJobIds = data.savedJobs || [];
          // Fetch full job details for bookmarked jobs
          const jobPromises = bookmarkedJobIds.map(async (jobId: string) => {
            const jobDoc = await getDoc(doc(db, "jobs", jobId));
            if (jobDoc.exists()) {
              return { id: jobDoc.id, ...jobDoc.data() };
            }
            return null;
          });
          const jobs = (await Promise.all(jobPromises)).filter(
            (job) => job !== null,
          );
          setBookmarkedJobs(jobs);
        }
      } else {
        navigation.replace("Login");
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const handleRemoveBookmark = async (jobId: string) => {
    if (!user) return;

    try {
      const userRef = doc(db, "users", user.uid);
      const currentBookmarks = bookmarkedJobs.map((job) => job.id);
      const updatedBookmarks = currentBookmarks.filter((id) => id !== jobId);

      await updateDoc(userRef, {
        savedJobs: updatedBookmarks,
      });

      setBookmarkedJobs(bookmarkedJobs.filter((job) => job.id !== jobId));
    } catch (error) {
      console.error("Error removing bookmark:", error);
      showAppAlert(
        "error",
        "Bookmark Error",
        "Failed to remove bookmark. Please try again.",
      );
    }
  };
  const handleToggleBookmark = (jobId: string) => handleRemoveBookmark(jobId);

  // Filter bookmarked jobs based on search
  const filteredJobs = bookmarkedJobs.filter((job) => {
    if (!searchText) return true;
    const search = searchText.toLowerCase();
    return (
      job.title?.toLowerCase().includes(search) ||
      job.company?.toLowerCase().includes(search) ||
      job.location?.toLowerCase().includes(search)
    );
  });

  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const pageBg = isDarkMode ? "#0F1117" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";

  // ── Job card (matches JobsScreen card) ─────────────────────────────────────
  const renderJobCard = ({ item: job }: any) => {
    const isNew =
      job.createdAt &&
      Date.now() - job.createdAt.seconds * 1000 < 7 * 24 * 60 * 60 * 1000;
    const isUrgent =
      job.deadline &&
      new Date(job.deadline).getTime() - Date.now() < 3 * 24 * 60 * 60 * 1000;

    if (isMobile) {
      return (
        <TouchableOpacity
          style={[
            styles.modernJobCard,
            {
              backgroundColor: colors.white,
              minHeight: 0,
              marginHorizontal: 0,
              marginBottom: 10,
            },
          ]}
          activeOpacity={0.8}
          onPress={() => navigation.navigate("JobDetails", { id: job.id, job })}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              padding: 12,
              gap: 10,
            }}
          >
            <View
              style={[
                styles.companyAvatar,
                {
                  backgroundColor: `${colors.deepNavy}10`,
                  width: 38,
                  height: 38,
                  borderRadius: 8,
                },
              ]}
            >
              {job.companyLogo ? (
                <Image
                  source={{ uri: job.companyLogo }}
                  style={{ width: 38, height: 38, borderRadius: 8 }}
                />
              ) : (
                <Text
                  style={[
                    styles.companyInitialLarge,
                    { color: colors.deepNavy, fontSize: 15 },
                  ]}
                >
                  {(job.company || "C").charAt(0).toUpperCase()}
                </Text>
              )}
            </View>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.bold,
                  color: colors.deepNavy,
                  lineHeight: 18,
                }}
                numberOfLines={2}
              >
                {job.title || "Job Title"}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  color: colors.warmGray,
                  fontFamily: fonts.medium,
                  marginTop: 1,
                }}
                numberOfLines={1}
              >
                {job.company || "Company"}
              </Text>
            </View>
            <TouchableOpacity
              style={{ padding: 4 }}
              onPress={(e) => {
                e.stopPropagation();
                handleToggleBookmark(job.id);
              }}
            >
              <Icon name="bookmark" size={20} color={colors.beeYellow} />
            </TouchableOpacity>
          </View>

          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              paddingHorizontal: 12,
              paddingBottom: 8,
              gap: 6,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: "#6366F112",
                paddingHorizontal: 7,
                paddingVertical: 3,
                borderRadius: 5,
                gap: 3,
              }}
            >
              <Icon name="work-outline" size={11} color="#6366F1" />
              <Text
                style={{
                  fontSize: 11,
                  color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                  fontFamily: fonts.medium,
                }}
              >
                {job.contractType || "Full-time"}
              </Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: "#6366F112",
                paddingHorizontal: 7,
                paddingVertical: 3,
                borderRadius: 5,
                gap: 3,
              }}
            >
              <Icon name="location-on" size={11} color="#6366F1" />
              <Text
                style={{
                  fontSize: 11,
                  color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                  fontFamily: fonts.medium,
                }}
                numberOfLines={1}
              >
                {job.isRemote ? "Remote" : job.location || "N/A"}
              </Text>
            </View>
            {job.experienceLevel && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: "#6366F112",
                  paddingHorizontal: 7,
                  paddingVertical: 3,
                  borderRadius: 5,
                  gap: 3,
                }}
              >
                <Icon name="school" size={11} color="#6366F1" />
                <Text
                  style={{
                    fontSize: 11,
                    color: isDarkMode ? "#E5E7EB" : colors.deepNavy,
                    fontFamily: fonts.medium,
                  }}
                  numberOfLines={1}
                >
                  {job.experienceLevel}
                </Text>
              </View>
            )}
            {(isNew || isUrgent || job.featured) && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: isUrgent
                    ? `${colors.error}15`
                    : isNew
                    ? `${colors.success}15`
                    : `${colors.beeYellow}25`,
                  paddingHorizontal: 7,
                  paddingVertical: 3,
                  borderRadius: 5,
                }}
              >
                <Text
                  style={{
                    fontSize: 10,
                    fontFamily: fonts.bold,
                    color: isUrgent
                      ? colors.error
                      : isNew
                      ? colors.success
                      : colors.deepNavy,
                  }}
                >
                  {isUrgent ? "URGENT" : isNew ? "NEW" : "⭐"}
                </Text>
              </View>
            )}
          </View>

          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              paddingHorizontal: 12,
              paddingBottom: 10,
              gap: 8,
            }}
          >
            {job.salary ? (
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.bold,
                  color: colors.deepNavy,
                }}
                numberOfLines={1}
              >
                {job.salary}
                {job.salaryPeriod ? ` / ${job.salaryPeriod}` : ""}
              </Text>
            ) : (
              <Text
                style={{
                  fontSize: 11,
                  color: colors.warmGray,
                  fontFamily: fonts.regular,
                }}
              >
                {job.createdAt
                  ? new Date(job.createdAt.seconds * 1000).toLocaleDateString(
                      "en-US",
                      { month: "short", day: "numeric" },
                    )
                  : "Recently posted"}
              </Text>
            )}
            <TouchableOpacity
              style={[
                styles.applyButton,
                {
                  backgroundColor: colors.deepNavy,
                  paddingHorizontal: 10,
                  paddingVertical: 7,
                },
              ]}
              onPress={(e) => {
                e.stopPropagation();
                navigation.navigate("JobDetails", { id: job.id, job });
              }}
            >
              <Text
                style={[
                  styles.applyButtonText,
                  { color: colors.white, fontSize: 11 },
                ]}
              >
                {t.applyButton}
              </Text>
              <Icon name="arrow-forward" size={13} color={colors.white} />
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      );
    }

    // Desktop card — matches Jobs screen style
    return (
      <TouchableOpacity
        style={[styles.modernJobCard, { backgroundColor: colors.white }]}
        activeOpacity={0.8}
        onPress={() => navigation.navigate("JobDetails", { id: job.id, job })}
      >
        <View style={styles.badgesContainer}>
          {isNew && (
            <View
              style={[
                styles.statusBadge,
                { backgroundColor: `${colors.success}20` },
              ]}
            >
              <Text style={[styles.statusBadgeText, { color: colors.success }]}>
                NEW
              </Text>
            </View>
          )}
          {isUrgent && (
            <View
              style={[
                styles.statusBadge,
                { backgroundColor: `${colors.error}20` },
              ]}
            >
              <Text style={[styles.statusBadgeText, { color: colors.error }]}>
                URGENT
              </Text>
            </View>
          )}
          {job.featured && (
            <View
              style={[
                styles.statusBadge,
                { backgroundColor: `${colors.beeYellow}30` },
              ]}
            >
              <Text
                style={[styles.statusBadgeText, { color: colors.deepNavy }]}
              >
                ⭐ FEATURED
              </Text>
            </View>
          )}
        </View>

        <View style={styles.cardHeader}>
          <View style={styles.companyInfo}>
            <View
              style={[
                styles.companyAvatar,
                { backgroundColor: `${colors.deepNavy}10` },
              ]}
            >
              {job.companyLogo ? (
                <Image
                  source={{ uri: job.companyLogo }}
                  style={styles.companyLogoImage}
                />
              ) : (
                <Text
                  style={[
                    styles.companyInitialLarge,
                    { color: colors.deepNavy },
                  ]}
                >
                  {(job.company || "C").charAt(0).toUpperCase()}
                </Text>
              )}
            </View>
            <View style={styles.companyDetails}>
              <Text
                style={[styles.companyNameLarge, { color: colors.deepNavy }]}
                numberOfLines={1}
              >
                {job.company || "Company Name"}
              </Text>
              <View style={styles.companyMeta}>
                {job.industry && (
                  <Text style={[styles.metaText, { color: colors.warmGray }]}>
                    {job.industry}
                  </Text>
                )}
              </View>
            </View>
          </View>
          <TouchableOpacity
            style={styles.bookmarkButton}
            onPress={(e) => {
              e.stopPropagation();
              handleToggleBookmark(job.id);
            }}
          >
            <Icon name="bookmark" size={22} color={colors.beeYellow} />
          </TouchableOpacity>
        </View>

        <View style={styles.titleContainer}>
          <Text
            style={[styles.jobTitleModern, { color: colors.deepNavy }]}
            numberOfLines={2}
          >
            {job.title || "Job Title"}
          </Text>
          {job.category && (
            <View
              style={[
                styles.categoryPill,
                { backgroundColor: `${colors.softBlue}30` },
              ]}
            >
              <Text
                style={[styles.categoryPillText, { color: colors.deepNavy }]}
              >
                {job.category}
              </Text>
            </View>
          )}
        </View>

        <View style={styles.infoGrid}>
          <View style={styles.infoCell}>
            <View
              style={{
                width: 30,
                height: 30,
                borderRadius: 8,
                backgroundColor: "#6366F112",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon name="work-outline" size={16} color="#6366F1" />
            </View>
            <View style={styles.infoCellContent}>
              <Text style={[styles.infoCellLabel, { color: colors.warmGray }]}>
                Type
              </Text>
              <Text
                style={[styles.infoCellValue, { color: colors.deepNavy }]}
                numberOfLines={1}
              >
                {job.contractType || "Full-time"}
              </Text>
            </View>
          </View>
          <View style={styles.infoCell}>
            <View
              style={{
                width: 30,
                height: 30,
                borderRadius: 8,
                backgroundColor: "#6366F112",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon name="location-on" size={16} color="#6366F1" />
            </View>
            <View style={styles.infoCellContent}>
              <Text style={[styles.infoCellLabel, { color: colors.warmGray }]}>
                Location
              </Text>
              <Text
                style={[styles.infoCellValue, { color: colors.deepNavy }]}
                numberOfLines={1}
              >
                {job.isRemote ? "🌍 Remote" : job.location || "N/A"}
              </Text>
            </View>
          </View>
          <View style={styles.infoCell}>
            <View
              style={{
                width: 30,
                height: 30,
                borderRadius: 8,
                backgroundColor: "#6366F112",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon name="school" size={16} color="#6366F1" />
            </View>
            <View style={styles.infoCellContent}>
              <Text style={[styles.infoCellLabel, { color: colors.warmGray }]}>
                Experience
              </Text>
              <Text
                style={[styles.infoCellValue, { color: colors.deepNavy }]}
                numberOfLines={1}
              >
                {job.experienceLevel || "Not specified"}
              </Text>
            </View>
          </View>
          {job.deadline && (
            <View style={styles.infoCell}>
              <View
                style={{
                  width: 30,
                  height: 30,
                  borderRadius: 8,
                  backgroundColor: isUrgent ? "#EF444415" : "#6366F112",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name="event"
                  size={16}
                  color={isUrgent ? "#EF4444" : "#6366F1"}
                />
              </View>
              <View style={styles.infoCellContent}>
                <Text
                  style={[styles.infoCellLabel, { color: colors.warmGray }]}
                >
                  Deadline
                </Text>
                <Text
                  style={[
                    styles.infoCellValue,
                    { color: isUrgent ? colors.error : colors.deepNavy },
                  ]}
                  numberOfLines={1}
                >
                  {new Date(job.deadline).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                  })}
                </Text>
              </View>
            </View>
          )}
        </View>

        {job.salary && (
          <View
            style={[
              styles.salarySection,
              {
                backgroundColor: `${colors.beeYellow}15`,
                borderLeftColor: colors.beeYellow,
              },
            ]}
          >
            <Icon name="payments" size={20} color={colors.deepNavy} />
            <Text style={[styles.salaryAmount, { color: colors.deepNavy }]}>
              {job.salary}
            </Text>
            {job.salaryPeriod && (
              <Text style={[styles.salaryPeriod, { color: colors.warmGray }]}>
                / {job.salaryPeriod}
              </Text>
            )}
          </View>
        )}

        {job.skills && job.skills.length > 0 && (
          <View style={styles.skillsContainer}>
            <Text style={[styles.skillsLabel, { color: colors.warmGray }]}>
              Required Skills:
            </Text>
            <View style={styles.skillsRow}>
              {job.skills.slice(0, 4).map((skill: string, index: number) => (
                <View
                  key={index}
                  style={[
                    styles.skillTag,
                    { backgroundColor: `${colors.deepNavy}08` },
                  ]}
                >
                  <Text
                    style={[styles.skillTagText, { color: colors.deepNavy }]}
                  >
                    {skill}
                  </Text>
                </View>
              ))}
              {job.skills.length > 4 && (
                <View
                  style={[
                    styles.skillTag,
                    { backgroundColor: `${colors.warmGray}20` },
                  ]}
                >
                  <Text
                    style={[styles.skillTagText, { color: colors.warmGray }]}
                  >
                    +{job.skills.length - 4}
                  </Text>
                </View>
              )}
            </View>
          </View>
        )}

        {job.description && (
          <Text
            style={[styles.descriptionPreview, { color: colors.warmGray }]}
            numberOfLines={2}
          >
            {job.description}
          </Text>
        )}

        <View
          style={[
            styles.cardFooter,
            { borderTopColor: `${colors.lightGray}50` },
          ]}
        >
          <View style={styles.statsContainer}>
            <View style={styles.statChip}>
              <Icon name="visibility" size={14} color="#6366F1" />
              <Text style={[styles.statChipText, { color: colors.warmGray }]}>
                {job.views || 0}
              </Text>
            </View>
            <View style={styles.statChip}>
              <Icon name="people" size={14} color="#6366F1" />
              <Text style={[styles.statChipText, { color: colors.warmGray }]}>
                {job.applicationCount || 0} applied
              </Text>
            </View>
            <View style={styles.statChip}>
              <Icon name="schedule" size={14} color="#6366F1" />
              <Text style={[styles.statChipText, { color: colors.warmGray }]}>
                {job.createdAt
                  ? new Date(job.createdAt.seconds * 1000).toLocaleDateString(
                      "en-US",
                      { month: "short", day: "numeric" },
                    )
                  : "Recent"}
              </Text>
            </View>
          </View>
          <TouchableOpacity
            style={[styles.applyButton, { backgroundColor: colors.deepNavy }]}
            onPress={(e) => {
              e.stopPropagation();
              navigation.navigate("JobDetails", { id: job.id, job });
            }}
          >
            <Text style={[styles.applyButtonText, { color: colors.white }]}>
              {t.applyButton}
            </Text>
            <Icon name="arrow-forward" size={16} color={colors.white} />
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: pageBg }]}>
      {/* ── APP BAR (matches Jobs screen) ── */}
      <View
        style={[
          styles.jobsToolbar,
          { backgroundColor: bg, borderBottomColor: border },
        ]}
      >
        {isMobile ? (
          isSearchExpanded ? (
            /* Mobile search mode */
            <View
              style={{
                flex: 1,
                flexDirection: "row",
                alignItems: "center",
                gap: 12,
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  setIsSearchExpanded(false);
                  setSearchText("");
                }}
                hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
              >
                <Icon name="arrow-back" size={22} color={primary} />
              </TouchableOpacity>
              <TextInput
                style={{
                  flex: 1,
                  fontSize: 16,
                  fontFamily: fonts.regular,
                  color: primary,
                  padding: 0,
                }}
                placeholder="Search saved jobs…"
                placeholderTextColor={muted}
                value={searchText}
                onChangeText={setSearchText}
                autoFocus
                returnKeyType="search"
              />
              {searchText.length > 0 && (
                <TouchableOpacity
                  onPress={() => setSearchText("")}
                  hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
                >
                  <Icon name="close" size={20} color={muted} />
                </TouchableOpacity>
              )}
            </View>
          ) : (
            /* Mobile default */
            <>
              <View
                style={{
                  flex: 1,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <TouchableOpacity
                  onPress={() => setShowMobileMenu(true)}
                  hitSlop={{ top: 8, bottom: 8, left: 4, right: 8 }}
                >
                  <Icon name="menu" size={24} color={primary} />
                </TouchableOpacity>
                <View
                  style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
                >
                  <Image
                    source={require("./assets/favicon.png")}
                    style={{ width: 26, height: 26, borderRadius: 6 }}
                    resizeMode="contain"
                  />
                  <View>
                    <Text
                      style={{
                        fontSize: 17,
                        fontFamily: fonts.bold,
                        color: primary,
                        letterSpacing: 0.1,
                        lineHeight: 20,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: fonts.regular,
                          color: isDarkMode ? "#9CA3AF" : "#94A3B8",
                        }}
                      >
                        Nib
                      </Text>
                      Jobs
                    </Text>
                    <View
                      style={{
                        height: 2.5,
                        width: 32,
                        backgroundColor: "#F4C430",
                        borderRadius: 2,
                      }}
                    />
                  </View>
                </View>
              </View>
              <TouchableOpacity
                onPress={() => setIsSearchExpanded(true)}
                style={{ padding: 8 }}
                hitSlop={{ top: 4, bottom: 4, left: 4, right: 4 }}
              >
                <Icon name="search" size={22} color={muted} />
              </TouchableOpacity>
            </>
          )
        ) : (
          /* ── DESKTOP APP BAR (matches JobsScreen) ── */
          <>
            <View style={styles.jobsToolbarLeft}>
              <TouchableOpacity onPress={() => navigation.navigate("Home")}>
                <Image
                  source={require("./assets/favicon.png")}
                  style={styles.toolbarLogo}
                  resizeMode="contain"
                />
              </TouchableOpacity>

              <TouchableOpacity
                style={[styles.toolbarNavButton, { opacity: 0.6 }]}
                onPress={() => navigation.navigate("Jobs")}
              >
                <Text
                  style={[
                    styles.toolbarNavButtonText,
                    { color: colors.deepNavy },
                  ]}
                >
                  {t.navJobs}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.toolbarNavButton, { opacity: 0.6 }]}
                onPress={() => navigation.navigate("Companies")}
              >
                <Text
                  style={[
                    styles.toolbarNavButtonText,
                    { color: colors.deepNavy },
                  ]}
                >
                  {t.companies}
                </Text>
              </TouchableOpacity>
              {user && userData?.role === "user" && (
                <TouchableOpacity
                  style={[
                    styles.toolbarNavButton,
                    {
                      backgroundColor: "#374151",
                      paddingHorizontal: 16,
                      borderRadius: 8,
                    },
                  ]}
                  onPress={() => navigation.navigate("CompanyRegistration")}
                >
                  <Text
                    style={[
                      styles.toolbarNavButtonText,
                      { color: "#FFFFFF", fontWeight: "600" },
                    ]}
                  >
                    {t.cdPostJob}
                  </Text>
                </TouchableOpacity>
              )}
              {user &&
                userData?.role === "company" &&
                userData?.companyProfile && (
                  <TouchableOpacity
                    style={[
                      styles.toolbarNavButton,
                      {
                        backgroundColor: "#374151",
                        paddingHorizontal: 16,
                        borderRadius: 8,
                      },
                    ]}
                    onPress={() => navigation.navigate("CompanyDashboard")}
                  >
                    <Text
                      style={[
                        styles.toolbarNavButtonText,
                        { color: "#FFFFFF", fontWeight: "600" },
                      ]}
                    >
                      {t.cdPostJob}
                    </Text>
                  </TouchableOpacity>
                )}
              {user && (
                <View
                  style={{
                    width: 38,
                    height: 38,
                    borderRadius: 10,
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: 4,
                    borderBottomWidth: 3,
                    borderBottomColor: colors.beeYellow,
                  }}
                >
                  <Icon name="bookmark" size={22} color={colors.beeYellow} />
                </View>
              )}

              <View
                style={[
                  styles.toolbarSearchContainer,
                  { backgroundColor: colors.lightGray },
                ]}
              >
                <Icon name="search" size={18} color={colors.warmGray} />
                <TextInput
                  style={[
                    styles.toolbarSearchInput,
                    { color: colors.deepNavy },
                  ]}
                  placeholder="Search saved jobs..."
                  placeholderTextColor={colors.warmGray}
                  value={searchText}
                  onChangeText={setSearchText}
                  returnKeyType="search"
                />
              </View>
            </View>

            <View style={styles.jobsToolbarRight}>
              {/* Alerts & Language - Desktop only */}
              {user && (
                <NotificationsBell
                  navigation={navigation}
                  isDarkMode={isDarkMode}
                  currentLanguage={currentLanguage}
                />
              )}
              <DesktopLanguageSelector
                currentLanguage={currentLanguage}
                setCurrentLanguage={setCurrentLanguage}
                isDarkMode={isDarkMode}
              />
              <TouchableOpacity
                style={styles.toolbarThemeToggle}
                onPress={toggleTheme}
              >
                <View
                  style={[
                    styles.themeToggleTrack,
                    {
                      backgroundColor: isDarkMode
                        ? colors.deepNavy
                        : colors.lightGray,
                    },
                  ]}
                >
                  <Icon
                    name="wb-sunny"
                    size={14}
                    color={isDarkMode ? colors.warmGray : colors.beeYellow}
                    style={styles.themeToggleIconLeft}
                  />
                  <View
                    style={[
                      styles.themeToggleKnob,
                      { backgroundColor: colors.white },
                      isDarkMode && styles.themeToggleKnobActive,
                    ]}
                  >
                    <Icon
                      name={isDarkMode ? "nightlight-round" : "wb-sunny"}
                      size={12}
                      color={isDarkMode ? colors.deepNavy : colors.beeYellow}
                    />
                  </View>
                  <Icon
                    name="nightlight-round"
                    size={14}
                    color={isDarkMode ? colors.beeYellow : colors.warmGray}
                    style={styles.themeToggleIconRight}
                  />
                </View>
              </TouchableOpacity>
              {user ? (
                <UserMenu
                  navigation={navigation}
                  user={user}
                  userData={userData}
                  isDarkMode={isDarkMode}
                  currentLanguage={currentLanguage}
                />
              ) : (
                <>
                  <TouchableOpacity
                    style={[
                      styles.toolbarLoginButton,
                      { borderColor: colors.deepNavy },
                    ]}
                    onPress={() => navigation.navigate("Login")}
                  >
                    <Text
                      style={[
                        styles.toolbarLoginButtonText,
                        { color: colors.deepNavy },
                      ]}
                    >
                      Login
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={[
                      styles.toolbarSignupButton,
                      { backgroundColor: colors.beeYellow },
                    ]}
                    onPress={() => navigation.navigate("Signup")}
                  >
                    <Text
                      style={[
                        styles.toolbarSignupButtonText,
                        { color: colors.buttonTextOnYellow },
                      ]}
                    >
                      Sign Up
                    </Text>
                  </TouchableOpacity>
                </>
              )}
            </View>
          </>
        )}
      </View>

      {/* Language Dropdown */}
      {showLanguageMenu && !isMobile && (
        <View
          style={[
            styles.languageMenu,
            {
              backgroundColor: colors.white,
              borderColor: colors.lightGray,
              top: dropdownPosition.top,
              right: dropdownPosition.right,
            },
          ]}
        >
          {[
            { code: "en", label: "English" },
            { code: "am", label: "አማርኛ" },
            { code: "ti", label: "ትግርኛ" },
            { code: "or", label: "Afaan Oromoo" },
          ].map((lang) => (
            <TouchableOpacity
              key={lang.code}
              style={styles.languageMenuItem}
              onPress={() => {
                setCurrentLanguage && setCurrentLanguage(lang.code);
                setShowLanguageMenu(false);
              }}
            >
              <Text
                style={[
                  styles.languageMenuItemText,
                  { color: colors.deepNavy },
                  currentLanguage === lang.code &&
                    styles.languageMenuItemTextActive,
                ]}
              >
                {lang.label}
              </Text>
              {currentLanguage === lang.code && (
                <Icon name="check" size={18} color={colors.beeYellow} />
              )}
            </TouchableOpacity>
          ))}
        </View>
      )}

      {/* Mobile Drawer */}
      {showMobileMenu && (
        <MobileDrawer
          visible={showMobileMenu}
          onClose={() => setShowMobileMenu(false)}
          navigation={navigation}
          user={user}
          userData={userData}
          isDarkMode={isDarkMode}
          toggleTheme={toggleTheme}
          colors={colors}
          currentView="candidate"
          currentLanguage={currentLanguage}
        />
      )}

      {/* ── CONTENT ── */}
      <View
        style={{
          flex: 1,
          backgroundColor: pageBg,
          paddingHorizontal: isMobile ? 12 : 24,
          paddingTop: 16,
        }}
      >
        {loading ? (
          <InlineLoadingIndicator message="Loading…" isDarkMode={isDarkMode} />
        ) : filteredJobs.length === 0 ? (
          <ScrollView contentContainerStyle={{ paddingBottom: 100 }}>
            <View
              style={{
                alignItems: "center",
                paddingTop: 64,
                paddingBottom: 32,
              }}
            >
              <View
                style={{
                  width: 72,
                  height: 72,
                  borderRadius: 36,
                  backgroundColor: isDarkMode ? "#1A1D23" : "#F3F4F6",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 16,
                }}
              >
                <Icon name="bookmark-outline" size={34} color={muted} />
              </View>
              <Text
                style={{
                  fontSize: 17,
                  fontFamily: fonts.bold,
                  color: primary,
                  marginBottom: 6,
                }}
              >
                {searchText ? "No results" : "Nothing saved yet"}
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.regular,
                  color: muted,
                  textAlign: "center",
                  paddingHorizontal: 32,
                  lineHeight: 20,
                }}
              >
                {searchText
                  ? "Try a different search term."
                  : "Tap the bookmark icon on any job to save it here."}
              </Text>
              {!searchText && (
                <TouchableOpacity
                  onPress={() => navigation.navigate("Jobs")}
                  style={{
                    marginTop: 20,
                    backgroundColor: "#F4C430",
                    paddingVertical: 11,
                    paddingHorizontal: 24,
                    borderRadius: 10,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <Icon name="search" size={17} color="#1A1D23" />
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.semiBold || fonts.bold,
                      color: "#1A1D23",
                    }}
                  >
                    Browse Jobs
                  </Text>
                </TouchableOpacity>
              )}
            </View>
          </ScrollView>
        ) : (
          <FlatList
            data={filteredJobs}
            renderItem={renderJobCard}
            keyExtractor={(item: any) => item.id || String(Math.random())}
            numColumns={isMobile ? 1 : 3}
            key={isMobile ? "bm-mobile" : "bm-grid-3"}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={[
              styles.modernJobsGrid,
              { paddingBottom: 100 },
            ]}
            columnWrapperStyle={!isMobile ? styles.modernJobsRow : undefined}
          />
        )}
      </View>

      {/* Bottom Nav */}
      <BottomNavBar
        navigation={navigation}
        activeRoute="Bookmarks"
        isDarkMode={isDarkMode}
        user={user}
        userData={userData}
        currentLanguage={currentLanguage}
      />
    </SafeAreaView>
  );
}

// Settings Screen - Main Menu
function SettingsScreen({
  navigation,
  route,
  isDarkMode,
  toggleTheme,
  currentLanguage = "en",
  setCurrentLanguage,
}: any) {
  const [user, setUser] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [selectedMenu, setSelectedMenu] = useState<string>("");
  const [bookmarkedJobs, setBookmarkedJobs] = useState<string[]>([]);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const languageButtonRef = useRef<any>(null);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 0,
    right: 0,
  });
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState<string[]>(
    [],
  );
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;

  // Listen for dimension changes
  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  const colors = isDarkMode ? darkColors : lightColors;
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;

  // Function to update URL parameter
  const updateURLParam = (menu: string) => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const url = new URL(window.location.href);
      if (menu) {
        url.searchParams.set("section", menu);
      } else {
        url.searchParams.delete("section");
      }
      window.history.pushState({}, "", url);
    }
  };

  // Function to handle menu selection with URL update
  const handleMenuSelect = (menuId: string) => {
    if (menuId === "subscription") {
      navigation.navigate("SettingsSubscription");
    } else if (menuId === "interests") {
      navigation.navigate("SettingsInterests", {
        user: { uid: user?.uid, email: user?.email },
        userData: userData || {},
      });
    } else {
      setSelectedMenu(menuId);
      updateURLParam(menuId);
    }
  };

  // Function to handle menu close with URL update
  const handleMenuClose = () => {
    setSelectedMenu("");
    updateURLParam("");
  };

  // Handle logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      await AsyncStorage.removeItem("userToken");
      setShowLogoutModal(false);
      navigation.replace("Login");
    } catch (error) {
      console.error("Logout error:", error);
      Alert.alert("Error", "Failed to logout. Please try again.");
    }
  };

  // Read URL parameter or route params on mount
  useEffect(() => {
    const sectionFromParams = route?.params?.section;
    if (sectionFromParams) {
      setSelectedMenu(sectionFromParams);
      updateURLParam(sectionFromParams);
      return;
    }
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const url = new URL(window.location.href);
      const section = url.searchParams.get("section");
      if (section) {
        setSelectedMenu(section);
      }
    }
  }, []);

  // Listen for browser back/forward navigation
  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const handlePopState = () => {
        const url = new URL(window.location.href);
        const section = url.searchParams.get("section");
        setSelectedMenu(section || "");
      };

      window.addEventListener("popstate", handlePopState);
      return () => window.removeEventListener("popstate", handlePopState);
    }
  }, []);

  const languageOptions = [
    { code: "en", label: "English" },
    { code: "am", label: "አማርኛ" },
    { code: "ti", label: "ትግርኛ" },
    { code: "or", label: "Afaan Oromoo" },
  ];

  const getCurrentLanguage = () => {
    return (
      languageOptions.find((lang) => lang.code === currentLanguage) ||
      languageOptions[0]
    );
  };

  const toggleLanguageDropdown = () => {
    if (!showLanguageMenu && languageButtonRef.current) {
      languageButtonRef.current.measureInWindow(
        (x: number, y: number, width: number, height: number) => {
          setDropdownPosition({
            top: y + height + 5,
            right:
              typeof window !== "undefined" ? window.innerWidth - x - width : 0,
          });
        },
      );
    }
    setShowLanguageMenu(!showLanguageMenu);
  };

  const changeLanguage = async (langCode: string) => {
    if (setCurrentLanguage) setCurrentLanguage(langCode);
    setSelectedLanguage(
      languageOptions.find((lang) => lang.code === langCode)?.label ||
        "English",
    );
    setShowLanguageMenu(false);
    try {
      await AsyncStorage.setItem("selectedLanguage", langCode);
    } catch (error) {
      console.error("Error saving language preference:", error);
    }
  };

  useEffect(() => {
    const initializeSettings = async () => {
      // Load saved language label for display label for display
      const savedLanguage = await AsyncStorage.getItem("selectedLanguage");
      if (savedLanguage) {
        setSelectedLanguage(
          languageOptions.find((lang) => lang.code === savedLanguage)?.label ||
            "English",
        );
      }
    };

    initializeSettings();

    let authInitialized = false;
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      // First call may be null before persistence restores — wait before redirecting
      if (!authUser && !authInitialized) {
        authInitialized = true;
        // Give AsyncStorage persistence 500ms to restore the session
        await new Promise((resolve) => setTimeout(resolve, 500));
        // Check again after delay
        if (auth.currentUser) {
          // Session was restored, don't redirect
          return;
        }
      }

      if (authUser) {
        setUser(authUser);
        // Fetch user data
        const userDoc = await getDoc(doc(db, "users", authUser.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          setUserData(data);
          setBookmarkedJobs(data.savedJobs || []);

          // Preselect user's job interests if they exist
          if (data.interestedCategory) {
            setSelectedCategories([data.interestedCategory]);
          }
          if (
            data.interestedSubcategories &&
            data.interestedSubcategories.length > 0
          ) {
            setSelectedSubcategories(data.interestedSubcategories);
          }
          if (data.interestedTags && data.interestedTags.length > 0) {
            setSelectedTags(data.interestedTags);
          }
        }
      } else {
        navigation.replace("Login");
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const refetchUserData = async () => {
    if (user) {
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists()) {
        const data = userDoc.data();
        setUserData(data);
        setBookmarkedJobs(data.savedJobs || []);
      }
    }
  };

  const settingsMenuItems = [
    {
      id: "portfolio",
      title: t.settingsPortfolioLabel,
      subtitle: t.settingsPortfolioSubtitle,
      icon: "work",
      color: "#F4C430",
    },
    {
      id: "account",
      title: t.settingsAccountSection,
      subtitle: t.settingsAccountSubtitle,
      icon: "person",
      color: "#4A90E2",
    },
    {
      id: "interests",
      title: t.settingsJobInterestsLabel,
      subtitle: t.settingsJobInterestsSubtitle,
      icon: "favorite",
      color: "#E74C3C",
    },
    {
      id: "preferences",
      title: t.settingsPreferencesSection,
      subtitle: t.settingsPreferencesSubtitle,
      icon: "tune",
      color: "#9B59B6",
    },
    {
      id: "notifications",
      title: t.notifications,
      subtitle: t.settingsNotificationsSubtitle,
      icon: "notifications",
      color: "#E67E22",
    },
    {
      id: "privacy",
      title: t.settingsPrivacyLabel,
      subtitle: t.settingsPrivacySubtitle,
      icon: "security",
      color: "#27AE60",
    },
    ...(FEATURES.PRICING_ENABLED
      ? [
          {
            id: "subscription",
            title: t.settingsSubscriptionLabel,
            subtitle: (() => {
              const subscriptionId = (
                userData?.subscriptionId ||
                userData?.subscriptionPlan ||
                "free"
              ).toLowerCase();
              const plan =
                SUBSCRIPTION_PLANS.find((p) => p.id === subscriptionId) ||
                SUBSCRIPTION_PLANS[0];
              return plan.name;
            })(),
            icon: "card-membership",
            color: "#F4C430",
          },
        ]
      : []),
    {
      id: "help",
      title: t.settingsHelpLabel,
      subtitle: t.settingsHelpSubtitle,
      icon: "help",
      color: "#3498DB",
    },
  ];

  const renderSettingsContent = () => {
    const props = {
      userData,
      user,
      isDarkMode,
      toggleTheme,
      colors,
      navigation,
      currentLanguage,
      changeLanguage,
      refetchUserData,
    };

    switch (selectedMenu) {
      case "account":
        return <SettingsAccountContent {...props} />;
      case "interests":
        return <SettingsInterestsContent {...props} />;
      case "preferences":
        return <SettingsPreferencesContent {...props} />;
      case "notifications":
        return <SettingsNotificationsContent {...props} />;
      case "privacy":
        return <SettingsPrivacyContent {...props} />;
      case "subscription":
        return <SettingsSubscriptionContent {...props} />;
      case "help":
        return <SettingsHelpContent {...props} />;
      default:
        return <SettingsAccountContent {...props} />;
    }
  };

  // Drawer-style flat row helpers (scoped inside SettingsScreen)
  const settingsBg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const settingsSurface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const settingsBorder = isDarkMode ? "#1E2027" : "#F0F0F0";
  const settingsPrimary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const settingsMuted = isDarkMode ? "#6B7280" : "#9CA3AF";

  const SettingsRow = ({
    icon,
    iconColor,
    label,
    subtitle,
    onPress,
    danger = false,
  }: any) => (
    <TouchableOpacity
      onPress={onPress}
      style={{
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: 14,
        paddingHorizontal: 20,
        gap: 16,
      }}
      activeOpacity={0.6}
    >
      <View
        style={{
          width: 36,
          height: 36,
          borderRadius: 10,
          backgroundColor: danger ? "#FEF2F2" : `${iconColor}18`,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon name={icon} size={20} color={danger ? "#EF4444" : iconColor} />
      </View>
      <View style={{ flex: 1 }}>
        <Text
          style={{
            fontSize: 15,
            fontFamily: fonts.medium,
            color: danger ? "#EF4444" : settingsPrimary,
          }}
        >
          {label}
        </Text>
        {subtitle ? (
          <Text
            style={{
              fontSize: 12,
              fontFamily: fonts.regular,
              color: settingsMuted,
              marginTop: 1,
            }}
          >
            {subtitle}
          </Text>
        ) : null}
      </View>
      <Icon name="chevron-right" size={18} color={settingsBorder} />
    </TouchableOpacity>
  );
  const SettingsDivider = () => (
    <View
      style={{
        height: 1,
        backgroundColor: settingsBorder,
        marginLeft: 20 + 36 + 16,
      }}
    />
  );
  const SettingsSectionLabel = ({ label }: any) => (
    <Text
      style={{
        fontSize: 11,
        fontFamily: fonts.medium,
        color: settingsMuted,
        letterSpacing: 0.8,
        textTransform: "uppercase",
        paddingHorizontal: 20,
        paddingTop: 24,
        paddingBottom: 8,
      }}
    >
      {label}
    </Text>
  );

  return (
    <SafeAreaView
      style={[
        styles.container,
        { backgroundColor: isDarkMode ? "#0F1117" : "#F9FAFB" },
      ]}
    >
      {/* ── APP BAR ── */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: 16,
          paddingVertical: 12,
          backgroundColor: settingsBg,
          borderBottomWidth: 1,
          borderBottomColor: settingsBorder,
        }}
      >
        {isMobile ? (
          <>
            <TouchableOpacity
              onPress={() => setShowMobileMenu(true)}
              hitSlop={{ top: 8, bottom: 8, left: 4, right: 8 }}
            >
              <Icon name="menu" size={24} color={settingsPrimary} />
            </TouchableOpacity>
            <View
              style={{
                flex: 1,
                flexDirection: "row",
                alignItems: "center",
                gap: 8,
                marginLeft: 10,
              }}
            >
              <Image
                source={require("./assets/favicon.png")}
                style={{ width: 26, height: 26, borderRadius: 6 }}
                resizeMode="contain"
              />
              <View>
                <Text
                  style={{
                    fontSize: 17,
                    fontFamily: fonts.bold,
                    color: settingsPrimary,
                    letterSpacing: 0.1,
                    lineHeight: 20,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: fonts.regular,
                      color: isDarkMode ? "#9CA3AF" : "#94A3B8",
                    }}
                  >
                    Nib
                  </Text>
                  Jobs
                </Text>
                <View
                  style={{
                    height: 2.5,
                    width: 32,
                    backgroundColor: "#F4C430",
                    borderRadius: 2,
                  }}
                />
              </View>
            </View>
          </>
        ) : (
          <>
            <TouchableOpacity onPress={() => navigation.navigate("Home")}>
              <Image
                source={require("./assets/favicon.png")}
                style={styles.toolbarLogo}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.toolbarNavButton, { opacity: 0.6 }]}
              onPress={() => navigation.navigate("Jobs")}
            >
              <Text
                style={[
                  styles.toolbarNavButtonText,
                  { color: colors.deepNavy },
                ]}
              >
                {t.navJobs}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.toolbarNavButton, { opacity: 0.6 }]}
              onPress={() => navigation.navigate("Companies")}
            >
              <Text
                style={[
                  styles.toolbarNavButtonText,
                  { color: colors.deepNavy },
                ]}
              >
                {t.companies}
              </Text>
            </TouchableOpacity>
            {user && (
              <TouchableOpacity
                style={[styles.toolbarNavButton, styles.toolbarBookmarksButton]}
                onPress={() => navigation.navigate("Bookmarks")}
              >
                <Icon name="bookmark" size={18} color={colors.beeYellow} />
                <Text
                  style={[
                    styles.toolbarNavButtonText,
                    { color: colors.deepNavy, marginLeft: 4 },
                  ]}
                >
                  {t.bookmarks}
                </Text>
              </TouchableOpacity>
            )}
            <View style={{ flex: 1 }} />
            {/* Desktop: subscription badge — hidden behind PRICING_ENABLED */}
            {FEATURES.PRICING_ENABLED &&
              user &&
              (() => {
                const subId = (
                  userData?.subscriptionId ||
                  userData?.subscriptionPlan ||
                  "free"
                ).toLowerCase();
                const plan =
                  SUBSCRIPTION_PLANS.find((p) => p.id === subId) ||
                  SUBSCRIPTION_PLANS[0];
                const badgeColors: Record<
                  string,
                  { bg: string; text: string }
                > = {
                  free: { bg: "#6B7280", text: "#FFF" },
                  standard: { bg: "#D97706", text: "#FFF" },
                  enterprise: { bg: "#1E3A8A", text: "#FFF" },
                };
                const bc = badgeColors[plan.id] || badgeColors.free;
                return (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        backgroundColor: bc.bg,
                        paddingHorizontal: 12,
                        paddingVertical: 6,
                        borderRadius: 16,
                        gap: 5,
                      }}
                    >
                      <Icon name={plan.icon} size={14} color={bc.text} />
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: fonts.bold,
                          color: bc.text,
                        }}
                      >
                        {plan.name}
                      </Text>
                    </View>
                    {plan.id === "free" && (
                      <TouchableOpacity
                        onPress={() =>
                          navigation.navigate("SettingsSubscription")
                        }
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          backgroundColor: "#10B981",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 16,
                          gap: 5,
                        }}
                      >
                        <Icon name="arrow-upward" size={14} color="#FFF" />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.bold,
                            color: "#FFF",
                          }}
                        >
                          Upgrade
                        </Text>
                      </TouchableOpacity>
                    )}
                  </View>
                );
              })()}
          </>
        )}
      </View>

      {/* Mobile Drawer */}
      {showMobileMenu && isMobile && (
        <MobileDrawer
          visible={showMobileMenu}
          onClose={() => setShowMobileMenu(false)}
          navigation={navigation}
          user={user}
          userData={userData}
          isDarkMode={isDarkMode}
          toggleTheme={toggleTheme}
          colors={colors}
          currentView="candidate"
          currentLanguage={currentLanguage}
        />
      )}

      {loading ? (
        <ModernLoadingScreen
          message="Loading profile..."
          isDarkMode={isDarkMode}
        />
      ) : (
        <View style={{ flex: 1, flexDirection: isMobile ? "column" : "row" }}>
          {/* ── LEFT PANEL: profile card (desktop sidebar / mobile compact row) ── */}
          <View
            style={{
              width: isMobile ? "100%" : 280,
              backgroundColor: settingsBg,
              borderRightWidth: isMobile ? 0 : 1,
              borderRightColor: settingsBorder,
              borderBottomWidth: isMobile ? 1 : 0,
              borderBottomColor: settingsBorder,
            }}
          >
            {isMobile ? (
              /* ── Mobile: single compact horizontal row ── */
              <TouchableOpacity
                onPress={() => handleMenuSelect("account")}
                activeOpacity={0.7}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  paddingHorizontal: 20,
                  paddingVertical: 14,
                  gap: 14,
                }}
              >
                {/* Avatar */}
                <View style={{ position: "relative" }}>
                  {userData?.profilePicture ? (
                    <Image
                      source={{ uri: userData.profilePicture }}
                      style={{ width: 48, height: 48, borderRadius: 24 }}
                    />
                  ) : (
                    <View
                      style={{
                        width: 48,
                        height: 48,
                        borderRadius: 24,
                        backgroundColor: "#F4C430",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 20,
                          fontFamily: fonts.bold,
                          color: "#1A1D23",
                        }}
                      >
                        {(userData?.displayName ||
                          user?.email ||
                          "U")[0].toUpperCase()}
                      </Text>
                    </View>
                  )}
                </View>
                {/* Name + email */}
                <View style={{ flex: 1, minWidth: 0 }}>
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.bold,
                      color: settingsPrimary,
                    }}
                    numberOfLines={1}
                  >
                    {userData?.displayName ||
                      user?.email?.split("@")[0] ||
                      "User"}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.regular,
                      color: settingsMuted,
                      marginTop: 1,
                    }}
                    numberOfLines={1}
                  >
                    {user?.email}
                  </Text>
                </View>
                {/* Edit chip */}
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 4,
                    paddingHorizontal: 12,
                    paddingVertical: 6,
                    borderRadius: 20,
                    backgroundColor: "#F4C430",
                  }}
                >
                  <Icon name="edit" size={13} color="#1A1D23" />
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      color: "#1A1D23",
                    }}
                  >
                    {t.editChipLabel}
                  </Text>
                </View>
              </TouchableOpacity>
            ) : (
              /* ── Desktop: tall centered card ── */
              <View
                style={{
                  alignItems: "center",
                  paddingVertical: 28,
                  paddingHorizontal: 20,
                }}
              >
                <View style={{ position: "relative", marginBottom: 14 }}>
                  {userData?.profilePicture ? (
                    <Image
                      source={{ uri: userData.profilePicture }}
                      style={{ width: 80, height: 80, borderRadius: 40 }}
                    />
                  ) : (
                    <View
                      style={{
                        width: 80,
                        height: 80,
                        borderRadius: 40,
                        backgroundColor: "#F4C430",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 32,
                          fontFamily: fonts.bold,
                          color: "#1A1D23",
                        }}
                      >
                        {(userData?.displayName ||
                          user?.email ||
                          "U")[0].toUpperCase()}
                      </Text>
                    </View>
                  )}
                  <TouchableOpacity
                    onPress={() => handleMenuSelect("account")}
                    style={{
                      position: "absolute",
                      bottom: 0,
                      right: 0,
                      width: 26,
                      height: 26,
                      borderRadius: 13,
                      backgroundColor: "#F4C430",
                      alignItems: "center",
                      justifyContent: "center",
                      borderWidth: 2,
                      borderColor: settingsBg,
                    }}
                  >
                    <Icon name="edit" size={13} color="#1A1D23" />
                  </TouchableOpacity>
                </View>
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: fonts.bold,
                    color: settingsPrimary,
                    textAlign: "center",
                  }}
                  numberOfLines={1}
                >
                  {userData?.displayName ||
                    user?.email?.split("@")[0] ||
                    "User"}
                </Text>
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.regular,
                    color: settingsMuted,
                    marginTop: 3,
                    textAlign: "center",
                  }}
                  numberOfLines={1}
                >
                  {user?.email}
                </Text>
                <View
                  style={{
                    flexDirection: "row",
                    gap: 8,
                    marginTop: 12,
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  <View
                    style={{
                      paddingHorizontal: 10,
                      paddingVertical: 4,
                      borderRadius: 12,
                      backgroundColor: settingsSurface,
                      borderWidth: 1,
                      borderColor: settingsBorder,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: fonts.medium,
                        color: settingsMuted,
                      }}
                    >
                      {userData?.role === "company"
                        ? "Company"
                        : t.jobSeekerLabel}
                    </Text>
                  </View>
                  {bookmarkedJobs.length > 0 && (
                    <View
                      style={{
                        paddingHorizontal: 10,
                        paddingVertical: 4,
                        borderRadius: 12,
                        backgroundColor: "#F4C43018",
                        borderWidth: 1,
                        borderColor: "#F4C43033",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.medium,
                          color: "#92620A",
                        }}
                      >
                        {bookmarkedJobs.length} {t.savedJobsCount}
                      </Text>
                    </View>
                  )}
                </View>
                <TouchableOpacity
                  onPress={() => handleMenuSelect("account")}
                  style={{
                    marginTop: 16,
                    paddingVertical: 9,
                    paddingHorizontal: 24,
                    borderRadius: 10,
                    backgroundColor: "#F4C430",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <Icon name="edit" size={15} color="#1A1D23" />
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.semiBold,
                      color: "#1A1D23",
                    }}
                  >
                    {t.editProfileButton}
                  </Text>
                </TouchableOpacity>
              </View>
            )}
          </View>

          {/* ── RIGHT PANEL: settings list ── */}
          <ScrollView
            style={{
              flex: 1,
              backgroundColor: isDarkMode ? "#0F1117" : "#F9FAFB",
            }}
            showsVerticalScrollIndicator={false}
          >
            {/* Account section */}
            <SettingsSectionLabel label={t.settingsAccountSection} />
            <View
              style={{
                backgroundColor: settingsBg,
                borderTopWidth: 1,
                borderBottomWidth: 1,
                borderColor: settingsBorder,
              }}
            >
              <SettingsRow
                icon="work"
                iconColor="#F4C430"
                label={t.settingsPortfolioLabel}
                subtitle={t.settingsPortfolioSubtitle}
                onPress={() => handleMenuSelect("portfolio")}
              />
              <SettingsDivider />
              <SettingsRow
                icon="person-outline"
                iconColor="#4A90E2"
                label={t.settingsAccountSection}
                subtitle={t.settingsAccountSubtitle}
                onPress={() => handleMenuSelect("account")}
              />
              <SettingsDivider />
              <SettingsRow
                icon="favorite-border"
                iconColor="#E74C3C"
                label={t.settingsJobInterestsLabel}
                subtitle={t.settingsJobInterestsSubtitle}
                onPress={() => handleMenuSelect("interests")}
              />
              <SettingsDivider />
              <SettingsRow
                icon="notifications-none"
                iconColor="#E67E22"
                label={t.notifications}
                subtitle={t.settingsNotificationsSubtitle}
                onPress={() => handleMenuSelect("notifications")}
              />
            </View>

            {/* Preferences section */}
            <SettingsSectionLabel label={t.settingsPreferencesSection} />
            <View
              style={{
                backgroundColor: settingsBg,
                borderTopWidth: 1,
                borderBottomWidth: 1,
                borderColor: settingsBorder,
              }}
            >
              <SettingsRow
                icon="tune"
                iconColor="#9B59B6"
                label={t.settingsPreferencesSection}
                subtitle={t.settingsPreferencesSubtitle}
                onPress={() => handleMenuSelect("preferences")}
              />
              <SettingsDivider />
              <SettingsRow
                icon="security"
                iconColor="#27AE60"
                label={t.settingsPrivacyLabel}
                subtitle={t.settingsPrivacySubtitle}
                onPress={() => handleMenuSelect("privacy")}
              />
              <SettingsDivider />
              {FEATURES.PRICING_ENABLED && (
                <>
                  <SettingsRow
                    icon="card-membership"
                    iconColor="#F4C430"
                    label={t.settingsSubscriptionLabel}
                    subtitle={(() => {
                      const id = (
                        userData?.subscriptionId ||
                        userData?.subscriptionPlan ||
                        "free"
                      ).toLowerCase();
                      return (
                        SUBSCRIPTION_PLANS.find((p) => p.id === id)?.name ||
                        "Free"
                      );
                    })()}
                    onPress={() => handleMenuSelect("subscription")}
                  />
                  <SettingsDivider />
                </>
              )}
              <SettingsRow
                icon="help-outline"
                iconColor="#3498DB"
                label={t.settingsHelpLabel}
                subtitle={t.settingsHelpSubtitle}
                onPress={() => handleMenuSelect("help")}
              />
            </View>

            {/* Sign out */}
            <SettingsSectionLabel label={t.settingsAccountActionsSection} />
            <View
              style={{
                backgroundColor: settingsBg,
                borderTopWidth: 1,
                borderBottomWidth: 1,
                borderColor: settingsBorder,
              }}
            >
              <SettingsRow
                icon="logout"
                iconColor="#EF4444"
                label={t.logout}
                subtitle={t.settingsLogoutSubtitle}
                danger
                onPress={() => setShowLogoutModal(true)}
              />
            </View>

            <View style={{ height: 40 }} />
          </ScrollView>
        </View>
      )}

      {/* Settings Detail Modal */}
      <Modal
        visible={
          selectedMenu !== "" &&
          selectedMenu !== "account" &&
          selectedMenu !== "portfolio"
        }
        animationType="slide"
        presentationStyle="pageSheet"
        onRequestClose={handleMenuClose}
      >
        <SafeAreaView
          style={[
            styles.container,
            { backgroundColor: isDarkMode ? "#0F1117" : "#FFFFFF" },
          ]}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              paddingHorizontal: 16,
              paddingVertical: 14,
              backgroundColor: isDarkMode ? "#0F1117" : "#FFFFFF",
              borderBottomWidth: 1,
              borderBottomColor: isDarkMode ? "#1E2027" : "#F0F0F0",
            }}
          >
            <TouchableOpacity
              onPress={handleMenuClose}
              hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
            >
              <Icon
                name="close"
                size={22}
                color={isDarkMode ? "#F9FAFB" : "#1A1D23"}
              />
            </TouchableOpacity>
            <Text
              style={{
                flex: 1,
                fontSize: 18,
                fontFamily: fonts.bold,
                color: isDarkMode ? "#F9FAFB" : "#1A1D23",
                marginLeft: 12,
                letterSpacing: -0.3,
              }}
            >
              {
                settingsMenuItems.find((item) => item.id === selectedMenu)
                  ?.title
              }
            </Text>
            <View style={{ width: 30 }} />
          </View>
          <View style={{ flex: 1 }}>{renderSettingsContent()}</View>
        </SafeAreaView>
      </Modal>

      {/* Portfolio Settings (Full Page) */}
      {selectedMenu === "portfolio" && (
        <Modal
          visible={true}
          animationType="slide"
          presentationStyle="fullScreen"
          onRequestClose={handleMenuClose}
        >
          <SafeAreaView
            style={[styles.container, { backgroundColor: colors.cream }]}
          >
            <View
              style={[
                styles.settingsModalHeader,
                {
                  backgroundColor: colors.white,
                  borderBottomColor: colors.lightGray,
                },
              ]}
            >
              <TouchableOpacity
                onPress={handleMenuClose}
                style={styles.settingsModalBackButton}
              >
                <Icon name="arrow-back" size={24} color={colors.deepNavy} />
              </TouchableOpacity>
              <Text
                style={[styles.settingsModalTitle, { color: colors.deepNavy }]}
              >
                Portfolio
              </Text>
              <View style={{ width: 40 }} />
            </View>
            <ScrollView
              style={{ flex: 1 }}
              showsVerticalScrollIndicator={false}
            >
              <SettingsPortfolioContent
                {...{ userData, user, colors, navigation, currentLanguage }}
              />
            </ScrollView>
          </SafeAreaView>
        </Modal>
      )}

      {/* Account Settings (Full Page) */}
      {selectedMenu === "account" && (
        <Modal
          visible={true}
          animationType="slide"
          presentationStyle="fullScreen"
          onRequestClose={handleMenuClose}
        >
          <SafeAreaView
            style={[
              styles.container,
              { backgroundColor: isDarkMode ? "#0F1117" : "#F9FAFB" },
            ]}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                paddingHorizontal: 16,
                paddingVertical: 14,
                backgroundColor: isDarkMode ? "#0F1117" : "#FFFFFF",
                borderBottomWidth: 1,
                borderBottomColor: isDarkMode ? "#1E2027" : "#F0F0F0",
              }}
            >
              <TouchableOpacity
                onPress={handleMenuClose}
                hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
              >
                <Icon
                  name="arrow-back"
                  size={22}
                  color={isDarkMode ? "#F9FAFB" : "#1A1D23"}
                />
              </TouchableOpacity>
              <Text
                style={{
                  flex: 1,
                  fontSize: 18,
                  fontFamily: fonts.bold,
                  color: isDarkMode ? "#F9FAFB" : "#1A1D23",
                  marginLeft: 12,
                  letterSpacing: -0.3,
                }}
              >
                {t.accountSettingsTitle}
              </Text>
            </View>
            <SettingsAccountContent
              {...{
                userData,
                user,
                isDarkMode,
                toggleTheme,
                colors,
                navigation,
                currentLanguage,
              }}
            />
          </SafeAreaView>
        </Modal>
      )}

      {/* Language dropdown overlay (same as JobsScreen) */}
      {showLanguageMenu && (
        <View style={styles.fullScreenDropdownOverlay}>
          <TouchableOpacity
            style={styles.fullScreenTouchArea}
            onPress={() => setShowLanguageMenu(false)}
            activeOpacity={1}
          />
          <View
            style={[
              styles.absoluteLanguageDropdown,
              { top: dropdownPosition.top, right: dropdownPosition.right },
            ]}
          >
            {languageOptions.map((language, index) => (
              <TouchableOpacity
                key={language.code}
                style={[
                  styles.languageOption,
                  currentLanguage === language.code &&
                    styles.languageOptionActive,
                  index === languageOptions.length - 1 && {
                    borderBottomWidth: 0,
                  },
                ]}
                onPress={() => changeLanguage(language.code)}
              >
                <Text style={styles.languageLabel}>{language.label}</Text>
                {currentLanguage === language.code && (
                  <Icon name="check" size={16} color={colors.beeYellow} />
                )}
              </TouchableOpacity>
            ))}
          </View>
        </View>
      )}

      {/* Bottom Navigation Bar */}
      <BottomNavBar
        navigation={navigation}
        activeRoute="Settings"
        isDarkMode={isDarkMode}
        user={user}
        userData={userData}
        currentLanguage={currentLanguage}
      />

      {/* Logout Confirmation Modal */}
      <LogoutConfirmationModal
        visible={showLogoutModal}
        onConfirm={handleLogout}
        onCancel={() => setShowLogoutModal(false)}
        isDarkMode={isDarkMode}
        currentLanguage={currentLanguage}
      />
    </SafeAreaView>
  );
}

// Settings Content Components

// Shared emoji-to-icon-name helper (used by multiple settings components)
const getIconFromEmoji = (emoji: string): string => {
  const emojiIconMap: { [key: string]: string } = {
    "💻": "computer",
    "📱": "phone-android",
    "📢": "trending-up",
    "💰": "attach-money",
    "🏥": "local-hospital",
    "🎓": "school",
    "🌍": "public",
    "🏢": "business",
    "🔧": "build",
    "🎨": "palette",
    "📊": "bar-chart",
    "🚀": "rocket-launch",
    "💼": "work",
    "📁": "folder",
    "⚙️": "settings",
    "🛠️": "handyman",
  };
  return emojiIconMap[emoji] || "category";
};

// Settings Interests Content Component
function SettingsInterestsContent({
  userData,
  user,
  colors,
  isDarkMode,
  refetchUserData,
  currentLanguage = "en",
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [categories, setCategories] = useState<any[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>(
    userData?.interestedCategory || "",
  );
  const [selectedSubcategories, setSelectedSubcategories] = useState<string[]>(
    userData?.interestedSubcategories || [],
  );
  const [selectedTags, setSelectedTags] = useState<string[]>(
    userData?.interestedTags || [],
  );
  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(
    new Set(),
  );
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tagSearch, setTagSearch] = useState<string>("");

  useEffect(() => {
    fetchCategories();
  }, []);

  // Sync local state when parent's userData refreshes (e.g. after save + refetch)
  useEffect(() => {
    if (userData) {
      setSelectedCategory(userData.interestedCategory || "");
      setSelectedSubcategories(userData.interestedSubcategories || []);
      setSelectedTags(userData.interestedTags || []);
    }
  }, [userData]);

  useEffect(() => {
    // Auto-expand selected category
    if (selectedCategory) {
      setExpandedCategories(new Set([selectedCategory]));
    }
  }, [selectedCategory]);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const categoriesCollection = collection(db, "categories");
      const categoriesSnapshot = await getDocs(categoriesCollection);
      const categoriesData = categoriesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(categoriesData);
    } catch (error) {
      console.error("Error fetching categories:", error);
      Alert.alert("Error", "Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  const getSubcategories = (parentPath: string) => {
    return categories.filter((cat) => cat.parentPath === parentPath);
  };

  const getAllTagsForCategory = (categoryPath: string) => {
    const category = categories.find((c) => c.path === categoryPath);
    const subcategories = getSubcategories(categoryPath);

    let allTags: string[] = [];
    if (category?.tags) {
      allTags = [...category.tags];
    }
    subcategories.forEach((subcat) => {
      if (subcat.tags) {
        allTags = [...allTags, ...subcat.tags];
      }
    });

    // Remove duplicates - no limit with Algolia
    const uniqueTags = [...new Set(allTags)];
    return uniqueTags;
  };

  const toggleCategory = (categoryPath: string) => {
    const newExpanded = new Set(expandedCategories);
    if (newExpanded.has(categoryPath)) {
      newExpanded.delete(categoryPath);
    } else {
      newExpanded.add(categoryPath);
    }
    setExpandedCategories(newExpanded);

    // Only allow one category selection
    if (selectedCategory === categoryPath) {
      setSelectedCategory("");
      setSelectedSubcategories([]);
      setSelectedTags([]);
      setTagSearch("");
    } else {
      setSelectedCategory(categoryPath);
      // Clear subcategories and tags from previous category
      setSelectedSubcategories([]);
      setSelectedTags([]);
      setTagSearch("");
    }
  };

  const toggleSubcategory = (subcategoryPath: string) => {
    const isSelected = selectedSubcategories.includes(subcategoryPath);
    const nextSubcategories = isSelected
      ? selectedSubcategories.filter((s) => s !== subcategoryPath)
      : [...selectedSubcategories, subcategoryPath];
    setSelectedSubcategories(nextSubcategories);

    const sub = categories.find((c) => c.path === subcategoryPath);
    const subTags: string[] = sub?.tags || [];
    if (subTags.length === 0) return;

    if (isSelected) {
      // Keep tags still covered by the category or remaining selected subcategories
      const coveredTags = new Set<string>();
      if (selectedCategory) {
        const cat = categories.find((c) => c.path === selectedCategory);
        if (cat?.tags) cat.tags.forEach((t: string) => coveredTags.add(t));
      }
      nextSubcategories.forEach((subPath) => {
        const s = categories.find((c) => c.path === subPath);
        if (s?.tags) s.tags.forEach((t: string) => coveredTags.add(t));
      });
      setSelectedTags((prev) =>
        prev.filter((t) => !subTags.includes(t) || coveredTags.has(t)),
      );
    } else {
      // Auto-select every tag under this subcategory as a preference
      setSelectedTags((prev) => Array.from(new Set([...prev, ...subTags])));
    }
  };

  const toggleTag = (tag: string) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag));
    } else {
      // No limit with Algolia!
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const clearAllInterests = () => {
    setSelectedCategory("");
    setSelectedSubcategories([]);
    setSelectedTags([]);
    setTagSearch("");
    setExpandedCategories(new Set());
  };

  const saveInterests = async () => {
    if (!user) return;

    if (!selectedCategory) {
      Alert.alert("Required", "Please select at least one category.");
      return;
    }

    try {
      setSaving(true);
      await updateDoc(doc(db, "users", user.uid), {
        interestedCategory: selectedCategory,
        interestedSubcategories: selectedSubcategories,
        interestedTags: selectedTags,
      });
      if (refetchUserData) await refetchUserData();
      Alert.alert("Success", "Your job interests have been saved!");
    } catch (error) {
      console.error("Error saving interests:", error);
      Alert.alert("Error", "Failed to save interests");
    } finally {
      setSaving(false);
    }
  };

  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const accent = "#F4C430";

  if (loading) {
    return (
      <InlineLoadingIndicator
        message="Loading categories..."
        isDarkMode={isDarkMode}
      />
    );
  }

  const selectedCategoryData = categories.find(
    (c) => c.path === selectedCategory,
  );
  const selectedSubcategoriesData = selectedSubcategories
    .map((path) => categories.find((c) => c.path === path))
    .filter(Boolean);

  return (
    <View
      style={{ flex: 1, backgroundColor: isDarkMode ? "#0F1117" : "#F9FAFB" }}
    >
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 100 }}
      >
        {/* Header */}
        <View
          style={{ paddingHorizontal: 20, paddingTop: 20, paddingBottom: 12 }}
        >
          <Text
            style={{
              fontSize: 15,
              color: muted,
              fontFamily: fonts.regular,
              lineHeight: 20,
            }}
          >
            {t.interestsHintText}
          </Text>
        </View>

        {/* Current Selections Display */}
        {(selectedCategory ||
          selectedSubcategories.length > 0 ||
          selectedTags.length > 0) && (
          <>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                paddingHorizontal: 20,
                paddingTop: 8,
                paddingBottom: 8,
              }}
            >
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: fonts.medium,
                  color: muted,
                  letterSpacing: 0.8,
                  textTransform: "uppercase",
                }}
              >
                {t.yourInterestsSection}
              </Text>
              <TouchableOpacity onPress={clearAllInterests}>
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.medium,
                    color: "#E11D48",
                  }}
                >
                  Clear all
                </Text>
              </TouchableOpacity>
            </View>
            <View
              style={{
                backgroundColor: bg,
                borderTopWidth: 1,
                borderBottomWidth: 1,
                borderColor: border,
                paddingHorizontal: 20,
                paddingVertical: 16,
              }}
            >
              {selectedCategory && (
                <View
                  style={{
                    marginBottom:
                      selectedSubcategories.length > 0 ||
                      selectedTags.length > 0
                        ? 12
                        : 0,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      color: muted,
                      marginBottom: 6,
                    }}
                  >
                    {t.categoryLabel}
                  </Text>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      backgroundColor: accent,
                      paddingHorizontal: 12,
                      paddingVertical: 7,
                      borderRadius: 8,
                      alignSelf: "flex-start",
                      gap: 6,
                    }}
                  >
                    {selectedCategoryData?.icon && (
                      <Icon
                        name={selectedCategoryData.icon}
                        size={14}
                        color="#1A1D23"
                      />
                    )}
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.bold,
                        color: "#1A1D23",
                      }}
                    >
                      {selectedCategoryData?.name || selectedCategory}
                    </Text>
                  </View>
                </View>
              )}
              {selectedSubcategories.length > 0 && (
                <View
                  style={{ marginBottom: selectedTags.length > 0 ? 12 : 0 }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      color: muted,
                      marginBottom: 6,
                    }}
                  >
                    {t.subcategoriesLabel} ({selectedSubcategories.length})
                  </Text>
                  <View
                    style={{ flexDirection: "row", flexWrap: "wrap", gap: 6 }}
                  >
                    {selectedSubcategoriesData.map(
                      (subcat: any, idx: number) => (
                        <View
                          key={idx}
                          style={{
                            backgroundColor: isDarkMode ? "#2A2D35" : "#EEF2FF",
                            paddingHorizontal: 10,
                            paddingVertical: 5,
                            borderRadius: 6,
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 12,
                              color: isDarkMode ? "#A5B4FC" : "#4F46E5",
                              fontFamily: fonts.medium,
                            }}
                          >
                            {subcat?.name || selectedSubcategories[idx]}
                          </Text>
                        </View>
                      ),
                    )}
                  </View>
                </View>
              )}
              {selectedTags.length > 0 && (
                <View>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      color: muted,
                      marginBottom: 6,
                    }}
                  >
                    {t.tagsLabel} ({selectedTags.length})
                  </Text>
                  <View
                    style={{ flexDirection: "row", flexWrap: "wrap", gap: 6 }}
                  >
                    {selectedTags.map((tag, idx) => (
                      <View
                        key={idx}
                        style={{
                          backgroundColor: surface,
                          paddingHorizontal: 10,
                          paddingVertical: 5,
                          borderRadius: 6,
                          borderWidth: 1,
                          borderColor: border,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 11,
                            color: primary,
                            fontFamily: fonts.medium,
                          }}
                        >
                          {tag}
                        </Text>
                      </View>
                    ))}
                  </View>
                </View>
              )}
            </View>
          </>
        )}

        {/* Categories Section Label */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.categoryLabel}
        </Text>

        {/* Main Categories */}
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {categories
            .filter((cat) => cat.level === 0)
            .map((category, catIndex, arr) => {
              const subcategories = getSubcategories(category.path);
              const isExpanded = expandedCategories.has(category.path);
              const isSelected = selectedCategory === category.path;
              const isLast = catIndex === arr.length - 1;

              return (
                <View key={category.id}>
                  {/* Main Category Row */}
                  <TouchableOpacity
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      paddingVertical: 14,
                      paddingHorizontal: 20,
                      gap: 14,
                      backgroundColor: isSelected
                        ? isDarkMode
                          ? "#1E2027"
                          : "#FFFBEB"
                        : bg,
                    }}
                    onPress={() => toggleCategory(category.path)}
                    activeOpacity={0.7}
                  >
                    <View
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: 10,
                        backgroundColor: isSelected
                          ? accent + "30"
                          : isDarkMode
                          ? "#1E2027"
                          : "#F3F4F6",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <Icon
                        name={getIconFromEmoji(category.icon) || "category"}
                        size={18}
                        color={isSelected ? accent : muted}
                      />
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 15,
                          fontFamily: fonts.semiBold,
                          color: primary,
                        }}
                      >
                        {category.name}
                      </Text>
                      {category.description && (
                        <Text
                          style={{
                            fontSize: 12,
                            color: muted,
                            marginTop: 1,
                            fontFamily: fonts.regular,
                          }}
                          numberOfLines={1}
                        >
                          {category.description}
                        </Text>
                      )}
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      {isSelected &&
                        (selectedSubcategories.length > 0 ||
                          selectedTags.length > 0) && (
                          <Icon
                            name="check-circle"
                            size={18}
                            color={accent}
                          />
                        )}
                      <Icon
                        name={
                          isExpanded
                            ? "keyboard-arrow-up"
                            : "keyboard-arrow-down"
                        }
                        size={22}
                        color={muted}
                      />
                    </View>
                  </TouchableOpacity>

                  {/* Subcategories Panel */}
                  {isSelected && isExpanded && subcategories.length > 0 && (
                    <View
                      style={{
                        borderTopWidth: 1,
                        borderTopColor: border,
                        backgroundColor: surface,
                        paddingHorizontal: 20,
                        paddingTop: 12,
                        paddingBottom: 4,
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.medium,
                          color: muted,
                          letterSpacing: 0.8,
                          textTransform: "uppercase",
                          marginBottom: 10,
                        }}
                      >
                        {t.subcategoriesSection}
                      </Text>
                      <View style={{ gap: 8, paddingBottom: 8 }}>
                        {subcategories.map((subcat) => {
                          const isSubSelected = selectedSubcategories.includes(
                            subcat.path,
                          );
                          return (
                            <TouchableOpacity
                              key={subcat.id}
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                paddingVertical: 11,
                                paddingHorizontal: 14,
                                backgroundColor: isSubSelected
                                  ? accent + "18"
                                  : bg,
                                borderRadius: 10,
                                borderWidth: 1,
                                borderColor: isSubSelected ? accent : border,
                              }}
                              onPress={() => toggleSubcategory(subcat.path)}
                              activeOpacity={0.7}
                            >
                              <Text
                                style={{
                                  flex: 1,
                                  fontSize: 14,
                                  fontFamily: isSubSelected
                                    ? fonts.medium
                                    : fonts.regular,
                                  color: primary,
                                }}
                              >
                                {subcat.name}
                              </Text>
                              {isSubSelected && (
                                <Icon
                                  name="check-circle"
                                  size={17}
                                  color={accent}
                                />
                              )}
                            </TouchableOpacity>
                          );
                        })}
                      </View>
                    </View>
                  )}

                  {/* Tags Panel */}
                  {isSelected &&
                    isExpanded &&
                    (() => {
                      const allTags = getAllTagsForCategory(category.path);
                      const filteredTags = tagSearch.trim()
                        ? allTags.filter((t: string) =>
                            t.toLowerCase().includes(tagSearch.toLowerCase()),
                          )
                        : allTags;
                      const selectedTagsForCategory = selectedTags.filter((t) =>
                        allTags.includes(t),
                      );
                      return (
                        <View
                          style={{
                            borderTopWidth: 1,
                            borderTopColor: border,
                            backgroundColor: bg,
                            paddingHorizontal: 20,
                            paddingTop: 12,
                            paddingBottom: 14,
                          }}
                        >
                          <View
                            style={{
                              flexDirection: "row",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: 10,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 11,
                                fontFamily: fonts.medium,
                                color: muted,
                                letterSpacing: 0.8,
                                textTransform: "uppercase",
                              }}
                            >
                              {t.tagsLabel}
                            </Text>
                            {selectedTagsForCategory.length > 0 && (
                              <TouchableOpacity
                                onPress={() =>
                                  setSelectedTags((prev) =>
                                    prev.filter((t) => !allTags.includes(t)),
                                  )
                                }
                              >
                                <Text
                                  style={{
                                    fontSize: 12,
                                    color: muted,
                                    fontFamily: fonts.regular,
                                  }}
                                >
                                  Clear all ({selectedTagsForCategory.length})
                                </Text>
                              </TouchableOpacity>
                            )}
                          </View>

                          {selectedTagsForCategory.length > 0 && (
                            <View
                              style={{
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gap: 6,
                                marginBottom: 12,
                              }}
                            >
                              {selectedTagsForCategory.map(
                                (tag: string, idx: number) => (
                                  <TouchableOpacity
                                    key={idx}
                                    style={{
                                      flexDirection: "row",
                                      alignItems: "center",
                                      gap: 4,
                                      paddingLeft: 10,
                                      paddingRight: 6,
                                      paddingVertical: 5,
                                      borderRadius: 16,
                                      backgroundColor: accent,
                                    }}
                                    onPress={() => toggleTag(tag)}
                                  >
                                    <Text
                                      style={{
                                        fontSize: 12,
                                        color: "#1A1D23",
                                        fontFamily: fonts.medium,
                                      }}
                                    >
                                      {tag}
                                    </Text>
                                    <Icon
                                      name="close"
                                      size={13}
                                      color="#1A1D23"
                                    />
                                  </TouchableOpacity>
                                ),
                              )}
                            </View>
                          )}

                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              backgroundColor: surface,
                              borderRadius: 10,
                              borderWidth: 1,
                              borderColor: border,
                              paddingHorizontal: 12,
                              marginBottom: 12,
                              height: 40,
                            }}
                          >
                            <Icon
                              name="search"
                              size={16}
                              color={muted}
                              style={{ marginRight: 8 }}
                            />
                            <TextInput
                              value={tagSearch}
                              onChangeText={setTagSearch}
                              placeholder={`Search ${allTags.length} tags...`}
                              placeholderTextColor={muted}
                              style={{
                                flex: 1,
                                fontSize: 13,
                                color: primary,
                                fontFamily: fonts.regular,
                                paddingVertical: 0,
                              }}
                            />
                            {tagSearch.length > 0 && (
                              <TouchableOpacity
                                onPress={() => setTagSearch("")}
                              >
                                <Icon name="close" size={15} color={muted} />
                              </TouchableOpacity>
                            )}
                          </View>

                          {filteredTags.length === 0 ? (
                            <Text
                              style={{
                                fontSize: 13,
                                color: muted,
                                fontFamily: fonts.regular,
                                textAlign: "center",
                                paddingVertical: 8,
                              }}
                            >
                              No tags match "{tagSearch}"
                            </Text>
                          ) : (
                            <View
                              style={{
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gap: 8,
                              }}
                            >
                              {filteredTags.map((tag: string, idx: number) => {
                                if (selectedTags.includes(tag)) return null;
                                return (
                                  <TouchableOpacity
                                    key={idx}
                                    style={{
                                      paddingHorizontal: 12,
                                      paddingVertical: 6,
                                      borderRadius: 16,
                                      backgroundColor: surface,
                                      borderWidth: 1,
                                      borderColor: border,
                                    }}
                                    onPress={() => toggleTag(tag)}
                                  >
                                    <Text
                                      style={{
                                        fontSize: 12,
                                        color: primary,
                                        fontFamily: fonts.medium,
                                      }}
                                    >
                                      {tag}
                                    </Text>
                                  </TouchableOpacity>
                                );
                              })}
                            </View>
                          )}
                        </View>
                      );
                    })()}

                  {!isLast && (
                    <View
                      style={{
                        height: 1,
                        backgroundColor: border,
                        marginLeft: 70,
                      }}
                    />
                  )}
                </View>
              );
            })}
        </View>
      </ScrollView>

      {/* Fixed Save Button */}
      <View
        style={{
          padding: 16,
          paddingBottom: 24,
          backgroundColor: bg,
          borderTopWidth: 1,
          borderTopColor: border,
        }}
      >
        <TouchableOpacity
          style={{
            backgroundColor: accent,
            paddingVertical: 15,
            borderRadius: 12,
            alignItems: "center",
            opacity: saving ? 0.6 : 1,
          }}
          onPress={saveInterests}
          disabled={saving}
          activeOpacity={0.85}
        >
          {saving ? (
            <ActivityIndicator size="small" color="#1A1D23" />
          ) : (
            <Text
              style={{ fontSize: 16, fontFamily: fonts.bold, color: "#1A1D23" }}
            >
              {t.saveJobInterestsButton}
            </Text>
          )}
        </TouchableOpacity>
      </View>
    </View>
  );
}

// Settings Account Content Component
function SettingsAccountContent({
  userData,
  user,
  colors,
  currentLanguage = "en",
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [displayName, setDisplayName] = useState("");
  const [username, setUsername] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [bio, setBio] = useState("");
  const [profilePicture, setProfilePicture] = useState("");
  const [bannerImage, setBannerImage] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadingBanner, setUploadingBanner] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const [usernameAvailable, setUsernameAvailable] = useState<boolean | null>(
    null,
  );
  const [checkingUsername, setCheckingUsername] = useState(false);

  // Social Links
  const [linkedinUrl, setLinkedinUrl] = useState("");
  const [githubUrl, setGithubUrl] = useState("");
  const [portfolioUrl, setPortfolioUrl] = useState("");
  const [twitterUrl, setTwitterUrl] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");

  // Update state when userData loads
  useEffect(() => {
    if (userData) {
      setDisplayName(userData.displayName || "");
      setUsername(userData.username || "");
      setDateOfBirth(userData.dateOfBirth || "");
      setBio(userData.bio || "");
      setProfilePicture(userData.profilePicture || "");
      setBannerImage(userData.bannerImage || "");
      setPhoneNumber(userData.phoneNumber || "");

      // Load social links
      const socialLinks = userData.socialLinks || {};
      setLinkedinUrl(socialLinks.linkedin || "");
      setGithubUrl(socialLinks.github || "");
      setPortfolioUrl(socialLinks.portfolio || "");
      setTwitterUrl(socialLinks.twitter || "");
      setInstagramUrl(socialLinks.instagram || "");
    }
  }, [userData]);

  // Check username availability
  const checkUsernameAvailability = async (usernameToCheck: string) => {
    if (!usernameToCheck || usernameToCheck.length < 3) {
      setUsernameAvailable(null);
      return;
    }

    // Don't check if it's the same as current username
    if (usernameToCheck.toLowerCase() === userData?.username?.toLowerCase()) {
      setUsernameAvailable(true);
      return;
    }

    setCheckingUsername(true);
    try {
      const usernameQuery = dbQuery(
        collection(db, "users"),
        where("username", "==", usernameToCheck.toLowerCase()),
      );
      const querySnapshot = await getDocs(usernameQuery);
      setUsernameAvailable(querySnapshot.empty);
    } catch (error) {
      console.error("Error checking username:", error);
      setUsernameAvailable(null);
    }
    setCheckingUsername(false);
  };

  // Debounced username check
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (username && username !== userData?.username) {
        checkUsernameAvailability(username);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [username]);

  const pickImage = async () => {
    try {
      setUploadError(null); // Clear any previous errors
      // Using Android photo picker (no permissions needed on Android 13+)
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [1, 1],
        quality: 0.8,
      });

      if (!result.canceled && result.assets[0]) {
        setUploading(true);
        await uploadImage(result.assets[0].uri);
      }
    } catch (error) {
      console.error("Error picking image:", error);
      Alert.alert("Error", "Failed to pick image");
    } finally {
      setUploading(false);
    }
  };

  const uploadImage = async (uri: string) => {
    if (!user) return;

    try {
      const response = await fetch(uri);
      const blob = await response.blob();

      // Get the actual MIME type from the blob
      const mimeType = blob.type || "image/jpeg";

      // Determine file extension from MIME type
      const extension = mimeType.split("/")[1] || "jpg";
      const filename = `${Date.now()}.${extension}`;

      // Convert blob to base64
      const reader = new FileReader();
      const base64Promise = new Promise<string>((resolve, reject) => {
        reader.onloadend = () => {
          const base64String = (reader.result as string).split(",")[1];
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      const fileData = await base64Promise;

      // Call the secure upload function
      const secureFileUploadCallable = httpsCallable(
        functions,
        "secureFileUploadCallable",
      );
      const result = await secureFileUploadCallable({
        fileData,
        filename,
        mimeType,
        fileType: "profile-picture",
      });

      const data = result.data as {
        success: boolean;
        downloadURL: string;
        error?: string;
      };

      if (!data.success) {
        throw new Error(data.error || "Upload failed");
      }

      const downloadURL = data.downloadURL;

      setProfilePicture(downloadURL);

      await updateDoc(doc(db, "users", user.uid), {
        profilePicture: downloadURL,
      });

      Alert.alert("Success", "Photo uploaded successfully!");
      setUploadError(null); // Clear any errors on success
    } catch (error: any) {
      console.error("Error uploading image:", error);

      let errorMessage = "";

      // Check for specific Firebase Storage errors
      if (error?.code === "storage/unauthorized") {
        errorMessage =
          "Upload Rejected: The photo you selected does not meet our requirements. Please ensure you are uploading a valid PNG, JPEG, or JPG image file that is less than 5MB.";
      } else if (error?.code === "storage/canceled") {
        errorMessage = "Upload Cancelled: Photo upload was cancelled.";
      } else if (error?.code === "storage/unknown") {
        errorMessage =
          "Upload Failed: An unknown error occurred. Please check your internet connection and try again.";
      } else if (error?.code === "storage/quota-exceeded") {
        errorMessage =
          "Storage Limit Exceeded: The storage quota has been exceeded. Please contact support.";
      } else {
        errorMessage =
          "Upload Failed: Failed to upload photo. Please try again with a different image.";
      }

      setUploadError(errorMessage);
      Alert.alert("Upload Error", errorMessage);
    }
  };

  const pickBannerImage = async () => {
    try {
      setUploadError(null);
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [16, 9],
        quality: 0.8,
      });

      if (!result.canceled && result.assets[0]) {
        setUploadingBanner(true);
        await uploadBannerImage(result.assets[0].uri);
      }
    } catch (error) {
      console.error("Error picking banner image:", error);
      Alert.alert("Error", "Failed to pick banner image");
    } finally {
      setUploadingBanner(false);
    }
  };

  const uploadBannerImage = async (uri: string) => {
    if (!user) return;

    try {
      const response = await fetch(uri);
      const blob = await response.blob();
      const mimeType = blob.type || "image/jpeg";
      const extension = mimeType.split("/")[1] || "jpg";
      const filename = `banner_${Date.now()}.${extension}`;

      const reader = new FileReader();
      const base64Promise = new Promise<string>((resolve, reject) => {
        reader.onloadend = () => {
          const base64String = (reader.result as string).split(",")[1];
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      const fileData = await base64Promise;
      const secureFileUploadCallable = httpsCallable(
        functions,
        "secureFileUploadCallable",
      );
      const result = await secureFileUploadCallable({
        fileData,
        filename,
        mimeType,
        fileType: "banner-image",
      });

      const data = result.data as {
        success: boolean;
        downloadURL: string;
        error?: string;
      };

      if (!data.success) {
        throw new Error(data.error || "Upload failed");
      }

      const downloadURL = data.downloadURL;
      setBannerImage(downloadURL);

      await updateDoc(doc(db, "users", user.uid), {
        bannerImage: downloadURL,
      });

      Alert.alert("Success", "Banner image uploaded successfully!");
      setUploadError(null);
    } catch (error: any) {
      console.error("Error uploading banner image:", error);
      setUploadError("Failed to upload banner image. Please try again.");
      Alert.alert(
        "Upload Error",
        "Failed to upload banner image. Please try again.",
      );
    }
  };

  const saveProfile = async () => {
    if (!user) return;

    // Validate username
    if (username.length < 3) {
      Alert.alert("Error", "Username must be at least 3 characters long");
      return;
    }

    if (!/^[a-zA-Z0-9_]+$/.test(username)) {
      Alert.alert(
        "Error",
        "Username can only contain letters, numbers, and underscores",
      );
      return;
    }

    if (username !== userData?.username && !usernameAvailable) {
      Alert.alert("Error", "This username is already taken");
      return;
    }

    try {
      setSaving(true);
      await updateDoc(doc(db, "users", user.uid), {
        displayName,
        username: username.toLowerCase(),
        dateOfBirth,
        bio,
        profilePicture,
        bannerImage,
        phoneNumber,
        socialLinks: {
          linkedin: linkedinUrl.trim(),
          github: githubUrl.trim(),
          portfolio: portfolioUrl.trim(),
          twitter: twitterUrl.trim(),
          instagram: instagramUrl.trim(),
        },
        updatedAt: new Date(),
      });
      Alert.alert("Success", "Profile updated successfully!");
    } catch (error) {
      console.error("Error updating profile:", error);
      Alert.alert("Error", "Failed to update profile");
    } finally {
      setSaving(false);
    }
  };

  const isDarkMode = colors === darkColors;
  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const accent = "#F4C430";

  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;

  useEffect(() => {
    const sub = Dimensions.addEventListener("change", ({ window }) =>
      setDimensions(window),
    );
    return () => sub?.remove();
  }, []);

  return (
    <View
      style={{ flex: 1, backgroundColor: isDarkMode ? "#0F1117" : "#F9FAFB" }}
    >
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 100 }}
      >
        {/* ── PROFILE HEADER ── */}
        <View
          style={{
            backgroundColor: bg,
            borderBottomWidth: 1,
            borderBottomColor: border,
          }}
        >
          {/* Banner */}
          <TouchableOpacity
            activeOpacity={0.85}
            onPress={pickBannerImage}
            disabled={uploadingBanner}
          >
            {bannerImage ? (
              <Image
                source={{ uri: bannerImage }}
                style={{ width: "100%", height: 100 }}
                resizeMode="cover"
              />
            ) : (
              <View
                style={{
                  width: "100%",
                  height: 100,
                  backgroundColor: accent + "22",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: 8,
                }}
              >
                <Icon name="add-a-photo" size={20} color={accent} />
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.medium,
                    color: accent,
                  }}
                >
                  {uploadingBanner ? t.savingText : t.addCoverPhotoLabel}
                </Text>
              </View>
            )}
            {bannerImage && !uploadingBanner && (
              <View
                style={{
                  position: "absolute",
                  top: 10,
                  right: 12,
                  backgroundColor: "rgba(0,0,0,0.55)",
                  borderRadius: 8,
                  paddingHorizontal: 10,
                  paddingVertical: 5,
                }}
              >
                <Text
                  style={{
                    color: "#FFF",
                    fontSize: 12,
                    fontFamily: fonts.medium,
                  }}
                >
                  {t.changeCoverPhotoLabel}
                </Text>
              </View>
            )}
          </TouchableOpacity>

          {/* Avatar + name/email */}
          <View style={{ paddingHorizontal: 20, paddingBottom: 20 }}>
            <View
              style={{
                flexDirection: "row",
                alignItems: "flex-end",
                gap: 14,
                marginTop: -28,
              }}
            >
              <View style={{ position: "relative" }}>
                {profilePicture ? (
                  <Image
                    source={{ uri: profilePicture }}
                    style={{
                      width: 72,
                      height: 72,
                      borderRadius: 36,
                      borderWidth: 3,
                      borderColor: bg,
                    }}
                  />
                ) : (
                  <View
                    style={{
                      width: 72,
                      height: 72,
                      borderRadius: 36,
                      backgroundColor: accent,
                      borderWidth: 3,
                      borderColor: bg,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 26,
                        fontFamily: fonts.bold,
                        color: "#1A1D23",
                      }}
                    >
                      {(userData?.displayName ||
                        user?.email ||
                        "U")[0].toUpperCase()}
                    </Text>
                  </View>
                )}
                <TouchableOpacity
                  onPress={pickImage}
                  disabled={uploading}
                  activeOpacity={0.8}
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    width: 24,
                    height: 24,
                    borderRadius: 12,
                    backgroundColor: accent,
                    borderWidth: 2,
                    borderColor: bg,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {uploading ? (
                    <ActivityIndicator size="small" color="#1A1D23" />
                  ) : (
                    <Icon name="edit" size={12} color="#1A1D23" />
                  )}
                </TouchableOpacity>
              </View>
              <View style={{ flex: 1, paddingBottom: 4 }}>
                <Text
                  style={{
                    fontSize: 17,
                    fontFamily: fonts.bold,
                    color: primary,
                  }}
                  numberOfLines={1}
                >
                  {userData?.displayName ||
                    user?.email?.split("@")[0] ||
                    "User"}
                </Text>
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.regular,
                    color: muted,
                    marginTop: 2,
                  }}
                  numberOfLines={1}
                >
                  {user?.email}
                </Text>
              </View>
            </View>
          </View>
        </View>

        {/* Error Alert */}
        {uploadError && (
          <View
            style={{
              marginHorizontal: 16,
              marginTop: 16,
              backgroundColor: isDarkMode ? "rgba(239,68,68,0.12)" : "#FEF2F2",
              borderLeftWidth: 3,
              borderLeftColor: "#EF4444",
              borderRadius: 10,
              padding: 12,
              flexDirection: "row",
              alignItems: "center",
              gap: 10,
            }}
          >
            <Icon name="error-outline" size={18} color="#EF4444" />
            <Text
              style={{
                flex: 1,
                fontSize: 13,
                fontFamily: fonts.regular,
                color: isDarkMode ? "#FCA5A5" : "#991B1B",
              }}
            >
              {uploadError}
            </Text>
            <TouchableOpacity onPress={() => setUploadError(null)}>
              <Icon name="close" size={16} color="#EF4444" />
            </TouchableOpacity>
          </View>
        )}

        {/* ── PERSONAL INFORMATION ── */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.personalInfoSection}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          <View style={{ paddingHorizontal: 20, paddingVertical: 14 }}>
            <Text
              style={{
                fontSize: 12,
                fontFamily: fonts.medium,
                color: muted,
                marginBottom: 8,
                letterSpacing: 0.3,
              }}
            >
              {t.displayNameLabel}
            </Text>
            <TextInput
              style={{
                fontSize: 15,
                fontFamily: fonts.regular,
                color: primary,
                backgroundColor: surface,
                borderRadius: 10,
                paddingVertical: 12,
                paddingHorizontal: 14,
                borderWidth: 1,
                borderColor: border,
              }}
              placeholder={t.displayNamePlaceholder}
              placeholderTextColor={muted}
              value={displayName}
              onChangeText={setDisplayName}
            />
          </View>
          <View
            style={{ height: 1, backgroundColor: border, marginLeft: 20 }}
          />
          <View style={{ paddingHorizontal: 20, paddingVertical: 14 }}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 8,
              }}
            >
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.medium,
                  color: muted,
                  letterSpacing: 0.3,
                }}
              >
                {t.usernameLabel}
              </Text>
              {checkingUsername && (
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.medium,
                    color: muted,
                  }}
                >
                  {t.checkingAvailability}
                </Text>
              )}
              {!checkingUsername &&
                usernameAvailable === true &&
                username !== userData?.username && (
                  <Text
                    style={{
                      fontSize: 11,
                      fontFamily: fonts.semiBold,
                      color: "#10B981",
                    }}
                  >
                    {t.usernameAvailableText}
                  </Text>
                )}
              {!checkingUsername &&
                usernameAvailable === false &&
                username !== userData?.username && (
                  <Text
                    style={{
                      fontSize: 11,
                      fontFamily: fonts.semiBold,
                      color: "#EF4444",
                    }}
                  >
                    {t.usernameTakenText}
                  </Text>
                )}
            </View>
            <TextInput
              style={{
                fontSize: 15,
                fontFamily: fonts.regular,
                color: primary,
                backgroundColor: surface,
                borderRadius: 10,
                paddingVertical: 12,
                paddingHorizontal: 14,
                borderWidth: 1,
                borderColor:
                  usernameAvailable === false && username !== userData?.username
                    ? "#EF4444"
                    : usernameAvailable === true &&
                      username !== userData?.username
                    ? "#10B981"
                    : border,
              }}
              placeholder="yourusername"
              placeholderTextColor={muted}
              value={username}
              onChangeText={setUsername}
              autoCapitalize="none"
            />
          </View>
          <View
            style={{ height: 1, backgroundColor: border, marginLeft: 20 }}
          />
          <View style={{ paddingHorizontal: 20, paddingVertical: 14 }}>
            <Text
              style={{
                fontSize: 12,
                fontFamily: fonts.medium,
                color: muted,
                marginBottom: 8,
                letterSpacing: 0.3,
              }}
            >
              {t.dateOfBirthLabel}
            </Text>
            <TextInput
              style={{
                fontSize: 15,
                fontFamily: fonts.regular,
                color: primary,
                backgroundColor: surface,
                borderRadius: 10,
                paddingVertical: 12,
                paddingHorizontal: 14,
                borderWidth: 1,
                borderColor: border,
              }}
              placeholder="YYYY-MM-DD"
              placeholderTextColor={muted}
              value={dateOfBirth}
              onChangeText={setDateOfBirth}
            />
          </View>
          <View
            style={{ height: 1, backgroundColor: border, marginLeft: 20 }}
          />
          <View style={{ paddingHorizontal: 20, paddingVertical: 14 }}>
            <Text
              style={{
                fontSize: 12,
                fontFamily: fonts.medium,
                color: muted,
                marginBottom: 8,
                letterSpacing: 0.3,
              }}
            >
              {t.bioLabel}
            </Text>
            <TextInput
              style={{
                fontSize: 15,
                fontFamily: fonts.regular,
                color: primary,
                backgroundColor: surface,
                borderRadius: 10,
                paddingVertical: 12,
                paddingHorizontal: 14,
                borderWidth: 1,
                borderColor: border,
                minHeight: 90,
                textAlignVertical: "top",
              }}
              placeholder={t.bioPlaceholder}
              placeholderTextColor={muted}
              value={bio}
              onChangeText={setBio}
              multiline
              numberOfLines={3}
            />
          </View>
        </View>

        {/* ── CONTACT ── */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.contactSection}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          <View style={{ paddingHorizontal: 20, paddingVertical: 14 }}>
            <Text
              style={{
                fontSize: 12,
                fontFamily: fonts.medium,
                color: muted,
                marginBottom: 8,
                letterSpacing: 0.3,
              }}
            >
              Email Address
            </Text>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: surface,
                borderRadius: 10,
                paddingVertical: 12,
                paddingHorizontal: 14,
                borderWidth: 1,
                borderColor: border,
              }}
            >
              <Text
                style={{
                  flex: 1,
                  fontSize: 15,
                  fontFamily: fonts.regular,
                  color: muted,
                }}
              >
                {user?.email || ""}
              </Text>
              <Icon name="verified" size={16} color="#10B981" />
            </View>
          </View>
          <View
            style={{ height: 1, backgroundColor: border, marginLeft: 20 }}
          />
          <View style={{ paddingHorizontal: 20, paddingVertical: 14 }}>
            <Text
              style={{
                fontSize: 12,
                fontFamily: fonts.medium,
                color: muted,
                marginBottom: 8,
                letterSpacing: 0.3,
              }}
            >
              {t.phoneNumberLabel}
            </Text>
            <TextInput
              style={{
                fontSize: 15,
                fontFamily: fonts.regular,
                color: primary,
                backgroundColor: surface,
                borderRadius: 10,
                paddingVertical: 12,
                paddingHorizontal: 14,
                borderWidth: 1,
                borderColor: border,
              }}
              placeholder="+251 911 234567"
              placeholderTextColor={muted}
              value={phoneNumber}
              onChangeText={setPhoneNumber}
              keyboardType="phone-pad"
            />
          </View>
        </View>

        {/* ── SOCIAL LINKS ── */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.socialLinksSection}
        </Text>

        {/* Social Links Card */}
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {[
            {
              label: "LinkedIn",
              value: linkedinUrl,
              setter: setLinkedinUrl,
              placeholder: "linkedin.com/in/user",
              badge: "in",
              badgeBg: "#0A66C2",
            },
            {
              label: "GitHub",
              value: githubUrl,
              setter: setGithubUrl,
              placeholder: "github.com/user",
              badge: "⚡",
              badgeBg: isDarkMode ? "#E6EDF3" : "#181717",
            },
            {
              label: "Portfolio",
              value: portfolioUrl,
              setter: setPortfolioUrl,
              placeholder: "yourportfolio.com",
              iconName: "language",
              badgeBg: "#3B82F6",
            },
            {
              label: "Twitter / X",
              value: twitterUrl,
              setter: setTwitterUrl,
              placeholder: "twitter.com/user",
              badge: "𝕏",
              badgeBg: "#000000",
            },
            {
              label: "Instagram",
              value: instagramUrl,
              setter: setInstagramUrl,
              placeholder: "instagram.com/user",
              iconName: "camera-alt",
              badgeBg: "#E4405F",
            },
          ].map((s, i, arr) => (
            <React.Fragment key={s.label}>
              <View
                style={{
                  paddingHorizontal: 20,
                  paddingVertical: 14,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 14,
                }}
              >
                <View
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: 9,
                    backgroundColor: s.badgeBg,
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {(s as any).iconName ? (
                    <Icon name={(s as any).iconName} size={17} color="#FFF" />
                  ) : (
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.bold,
                        color:
                          s.label === "GitHub" && isDarkMode
                            ? "#181717"
                            : "#FFF",
                      }}
                    >
                      {(s as any).badge}
                    </Text>
                  )}
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      color: muted,
                      marginBottom: 7,
                      letterSpacing: 0.3,
                    }}
                  >
                    {s.label}
                  </Text>
                  <TextInput
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.regular,
                      color: primary,
                      backgroundColor: surface,
                      borderRadius: 10,
                      paddingVertical: 10,
                      paddingHorizontal: 12,
                      borderWidth: 1,
                      borderColor: border,
                    }}
                    placeholder={s.placeholder}
                    placeholderTextColor={muted}
                    value={s.value}
                    onChangeText={s.setter}
                    autoCapitalize="none"
                    keyboardType="url"
                  />
                </View>
              </View>
              {i < arr.length - 1 && (
                <View
                  style={{ height: 1, backgroundColor: border, marginLeft: 68 }}
                />
              )}
            </React.Fragment>
          ))}
        </View>

        <View style={{ height: 24 }} />
      </ScrollView>

      {/* ── FIXED SAVE BUTTON ── */}
      <View
        style={{
          paddingHorizontal: 20,
          paddingVertical: 14,
          backgroundColor: bg,
          borderTopWidth: 1,
          borderTopColor: border,
        }}
      >
        <TouchableOpacity
          activeOpacity={0.8}
          style={{
            backgroundColor: accent,
            borderRadius: 12,
            paddingVertical: 15,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            opacity: saving ? 0.6 : 1,
          }}
          onPress={saveProfile}
          disabled={saving}
        >
          {saving ? (
            <>
              <ActivityIndicator size="small" color="#1A1D23" />
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.semiBold,
                  color: "#1A1D23",
                }}
              >
                {t.savingText}
              </Text>
            </>
          ) : (
            <>
              <Icon name="check" size={20} color="#1A1D23" />
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.semiBold,
                  color: "#1A1D23",
                }}
              >
                {t.saveChangesLabel}
              </Text>
            </>
          )}
        </TouchableOpacity>
      </View>
    </View>
  );
}

function SettingsPortfolioContent({
  userData,
  user,
  colors,
  navigation,
  currentLanguage = "en",
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [saving, setSaving] = useState(false);
  const [cvUploading, setCvUploading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const [jobTitle, setJobTitle] = useState("");
  const [company, setCompany] = useState("");
  const [experience, setExperience] = useState("");
  const [skills, setSkills] = useState("");
  const [education, setEducation] = useState("");
  const [achievements, setAchievements] = useState("");
  const [cvUrl, setCvUrl] = useState("");
  const [portfolioUrl, setPortfolioUrl] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [github, setGithub] = useState("");

  const isDarkMode = colors === darkColors;
  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const pageBg = isDarkMode ? "#0F1117" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const inputBg = isDarkMode ? "#12151B" : "#F9FAFB";

  useEffect(() => {
    if (userData?.portfolio) {
      const p = userData.portfolio;
      setJobTitle(p.jobTitle || "");
      setCompany(p.company || "");
      setExperience(p.experience || "");
      setSkills(p.skills || "");
      setEducation(p.education || "");
      setAchievements(p.achievements || "");
      setCvUrl(p.cvUrl || "");
      setPortfolioUrl(p.portfolioUrl || "");
      setLinkedin(p.linkedin || "");
      setGithub(p.github || "");
    }
  }, [userData]);

  const pickCV = async () => {
    try {
      setCvUploading(true);
      const result = await DocumentPicker.getDocumentAsync({
        type: [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ],
        copyToCacheDirectory: true,
      });
      if (!result.canceled && result.assets && result.assets.length > 0) {
        const file = result.assets[0];
        await uploadCV(file.uri, file.name);
      }
    } catch (error) {
      Alert.alert("Error", "Failed to pick CV file");
    } finally {
      setCvUploading(false);
    }
  };

  const uploadCV = async (uri: string, filename: string) => {
    if (!user) return;
    try {
      const response = await fetch(uri);
      const blob = await response.blob();
      const reader = new FileReader();
      const base64Promise = new Promise<string>((resolve, reject) => {
        reader.onloadend = () =>
          resolve((reader.result as string).split(",")[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      const fileData = await base64Promise;
      let mimeType = "application/pdf";
      if (filename.endsWith(".doc")) mimeType = "application/msword";
      else if (filename.endsWith(".docx"))
        mimeType =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      const secureFileUploadCallable = httpsCallable(
        functions,
        "secureFileUploadCallable",
      );
      const result = await secureFileUploadCallable({
        fileData,
        filename,
        mimeType,
        fileType: "cv",
      });
      const data = result.data as {
        success: boolean;
        downloadURL: string;
        error?: string;
      };
      if (!data.success) throw new Error(data.error || "Upload failed");
      setCvUrl(data.downloadURL);
      await updateDoc(doc(db, "users", user.uid), {
        "portfolio.cvUrl": data.downloadURL,
        "portfolio.cvUpdatedAt": new Date().toISOString(),
      });
      Alert.alert("Success", "CV uploaded successfully!");
    } catch {
      Alert.alert("Error", "Failed to upload CV. Please try again.");
    }
  };

  const savePortfolio = async () => {
    if (!user) return;
    try {
      setSaving(true);
      await updateDoc(doc(db, "users", user.uid), {
        portfolio: {
          jobTitle,
          company,
          experience,
          skills,
          education,
          achievements,
          cvUrl,
          portfolioUrl,
          linkedin,
          github,
          updatedAt: new Date().toISOString(),
        },
      });
      Alert.alert("Saved", "Portfolio updated successfully!");
    } catch {
      Alert.alert("Error", "Failed to update portfolio. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const getProfileLink = () =>
    `https://nibjobs.com/profile/${userData?.username || user?.uid}`;

  const copyProfileLink = () => {
    const link = getProfileLink();
    if (typeof navigator !== "undefined" && navigator.clipboard) {
      navigator.clipboard.writeText(link);
      Alert.alert("Copied!", "Profile link copied to clipboard");
    } else {
      Alert.alert("Profile Link", link);
    }
  };

  const SectionLabel = ({ label }: { label: string }) => (
    <Text
      style={{
        fontSize: 11,
        fontFamily: fonts.medium,
        color: muted,
        letterSpacing: 0.8,
        textTransform: "uppercase",
        paddingHorizontal: 20,
        paddingTop: 24,
        paddingBottom: 8,
      }}
    >
      {label}
    </Text>
  );

  const Divider = () => (
    <View style={{ height: 1, backgroundColor: border, marginLeft: 20 }} />
  );

  const FieldRow = ({
    label,
    value,
    onChangeText,
    placeholder,
    multiline = false,
    keyboardType = "default",
    autoCapitalize = "sentences",
  }: any) => (
    <View style={{ paddingHorizontal: 20, paddingVertical: 12 }}>
      <Text
        style={{
          fontSize: 11,
          fontFamily: fonts.medium,
          color: muted,
          marginBottom: 6,
          letterSpacing: 0.3,
        }}
      >
        {label}
      </Text>
      <TextInput
        style={{
          fontSize: 15,
          fontFamily: fonts.regular,
          color: primary,
          backgroundColor: inputBg,
          borderRadius: 8,
          paddingHorizontal: 12,
          paddingVertical: multiline ? 10 : 0,
          height: multiline ? undefined : 40,
          minHeight: multiline ? 80 : undefined,
          borderWidth: 1,
          borderColor: border,
          textAlignVertical: multiline ? "top" : "center",
        }}
        placeholder={placeholder}
        placeholderTextColor={muted}
        value={value}
        onChangeText={onChangeText}
        multiline={multiline}
        keyboardType={keyboardType}
        autoCapitalize={autoCapitalize}
      />
    </View>
  );

  return (
    <ScrollView
      style={{ flex: 1, backgroundColor: pageBg }}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{ paddingBottom: 48 }}
    >
      {/* ── Profile Link ── */}
      <SectionLabel label={t.profileLinkSection} />
      <View
        style={{
          backgroundColor: bg,
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: border,
        }}
      >
        <View style={{ paddingHorizontal: 20, paddingVertical: 14 }}>
          <Text
            style={{
              fontSize: 12,
              fontFamily: fonts.regular,
              color: muted,
              marginBottom: 10,
            }}
            numberOfLines={1}
            selectable
          >
            {getProfileLink()}
          </Text>
          <View style={{ flexDirection: "row", gap: 10 }}>
            <TouchableOpacity
              onPress={copyProfileLink}
              style={{
                flex: 1,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                backgroundColor: "#F4C430",
                paddingVertical: 10,
                borderRadius: 10,
              }}
            >
              <Icon name="content-copy" size={16} color="#1A1D23" />
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.medium,
                  color: "#1A1D23",
                }}
              >
                {t.copyLinkLabel}
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => setShowPreview(true)}
              style={{
                flex: 1,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                backgroundColor: inputBg,
                paddingVertical: 10,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: border,
              }}
            >
              <Icon name="visibility" size={16} color={primary} />
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.medium,
                  color: primary,
                }}
              >
                {t.previewLabel}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>

      {/* ── CV / Resume ── */}
      <SectionLabel label={t.cvResumeSection} />
      <View
        style={{
          backgroundColor: bg,
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: border,
        }}
      >
        <View style={{ paddingHorizontal: 20, paddingVertical: 14 }}>
          {cvUrl ? (
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 12 }}
            >
              <View
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  backgroundColor: "#F4C43018",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="description" size={22} color="#F4C430" />
              </View>
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.medium,
                    color: primary,
                  }}
                >
                  {t.cvUploadedText}
                </Text>
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.regular,
                    color: muted,
                    marginTop: 1,
                  }}
                >
                  {t.cvPdfDocLabel}
                </Text>
              </View>
              <TouchableOpacity
                onPress={pickCV}
                style={{
                  paddingHorizontal: 14,
                  paddingVertical: 7,
                  borderRadius: 8,
                  borderWidth: 1,
                  borderColor: border,
                }}
              >
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.medium,
                    color: primary,
                  }}
                >
                  {t.cvReplaceButton}
                </Text>
              </TouchableOpacity>
            </View>
          ) : (
            <TouchableOpacity
              onPress={pickCV}
              disabled={cvUploading}
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                paddingVertical: 18,
                borderRadius: 10,
                borderWidth: 1.5,
                borderColor: border,
                borderStyle: "dashed",
                backgroundColor: inputBg,
              }}
            >
              {cvUploading ? (
                <ActivityIndicator size="small" color="#F4C430" />
              ) : (
                <Icon name="cloud-upload" size={22} color="#F4C430" />
              )}
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.medium,
                  color: cvUploading ? muted : primary,
                }}
              >
                {cvUploading ? t.cvUploadingText : t.cvUploadButton}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.regular,
                  color: muted,
                }}
              >
                PDF, DOC, DOCX
              </Text>
            </TouchableOpacity>
          )}
        </View>
      </View>

      {/* ── Professional Info ── */}
      <SectionLabel label={t.professionalInfoSection} />
      <View
        style={{
          backgroundColor: bg,
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: border,
        }}
      >
        <FieldRow
          label={t.jobTitleLabel}
          value={jobTitle}
          onChangeText={setJobTitle}
          placeholder="e.g. Senior Software Engineer"
        />
        <Divider />
        <FieldRow
          label="Company"
          value={company}
          onChangeText={setCompany}
          placeholder="e.g. Tech Company Inc."
        />
        <Divider />
        <FieldRow
          label={t.yearsOfExperienceLabel}
          value={experience}
          onChangeText={setExperience}
          placeholder="e.g. 5 years"
        />
      </View>

      {/* ── About ── */}
      <SectionLabel label={t.aboutSection} />
      <View
        style={{
          backgroundColor: bg,
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: border,
        }}
      >
        <FieldRow
          label={t.skillsLabel}
          value={skills}
          onChangeText={setSkills}
          placeholder="React, Node.js, Python, AWS…"
          multiline
        />
        <Divider />
        <FieldRow
          label={t.educationLabel}
          value={education}
          onChangeText={setEducation}
          placeholder="Degree, Institution, Year"
          multiline
        />
        <Divider />
        <FieldRow
          label={t.keyAchievementsLabel}
          value={achievements}
          onChangeText={setAchievements}
          placeholder="Highlight major accomplishments and awards"
          multiline
        />
      </View>

      {/* ── Links ── */}
      <SectionLabel label={t.linksSection} />
      <View
        style={{
          backgroundColor: bg,
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: border,
        }}
      >
        <FieldRow
          label={t.portfolioWebsiteLabel}
          value={portfolioUrl}
          onChangeText={setPortfolioUrl}
          placeholder="https://yourwebsite.com"
          keyboardType="url"
          autoCapitalize="none"
        />
        <Divider />
        <FieldRow
          label="LinkedIn"
          value={linkedin}
          onChangeText={setLinkedin}
          placeholder="https://linkedin.com/in/yourprofile"
          keyboardType="url"
          autoCapitalize="none"
        />
        <Divider />
        <FieldRow
          label="GitHub"
          value={github}
          onChangeText={setGithub}
          placeholder="https://github.com/yourusername"
          keyboardType="url"
          autoCapitalize="none"
        />
      </View>

      {/* ── Save ── */}
      <View style={{ paddingHorizontal: 20, paddingTop: 28 }}>
        <TouchableOpacity
          onPress={savePortfolio}
          disabled={saving}
          style={{
            backgroundColor: "#F4C430",
            paddingVertical: 14,
            borderRadius: 12,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            opacity: saving ? 0.6 : 1,
          }}
        >
          {saving ? (
            <ActivityIndicator size="small" color="#1A1D23" />
          ) : (
            <>
              <Icon name="check" size={18} color="#1A1D23" />
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.bold,
                  color: "#1A1D23",
                }}
              >
                {t.savePortfolioButton}
              </Text>
            </>
          )}
        </TouchableOpacity>
      </View>

      {/* ── Preview Modal (mirrors PublicProfileScreen) ── */}
      <Modal
        visible={showPreview}
        animationType="slide"
        presentationStyle="fullScreen"
        onRequestClose={() => setShowPreview(false)}
      >
        <SafeAreaView style={{ flex: 1, backgroundColor: pageBg }}>
          {/* Header */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              paddingHorizontal: 16,
              paddingVertical: 12,
              backgroundColor: bg,
              borderBottomWidth: 1,
              borderBottomColor: border,
            }}
          >
            <TouchableOpacity
              onPress={() => setShowPreview(false)}
              hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
            >
              <Icon name="arrow-back" size={22} color={primary} />
            </TouchableOpacity>
            <Text
              style={{
                flex: 1,
                fontSize: 17,
                fontFamily: fonts.bold,
                color: primary,
                marginLeft: 14,
              }}
            >
              {t.profilePreviewTitle}
            </Text>
            <Text
              style={{ fontSize: 12, fontFamily: fonts.regular, color: muted }}
            >
              {t.asSeenByOthers}
            </Text>
          </View>

          {(() => {
            const accent = "#F4C430";
            const isMobile = Dimensions.get("window").width < 768;
            const pBanner = userData?.bannerImage || "";
            const pDob = userData?.dateOfBirth || "";
            const pPhone = userData?.phoneNumber || "";
            const pSL = userData?.socialLinks || {};
            const pLinkedin = pSL.linkedin || linkedin || "";
            const pGithub = pSL.github || github || "";
            const pPortfolio = pSL.portfolio || portfolioUrl || "";
            const pTwitter = pSL.twitter || "";
            const pInstagram = pSL.instagram || "";
            const pCategories = (userData?.selectedCategories ||
              []) as string[];
            const pTags = (userData?.interestedTags ||
              userData?.selectedTags ||
              []) as string[];
            const avatarInitial = (userData?.displayName ||
              "U")[0].toUpperCase();
            const hasSocial =
              pLinkedin || pGithub || pPortfolio || pTwitter || pInstagram;
            const skillsList = skills
              .split(",")
              .map((s: string) => s.trim())
              .filter(Boolean);

            const openUrl = (raw: string, fallback: string) =>
              Linking.openURL(raw.startsWith("http") ? raw : fallback + raw);

            return (
              <ScrollView
                showsVerticalScrollIndicator={false}
                contentContainerStyle={{ paddingBottom: 48 }}
              >
                {/* ── Banner + Hero Card ── */}
                <View
                  style={{
                    backgroundColor: bg,
                    borderBottomWidth: 1,
                    borderColor: border,
                    overflow: "hidden",
                  }}
                >
                  {pBanner ? (
                    <Image
                      source={{ uri: pBanner }}
                      style={{ width: "100%", height: isMobile ? 140 : 180 }}
                      resizeMode="cover"
                    />
                  ) : (
                    <View
                      style={{
                        width: "100%",
                        height: isMobile ? 100 : 120,
                        backgroundColor: isDarkMode ? "#1A1D23" : "#FDF6E3",
                      }}
                    >
                      <View
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: 40,
                          backgroundColor: bg,
                        }}
                      />
                    </View>
                  )}

                  {/* Avatar */}
                  <View
                    style={{
                      alignItems: "center",
                      marginTop: pBanner ? -50 : -46,
                    }}
                  >
                    {userData?.profilePicture ? (
                      <Image
                        source={{ uri: userData.profilePicture }}
                        style={{
                          width: 96,
                          height: 96,
                          borderRadius: 48,
                          borderWidth: 3,
                          borderColor: bg,
                        }}
                      />
                    ) : (
                      <View
                        style={{
                          width: 96,
                          height: 96,
                          borderRadius: 48,
                          backgroundColor: accent,
                          alignItems: "center",
                          justifyContent: "center",
                          borderWidth: 3,
                          borderColor: bg,
                          shadowColor: accent,
                          shadowOffset: { width: 0, height: 4 },
                          shadowOpacity: 0.3,
                          shadowRadius: 8,
                          elevation: 4,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 36,
                            fontFamily: fonts.bold,
                            color: "#1A1D23",
                          }}
                        >
                          {avatarInitial}
                        </Text>
                      </View>
                    )}
                  </View>

                  {/* Identity */}
                  <View
                    style={{
                      paddingHorizontal: isMobile ? 24 : 32,
                      paddingTop: 12,
                      paddingBottom: 24,
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 24,
                        fontFamily: fonts.bold,
                        color: primary,
                        textAlign: "center",
                      }}
                    >
                      {userData?.displayName || "Your Name"}
                    </Text>
                    {userData?.username ? (
                      <Text
                        style={{
                          fontSize: 13,
                          fontFamily: fonts.regular,
                          color: muted,
                          marginTop: 3,
                          textAlign: "center",
                        }}
                      >
                        @{userData.username}
                      </Text>
                    ) : null}

                    {jobTitle || company ? (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 5,
                          marginTop: 10,
                        }}
                      >
                        <Icon name="work-outline" size={14} color={muted} />
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: fonts.medium,
                            color: muted,
                            textAlign: "center",
                          }}
                        >
                          {jobTitle}
                          {jobTitle && company ? " · " : ""}
                          {company}
                        </Text>
                      </View>
                    ) : null}

                    {userData?.bio ? (
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: fonts.regular,
                          color: muted,
                          marginTop: 14,
                          textAlign: "center",
                          lineHeight: 22,
                          maxWidth: 440,
                        }}
                      >
                        {userData.bio}
                      </Text>
                    ) : null}

                    {/* Phone & DOB pills */}
                    {pPhone || pDob ? (
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          justifyContent: "center",
                          gap: 10,
                          marginTop: 14,
                        }}
                      >
                        {pPhone ? (
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 4,
                              backgroundColor: inputBg,
                              borderRadius: 8,
                              borderWidth: 1,
                              borderColor: border,
                              paddingHorizontal: 10,
                              paddingVertical: 5,
                            }}
                          >
                            <Icon name="phone" size={13} color={muted} />
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.regular,
                                color: muted,
                              }}
                            >
                              {pPhone}
                            </Text>
                          </View>
                        ) : null}
                        {pDob ? (
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 4,
                              backgroundColor: inputBg,
                              borderRadius: 8,
                              borderWidth: 1,
                              borderColor: border,
                              paddingHorizontal: 10,
                              paddingVertical: 5,
                            }}
                          >
                            <Icon name="cake" size={13} color={muted} />
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.regular,
                                color: muted,
                              }}
                            >
                              {pDob}
                            </Text>
                          </View>
                        ) : null}
                      </View>
                    ) : null}

                    {/* Social link pills */}
                    {hasSocial ? (
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          justifyContent: "center",
                          gap: 8,
                          marginTop: 16,
                        }}
                      >
                        {pLinkedin ? (
                          <TouchableOpacity
                            onPress={() =>
                              openUrl(pLinkedin, "https://linkedin.com/in/")
                            }
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 5,
                              backgroundColor: "#0077B510",
                              borderRadius: 20,
                              borderWidth: 1,
                              borderColor: "#0077B530",
                              paddingHorizontal: 14,
                              paddingVertical: 7,
                            }}
                          >
                            <Icon name="link" size={14} color="#0077B5" />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#0077B5",
                              }}
                            >
                              LinkedIn
                            </Text>
                          </TouchableOpacity>
                        ) : null}
                        {pGithub ? (
                          <TouchableOpacity
                            onPress={() =>
                              openUrl(pGithub, "https://github.com/")
                            }
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 5,
                              backgroundColor: inputBg,
                              borderRadius: 20,
                              borderWidth: 1,
                              borderColor: border,
                              paddingHorizontal: 14,
                              paddingVertical: 7,
                            }}
                          >
                            <Icon name="code" size={14} color={primary} />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: primary,
                              }}
                            >
                              GitHub
                            </Text>
                          </TouchableOpacity>
                        ) : null}
                        {pPortfolio ? (
                          <TouchableOpacity
                            onPress={() => openUrl(pPortfolio, "https://")}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 5,
                              backgroundColor: "#4A90E210",
                              borderRadius: 20,
                              borderWidth: 1,
                              borderColor: "#4A90E230",
                              paddingHorizontal: 14,
                              paddingVertical: 7,
                            }}
                          >
                            <Icon name="language" size={14} color="#4A90E2" />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#4A90E2",
                              }}
                            >
                              Portfolio
                            </Text>
                          </TouchableOpacity>
                        ) : null}
                        {pTwitter ? (
                          <TouchableOpacity
                            onPress={() => openUrl(pTwitter, "https://x.com/")}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 5,
                              backgroundColor: inputBg,
                              borderRadius: 20,
                              borderWidth: 1,
                              borderColor: border,
                              paddingHorizontal: 14,
                              paddingVertical: 7,
                            }}
                          >
                            <Icon name="tag" size={14} color={primary} />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: primary,
                              }}
                            >
                              X / Twitter
                            </Text>
                          </TouchableOpacity>
                        ) : null}
                        {pInstagram ? (
                          <TouchableOpacity
                            onPress={() =>
                              openUrl(pInstagram, "https://instagram.com/")
                            }
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 5,
                              backgroundColor: "#E1306C10",
                              borderRadius: 20,
                              borderWidth: 1,
                              borderColor: "#E1306C30",
                              paddingHorizontal: 14,
                              paddingVertical: 7,
                            }}
                          >
                            <Icon name="camera-alt" size={14} color="#E1306C" />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#E1306C",
                              }}
                            >
                              Instagram
                            </Text>
                          </TouchableOpacity>
                        ) : null}
                      </View>
                    ) : null}
                  </View>
                </View>

                {/* ── Skills ── */}
                {skillsList.length > 0 ? (
                  <View style={{ marginTop: 12 }}>
                    <View
                      style={{
                        backgroundColor: bg,
                        borderTopWidth: 1,
                        borderBottomWidth: 1,
                        borderColor: border,
                        paddingHorizontal: isMobile ? 20 : 28,
                        paddingTop: 16,
                        paddingBottom: 18,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                          marginBottom: 12,
                        }}
                      >
                        <Icon name="local-offer" size={15} color={accent} />
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.medium,
                            color: muted,
                            textTransform: "uppercase",
                            letterSpacing: 0.8,
                          }}
                        >
                          Skills
                        </Text>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                        }}
                      >
                        {skillsList.map((sk: string, i: number) => (
                          <View
                            key={i}
                            style={{
                              backgroundColor: inputBg,
                              borderRadius: 8,
                              borderWidth: 1,
                              borderColor: border,
                              paddingHorizontal: 12,
                              paddingVertical: 6,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.regular,
                                color: primary,
                              }}
                            >
                              {sk}
                            </Text>
                          </View>
                        ))}
                      </View>
                    </View>
                  </View>
                ) : null}

                {/* ── Experience / Education / Achievements ── */}
                {(
                  [
                    {
                      label: "Experience",
                      value: experience,
                      icon: "business-center",
                    },
                    { label: "Education", value: education, icon: "school" },
                    {
                      label: "Achievements",
                      value: achievements,
                      icon: "emoji-events",
                    },
                  ] as const
                )
                  .filter((s) => s.value)
                  .map((s) => (
                    <View key={s.label} style={{ marginTop: 12 }}>
                      <View
                        style={{
                          backgroundColor: bg,
                          borderTopWidth: 1,
                          borderBottomWidth: 1,
                          borderColor: border,
                          paddingHorizontal: isMobile ? 20 : 28,
                          paddingTop: 16,
                          paddingBottom: 18,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                            marginBottom: 10,
                          }}
                        >
                          <Icon name={s.icon as any} size={15} color={accent} />
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.medium,
                              color: muted,
                              textTransform: "uppercase",
                              letterSpacing: 0.8,
                            }}
                          >
                            {s.label}
                          </Text>
                        </View>
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: fonts.regular,
                            color: primary,
                            lineHeight: 22,
                          }}
                        >
                          {s.value}
                        </Text>
                      </View>
                    </View>
                  ))}

                {/* ── CV / Resume Download ── */}
                {cvUrl ? (
                  <View style={{ marginTop: 12 }}>
                    <View
                      style={{
                        backgroundColor: bg,
                        borderTopWidth: 1,
                        borderBottomWidth: 1,
                        borderColor: border,
                        paddingHorizontal: isMobile ? 20 : 28,
                        paddingTop: 16,
                        paddingBottom: 18,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                          marginBottom: 12,
                        }}
                      >
                        <Icon name="description" size={15} color={accent} />
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.medium,
                            color: muted,
                            textTransform: "uppercase",
                            letterSpacing: 0.8,
                          }}
                        >
                          Resume / CV
                        </Text>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 10,
                          backgroundColor: inputBg,
                          borderRadius: 12,
                          borderWidth: 1,
                          borderColor: border,
                          paddingHorizontal: 16,
                          paddingVertical: 12,
                        }}
                      >
                        <View
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: 10,
                            backgroundColor: "#F4C43018",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon
                            name="picture-as-pdf"
                            size={22}
                            color={accent}
                          />
                        </View>
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 14,
                              fontFamily: fonts.semiBold,
                              color: primary,
                            }}
                          >
                            View Resume
                          </Text>
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.regular,
                              color: muted,
                              marginTop: 2,
                            }}
                          >
                            Tap to open or download
                          </Text>
                        </View>
                        <Icon name="open-in-new" size={18} color={muted} />
                      </View>
                    </View>
                  </View>
                ) : null}

                {/* ── Interests (categories + tags) ── */}
                {pCategories.length > 0 || pTags.length > 0 ? (
                  <View style={{ marginTop: 12 }}>
                    <View
                      style={{
                        backgroundColor: bg,
                        borderTopWidth: 1,
                        borderBottomWidth: 1,
                        borderColor: border,
                        paddingHorizontal: isMobile ? 20 : 28,
                        paddingTop: 16,
                        paddingBottom: 18,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                          marginBottom: 12,
                        }}
                      >
                        <Icon name="interests" size={15} color={accent} />
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.medium,
                            color: muted,
                            textTransform: "uppercase",
                            letterSpacing: 0.8,
                          }}
                        >
                          Interests
                        </Text>
                      </View>
                      {pCategories.length > 0 ? (
                        <View
                          style={{ marginBottom: pTags.length > 0 ? 14 : 0 }}
                        >
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: muted,
                              marginBottom: 8,
                            }}
                          >
                            Categories
                          </Text>
                          <View
                            style={{
                              flexDirection: "row",
                              flexWrap: "wrap",
                              gap: 8,
                            }}
                          >
                            {pCategories.map((cat: string, i: number) => (
                              <View
                                key={i}
                                style={{
                                  backgroundColor: accent + "14",
                                  borderRadius: 8,
                                  borderWidth: 1,
                                  borderColor: accent + "30",
                                  paddingHorizontal: 12,
                                  paddingVertical: 6,
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 13,
                                    fontFamily: fonts.medium,
                                    color: isDarkMode ? accent : "#92400E",
                                  }}
                                >
                                  {cat}
                                </Text>
                              </View>
                            ))}
                          </View>
                        </View>
                      ) : null}
                      {pTags.length > 0 ? (
                        <View>
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: muted,
                              marginBottom: 8,
                            }}
                          >
                            Topics
                          </Text>
                          <View
                            style={{
                              flexDirection: "row",
                              flexWrap: "wrap",
                              gap: 8,
                            }}
                          >
                            {pTags.map((tag: string, i: number) => (
                              <View
                                key={i}
                                style={{
                                  backgroundColor: inputBg,
                                  borderRadius: 8,
                                  borderWidth: 1,
                                  borderColor: border,
                                  paddingHorizontal: 12,
                                  paddingVertical: 6,
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 13,
                                    fontFamily: fonts.regular,
                                    color: primary,
                                  }}
                                >
                                  {tag}
                                </Text>
                              </View>
                            ))}
                          </View>
                        </View>
                      ) : null}
                    </View>
                  </View>
                ) : null}
              </ScrollView>
            );
          })()}
        </SafeAreaView>
      </Modal>
    </ScrollView>
  );
}

function SettingsPreferencesContent({
  colors,
  isDarkMode,
  toggleTheme,
  currentLanguage,
  changeLanguage,
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const languageOptions = [
    { code: "en", label: "English", icon: "language" },
    { code: "am", label: "አማርኛ", icon: "language" },
    { code: "ti", label: "ትግርኛ", icon: "language" },
    { code: "or", label: "Afaan Oromoo", icon: "language" },
  ];

  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const accent = "#F4C430";

  return (
    <View style={{ flex: 1, backgroundColor: surface }}>
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 40 }}
      >
        {/* Appearance Section */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.appearanceSection}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              paddingVertical: 14,
              paddingHorizontal: 20,
              gap: 16,
            }}
          >
            <View
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                backgroundColor: isDarkMode ? "#2A2D35" : "#FFF8E0",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon
                name={isDarkMode ? "nightlight-round" : "wb-sunny"}
                size={18}
                color={accent}
              />
            </View>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.semiBold,
                  color: primary,
                }}
              >
                Dark Mode
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  color: muted,
                  marginTop: 1,
                  fontFamily: fonts.regular,
                }}
              >
                {isDarkMode ? t.darkModeEnabled : t.lightModeEnabled}
              </Text>
            </View>
            <Switch
              value={isDarkMode}
              onValueChange={toggleTheme}
              trackColor={{ false: border, true: accent }}
              thumbColor={isDarkMode ? "#1A1D23" : "#FFFFFF"}
              ios_backgroundColor={border}
            />
          </View>
        </View>

        {/* Language Section */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.language}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {languageOptions.map((lang, idx) => {
            const isSelected = currentLanguage === lang.code;
            const isLast = idx === languageOptions.length - 1;
            return (
              <View key={lang.code}>
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 14,
                    paddingHorizontal: 20,
                    gap: 16,
                  }}
                  onPress={() => changeLanguage(lang.code)}
                  activeOpacity={0.7}
                >
                  <View
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: 10,
                      backgroundColor: isSelected
                        ? accent + "18"
                        : isDarkMode
                        ? "#1E2027"
                        : "#F3F4F6",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Icon
                      name="language"
                      size={18}
                      color={isSelected ? accent : muted}
                    />
                  </View>
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 15,
                      fontFamily: isSelected ? fonts.semiBold : fonts.regular,
                      color: primary,
                    }}
                  >
                    {lang.label}
                  </Text>
                  {isSelected ? (
                    <Icon name="check-circle" size={20} color={accent} />
                  ) : (
                    <View
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 10,
                        borderWidth: 1.5,
                        borderColor: border,
                      }}
                    />
                  )}
                </TouchableOpacity>
                {!isLast && (
                  <View
                    style={{
                      height: 1,
                      backgroundColor: border,
                      marginLeft: 72,
                    }}
                  />
                )}
              </View>
            );
          })}
        </View>
      </ScrollView>
    </View>
  );
}

function SettingsLanguageContent({
  userData,
  user,
  colors,
  currentLanguage = "en",
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [selectedLanguage, setSelectedLanguage] = useState(
    userData?.language || "English",
  );
  const [saving, setSaving] = useState(false);

  const languages = ["English", "Amharic", "Oromifa"];

  const saveLanguage = async () => {
    if (!user) return;

    try {
      setSaving(true);
      await updateDoc(doc(db, "users", user.uid), {
        language: selectedLanguage,
      });
      Alert.alert("Success", "Language preference saved!");
    } catch (error) {
      console.error("Error saving language:", error);
      Alert.alert("Error", "Failed to save language preference");
    } finally {
      setSaving(false);
    }
  };

  return (
    <ScrollView style={styles.settingsContentScroll}>
      <View style={styles.settingsContentSection}>
        <Text style={[styles.settingsContentTitle, { color: colors.deepNavy }]}>
          Language
        </Text>

        <View style={styles.settingsSection}>
          <Text
            style={[styles.settingsSectionTitle, { color: colors.deepNavy }]}
          >
            Select Language
          </Text>

          {languages.map((lang) => (
            <TouchableOpacity
              key={lang}
              style={[
                styles.settingsToggleItem,
                { backgroundColor: colors.white },
              ]}
              onPress={() => setSelectedLanguage(lang)}
            >
              <View style={styles.settingsToggleLeft}>
                <View
                  style={[
                    styles.settingsMenuIconContainer,
                    { backgroundColor: colors.cream },
                  ]}
                >
                  <Icon name="language" size={24} color={colors.beeYellow} />
                </View>
                <Text
                  style={[styles.settingsMenuTitle, { color: colors.deepNavy }]}
                >
                  {lang}
                </Text>
              </View>
              {selectedLanguage === lang && (
                <Icon name="check-circle" size={24} color={colors.success} />
              )}
            </TouchableOpacity>
          ))}
        </View>

        <TouchableOpacity
          style={[
            styles.settingsSaveButton,
            { backgroundColor: colors.beeYellow },
            saving && styles.settingsSaveButtonDisabled,
          ]}
          onPress={saveLanguage}
          disabled={saving}
        >
          {saving ? (
            <ActivityIndicator size="small" color={colors.buttonTextOnYellow} />
          ) : (
            <Text
              style={[
                styles.settingsSaveButtonText,
                { color: colors.buttonTextOnYellow },
              ]}
            >
              {t.saveChangesButton}
            </Text>
          )}
        </TouchableOpacity>
      </View>
    </ScrollView>
  );
}

function SettingsSubscriptionContent({
  userData,
  user,
  colors,
  navigation,
  currentLanguage = "en",
}: any) {
  const t = translations[currentLanguage] || translations.en;
  const [subscriptionPlans, setSubscriptionPlans] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [billing, setBilling] = useState<"monthly" | "yearly">("monthly");
  const currentPlanId = (
    userData?.subscriptionId ||
    userData?.subscriptionPlan ||
    "free"
  ).toLowerCase();
  const isDarkMode = colors === darkColors;

  useEffect(() => {
    loadSubscriptionPlans();
  }, []);

  const loadSubscriptionPlans = async () => {
    try {
      setLoading(true);
      const snapshot = await getDocs(
        dbQuery(collection(db, "subscriptionPlans"), limit(20)),
      );
      const plansData = snapshot.docs.map((d) => ({
        id: d.id.toLowerCase(),
        ...d.data(),
      }));
      const sortOrder: { [key: string]: number } = {
        free: 1,
        standard: 2,
        pro: 3,
        enterprise: 4,
      };
      plansData.sort(
        (a, b) => (sortOrder[a.id] || 999) - (sortOrder[b.id] || 999),
      );
      setSubscriptionPlans(
        plansData.length > 0 ? plansData : SUBSCRIPTION_PLANS,
      );
    } catch {
      setSubscriptionPlans(SUBSCRIPTION_PLANS);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectPlan = (planId: string) => {
    if (!user) {
      Alert.alert(t.loginRequiredTitle, t.loginRequiredMessage, [
        { text: t.cancelButton, style: "cancel" },
        {
          text: t.login,
          onPress: () => {
            navigation.navigate("Home");
            setTimeout(() => navigation.navigate("Signup"), 100);
          },
        },
      ]);
      return;
    }
    if (planId === currentPlanId) return;
    if (planId === "free") {
      Alert.alert(t.downgradeToFreeTitle, t.downgradeToFreeMessage, [
        { text: t.cancelButton, style: "cancel" },
        {
          text: t.confirmButton,
          onPress: async () => {
            try {
              await updateDoc(doc(db, "users", user.uid), {
                subscriptionPlan: "free",
              });
              Alert.alert(t.successTitle, t.planSwitchedToFree);
            } catch {
              Alert.alert(t.errorTitle, t.planFailedToSwitch);
            }
          },
        },
      ]);
    } else {
      navigation.goBack();
      setTimeout(
        () =>
          navigation.navigate("Payment", {
            plan: planId,
            returnTo: "Settings",
          }),
        100,
      );
    }
  };

  const bg = isDarkMode ? "#0D0F12" : "#F7F8FA";
  const card = isDarkMode ? "#161A1F" : "#FFFFFF";
  const txt = isDarkMode ? "#F1F3F5" : "#111827";
  const sub = isDarkMode ? "#8B8FA8" : "#6B7280";
  const div = isDarkMode ? "#1E2330" : "#F0F1F3";

  const planMeta: Record<
    string,
    { icon: string; accent: string; darkAccent: string }
  > = {
    free: { icon: "bolt", accent: "#6B7280", darkAccent: "#9CA3AF" },
    standard: { icon: "star", accent: "#D97706", darkAccent: "#F4C430" },
    pro: { icon: "verified", accent: "#7C3AED", darkAccent: "#A78BFA" },
    enterprise: { icon: "business", accent: "#4F46E5", darkAccent: "#818CF8" },
  };

  return (
    <ScrollView
      style={{ flex: 1, backgroundColor: bg }}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{ paddingBottom: 48 }}
    >
      {/* ── Header ─────────────────────────────────────────────── */}
      <View
        style={{
          paddingTop: 32,
          paddingHorizontal: 24,
          paddingBottom: 28,
          alignItems: "center",
        }}
      >
        <Text
          style={{
            fontSize: 26,
            fontFamily: fonts.bold,
            fontWeight: "800",
            color: txt,
            textAlign: "center",
            letterSpacing: -0.5,
          }}
        >
          {t.pickAPlan}
        </Text>
        <Text
          style={{
            fontSize: 14,
            color: sub,
            marginTop: 6,
            textAlign: "center",
          }}
        >
          {t.upgradeAnytimeCancelAnytime}
        </Text>

        {/* Billing toggle */}
        <View
          style={{
            flexDirection: "row",
            marginTop: 20,
            backgroundColor: isDarkMode ? "#1E2330" : "#EBEBED",
            borderRadius: 12,
            padding: 3,
            alignSelf: "center",
          }}
        >
          {(["monthly", "yearly"] as const).map((p) => {
            const active = billing === p;
            return (
              <TouchableOpacity
                key={p}
                onPress={() => setBilling(p)}
                style={{
                  paddingHorizontal: 18,
                  paddingVertical: 7,
                  borderRadius: 9,
                  backgroundColor: active
                    ? isDarkMode
                      ? "#2A2F3D"
                      : "#FFFFFF"
                    : "transparent",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 6,
                  shadowColor: active ? "#000" : "transparent",
                  shadowOffset: { width: 0, height: 1 },
                  shadowOpacity: active ? 0.08 : 0,
                  shadowRadius: 3,
                  elevation: active ? 2 : 0,
                }}
              >
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.bold,
                    fontWeight: "600",
                    color: active ? txt : sub,
                  }}
                >
                  {p === "monthly" ? t.billingMonthly : t.billingYearly}
                </Text>
                {p === "yearly" && (
                  <View
                    style={{
                      backgroundColor: "#10B98120",
                      paddingHorizontal: 5,
                      paddingVertical: 1,
                      borderRadius: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 9,
                        fontWeight: "800",
                        color: "#10B981",
                        letterSpacing: 0.3,
                      }}
                    >
                      −17%
                    </Text>
                  </View>
                )}
              </TouchableOpacity>
            );
          })}
        </View>
      </View>

      {/* ── Plans ──────────────────────────────────────────────── */}
      <View style={{ alignItems: "center", paddingHorizontal: 20 }}>
        <View style={{ width: "100%", maxWidth: 400, gap: 10 }}>
          {loading ? (
            <InlineLoadingIndicator
              message={t.loadingPlans}
              isDarkMode={isDarkMode}
            />
          ) : (
            subscriptionPlans.map((plan) => {
              const isCurrent = plan.id === currentPlanId;
              const isPopular = plan.id === "standard";
              const isFree = plan.id === "free";
              const features: any[] = plan.features || [];
              const price =
                billing === "monthly"
                  ? plan.priceMonthly || 0
                  : plan.priceYearly || 0;
              const meta = planMeta[plan.id] || planMeta.free;
              const accent = isDarkMode ? meta.darkAccent : meta.accent;

              // Popular card is inverted (dark-on-light / light-on-dark)
              const cardBg = isPopular
                ? isDarkMode
                  ? "#F4C430"
                  : "#1A1B3E"
                : card;
              const cardTxt = isPopular
                ? isDarkMode
                  ? "#1A1B3E"
                  : "#FFFFFF"
                : txt;
              const cardSub = isPopular
                ? isDarkMode
                  ? "#4A3A00"
                  : "rgba(255,255,255,0.65)"
                : sub;
              const cardDiv = isPopular
                ? isDarkMode
                  ? "#C9A620"
                  : "rgba(255,255,255,0.12)"
                : div;
              const featureEnabled = isPopular
                ? isDarkMode
                  ? "#1A1B3E"
                  : "#FFFFFF"
                : isDarkMode
                ? "#D1D5DB"
                : "#374151";
              const featureDisabled = isPopular
                ? isDarkMode
                  ? "#82661A"
                  : "rgba(255,255,255,0.35)"
                : sub;
              const checkColor = isPopular
                ? isDarkMode
                  ? "#1A1B3E"
                  : "#FFFFFF"
                : "#10B981";
              const crossColor = isPopular
                ? isDarkMode
                  ? "#82661A"
                  : "rgba(255,255,255,0.3)"
                : isDarkMode
                ? "#3F4249"
                : "#D1D5DB";

              return (
                <View
                  key={plan.id}
                  style={{
                    backgroundColor: cardBg,
                    borderRadius: 18,
                    padding: 20,
                    marginHorizontal: isPopular ? -6 : 0,
                    borderWidth: isCurrent && !isPopular ? 2 : 0,
                    borderColor: "#10B981",
                    shadowColor: isPopular
                      ? isDarkMode
                        ? "#F4C430"
                        : "#1A1B3E"
                      : "#000",
                    shadowOffset: { width: 0, height: isPopular ? 8 : 2 },
                    shadowOpacity: isPopular ? 0.18 : 0.05,
                    shadowRadius: isPopular ? 18 : 6,
                    elevation: isPopular ? 8 : 2,
                    zIndex: isPopular ? 1 : 0,
                  }}
                >
                  {/* Top row */}
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "flex-start",
                      justifyContent: "space-between",
                      marginBottom: 18,
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <View
                        style={{
                          width: 38,
                          height: 38,
                          borderRadius: 11,
                          backgroundColor: isPopular
                            ? isDarkMode
                              ? "rgba(0,0,0,0.12)"
                              : "rgba(255,255,255,0.15)"
                            : isDarkMode
                            ? accent + "22"
                            : accent + "14",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon
                          name={meta.icon}
                          size={19}
                          color={isPopular ? cardTxt : accent}
                        />
                      </View>
                      <View>
                        <Text
                          style={{
                            fontSize: 17,
                            fontFamily: fonts.bold,
                            fontWeight: "700",
                            color: cardTxt,
                          }}
                        >
                          {plan.name}
                        </Text>
                        {isCurrent && (
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 4,
                              marginTop: 2,
                            }}
                          >
                            <View
                              style={{
                                width: 5,
                                height: 5,
                                borderRadius: 2.5,
                                backgroundColor: isPopular
                                  ? cardTxt
                                  : "#10B981",
                              }}
                            />
                            <Text
                              style={{
                                fontSize: 11,
                                fontWeight: "600",
                                color: isPopular ? cardTxt : "#10B981",
                              }}
                            >
                              {t.planActiveBadge}
                            </Text>
                          </View>
                        )}
                      </View>
                    </View>
                    {isPopular && (
                      <View
                        style={{
                          backgroundColor: isDarkMode
                            ? "rgba(0,0,0,0.15)"
                            : "rgba(255,255,255,0.18)",
                          paddingHorizontal: 8,
                          paddingVertical: 3,
                          borderRadius: 6,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 9,
                            fontWeight: "800",
                            color: cardTxt,
                            letterSpacing: 1,
                          }}
                        >
                          {t.planPopularBadge}
                        </Text>
                      </View>
                    )}
                  </View>

                  {/* Price */}
                  <View style={{ marginBottom: 18 }}>
                    {isFree ? (
                      <Text
                        style={{
                          fontSize: 32,
                          fontFamily: fonts.bold,
                          fontWeight: "800",
                          color: cardTxt,
                        }}
                      >
                        {t.planPriceFree}
                      </Text>
                    ) : (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "flex-end",
                          gap: 3,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 13,
                            fontWeight: "600",
                            color: cardSub,
                            marginBottom: 5,
                          }}
                        >
                          ETB
                        </Text>
                        <Text
                          style={{
                            fontSize: 36,
                            fontFamily: fonts.bold,
                            fontWeight: "800",
                            color: cardTxt,
                            lineHeight: 40,
                          }}
                        >
                          {price.toLocaleString()}
                        </Text>
                        <Text
                          style={{
                            fontSize: 13,
                            color: cardSub,
                            marginBottom: 6,
                          }}
                        >
                          {billing === "monthly"
                            ? t.planPricePerMo
                            : t.planPricePerYr}
                        </Text>
                      </View>
                    )}
                    {billing === "yearly" &&
                      !isFree &&
                      plan.priceMonthly > 0 && (
                        <Text
                          style={{
                            fontSize: 12,
                            color: isPopular ? cardSub : "#10B981",
                            fontWeight: "600",
                            marginTop: 2,
                          }}
                        >
                          {t.planSavesPercent.replace(
                            "{percent}",
                            String(
                              Math.round(
                                100 -
                                  (plan.priceYearly /
                                    (plan.priceMonthly * 12)) *
                                    100,
                              ),
                            ),
                          )}
                        </Text>
                      )}
                  </View>

                  {/* Divider */}
                  <View
                    style={{
                      height: 1,
                      backgroundColor: cardDiv,
                      marginBottom: 16,
                    }}
                  />

                  {/* Features */}
                  {features.length > 0 && (
                    <View style={{ gap: 10, marginBottom: 20 }}>
                      {features.map((feature: any, idx: number) => {
                        const rawName =
                          typeof feature === "string"
                            ? feature
                            : feature.name || feature.text || "";
                        const enabled =
                          typeof feature === "string"
                            ? true
                            : feature.enabled !== false;
                        // Map to translated feature text by plan id + index
                        let name = rawName;
                        if (plan.id === "free") {
                          const arr = [
                            (t as any).freeFeature1,
                            (t as any).freeFeature2,
                            (t as any).freeFeature3,
                            (t as any).freeFeature4,
                          ];
                          name = arr[idx] || rawName;
                        } else if (plan.id === "standard") {
                          const arr = [
                            (t as any).standardFeature1,
                            (t as any).standardFeature2,
                            (t as any).standardFeature3,
                            (t as any).standardFeature4,
                            (t as any).standardFeature5,
                          ];
                          name = arr[idx] || rawName;
                        } else if (plan.id === "pro") {
                          const arr = [
                            (t as any).proFeature1,
                            (t as any).proFeature2,
                            (t as any).proFeature3,
                            (t as any).proFeature4,
                            (t as any).proFeature5,
                            (t as any).proFeature6,
                            (t as any).proFeature7,
                          ];
                          name = arr[idx] || rawName;
                        } else if (plan.id === "enterprise") {
                          const arr = [
                            (t as any).enterpriseFeature1,
                            (t as any).enterpriseFeature2,
                            (t as any).enterpriseFeature3,
                            (t as any).enterpriseFeature4,
                            (t as any).enterpriseFeature5,
                            (t as any).enterpriseFeature6,
                            (t as any).enterpriseFeature7,
                          ];
                          name = arr[idx] || rawName;
                        }
                        return (
                          <View
                            key={idx}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <View
                              style={{
                                width: 18,
                                height: 18,
                                borderRadius: 9,
                                backgroundColor: enabled
                                  ? isPopular
                                    ? "rgba(255,255,255,0.2)"
                                    : "#10B98118"
                                  : "transparent",
                                borderWidth: enabled ? 0 : 1,
                                borderColor: crossColor,
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                              }}
                            >
                              <Icon
                                name={enabled ? "check" : "close"}
                                size={11}
                                color={enabled ? checkColor : crossColor}
                              />
                            </View>
                            <Text
                              style={{
                                flex: 1,
                                fontSize: 13,
                                fontFamily: fonts.regular,
                                color: enabled
                                  ? featureEnabled
                                  : featureDisabled,
                                textDecorationLine: enabled
                                  ? "none"
                                  : "line-through",
                              }}
                            >
                              {name}
                            </Text>
                          </View>
                        );
                      })}
                    </View>
                  )}

                  {/* CTA */}
                  <TouchableOpacity
                    onPress={() => handleSelectPlan(plan.id)}
                    disabled={isCurrent}
                    activeOpacity={0.82}
                    style={{
                      paddingVertical: 13,
                      borderRadius: 12,
                      alignItems: "center",
                      backgroundColor: isCurrent
                        ? isPopular
                          ? isDarkMode
                            ? "rgba(0,0,0,0.1)"
                            : "rgba(255,255,255,0.12)"
                          : isDarkMode
                          ? "#1E2330"
                          : "#F3F4F6"
                        : isPopular
                        ? isDarkMode
                          ? "#1A1B3E"
                          : "#FFFFFF"
                        : isDarkMode
                        ? "#F4C430"
                        : "#1A1B3E",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontFamily: fonts.bold,
                        fontWeight: "700",
                        color: isCurrent
                          ? isPopular
                            ? cardSub
                            : sub
                          : isPopular
                          ? isDarkMode
                            ? "#F4C430"
                            : "#1A1B3E"
                          : isDarkMode
                          ? "#1A1B3E"
                          : "#FFFFFF",
                      }}
                    >
                      {isCurrent
                        ? t.planCurrentPlanCta
                        : isFree
                        ? t.planSwitchToFree
                        : t.planGetName.replace("{name}", plan.name)}
                    </Text>
                  </TouchableOpacity>
                </View>
              );
            })
          )}

          {/* ── Footer note ────────────────────────────────────── */}
          {!loading && (
            <View style={{ paddingVertical: 20, alignItems: "center", gap: 6 }}>
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 16 }}
              >
                {[
                  { icon: "lock-outline", label: t.planSecureCheckout },
                  { icon: "refresh", label: t.planCancelAnytime },
                  { icon: "headset-mic", label: t.plan247Support },
                ].map((item, i) => (
                  <View key={i} style={{ alignItems: "center", gap: 4 }}>
                    <Icon name={item.icon} size={16} color={sub} />
                    <Text
                      style={{
                        fontSize: 10,
                        color: sub,
                        fontFamily: fonts.regular,
                      }}
                    >
                      {item.label}
                    </Text>
                  </View>
                ))}
              </View>
            </View>
          )}
        </View>
      </View>
    </ScrollView>
  );
}

// Settings Profile Sub-Screen (kept for backward compatibility with navigation)
function SettingsProfileScreen({ navigation, route, isDarkMode }: any) {
  const { userData, user } = route.params;
  const [displayName, setDisplayName] = useState(userData?.displayName || "");
  const [dateOfBirth, setDateOfBirth] = useState(userData?.dateOfBirth || "");
  const [bio, setBio] = useState(userData?.bio || "");
  const [profilePicture, setProfilePicture] = useState(
    userData?.profilePicture || "",
  );
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);

  // Mobile drawer and menu states
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);

  const colors = isDarkMode ? darkColors : lightColors;

  const pickImage = async () => {
    try {
      setUploadError(null); // Clear any previous errors
      // Using Android photo picker (no permissions needed on Android 13+)
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [1, 1],
        quality: 0.8,
      });

      if (!result.canceled && result.assets[0]) {
        setUploading(true);
        await uploadImage(result.assets[0].uri);
      }
    } catch (error) {
      console.error("Error picking image:", error);
      Alert.alert("Error", "Failed to pick image");
    } finally {
      setUploading(false);
    }
  };

  const uploadImage = async (uri: string) => {
    if (!user) return;

    try {
      // Fetch the image
      const response = await fetch(uri);
      const blob = await response.blob();

      // Get the actual MIME type from the blob
      const mimeType = blob.type || "image/jpeg";

      // Determine file extension from MIME type
      const extension = mimeType.split("/")[1] || "jpg";
      const filename = `${Date.now()}.${extension}`;

      // Convert blob to base64
      const reader = new FileReader();
      const base64Promise = new Promise<string>((resolve, reject) => {
        reader.onloadend = () => {
          const base64String = (reader.result as string).split(",")[1];
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      const fileData = await base64Promise;

      // Call the secure upload function
      const secureFileUploadCallable = httpsCallable(
        functions,
        "secureFileUploadCallable",
      );
      const result = await secureFileUploadCallable({
        fileData,
        filename,
        mimeType,
        fileType: "profile-picture",
      });

      const data = result.data as {
        success: boolean;
        downloadURL: string;
        error?: string;
      };

      if (!data.success) {
        throw new Error(data.error || "Upload failed");
      }

      const downloadURL = data.downloadURL;

      // Update the profile picture state
      setProfilePicture(downloadURL);

      // Save to Firestore immediately
      await updateDoc(doc(db, "users", user.uid), {
        profilePicture: downloadURL,
      });

      Alert.alert("Success", "Photo uploaded successfully!");
      setUploadError(null); // Clear any errors on success
    } catch (error: any) {
      console.error("Error uploading image:", error);

      let errorMessage = "";

      // Check for specific Firebase Storage errors
      if (error?.code === "storage/unauthorized") {
        errorMessage =
          "Upload Rejected: The photo you selected does not meet our requirements. Please ensure you are uploading a valid PNG, JPEG, or JPG image file that is less than 5MB.";
      } else if (error?.code === "storage/canceled") {
        errorMessage = "Upload Cancelled: Photo upload was cancelled.";
      } else if (error?.code === "storage/unknown") {
        errorMessage =
          "Upload Failed: An unknown error occurred. Please check your internet connection and try again.";
      } else if (error?.code === "storage/quota-exceeded") {
        errorMessage =
          "Storage Limit Exceeded: The storage quota has been exceeded. Please contact support.";
      } else {
        errorMessage =
          "Upload Failed: Failed to upload photo. Please try again with a different image.";
      }

      setUploadError(errorMessage);
      Alert.alert("Upload Error", errorMessage);
    }
  };

  const saveProfile = async () => {
    if (!user) return;

    try {
      setSaving(true);
      await updateDoc(doc(db, "users", user.uid), {
        displayName,
        dateOfBirth,
        bio,
        profilePicture,
      });
      Alert.alert("Success", "Profile updated successfully!");
      navigation.goBack();
    } catch (error) {
      console.error("Error updating profile:", error);
      Alert.alert("Error", "Failed to update profile");
    } finally {
      setSaving(false);
    }
  };

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: colors.cream }]}>
      {/* Header Toolbar - Same style as Jobs page */}
      <View
        style={[
          styles.jobsToolbar,
          {
            backgroundColor: colors.white,
            borderBottomColor: colors.lightGray,
          },
        ]}
      >
        <View style={styles.jobsToolbarLeft}>
          {/* Mobile Menu Button (Drawer) */}
          {Platform.OS !== "web" && (
            <TouchableOpacity
              onPress={() => setShowMobileMenu(true)}
              style={styles.mobileMenuButton}
            >
              <Icon name="menu" size={24} color={colors.deepNavy} />
            </TouchableOpacity>
          )}

          {/* Title */}
          <Text
            style={[
              styles.settingsTitle,
              { color: colors.deepNavy, marginLeft: 16 },
            ]}
          >
            Profile
          </Text>
        </View>

        <View style={styles.jobsToolbarRight}>
          {/* More Menu Button (3 dots) */}
          {Platform.OS !== "web" && (
            <TouchableOpacity
              style={[
                styles.toolbarIconButton,
                { backgroundColor: isDarkMode ? "#2C2F36" : colors.cream },
              ]}
              onPress={() => setIsMoreMenuOpen(!isMoreMenuOpen)}
            >
              <Icon
                name="more-vert"
                size={24}
                color={isDarkMode ? colors.white : colors.deepNavy}
              />
            </TouchableOpacity>
          )}
        </View>
      </View>

      {/* More Menu Dropdown for Profile */}
      {isMoreMenuOpen && Platform.OS !== "web" && (
        <View style={styles.fullScreenDropdownOverlay}>
          <TouchableOpacity
            style={styles.fullScreenTouchArea}
            onPress={() => setIsMoreMenuOpen(false)}
            activeOpacity={1}
          />
          <View style={[styles.moreMenuDropdown, { top: 60, right: 16 }]}>
            <TouchableOpacity
              style={styles.moreMenuItem}
              onPress={() => {
                setIsMoreMenuOpen(false);
                navigation.navigate("Settings");
              }}
            >
              <Icon name="settings" size={20} color={colors.deepNavy} />
              <Text style={styles.moreMenuText}>Settings</Text>
            </TouchableOpacity>

            <View style={styles.moreMenuDivider} />

            <TouchableOpacity
              style={styles.moreMenuItem}
              onPress={() => {
                setIsMoreMenuOpen(false);
                navigation.goBack();
              }}
            >
              <Icon name="arrow-back" size={20} color={colors.deepNavy} />
              <Text style={styles.moreMenuText}>Back</Text>
            </TouchableOpacity>
          </View>
        </View>
      )}

      {/* Mobile Drawer Menu */}
      {showMobileMenu && Platform.OS !== "web" && (
        <MobileDrawer
          visible={showMobileMenu}
          onClose={() => setShowMobileMenu(false)}
          navigation={navigation}
          user={user}
          userData={userData}
          isDarkMode={isDarkMode}
          toggleTheme={toggleTheme}
          colors={colors}
          currentView="candidate"
          currentLanguage={currentLanguage}
        />
      )}

      <ScrollView
        style={[styles.settingsContainer, { backgroundColor: colors.cream }]}
      >
        <View style={styles.settingsSection}>
          {/* Profile Picture */}
          <View
            style={[
              styles.settingsInputGroup,
              { backgroundColor: colors.white },
            ]}
          >
            <Text
              style={[styles.settingsInputLabel, { color: colors.deepNavy }]}
            >
              Profile Picture
            </Text>
            <View style={styles.profilePictureContainer}>
              {profilePicture ? (
                <Image
                  source={{ uri: profilePicture }}
                  style={styles.profilePicturePreview}
                />
              ) : (
                <View
                  style={[
                    styles.profilePicturePlaceholder,
                    { backgroundColor: colors.beeYellow },
                  ]}
                >
                  <Icon name="person" size={64} color="#1a1a2e" />
                </View>
              )}

              <TouchableOpacity
                style={[
                  styles.uploadPhotoButton,
                  { backgroundColor: colors.beeYellow },
                ]}
                onPress={pickImage}
                disabled={uploading}
              >
                <Icon name="cloud-upload" size={20} color="#1a1a2e" />
                <Text
                  style={[styles.uploadPhotoButtonText, { color: "#1a1a2e" }]}
                >
                  {uploading ? "Uploading..." : "Upload Photo"}
                </Text>
              </TouchableOpacity>

              {/* Error Message Display */}
              {uploadError && (
                <View
                  style={{
                    backgroundColor: "#FEE2E2",
                    borderWidth: 1,
                    borderColor: "#EF4444",
                    borderRadius: 8,
                    padding: 12,
                    marginTop: 12,
                    flexDirection: "row",
                    alignItems: "flex-start",
                    gap: 8,
                  }}
                >
                  <Icon name="error" size={20} color="#DC2626" />
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 13,
                      color: "#991B1B",
                      lineHeight: 18,
                    }}
                  >
                    {uploadError}
                  </Text>
                  <TouchableOpacity onPress={() => setUploadError(null)}>
                    <Icon name="close" size={18} color="#DC2626" />
                  </TouchableOpacity>
                </View>
              )}
            </View>
          </View>

          {/* Display Name */}
          <View
            style={[
              styles.settingsInputGroup,
              { backgroundColor: colors.white },
            ]}
          >
            <Text
              style={[styles.settingsInputLabel, { color: colors.deepNavy }]}
            >
              Display Name
            </Text>
            <TextInput
              style={[
                styles.settingsTextInput,
                { backgroundColor: colors.cream, color: colors.deepNavy },
              ]}
              placeholder="Enter your display name"
              placeholderTextColor={colors.warmGray}
              value={displayName}
              onChangeText={setDisplayName}
            />
          </View>

          {/* Bio */}
          <View
            style={[
              styles.settingsInputGroup,
              { backgroundColor: colors.white },
            ]}
          >
            <Text
              style={[styles.settingsInputLabel, { color: colors.deepNavy }]}
            >
              Bio
            </Text>
            <TextInput
              style={[
                styles.settingsTextInput,
                styles.settingsTextAreaInput,
                { backgroundColor: colors.cream, color: colors.deepNavy },
              ]}
              placeholder="Tell us about yourself..."
              placeholderTextColor={colors.warmGray}
              value={bio}
              onChangeText={setBio}
              multiline
              numberOfLines={4}
              textAlignVertical="top"
            />
          </View>

          {/* Date of Birth */}
          <View
            style={[
              styles.settingsInputGroup,
              { backgroundColor: colors.white },
            ]}
          >
            <Text
              style={[styles.settingsInputLabel, { color: colors.deepNavy }]}
            >
              Date of Birth
            </Text>
            <TextInput
              style={[
                styles.settingsTextInput,
                { backgroundColor: colors.cream, color: colors.deepNavy },
              ]}
              placeholder="YYYY-MM-DD"
              placeholderTextColor={colors.warmGray}
              value={dateOfBirth}
              onChangeText={setDateOfBirth}
            />
            <Text
              style={[styles.settingsInputHint, { color: colors.warmGray }]}
            >
              Format: YYYY-MM-DD (e.g., 1990-01-15)
            </Text>
          </View>

          {/* Email (Read-only) */}
          <View
            style={[
              styles.settingsInputGroup,
              { backgroundColor: colors.white },
            ]}
          >
            <Text
              style={[styles.settingsInputLabel, { color: colors.deepNavy }]}
            >
              Email
            </Text>
            <TextInput
              style={[
                styles.settingsTextInput,
                styles.settingsTextInputDisabled,
                { backgroundColor: colors.lightGray, color: colors.warmGray },
              ]}
              value={user?.email || ""}
              editable={false}
            />
          </View>
        </View>

        {/* Save Button */}
        <TouchableOpacity
          style={[
            styles.settingsSaveButton,
            { backgroundColor: colors.beeYellow },
            saving && styles.settingsSaveButtonDisabled,
          ]}
          onPress={saveProfile}
          disabled={saving}
        >
          {saving ? (
            <ActivityIndicator size="small" color={colors.deepNavy} />
          ) : (
            <Text style={[styles.settingsSaveButtonText, { color: "#1a1a2e" }]}>
              Save Changes
            </Text>
          )}
        </TouchableOpacity>
      </ScrollView>
    </SafeAreaView>
  );
}

// Settings Appearance Sub-Screen
function SettingsAppearanceScreen({
  navigation,
  isDarkMode,
  toggleTheme,
}: any) {
  const colors = isDarkMode ? darkColors : lightColors;

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: colors.cream }]}>
      <View
        style={[
          styles.settingsHeader,
          {
            backgroundColor: colors.white,
            borderBottomColor: colors.lightGray,
          },
        ]}
      >
        <TouchableOpacity
          style={styles.settingsBackButton}
          onPress={() => navigation.goBack()}
        >
          <Icon name="arrow-back" size={24} color={colors.deepNavy} />
        </TouchableOpacity>
        <Text style={[styles.settingsTitle, { color: colors.deepNavy }]}>
          Appearance
        </Text>
      </View>

      <ScrollView
        style={[styles.settingsContainer, { backgroundColor: colors.cream }]}
      >
        <View style={styles.settingsSection}>
          <Text
            style={[styles.settingsSectionTitle, { color: colors.deepNavy }]}
          >
            Theme
          </Text>

          {/* Theme Toggle */}
          <TouchableOpacity
            style={[
              styles.settingsToggleItem,
              { backgroundColor: colors.white },
            ]}
            onPress={toggleTheme}
          >
            <View style={styles.settingsToggleLeft}>
              <View
                style={[
                  styles.settingsMenuIconContainer,
                  { backgroundColor: colors.cream },
                ]}
              >
                <Icon
                  name={isDarkMode ? "dark-mode" : "light-mode"}
                  size={24}
                  color={colors.beeYellow}
                />
              </View>
              <View>
                <Text
                  style={[
                    styles.settingsToggleTitle,
                    { color: colors.deepNavy },
                  ]}
                >
                  Dark Mode
                </Text>
                <Text
                  style={[
                    styles.settingsToggleSubtitle,
                    { color: colors.warmGray },
                  ]}
                >
                  {isDarkMode ? "Enabled" : "Disabled"}
                </Text>
              </View>
            </View>
            <View
              style={[
                styles.toggleSwitch,
                isDarkMode && styles.toggleSwitchActive,
              ]}
            >
              <View
                style={[
                  styles.toggleKnob,
                  isDarkMode && styles.toggleKnobActive,
                ]}
              />
            </View>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

// Notifications Settings Content
function SettingsNotificationsContent({
  userData,
  user,
  colors,
  refetchUserData,
  currentLanguage = "en",
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [emailNotifications, setEmailNotifications] = useState(
    userData?.emailNotifications ?? true,
  );
  const [pushNotifications, setPushNotifications] = useState(
    userData?.pushNotifications ?? true,
  );
  const [jobAlerts, setJobAlerts] = useState(userData?.jobAlerts ?? true);
  const [applicationUpdates, setApplicationUpdates] = useState(
    userData?.applicationUpdates ?? true,
  );
  const [saving, setSaving] = useState(false);

  const isDarkMode = colors === darkColors;
  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const accent = "#F4C430";

  const handlePushToggle = async (newValue: boolean) => {
    if (
      newValue &&
      Platform.OS === "web" &&
      typeof Notification !== "undefined"
    ) {
      // Request browser notification permission for web
      try {
        console.log("[Settings] Requesting browser notification permission...");
        const permission = await Notification.requestPermission();
        console.log("[Settings] Permission result:", permission);

        if (permission !== "granted") {
          Alert.alert(
            "Permission Denied",
            'Push notifications are blocked. To enable:\n\n1. Click the lock/info icon in the address bar\n2. Find "Notifications"\n3. Change to "Allow"\n4. Reload the page and try again',
          );
          return;
        }

        console.log("[Settings] Notification permission granted");
      } catch (error) {
        console.error(
          "[Settings] Failed to request notification permission:",
          error,
        );
        Alert.alert(
          "Error",
          "Failed to request notification permission. Please check browser console.",
        );
        return;
      }
    }
    setPushNotifications(newValue);
  };

  const saveNotificationSettings = async () => {
    if (!user) return;
    try {
      setSaving(true);
      console.log("[Settings] Saving notification settings:", {
        emailNotifications,
        pushNotifications,
        jobAlerts,
        applicationUpdates,
      });

      await updateDoc(doc(db, "users", user.uid), {
        emailNotifications,
        pushNotifications,
        jobAlerts,
        applicationUpdates,
        notificationPreferences: {
          newJobs: jobAlerts,
          applicationUpdates: applicationUpdates,
        },
        isPushNotificationsEnabled: pushNotifications && jobAlerts,
        isEmailNotificationsEnabled: emailNotifications && jobAlerts,
        isNotificationsEnabled: jobAlerts,
      });

      console.log("[Settings] Settings saved successfully");

      if (refetchUserData) {
        console.log("[Settings] Refetching user data...");
        await refetchUserData();
      }

      Alert.alert(
        "Success",
        "Notification settings saved! Web FCM token will be registered automatically.",
      );
    } catch (error) {
      console.error("[Settings] Error saving settings:", error);
      Alert.alert("Error", "Failed to save settings");
    } finally {
      setSaving(false);
    }
  };

  const rows = [
    {
      icon: "email",
      label: t.emailNotificationsLabel,
      subtitle: t.emailNotificationsSubtitle,
      value: emailNotifications,
      onChange: setEmailNotifications,
    },
    {
      icon: "notifications-active",
      label: t.pushNotificationsLabel,
      subtitle: t.pushNotificationsSubtitle,
      value: pushNotifications,
      onChange: handlePushToggle,
    },
    {
      icon: "work-outline",
      label: t.jobAlertsLabel,
      subtitle: t.jobAlertsSubtitle,
      value: jobAlerts,
      onChange: setJobAlerts,
    },
    {
      icon: "update",
      label: t.applicationUpdatesLabel,
      subtitle: t.applicationUpdatesSubtitle,
      value: applicationUpdates,
      onChange: setApplicationUpdates,
    },
  ];

  return (
    <View style={{ flex: 1, backgroundColor: surface }}>
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 100 }}
      >
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.notifications}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {rows.map((row, idx) => (
            <View key={row.label}>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  paddingVertical: 14,
                  paddingHorizontal: 20,
                  gap: 16,
                }}
              >
                <View
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    backgroundColor: row.value
                      ? isDarkMode
                        ? "#2A2D1A"
                        : "#FFFBEB"
                      : isDarkMode
                      ? "#1E2027"
                      : "#F3F4F6",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Icon
                    name={row.icon}
                    size={18}
                    color={row.value ? accent : muted}
                  />
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.semiBold,
                      color: primary,
                    }}
                  >
                    {row.label}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color: muted,
                      marginTop: 1,
                      fontFamily: fonts.regular,
                    }}
                  >
                    {row.subtitle}
                  </Text>
                </View>
                <Switch
                  value={row.value}
                  onValueChange={row.onChange}
                  trackColor={{ false: border, true: accent }}
                  thumbColor={
                    row.value ? "#1A1D23" : isDarkMode ? "#6B7280" : "#FFFFFF"
                  }
                  ios_backgroundColor={border}
                />
              </View>
              {idx < rows.length - 1 && (
                <View
                  style={{ height: 1, backgroundColor: border, marginLeft: 72 }}
                />
              )}
            </View>
          ))}
        </View>
      </ScrollView>

      {/* Fixed Save Button */}
      <View
        style={{
          padding: 16,
          paddingBottom: 24,
          backgroundColor: bg,
          borderTopWidth: 1,
          borderTopColor: border,
        }}
      >
        <TouchableOpacity
          style={{
            backgroundColor: accent,
            paddingVertical: 15,
            borderRadius: 12,
            alignItems: "center",
            opacity: saving ? 0.6 : 1,
          }}
          onPress={saveNotificationSettings}
          disabled={saving}
          activeOpacity={0.85}
        >
          {saving ? (
            <ActivityIndicator size="small" color="#1A1D23" />
          ) : (
            <Text
              style={{ fontSize: 16, fontFamily: fonts.bold, color: "#1A1D23" }}
            >
              {t.saveChangesLabel}
            </Text>
          )}
        </TouchableOpacity>
      </View>
    </View>
  );
}

// Privacy Settings Content
function SettingsPrivacyContent({
  userData,
  user,
  colors,
  currentLanguage = "en",
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [profileVisibility, setProfileVisibility] = useState(
    userData?.profileVisibility ?? "public",
  );
  const [showEmail, setShowEmail] = useState(userData?.showEmail ?? false);
  const [allowMessaging, setAllowMessaging] = useState(
    userData?.allowMessaging ?? true,
  );
  const [saving, setSaving] = useState(false);

  const isDarkMode = colors === darkColors;
  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const accent = "#F4C430";

  const savePrivacySettings = async () => {
    if (!user) return;
    try {
      setSaving(true);
      await updateDoc(doc(db, "users", user.uid), {
        profileVisibility,
        showEmail,
        allowMessaging,
      });
      Alert.alert("Success", "Privacy settings saved!");
    } catch (error) {
      console.error("Error saving settings:", error);
      Alert.alert("Error", "Failed to save settings");
    } finally {
      setSaving(false);
    }
  };

  const visibilityOptions = [
    {
      value: "public",
      label: t.visibilityPublic,
      subtitle: t.visibilityPublicSubtitle,
      icon: "public",
    },
    {
      value: "connections-only",
      label: t.visibilityConnectionsOnly,
      subtitle: t.visibilityConnectionsOnlySubtitle,
      icon: "people",
    },
    {
      value: "private",
      label: t.visibilityPrivate,
      subtitle: t.visibilityPrivateSubtitle,
      icon: "lock",
    },
  ];

  return (
    <View style={{ flex: 1, backgroundColor: surface }}>
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 100 }}
      >
        {/* Profile Visibility Section */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.profileVisibilitySection}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {visibilityOptions.map((opt, idx) => {
            const isSelected = profileVisibility === opt.value;
            const isLast = idx === visibilityOptions.length - 1;
            return (
              <View key={opt.value}>
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 14,
                    paddingHorizontal: 20,
                    gap: 16,
                  }}
                  onPress={() => setProfileVisibility(opt.value)}
                  activeOpacity={0.7}
                >
                  <View
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: 10,
                      backgroundColor: isSelected
                        ? accent + "18"
                        : isDarkMode
                        ? "#1E2027"
                        : "#F3F4F6",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Icon
                      name={opt.icon}
                      size={18}
                      color={isSelected ? accent : muted}
                    />
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 15,
                        fontFamily: isSelected ? fonts.semiBold : fonts.regular,
                        color: primary,
                      }}
                    >
                      {opt.label}
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,
                        color: muted,
                        marginTop: 1,
                        fontFamily: fonts.regular,
                      }}
                    >
                      {opt.subtitle}
                    </Text>
                  </View>
                  {isSelected ? (
                    <Icon name="check-circle" size={20} color={accent} />
                  ) : (
                    <View
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 10,
                        borderWidth: 1.5,
                        borderColor: border,
                      }}
                    />
                  )}
                </TouchableOpacity>
                {!isLast && (
                  <View
                    style={{
                      height: 1,
                      backgroundColor: border,
                      marginLeft: 72,
                    }}
                  />
                )}
              </View>
            );
          })}
        </View>

        {/* Contact & Messaging Section */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.contactMessagingSection}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {/* Show Email */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              paddingVertical: 14,
              paddingHorizontal: 20,
              gap: 16,
            }}
          >
            <View
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                backgroundColor: showEmail
                  ? isDarkMode
                    ? "#2A2D1A"
                    : "#FFFBEB"
                  : isDarkMode
                  ? "#1E2027"
                  : "#F3F4F6",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon name="email" size={18} color={showEmail ? accent : muted} />
            </View>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.semiBold,
                  color: primary,
                }}
              >
                {t.showEmailLabel}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  color: muted,
                  marginTop: 1,
                  fontFamily: fonts.regular,
                }}
              >
                {t.showEmailSubtitle}
              </Text>
            </View>
            <Switch
              value={showEmail}
              onValueChange={setShowEmail}
              trackColor={{ false: border, true: accent }}
              thumbColor={
                showEmail ? "#1A1D23" : isDarkMode ? "#6B7280" : "#FFFFFF"
              }
              ios_backgroundColor={border}
            />
          </View>

          <View
            style={{ height: 1, backgroundColor: border, marginLeft: 72 }}
          />

          {/* Allow Messaging */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              paddingVertical: 14,
              paddingHorizontal: 20,
              gap: 16,
            }}
          >
            <View
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                backgroundColor: allowMessaging
                  ? isDarkMode
                    ? "#2A2D1A"
                    : "#FFFBEB"
                  : isDarkMode
                  ? "#1E2027"
                  : "#F3F4F6",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon
                name="message"
                size={18}
                color={allowMessaging ? accent : muted}
              />
            </View>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.semiBold,
                  color: primary,
                }}
              >
                {t.allowMessagingLabel}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  color: muted,
                  marginTop: 1,
                  fontFamily: fonts.regular,
                }}
              >
                {t.allowMessagingSubtitle}
              </Text>
            </View>
            <Switch
              value={allowMessaging}
              onValueChange={setAllowMessaging}
              trackColor={{ false: border, true: accent }}
              thumbColor={
                allowMessaging ? "#1A1D23" : isDarkMode ? "#6B7280" : "#FFFFFF"
              }
              ios_backgroundColor={border}
            />
          </View>
        </View>
      </ScrollView>

      {/* Fixed Save Button */}
      <View
        style={{
          padding: 16,
          paddingBottom: 24,
          backgroundColor: bg,
          borderTopWidth: 1,
          borderTopColor: border,
        }}
      >
        <TouchableOpacity
          style={{
            backgroundColor: accent,
            paddingVertical: 15,
            borderRadius: 12,
            alignItems: "center",
            opacity: saving ? 0.6 : 1,
          }}
          onPress={savePrivacySettings}
          disabled={saving}
          activeOpacity={0.85}
        >
          {saving ? (
            <ActivityIndicator size="small" color="#1A1D23" />
          ) : (
            <Text
              style={{ fontSize: 16, fontFamily: fonts.bold, color: "#1A1D23" }}
            >
              {t.saveChangesLabel}
            </Text>
          )}
        </TouchableOpacity>
      </View>
    </View>
  );
}

// Help & Support Content
function SettingsHelpContent({ colors, currentLanguage = "en" }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [selectedSection, setSelectedSection] = useState<string>("");

  // Read URL parameter on mount
  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      const section = params.get("helpSection");
      if (section) {
        setSelectedSection(section);
      }
    }
  }, []);

  // Update URL when section changes
  const handleSectionSelect = (sectionId: string) => {
    setSelectedSection(sectionId);
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const url = new URL(window.location.href);
      url.searchParams.set("helpSection", sectionId);
      window.history.pushState({}, "", url.toString());
    }
  };

  // Handle back navigation
  const handleBack = () => {
    setSelectedSection("");
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const url = new URL(window.location.href);
      url.searchParams.delete("helpSection");
      window.history.pushState({}, "", url.toString());
    }
  };

  // Listen for browser back/forward navigation
  useEffect(() => {
    if (Platform.OS === "web") {
      const handlePopState = () => {
        if (typeof window !== "undefined") {
          const params = new URLSearchParams(window.location.search);
          const section = params.get("helpSection");
          setSelectedSection(section || "");
        }
      };

      window.addEventListener("popstate", handlePopState);
      return () => window.removeEventListener("popstate", handlePopState);
    }
  }, []);

  const helpItems = [
    {
      id: "faqs",
      icon: "help-outline",
      title: t.faqsMenuTitle,
      subtitle: t.faqsMenuSubtitle,
    },
    {
      id: "contact",
      icon: "contact-support",
      title: t.contactSupportTitle,
      subtitle: t.contactSupportSubtitle,
    },
    {
      id: "feedback",
      icon: "feedback",
      title: t.sendFeedbackTitle,
      subtitle: t.sendFeedbackSubtitle,
    },
    {
      id: "privacy",
      icon: "policy",
      title: t.privacyPolicy,
      subtitle: t.privacyPolicySubtitle,
    },
    {
      id: "terms",
      icon: "description",
      title: t.termsOfService,
      subtitle: t.termsOfServiceSubtitle,
    },
  ];

  // Render section content
  const renderSectionContent = () => {
    switch (selectedSection) {
      case "faqs":
        return (
          <HelpFAQsContent
            colors={colors}
            onBack={handleBack}
            currentLanguage={currentLanguage}
          />
        );
      case "contact":
        return (
          <HelpContactContent
            colors={colors}
            onBack={handleBack}
            currentLanguage={currentLanguage}
          />
        );
      case "feedback":
        return (
          <HelpFeedbackContent
            colors={colors}
            onBack={handleBack}
            currentLanguage={currentLanguage}
          />
        );
      case "privacy":
        return (
          <HelpPrivacyContent
            colors={colors}
            onBack={handleBack}
            currentLanguage={currentLanguage}
          />
        );
      case "terms":
        return (
          <HelpTermsContent
            colors={colors}
            onBack={handleBack}
            currentLanguage={currentLanguage}
          />
        );
      default:
        return null;
    }
  };

  if (selectedSection) {
    return renderSectionContent();
  }

  const isDarkMode = colors === darkColors;
  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const accent = "#F4C430";

  return (
    <View style={{ flex: 1, backgroundColor: surface }}>
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 40 }}
      >
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.settingsHelpLabel}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {helpItems.map((item, index) => {
            const isLast = index === helpItems.length - 1;
            return (
              <View key={item.id}>
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 14,
                    paddingHorizontal: 20,
                    gap: 16,
                  }}
                  onPress={() => handleSectionSelect(item.id)}
                  activeOpacity={0.7}
                >
                  <View
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: 10,
                      backgroundColor: isDarkMode ? "#1E2027" : "#F3F4F6",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Icon name={item.icon} size={18} color={muted} />
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 15,
                        fontFamily: fonts.semiBold,
                        color: primary,
                      }}
                    >
                      {item.title}
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,
                        color: muted,
                        marginTop: 1,
                        fontFamily: fonts.regular,
                      }}
                    >
                      {item.subtitle}
                    </Text>
                  </View>
                  <Icon name="chevron-right" size={20} color={muted} />
                </TouchableOpacity>
                {!isLast && (
                  <View
                    style={{
                      height: 1,
                      backgroundColor: border,
                      marginLeft: 72,
                    }}
                  />
                )}
              </View>
            );
          })}
        </View>

        {/* Contact Banner */}
        <View
          style={{
            marginHorizontal: 20,
            marginTop: 24,
            padding: 16,
            backgroundColor: bg,
            borderRadius: 12,
            borderWidth: 1,
            borderColor: border,
            alignItems: "center",
            gap: 4,
          }}
        >
          <Text
            style={{ fontSize: 14, fontFamily: fonts.semiBold, color: primary }}
          >
            {t.needImmediateHelpText}
          </Text>
          <Text
            style={{ fontSize: 13, color: muted, fontFamily: fonts.regular }}
          >
            support@nibjobs.com
          </Text>
        </View>
      </ScrollView>
    </View>
  );
}

// Help FAQs Content
function HelpFAQsContent({ colors, onBack, currentLanguage = "en" }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const faqs = Array.from({ length: 10 }, (_, i) => ({
    question: (t as any)[`helpFaq${i + 1}Q`] || "",
    answer: (t as any)[`helpFaq${i + 1}A`] || "",
  }));

  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const isDarkMode = colors === darkColors;
  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const accent = "#F4C430";

  return (
    <View style={{ flex: 1, backgroundColor: surface }}>
      {/* Back row */}
      <TouchableOpacity
        onPress={onBack}
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: 20,
          paddingVertical: 14,
          borderBottomWidth: 1,
          borderBottomColor: border,
          backgroundColor: bg,
          gap: 10,
        }}
        activeOpacity={0.7}
      >
        <Icon name="arrow-back" size={20} color={muted} />
        <Text style={{ fontSize: 14, fontFamily: fonts.medium, color: muted }}>
          {t.settingsHelpLabel}
        </Text>
      </TouchableOpacity>

      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 40 }}
      >
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.frequentlyAskedQuestionsLabel}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {faqs.map((faq, index) => {
            const isExpanded = expandedIndex === index;
            const isLast = index === faqs.length - 1;
            return (
              <View key={index}>
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 16,
                    paddingHorizontal: 20,
                    gap: 14,
                  }}
                  onPress={() => setExpandedIndex(isExpanded ? null : index)}
                  activeOpacity={0.7}
                >
                  <View
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: 8,
                      backgroundColor: isExpanded
                        ? accent + "20"
                        : isDarkMode
                        ? "#1E2027"
                        : "#F3F4F6",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: fonts.bold,
                        color: isExpanded ? accent : muted,
                      }}
                    >
                      {index + 1}
                    </Text>
                  </View>
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 15,
                      fontFamily: isExpanded ? fonts.semiBold : fonts.regular,
                      color: primary,
                      lineHeight: 21,
                    }}
                  >
                    {faq.question}
                  </Text>
                  <Icon
                    name={
                      isExpanded ? "keyboard-arrow-up" : "keyboard-arrow-down"
                    }
                    size={20}
                    color={muted}
                  />
                </TouchableOpacity>
                {isExpanded && (
                  <View
                    style={{
                      paddingHorizontal: 20,
                      paddingBottom: 16,
                      paddingLeft: 62,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        color: muted,
                        lineHeight: 22,
                        fontFamily: fonts.regular,
                      }}
                    >
                      {faq.answer}
                    </Text>
                  </View>
                )}
                {!isLast && (
                  <View
                    style={{
                      height: 1,
                      backgroundColor: border,
                      marginLeft: 62,
                    }}
                  />
                )}
              </View>
            );
          })}
        </View>

        {/* Support footer */}
        <View
          style={{
            marginHorizontal: 20,
            marginTop: 24,
            padding: 16,
            backgroundColor: bg,
            borderRadius: 12,
            borderWidth: 1,
            borderColor: border,
            alignItems: "center",
            gap: 4,
          }}
        >
          <Text
            style={{ fontSize: 14, fontFamily: fonts.semiBold, color: primary }}
          >
            {t.stillHaveQuestionsText}
          </Text>
          <Text
            style={{ fontSize: 13, color: muted, fontFamily: fonts.regular }}
          >
            support@nibjobs.com
          </Text>
        </View>
      </ScrollView>
    </View>
  );
}

// Help Contact Support Content
function HelpContactContent({ colors, onBack, currentLanguage = "en" }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = async () => {
    if (!name || !email || !subject || !message) {
      Alert.alert(
        t.errorTitle,
        (t as any).fillAllFields || "Please fill in all required fields",
      );
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      Alert.alert(
        t.errorTitle,
        (t as any).invalidEmail || "Please enter a valid email address",
      );
      return;
    }

    setSending(true);
    try {
      console.log(
        "🔵 Attempting to save contact support request to Firestore...",
      );
      console.log("📋 Data:", { name, email, phone, subject, message });
      console.log("🔧 Database instance:", db);

      // Save contact support request to Firestore using addDoc
      const docRef = await addDoc(collection(db, "contactSupport"), {
        name,
        email,
        phone: phone || null,
        subject,
        message,
        status: "pending",
        createdAt: new Date(),
        updatedAt: new Date(),
      });

      console.log(
        "✅ Contact support request saved successfully! Document ID:",
        docRef.id,
      );

      // Show success banner
      setShowSuccess(true);

      // Clear form
      setName("");
      setEmail("");
      setPhone("");
      setSubject("");
      setMessage("");

      // Hide banner after 5 seconds
      setTimeout(() => setShowSuccess(false), 5000);
    } catch (error) {
      console.error("❌ Error submitting contact form:", error);
      console.error("❌ Error details:", {
        message: error instanceof Error ? error.message : "Unknown error",
        code: (error as any).code,
        stack: error instanceof Error ? error.stack : undefined,
      });
      Alert.alert(
        t.errorTitle,
        (t as any).messageSendFailed ||
          "Failed to send message. Please try again or contact us directly at support@nibjobs.com",
      );
    } finally {
      setSending(false);
    }
  };

  const isDarkMode = colors === darkColors;
  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const accent = "#F4C430";
  const inputBg = isDarkMode ? "#1E2027" : "#F3F4F6";

  return (
    <View style={{ flex: 1, backgroundColor: surface }}>
      {/* Back row */}
      <TouchableOpacity
        onPress={onBack}
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: 20,
          paddingVertical: 14,
          borderBottomWidth: 1,
          borderBottomColor: border,
          backgroundColor: bg,
          gap: 10,
        }}
        activeOpacity={0.7}
      >
        <Icon name="arrow-back" size={20} color={muted} />
        <Text style={{ fontSize: 14, fontFamily: fonts.medium, color: muted }}>
          {t.settingsHelpLabel}
        </Text>
      </TouchableOpacity>

      {/* Success Banner */}
      {showSuccess && (
        <View
          style={{
            backgroundColor: "#10B981",
            paddingHorizontal: 20,
            paddingVertical: 14,
            flexDirection: "row",
            alignItems: "center",
            gap: 12,
          }}
        >
          <Icon name="check-circle" size={20} color="#FFFFFF" />
          <View style={{ flex: 1 }}>
            <Text
              style={{ fontSize: 14, fontFamily: fonts.bold, color: "#FFFFFF" }}
            >
              {t.messageSentText}
            </Text>
            <Text
              style={{
                fontSize: 12,
                color: "rgba(255,255,255,0.85)",
                fontFamily: fonts.regular,
              }}
            >
              {t.messageReplyTimeText}
            </Text>
          </View>
          <TouchableOpacity
            onPress={() => setShowSuccess(false)}
            hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
          >
            <Icon name="close" size={18} color="#FFFFFF" />
          </TouchableOpacity>
        </View>
      )}

      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 40 }}
      >
        {/* Form section */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.messageSectionHeader}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
            paddingHorizontal: 20,
            paddingVertical: 16,
            gap: 16,
          }}
        >
          {/* Name */}
          <View style={{ gap: 6 }}>
            <Text
              style={{ fontSize: 12, fontFamily: fonts.medium, color: muted }}
            >
              {t.fullName} <Text style={{ color: "#EF4444" }}>*</Text>
            </Text>
            <TextInput
              style={{
                backgroundColor: inputBg,
                borderRadius: 10,
                paddingHorizontal: 14,
                paddingVertical: 12,
                fontSize: 15,
                color: primary,
                fontFamily: fonts.regular,
              }}
              placeholder={t.fullNamePlaceholder}
              placeholderTextColor={muted}
              value={name}
              onChangeText={setName}
            />
          </View>
          {/* Email */}
          <View style={{ gap: 6 }}>
            <Text
              style={{ fontSize: 12, fontFamily: fonts.medium, color: muted }}
            >
              {t.emailAddress} <Text style={{ color: "#EF4444" }}>*</Text>
            </Text>
            <TextInput
              style={{
                backgroundColor: inputBg,
                borderRadius: 10,
                paddingHorizontal: 14,
                paddingVertical: 12,
                fontSize: 15,
                color: primary,
                fontFamily: fonts.regular,
              }}
              placeholder="your@email.com"
              placeholderTextColor={muted}
              value={email}
              onChangeText={setEmail}
              keyboardType="email-address"
              autoCapitalize="none"
            />
          </View>
          {/* Subject */}
          <View style={{ gap: 6 }}>
            <Text
              style={{ fontSize: 12, fontFamily: fonts.medium, color: muted }}
            >
              {t.subjectFieldLabel} <Text style={{ color: "#EF4444" }}>*</Text>
            </Text>
            <TextInput
              style={{
                backgroundColor: inputBg,
                borderRadius: 10,
                paddingHorizontal: 14,
                paddingVertical: 12,
                fontSize: 15,
                color: primary,
                fontFamily: fonts.regular,
              }}
              placeholder={t.subjectFieldPlaceholder}
              placeholderTextColor={muted}
              value={subject}
              onChangeText={setSubject}
            />
          </View>
          {/* Message */}
          <View style={{ gap: 6 }}>
            <Text
              style={{ fontSize: 12, fontFamily: fonts.medium, color: muted }}
            >
              {t.messageSectionHeader}{" "}
              <Text style={{ color: "#EF4444" }}>*</Text>
            </Text>
            <TextInput
              style={{
                backgroundColor: inputBg,
                borderRadius: 10,
                paddingHorizontal: 14,
                paddingVertical: 13,
                fontSize: 15,
                color: primary,
                fontFamily: fonts.regular,
                height: 130,
                textAlignVertical: "top",
              }}
              placeholder={t.messageFieldPlaceholder}
              placeholderTextColor={muted}
              value={message}
              onChangeText={setMessage}
              multiline
            />
          </View>
        </View>

        {/* Submit button */}
        <View style={{ paddingHorizontal: 20, paddingTop: 20 }}>
          <TouchableOpacity
            onPress={handleSubmit}
            disabled={sending}
            style={{
              backgroundColor: accent,
              borderRadius: 12,
              paddingVertical: 15,
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "center",
              gap: 8,
              opacity: sending ? 0.6 : 1,
            }}
            activeOpacity={0.85}
          >
            {sending ? (
              <>
                <ActivityIndicator color="#1A1D23" />
                <Text
                  style={{
                    fontSize: 15,
                    fontFamily: fonts.bold,
                    color: "#1A1D23",
                  }}
                >
                  {t.sendingText}
                </Text>
              </>
            ) : (
              <>
                <Icon name="send" size={17} color="#1A1D23" />
                <Text
                  style={{
                    fontSize: 15,
                    fontFamily: fonts.bold,
                    color: "#1A1D23",
                  }}
                >
                  {t.sendMessageButton}
                </Text>
              </>
            )}
          </TouchableOpacity>
        </View>

        {/* Contact info */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 32,
            paddingBottom: 8,
          }}
        >
          {t.otherWaysToReachLabel}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {[
            { icon: "email", label: "Email", value: "support@nibjobs.com" },
            {
              icon: "access-time",
              label: t.supportHoursLabel,
              value: t.supportHoursText,
            },
          ].map((item, idx, arr) => (
            <View key={item.label}>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  paddingVertical: 14,
                  paddingHorizontal: 20,
                  gap: 16,
                }}
              >
                <View
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    backgroundColor: isDarkMode ? "#1E2027" : "#F3F4F6",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Icon name={item.icon} size={18} color={muted} />
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      color: muted,
                    }}
                  >
                    {item.label}
                  </Text>
                  <Text
                    style={{
                      fontSize: 15,
                      fontFamily: fonts.regular,
                      color: primary,
                      marginTop: 1,
                    }}
                  >
                    {item.value}
                  </Text>
                </View>
              </View>
              {idx < arr.length - 1 && (
                <View
                  style={{ height: 1, backgroundColor: border, marginLeft: 72 }}
                />
              )}
            </View>
          ))}
        </View>
      </ScrollView>
    </View>
  );
}

// Help Feedback Content
function HelpFeedbackContent({ colors, onBack, currentLanguage = "en" }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [category, setCategory] = useState("");
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [sending, setSending] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const categoriesKeys = [
    "feedbackCategoryFeatureRequest",
    "feedbackCategoryBugReport",
    "feedbackCategoryUserExperience",
    "feedbackCategoryPerformance",
    "feedbackCategoryOther",
  ] as const;
  const categories = categoriesKeys.map((key) => (t as any)[key] as string);

  const handleSubmit = async () => {
    if (!category || !feedback) {
      Alert.alert("Error", t.feedbackErrorText);
      return;
    }

    setSending(true);
    try {
      console.log("🔵 Attempting to save feedback to Firestore...");
      console.log("📋 Data:", { category, rating, feedback });
      console.log("🔧 Database instance:", db);

      // Save feedback to Firestore using addDoc
      const docRef = await addDoc(collection(db, "feedback"), {
        category,
        rating,
        feedback,
        status: "pending",
        createdAt: new Date(),
        updatedAt: new Date(),
      });

      console.log("✅ Feedback saved successfully! Document ID:", docRef.id);

      // Show success banner
      setShowSuccess(true);

      // Clear form
      setCategory("");
      setRating(0);
      setFeedback("");

      // Hide banner after 5 seconds
      setTimeout(() => setShowSuccess(false), 5000);
    } catch (error) {
      console.error("❌ Error submitting feedback:", error);
      console.error("❌ Error details:", {
        message: error instanceof Error ? error.message : "Unknown error",
        code: (error as any).code,
        stack: error instanceof Error ? error.stack : undefined,
      });
      Alert.alert(
        t.errorTitle,
        (t as any).feedbackSubmitFailed ||
          "Failed to submit feedback. Please try again.",
      );
    } finally {
      setSending(false);
    }
  };

  const isDarkMode = colors === darkColors;
  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const accent = "#F4C430";
  const inputBg = isDarkMode ? "#1E2027" : "#F3F4F6";

  return (
    <View style={{ flex: 1, backgroundColor: surface }}>
      {/* Back row */}
      <TouchableOpacity
        onPress={onBack}
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: 20,
          paddingVertical: 14,
          borderBottomWidth: 1,
          borderBottomColor: border,
          backgroundColor: bg,
          gap: 10,
        }}
        activeOpacity={0.7}
      >
        <Icon name="arrow-back" size={20} color={muted} />
        <Text style={{ fontSize: 14, fontFamily: fonts.medium, color: muted }}>
          {t.settingsHelpLabel}
        </Text>
      </TouchableOpacity>

      {/* Success Banner */}
      {showSuccess && (
        <View
          style={{
            backgroundColor: "#10B981",
            paddingHorizontal: 20,
            paddingVertical: 14,
            flexDirection: "row",
            alignItems: "center",
            gap: 12,
          }}
        >
          <Icon name="check-circle" size={20} color="#FFFFFF" />
          <View style={{ flex: 1 }}>
            <Text
              style={{ fontSize: 14, fontFamily: fonts.bold, color: "#FFFFFF" }}
            >
              {t.feedbackSubmittedTitle}
            </Text>
            <Text
              style={{
                fontSize: 12,
                color: "rgba(255,255,255,0.85)",
                fontFamily: fonts.regular,
              }}
            >
              {t.feedbackThankYouText}
            </Text>
          </View>
          <TouchableOpacity
            onPress={() => setShowSuccess(false)}
            hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
          >
            <Icon name="close" size={18} color="#FFFFFF" />
          </TouchableOpacity>
        </View>
      )}

      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 40 }}
      >
        {/* Category */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.feedbackCategoryLabel}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {categories.map((cat, idx) => {
            const isSelected = category === cat;
            const isLast = idx === categories.length - 1;
            return (
              <View key={cat}>
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 14,
                    paddingHorizontal: 20,
                    gap: 16,
                  }}
                  onPress={() => setCategory(cat)}
                  activeOpacity={0.7}
                >
                  <View
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: 10,
                      backgroundColor: isSelected
                        ? accent + "18"
                        : isDarkMode
                        ? "#1E2027"
                        : "#F3F4F6",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Icon
                      name="label-outline"
                      size={17}
                      color={isSelected ? accent : muted}
                    />
                  </View>
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 15,
                      fontFamily: isSelected ? fonts.semiBold : fonts.regular,
                      color: primary,
                    }}
                  >
                    {cat}
                  </Text>
                  {isSelected ? (
                    <Icon name="check-circle" size={20} color={accent} />
                  ) : (
                    <View
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: 10,
                        borderWidth: 1.5,
                        borderColor: border,
                      }}
                    />
                  )}
                </TouchableOpacity>
                {!isLast && (
                  <View
                    style={{
                      height: 1,
                      backgroundColor: border,
                      marginLeft: 72,
                    }}
                  />
                )}
              </View>
            );
          })}
        </View>

        {/* Star rating */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.feedbackRatingLabel}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
            paddingVertical: 18,
            paddingHorizontal: 20,
          }}
        >
          <View style={{ flexDirection: "row", gap: 14 }}>
            {[1, 2, 3, 4, 5].map((star) => (
              <TouchableOpacity
                key={star}
                onPress={() => setRating(star)}
                activeOpacity={0.7}
              >
                <Icon
                  name={star <= rating ? "star" : "star-border"}
                  size={34}
                  color={
                    star <= rating ? accent : isDarkMode ? "#3A3D45" : "#D1D5DB"
                  }
                />
              </TouchableOpacity>
            ))}
          </View>
        </View>

        {/* Feedback text */}
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 24,
            paddingBottom: 8,
          }}
        >
          {t.yourFeedbackLabel}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
            paddingHorizontal: 20,
            paddingVertical: 16,
          }}
        >
          <TextInput
            style={{
              backgroundColor: inputBg,
              borderRadius: 10,
              paddingHorizontal: 14,
              paddingVertical: 13,
              fontSize: 15,
              color: primary,
              fontFamily: fonts.regular,
              height: 130,
              textAlignVertical: "top",
            }}
            placeholder={t.feedbackPlaceholder}
            placeholderTextColor={muted}
            value={feedback}
            onChangeText={setFeedback}
            multiline
          />
        </View>

        {/* Submit */}
        <View style={{ paddingHorizontal: 20, paddingTop: 20 }}>
          <TouchableOpacity
            style={{
              backgroundColor: accent,
              borderRadius: 12,
              paddingVertical: 15,
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "center",
              gap: 8,
              opacity: sending ? 0.6 : 1,
            }}
            onPress={handleSubmit}
            disabled={sending}
            activeOpacity={0.85}
          >
            {sending ? (
              <>
                <ActivityIndicator color="#1A1D23" />
                <Text
                  style={{
                    fontSize: 15,
                    fontFamily: fonts.bold,
                    color: "#1A1D23",
                  }}
                >
                  {t.submittingText}
                </Text>
              </>
            ) : (
              <>
                <Icon name="send" size={17} color="#1A1D23" />
                <Text
                  style={{
                    fontSize: 15,
                    fontFamily: fonts.bold,
                    color: "#1A1D23",
                  }}
                >
                  {t.submitFeedbackButton}
                </Text>
              </>
            )}
          </TouchableOpacity>
        </View>
      </ScrollView>
    </View>
  );
}

// Help Privacy Policy Content
function HelpPrivacyContent({ colors, onBack, currentLanguage = "en" }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const isDarkMode = colors === darkColors;
  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const accent = "#F4C430";

  const sections = Array.from({ length: 6 }, (_, i) => ({
    title: (t as any)[`privacySection${i + 1}Title`] || "",
    body: (t as any)[`privacySection${i + 1}Text`] || "",
  }));

  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);

  return (
    <View style={{ flex: 1, backgroundColor: surface }}>
      {/* Back row */}
      <TouchableOpacity
        onPress={onBack}
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: 20,
          paddingVertical: 14,
          borderBottomWidth: 1,
          borderBottomColor: border,
          backgroundColor: bg,
          gap: 10,
        }}
        activeOpacity={0.7}
      >
        <Icon name="arrow-back" size={20} color={muted} />
        <Text style={{ fontSize: 14, fontFamily: fonts.medium, color: muted }}>
          {t.settingsHelpLabel}
        </Text>
      </TouchableOpacity>

      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 40 }}
      >
        {/* Meta */}
        <View
          style={{ paddingHorizontal: 20, paddingTop: 20, paddingBottom: 4 }}
        >
          <Text
            style={{ fontSize: 12, fontFamily: fonts.regular, color: muted }}
          >
            {t.lastUpdated} November 19, 2025
          </Text>
        </View>

        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 16,
            paddingBottom: 8,
          }}
        >
          {t.privacyPolicy}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {sections.map((s, idx) => {
            const isExpanded = expandedIdx === idx;
            const isLast = idx === sections.length - 1;
            return (
              <View key={idx}>
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 15,
                    paddingHorizontal: 20,
                    gap: 14,
                  }}
                  onPress={() => setExpandedIdx(isExpanded ? null : idx)}
                  activeOpacity={0.7}
                >
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 15,
                      fontFamily: isExpanded ? fonts.semiBold : fonts.regular,
                      color: primary,
                    }}
                  >
                    {s.title}
                  </Text>
                  <Icon
                    name={
                      isExpanded ? "keyboard-arrow-up" : "keyboard-arrow-down"
                    }
                    size={20}
                    color={muted}
                  />
                </TouchableOpacity>
                {isExpanded && (
                  <View style={{ paddingHorizontal: 20, paddingBottom: 16 }}>
                    <Text
                      style={{
                        fontSize: 14,
                        color: muted,
                        lineHeight: 22,
                        fontFamily: fonts.regular,
                      }}
                    >
                      {s.body}
                    </Text>
                  </View>
                )}
                {!isLast && (
                  <View
                    style={{
                      height: 1,
                      backgroundColor: border,
                      marginLeft: 20,
                    }}
                  />
                )}
              </View>
            );
          })}
        </View>
      </ScrollView>
    </View>
  );
}

// Help Terms of Service Content
function HelpTermsContent({ colors, onBack, currentLanguage = "en" }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const isDarkMode = colors === darkColors;
  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";

  const sections = Array.from({ length: 8 }, (_, i) => ({
    title: (t as any)[`termsSection${i + 1}Title`] || "",
    body: (t as any)[`termsSection${i + 1}Text`] || "",
  }));

  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);

  return (
    <View style={{ flex: 1, backgroundColor: surface }}>
      {/* Back row */}
      <TouchableOpacity
        onPress={onBack}
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: 20,
          paddingVertical: 14,
          borderBottomWidth: 1,
          borderBottomColor: border,
          backgroundColor: bg,
          gap: 10,
        }}
        activeOpacity={0.7}
      >
        <Icon name="arrow-back" size={20} color={muted} />
        <Text style={{ fontSize: 14, fontFamily: fonts.medium, color: muted }}>
          {t.settingsHelpLabel}
        </Text>
      </TouchableOpacity>

      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 40 }}
      >
        {/* Meta */}
        <View
          style={{ paddingHorizontal: 20, paddingTop: 20, paddingBottom: 4 }}
        >
          <Text
            style={{ fontSize: 12, fontFamily: fonts.regular, color: muted }}
          >
            {t.lastUpdated} November 19, 2025
          </Text>
        </View>

        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.medium,
            color: muted,
            letterSpacing: 0.8,
            textTransform: "uppercase",
            paddingHorizontal: 20,
            paddingTop: 16,
            paddingBottom: 8,
          }}
        >
          {t.termsOfService}
        </Text>
        <View
          style={{
            backgroundColor: bg,
            borderTopWidth: 1,
            borderBottomWidth: 1,
            borderColor: border,
          }}
        >
          {sections.map((s, idx) => {
            const isExpanded = expandedIdx === idx;
            const isLast = idx === sections.length - 1;
            return (
              <View key={idx}>
                <TouchableOpacity
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 15,
                    paddingHorizontal: 20,
                    gap: 14,
                  }}
                  onPress={() => setExpandedIdx(isExpanded ? null : idx)}
                  activeOpacity={0.7}
                >
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 15,
                      fontFamily: isExpanded ? fonts.semiBold : fonts.regular,
                      color: primary,
                    }}
                  >
                    {s.title}
                  </Text>
                  <Icon
                    name={
                      isExpanded ? "keyboard-arrow-up" : "keyboard-arrow-down"
                    }
                    size={20}
                    color={muted}
                  />
                </TouchableOpacity>
                {isExpanded && (
                  <View style={{ paddingHorizontal: 20, paddingBottom: 16 }}>
                    <Text
                      style={{
                        fontSize: 14,
                        color: muted,
                        lineHeight: 22,
                        fontFamily: fonts.regular,
                      }}
                    >
                      {s.body}
                    </Text>
                  </View>
                )}
                {!isLast && (
                  <View
                    style={{
                      height: 1,
                      backgroundColor: border,
                      marginLeft: 20,
                    }}
                  />
                )}
              </View>
            );
          })}
        </View>
      </ScrollView>
    </View>
  );
}

// Settings Language Sub-Screen
function SettingsLanguageScreen({ navigation, route, isDarkMode }: any) {
  const { userData, user } = route.params;
  const [selectedLanguage, setSelectedLanguage] = useState(
    userData?.language || "English",
  );
  const [saving, setSaving] = useState(false);

  const colors = isDarkMode ? darkColors : lightColors;
  const languages = ["English", "Amharic", "Oromifa"];

  const saveLanguage = async () => {
    if (!user) return;

    try {
      setSaving(true);
      await updateDoc(doc(db, "users", user.uid), {
        language: selectedLanguage,
      });
      Alert.alert("Success", "Language preference saved!");
      navigation.goBack();
    } catch (error) {
      console.error("Error saving language:", error);
      Alert.alert("Error", "Failed to save language preference");
    } finally {
      setSaving(false);
    }
  };

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: colors.cream }]}>
      <View
        style={[
          styles.settingsHeader,
          {
            backgroundColor: colors.white,
            borderBottomColor: colors.lightGray,
          },
        ]}
      >
        <TouchableOpacity
          style={styles.settingsBackButton}
          onPress={() => navigation.goBack()}
        >
          <Icon name="arrow-back" size={24} color={colors.deepNavy} />
        </TouchableOpacity>
        <Text style={[styles.settingsTitle, { color: colors.deepNavy }]}>
          Language
        </Text>
      </View>

      <ScrollView
        style={[styles.settingsContainer, { backgroundColor: colors.cream }]}
      >
        <View style={styles.settingsSection}>
          <Text
            style={[styles.settingsSectionTitle, { color: colors.deepNavy }]}
          >
            Select Language
          </Text>

          {languages.map((lang) => (
            <TouchableOpacity
              key={lang}
              style={[
                styles.settingsSelectionItem,
                { backgroundColor: colors.white },
                selectedLanguage === lang && {
                  borderColor: colors.beeYellow,
                  borderWidth: 2,
                },
              ]}
              onPress={() => setSelectedLanguage(lang)}
            >
              <View style={styles.settingsSelectionLeft}>
                <Icon
                  name="language"
                  size={24}
                  color={
                    selectedLanguage === lang
                      ? colors.beeYellow
                      : colors.warmGray
                  }
                />
                <Text
                  style={[
                    styles.settingsSelectionText,
                    { color: colors.deepNavy },
                    selectedLanguage === lang && { fontWeight: "600" },
                  ]}
                >
                  {lang}
                </Text>
              </View>
              {selectedLanguage === lang && (
                <Icon name="check-circle" size={24} color={colors.beeYellow} />
              )}
            </TouchableOpacity>
          ))}
        </View>

        {/* Save Button */}
        <TouchableOpacity
          style={[
            styles.settingsSaveButton,
            { backgroundColor: colors.beeYellow },
            saving && styles.settingsSaveButtonDisabled,
          ]}
          onPress={saveLanguage}
          disabled={saving}
        >
          {saving ? (
            <ActivityIndicator size="small" color={colors.deepNavy} />
          ) : (
            <Text
              style={[
                styles.settingsSaveButtonText,
                { color: colors.deepNavy },
              ]}
            >
              Save Language
            </Text>
          )}
        </TouchableOpacity>
      </ScrollView>
    </SafeAreaView>
  );
}

// Settings Interests Sub-Screen
function SettingsInterestsScreen({ navigation, route, isDarkMode }: any) {
  const { userData: initialUserData, user } = route.params;
  const [categories, setCategories] = useState<any[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<string[]>(
    initialUserData?.interestedCategories ||
      (initialUserData?.interestedCategory
        ? [initialUserData.interestedCategory]
        : []),
  );
  const [selectedSubcategories, setSelectedSubcategories] = useState<string[]>(
    initialUserData?.interestedSubcategories || [],
  );
  const [selectedTags, setSelectedTags] = useState<string[]>(
    initialUserData?.interestedTags || [],
  );
  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(
    new Set(),
  );
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tagSearch, setTagSearch] = useState("");

  // ── Design tokens (mirror ProfileSetupScreen) ─────────────────────────────
  const bg = isDarkMode ? "#0F172A" : "#F8FAFC";
  const surface = isDarkMode ? "#1E293B" : "#FFFFFF";
  const border = isDarkMode ? "#334155" : "#E2E8F0";
  const textPrimary = isDarkMode ? "#F1F5F9" : "#0F172A";
  const textMuted = "#64748B";
  const accent = "#FFB800";
  const accentSoft = isDarkMode ? "#2D2507" : "#FFFBEB";
  const accentIndigo = "#6366F1";

  const sectionCard = {
    backgroundColor: surface,
    borderRadius: 18,
    padding: 20,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: border,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: isDarkMode ? 0 : 0.05,
    shadowRadius: 8,
    elevation: 2,
  };

  useEffect(() => {
    fetchCategories();
    fetchFreshUserData();
  }, []);

  const fetchFreshUserData = async () => {
    if (!user) return;
    try {
      const userDoc = await getDoc(doc(db, "users", user.uid));
      if (userDoc.exists()) {
        const data = userDoc.data();
        setSelectedCategories(
          data.interestedCategories ||
            (data.interestedCategory ? [data.interestedCategory] : []),
        );
        setSelectedSubcategories(data.interestedSubcategories || []);
        setSelectedTags(data.interestedTags || []);
      }
    } catch (error) {
      console.error("Error fetching fresh user data:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const snap = await getDocs(collection(db, "categories"));
      setCategories(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (error) {
      console.error("Error fetching categories:", error);
      Alert.alert("Error", "Failed to load categories");
    } finally {
      setLoading(false);
    }
  };

  const getSubcategories = (parentPath: string) =>
    categories.filter((cat) => cat.parentPath === parentPath);

  const toggleCategory = (path: string) => {
    const newExpanded = new Set(expandedCategories);
    if (newExpanded.has(path)) newExpanded.delete(path);
    else newExpanded.add(path);
    setExpandedCategories(newExpanded);
    if (selectedCategories.includes(path)) {
      setSelectedCategories(selectedCategories.filter((c) => c !== path));
      const subcatPaths = getSubcategories(path).map((s) => s.path);
      setSelectedSubcategories(
        selectedSubcategories.filter((s) => !subcatPaths.includes(s)),
      );
    } else {
      setSelectedCategories([...selectedCategories, path]);
    }
  };

  const toggleSubcategory = (path: string) => {
    const isSelected = selectedSubcategories.includes(path);
    const nextSubcategories = isSelected
      ? selectedSubcategories.filter((s) => s !== path)
      : [...selectedSubcategories, path];
    setSelectedSubcategories(nextSubcategories);

    const sub = categories.find((c) => c.path === path);
    const subTags: string[] = sub?.tags || [];
    if (subTags.length === 0) return;

    if (isSelected) {
      // Keep tags still covered by the remaining selected categories/subcategories
      const coveredTags = new Set<string>();
      selectedCategories.forEach((catPath) => {
        const cat = categories.find((c) => c.path === catPath);
        if (cat?.tags) cat.tags.forEach((t: string) => coveredTags.add(t));
        getSubcategories(catPath).forEach((s) => {
          if (s.tags) s.tags.forEach((t: string) => coveredTags.add(t));
        });
      });
      nextSubcategories.forEach((subPath) => {
        const s = categories.find((c) => c.path === subPath);
        if (s?.tags) s.tags.forEach((t: string) => coveredTags.add(t));
      });
      setSelectedTags((prev) =>
        prev.filter((t) => !subTags.includes(t) || coveredTags.has(t)),
      );
    } else {
      // Auto-select every tag under this subcategory as a preference
      setSelectedTags((prev) => Array.from(new Set([...prev, ...subTags])));
    }
  };

  const toggleTag = (tag: string) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag],
    );
  };

  const saveInterests = async () => {
    if (!user) return;
    try {
      setSaving(true);
      await updateDoc(doc(db, "users", user.uid), {
        interestedCategories: selectedCategories,
        interestedCategory: selectedCategories[0] || "",
        interestedSubcategories: selectedSubcategories,
        interestedTags: selectedTags,
      });
      Alert.alert("Saved!", "Your job interests have been updated.");
      navigation.goBack();
    } catch (error) {
      console.error("Error saving interests:", error);
      Alert.alert("Error", "Failed to save interests");
    } finally {
      setSaving(false);
    }
  };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: bg }}>
      {/* Header */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: 16,
          paddingVertical: 12,
          backgroundColor: surface,
          borderBottomWidth: 1,
          borderBottomColor: border,
        }}
      >
        <TouchableOpacity
          onPress={() => navigation.goBack()}
          hitSlop={{ top: 8, bottom: 8, left: 4, right: 8 }}
        >
          <Icon name="arrow-back" size={24} color={textPrimary} />
        </TouchableOpacity>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 8,
            marginLeft: 12,
          }}
        >
          <Image
            source={require("./assets/favicon.png")}
            style={{ width: 24, height: 24, borderRadius: 6 }}
            resizeMode="contain"
          />
          <View>
            <Text
              style={{
                fontSize: 16,
                fontFamily: fonts.bold,
                color: textPrimary,
                letterSpacing: 0.1,
                lineHeight: 20,
              }}
            >
              <Text style={{ fontFamily: fonts.regular, color: textMuted }}>
                Nib
              </Text>
              Jobs
            </Text>
            <View
              style={{
                height: 2.5,
                width: 28,
                backgroundColor: "#F4C430",
                borderRadius: 2,
              }}
            />
          </View>
        </View>
        <View style={{ flex: 1 }} />
        {(selectedCategories.length > 0 || selectedTags.length > 0) && (
          <View
            style={{
              paddingHorizontal: 10,
              paddingVertical: 4,
              borderRadius: 20,
              backgroundColor: isDarkMode ? "#1E1B4B" : "#EEF2FF",
            }}
          >
            <Text
              style={{ fontSize: 12, color: accentIndigo, fontWeight: "700" }}
            >
              {selectedCategories.length} cat · {selectedTags.length} tags
            </Text>
          </View>
        )}
      </View>

      <ScrollView
        style={{ flex: 1, backgroundColor: bg }}
        contentContainerStyle={{ padding: 16, paddingBottom: 48 }}
      >
        {/* Hero */}
        <View
          style={{ alignItems: "center", paddingVertical: 24, marginBottom: 8 }}
        >
          <View
            style={{
              width: 64,
              height: 64,
              borderRadius: 20,
              backgroundColor: isDarkMode ? "#3B1A26" : "#FFF1F2",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 16,
            }}
          >
            <Icon name="favorite" size={30} color="#E11D48" />
          </View>
          <Text
            style={{
              fontSize: 24,
              fontWeight: "700",
              color: textPrimary,
              textAlign: "center",
              marginBottom: 6,
            }}
          >
            Your Job Interests
          </Text>
          <Text
            style={{
              fontSize: 14,
              color: textMuted,
              textAlign: "center",
              lineHeight: 21,
              maxWidth: 320,
            }}
          >
            Pick the fields that excite you — we'll tailor your job feed to
            match.
          </Text>
        </View>

        {/* Categories card */}
        <View style={sectionCard}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 14,
            }}
          >
            <View>
              <Text
                style={{ fontSize: 15, fontWeight: "700", color: textPrimary }}
              >
                Categories
              </Text>
              <Text style={{ fontSize: 12, color: textMuted, marginTop: 2 }}>
                Select all that apply
              </Text>
            </View>
            {selectedCategories.length > 0 && (
              <View
                style={{
                  paddingHorizontal: 10,
                  paddingVertical: 4,
                  borderRadius: 20,
                  backgroundColor: isDarkMode ? "#1E1B4B" : "#EEF2FF",
                }}
              >
                <Text
                  style={{
                    fontSize: 12,
                    color: accentIndigo,
                    fontWeight: "700",
                  }}
                >
                  {selectedCategories.length} chosen
                </Text>
              </View>
            )}
          </View>

          {loading ? (
            <View style={{ alignItems: "center", paddingVertical: 24 }}>
              <ActivityIndicator size="small" color={accent} />
              <Text style={{ color: textMuted, marginTop: 10, fontSize: 13 }}>
                Loading categories…
              </Text>
            </View>
          ) : (
            <View style={{ gap: 8 }}>
              {categories
                .filter((c) => c.level === 0)
                .map((category) => {
                  const subs = getSubcategories(category.path);
                  const isExpanded = expandedCategories.has(category.path);
                  const isSelected = selectedCategories.includes(category.path);
                  return (
                    <View
                      key={category.id}
                      style={{
                        borderRadius: 14,
                        overflow: "hidden",
                        borderWidth: 1.5,
                        borderColor: isSelected ? accentIndigo : border,
                        backgroundColor: isSelected
                          ? isDarkMode
                            ? "#1E1B4B"
                            : "#EEF2FF"
                          : isDarkMode
                          ? "#1E293B"
                          : "#FAFAFA",
                      }}
                    >
                      <TouchableOpacity
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          padding: 14,
                        }}
                        onPress={() => toggleCategory(category.path)}
                        activeOpacity={0.7}
                      >
                        <View
                          style={{
                            width: 38,
                            height: 38,
                            borderRadius: 12,
                            backgroundColor: category.color
                              ? category.color + "20"
                              : isDarkMode
                              ? "#1E1B4B"
                              : "#EEF2FF",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 12,
                          }}
                        >
                          <Icon
                            name={getIconFromEmoji(category.icon) || "category"}
                            size={18}
                            color={category.color || accentIndigo}
                          />
                        </View>
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 14,
                              fontWeight: "600",
                              color: textPrimary,
                            }}
                          >
                            {category.name}
                          </Text>
                          {category.description ? (
                            <Text
                              style={{
                                fontSize: 12,
                                color: textMuted,
                                marginTop: 2,
                              }}
                              numberOfLines={1}
                            >
                              {category.description}
                            </Text>
                          ) : null}
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          {isSelected ? (
                            <View
                              style={{
                                width: 22,
                                height: 22,
                                borderRadius: 11,
                                backgroundColor: accentIndigo,
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Icon name="check" size={13} color="#FFFFFF" />
                            </View>
                          ) : (
                            <View
                              style={{
                                width: 22,
                                height: 22,
                                borderRadius: 11,
                                borderWidth: 1.5,
                                borderColor: border,
                              }}
                            />
                          )}
                          {subs.length > 0 && (
                            <Icon
                              name={isExpanded ? "expand-less" : "expand-more"}
                              size={20}
                              color={textMuted}
                            />
                          )}
                        </View>
                      </TouchableOpacity>

                      {/* Subcategory pills */}
                      {isExpanded && subs.length > 0 && (
                        <View
                          style={{
                            paddingHorizontal: 14,
                            paddingBottom: 14,
                            borderTopWidth: 1,
                            borderTopColor: border,
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 8,
                            paddingTop: 12,
                          }}
                        >
                          {subs.map((sub) => {
                            const subSel = selectedSubcategories.includes(
                              sub.path,
                            );
                            return (
                              <TouchableOpacity
                                key={sub.id}
                                onPress={() => toggleSubcategory(sub.path)}
                                style={{
                                  paddingHorizontal: 12,
                                  paddingVertical: 7,
                                  borderRadius: 20,
                                  backgroundColor: subSel
                                    ? accentIndigo
                                    : isDarkMode
                                    ? "#334155"
                                    : "#F1F5F9",
                                  borderWidth: 1,
                                  borderColor: subSel
                                    ? accentIndigo
                                    : "transparent",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 12,
                                    fontWeight: "600",
                                    color: subSel ? "#FFFFFF" : textMuted,
                                  }}
                                >
                                  {sub.name}
                                </Text>
                              </TouchableOpacity>
                            );
                          })}
                        </View>
                      )}
                    </View>
                  );
                })}
            </View>
          )}
        </View>

        {/* Tags card */}
        <View style={sectionCard}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 12,
            }}
          >
            <View>
              <Text
                style={{ fontSize: 15, fontWeight: "700", color: textPrimary }}
              >
                Interest Tags
              </Text>
              <Text style={{ fontSize: 12, color: textMuted, marginTop: 2 }}>
                Refine your feed with specific skills or topics
              </Text>
            </View>
            {selectedTags.length > 0 && (
              <View
                style={{
                  paddingHorizontal: 10,
                  paddingVertical: 4,
                  borderRadius: 20,
                  backgroundColor: isDarkMode ? "#1E1B4B" : "#EEF2FF",
                }}
              >
                <Text
                  style={{
                    fontSize: 12,
                    color: accentIndigo,
                    fontWeight: "700",
                  }}
                >
                  {selectedTags.length} selected
                </Text>
              </View>
            )}
          </View>

          {/* Search bar */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              borderWidth: 1.5,
              borderColor: border,
              borderRadius: 12,
              paddingHorizontal: 12,
              marginBottom: 14,
              backgroundColor: isDarkMode ? "#1E293B" : "#F8FAFC",
            }}
          >
            <Icon
              name="search"
              size={16}
              color={textMuted}
              style={{ marginRight: 8 }}
            />
            <TextInput
              style={{
                flex: 1,
                paddingVertical: 10,
                fontSize: 14,
                color: textPrimary,
              }}
              placeholder="Search interest tags…"
              placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
              value={tagSearch}
              onChangeText={setTagSearch}
            />
            {tagSearch.length > 0 && (
              <TouchableOpacity
                onPress={() => setTagSearch("")}
                hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
              >
                <Icon name="close" size={16} color={textMuted} />
              </TouchableOpacity>
            )}
          </View>

          {selectedCategories.length === 0 ? (
            <View style={{ alignItems: "center", paddingVertical: 20 }}>
              <Icon name="touch-app" size={32} color={textMuted} />
              <Text
                style={{
                  fontSize: 13,
                  color: textMuted,
                  marginTop: 8,
                  textAlign: "center",
                }}
              >
                Select a category above to see relevant tags
              </Text>
            </View>
          ) : (
            (() => {
              const groups: { cat: any; filtered: string[] }[] = [];
              selectedCategories.forEach((catPath) => {
                const cat = categories.find((c: any) => c.path === catPath);
                if (!cat) return;
                const tagsSet = new Set<string>();
                if (cat.tags) cat.tags.forEach((t: string) => tagsSet.add(t));
                getSubcategories(catPath).forEach((sub: any) => {
                  if (sub.tags) sub.tags.forEach((t: string) => tagsSet.add(t));
                });
                const allTags = Array.from(tagsSet);
                const filtered = tagSearch
                  ? allTags.filter((t) =>
                      t.toLowerCase().includes(tagSearch.toLowerCase()),
                    )
                  : allTags;
                groups.push({ cat, filtered });
              });
              const hasAnyTags = groups.some((g) => g.filtered.length > 0);
              if (!hasAnyTags) {
                return (
                  <Text
                    style={{
                      fontSize: 13,
                      color: textMuted,
                      textAlign: "center",
                      paddingVertical: 12,
                    }}
                  >
                    {tagSearch
                      ? `No tags match "${tagSearch}"`
                      : "No tags available for selected categories"}
                  </Text>
                );
              }
              return (
                <>
                  {groups.map(({ cat, filtered }) => {
                    if (filtered.length === 0) return null;
                    return (
                      <View key={cat.path} style={{ marginBottom: 14 }}>
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                            marginBottom: 8,
                          }}
                        >
                          <Icon
                            name={getIconFromEmoji(cat.icon) || "category"}
                            size={13}
                            color={cat.color || accentIndigo}
                          />
                          <Text
                            style={{
                              fontSize: 11,
                              fontWeight: "700",
                              color: cat.color || accentIndigo,
                              textTransform: "uppercase",
                              letterSpacing: 0.5,
                            }}
                          >
                            {cat.name}
                          </Text>
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 8,
                          }}
                        >
                          {filtered.map((tag) => {
                            const isTagSelected = selectedTags.includes(tag);
                            return (
                              <TouchableOpacity
                                key={tag}
                                onPress={() => toggleTag(tag)}
                                activeOpacity={0.7}
                                style={{
                                  paddingHorizontal: 14,
                                  paddingVertical: 8,
                                  borderRadius: 20,
                                  backgroundColor: isTagSelected
                                    ? accentIndigo
                                    : isDarkMode
                                    ? "#1E293B"
                                    : "#F1F5F9",
                                  borderWidth: 1.5,
                                  borderColor: isTagSelected
                                    ? accentIndigo
                                    : border,
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 13,
                                    fontWeight: "600",
                                    color: isTagSelected
                                      ? "#FFFFFF"
                                      : textMuted,
                                  }}
                                >
                                  {tag}
                                </Text>
                              </TouchableOpacity>
                            );
                          })}
                        </View>
                      </View>
                    );
                  })}
                </>
              );
            })()
          )}
        </View>

        {/* Tip */}
        <View
          style={{
            flexDirection: "row",
            alignItems: "flex-start",
            padding: 14,
            backgroundColor: accentSoft,
            borderRadius: 14,
            borderWidth: 1,
            borderColor: isDarkMode ? "#3D2E07" : "#FDE68A",
            marginBottom: 24,
          }}
        >
          <Icon
            name="lightbulb-outline"
            size={16}
            color={accent}
            style={{ marginTop: 1 }}
          />
          <Text
            style={{
              fontSize: 13,
              color: isDarkMode ? "#FCD34D" : "#92400E",
              marginLeft: 8,
              flex: 1,
              lineHeight: 19,
            }}
          >
            The more specific your selections, the more relevant your job feed
            becomes.
          </Text>
        </View>

        {/* Save button */}
        <TouchableOpacity
          onPress={saveInterests}
          disabled={saving}
          style={{
            backgroundColor: saving
              ? isDarkMode
                ? "#334155"
                : "#E2E8F0"
              : "#E11D48",
            borderRadius: 16,
            paddingVertical: 16,
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "row",
            gap: 8,
            shadowColor: "#E11D48",
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: saving ? 0 : 0.3,
            shadowRadius: 8,
            elevation: saving ? 0 : 4,
          }}
        >
          {saving ? (
            <ActivityIndicator size="small" color={textMuted} />
          ) : (
            <>
              <Icon name="favorite" size={18} color="#FFFFFF" />
              <Text
                style={{
                  fontSize: 16,
                  fontWeight: "700",
                  color: "#FFFFFF",
                  letterSpacing: 0.3,
                }}
              >
                Save Interests
              </Text>
            </>
          )}
        </TouchableOpacity>
      </ScrollView>
    </SafeAreaView>
  );
}

// Settings Subscription Sub-Screen - RED TEST
function SettingsSubscriptionScreen({
  navigation,
  route,
  isDarkMode,
  currentLanguage = "en",
}: any) {
  const colors = isDarkMode ? darkColors : lightColors;
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [user, setUser] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        setUser(authUser);
        const userDoc = await getDoc(doc(db, "users", authUser.uid));
        if (userDoc.exists()) {
          setUserData(userDoc.data());
        }
      } else {
        navigation.replace("Login");
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: colors.cream }]}>
      {/* Enhanced Header Toolbar */}
      <View
        style={[
          styles.jobsToolbar,
          {
            backgroundColor: isDarkMode ? "#0F1117" : colors.white,
            borderBottomColor: isDarkMode ? "#1E2027" : colors.lightGray,
          },
        ]}
      >
        {isMobile ? (
          /* ── MOBILE: wordmark + back button ── */
          <>
            <View
              style={{
                flex: 1,
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
              }}
            >
              <TouchableOpacity
                onPress={() => navigation.goBack()}
                hitSlop={{ top: 8, bottom: 8, left: 4, right: 8 }}
              >
                <Icon
                  name="arrow-back"
                  size={24}
                  color={isDarkMode ? "#F9FAFB" : colors.deepNavy}
                />
              </TouchableOpacity>
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
              >
                <Image
                  source={require("./assets/favicon.png")}
                  style={{ width: 26, height: 26, borderRadius: 6 }}
                  resizeMode="contain"
                />
                <View>
                  <Text
                    style={{
                      fontSize: 17,
                      fontFamily: fonts.bold,
                      color: isDarkMode ? "#F9FAFB" : colors.deepNavy,
                      letterSpacing: 0.1,
                      lineHeight: 20,
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: fonts.regular,
                        color: isDarkMode ? "#9CA3AF" : "#94A3B8",
                      }}
                    >
                      Nib
                    </Text>
                    Jobs
                  </Text>
                  <View
                    style={{
                      height: 2.5,
                      width: 32,
                      backgroundColor: "#F4C430",
                      borderRadius: 2,
                    }}
                  />
                </View>
              </View>
            </View>
          </>
        ) : (
          /* ── DESKTOP: original toolbar ── */
          <>
            <View style={styles.jobsToolbarLeft}>
              <TouchableOpacity
                onPress={() => navigation.goBack()}
                style={styles.mobileMenuButton}
              >
                <Icon name="arrow-back" size={24} color={colors.deepNavy} />
              </TouchableOpacity>
              <Text
                style={[
                  styles.settingsModalTitle,
                  { color: colors.deepNavy, marginLeft: 16 },
                ]}
              >
                {t.subscriptionPlansTitle}
              </Text>
            </View>
            <View style={styles.jobsToolbarRight}>
              {!isMobile &&
                user &&
                (() => {
                  const subscriptionId = (
                    userData?.subscriptionId ||
                    userData?.subscriptionPlan ||
                    "free"
                  ).toLowerCase();
                  const plan =
                    SUBSCRIPTION_PLANS.find((p) => p.id === subscriptionId) ||
                    SUBSCRIPTION_PLANS[0];
                  const badgeColors = {
                    free: { bg: "#6B7280", text: "#FFFFFF" },
                    standard: { bg: "#D97706", text: "#FFFFFF" },
                    enterprise: { bg: "#1E3A8A", text: "#FFFFFF" },
                  };
                  const colors_badge =
                    badgeColors[plan.id as keyof typeof badgeColors] ||
                    badgeColors.free;
                  return (
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 12,
                        marginRight: 12,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          backgroundColor: colors_badge.bg,
                          paddingHorizontal: 14,
                          paddingVertical: 8,
                          borderRadius: 20,
                          shadowColor: "#000",
                          shadowOffset: { width: 0, height: 2 },
                          shadowOpacity: 0.2,
                          shadowRadius: 4,
                          elevation: 3,
                        }}
                      >
                        <Icon
                          name={plan.icon}
                          size={16}
                          color={colors_badge.text}
                        />
                        <Text
                          style={{
                            fontSize: 13,
                            fontFamily: fonts.bold,
                            color: colors_badge.text,
                            fontWeight: "700",
                            marginLeft: 6,
                            letterSpacing: 0.3,
                          }}
                        >
                          {plan.name.toUpperCase()}
                        </Text>
                      </View>

                      {/* Settings Button */}
                      <TouchableOpacity
                        onPress={() => navigation.navigate("Settings")}
                        style={{
                          paddingHorizontal: 12,
                          paddingVertical: 8,
                          borderRadius: 8,
                          backgroundColor: isDarkMode
                            ? "#2C2F36"
                            : colors.cream,
                        }}
                      >
                        <Icon
                          name="settings"
                          size={20}
                          color={colors.deepNavy}
                        />
                      </TouchableOpacity>

                      {/* Home/Jobs Button */}
                      <TouchableOpacity
                        onPress={() => navigation.navigate("Jobs")}
                        style={{
                          paddingHorizontal: 12,
                          paddingVertical: 8,
                          borderRadius: 8,
                          backgroundColor: isDarkMode
                            ? "#2C2F36"
                            : colors.cream,
                        }}
                      >
                        <Icon name="home" size={20} color={colors.deepNavy} />
                      </TouchableOpacity>
                    </View>
                  );
                })()}
              {isMobile && (
                <TouchableOpacity
                  style={[
                    styles.toolbarIconButton,
                    { backgroundColor: isDarkMode ? "#2C2F36" : colors.cream },
                  ]}
                  onPress={() => setIsMoreMenuOpen(!isMoreMenuOpen)}
                >
                  <Icon
                    name="more-vert"
                    size={24}
                    color={isDarkMode ? colors.white : colors.deepNavy}
                  />
                </TouchableOpacity>
              )}
            </View>
          </>
        )}
      </View>

      {/* More Menu Dropdown */}
      {isMoreMenuOpen && isMobile && (
        <View style={styles.fullScreenDropdownOverlay}>
          <TouchableOpacity
            style={styles.fullScreenTouchArea}
            onPress={() => setIsMoreMenuOpen(false)}
            activeOpacity={1}
          />
          <View style={[styles.moreMenuDropdown, { top: 60, right: 16 }]}>
            <TouchableOpacity
              style={styles.moreMenuItem}
              onPress={() => {
                setIsMoreMenuOpen(false);
                navigation.navigate("Settings");
              }}
            >
              <Icon name="settings" size={20} color={colors.deepNavy} />
              <Text style={styles.moreMenuText}>Settings</Text>
            </TouchableOpacity>

            <View style={styles.moreMenuDivider} />

            <TouchableOpacity
              style={styles.moreMenuItem}
              onPress={() => {
                setIsMoreMenuOpen(false);
                navigation.navigate("Jobs");
              }}
            >
              <Icon name="work" size={20} color={colors.deepNavy} />
              <Text style={styles.moreMenuText}>Browse Jobs</Text>
            </TouchableOpacity>
          </View>
        </View>
      )}

      {loading ? (
        <ModernLoadingScreen
          message="Loading subscription..."
          isDarkMode={isDarkMode}
        />
      ) : (
        <SettingsSubscriptionContent
          userData={userData}
          user={user}
          colors={colors}
          navigation={navigation}
          currentLanguage={currentLanguage}
        />
      )}
    </SafeAreaView>
  );
}

// Company Registration Screen
function CompanyRegistrationScreen({
  navigation,
  route,
  isDarkMode,
  currentLanguage = "en",
}: any) {
  const colors = isDarkMode ? darkColors : lightColors;
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [user, setUser] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [uploadingDocument, setUploadingDocument] = useState(false);

  // Form fields
  const [companyName, setCompanyName] = useState("");
  const [companyDescription, setCompanyDescription] = useState("");
  const [industry, setIndustry] = useState("");
  const [companySize, setCompanySize] = useState("");
  const [foundedYear, setFoundedYear] = useState("");
  const [website, setWebsite] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("Ethiopia");
  const [logoUrl, setLogoUrl] = useState("");
  const [showIndustryPicker, setShowIndustryPicker] = useState(false);
  const [showSizePicker, setShowSizePicker] = useState(false);
  const [linkedIn, setLinkedIn] = useState("");
  const [facebook, setFacebook] = useState("");
  const [twitter, setTwitter] = useState("");

  // Validation errors
  const [errors, setErrors] = useState({
    companyName: "",
    companyDescription: "",
    industry: "",
    companySize: "",
    companyEmail: "",
    companyPhone: "",
    address: "",
    city: "",
    logoUrl: "",
  });

  // Refs for scrolling to error fields
  const scrollViewRef = useRef<ScrollView>(null);
  const fieldRefs = useRef({
    logoUrl: null as View | null,
    companyName: null as View | null,
    companyDescription: null as View | null,
    industry: null as View | null,
    companySize: null as View | null,
    companyEmail: null as View | null,
    companyPhone: null as View | null,
    address: null as View | null,
    city: null as View | null,
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        setUser(authUser);
        try {
          const userDoc = await getDoc(doc(db, "users", authUser.uid));
          if (userDoc.exists()) {
            const data = userDoc.data();
            setUserData(data);

            // If user already has company data, pre-fill the form
            if (data.companyProfile) {
              const cp = data.companyProfile;
              setCompanyName(cp.companyName || "");
              setCompanyDescription(cp.description || "");
              setIndustry(cp.industry || "");
              setCompanySize(cp.size || "");
              setFoundedYear(cp.foundedYear || "");
              setWebsite(cp.website || "");
              setCompanyEmail(cp.email || "");
              setCompanyPhone(cp.phone || "");
              setAddress(cp.address || "");
              setCity(cp.city || "");
              setCountry(cp.country || "Ethiopia");
              setLogoUrl(cp.logoUrl || "");
              setLinkedIn(cp.socialMedia?.linkedIn || "");
              setFacebook(cp.socialMedia?.facebook || "");
              setTwitter(cp.socialMedia?.twitter || "");
            }
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      } else {
        navigation.replace("Login");
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const pickLogo = async () => {
    try {
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [1, 1],
        quality: 0.8,
      });

      if (!result.canceled && result.assets[0]) {
        setUploadingLogo(true);
        const uri = result.assets[0].uri;
        const uploadedUrl = await uploadImage(uri, "companyLogos");
        setLogoUrl(uploadedUrl);
        // Clear logo error when successfully uploaded
        if (errors.logoUrl) {
          setErrors({ ...errors, logoUrl: "" });
        }
      }
    } catch (error) {
      console.error("Error picking logo:", error);
      Alert.alert("Error", "Failed to select logo");
    } finally {
      setUploadingLogo(false);
    }
  };

  const uploadImage = async (uri: string, folder: string) => {
    try {
      const response = await fetch(uri);
      const blob = await response.blob();

      // Get the actual MIME type from the blob
      const mimeType = blob.type || "image/jpeg";

      // Determine file extension from MIME type
      const extension = mimeType.split("/")[1] || "jpg";
      const filename = `${Date.now()}.${extension}`;

      // Convert blob to base64
      const reader = new FileReader();
      const base64Promise = new Promise<string>((resolve, reject) => {
        reader.onloadend = () => {
          const base64String = (reader.result as string).split(",")[1];
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      const fileData = await base64Promise;

      // Call the secure upload function
      const secureFileUploadCallable = httpsCallable(
        functions,
        "secureFileUploadCallable",
      );
      const result = await secureFileUploadCallable({
        fileData,
        filename,
        mimeType,
        fileType: "company-logo",
      });

      const data = result.data as {
        success: boolean;
        downloadURL: string;
        error?: string;
      };

      if (!data.success) {
        throw new Error(data.error || "Upload failed");
      }

      return data.downloadURL;
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  };

  const handleSubmit = async () => {
    console.log("🔵 Submit button clicked");

    // Reset all errors
    setErrors({
      companyName: "",
      companyDescription: "",
      industry: "",
      companySize: "",
      companyEmail: "",
      companyPhone: "",
      address: "",
      city: "",
      logoUrl: "",
    });

    // Check if user is authenticated
    if (!user) {
      console.error("❌ No user found");
      Alert.alert(
        "Authentication Error",
        "You must be logged in to submit. Please log in and try again.",
      );
      return;
    }

    console.log("✅ User authenticated:", user.uid);

    // Log all form values for debugging
    console.log("📋 Form values:", {
      companyName,
      companyDescription,
      industry,
      companySize,
      companyEmail,
      companyPhone,
      address,
      city,
      logoUrl,
    });

    // Collect all validation errors
    const newErrors: any = {};
    let hasErrors = false;

    // Detailed validation with specific field messages
    if (!companyName || companyName.trim() === "") {
      console.log("❌ Validation failed: Company Name is empty");
      newErrors.companyName = "Company Name is required";
      hasErrors = true;
    }

    if (!companyDescription || companyDescription.trim() === "") {
      console.log("❌ Validation failed: Company Description is empty");
      newErrors.companyDescription = "Company Description is required";
      hasErrors = true;
    }

    if (!industry || industry.trim() === "") {
      console.log("❌ Validation failed: Industry is empty");
      newErrors.industry = "Please select an Industry";
      hasErrors = true;
    }

    if (!companySize || companySize.trim() === "") {
      console.log("❌ Validation failed: Company Size is empty");
      newErrors.companySize = "Please select Company Size";
      hasErrors = true;
    }

    if (!companyEmail || companyEmail.trim() === "") {
      console.log("❌ Validation failed: Company Email is empty");
      newErrors.companyEmail = "Company Email is required";
      hasErrors = true;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(companyEmail)) {
        console.log("❌ Validation failed: Invalid email format");
        newErrors.companyEmail = "Please enter a valid email address";
        hasErrors = true;
      }
    }

    if (!companyPhone || companyPhone.trim() === "") {
      console.log("❌ Validation failed: Company Phone is empty");
      newErrors.companyPhone = "Company Phone Number is required";
      hasErrors = true;
    }

    if (!address || address.trim() === "") {
      console.log("❌ Validation failed: Address is empty");
      newErrors.address = "Company Address is required";
      hasErrors = true;
    }

    if (!city || city.trim() === "") {
      console.log("❌ Validation failed: City is empty");
      newErrors.city = "City is required";
      hasErrors = true;
    }

    if (!logoUrl || logoUrl.trim() === "") {
      console.log("❌ Validation failed: Logo URL is empty");
      newErrors.logoUrl = "Please upload a company logo before submitting";
      hasErrors = true;
    }

    // If there are any validation errors, update state and return
    if (hasErrors) {
      setErrors(newErrors);

      // Find the first field with an error and scroll to it
      const errorFields: Array<keyof typeof fieldRefs.current> = [
        "logoUrl",
        "companyName",
        "companyDescription",
        "industry",
        "companySize",
        "companyEmail",
        "companyPhone",
        "address",
        "city",
      ];
      const firstErrorField = errorFields.find((field) => newErrors[field]);

      if (firstErrorField && fieldRefs.current[firstErrorField]) {
        // Small delay to ensure error state is updated before measuring
        setTimeout(() => {
          fieldRefs.current[firstErrorField]?.measureLayout(
            scrollViewRef.current as any,
            (_x: number, y: number) => {
              scrollViewRef.current?.scrollTo({ y: y - 100, animated: true });
            },
            () => {
              // Fallback if measureLayout fails
              console.log("Failed to measure field position");
            },
          );
        }, 100);
      }

      // Show a summary alert
      Alert.alert(
        "Validation Error",
        "Please fill in all required fields marked in red.",
      );
      return;
    }

    console.log("✅ All validations passed");

    try {
      setSaving(true);
      console.log("🔄 Starting submission to Firestore...");

      const companyProfile = {
        companyName,
        description: companyDescription,
        industry,
        size: companySize,
        foundedYear,
        website,
        email: companyEmail,
        phone: companyPhone,
        address,
        city,
        country,
        logoUrl,
        socialMedia: {
          linkedIn,
          facebook,
          twitter,
        },
        verificationStatus: "pending", // pending, approved, rejected
        submittedAt: new Date(),
        updatedAt: new Date(),
      };

      console.log("📦 Company profile data:", companyProfile);

      // Update user document
      const userRef = doc(db, "users", user.uid);
      console.log("📝 Updating user document:", user.uid);

      await updateDoc(userRef, {
        role: "company",
        companyProfile,
        updatedAt: new Date(),
      });

      console.log("✅ User document updated successfully");

      // Send verification email notification
      try {
        console.log("📧 Sending verification email...");
        const notifyCompanyVerification = httpsCallable(
          functions,
          "notifyCompanyVerification",
        );
        await notifyCompanyVerification({
          userEmail: user.email,
          userName: userData?.displayName || userData?.name || "User",
          companyName: companyName,
        });
        console.log("✅ Verification email sent");
      } catch (emailError) {
        console.error("⚠️ Failed to send verification email:", emailError);
        // Don't fail the submission if email fails
      }

      console.log("✅ Submission completed successfully");

      Alert.alert(
        "Success!",
        "Your company profile has been submitted for verification. We're reviewing it and will notify you via email shortly.",
        [
          {
            text: "OK",
            onPress: () => navigation.replace("CompanyDashboard"),
          },
        ],
      );
    } catch (error) {
      console.error("❌ Error submitting company profile:", error);
      console.error("Error details:", {
        message: error.message,
        code: error.code,
        stack: error.stack,
      });
      Alert.alert(
        "Error",
        `Failed to submit company profile: ${
          error.message || "Unknown error"
        }. Please try again.`,
      );
    } finally {
      setSaving(false);
      console.log("🔵 Submit process finished");
    }
  };

  if (loading) {
    return <ModernLoadingScreen message="Loading..." isDarkMode={isDarkMode} />;
  }

  // If user is already a company, show message
  if (userData?.role === "company") {
    const verificationStatus =
      userData?.companyProfile?.verificationStatus || "pending";
    return (
      <SafeAreaView
        style={[styles.container, { backgroundColor: colors.cream }]}
      >
        <View style={{ padding: 40, alignItems: "center" }}>
          <Icon
            name={
              verificationStatus === "approved"
                ? "verified"
                : verificationStatus === "rejected"
                ? "cancel"
                : "pending"
            }
            size={80}
            color={
              verificationStatus === "approved"
                ? colors.success
                : verificationStatus === "rejected"
                ? colors.danger
                : colors.beeYellow
            }
          />
          <Text
            style={{
              fontSize: 24,
              fontWeight: "700",
              color: colors.deepNavy,
              marginTop: 20,
              fontFamily: fonts.bold,
            }}
          >
            {verificationStatus === "approved"
              ? "Company Verified!"
              : verificationStatus === "rejected"
              ? "Verification Rejected"
              : "Pending Verification"}
          </Text>
          <Text
            style={{
              fontSize: 16,
              color: colors.warmGray,
              marginTop: 12,
              textAlign: "center",
              fontFamily: fonts.regular,
            }}
          >
            {verificationStatus === "approved"
              ? "Your company profile has been verified. You can now post jobs and manage your company."
              : verificationStatus === "rejected"
              ? "Your company profile was rejected. Please contact support for more information."
              : "Your company profile is under review. We'll notify you once it's verified."}
          </Text>
          <TouchableOpacity
            style={[
              styles.modernButton,
              { backgroundColor: colors.beeYellow, marginTop: 32 },
            ]}
            onPress={() => navigation.goBack()}
          >
            <Text style={[styles.modernButtonText, { color: colors.deepNavy }]}>
              Go Back
            </Text>
          </TouchableOpacity>
        </View>
      </SafeAreaView>
    );
  }

  const industries = [
    "Technology",
    "Finance",
    "Healthcare",
    "Education",
    "Retail",
    "Manufacturing",
    "Construction",
    "Agriculture",
    "Transportation",
    "Hospitality",
    "Real Estate",
    "Media & Entertainment",
    "Consulting",
    "Non-Profit",
    "Other",
  ];

  const companySizes = [
    "1-10 employees",
    "11-50 employees",
    "51-200 employees",
    "201-500 employees",
    "501-1000 employees",
    "1000+ employees",
  ];

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: colors.cream }]}>
      <View
        style={[
          styles.settingsHeader,
          {
            backgroundColor: colors.white,
            borderBottomColor: colors.lightGray,
          },
        ]}
      >
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Icon name="arrow-back" size={24} color={colors.deepNavy} />
        </TouchableOpacity>
        <Text style={[styles.settingsHeaderTitle, { color: colors.deepNavy }]}>
          Post a Job
        </Text>
        <View style={{ width: 24 }} />
      </View>

      <ScrollView
        ref={scrollViewRef}
        style={{ flex: 1 }}
        contentContainerStyle={{ padding: 24 }}
        showsVerticalScrollIndicator={false}
      >
        {/* Header Section */}
        <View style={{ marginBottom: 32 }}>
          <Text
            style={{
              fontSize: 32,
              fontWeight: "700",
              color: colors.deepNavy,
              marginBottom: 12,
              fontFamily: fonts.bold,
            }}
          >
            Register Your Company
          </Text>
          <Text
            style={{
              fontSize: 16,
              color: colors.warmGray,
              lineHeight: 24,
              fontFamily: fonts.regular,
            }}
          >
            Join thousands of companies finding top talent on NibJobs. Complete
            the form below to get started.
          </Text>
        </View>

        {/* Company Logo Section */}
        <View
          ref={(ref) => (fieldRefs.current.logoUrl = ref)}
          style={{
            backgroundColor: colors.white,
            borderRadius: 16,
            padding: 24,
            marginBottom: 24,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.05,
            shadowRadius: 12,
            elevation: 3,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 20,
            }}
          >
            <View
              style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: colors.beeYellow + "20",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 12,
              }}
            >
              <Icon name="business" size={22} color={colors.beeYellow} />
            </View>
            <Text
              style={{
                fontSize: 20,
                fontWeight: "700",
                color: colors.deepNavy,
                fontFamily: fonts.bold,
              }}
            >
              Company Logo *
            </Text>
          </View>

          {logoUrl ? (
            <View style={{ alignItems: "center", marginBottom: 20 }}>
              <Image
                source={{ uri: logoUrl }}
                style={{
                  width: 160,
                  height: 160,
                  borderRadius: 80,
                  marginBottom: 16,
                  borderWidth: 4,
                  borderColor: colors.beeYellow + "30",
                }}
              />
              <TouchableOpacity
                onPress={pickLogo}
                style={{
                  paddingHorizontal: 24,
                  paddingVertical: 12,
                  borderRadius: 10,
                  borderWidth: 2,
                  borderColor: colors.beeYellow,
                }}
                disabled={uploadingLogo}
              >
                {uploadingLogo ? (
                  <ActivityIndicator size="small" color={colors.beeYellow} />
                ) : (
                  <Text
                    style={{
                      color: colors.beeYellow,
                      fontFamily: fonts.medium,
                      fontSize: 15,
                    }}
                  >
                    Change Logo
                  </Text>
                )}
              </TouchableOpacity>
            </View>
          ) : (
            <>
              <TouchableOpacity
                style={{
                  backgroundColor: colors.cream,
                  borderWidth: 2,
                  borderStyle: "dashed",
                  borderColor: errors.logoUrl ? "#EF4444" : colors.beeYellow,
                  borderRadius: 16,
                  padding: 40,
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onPress={pickLogo}
                disabled={uploadingLogo}
              >
                {uploadingLogo ? (
                  <ActivityIndicator color={colors.beeYellow} size="large" />
                ) : (
                  <>
                    <View
                      style={{
                        width: 64,
                        height: 64,
                        borderRadius: 32,
                        backgroundColor: colors.beeYellow + "20",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 16,
                      }}
                    >
                      <Icon
                        name="add-photo-alternate"
                        size={32}
                        color={colors.beeYellow}
                      />
                    </View>
                    <Text
                      style={{
                        color: colors.deepNavy,
                        fontFamily: fonts.medium,
                        fontSize: 16,
                        marginBottom: 8,
                      }}
                    >
                      Upload Company Logo
                    </Text>
                    <Text
                      style={{
                        color: colors.warmGray,
                        fontFamily: fonts.regular,
                        fontSize: 14,
                      }}
                    >
                      PNG or JPG, up to 5MB
                    </Text>
                  </>
                )}
              </TouchableOpacity>
              {errors.logoUrl ? (
                <Text
                  style={{
                    color: "#EF4444",
                    fontSize: 13,
                    marginTop: 8,
                    fontFamily: fonts.regular,
                  }}
                >
                  {errors.logoUrl}
                </Text>
              ) : null}
            </>
          )}
        </View>

        {/* Company Information Section */}
        <View
          style={{
            backgroundColor: colors.white,
            borderRadius: 16,
            padding: 24,
            marginBottom: 24,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.05,
            shadowRadius: 12,
            elevation: 3,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 24,
            }}
          >
            <View
              style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: colors.beeYellow + "20",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 12,
              }}
            >
              <Icon name="info" size={22} color={colors.beeYellow} />
            </View>
            <Text
              style={{
                fontSize: 20,
                fontWeight: "700",
                color: colors.deepNavy,
                fontFamily: fonts.bold,
              }}
            >
              Company Information
            </Text>
          </View>

          <View
            ref={(ref) => (fieldRefs.current.companyName = ref)}
            style={{ marginBottom: 20 }}
          >
            <Text
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: colors.deepNavy,
                marginBottom: 8,
                fontFamily: fonts.medium,
              }}
            >
              {t.companyNameLabel} *
            </Text>
            <TextInput
              style={{
                backgroundColor: colors.cream,
                borderWidth: 1,
                borderColor: errors.companyName ? "#EF4444" : colors.lightGray,
                borderRadius: 12,
                padding: 16,
                fontSize: 16,
                color: colors.deepNavy,
                fontFamily: fonts.regular,
              }}
              value={companyName}
              onChangeText={(text) => {
                setCompanyName(text);
                if (errors.companyName) {
                  setErrors({ ...errors, companyName: "" });
                }
              }}
              placeholder="e.g., Acme Corporation"
              placeholderTextColor={colors.warmGray}
            />
            {errors.companyName ? (
              <Text
                style={{
                  color: "#EF4444",
                  fontSize: 13,
                  marginTop: 6,
                  fontFamily: fonts.regular,
                }}
              >
                {errors.companyName}
              </Text>
            ) : null}
          </View>

          <View
            ref={(ref) => (fieldRefs.current.companyDescription = ref)}
            style={{ marginBottom: 20 }}
          >
            <Text
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: colors.deepNavy,
                marginBottom: 8,
                fontFamily: fonts.medium,
              }}
            >
              {t.companyDescriptionLabel} *
            </Text>
            <TextInput
              style={{
                backgroundColor: colors.cream,
                borderWidth: 1,
                borderColor: errors.companyDescription
                  ? "#EF4444"
                  : colors.lightGray,
                borderRadius: 12,
                padding: 16,
                fontSize: 16,
                color: colors.deepNavy,
                fontFamily: fonts.regular,
                minHeight: 120,
                textAlignVertical: "top",
              }}
              value={companyDescription}
              onChangeText={(text) => {
                setCompanyDescription(text);
                if (errors.companyDescription) {
                  setErrors({ ...errors, companyDescription: "" });
                }
              }}
              placeholder="Tell us about your company, mission, and values..."
              placeholderTextColor={colors.warmGray}
              multiline
              numberOfLines={5}
            />
            {errors.companyDescription ? (
              <Text
                style={{
                  color: "#EF4444",
                  fontSize: 13,
                  marginTop: 6,
                  fontFamily: fonts.regular,
                }}
              >
                {errors.companyDescription}
              </Text>
            ) : null}
          </View>

          <View
            ref={(ref) => (fieldRefs.current.industry = ref)}
            style={{ marginBottom: 20 }}
          >
            <Text
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: colors.deepNavy,
                marginBottom: 8,
                fontFamily: fonts.medium,
              }}
            >
              {t.industryLabel} *
            </Text>
            <View
              style={{
                backgroundColor: colors.cream,
                borderWidth: 1,
                borderColor: errors.industry ? "#EF4444" : colors.lightGray,
                borderRadius: 12,
                overflow: "hidden",
              }}
            >
              <TouchableOpacity
                onPress={() => setShowIndustryPicker(true)}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  padding: 16,
                  justifyContent: "space-between",
                }}
              >
                <Text
                  style={{
                    fontSize: 16,
                    fontFamily: fonts.regular,
                    color: industry ? colors.deepNavy : colors.warmGray,
                  }}
                >
                  {industry || "Select an industry"}
                </Text>
                <Icon
                  name="arrow-drop-down"
                  size={24}
                  color={colors.warmGray}
                />
              </TouchableOpacity>
              <Modal
                visible={showIndustryPicker}
                transparent
                animationType="fade"
                onRequestClose={() => setShowIndustryPicker(false)}
              >
                <TouchableOpacity
                  style={{
                    flex: 1,
                    backgroundColor: "rgba(0,0,0,0.4)",
                    justifyContent: "flex-end",
                  }}
                  activeOpacity={1}
                  onPress={() => setShowIndustryPicker(false)}
                >
                  <View
                    style={{
                      backgroundColor: colors.white,
                      borderTopLeftRadius: 20,
                      borderTopRightRadius: 20,
                      maxHeight: "70%",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 16,
                        borderBottomWidth: 1,
                        borderBottomColor: colors.lightGray,
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 17,
                          fontFamily: fonts.semiBold,
                          color: colors.deepNavy,
                        }}
                      >
                        Select Industry
                      </Text>
                      <TouchableOpacity
                        onPress={() => setShowIndustryPicker(false)}
                      >
                        <Icon name="close" size={22} color={colors.warmGray} />
                      </TouchableOpacity>
                    </View>
                    <ScrollView>
                      {industries.map((ind) => (
                        <TouchableOpacity
                          key={ind}
                          onPress={() => {
                            setIndustry(ind);
                            if (errors.industry)
                              setErrors({ ...errors, industry: "" });
                            setShowIndustryPicker(false);
                          }}
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingHorizontal: 20,
                            paddingVertical: 14,
                            borderBottomWidth: 1,
                            borderBottomColor: colors.cream,
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 15,
                              fontFamily: fonts.regular,
                              color: colors.deepNavy,
                            }}
                          >
                            {ind}
                          </Text>
                          {industry === ind && (
                            <Icon
                              name="check"
                              size={20}
                              color={colors.beeYellow}
                            />
                          )}
                        </TouchableOpacity>
                      ))}
                    </ScrollView>
                  </View>
                </TouchableOpacity>
              </Modal>
            </View>
            {errors.industry ? (
              <Text
                style={{
                  color: "#EF4444",
                  fontSize: 13,
                  marginTop: 6,
                  fontFamily: fonts.regular,
                }}
              >
                {errors.industry}
              </Text>
            ) : null}
          </View>

          <View
            ref={(ref) => (fieldRefs.current.companySize = ref)}
            style={{ marginBottom: 20 }}
          >
            <Text
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: colors.deepNavy,
                marginBottom: 8,
                fontFamily: fonts.medium,
              }}
            >
              {t.companySizeLabel} *
            </Text>
            <View
              style={{
                backgroundColor: colors.cream,
                borderWidth: 1,
                borderColor: errors.companySize ? "#EF4444" : colors.lightGray,
                borderRadius: 12,
                overflow: "hidden",
              }}
            >
              <TouchableOpacity
                onPress={() => setShowSizePicker(true)}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  padding: 16,
                  justifyContent: "space-between",
                }}
              >
                <Text
                  style={{
                    fontSize: 16,
                    fontFamily: fonts.regular,
                    color: companySize ? colors.deepNavy : colors.warmGray,
                  }}
                >
                  {companySize || "Select company size"}
                </Text>
                <Icon
                  name="arrow-drop-down"
                  size={24}
                  color={colors.warmGray}
                />
              </TouchableOpacity>
              <Modal
                visible={showSizePicker}
                transparent
                animationType="fade"
                onRequestClose={() => setShowSizePicker(false)}
              >
                <TouchableOpacity
                  style={{
                    flex: 1,
                    backgroundColor: "rgba(0,0,0,0.4)",
                    justifyContent: "flex-end",
                  }}
                  activeOpacity={1}
                  onPress={() => setShowSizePicker(false)}
                >
                  <View
                    style={{
                      backgroundColor: colors.white,
                      borderTopLeftRadius: 20,
                      borderTopRightRadius: 20,
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 16,
                        borderBottomWidth: 1,
                        borderBottomColor: colors.lightGray,
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 17,
                          fontFamily: fonts.semiBold,
                          color: colors.deepNavy,
                        }}
                      >
                        Select Company Size
                      </Text>
                      <TouchableOpacity
                        onPress={() => setShowSizePicker(false)}
                      >
                        <Icon name="close" size={22} color={colors.warmGray} />
                      </TouchableOpacity>
                    </View>
                    {companySizes.map((size) => (
                      <TouchableOpacity
                        key={size}
                        onPress={() => {
                          setCompanySize(size);
                          if (errors.companySize)
                            setErrors({ ...errors, companySize: "" });
                          setShowSizePicker(false);
                        }}
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          paddingHorizontal: 20,
                          paddingVertical: 14,
                          borderBottomWidth: 1,
                          borderBottomColor: colors.cream,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 15,
                            fontFamily: fonts.regular,
                            color: colors.deepNavy,
                          }}
                        >
                          {size}
                        </Text>
                        {companySize === size && (
                          <Icon
                            name="check"
                            size={20}
                            color={colors.beeYellow}
                          />
                        )}
                      </TouchableOpacity>
                    ))}
                  </View>
                </TouchableOpacity>
              </Modal>
            </View>
          </View>

          <View style={{ flexDirection: "row", gap: 16, marginBottom: 20 }}>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 15,
                  fontWeight: "600",
                  color: colors.deepNavy,
                  marginBottom: 8,
                  fontFamily: fonts.medium,
                }}
              >
                Founded Year
              </Text>
              <TextInput
                style={{
                  backgroundColor: colors.cream,
                  borderWidth: 1,
                  borderColor: colors.lightGray,
                  borderRadius: 12,
                  padding: 16,
                  fontSize: 16,
                  color: colors.deepNavy,
                  fontFamily: fonts.regular,
                }}
                value={foundedYear}
                onChangeText={setFoundedYear}
                placeholder="2020"
                placeholderTextColor={colors.warmGray}
                keyboardType="numeric"
              />
            </View>
          </View>

          <View style={{ marginBottom: 0 }}>
            <Text
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: colors.deepNavy,
                marginBottom: 8,
                fontFamily: fonts.medium,
              }}
            >
              {t.websiteLabel}
            </Text>
            <TextInput
              style={{
                backgroundColor: colors.cream,
                borderWidth: 1,
                borderColor: colors.lightGray,
                borderRadius: 12,
                padding: 16,
                fontSize: 16,
                color: colors.deepNavy,
                fontFamily: fonts.regular,
              }}
              value={website}
              onChangeText={setWebsite}
              placeholder="https://www.yourcompany.com"
              placeholderTextColor={colors.warmGray}
              keyboardType="url"
              autoCapitalize="none"
            />
          </View>
        </View>

        {/* Contact Information Section */}
        <View
          style={{
            backgroundColor: colors.white,
            borderRadius: 16,
            padding: 24,
            marginBottom: 24,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.05,
            shadowRadius: 12,
            elevation: 3,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 24,
            }}
          >
            <View
              style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: colors.beeYellow + "20",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 12,
              }}
            >
              <Icon name="contact-mail" size={22} color={colors.beeYellow} />
            </View>
            <Text
              style={{
                fontSize: 20,
                fontWeight: "700",
                color: colors.deepNavy,
                fontFamily: fonts.bold,
              }}
            >
              Contact Information
            </Text>
          </View>

          <View
            ref={(ref) => (fieldRefs.current.companyEmail = ref)}
            style={{ marginBottom: 20 }}
          >
            <Text
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: colors.deepNavy,
                marginBottom: 8,
                fontFamily: fonts.medium,
              }}
            >
              {t.companyEmailLabel} *
            </Text>
            <TextInput
              style={{
                backgroundColor: colors.cream,
                borderWidth: 1,
                borderColor: errors.companyEmail ? "#EF4444" : colors.lightGray,
                borderRadius: 12,
                padding: 16,
                fontSize: 16,
                color: colors.deepNavy,
                fontFamily: fonts.regular,
              }}
              value={companyEmail}
              onChangeText={(text) => {
                setCompanyEmail(text);
                if (errors.companyEmail) {
                  setErrors({ ...errors, companyEmail: "" });
                }
              }}
              placeholder="contact@yourcompany.com"
              placeholderTextColor={colors.warmGray}
              keyboardType="email-address"
              autoCapitalize="none"
            />
            {errors.companyEmail ? (
              <Text
                style={{
                  color: "#EF4444",
                  fontSize: 13,
                  marginTop: 6,
                  fontFamily: fonts.regular,
                }}
              >
                {errors.companyEmail}
              </Text>
            ) : null}
          </View>

          <View
            ref={(ref) => (fieldRefs.current.companyPhone = ref)}
            style={{ marginBottom: 20 }}
          >
            <Text
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: colors.deepNavy,
                marginBottom: 8,
                fontFamily: fonts.medium,
              }}
            >
              {t.companyPhoneLabel} *
            </Text>
            <TextInput
              style={{
                backgroundColor: colors.cream,
                borderWidth: 1,
                borderColor: errors.companyPhone ? "#EF4444" : colors.lightGray,
                borderRadius: 12,
                padding: 16,
                fontSize: 16,
                color: colors.deepNavy,
                fontFamily: fonts.regular,
              }}
              value={companyPhone}
              onChangeText={(text) => {
                setCompanyPhone(text);
                if (errors.companyPhone) {
                  setErrors({ ...errors, companyPhone: "" });
                }
              }}
              placeholder="+251 9XX XXX XXX"
              placeholderTextColor={colors.warmGray}
              keyboardType="phone-pad"
            />
            {errors.companyPhone ? (
              <Text
                style={{
                  color: "#EF4444",
                  fontSize: 13,
                  marginTop: 6,
                  fontFamily: fonts.regular,
                }}
              >
                {errors.companyPhone}
              </Text>
            ) : null}
          </View>

          <View
            ref={(ref) => (fieldRefs.current.address = ref)}
            style={{ marginBottom: 20 }}
          >
            <Text
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: colors.deepNavy,
                marginBottom: 8,
                fontFamily: fonts.medium,
              }}
            >
              {t.addressLabel} *
            </Text>
            <TextInput
              style={{
                backgroundColor: colors.cream,
                borderWidth: 1,
                borderColor: errors.address ? "#EF4444" : colors.lightGray,
                borderRadius: 12,
                padding: 16,
                fontSize: 16,
                color: colors.deepNavy,
                fontFamily: fonts.regular,
              }}
              value={address}
              onChangeText={(text) => {
                setAddress(text);
                if (errors.address) {
                  setErrors({ ...errors, address: "" });
                }
              }}
              placeholder="Street address"
              placeholderTextColor={colors.warmGray}
            />
            {errors.address ? (
              <Text
                style={{
                  color: "#EF4444",
                  fontSize: 13,
                  marginTop: 6,
                  fontFamily: fonts.regular,
                }}
              >
                {errors.address}
              </Text>
            ) : null}
          </View>

          <View style={{ flexDirection: "row", gap: 16, marginBottom: 0 }}>
            <View
              ref={(ref) => (fieldRefs.current.city = ref)}
              style={{ flex: 1 }}
            >
              <Text
                style={{
                  fontSize: 15,
                  fontWeight: "600",
                  color: colors.deepNavy,
                  marginBottom: 8,
                  fontFamily: fonts.medium,
                }}
              >
                {t.cityLabel} *
              </Text>
              <TextInput
                style={{
                  backgroundColor: colors.cream,
                  borderWidth: 1,
                  borderColor: errors.city ? "#EF4444" : colors.lightGray,
                  borderRadius: 12,
                  padding: 16,
                  fontSize: 16,
                  color: colors.deepNavy,
                  fontFamily: fonts.regular,
                }}
                value={city}
                onChangeText={(text) => {
                  setCity(text);
                  if (errors.city) {
                    setErrors({ ...errors, city: "" });
                  }
                }}
                placeholder="Addis Ababa"
                placeholderTextColor={colors.warmGray}
              />
              {errors.city ? (
                <Text
                  style={{
                    color: "#EF4444",
                    fontSize: 13,
                    marginTop: 6,
                    fontFamily: fonts.regular,
                  }}
                >
                  {errors.city}
                </Text>
              ) : null}
            </View>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 15,
                  fontWeight: "600",
                  color: colors.deepNavy,
                  marginBottom: 8,
                  fontFamily: fonts.medium,
                }}
              >
                Country
              </Text>
              <TextInput
                style={{
                  backgroundColor: colors.cream,
                  borderWidth: 1,
                  borderColor: colors.lightGray,
                  borderRadius: 12,
                  padding: 16,
                  fontSize: 16,
                  color: colors.deepNavy,
                  fontFamily: fonts.regular,
                }}
                value={country}
                onChangeText={setCountry}
                placeholder="Ethiopia"
                placeholderTextColor={colors.warmGray}
              />
            </View>
          </View>
        </View>

        {/* Social Media Section */}
        <View
          style={{
            backgroundColor: colors.white,
            borderRadius: 16,
            padding: 24,
            marginBottom: 32,
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.05,
            shadowRadius: 12,
            elevation: 3,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 16,
            }}
          >
            <View
              style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: colors.beeYellow + "20",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 12,
              }}
            >
              <Icon name="share" size={22} color={colors.beeYellow} />
            </View>
            <Text
              style={{
                fontSize: 20,
                fontWeight: "700",
                color: colors.deepNavy,
                fontFamily: fonts.bold,
              }}
            >
              Social Media
            </Text>
          </View>

          <Text
            style={{
              fontSize: 14,
              color: colors.warmGray,
              marginBottom: 20,
              fontFamily: fonts.regular,
            }}
          >
            Optional - Help candidates learn more about your company
          </Text>

          <View style={{ marginBottom: 20 }}>
            <Text
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: colors.deepNavy,
                marginBottom: 8,
                fontFamily: fonts.medium,
              }}
            >
              LinkedIn
            </Text>
            <TextInput
              style={{
                backgroundColor: colors.cream,
                borderWidth: 1,
                borderColor: colors.lightGray,
                borderRadius: 12,
                padding: 16,
                fontSize: 16,
                color: colors.deepNavy,
                fontFamily: fonts.regular,
              }}
              value={linkedIn}
              onChangeText={setLinkedIn}
              placeholder="https://linkedin.com/company/yourcompany"
              placeholderTextColor={colors.warmGray}
              autoCapitalize="none"
            />
          </View>

          <View style={{ marginBottom: 20 }}>
            <Text
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: colors.deepNavy,
                marginBottom: 8,
                fontFamily: fonts.medium,
              }}
            >
              Facebook
            </Text>
            <TextInput
              style={{
                backgroundColor: colors.cream,
                borderWidth: 1,
                borderColor: colors.lightGray,
                borderRadius: 12,
                padding: 16,
                fontSize: 16,
                color: colors.deepNavy,
                fontFamily: fonts.regular,
              }}
              value={facebook}
              onChangeText={setFacebook}
              placeholder="https://facebook.com/yourcompany"
              placeholderTextColor={colors.warmGray}
              autoCapitalize="none"
            />
          </View>

          <View style={{ marginBottom: 0 }}>
            <Text
              style={{
                fontSize: 15,
                fontWeight: "600",
                color: colors.deepNavy,
                marginBottom: 8,
                fontFamily: fonts.medium,
              }}
            >
              Twitter
            </Text>
            <TextInput
              style={{
                backgroundColor: colors.cream,
                borderWidth: 1,
                borderColor: colors.lightGray,
                borderRadius: 12,
                padding: 16,
                fontSize: 16,
                color: colors.deepNavy,
                fontFamily: fonts.regular,
              }}
              value={twitter}
              onChangeText={setTwitter}
              placeholder="https://twitter.com/yourcompany"
              placeholderTextColor={colors.warmGray}
              autoCapitalize="none"
            />
          </View>
        </View>

        {/* Submit Button */}
        <TouchableOpacity
          style={{
            backgroundColor: "#374151",
            paddingVertical: 18,
            borderRadius: 14,
            alignItems: "center",
            shadowColor: "#000",
            shadowOffset: { width: 0, height: 4 },
            shadowOpacity: 0.2,
            shadowRadius: 16,
            elevation: 5,
            marginBottom: 40,
          }}
          onPress={handleSubmit}
          disabled={saving}
        >
          {saving ? (
            <ActivityIndicator color="#FFFFFF" />
          ) : (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Icon name="send" size={22} color="#FFFFFF" />
              <Text
                style={{
                  color: "#FFFFFF",
                  fontSize: 18,
                  fontFamily: fonts.bold,
                  marginLeft: 10,
                }}
              >
                Submit for Verification
              </Text>
            </View>
          )}
        </TouchableOpacity>
      </ScrollView>
    </SafeAreaView>
  );
}

// Company Dashboard Screen
function CompanyDashboardScreen({
  navigation,
  route,
  isDarkMode,
  toggleTheme,
  currentLanguage = "en",
}: any) {
  const colors = isDarkMode ? darkColors : lightColors;
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [activeTab, setActiveTab] = useState("statistics");
  const [user, setUser] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const [upgradeModal, setUpgradeModal] = useState<{
    visible: boolean;
    featureLabel?: string;
  }>({ visible: false });

  // Responsive design
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;
  const isTablet = dimensions.width >= 768 && dimensions.width < 1024;
  const isDesktop = dimensions.width >= 1024;

  // Mobile menu state
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [isFabOpen, setIsFabOpen] = useState(false);

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  // URL query-based routing for maintaining state on refresh
  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);
      const tabFromURL = urlParams.get("tab");
      if (
        tabFromURL &&
        [
          "statistics",
          "posted-jobs",
          "applications",
          "candidates",
          "profile",
        ].includes(tabFromURL)
      ) {
        setActiveTab(tabFromURL);
      }
    }
  }, []);

  const dashPermission = useSubscriptionPermissions(
    userData?.subscriptionPlan || userData?.subscriptionId,
  );

  // Update URL when tab changes
  const handleTabChange = (tabId: string) => {
    if (
      tabId === "candidates" &&
      !dashPermission.hasPermission("canViewTalentPool")
    ) {
      setUpgradeModal({ visible: true, featureLabel: "View Talent Pool" });
      return;
    }
    if (
      tabId === "statistics" &&
      !dashPermission.hasPermission("canViewAnalytics")
    ) {
      setUpgradeModal({ visible: true, featureLabel: "Analytics Dashboard" });
      return;
    }
    if (
      tabId === "applications" &&
      !dashPermission.hasPermission("canManageApplications")
    ) {
      setUpgradeModal({ visible: true, featureLabel: "Manage Applications" });
      return;
    }
    if (
      tabId === "profile" &&
      !dashPermission.hasPermission("canAccessCompanyBranding")
    ) {
      setUpgradeModal({ visible: true, featureLabel: "Company Branding" });
      return;
    }
    setActiveTab(tabId);
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const url = new URL(window.location.href);
      url.searchParams.set("tab", tabId);
      window.history.replaceState({}, "", url.toString());
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        setUser(authUser);
        const userRef = doc(db, "users", authUser.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const data = userSnap.data();
          setUserData(data);
          // Redirect if not a company
          if (data.role !== "company") {
            navigation.replace("Unauthorized");
            return;
          }
        }
      } else {
        navigation.replace("Unauthorized");
        return;
      }
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    if (Platform.OS === "web" && typeof window !== "undefined") {
      window.history.replaceState({}, document.title, "/");
    }
    navigation.replace(Platform.OS !== "web" ? "Jobs" : "Home");
  };

  const sidebarCategories = [
    {
      label: t.cdOverview,
      icon: "dashboard",
      color: "#6366F1",
      items: [
        {
          id: "statistics",
          title: t.cdDashboard,
          subtitle: t.cdAnalyticsInsights,
          icon: "analytics",
          color: "#6366F1",
        },
      ],
    },
    {
      label: t.cdHiring,
      icon: "work",
      color: "#10B981",
      items: [
        {
          id: "posted-jobs",
          title: t.cdJobPostings,
          subtitle: t.cdManageYourJobs,
          icon: "work",
          color: "#10B981",
          badge: null,
        },
        {
          id: "applications",
          title: t.cdApplications,
          subtitle: t.cdReviewCandidates,
          icon: "assignment",
          color: "#F59E0B",
          badge: null,
        },
        {
          id: "candidates",
          title: t.cdTalentPool,
          subtitle: t.cdDiscoverTalent,
          icon: "people",
          color: "#3B82F6",
          badge: "NEW",
        },
      ],
    },
    {
      label: t.cdSettings,
      icon: "settings",
      color: "#8B5CF6",
      items: [
        {
          id: "profile",
          title: t.cdCompanyProfile,
          subtitle: t.cdUpdateDetails,
          icon: "business",
          color: "#8B5CF6",
        },
      ],
    },
  ];

  if (loading) {
    return (
      <ModernLoadingScreen
        message={t.cdLoadingDashboard}
        isDarkMode={isDarkMode}
      />
    );
  }

  // Get current tab title
  const getCurrentTabTitle = () => {
    for (const category of sidebarCategories) {
      const item = category.items.find((i) => i.id === activeTab);
      if (item) return item.title;
    }
    return t.cdDashboard;
  };

  return (
    <SafeAreaView
      style={[
        styles.container,
        { backgroundColor: isMobile ? "#0F1117" : colors.white },
      ]}
    >
      <SubscriptionUpgradeModal
        visible={upgradeModal.visible}
        featureLabel={upgradeModal.featureLabel}
        currentPlan={userData?.subscriptionPlan || userData?.subscriptionId}
        onClose={() => setUpgradeModal({ visible: false })}
        navigation={navigation}
        isDarkMode={isDarkMode}
      />
      {/* Mobile View */}
      {isMobile ? (
        (() => {
          const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
          const surface = isDarkMode ? "#1A1D23" : "#F9FAFB";
          const border = isDarkMode ? "#1E2027" : "#F0F0F0";
          const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
          const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
          const accent = "#F4C430";

          const drawerRow = (
            icon: string,
            iconColor: string,
            label: string,
            onPress: () => void,
            danger = false,
          ) => (
            <TouchableOpacity
              onPress={onPress}
              style={{
                flexDirection: "row",
                alignItems: "center",
                paddingVertical: 12,
                paddingHorizontal: 20,
                gap: 14,
              }}
              activeOpacity={0.6}
            >
              <View
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 9,
                  backgroundColor: danger ? "#FEF2F215" : `${iconColor}22`,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name={icon}
                  size={18}
                  color={danger ? "#EF4444" : iconColor}
                />
              </View>
              <Text
                style={{
                  flex: 1,
                  fontSize: 15,
                  fontFamily: fonts.regular,
                  color: danger ? "#EF4444" : primary,
                }}
              >
                {label}
              </Text>
              <Icon name="chevron-right" size={16} color={border} />
            </TouchableOpacity>
          );

          const drawerDivider = () => (
            <View
              style={{
                height: 1,
                backgroundColor: border,
                marginHorizontal: 20,
              }}
            />
          );

          const drawerSection = (label: string) => (
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.medium,
                color: muted,
                letterSpacing: 0.8,
                textTransform: "uppercase",
                paddingHorizontal: 20,
                paddingTop: 20,
                paddingBottom: 6,
              }}
            >
              {label}
            </Text>
          );

          return (
            <View
              style={{
                flex: 1,
                backgroundColor: isDarkMode ? "#111318" : "#F3F4F6",
              }}
            >
              {/* ── Top Bar ── */}
              <View
                style={{
                  backgroundColor: "#0F1117",
                  paddingTop: 12,
                  paddingBottom: 12,
                  paddingHorizontal: 16,
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <TouchableOpacity
                  onPress={() => setShowMobileMenu(true)}
                  style={{ padding: 6, marginRight: 12 }}
                >
                  <Icon name="menu" size={24} color="#9CA3AF" />
                </TouchableOpacity>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 17,
                      fontFamily: fonts.bold,
                      color: "#F9FAFB",
                    }}
                  >
                    {getCurrentTabTitle()}
                  </Text>
                  {userData?.companyProfile?.companyName ? (
                    <Text
                      style={{
                        fontSize: 12,
                        color: "#6B7280",
                        fontFamily: fonts.regular,
                      }}
                    >
                      {userData.companyProfile.companyName}
                    </Text>
                  ) : null}
                </View>
                <TouchableOpacity
                  onPress={() => setIsMoreMenuOpen(!isMoreMenuOpen)}
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    backgroundColor: "#1A1D23",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name="more-vert" size={20} color="#9CA3AF" />
                </TouchableOpacity>
              </View>

              {/* More menu dropdown */}
              {isMoreMenuOpen && (
                <View style={styles.fullScreenDropdownOverlay}>
                  <TouchableOpacity
                    style={styles.fullScreenTouchArea}
                    onPress={() => setIsMoreMenuOpen(false)}
                    activeOpacity={1}
                  />
                  <View
                    style={[
                      styles.moreMenuDropdown,
                      {
                        top: 100,
                        right: 12,
                        backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
                      },
                    ]}
                  >
                    <TouchableOpacity
                      style={styles.moreMenuItem}
                      onPress={() => {
                        setIsMoreMenuOpen(false);
                        toggleTheme();
                      }}
                    >
                      <Icon
                        name={isDarkMode ? "wb-sunny" : "nightlight-round"}
                        size={18}
                        color={isDarkMode ? "#F9FAFB" : "#1A1D23"}
                      />
                      <Text
                        style={[
                          styles.moreMenuText,
                          { color: isDarkMode ? "#F9FAFB" : "#1A1D23" },
                        ]}
                      >
                        {isDarkMode ? t.lightMode : t.darkMode}
                      </Text>
                    </TouchableOpacity>
                    <View style={styles.moreMenuDivider} />
                    <TouchableOpacity
                      style={styles.moreMenuItem}
                      onPress={() => {
                        setIsMoreMenuOpen(false);
                        navigation.navigate("Jobs");
                      }}
                    >
                      <Icon
                        name="search"
                        size={18}
                        color={isDarkMode ? "#F9FAFB" : "#1A1D23"}
                      />
                      <Text
                        style={[
                          styles.moreMenuText,
                          { color: isDarkMode ? "#F9FAFB" : "#1A1D23" },
                        ]}
                      >
                        {t.cdBrowseJobs}
                      </Text>
                    </TouchableOpacity>
                    <View style={styles.moreMenuDivider} />
                    <TouchableOpacity
                      style={styles.moreMenuItem}
                      onPress={() => {
                        setIsMoreMenuOpen(false);
                        handleLogout();
                      }}
                    >
                      <Icon name="logout" size={18} color="#DC2626" />
                      <Text style={[styles.moreMenuText, { color: "#DC2626" }]}>
                        {t.cdSignOut}
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              )}

              {/* ── Main Content ── */}
              <View style={{ flex: 1 }}>
                {activeTab === "statistics" && (
                  <CompanyStatisticsContent
                    colors={colors}
                    companyData={userData?.companyProfile}
                    navigation={navigation}
                    onTabChange={handleTabChange}
                    t={t}
                  />
                )}
                {activeTab === "posted-jobs" && (
                  <CompanyPostedJobsContent
                    colors={colors}
                    companyId={user?.uid}
                    navigation={navigation}
                    isDarkMode={isDarkMode}
                    t={t}
                  />
                )}
                {activeTab === "applications" && (
                  <CompanyApplicationsContent
                    colors={colors}
                    companyId={user?.uid}
                    navigation={navigation}
                    isDarkMode={isDarkMode}
                    t={t}
                  />
                )}
                {activeTab === "candidates" && (
                  <CompanyCandidatesContent
                    colors={colors}
                    navigation={navigation}
                    isDarkMode={isDarkMode}
                    t={t}
                    currentLanguage={currentLanguage}
                  />
                )}
                {activeTab === "profile" && (
                  <CompanyProfileContent
                    colors={colors}
                    userData={userData}
                    user={user}
                    isDarkMode={isDarkMode}
                    t={t}
                  />
                )}
              </View>

              {/* ── Side Drawer ── */}
              <Modal
                visible={showMobileMenu}
                animationType="slide"
                transparent
                onRequestClose={() => setShowMobileMenu(false)}
              >
                <View style={{ flex: 1, flexDirection: "row" }}>
                  <TouchableOpacity
                    style={{ flex: 1, backgroundColor: "rgba(0,0,0,0.4)" }}
                    activeOpacity={1}
                    onPress={() => setShowMobileMenu(false)}
                  />
                  <View
                    style={{ width: 300, height: "100%", backgroundColor: bg }}
                  >
                    {/* Header */}
                    <View
                      style={{
                        paddingTop: 52,
                        paddingBottom: 20,
                        paddingHorizontal: 20,
                        backgroundColor: surface,
                        borderBottomWidth: 1,
                        borderBottomColor: border,
                      }}
                    >
                      <TouchableOpacity
                        onPress={() => setShowMobileMenu(false)}
                        style={{
                          position: "absolute",
                          top: 52,
                          right: 16,
                          padding: 4,
                        }}
                        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
                      >
                        <Icon name="close" size={22} color={muted} />
                      </TouchableOpacity>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 12,
                          marginTop: 4,
                        }}
                      >
                        {userData?.companyProfile?.logoUrl ? (
                          <Image
                            source={{ uri: userData.companyProfile.logoUrl }}
                            style={{ width: 48, height: 48, borderRadius: 24 }}
                          />
                        ) : (
                          <View
                            style={{
                              width: 48,
                              height: 48,
                              borderRadius: 14,
                              backgroundColor: accent,
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Icon name="business" size={26} color="#1A1D23" />
                          </View>
                        )}
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 16,
                              fontFamily: fonts.semiBold,
                              color: primary,
                            }}
                            numberOfLines={1}
                          >
                            {userData?.companyProfile?.companyName || "Company"}
                          </Text>
                          {userData?.companyProfile?.verificationStatus ===
                          "approved" ? (
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 4,
                                marginTop: 2,
                              }}
                            >
                              <Icon name="verified" size={13} color="#10B981" />
                              <Text
                                style={{
                                  fontSize: 12,
                                  color: "#10B981",
                                  fontFamily: fonts.medium,
                                }}
                              >
                                {t.cdVerified}
                              </Text>
                            </View>
                          ) : (
                            <Text
                              style={{
                                fontSize: 12,
                                color: muted,
                                fontFamily: fonts.regular,
                                marginTop: 1,
                              }}
                            >
                              {t.cdCompanyAccount}
                            </Text>
                          )}
                          {(() => {
                            const planIdRaw = (
                              userData?.subscriptionPlan ||
                              userData?.subscriptionId ||
                              "free"
                            )
                              .toString()
                              .toLowerCase();
                            const planColors: Record<
                              string,
                              { bg: string; fg: string }
                            > = {
                              free: { bg: "#6B728022", fg: "#6B7280" },
                              standard: { bg: "#3B82F622", fg: "#3B82F6" },
                              pro: {
                                bg: "#F4C43022",
                                fg: isDarkMode ? "#F4C430" : "#B68A00",
                              },
                              enterprise: { bg: "#8B5CF622", fg: "#8B5CF6" },
                            };
                            const planKey = planColors[planIdRaw]
                              ? planIdRaw
                              : "free";
                            const planLabel =
                              planKey.charAt(0).toUpperCase() +
                              planKey.slice(1);
                            const pc = planColors[planKey];
                            return (
                              <View
                                style={{
                                  flexDirection: "row",
                                  flexWrap: "wrap",
                                  gap: 6,
                                  marginTop: 6,
                                }}
                              >
                                <View
                                  style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: 4,
                                    paddingHorizontal: 8,
                                    paddingVertical: 3,
                                    borderRadius: 999,
                                    backgroundColor: "#10B98122",
                                  }}
                                >
                                  <Icon
                                    name="business"
                                    size={11}
                                    color="#10B981"
                                  />
                                  <Text
                                    style={{
                                      fontSize: 11,
                                      fontFamily: fonts.semiBold,
                                      color: "#10B981",
                                    }}
                                    numberOfLines={1}
                                  >
                                    {t.company}
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: 4,
                                    paddingHorizontal: 8,
                                    paddingVertical: 3,
                                    borderRadius: 999,
                                    backgroundColor: pc.bg,
                                  }}
                                >
                                  <Icon
                                    name={
                                      planKey === "free"
                                        ? "star-outline"
                                        : "star"
                                    }
                                    size={11}
                                    color={pc.fg}
                                  />
                                  <Text
                                    style={{
                                      fontSize: 11,
                                      fontFamily: fonts.semiBold,
                                      color: pc.fg,
                                    }}
                                    numberOfLines={1}
                                  >
                                    {planLabel}
                                  </Text>
                                </View>
                              </View>
                            );
                          })()}
                        </View>
                      </View>
                    </View>

                    <ScrollView
                      showsVerticalScrollIndicator={false}
                      style={{ flex: 1 }}
                    >
                      {/* DASHBOARD */}
                      {drawerSection(t.cdDashboard)}
                      {drawerRow("analytics", "#6366F1", t.cdAnalytics, () => {
                        handleTabChange("statistics");
                        setShowMobileMenu(false);
                      })}
                      {drawerDivider()}
                      {drawerRow("work", "#10B981", t.cdJobPostings, () => {
                        handleTabChange("posted-jobs");
                        setShowMobileMenu(false);
                      })}
                      {drawerDivider()}
                      {drawerRow(
                        "assignment",
                        "#F59E0B",
                        t.cdApplications,
                        () => {
                          handleTabChange("applications");
                          setShowMobileMenu(false);
                        },
                      )}
                      {drawerDivider()}
                      {drawerRow("people", "#3B82F6", t.cdTalentPool, () => {
                        handleTabChange("candidates");
                        setShowMobileMenu(false);
                      })}

                      {/* SETTINGS */}
                      {drawerSection(t.cdSettings)}
                      {drawerRow(
                        "business",
                        "#8B5CF6",
                        t.cdCompanyProfile,
                        () => {
                          handleTabChange("profile");
                          setShowMobileMenu(false);
                        },
                      )}
                      {drawerDivider()}
                      {drawerRow(
                        "settings",
                        "#6B7280",
                        t.cdAccountSettings,
                        () => {
                          setShowMobileMenu(false);
                          navigation.navigate("Settings");
                        },
                      )}
                      {drawerDivider()}
                      {/* Theme toggle */}
                      <TouchableOpacity
                        onPress={toggleTheme}
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingVertical: 12,
                          paddingHorizontal: 20,
                          gap: 14,
                        }}
                        activeOpacity={0.6}
                      >
                        <View
                          style={{
                            width: 34,
                            height: 34,
                            borderRadius: 9,
                            backgroundColor: isDarkMode
                              ? "#F4C43022"
                              : "#1A1D2322",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon
                            name={isDarkMode ? "wb-sunny" : "nightlight-round"}
                            size={18}
                            color={isDarkMode ? "#F4C430" : "#1A1D23"}
                          />
                        </View>
                        <Text
                          style={{
                            flex: 1,
                            fontSize: 15,
                            fontFamily: fonts.regular,
                            color: primary,
                          }}
                        >
                          {isDarkMode ? t.lightMode : t.darkMode}
                        </Text>
                        <View
                          style={{
                            width: 20,
                            height: 20,
                            borderRadius: 10,
                            backgroundColor: isDarkMode ? "#1A1D23" : muted,
                            alignSelf: isDarkMode ? "flex-end" : "flex-start",
                          }}
                        />
                      </TouchableOpacity>

                      {/* SWITCH */}
                      {drawerSection(t.cdSwitchView)}
                      {drawerRow(
                        "person-search",
                        "#0EA5E9",
                        t.cdCandidateView,
                        () => {
                          setShowMobileMenu(false);
                          navigation.navigate("Jobs");
                        },
                      )}

                      {/* LOGOUT */}
                      <View style={{ marginTop: 8, marginBottom: 36 }}>
                        {drawerDivider()}
                        {drawerRow(
                          "logout",
                          "#EF4444",
                          t.cdSignOut,
                          () => {
                            setShowMobileMenu(false);
                            handleLogout();
                          },
                          true,
                        )}
                      </View>
                    </ScrollView>
                  </View>
                </View>
              </Modal>

              {/* ── Company Dashboard FAB (replaces bottom nav on mobile) ── */}
              {isFabOpen && (
                <TouchableOpacity
                  style={
                    {
                      position: "absolute",
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                      zIndex: 10,
                      backgroundColor: "rgba(0,0,0,0.45)",
                      ...(Platform.OS === "web"
                        ? {
                            backdropFilter: "blur(4px)",
                            WebkitBackdropFilter: "blur(4px)",
                          }
                        : {}),
                    } as any
                  }
                  activeOpacity={1}
                  onPress={() => setIsFabOpen(false)}
                />
              )}
              <View
                style={{
                  position: "absolute",
                  bottom: 24,
                  right: 20,
                  alignItems: "flex-end",
                  zIndex: 20,
                }}
              >
                {/* Speed-dial actions */}
                {isFabOpen && (
                  <View style={{ marginBottom: 14, alignItems: "flex-end" }}>
                    {[
                      {
                        tab: "statistics",
                        icon: "analytics",
                        color: "#6366F1",
                        label: t.cdAnalytics,
                      },
                      {
                        tab: "posted-jobs",
                        icon: "work",
                        color: "#10B981",
                        label: t.cdJobPostings,
                      },
                      {
                        tab: "applications",
                        icon: "assignment",
                        color: "#F59E0B",
                        label: t.cdApplications,
                      },
                      {
                        tab: "candidates",
                        icon: "people",
                        color: "#3B82F6",
                        label: t.cdTalentPool,
                      },
                      {
                        tab: "profile",
                        icon: "business",
                        color: "#8B5CF6",
                        label: t.cdCompanyProfile,
                      },
                    ].map((action) => (
                      <TouchableOpacity
                        key={action.tab}
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 10,
                        }}
                        onPress={() => {
                          handleTabChange(action.tab);
                          setIsFabOpen(false);
                        }}
                        activeOpacity={0.8}
                      >
                        <View
                          style={{
                            paddingHorizontal: 14,
                            paddingVertical: 8,
                            marginRight: 10,
                            borderRadius: 20,
                            backgroundColor: isDarkMode ? "#1A1D23" : "#FFFFFF",
                            shadowColor: "#000",
                            shadowOffset: { width: 0, height: 2 },
                            shadowOpacity: 0.15,
                            shadowRadius: 8,
                            elevation: 4,
                            borderWidth: 1,
                            borderColor: isDarkMode ? "#2C2F36" : "#F0F0F0",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.semiBold,
                              color: isDarkMode ? "#F9FAFB" : "#1A1D23",
                            }}
                          >
                            {action.label}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: 44,
                            height: 44,
                            borderRadius: 22,
                            backgroundColor: action.color,
                            alignItems: "center",
                            justifyContent: "center",
                            shadowColor: action.color,
                            shadowOffset: { width: 0, height: 4 },
                            shadowOpacity: 0.4,
                            shadowRadius: 8,
                            elevation: 6,
                          }}
                        >
                          <Icon
                            name={action.icon as any}
                            size={22}
                            color="#FFFFFF"
                          />
                        </View>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
                {/* Main FAB button */}
                <TouchableOpacity
                  onPress={() => setIsFabOpen(!isFabOpen)}
                  style={{
                    width: 58,
                    height: 58,
                    borderRadius: 29,
                    backgroundColor: "#F4C430",
                    alignItems: "center",
                    justifyContent: "center",
                    shadowColor: "#F4C430",
                    shadowOffset: { width: 0, height: 6 },
                    shadowOpacity: 0.45,
                    shadowRadius: 12,
                    elevation: 8,
                  }}
                  activeOpacity={0.85}
                >
                  <Icon
                    name={isFabOpen ? "close" : "apps"}
                    size={26}
                    color="#1A1D23"
                  />
                </TouchableOpacity>
              </View>
            </View>
          );
        })()
      ) : (
        /* Desktop View - Clean & Minimal Sidebar */
        <View style={styles.adminContainer}>
          {/* Minimalist Sidebar */}
          <View
            style={[
              styles.sidebar,
              {
                backgroundColor: isDarkMode ? "#0F1117" : "#FFFFFF",
                borderRightWidth: 1,
                borderRightColor: isDarkMode ? "#1E222D" : "#E5E7EB",
              },
              isSidebarCollapsed && styles.sidebarCollapsed,
            ]}
          >
            {/* Modern Hero Header */}
            <View
              style={{
                padding: isSidebarCollapsed ? 12 : 24,
                paddingBottom: isSidebarCollapsed ? 12 : 20,
                borderBottomWidth: 1,
                borderBottomColor: isDarkMode ? "#1E222D" : "#E5E7EB",
                position: "relative",
              }}
            >
              {!isSidebarCollapsed ? (
                <View>
                  {/* Collapse Toggle - Top Right */}
                  <TouchableOpacity
                    onPress={() => setIsSidebarCollapsed(true)}
                    style={{
                      position: "absolute",
                      top: 20,
                      right: 20,
                      width: 32,
                      height: 32,
                      borderRadius: 8,
                      backgroundColor: isDarkMode ? "#1E222D" : "#F3F4F6",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 1,
                    }}
                  >
                    <Icon
                      name="menu-open"
                      size={20}
                      color={isDarkMode ? "#9CA3AF" : "#6B7280"}
                    />
                  </TouchableOpacity>

                  {/* Company Branding Card */}
                  <View
                    style={{
                      backgroundColor: isDarkMode
                        ? "#1A1D23"
                        : colors.beeYellow + "12",
                      borderRadius: 16,
                      padding: 16,
                      marginBottom: 16,
                      borderWidth: 1,
                      borderColor: isDarkMode
                        ? "#252932"
                        : colors.beeYellow + "30",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: 12,
                      }}
                    >
                      <View
                        style={{
                          width: 56,
                          height: 56,
                          borderRadius: 14,
                          backgroundColor: isDarkMode
                            ? "#0F1114"
                            : colors.white,
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: 12,
                          overflow: "hidden",
                          borderWidth: 2,
                          borderColor: isDarkMode
                            ? "#1E222D"
                            : colors.beeYellow + "40",
                          shadowColor: colors.beeYellow,
                          shadowOffset: { width: 0, height: 2 },
                          shadowOpacity: 0.1,
                          shadowRadius: 4,
                          elevation: 2,
                        }}
                      >
                        {userData?.companyProfile?.logoUrl ? (
                          <Image
                            source={{ uri: userData.companyProfile.logoUrl }}
                            style={{ width: 56, height: 56, borderRadius: 14 }}
                          />
                        ) : (
                          <Icon
                            name="business"
                            size={28}
                            color={colors.beeYellow}
                          />
                        )}
                      </View>
                      <View style={{ flex: 1, paddingRight: 24 }}>
                        <Text
                          style={{
                            fontSize: 17,
                            fontFamily: fonts.bold,
                            color: isDarkMode ? "#F9FAFB" : "#0F172A",
                            marginBottom: 4,
                            letterSpacing: -0.3,
                          }}
                          numberOfLines={1}
                        >
                          {userData?.companyProfile?.companyName ||
                            "Your Company"}
                        </Text>
                        <View
                          style={{ flexDirection: "row", alignItems: "center" }}
                        >
                          <View
                            style={{
                              width: 6,
                              height: 6,
                              borderRadius: 3,
                              backgroundColor: "#10B981",
                              marginRight: 6,
                            }}
                          />
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: isDarkMode ? "#9CA3AF" : "#64748B",
                            }}
                          >
                            {t.cdActiveDashboard}
                          </Text>
                        </View>
                      </View>
                    </View>

                    {/* Verification Status - Enhanced */}
                    {userData?.companyProfile?.verificationStatus && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          paddingHorizontal: 12,
                          paddingVertical: 8,
                          borderRadius: 10,
                          backgroundColor:
                            userData.companyProfile.verificationStatus ===
                            "approved"
                              ? "#10B98115"
                              : userData.companyProfile.verificationStatus ===
                                "rejected"
                              ? "#EF444415"
                              : "#F59E0B15",
                          borderWidth: 1,
                          borderColor:
                            userData.companyProfile.verificationStatus ===
                            "approved"
                              ? "#10B98140"
                              : userData.companyProfile.verificationStatus ===
                                "rejected"
                              ? "#EF444440"
                              : "#F59E0B40",
                        }}
                      >
                        <View
                          style={{ flexDirection: "row", alignItems: "center" }}
                        >
                          <Icon
                            name={
                              userData.companyProfile.verificationStatus ===
                              "approved"
                                ? "verified"
                                : userData.companyProfile.verificationStatus ===
                                  "rejected"
                                ? "cancel"
                                : "schedule"
                            }
                            size={16}
                            color={
                              userData.companyProfile.verificationStatus ===
                              "approved"
                                ? "#10B981"
                                : userData.companyProfile.verificationStatus ===
                                  "rejected"
                                ? "#EF4444"
                                : "#F59E0B"
                            }
                          />
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.semiBold,
                              color:
                                userData.companyProfile.verificationStatus ===
                                "approved"
                                  ? "#10B981"
                                  : userData.companyProfile
                                      .verificationStatus === "rejected"
                                  ? "#EF4444"
                                  : "#F59E0B",
                              marginLeft: 8,
                            }}
                          >
                            {userData.companyProfile.verificationStatus ===
                            "approved"
                              ? t.cdVerifiedCompany
                              : userData.companyProfile.verificationStatus ===
                                "rejected"
                              ? t.cdVerificationRejected
                              : t.cdVerificationPending}
                          </Text>
                        </View>
                        {userData.companyProfile.verificationStatus !==
                          "approved" && (
                          <Icon
                            name="arrow-forward"
                            size={14}
                            color={
                              userData.companyProfile.verificationStatus ===
                              "rejected"
                                ? "#EF4444"
                                : "#F59E0B"
                            }
                          />
                        )}
                      </View>
                    )}
                  </View>

                  {/* Quick Access Banner - "Post a Job" CTA */}
                  {userData?.companyProfile?.verificationStatus ===
                    "approved" && (
                    <TouchableOpacity
                      onPress={() => handleTabChange("posted-jobs")}
                      style={{
                        backgroundColor: "#374151",
                        borderRadius: 12,
                        paddingVertical: 12,
                        paddingHorizontal: 16,
                        marginBottom: 8,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        shadowColor: "#3B82F6",
                        shadowOffset: { width: 0, height: 4 },
                        shadowOpacity: 0.3,
                        shadowRadius: 8,
                        elevation: 4,
                      }}
                      activeOpacity={0.8}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          flex: 1,
                        }}
                      >
                        <View
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: 10,
                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 12,
                          }}
                        >
                          <Icon name="add-circle" size={20} color="#FFFFFF" />
                        </View>
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: fonts.bold,
                            color: "#FFFFFF",
                          }}
                        >
                          Post a Job
                        </Text>
                      </View>
                      <Icon name="arrow-forward" size={18} color="#FFFFFF" />
                    </TouchableOpacity>
                  )}
                </View>
              ) : (
                <View style={{ alignItems: "center" }}>
                  {/* Collapsed Logo */}
                  <View
                    style={{
                      width: 48,
                      height: 48,
                      borderRadius: 12,
                      backgroundColor: isDarkMode
                        ? "#1A1D23"
                        : colors.beeYellow + "20",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                      borderWidth: 2,
                      borderColor: isDarkMode
                        ? "#252932"
                        : colors.beeYellow + "40",
                      marginBottom: 12,
                    }}
                  >
                    {userData?.companyProfile?.logoUrl ? (
                      <Image
                        source={{ uri: userData.companyProfile.logoUrl }}
                        style={{ width: 48, height: 48, borderRadius: 12 }}
                      />
                    ) : (
                      <Icon
                        name="business"
                        size={24}
                        color={colors.beeYellow}
                      />
                    )}
                  </View>

                  {/* Verification Indicator Dot */}
                  {userData?.companyProfile?.verificationStatus ===
                    "approved" && (
                    <View
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: 4,
                        backgroundColor: "#10B981",
                        marginBottom: 8,
                      }}
                    />
                  )}

                  {/* Expand Button */}
                  <TouchableOpacity
                    onPress={() => setIsSidebarCollapsed(false)}
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 10,
                      backgroundColor: isDarkMode ? "#1E222D" : "#F3F4F6",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon
                      name="menu"
                      size={20}
                      color={isDarkMode ? "#9CA3AF" : "#6B7280"}
                    />
                  </TouchableOpacity>
                </View>
              )}
            </View>

            {/* Modern Navigation Section - Revamped */}
            <ScrollView
              style={{ flex: 1 }}
              showsVerticalScrollIndicator={false}
              contentContainerStyle={{
                padding: isSidebarCollapsed ? 12 : 20,
                paddingBottom: 24,
              }}
            >
              {sidebarCategories.map((category, categoryIndex) => (
                <View key={category.label} style={{ marginBottom: 24 }}>
                  {!isSidebarCollapsed && (
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: 14,
                        paddingHorizontal: 4,
                      }}
                    >
                      {/* Category Icon Badge */}
                      <View
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: 9,
                          backgroundColor: category.color + "15",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: 10,
                          borderWidth: 1,
                          borderColor: category.color + "30",
                        }}
                      >
                        <Icon
                          name={category.icon}
                          size={16}
                          color={category.color}
                        />
                      </View>
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.bold,
                          color: isDarkMode ? "#9CA3AF" : "#6B7280",
                          letterSpacing: 1,
                          textTransform: "uppercase",
                          flex: 1,
                        }}
                      >
                        {category.label}
                      </Text>
                      {/* Decorative line */}
                      <View
                        style={{
                          height: 1.5,
                          width: 40,
                          backgroundColor: category.color + "30",
                          borderRadius: 1,
                        }}
                      />
                    </View>
                  )}

                  {/* Menu Items */}
                  {category.items.map((item, index) => {
                    const isActive = activeTab === item.id;
                    return (
                      <TouchableOpacity
                        key={item.id}
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingVertical: 13,
                          paddingHorizontal: isSidebarCollapsed ? 10 : 14,
                          marginBottom: 6,
                          borderRadius: 14,
                          backgroundColor: isActive
                            ? isDarkMode
                              ? `${item.color}22`
                              : `${item.color}12`
                            : isDarkMode
                            ? "transparent"
                            : "transparent",
                          borderWidth: isActive ? 1.5 : 0,
                          borderColor: isActive ? item.color : "transparent",
                          shadowColor: isActive ? item.color : "transparent",
                          shadowOffset: { width: 0, height: 4 },
                          shadowOpacity: isActive ? 0.25 : 0,
                          shadowRadius: 8,
                          elevation: isActive ? 4 : 0,
                          position: "relative",
                        }}
                        onPress={() => handleTabChange(item.id)}
                        activeOpacity={0.75}
                      >
                        {/* Active Indicator Bar */}
                        {isActive && !isSidebarCollapsed && (
                          <View
                            style={{
                              position: "absolute",
                              left: 0,
                              top: "20%",
                              bottom: "20%",
                              width: 4,
                              backgroundColor: item.color,
                              borderTopRightRadius: 4,
                              borderBottomRightRadius: 4,
                            }}
                          />
                        )}

                        {/* Icon Container with Gradient-like effect */}
                        <View
                          style={{
                            width: isSidebarCollapsed ? 44 : 46,
                            height: isSidebarCollapsed ? 44 : 46,
                            borderRadius: 12,
                            backgroundColor: isActive
                              ? item.color
                              : isDarkMode
                              ? "#1A1D23"
                              : `${item.color}10`,
                            alignItems: "center",
                            justifyContent: "center",
                            shadowColor: isActive ? item.color : "transparent",
                            shadowOffset: { width: 0, height: 4 },
                            shadowOpacity: 0.3,
                            shadowRadius: 8,
                            elevation: isActive ? 5 : 0,
                          }}
                        >
                          <Icon
                            name={item.icon}
                            size={isSidebarCollapsed ? 22 : 24}
                            color={
                              isActive
                                ? "#FFFFFF"
                                : isDarkMode
                                ? "#9CA3AF"
                                : item.color
                            }
                          />
                        </View>

                        {/* Text Content */}
                        {!isSidebarCollapsed && (
                          <View style={{ flex: 1, marginLeft: 14 }}>
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                marginBottom: 2,
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 14,
                                  fontFamily: isActive
                                    ? fonts.bold
                                    : fonts.semiBold,
                                  color: isActive
                                    ? isDarkMode
                                      ? "#FFFFFF"
                                      : "#0F172A"
                                    : isDarkMode
                                    ? "#E5E7EB"
                                    : "#334155",
                                  letterSpacing: -0.2,
                                }}
                              >
                                {item.title}
                              </Text>
                              {item.badge && (
                                <View
                                  style={{
                                    backgroundColor: "#10B981",
                                    paddingHorizontal: 6,
                                    paddingVertical: 2,
                                    borderRadius: 6,
                                    marginLeft: 8,
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: 8,
                                      fontFamily: fonts.bold,
                                      color: "#FFFFFF",
                                      letterSpacing: 0.5,
                                    }}
                                  >
                                    {item.badge}
                                  </Text>
                                </View>
                              )}
                            </View>
                            <Text
                              style={{
                                fontSize: 11,
                                fontFamily: fonts.regular,
                                color: isDarkMode ? "#6B7280" : "#9CA3AF",
                                lineHeight: 14,
                              }}
                            >
                              {item.subtitle}
                            </Text>
                          </View>
                        )}

                        {/* Active Arrow Indicator */}
                        {!isSidebarCollapsed && isActive && (
                          <View
                            style={{
                              width: 28,
                              height: 28,
                              borderRadius: 9,
                              backgroundColor: `${item.color}20`,
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Icon
                              name="chevron-right"
                              size={18}
                              color={item.color}
                            />
                          </View>
                        )}

                        {/* Collapsed Active Dot */}
                        {isSidebarCollapsed && isActive && (
                          <View
                            style={{
                              position: "absolute",
                              right: 8,
                              top: 8,
                              width: 8,
                              height: 8,
                              borderRadius: 4,
                              backgroundColor: item.color,
                            }}
                          />
                        )}
                      </TouchableOpacity>
                    );
                  })}
                </View>
              ))}

              {/* Divider with Modern Style */}
              {!isSidebarCollapsed && (
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginVertical: 20,
                    marginHorizontal: 4,
                  }}
                >
                  <View
                    style={{
                      height: 1,
                      flex: 1,
                      backgroundColor: isDarkMode ? "#1E222D" : "#E5E7EB",
                    }}
                  />
                  <Text
                    style={{
                      fontSize: 10,
                      fontFamily: fonts.semiBold,
                      color: isDarkMode ? "#6B7280" : "#9CA3AF",
                      paddingHorizontal: 12,
                      letterSpacing: 0.5,
                    }}
                  >
                    QUICK LINKS
                  </Text>
                  <View
                    style={{
                      height: 1,
                      flex: 1,
                      backgroundColor: isDarkMode ? "#1E222D" : "#E5E7EB",
                    }}
                  />
                </View>
              )}

              {/* Additional Actions - Revamped */}
              <View style={{ marginBottom: 8 }}>
                {/* Account Settings */}
                <TouchableOpacity
                  onPress={() => navigation.navigate("Settings")}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 12,
                    paddingHorizontal: isSidebarCollapsed ? 10 : 14,
                    marginBottom: 6,
                    borderRadius: 13,
                  }}
                  activeOpacity={0.75}
                >
                  <View
                    style={{
                      width: isSidebarCollapsed ? 44 : 42,
                      height: isSidebarCollapsed ? 44 : 42,
                      borderRadius: 11,
                      backgroundColor: isDarkMode ? "#1A1D23" : "#EEF2FF",
                      alignItems: "center",
                      justifyContent: "center",
                      borderWidth: 1,
                      borderColor: isDarkMode ? "#252932" : "#C7D2FE",
                    }}
                  >
                    <Icon
                      name="settings"
                      size={isSidebarCollapsed ? 22 : 20}
                      color={isDarkMode ? "#818CF8" : "#6366F1"}
                    />
                  </View>
                  {!isSidebarCollapsed && (
                    <View style={{ flex: 1, marginLeft: 14 }}>
                      <Text
                        style={{
                          fontSize: 13,
                          fontFamily: fonts.semiBold,
                          color: isDarkMode ? "#D1D5DB" : "#374151",
                          marginBottom: 1,
                        }}
                      >
                        {t.cdSettings}
                      </Text>
                    </View>
                  )}
                </TouchableOpacity>

                {/* Theme Switcher */}
                <TouchableOpacity
                  onPress={toggleTheme}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 12,
                    paddingHorizontal: isSidebarCollapsed ? 10 : 14,
                    marginBottom: 6,
                    borderRadius: 13,
                  }}
                  activeOpacity={0.75}
                >
                  <View
                    style={{
                      width: isSidebarCollapsed ? 44 : 42,
                      height: isSidebarCollapsed ? 44 : 42,
                      borderRadius: 11,
                      backgroundColor: isDarkMode ? "#1A1D23" : "#FEF3C7",
                      alignItems: "center",
                      justifyContent: "center",
                      borderWidth: 1,
                      borderColor: isDarkMode ? "#252932" : "#FDE68A",
                    }}
                  >
                    <Icon
                      name={isDarkMode ? "wb-sunny" : "nights-stay"}
                      size={isSidebarCollapsed ? 22 : 20}
                      color={isDarkMode ? "#FCD34D" : "#F59E0B"}
                    />
                  </View>
                  {!isSidebarCollapsed && (
                    <View style={{ flex: 1, marginLeft: 14 }}>
                      <Text
                        style={{
                          fontSize: 13,
                          fontFamily: fonts.semiBold,
                          color: isDarkMode ? "#D1D5DB" : "#374151",
                          marginBottom: 1,
                        }}
                      >
                        {isDarkMode ? t.lightMode : t.darkMode}
                      </Text>
                      <Text
                        style={{
                          fontSize: 10,
                          fontFamily: fonts.regular,
                          color: isDarkMode ? "#6B7280" : "#9CA3AF",
                        }}
                      >
                        Switch appearance
                      </Text>
                    </View>
                  )}
                </TouchableOpacity>

                {/* Browse Jobs Link - Moved to Bottom */}
                <TouchableOpacity
                  onPress={() => navigation.navigate("Jobs")}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 12,
                    paddingHorizontal: isSidebarCollapsed ? 10 : 14,
                    borderRadius: 13,
                  }}
                  activeOpacity={0.75}
                >
                  <View
                    style={{
                      width: isSidebarCollapsed ? 44 : 42,
                      height: isSidebarCollapsed ? 44 : 42,
                      borderRadius: 11,
                      backgroundColor: isDarkMode ? "#1A1D23" : "#ECFDF5",
                      alignItems: "center",
                      justifyContent: "center",
                      borderWidth: 1,
                      borderColor: isDarkMode ? "#252932" : "#A7F3D0",
                    }}
                  >
                    <Icon
                      name="work-outline"
                      size={isSidebarCollapsed ? 22 : 20}
                      color={isDarkMode ? "#10B981" : "#059669"}
                    />
                  </View>
                  {!isSidebarCollapsed && (
                    <View style={{ flex: 1, marginLeft: 14 }}>
                      <Text
                        style={{
                          fontSize: 13,
                          fontFamily: fonts.semiBold,
                          color: isDarkMode ? "#D1D5DB" : "#374151",
                          marginBottom: 1,
                        }}
                      >
                        {t.cdBrowseJobs}
                      </Text>
                      <Text
                        style={{
                          fontSize: 10,
                          fontFamily: fonts.regular,
                          color: isDarkMode ? "#6B7280" : "#9CA3AF",
                        }}
                      >
                        Explore all positions
                      </Text>
                    </View>
                  )}
                </TouchableOpacity>
              </View>
            </ScrollView>

            {/* Enhanced Bottom Sign Out Section */}
            <View
              style={{
                padding: isSidebarCollapsed ? 12 : 18,
                borderTopWidth: 1,
                borderTopColor: isDarkMode ? "#1E222D" : "#E5E7EB",
                backgroundColor: isDarkMode ? "#0A0C10" : "#FAFAFA",
              }}
            >
              {/* Modern Sign Out Button */}
              <TouchableOpacity
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  paddingVertical: isSidebarCollapsed ? 14 : 14,
                  paddingHorizontal: isSidebarCollapsed ? 12 : 16,
                  borderRadius: 13,
                  backgroundColor: isDarkMode ? "#DC262618" : "#FEE2E2",
                  borderWidth: 1.5,
                  borderColor: isDarkMode ? "#DC262640" : "#FECACA",
                  shadowColor: "#DC2626",
                  shadowOffset: { width: 0, height: 2 },
                  shadowOpacity: 0.15,
                  shadowRadius: 6,
                  elevation: 2,
                }}
                onPress={handleLogout}
                activeOpacity={0.8}
              >
                <View
                  style={{
                    width: isSidebarCollapsed ? 40 : 38,
                    height: isSidebarCollapsed ? 40 : 38,
                    borderRadius: 11,
                    backgroundColor: isDarkMode ? "#DC262628" : "#FCA5A5",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name="logout" size={20} color="#DC2626" />
                </View>
                {!isSidebarCollapsed && (
                  <View style={{ flex: 1, marginLeft: 14 }}>
                    <Text
                      style={{
                        fontSize: 14,
                        fontFamily: fonts.bold,
                        color: "#DC2626",
                        marginBottom: 1,
                      }}
                    >
                      {t.cdSignOut}
                    </Text>
                    <Text
                      style={{
                        fontSize: 10,
                        fontFamily: fonts.medium,
                        color: "#DC2626",
                        opacity: 0.7,
                        marginTop: 2,
                      }}
                    >
                      {userData?.email || user?.email || ""}
                    </Text>
                  </View>
                )}
              </TouchableOpacity>
            </View>
          </View>

          {/* Main Content */}
          <View
            style={[
              styles.adminMainContent,
              { backgroundColor: colors.lightGray },
            ]}
          >
            {/* Simplified Toolbar */}
            <View
              style={{
                backgroundColor: isDarkMode ? "#1A1D23" : colors.white,
                borderBottomWidth: 1,
                borderBottomColor: isDarkMode ? "#2C2F36" : "#E5E7EB",
              }}
            >
              <View
                style={{
                  paddingHorizontal: isDesktop ? 24 : 16,
                  paddingVertical: 16,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* Left - Page Title */}
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: isDesktop ? 24 : 20,
                      fontFamily: fonts.bold,
                      color: isDarkMode ? "#F9FAFB" : "#0F172A",
                      marginBottom: 4,
                    }}
                  >
                    {getCurrentTabTitle()}
                  </Text>
                  <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.medium,
                        color: isDarkMode ? "#9CA3AF" : "#6B7280",
                      }}
                    >
                      Home
                    </Text>
                    <Icon
                      name="chevron-right"
                      size={14}
                      color={isDarkMode ? "#6B7280" : "#9CA3AF"}
                      style={{ marginHorizontal: 6 }}
                    />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.medium,
                        color: isDarkMode ? "#D1D5DB" : "#374151",
                      }}
                    >
                      {t.cdDashboard}
                    </Text>
                  </View>
                </View>

                {/* Right - Actions */}
                <View
                  style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
                >
                  {/* Verification Badge */}
                  {userData?.companyProfile?.verificationStatus && (
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingHorizontal: 10,
                        paddingVertical: 6,
                        borderRadius: 6,
                        backgroundColor:
                          userData.companyProfile.verificationStatus ===
                          "approved"
                            ? "#10B98115"
                            : userData.companyProfile.verificationStatus ===
                              "rejected"
                            ? "#EF444415"
                            : "#F59E0B15",
                      }}
                    >
                      <Icon
                        name={
                          userData.companyProfile.verificationStatus ===
                          "approved"
                            ? "verified"
                            : userData.companyProfile.verificationStatus ===
                              "rejected"
                            ? "cancel"
                            : "schedule"
                        }
                        size={14}
                        color={
                          userData.companyProfile.verificationStatus ===
                          "approved"
                            ? "#10B981"
                            : userData.companyProfile.verificationStatus ===
                              "rejected"
                            ? "#EF4444"
                            : "#F59E0B"
                        }
                      />
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.semiBold,
                          color:
                            userData.companyProfile.verificationStatus ===
                            "approved"
                              ? "#10B981"
                              : userData.companyProfile.verificationStatus ===
                                "rejected"
                              ? "#EF4444"
                              : "#F59E0B",
                          marginLeft: 5,
                        }}
                      >
                        {userData.companyProfile.verificationStatus ===
                        "approved"
                          ? t.cdVerified
                          : userData.companyProfile.verificationStatus ===
                            "rejected"
                          ? "Rejected"
                          : "Pending"}
                      </Text>
                    </View>
                  )}

                  {/* Candidates */}
                  <TouchableOpacity
                    onPress={() => setActiveTab("candidates")}
                    style={{
                      paddingHorizontal: 12,
                      paddingVertical: 8,
                      borderRadius: 6,
                      backgroundColor:
                        activeTab === "candidates" ? "#374151" : "transparent",
                    }}
                  >
                    <Icon
                      name="people"
                      size={20}
                      color={
                        activeTab === "candidates"
                          ? "#FFFFFF"
                          : isDarkMode
                          ? "#D1D5DB"
                          : "#6B7280"
                      }
                    />
                  </TouchableOpacity>

                  {/* Jobs */}
                  <TouchableOpacity
                    onPress={() => navigation.navigate("Jobs")}
                    style={{
                      paddingHorizontal: 12,
                      paddingVertical: 8,
                      borderRadius: 6,
                    }}
                  >
                    <Icon
                      name="work-outline"
                      size={20}
                      color={isDarkMode ? "#D1D5DB" : "#6B7280"}
                    />
                  </TouchableOpacity>

                  {/* Theme Toggle */}
                  <TouchableOpacity
                    onPress={toggleTheme}
                    style={{
                      paddingHorizontal: 12,
                      paddingVertical: 8,
                      borderRadius: 6,
                    }}
                  >
                    <Icon
                      name={isDarkMode ? "wb-sunny" : "nightlight-round"}
                      size={20}
                      color={isDarkMode ? "#FCD34D" : "#6B7280"}
                    />
                  </TouchableOpacity>

                  {/* Settings */}
                  <TouchableOpacity
                    onPress={() => navigation.navigate("Settings")}
                    style={{
                      paddingHorizontal: 12,
                      paddingVertical: 8,
                      borderRadius: 6,
                    }}
                  >
                    <Icon
                      name="settings"
                      size={20}
                      color={isDarkMode ? "#D1D5DB" : "#6B7280"}
                    />
                  </TouchableOpacity>
                </View>
              </View>
            </View>

            {/* Content Area */}
            <View style={{ flex: 1 }}>
              {activeTab === "statistics" && (
                <CompanyStatisticsContent
                  colors={colors}
                  companyData={userData?.companyProfile}
                  navigation={navigation}
                  onTabChange={handleTabChange}
                  t={t}
                />
              )}
              {activeTab === "posted-jobs" && (
                <CompanyPostedJobsContent
                  colors={colors}
                  companyId={user?.uid}
                  navigation={navigation}
                  isDarkMode={isDarkMode}
                  t={t}
                />
              )}
              {activeTab === "applications" && (
                <CompanyApplicationsContent
                  colors={colors}
                  companyId={user?.uid}
                  navigation={navigation}
                  isDarkMode={isDarkMode}
                  t={t}
                />
              )}
              {activeTab === "candidates" && (
                <CompanyCandidatesContent
                  colors={colors}
                  navigation={navigation}
                  isDarkMode={isDarkMode}
                  t={t}
                  currentLanguage={currentLanguage}
                />
              )}
              {activeTab === "profile" && (
                <CompanyProfileContent
                  colors={colors}
                  userData={userData}
                  user={user}
                  isDarkMode={isDarkMode}
                  t={t}
                />
              )}
            </View>
          </View>
        </View>
      )}

      {/* Bottom Navigation Bar — desktop / tablet only; mobile uses FAB */}
      {!isMobile && (
        <BottomNavBar
          navigation={navigation}
          activeRoute="CompanyDashboard"
          isDarkMode={isDarkMode}
          user={user}
          userData={userData}
          currentLanguage={currentLanguage}
        />
      )}
    </SafeAreaView>
  );
}

// Company Statistics Content
function CompanyStatisticsContent({
  colors,
  companyData,
  navigation,
  onTabChange,
  t,
}: any) {
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;
  const [loading, setLoading] = useState(true);
  const [statsData, setStatsData] = useState<any>({
    activeJobs: 0,
    totalJobs: 0,
    totalApplicants: 0,
    pendingApplications: 0,
    reviewedApplications: 0,
    verificationStatus: companyData?.verificationStatus || "pending",
  });

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  useEffect(() => {
    loadStatistics();
  }, [companyData]);

  const loadStatistics = async () => {
    try {
      setLoading(true);
      const currentUser = auth.currentUser;

      if (!currentUser) {
        setLoading(false);
        return;
      }

      // Fetch jobs posted by this company
      const jobsQuery = dbQuery(
        collection(db, "jobs"),
        where("companyId", "==", currentUser.uid),
      );
      const jobsSnapshot = await getDocs(jobsQuery);
      const jobs = jobsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Count active vs inactive jobs
      const now = new Date();
      const activeJobs = jobs.filter((job) => {
        // Check if job has an expiresAt field and if it's still valid
        if (job.expiresAt) {
          const expiresAt = job.expiresAt.toDate
            ? job.expiresAt.toDate()
            : new Date(job.expiresAt);
          return expiresAt > now;
        }
        // If no expiresAt, consider it active if posted in last 90 days
        const postedAt = job.postedAt?.toDate
          ? job.postedAt.toDate()
          : new Date(job.postedAt);
        const daysSincePosted =
          (now.getTime() - postedAt.getTime()) / (1000 * 60 * 60 * 24);
        return daysSincePosted <= 90;
      }).length;

      // Fetch all applications for this company's jobs
      let totalApplicants = 0;
      let pendingApps = 0;
      let reviewedApps = 0;

      if (jobs.length > 0) {
        const jobIds = jobs.map((job) => job.id);
        // Firestore 'in' query has a limit of 10, so we'll batch if needed
        const batchSize = 10;
        for (let i = 0; i < jobIds.length; i += batchSize) {
          const batch = jobIds.slice(i, i + batchSize);
          const appsQuery = dbQuery(
            collection(db, "applications"),
            where("jobId", "in", batch),
          );
          const appsSnapshot = await getDocs(appsQuery);
          totalApplicants += appsSnapshot.size;

          appsSnapshot.docs.forEach((doc) => {
            const status = doc.data().status;
            if (status === "pending") {
              pendingApps++;
            } else {
              reviewedApps++;
            }
          });
        }
      }

      setStatsData({
        activeJobs,
        totalJobs: jobs.length,
        totalApplicants,
        pendingApplications: pendingApps,
        reviewedApplications: reviewedApps,
        verificationStatus: companyData?.verificationStatus || "pending",
      });
    } catch (error) {
      console.error("Error loading statistics:", error);
    } finally {
      setLoading(false);
    }
  };

  // Render loading skeleton
  const LoadingSkeleton = () => (
    <View style={{ padding: isMobile ? 16 : 32 }}>
      {[1, 2, 3].map((item) => (
        <View
          key={item}
          style={{
            backgroundColor: colors.white,
            borderRadius: 16,
            padding: 20,
            marginBottom: 16,
            height: 100,
          }}
        >
          <View
            style={{
              backgroundColor: colors.lightGray,
              height: 20,
              width: "40%",
              borderRadius: 4,
              marginBottom: 12,
            }}
          />
          <View
            style={{
              backgroundColor: colors.lightGray,
              height: 40,
              width: "60%",
              borderRadius: 4,
            }}
          />
        </View>
      ))}
    </View>
  );

  if (loading) {
    return <LoadingSkeleton />;
  }

  const isDark = colors.lightGray === "#1F2937";
  const bg = isDark ? "#0F1117" : "#F3F4F6";
  const card = isDark ? "#1A1D23" : "#FFFFFF";
  const txt = isDark ? "#F9FAFB" : "#0F172A";
  const muted = isDark ? "#6B7280" : "#9CA3AF";
  const border = isDark ? "#252932" : "#F0F0F0";

  /* ─── Mobile layout ─── */
  if (isMobile) {
    const avgPerJob =
      statsData.totalJobs > 0
        ? (statsData.totalApplicants / statsData.totalJobs).toFixed(1)
        : "0";

    const statCards = [
      {
        value: statsData.activeJobs,
        label: t.cdActiveJobs,
        sub: `${statsData.totalJobs} ${t.cdTotal.toLowerCase()}`,
        icon: "work",
        color: "#3B82F6",
      },
      {
        value: statsData.totalApplicants,
        label: t.cdTotalApplicants,
        sub: `${statsData.pendingApplications} ${t.cdPending.toLowerCase()}`,
        icon: "people",
        color: "#10B981",
      },
      {
        value: statsData.pendingApplications,
        label: t.cdToReview,
        sub: t.cdPendingApplications,
        icon: "notifications",
        color: "#F59E0B",
      },
      {
        value: statsData.reviewedApplications,
        label: t.cdReviewed,
        sub: t.cdProcessedSoFar,
        icon: "check-circle",
        color: "#6366F1",
      },
      {
        value: avgPerJob,
        label: t.cdAvgPerJob,
        sub: t.cdApplicationsPerPosting,
        icon: "trending-up",
        color: "#8B5CF6",
      },
      {
        value: statsData.totalJobs,
        label: t.cdTotalJobs,
        sub: `${statsData.activeJobs} ${t.cdStillActive}`,
        icon: "work-outline",
        color: "#EC4899",
      },
    ];

    const quickActions = [
      {
        icon: "add-circle",
        label: t.cdPostJob,
        action: "posted-jobs",
        color: "#3B82F6",
      },
      {
        icon: "assignment",
        label: t.cdApplications,
        action: "applications",
        color: "#6366F1",
      },
      {
        icon: "people",
        label: t.cdTalentPool,
        action: "candidates",
        color: "#10B981",
      },
      {
        icon: "business",
        label: t.cdCompanyProfile,
        action: "profile",
        color: "#8B5CF6",
      },
    ];

    return (
      <ScrollView
        style={{ flex: 1, backgroundColor: bg }}
        contentContainerStyle={{ paddingBottom: 100 }}
        showsVerticalScrollIndicator={false}
      >
        {/* ── Hero Banner ── */}
        <View
          style={{
            margin: 12,
            marginBottom: 0,
            borderRadius: 20,
            backgroundColor: isDark ? "#111420" : "#0F172A",
            padding: 20,
            overflow: "hidden",
          }}
        >
          {/* Decorative orbs */}
          <View
            style={{
              position: "absolute",
              top: -24,
              right: -24,
              width: 110,
              height: 110,
              borderRadius: 55,
              backgroundColor: "rgba(99,102,241,0.12)",
            }}
          />
          <View
            style={{
              position: "absolute",
              bottom: 0,
              right: 60,
              width: 70,
              height: 70,
              borderRadius: 35,
              backgroundColor: "rgba(244,196,48,0.07)",
            }}
          />

          {/* Label + verified chip */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 18,
            }}
          >
            <Text
              style={{
                color: "rgba(255,255,255,0.4)",
                fontSize: 11,
                fontFamily: fonts.bold,
                letterSpacing: 1.2,
                textTransform: "uppercase",
              }}
            >
              {companyData?.companyName || "Overview"}
            </Text>
            {statsData.verificationStatus === "approved" && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 4,
                  backgroundColor: "#10B98120",
                  paddingHorizontal: 9,
                  paddingVertical: 4,
                  borderRadius: 20,
                  borderWidth: 1,
                  borderColor: "#10B98140",
                }}
              >
                <Icon name="verified" size={12} color="#10B981" />
                <Text
                  style={{
                    fontSize: 10,
                    fontFamily: fonts.semiBold,
                    color: "#10B981",
                  }}
                >
                  Verified
                </Text>
              </View>
            )}
          </View>

          {/* Big numbers */}
          <View style={{ flexDirection: "row", alignItems: "flex-end" }}>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 52,
                  fontFamily: fonts.bold,
                  color: "#FFFFFF",
                  letterSpacing: -2,
                  lineHeight: 56,
                }}
              >
                {statsData.totalApplicants}
              </Text>
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.medium,
                  color: "rgba(255,255,255,0.4)",
                  marginTop: 4,
                }}
              >
                Total Applicants
              </Text>
            </View>
            <View
              style={{
                width: 1,
                height: 58,
                backgroundColor: "rgba(255,255,255,0.08)",
                marginHorizontal: 16,
                marginBottom: 4,
              }}
            />
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 52,
                  fontFamily: fonts.bold,
                  color: "#F4C430",
                  letterSpacing: -2,
                  lineHeight: 56,
                }}
              >
                {statsData.activeJobs}
              </Text>
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.medium,
                  color: "rgba(255,255,255,0.4)",
                  marginTop: 4,
                }}
              >
                Active Jobs
              </Text>
            </View>
          </View>

          {/* Pending alert row */}
          {statsData.pendingApplications > 0 && (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 8,
                marginTop: 16,
                paddingTop: 14,
                borderTopWidth: 1,
                borderTopColor: "rgba(255,255,255,0.06)",
              }}
            >
              <View
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: 3,
                  backgroundColor: "#F59E0B",
                }}
              />
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.regular,
                  color: "rgba(255,255,255,0.4)",
                }}
              >
                <Text style={{ color: "#F59E0B", fontFamily: fonts.semiBold }}>
                  {statsData.pendingApplications}
                </Text>{" "}
                applications awaiting review
              </Text>
            </View>
          )}
        </View>

        {/* ── Stat detail grid ── */}
        <View style={{ paddingHorizontal: 12, paddingTop: 12 }}>
          <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10 }}>
            {statCards.map((s, i) => (
              <View
                key={i}
                style={{
                  width: "47.5%",
                  backgroundColor: card,
                  borderRadius: 16,
                  padding: 14,
                  borderWidth: 1,
                  borderColor: border,
                  ...(Platform.OS === "web"
                    ? {
                        boxShadow: isDark
                          ? "0 2px 8px rgba(0,0,0,0.3)"
                          : "0 2px 8px rgba(0,0,0,0.06)",
                      }
                    : {
                        shadowColor: "#000",
                        shadowOffset: { width: 0, height: 2 },
                        shadowOpacity: 0.07,
                        shadowRadius: 6,
                        elevation: 3,
                      }),
                }}
              >
                {/* Icon */}
                <View
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    backgroundColor: `${s.color}18`,
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 10,
                  }}
                >
                  <Icon name={s.icon as any} size={18} color={s.color} />
                </View>
                {/* Value */}
                <Text
                  style={{
                    fontSize: 28,
                    fontFamily: fonts.bold,
                    color: txt,
                    letterSpacing: -1,
                    lineHeight: 32,
                  }}
                >
                  {s.value}
                </Text>
                {/* Label */}
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.semiBold,
                    color: txt,
                    marginTop: 2,
                  }}
                >
                  {s.label}
                </Text>
                {/* Sub */}
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.regular,
                    color: muted,
                    marginTop: 3,
                  }}
                  numberOfLines={1}
                >
                  {s.sub}
                </Text>
              </View>
            ))}
          </View>
        </View>

        {/* ── Quick actions ── */}
        <View style={{ paddingHorizontal: 12, paddingTop: 20 }}>
          <Text
            style={{
              fontSize: 13,
              fontFamily: fonts.bold,
              color: muted,
              letterSpacing: 0.8,
              textTransform: "uppercase",
              marginBottom: 10,
            }}
          >
            {t.cdQuickActions}
          </Text>
          <View style={{ flexDirection: "row", gap: 10 }}>
            {quickActions.map((a, i) => (
              <TouchableOpacity
                key={i}
                onPress={() => onTabChange?.(a.action)}
                activeOpacity={0.75}
                style={{
                  flex: 1,
                  backgroundColor: card,
                  borderRadius: 14,
                  paddingVertical: 14,
                  alignItems: "center",
                  borderWidth: 1,
                  borderColor: border,
                  gap: 6,
                  ...(Platform.OS === "web"
                    ? {
                        boxShadow: isDark
                          ? "0 2px 6px rgba(0,0,0,0.25)"
                          : "0 2px 6px rgba(0,0,0,0.05)",
                      }
                    : { elevation: 2 }),
                }}
              >
                <View
                  style={{
                    width: 38,
                    height: 38,
                    borderRadius: 11,
                    backgroundColor: `${a.color}18`,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name={a.icon as any} size={19} color={a.color} />
                </View>
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.semiBold,
                    color: txt,
                    textAlign: "center",
                  }}
                >
                  {a.label}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>

        {/* ── Application pipeline bar ── */}
        {statsData.totalApplicants > 0 && (
          <View style={{ paddingHorizontal: 12, paddingTop: 20 }}>
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.bold,
                color: muted,
                letterSpacing: 0.8,
                textTransform: "uppercase",
                marginBottom: 10,
              }}
            >
              {t.cdApplicationPipeline}
            </Text>
            <View
              style={{
                backgroundColor: card,
                borderRadius: 16,
                padding: 16,
                borderWidth: 1,
                borderColor: border,
              }}
            >
              {/* Progress bar */}
              <View
                style={{
                  flexDirection: "row",
                  height: 8,
                  borderRadius: 4,
                  overflow: "hidden",
                  backgroundColor: isDark ? "#2C2F36" : "#F0F0F0",
                  marginBottom: 14,
                }}
              >
                <View
                  style={{
                    flex: statsData.reviewedApplications,
                    backgroundColor: "#10B981",
                  }}
                />
                <View
                  style={{
                    flex: statsData.pendingApplications,
                    backgroundColor: "#F59E0B",
                  }}
                />
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                {[
                  {
                    label: t.cdReviewed,
                    value: statsData.reviewedApplications,
                    color: "#10B981",
                  },
                  {
                    label: t.cdPending,
                    value: statsData.pendingApplications,
                    color: "#F59E0B",
                  },
                  {
                    label: t.cdTotal,
                    value: statsData.totalApplicants,
                    color: txt,
                  },
                ].map((p, i) => (
                  <View key={i} style={{ alignItems: "center" }}>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 5,
                      }}
                    >
                      <View
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: 4,
                          backgroundColor: p.color,
                        }}
                      />
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.regular,
                          color: muted,
                        }}
                      >
                        {p.label}
                      </Text>
                    </View>
                    <Text
                      style={{
                        fontSize: 18,
                        fontFamily: fonts.bold,
                        color: p.color,
                        marginTop: 2,
                      }}
                    >
                      {p.value}
                    </Text>
                  </View>
                ))}
              </View>
            </View>
          </View>
        )}

        {/* ── Empty state ── */}
        {statsData.totalJobs === 0 && (
          <View style={{ paddingHorizontal: 12, paddingTop: 20 }}>
            <View
              style={{
                backgroundColor: card,
                borderRadius: 18,
                padding: 28,
                alignItems: "center",
                borderWidth: 1,
                borderColor: border,
              }}
            >
              <View
                style={{
                  width: 64,
                  height: 64,
                  borderRadius: 32,
                  backgroundColor: "#3B82F614",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 14,
                }}
              >
                <Icon name="work-outline" size={32} color="#3B82F6" />
              </View>
              <Text
                style={{
                  fontSize: 18,
                  fontFamily: fonts.bold,
                  color: txt,
                  textAlign: "center",
                  marginBottom: 8,
                }}
              >
                {t.cdPostYourFirstJob}
              </Text>
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.regular,
                  color: muted,
                  textAlign: "center",
                  marginBottom: 20,
                  lineHeight: 20,
                }}
              >
                {t.cdFirstJobDesc}
              </Text>
              <TouchableOpacity
                onPress={() => onTabChange?.("posted-jobs")}
                style={{
                  backgroundColor: "#3B82F6",
                  paddingHorizontal: 28,
                  paddingVertical: 12,
                  borderRadius: 12,
                }}
                activeOpacity={0.8}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    color: "#FFFFFF",
                  }}
                >
                  {t.cdCreateJobPosting}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        )}
      </ScrollView>
    );
  }

  /* ─── Desktop / tablet layout (unchanged structure) ─── */
  return (
    <ScrollView
      style={[styles.contentContainer, { backgroundColor: bg }]}
      contentContainerStyle={{ paddingBottom: 40 }}
      showsVerticalScrollIndicator={false}
    >
      {/* Clean Header */}
      <View style={{ padding: 32, backgroundColor: colors.white }}>
        <Text
          style={{
            fontSize: 36,
            fontFamily: fonts.bold,
            color: colors.deepNavy,
            marginBottom: 8,
          }}
        >
          {t.cdDashboard}
        </Text>
        <View style={{ flexDirection: "row", alignItems: "center", gap: 12 }}>
          <Text
            style={{
              fontSize: 15,
              fontFamily: fonts.regular,
              color: colors.warmGray,
            }}
          >
            {companyData?.companyName || "Your Company"}
          </Text>
          {statsData.verificationStatus === "approved" && (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 4,
                backgroundColor: "#10B98110",
                paddingHorizontal: 10,
                paddingVertical: 4,
                borderRadius: 12,
              }}
            >
              <Icon name="verified" size={14} color="#10B981" />
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.medium,
                  color: "#10B981",
                }}
              >
                {t.cdVerified}
              </Text>
            </View>
          )}
        </View>
      </View>

      {/* Main Stats Grid */}
      <View style={{ padding: 32, gap: 16 }}>
        <View style={{ flexDirection: "row", gap: 16 }}>
          {[
            {
              value: statsData.activeJobs,
              label: t.cdActiveJobs,
              sub: `${statsData.totalJobs} ${t.cdTotal.toLowerCase()}`,
              icon: "work-outline",
              color: "#3B82F6",
            },
            {
              value: statsData.totalApplicants,
              label: t.cdTotalApplicants,
              sub: `${
                statsData.pendingApplications
              } ${t.cdPending.toLowerCase()}`,
              icon: "people-outline",
              color: "#10B981",
            },
            {
              value:
                statsData.totalJobs > 0
                  ? (statsData.totalApplicants / statsData.totalJobs).toFixed(1)
                  : "0",
              label: t.cdAvgPerJob,
              sub: t.cdApplicationsPerPosting,
              icon: "trending-up",
              color: "#6366F1",
            },
          ].map((s, i) => (
            <View
              key={i}
              style={{
                flex: 1,
                backgroundColor: colors.white,
                borderRadius: 16,
                padding: 24,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.05,
                shadowRadius: 3,
                elevation: 2,
              }}
            >
              <View
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: 10,
                  backgroundColor: `${s.color}08`,
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 16,
                }}
              >
                <Icon name={s.icon as any} size={24} color={s.color} />
              </View>
              <Text
                style={{
                  fontSize: 36,
                  fontFamily: fonts.bold,
                  color: colors.deepNavy,
                  marginBottom: 4,
                  letterSpacing: -1,
                }}
              >
                {s.value}
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.medium,
                  color: colors.warmGray,
                }}
              >
                {s.label}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.regular,
                  color: colors.warmGray,
                  marginTop: 8,
                }}
              >
                {s.sub}
              </Text>
            </View>
          ))}
        </View>
        <View style={{ flexDirection: "row", gap: 16 }}>
          {[
            {
              value: statsData.pendingApplications,
              label: t.cdPendingReviews,
              icon:
                statsData.pendingApplications > 0
                  ? "notifications-active"
                  : "done-all",
              color: statsData.pendingApplications > 0 ? "#F59E0B" : "#10B981",
            },
            {
              value: statsData.reviewedApplications,
              label: t.cdReviewed,
              icon: "check-circle-outline",
              color: "#10B981",
            },
          ].map((s, i) => (
            <View
              key={i}
              style={{
                flex: 1,
                backgroundColor: colors.white,
                borderRadius: 16,
                padding: 24,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.05,
                shadowRadius: 3,
                elevation: 2,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <View>
                  <Text
                    style={{
                      fontSize: 28,
                      fontFamily: fonts.bold,
                      color: colors.deepNavy,
                      marginBottom: 4,
                    }}
                  >
                    {s.value}
                  </Text>
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.medium,
                      color: colors.warmGray,
                    }}
                  >
                    {s.label}
                  </Text>
                </View>
                <View
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: 12,
                    backgroundColor: `${s.color}08`,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name={s.icon as any} size={28} color={s.color} />
                </View>
              </View>
            </View>
          ))}
        </View>
      </View>

      {/* Quick Actions */}
      <View style={{ paddingHorizontal: 32, marginBottom: 32 }}>
        <Text
          style={{
            fontSize: 16,
            fontFamily: fonts.semiBold,
            color: colors.deepNavy,
            marginBottom: 16,
          }}
        >
          {t.cdQuickActions}
        </Text>
        <View style={{ flexDirection: "row", gap: 10 }}>
          {[
            {
              icon: "add-circle-outline",
              label: t.cdPostNewJob,
              action: "posted-jobs",
              color: "#3B82F6",
            },
            {
              icon: "assignment",
              label: t.cdViewApplications,
              action: "applications",
              color: "#6366F1",
            },
            {
              icon: "people-outline",
              label: t.cdBrowseCandidates,
              action: "candidates",
              color: "#10B981",
            },
            {
              icon: "business",
              label: t.cdEditProfile,
              action: "profile",
              color: "#8B5CF6",
            },
          ].map((a, i) => (
            <TouchableOpacity
              key={i}
              style={{
                flex: 1,
                backgroundColor: colors.white,
                borderRadius: 12,
                padding: 16,
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
                borderWidth: 1,
                borderColor: isDark ? "#374151" : "#E5E7EB",
              }}
              activeOpacity={0.7}
              onPress={() => onTabChange?.(a.action)}
            >
              <View
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  backgroundColor: `${a.color}10`,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name={a.icon as any} size={20} color={a.color} />
              </View>
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.medium,
                  color: colors.deepNavy,
                  flex: 1,
                }}
              >
                {a.label}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      </View>

      {/* Empty State */}
      {statsData.totalJobs === 0 && (
        <View style={{ paddingHorizontal: 32, marginBottom: 24 }}>
          <View
            style={{
              backgroundColor: colors.white,
              borderRadius: 16,
              padding: 48,
              alignItems: "center",
            }}
          >
            <View
              style={{
                width: 80,
                height: 80,
                borderRadius: 40,
                backgroundColor: "#3B82F610",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 20,
              }}
            >
              <Icon name="work-outline" size={40} color="#3B82F6" />
            </View>
            <Text
              style={{
                fontSize: 24,
                fontFamily: fonts.bold,
                color: colors.deepNavy,
                textAlign: "center",
                marginBottom: 12,
              }}
            >
              {t.cdPostYourFirstJob}
            </Text>
            <Text
              style={{
                fontSize: 15,
                fontFamily: fonts.regular,
                color: colors.warmGray,
                textAlign: "center",
                marginBottom: 24,
                maxWidth: 400,
              }}
            >
              {t.cdFirstJobDesc}
            </Text>
            <TouchableOpacity
              style={{
                backgroundColor: "#374151",
                paddingHorizontal: 32,
                paddingVertical: 14,
                borderRadius: 12,
              }}
              onPress={() => onTabChange?.("posted-jobs")}
            >
              <Text
                style={{
                  fontSize: 15,
                  fontFamily: fonts.semiBold,
                  color: "#FFFFFF",
                }}
              >
                {t.cdCreateJobPosting}
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      )}
    </ScrollView>
  );
}

// Company Applications Content - View all applications across all company jobs
function CompanyApplicationsContent({
  colors,
  companyId,
  navigation,
  isDarkMode,
  t,
}: any) {
  const dimensions = Dimensions.get("window");
  const isMobile = dimensions.width < 768;
  const { showAlert: showAppAlert } = useAppAlert();

  const [applications, setApplications] = useState<any[]>([]);
  const [filteredApplications, setFilteredApplications] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState<string>("all");
  const [selectedApplication, setSelectedApplication] = useState<any>(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState<"date" | "name" | "status">("date");
  const [jobsMap, setJobsMap] = useState<{ [key: string]: any }>({});

  useEffect(() => {
    loadApplications();
  }, [companyId]);

  useEffect(() => {
    // Filter and search applications
    let filtered = applications;

    // Filter by status
    if (filterStatus !== "all") {
      filtered = filtered.filter((app) => app.status === filterStatus);
    }

    // Search by name, email, or job title
    if (searchText.trim()) {
      const search = searchText.toLowerCase();
      filtered = filtered.filter(
        (app) =>
          app.applicantName?.toLowerCase().includes(search) ||
          app.applicantEmail?.toLowerCase().includes(search) ||
          app.jobTitle?.toLowerCase().includes(search),
      );
    }

    // Sort applications
    if (sortBy === "date") {
      filtered = filtered.sort((a, b) => {
        const dateA = a.appliedAt?.toDate ? a.appliedAt.toDate() : new Date(0);
        const dateB = b.appliedAt?.toDate ? b.appliedAt.toDate() : new Date(0);
        return dateB.getTime() - dateA.getTime();
      });
    } else if (sortBy === "name") {
      filtered = filtered.sort((a, b) =>
        (a.applicantName || "").localeCompare(b.applicantName || ""),
      );
    } else if (sortBy === "status") {
      const statusOrder = {
        accepted: 0,
        shortlisted: 1,
        reviewed: 2,
        pending: 3,
        rejected: 4,
      };
      filtered = filtered.sort(
        (a, b) => (statusOrder[a.status] || 99) - (statusOrder[b.status] || 99),
      );
    }

    setFilteredApplications(filtered);
  }, [filterStatus, applications, searchText, sortBy]);

  const loadApplications = async () => {
    try {
      setLoading(true);

      console.log(
        `📋 [Applications] Loading applications for companyId: ${companyId}`,
      );

      // Query applications directly by companyId (simpler and more reliable)
      const applicationsQuery = dbQuery(
        collection(db, "applications"),
        where("companyId", "==", companyId),
        orderBy("appliedAt", "desc"),
      );

      const snapshot = await getDocs(applicationsQuery);
      console.log(
        `📋 [Applications] Found ${snapshot.docs.length} applications`,
      );

      const applicationsData = snapshot.docs.map((doc) => {
        const data = doc.data();
        console.log(
          `   ├─ Application ${doc.id}: jobId=${data.jobId}, applicant=${data.applicantName}, status=${data.status}`,
        );
        return {
          id: doc.id,
          ...data,
          jobTitle: data.jobTitle || "Unknown Job",
          jobLocation: data.jobLocation || "",
        };
      });

      setApplications(applicationsData);

      // Also load job details for jobs that don't have cached data
      const uniqueJobIds = [
        ...new Set(applicationsData.map((app) => app.jobId).filter(Boolean)),
      ];
      if (uniqueJobIds.length > 0) {
        const jobsMapData: { [key: string]: any } = {};

        // Fetch jobs in batches of 10 (Firestore 'in' query limit)
        for (let i = 0; i < uniqueJobIds.length; i += 10) {
          const batch = uniqueJobIds.slice(i, i + 10);
          const jobsQuery = dbQuery(
            collection(db, "jobs"),
            where("__name__", "in", batch),
          );
          const jobsSnapshot = await getDocs(jobsQuery);
          jobsSnapshot.docs.forEach((doc) => {
            jobsMapData[doc.id] = { id: doc.id, ...doc.data() };
          });
        }

        setJobsMap(jobsMapData);

        // Update applications with job details if they're missing
        const updatedApplications = applicationsData.map((app) => ({
          ...app,
          jobTitle:
            app.jobTitle || jobsMapData[app.jobId]?.title || "Unknown Job",
          jobLocation:
            app.jobLocation || jobsMapData[app.jobId]?.location || "",
        }));
        setApplications(updatedApplications);
      }

      console.log(
        `✅ [Applications] Loaded ${applicationsData.length} applications successfully`,
      );
    } catch (error) {
      console.error("❌ [Applications] Error loading applications:", error);
      showAppAlert(
        "error",
        "Loading Failed",
        "Failed to load applications. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (
    applicationId: string,
    newStatus: string,
  ) => {
    try {
      setUpdatingStatus(true);

      // Update Firestore
      await updateDoc(doc(db, "applications", applicationId), {
        status: newStatus,
        updatedAt: new Date(),
      });

      // Find the application to get applicant details
      const application = applications.find((app) => app.id === applicationId);

      // Update local state
      setApplications((prev) =>
        prev.map((app) =>
          app.id === applicationId
            ? { ...app, status: newStatus, updatedAt: new Date() }
            : app,
        ),
      );

      if (selectedApplication?.id === applicationId) {
        setSelectedApplication({ ...selectedApplication, status: newStatus });
      }

      // When accepted: close the job posting so no more applications are accepted
      if (newStatus === "accepted" && application) {
        try {
          await updateDoc(doc(db, "jobs", application.jobId), {
            isActive: false,
            closedAt: new Date(),
            closedReason: "applicant_accepted",
          });
          // Update local jobs map
          if (jobsMap[application.jobId]) {
            setJobsMap((prev) => ({
              ...prev,
              [application.jobId]: {
                ...prev[application.jobId],
                isActive: false,
              },
            }));
          }
        } catch (closeErr) {
          console.error("Error closing job posting:", closeErr);
        }
      }

      // Send email + push notification for accepted or rejected status
      if (
        (newStatus === "accepted" || newStatus === "rejected") &&
        application
      ) {
        try {
          const notifyApplicationStatusChange = httpsCallable(
            functions,
            "notifyApplicationStatusChange",
          );
          await notifyApplicationStatusChange({
            applicantId: application.applicantId,
            applicantEmail: application.applicantEmail,
            applicantName: application.applicantName,
            jobTitle: application.jobTitle,
            companyName:
              jobsMap[application.jobId]?.companyName ||
              jobsMap[application.jobId]?.company ||
              "Company",
            status: newStatus,
          });
          console.log(`Email notification sent for ${newStatus} status`);
        } catch (emailError) {
          console.error("Error sending email notification:", emailError);
          // Don't fail the status update if email fails
        }
      }

      const statusLabels: Record<string, string> = {
        reviewed: "Reviewed",
        shortlisted: "Shortlisted",
        accepted: "Accepted",
        rejected: "Rejected",
      };
      const statusLabel = statusLabels[newStatus] || newStatus;
      const alertType =
        newStatus === "accepted"
          ? "success"
          : newStatus === "rejected"
          ? "warning"
          : "info";
      showAppAlert(
        alertType as AlertType,
        `Application ${statusLabel}`,
        `Application status updated to ${statusLabel}.${
          newStatus === "accepted" ? " The job posting has been closed." : ""
        }`,
      );
    } catch (error) {
      console.error("Error updating status:", error);
      showAppAlert(
        "error",
        "Update Failed",
        "Failed to update application status. Please try again.",
      );
    } finally {
      setUpdatingStatus(false);
    }
  };

  const handleAddNote = async (applicationId: string, note: string) => {
    try {
      await updateDoc(doc(db, "applications", applicationId), {
        notes: note,
        updatedAt: new Date(),
      });

      // Update local state
      setApplications((prev) =>
        prev.map((app) =>
          app.id === applicationId ? { ...app, notes: note } : app,
        ),
      );

      if (selectedApplication?.id === applicationId) {
        setSelectedApplication({ ...selectedApplication, notes: note });
      }

      showAppAlert(
        "success",
        "Note Saved",
        "Your note has been saved successfully.",
      );
    } catch (error) {
      console.error("Error adding note:", error);
      showAppAlert(
        "error",
        "Save Failed",
        "Failed to save note. Please try again.",
      );
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "pending":
        return colors.warmGray;
      case "reviewed":
        return colors.softBlue;
      case "shortlisted":
        return colors.beeYellow;
      case "accepted":
        return colors.success;
      case "rejected":
        return colors.danger;
      default:
        return colors.warmGray;
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case "pending":
        return "schedule";
      case "reviewed":
        return "visibility";
      case "shortlisted":
        return "star";
      case "accepted":
        return "check-circle";
      case "rejected":
        return "cancel";
      default:
        return "help";
    }
  };

  const statusCounts = {
    all: applications.length,
    pending: applications.filter((app) => app.status === "pending").length,
    reviewed: applications.filter((app) => app.status === "reviewed").length,
    shortlisted: applications.filter((app) => app.status === "shortlisted")
      .length,
    accepted: applications.filter((app) => app.status === "accepted").length,
    rejected: applications.filter((app) => app.status === "rejected").length,
  };

  const isDark = colors.lightGray === "#1F2937";
  const bg = isDark ? "#0F1117" : "#F3F4F6";
  const card = isDark ? "#1A1D23" : "#FFFFFF";
  const txt = isDark ? "#F9FAFB" : "#0F172A";
  const muted = isDark ? "#6B7280" : "#9CA3AF";
  const border = isDark ? "#252932" : "#F0F0F0";

  if (loading) {
    return (
      <View style={{ flex: 1, backgroundColor: bg }}>
        <FullScreenLoader
          message={t.cdLoadingApplications}
          isDarkMode={isDarkMode}
        />
      </View>
    );
  }

  return (
    <View style={{ flex: 1, backgroundColor: bg }}>
      {/* ── Header ── */}
      {isMobile ? (
        /* Mobile: compact strip */
        <View
          style={{
            backgroundColor: isDark ? "#111318" : "#FFFFFF",
            paddingHorizontal: 16,
            paddingTop: 12,
            paddingBottom: 12,
            borderBottomWidth: 1,
            borderBottomColor: border,
          }}
        >
          {/* Stat chips + search */}
          <View style={{ flexDirection: "row", gap: 6, marginBottom: 10 }}>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 4,
                backgroundColor: "#F59E0B18",
                paddingHorizontal: 10,
                paddingVertical: 5,
                borderRadius: 20,
                borderWidth: 1,
                borderColor: "#F59E0B30",
              }}
            >
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.bold,
                  color: "#F59E0B",
                }}
              >
                {statusCounts.pending}
              </Text>
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: fonts.medium,
                  color: "#F59E0B",
                }}
              >
                pending
              </Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 4,
                backgroundColor: isDark ? "#252932" : "#F3F4F6",
                paddingHorizontal: 10,
                paddingVertical: 5,
                borderRadius: 20,
              }}
            >
              <Text
                style={{ fontSize: 14, fontFamily: fonts.bold, color: txt }}
              >
                {statusCounts.all}
              </Text>
              <Text
                style={{ fontSize: 11, fontFamily: fonts.medium, color: muted }}
              >
                total
              </Text>
            </View>
          </View>
          {/* Search Bar */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              backgroundColor: isDark ? "#252932" : "#F3F4F6",
              borderRadius: 12,
              paddingHorizontal: 12,
              height: 40,
              borderWidth: 1,
              borderColor: border,
            }}
          >
            <Icon name="search" size={18} color={muted} />
            <TextInput
              style={{
                flex: 1,
                marginLeft: 10,
                fontFamily: fonts.regular,
                fontSize: 14,
                color: txt,
              }}
              placeholder={t.cdSearchApplications}
              placeholderTextColor={muted}
              value={searchText}
              onChangeText={setSearchText}
            />
            {searchText ? (
              <TouchableOpacity onPress={() => setSearchText("")}>
                <Icon name="close" size={16} color={muted} />
              </TouchableOpacity>
            ) : null}
          </View>
        </View>
      ) : (
        /* Desktop: existing header */
        <View style={{ backgroundColor: colors.white, padding: 32 }}>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 16,
            }}
          >
            <View>
              <Text
                style={{
                  fontSize: 28,
                  fontFamily: fonts.bold,
                  color: colors.deepNavy,
                  marginBottom: 4,
                }}
              >
                {t.cdApplications}
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.regular,
                  color: colors.warmGray,
                }}
              >
                Review and manage candidate applications
              </Text>
            </View>
          </View>
          {/* Desktop stats row */}
          <View style={{ flexDirection: "row", gap: 12, flexWrap: "wrap" }}>
            <View
              style={{
                flex: 1,
                minWidth: 120,
                backgroundColor: isDark ? "#1F2937" : "#F3F4F6",
                paddingHorizontal: 16,
                paddingVertical: 12,
                borderRadius: 12,
              }}
            >
              <Text
                style={{ fontSize: 24, fontFamily: fonts.bold, color: txt }}
              >
                {statusCounts.all}
              </Text>
              <Text
                style={{ fontSize: 12, fontFamily: fonts.medium, color: muted }}
              >
                {t.cdTotal}
              </Text>
            </View>
            <View
              style={{
                flex: 1,
                minWidth: 120,
                backgroundColor: "#FEF3C7",
                paddingHorizontal: 16,
                paddingVertical: 12,
                borderRadius: 12,
              }}
            >
              <Text
                style={{
                  fontSize: 24,
                  fontFamily: fonts.bold,
                  color: "#D97706",
                }}
              >
                {statusCounts.pending}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.medium,
                  color: "#92400E",
                }}
              >
                {t.cdPending}
              </Text>
            </View>
            <View
              style={{
                flex: 1,
                minWidth: 120,
                backgroundColor: "#ECFDF5",
                paddingHorizontal: 16,
                paddingVertical: 12,
                borderRadius: 12,
              }}
            >
              <Text
                style={{
                  fontSize: 24,
                  fontFamily: fonts.bold,
                  color: "#10B981",
                }}
              >
                {statusCounts.accepted}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.medium,
                  color: "#059669",
                }}
              >
                {t.cdAccept}
              </Text>
            </View>
            {statusCounts.shortlisted > 0 && (
              <View
                style={{
                  flex: 1,
                  minWidth: 120,
                  backgroundColor: "#EEF2FF",
                  paddingHorizontal: 16,
                  paddingVertical: 12,
                  borderRadius: 12,
                }}
              >
                <Text
                  style={{
                    fontSize: 24,
                    fontFamily: fonts.bold,
                    color: "#6366F1",
                  }}
                >
                  {statusCounts.shortlisted}
                </Text>
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.medium,
                    color: "#4F46E5",
                  }}
                >
                  Shortlisted
                </Text>
              </View>
            )}
          </View>
          {/* Desktop search bar */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              backgroundColor: isDark ? "#1F2937" : "#F3F4F6",
              borderRadius: 12,
              paddingHorizontal: 16,
              marginTop: 16,
              height: 44,
            }}
          >
            <Icon name="search" size={20} color={muted} />
            <TextInput
              style={{
                flex: 1,
                marginLeft: 12,
                fontFamily: fonts.regular,
                fontSize: 14,
                color: txt,
              }}
              placeholder={t.cdSearchApplications}
              placeholderTextColor={muted}
              value={searchText}
              onChangeText={setSearchText}
            />
            {searchText ? (
              <TouchableOpacity onPress={() => setSearchText("")}>
                <Icon name="close" size={20} color={muted} />
              </TouchableOpacity>
            ) : null}
          </View>
        </View>
      )}

      {/* Filter Pills */}
      <View
        style={{
          paddingHorizontal: isMobile ? 12 : 32,
          paddingTop: isMobile ? 10 : 16,
        }}
      >
        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          contentContainerStyle={{ gap: 8, paddingBottom: 8 }}
        >
          {[
            "all",
            "pending",
            "reviewed",
            "shortlisted",
            "accepted",
            "rejected",
          ].map((status) => {
            const isActive = filterStatus === status;
            return (
              <TouchableOpacity
                key={status}
                onPress={() => setFilterStatus(status)}
                style={{
                  paddingVertical: isMobile ? 7 : 8,
                  paddingHorizontal: isMobile ? 12 : 16,
                  borderRadius: 20,
                  backgroundColor: isActive
                    ? isMobile
                      ? "#3B82F6"
                      : colors.deepNavy
                    : card,
                  borderWidth: 1,
                  borderColor: isActive
                    ? isMobile
                      ? "#3B82F6"
                      : colors.deepNavy
                    : border,
                }}
              >
                <View
                  style={{ flexDirection: "row", alignItems: "center", gap: 6 }}
                >
                  <Text
                    style={{
                      fontFamily: fonts.medium,
                      fontSize: isMobile ? 12 : 13,
                      color: isActive ? "#FFFFFF" : txt,
                      textTransform: "capitalize",
                    }}
                  >
                    {status === "all"
                      ? t.statusAll
                      : status === "pending"
                      ? t.statusPending
                      : status === "reviewed"
                      ? t.statusReviewed
                      : status === "shortlisted"
                      ? t.statusShortlisted
                      : status === "accepted"
                      ? t.statusAccepted
                      : status === "rejected"
                      ? t.statusRejected
                      : status}
                  </Text>
                  <View
                    style={{
                      backgroundColor: isActive
                        ? "rgba(255,255,255,0.25)"
                        : isDark
                        ? "#252932"
                        : "#F3F4F6",
                      paddingHorizontal: 6,
                      paddingVertical: 2,
                      borderRadius: 8,
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 11,
                        color: isActive ? "#FFFFFF" : txt,
                      }}
                    >
                      {statusCounts[status]}
                    </Text>
                  </View>
                </View>
              </TouchableOpacity>
            );
          })}
        </ScrollView>
      </View>

      {/* Applications List */}
      {filteredApplications.length === 0 ? (
        <View
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            padding: isMobile ? 32 : 48,
          }}
        >
          <View
            style={{
              width: isMobile ? 64 : 80,
              height: isMobile ? 64 : 80,
              borderRadius: isMobile ? 32 : 40,
              backgroundColor: "#3B82F614",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: isMobile ? 14 : 20,
            }}
          >
            <Icon name="inbox" size={isMobile ? 32 : 40} color="#3B82F6" />
          </View>
          <Text
            style={{
              fontSize: isMobile ? 18 : 20,
              fontFamily: fonts.bold,
              color: txt,
              marginBottom: 8,
              textAlign: "center",
            }}
          >
            {t.cdNoApplicationsFound}
          </Text>
          <Text
            style={{
              fontSize: isMobile ? 13 : 14,
              fontFamily: fonts.regular,
              color: muted,
              textAlign: "center",
              maxWidth: 300,
              lineHeight: isMobile ? 20 : 22,
            }}
          >
            {searchText || filterStatus !== "all"
              ? t.cdTryAdjustingFilters
              : t.cdApplicationsWillAppear}
          </Text>
        </View>
      ) : (
        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={{
            padding: isMobile ? 12 : 32,
            paddingBottom: isMobile ? 100 : 40,
            gap: isMobile ? 10 : 12,
          }}
          showsVerticalScrollIndicator={false}
        >
          {filteredApplications.map((application) => {
            const statusColor = getStatusColor(application.status);
            const appliedDate = application.appliedAt?.toDate
              ? new Date(application.appliedAt.toDate())
              : null;
            const formattedDate = appliedDate
              ? appliedDate.toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year:
                    appliedDate.getFullYear() !== new Date().getFullYear()
                      ? "numeric"
                      : undefined,
                })
              : "";

            return (
              <TouchableOpacity
                key={application.id}
                activeOpacity={0.75}
                onPress={() => {
                  setSelectedApplication(application);
                  setShowDetailModal(true);
                }}
                style={
                  isMobile
                    ? {
                        backgroundColor: card,
                        borderRadius: 16,
                        padding: 14,
                        borderWidth: 1,
                        borderColor: border,
                        ...(Platform.OS === "web"
                          ? {
                              boxShadow: isDark
                                ? "0 2px 8px rgba(0,0,0,0.3)"
                                : "0 2px 8px rgba(0,0,0,0.06)",
                            }
                          : { elevation: 2 }),
                      }
                    : {
                        backgroundColor: colors.white,
                        borderRadius: 16,
                        padding: 24,
                        shadowColor: "#000",
                        shadowOffset: { width: 0, height: 1 },
                        shadowOpacity: 0.05,
                        shadowRadius: 3,
                        elevation: 2,
                      }
                }
              >
                {isMobile ? (
                  /* ── Mobile card ── */
                  <>
                    {/* Name + status row */}
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: 10,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          flex: 1,
                          marginRight: 10,
                        }}
                      >
                        <View
                          style={{
                            width: 38,
                            height: 38,
                            borderRadius: 19,
                            backgroundColor: "#3B82F618",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 10,
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: fonts.bold,
                              fontSize: 15,
                              color: "#3B82F6",
                            }}
                          >
                            {application.applicantName
                              ?.charAt(0)
                              ?.toUpperCase() || "?"}
                          </Text>
                        </View>
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 15,
                              fontFamily: fonts.bold,
                              color: txt,
                            }}
                            numberOfLines={1}
                          >
                            {application.applicantName}
                          </Text>
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: muted,
                              marginTop: 1,
                            }}
                            numberOfLines={1}
                          >
                            {application.jobTitle}
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 5,
                          backgroundColor: statusColor + "18",
                          paddingHorizontal: 10,
                          paddingVertical: 5,
                          borderRadius: 20,
                          borderWidth: 1,
                          borderColor: statusColor + "30",
                        }}
                      >
                        <View
                          style={{
                            width: 6,
                            height: 6,
                            borderRadius: 3,
                            backgroundColor: statusColor,
                          }}
                        />
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.semiBold,
                            color: statusColor,
                            textTransform: "capitalize",
                          }}
                        >
                          {application.status}
                        </Text>
                      </View>
                    </View>
                    {/* Meta row */}
                    <View
                      style={{
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: 10,
                        marginBottom: 12,
                        paddingBottom: 12,
                        borderBottomWidth: 1,
                        borderBottomColor: border,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <Icon name="email" size={13} color={muted} />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.regular,
                            color: muted,
                          }}
                          numberOfLines={1}
                        >
                          {application.applicantEmail}
                        </Text>
                      </View>
                      {formattedDate && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 5,
                          }}
                        >
                          <Icon name="calendar-today" size={13} color={muted} />
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.regular,
                              color: muted,
                            }}
                          >
                            Applied {formattedDate}
                          </Text>
                        </View>
                      )}
                    </View>
                    {/* Action buttons */}
                    <View style={{ flexDirection: "row", gap: 8 }}>
                      {application.status === "pending" && (
                        <>
                          <TouchableOpacity
                            style={{
                              flex: 1,
                              backgroundColor: "#6366F118",
                              paddingVertical: 9,
                              borderRadius: 10,
                              alignItems: "center",
                              borderWidth: 1,
                              borderColor: "#6366F130",
                            }}
                            onPress={(e) => {
                              e.stopPropagation?.();
                              handleStatusChange(application.id, "shortlisted");
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#6366F1",
                              }}
                            >
                              {t.cdShortlist}
                            </Text>
                          </TouchableOpacity>
                          <TouchableOpacity
                            style={{
                              flex: 1,
                              backgroundColor: "#EF444418",
                              paddingVertical: 9,
                              borderRadius: 10,
                              alignItems: "center",
                              borderWidth: 1,
                              borderColor: "#EF444430",
                            }}
                            onPress={(e) => {
                              e.stopPropagation?.();
                              handleStatusChange(application.id, "rejected");
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#EF4444",
                              }}
                            >
                              {t.cdReject}
                            </Text>
                          </TouchableOpacity>
                        </>
                      )}
                      {application.status === "shortlisted" && (
                        <>
                          <TouchableOpacity
                            style={{
                              flex: 1,
                              backgroundColor: "#10B98118",
                              paddingVertical: 9,
                              borderRadius: 10,
                              alignItems: "center",
                              borderWidth: 1,
                              borderColor: "#10B98130",
                            }}
                            onPress={(e) => {
                              e.stopPropagation?.();
                              handleStatusChange(application.id, "accepted");
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#10B981",
                              }}
                            >
                              {t.cdAccept}
                            </Text>
                          </TouchableOpacity>
                          <TouchableOpacity
                            style={{
                              flex: 1,
                              backgroundColor: "#EF444418",
                              paddingVertical: 9,
                              borderRadius: 10,
                              alignItems: "center",
                              borderWidth: 1,
                              borderColor: "#EF444430",
                            }}
                            onPress={(e) => {
                              e.stopPropagation?.();
                              handleStatusChange(application.id, "rejected");
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#EF4444",
                              }}
                            >
                              {t.cdReject}
                            </Text>
                          </TouchableOpacity>
                        </>
                      )}
                      {(application.status === "accepted" ||
                        application.status === "rejected" ||
                        application.status === "reviewed") && (
                        <TouchableOpacity
                          style={{
                            flex: 1,
                            backgroundColor: isDark ? "#252932" : "#F3F4F6",
                            paddingVertical: 9,
                            borderRadius: 10,
                            alignItems: "center",
                            flexDirection: "row",
                            justifyContent: "center",
                            gap: 6,
                            borderWidth: 1,
                            borderColor: border,
                          }}
                          onPress={() => {
                            setSelectedApplication(application);
                            setShowDetailModal(true);
                          }}
                        >
                          <Icon name="visibility" size={16} color={txt} />
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.semiBold,
                              color: txt,
                            }}
                          >
                            {t.cdViewDetails}
                          </Text>
                        </TouchableOpacity>
                      )}
                    </View>
                  </>
                ) : (
                  /* ── Desktop card (unchanged) ── */
                  <>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        marginBottom: 16,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          flex: 1,
                          marginRight: 12,
                        }}
                      >
                        <View
                          style={{
                            width: 48,
                            height: 48,
                            borderRadius: 24,
                            backgroundColor: "#3B82F615",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 12,
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: fonts.bold,
                              fontSize: 18,
                              color: "#3B82F6",
                            }}
                          >
                            {application.applicantName
                              ?.charAt(0)
                              ?.toUpperCase() || "?"}
                          </Text>
                        </View>
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 17,
                              fontFamily: fonts.bold,
                              color: colors.deepNavy,
                              marginBottom: 4,
                            }}
                          >
                            {application.applicantName}
                          </Text>
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.medium,
                              color: colors.warmGray,
                            }}
                          >
                            {application.jobTitle}
                          </Text>
                        </View>
                      </View>
                      <View
                        style={{
                          backgroundColor: statusColor + "15",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <View
                            style={{
                              width: 6,
                              height: 6,
                              borderRadius: 3,
                              backgroundColor: statusColor,
                            }}
                          />
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.semiBold,
                              color: statusColor,
                              textTransform: "capitalize",
                            }}
                          >
                            {application.status}
                          </Text>
                        </View>
                      </View>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: 16,
                        paddingBottom: 16,
                        borderBottomWidth: 1,
                        borderBottomColor: isDark ? "#374151" : "#E5E7EB",
                        marginBottom: 16,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <Icon name="email" size={16} color="#6B7280" />
                        <Text
                          style={{
                            fontSize: 13,
                            fontFamily: fonts.regular,
                            color: colors.warmGray,
                          }}
                        >
                          {application.applicantEmail}
                        </Text>
                      </View>
                      {application.applicantPhone && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <Icon name="phone" size={16} color="#6B7280" />
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.regular,
                              color: colors.warmGray,
                            }}
                          >
                            {application.applicantPhone}
                          </Text>
                        </View>
                      )}
                      {formattedDate && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <Icon
                            name="calendar-today"
                            size={16}
                            color="#6B7280"
                          />
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.regular,
                              color: colors.warmGray,
                            }}
                          >
                            Applied {formattedDate}
                          </Text>
                        </View>
                      )}
                    </View>
                    <View style={{ flexDirection: "row", gap: 8 }}>
                      {application.status === "pending" && (
                        <>
                          <TouchableOpacity
                            style={{
                              flex: 1,
                              backgroundColor: "#EEF2FF",
                              paddingVertical: 10,
                              borderRadius: 10,
                              alignItems: "center",
                            }}
                            onPress={(e) => {
                              e.stopPropagation();
                              handleStatusChange(application.id, "shortlisted");
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#6366F1",
                              }}
                            >
                              {t.cdShortlist}
                            </Text>
                          </TouchableOpacity>
                          <TouchableOpacity
                            style={{
                              flex: 1,
                              backgroundColor: "#FEF2F2",
                              paddingVertical: 10,
                              borderRadius: 10,
                              alignItems: "center",
                            }}
                            onPress={(e) => {
                              e.stopPropagation();
                              handleStatusChange(application.id, "rejected");
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#EF4444",
                              }}
                            >
                              {t.cdReject}
                            </Text>
                          </TouchableOpacity>
                        </>
                      )}
                      {application.status === "shortlisted" && (
                        <>
                          <TouchableOpacity
                            style={{
                              flex: 1,
                              backgroundColor: "#ECFDF5",
                              paddingVertical: 10,
                              borderRadius: 10,
                              alignItems: "center",
                            }}
                            onPress={(e) => {
                              e.stopPropagation();
                              handleStatusChange(application.id, "accepted");
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#10B981",
                              }}
                            >
                              {t.cdAccept}
                            </Text>
                          </TouchableOpacity>
                          <TouchableOpacity
                            style={{
                              flex: 1,
                              backgroundColor: "#FEF2F2",
                              paddingVertical: 10,
                              borderRadius: 10,
                              alignItems: "center",
                            }}
                            onPress={(e) => {
                              e.stopPropagation();
                              handleStatusChange(application.id, "rejected");
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#EF4444",
                              }}
                            >
                              {t.cdReject}
                            </Text>
                          </TouchableOpacity>
                        </>
                      )}
                      {(application.status === "accepted" ||
                        application.status === "rejected" ||
                        application.status === "reviewed") && (
                        <TouchableOpacity
                          style={{
                            flex: 1,
                            backgroundColor: isDark ? "#374151" : "#F3F4F6",
                            paddingVertical: 10,
                            borderRadius: 10,
                            alignItems: "center",
                            flexDirection: "row",
                            justifyContent: "center",
                            gap: 6,
                          }}
                          onPress={() => {
                            setSelectedApplication(application);
                            setShowDetailModal(true);
                          }}
                        >
                          <Icon
                            name="visibility"
                            size={18}
                            color={colors.deepNavy}
                          />
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.semiBold,
                              color: colors.deepNavy,
                            }}
                          >
                            {t.cdViewDetails}
                          </Text>
                        </TouchableOpacity>
                      )}
                    </View>
                  </>
                )}
              </TouchableOpacity>
            );
          })}
        </ScrollView>
      )}

      {/* Application Detail Modal */}
      {selectedApplication && (
        <Modal
          visible={showDetailModal}
          transparent
          animationType={isMobile ? "slide" : "fade"}
          onRequestClose={() => setShowDetailModal(false)}
        >
          <View
            style={{
              flex: 1,
              backgroundColor: "rgba(0,0,0,0.5)",
              justifyContent: isMobile ? "flex-end" : "center",
              alignItems: "center",
              padding: isMobile ? 0 : 20,
            }}
          >
            <View
              style={{
                backgroundColor: colors.white,
                borderRadius: isMobile ? 24 : 16,
                borderBottomLeftRadius: isMobile ? 0 : 16,
                borderBottomRightRadius: isMobile ? 0 : 16,
                width: "100%",
                maxWidth: isMobile ? "100%" : 600,
                maxHeight: isMobile ? "92%" : "90%",
              }}
            >
              {/* Modal Header */}
              {isMobile ? (
                /* Mobile Header */
                <View
                  style={{
                    paddingTop: 12,
                    paddingBottom: 16,
                    paddingHorizontal: 20,
                    borderBottomWidth: 1,
                    borderBottomColor: colors.warmGray + "15",
                  }}
                >
                  {/* Drag Handle */}
                  <View
                    style={{
                      width: 40,
                      height: 4,
                      backgroundColor: colors.warmGray + "40",
                      borderRadius: 2,
                      alignSelf: "center",
                      marginBottom: 16,
                    }}
                  />

                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      {/* Applicant Avatar */}
                      {selectedApplication.applicantPhotoURL ? (
                        <Image
                          source={{
                            uri: selectedApplication.applicantPhotoURL,
                          }}
                          style={{
                            width: 50,
                            height: 50,
                            borderRadius: 25,
                            marginRight: 12,
                            backgroundColor: colors.lightGray,
                          }}
                        />
                      ) : (
                        <View
                          style={{
                            width: 50,
                            height: 50,
                            borderRadius: 25,
                            backgroundColor: colors.beeYellow + "15",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 12,
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: fonts.bold,
                              fontSize: 20,
                              color: colors.beeYellow,
                            }}
                          >
                            {selectedApplication.applicantName
                              ?.charAt(0)
                              ?.toUpperCase() || "?"}
                          </Text>
                        </View>
                      )}
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: 17,
                            color: colors.deepNavy,
                          }}
                          numberOfLines={1}
                        >
                          {selectedApplication.applicantName}
                        </Text>
                        <Text
                          style={{
                            fontFamily: fonts.regular,
                            fontSize: 13,
                            color: colors.warmGray,
                            marginTop: 2,
                          }}
                          numberOfLines={1}
                        >
                          {selectedApplication.applicantJobTitle
                            ? `${selectedApplication.applicantJobTitle}${
                                selectedApplication.applicantCompany
                                  ? ` at ${selectedApplication.applicantCompany}`
                                  : ""
                              }`
                            : selectedApplication.jobTitle}
                        </Text>
                      </View>
                    </View>
                    <TouchableOpacity
                      onPress={() => setShowDetailModal(false)}
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: 18,
                        backgroundColor: colors.warmGray + "15",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon name="close" size={20} color={colors.deepNavy} />
                    </TouchableOpacity>
                  </View>

                  {/* Current Status Badge */}
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: 12,
                      paddingVertical: 8,
                      paddingHorizontal: 12,
                      backgroundColor:
                        getStatusColor(selectedApplication.status) + "15",
                      borderRadius: 10,
                      alignSelf: "flex-start",
                      gap: 6,
                    }}
                  >
                    <Icon
                      name={getStatusIcon(selectedApplication.status)}
                      size={16}
                      color={getStatusColor(selectedApplication.status)}
                    />
                    <Text
                      style={{
                        fontFamily: fonts.medium,
                        fontSize: 13,
                        color: getStatusColor(selectedApplication.status),
                        textTransform: "capitalize",
                      }}
                    >
                      {selectedApplication.status}
                    </Text>
                  </View>
                </View>
              ) : (
                /* Desktop Header */
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: 20,
                    borderBottomWidth: 1,
                    borderBottomColor: colors.warmGray + "20",
                  }}
                >
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 20,
                        color: colors.deepNavy,
                      }}
                    >
                      {t.cdApplicationDetails}
                    </Text>
                    <Text
                      style={{
                        fontFamily: fonts.regular,
                        fontSize: 14,
                        color: colors.warmGray,
                        marginTop: 4,
                      }}
                    >
                      {selectedApplication.jobTitle}
                    </Text>
                  </View>
                  <TouchableOpacity
                    onPress={() => setShowDetailModal(false)}
                    style={{
                      padding: 8,
                      borderRadius: 8,
                      backgroundColor: colors.warmGray + "10",
                    }}
                  >
                    <Icon name="close" size={24} color={colors.deepNavy} />
                  </TouchableOpacity>
                </View>
              )}

              <ScrollView
                style={{ flex: 1 }}
                showsVerticalScrollIndicator={false}
                contentContainerStyle={{ paddingBottom: isMobile ? 30 : 20 }}
              >
                {/* Modal Content */}
                <View style={{ padding: isMobile ? 16 : 20 }}>
                  {/* Applicant Info Card */}
                  <View
                    style={{
                      marginBottom: isMobile ? 16 : 24,
                      backgroundColor: isMobile
                        ? colors.lightGray
                        : "transparent",
                      borderRadius: 14,
                      padding: isMobile ? 14 : 0,
                    }}
                  >
                    {!isMobile && (
                      <Text
                        style={{
                          fontFamily: fonts.bold,
                          fontSize: 14,
                          color: colors.warmGray,
                          textTransform: "uppercase",
                          marginBottom: 12,
                        }}
                      >
                        {t.cdApplicantInfo}
                      </Text>
                    )}
                    {isMobile && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Icon
                          name="person"
                          size={16}
                          color={colors.beeYellow}
                        />
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: 13,
                            color: colors.deepNavy,
                            marginLeft: 8,
                          }}
                        >
                          {t.cdContactInfo}
                        </Text>
                      </View>
                    )}
                    <View style={{ gap: isMobile ? 10 : 12 }}>
                      {!isMobile && (
                        <View
                          style={{ flexDirection: "row", alignItems: "center" }}
                        >
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              flex: 1,
                            }}
                          >
                            {selectedApplication.applicantPhotoURL ? (
                              <Image
                                source={{
                                  uri: selectedApplication.applicantPhotoURL,
                                }}
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: 20,
                                  marginRight: 10,
                                  backgroundColor: colors.lightGray,
                                }}
                              />
                            ) : (
                              <View
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: 20,
                                  backgroundColor: colors.beeYellow + "20",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: 10,
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 16,
                                    fontFamily: fonts.bold,
                                    color: colors.beeYellow,
                                  }}
                                >
                                  {selectedApplication.applicantName
                                    ?.charAt(0)
                                    ?.toUpperCase() || "A"}
                                </Text>
                              </View>
                            )}
                            <View>
                              <Text
                                style={{
                                  fontFamily: fonts.medium,
                                  fontSize: 15,
                                  color: colors.deepNavy,
                                }}
                              >
                                {selectedApplication.applicantName}
                              </Text>
                              {selectedApplication.applicantJobTitle && (
                                <Text
                                  style={{
                                    fontFamily: fonts.regular,
                                    fontSize: 13,
                                    color: colors.warmGray,
                                  }}
                                >
                                  {selectedApplication.applicantJobTitle}
                                  {selectedApplication.applicantCompany
                                    ? ` at ${selectedApplication.applicantCompany}`
                                    : ""}
                                </Text>
                              )}
                            </View>
                          </View>
                        </View>
                      )}
                      <TouchableOpacity
                        style={{ flexDirection: "row", alignItems: "center" }}
                        onPress={() => {
                          if (Platform.OS === "web") {
                            window.open(
                              `mailto:${selectedApplication.applicantEmail}`,
                              "_blank",
                            );
                          } else {
                            Linking.openURL(
                              `mailto:${selectedApplication.applicantEmail}`,
                            );
                          }
                        }}
                      >
                        <View
                          style={{
                            width: isMobile ? 32 : "auto",
                            height: isMobile ? 32 : "auto",
                            borderRadius: isMobile ? 16 : 0,
                            backgroundColor: isMobile
                              ? colors.white
                              : "transparent",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon
                            name="email"
                            size={isMobile ? 16 : 18}
                            color={colors.beeYellow}
                          />
                        </View>
                        <Text
                          style={{
                            fontFamily: fonts.regular,
                            fontSize: isMobile ? 13 : 14,
                            color: colors.softBlue,
                            marginLeft: isMobile ? 10 : 10,
                            flex: 1,
                          }}
                        >
                          {selectedApplication.applicantEmail}
                        </Text>
                        <Icon
                          name="open-in-new"
                          size={12}
                          color={colors.softBlue}
                        />
                      </TouchableOpacity>
                      {selectedApplication.applicantPhone && (
                        <TouchableOpacity
                          style={{ flexDirection: "row", alignItems: "center" }}
                          onPress={() => {
                            if (Platform.OS === "web") {
                              window.open(
                                `tel:${selectedApplication.applicantPhone}`,
                                "_blank",
                              );
                            } else {
                              Linking.openURL(
                                `tel:${selectedApplication.applicantPhone}`,
                              );
                            }
                          }}
                        >
                          <View
                            style={{
                              width: isMobile ? 32 : "auto",
                              height: isMobile ? 32 : "auto",
                              borderRadius: isMobile ? 16 : 0,
                              backgroundColor: isMobile
                                ? colors.white
                                : "transparent",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Icon
                              name="phone"
                              size={isMobile ? 16 : 18}
                              color={colors.beeYellow}
                            />
                          </View>
                          <Text
                            style={{
                              fontFamily: fonts.regular,
                              fontSize: isMobile ? 13 : 14,
                              color: colors.softBlue,
                              marginLeft: 10,
                            }}
                          >
                            {selectedApplication.applicantPhone}
                          </Text>
                          <Icon
                            name="open-in-new"
                            size={12}
                            color={colors.softBlue}
                          />
                        </TouchableOpacity>
                      )}
                      {selectedApplication.applicantAddress && (
                        <View
                          style={{ flexDirection: "row", alignItems: "center" }}
                        >
                          <View
                            style={{
                              width: isMobile ? 32 : "auto",
                              height: isMobile ? 32 : "auto",
                              borderRadius: isMobile ? 16 : 0,
                              backgroundColor: isMobile
                                ? colors.white
                                : "transparent",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Icon
                              name="location-on"
                              size={isMobile ? 16 : 18}
                              color={colors.beeYellow}
                            />
                          </View>
                          <Text
                            style={{
                              fontFamily: fonts.regular,
                              fontSize: isMobile ? 13 : 14,
                              color: colors.warmGray,
                              marginLeft: 10,
                              flex: 1,
                            }}
                          >
                            {selectedApplication.applicantAddress}
                          </Text>
                        </View>
                      )}
                    </View>
                  </View>

                  {/* Professional Overview */}
                  {(selectedApplication.applicantJobTitle ||
                    selectedApplication.applicantExperience ||
                    selectedApplication.applicantCompany) && (
                    <View
                      style={{
                        marginBottom: isMobile ? 16 : 24,
                        backgroundColor: colors.beeYellow + "10",
                        borderRadius: 14,
                        padding: isMobile ? 14 : 16,
                        borderWidth: 1,
                        borderColor: colors.beeYellow + "25",
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 10,
                        }}
                      >
                        <Icon name="badge" size={16} color={colors.beeYellow} />
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: isMobile ? 13 : 14,
                            color: colors.deepNavy,
                            marginLeft: 8,
                          }}
                        >
                          {t.cdProfessionalOverview}
                        </Text>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 12,
                        }}
                      >
                        {selectedApplication.applicantJobTitle && (
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <Icon
                              name="work"
                              size={14}
                              color={colors.warmGray}
                            />
                            <Text
                              style={{
                                fontSize: isMobile ? 13 : 14,
                                fontFamily: fonts.medium,
                                color: colors.deepNavy,
                              }}
                            >
                              {selectedApplication.applicantJobTitle}
                            </Text>
                          </View>
                        )}
                        {selectedApplication.applicantCompany && (
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <Icon
                              name="business"
                              size={14}
                              color={colors.warmGray}
                            />
                            <Text
                              style={{
                                fontSize: isMobile ? 13 : 14,
                                fontFamily: fonts.medium,
                                color: colors.deepNavy,
                              }}
                            >
                              {selectedApplication.applicantCompany}
                            </Text>
                          </View>
                        )}
                        {selectedApplication.applicantExperience && (
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            <Icon
                              name="schedule"
                              size={14}
                              color={colors.warmGray}
                            />
                            <Text
                              style={{
                                fontSize: isMobile ? 13 : 14,
                                fontFamily: fonts.medium,
                                color: colors.deepNavy,
                              }}
                            >
                              {selectedApplication.applicantExperience}{" "}
                              experience
                            </Text>
                          </View>
                        )}
                      </View>
                    </View>
                  )}

                  {/* Resume / CV Section */}
                  {selectedApplication.resumeUrl && (
                    <View
                      style={{
                        marginBottom: isMobile ? 16 : 24,
                        backgroundColor: isMobile
                          ? colors.lightGray
                          : "transparent",
                        borderRadius: 14,
                        padding: isMobile ? 14 : 0,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Icon
                          name="description"
                          size={16}
                          color={colors.beeYellow}
                        />
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: isMobile ? 13 : 14,
                            color: isMobile ? colors.deepNavy : colors.warmGray,
                            textTransform: isMobile ? "none" : "uppercase",
                            marginLeft: 8,
                          }}
                        >
                          Resume / CV
                        </Text>
                      </View>
                      <View style={{ flexDirection: "row", gap: 10 }}>
                        <TouchableOpacity
                          style={{
                            flex: 1,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 8,
                            backgroundColor: colors.beeYellow,
                            paddingVertical: 12,
                            borderRadius: 10,
                          }}
                          onPress={() => {
                            if (Platform.OS === "web") {
                              window.open(
                                selectedApplication.resumeUrl,
                                "_blank",
                              );
                            } else {
                              Linking.openURL(selectedApplication.resumeUrl);
                            }
                          }}
                        >
                          <Icon
                            name="visibility"
                            size={18}
                            color={colors.deepNavy}
                          />
                          <Text
                            style={{
                              fontSize: 14,
                              fontFamily: fonts.semiBold,
                              color: colors.deepNavy,
                            }}
                          >
                            View CV
                          </Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          style={{
                            flex: 1,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 8,
                            backgroundColor: colors.white,
                            paddingVertical: 12,
                            borderRadius: 10,
                            borderWidth: 1,
                            borderColor: colors.warmGray + "30",
                          }}
                          onPress={() => {
                            if (Platform.OS === "web") {
                              const a = document.createElement("a");
                              a.href = selectedApplication.resumeUrl;
                              a.download = `${
                                selectedApplication.applicantName?.replace(
                                  /\s+/g,
                                  "_",
                                ) || "applicant"
                              }_CV`;
                              a.target = "_blank";
                              document.body.appendChild(a);
                              a.click();
                              document.body.removeChild(a);
                            } else {
                              Linking.openURL(selectedApplication.resumeUrl);
                            }
                          }}
                        >
                          <Icon
                            name="file-download"
                            size={18}
                            color={colors.deepNavy}
                          />
                          <Text
                            style={{
                              fontSize: 14,
                              fontFamily: fonts.semiBold,
                              color: colors.deepNavy,
                            }}
                          >
                            Download
                          </Text>
                        </TouchableOpacity>
                      </View>
                    </View>
                  )}

                  {/* About / Bio */}
                  {selectedApplication.applicantBio && (
                    <View
                      style={{
                        marginBottom: isMobile ? 16 : 24,
                        backgroundColor: isMobile
                          ? colors.lightGray
                          : "transparent",
                        borderRadius: 14,
                        padding: isMobile ? 14 : 0,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Icon
                          name="info-outline"
                          size={16}
                          color={colors.beeYellow}
                        />
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: isMobile ? 13 : 14,
                            color: isMobile ? colors.deepNavy : colors.warmGray,
                            textTransform: isMobile ? "none" : "uppercase",
                            marginLeft: 8,
                          }}
                        >
                          About
                        </Text>
                      </View>
                      <Text
                        style={{
                          fontFamily: fonts.regular,
                          fontSize: isMobile ? 13 : 14,
                          color: colors.warmGray,
                          lineHeight: isMobile ? 20 : 22,
                        }}
                      >
                        {selectedApplication.applicantBio}
                      </Text>
                    </View>
                  )}

                  {/* Skills */}
                  {selectedApplication.applicantSkills && (
                    <View
                      style={{
                        marginBottom: isMobile ? 16 : 24,
                        backgroundColor: isMobile
                          ? colors.lightGray
                          : "transparent",
                        borderRadius: 14,
                        padding: isMobile ? 14 : 0,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Icon
                          name="auto-awesome"
                          size={16}
                          color={colors.beeYellow}
                        />
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: isMobile ? 13 : 14,
                            color: isMobile ? colors.deepNavy : colors.warmGray,
                            textTransform: isMobile ? "none" : "uppercase",
                            marginLeft: 8,
                          }}
                        >
                          Skills
                        </Text>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                        }}
                      >
                        {selectedApplication.applicantSkills
                          .split(",")
                          .map((skill: string, idx: number) => (
                            <View
                              key={idx}
                              style={{
                                backgroundColor: colors.beeYellow + "20",
                                paddingHorizontal: 12,
                                paddingVertical: 6,
                                borderRadius: 16,
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 12,
                                  fontFamily: fonts.medium,
                                  color: colors.deepNavy,
                                }}
                              >
                                {skill.trim()}
                              </Text>
                            </View>
                          ))}
                      </View>
                    </View>
                  )}

                  {/* Experience */}
                  {selectedApplication.applicantExperience && (
                    <View
                      style={{
                        marginBottom: isMobile ? 16 : 24,
                        backgroundColor: isMobile
                          ? colors.lightGray
                          : "transparent",
                        borderRadius: 14,
                        padding: isMobile ? 14 : 0,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Icon
                          name="work-outline"
                          size={16}
                          color={colors.beeYellow}
                        />
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: isMobile ? 13 : 14,
                            color: isMobile ? colors.deepNavy : colors.warmGray,
                            textTransform: isMobile ? "none" : "uppercase",
                            marginLeft: 8,
                          }}
                        >
                          Experience
                        </Text>
                      </View>
                      <Text
                        style={{
                          fontFamily: fonts.regular,
                          fontSize: isMobile ? 13 : 14,
                          color: colors.warmGray,
                          lineHeight: isMobile ? 20 : 22,
                        }}
                      >
                        {selectedApplication.applicantExperience}
                      </Text>
                    </View>
                  )}

                  {/* Education */}
                  {selectedApplication.applicantEducation && (
                    <View
                      style={{
                        marginBottom: isMobile ? 16 : 24,
                        backgroundColor: isMobile
                          ? colors.lightGray
                          : "transparent",
                        borderRadius: 14,
                        padding: isMobile ? 14 : 0,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Icon
                          name="school"
                          size={16}
                          color={colors.beeYellow}
                        />
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: isMobile ? 13 : 14,
                            color: isMobile ? colors.deepNavy : colors.warmGray,
                            textTransform: isMobile ? "none" : "uppercase",
                            marginLeft: 8,
                          }}
                        >
                          Education
                        </Text>
                      </View>
                      <Text
                        style={{
                          fontFamily: fonts.regular,
                          fontSize: isMobile ? 13 : 14,
                          color: colors.warmGray,
                          lineHeight: isMobile ? 20 : 22,
                        }}
                      >
                        {selectedApplication.applicantEducation}
                      </Text>
                    </View>
                  )}

                  {/* Achievements */}
                  {selectedApplication.applicantAchievements && (
                    <View
                      style={{
                        marginBottom: isMobile ? 16 : 24,
                        backgroundColor: isMobile
                          ? colors.lightGray
                          : "transparent",
                        borderRadius: 14,
                        padding: isMobile ? 14 : 0,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Icon
                          name="emoji-events"
                          size={16}
                          color={colors.beeYellow}
                        />
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: isMobile ? 13 : 14,
                            color: isMobile ? colors.deepNavy : colors.warmGray,
                            textTransform: isMobile ? "none" : "uppercase",
                            marginLeft: 8,
                          }}
                        >
                          Achievements
                        </Text>
                      </View>
                      <Text
                        style={{
                          fontFamily: fonts.regular,
                          fontSize: isMobile ? 13 : 14,
                          color: colors.warmGray,
                          lineHeight: isMobile ? 20 : 22,
                        }}
                      >
                        {selectedApplication.applicantAchievements}
                      </Text>
                    </View>
                  )}

                  {/* Social & Professional Links */}
                  {(selectedApplication.applicantPortfolio ||
                    selectedApplication.applicantLinkedIn ||
                    selectedApplication.applicantGitHub ||
                    selectedApplication.applicantTwitter ||
                    selectedApplication.applicantInstagram) && (
                    <View
                      style={{
                        marginBottom: isMobile ? 16 : 24,
                        backgroundColor: isMobile
                          ? colors.lightGray
                          : "transparent",
                        borderRadius: 14,
                        padding: isMobile ? 14 : 0,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Icon name="share" size={16} color={colors.beeYellow} />
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: isMobile ? 13 : 14,
                            color: isMobile ? colors.deepNavy : colors.warmGray,
                            textTransform: isMobile ? "none" : "uppercase",
                            marginLeft: 8,
                          }}
                        >
                          Social & Professional Links
                        </Text>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                        }}
                      >
                        {selectedApplication.applicantLinkedIn && (
                          <TouchableOpacity
                            onPress={() => {
                              const url =
                                selectedApplication.applicantLinkedIn.startsWith(
                                  "http",
                                )
                                  ? selectedApplication.applicantLinkedIn
                                  : `https://${selectedApplication.applicantLinkedIn}`;
                              if (Platform.OS === "web") {
                                window.open(url, "_blank");
                              } else {
                                Linking.openURL(url);
                              }
                            }}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              backgroundColor: "#0A66C2" + "15",
                              paddingVertical: 8,
                              paddingHorizontal: 12,
                              borderRadius: 10,
                              gap: 6,
                            }}
                          >
                            <View
                              style={{
                                width: 22,
                                height: 22,
                                borderRadius: 5,
                                backgroundColor: "#0A66C2",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 10,
                                  fontFamily: fonts.bold,
                                  color: "#FFF",
                                }}
                              >
                                in
                              </Text>
                            </View>
                            <Text
                              style={{
                                fontFamily: fonts.medium,
                                fontSize: 12,
                                color: "#0A66C2",
                              }}
                            >
                              LinkedIn
                            </Text>
                          </TouchableOpacity>
                        )}
                        {selectedApplication.applicantGitHub && (
                          <TouchableOpacity
                            onPress={() => {
                              const url =
                                selectedApplication.applicantGitHub.startsWith(
                                  "http",
                                )
                                  ? selectedApplication.applicantGitHub
                                  : `https://${selectedApplication.applicantGitHub}`;
                              if (Platform.OS === "web") {
                                window.open(url, "_blank");
                              } else {
                                Linking.openURL(url);
                              }
                            }}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              backgroundColor: "#181717" + "12",
                              paddingVertical: 8,
                              paddingHorizontal: 12,
                              borderRadius: 10,
                              gap: 6,
                            }}
                          >
                            <View
                              style={{
                                width: 22,
                                height: 22,
                                borderRadius: 5,
                                backgroundColor: "#181717",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 10,
                                  fontFamily: fonts.bold,
                                  color: "#FFF",
                                }}
                              >
                                ⚡
                              </Text>
                            </View>
                            <Text
                              style={{
                                fontFamily: fonts.medium,
                                fontSize: 12,
                                color: "#181717",
                              }}
                            >
                              GitHub
                            </Text>
                          </TouchableOpacity>
                        )}
                        {selectedApplication.applicantPortfolio && (
                          <TouchableOpacity
                            onPress={() => {
                              const url =
                                selectedApplication.applicantPortfolio.startsWith(
                                  "http",
                                )
                                  ? selectedApplication.applicantPortfolio
                                  : `https://${selectedApplication.applicantPortfolio}`;
                              if (Platform.OS === "web") {
                                window.open(url, "_blank");
                              } else {
                                Linking.openURL(url);
                              }
                            }}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              backgroundColor: "#3B82F6" + "15",
                              paddingVertical: 8,
                              paddingHorizontal: 12,
                              borderRadius: 10,
                              gap: 6,
                            }}
                          >
                            <View
                              style={{
                                width: 22,
                                height: 22,
                                borderRadius: 5,
                                backgroundColor: "#3B82F6",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Icon name="language" size={12} color="#FFF" />
                            </View>
                            <Text
                              style={{
                                fontFamily: fonts.medium,
                                fontSize: 12,
                                color: "#3B82F6",
                              }}
                            >
                              Portfolio
                            </Text>
                          </TouchableOpacity>
                        )}
                        {selectedApplication.applicantTwitter && (
                          <TouchableOpacity
                            onPress={() => {
                              const url =
                                selectedApplication.applicantTwitter.startsWith(
                                  "http",
                                )
                                  ? selectedApplication.applicantTwitter
                                  : `https://${selectedApplication.applicantTwitter}`;
                              if (Platform.OS === "web") {
                                window.open(url, "_blank");
                              } else {
                                Linking.openURL(url);
                              }
                            }}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              backgroundColor: "#000000" + "10",
                              paddingVertical: 8,
                              paddingHorizontal: 12,
                              borderRadius: 10,
                              gap: 6,
                            }}
                          >
                            <View
                              style={{
                                width: 22,
                                height: 22,
                                borderRadius: 5,
                                backgroundColor: "#000000",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 10,
                                  fontFamily: fonts.bold,
                                  color: "#FFF",
                                }}
                              >
                                𝕏
                              </Text>
                            </View>
                            <Text
                              style={{
                                fontFamily: fonts.medium,
                                fontSize: 12,
                                color: "#000000",
                              }}
                            >
                              Twitter / X
                            </Text>
                          </TouchableOpacity>
                        )}
                        {selectedApplication.applicantInstagram && (
                          <TouchableOpacity
                            onPress={() => {
                              const url =
                                selectedApplication.applicantInstagram.startsWith(
                                  "http",
                                )
                                  ? selectedApplication.applicantInstagram
                                  : `https://${selectedApplication.applicantInstagram}`;
                              if (Platform.OS === "web") {
                                window.open(url, "_blank");
                              } else {
                                Linking.openURL(url);
                              }
                            }}
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              backgroundColor: "#E4405F" + "15",
                              paddingVertical: 8,
                              paddingHorizontal: 12,
                              borderRadius: 10,
                              gap: 6,
                            }}
                          >
                            <View
                              style={{
                                width: 22,
                                height: 22,
                                borderRadius: 5,
                                backgroundColor: "#E4405F",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Icon name="camera-alt" size={12} color="#FFF" />
                            </View>
                            <Text
                              style={{
                                fontFamily: fonts.medium,
                                fontSize: 12,
                                color: "#E4405F",
                              }}
                            >
                              Instagram
                            </Text>
                          </TouchableOpacity>
                        )}
                      </View>
                    </View>
                  )}

                  {/* Interested Tags */}
                  {selectedApplication.applicantInterestedTags &&
                    selectedApplication.applicantInterestedTags.length > 0 && (
                      <View
                        style={{
                          marginBottom: isMobile ? 16 : 24,
                          backgroundColor: isMobile
                            ? colors.lightGray
                            : "transparent",
                          borderRadius: 14,
                          padding: isMobile ? 14 : 0,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            marginBottom: 12,
                          }}
                        >
                          <Icon
                            name="sell"
                            size={16}
                            color={colors.beeYellow}
                          />
                          <Text
                            style={{
                              fontFamily: fonts.bold,
                              fontSize: isMobile ? 13 : 14,
                              color: isMobile
                                ? colors.deepNavy
                                : colors.warmGray,
                              textTransform: isMobile ? "none" : "uppercase",
                              marginLeft: 8,
                            }}
                          >
                            Interested In
                          </Text>
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 8,
                          }}
                        >
                          {selectedApplication.applicantInterestedTags.map(
                            (tag: string, idx: number) => (
                              <View
                                key={idx}
                                style={{
                                  backgroundColor: colors.softBlue + "15",
                                  paddingHorizontal: 12,
                                  paddingVertical: 6,
                                  borderRadius: 16,
                                  borderWidth: 1,
                                  borderColor: colors.softBlue + "30",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 12,
                                    fontFamily: fonts.medium,
                                    color: colors.softBlue,
                                  }}
                                >
                                  {tag}
                                </Text>
                              </View>
                            ),
                          )}
                        </View>
                      </View>
                    )}

                  {/* Cover Letter */}
                  {selectedApplication.coverLetter && (
                    <View
                      style={{
                        marginBottom: isMobile ? 16 : 24,
                        backgroundColor: isMobile
                          ? colors.lightGray
                          : "transparent",
                        borderRadius: 14,
                        padding: isMobile ? 14 : 0,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 12,
                        }}
                      >
                        <Icon
                          name="description"
                          size={16}
                          color={colors.beeYellow}
                        />
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: isMobile ? 13 : 14,
                            color: isMobile ? colors.deepNavy : colors.warmGray,
                            textTransform: isMobile ? "none" : "uppercase",
                            marginLeft: 8,
                          }}
                        >
                          Cover Letter
                        </Text>
                      </View>
                      <Text
                        style={{
                          fontFamily: fonts.regular,
                          fontSize: isMobile ? 13 : 14,
                          color: colors.deepNavy,
                          lineHeight: isMobile ? 20 : 22,
                        }}
                      >
                        {selectedApplication.coverLetter}
                      </Text>
                    </View>
                  )}

                  {/* Status Management */}
                  <View
                    style={{
                      marginBottom: isMobile ? 16 : 24,
                      backgroundColor: isMobile
                        ? colors.lightGray
                        : "transparent",
                      borderRadius: 14,
                      padding: isMobile ? 14 : 0,
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: 12,
                      }}
                    >
                      <Icon
                        name="swap-horiz"
                        size={16}
                        color={colors.beeYellow}
                      />
                      <Text
                        style={{
                          fontFamily: fonts.bold,
                          fontSize: isMobile ? 13 : 14,
                          color: isMobile ? colors.deepNavy : colors.warmGray,
                          textTransform: isMobile ? "none" : "uppercase",
                          marginLeft: 8,
                        }}
                      >
                        Update Status
                      </Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: 8,
                      }}
                    >
                      {[
                        "pending",
                        "reviewed",
                        "shortlisted",
                        "accepted",
                        "rejected",
                      ].map((status) => {
                        const isActive = selectedApplication.status === status;
                        const statusColor = getStatusColor(status);
                        return (
                          <TouchableOpacity
                            key={status}
                            disabled={updatingStatus}
                            onPress={() =>
                              handleStatusChange(selectedApplication.id, status)
                            }
                            style={{
                              paddingVertical: isMobile ? 8 : 10,
                              paddingHorizontal: isMobile ? 12 : 16,
                              borderRadius: isMobile ? 10 : 8,
                              backgroundColor: isActive
                                ? statusColor
                                : colors.white,
                              borderWidth: 1,
                              borderColor: statusColor,
                              opacity: updatingStatus ? 0.6 : 1,
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 4,
                            }}
                          >
                            {isMobile && (
                              <Icon
                                name={getStatusIcon(status)}
                                size={14}
                                color={isActive ? colors.white : statusColor}
                              />
                            )}
                            <Text
                              style={{
                                fontFamily: fonts.medium,
                                fontSize: isMobile ? 12 : 13,
                                color: isActive ? colors.white : statusColor,
                                textTransform: "capitalize",
                              }}
                            >
                              {status}
                            </Text>
                          </TouchableOpacity>
                        );
                      })}
                    </View>
                  </View>

                  {/* Notes */}
                  <View
                    style={{
                      backgroundColor: isMobile
                        ? colors.lightGray
                        : "transparent",
                      borderRadius: 14,
                      padding: isMobile ? 14 : 0,
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: 12,
                      }}
                    >
                      <Icon
                        name="edit-note"
                        size={16}
                        color={colors.beeYellow}
                      />
                      <Text
                        style={{
                          fontFamily: fonts.bold,
                          fontSize: isMobile ? 13 : 14,
                          color: isMobile ? colors.deepNavy : colors.warmGray,
                          textTransform: isMobile ? "none" : "uppercase",
                          marginLeft: 8,
                        }}
                      >
                        Internal Notes
                      </Text>
                    </View>
                    <TextInput
                      style={{
                        borderWidth: 1,
                        borderColor: colors.warmGray + "30",
                        borderRadius: isMobile ? 12 : 8,
                        padding: 12,
                        fontFamily: fonts.regular,
                        fontSize: isMobile ? 13 : 14,
                        color: colors.deepNavy,
                        minHeight: isMobile ? 80 : 100,
                        textAlignVertical: "top",
                        backgroundColor: colors.white,
                      }}
                      multiline
                      placeholder="Add notes about this applicant..."
                      placeholderTextColor={colors.warmGray}
                      value={selectedApplication.notes || ""}
                      onChangeText={(text) =>
                        setSelectedApplication({
                          ...selectedApplication,
                          notes: text,
                        })
                      }
                    />
                    <TouchableOpacity
                      onPress={() =>
                        handleAddNote(
                          selectedApplication.id,
                          selectedApplication.notes || "",
                        )
                      }
                      style={{
                        marginTop: 12,
                        backgroundColor: colors.beeYellow,
                        paddingVertical: isMobile ? 14 : 12,
                        paddingHorizontal: 20,
                        borderRadius: isMobile ? 12 : 8,
                        alignItems: "center",
                        flexDirection: "row",
                        justifyContent: "center",
                        gap: 8,
                      }}
                    >
                      <Icon name="save" size={18} color={colors.deepNavy} />
                      <Text
                        style={{
                          fontFamily: fonts.bold,
                          fontSize: 14,
                          color: colors.deepNavy,
                        }}
                      >
                        Save Notes
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              </ScrollView>
            </View>
          </View>
        </Modal>
      )}

      {/* FAB - Filter Applications (Mobile only) */}
      {isMobile && (
        <TouchableOpacity
          style={[
            styles.fab,
            styles.fabSmall,
            { backgroundColor: colors.beeYellow },
          ]}
          onPress={() => {
            // Cycle through filter options
            const statuses = [
              "all",
              "pending",
              "reviewed",
              "shortlisted",
              "accepted",
              "rejected",
            ];
            const currentIndex = statuses.indexOf(filterStatus);
            const nextIndex = (currentIndex + 1) % statuses.length;
            setFilterStatus(statuses[nextIndex]);
          }}
          activeOpacity={0.8}
        >
          <Icon name="filter-list" size={24} color={colors.deepNavy} />
        </TouchableOpacity>
      )}
    </View>
  );
}

// Company Applicants Screen
function CompanyApplicantsScreen({
  route,
  navigation,
  isDarkMode,
  toggleTheme,
  colors,
  currentLanguage = "en",
}: any) {
  const { jobId } = route.params || {};
  const { showAlert: showAppAlert } = useAppAlert();
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [job, setJob] = useState<any>(null);
  const [applications, setApplications] = useState<any[]>([]);
  const [filteredApplications, setFilteredApplications] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState<string>("all");
  const [selectedApplication, setSelectedApplication] = useState<any>(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState<"date" | "name" | "status">("date");
  const user = auth.currentUser;

  useEffect(() => {
    loadJobAndApplications();
  }, [jobId]);

  useEffect(() => {
    // Filter and search applications
    let filtered = applications;

    // Filter by status
    if (filterStatus !== "all") {
      filtered = filtered.filter((app) => app.status === filterStatus);
    }

    // Search by name or email
    if (searchText.trim()) {
      const search = searchText.toLowerCase();
      filtered = filtered.filter(
        (app) =>
          app.applicantName?.toLowerCase().includes(search) ||
          app.applicantEmail?.toLowerCase().includes(search),
      );
    }

    // Sort applications
    if (sortBy === "date") {
      filtered = filtered.sort((a, b) => {
        const dateA = a.appliedAt?.toDate ? a.appliedAt.toDate() : new Date(0);
        const dateB = b.appliedAt?.toDate ? b.appliedAt.toDate() : new Date(0);
        return dateB.getTime() - dateA.getTime();
      });
    } else if (sortBy === "name") {
      filtered = filtered.sort((a, b) =>
        (a.applicantName || "").localeCompare(b.applicantName || ""),
      );
    } else if (sortBy === "status") {
      const statusOrder = {
        accepted: 0,
        shortlisted: 1,
        reviewed: 2,
        pending: 3,
        rejected: 4,
      };
      filtered = filtered.sort(
        (a, b) => (statusOrder[a.status] || 99) - (statusOrder[b.status] || 99),
      );
    }

    setFilteredApplications(filtered);
  }, [filterStatus, applications, searchText, sortBy]);

  const loadJobAndApplications = async () => {
    try {
      setLoading(true);

      // Load job details
      const jobDoc = await getDoc(doc(db, "jobs", jobId));
      if (!jobDoc.exists()) {
        showAppAlert(
          "error",
          "Job Not Found",
          "The job you are looking for could not be found.",
          { onClose: () => navigation.goBack() },
        );
        return;
      }

      const jobData = { id: jobDoc.id, ...jobDoc.data() };

      // Verify ownership
      if (jobData.companyId !== user?.uid && jobData.createdBy !== user?.uid) {
        navigation.replace("Unauthorized");
        return;
      }

      setJob(jobData);

      // Load applications
      const applicationsQuery = dbQuery(
        collection(db, "applications"),
        where("jobId", "==", jobId),
        orderBy("appliedAt", "desc"),
      );
      const snapshot = await getDocs(applicationsQuery);
      const applicationsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setApplications(applicationsData);
      setFilteredApplications(applicationsData);
    } catch (error) {
      console.error("Error loading applications:", error);
      showAppAlert(
        "error",
        "Loading Failed",
        "Failed to load applications. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (
    applicationId: string,
    newStatus: string,
  ) => {
    try {
      setUpdatingStatus(true);

      // Update Firestore
      await updateDoc(doc(db, "applications", applicationId), {
        status: newStatus,
        updatedAt: new Date(),
      });

      // Find the application to get applicant details
      const application = applications.find((app) => app.id === applicationId);

      // Update local state
      setApplications((prev) =>
        prev.map((app) =>
          app.id === applicationId
            ? { ...app, status: newStatus, updatedAt: new Date() }
            : app,
        ),
      );

      if (selectedApplication?.id === applicationId) {
        setSelectedApplication({ ...selectedApplication, status: newStatus });
      }

      // When accepted: close the job posting so no more applications are accepted
      if (newStatus === "accepted" && application && job) {
        try {
          await updateDoc(doc(db, "jobs", job.id), {
            isActive: false,
            closedAt: new Date(),
            closedReason: "applicant_accepted",
          });
          setJob((prev: any) => (prev ? { ...prev, isActive: false } : prev));
        } catch (closeErr) {
          console.error("Error closing job posting:", closeErr);
        }
      }

      // Send email + push notification for accepted or rejected status
      if (
        (newStatus === "accepted" || newStatus === "rejected") &&
        application
      ) {
        try {
          const notifyApplicationStatusChange = httpsCallable(
            functions,
            "notifyApplicationStatusChange",
          );
          await notifyApplicationStatusChange({
            applicantId: application.applicantId,
            applicantEmail: application.applicantEmail,
            applicantName: application.applicantName,
            jobTitle: job?.title || "Position",
            companyName: job?.companyName || job?.company || "Company",
            status: newStatus,
          });
          console.log(`Email notification sent for ${newStatus} status`);
        } catch (emailError) {
          console.error("Error sending email notification:", emailError);
        }
      }

      const statusLabels: Record<string, string> = {
        reviewed: "Reviewed",
        shortlisted: "Shortlisted",
        accepted: "Accepted",
        rejected: "Rejected",
      };
      const statusLabel = statusLabels[newStatus] || newStatus;
      const alertType =
        newStatus === "accepted"
          ? "success"
          : newStatus === "rejected"
          ? "warning"
          : "info";
      showAppAlert(
        alertType as AlertType,
        `Application ${statusLabel}`,
        `Application status updated to ${statusLabel}.${
          newStatus === "accepted" ? " The job posting has been closed." : ""
        }`,
      );
    } catch (error) {
      console.error("Error updating status:", error);
      showAppAlert(
        "error",
        "Update Failed",
        "Failed to update application status. Please try again.",
      );
    } finally {
      setUpdatingStatus(false);
    }
  };

  const handleAddNote = async (applicationId: string, note: string) => {
    try {
      await updateDoc(doc(db, "applications", applicationId), {
        notes: note,
        updatedAt: new Date(),
      });

      // Update local state
      setApplications((prev) =>
        prev.map((app) =>
          app.id === applicationId ? { ...app, notes: note } : app,
        ),
      );

      if (selectedApplication?.id === applicationId) {
        setSelectedApplication({ ...selectedApplication, notes: note });
      }

      showAppAlert(
        "success",
        "Note Saved",
        "Your note has been saved successfully.",
      );
    } catch (error) {
      console.error("Error adding note:", error);
      showAppAlert(
        "error",
        "Save Failed",
        "Failed to save note. Please try again.",
      );
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "pending":
        return colors.warmGray;
      case "reviewed":
        return colors.softBlue;
      case "shortlisted":
        return colors.beeYellow;
      case "accepted":
        return colors.success;
      case "rejected":
        return colors.danger;
      default:
        return colors.warmGray;
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case "pending":
        return "schedule";
      case "reviewed":
        return "visibility";
      case "shortlisted":
        return "star";
      case "accepted":
        return "check-circle";
      case "rejected":
        return "cancel";
      default:
        return "help";
    }
  };

  const statusOptions = [
    "pending",
    "reviewed",
    "shortlisted",
    "accepted",
    "rejected",
  ];

  return (
    <View
      style={[styles.screenContainer, { backgroundColor: colors.lightGray }]}
    >
      {/* Header */}
      <View style={[styles.screenHeader, { backgroundColor: colors.white }]}>
        <TouchableOpacity
          onPress={() => navigation.goBack()}
          style={styles.backButton}
        >
          <Icon name="arrow-back" size={24} color={colors.deepNavy} />
        </TouchableOpacity>
        <View style={{ flex: 1 }}>
          <Text style={[styles.screenTitle, { color: colors.deepNavy }]}>
            Applications
          </Text>
          {job && (
            <Text style={[styles.screenSubtitle, { color: colors.warmGray }]}>
              {job.title} • {applications.length}{" "}
              {applications.length === 1 ? "applicant" : "applicants"}
            </Text>
          )}
        </View>
      </View>

      {/* Search and Sort Bar */}
      <View
        style={[
          styles.applicantsSearchContainer,
          { backgroundColor: colors.white },
        ]}
      >
        <View
          style={[
            styles.applicantsSearchBar,
            { backgroundColor: colors.lightGray },
          ]}
        >
          <Icon name="search" size={20} color={colors.warmGray} />
          <TextInput
            style={[styles.applicantsSearchInput, { color: colors.deepNavy }]}
            placeholder="Search by name or email..."
            placeholderTextColor={colors.warmGray}
            value={searchText}
            onChangeText={setSearchText}
          />
          {searchText ? (
            <TouchableOpacity onPress={() => setSearchText("")}>
              <Icon name="close" size={20} color={colors.warmGray} />
            </TouchableOpacity>
          ) : null}
        </View>

        <View style={styles.applicantsSortContainer}>
          <Text
            style={[styles.applicantsSortLabel, { color: colors.warmGray }]}
          >
            Sort:
          </Text>
          <TouchableOpacity
            style={[
              styles.applicantsSortButton,
              sortBy === "date" && { backgroundColor: colors.cream },
            ]}
            onPress={() => setSortBy("date")}
          >
            <Icon
              name="schedule"
              size={16}
              color={sortBy === "date" ? colors.beeYellow : colors.warmGray}
            />
            <Text
              style={[
                styles.applicantsSortText,
                {
                  color: sortBy === "date" ? colors.beeYellow : colors.warmGray,
                },
              ]}
            >
              Date
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[
              styles.applicantsSortButton,
              sortBy === "name" && { backgroundColor: colors.cream },
            ]}
            onPress={() => setSortBy("name")}
          >
            <Icon
              name="sort-by-alpha"
              size={16}
              color={sortBy === "name" ? colors.beeYellow : colors.warmGray}
            />
            <Text
              style={[
                styles.applicantsSortText,
                {
                  color: sortBy === "name" ? colors.beeYellow : colors.warmGray,
                },
              ]}
            >
              Name
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[
              styles.applicantsSortButton,
              sortBy === "status" && { backgroundColor: colors.cream },
            ]}
            onPress={() => setSortBy("status")}
          >
            <Icon
              name="filter-list"
              size={16}
              color={sortBy === "status" ? colors.beeYellow : colors.warmGray}
            />
            <Text
              style={[
                styles.applicantsSortText,
                {
                  color:
                    sortBy === "status" ? colors.beeYellow : colors.warmGray,
                },
              ]}
            >
              Status
            </Text>
          </TouchableOpacity>
        </View>
      </View>

      {/* Filter Tabs */}
      <View
        style={[
          styles.applicantsFilterContainer,
          { backgroundColor: colors.white },
        ]}
      >
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          <TouchableOpacity
            style={[
              styles.applicantsFilterTab,
              filterStatus === "all" && { backgroundColor: colors.beeYellow },
            ]}
            onPress={() => setFilterStatus("all")}
          >
            <Text
              style={[
                styles.applicantsFilterTabText,
                {
                  color:
                    filterStatus === "all" ? colors.deepNavy : colors.warmGray,
                },
              ]}
            >
              {t.statusAll} ({applications.length})
            </Text>
          </TouchableOpacity>
          {statusOptions.map((status) => {
            const count = applications.filter(
              (app) => app.status === status,
            ).length;
            return (
              <TouchableOpacity
                key={status}
                style={[
                  styles.applicantsFilterTab,
                  filterStatus === status && {
                    backgroundColor: colors.beeYellow,
                  },
                ]}
                onPress={() => setFilterStatus(status)}
              >
                <Icon
                  name={getStatusIcon(status)}
                  size={16}
                  color={
                    filterStatus === status ? colors.deepNavy : colors.warmGray
                  }
                />
                <Text
                  style={[
                    styles.applicantsFilterTabText,
                    {
                      color:
                        filterStatus === status
                          ? colors.deepNavy
                          : colors.warmGray,
                    },
                  ]}
                >
                  {status === "pending"
                    ? t.statusPending
                    : status === "reviewed"
                    ? t.statusReviewed
                    : status === "shortlisted"
                    ? t.statusShortlisted
                    : status === "accepted"
                    ? t.statusAccepted
                    : status === "rejected"
                    ? t.statusRejected
                    : status.charAt(0).toUpperCase() + status.slice(1)}{" "}
                  ({count})
                </Text>
              </TouchableOpacity>
            );
          })}
        </ScrollView>
      </View>

      {/* Content */}
      {loading ? (
        <InlineLoadingIndicator
          message="Loading applications..."
          isDarkMode={isDarkMode}
        />
      ) : filteredApplications.length === 0 ? (
        <View style={{ padding: 20, alignItems: "center", marginTop: 100 }}>
          <Icon name="people-outline" size={64} color={colors.warmGray} />
          <Text
            style={{
              fontSize: 18,
              fontFamily: fonts.semiBold,
              color: colors.deepNavy,
              marginTop: 16,
            }}
          >
            {t.noApplicationsYet}
          </Text>
          <Text
            style={{
              fontSize: 14,
              fontFamily: fonts.regular,
              color: colors.warmGray,
              textAlign: "center",
              marginTop: 8,
            }}
          >
            {filterStatus === "all"
              ? "Applications will appear here when candidates apply for this position."
              : `No applications with status "${filterStatus}".`}
          </Text>
        </View>
      ) : (
        <ScrollView style={{ padding: 16 }}>
          {filteredApplications.map((application) => (
            <TouchableOpacity
              key={application.id}
              style={[styles.applicantCard, { backgroundColor: colors.white }]}
              onPress={() => {
                setSelectedApplication(application);
                setShowDetailModal(true);
              }}
            >
              {/* Applicant Header */}
              <View style={styles.applicantHeader}>
                {application.applicantPhotoURL ? (
                  <Image
                    source={{ uri: application.applicantPhotoURL }}
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 22,
                      backgroundColor: colors.lightGray,
                    }}
                  />
                ) : (
                  <View
                    style={[
                      styles.applicantAvatar,
                      { backgroundColor: colors.cream },
                    ]}
                  >
                    <Text
                      style={[
                        styles.applicantAvatarText,
                        { color: colors.beeYellow },
                      ]}
                    >
                      {application.applicantName?.charAt(0).toUpperCase() ||
                        "A"}
                    </Text>
                  </View>
                )}
                <View style={{ flex: 1 }}>
                  <Text
                    style={[styles.applicantName, { color: colors.deepNavy }]}
                  >
                    {application.applicantName}
                  </Text>
                  <Text
                    style={[styles.applicantEmail, { color: colors.warmGray }]}
                  >
                    {application.applicantJobTitle
                      ? `${application.applicantJobTitle}${
                          application.applicantCompany
                            ? ` at ${application.applicantCompany}`
                            : ""
                        }`
                      : application.applicantEmail}
                  </Text>
                </View>
                <View
                  style={[
                    styles.applicantStatusBadge,
                    {
                      backgroundColor:
                        getStatusColor(application.status) + "20",
                    },
                  ]}
                >
                  <Icon
                    name={getStatusIcon(application.status)}
                    size={14}
                    color={getStatusColor(application.status)}
                  />
                  <Text
                    style={[
                      styles.applicantStatusText,
                      { color: getStatusColor(application.status) },
                    ]}
                  >
                    {application.status.charAt(0).toUpperCase() +
                      application.status.slice(1)}
                  </Text>
                </View>
              </View>

              {/* Applicant Details */}
              <View style={styles.applicantDetails}>
                {application.applicantPhone && (
                  <View style={styles.applicantDetailRow}>
                    <Icon name="phone" size={14} color={colors.warmGray} />
                    <Text
                      style={[
                        styles.applicantDetailText,
                        { color: colors.warmGray },
                      ]}
                    >
                      {application.applicantPhone}
                    </Text>
                  </View>
                )}
                {application.applicantAddress && (
                  <View style={styles.applicantDetailRow}>
                    <Icon
                      name="location-on"
                      size={14}
                      color={colors.warmGray}
                    />
                    <Text
                      style={[
                        styles.applicantDetailText,
                        { color: colors.warmGray },
                      ]}
                      numberOfLines={1}
                    >
                      {application.applicantAddress}
                    </Text>
                  </View>
                )}
              </View>

              {/* Skills Preview */}
              {application.applicantSkills && (
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: 4,
                    marginBottom: 8,
                  }}
                >
                  {application.applicantSkills
                    .split(",")
                    .slice(0, 3)
                    .map((skill: string, idx: number) => (
                      <View
                        key={idx}
                        style={{
                          backgroundColor: colors.beeYellow + "15",
                          paddingHorizontal: 8,
                          paddingVertical: 3,
                          borderRadius: 10,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.medium,
                            color: colors.deepNavy,
                          }}
                        >
                          {skill.trim()}
                        </Text>
                      </View>
                    ))}
                  {application.applicantSkills.split(",").length > 3 && (
                    <View
                      style={{
                        backgroundColor: colors.lightGray,
                        paddingHorizontal: 8,
                        paddingVertical: 3,
                        borderRadius: 10,
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.medium,
                          color: colors.warmGray,
                        }}
                      >
                        +{application.applicantSkills.split(",").length - 3}
                      </Text>
                    </View>
                  )}
                </View>
              )}

              {/* Links */}
              {(application.applicantPortfolio ||
                application.applicantLinkedIn ||
                application.applicantGitHub ||
                application.resumeUrl) && (
                <View style={styles.applicantLinks}>
                  {application.resumeUrl && (
                    <TouchableOpacity
                      style={[
                        styles.applicantLinkBadge,
                        { backgroundColor: colors.cream },
                      ]}
                      onPress={(e) => {
                        e.stopPropagation();
                        if (Platform.OS === "web") {
                          window.open(application.resumeUrl, "_blank");
                        } else {
                          Linking.openURL(application.resumeUrl);
                        }
                      }}
                    >
                      <Icon
                        name="description"
                        size={12}
                        color={colors.beeYellow}
                      />
                      <Text
                        style={[
                          styles.applicantLinkText,
                          { color: colors.deepNavy },
                        ]}
                      >
                        Resume
                      </Text>
                      <Icon
                        name="open-in-new"
                        size={10}
                        color={colors.deepNavy}
                      />
                    </TouchableOpacity>
                  )}
                  {application.applicantPortfolio && (
                    <View
                      style={[
                        styles.applicantLinkBadge,
                        { backgroundColor: colors.lightGray },
                      ]}
                    >
                      <Icon name="language" size={12} color={colors.warmGray} />
                      <Text
                        style={[
                          styles.applicantLinkText,
                          { color: colors.warmGray },
                        ]}
                      >
                        Portfolio
                      </Text>
                    </View>
                  )}
                  {application.applicantLinkedIn && (
                    <View
                      style={[
                        styles.applicantLinkBadge,
                        { backgroundColor: colors.lightGray },
                      ]}
                    >
                      <Icon name="work" size={12} color={colors.warmGray} />
                      <Text
                        style={[
                          styles.applicantLinkText,
                          { color: colors.warmGray },
                        ]}
                      >
                        LinkedIn
                      </Text>
                    </View>
                  )}
                  {application.applicantGitHub && (
                    <View
                      style={[
                        styles.applicantLinkBadge,
                        { backgroundColor: colors.lightGray },
                      ]}
                    >
                      <Icon name="code" size={12} color={colors.warmGray} />
                      <Text
                        style={[
                          styles.applicantLinkText,
                          { color: colors.warmGray },
                        ]}
                      >
                        GitHub
                      </Text>
                    </View>
                  )}
                </View>
              )}

              {/* Footer */}
              <View
                style={[
                  styles.applicantFooter,
                  { borderTopColor: colors.lightGray },
                ]}
              >
                <View style={styles.applicantFooterLeft}>
                  <Icon name="schedule" size={12} color={colors.warmGray} />
                  <Text
                    style={[styles.applicantDate, { color: colors.warmGray }]}
                  >
                    Applied{" "}
                    {application.appliedAt?.toDate
                      ? new Date(
                          application.appliedAt.toDate(),
                        ).toLocaleDateString()
                      : "Recently"}
                  </Text>
                </View>
                <TouchableOpacity
                  style={[
                    styles.applicantViewButton,
                    { backgroundColor: colors.beeYellow },
                  ]}
                  onPress={() => {
                    setSelectedApplication(application);
                    setShowDetailModal(true);
                  }}
                >
                  <Text
                    style={[
                      styles.applicantViewButtonText,
                      { color: colors.deepNavy },
                    ]}
                  >
                    View Details
                  </Text>
                  <Icon
                    name="arrow-forward"
                    size={14}
                    color={colors.deepNavy}
                  />
                </TouchableOpacity>
              </View>
            </TouchableOpacity>
          ))}
        </ScrollView>
      )}

      {/* Application Detail Modal */}
      <Modal
        visible={showDetailModal}
        animationType="slide"
        transparent={true}
        onRequestClose={() => setShowDetailModal(false)}
      >
        <View style={styles.applicantModalOverlay}>
          <View
            style={[
              styles.applicantModalContainer,
              { backgroundColor: colors.white },
            ]}
          >
            {selectedApplication && (
              <ScrollView>
                {/* Modal Header with Avatar */}
                <View
                  style={[
                    styles.applicantModalHeader,
                    { backgroundColor: colors.cream },
                  ]}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      flex: 1,
                      gap: 14,
                    }}
                  >
                    {selectedApplication.applicantPhotoURL ? (
                      <Image
                        source={{ uri: selectedApplication.applicantPhotoURL }}
                        style={{
                          width: 52,
                          height: 52,
                          borderRadius: 26,
                          backgroundColor: colors.lightGray,
                        }}
                      />
                    ) : (
                      <View
                        style={{
                          width: 52,
                          height: 52,
                          borderRadius: 26,
                          backgroundColor: colors.beeYellow + "30",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 22,
                            fontFamily: fonts.bold,
                            color: colors.beeYellow,
                          }}
                        >
                          {selectedApplication.applicantName
                            ?.charAt(0)
                            .toUpperCase() || "A"}
                        </Text>
                      </View>
                    )}
                    <View style={{ flex: 1 }}>
                      <Text
                        style={[
                          styles.applicantModalTitle,
                          { color: colors.deepNavy },
                        ]}
                      >
                        {selectedApplication.applicantName}
                      </Text>
                      {selectedApplication.applicantJobTitle ? (
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: fonts.medium,
                            color: colors.warmGray,
                          }}
                        >
                          {selectedApplication.applicantJobTitle}
                          {selectedApplication.applicantCompany
                            ? ` at ${selectedApplication.applicantCompany}`
                            : ""}
                        </Text>
                      ) : (
                        <Text
                          style={[
                            styles.applicantModalSubtitle,
                            { color: colors.warmGray },
                          ]}
                        >
                          {selectedApplication.applicantEmail}
                        </Text>
                      )}
                    </View>
                  </View>
                  <TouchableOpacity onPress={() => setShowDetailModal(false)}>
                    <Icon name="close" size={24} color={colors.deepNavy} />
                  </TouchableOpacity>
                </View>

                {/* Professional Overview */}
                {(selectedApplication.applicantJobTitle ||
                  selectedApplication.applicantExperience ||
                  selectedApplication.applicantCompany) && (
                  <View
                    style={[
                      styles.applicantModalSection,
                      { backgroundColor: colors.cream + "60" },
                    ]}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: 12,
                      }}
                    >
                      {selectedApplication.applicantJobTitle && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <Icon
                            name="badge"
                            size={16}
                            color={colors.beeYellow}
                          />
                          <Text
                            style={{
                              fontSize: 14,
                              fontFamily: fonts.medium,
                              color: colors.deepNavy,
                            }}
                          >
                            {selectedApplication.applicantJobTitle}
                          </Text>
                        </View>
                      )}
                      {selectedApplication.applicantCompany && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <Icon
                            name="business"
                            size={16}
                            color={colors.beeYellow}
                          />
                          <Text
                            style={{
                              fontSize: 14,
                              fontFamily: fonts.medium,
                              color: colors.deepNavy,
                            }}
                          >
                            {selectedApplication.applicantCompany}
                          </Text>
                        </View>
                      )}
                      {selectedApplication.applicantExperience && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <Icon
                            name="work-history"
                            size={16}
                            color={colors.beeYellow}
                          />
                          <Text
                            style={{
                              fontSize: 14,
                              fontFamily: fonts.medium,
                              color: colors.deepNavy,
                            }}
                          >
                            {selectedApplication.applicantExperience} experience
                          </Text>
                        </View>
                      )}
                      {selectedApplication.applicantAddress && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <Icon
                            name="location-on"
                            size={16}
                            color={colors.beeYellow}
                          />
                          <Text
                            style={{
                              fontSize: 14,
                              fontFamily: fonts.medium,
                              color: colors.deepNavy,
                            }}
                          >
                            {selectedApplication.applicantAddress}
                          </Text>
                        </View>
                      )}
                    </View>
                  </View>
                )}

                {/* Status Section */}
                <View style={styles.applicantModalSection}>
                  <Text
                    style={[
                      styles.applicantModalSectionTitle,
                      { color: colors.deepNavy },
                    ]}
                  >
                    Application Status
                  </Text>
                  <View style={styles.applicantStatusButtons}>
                    {statusOptions.map((status) => (
                      <TouchableOpacity
                        key={status}
                        style={[
                          styles.applicantStatusButton,
                          {
                            backgroundColor:
                              selectedApplication.status === status
                                ? getStatusColor(status)
                                : colors.lightGray,
                          },
                        ]}
                        onPress={() =>
                          handleStatusChange(selectedApplication.id, status)
                        }
                        disabled={updatingStatus}
                      >
                        <Icon
                          name={getStatusIcon(status)}
                          size={16}
                          color={
                            selectedApplication.status === status
                              ? colors.white
                              : colors.warmGray
                          }
                        />
                        <Text
                          style={[
                            styles.applicantStatusButtonText,
                            {
                              color:
                                selectedApplication.status === status
                                  ? colors.white
                                  : colors.warmGray,
                            },
                          ]}
                        >
                          {status.charAt(0).toUpperCase() + status.slice(1)}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                </View>

                {/* Resume / CV Section */}
                {selectedApplication.resumeUrl && (
                  <View style={styles.applicantModalSection}>
                    <Text
                      style={[
                        styles.applicantModalSectionTitle,
                        { color: colors.deepNavy },
                      ]}
                    >
                      Resume / CV
                    </Text>
                    <View style={{ flexDirection: "row", gap: 10 }}>
                      <TouchableOpacity
                        style={{
                          flex: 1,
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 8,
                          backgroundColor: colors.beeYellow,
                          paddingVertical: 12,
                          borderRadius: 10,
                        }}
                        onPress={() => {
                          if (Platform.OS === "web") {
                            window.open(
                              selectedApplication.resumeUrl,
                              "_blank",
                            );
                          } else {
                            Linking.openURL(selectedApplication.resumeUrl);
                          }
                        }}
                      >
                        <Icon
                          name="visibility"
                          size={18}
                          color={colors.deepNavy}
                        />
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: fonts.semiBold,
                            color: colors.deepNavy,
                          }}
                        >
                          View CV
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={{
                          flex: 1,
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 8,
                          backgroundColor: colors.lightGray,
                          paddingVertical: 12,
                          borderRadius: 10,
                        }}
                        onPress={() => {
                          if (Platform.OS === "web") {
                            const a = document.createElement("a");
                            a.href = selectedApplication.resumeUrl;
                            a.download = `${
                              selectedApplication.applicantName?.replace(
                                /\s+/g,
                                "_",
                              ) || "applicant"
                            }_CV`;
                            a.target = "_blank";
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                          } else {
                            Linking.openURL(selectedApplication.resumeUrl);
                          }
                        }}
                      >
                        <Icon
                          name="file-download"
                          size={18}
                          color={colors.deepNavy}
                        />
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: fonts.semiBold,
                            color: colors.deepNavy,
                          }}
                        >
                          Download
                        </Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                )}

                {/* About / Bio */}
                {selectedApplication.applicantBio && (
                  <View style={styles.applicantModalSection}>
                    <Text
                      style={[
                        styles.applicantModalSectionTitle,
                        { color: colors.deepNavy },
                      ]}
                    >
                      About
                    </Text>
                    <Text
                      style={{
                        fontSize: 15,
                        lineHeight: 22,
                        fontFamily: fonts.regular,
                        color: colors.warmGray,
                      }}
                    >
                      {selectedApplication.applicantBio}
                    </Text>
                  </View>
                )}

                {/* Skills */}
                {selectedApplication.applicantSkills && (
                  <View style={styles.applicantModalSection}>
                    <Text
                      style={[
                        styles.applicantModalSectionTitle,
                        { color: colors.deepNavy },
                      ]}
                    >
                      Skills
                    </Text>
                    <View
                      style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}
                    >
                      {selectedApplication.applicantSkills
                        .split(",")
                        .map((skill: string, idx: number) => (
                          <View
                            key={idx}
                            style={{
                              backgroundColor: colors.beeYellow + "20",
                              paddingHorizontal: 12,
                              paddingVertical: 6,
                              borderRadius: 16,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.medium,
                                color: colors.deepNavy,
                              }}
                            >
                              {skill.trim()}
                            </Text>
                          </View>
                        ))}
                    </View>
                  </View>
                )}

                {/* Experience */}
                {selectedApplication.applicantExperience && (
                  <View style={styles.applicantModalSection}>
                    <Text
                      style={[
                        styles.applicantModalSectionTitle,
                        { color: colors.deepNavy },
                      ]}
                    >
                      <Icon
                        name="work-outline"
                        size={16}
                        color={colors.deepNavy}
                      />{" "}
                      Experience
                    </Text>
                    <Text
                      style={{
                        fontSize: 15,
                        lineHeight: 22,
                        fontFamily: fonts.regular,
                        color: colors.warmGray,
                      }}
                    >
                      {selectedApplication.applicantExperience}
                    </Text>
                  </View>
                )}

                {/* Education */}
                {selectedApplication.applicantEducation && (
                  <View style={styles.applicantModalSection}>
                    <Text
                      style={[
                        styles.applicantModalSectionTitle,
                        { color: colors.deepNavy },
                      ]}
                    >
                      <Icon name="school" size={16} color={colors.deepNavy} />{" "}
                      Education
                    </Text>
                    <Text
                      style={{
                        fontSize: 15,
                        lineHeight: 22,
                        fontFamily: fonts.regular,
                        color: colors.warmGray,
                      }}
                    >
                      {selectedApplication.applicantEducation}
                    </Text>
                  </View>
                )}

                {/* Achievements */}
                {selectedApplication.applicantAchievements && (
                  <View style={styles.applicantModalSection}>
                    <Text
                      style={[
                        styles.applicantModalSectionTitle,
                        { color: colors.deepNavy },
                      ]}
                    >
                      <Icon
                        name="emoji-events"
                        size={16}
                        color={colors.deepNavy}
                      />{" "}
                      Achievements
                    </Text>
                    <Text
                      style={{
                        fontSize: 15,
                        lineHeight: 22,
                        fontFamily: fonts.regular,
                        color: colors.warmGray,
                      }}
                    >
                      {selectedApplication.applicantAchievements}
                    </Text>
                  </View>
                )}

                {/* Contact Information */}
                <View style={styles.applicantModalSection}>
                  <Text
                    style={[
                      styles.applicantModalSectionTitle,
                      { color: colors.deepNavy },
                    ]}
                  >
                    Contact Information
                  </Text>
                  <TouchableOpacity
                    style={styles.applicantModalInfoRow}
                    onPress={() => {
                      if (Platform.OS === "web") {
                        window.open(
                          `mailto:${selectedApplication.applicantEmail}`,
                          "_blank",
                        );
                      } else {
                        Linking.openURL(
                          `mailto:${selectedApplication.applicantEmail}`,
                        );
                      }
                    }}
                  >
                    <Icon name="email" size={18} color={colors.beeYellow} />
                    <Text
                      style={[
                        styles.applicantModalInfoText,
                        { color: colors.softBlue },
                      ]}
                    >
                      {selectedApplication.applicantEmail}
                    </Text>
                    <Icon
                      name="open-in-new"
                      size={12}
                      color={colors.softBlue}
                    />
                  </TouchableOpacity>
                  {selectedApplication.applicantPhone && (
                    <TouchableOpacity
                      style={styles.applicantModalInfoRow}
                      onPress={() => {
                        if (Platform.OS === "web") {
                          window.open(
                            `tel:${selectedApplication.applicantPhone}`,
                            "_blank",
                          );
                        } else {
                          Linking.openURL(
                            `tel:${selectedApplication.applicantPhone}`,
                          );
                        }
                      }}
                    >
                      <Icon name="phone" size={18} color={colors.beeYellow} />
                      <Text
                        style={[
                          styles.applicantModalInfoText,
                          { color: colors.softBlue },
                        ]}
                      >
                        {selectedApplication.applicantPhone}
                      </Text>
                      <Icon
                        name="open-in-new"
                        size={12}
                        color={colors.softBlue}
                      />
                    </TouchableOpacity>
                  )}
                  {selectedApplication.applicantAddress && (
                    <View style={styles.applicantModalInfoRow}>
                      <Icon
                        name="location-on"
                        size={18}
                        color={colors.beeYellow}
                      />
                      <Text
                        style={[
                          styles.applicantModalInfoText,
                          { color: colors.warmGray },
                        ]}
                      >
                        {selectedApplication.applicantAddress}
                      </Text>
                    </View>
                  )}
                </View>

                {/* Social & Professional Links */}
                {(selectedApplication.applicantPortfolio ||
                  selectedApplication.applicantLinkedIn ||
                  selectedApplication.applicantGitHub ||
                  selectedApplication.applicantTwitter ||
                  selectedApplication.applicantInstagram) && (
                  <View style={styles.applicantModalSection}>
                    <Text
                      style={[
                        styles.applicantModalSectionTitle,
                        { color: colors.deepNavy },
                      ]}
                    >
                      Social & Professional Links
                    </Text>
                    {selectedApplication.applicantLinkedIn && (
                      <TouchableOpacity
                        style={styles.applicantModalLinkRow}
                        onPress={() => {
                          const url =
                            selectedApplication.applicantLinkedIn.startsWith(
                              "http",
                            )
                              ? selectedApplication.applicantLinkedIn
                              : `https://${selectedApplication.applicantLinkedIn}`;
                          if (Platform.OS === "web") {
                            window.open(url, "_blank");
                          } else {
                            Linking.openURL(url);
                          }
                        }}
                      >
                        <View
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: 8,
                            backgroundColor: "#0A66C2",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.bold,
                              color: "#FFF",
                            }}
                          >
                            in
                          </Text>
                        </View>
                        <Text
                          style={[
                            styles.applicantModalLinkText,
                            { color: colors.softBlue },
                          ]}
                        >
                          LinkedIn
                        </Text>
                        <Icon
                          name="open-in-new"
                          size={14}
                          color={colors.softBlue}
                        />
                      </TouchableOpacity>
                    )}
                    {selectedApplication.applicantGitHub && (
                      <TouchableOpacity
                        style={styles.applicantModalLinkRow}
                        onPress={() => {
                          const url =
                            selectedApplication.applicantGitHub.startsWith(
                              "http",
                            )
                              ? selectedApplication.applicantGitHub
                              : `https://${selectedApplication.applicantGitHub}`;
                          if (Platform.OS === "web") {
                            window.open(url, "_blank");
                          } else {
                            Linking.openURL(url);
                          }
                        }}
                      >
                        <View
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: 8,
                            backgroundColor: "#181717",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.bold,
                              color: "#FFF",
                            }}
                          >
                            ⚡
                          </Text>
                        </View>
                        <Text
                          style={[
                            styles.applicantModalLinkText,
                            { color: colors.softBlue },
                          ]}
                        >
                          GitHub
                        </Text>
                        <Icon
                          name="open-in-new"
                          size={14}
                          color={colors.softBlue}
                        />
                      </TouchableOpacity>
                    )}
                    {selectedApplication.applicantPortfolio && (
                      <TouchableOpacity
                        style={styles.applicantModalLinkRow}
                        onPress={() => {
                          const url =
                            selectedApplication.applicantPortfolio.startsWith(
                              "http",
                            )
                              ? selectedApplication.applicantPortfolio
                              : `https://${selectedApplication.applicantPortfolio}`;
                          if (Platform.OS === "web") {
                            window.open(url, "_blank");
                          } else {
                            Linking.openURL(url);
                          }
                        }}
                      >
                        <View
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: 8,
                            backgroundColor: "#3B82F6",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon name="language" size={16} color="#FFF" />
                        </View>
                        <Text
                          style={[
                            styles.applicantModalLinkText,
                            { color: colors.softBlue },
                          ]}
                        >
                          Portfolio
                        </Text>
                        <Icon
                          name="open-in-new"
                          size={14}
                          color={colors.softBlue}
                        />
                      </TouchableOpacity>
                    )}
                    {selectedApplication.applicantTwitter && (
                      <TouchableOpacity
                        style={styles.applicantModalLinkRow}
                        onPress={() => {
                          const url =
                            selectedApplication.applicantTwitter.startsWith(
                              "http",
                            )
                              ? selectedApplication.applicantTwitter
                              : `https://${selectedApplication.applicantTwitter}`;
                          if (Platform.OS === "web") {
                            window.open(url, "_blank");
                          } else {
                            Linking.openURL(url);
                          }
                        }}
                      >
                        <View
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: 8,
                            backgroundColor: "#000000",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.bold,
                              color: "#FFF",
                            }}
                          >
                            𝕏
                          </Text>
                        </View>
                        <Text
                          style={[
                            styles.applicantModalLinkText,
                            { color: colors.softBlue },
                          ]}
                        >
                          Twitter / X
                        </Text>
                        <Icon
                          name="open-in-new"
                          size={14}
                          color={colors.softBlue}
                        />
                      </TouchableOpacity>
                    )}
                    {selectedApplication.applicantInstagram && (
                      <TouchableOpacity
                        style={styles.applicantModalLinkRow}
                        onPress={() => {
                          const url =
                            selectedApplication.applicantInstagram.startsWith(
                              "http",
                            )
                              ? selectedApplication.applicantInstagram
                              : `https://${selectedApplication.applicantInstagram}`;
                          if (Platform.OS === "web") {
                            window.open(url, "_blank");
                          } else {
                            Linking.openURL(url);
                          }
                        }}
                      >
                        <View
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: 8,
                            backgroundColor: "#E4405F",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon name="camera-alt" size={16} color="#FFF" />
                        </View>
                        <Text
                          style={[
                            styles.applicantModalLinkText,
                            { color: colors.softBlue },
                          ]}
                        >
                          Instagram
                        </Text>
                        <Icon
                          name="open-in-new"
                          size={14}
                          color={colors.softBlue}
                        />
                      </TouchableOpacity>
                    )}
                  </View>
                )}

                {/* Interested Tags */}
                {selectedApplication.applicantInterestedTags &&
                  selectedApplication.applicantInterestedTags.length > 0 && (
                    <View style={styles.applicantModalSection}>
                      <Text
                        style={[
                          styles.applicantModalSectionTitle,
                          { color: colors.deepNavy },
                        ]}
                      >
                        Interested In
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                        }}
                      >
                        {selectedApplication.applicantInterestedTags.map(
                          (tag: string, idx: number) => (
                            <View
                              key={idx}
                              style={{
                                backgroundColor: colors.softBlue + "15",
                                paddingHorizontal: 12,
                                paddingVertical: 6,
                                borderRadius: 16,
                                borderWidth: 1,
                                borderColor: colors.softBlue + "30",
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 13,
                                  fontFamily: fonts.medium,
                                  color: colors.softBlue,
                                }}
                              >
                                {tag}
                              </Text>
                            </View>
                          ),
                        )}
                      </View>
                    </View>
                  )}

                {/* Cover Letter */}
                {selectedApplication.coverLetter && (
                  <View style={styles.applicantModalSection}>
                    <Text
                      style={[
                        styles.applicantModalSectionTitle,
                        { color: colors.deepNavy },
                      ]}
                    >
                      Cover Letter
                    </Text>
                    <Text
                      style={[
                        styles.applicantModalCoverLetter,
                        { color: colors.warmGray },
                      ]}
                    >
                      {selectedApplication.coverLetter}
                    </Text>
                  </View>
                )}

                {/* Notes Section */}
                <View style={styles.applicantModalSection}>
                  <Text
                    style={[
                      styles.applicantModalSectionTitle,
                      { color: colors.deepNavy },
                    ]}
                  >
                    Internal Notes
                  </Text>
                  <TextInput
                    style={[
                      styles.applicantModalNotesInput,
                      {
                        backgroundColor: colors.lightGray,
                        color: colors.deepNavy,
                        borderColor: colors.warmGray,
                      },
                    ]}
                    placeholder="Add notes about this applicant (visible only to your company)..."
                    placeholderTextColor={colors.warmGray}
                    multiline
                    numberOfLines={4}
                    value={selectedApplication.notes || ""}
                    onChangeText={(text) =>
                      setSelectedApplication({
                        ...selectedApplication,
                        notes: text,
                      })
                    }
                  />
                  <TouchableOpacity
                    style={[
                      styles.applicantModalSaveNotesButton,
                      { backgroundColor: colors.beeYellow },
                    ]}
                    onPress={() =>
                      handleAddNote(
                        selectedApplication.id,
                        selectedApplication.notes || "",
                      )
                    }
                  >
                    <Icon name="save" size={16} color={colors.deepNavy} />
                    <Text
                      style={[
                        styles.applicantModalSaveNotesButtonText,
                        { color: colors.deepNavy },
                      ]}
                    >
                      Save Notes
                    </Text>
                  </TouchableOpacity>
                </View>

                {/* Application Date */}
                <View
                  style={[
                    styles.applicantModalFooter,
                    { borderTopColor: colors.lightGray },
                  ]}
                >
                  <Icon name="schedule" size={14} color={colors.warmGray} />
                  <Text
                    style={[
                      styles.applicantModalDate,
                      { color: colors.warmGray },
                    ]}
                  >
                    Applied on{" "}
                    {selectedApplication.appliedAt?.toDate
                      ? new Date(
                          selectedApplication.appliedAt.toDate(),
                        ).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      : "Unknown"}
                  </Text>
                </View>
              </ScrollView>
            )}
          </View>
        </View>
      </Modal>
    </View>
  );
}

// Company Posted Jobs Content
function CompanyPostedJobsContent({
  colors,
  companyId,
  navigation,
  isDarkMode,
  t,
}: any) {
  const [jobs, setJobs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingJob, setEditingJob] = useState<any>(null);
  const [saving, setSaving] = useState(false);
  const [companyData, setCompanyData] = useState<any>(null);
  const [upgradeModal, setUpgradeModal] = useState<{
    visible: boolean;
    featureLabel?: string;
  }>({ visible: false });

  // Responsive dimensions
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;
  const isTablet = dimensions.width >= 768 && dimensions.width < 1024;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  // Form fields
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [contractType, setContractType] = useState("Full-time");
  const [location, setLocation] = useState("");
  const [salary, setSalary] = useState("");
  const [description, setDescription] = useState("");
  const [requirements, setRequirements] = useState("");
  const [responsibilities, setResponsibilities] = useState("");
  const [isRemote, setIsRemote] = useState(false);
  const [tags, setTags] = useState<string[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [availableTags, setAvailableTags] = useState<string[]>([]);
  const [validationErrors, setValidationErrors] = useState<{
    [key: string]: string;
  }>({});
  const scrollViewRef = React.useRef<any>(null);

  // Confirmation modal state
  const [confirmationModal, setConfirmationModal] = useState({
    visible: false,
    title: "",
    message: "",
    onConfirm: () => {},
    confirmText: "Confirm",
    cancelText: "Cancel",
    isDestructive: false,
  });

  // Alert modal state (for non-confirmation alerts)
  const [alertModal, setAlertModal] = useState({
    visible: false,
    title: "",
    message: "",
  });

  const showConfirmation = (
    title: string,
    message: string,
    onConfirm: () => void,
    options?: {
      confirmText?: string;
      cancelText?: string;
      isDestructive?: boolean;
    },
  ) => {
    setConfirmationModal({
      visible: true,
      title,
      message,
      onConfirm,
      confirmText: options?.confirmText || "Confirm",
      cancelText: options?.cancelText || "Cancel",
      isDestructive: options?.isDestructive || false,
    });
  };

  const showAlert = (title: string, message: string) => {
    setAlertModal({
      visible: true,
      title,
      message,
    });
  };

  useEffect(() => {
    loadCompanyData();
    loadJobs();
    loadCategories();
  }, [companyId]);

  const postPermission = useSubscriptionPermissions(
    companyData?.subscriptionPlan || companyData?.subscriptionId,
  );

  useEffect(() => {
    // Update available tags when category changes
    if (category) {
      const selectedCategory = categories.find((cat) => cat.name === category);
      if (selectedCategory && selectedCategory.tags) {
        setAvailableTags(selectedCategory.tags);
      } else {
        setAvailableTags([]);
      }
    } else {
      setAvailableTags([]);
    }
  }, [category, categories]);

  const loadCategories = async () => {
    try {
      const categoriesQuery = collection(db, "categories");
      const snapshot = await getDocs(categoriesQuery);
      const categoriesData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(categoriesData);
    } catch (error) {
      console.error("Error loading categories:", error);
    }
  };

  const loadCompanyData = async () => {
    try {
      if (!companyId) return;
      const userDoc = await getDoc(doc(db, "users", companyId));
      if (userDoc.exists()) {
        setCompanyData(userDoc.data());
      }
    } catch (error) {
      console.error("Error loading company data:", error);
    }
  };

  const loadJobs = async () => {
    try {
      setLoading(true);
      const jobsQuery = dbQuery(
        collection(db, "jobs"),
        where("companyId", "==", companyId),
        where("deleted", "!=", true),
        orderBy("deleted"),
        orderBy("createdAt", "desc"),
      );
      const snapshot = await getDocs(jobsQuery);
      const jobsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Fetch real application counts from the applications collection
      const jobsWithCounts = await Promise.all(
        jobsData.map(async (job: any) => {
          try {
            const appsQuery = dbQuery(
              collection(db, "applications"),
              where("jobId", "==", job.id),
            );
            const appsSnapshot = await getDocs(appsQuery);
            return { ...job, applicationCount: appsSnapshot.size };
          } catch {
            return job;
          }
        }),
      );

      setJobs(jobsWithCounts);
    } catch (error) {
      console.error("Error loading jobs:", error);
    } finally {
      setLoading(false);
    }
  };

  const openCreateModal = () => {
    if (!postPermission.hasPermission("canCreateJobs")) {
      setUpgradeModal({ visible: true, featureLabel: "Post Job Listings" });
      return;
    }
    resetForm();
    setEditingJob(null);
    setShowCreateModal(true);
  };

  const openEditModal = (job: any) => {
    setEditingJob(job);
    setTitle(job.title || "");
    setCategory(job.category || "");
    setContractType(job.contractType || "Full-time");
    setLocation(job.location || "");
    setSalary(job.salary || "");
    setDescription(job.description || "");
    setRequirements(job.requirements || "");
    setResponsibilities(job.responsibilities || "");
    setIsRemote(job.isRemote || false);
    setTags(job.tags || []);
    setShowCreateModal(true);
  };

  const resetForm = () => {
    setTitle("");
    setCategory("");
    setContractType("Full-time");
    setLocation("");
    setSalary("");
    setDescription("");
    setRequirements("");
    setResponsibilities("");
    setIsRemote(false);
    setTags([]);
    setValidationErrors({});
  };

  const validateForm = () => {
    const errors: { [key: string]: string } = {};

    if (!title.trim()) {
      errors.title = t.cdJobTitleRequired;
    }

    if (!category) {
      errors.category = t.cdCategoryRequired;
    }

    if (!location.trim()) {
      errors.location = t.cdLocationRequired;
    }

    if (tags.length === 0) {
      errors.tags = t.cdSkillsRequired;
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    // Validate form
    if (!validateForm()) {
      // Scroll to top to show validation errors
      if (scrollViewRef.current) {
        scrollViewRef.current.scrollTo({ y: 0, animated: true });
      }

      // Show alert with first error
      const firstError =
        Object.values(validationErrors)[0] ||
        "Please fill in all required fields";
      alert("Validation Error: " + firstError);
      return;
    }

    try {
      setSaving(true);
      const jobData = {
        title,
        company: companyData?.companyProfile?.companyName || "Unknown Company",
        companyId,
        createdBy: companyId, // Add for security rules compatibility
        category,
        contractType,
        location,
        salary,
        description,
        requirements,
        responsibilities,
        isRemote,
        tags: tags,
        jobSource: "company",
        postedDate: editingJob?.postedDate || new Date(),
        createdAt: editingJob ? editingJob.createdAt : new Date(),
        updatedAt: new Date(),
        deleted: editingJob?.deleted || false, // Preserve deleted status or set to false
        isActive:
          editingJob?.isActive !== undefined ? editingJob.isActive : true, // Preserve active status or set to true for new jobs
      };

      if (editingJob) {
        // Update existing job
        await updateDoc(doc(db, "jobs", editingJob.id), jobData);
        showAlert("Success", t.cdJobUpdated);
      } else {
        // Create new job
        await addDoc(collection(db, "jobs"), jobData);
        showAlert("Success", t.cdJobPosted);
      }

      setShowCreateModal(false);
      resetForm();
      loadJobs();
    } catch (error) {
      console.error("Error saving job:", error);
      showAlert("Error", "Failed to save job. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (jobId: string) => {
    showConfirmation(
      t.cdDeleteJobPosting,
      t.cdDeleteJobConfirm,
      async () => {
        try {
          // Verify job ownership before deletion
          const jobDoc = await getDoc(doc(db, "jobs", jobId));
          if (!jobDoc.exists()) {
            showAlert("Error", "Job not found.");
            return;
          }

          const jobData = jobDoc.data();
          if (
            jobData.companyId !== companyId &&
            jobData.createdBy !== companyId
          ) {
            showAlert(
              "Error",
              "You can only delete jobs created by your company.",
            );
            return;
          }

          await updateDoc(doc(db, "jobs", jobId), {
            deleted: true,
            deletedAt: new Date(),
          });
          showAlert("Success", "Job deleted successfully!");
          loadJobs();
        } catch (error) {
          console.error("Error deleting job:", error);
          showAlert("Error", "Failed to delete job. Please try again.");
        }
      },
      { confirmText: "Delete", cancelText: "Cancel", isDestructive: true },
    );
  };

  const handleToggleActive = async (jobId: string, currentStatus: boolean) => {
    try {
      await updateDoc(doc(db, "jobs", jobId), {
        isActive: !currentStatus,
        updatedAt: new Date(),
      });
      showAlert(
        "Success",
        `Job ${!currentStatus ? "activated" : "deactivated"} successfully!`,
      );
      loadJobs();
    } catch (error) {
      console.error("Error toggling job status:", error);
      showAlert("Error", "Failed to update job status. Please try again.");
    }
  };

  const categoryNames = categories.map((cat) => cat.name).filter(Boolean);
  const fallbackCategories = [
    "Technology",
    "Finance",
    "Healthcare",
    "Education",
    "Retail",
    "Manufacturing",
    "Construction",
    "Agriculture",
    "Transportation",
    "Hospitality",
    "Real Estate",
    "Media & Entertainment",
    "Consulting",
    "Marketing",
    "Sales",
    "Customer Service",
    "Other",
  ];
  const categoryOptions =
    categoryNames.length > 0 ? categoryNames : fallbackCategories;

  const contractTypes = [
    "Full-time",
    "Part-time",
    "Contract",
    "Temporary",
    "Internship",
    "Freelance",
  ];

  // Get job stats
  const isDark = colors.lightGray === "#1F2937";
  const bg = isDark ? "#0F1117" : "#F3F4F6";
  const card = isDark ? "#1A1D23" : "#FFFFFF";
  const txt = isDark ? "#F9FAFB" : "#0F172A";
  const muted = isDark ? "#6B7280" : "#9CA3AF";
  const border = isDark ? "#252932" : "#F0F0F0";

  const activeJobsCount = jobs.filter((job) => job.isActive !== false).length;
  const inactiveJobsCount = jobs.filter((job) => job.isActive === false).length;

  return (
    <View style={{ flex: 1, backgroundColor: bg }}>
      <SubscriptionUpgradeModal
        visible={upgradeModal.visible}
        featureLabel={upgradeModal.featureLabel}
        currentPlan={
          companyData?.subscriptionPlan || companyData?.subscriptionId
        }
        onClose={() => setUpgradeModal({ visible: false })}
        navigation={navigation}
        isDarkMode={isDarkMode}
      />

      {/* ── Header ── */}
      {isMobile ? (
        /* Mobile: compact strip */
        <View
          style={{
            backgroundColor: isDark ? "#111318" : "#FFFFFF",
            paddingHorizontal: 16,
            paddingTop: 12,
            paddingBottom: 12,
            borderBottomWidth: 1,
            borderBottomColor: border,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TouchableOpacity
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 6,
              backgroundColor: "#10B98118",
              paddingHorizontal: 14,
              paddingVertical: 8,
              borderRadius: 20,
              borderWidth: 1,
              borderColor: "#10B98130",
            }}
            onPress={openCreateModal}
          >
            <Icon name="add" size={16} color="#10B981" />
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.semiBold,
                color: "#10B981",
              }}
            >
              {t.postJobButton}
            </Text>
          </TouchableOpacity>
          <View style={{ flexDirection: "row", gap: 8 }}>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 4,
                backgroundColor: "#10B98118",
                paddingHorizontal: 10,
                paddingVertical: 5,
                borderRadius: 20,
                borderWidth: 1,
                borderColor: "#10B98130",
              }}
            >
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.bold,
                  color: "#10B981",
                }}
              >
                {activeJobsCount}
              </Text>
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: fonts.medium,
                  color: "#10B981",
                }}
              >
                active
              </Text>
            </View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 4,
                backgroundColor: isDark ? "#252932" : "#F3F4F6",
                paddingHorizontal: 10,
                paddingVertical: 5,
                borderRadius: 20,
              }}
            >
              <Text
                style={{ fontSize: 14, fontFamily: fonts.bold, color: txt }}
              >
                {jobs.length}
              </Text>
              <Text
                style={{ fontSize: 11, fontFamily: fonts.medium, color: muted }}
              >
                total
              </Text>
            </View>
          </View>
        </View>
      ) : (
        /* Desktop: existing header with stats row */
        <View style={{ backgroundColor: colors.white, padding: 32 }}>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 16,
            }}
          >
            <View>
              <Text
                style={{
                  fontSize: 28,
                  fontFamily: fonts.bold,
                  color: colors.deepNavy,
                  marginBottom: 4,
                }}
              >
                Job Postings
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.regular,
                  color: colors.warmGray,
                }}
              >
                {t.cdManageJobListings}
              </Text>
            </View>
            <TouchableOpacity
              style={{
                backgroundColor: "#374151",
                flexDirection: "row",
                alignItems: "center",
                paddingHorizontal: 20,
                paddingVertical: 12,
                borderRadius: 12,
                gap: 8,
              }}
              onPress={openCreateModal}
            >
              <Icon name="add" size={20} color="#FFFFFF" />
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.semiBold,
                  color: "#FFFFFF",
                }}
              >
                {t.cdCreateJob}
              </Text>
            </TouchableOpacity>
          </View>
          <View style={{ flexDirection: "row", gap: 12 }}>
            <View
              style={{
                flex: 1,
                backgroundColor: isDark ? "#1F2937" : "#F3F4F6",
                paddingHorizontal: 16,
                paddingVertical: 12,
                borderRadius: 12,
              }}
            >
              <Text
                style={{ fontSize: 24, fontFamily: fonts.bold, color: txt }}
              >
                {jobs.length}
              </Text>
              <Text
                style={{ fontSize: 12, fontFamily: fonts.medium, color: muted }}
              >
                {t.cdTotal}
              </Text>
            </View>
            <View
              style={{
                flex: 1,
                backgroundColor: "#ECFDF5",
                paddingHorizontal: 16,
                paddingVertical: 12,
                borderRadius: 12,
              }}
            >
              <Text
                style={{
                  fontSize: 24,
                  fontFamily: fonts.bold,
                  color: "#10B981",
                }}
              >
                {activeJobsCount}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.medium,
                  color: "#059669",
                }}
              >
                {t.cdActive}
              </Text>
            </View>
            {inactiveJobsCount > 0 && (
              <View
                style={{
                  flex: 1,
                  backgroundColor: "#FEF2F2",
                  paddingHorizontal: 16,
                  paddingVertical: 12,
                  borderRadius: 12,
                }}
              >
                <Text
                  style={{
                    fontSize: 24,
                    fontFamily: fonts.bold,
                    color: "#EF4444",
                  }}
                >
                  {inactiveJobsCount}
                </Text>
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.medium,
                    color: "#DC2626",
                  }}
                >
                  {t.cdPaused}
                </Text>
              </View>
            )}
          </View>
        </View>
      )}

      {loading ? (
        <InlineLoadingIndicator
          message={t.cdLoadingJobs}
          isDarkMode={isDarkMode}
        />
      ) : jobs.length === 0 ? (
        <View
          style={{
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
            padding: isMobile ? 32 : 48,
          }}
        >
          <View
            style={{
              width: isMobile ? 64 : 80,
              height: isMobile ? 64 : 80,
              borderRadius: isMobile ? 32 : 40,
              backgroundColor: "#3B82F614",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: isMobile ? 14 : 20,
            }}
          >
            <Icon
              name="work-outline"
              size={isMobile ? 32 : 40}
              color="#3B82F6"
            />
          </View>
          <Text
            style={{
              fontSize: isMobile ? 18 : 20,
              fontFamily: fonts.bold,
              color: txt,
              marginBottom: isMobile ? 8 : 8,
              textAlign: "center",
            }}
          >
            {t.cdNoJobsYet}
          </Text>
          <Text
            style={{
              fontSize: isMobile ? 13 : 14,
              fontFamily: fonts.regular,
              color: muted,
              marginBottom: isMobile ? 20 : 24,
              textAlign: "center",
              maxWidth: 300,
              lineHeight: isMobile ? 20 : 22,
            }}
          >
            {t.cdFirstJobPostingDesc}
          </Text>
          <TouchableOpacity
            style={{
              backgroundColor: "#3B82F6",
              paddingHorizontal: isMobile ? 28 : 24,
              paddingVertical: 12,
              borderRadius: 12,
            }}
            onPress={openCreateModal}
            activeOpacity={0.8}
          >
            <Text
              style={{
                fontSize: isMobile ? 14 : 14,
                fontFamily: fonts.semiBold,
                color: "#FFFFFF",
              }}
            >
              {t.cdCreateFirstJob}
            </Text>
          </TouchableOpacity>
        </View>
      ) : (
        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={{
            padding: isMobile ? 12 : 32,
            paddingBottom: isMobile ? 100 : 32,
            gap: isMobile ? 10 : 16,
          }}
          showsVerticalScrollIndicator={false}
        >
          {jobs.map((job) => {
            const isActive = job.isActive !== false;
            const applicantCount = job.applicationCount || 0;
            const postedDate = job.createdAt?.toDate
              ? new Date(job.createdAt.toDate())
              : null;
            const formattedDate = postedDate
              ? postedDate.toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                })
              : "";

            return (
              <TouchableOpacity
                key={job.id}
                activeOpacity={0.75}
                onPress={() => openEditModal(job)}
                style={
                  isMobile
                    ? {
                        backgroundColor: card,
                        borderRadius: 16,
                        padding: 14,
                        borderWidth: 1,
                        borderColor: border,
                        ...(Platform.OS === "web"
                          ? {
                              boxShadow: isDark
                                ? "0 2px 8px rgba(0,0,0,0.3)"
                                : "0 2px 8px rgba(0,0,0,0.06)",
                            }
                          : { elevation: 2 }),
                      }
                    : {
                        backgroundColor: colors.white,
                        borderRadius: 16,
                        padding: 24,
                        shadowColor: "#000",
                        shadowOffset: { width: 0, height: 1 },
                        shadowOpacity: 0.05,
                        shadowRadius: 3,
                        elevation: 2,
                      }
                }
              >
                {isMobile ? (
                  /* ── Mobile card ── */
                  <>
                    {/* Title row + status */}
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        marginBottom: 10,
                      }}
                    >
                      <View style={{ flex: 1, marginRight: 10 }}>
                        <Text
                          style={{
                            fontSize: 16,
                            fontFamily: fonts.bold,
                            color: txt,
                            lineHeight: 22,
                          }}
                          numberOfLines={2}
                        >
                          {job.title}
                        </Text>
                        {job.category && (
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: muted,
                              marginTop: 2,
                            }}
                          >
                            {job.category}
                          </Text>
                        )}
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 5,
                          backgroundColor: isActive ? "#10B98118" : "#EF444418",
                          paddingHorizontal: 10,
                          paddingVertical: 5,
                          borderRadius: 20,
                          borderWidth: 1,
                          borderColor: isActive ? "#10B98130" : "#EF444430",
                        }}
                      >
                        <View
                          style={{
                            width: 6,
                            height: 6,
                            borderRadius: 3,
                            backgroundColor: isActive ? "#10B981" : "#EF4444",
                          }}
                        />
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.semiBold,
                            color: isActive ? "#10B981" : "#EF4444",
                          }}
                        >
                          {isActive ? t.cdActive : t.cdPaused}
                        </Text>
                      </View>
                    </View>
                    {/* Meta row */}
                    <View
                      style={{
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: 10,
                        marginBottom: 12,
                        paddingBottom: 12,
                        borderBottomWidth: 1,
                        borderBottomColor: border,
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <Icon name="location-on" size={13} color={muted} />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.regular,
                            color: muted,
                          }}
                        >
                          {job.location || "Remote"}
                        </Text>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <Icon name="schedule" size={13} color={muted} />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.regular,
                            color: muted,
                          }}
                        >
                          {job.contractType}
                        </Text>
                      </View>
                      {job.salary && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 5,
                          }}
                        >
                          <Icon name="payments" size={13} color="#3B82F6" />
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: txt,
                            }}
                          >
                            {job.salary}
                          </Text>
                        </View>
                      )}
                      {formattedDate && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 5,
                          }}
                        >
                          <Icon name="calendar-today" size={13} color={muted} />
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.regular,
                              color: muted,
                            }}
                          >
                            Posted {formattedDate}
                          </Text>
                        </View>
                      )}
                    </View>
                    {/* Footer: applicants + actions */}
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                          backgroundColor: "#6366F118",
                          paddingHorizontal: 10,
                          paddingVertical: 6,
                          borderRadius: 10,
                        }}
                      >
                        <Icon name="people" size={15} color="#6366F1" />
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: fonts.bold,
                            color: "#6366F1",
                          }}
                        >
                          {applicantCount}
                        </Text>
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.medium,
                            color: "#818CF8",
                          }}
                        >
                          {applicantCount === 1 ? "Applicant" : "Applicants"}
                        </Text>
                      </View>
                      <View style={{ flexDirection: "row", gap: 8 }}>
                        <TouchableOpacity
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: 10,
                            backgroundColor: isActive
                              ? "#EF444418"
                              : "#10B98118",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onPress={(e) => {
                            e.stopPropagation?.();
                            handleToggleActive(job.id, isActive);
                          }}
                          activeOpacity={0.7}
                        >
                          <Icon
                            name={isActive ? "pause" : "play-arrow"}
                            size={18}
                            color={isActive ? "#EF4444" : "#10B981"}
                          />
                        </TouchableOpacity>
                        <TouchableOpacity
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: 10,
                            backgroundColor: isDark ? "#252932" : "#F3F4F6",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onPress={(e) => {
                            e.stopPropagation?.();
                            handleDelete(job.id);
                          }}
                          activeOpacity={0.7}
                        >
                          <Icon name="delete-outline" size={18} color={muted} />
                        </TouchableOpacity>
                        <TouchableOpacity
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: 10,
                            backgroundColor: "#6366F118",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onPress={() => openEditModal(job)}
                          activeOpacity={0.7}
                        >
                          <Icon name="edit" size={18} color="#6366F1" />
                        </TouchableOpacity>
                      </View>
                    </View>
                  </>
                ) : (
                  /* ── Desktop card (original layout) ── */
                  <>
                    {/* Header Row */}
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "flex-start",
                        justifyContent: "space-between",
                        marginBottom: 16,
                      }}
                    >
                      <View style={{ flex: 1, marginRight: 12 }}>
                        <Text
                          style={{
                            fontSize: 18,
                            fontFamily: fonts.bold,
                            color: colors.deepNavy,
                            marginBottom: 6,
                            lineHeight: 24,
                          }}
                        >
                          {job.title}
                        </Text>
                        {job.category && (
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.medium,
                              color: colors.warmGray,
                            }}
                          >
                            {job.category}
                          </Text>
                        )}
                      </View>
                      <View
                        style={{
                          backgroundColor: isActive ? "#ECFDF5" : "#FEF2F2",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <View
                            style={{
                              width: 6,
                              height: 6,
                              borderRadius: 3,
                              backgroundColor: isActive ? "#10B981" : "#EF4444",
                            }}
                          />
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.semiBold,
                              color: isActive ? "#059669" : "#DC2626",
                            }}
                          >
                            {isActive ? t.cdActive : t.cdPaused}
                          </Text>
                        </View>
                      </View>
                    </View>
                    {/* Meta Info Grid */}
                    <View
                      style={{
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: 16,
                        marginBottom: 16,
                        paddingBottom: 16,
                        borderBottomWidth: 1,
                        borderBottomColor: isDark ? "#374151" : "#E5E7EB",
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <Icon name="location-on" size={16} color="#6B7280" />
                        <Text
                          style={{
                            fontSize: 13,
                            fontFamily: fonts.regular,
                            color: colors.warmGray,
                          }}
                        >
                          {job.location || "Remote"}
                        </Text>
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        <Icon name="schedule" size={16} color="#6B7280" />
                        <Text
                          style={{
                            fontSize: 13,
                            fontFamily: fonts.regular,
                            color: colors.warmGray,
                          }}
                        >
                          {job.contractType}
                        </Text>
                      </View>
                      {job.salary && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <Icon name="payments" size={16} color="#3B82F6" />
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.medium,
                              color: colors.deepNavy,
                            }}
                          >
                            {job.salary}
                          </Text>
                        </View>
                      )}
                      {formattedDate && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <Icon
                            name="calendar-today"
                            size={16}
                            color="#6B7280"
                          />
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.regular,
                              color: colors.warmGray,
                            }}
                          >
                            Posted {formattedDate}
                          </Text>
                        </View>
                      )}
                    </View>
                    {/* Footer Row */}
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          backgroundColor: "#EEF2FF",
                          paddingHorizontal: 12,
                          paddingVertical: 8,
                          borderRadius: 10,
                          gap: 8,
                        }}
                      >
                        <Icon name="people" size={18} color="#6366F1" />
                        <View>
                          <Text
                            style={{
                              fontSize: 16,
                              fontFamily: fonts.bold,
                              color: "#6366F1",
                            }}
                          >
                            {applicantCount}
                          </Text>
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.medium,
                              color: "#818CF8",
                            }}
                          >
                            {applicantCount === 1
                              ? t.cdApplicants
                              : t.cdApplicants}
                          </Text>
                        </View>
                      </View>
                      <View style={{ flexDirection: "row", gap: 8 }}>
                        <TouchableOpacity
                          style={{
                            backgroundColor: isActive ? "#FEF2F2" : "#ECFDF5",
                            width: 40,
                            height: 40,
                            borderRadius: 10,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onPress={(e) => {
                            e.stopPropagation();
                            handleToggleActive(job.id, isActive);
                          }}
                        >
                          <Icon
                            name={isActive ? "pause" : "play-arrow"}
                            size={20}
                            color={isActive ? "#EF4444" : "#10B981"}
                          />
                        </TouchableOpacity>
                        <TouchableOpacity
                          style={{
                            backgroundColor: isDark ? "#374151" : "#F3F4F6",
                            width: 40,
                            height: 40,
                            borderRadius: 10,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onPress={(e) => {
                            e.stopPropagation();
                            handleDelete(job.id);
                          }}
                        >
                          <Icon
                            name="delete-outline"
                            size={20}
                            color="#6B7280"
                          />
                        </TouchableOpacity>
                        <TouchableOpacity
                          style={{
                            backgroundColor: "#EEF2FF",
                            width: 40,
                            height: 40,
                            borderRadius: 10,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onPress={() => openEditModal(job)}
                        >
                          <Icon name="edit" size={20} color="#6366F1" />
                        </TouchableOpacity>
                      </View>
                    </View>
                  </>
                )}
              </TouchableOpacity>
            );
          })}
        </ScrollView>
      )}

      {/* Create/Edit Job Modal */}
      <Modal
        visible={showCreateModal}
        animationType="slide"
        transparent={true}
        onRequestClose={() => setShowCreateModal(false)}
      >
        {/* full-screen overlay, same tint as drawer backdrop */}
        <View
          style={{
            flex: 1,
            backgroundColor: "rgba(0,0,0,0.55)",
            justifyContent: "center",
            alignItems: "center",
            padding: 16,
          }}
        >
          <View
            style={{
              width: "100%",
              maxWidth: 860,
              height: "92%",
              backgroundColor: bg,
              borderRadius: 20,
              overflow: "hidden",
              borderWidth: 1,
              borderColor: border,
            }}
          >
            {/* ── Header (matches drawer header) ── */}
            <View
              style={{
                backgroundColor: card,
                paddingHorizontal: 20,
                paddingVertical: 18,
                borderBottomWidth: 1,
                borderBottomColor: border,
                flexDirection: "row",
                alignItems: "center",
                gap: 14,
              }}
            >
              <View
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: 12,
                  backgroundColor: "#F4C43020",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name={editingJob ? "edit" : "work"}
                  size={22}
                  color="#F4C430"
                />
              </View>
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 17,
                    fontFamily: fonts.bold,
                    color: txt,
                    letterSpacing: -0.2,
                  }}
                >
                  {editingJob ? t.cdEditJobPosting : t.cdCreateNewJob}
                </Text>
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.regular,
                    color: muted,
                    marginTop: 1,
                  }}
                >
                  {editingJob ? t.cdUpdateJobDetails : t.cdFillNewOpening}
                </Text>
              </View>
              <TouchableOpacity
                onPress={() => setShowCreateModal(false)}
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 10,
                  backgroundColor: bg,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="close" size={18} color={muted} />
              </TouchableOpacity>
            </View>

            {/* ── Scrollable form ── */}
            <ScrollView
              ref={scrollViewRef}
              showsVerticalScrollIndicator={false}
              contentContainerStyle={{ padding: 20, gap: 14 }}
            >
              {/* Section: Basic Information */}
              <View
                style={{
                  backgroundColor: card,
                  borderRadius: 14,
                  padding: 18,
                  borderWidth: 1,
                  borderColor: border,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                    marginBottom: 18,
                  }}
                >
                  <View
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 8,
                      backgroundColor: "#6366F118",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name="info" size={16} color="#6366F1" />
                  </View>
                  <Text
                    style={{ fontSize: 14, fontFamily: fonts.bold, color: txt }}
                  >
                    {t.cdBasicInformation}
                  </Text>
                </View>

                {/* Job Title */}
                <View style={{ marginBottom: 14 }}>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.semiBold,
                      color: muted,
                      marginBottom: 6,
                      letterSpacing: 0.3,
                    }}
                  >
                    {t.cdJobTitle} <Text style={{ color: "#EF4444" }}>*</Text>
                  </Text>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 10,
                      backgroundColor: bg,
                      borderRadius: 11,
                      paddingHorizontal: 13,
                      paddingVertical: 12,
                      borderWidth: 1,
                      borderColor: validationErrors.title ? "#EF4444" : border,
                    }}
                  >
                    <Icon
                      name="work-outline"
                      size={17}
                      color={validationErrors.title ? "#EF4444" : muted}
                    />
                    <TextInput
                      style={{
                        flex: 1,
                        fontSize: 14,
                        fontFamily: fonts.regular,
                        color: txt,
                        padding: 0,
                      }}
                      placeholder="e.g. Senior Software Engineer"
                      placeholderTextColor={muted}
                      value={title}
                      onChangeText={(t) => {
                        setTitle(t);
                        if (validationErrors.title)
                          setValidationErrors((p) => {
                            const n = { ...p };
                            delete n.title;
                            return n;
                          });
                      }}
                    />
                  </View>
                  {validationErrors.title && (
                    <Text
                      style={{
                        fontSize: 11,
                        color: "#EF4444",
                        marginTop: 4,
                        fontFamily: fonts.regular,
                      }}
                    >
                      {validationErrors.title}
                    </Text>
                  )}
                </View>

                {/* Category + Contract row */}
                <View style={{ flexDirection: "row", gap: 12 }}>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: muted,
                        marginBottom: 6,
                        letterSpacing: 0.3,
                      }}
                    >
                      {t.cdCategory} <Text style={{ color: "#EF4444" }}>*</Text>
                    </Text>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10,
                        backgroundColor: bg,
                        borderRadius: 11,
                        paddingHorizontal: 13,
                        borderWidth: 1,
                        borderColor: validationErrors.category
                          ? "#EF4444"
                          : border,
                        height: 46,
                      }}
                    >
                      <Icon
                        name="category"
                        size={17}
                        color={validationErrors.category ? "#EF4444" : muted}
                      />
                      <select
                        value={category}
                        onChange={(e) => {
                          setCategory(e.target.value);
                          if (validationErrors.category)
                            setValidationErrors((p) => {
                              const n = { ...p };
                              delete n.category;
                              return n;
                            });
                        }}
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          backgroundColor: bg,
                          color: txt,
                          fontSize: "14px",
                          fontFamily: fonts.regular,
                          cursor: "pointer",
                        }}
                      >
                        <option value="">Select category</option>
                        {categoryOptions.map((c) => (
                          <option key={c} value={c}>
                            {c}
                          </option>
                        ))}
                      </select>
                    </View>
                    {validationErrors.category && (
                      <Text
                        style={{
                          fontSize: 11,
                          color: "#EF4444",
                          marginTop: 4,
                          fontFamily: fonts.regular,
                        }}
                      >
                        {validationErrors.category}
                      </Text>
                    )}
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: muted,
                        marginBottom: 6,
                        letterSpacing: 0.3,
                      }}
                    >
                      {t.cdContractType}
                    </Text>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10,
                        backgroundColor: bg,
                        borderRadius: 11,
                        paddingHorizontal: 13,
                        borderWidth: 1,
                        borderColor: border,
                        height: 46,
                      }}
                    >
                      <Icon name="schedule" size={17} color={muted} />
                      <select
                        value={contractType}
                        onChange={(e) => setContractType(e.target.value)}
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          backgroundColor: bg,
                          color: txt,
                          fontSize: "14px",
                          fontFamily: fonts.regular,
                          cursor: "pointer",
                        }}
                      >
                        {contractTypes.map((t) => (
                          <option key={t} value={t}>
                            {t}
                          </option>
                        ))}
                      </select>
                    </View>
                  </View>
                </View>
              </View>

              {/* Section: Location & Compensation */}
              <View
                style={{
                  backgroundColor: card,
                  borderRadius: 14,
                  padding: 18,
                  borderWidth: 1,
                  borderColor: border,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                    marginBottom: 18,
                  }}
                >
                  <View
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 8,
                      backgroundColor: "#10B98118",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name="place" size={16} color="#10B981" />
                  </View>
                  <Text
                    style={{ fontSize: 14, fontFamily: fonts.bold, color: txt }}
                  >
                    {t.cdLocationCompensation}
                  </Text>
                </View>

                {/* Location */}
                <View style={{ marginBottom: 14 }}>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.semiBold,
                      color: muted,
                      marginBottom: 6,
                      letterSpacing: 0.3,
                    }}
                  >
                    {t.locationLabel}{" "}
                    <Text style={{ color: "#EF4444" }}>*</Text>
                  </Text>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 10,
                      backgroundColor: bg,
                      borderRadius: 11,
                      paddingHorizontal: 13,
                      paddingVertical: 12,
                      borderWidth: 1,
                      borderColor: validationErrors.location
                        ? "#EF4444"
                        : border,
                    }}
                  >
                    <Icon
                      name="location-on"
                      size={17}
                      color={validationErrors.location ? "#EF4444" : muted}
                    />
                    <TextInput
                      style={{
                        flex: 1,
                        fontSize: 14,
                        fontFamily: fonts.regular,
                        color: txt,
                        padding: 0,
                      }}
                      placeholder="e.g. Addis Ababa, Ethiopia"
                      placeholderTextColor={muted}
                      value={location}
                      onChangeText={(t) => {
                        setLocation(t);
                        if (validationErrors.location)
                          setValidationErrors((p) => {
                            const n = { ...p };
                            delete n.location;
                            return n;
                          });
                      }}
                    />
                  </View>
                  {validationErrors.location && (
                    <Text
                      style={{
                        fontSize: 11,
                        color: "#EF4444",
                        marginTop: 4,
                        fontFamily: fonts.regular,
                      }}
                    >
                      {validationErrors.location}
                    </Text>
                  )}
                </View>

                {/* Remote toggle */}
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    backgroundColor: bg,
                    borderRadius: 11,
                    paddingHorizontal: 14,
                    paddingVertical: 12,
                    borderWidth: 1,
                    borderColor: border,
                    marginBottom: 14,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <Icon
                      name="laptop"
                      size={18}
                      color={isRemote ? "#10B981" : muted}
                    />
                    <View>
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: fonts.semiBold,
                          color: txt,
                        }}
                      >
                        {t.cdRemoteWorkAvailable}
                      </Text>
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.regular,
                          color: muted,
                          marginTop: 1,
                        }}
                      >
                        {t.remoteWorkSubtitle}
                      </Text>
                    </View>
                  </View>
                  <Switch
                    value={isRemote}
                    onValueChange={setIsRemote}
                    trackColor={{ false: border, true: "#10B98150" }}
                    thumbColor={isRemote ? "#10B981" : muted}
                  />
                </View>

                {/* Salary */}
                <View>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.semiBold,
                      color: muted,
                      marginBottom: 6,
                      letterSpacing: 0.3,
                    }}
                  >
                    {t.cdMonthlySalary}
                  </Text>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 10,
                      backgroundColor: bg,
                      borderRadius: 11,
                      paddingHorizontal: 13,
                      paddingVertical: 12,
                      borderWidth: 1,
                      borderColor: border,
                    }}
                  >
                    <Icon name="attach-money" size={17} color={muted} />
                    <TextInput
                      style={{
                        flex: 1,
                        fontSize: 14,
                        fontFamily: fonts.regular,
                        color: txt,
                        padding: 0,
                      }}
                      placeholder="e.g. 15,000 – 25,000 Birr/month"
                      placeholderTextColor={muted}
                      value={salary}
                      onChangeText={setSalary}
                    />
                  </View>
                </View>
              </View>

              {/* Section: Job Details */}
              <View
                style={{
                  backgroundColor: card,
                  borderRadius: 14,
                  padding: 18,
                  borderWidth: 1,
                  borderColor: border,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                    marginBottom: 18,
                  }}
                >
                  <View
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 8,
                      backgroundColor: "#F59E0B18",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name="description" size={16} color="#F59E0B" />
                  </View>
                  <Text
                    style={{ fontSize: 14, fontFamily: fonts.bold, color: txt }}
                  >
                    {t.cdJobDetails}
                  </Text>
                </View>

                {[
                  {
                    label: t.cdJobDescription,
                    hint: "Describe the role and what makes this opportunity unique",
                    val: description,
                    set: setDescription,
                    ph: "Enter a detailed description of the job role...",
                  },
                  {
                    label: t.cdRequirements,
                    hint: "List required skills, qualifications, and experience",
                    val: requirements,
                    set: setRequirements,
                    ph: "• Bachelor's degree in relevant field\n• 3+ years of experience\n• Strong communication skills",
                  },
                  {
                    label: t.cdKeyResponsibilities,
                    hint: "Outline the main duties and day-to-day tasks",
                    val: responsibilities,
                    set: setResponsibilities,
                    ph: "• Lead development projects\n• Collaborate with team members\n• Mentor junior developers",
                  },
                ].map((f, fi) => (
                  <View key={fi} style={{ marginBottom: fi < 2 ? 16 : 0 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: muted,
                        marginBottom: 2,
                        letterSpacing: 0.3,
                      }}
                    >
                      {f.label}
                    </Text>
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: fonts.regular,
                        color: muted,
                        marginBottom: 6,
                        opacity: 0.75,
                      }}
                    >
                      {f.hint}
                    </Text>
                    <TextInput
                      style={{
                        backgroundColor: bg,
                        borderRadius: 11,
                        paddingHorizontal: 13,
                        paddingVertical: 12,
                        fontSize: 14,
                        fontFamily: fonts.regular,
                        color: txt,
                        borderWidth: 1,
                        borderColor: border,
                        minHeight: 110,
                        textAlignVertical: "top",
                      }}
                      placeholder={f.ph}
                      placeholderTextColor={muted}
                      value={f.val}
                      onChangeText={f.set}
                      multiline
                      numberOfLines={5}
                    />
                  </View>
                ))}
              </View>

              {/* Section: Skills & Tags */}
              <View
                style={{
                  backgroundColor: card,
                  borderRadius: 14,
                  padding: 18,
                  borderWidth: 1,
                  borderColor: validationErrors.tags ? "#EF4444" : border,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                    marginBottom: 6,
                  }}
                >
                  <View
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 8,
                      backgroundColor: "#8B5CF618",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name="local-offer" size={16} color="#8B5CF6" />
                  </View>
                  <Text
                    style={{ fontSize: 14, fontFamily: fonts.bold, color: txt }}
                  >
                    {t.cdSkillsTags} <Text style={{ color: "#EF4444" }}>*</Text>
                  </Text>
                </View>
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.regular,
                    color: muted,
                    marginBottom: 12,
                  }}
                >
                  {category
                    ? `Select relevant skills for ${category}`
                    : "Please select a category first"}
                </Text>

                {availableTags.length > 0 ? (
                  <ScrollView
                    style={{
                      maxHeight: 200,
                      borderRadius: 10,
                      borderWidth: 1,
                      borderColor: validationErrors.tags ? "#EF4444" : border,
                    }}
                    contentContainerStyle={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      gap: 8,
                      padding: 12,
                    }}
                    showsVerticalScrollIndicator
                  >
                    {availableTags.map((tag, index) => {
                      const isSelected = tags.includes(tag);
                      return (
                        <TouchableOpacity
                          key={index}
                          onPress={() => {
                            if (isSelected) {
                              setTags(tags.filter((t) => t !== tag));
                            } else {
                              setTags([...tags, tag]);
                              if (validationErrors.tags)
                                setValidationErrors((p) => {
                                  const n = { ...p };
                                  delete n.tags;
                                  return n;
                                });
                            }
                          }}
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 5,
                            paddingHorizontal: 12,
                            paddingVertical: 7,
                            borderRadius: 20,
                            borderWidth: 1,
                            backgroundColor: isSelected ? "#8B5CF6" : bg,
                            borderColor: isSelected ? "#8B5CF6" : border,
                          }}
                        >
                          {isSelected && (
                            <Icon name="check" size={12} color="#FFFFFF" />
                          )}
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: isSelected ? "#FFFFFF" : muted,
                            }}
                          >
                            {tag}
                          </Text>
                        </TouchableOpacity>
                      );
                    })}
                  </ScrollView>
                ) : (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 10,
                      backgroundColor: bg,
                      borderRadius: 11,
                      padding: 13,
                      borderWidth: 1,
                      borderColor: border,
                    }}
                  >
                    <Icon name="info" size={18} color={muted} />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.regular,
                        color: muted,
                      }}
                    >
                      {category
                        ? "No tags available for this category"
                        : "Select a category to see available tags"}
                    </Text>
                  </View>
                )}

                {validationErrors.tags && (
                  <Text
                    style={{
                      fontSize: 11,
                      color: "#EF4444",
                      marginTop: 8,
                      fontFamily: fonts.regular,
                    }}
                  >
                    {validationErrors.tags}
                  </Text>
                )}

                {tags.length > 0 && (
                  <View
                    style={{
                      marginTop: 14,
                      paddingTop: 14,
                      borderTopWidth: 1,
                      borderTopColor: border,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: fonts.semiBold,
                        color: muted,
                        marginBottom: 8,
                      }}
                    >
                      {t.selectedCountLabel} ({tags.length})
                    </Text>
                    <View
                      style={{ flexDirection: "row", flexWrap: "wrap", gap: 6 }}
                    >
                      {tags.map((t, ti) => (
                        <View
                          key={ti}
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 4,
                            backgroundColor: "#F4C43022",
                            paddingHorizontal: 11,
                            paddingVertical: 5,
                            borderRadius: 20,
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: "#F4C430",
                            }}
                          >
                            {t}
                          </Text>
                        </View>
                      ))}
                    </View>
                  </View>
                )}
              </View>
            </ScrollView>

            {/* ── Footer (matches drawer footer style) ── */}
            <View
              style={{
                backgroundColor: card,
                paddingHorizontal: 20,
                paddingVertical: 14,
                borderTopWidth: 1,
                borderTopColor: border,
                flexDirection: "row",
                gap: 10,
              }}
            >
              <TouchableOpacity
                onPress={() => setShowCreateModal(false)}
                disabled={saving}
                style={{
                  flex: 1,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  paddingVertical: 13,
                  borderRadius: 12,
                  borderWidth: 1,
                  borderColor: border,
                  backgroundColor: bg,
                }}
              >
                <Icon name="close" size={16} color={muted} />
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    color: muted,
                  }}
                >
                  {t.cancelButton}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={handleSubmit}
                disabled={saving}
                style={{
                  flex: 2,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  paddingVertical: 13,
                  borderRadius: 12,
                  backgroundColor: "#F4C430",
                }}
              >
                {saving ? (
                  <ActivityIndicator size="small" color="#1A1D23" />
                ) : (
                  <>
                    <Icon
                      name={editingJob ? "check" : "add"}
                      size={18}
                      color="#1A1D23"
                    />
                    <Text
                      style={{
                        fontSize: 14,
                        fontFamily: fonts.bold,
                        color: "#1A1D23",
                      }}
                    >
                      {editingJob ? t.updateJobButton : t.postJobButton}
                    </Text>
                  </>
                )}
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Custom Confirmation Modal */}
      <Modal
        visible={confirmationModal.visible}
        transparent={true}
        animationType="fade"
        onRequestClose={() =>
          setConfirmationModal({ ...confirmationModal, visible: false })
        }
      >
        <View style={styles.customModalOverlay}>
          <View
            style={[
              styles.customModalContainer,
              { backgroundColor: colors.white },
            ]}
          >
            <View style={styles.customModalHeader}>
              <View
                style={[
                  styles.customModalIconContainer,
                  {
                    backgroundColor: confirmationModal.isDestructive
                      ? "#FEE2E2"
                      : colors.cream,
                  },
                ]}
              >
                <Icon
                  name={
                    confirmationModal.isDestructive ? "warning" : "help-outline"
                  }
                  size={32}
                  color={
                    confirmationModal.isDestructive ? "#EF4444" : "#3B82F6"
                  }
                />
              </View>
              <Text
                style={[styles.customModalTitle, { color: colors.deepNavy }]}
              >
                {confirmationModal.title}
              </Text>
              <Text
                style={[styles.customModalMessage, { color: colors.warmGray }]}
              >
                {confirmationModal.message}
              </Text>
            </View>

            <View style={styles.customModalActions}>
              <TouchableOpacity
                style={[
                  styles.customModalButton,
                  styles.customModalCancelButton,
                  { borderColor: colors.lightGray },
                ]}
                onPress={() =>
                  setConfirmationModal({ ...confirmationModal, visible: false })
                }
              >
                <Text
                  style={[
                    styles.customModalButtonText,
                    { color: colors.warmGray },
                  ]}
                >
                  {confirmationModal.cancelText}
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={[
                  styles.customModalButton,
                  styles.customModalConfirmButton,
                  {
                    backgroundColor: confirmationModal.isDestructive
                      ? "#EF4444"
                      : colors.beeYellow,
                  },
                ]}
                onPress={() => {
                  confirmationModal.onConfirm();
                  setConfirmationModal({
                    ...confirmationModal,
                    visible: false,
                  });
                }}
              >
                <Text
                  style={[
                    styles.customModalButtonText,
                    {
                      color: confirmationModal.isDestructive
                        ? colors.white
                        : colors.deepNavy,
                    },
                  ]}
                >
                  {confirmationModal.confirmText}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Custom Alert Modal */}
      <Modal
        visible={alertModal.visible}
        transparent={true}
        animationType="fade"
        onRequestClose={() => setAlertModal({ ...alertModal, visible: false })}
      >
        <View style={styles.customModalOverlay}>
          <View
            style={[
              styles.customModalContainer,
              { backgroundColor: colors.white },
            ]}
          >
            <View style={styles.customModalHeader}>
              <View
                style={[
                  styles.customModalIconContainer,
                  {
                    backgroundColor:
                      alertModal.title === "Success"
                        ? "#D1FAE5"
                        : alertModal.title === "Error"
                        ? "#FEE2E2"
                        : colors.cream,
                  },
                ]}
              >
                <Icon
                  name={
                    alertModal.title === "Success"
                      ? "check-circle"
                      : alertModal.title === "Error"
                      ? "error"
                      : "info"
                  }
                  size={32}
                  color={
                    alertModal.title === "Success"
                      ? "#10B981"
                      : alertModal.title === "Error"
                      ? "#EF4444"
                      : colors.beeYellow
                  }
                />
              </View>
              <Text
                style={[styles.customModalTitle, { color: colors.deepNavy }]}
              >
                {alertModal.title}
              </Text>
              <Text
                style={[styles.customModalMessage, { color: colors.warmGray }]}
              >
                {alertModal.message}
              </Text>
            </View>

            <View style={styles.customModalActions}>
              <TouchableOpacity
                style={[
                  styles.customModalButton,
                  styles.customModalConfirmButton,
                  { backgroundColor: colors.beeYellow },
                ]}
                onPress={() => setAlertModal({ ...alertModal, visible: false })}
              >
                <Text
                  style={[
                    styles.customModalButtonText,
                    { color: colors.deepNavy },
                  ]}
                >
                  OK
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* FAB - Add New Job (Mobile only) */}
      {isMobile && (
        <TouchableOpacity
          style={[
            styles.fab,
            styles.fabSmall,
            { backgroundColor: colors.beeYellow },
          ]}
          onPress={openCreateModal}
          activeOpacity={0.8}
        >
          <Icon name="add" size={24} color={colors.deepNavy} />
        </TouchableOpacity>
      )}
    </View>
  );
}

// Company Candidates Content - Browse candidates within dashboard
function CompanyCandidatesContent({
  colors,
  navigation,
  isDarkMode,
  t,
  currentLanguage = "en",
}: any) {
  const [candidates, setCandidates] = useState<any[]>([]);
  const [filteredCandidates, setFilteredCandidates] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [selectedExperience, setSelectedExperience] = useState<string[]>([]);
  const [showFilters, setShowFilters] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCandidate, setSelectedCandidate] = useState<any>(null);
  const [allCategories, setAllCategories] = useState<any[]>([]);

  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  // Helper: resolve a category/subcategory path to a display name
  const resolveCategoryName = (path: string): string => {
    if (!path) return path;
    // First try top-level categories
    const cat = allCategories.find(
      (c: any) => c.path === path || c.id === path,
    );
    if (cat) return cat.name || path;
    // Try subcategories
    for (const c of allCategories) {
      const sub = (c.subcategories || []).find(
        (s: any) => s.path === path || s.id === path,
      );
      if (sub) return sub.name || path;
    }
    // Fallback: prettify the path (e.g. "information-technology" → "Information Technology")
    return path
      .replace(/-/g, " ")
      .replace(/\b\w/g, (l: string) => l.toUpperCase());
  };

  useEffect(() => {
    fetchCandidates();
    // Fetch categories so we can resolve path → display name in the modal
    getDocs(collection(db, "categories"))
      .then((snap) => {
        setAllCategories(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .catch(() => {});
  }, []);

  const availableTags = [
    "JavaScript",
    "Python",
    "React",
    "Node.js",
    "TypeScript",
    "Java",
    "C++",
    "Angular",
    "Vue.js",
    "PHP",
    "Mobile Development",
    "Web Development",
    "UI/UX Design",
    "Data Science",
    "Machine Learning",
    "DevOps",
    "Cloud Computing",
  ];

  const experienceLevels = [
    "Entry Level",
    "Mid Level",
    "Senior Level",
    "Expert",
  ];

  const fetchCandidates = async () => {
    try {
      setLoading(true);
      const usersRef = collection(db, "users");
      const candidatesQuery = dbQuery(
        usersRef,
        where("role", "not-in", ["company", "admin", "superadmin"]),
        limit(100),
      );
      const querySnapshot = await getDocs(candidatesQuery);

      const candidateData = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((c: any) => c.profileSetupComplete === true);

      setCandidates(candidateData);
      setFilteredCandidates(candidateData);
    } catch (error) {
      console.error("Error fetching candidates:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let filtered = [...candidates];

    if (searchQuery) {
      filtered = filtered.filter(
        (candidate) =>
          candidate.fullName
            ?.toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          candidate.displayName
            ?.toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          candidate.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          candidate.jobTitle
            ?.toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          candidate.username?.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }

    if (selectedTags.length > 0) {
      filtered = filtered.filter(
        (candidate) =>
          candidate.skills?.some((skill: string) =>
            selectedTags.some((tag) =>
              skill.toLowerCase().includes(tag.toLowerCase()),
            ),
          ) ||
          candidate.interests?.some((interest: string) =>
            selectedTags.some((tag) =>
              interest.toLowerCase().includes(tag.toLowerCase()),
            ),
          ),
      );
    }

    if (selectedExperience.length > 0) {
      filtered = filtered.filter((candidate) =>
        selectedExperience.includes(candidate.experienceLevel),
      );
    }

    setFilteredCandidates(filtered);
  }, [searchQuery, selectedTags, selectedExperience, candidates]);

  const toggleTag = (tag: string) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag],
    );
  };

  const toggleExperience = (level: string) => {
    setSelectedExperience((prev) =>
      prev.includes(level) ? prev.filter((l) => l !== level) : [...prev, level],
    );
  };

  const clearFilters = () => {
    setSelectedTags([]);
    setSelectedExperience([]);
    setSearchQuery("");
  };

  const isDark = isDarkMode;
  const bg = isDark ? "#0F1117" : "#F3F4F6";
  const cardBg = isDark ? "#1A1D23" : "#FFFFFF";
  const txt = isDark ? "#F9FAFB" : "#0F172A";
  const muted = isDark ? "#6B7280" : "#9CA3AF";
  const borderC = isDark ? "#252932" : "#F0F0F0";

  if (loading) {
    return (
      <View style={{ flex: 1, backgroundColor: bg }}>
        <FullScreenLoader
          message="Loading candidates..."
          isDarkMode={isDarkMode}
        />
      </View>
    );
  }

  return (
    <>
      <ScrollView style={{ flex: 1, backgroundColor: bg }}>
        {/* ── Header ── */}
        {isMobile ? (
          /* Mobile: compact strip */
          <View
            style={{
              backgroundColor: isDark ? "#111318" : "#FFFFFF",
              paddingHorizontal: 16,
              paddingTop: 12,
              paddingBottom: 12,
              borderBottomWidth: 1,
              borderBottomColor: borderC,
            }}
          >
            {/* Count chip row */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 4,
                  backgroundColor: isDark ? "#252932" : "#F3F4F6",
                  paddingHorizontal: 10,
                  paddingVertical: 5,
                  borderRadius: 20,
                }}
              >
                <Text
                  style={{ fontSize: 14, fontFamily: fonts.bold, color: txt }}
                >
                  {filteredCandidates.length}
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.medium,
                    color: muted,
                  }}
                >
                  {t.cdFound}
                </Text>
              </View>
            </View>
            {/* Search bar */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: isDark ? "#252932" : "#F3F4F6",
                borderRadius: 12,
                paddingHorizontal: 12,
                height: 40,
                borderWidth: 1,
                borderColor: borderC,
              }}
            >
              <Icon name="search" size={18} color={muted} />
              <TextInput
                style={
                  {
                    flex: 1,
                    marginLeft: 10,
                    fontFamily: fonts.regular,
                    fontSize: 14,
                    color: txt,
                    outlineStyle: "none",
                  } as any
                }
                placeholder={t.cdSearchCandidates}
                placeholderTextColor={muted}
                value={searchQuery}
                onChangeText={setSearchQuery}
              />
              {searchQuery ? (
                <TouchableOpacity onPress={() => setSearchQuery("")}>
                  <Icon name="close" size={16} color={muted} />
                </TouchableOpacity>
              ) : null}
            </View>
          </View>
        ) : (
          /* Desktop: existing top bar */
          <View
            style={{
              paddingHorizontal: 32,
              paddingTop: 28,
              paddingBottom: 14,
              backgroundColor: isDark ? "#111827" : "#F8FAFC",
            }}
          >
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 12 }}
            >
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
              >
                <Text
                  style={{
                    fontSize: 22,
                    fontFamily: fonts.bold,
                    color: colors.deepNavy,
                  }}
                >
                  {t.cdTalentPool}
                </Text>
                <View
                  style={{
                    paddingHorizontal: 9,
                    paddingVertical: 3,
                    borderRadius: 20,
                    backgroundColor: isDark ? "#1F2937" : "#E5E7EB",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.semiBold,
                      color: colors.warmGray,
                    }}
                  >
                    {filteredCandidates.length}
                  </Text>
                </View>
              </View>
              <View
                style={{
                  flex: 1,
                  flexDirection: "row",
                  alignItems: "center",
                  backgroundColor: isDark ? "#1F2937" : "#FFFFFF",
                  borderRadius: 10,
                  paddingHorizontal: 10,
                  height: 38,
                  borderWidth: 1,
                  borderColor: isDark ? "#374151" : "#E5E7EB",
                }}
              >
                <Icon
                  name="search"
                  size={16}
                  color={isDark ? "#4B5563" : "#9CA3AF"}
                />
                <TextInput
                  style={
                    {
                      flex: 1,
                      marginLeft: 7,
                      fontFamily: fonts.regular,
                      fontSize: 13,
                      color: colors.deepNavy,
                      outlineStyle: "none",
                    } as any
                  }
                  placeholder={t.cdSearchCandidates}
                  placeholderTextColor={isDark ? "#4B5563" : "#9CA3AF"}
                  value={searchQuery}
                  onChangeText={setSearchQuery}
                />
                {searchQuery ? (
                  <TouchableOpacity onPress={() => setSearchQuery("")}>
                    <Icon
                      name="close"
                      size={15}
                      color={isDark ? "#4B5563" : "#9CA3AF"}
                    />
                  </TouchableOpacity>
                ) : null}
              </View>
            </View>
          </View>
        )}

        {/* ── Candidates Grid ── */}
        {filteredCandidates.length > 0 ? (
          <View
            style={{
              flexDirection: isMobile ? "column" : "row",
              flexWrap: "wrap",
              gap: isMobile ? 10 : 12,
              paddingHorizontal: isMobile ? 12 : 32,
              paddingTop: isMobile ? 12 : 0,
              paddingBottom: isMobile ? 100 : 40,
            }}
          >
            {filteredCandidates.map((candidate) => (
              <TouchableOpacity
                key={candidate.id}
                activeOpacity={0.85}
                onPress={() => setSelectedCandidate(candidate)}
                style={{
                  width: isMobile ? "100%" : ("calc(33.333% - 8px)" as any),
                  backgroundColor: isMobile
                    ? cardBg
                    : isDark
                    ? "#1F2937"
                    : "#FFFFFF",
                  borderRadius: isMobile ? 16 : 14,
                  overflow: "hidden",
                  borderWidth: 1,
                  borderColor: isMobile
                    ? borderC
                    : isDark
                    ? "#374151"
                    : "#F1F5F9",
                  ...(isMobile && Platform.OS === "web"
                    ? {
                        boxShadow: isDark
                          ? "0 2px 8px rgba(0,0,0,0.3)"
                          : "0 2px 8px rgba(0,0,0,0.06)",
                      }
                    : {}),
                }}
              >
                {/* Top row: avatar + name block + chevron */}
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-start",
                    padding: 14,
                    gap: 12,
                  }}
                >
                  {/* Avatar */}
                  {(() => {
                    const _id = candidate.id || candidate.email || "u";
                    const _h = _id
                      .split("")
                      .reduce((a: number, c: string) => a + c.charCodeAt(0), 0);
                    const _bgs = [
                      "#EEF2FF",
                      "#FDF2F8",
                      "#ECFDF5",
                      "#FFF7ED",
                      "#EFF6FF",
                    ];
                    const _fgs = [
                      "#6366F1",
                      "#EC4899",
                      "#10B981",
                      "#F59E0B",
                      "#3B82F6",
                    ];
                    const _name =
                      candidate.fullName || candidate.displayName || "";
                    const _parts = _name.trim().split(/\s+/).filter(Boolean);
                    const _initials =
                      _parts.length > 1
                        ? (
                            _parts[0][0] + _parts[_parts.length - 1][0]
                          ).toUpperCase()
                        : _parts.length === 1
                        ? _parts[0][0].toUpperCase()
                        : (candidate.email?.charAt(0) || "?").toUpperCase();
                    const _imgUri =
                      candidate.profilePicture ||
                      candidate.profile?.avatar ||
                      candidate.photoURL;
                    return (
                      <View
                        style={{
                          width: 52,
                          height: 52,
                          borderRadius: 26,
                          backgroundColor: isDark
                            ? "#252932"
                            : _bgs[_h % _bgs.length],
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          flexShrink: 0,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 18,
                            fontFamily: fonts.bold,
                            color: _fgs[_h % _fgs.length],
                            letterSpacing: 0.5,
                          }}
                        >
                          {_initials}
                        </Text>
                        {!!_imgUri && (
                          <Image
                            source={{ uri: _imgUri }}
                            style={{
                              width: 52,
                              height: 52,
                              position: "absolute",
                            }}
                          />
                        )}
                      </View>
                    );
                  })()}

                  {/* Name + title + meta */}
                  <View style={{ flex: 1, minWidth: 0 }}>
                    {/* Name row */}
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 6,
                        marginBottom: 2,
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: fonts.semiBold,
                          color: colors.deepNavy,
                          flexShrink: 1,
                        }}
                        numberOfLines={1}
                      >
                        {candidate.fullName ||
                          candidate.displayName ||
                          "Candidate"}
                      </Text>
                      {(candidate.availability === "Immediately" ||
                        candidate.availability === "Available") && (
                        <View
                          style={{
                            width: 7,
                            height: 7,
                            borderRadius: 4,
                            backgroundColor: "#10B981",
                            flexShrink: 0,
                          }}
                        />
                      )}
                    </View>

                    {/* Job title */}
                    {(candidate.jobTitle || candidate.profession) && (
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: fonts.medium,
                          color: "#6366F1",
                          marginBottom: 6,
                        }}
                        numberOfLines={1}
                      >
                        {candidate.jobTitle || candidate.profession}
                      </Text>
                    )}

                    {/* Meta row 1: location + work type */}
                    <View
                      style={{
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: 10,
                        marginBottom: 4,
                      }}
                    >
                      {candidate.location && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 3,
                          }}
                        >
                          <Icon
                            name="location-on"
                            size={11}
                            color={isDarkMode ? "#4B5563" : "#9CA3AF"}
                          />
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.regular,
                              color: colors.warmGray,
                            }}
                            numberOfLines={1}
                          >
                            {candidate.location}
                          </Text>
                        </View>
                      )}
                      {(candidate.workType || candidate.preferredWorkType) && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 3,
                          }}
                        >
                          <Icon
                            name="business-center"
                            size={11}
                            color={isDarkMode ? "#4B5563" : "#9CA3AF"}
                          />
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.regular,
                              color: colors.warmGray,
                            }}
                          >
                            {candidate.workType || candidate.preferredWorkType}
                          </Text>
                        </View>
                      )}
                    </View>

                    {/* Meta row 2: experience level + years */}
                    <View
                      style={{ flexDirection: "row", flexWrap: "wrap", gap: 6 }}
                    >
                      {candidate.experienceLevel && (
                        <View
                          style={{
                            paddingHorizontal: 7,
                            paddingVertical: 2,
                            borderRadius: 4,
                            backgroundColor: isDarkMode ? "#374151" : "#F3F4F6",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 10,
                              fontFamily: fonts.medium,
                              color: colors.warmGray,
                            }}
                          >
                            {candidate.experienceLevel}
                          </Text>
                        </View>
                      )}
                      {(candidate.yearsOfExperience ||
                        candidate.experience) && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 3,
                          }}
                        >
                          <Icon
                            name="work-outline"
                            size={11}
                            color={isDarkMode ? "#4B5563" : "#9CA3AF"}
                          />
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.regular,
                              color: colors.warmGray,
                            }}
                          >
                            {candidate.yearsOfExperience ||
                              candidate.experience}{" "}
                            {t.cdYearsExp}
                          </Text>
                        </View>
                      )}
                      {candidate.interestedCategory && (
                        <View
                          style={{
                            paddingHorizontal: 7,
                            paddingVertical: 2,
                            borderRadius: 4,
                            backgroundColor: isDarkMode ? "#1E293B" : "#EEF2FF",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 10,
                              fontFamily: fonts.medium,
                              color: isDarkMode ? "#818CF8" : "#4F46E5",
                            }}
                            numberOfLines={1}
                          >
                            {resolveCategoryName(candidate.interestedCategory)}
                          </Text>
                        </View>
                      )}
                    </View>
                  </View>

                  {/* Chevron */}
                  <Icon
                    name="chevron-right"
                    size={18}
                    color={isDarkMode ? "#4B5563" : "#D1D5DB"}
                    style={{ marginTop: 2 }}
                  />
                </View>

                {/* Skills strip */}
                {candidate.skills && candidate.skills.length > 0 && (
                  <View
                    style={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      gap: 5,
                      paddingHorizontal: 14,
                      paddingBottom: 12,
                      paddingTop: 0,
                    }}
                  >
                    {candidate.skills
                      .slice(0, 4)
                      .map((skill: string, idx: number) => (
                        <View
                          key={idx}
                          style={{
                            paddingHorizontal: 8,
                            paddingVertical: 3,
                            borderRadius: 5,
                            backgroundColor: isDarkMode ? "#111827" : "#F8FAFC",
                            borderWidth: 1,
                            borderColor: isDarkMode ? "#374151" : "#E5E7EB",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 10,
                              fontFamily: fonts.medium,
                              color: colors.warmGray,
                            }}
                          >
                            {skill}
                          </Text>
                        </View>
                      ))}
                    {candidate.skills.length > 4 && (
                      <View
                        style={{
                          paddingHorizontal: 8,
                          paddingVertical: 3,
                          borderRadius: 5,
                          backgroundColor: isDarkMode ? "#111827" : "#F8FAFC",
                          borderWidth: 1,
                          borderColor: isDarkMode ? "#374151" : "#E5E7EB",
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 10,
                            fontFamily: fonts.medium,
                            color: colors.warmGray,
                          }}
                        >
                          +{candidate.skills.length - 4}
                        </Text>
                      </View>
                    )}
                  </View>
                )}
              </TouchableOpacity>
            ))}
          </View>
        ) : (
          <View
            style={{
              alignItems: "center",
              justifyContent: "center",
              padding: isMobile ? 48 : 64,
            }}
          >
            <View
              style={{
                width: isMobile ? 64 : 72,
                height: isMobile ? 64 : 72,
                borderRadius: isMobile ? 32 : 36,
                backgroundColor: "#3B82F614",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 14,
              }}
            >
              <Icon
                name="people-outline"
                size={isMobile ? 32 : 36}
                color="#3B82F6"
              />
            </View>
            <Text
              style={{
                fontSize: isMobile ? 18 : 15,
                fontFamily: fonts.bold,
                color: txt,
                marginBottom: 6,
                textAlign: "center",
              }}
            >
              {searchQuery ? t.cdNoResultsFound : t.cdNoCandidatesYet}
            </Text>
            <Text
              style={{
                fontSize: isMobile ? 13 : 13,
                fontFamily: fonts.regular,
                color: muted,
                textAlign: "center",
                lineHeight: 20,
              }}
            >
              {searchQuery ? t.cdTryDifferentSearch : t.cdCandidatesWillAppear}
            </Text>
          </View>
        )}
      </ScrollView>

      {/* Talent Profile Detail Modal */}
      <Modal
        visible={!!selectedCandidate}
        transparent
        animationType="slide"
        onRequestClose={() => setSelectedCandidate(null)}
      >
        <View
          style={{
            flex: 1,
            backgroundColor: "rgba(0,0,0,0.7)",
            justifyContent: isMobile ? "flex-end" : "center",
            alignItems: "center",
          }}
        >
          <View
            style={{
              width: isMobile ? "100%" : Math.min(920, 920),
              height: isMobile ? "95%" : "88%",
              backgroundColor: isDarkMode ? "#0F172A" : "#F1F5F9",
              borderRadius: isMobile ? 24 : 20,
              overflow: "hidden",
              flexDirection: isMobile ? "column" : "row",
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 20 },
              shadowOpacity: 0.4,
              shadowRadius: 50,
              elevation: 20,
            }}
          >
            {selectedCandidate && (
              <>
                {/* Mobile drag handle */}
                {isMobile && (
                  <View
                    style={{
                      alignItems: "center",
                      paddingVertical: 10,
                      backgroundColor: isDarkMode ? "#1E293B" : "#FFFFFF",
                    }}
                  >
                    <View
                      style={{
                        width: 40,
                        height: 4,
                        borderRadius: 2,
                        backgroundColor: isDarkMode ? "#475569" : "#CBD5E1",
                      }}
                    />
                  </View>
                )}

                {/* ─── LEFT SIDEBAR ─── */}
                <View
                  style={{
                    width: isMobile ? "100%" : 300,
                    backgroundColor: isDarkMode ? "#1E293B" : "#FFFFFF",
                    borderRightWidth: isMobile ? 0 : 1,
                    borderRightColor: isDarkMode ? "#334155" : "#E2E8F0",
                    borderBottomWidth: isMobile ? 1 : 0,
                    borderBottomColor: isDarkMode ? "#334155" : "#E2E8F0",
                  }}
                >
                  {/* Mini banner header */}
                  <View
                    style={{
                      height: isMobile ? 80 : 110,
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    {selectedCandidate.bannerImage ||
                    selectedCandidate.profile?.banner ? (
                      <Image
                        source={{
                          uri:
                            selectedCandidate.bannerImage ||
                            selectedCandidate.profile?.banner,
                        }}
                        style={{ width: "100%", height: "100%" }}
                        resizeMode="cover"
                      />
                    ) : (
                      (() => {
                        const id =
                          selectedCandidate.id ||
                          selectedCandidate.email ||
                          "default";
                        const hash = id
                          .split("")
                          .reduce(
                            (acc: number, char: string) =>
                              acc + char.charCodeAt(0),
                            0,
                          );
                        const cp = [
                          ["#4A5568", "#5A6378"],
                          ["#7C6BA0", "#8B7BB8"],
                          ["#A87C6D", "#9C6D5F"],
                          ["#5F8575", "#6B9585"],
                          ["#5D6D85", "#6A7D95"],
                        ];
                        const [c1, c2] = cp[hash % cp.length];
                        return (
                          <View
                            style={{
                              width: "100%",
                              height: "100%",
                              backgroundColor: c1,
                            }}
                          >
                            <View
                              style={{
                                position: "absolute",
                                width: 180,
                                height: 180,
                                borderRadius: 90,
                                backgroundColor: c2,
                                opacity: 0.2,
                                top: -70,
                                right: -50,
                              }}
                            />
                            <View
                              style={{
                                position: "absolute",
                                width: 120,
                                height: 120,
                                borderRadius: 60,
                                backgroundColor: c2,
                                opacity: 0.15,
                                bottom: -40,
                                left: -20,
                              }}
                            />
                          </View>
                        );
                      })()
                    )}
                    {/* Close */}
                    <TouchableOpacity
                      onPress={() => setSelectedCandidate(null)}
                      style={{
                        position: "absolute",
                        top: 12,
                        right: 12,
                        width: 34,
                        height: 34,
                        borderRadius: 17,
                        backgroundColor: "rgba(0,0,0,0.45)",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon name="close" size={18} color="#FFFFFF" />
                    </TouchableOpacity>
                    {/* Available badge */}
                    {(selectedCandidate.availability === "Immediately" ||
                      selectedCandidate.availability === "Available") && (
                      <View
                        style={{
                          position: "absolute",
                          top: 12,
                          left: 12,
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 5,
                          paddingHorizontal: 10,
                          paddingVertical: 5,
                          borderRadius: 20,
                          backgroundColor: "#10B981",
                        }}
                      >
                        <View
                          style={{
                            width: 6,
                            height: 6,
                            borderRadius: 3,
                            backgroundColor: "#FFFFFF",
                          }}
                        />
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.bold,
                            color: "#FFFFFF",
                          }}
                        >
                          Available
                        </Text>
                      </View>
                    )}
                  </View>

                  {/* Avatar overlapping banner */}
                  <View
                    style={{
                      alignItems: isMobile ? "center" : "flex-start",
                      paddingLeft: isMobile ? 0 : 20,
                      marginTop: -44,
                      marginBottom: 10,
                      zIndex: 1,
                    }}
                  >
                    {(() => {
                      const _id =
                        selectedCandidate.id || selectedCandidate.email || "u";
                      const _h = _id
                        .split("")
                        .reduce(
                          (a: number, c: string) => a + c.charCodeAt(0),
                          0,
                        );
                      const _bgs = [
                        "#EEF2FF",
                        "#FDF2F8",
                        "#ECFDF5",
                        "#FFF7ED",
                        "#EFF6FF",
                      ];
                      const _fgs = [
                        "#6366F1",
                        "#EC4899",
                        "#10B981",
                        "#F59E0B",
                        "#3B82F6",
                      ];
                      const _name =
                        selectedCandidate.fullName ||
                        selectedCandidate.displayName ||
                        "";
                      const _parts = _name.trim().split(/\s+/).filter(Boolean);
                      const _initials =
                        _parts.length > 1
                          ? (
                              _parts[0][0] + _parts[_parts.length - 1][0]
                            ).toUpperCase()
                          : _parts.length === 1
                          ? _parts[0][0].toUpperCase()
                          : (
                              selectedCandidate.email?.charAt(0) || "C"
                            ).toUpperCase();
                      const _imgUri =
                        selectedCandidate.profilePicture ||
                        selectedCandidate.profile?.avatar ||
                        selectedCandidate.photoURL;
                      return (
                        <View
                          style={{
                            width: 88,
                            height: 88,
                            borderRadius: 44,
                            backgroundColor: isDark
                              ? "#252932"
                              : _bgs[_h % _bgs.length],
                            borderWidth: 4,
                            borderColor: isDark ? "#1E293B" : "#FFFFFF",
                            overflow: "hidden",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 34,
                              fontFamily: fonts.bold,
                              color: _fgs[_h % _fgs.length],
                              letterSpacing: 1,
                            }}
                          >
                            {_initials}
                          </Text>
                          {!!_imgUri && (
                            <Image
                              source={{ uri: _imgUri }}
                              style={{
                                width: 88,
                                height: 88,
                                position: "absolute",
                              }}
                            />
                          )}
                        </View>
                      );
                    })()}
                  </View>

                  <ScrollView
                    style={{ flex: isMobile ? undefined : 1 }}
                    contentContainerStyle={{
                      paddingHorizontal: 20,
                      paddingBottom: 24,
                    }}
                    showsVerticalScrollIndicator={false}
                  >
                    {/* Name & title */}
                    <Text
                      style={{
                        fontSize: 20,
                        fontFamily: fonts.bold,
                        color: isDarkMode ? "#F1F5F9" : "#0F172A",
                        marginBottom: 2,
                        textAlign: isMobile ? "center" : "left",
                      }}
                    >
                      {selectedCandidate.fullName ||
                        selectedCandidate.displayName ||
                        "Candidate"}
                    </Text>
                    {selectedCandidate.username && (
                      <Text
                        style={{
                          fontSize: 13,
                          fontFamily: fonts.medium,
                          color: isDarkMode ? "#475569" : "#94A3B8",
                          marginBottom: 3,
                          textAlign: isMobile ? "center" : "left",
                        }}
                      >
                        @{selectedCandidate.username}
                      </Text>
                    )}
                    {(selectedCandidate.jobTitle ||
                      selectedCandidate.profession) && (
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: fonts.semiBold,
                          color: "#6366F1",
                          marginBottom: 8,
                          textAlign: isMobile ? "center" : "left",
                        }}
                      >
                        {selectedCandidate.jobTitle ||
                          selectedCandidate.profession}
                      </Text>
                    )}

                    {/* Category pills */}
                    {(selectedCandidate.interestedCategory ||
                      (selectedCandidate.interestedSubcategories &&
                        selectedCandidate.interestedSubcategories.length >
                          0)) && (
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 6,
                          marginBottom: 14,
                          justifyContent: isMobile ? "center" : "flex-start",
                        }}
                      >
                        {selectedCandidate.interestedCategory && (
                          <View
                            style={{
                              paddingHorizontal: 9,
                              paddingVertical: 3,
                              borderRadius: 6,
                              backgroundColor: "#EEF2FF",
                              borderWidth: 1,
                              borderColor: "#C7D2FE",
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 11,
                                fontFamily: fonts.semiBold,
                                color: "#6366F1",
                              }}
                            >
                              {resolveCategoryName(
                                selectedCandidate.interestedCategory,
                              )}
                            </Text>
                          </View>
                        )}
                        {selectedCandidate.interestedSubcategories &&
                          selectedCandidate.interestedSubcategories
                            .slice(0, 2)
                            .map((sub: string, i: number) => (
                              <View
                                key={i}
                                style={{
                                  paddingHorizontal: 9,
                                  paddingVertical: 3,
                                  borderRadius: 6,
                                  backgroundColor: isDarkMode
                                    ? "#334155"
                                    : "#F1F5F9",
                                  borderWidth: 1,
                                  borderColor: isDarkMode
                                    ? "#475569"
                                    : "#E2E8F0",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 11,
                                    fontFamily: fonts.medium,
                                    color: isDarkMode ? "#94A3B8" : "#64748B",
                                  }}
                                >
                                  {resolveCategoryName(sub)}
                                </Text>
                              </View>
                            ))}
                      </View>
                    )}

                    {/* Divider */}
                    <View
                      style={{
                        height: 1,
                        backgroundColor: isDarkMode ? "#334155" : "#E2E8F0",
                        marginBottom: 14,
                      }}
                    />

                    {/* Contact rows */}
                    {selectedCandidate.email && (
                      <TouchableOpacity
                        onPress={() => {
                          if (Platform.OS === "web") {
                            navigator.clipboard.writeText(
                              selectedCandidate.email,
                            );
                            Alert.alert("Copied", "Email copied!");
                          }
                        }}
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 10,
                          marginBottom: 10,
                        }}
                      >
                        <View
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: 8,
                            backgroundColor: "#EEF2FF",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon name="email" size={15} color="#6366F1" />
                        </View>
                        <Text
                          style={{
                            flex: 1,
                            fontSize: 13,
                            fontFamily: fonts.medium,
                            color: isDarkMode ? "#CBD5E1" : "#475569",
                          }}
                          numberOfLines={1}
                        >
                          {selectedCandidate.email}
                        </Text>
                        <Icon
                          name="content-copy"
                          size={13}
                          color={isDarkMode ? "#475569" : "#CBD5E1"}
                        />
                      </TouchableOpacity>
                    )}
                    {(selectedCandidate.phone ||
                      selectedCandidate.phoneNumber) && (
                      <TouchableOpacity
                        onPress={() => {
                          const p =
                            selectedCandidate.phone ||
                            selectedCandidate.phoneNumber;
                          if (Platform.OS === "web") {
                            navigator.clipboard.writeText(p);
                            Alert.alert("Copied", "Phone copied!");
                          }
                        }}
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 10,
                          marginBottom: 10,
                        }}
                      >
                        <View
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: 8,
                            backgroundColor: "#ECFDF5",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon name="phone" size={15} color="#10B981" />
                        </View>
                        <Text
                          style={{
                            flex: 1,
                            fontSize: 13,
                            fontFamily: fonts.medium,
                            color: isDarkMode ? "#CBD5E1" : "#475569",
                          }}
                          numberOfLines={1}
                        >
                          {selectedCandidate.phone ||
                            selectedCandidate.phoneNumber}
                        </Text>
                        <Icon
                          name="content-copy"
                          size={13}
                          color={isDarkMode ? "#475569" : "#CBD5E1"}
                        />
                      </TouchableOpacity>
                    )}
                    {selectedCandidate.location && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 10,
                          marginBottom: 10,
                        }}
                      >
                        <View
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: 8,
                            backgroundColor: "#EFF6FF",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon name="location-on" size={15} color="#3B82F6" />
                        </View>
                        <Text
                          style={{
                            flex: 1,
                            fontSize: 13,
                            fontFamily: fonts.medium,
                            color: isDarkMode ? "#CBD5E1" : "#475569",
                          }}
                          numberOfLines={1}
                        >
                          {selectedCandidate.location}
                        </Text>
                      </View>
                    )}
                    {selectedCandidate.currentCompany && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 10,
                          marginBottom: 10,
                        }}
                      >
                        <View
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: 8,
                            backgroundColor: "#FFF7ED",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon name="business" size={15} color="#F59E0B" />
                        </View>
                        <Text
                          style={{
                            flex: 1,
                            fontSize: 13,
                            fontFamily: fonts.medium,
                            color: isDarkMode ? "#CBD5E1" : "#475569",
                          }}
                          numberOfLines={1}
                        >
                          {selectedCandidate.currentCompany}
                        </Text>
                      </View>
                    )}
                    {selectedCandidate.dateOfBirth && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 10,
                          marginBottom: 10,
                        }}
                      >
                        <View
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: 8,
                            backgroundColor: "#FFF7ED",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon name="cake" size={15} color="#F59E0B" />
                        </View>
                        <Text
                          style={{
                            flex: 1,
                            fontSize: 13,
                            fontFamily: fonts.medium,
                            color: isDarkMode ? "#CBD5E1" : "#475569",
                          }}
                          numberOfLines={1}
                        >
                          {selectedCandidate.dateOfBirth}
                          {(() => {
                            try {
                              const a = Math.floor(
                                (Date.now() -
                                  new Date(
                                    selectedCandidate.dateOfBirth,
                                  ).getTime()) /
                                  (365.25 * 24 * 60 * 60 * 1000),
                              );
                              return a > 0 && a < 100 ? ` · ${a} yrs` : "";
                            } catch {
                              return "";
                            }
                          })()}
                        </Text>
                      </View>
                    )}

                    {/* Divider */}
                    <View
                      style={{
                        height: 1,
                        backgroundColor: isDarkMode ? "#334155" : "#E2E8F0",
                        marginVertical: 14,
                      }}
                    />

                    {/* Stats */}
                    <Text
                      style={{
                        fontSize: 10,
                        fontFamily: fonts.bold,
                        color: isDarkMode ? "#475569" : "#94A3B8",
                        letterSpacing: 1.2,
                        textTransform: "uppercase",
                        marginBottom: 10,
                      }}
                    >
                      Quick Stats
                    </Text>
                    <View style={{ gap: 7 }}>
                      {selectedCandidate.experienceLevel && (
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.medium,
                              color: isDarkMode ? "#94A3B8" : "#64748B",
                            }}
                          >
                            Level
                          </Text>
                          <View
                            style={{
                              paddingHorizontal: 9,
                              paddingVertical: 3,
                              borderRadius: 6,
                              backgroundColor: "#ECFDF5",
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.bold,
                                color: "#059669",
                              }}
                            >
                              {selectedCandidate.experienceLevel}
                            </Text>
                          </View>
                        </View>
                      )}
                      {(selectedCandidate.yearsOfExperience ||
                        selectedCandidate.experience) && (
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.medium,
                              color: isDarkMode ? "#94A3B8" : "#64748B",
                            }}
                          >
                            Experience
                          </Text>
                          <View
                            style={{
                              paddingHorizontal: 9,
                              paddingVertical: 3,
                              borderRadius: 6,
                              backgroundColor: "#F3E8FF",
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.bold,
                                color: "#7C3AED",
                              }}
                            >
                              {selectedCandidate.yearsOfExperience ||
                                selectedCandidate.experience}{" "}
                              yrs
                            </Text>
                          </View>
                        </View>
                      )}
                      {selectedCandidate.availability && (
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.medium,
                              color: isDarkMode ? "#94A3B8" : "#64748B",
                            }}
                          >
                            Availability
                          </Text>
                          <View
                            style={{
                              paddingHorizontal: 9,
                              paddingVertical: 3,
                              borderRadius: 6,
                              backgroundColor: "#EFF6FF",
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.bold,
                                color: "#2563EB",
                              }}
                            >
                              {selectedCandidate.availability}
                            </Text>
                          </View>
                        </View>
                      )}
                      {(selectedCandidate.workType ||
                        selectedCandidate.preferredWorkType) && (
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.medium,
                              color: isDarkMode ? "#94A3B8" : "#64748B",
                            }}
                          >
                            Work Mode
                          </Text>
                          <View
                            style={{
                              paddingHorizontal: 9,
                              paddingVertical: 3,
                              borderRadius: 6,
                              backgroundColor: "#FEF3C7",
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.bold,
                                color: "#D97706",
                              }}
                            >
                              {selectedCandidate.workType ||
                                selectedCandidate.preferredWorkType}
                            </Text>
                          </View>
                        </View>
                      )}
                      {selectedCandidate.employmentType && (
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.medium,
                              color: isDarkMode ? "#94A3B8" : "#64748B",
                            }}
                          >
                            Employment
                          </Text>
                          <View
                            style={{
                              paddingHorizontal: 9,
                              paddingVertical: 3,
                              borderRadius: 6,
                              backgroundColor: isDarkMode
                                ? "#334155"
                                : "#F1F5F9",
                              borderWidth: 1,
                              borderColor: isDarkMode ? "#475569" : "#E2E8F0",
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.bold,
                                color: isDarkMode ? "#CBD5E1" : "#475569",
                              }}
                            >
                              {selectedCandidate.employmentType}
                            </Text>
                          </View>
                        </View>
                      )}
                      {selectedCandidate.noticePeriod && (
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.medium,
                              color: isDarkMode ? "#94A3B8" : "#64748B",
                            }}
                          >
                            Notice Period
                          </Text>
                          <View
                            style={{
                              paddingHorizontal: 9,
                              paddingVertical: 3,
                              borderRadius: 6,
                              backgroundColor: "#FEE2E2",
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.bold,
                                color: "#DC2626",
                              }}
                            >
                              {selectedCandidate.noticePeriod}
                            </Text>
                          </View>
                        </View>
                      )}
                    </View>

                    {/* Salary */}
                    {selectedCandidate.salaryExpectation && (
                      <>
                        <View
                          style={{
                            height: 1,
                            backgroundColor: isDarkMode ? "#334155" : "#E2E8F0",
                            marginVertical: 14,
                          }}
                        />
                        <View
                          style={{
                            padding: 12,
                            backgroundColor: isDarkMode ? "#052E16" : "#ECFDF5",
                            borderRadius: 10,
                            borderWidth: 1,
                            borderColor: isDarkMode ? "#14532D" : "#BBF7D0",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.medium,
                              color: isDarkMode ? "#4ADE80" : "#059669",
                              marginBottom: 4,
                            }}
                          >
                            💰 Salary Expectation
                          </Text>
                          <Text
                            style={{
                              fontSize: 16,
                              fontFamily: fonts.bold,
                              color: isDarkMode ? "#4ADE80" : "#10B981",
                            }}
                          >
                            {selectedCandidate.salaryExpectation}
                          </Text>
                        </View>
                      </>
                    )}

                    {/* Profile completeness */}
                    {selectedCandidate.profileCompleteness !== undefined && (
                      <>
                        <View
                          style={{
                            height: 1,
                            backgroundColor: isDarkMode ? "#334155" : "#E2E8F0",
                            marginVertical: 14,
                          }}
                        />
                        <View
                          style={{
                            flexDirection: "row",
                            justifyContent: "space-between",
                            marginBottom: 6,
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: isDarkMode ? "#64748B" : "#94A3B8",
                            }}
                          >
                            Profile Complete
                          </Text>
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.bold,
                              color:
                                selectedCandidate.profileCompleteness >= 80
                                  ? "#10B981"
                                  : selectedCandidate.profileCompleteness >= 50
                                  ? "#F59E0B"
                                  : "#EF4444",
                            }}
                          >
                            {selectedCandidate.profileCompleteness}%
                          </Text>
                        </View>
                        <View
                          style={{
                            height: 5,
                            backgroundColor: isDarkMode ? "#334155" : "#E2E8F0",
                            borderRadius: 3,
                          }}
                        >
                          <View
                            style={{
                              height: 5,
                              width: `${selectedCandidate.profileCompleteness}%`,
                              backgroundColor:
                                selectedCandidate.profileCompleteness >= 80
                                  ? "#10B981"
                                  : selectedCandidate.profileCompleteness >= 50
                                  ? "#F59E0B"
                                  : "#EF4444",
                              borderRadius: 3,
                            }}
                          />
                        </View>
                      </>
                    )}

                    {/* Joined date */}
                    {selectedCandidate.createdAt && (
                      <>
                        <View
                          style={{
                            height: 1,
                            backgroundColor: isDarkMode ? "#334155" : "#E2E8F0",
                            marginVertical: 14,
                          }}
                        />
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 7,
                          }}
                        >
                          <Icon
                            name="calendar-today"
                            size={13}
                            color={isDarkMode ? "#475569" : "#94A3B8"}
                          />
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: isDarkMode ? "#475569" : "#94A3B8",
                            }}
                          >
                            Joined{" "}
                            {(() => {
                              try {
                                const d = selectedCandidate.createdAt?.seconds
                                  ? new Date(
                                      selectedCandidate.createdAt.seconds *
                                        1000,
                                    )
                                  : new Date(selectedCandidate.createdAt);
                                return d.toLocaleDateString("en-US", {
                                  month: "long",
                                  year: "numeric",
                                });
                              } catch {
                                return "";
                              }
                            })()}
                          </Text>
                        </View>
                      </>
                    )}

                    {/* Action buttons */}
                    <View
                      style={{
                        height: 1,
                        backgroundColor: isDarkMode ? "#334155" : "#E2E8F0",
                        marginTop: 18,
                        marginBottom: 14,
                      }}
                    />
                    <TouchableOpacity
                      style={{
                        backgroundColor: "#6366F1",
                        paddingVertical: 13,
                        borderRadius: 11,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 8,
                        shadowColor: "#6366F1",
                        shadowOffset: { width: 0, height: 4 },
                        shadowOpacity: 0.3,
                        shadowRadius: 8,
                        elevation: 4,
                        marginBottom: 8,
                      }}
                      onPress={() => {
                        setSelectedCandidate(null);
                        Alert.alert(
                          "Contact",
                          `Send message to ${
                            selectedCandidate?.fullName ||
                            selectedCandidate?.email
                          }`,
                        );
                      }}
                    >
                      <Icon name="mail" size={17} color="#FFFFFF" />
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: fonts.bold,
                          color: "#FFFFFF",
                        }}
                      >
                        Send Message
                      </Text>
                    </TouchableOpacity>
                    {(selectedCandidate.cvUrl ||
                      selectedCandidate.portfolio?.cvUrl) && (
                      <TouchableOpacity
                        style={{
                          paddingVertical: 11,
                          borderRadius: 11,
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 8,
                          borderWidth: 1.5,
                          borderColor: "#6366F1",
                        }}
                        onPress={() =>
                          Platform.OS === "web" &&
                          window.open(
                            selectedCandidate.cvUrl ||
                              selectedCandidate.portfolio?.cvUrl,
                            "_blank",
                          )
                        }
                      >
                        <Icon name="description" size={17} color="#6366F1" />
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: fonts.bold,
                            color: "#6366F1",
                          }}
                        >
                          View Resume
                        </Text>
                      </TouchableOpacity>
                    )}
                  </ScrollView>
                </View>

                {/* ─── RIGHT CONTENT PANEL ─── */}
                <ScrollView
                  style={{
                    flex: 1,
                    backgroundColor: isDarkMode ? "#0F172A" : "#F8FAFC",
                  }}
                  contentContainerStyle={{ padding: isMobile ? 20 : 28 }}
                  showsVerticalScrollIndicator={false}
                >
                  {/* ── Interested Industry ── */}
                  {(selectedCandidate.interestedCategory ||
                    (selectedCandidate.interestedSubcategories &&
                      selectedCandidate.interestedSubcategories.length >
                        0)) && (
                    <View style={{ marginBottom: 28 }}>
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.bold,
                          color: isDarkMode ? "#475569" : "#94A3B8",
                          textTransform: "uppercase",
                          letterSpacing: 1.2,
                          marginBottom: 12,
                        }}
                      >
                        Interested Industry
                      </Text>
                      <View
                        style={{
                          padding: 14,
                          backgroundColor: isDarkMode ? "#1E293B" : "#FFFFFF",
                          borderRadius: 12,
                          borderWidth: 1,
                          borderColor: isDarkMode ? "#334155" : "#E2E8F0",
                        }}
                      >
                        {selectedCandidate.interestedCategory && (
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 10,
                              marginBottom:
                                selectedCandidate.interestedSubcategories &&
                                selectedCandidate.interestedSubcategories
                                  .length > 0
                                  ? 10
                                  : 0,
                            }}
                          >
                            <View
                              style={{
                                width: 32,
                                height: 32,
                                borderRadius: 8,
                                backgroundColor: "#EEF2FF",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Icon name="category" size={16} color="#6366F1" />
                            </View>
                            <View style={{ flex: 1 }}>
                              <Text
                                style={{
                                  fontSize: 11,
                                  fontFamily: fonts.medium,
                                  color: isDarkMode ? "#475569" : "#94A3B8",
                                  marginBottom: 1,
                                }}
                              >
                                Category
                              </Text>
                              <Text
                                style={{
                                  fontSize: 14,
                                  fontFamily: fonts.bold,
                                  color: isDarkMode ? "#F1F5F9" : "#0F172A",
                                }}
                              >
                                {resolveCategoryName(
                                  selectedCandidate.interestedCategory,
                                )}
                              </Text>
                            </View>
                          </View>
                        )}
                        {selectedCandidate.interestedSubcategories &&
                          selectedCandidate.interestedSubcategories.length >
                            0 && (
                            <View
                              style={{
                                paddingTop: selectedCandidate.interestedCategory
                                  ? 10
                                  : 0,
                                borderTopWidth:
                                  selectedCandidate.interestedCategory ? 1 : 0,
                                borderTopColor: isDarkMode
                                  ? "#334155"
                                  : "#F1F5F9",
                              }}
                            >
                              <View
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 10,
                                  marginBottom: 8,
                                }}
                              >
                                <View
                                  style={{
                                    width: 32,
                                    height: 32,
                                    borderRadius: 8,
                                    backgroundColor: isDarkMode
                                      ? "#334155"
                                      : "#F1F5F9",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Icon
                                    name="label"
                                    size={16}
                                    color={isDarkMode ? "#94A3B8" : "#64748B"}
                                  />
                                </View>
                                <Text
                                  style={{
                                    fontSize: 11,
                                    fontFamily: fonts.medium,
                                    color: isDarkMode ? "#475569" : "#94A3B8",
                                  }}
                                >
                                  Subcategories
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  flexWrap: "wrap",
                                  gap: 6,
                                  paddingLeft: 42,
                                }}
                              >
                                {selectedCandidate.interestedSubcategories.map(
                                  (sub: string, i: number) => (
                                    <View
                                      key={i}
                                      style={{
                                        paddingHorizontal: 10,
                                        paddingVertical: 4,
                                        borderRadius: 8,
                                        backgroundColor: isDarkMode
                                          ? "#334155"
                                          : "#F1F5F9",
                                        borderWidth: 1,
                                        borderColor: isDarkMode
                                          ? "#475569"
                                          : "#E2E8F0",
                                      }}
                                    >
                                      <Text
                                        style={{
                                          fontSize: 12,
                                          fontFamily: fonts.medium,
                                          color: isDarkMode
                                            ? "#CBD5E1"
                                            : "#64748B",
                                        }}
                                      >
                                        {resolveCategoryName(sub)}
                                      </Text>
                                    </View>
                                  ),
                                )}
                              </View>
                            </View>
                          )}
                      </View>
                    </View>
                  )}

                  {/* ── Bio ── */}
                  {selectedCandidate.bio && (
                    <View style={{ marginBottom: 28 }}>
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.bold,
                          color: isDarkMode ? "#475569" : "#94A3B8",
                          textTransform: "uppercase",
                          letterSpacing: 1.2,
                          marginBottom: 10,
                        }}
                      >
                        About
                      </Text>
                      <Text
                        style={{
                          fontSize: 15,
                          fontFamily: fonts.regular,
                          color: isDarkMode ? "#CBD5E1" : "#334155",
                          lineHeight: 26,
                        }}
                      >
                        {selectedCandidate.bio}
                      </Text>
                    </View>
                  )}

                  {/* ── Skills & Tags ── */}
                  {(selectedCandidate.skills?.length > 0 ||
                    selectedCandidate.interestedTags?.length > 0) && (
                    <View style={{ marginBottom: 28 }}>
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.bold,
                          color: isDarkMode ? "#475569" : "#94A3B8",
                          textTransform: "uppercase",
                          letterSpacing: 1.2,
                          marginBottom: 10,
                        }}
                      >
                        Skills & Expertise
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                        }}
                      >
                        {selectedCandidate.skills &&
                          selectedCandidate.skills.map(
                            (skill: string, idx: number) => (
                              <View
                                key={`skill-${idx}`}
                                style={{
                                  paddingHorizontal: 13,
                                  paddingVertical: 6,
                                  borderRadius: 20,
                                  backgroundColor: isDarkMode
                                    ? "#1E293B"
                                    : "#FFFFFF",
                                  borderWidth: 1,
                                  borderColor: isDarkMode
                                    ? "#334155"
                                    : "#E2E8F0",
                                  shadowColor: "#000",
                                  shadowOffset: { width: 0, height: 1 },
                                  shadowOpacity: 0.05,
                                  shadowRadius: 2,
                                  elevation: 1,
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 13,
                                    fontFamily: fonts.semiBold,
                                    color: isDarkMode ? "#CBD5E1" : "#334155",
                                  }}
                                >
                                  {skill}
                                </Text>
                              </View>
                            ),
                          )}
                        {selectedCandidate.interestedTags &&
                          selectedCandidate.interestedTags.map(
                            (tag: string, idx: number) => (
                              <View
                                key={`tag-${idx}`}
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 4,
                                  paddingHorizontal: 11,
                                  paddingVertical: 5,
                                  borderRadius: 20,
                                  backgroundColor: isDarkMode
                                    ? "#1C1A2E"
                                    : "#F5F3FF",
                                  borderWidth: 1,
                                  borderColor: isDarkMode
                                    ? "#4C3D7A"
                                    : "#DDD6FE",
                                }}
                              >
                                <Icon
                                  name="local-offer"
                                  size={11}
                                  color="#7C3AED"
                                />
                                <Text
                                  style={{
                                    fontSize: 12,
                                    fontFamily: fonts.semiBold,
                                    color: isDarkMode ? "#A78BFA" : "#6D28D9",
                                  }}
                                >
                                  {tag}
                                </Text>
                              </View>
                            ),
                          )}
                      </View>
                    </View>
                  )}

                  {/* ── Languages ── */}
                  {selectedCandidate.languages &&
                    selectedCandidate.languages.length > 0 && (
                      <View style={{ marginBottom: 28 }}>
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.bold,
                            color: isDarkMode ? "#475569" : "#94A3B8",
                            textTransform: "uppercase",
                            letterSpacing: 1.2,
                            marginBottom: 10,
                          }}
                        >
                          Languages
                        </Text>
                        <View
                          style={{
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 8,
                          }}
                        >
                          {selectedCandidate.languages.map(
                            (lang: string, idx: number) => (
                              <View
                                key={idx}
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 6,
                                  paddingHorizontal: 13,
                                  paddingVertical: 7,
                                  borderRadius: 10,
                                  backgroundColor: isDarkMode
                                    ? "#1E293B"
                                    : "#FFFFFF",
                                  borderWidth: 1,
                                  borderColor: isDarkMode
                                    ? "#334155"
                                    : "#E2E8F0",
                                }}
                              >
                                <Icon
                                  name="language"
                                  size={14}
                                  color="#6366F1"
                                />
                                <Text
                                  style={{
                                    fontSize: 13,
                                    fontFamily: fonts.semiBold,
                                    color: isDarkMode ? "#CBD5E1" : "#334155",
                                  }}
                                >
                                  {lang}
                                </Text>
                              </View>
                            ),
                          )}
                        </View>
                      </View>
                    )}

                  {/* ── Work Experience (timeline) ── */}
                  {selectedCandidate.workExperience &&
                    selectedCandidate.workExperience.length > 0 && (
                      <View style={{ marginBottom: 28 }}>
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.bold,
                            color: isDarkMode ? "#475569" : "#94A3B8",
                            textTransform: "uppercase",
                            letterSpacing: 1.2,
                            marginBottom: 16,
                          }}
                        >
                          Work Experience
                        </Text>
                        <View style={{ gap: 0 }}>
                          {selectedCandidate.workExperience.map(
                            (exp: any, idx: number) => (
                              <View
                                key={idx}
                                style={{ flexDirection: "row", gap: 14 }}
                              >
                                <View
                                  style={{ alignItems: "center", width: 36 }}
                                >
                                  <View
                                    style={{
                                      width: 36,
                                      height: 36,
                                      borderRadius: 8,
                                      backgroundColor: isDarkMode
                                        ? "#1E293B"
                                        : "#FFFFFF",
                                      borderWidth: 1.5,
                                      borderColor: "#6366F1",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Icon
                                      name="work-outline"
                                      size={16}
                                      color="#6366F1"
                                    />
                                  </View>
                                  {idx <
                                    selectedCandidate.workExperience.length -
                                      1 && (
                                    <View
                                      style={{
                                        width: 2,
                                        flex: 1,
                                        minHeight: 20,
                                        backgroundColor: isDarkMode
                                          ? "#334155"
                                          : "#E2E8F0",
                                        marginTop: 4,
                                      }}
                                    />
                                  )}
                                </View>
                                <View
                                  style={{
                                    flex: 1,
                                    paddingBottom:
                                      idx <
                                      selectedCandidate.workExperience.length -
                                        1
                                        ? 20
                                        : 0,
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: 15,
                                      fontFamily: fonts.bold,
                                      color: isDarkMode ? "#F1F5F9" : "#0F172A",
                                      marginBottom: 2,
                                    }}
                                  >
                                    {exp.position || "Position"}
                                  </Text>
                                  {exp.company && (
                                    <Text
                                      style={{
                                        fontSize: 13,
                                        fontFamily: fonts.semiBold,
                                        color: "#6366F1",
                                        marginBottom: 4,
                                      }}
                                    >
                                      {exp.company}
                                    </Text>
                                  )}
                                  {(exp.startDate || exp.endDate) && (
                                    <View
                                      style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        gap: 4,
                                        marginBottom: 6,
                                      }}
                                    >
                                      <Icon
                                        name="schedule"
                                        size={12}
                                        color={
                                          isDarkMode ? "#475569" : "#94A3B8"
                                        }
                                      />
                                      <Text
                                        style={{
                                          fontSize: 12,
                                          fontFamily: fonts.medium,
                                          color: isDarkMode
                                            ? "#475569"
                                            : "#94A3B8",
                                        }}
                                      >
                                        {exp.startDate} –{" "}
                                        {exp.endDate || "Present"}
                                      </Text>
                                    </View>
                                  )}
                                  {exp.description && (
                                    <Text
                                      style={{
                                        fontSize: 13,
                                        fontFamily: fonts.regular,
                                        color: isDarkMode
                                          ? "#94A3B8"
                                          : "#475569",
                                        lineHeight: 20,
                                      }}
                                    >
                                      {exp.description}
                                    </Text>
                                  )}
                                </View>
                              </View>
                            ),
                          )}
                        </View>
                      </View>
                    )}

                  {/* ── Education ── */}
                  {selectedCandidate.education && (
                    <View style={{ marginBottom: 28 }}>
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.bold,
                          color: isDarkMode ? "#475569" : "#94A3B8",
                          textTransform: "uppercase",
                          letterSpacing: 1.2,
                          marginBottom: 12,
                        }}
                      >
                        Education
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 14,
                          padding: 16,
                          backgroundColor: isDarkMode ? "#1E293B" : "#FFFFFF",
                          borderRadius: 12,
                          borderWidth: 1,
                          borderColor: isDarkMode ? "#334155" : "#E2E8F0",
                        }}
                      >
                        <View
                          style={{
                            width: 38,
                            height: 38,
                            borderRadius: 8,
                            backgroundColor: "#F3E8FF",
                            borderWidth: 1.5,
                            borderColor: "#8B5CF6",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon name="school" size={18} color="#8B5CF6" />
                        </View>
                        <View style={{ flex: 1 }}>
                          <Text
                            style={{
                              fontSize: 15,
                              fontFamily: fonts.bold,
                              color: isDarkMode ? "#F1F5F9" : "#0F172A",
                              marginBottom: 2,
                            }}
                          >
                            {typeof selectedCandidate.education === "string"
                              ? selectedCandidate.education
                              : selectedCandidate.education.degree || "Degree"}
                          </Text>
                          {typeof selectedCandidate.education === "object" &&
                            selectedCandidate.education.institution && (
                              <Text
                                style={{
                                  fontSize: 13,
                                  fontFamily: fonts.medium,
                                  color: isDarkMode ? "#64748B" : "#64748B",
                                  marginBottom: 2,
                                }}
                              >
                                {selectedCandidate.education.institution}
                              </Text>
                            )}
                          {typeof selectedCandidate.education === "object" &&
                            selectedCandidate.education.year && (
                              <Text
                                style={{
                                  fontSize: 12,
                                  fontFamily: fonts.regular,
                                  color: isDarkMode ? "#475569" : "#94A3B8",
                                }}
                              >
                                {selectedCandidate.education.year}
                              </Text>
                            )}
                        </View>
                      </View>
                    </View>
                  )}

                  {/* ── Certifications ── */}
                  {selectedCandidate.certifications &&
                    selectedCandidate.certifications.length > 0 && (
                      <View style={{ marginBottom: 28 }}>
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.bold,
                            color: isDarkMode ? "#475569" : "#94A3B8",
                            textTransform: "uppercase",
                            letterSpacing: 1.2,
                            marginBottom: 12,
                          }}
                        >
                          Certifications
                        </Text>
                        <View style={{ gap: 8 }}>
                          {selectedCandidate.certifications.map(
                            (cert: any, idx: number) => (
                              <View
                                key={idx}
                                style={{
                                  flexDirection: "row",
                                  alignItems: "flex-start",
                                  gap: 12,
                                  padding: 14,
                                  backgroundColor: isDarkMode
                                    ? "#1E293B"
                                    : "#FFFFFF",
                                  borderRadius: 10,
                                  borderWidth: 1,
                                  borderColor: isDarkMode
                                    ? "#334155"
                                    : "#E2E8F0",
                                }}
                              >
                                <Icon
                                  name="verified"
                                  size={20}
                                  color="#10B981"
                                  style={{ marginTop: 1 }}
                                />
                                <View style={{ flex: 1 }}>
                                  <Text
                                    style={{
                                      fontSize: 14,
                                      fontFamily: fonts.bold,
                                      color: isDarkMode ? "#F1F5F9" : "#0F172A",
                                      marginBottom: 1,
                                    }}
                                  >
                                    {typeof cert === "string"
                                      ? cert
                                      : cert.name}
                                  </Text>
                                  {typeof cert === "object" && cert.issuer && (
                                    <Text
                                      style={{
                                        fontSize: 12,
                                        fontFamily: fonts.medium,
                                        color: isDarkMode
                                          ? "#64748B"
                                          : "#94A3B8",
                                      }}
                                    >
                                      {cert.issuer}
                                      {cert.year ? ` · ${cert.year}` : ""}
                                    </Text>
                                  )}
                                </View>
                              </View>
                            ),
                          )}
                        </View>
                      </View>
                    )}

                  {/* ── Achievements ── */}
                  {(selectedCandidate.achievements ||
                    selectedCandidate.portfolio?.achievements) && (
                    <View style={{ marginBottom: 28 }}>
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.bold,
                          color: isDarkMode ? "#475569" : "#94A3B8",
                          textTransform: "uppercase",
                          letterSpacing: 1.2,
                          marginBottom: 12,
                        }}
                      >
                        Achievements
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          gap: 12,
                          padding: 16,
                          backgroundColor: isDarkMode ? "#1C1A0A" : "#FFFBEB",
                          borderRadius: 12,
                          borderWidth: 1,
                          borderColor: isDarkMode ? "#713F12" : "#FDE68A",
                        }}
                      >
                        <Icon
                          name="emoji-events"
                          size={22}
                          color="#F59E0B"
                          style={{ marginTop: 2 }}
                        />
                        <Text
                          style={{
                            flex: 1,
                            fontSize: 14,
                            fontFamily: fonts.regular,
                            color: isDarkMode ? "#FDE68A" : "#78350F",
                            lineHeight: 22,
                          }}
                        >
                          {selectedCandidate.achievements ||
                            selectedCandidate.portfolio?.achievements}
                        </Text>
                      </View>
                    </View>
                  )}

                  {/* ── Preferred Locations ── */}
                  {selectedCandidate.preferredLocations &&
                    selectedCandidate.preferredLocations.length > 0 && (
                      <View style={{ marginBottom: 28 }}>
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.bold,
                            color: isDarkMode ? "#475569" : "#94A3B8",
                            textTransform: "uppercase",
                            letterSpacing: 1.2,
                            marginBottom: 12,
                          }}
                        >
                          Open to Work In
                        </Text>
                        <View
                          style={{
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 8,
                          }}
                        >
                          {selectedCandidate.preferredLocations.map(
                            (loc: string, i: number) => (
                              <View
                                key={i}
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 5,
                                  paddingHorizontal: 11,
                                  paddingVertical: 6,
                                  borderRadius: 8,
                                  backgroundColor: "#EFF6FF",
                                  borderWidth: 1,
                                  borderColor: "#BFDBFE",
                                }}
                              >
                                <Icon name="place" size={13} color="#3B82F6" />
                                <Text
                                  style={{
                                    fontSize: 12,
                                    fontFamily: fonts.medium,
                                    color: "#1D4ED8",
                                  }}
                                >
                                  {loc}
                                </Text>
                              </View>
                            ),
                          )}
                        </View>
                      </View>
                    )}

                  {/* ── Links & Socials ── */}
                  {(selectedCandidate.linkedin ||
                    selectedCandidate.github ||
                    selectedCandidate.portfolio?.portfolioUrl ||
                    selectedCandidate.website ||
                    selectedCandidate.socialLinks?.linkedin ||
                    selectedCandidate.socialLinks?.github ||
                    selectedCandidate.socialLinks?.portfolio ||
                    selectedCandidate.socialLinks?.twitter ||
                    selectedCandidate.socialLinks?.instagram) && (
                    <View style={{ marginBottom: 12 }}>
                      <Text
                        style={{
                          fontSize: 11,
                          fontFamily: fonts.bold,
                          color: isDarkMode ? "#475569" : "#94A3B8",
                          textTransform: "uppercase",
                          letterSpacing: 1.2,
                          marginBottom: 12,
                        }}
                      >
                        Links & Socials
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                        }}
                      >
                        {(selectedCandidate.linkedin ||
                          selectedCandidate.socialLinks?.linkedin) && (
                          <TouchableOpacity
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 7,
                              paddingHorizontal: 13,
                              paddingVertical: 8,
                              borderRadius: 9,
                              backgroundColor: isDarkMode
                                ? "#1E293B"
                                : "#FFFFFF",
                              borderWidth: 1,
                              borderColor: "#0A66C2",
                            }}
                            onPress={() =>
                              Platform.OS === "web" &&
                              window.open(
                                selectedCandidate.linkedin ||
                                  selectedCandidate.socialLinks?.linkedin,
                                "_blank",
                              )
                            }
                          >
                            <Icon name="link" size={15} color="#0A66C2" />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.bold,
                                color: "#0A66C2",
                              }}
                            >
                              LinkedIn
                            </Text>
                          </TouchableOpacity>
                        )}
                        {(selectedCandidate.github ||
                          selectedCandidate.socialLinks?.github) && (
                          <TouchableOpacity
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 7,
                              paddingHorizontal: 13,
                              paddingVertical: 8,
                              borderRadius: 9,
                              backgroundColor: isDarkMode
                                ? "#1E293B"
                                : "#FFFFFF",
                              borderWidth: 1,
                              borderColor: isDarkMode ? "#475569" : "#D1D5DB",
                            }}
                            onPress={() =>
                              Platform.OS === "web" &&
                              window.open(
                                selectedCandidate.github ||
                                  selectedCandidate.socialLinks?.github,
                                "_blank",
                              )
                            }
                          >
                            <Icon
                              name="code"
                              size={15}
                              color={isDarkMode ? "#CBD5E1" : "#374151"}
                            />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.bold,
                                color: isDarkMode ? "#CBD5E1" : "#374151",
                              }}
                            >
                              GitHub
                            </Text>
                          </TouchableOpacity>
                        )}
                        {(selectedCandidate.portfolio?.portfolioUrl ||
                          selectedCandidate.socialLinks?.portfolio ||
                          selectedCandidate.website) && (
                          <TouchableOpacity
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 7,
                              paddingHorizontal: 13,
                              paddingVertical: 8,
                              borderRadius: 9,
                              backgroundColor: isDarkMode
                                ? "#1E293B"
                                : "#FFFFFF",
                              borderWidth: 1,
                              borderColor: "#8B5CF6",
                            }}
                            onPress={() =>
                              Platform.OS === "web" &&
                              window.open(
                                selectedCandidate.portfolio?.portfolioUrl ||
                                  selectedCandidate.socialLinks?.portfolio ||
                                  selectedCandidate.website,
                                "_blank",
                              )
                            }
                          >
                            <Icon name="language" size={15} color="#8B5CF6" />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.bold,
                                color: "#8B5CF6",
                              }}
                            >
                              Portfolio
                            </Text>
                          </TouchableOpacity>
                        )}
                        {selectedCandidate.socialLinks?.twitter && (
                          <TouchableOpacity
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 7,
                              paddingHorizontal: 13,
                              paddingVertical: 8,
                              borderRadius: 9,
                              backgroundColor: isDarkMode
                                ? "#1E293B"
                                : "#FFFFFF",
                              borderWidth: 1,
                              borderColor: "#1DA1F2",
                            }}
                            onPress={() =>
                              Platform.OS === "web" &&
                              window.open(
                                selectedCandidate.socialLinks.twitter,
                                "_blank",
                              )
                            }
                          >
                            <Icon
                              name="alternate-email"
                              size={15}
                              color="#1DA1F2"
                            />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.bold,
                                color: "#1DA1F2",
                              }}
                            >
                              Twitter / X
                            </Text>
                          </TouchableOpacity>
                        )}
                        {selectedCandidate.socialLinks?.instagram && (
                          <TouchableOpacity
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 7,
                              paddingHorizontal: 13,
                              paddingVertical: 8,
                              borderRadius: 9,
                              backgroundColor: isDarkMode
                                ? "#1E293B"
                                : "#FFFFFF",
                              borderWidth: 1,
                              borderColor: "#E1306C",
                            }}
                            onPress={() =>
                              Platform.OS === "web" &&
                              window.open(
                                selectedCandidate.socialLinks.instagram,
                                "_blank",
                              )
                            }
                          >
                            <Icon
                              name="photo-camera"
                              size={15}
                              color="#E1306C"
                            />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.bold,
                                color: "#E1306C",
                              }}
                            >
                              Instagram
                            </Text>
                          </TouchableOpacity>
                        )}
                      </View>
                    </View>
                  )}
                </ScrollView>
              </>
            )}
          </View>
        </View>
      </Modal>
    </>
  );
}

// Company Profile Content
function CompanyProfileContent({ colors, userData, user, isDarkMode, t }: any) {
  const dimensions = Dimensions.get("window");
  const isMobile = dimensions.width < 768;

  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);

  const companyProfile = userData?.companyProfile || {};
  const verificationStatus = companyProfile.verificationStatus || "pending";

  const [companyName, setCompanyName] = useState(
    companyProfile.companyName || "",
  );
  const [companyDescription, setCompanyDescription] = useState(
    companyProfile.companyDescription || "",
  );
  const [industry, setIndustry] = useState(companyProfile.industry || "");
  const [companySize, setCompanySize] = useState(
    companyProfile.companySize || "",
  );
  const [foundedYear, setFoundedYear] = useState(
    companyProfile.foundedYear || "",
  );
  const [website, setWebsite] = useState(companyProfile.website || "");
  const [companyEmail, setCompanyEmail] = useState(
    companyProfile.companyEmail || "",
  );
  const [companyPhone, setCompanyPhone] = useState(
    companyProfile.companyPhone || "",
  );
  const [address, setAddress] = useState(companyProfile.address || "");
  const [city, setCity] = useState(companyProfile.city || "");
  const [country, setCountry] = useState(companyProfile.country || "Ethiopia");
  const [logoUrl, setLogoUrl] = useState(companyProfile.logoUrl || "");
  const [linkedIn, setLinkedIn] = useState(companyProfile.linkedIn || "");
  const [facebook, setFacebook] = useState(companyProfile.facebook || "");
  const [twitter, setTwitter] = useState(companyProfile.twitter || "");

  const pickLogo = async () => {
    try {
      setUploadingLogo(true);
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [1, 1],
        quality: 0.8,
      });

      if (!result.canceled && result.assets[0]) {
        const uploadedUrl = await uploadImage(
          result.assets[0].uri,
          "company-logos",
        );
        if (uploadedUrl) {
          setLogoUrl(uploadedUrl);
        }
      }
    } catch (error) {
      Alert.alert("Error", "Failed to upload logo");
    } finally {
      setUploadingLogo(false);
    }
  };

  const uploadImage = async (uri: string, folder: string) => {
    try {
      const response = await fetch(uri);
      const blob = await response.blob();

      // Get the actual MIME type from the blob
      const mimeType = blob.type || "image/jpeg";

      // Determine file extension from MIME type
      const extension = mimeType.split("/")[1] || "jpg";
      const filename = `${Date.now()}.${extension}`;

      // Convert blob to base64
      const reader = new FileReader();
      const base64Promise = new Promise<string>((resolve, reject) => {
        reader.onloadend = () => {
          const base64String = (reader.result as string).split(",")[1];
          resolve(base64String);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      const fileData = await base64Promise;

      // Call the secure upload function
      const secureFileUploadCallable = httpsCallable(
        functions,
        "secureFileUploadCallable",
      );
      const result = await secureFileUploadCallable({
        fileData,
        filename,
        mimeType,
        fileType: "company-logo",
      });

      const data = result.data as {
        success: boolean;
        downloadURL: string;
        error?: string;
      };

      if (!data.success) {
        throw new Error(data.error || "Upload failed");
      }

      return data.downloadURL;
    } catch (error) {
      console.error("Upload error:", error);
      return null;
    }
  };

  const handleSave = async () => {
    if (!user) return;

    try {
      setSaving(true);
      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, {
        companyProfile: {
          ...companyProfile,
          companyName,
          companyDescription,
          industry,
          companySize,
          foundedYear,
          website,
          companyEmail,
          companyPhone,
          address,
          city,
          country,
          logoUrl,
          linkedIn,
          facebook,
          twitter,
          updatedAt: new Date(),
        },
        updatedAt: new Date(),
      });
      Alert.alert("Success", "Company profile updated successfully!");
      setEditing(false);
    } catch (error) {
      Alert.alert("Error", "Failed to update company profile");
    } finally {
      setSaving(false);
    }
  };

  // Get verification status styling
  const getVerificationStyles = () => {
    if (verificationStatus === "approved") {
      return {
        bg: colors.success + "15",
        border: colors.success,
        text: colors.success,
        icon: "verified",
        title: t.cdYourCompanyVerified,
        message: t.cdYourCompanyVerified,
      };
    } else if (verificationStatus === "rejected") {
      return {
        bg: colors.danger + "15",
        border: colors.danger,
        text: colors.danger,
        icon: "cancel",
        title: t.cdVerificationRejected,
        message: t.cdContactSupportInfo,
      };
    }
    return {
      bg: colors.beeYellow + "15",
      border: colors.beeYellow,
      text: colors.beeYellow,
      icon: "pending",
      title: t.cdVerificationPending,
      message: t.cdUnderReview,
    };
  };

  const verificationStyle = getVerificationStyles();

  const isDark = isDarkMode;
  const bg = isDark ? "#0F1117" : "#F3F4F6";
  const card = isDark ? "#1A1D23" : "#FFFFFF";
  const txt = isDark ? "#F9FAFB" : "#0F172A";
  const muted = isDark ? "#6B7280" : "#9CA3AF";
  const borderC = isDark ? "#252932" : "#F0F0F0";

  // Mobile Input Field Component
  const MobileInputField = ({
    label,
    value,
    onChangeText,
    placeholder,
    multiline = false,
    keyboardType = "default",
    icon,
  }: any) => (
    <View style={{ marginBottom: 16 }}>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginBottom: 8,
          gap: 6,
        }}
      >
        {icon && <Icon name={icon} size={16} color={colors.beeYellow} />}
        <Text style={{ fontFamily: fonts.medium, fontSize: 13, color: muted }}>
          {label}
        </Text>
      </View>
      <TextInput
        style={{
          backgroundColor: editing
            ? isDark
              ? "#252932"
              : "#FFFFFF"
            : isDark
            ? "#1A1D23"
            : "#F0F0F0",
          borderRadius: 12,
          paddingHorizontal: 14,
          paddingVertical: 12,
          fontFamily: fonts.regular,
          fontSize: 14,
          color: txt,
          borderWidth: editing ? 1 : 0,
          borderColor: borderC,
          minHeight: multiline ? 100 : 48,
          textAlignVertical: multiline ? "top" : "center",
        }}
        value={value}
        onChangeText={onChangeText}
        editable={editing}
        placeholder={placeholder}
        placeholderTextColor={muted}
        multiline={multiline}
        keyboardType={keyboardType}
      />
    </View>
  );

  return (
    <View style={{ flex: 1, backgroundColor: bg }}>
      {isMobile ? (
        /* ========== MOBILE VIEW ========== */
        <ScrollView
          style={{ flex: 1 }}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{ paddingBottom: 100 }}
        >
          {/* ── Compact Strip Header ── */}
          <View
            style={{
              backgroundColor: isDark ? "#111318" : "#FFFFFF",
              paddingHorizontal: 16,
              paddingTop: 12,
              paddingBottom: 12,
              borderBottomWidth: 1,
              borderBottomColor: borderC,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 6,
                  backgroundColor: verificationStyle.bg,
                  paddingHorizontal: 12,
                  paddingVertical: 7,
                  borderRadius: 20,
                }}
              >
                <Icon
                  name={verificationStyle.icon}
                  size={14}
                  color={verificationStyle.text}
                />
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.semiBold,
                    color: verificationStyle.text,
                  }}
                >
                  {verificationStyle.title}
                </Text>
              </View>
              <TouchableOpacity
                onPress={() => (editing ? handleSave() : setEditing(true))}
                disabled={saving}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 6,
                  backgroundColor: editing
                    ? "#F59E0B"
                    : isDark
                    ? "#252932"
                    : "#F3F4F6",
                  paddingHorizontal: 14,
                  paddingVertical: 8,
                  borderRadius: 20,
                }}
              >
                {saving ? (
                  <ActivityIndicator
                    size="small"
                    color={editing ? "#1C1917" : txt}
                  />
                ) : (
                  <>
                    <Icon
                      name={editing ? "save" : "edit"}
                      size={16}
                      color={editing ? "#1C1917" : txt}
                    />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.semiBold,
                        color: editing ? "#1C1917" : txt,
                      }}
                    >
                      {editing ? "Save" : "Edit"}
                    </Text>
                  </>
                )}
              </TouchableOpacity>
            </View>
            {editing && (
              <TouchableOpacity
                onPress={() => setEditing(false)}
                style={{ marginTop: 8, alignItems: "flex-end" }}
              >
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.medium,
                    color: muted,
                  }}
                >
                  {t.cancelButton}
                </Text>
              </TouchableOpacity>
            )}
          </View>

          {/* Profile Header Card */}
          <View
            style={{
              backgroundColor: card,
              marginHorizontal: 16,
              marginTop: 16,
              borderRadius: 16,
              padding: 20,
              alignItems: "center",
              borderWidth: 1,
              borderColor: borderC,
            }}
          >
            {/* Logo */}
            <View style={{ position: "relative" }}>
              {logoUrl ? (
                <Image
                  source={{ uri: logoUrl }}
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: 50,
                    borderWidth: 3,
                    borderColor: colors.beeYellow + "30",
                  }}
                />
              ) : (
                <View
                  style={{
                    width: 100,
                    height: 100,
                    borderRadius: 50,
                    backgroundColor: colors.beeYellow + "15",
                    alignItems: "center",
                    justifyContent: "center",
                    borderWidth: 3,
                    borderColor: colors.beeYellow + "30",
                  }}
                >
                  <Icon name="business" size={40} color={colors.beeYellow} />
                </View>
              )}
              {editing && (
                <TouchableOpacity
                  onPress={pickLogo}
                  disabled={uploadingLogo}
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    width: 32,
                    height: 32,
                    borderRadius: 16,
                    backgroundColor: colors.beeYellow,
                    alignItems: "center",
                    justifyContent: "center",
                    borderWidth: 2,
                    borderColor: colors.white,
                  }}
                >
                  {uploadingLogo ? (
                    <ActivityIndicator size="small" color={colors.deepNavy} />
                  ) : (
                    <Icon name="camera-alt" size={16} color={colors.deepNavy} />
                  )}
                </TouchableOpacity>
              )}
            </View>

            {/* Company Name */}
            <Text
              style={{
                fontFamily: fonts.bold,
                fontSize: 20,
                color: txt,
                marginTop: 14,
                textAlign: "center",
              }}
            >
              {companyName || "Company Name"}
            </Text>

            {/* Industry Badge */}
            {industry ? (
              <View
                style={{
                  backgroundColor: colors.beeYellow + "18",
                  paddingHorizontal: 12,
                  paddingVertical: 6,
                  borderRadius: 20,
                  marginTop: 8,
                }}
              >
                <Text
                  style={{
                    fontFamily: fonts.medium,
                    fontSize: 12,
                    color: colors.beeYellow,
                  }}
                >
                  {industry}
                </Text>
              </View>
            ) : null}

            {/* Verification Badge */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: verificationStyle.bg,
                paddingHorizontal: 14,
                paddingVertical: 8,
                borderRadius: 20,
                marginTop: 12,
                gap: 6,
              }}
            >
              <Icon
                name={verificationStyle.icon}
                size={16}
                color={verificationStyle.text}
              />
              <Text
                style={{
                  fontFamily: fonts.medium,
                  fontSize: 12,
                  color: verificationStyle.text,
                }}
              >
                {verificationStyle.title}
              </Text>
            </View>
          </View>

          {/* Quick Info Cards */}
          <View
            style={{
              flexDirection: "row",
              paddingHorizontal: 16,
              marginTop: 12,
              gap: 10,
            }}
          >
            {[
              {
                icon: "people",
                label: t.cdSizeLabel,
                value: companySize || "-",
                color: "#3B82F6",
              },
              {
                icon: "calendar-today",
                label: t.cdFoundedLabel,
                value: foundedYear || "-",
                color: "#8B5CF6",
              },
              {
                icon: "location-on",
                label: "Location",
                value: city || "-",
                color: "#10B981",
              },
            ].map((item, index) => (
              <View
                key={index}
                style={{
                  flex: 1,
                  backgroundColor: card,
                  borderRadius: 14,
                  padding: 12,
                  alignItems: "center",
                  borderWidth: 1,
                  borderColor: borderC,
                }}
              >
                <View
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: 17,
                    backgroundColor: item.color + "18",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: 8,
                  }}
                >
                  <Icon name={item.icon} size={17} color={item.color} />
                </View>
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: 13,
                    color: txt,
                    textAlign: "center",
                  }}
                  numberOfLines={1}
                >
                  {item.value}
                </Text>
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 11,
                    color: muted,
                    marginTop: 2,
                  }}
                >
                  {item.label}
                </Text>
              </View>
            ))}
          </View>

          {/* About Section */}
          <View
            style={{
              backgroundColor: card,
              marginHorizontal: 16,
              marginTop: 12,
              borderRadius: 16,
              padding: 16,
              borderWidth: 1,
              borderColor: borderC,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 10,
                gap: 6,
              }}
            >
              <View
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 10,
                  backgroundColor: colors.beeYellow + "15",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="info" size={18} color={colors.beeYellow} />
              </View>
              <Text
                style={{ fontFamily: fonts.bold, fontSize: 16, color: txt }}
              >
                {t.cdAboutCompany}
              </Text>
            </View>

            <MobileInputField
              label={t.cdCompanyNameLabel}
              value={companyName}
              onChangeText={setCompanyName}
              placeholder="Enter company name"
              icon="business"
            />
            <MobileInputField
              label={t.cdDescriptionLabel}
              value={companyDescription}
              onChangeText={setCompanyDescription}
              placeholder="Tell us about your company..."
              multiline={true}
              icon="description"
            />
            <MobileInputField
              label={t.cdIndustryLabel}
              value={industry}
              onChangeText={setIndustry}
              placeholder="e.g., Technology, Finance"
              icon="category"
            />
            <View style={{ flexDirection: "row", gap: 12 }}>
              <View style={{ flex: 1 }}>
                <MobileInputField
                  label={t.cdCompanySizeLabel}
                  value={companySize}
                  onChangeText={setCompanySize}
                  placeholder="e.g., 50-100"
                  icon="people"
                />
              </View>
              <View style={{ flex: 1 }}>
                <MobileInputField
                  label={t.cdFoundedYearLabel}
                  value={foundedYear}
                  onChangeText={setFoundedYear}
                  placeholder="e.g., 2020"
                  icon="event"
                />
              </View>
            </View>
          </View>

          {/* Contact Section */}
          <View
            style={{
              backgroundColor: card,
              marginHorizontal: 16,
              marginTop: 12,
              borderRadius: 16,
              padding: 16,
              borderWidth: 1,
              borderColor: borderC,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 10,
                gap: 6,
              }}
            >
              <View
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 10,
                  backgroundColor: colors.softBlue + "15",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="contact-mail" size={18} color={colors.softBlue} />
              </View>
              <Text
                style={{ fontFamily: fonts.bold, fontSize: 16, color: txt }}
              >
                {t.cdContactInformation}
              </Text>
            </View>

            <MobileInputField
              label="Email"
              value={companyEmail}
              onChangeText={setCompanyEmail}
              placeholder="contact@company.com"
              keyboardType="email-address"
              icon="email"
            />
            <MobileInputField
              label="Phone"
              value={companyPhone}
              onChangeText={setCompanyPhone}
              placeholder="+251-XXX-XXXX"
              keyboardType="phone-pad"
              icon="phone"
            />
            <MobileInputField
              label="Website"
              value={website}
              onChangeText={setWebsite}
              placeholder="https://yourcompany.com"
              icon="language"
            />
          </View>

          {/* Location Section */}
          <View
            style={{
              backgroundColor: card,
              marginHorizontal: 16,
              marginTop: 12,
              borderRadius: 16,
              padding: 16,
              borderWidth: 1,
              borderColor: borderC,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 10,
                gap: 6,
              }}
            >
              <View
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 10,
                  backgroundColor: colors.success + "15",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="location-on" size={18} color={colors.success} />
              </View>
              <Text
                style={{ fontFamily: fonts.bold, fontSize: 16, color: txt }}
              >
                Location
              </Text>
            </View>

            <MobileInputField
              label="Address"
              value={address}
              onChangeText={setAddress}
              placeholder="Street address"
              icon="home"
            />
            <View style={{ flexDirection: "row", gap: 12 }}>
              <View style={{ flex: 1 }}>
                <MobileInputField
                  label="City"
                  value={city}
                  onChangeText={setCity}
                  placeholder="City"
                  icon="location-city"
                />
              </View>
              <View style={{ flex: 1 }}>
                <MobileInputField
                  label="Country"
                  value={country}
                  onChangeText={setCountry}
                  placeholder="Country"
                  icon="public"
                />
              </View>
            </View>
          </View>

          {/* Social Media Section */}
          <View
            style={{
              backgroundColor: card,
              marginHorizontal: 16,
              marginTop: 12,
              marginBottom: 4,
              borderRadius: 16,
              padding: 16,
              borderWidth: 1,
              borderColor: borderC,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 10,
                gap: 6,
              }}
            >
              <View
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 10,
                  backgroundColor: "#1DA1F2" + "15",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="share" size={18} color="#1DA1F2" />
              </View>
              <Text
                style={{ fontFamily: fonts.bold, fontSize: 16, color: txt }}
              >
                Social Media
              </Text>
            </View>

            {[
              {
                value: linkedIn,
                onChange: setLinkedIn,
                placeholder: "LinkedIn URL",
                icon: "work",
                color: "#0077B5",
              },
              {
                value: facebook,
                onChange: setFacebook,
                placeholder: "Facebook URL",
                icon: "facebook",
                color: "#1877F2",
              },
              {
                value: twitter,
                onChange: setTwitter,
                placeholder: "Twitter/X URL",
                icon: "alternate-email",
                color: "#1DA1F2",
              },
            ].map((social, idx) => (
              <View
                key={idx}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: idx < 2 ? 12 : 0,
                  backgroundColor: editing
                    ? isDark
                      ? "#252932"
                      : "#FFFFFF"
                    : isDark
                    ? "#1A1D23"
                    : "#F0F0F0",
                  borderRadius: 12,
                  borderWidth: editing ? 1 : 0,
                  borderColor: borderC,
                  overflow: "hidden",
                }}
              >
                <View
                  style={{
                    width: 46,
                    height: 46,
                    backgroundColor: social.color + "18",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name={social.icon} size={20} color={social.color} />
                </View>
                <TextInput
                  style={{
                    flex: 1,
                    paddingHorizontal: 12,
                    fontFamily: fonts.regular,
                    fontSize: 14,
                    color: txt,
                    height: 46,
                  }}
                  value={social.value}
                  onChangeText={social.onChange}
                  editable={editing}
                  placeholder={social.placeholder}
                  placeholderTextColor={muted}
                />
              </View>
            ))}
          </View>
        </ScrollView>
      ) : (
        /* ========== DESKTOP VIEW - Modern Redesign ========== */
        <>
          {/* Clean Modern Header */}
          <View
            style={{
              padding: 24,
              backgroundColor: colors.white,
              borderBottomWidth: 1,
              borderBottomColor: isDarkMode ? "#1F2937" : "#E5E7EB",
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <View>
                <Text
                  style={{
                    fontSize: 24,
                    fontFamily: fonts.bold,
                    color: colors.deepNavy,
                    marginBottom: 4,
                  }}
                >
                  Company Profile
                </Text>
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.regular,
                    color: colors.warmGray,
                  }}
                >
                  Manage your company information and settings
                </Text>
              </View>

              {/* Action Buttons */}
              <View style={{ flexDirection: "row", gap: 12 }}>
                {editing && (
                  <TouchableOpacity
                    onPress={() => setEditing(false)}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 8,
                      paddingHorizontal: 16,
                      paddingVertical: 10,
                      borderRadius: 8,
                      borderWidth: 1,
                      borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                      backgroundColor: "transparent",
                    }}
                  >
                    <Icon name="close" size={18} color={colors.warmGray} />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.semiBold,
                        color: colors.warmGray,
                      }}
                    >
                      Cancel
                    </Text>
                  </TouchableOpacity>
                )}

                <TouchableOpacity
                  onPress={() => (editing ? handleSave() : setEditing(true))}
                  disabled={saving}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 8,
                    paddingHorizontal: 20,
                    paddingVertical: 10,
                    borderRadius: 8,
                    backgroundColor: editing
                      ? colors.deepNavy
                      : isDarkMode
                      ? "#374151"
                      : "#F3F4F6",
                  }}
                >
                  {saving ? (
                    <ActivityIndicator
                      size="small"
                      color={editing ? colors.white : colors.deepNavy}
                    />
                  ) : (
                    <>
                      <Icon
                        name={editing ? "save" : "edit"}
                        size={18}
                        color={editing ? colors.white : colors.deepNavy}
                      />
                      <Text
                        style={{
                          fontSize: 13,
                          fontFamily: fonts.semiBold,
                          color: editing ? colors.white : colors.deepNavy,
                        }}
                      >
                        {editing ? "Save Changes" : t.cdEditProfile}
                      </Text>
                    </>
                  )}
                </TouchableOpacity>
              </View>
            </View>
          </View>

          <ScrollView
            style={{
              flex: 1,
              backgroundColor: isDarkMode ? "#111827" : "#F9FAFB",
            }}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{ padding: 24, paddingBottom: 40 }}
          >
            {/* Verification Status Banner */}
            <View
              style={{
                backgroundColor: verificationStyle.bg,
                borderRadius: 12,
                padding: 20,
                marginBottom: 24,
                borderWidth: 1,
                borderColor: verificationStyle.border + "40",
              }}
            >
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 12 }}
              >
                <View
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: 24,
                    backgroundColor: verificationStyle.border + "20",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon
                    name={verificationStyle.icon}
                    size={24}
                    color={verificationStyle.text}
                  />
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 16,
                      fontFamily: fonts.bold,
                      color: verificationStyle.text,
                      marginBottom: 4,
                    }}
                  >
                    {verificationStyle.title}
                  </Text>
                  <Text
                    style={{
                      fontSize: 13,
                      fontFamily: fonts.regular,
                      color: verificationStyle.text,
                      opacity: 0.9,
                    }}
                  >
                    {verificationStyle.message}
                  </Text>
                </View>
              </View>
            </View>

            {/* Company Logo & Basic Info Card */}
            <View
              style={{
                backgroundColor: colors.white,
                borderRadius: 12,
                padding: 24,
                marginBottom: 20,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.05,
                shadowRadius: 3,
                elevation: 2,
              }}
            >
              <View style={{ flexDirection: "row", gap: 24 }}>
                {/* Logo Section */}
                <View style={{ alignItems: "center" }}>
                  <View style={{ position: "relative" }}>
                    {logoUrl ? (
                      <Image
                        source={{ uri: logoUrl }}
                        style={{
                          width: 140,
                          height: 140,
                          borderRadius: 70,
                          borderWidth: 4,
                          borderColor: isDarkMode ? "#374151" : "#F3F4F6",
                        }}
                      />
                    ) : (
                      <View
                        style={{
                          width: 140,
                          height: 140,
                          borderRadius: 70,
                          backgroundColor: isDarkMode ? "#1F2937" : "#F3F4F6",
                          borderWidth: 4,
                          borderColor: isDarkMode ? "#374151" : "#E5E7EB",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon
                          name="business"
                          size={56}
                          color={colors.warmGray}
                        />
                      </View>
                    )}
                    {editing && (
                      <TouchableOpacity
                        onPress={pickLogo}
                        disabled={uploadingLogo}
                        style={{
                          position: "absolute",
                          bottom: 4,
                          right: 4,
                          width: 44,
                          height: 44,
                          borderRadius: 22,
                          backgroundColor: colors.deepNavy,
                          alignItems: "center",
                          justifyContent: "center",
                          borderWidth: 3,
                          borderColor: colors.white,
                          shadowColor: "#000",
                          shadowOffset: { width: 0, height: 2 },
                          shadowOpacity: 0.2,
                          shadowRadius: 4,
                        }}
                      >
                        {uploadingLogo ? (
                          <ActivityIndicator
                            size="small"
                            color={colors.white}
                          />
                        ) : (
                          <Icon
                            name="camera-alt"
                            size={20}
                            color={colors.white}
                          />
                        )}
                      </TouchableOpacity>
                    )}
                  </View>
                  <Text
                    style={{
                      fontSize: 11,
                      fontFamily: fonts.regular,
                      color: colors.warmGray,
                      marginTop: 12,
                      textAlign: "center",
                    }}
                  >
                    Company Logo
                  </Text>
                </View>

                {/* Quick Stats */}
                <View style={{ flex: 1 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 16,
                      marginBottom: 20,
                    }}
                  >
                    {[
                      {
                        icon: "people",
                        label: t.cdCompanySizeLabel,
                        value: companySize || "Not set",
                        color: "#3B82F6",
                      },
                      {
                        icon: "calendar-today",
                        label: t.cdFoundedLabel,
                        value: foundedYear || "Not set",
                        color: "#8B5CF6",
                      },
                      {
                        icon: "location-on",
                        label: "Location",
                        value: city || "Not set",
                        color: "#10B981",
                      },
                    ].map((stat, index) => (
                      <View
                        key={index}
                        style={{
                          flex: 1,
                          backgroundColor: isDarkMode ? "#1F2937" : "#F9FAFB",
                          borderRadius: 10,
                          padding: 16,
                        }}
                      >
                        <View
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: 8,
                            backgroundColor: stat.color + "15",
                            alignItems: "center",
                            justifyContent: "center",
                            marginBottom: 10,
                          }}
                        >
                          <Icon name={stat.icon} size={16} color={stat.color} />
                        </View>
                        <Text
                          style={{
                            fontSize: 15,
                            fontFamily: fonts.bold,
                            color: colors.deepNavy,
                            marginBottom: 4,
                          }}
                          numberOfLines={1}
                        >
                          {stat.value}
                        </Text>
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.regular,
                            color: colors.warmGray,
                          }}
                        >
                          {stat.label}
                        </Text>
                      </View>
                    ))}
                  </View>

                  {/* Company Name Display */}
                  {!editing && (
                    <View>
                      <Text
                        style={{
                          fontSize: 20,
                          fontFamily: fonts.bold,
                          color: colors.deepNavy,
                          marginBottom: 6,
                        }}
                      >
                        {companyName || "Company Name Not Set"}
                      </Text>
                      {industry && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <Icon
                            name="category"
                            size={14}
                            color={colors.warmGray}
                          />
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.medium,
                              color: colors.warmGray,
                            }}
                          >
                            {industry}
                          </Text>
                        </View>
                      )}
                    </View>
                  )}
                </View>
              </View>
            </View>

            {/* Company Information Section */}
            <View
              style={{
                backgroundColor: colors.white,
                borderRadius: 12,
                padding: 24,
                marginBottom: 20,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.05,
                shadowRadius: 3,
                elevation: 2,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 20,
                  gap: 10,
                }}
              >
                <View
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    backgroundColor: isDarkMode ? "#374151" : "#EEF2FF",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name="info" size={18} color="#6366F1" />
                </View>
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: fonts.bold,
                    color: colors.deepNavy,
                  }}
                >
                  Company Information
                </Text>
              </View>

              {/* Two Column Layout */}
              <View style={{ flexDirection: "row", gap: 20 }}>
                <View style={{ flex: 1 }}>
                  {/* Company Name */}
                  <View style={{ marginBottom: 20 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: colors.warmGray,
                        marginBottom: 8,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      {t.cdCompanyNameLabel} *
                    </Text>
                    <TextInput
                      style={{
                        backgroundColor: editing
                          ? isDarkMode
                            ? "#1F2937"
                            : "#FFFFFF"
                          : isDarkMode
                          ? "#0F1419"
                          : "#F9FAFB",
                        borderRadius: 8,
                        paddingHorizontal: 14,
                        paddingVertical: 12,
                        fontFamily: fonts.medium,
                        fontSize: 14,
                        color: colors.deepNavy,
                        borderWidth: editing ? 1 : 0,
                        borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                      }}
                      value={companyName}
                      onChangeText={setCompanyName}
                      editable={editing}
                      placeholder="Enter company name"
                      placeholderTextColor={colors.warmGray}
                    />
                  </View>

                  {/* Industry */}
                  <View style={{ marginBottom: 20 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: colors.warmGray,
                        marginBottom: 8,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      {t.cdIndustryLabel} *
                    </Text>
                    <TextInput
                      style={{
                        backgroundColor: editing
                          ? isDarkMode
                            ? "#1F2937"
                            : "#FFFFFF"
                          : isDarkMode
                          ? "#0F1419"
                          : "#F9FAFB",
                        borderRadius: 8,
                        paddingHorizontal: 14,
                        paddingVertical: 12,
                        fontFamily: fonts.medium,
                        fontSize: 14,
                        color: colors.deepNavy,
                        borderWidth: editing ? 1 : 0,
                        borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                      }}
                      value={industry}
                      onChangeText={setIndustry}
                      editable={editing}
                      placeholder="e.g., Technology, Finance, Healthcare"
                      placeholderTextColor={colors.warmGray}
                    />
                  </View>

                  {/* Founded Year */}
                  <View style={{ marginBottom: 20 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: colors.warmGray,
                        marginBottom: 8,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      {t.cdFoundedYearLabel}
                    </Text>
                    <TextInput
                      style={{
                        backgroundColor: editing
                          ? isDarkMode
                            ? "#1F2937"
                            : "#FFFFFF"
                          : isDarkMode
                          ? "#0F1419"
                          : "#F9FAFB",
                        borderRadius: 8,
                        paddingHorizontal: 14,
                        paddingVertical: 12,
                        fontFamily: fonts.medium,
                        fontSize: 14,
                        color: colors.deepNavy,
                        borderWidth: editing ? 1 : 0,
                        borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                      }}
                      value={foundedYear}
                      onChangeText={setFoundedYear}
                      editable={editing}
                      placeholder="e.g., 2020"
                      placeholderTextColor={colors.warmGray}
                      keyboardType="numeric"
                    />
                  </View>
                </View>

                <View style={{ flex: 1 }}>
                  {/* Company Size */}
                  <View style={{ marginBottom: 20 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: colors.warmGray,
                        marginBottom: 8,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      {t.cdCompanySizeLabel}
                    </Text>
                    <TextInput
                      style={{
                        backgroundColor: editing
                          ? isDarkMode
                            ? "#1F2937"
                            : "#FFFFFF"
                          : isDarkMode
                          ? "#0F1419"
                          : "#F9FAFB",
                        borderRadius: 8,
                        paddingHorizontal: 14,
                        paddingVertical: 12,
                        fontFamily: fonts.medium,
                        fontSize: 14,
                        color: colors.deepNavy,
                        borderWidth: editing ? 1 : 0,
                        borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                      }}
                      value={companySize}
                      onChangeText={setCompanySize}
                      editable={editing}
                      placeholder="e.g., 10-50, 50-200, 200+"
                      placeholderTextColor={colors.warmGray}
                    />
                  </View>

                  {/* Website */}
                  <View style={{ marginBottom: 20 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: colors.warmGray,
                        marginBottom: 8,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      Website
                    </Text>
                    <TextInput
                      style={{
                        backgroundColor: editing
                          ? isDarkMode
                            ? "#1F2937"
                            : "#FFFFFF"
                          : isDarkMode
                          ? "#0F1419"
                          : "#F9FAFB",
                        borderRadius: 8,
                        paddingHorizontal: 14,
                        paddingVertical: 12,
                        fontFamily: fonts.medium,
                        fontSize: 14,
                        color: colors.deepNavy,
                        borderWidth: editing ? 1 : 0,
                        borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                      }}
                      value={website}
                      onChangeText={setWebsite}
                      editable={editing}
                      placeholder="https://www.example.com"
                      placeholderTextColor={colors.warmGray}
                      keyboardType="url"
                    />
                  </View>
                </View>
              </View>

              {/* Description - Full Width */}
              <View>
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.semiBold,
                    color: colors.warmGray,
                    marginBottom: 8,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                  }}
                >
                  Company Description
                </Text>
                <TextInput
                  style={{
                    backgroundColor: editing
                      ? isDarkMode
                        ? "#1F2937"
                        : "#FFFFFF"
                      : isDarkMode
                      ? "#0F1419"
                      : "#F9FAFB",
                    borderRadius: 8,
                    paddingHorizontal: 14,
                    paddingVertical: 12,
                    fontFamily: fonts.regular,
                    fontSize: 14,
                    color: colors.deepNavy,
                    borderWidth: editing ? 1 : 0,
                    borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                    minHeight: 120,
                    textAlignVertical: "top",
                  }}
                  value={companyDescription}
                  onChangeText={setCompanyDescription}
                  editable={editing}
                  multiline
                  placeholder="Tell candidates about your company, culture, and what makes you unique..."
                  placeholderTextColor={colors.warmGray}
                />
              </View>
            </View>

            {/* Contact Information Section */}
            <View
              style={{
                backgroundColor: colors.white,
                borderRadius: 12,
                padding: 24,
                marginBottom: 20,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.05,
                shadowRadius: 3,
                elevation: 2,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 20,
                  gap: 10,
                }}
              >
                <View
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    backgroundColor: isDarkMode ? "#374151" : "#ECFDF5",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name="contact-mail" size={18} color="#10B981" />
                </View>
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: fonts.bold,
                    color: colors.deepNavy,
                  }}
                >
                  {t.cdContactInformation}
                </Text>
              </View>

              <View style={{ flexDirection: "row", gap: 20 }}>
                <View style={{ flex: 1 }}>
                  {/* Email */}
                  <View style={{ marginBottom: 20 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: colors.warmGray,
                        marginBottom: 8,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      Email Address *
                    </Text>
                    <TextInput
                      style={{
                        backgroundColor: editing
                          ? isDarkMode
                            ? "#1F2937"
                            : "#FFFFFF"
                          : isDarkMode
                          ? "#0F1419"
                          : "#F9FAFB",
                        borderRadius: 8,
                        paddingHorizontal: 14,
                        paddingVertical: 12,
                        fontFamily: fonts.medium,
                        fontSize: 14,
                        color: colors.deepNavy,
                        borderWidth: editing ? 1 : 0,
                        borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                      }}
                      value={companyEmail}
                      onChangeText={setCompanyEmail}
                      editable={editing}
                      placeholder="contact@company.com"
                      placeholderTextColor={colors.warmGray}
                      keyboardType="email-address"
                    />
                  </View>
                </View>

                <View style={{ flex: 1 }}>
                  {/* Phone */}
                  <View style={{ marginBottom: 20 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: colors.warmGray,
                        marginBottom: 8,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      Phone Number
                    </Text>
                    <TextInput
                      style={{
                        backgroundColor: editing
                          ? isDarkMode
                            ? "#1F2937"
                            : "#FFFFFF"
                          : isDarkMode
                          ? "#0F1419"
                          : "#F9FAFB",
                        borderRadius: 8,
                        paddingHorizontal: 14,
                        paddingVertical: 12,
                        fontFamily: fonts.medium,
                        fontSize: 14,
                        color: colors.deepNavy,
                        borderWidth: editing ? 1 : 0,
                        borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                      }}
                      value={companyPhone}
                      onChangeText={setCompanyPhone}
                      editable={editing}
                      placeholder="+251-XXX-XXXX"
                      placeholderTextColor={colors.warmGray}
                      keyboardType="phone-pad"
                    />
                  </View>
                </View>
              </View>
            </View>

            {/* Location Section */}
            <View
              style={{
                backgroundColor: colors.white,
                borderRadius: 12,
                padding: 24,
                marginBottom: 20,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.05,
                shadowRadius: 3,
                elevation: 2,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 20,
                  gap: 10,
                }}
              >
                <View
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    backgroundColor: isDarkMode ? "#374151" : "#FEF3C7",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name="location-on" size={18} color="#F59E0B" />
                </View>
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: fonts.bold,
                    color: colors.deepNavy,
                  }}
                >
                  Location
                </Text>
              </View>

              <View style={{ flexDirection: "row", gap: 20, marginBottom: 20 }}>
                <View style={{ flex: 1 }}>
                  {/* City */}
                  <View>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: colors.warmGray,
                        marginBottom: 8,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      City *
                    </Text>
                    <TextInput
                      style={{
                        backgroundColor: editing
                          ? isDarkMode
                            ? "#1F2937"
                            : "#FFFFFF"
                          : isDarkMode
                          ? "#0F1419"
                          : "#F9FAFB",
                        borderRadius: 8,
                        paddingHorizontal: 14,
                        paddingVertical: 12,
                        fontFamily: fonts.medium,
                        fontSize: 14,
                        color: colors.deepNavy,
                        borderWidth: editing ? 1 : 0,
                        borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                      }}
                      value={city}
                      onChangeText={setCity}
                      editable={editing}
                      placeholder="e.g., Addis Ababa"
                      placeholderTextColor={colors.warmGray}
                    />
                  </View>
                </View>

                <View style={{ flex: 1 }}>
                  {/* Country */}
                  <View>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: colors.warmGray,
                        marginBottom: 8,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      Country *
                    </Text>
                    <TextInput
                      style={{
                        backgroundColor: editing
                          ? isDarkMode
                            ? "#1F2937"
                            : "#FFFFFF"
                          : isDarkMode
                          ? "#0F1419"
                          : "#F9FAFB",
                        borderRadius: 8,
                        paddingHorizontal: 14,
                        paddingVertical: 12,
                        fontFamily: fonts.medium,
                        fontSize: 14,
                        color: colors.deepNavy,
                        borderWidth: editing ? 1 : 0,
                        borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                      }}
                      value={country}
                      onChangeText={setCountry}
                      editable={editing}
                      placeholder="Ethiopia"
                      placeholderTextColor={colors.warmGray}
                    />
                  </View>
                </View>
              </View>

              {/* Address - Full Width */}
              <View>
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.semiBold,
                    color: colors.warmGray,
                    marginBottom: 8,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                  }}
                >
                  Street Address
                </Text>
                <TextInput
                  style={{
                    backgroundColor: editing
                      ? isDarkMode
                        ? "#1F2937"
                        : "#FFFFFF"
                      : isDarkMode
                      ? "#0F1419"
                      : "#F9FAFB",
                    borderRadius: 8,
                    paddingHorizontal: 14,
                    paddingVertical: 12,
                    fontFamily: fonts.medium,
                    fontSize: 14,
                    color: colors.deepNavy,
                    borderWidth: editing ? 1 : 0,
                    borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                  }}
                  value={address}
                  onChangeText={setAddress}
                  editable={editing}
                  placeholder="Enter your office address"
                  placeholderTextColor={colors.warmGray}
                />
              </View>
            </View>

            {/* Social Media Section */}
            <View
              style={{
                backgroundColor: colors.white,
                borderRadius: 12,
                padding: 24,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 1 },
                shadowOpacity: 0.05,
                shadowRadius: 3,
                elevation: 2,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 20,
                  gap: 10,
                }}
              >
                <View
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 10,
                    backgroundColor: isDarkMode ? "#374151" : "#EFF6FF",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name="share" size={18} color="#3B82F6" />
                </View>
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: fonts.bold,
                    color: colors.deepNavy,
                  }}
                >
                  Social Media Links
                </Text>
              </View>

              {/* LinkedIn */}
              <View style={{ marginBottom: 16 }}>
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.semiBold,
                    color: colors.warmGray,
                    marginBottom: 8,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                  }}
                >
                  LinkedIn
                </Text>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: editing
                      ? isDarkMode
                        ? "#1F2937"
                        : "#FFFFFF"
                      : isDarkMode
                      ? "#0F1419"
                      : "#F9FAFB",
                    borderRadius: 8,
                    borderWidth: editing ? 1 : 0,
                    borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                    overflow: "hidden",
                  }}
                >
                  <View
                    style={{
                      width: 44,
                      height: 44,
                      backgroundColor: "#0077B5" + "15",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name="work" size={18} color="#0077B5" />
                  </View>
                  <TextInput
                    style={{
                      flex: 1,
                      paddingHorizontal: 14,
                      fontFamily: fonts.medium,
                      fontSize: 14,
                      color: colors.deepNavy,
                      height: 44,
                    }}
                    value={linkedIn}
                    onChangeText={setLinkedIn}
                    editable={editing}
                    placeholder="https://linkedin.com/company/..."
                    placeholderTextColor={colors.warmGray}
                  />
                </View>
              </View>

              {/* Facebook */}
              <View style={{ marginBottom: 16 }}>
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.semiBold,
                    color: colors.warmGray,
                    marginBottom: 8,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                  }}
                >
                  Facebook
                </Text>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: editing
                      ? isDarkMode
                        ? "#1F2937"
                        : "#FFFFFF"
                      : isDarkMode
                      ? "#0F1419"
                      : "#F9FAFB",
                    borderRadius: 8,
                    borderWidth: editing ? 1 : 0,
                    borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                    overflow: "hidden",
                  }}
                >
                  <View
                    style={{
                      width: 44,
                      height: 44,
                      backgroundColor: "#1877F2" + "15",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name="facebook" size={18} color="#1877F2" />
                  </View>
                  <TextInput
                    style={{
                      flex: 1,
                      paddingHorizontal: 14,
                      fontFamily: fonts.medium,
                      fontSize: 14,
                      color: colors.deepNavy,
                      height: 44,
                    }}
                    value={facebook}
                    onChangeText={setFacebook}
                    editable={editing}
                    placeholder="https://facebook.com/..."
                    placeholderTextColor={colors.warmGray}
                  />
                </View>
              </View>

              {/* Twitter */}
              <View>
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.semiBold,
                    color: colors.warmGray,
                    marginBottom: 8,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                  }}
                >
                  Twitter / X
                </Text>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    backgroundColor: editing
                      ? isDarkMode
                        ? "#1F2937"
                        : "#FFFFFF"
                      : isDarkMode
                      ? "#0F1419"
                      : "#F9FAFB",
                    borderRadius: 8,
                    borderWidth: editing ? 1 : 0,
                    borderColor: isDarkMode ? "#374151" : "#D1D5DB",
                    overflow: "hidden",
                  }}
                >
                  <View
                    style={{
                      width: 44,
                      height: 44,
                      backgroundColor: "#1DA1F2" + "15",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name="alternate-email" size={18} color="#1DA1F2" />
                  </View>
                  <TextInput
                    style={{
                      flex: 1,
                      paddingHorizontal: 14,
                      fontFamily: fonts.medium,
                      fontSize: 14,
                      color: colors.deepNavy,
                      height: 44,
                    }}
                    value={twitter}
                    onChangeText={setTwitter}
                    editable={editing}
                    placeholder="https://twitter.com/..."
                    placeholderTextColor={colors.warmGray}
                  />
                </View>
              </View>
            </View>
          </ScrollView>
        </>
      )}
    </View>
  );
}

// Admin Panel Screen with Sidebar
function AdminPanelScreen({
  navigation,
  isDarkMode,
  toggleTheme,
  colors: themeColors,
}: any) {
  const [activeTab, setActiveTab] = useState("analytics");
  const [user, setUser] = useState<any>(null);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const colors = themeColors || lightColors;

  // Monitor dimension changes for responsive behavior
  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
      // Auto-close drawer when switching to desktop
      if (window.width >= 768) {
        setIsDrawerOpen(false);
      }
    });
    return () => subscription?.remove();
  }, []);

  const isMobile = dimensions.width < 768;

  // URL query-based routing for maintaining state on refresh
  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const urlParams = new URLSearchParams(window.location.search);
      const tabFromURL = urlParams.get("tab");
      if (
        tabFromURL &&
        [
          "analytics",
          "engagement",
          "insights",
          "categories",
          "jobs",
          "telegram",
          "scrapeHistory",
          "users",
          "companies",
          "subscriptions",
          "banks",
          "payments",
          "support",
          "settings",
        ].includes(tabFromURL)
      ) {
        setActiveTab(tabFromURL);
      }
    }
  }, []);

  // Update URL when tab changes
  const handleTabChange = (tabId: string) => {
    setActiveTab(tabId);
    // Close drawer on mobile when selecting a tab
    if (isMobile) {
      setIsDrawerOpen(false);
    }
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const url = new URL(window.location.href);
      url.searchParams.set("tab", tabId);
      window.history.replaceState({}, "", url.toString());
    }
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        try {
          const userDoc = await getDoc(doc(db, "users", authUser.uid));
          if (userDoc.exists()) {
            const userData = userDoc.data();
            const userRole = userData.role || "reader";

            // Check if user has admin privileges
            if (userRole !== "superadmin" && userRole !== "admin") {
              setIsCheckingAuth(false);
              if (Platform.OS === "web" && typeof window !== "undefined") {
                window.history.replaceState(
                  {},
                  document.title,
                  "/unauthorized",
                );
              }
              navigation.replace("Unauthorized");
              return;
            }

            setUser({ ...authUser, ...userData });
          } else {
            // User document doesn't exist - deny access
            setIsCheckingAuth(false);
            navigation.replace("Unauthorized");
            return;
          }
        } catch (error) {
          console.error("Error checking admin access:", error);
          setIsCheckingAuth(false);
          navigation.replace("Unauthorized");
          return;
        }
      } else {
        // User not logged in - redirect to unauthorized
        setIsCheckingAuth(false);
        navigation.replace("Unauthorized");
        return;
      }
      setIsCheckingAuth(false);
    });
    return unsubscribe;
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    // Clear URL parameters when logging out
    if (Platform.OS === "web" && typeof window !== "undefined") {
      window.history.replaceState({}, document.title, "/");
    }
    navigation.replace("Home");
  };

  const sidebarCategories = [
    {
      label: "OVERVIEW",
      items: [
        { id: "analytics", title: "Analytics", icon: "analytics" },
        { id: "engagement", title: "User Engagement", icon: "insights" },
        { id: "insights", title: "Market Insights", icon: "lightbulb" },
      ],
    },
    {
      label: "CONTENT",
      items: [
        { id: "categories", title: "Job Categories", icon: "category" },
        { id: "jobs", title: "Jobs", icon: "work" },
        { id: "telegram", title: "Telegram Channels", icon: "chat" },
        { id: "scrapeHistory", title: "Scrape History", icon: "history" },
      ],
    },
    {
      label: "MANAGEMENT",
      items: [
        { id: "users", title: "Users", icon: "people" },
        { id: "companies", title: "Companies", icon: "business" },
        {
          id: "subscriptions",
          title: "Subscriptions",
          icon: "card-membership",
        },
      ],
    },
    {
      label: "FINANCIAL",
      items: [
        { id: "payments", title: "Payment Requests", icon: "payment" },
        { id: "banks", title: "Bank Configuration", icon: "account-balance" },
      ],
    },
    {
      label: "SUPPORT",
      items: [{ id: "support", title: "Support Requests", icon: "support" }],
    },
    {
      label: "COMMUNICATION",
      items: [
        { id: "announcements", title: "Announcements", icon: "campaign" },
      ],
    },
    {
      label: "SYSTEM",
      items: [{ id: "settings", title: "Settings", icon: "settings" }],
    },
  ];

  // Show loading spinner while checking authentication
  if (isCheckingAuth) {
    return (
      <SafeAreaView
        style={[styles.container, { backgroundColor: colors.white }]}
      >
        <FullScreenLoader
          message="Verifying admin access..."
          isDarkMode={false}
        />
      </SafeAreaView>
    );
  }

  // Don't render admin panel if user is not set or not authorized
  if (!user || (user.role !== "superadmin" && user.role !== "admin")) {
    return null;
  }

  // ── Sidebar Component (Reusable for Desktop & Mobile Drawer) ──
  const renderSidebar = () => (
    <ScrollView
      style={[
        {
          width: isMobile ? 280 : isSidebarCollapsed ? 64 : 240,
          minWidth: isMobile ? 280 : isSidebarCollapsed ? 64 : 240,
          maxWidth: isMobile ? 280 : isSidebarCollapsed ? 64 : 240,
          flexShrink: 0,
          flexGrow: 0,
          backgroundColor: colors.sidebarBg,
          borderRightWidth: 1,
          borderRightColor: colors.sidebarBorder,
        },
      ]}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: isMobile ? 80 : 20 }}
      showsVerticalScrollIndicator={false}
    >
      {/* ── Logo / Brand Header ── */}
      <View
        style={{
          paddingTop: 20,
          paddingBottom: 16,
          paddingHorizontal: isSidebarCollapsed && !isMobile ? 12 : 20,
          borderBottomWidth: 1,
          borderBottomColor: colors.sidebarBorder,
          flexDirection: isSidebarCollapsed && !isMobile ? "column" : "row",
          alignItems: "center",
          gap: 12,
        }}
      >
        {/* Logo mark */}
        <View
          style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            backgroundColor: colors.sidebarAccent,
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          <Image
            source={require("./assets/favicon.png")}
            style={{ width: 24, height: 24, borderRadius: 4 }}
          />
        </View>
        {(!isSidebarCollapsed || isMobile) && (
          <View style={{ flex: 1, minWidth: 0 }}>
            <Text
              style={{
                fontSize: 16,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: colors.sidebarTextActive,
                letterSpacing: -0.3,
              }}
            >
              NibJobs
            </Text>
            <Text
              style={{
                fontSize: 10,
                fontFamily: fonts.regular,
                color: colors.adminMuted,
                letterSpacing: 0.5,
                textTransform: "uppercase",
                marginTop: 1,
              }}
            >
              Admin Console
            </Text>
          </View>
        )}
        {/* Collapse toggle (Desktop only) or Close button (Mobile) */}
        {isMobile ? (
          <TouchableOpacity
            onPress={toggleDrawer}
            style={{
              width: 32,
              height: 32,
              borderRadius: 10,
              backgroundColor: colors.sidebarHover,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon name="close" size={18} color={colors.adminMuted} />
          </TouchableOpacity>
        ) : (
          <TouchableOpacity
            onPress={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
            style={{
              width: 26,
              height: 26,
              borderRadius: 8,
              backgroundColor: colors.sidebarHover,
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 0,
            }}
          >
            <Icon
              name={isSidebarCollapsed ? "chevron-right" : "chevron-left"}
              size={14}
              color={colors.adminMuted}
            />
          </TouchableOpacity>
        )}
      </View>

      {/* ── User card ── */}
      {(!isSidebarCollapsed || isMobile) && (
        <View
          style={{
            margin: 12,
            borderRadius: 12,
            backgroundColor: colors.sidebarHover,
            padding: 12,
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
          }}
        >
          <View
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              backgroundColor:
                user?.role === "superadmin" ? "#F59E0B22" : "#3B82F622",
              borderWidth: 1.5,
              borderColor:
                user?.role === "superadmin" ? "#F59E0B55" : "#3B82F655",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                fontSize: 16,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: user?.role === "superadmin" ? "#F59E0B" : "#3B82F6",
              }}
            >
              {user?.displayName?.charAt(0)?.toUpperCase() ||
                user?.email?.charAt(0)?.toUpperCase() ||
                "A"}
            </Text>
          </View>
          <View style={{ flex: 1, minWidth: 0 }}>
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.bold,
                fontWeight: "600",
                color: colors.sidebarTextActive,
              }}
              numberOfLines={1}
            >
              {user?.displayName || user?.email?.split("@")[0] || "Admin"}
            </Text>
            <View
              style={{
                marginTop: 3,
                flexDirection: "row",
                alignItems: "center",
                gap: 5,
                backgroundColor:
                  user?.role === "superadmin" ? "#F59E0B18" : "#3B82F618",
                paddingHorizontal: 6,
                paddingVertical: 2,
                borderRadius: 6,
                alignSelf: "flex-start",
              }}
            >
              <View
                style={{
                  width: 5,
                  height: 5,
                  borderRadius: 3,
                  backgroundColor:
                    user?.role === "superadmin" ? "#F59E0B" : "#3B82F6",
                }}
              />
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: fonts.bold,
                  fontWeight: "700",
                  color:
                    user?.role === "superadmin"
                      ? isDarkMode
                        ? "#FCD34D"
                        : "#D97706"
                      : isDarkMode
                      ? "#93C5FD"
                      : "#2563EB",
                  letterSpacing: 0.3,
                  textTransform: "uppercase",
                }}
              >
                {user?.role === "superadmin" ? "Super Admin" : "Admin"}
              </Text>
            </View>
          </View>
        </View>
      )}

      {/* ── Navigation ── */}
      <View
        style={{
          flex: 1,
          paddingHorizontal: isSidebarCollapsed && !isMobile ? 8 : 12,
          marginTop: 4,
        }}
      >
        {sidebarCategories.map((category: any) => {
          const catAccent =
            ADMIN_CATEGORY_ACCENTS[category.label] || colors.adminMuted;
          return (
            <View key={category.label} style={{ marginBottom: 4 }}>
              {/* Section label */}
              {(!isSidebarCollapsed || isMobile) && (
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 6,
                    paddingHorizontal: 8,
                    marginTop: 16,
                    marginBottom: 4,
                  }}
                >
                  <View
                    style={{
                      width: 3,
                      height: 10,
                      borderRadius: 2,
                      backgroundColor: catAccent,
                    }}
                  />
                  <Text
                    style={{
                      fontSize: 9,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: catAccent,
                      letterSpacing: 1.4,
                      textTransform: "uppercase",
                    }}
                  >
                    {category.label}
                  </Text>
                </View>
              )}
              {isSidebarCollapsed && !isMobile && (
                <View style={{ height: 8 }} />
              )}
              {/* Nav items */}
              {category.items.map((item: any) => {
                const isActive = activeTab === item.id;
                return (
                  <TouchableOpacity
                    key={item.id}
                    onPress={() => handleTabChange(item.id)}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 10,
                      paddingVertical: 9,
                      paddingHorizontal:
                        isSidebarCollapsed && !isMobile ? 10 : 10,
                      borderRadius: 10,
                      marginBottom: 2,
                      backgroundColor: isActive
                        ? catAccent + "22"
                        : "transparent",
                      borderLeftWidth: isActive ? 3 : 0,
                      borderLeftColor: isActive ? catAccent : "transparent",
                    }}
                  >
                    <View
                      style={{
                        width: isSidebarCollapsed && !isMobile ? 36 : 30,
                        height: isSidebarCollapsed && !isMobile ? 36 : 30,
                        borderRadius: isSidebarCollapsed && !isMobile ? 10 : 8,
                        backgroundColor: isActive
                          ? catAccent + "30"
                          : colors.sidebarHover,
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: 0,
                      }}
                    >
                      <Icon
                        name={item.icon}
                        size={16}
                        color={isActive ? catAccent : colors.sidebarText}
                      />
                    </View>
                    {(!isSidebarCollapsed || isMobile) && (
                      <Text
                        style={{
                          flex: 1,
                          fontSize: 13,
                          fontFamily: isActive ? fonts.semiBold : fonts.regular,
                          fontWeight: isActive ? "600" : "400",
                          color: isActive
                            ? colors.sidebarTextActive
                            : colors.sidebarText,
                        }}
                      >
                        {item.title}
                      </Text>
                    )}
                    {isActive && (!isSidebarCollapsed || isMobile) && (
                      <View
                        style={{
                          width: 6,
                          height: 6,
                          borderRadius: 3,
                          backgroundColor: catAccent,
                        }}
                      />
                    )}
                  </TouchableOpacity>
                );
              })}
            </View>
          );
        })}
      </View>

      {/* ── Bottom: Theme + Sign Out ── */}
      <View
        style={{
          paddingHorizontal: isSidebarCollapsed && !isMobile ? 8 : 12,
          paddingTop: 12,
          marginTop: 8,
          borderTopWidth: 1,
          borderTopColor: colors.sidebarBorder,
          gap: 4,
        }}
      >
        {/* Theme toggle */}
        <TouchableOpacity
          onPress={toggleTheme}
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
            paddingVertical: 9,
            paddingHorizontal: 10,
            borderRadius: 10,
            backgroundColor: colors.sidebarHover,
          }}
        >
          <View
            style={{
              width: isSidebarCollapsed && !isMobile ? 36 : 30,
              height: isSidebarCollapsed && !isMobile ? 36 : 30,
              borderRadius: isSidebarCollapsed && !isMobile ? 10 : 8,
              backgroundColor: isDarkMode ? "#FCD34D18" : "#3B82F618",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon
              name={isDarkMode ? "wb-sunny" : "nights-stay"}
              size={16}
              color={isDarkMode ? "#FCD34D" : "#60A5FA"}
            />
          </View>
          {(!isSidebarCollapsed || isMobile) && (
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.regular,
                color: colors.sidebarText,
              }}
            >
              {isDarkMode ? "Light Mode" : "Dark Mode"}
            </Text>
          )}
        </TouchableOpacity>

        {/* Sign out */}
        <TouchableOpacity
          onPress={() => setShowLogoutModal(true)}
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
            paddingVertical: 9,
            paddingHorizontal: 10,
            borderRadius: 10,
            backgroundColor: `${colors.danger}18`,
          }}
        >
          <View
            style={{
              width: isSidebarCollapsed && !isMobile ? 36 : 30,
              height: isSidebarCollapsed && !isMobile ? 36 : 30,
              borderRadius: isSidebarCollapsed && !isMobile ? 10 : 8,
              backgroundColor: `${colors.danger}18`,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon name="logout" size={16} color={colors.danger} />
          </View>
          {(!isSidebarCollapsed || isMobile) && (
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.semiBold,
                fontWeight: "600",
                color: colors.danger,
              }}
            >
              Sign Out
            </Text>
          )}
        </TouchableOpacity>
      </View>
    </ScrollView>
  );

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: colors.white }]}>
      <View
        style={[
          styles.adminContainer,
          { flexDirection: isMobile ? "column" : "row" },
        ]}
      >
        {/* ── Mobile Header (Hamburger Menu) ── */}
        {isMobile && (
          <View
            style={{
              height: 56,
              backgroundColor: colors.sidebarBg,
              borderBottomWidth: 1,
              borderBottomColor: colors.sidebarBorder,
              flexDirection: "row",
              alignItems: "center",
              paddingHorizontal: 16,
              gap: 12,
              zIndex: 10,
            }}
          >
            {/* Hamburger Menu */}
            <TouchableOpacity
              onPress={toggleDrawer}
              style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                backgroundColor: colors.sidebarHover,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Icon name="menu" size={22} color={colors.sidebarTextActive} />
            </TouchableOpacity>

            {/* Logo + Title */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
                flex: 1,
              }}
            >
              <View
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  backgroundColor: colors.sidebarAccent,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image
                  source={require("./assets/favicon.png")}
                  style={{ width: 20, height: 20 }}
                />
              </View>
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 15,
                    fontFamily: fonts.bold,
                    color: colors.sidebarTextActive,
                    letterSpacing: -0.2,
                  }}
                >
                  Admin Console
                </Text>
                <Text
                  style={{
                    fontSize: 10,
                    color: colors.adminMuted,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                  }}
                >
                  {sidebarCategories
                    .flatMap((c) => c.items)
                    .find((i) => i.id === activeTab)?.title || "Dashboard"}
                </Text>
              </View>
            </View>

            {/* User Avatar */}
            <View
              style={{
                width: 36,
                height: 36,
                borderRadius: 10,
                backgroundColor:
                  user?.role === "superadmin" ? "#F59E0B22" : "#3B82F622",
                borderWidth: 2,
                borderColor:
                  user?.role === "superadmin" ? "#F59E0B" : "#3B82F6",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.bold,
                  color: user?.role === "superadmin" ? "#F59E0B" : "#3B82F6",
                }}
              >
                {user?.displayName?.charAt(0)?.toUpperCase() ||
                  user?.email?.charAt(0)?.toUpperCase() ||
                  "A"}
              </Text>
            </View>
          </View>
        )}

        {/* ── Drawer Overlay (Mobile) ── */}
        {isMobile && isDrawerOpen && (
          <View
            style={{
              position: "absolute",
              top: 56,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 999,
              flexDirection: "row",
            }}
          >
            {/* Sidebar (direct child — scrolls independently) */}
            {renderSidebar()}
            {/* Backdrop tap area */}
            <TouchableOpacity
              activeOpacity={1}
              onPress={toggleDrawer}
              style={{ flex: 1, backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            />
          </View>
        )}

        {/* ── Desktop Sidebar ── */}
        {!isMobile && renderSidebar()}

        {/* Main Content */}
        <View
          style={[
            styles.adminMainContent,
            {
              backgroundColor: colors.lightGray,
              paddingBottom: isMobile ? 68 : 0, // Add padding for bottom nav on mobile
            },
          ]}
        >
          {activeTab === "analytics" && (
            <AnalyticsContent colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "engagement" && (
            <EngagementContent colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "insights" && (
            <InsightsContent colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "categories" && (
            <CategoriesContent colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "jobs" && (
            <JobsContent colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "telegram" && (
            <TelegramChannelsScreen colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "scrapeHistory" && (
            <ScrapeHistoryContent colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "users" && (
            <UsersContent colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "companies" && (
            <CompanyVerificationsContent
              colors={colors}
              isDarkMode={isDarkMode}
            />
          )}
          {activeTab === "subscriptions" && (
            <SubscriptionsContent colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "payments" && (
            <PaymentRequestsContent colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "banks" && (
            <BankConfigurationContent colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "support" && (
            <SupportRequestsContent colors={colors} isDarkMode={isDarkMode} />
          )}
          {activeTab === "announcements" && (
            <AnnouncementsScreen
              colors={colors}
              isDarkMode={isDarkMode}
              userRole={user?.role}
            />
          )}
          {activeTab === "settings" && (
            <AdminSettingsContent
              colors={colors}
              isDarkMode={isDarkMode}
              userRole={user?.role}
            />
          )}
        </View>

        {/* ── Bottom Navigation Bar (Mobile Only) ── */}
        {isMobile && (
          <View
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: 64,
              backgroundColor: isDarkMode ? "#0D1424" : "#FFFFFF",
              borderTopWidth: 1,
              borderTopColor: isDarkMode ? "#1E293B" : "#E2E8F0",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-around",
              paddingHorizontal: 8,
              paddingBottom: Platform.OS === "ios" ? 8 : 0,
              shadowColor: "#000",
              shadowOffset: { width: 0, height: -2 },
              shadowOpacity: 0.1,
              shadowRadius: 8,
              elevation: 8,
            }}
          >
            {/* Quick Action Buttons */}
            {[
              {
                id: "analytics",
                icon: "analytics",
                label: "Analytics",
                color: "#6366F1",
              },
              { id: "users", icon: "people", label: "Users", color: "#F59E0B" },
              { id: "jobs", icon: "work", label: "Jobs", color: "#10B981" },
              {
                id: "support",
                icon: "support",
                label: "Support",
                color: "#14B8A6",
              },
              {
                id: "settings",
                icon: "settings",
                label: "Settings",
                color: "#64748B",
              },
            ].map((item) => {
              const isActive = activeTab === item.id;
              return (
                <TouchableOpacity
                  key={item.id}
                  onPress={() => handleTabChange(item.id)}
                  style={{
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    paddingVertical: 8,
                    borderRadius: 12,
                    backgroundColor: isActive
                      ? `${item.color}15`
                      : "transparent",
                  }}
                >
                  <View
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 10,
                      backgroundColor: isActive
                        ? `${item.color}25`
                        : "transparent",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 2,
                    }}
                  >
                    <Icon
                      name={item.icon}
                      size={20}
                      color={
                        isActive
                          ? item.color
                          : isDarkMode
                          ? "#64748B"
                          : "#94A3B8"
                      }
                    />
                  </View>
                  <Text
                    style={{
                      fontSize: 10,
                      fontFamily: isActive ? fonts.semiBold : fonts.regular,
                      color: isActive
                        ? item.color
                        : isDarkMode
                        ? "#64748B"
                        : "#94A3B8",
                      letterSpacing: 0.3,
                    }}
                  >
                    {item.label}
                  </Text>
                </TouchableOpacity>
              );
            })}
          </View>
        )}
      </View>

      {/* ── Logout Confirmation Modal (Admin) ── */}
      <Modal
        visible={showLogoutModal}
        transparent
        animationType="fade"
        onRequestClose={() => setShowLogoutModal(false)}
      >
        <View
          style={{
            flex: 1,
            backgroundColor: "rgba(0,0,0,0.55)",
            justifyContent: "center",
            alignItems: "center",
            padding: 28,
          }}
        >
          <View
            style={{
              width: "100%",
              maxWidth: 360,
              backgroundColor: isDarkMode ? "#161F2E" : "#FFFFFF",
              borderRadius: 20,
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <View
              style={{
                paddingHorizontal: 24,
                paddingTop: 28,
                paddingBottom: 16,
                alignItems: "center",
              }}
            >
              <View
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: 16,
                  backgroundColor: "#EF444418",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 14,
                }}
              >
                <Icon name="logout" size={26} color="#EF4444" />
              </View>
              <Text
                style={{
                  fontSize: 18,
                  fontFamily: fonts.bold,
                  fontWeight: "700",
                  color: isDarkMode ? "#F9FAFB" : "#0F172A",
                  marginBottom: 8,
                }}
              >
                Sign Out?
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.regular,
                  color: isDarkMode ? "#94A3B8" : "#64748B",
                  textAlign: "center",
                  lineHeight: 20,
                }}
              >
                You will be signed out of the admin console and returned to the
                home screen.
              </Text>
            </View>
            {/* Actions */}
            <View
              style={{
                flexDirection: "row",
                gap: 10,
                paddingHorizontal: 20,
                paddingBottom: 24,
                paddingTop: 8,
              }}
            >
              <TouchableOpacity
                onPress={() => setShowLogoutModal(false)}
                style={{
                  flex: 1,
                  paddingVertical: 12,
                  borderRadius: 11,
                  backgroundColor: isDarkMode ? "#1E293B" : "#F1F5F9",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    fontWeight: "600",
                    color: isDarkMode ? "#94A3B8" : "#64748B",
                  }}
                >
                  Cancel
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={handleLogout}
                style={{
                  flex: 1,
                  paddingVertical: 12,
                  borderRadius: 11,
                  backgroundColor: "#EF4444",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    fontWeight: "600",
                    color: "#FFFFFF",
                  }}
                >
                  Sign Out
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </SafeAreaView>
  );
}

// Categories Content
function CategoriesContent({
  colors = lightColors,
  isDarkMode = false,
}: {
  colors?: any;
  isDarkMode?: boolean;
}) {
  const [categories, setCategories] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [expandedCategories, setExpandedCategories] = useState<Set<string>>(
    new Set(),
  );
  const [editingTags, setEditingTags] = useState<string | null>(null);
  const [newTag, setNewTag] = useState("");
  const [savingTags, setSavingTags] = useState(false);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));

  const isMobile = dimensions.width < 768;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  const toggleCategory = (categoryId: string) => {
    setExpandedCategories((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(categoryId)) {
        newSet.delete(categoryId);
      } else {
        newSet.add(categoryId);
      }
      return newSet;
    });
  };

  const getSubcategories = (parentPath: string) => {
    return categories.filter(
      (cat) => cat.level === 1 && cat.parentPath === parentPath,
    );
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      setLoading(true);
      console.log("🔍 Fetching categories from Firebase...");

      // Use a simpler query first - just get all categories without ordering
      // Once the index is built, we can add back the orderBy clauses
      const categoriesQuery = collection(db, "categories");

      console.log("📡 Executing query...");
      const categoriesSnapshot = await getDocs(categoriesQuery);

      console.log("📊 Query results:", {
        empty: categoriesSnapshot.empty,
        size: categoriesSnapshot.size,
        docs: categoriesSnapshot.docs.length,
      });

      const fetchedCategories = categoriesSnapshot.docs.map((doc) => {
        const data = doc.data();
        console.log("📝 Category doc:", { id: doc.id, data });
        return {
          id: doc.id,
          ...data,
          icon: getIconFromEmoji(data.icon || "📁"),
        };
      });

      // Sort manually in the client for now
      fetchedCategories.sort((a: any, b: any) => {
        if (a.level !== b.level) {
          return (a.level || 0) - (b.level || 0); // Sort by level first
        }
        return (a.order || 0) - (b.order || 0); // Then by order
      });

      console.log("✅ Fetched categories:", fetchedCategories);
      setCategories(fetchedCategories);
    } catch (error) {
      console.error("❌ Error fetching categories:", error);
      const errorMessage =
        error instanceof Error ? error.message : "Unknown error occurred";
      Alert.alert("Error", `Failed to load categories: ${errorMessage}`);
      // Fallback to empty array
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddTag = async (categoryId: string) => {
    if (!newTag.trim()) return;

    try {
      setSavingTags(true);
      const categoryRef = doc(db, "categories", categoryId);
      const categoryDoc = await getDoc(categoryRef);

      if (categoryDoc.exists()) {
        const currentTags = categoryDoc.data().tags || [];

        // Split by comma and trim each tag
        const newTags = newTag
          .split(",")
          .map((tag) => tag.trim())
          .filter((tag) => tag.length > 0)
          .filter((tag) => !currentTags.includes(tag)); // Avoid duplicates

        if (newTags.length === 0) {
          Alert.alert("Info", "All tags already exist or input is empty");
          setSavingTags(false);
          return;
        }

        const updatedTags = [...currentTags, ...newTags];

        await updateDoc(categoryRef, { tags: updatedTags });

        // Update local state
        setCategories((prev) =>
          prev.map((cat) =>
            cat.id === categoryId ? { ...cat, tags: updatedTags } : cat,
          ),
        );

        setNewTag("");
        const message =
          newTags.length === 1
            ? "Tag added successfully!"
            : `${newTags.length} tags added successfully!`;
        Alert.alert("Success", message);
      }
    } catch (error) {
      console.error("Error adding tag:", error);
      Alert.alert("Error", "Failed to add tag");
    } finally {
      setSavingTags(false);
    }
  };

  const handleRemoveTag = async (categoryId: string, tagToRemove: string) => {
    try {
      setSavingTags(true);
      const categoryRef = doc(db, "categories", categoryId);
      const categoryDoc = await getDoc(categoryRef);

      if (categoryDoc.exists()) {
        const currentTags = categoryDoc.data().tags || [];
        const updatedTags = currentTags.filter(
          (tag: string) => tag !== tagToRemove,
        );

        await updateDoc(categoryRef, { tags: updatedTags });

        // Update local state
        setCategories((prev) =>
          prev.map((cat) =>
            cat.id === categoryId ? { ...cat, tags: updatedTags } : cat,
          ),
        );

        Alert.alert("Success", "Tag removed successfully!");
      }
    } catch (error) {
      console.error("Error removing tag:", error);
      Alert.alert("Error", "Failed to remove tag");
    } finally {
      setSavingTags(false);
    }
  };

  return (
    <View
      style={{ flex: 1, backgroundColor: colors.adminPageBg }}
    >
      {/* ── Page Header ── */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: colors.adminHeaderBg,
          paddingHorizontal: 28,
          paddingVertical: 18,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center", gap: 14 }}>
          <View
            style={{
              width: 40,
              height: 40,
              borderRadius: 11,
              backgroundColor: `${colors.sidebarAccent}22`,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon name="category" size={22} color={colors.sidebarAccent} />
          </View>
          <View>
            <Text
              style={{
                fontSize: 18,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#F9FAFB",
                letterSpacing: -0.3,
              }}
            >
              Job Categories
            </Text>
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.regular,
                color: "#64748B",
                marginTop: 1,
              }}
            >
              {categories.filter((c) => c.level === 0).length} categories ·{" "}
              {categories.filter((c) => c.level === 1).length} subcategories
            </Text>
          </View>
        </View>
        <TouchableOpacity
          onPress={fetchCategories}
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 6,
            backgroundColor: colors.sidebarAccent,
            paddingHorizontal: 14,
            paddingVertical: 8,
            borderRadius: 9,
          }}
        >
          <Icon name="refresh" size={15} color="#FFFFFF" />
          <Text
            style={{
              fontSize: 12,
              fontFamily: fonts.semiBold,
              fontWeight: "600",
              color: "#FFFFFF",
            }}
          >
            Refresh
          </Text>
        </TouchableOpacity>
      </View>

      {loading ? (
        <InlineLoadingIndicator
          message="Loading categories..."
          isDarkMode={isDarkMode}
        />
      ) : categories.length === 0 ? (
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            gap: 12,
          }}
        >
          <View
            style={{
              width: 64,
              height: 64,
              borderRadius: 18,
              backgroundColor: colors.adminBorder,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon
              name="category"
              size={32}
              color={colors.adminMuted}
            />
          </View>
          <Text
            style={{
              fontSize: 16,
              fontFamily: fonts.bold,
              fontWeight: "600",
              color: colors.adminMuted,
            }}
          >
            No categories found
          </Text>
        </View>
      ) : (
        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={{ padding: 24, gap: 12 }}
          showsVerticalScrollIndicator={false}
        >
          {categories
            .filter((category) => category.level === 0)
            .map((category) => {
              const subcategories = getSubcategories(category.path);
              const isExpanded = expandedCategories.has(category.id);
              const hasSubcategories = subcategories.length > 0;
              const catColor = category.color || "#10B981";

              return (
                <View
                  key={category.id}
                  style={{
                    backgroundColor: colors.adminCardBg,
                    borderRadius: 14,
                    overflow: "hidden",
                    borderLeftWidth: 3,
                    borderLeftColor: catColor,
                    ...Platform.select({
                      web: {
                        boxShadow: isDarkMode
                          ? "0 2px 10px rgba(0,0,0,0.25)"
                          : "0 2px 10px rgba(0,0,0,0.06)",
                      },
                      default: {
                        shadowColor: "#000",
                        shadowOffset: { width: 0, height: 2 },
                        shadowOpacity: 0.07,
                        shadowRadius: 6,
                        elevation: 2,
                      },
                    }),
                  }}
                >
                  {/* Category row */}
                  <TouchableOpacity
                    onPress={() =>
                      hasSubcategories && toggleCategory(category.id)
                    }
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      padding: 16,
                      gap: 14,
                    }}
                    activeOpacity={hasSubcategories ? 0.7 : 1}
                  >
                    <View
                      style={{
                        width: 42,
                        height: 42,
                        borderRadius: 11,
                        backgroundColor: catColor + "20",
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: 0,
                      }}
                    >
                      <Icon
                        name={getIconFromEmoji(category.icon)}
                        size={22}
                        color={catColor}
                      />
                    </View>
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 15,
                          fontFamily: fonts.bold,
                          fontWeight: "700",
                          color: colors.sidebarTextActive,
                        }}
                      >
                        {category.name}
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 10,
                          marginTop: 3,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 4,
                          }}
                        >
                          <Icon
                            name="work-outline"
                            size={11}
                            color={colors.adminMuted}
                          />
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.regular,
                              color: colors.adminMuted,
                            }}
                          >
                            {category.jobCount || 0} jobs
                          </Text>
                        </View>
                        {hasSubcategories && (
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 4,
                            }}
                          >
                            <Icon
                              name="account-tree"
                              size={11}
                              color={colors.adminMuted}
                            />
                            <Text
                              style={{
                                fontSize: 11,
                                fontFamily: fonts.regular,
                                color: colors.adminMuted,
                              }}
                            >
                              {subcategories.length} subcategories
                            </Text>
                          </View>
                        )}
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.regular,
                            color: colors.adminMuted,
                          }}
                        >
                          {category.path}
                        </Text>
                      </View>
                    </View>
                    {hasSubcategories && (
                      <View
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 8,
                          backgroundColor: colors.sidebarHover,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Icon
                          name={
                            isExpanded
                              ? "keyboard-arrow-up"
                              : "keyboard-arrow-down"
                          }
                          size={20}
                          color={colors.adminMuted}
                        />
                      </View>
                    )}
                  </TouchableOpacity>

                  {/* Subcategories */}
                  {isExpanded && (
                    <View
                      style={{
                        borderTopWidth: 1,
                        borderTopColor: colors.adminBorder,
                      }}
                    >
                      {subcategories.map((sub, subIdx) => (
                        <View
                          key={sub.id}
                          style={{
                            borderTopWidth: subIdx > 0 ? 1 : 0,
                            borderTopColor: colors.adminBorder,
                          }}
                        >
                          {/* Subcategory row */}
                          <View
                            style={{
                              flexDirection: "row",
                              alignItems: "flex-start",
                              paddingVertical: 14,
                              paddingHorizontal: 16,
                              paddingLeft: 28,
                              gap: 12,
                              backgroundColor: isDarkMode
                                ? "#0F172A"
                                : "#F8FAFC",
                            }}
                          >
                            <View
                              style={{
                                width: 34,
                                height: 34,
                                borderRadius: 9,
                                backgroundColor: (sub.color || catColor) + "18",
                                justifyContent: "center",
                                alignItems: "center",
                                flexShrink: 0,
                                marginTop: 2,
                              }}
                            >
                              <Icon
                                name={getIconFromEmoji(sub.icon)}
                                size={18}
                                color={sub.color || catColor}
                              />
                            </View>
                            <View style={{ flex: 1 }}>
                              <View
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: 10,
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 13,
                                    fontFamily: fonts.bold,
                                    fontWeight: "600",
                                    color: colors.sidebarTextActive,
                                    flex: 1,
                                  }}
                                >
                                  {sub.name}
                                </Text>
                                <TouchableOpacity
                                  onPress={() =>
                                    setEditingTags(
                                      editingTags === sub.id ? null : sub.id,
                                    )
                                  }
                                  style={{
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: 5,
                                    backgroundColor:
                                      editingTags === sub.id
                                        ? isDarkMode
                                          ? "#1E293B"
                                          : "#E2E8F0"
                                        : "#F59E0B",
                                    paddingHorizontal: 10,
                                    paddingVertical: 5,
                                    borderRadius: 7,
                                  }}
                                >
                                  <Icon
                                    name={
                                      editingTags === sub.id ? "close" : "label"
                                    }
                                    size={13}
                                    color={
                                      editingTags === sub.id
                                        ? isDarkMode
                                          ? "#64748B"
                                          : "#64748B"
                                        : "#0F172A"
                                    }
                                  />
                                  <Text
                                    style={{
                                      fontSize: 11,
                                      fontFamily: fonts.bold,
                                      fontWeight: "600",
                                      color:
                                        editingTags === sub.id
                                          ? isDarkMode
                                            ? "#64748B"
                                            : "#64748B"
                                          : "#0F172A",
                                    }}
                                  >
                                    {editingTags === sub.id ? "Close" : "Tags"}
                                  </Text>
                                </TouchableOpacity>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 8,
                                  marginTop: 3,
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 11,
                                    fontFamily: fonts.regular,
                                    color: colors.adminMuted,
                                  }}
                                >
                                  {sub.jobCount || 0} jobs
                                </Text>
                                <Text
                                  style={{
                                    fontSize: 11,
                                    fontFamily: fonts.regular,
                                    color: colors.adminMuted,
                                  }}
                                >
                                  {sub.fullPath}
                                </Text>
                              </View>
                              {/* Tag chips */}
                              {sub.tags &&
                                sub.tags.length > 0 &&
                                editingTags !== sub.id && (
                                  <View
                                    style={{
                                      flexDirection: "row",
                                      flexWrap: "wrap",
                                      gap: 5,
                                      marginTop: 8,
                                    }}
                                  >
                                    {sub.tags
                                      .slice(0, 6)
                                      .map((tag: string, ti: number) => (
                                        <View
                                          key={ti}
                                          style={{
                                            backgroundColor: isDarkMode
                                              ? "#1E293B"
                                              : "#F1F5F9",
                                            paddingHorizontal: 8,
                                            paddingVertical: 3,
                                            borderRadius: 6,
                                            borderWidth: 1,
                                            borderColor: isDarkMode
                                              ? "#334155"
                                              : "#E2E8F0",
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: 10,
                                              fontFamily: fonts.medium,
                                              color: isDarkMode
                                                ? "#94A3B8"
                                                : "#64748B",
                                            }}
                                          >
                                            {tag}
                                          </Text>
                                        </View>
                                      ))}
                                    {sub.tags.length > 6 && (
                                      <Text
                                        style={{
                                          fontSize: 10,
                                          fontFamily: fonts.regular,
                                          color: isDarkMode
                                            ? "#475569"
                                            : "#94A3B8",
                                          alignSelf: "center",
                                        }}
                                      >
                                        +{sub.tags.length - 6} more
                                      </Text>
                                    )}
                                  </View>
                                )}
                            </View>
                          </View>

                          {/* Tag editor */}
                          {editingTags === sub.id && (
                            <View
                              style={{
                                padding: 16,
                                paddingLeft: 28,
                                backgroundColor: isDarkMode
                                  ? "#0D1424"
                                  : "#F1F5F9",
                                borderTopWidth: 1,
                                borderTopColor: isDarkMode
                                  ? "#1E293B"
                                  : "#E2E8F0",
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 11,
                                  fontFamily: fonts.bold,
                                  fontWeight: "700",
                                  color: "#F59E0B",
                                  letterSpacing: 1.2,
                                  textTransform: "uppercase",
                                  marginBottom: 12,
                                }}
                              >
                                Tags · {sub.name}
                              </Text>
                              {/* Add tag row */}
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 8,
                                  marginBottom: 14,
                                }}
                              >
                                <View
                                  style={{
                                    flex: 1,
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: 8,
                                    backgroundColor: isDarkMode
                                      ? "#161F2E"
                                      : "#FFFFFF",
                                    borderRadius: 9,
                                    paddingHorizontal: 12,
                                    borderWidth: 1,
                                    borderColor: isDarkMode
                                      ? "#1E293B"
                                      : "#E2E8F0",
                                  }}
                                >
                                  <Icon
                                    name="add"
                                    size={16}
                                    color={colors.adminMuted}
                                  />
                                  <TextInput
                                    style={
                                      {
                                        flex: 1,
                                        height: 36,
                                        fontSize: 13,
                                        fontFamily: fonts.regular,
                                        color: isDarkMode
                                          ? "#F1F5F9"
                                          : "#0F172A",
                                        outlineStyle: "none",
                                      } as any
                                    }
                                    placeholder="Add tag (comma-separated)…"
                                    placeholderTextColor={
                                      colors.adminMuted
                                    }
                                    value={newTag}
                                    onChangeText={setNewTag}
                                    onSubmitEditing={() => handleAddTag(sub.id)}
                                  />
                                </View>
                                <TouchableOpacity
                                  onPress={() => handleAddTag(sub.id)}
                                  disabled={!newTag.trim() || savingTags}
                                  style={{
                                    backgroundColor: "#F59E0B",
                                    paddingHorizontal: 16,
                                    borderRadius: 9,
                                    justifyContent: "center",
                                    alignItems: "center",
                                    opacity:
                                      !newTag.trim() || savingTags ? 0.5 : 1,
                                  }}
                                >
                                  {savingTags ? (
                                    <ActivityIndicator
                                      size="small"
                                      color="#0F172A"
                                    />
                                  ) : (
                                    <Text
                                      style={{
                                        fontSize: 13,
                                        fontFamily: fonts.bold,
                                        fontWeight: "700",
                                        color: "#0F172A",
                                      }}
                                    >
                                      Add
                                    </Text>
                                  )}
                                </TouchableOpacity>
                              </View>
                              {/* Existing tags */}
                              <View
                                style={{
                                  flexDirection: "row",
                                  flexWrap: "wrap",
                                  gap: 6,
                                }}
                              >
                                {sub.tags && sub.tags.length > 0 ? (
                                  sub.tags.map((tag: string, ti: number) => (
                                    <View
                                      key={ti}
                                      style={{
                                        flexDirection: "row",
                                        alignItems: "center",
                                        gap: 5,
                                        backgroundColor: isDarkMode
                                          ? "#1E293B"
                                          : "#FFFFFF",
                                        paddingLeft: 10,
                                        paddingRight: 6,
                                        paddingVertical: 5,
                                        borderRadius: 8,
                                        borderWidth: 1,
                                        borderColor: isDarkMode
                                          ? "#334155"
                                          : "#E2E8F0",
                                      }}
                                    >
                                      <Text
                                        style={{
                                          fontSize: 12,
                                          fontFamily: fonts.medium,
                                          color: isDarkMode
                                            ? "#CBD5E1"
                                            : "#374151",
                                        }}
                                      >
                                        {tag}
                                      </Text>
                                      <TouchableOpacity
                                        onPress={() =>
                                          handleRemoveTag(sub.id, tag)
                                        }
                                        disabled={savingTags}
                                        style={{
                                          width: 18,
                                          height: 18,
                                          borderRadius: 5,
                                          backgroundColor: "#EF444422",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Icon
                                          name="close"
                                          size={11}
                                          color="#EF4444"
                                        />
                                      </TouchableOpacity>
                                    </View>
                                  ))
                                ) : (
                                  <Text
                                    style={{
                                      fontSize: 12,
                                      fontFamily: fonts.regular,
                                      color: colors.adminMuted,
                                    }}
                                  >
                                    No tags yet.
                                  </Text>
                                )}
                              </View>
                            </View>
                          )}
                        </View>
                      ))}
                    </View>
                  )}
                </View>
              );
            })}
        </ScrollView>
      )}
    </View>
  );
}

// Jobs Content
interface Job {
  id: string;
  title: string;
  company: string;
  category: string;
  contractType: string;
  location: string;
  salary?: string;
  jobSource: string;
  postedDate?: Date;
  createdAt?: Date;
  isRemote: boolean;
  tags: string[];
}

function JobsContent({
  colors = lightColors,
  isDarkMode = false,
}: {
  colors?: any;
  isDarkMode?: boolean;
}) {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalJobs, setTotalJobs] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastDoc, setLastDoc] = useState<any>(null);
  const [firstDoc, setFirstDoc] = useState<any>(null);
  const [pageSnapshots, setPageSnapshots] = useState<Map<number, any>>(
    new Map(),
  );
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const jobsPerPage = 20;

  const isMobile = dimensions.width < 768;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  // Get total count of jobs
  const getTotalCount = async () => {
    try {
      const jobsRef = collection(db, "jobs");
      const countSnapshot = await getCountFromServer(jobsRef);
      setTotalJobs(countSnapshot.data().count);
    } catch (err) {
      console.error("Error getting total count:", err);
    }
  };

  const loadJobs = async (
    page: number = 1,
    direction: "next" | "prev" | "first" = "first",
  ) => {
    try {
      setLoading(true);
      console.log(`📋 Loading jobs from Firestore - Page ${page}`);

      const jobsRef = collection(db, "jobs");
      let jobsQuery;

      if (direction === "first" || page === 1) {
        // First page - no cursor
        jobsQuery = dbQuery(
          jobsRef,
          orderBy("createdAt", "desc"),
          limit(jobsPerPage),
        );
      } else if (direction === "next" && lastDoc) {
        // Next page - start after last document
        jobsQuery = dbQuery(
          jobsRef,
          orderBy("createdAt", "desc"),
          startAfter(lastDoc),
          limit(jobsPerPage),
        );
      } else if (direction === "prev" && pageSnapshots.has(page)) {
        // Previous page - use cached snapshot
        const cachedDoc = pageSnapshots.get(page);
        jobsQuery = dbQuery(
          jobsRef,
          orderBy("createdAt", "desc"),
          startAfter(cachedDoc),
          limit(jobsPerPage),
        );
      } else {
        // Fallback to first page
        jobsQuery = dbQuery(
          jobsRef,
          orderBy("createdAt", "desc"),
          limit(jobsPerPage),
        );
      }

      const querySnapshot = await getDocs(jobsQuery);

      if (querySnapshot.empty) {
        setJobs([]);
        setError("No jobs found");
        setLoading(false);
        return;
      }

      const jobsData: Job[] = [];

      querySnapshot.forEach((doc) => {
        const data = doc.data() as any;
        jobsData.push({
          id: doc.id,
          title: data.title || "No title",
          company: data.company || "Unknown company",
          category: data.category || "Other",
          contractType: data.contractType || "Full-time",
          location: data.location || "Not specified",
          salary: data.salary,
          jobSource: data.jobSource || "Unknown",
          postedDate: data.postedDate ? data.postedDate.toDate() : null,
          createdAt: data.createdAt ? data.createdAt.toDate() : null,
          isRemote: data.isRemote || false,
          tags: data.tags || [],
        });
      });

      // Cache first document of current page for previous navigation
      const newPageSnapshots = new Map(pageSnapshots);
      if (querySnapshot.docs.length > 0) {
        newPageSnapshots.set(page, querySnapshot.docs[0]);
        setPageSnapshots(newPageSnapshots);
      }

      // Store last and first documents for pagination
      setLastDoc(querySnapshot.docs[querySnapshot.docs.length - 1]);
      setFirstDoc(querySnapshot.docs[0]);

      console.log(
        `✅ Loaded ${jobsData.length} jobs from Firestore (Page ${page})`,
      );
      setJobs(jobsData);
      setCurrentPage(page);
      setError(null);
    } catch (err) {
      console.error("❌ Error loading jobs:", err);
      setError(err instanceof Error ? err.message : "Failed to load jobs");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTotalCount();
    loadJobs(1, "first");
  }, []);

  const goToNextPage = () => {
    if (jobs.length === jobsPerPage) {
      loadJobs(currentPage + 1, "next");
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      loadJobs(currentPage - 1, "prev");
    }
  };

  // Cursor-based pagination
  const hasNextPage = jobs.length === jobsPerPage;
  const hasPrevPage = currentPage > 1;

  // Filter jobs based on search (client-side filter on current page only)
  const filteredJobs = jobs.filter(
    (job) =>
      searchQuery === "" ||
      job.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      job.company?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      job.category?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      job.location?.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const formatDate = (date: Date | null | undefined) => {
    if (!date) return "N/A";
    return date.toLocaleDateString();
  };

  return (
    <View
      style={{ flex: 1, backgroundColor: colors.adminPageBg }}
    >
      {/* ── Page Header ── */}
      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          justifyContent: "space-between",
          backgroundColor: colors.adminHeaderBg,
          paddingHorizontal: isMobile ? 16 : 28,
          paddingVertical: isMobile ? 14 : 18,
          gap: isMobile ? 12 : 0,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: isMobile ? 10 : 14,
          }}
        >
          <View
            style={{
              width: isMobile ? 36 : 40,
              height: isMobile ? 36 : 40,
              borderRadius: 11,
              backgroundColor: `${colors.sidebarAccent}22`,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon
              name="work"
              size={isMobile ? 20 : 22}
              color={colors.sidebarAccent}
            />
          </View>
          <View>
            <Text
              style={{
                fontSize: isMobile ? 16 : 18,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#F9FAFB",
                letterSpacing: -0.3,
              }}
            >
              Job Management
            </Text>
            <Text
              style={{
                fontSize: isMobile ? 10 : 11,
                fontFamily: fonts.regular,
                color: "#64748B",
                marginTop: 1,
              }}
            >
              {totalJobs.toLocaleString()} total jobs · page {currentPage}
            </Text>
          </View>
        </View>
        <TouchableOpacity
          onPress={() => {
            getTotalCount();
            loadJobs(1, "first");
          }}
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 6,
            backgroundColor: colors.sidebarAccent,
            paddingHorizontal: isMobile ? 12 : 14,
            paddingVertical: isMobile ? 7 : 8,
            borderRadius: 9,
            alignSelf: isMobile ? "flex-start" : "auto",
          }}
        >
          <Icon name="refresh" size={isMobile ? 14 : 15} color="#FFFFFF" />
          <Text
            style={{
              fontSize: isMobile ? 11 : 12,
              fontFamily: fonts.semiBold,
              fontWeight: "600",
              color: "#FFFFFF",
            }}
          >
            Refresh
          </Text>
        </TouchableOpacity>
      </View>

      {/* ── Search ── */}
      <View
        style={{
          paddingHorizontal: isMobile ? 16 : 24,
          paddingTop: 16,
          paddingBottom: 8,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
            backgroundColor: colors.adminCardBg,
            borderRadius: 10,
            paddingHorizontal: 14,
            paddingVertical: 10,
            borderWidth: 1,
            borderColor: colors.adminBorder,
          }}
        >
          <Icon
            name="search"
            size={18}
            color={colors.adminMuted}
          />
          <TextInput
            style={
              {
                flex: 1,
                fontSize: 13,
                fontFamily: fonts.regular,
                color: colors.sidebarTextActive,
                outlineStyle: "none",
              } as any
            }
            placeholder="Search jobs on current page…"
            placeholderTextColor={colors.adminMuted}
            value={searchQuery}
            onChangeText={setSearchQuery}
          />
          {searchQuery.length > 0 && (
            <TouchableOpacity onPress={() => setSearchQuery("")}>
              <Icon
                name="close"
                size={16}
                color={colors.adminMuted}
              />
            </TouchableOpacity>
          )}
        </View>
      </View>

      {error && (
        <View
          style={{
            marginHorizontal: 24,
            marginBottom: 8,
            padding: 12,
            backgroundColor: "#EF444420",
            borderRadius: 10,
            borderLeftWidth: 3,
            borderLeftColor: "#EF4444",
          }}
        >
          <Text
            style={{
              fontSize: 12,
              fontFamily: fonts.bold,
              fontWeight: "600",
              color: "#EF4444",
            }}
          >
            {error}
          </Text>
        </View>
      )}

      {loading ? (
        <InlineLoadingIndicator
          message="Loading jobs…"
          isDarkMode={isDarkMode}
        />
      ) : (
        <View
          style={{
            flex: 1,
            marginHorizontal: isMobile ? 16 : 24,
            marginTop: 8,
            marginBottom: 16,
            borderRadius: 14,
            overflow: "hidden",
            backgroundColor: colors.adminCardBg,
            ...Platform.select({
              web: {
                boxShadow: isDarkMode
                  ? "0 2px 12px rgba(0,0,0,0.3)"
                  : "0 2px 12px rgba(0,0,0,0.06)",
              },
              default: {
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.07,
                shadowRadius: 8,
                elevation: 2,
              },
            }),
          }}
        >
          {/* Table header - Desktop only */}
          {!isMobile && (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: colors.adminHeaderBg,
                paddingHorizontal: 16,
                paddingVertical: 11,
              }}
            >
              {[
                { label: "Title", flex: 2.5 },
                { label: "Company", flex: 1.5 },
                { label: "Category", flex: 1.2 },
                { label: "Location", flex: 1.2 },
                { label: "Type", flex: 1 },
                { label: "Source", flex: 1 },
                { label: "Posted", flex: 0.9 },
              ].map((col) => (
                <Text
                  key={col.label}
                  style={{
                    flex: col.flex,
                    fontSize: 10,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#64748B",
                    letterSpacing: 1.1,
                    textTransform: "uppercase",
                  }}
                >
                  {col.label}
                </Text>
              ))}
            </View>
          )}

          {/* Rows / Cards */}
          <ScrollView showsVerticalScrollIndicator={false}>
            {filteredJobs.length === 0 ? (
              <View style={{ padding: 40, alignItems: "center", gap: 10 }}>
                <View
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: 16,
                    backgroundColor: colors.sidebarHover,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Icon
                    name="work-outline"
                    size={28}
                    color={colors.adminMuted}
                  />
                </View>
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.bold,
                    fontWeight: "600",
                    color: colors.adminMuted,
                  }}
                >
                  {searchQuery ? "No jobs match your search" : "No jobs found"}
                </Text>
              </View>
            ) : isMobile ? (
              // Mobile: Card Layout
              filteredJobs.map((job, idx) => (
                <View
                  key={job.id}
                  style={{
                    padding: 14,
                    borderBottomWidth: idx === filteredJobs.length - 1 ? 0 : 1,
                    borderBottomColor: colors.adminBorder,
                    backgroundColor:
                      idx % 2 === 0
                        ? isDarkMode
                          ? "#161F2E"
                          : "#FFFFFF"
                        : isDarkMode
                        ? "#111827"
                        : "#F9FAFB",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.bold,
                      fontWeight: "600",
                      color: colors.sidebarTextActive,
                      marginBottom: 8,
                    }}
                  >
                    {job.title}
                  </Text>
                  <View style={{ gap: 6 }}>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <Icon
                        name="business"
                        size={14}
                        color={colors.adminMuted}
                      />
                      <Text
                        style={{
                          flex: 1,
                          fontSize: 12,
                          fontFamily: fonts.regular,
                          color: colors.adminMuted,
                        }}
                      >
                        {job.company}
                      </Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <Icon
                        name="location-on"
                        size={14}
                        color={colors.adminMuted}
                      />
                      <Text
                        style={{
                          flex: 1,
                          fontSize: 12,
                          fontFamily: fonts.regular,
                          color: colors.adminMuted,
                        }}
                      >
                        {job.location}
                      </Text>
                      {job.isRemote && (
                        <View
                          style={{
                            backgroundColor: "#6366F118",
                            paddingHorizontal: 6,
                            paddingVertical: 2,
                            borderRadius: 5,
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 9,
                              fontFamily: fonts.bold,
                              fontWeight: "600",
                              color: "#6366F1",
                              letterSpacing: 0.5,
                            }}
                          >
                            REMOTE
                          </Text>
                        </View>
                      )}
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 8,
                        flexWrap: "wrap",
                        marginTop: 4,
                      }}
                    >
                      <View
                        style={{
                          backgroundColor: colors.sidebarHover,
                          paddingHorizontal: 8,
                          paddingVertical: 4,
                          borderRadius: 6,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.medium,
                            fontWeight: "500",
                            color: colors.adminMuted,
                          }}
                        >
                          {job.category}
                        </Text>
                      </View>
                      <View
                        style={{
                          backgroundColor: job.contractType
                            ?.toLowerCase()
                            .includes("full")
                            ? "#10B98118"
                            : "#F59E0B18",
                          paddingHorizontal: 8,
                          paddingVertical: 4,
                          borderRadius: 6,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 11,
                            fontFamily: fonts.medium,
                            fontWeight: "500",
                            color: job.contractType
                              ?.toLowerCase()
                              .includes("full")
                              ? "#10B981"
                              : "#F59E0B",
                          }}
                        >
                          {job.contractType}
                        </Text>
                      </View>
                      <Text
                        style={{
                          fontSize: 10,
                          fontFamily: fonts.regular,
                          color: colors.adminMuted,
                        }}
                      >
                        {job.jobSource} · {formatDate(job.createdAt)}
                      </Text>
                    </View>
                  </View>
                </View>
              ))
            ) : (
              // Desktop: Table Layout
              filteredJobs.map((job, idx) => (
                <View
                  key={job.id}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingHorizontal: 16,
                    paddingVertical: 12,
                    backgroundColor:
                      idx % 2 === 0
                        ? isDarkMode
                          ? "#161F2E"
                          : "#FFFFFF"
                        : isDarkMode
                        ? "#111827"
                        : "#F9FAFB",
                    borderBottomWidth: idx === filteredJobs.length - 1 ? 0 : 1,
                    borderBottomColor: colors.adminBorder,
                  }}
                >
                  <View style={{ flex: 2.5, paddingRight: 12 }}>
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.bold,
                        fontWeight: "600",
                        color: colors.sidebarTextActive,
                      }}
                      numberOfLines={2}
                    >
                      {job.title}
                    </Text>
                  </View>
                  <Text
                    style={{
                      flex: 1.5,
                      fontSize: 12,
                      fontFamily: fonts.regular,
                      color: colors.adminMuted,
                      paddingRight: 8,
                    }}
                    numberOfLines={1}
                  >
                    {job.company}
                  </Text>
                  <View style={{ flex: 1.2, paddingRight: 8 }}>
                    <View
                      style={{
                        backgroundColor: colors.sidebarHover,
                        paddingHorizontal: 7,
                        paddingVertical: 3,
                        borderRadius: 6,
                        alignSelf: "flex-start",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 10,
                          fontFamily: fonts.medium,
                          fontWeight: "500",
                          color: colors.adminMuted,
                        }}
                        numberOfLines={1}
                      >
                        {job.category}
                      </Text>
                    </View>
                  </View>
                  <View style={{ flex: 1.2, paddingRight: 8, gap: 3 }}>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.regular,
                        color: colors.adminMuted,
                      }}
                      numberOfLines={1}
                    >
                      {job.location}
                    </Text>
                    {job.isRemote && (
                      <View
                        style={{
                          backgroundColor: "#6366F118",
                          paddingHorizontal: 6,
                          paddingVertical: 2,
                          borderRadius: 5,
                          alignSelf: "flex-start",
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 9,
                            fontFamily: fonts.bold,
                            fontWeight: "600",
                            color: "#6366F1",
                            letterSpacing: 0.5,
                          }}
                        >
                          REMOTE
                        </Text>
                      </View>
                    )}
                  </View>
                  <View style={{ flex: 1, paddingRight: 8 }}>
                    <View
                      style={{
                        backgroundColor: job.contractType
                          ?.toLowerCase()
                          .includes("full")
                          ? "#10B98118"
                          : "#F59E0B18",
                        paddingHorizontal: 7,
                        paddingVertical: 3,
                        borderRadius: 6,
                        alignSelf: "flex-start",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 10,
                          fontFamily: fonts.medium,
                          fontWeight: "500",
                          color: job.contractType
                            ?.toLowerCase()
                            .includes("full")
                            ? "#10B981"
                            : "#F59E0B",
                        }}
                        numberOfLines={1}
                      >
                        {job.contractType}
                      </Text>
                    </View>
                  </View>
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 11,
                      fontFamily: fonts.regular,
                      color: colors.adminMuted,
                      paddingRight: 8,
                    }}
                    numberOfLines={1}
                  >
                    {job.jobSource}
                  </Text>
                  <Text
                    style={{
                      flex: 0.9,
                      fontSize: 11,
                      fontFamily: fonts.regular,
                      color: colors.adminMuted,
                    }}
                    numberOfLines={1}
                  >
                    {formatDate(job.createdAt)}
                  </Text>
                </View>
              ))
            )}
          </ScrollView>

          {/* Pagination */}
          {(hasNextPage || hasPrevPage) && (
            <View
              style={{
                flexDirection: isMobile ? "column" : "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingHorizontal: 16,
                paddingVertical: 12,
                borderTopWidth: 1,
                borderTopColor: colors.adminBorder,
                backgroundColor: colors.adminHeaderBg,
                gap: isMobile ? 10 : 0,
              }}
            >
              {isMobile && (
                <View style={{ alignItems: "center", gap: 2 }}>
                  <Text
                    style={{
                      fontSize: 13,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: colors.sidebarTextActive,
                    }}
                  >
                    Page {currentPage}
                  </Text>
                  <Text
                    style={{
                      fontSize: 11,
                      fontFamily: fonts.regular,
                      color: colors.adminMuted,
                    }}
                  >
                    {filteredJobs.length} jobs shown
                  </Text>
                </View>
              )}
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 10,
                  width: isMobile ? "100%" : "auto",
                }}
              >
                <TouchableOpacity
                  onPress={goToPrevPage}
                  disabled={!hasPrevPage || loading}
                  style={{
                    flex: isMobile ? 1 : undefined,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 6,
                    paddingHorizontal: 14,
                    paddingVertical: isMobile ? 10 : 7,
                    borderRadius: 8,
                    backgroundColor: hasPrevPage
                      ? isDarkMode
                        ? "#1E293B"
                        : "#E2E8F0"
                      : "transparent",
                    opacity: hasPrevPage ? 1 : 0.3,
                  }}
                >
                  <Icon
                    name="chevron-left"
                    size={16}
                    color={colors.adminMuted}
                  />
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      fontWeight: "500",
                      color: colors.adminMuted,
                    }}
                  >
                    Previous
                  </Text>
                </TouchableOpacity>
                {!isMobile && (
                  <View style={{ alignItems: "center", gap: 2 }}>
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.bold,
                        fontWeight: "700",
                        color: colors.sidebarTextActive,
                      }}
                    >
                      Page {currentPage}
                    </Text>
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: fonts.regular,
                        color: colors.adminMuted,
                      }}
                    >
                      {filteredJobs.length} jobs shown
                    </Text>
                  </View>
                )}
                <TouchableOpacity
                  onPress={goToNextPage}
                  disabled={!hasNextPage || loading}
                  style={{
                    flex: isMobile ? 1 : undefined,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 6,
                    paddingHorizontal: 14,
                    paddingVertical: isMobile ? 10 : 7,
                    borderRadius: 8,
                    backgroundColor: hasNextPage
                      ? isDarkMode
                        ? "#1E293B"
                        : "#E2E8F0"
                      : "transparent",
                    opacity: hasNextPage ? 1 : 0.3,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      fontWeight: "500",
                      color: colors.adminMuted,
                    }}
                  >
                    Next
                  </Text>
                  <Icon
                    name="chevron-right"
                    size={16}
                    color={colors.adminMuted}
                  />
                </TouchableOpacity>
              </View>
            </View>
          )}
        </View>
      )}
    </View>
  );
}

// Users Content
function UsersContent({
  colors = lightColors,
  isDarkMode = false,
}: {
  colors?: any;
  isDarkMode?: boolean;
}) {
  const [users, setUsers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [updatingUserId, setUpdatingUserId] = useState<string | null>(null);
  const [deletingUserId, setDeletingUserId] = useState<string | null>(null);
  const [userToDelete, setUserToDelete] = useState<any | null>(null);
  const [selectedUser, setSelectedUser] = useState<any | null>(null);
  const [showUserDetail, setShowUserDetail] = useState(false);
  const [filterRole, setFilterRole] = useState<string>("all");
  const [filterEmailStatus, setFilterEmailStatus] = useState<string>("all");
  const [filterSubscription, setFilterSubscription] = useState<string>("all");
  const [filterAccountStatus, setFilterAccountStatus] = useState<string>("all");
  // uid -> Firebase Auth provider ids ("google.com", "password", ...)
  const [signInMethods, setSignInMethods] = useState<Record<string, string[]>>(
    {},
  );
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const usersPerPage = 10;

  const signInMethodLabel = (uid: string) => {
    const providers = signInMethods[uid];
    if (!providers) return null;
    if (providers.length === 0) return "Unknown";
    const names: Record<string, string> = {
      "google.com": "Google",
      password: "Email/Password",
      phone: "Phone",
      "apple.com": "Apple",
      "facebook.com": "Facebook",
    };
    return providers.map((p) => names[p] || p).join(" + ");
  };

  // Users whose photo failed to load (e.g. Google's avatar CDN rate-limits
  // when a whole page of avatars loads at once) fall back to their initial.
  const [brokenAvatars, setBrokenAvatars] = useState<Record<string, boolean>>(
    {},
  );
  const avatarFor = (user: any) =>
    brokenAvatars[user.id] ? null : pickAvatarUrl(user);

  const signInMethodColor = (uid: string) => {
    const providers = signInMethods[uid] || [];
    if (providers.length > 1) return "#8B5CF6";
    if (providers[0] === "google.com") return "#EA4335";
    if (providers[0] === "password") return "#6366F1";
    if (providers[0] === "phone") return "#10B981";
    return "#64748B";
  };

  const isMobile = dimensions.width < 768;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      console.log("🔍 Fetching users from Firestore...");
      const usersRef = collection(db, "users");

      // Fetch with pagination limit to avoid expensive full collection scan
      const usersQuery = dbQuery(usersRef, limit(100));
      const querySnapshot = await getDocs(usersQuery);

      console.log("📊 Query snapshot size:", querySnapshot.size);

      const fetchedUsers: any[] = [];
      querySnapshot.forEach((doc) => {
        console.log("👤 User found:", doc.id, doc.data());
        fetchedUsers.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      // Sort by createdAt if it exists, otherwise by email
      fetchedUsers.sort((a, b) => {
        if (a.createdAt && b.createdAt) {
          return b.createdAt.seconds - a.createdAt.seconds;
        }
        return (a.email || "").localeCompare(b.email || "");
      });

      console.log("✅ Total users fetched:", fetchedUsers.length);
      setUsers(fetchedUsers);

      // Sign-in methods live in Firebase Auth, not Firestore — load them
      // separately so a failure here doesn't block the user list.
      const getMethods = httpsCallable(functions, "getUserSignInMethods");
      getMethods({ uids: fetchedUsers.map((u) => u.id) })
        .then((res: any) => setSignInMethods(res.data?.methods || {}))
        .catch((err) =>
          console.error("❌ Error fetching sign-in methods:", err),
        );
    } catch (error) {
      console.error("❌ Error fetching users:", error);
      alert("Error fetching users: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = async (userId: string, newRole: string) => {
    try {
      setUpdatingUserId(userId);

      // Get current user data
      const currentUser = users.find((u) => u.id === userId);
      if (!currentUser) return;

      const oldRole = currentUser.role || "user";
      const userRef = doc(db, "users", userId);

      await updateDoc(userRef, {
        role: newRole,
        updatedAt: new Date(),
      });

      // Update local state
      setUsers(
        users.map((user) =>
          user.id === userId ? { ...user, role: newRole } : user,
        ),
      );

      // Send email notification
      try {
        const notifyRoleChange = httpsCallable(functions, "notifyRoleChange");
        await notifyRoleChange({
          userEmail: currentUser.email,
          userName: currentUser.displayName || currentUser.name || "User",
          oldRole: oldRole,
          newRole: newRole,
        });
        alert(
          `User role updated to ${newRole} successfully! Email notification sent.`,
        );
      } catch (emailError) {
        console.error("Failed to send email notification:", emailError);
        alert(
          `User role updated to ${newRole} successfully! (Email notification failed)`,
        );
      }
    } catch (error) {
      console.error("Error updating user role:", error);
      alert("Error updating user role: " + (error as Error).message);
    } finally {
      setUpdatingUserId(null);
    }
  };

  const handleSubscriptionChange = async (
    userId: string,
    newSubscriptionId: string,
  ) => {
    try {
      setUpdatingUserId(userId);

      // Get current user data
      const currentUser = users.find((u) => u.id === userId);
      if (!currentUser) return;

      const oldPlan = currentUser.subscriptionId || "free";
      const userRef = doc(db, "users", userId);

      // Determine subscription end date based on plan
      let subscriptionEndDate = null;
      if (newSubscriptionId !== "free") {
        // Set end date to 1 year from now for paid plans
        subscriptionEndDate = new Date();
        subscriptionEndDate.setFullYear(subscriptionEndDate.getFullYear() + 1);
      }

      await updateDoc(userRef, {
        subscriptionId: newSubscriptionId,
        subscriptionStatus: "active",
        subscriptionStartDate: new Date(),
        subscriptionEndDate: subscriptionEndDate,
        updatedAt: new Date(),
      });

      // Update local state
      setUsers(
        users.map((user) =>
          user.id === userId
            ? {
                ...user,
                subscriptionId: newSubscriptionId,
                subscriptionStatus: "active",
                subscriptionStartDate: new Date(),
                subscriptionEndDate: subscriptionEndDate,
              }
            : user,
        ),
      );

      // Send email notification
      try {
        const notifySubscriptionChange = httpsCallable(
          functions,
          "notifySubscriptionChange",
        );
        await notifySubscriptionChange({
          userEmail: currentUser.email,
          userName: currentUser.displayName || currentUser.name || "User",
          oldPlan: oldPlan,
          newPlan: newSubscriptionId,
        });
        alert(
          `User subscription updated to ${newSubscriptionId} successfully! Email notification sent.`,
        );
      } catch (emailError) {
        console.error("Failed to send email notification:", emailError);
        alert(
          `User subscription updated to ${newSubscriptionId} successfully! (Email notification failed)`,
        );
      }
    } catch (error) {
      console.error("Error updating user subscription:", error);
      alert("Error updating user subscription: " + (error as Error).message);
    } finally {
      setUpdatingUserId(null);
    }
  };

  const handleDeleteUser = async (userId: string) => {
    try {
      setDeletingUserId(userId);
      const deleteUserAccount = httpsCallable(functions, "deleteUserAccount");
      await deleteUserAccount({ targetUid: userId });
      setUsers((prev) => prev.filter((u) => u.id !== userId));
      setUserToDelete(null);
      alert("User account permanently deleted.");
    } catch (error: any) {
      console.error("Error deleting user:", error);
      alert("Failed to delete user: " + (error.message || "Unknown error"));
    } finally {
      setDeletingUserId(null);
    }
  };

  // Filter users based on search and filters
  const filteredUsers = users.filter((user) => {
    // Search filter
    const matchesSearch =
      user.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.displayName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      user.role?.toLowerCase().includes(searchQuery.toLowerCase());

    if (!matchesSearch) return false;

    // Role filter
    if (filterRole !== "all" && user.role !== filterRole) return false;

    // Email status filter
    if (filterEmailStatus === "verified" && !user.isVerified) return false;
    if (filterEmailStatus === "unverified" && user.isVerified) return false;

    // Subscription filter
    if (
      filterSubscription !== "all" &&
      (user.subscriptionId || "free") !== filterSubscription
    )
      return false;

    // Account status filter
    if (filterAccountStatus === "active" && user.isActive === false)
      return false;
    if (filterAccountStatus === "inactive" && user.isActive !== false)
      return false;

    return true;
  });

  // Pagination
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  const startIndex = (currentPage - 1) * usersPerPage;
  const endIndex = startIndex + usersPerPage;
  const currentUsers = filteredUsers.slice(startIndex, endIndex);

  const goToPage = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const formatDate = (timestamp: any) => {
    if (!timestamp) return "N/A";
    try {
      return new Date(timestamp.seconds * 1000).toLocaleDateString();
    } catch {
      return "N/A";
    }
  };

  return (
    <View style={{ flex: 1, backgroundColor: colors.adminPageBg }}>
      {/* ── Page Header ── */}
      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          justifyContent: "space-between",
          backgroundColor: colors.adminHeaderBg,
          paddingHorizontal: isMobile ? 16 : 28,
          paddingVertical: isMobile ? 14 : 18,
          gap: isMobile ? 12 : 0,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: isMobile ? 10 : 14,
          }}
        >
          <View
            style={{
              width: isMobile ? 36 : 40,
              height: isMobile ? 36 : 40,
              borderRadius: 11,
              backgroundColor: `${colors.sidebarAccent}22`,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon
              name="people"
              size={isMobile ? 20 : 22}
              color={colors.sidebarAccent}
            />
          </View>
          <View>
            <Text
              style={{
                fontSize: isMobile ? 16 : 18,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#F9FAFB",
                letterSpacing: -0.3,
              }}
            >
              User Management
            </Text>
            <Text
              style={{
                fontSize: isMobile ? 10 : 11,
                fontFamily: fonts.regular,
                color: "#64748B",
                marginTop: 1,
              }}
            >
              {users.length} users ·{" "}
              {users.filter((u) => u.isActive !== false).length} active
            </Text>
          </View>
        </View>
        <TouchableOpacity
          onPress={fetchUsers}
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 6,
            backgroundColor: colors.sidebarAccent,
            paddingHorizontal: isMobile ? 12 : 14,
            paddingVertical: isMobile ? 7 : 8,
            borderRadius: 9,
            alignSelf: isMobile ? "flex-start" : "auto",
          }}
        >
          <Icon name="refresh" size={isMobile ? 14 : 15} color="#FFFFFF" />
          <Text
            style={{
              fontSize: isMobile ? 11 : 12,
              fontFamily: fonts.semiBold,
              fontWeight: "600",
              color: "#FFFFFF",
            }}
          >
            Refresh
          </Text>
        </TouchableOpacity>
      </View>

      {/* ── Search + Filters ── */}
      <View
        style={{
          backgroundColor: colors.adminPageBg,
          paddingHorizontal: isMobile ? 16 : 20,
          paddingTop: 16,
          paddingBottom: 8,
        }}
      >
        {/* Search */}
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: colors.adminCardBg,
            borderRadius: 10,
            paddingHorizontal: 12,
            paddingVertical: 10,
            marginBottom: 14,
            ...getAdminCardShadow(isDarkMode),
          }}
        >
          <Icon name="search" size={18} color={colors.adminMuted} />
          <TextInput
            style={{
              flex: 1,
              marginLeft: 8,
              fontSize: 13,
              fontFamily: fonts.regular,
              color: colors.sidebarTextActive,
              outlineStyle: "none",
            }}
            placeholder="Search by email, name, or role..."
            placeholderTextColor={colors.adminMuted}
            value={searchQuery}
            onChangeText={setSearchQuery}
          />
          {searchQuery.length > 0 && (
            <TouchableOpacity onPress={() => setSearchQuery("")}>
              <Icon name="close" size={16} color={colors.adminMuted} />
            </TouchableOpacity>
          )}
        </View>

        {/* Filter chips */}
        <View style={{ gap: 10 }}>
          {/* Role */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 6,
              flexWrap: "wrap",
            }}
          >
            <Text
              style={{
                fontSize: 10,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: colors.adminMuted,
                textTransform: "uppercase",
                letterSpacing: 0.8,
                width: 62,
              }}
            >
              Role
            </Text>
            {[
              { value: "all", label: "All" },
              { value: "user", label: "User" },
              { value: "company", label: "Company" },
              { value: "admin", label: "Admin" },
              { value: "superadmin", label: "Super" },
            ].map((opt) => (
              <TouchableOpacity
                key={opt.value}
                onPress={() => {
                  setFilterRole(opt.value);
                  setCurrentPage(1);
                }}
                style={{
                  paddingHorizontal: 10,
                  paddingVertical: 4,
                  borderRadius: 20,
                  backgroundColor:
                    filterRole === opt.value ? "#6366F1" : colors.adminBorder,
                  borderWidth: 1,
                  borderColor:
                    filterRole === opt.value ? "#6366F1" : "transparent",
                }}
              >
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.medium,
                    color:
                      filterRole === opt.value
                        ? "#FFFFFF"
                        : colors.sidebarText,
                  }}
                >
                  {opt.label}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
          {/* Email Status */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 6,
              flexWrap: "wrap",
            }}
          >
            <Text
              style={{
                fontSize: 10,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: colors.adminMuted,
                textTransform: "uppercase",
                letterSpacing: 0.8,
                width: 62,
              }}
            >
              Email
            </Text>
            {[
              { value: "all", label: "All" },
              { value: "verified", label: "Verified" },
              { value: "unverified", label: "Unverified" },
            ].map((opt) => (
              <TouchableOpacity
                key={opt.value}
                onPress={() => {
                  setFilterEmailStatus(opt.value);
                  setCurrentPage(1);
                }}
                style={{
                  paddingHorizontal: 10,
                  paddingVertical: 4,
                  borderRadius: 20,
                  backgroundColor:
                    filterEmailStatus === opt.value
                      ? "#10B981"
                      : colors.adminBorder,
                  borderWidth: 1,
                  borderColor:
                    filterEmailStatus === opt.value ? "#10B981" : "transparent",
                }}
              >
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.medium,
                    color:
                      filterEmailStatus === opt.value
                        ? "#FFFFFF"
                        : colors.sidebarText,
                  }}
                >
                  {opt.label}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
          {/* Subscription */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 6,
              flexWrap: "wrap",
            }}
          >
            <Text
              style={{
                fontSize: 10,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: colors.adminMuted,
                textTransform: "uppercase",
                letterSpacing: 0.8,
                width: 62,
              }}
            >
              Plan
            </Text>
            {[
              { value: "all", label: "All" },
              { value: "free", label: "Free" },
              { value: "standard", label: "Standard" },
              { value: "enterprise", label: "Enterprise" },
            ].map((opt) => (
              <TouchableOpacity
                key={opt.value}
                onPress={() => {
                  setFilterSubscription(opt.value);
                  setCurrentPage(1);
                }}
                style={{
                  paddingHorizontal: 10,
                  paddingVertical: 4,
                  borderRadius: 20,
                  backgroundColor:
                    filterSubscription === opt.value
                      ? "#F59E0B"
                      : colors.adminBorder,
                  borderWidth: 1,
                  borderColor:
                    filterSubscription === opt.value
                      ? "#F59E0B"
                      : "transparent",
                }}
              >
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.medium,
                    color:
                      filterSubscription === opt.value
                        ? "#FFFFFF"
                        : colors.sidebarText,
                  }}
                >
                  {opt.label}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
          {/* Account Status */}
          <View style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
            <Text
              style={{
                fontSize: 10,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: colors.adminMuted,
                textTransform: "uppercase",
                letterSpacing: 0.8,
                width: 62,
              }}
            >
              Status
            </Text>
            {[
              { value: "all", label: "All" },
              { value: "active", label: "Active" },
              { value: "inactive", label: "Inactive" },
            ].map((opt) => (
              <TouchableOpacity
                key={opt.value}
                onPress={() => {
                  setFilterAccountStatus(opt.value);
                  setCurrentPage(1);
                }}
                style={{
                  paddingHorizontal: 10,
                  paddingVertical: 4,
                  borderRadius: 20,
                  backgroundColor:
                    filterAccountStatus === opt.value
                      ? "#3B82F6"
                      : colors.adminBorder,
                  borderWidth: 1,
                  borderColor:
                    filterAccountStatus === opt.value
                      ? "#3B82F6"
                      : "transparent",
                }}
              >
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.medium,
                    color:
                      filterAccountStatus === opt.value
                        ? "#FFFFFF"
                        : colors.sidebarText,
                  }}
                >
                  {opt.label}
                </Text>
              </TouchableOpacity>
            ))}
            {(filterRole !== "all" ||
              filterEmailStatus !== "all" ||
              filterSubscription !== "all" ||
              filterAccountStatus !== "all") && (
              <TouchableOpacity
                onPress={() => {
                  setFilterRole("all");
                  setFilterEmailStatus("all");
                  setFilterSubscription("all");
                  setFilterAccountStatus("all");
                  setCurrentPage(1);
                }}
                style={{
                  paddingHorizontal: 10,
                  paddingVertical: 4,
                  borderRadius: 20,
                  backgroundColor: `${colors.danger}20`,
                  borderWidth: 1,
                  borderColor: colors.danger,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 4,
                  marginLeft: 6,
                }}
              >
                <Icon name="close" size={11} color={colors.danger} />
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.medium,
                    color: colors.danger,
                  }}
                >
                  Clear
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </View>
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.regular,
            color: colors.adminMuted,
            marginTop: 10,
            marginBottom: 4,
          }}
        >
          Showing {filteredUsers.length} of {users.length} users
        </Text>
      </View>

      {loading ? (
        <InlineLoadingIndicator
          message="Loading users..."
          isDarkMode={isDarkMode}
        />
      ) : (
        <>
          {/* ── Users Table ── */}
          <View
            style={{
              marginHorizontal: isMobile ? 16 : 20,
              marginTop: 4,
              marginBottom: 16,
              borderRadius: 14,
              overflow: "hidden",
              backgroundColor: colors.adminCardBg,
              ...getAdminCardShadow(isDarkMode),
            }}
          >
            {/* Desktop: Table Header */}
            {!isMobile && (
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: colors.adminHeaderBg,
                  paddingVertical: 11,
                  paddingHorizontal: 14,
                }}
              >
                <Text
                  style={{
                    flex: 0.5,
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  {" "}
                </Text>
                <Text
                  style={{
                    flex: 2,
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  Email
                </Text>
                <Text
                  style={{
                    flex: 1.5,
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  Name
                </Text>
                <Text
                  style={{
                    flex: 1.2,
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  Sign-in
                </Text>
                <Text
                  style={{
                    flex: 1,
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  Role
                </Text>
                <Text
                  style={{
                    flex: 1,
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  Email
                </Text>
                <Text
                  style={{
                    flex: 1,
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  Verify
                </Text>
                <Text
                  style={{
                    flex: 1,
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  Plan
                </Text>
                <Text
                  style={{
                    flex: 1,
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  Status
                </Text>
                <Text
                  style={{
                    flex: 1,
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  Created
                </Text>
                <Text
                  style={{
                    flex: 2,
                    fontSize: 11,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#94A3B8",
                    textTransform: "uppercase",
                    letterSpacing: 0.6,
                  }}
                >
                  Actions
                </Text>
              </View>
            )}

            <ScrollView style={{ maxHeight: isMobile ? 600 : 520 }}>
              {currentUsers.length === 0 ? (
                <View style={{ alignItems: "center", paddingVertical: 40 }}>
                  <Icon
                    name="people-outline"
                    size={48}
                    color={colors.adminBorder}
                  />
                  <Text
                    style={{
                      marginTop: 12,
                      fontSize: 14,
                      fontFamily: fonts.regular,
                      color: colors.adminMuted,
                    }}
                  >
                    {searchQuery
                      ? "No users found matching your search"
                      : "No users yet"}
                  </Text>
                </View>
              ) : isMobile ? (
                // Mobile: Card Layout
                currentUsers.map((user, index) => (
                  <View
                    key={user.id}
                    style={{
                      padding: 14,
                      borderBottomWidth:
                        index === currentUsers.length - 1 ? 0 : 1,
                      borderBottomColor: colors.adminBorder,
                      backgroundColor:
                        index % 2 === 0
                          ? colors.adminCardBg
                          : colors.adminCardAltBg,
                    }}
                  >
                    {/* Avatar, Email & Name */}
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: 10,
                      }}
                    >
                      {avatarFor(user) ? (
                        <Image
                          source={{ uri: avatarFor(user) as string }}
                          onError={() =>
                            setBrokenAvatars((prev) => ({ ...prev, [user.id]: true }))
                          }
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: 18,
                            backgroundColor: colors.lightGray,
                            marginRight: 10,
                          }}
                        />
                      ) : (
                        <View
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: 18,
                            backgroundColor: colors.beeYellow,
                            justifyContent: "center",
                            alignItems: "center",
                            marginRight: 10,
                          }}
                        >
                          <Text
                            style={{
                              color: colors.deepNavy,
                              fontWeight: "bold",
                              fontSize: 14,
                            }}
                          >
                            {(user.displayName || user.name || "")
                              .trim()
                              .charAt(0)
                              .toUpperCase() ||
                              (user.email || "").charAt(0).toUpperCase() ||
                              "?"}
                          </Text>
                        </View>
                      )}
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontSize: 13,
                            fontFamily: fonts.bold,
                            fontWeight: "600",
                            color: colors.sidebarTextActive,
                            marginBottom: 4,
                          }}
                        >
                          {user.displayName || user.name || "No Name"}
                        </Text>
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.regular,
                            color: colors.sidebarText,
                          }}
                        >
                          {user.email || "N/A"}
                        </Text>
                        {signInMethodLabel(user.id) && (
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.regular,
                              color: colors.adminMuted,
                            }}
                          >
                            Signs in with {signInMethodLabel(user.id)}
                          </Text>
                        )}
                      </View>
                    </View>

                    {/* Badges */}
                    <View
                      style={{
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: 6,
                        marginBottom: 10,
                      }}
                    >
                      {/* Role Badge */}
                      <View
                        style={[
                          styles.roleBadge,
                          {
                            backgroundColor:
                              user.role === "admin"
                                ? isDarkMode
                                  ? "#3B2817"
                                  : "#FEF3C7"
                                : user.role === "superadmin"
                                ? isDarkMode
                                  ? "#3F1F1F"
                                  : "#FEE2E2"
                                : user.role === "company"
                                ? isDarkMode
                                  ? "#1E3A5F"
                                  : "#DBEAFE"
                                : colors.lightGray,
                          },
                        ]}
                      >
                        <Text
                          style={[
                            styles.roleBadgeText,
                            {
                              color:
                                user.role === "admin"
                                  ? isDarkMode
                                    ? "#FCD34D"
                                    : "#D97706"
                                  : user.role === "superadmin"
                                  ? isDarkMode
                                    ? "#FCA5A5"
                                    : "#DC2626"
                                  : user.role === "company"
                                  ? isDarkMode
                                    ? "#93C5FD"
                                    : "#2563EB"
                                  : colors.deepNavy,
                            },
                          ]}
                        >
                          {user.role?.toUpperCase() || "USER"}
                        </Text>
                      </View>

                      {/* Email Verification */}
                      <View
                        style={[
                          styles.roleBadge,
                          {
                            backgroundColor: user.isVerified
                              ? isDarkMode
                                ? "#1F3F2F"
                                : "#D1FAE5"
                              : isDarkMode
                              ? "#3B2817"
                              : "#FEF3C7",
                          },
                        ]}
                      >
                        <Text
                          style={[
                            styles.roleBadgeText,
                            {
                              color: user.isVerified
                                ? isDarkMode
                                  ? "#86EFAC"
                                  : "#065F46"
                                : isDarkMode
                                ? "#FCD34D"
                                : "#D97706",
                            },
                          ]}
                        >
                          {user.isVerified ? "✓ VERIFIED" : "⋯ PENDING"}
                        </Text>
                      </View>

                      {/* Subscription */}
                      <View
                        style={[
                          styles.roleBadge,
                          {
                            backgroundColor:
                              user.subscriptionId === "enterprise"
                                ? isDarkMode
                                  ? "#1E3A5F"
                                  : "#DBEAFE"
                                : user.subscriptionId === "pro"
                                ? isDarkMode
                                  ? "#3B1F5F"
                                  : "#EDE9FE"
                                : user.subscriptionId === "standard"
                                ? isDarkMode
                                  ? "#3B2817"
                                  : "#FEF3C7"
                                : colors.lightGray,
                          },
                        ]}
                      >
                        <Text
                          style={[
                            styles.roleBadgeText,
                            {
                              color:
                                user.subscriptionId === "enterprise"
                                  ? isDarkMode
                                    ? "#93C5FD"
                                    : "#2563EB"
                                  : user.subscriptionId === "pro"
                                  ? isDarkMode
                                    ? "#C4B5FD"
                                    : "#7C3AED"
                                  : user.subscriptionId === "standard"
                                  ? isDarkMode
                                    ? "#FCD34D"
                                    : "#D97706"
                                  : colors.deepNavy,
                            },
                          ]}
                        >
                          {(user.subscriptionId || "free").toUpperCase()}
                        </Text>
                      </View>

                      {/* Status */}
                      <View
                        style={[
                          styles.statusBadge,
                          {
                            backgroundColor:
                              user.isActive === false
                                ? isDarkMode
                                  ? "#3F1F1F"
                                  : "#FEE2E2"
                                : isDarkMode
                                ? "#1F3F2F"
                                : "#D1FAE5",
                          },
                        ]}
                      >
                        <Text
                          style={[
                            styles.statusBadgeText,
                            {
                              color:
                                user.isActive === false
                                  ? isDarkMode
                                    ? "#FCA5A5"
                                    : "#DC2626"
                                  : isDarkMode
                                  ? "#86EFAC"
                                  : "#065F46",
                            },
                          ]}
                        >
                          {user.isActive === false ? "INACTIVE" : "ACTIVE"}
                        </Text>
                      </View>
                    </View>

                    {/* Created Date */}
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: fonts.regular,
                        color: colors.adminMuted,
                        marginBottom: 10,
                      }}
                    >
                      Created: {formatDate(user.createdAt)}
                    </Text>

                    {/* Actions */}
                    {updatingUserId === user.id ? (
                      <ActivityIndicator
                        size="small"
                        color={colors.beeYellow}
                      />
                    ) : (
                      <View style={{ gap: 8 }}>
                        <View style={{ flexDirection: "row", gap: 8 }}>
                          <View style={{ flex: 1 }}>
                            <Text
                              style={{
                                fontSize: 10,
                                fontFamily: fonts.bold,
                                color: colors.adminMuted,
                                marginBottom: 4,
                                textTransform: "uppercase",
                              }}
                            >
                              Role
                            </Text>
                            <select
                              value={user.role || "user"}
                              onChange={(e) =>
                                handleRoleChange(user.id, e.target.value)
                              }
                              style={{
                                padding: "8px",
                                borderRadius: "8px",
                                border: `1px solid ${colors.adminBorder}`,
                                backgroundColor: colors.sidebarHover,
                                color: colors.sidebarTextActive,
                                fontSize: "12px",
                                cursor: "pointer",
                                outline: "none",
                                width: "100%",
                              }}
                            >
                              <option value="user">User</option>
                              <option value="company">Company</option>
                              <option value="admin">Admin</option>
                              <option value="superadmin">Super Admin</option>
                            </select>
                          </View>
                          <View style={{ flex: 1 }}>
                            <Text
                              style={{
                                fontSize: 10,
                                fontFamily: fonts.bold,
                                color: colors.adminMuted,
                                marginBottom: 4,
                                textTransform: "uppercase",
                              }}
                            >
                              Plan
                            </Text>
                            <select
                              value={user.subscriptionId || "free"}
                              onChange={(e) =>
                                handleSubscriptionChange(
                                  user.id,
                                  e.target.value,
                                )
                              }
                              style={{
                                padding: "8px",
                                borderRadius: "8px",
                                border: `1px solid ${colors.adminBorder}`,
                                backgroundColor: colors.sidebarHover,
                                color: colors.sidebarTextActive,
                                fontSize: "12px",
                                cursor: "pointer",
                                outline: "none",
                                width: "100%",
                              }}
                            >
                              <option value="free">Free</option>
                              <option value="standard">Standard</option>
                              <option value="enterprise">Enterprise</option>
                            </select>
                          </View>
                        </View>
                        <TouchableOpacity
                          onPress={() => {
                            setSelectedUser(user);
                            setShowUserDetail(true);
                          }}
                          style={{
                            backgroundColor: colors.sidebarAccent,
                            paddingVertical: 10,
                            paddingHorizontal: 12,
                            borderRadius: 8,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 6,
                          }}
                        >
                          <Icon name="info-outline" size={16} color="#FFFFFF" />
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.semiBold,
                              fontWeight: "600",
                              color: "#FFFFFF",
                            }}
                          >
                            View Details
                          </Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          onPress={() => setUserToDelete(user)}
                          disabled={deletingUserId === user.id}
                          style={{
                            backgroundColor: `${colors.danger}22`,
                            paddingVertical: 10,
                            paddingHorizontal: 12,
                            borderRadius: 8,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 6,
                            opacity: deletingUserId === user.id ? 0.5 : 1,
                          }}
                        >
                          {deletingUserId === user.id ? (
                            <ActivityIndicator
                              size="small"
                              color={colors.danger}
                            />
                          ) : (
                            <Icon
                              name="delete-forever"
                              size={16}
                              color={colors.danger}
                            />
                          )}
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.semiBold,
                              fontWeight: "600",
                              color: colors.danger,
                            }}
                          >
                            Delete
                          </Text>
                        </TouchableOpacity>
                      </View>
                    )}
                  </View>
                ))
              ) : (
                // Desktop: Table Layout
                currentUsers.map((user, index) => (
                  <TouchableOpacity
                    key={user.id}
                    style={[
                      {
                        flexDirection: "row",
                        alignItems: "center",
                        paddingVertical: 11,
                        paddingHorizontal: 14,
                        borderBottomWidth: 1,
                        borderBottomColor: colors.adminBorder,
                        cursor: "pointer",
                      },
                      index % 2 !== 0 && {
                        backgroundColor: colors.adminCardAltBg,
                      },
                      index % 2 === 0 && {
                        backgroundColor: colors.adminCardBg,
                      },
                    ]}
                    onPress={() => {
                      setSelectedUser(user);
                      setShowUserDetail(true);
                    }}
                  >
                    <View style={{ flex: 0.5 }}>
                      {avatarFor(user) ? (
                        <Image
                          source={{ uri: avatarFor(user) as string }}
                          onError={() =>
                            setBrokenAvatars((prev) => ({ ...prev, [user.id]: true }))
                          }
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: 16,
                            backgroundColor: colors.lightGray,
                          }}
                        />
                      ) : (
                        <View
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: 16,
                            backgroundColor: colors.beeYellow,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Text
                            style={{
                              color: colors.deepNavy,
                              fontWeight: "bold",
                              fontSize: 13,
                            }}
                          >
                            {(user.displayName || user.name || "")
                              .trim()
                              .charAt(0)
                              .toUpperCase() ||
                              (user.email || "").charAt(0).toUpperCase() ||
                              "?"}
                          </Text>
                        </View>
                      )}
                    </View>
                    <Text
                      style={[
                        styles.tableCell,
                        { flex: 2, color: colors.deepNavy },
                      ]}
                      numberOfLines={1}
                    >
                      {user.email || "N/A"}
                    </Text>
                    <Text
                      style={[
                        styles.tableCell,
                        { flex: 1.5, color: colors.deepNavy },
                      ]}
                      numberOfLines={1}
                    >
                      {user.displayName || user.name || "N/A"}
                    </Text>
                    <View style={[styles.tableCell, { flex: 1.2 }]}>
                      {signInMethodLabel(user.id) ? (
                        <View
                          style={[
                            styles.roleBadge,
                            {
                              backgroundColor: `${signInMethodColor(user.id)}1F`,
                            },
                          ]}
                        >
                          <Text
                            style={[
                              styles.roleBadgeText,
                              { color: signInMethodColor(user.id) },
                            ]}
                            numberOfLines={1}
                          >
                            {signInMethodLabel(user.id)}
                          </Text>
                        </View>
                      ) : (
                        <Text
                          style={{
                            fontSize: 12,
                            color: colors.warmGray,
                            fontFamily: fonts.regular,
                          }}
                        >
                          …
                        </Text>
                      )}
                    </View>
                    <View style={[styles.tableCell, { flex: 1 }]}>
                      <View
                        style={[
                          styles.roleBadge,
                          {
                            backgroundColor:
                              user.role === "admin"
                                ? isDarkMode
                                  ? "#3B2817"
                                  : "#FEF3C7"
                                : user.role === "superadmin"
                                ? isDarkMode
                                  ? "#3F1F1F"
                                  : "#FEE2E2"
                                : user.role === "company"
                                ? isDarkMode
                                  ? "#1E3A5F"
                                  : "#DBEAFE"
                                : colors.lightGray,
                          },
                        ]}
                      >
                        <Text
                          style={[
                            styles.roleBadgeText,
                            {
                              color:
                                user.role === "admin"
                                  ? isDarkMode
                                    ? "#FCD34D"
                                    : "#D97706"
                                  : user.role === "superadmin"
                                  ? isDarkMode
                                    ? "#FCA5A5"
                                    : "#DC2626"
                                  : user.role === "company"
                                  ? isDarkMode
                                    ? "#93C5FD"
                                    : "#2563EB"
                                  : colors.deepNavy,
                            },
                          ]}
                        >
                          {user.role || "user"}
                        </Text>
                      </View>
                    </View>
                    <View style={[styles.tableCell, { flex: 1 }]}>
                      <View
                        style={[
                          styles.roleBadge,
                          {
                            backgroundColor: user.isVerified
                              ? isDarkMode
                                ? "#1F3F2F"
                                : "#D1FAE5"
                              : isDarkMode
                              ? "#3B2817"
                              : "#FEF3C7",
                          },
                        ]}
                      >
                        <Text
                          style={[
                            styles.roleBadgeText,
                            {
                              color: user.isVerified
                                ? isDarkMode
                                  ? "#86EFAC"
                                  : "#065F46"
                                : isDarkMode
                                ? "#FCD34D"
                                : "#D97706",
                            },
                          ]}
                        >
                          {user.isVerified ? "✓ Verified" : "⋯ Pending"}
                        </Text>
                      </View>
                    </View>
                    <View style={[styles.tableCell, { flex: 1 }]}>
                      {user.role === "company" ? (
                        <View
                          style={[
                            styles.roleBadge,
                            {
                              backgroundColor:
                                user.companyProfile?.verificationStatus ===
                                "approved"
                                  ? isDarkMode
                                    ? "#1F3F2F"
                                    : "#D1FAE5"
                                  : user.companyProfile?.verificationStatus ===
                                    "rejected"
                                  ? isDarkMode
                                    ? "#3F1F1F"
                                    : "#FEE2E2"
                                  : isDarkMode
                                  ? "#3B2817"
                                  : "#FEF3C7",
                            },
                          ]}
                        >
                          <Text
                            style={[
                              styles.roleBadgeText,
                              {
                                color:
                                  user.companyProfile?.verificationStatus ===
                                  "approved"
                                    ? isDarkMode
                                      ? "#86EFAC"
                                      : "#065F46"
                                    : user.companyProfile
                                        ?.verificationStatus === "rejected"
                                    ? isDarkMode
                                      ? "#FCA5A5"
                                      : "#DC2626"
                                    : isDarkMode
                                    ? "#FCD34D"
                                    : "#D97706",
                              },
                            ]}
                          >
                            {user.companyProfile?.verificationStatus ===
                            "approved"
                              ? "✓ Verified"
                              : user.companyProfile?.verificationStatus ===
                                "rejected"
                              ? "✗ Rejected"
                              : "⋯ Pending"}
                          </Text>
                        </View>
                      ) : (
                        <Text
                          style={{
                            fontSize: 12,
                            color: colors.warmGray,
                            fontFamily: fonts.regular,
                          }}
                        >
                          —
                        </Text>
                      )}
                    </View>
                    <View style={[styles.tableCell, { flex: 1 }]}>
                      <View
                        style={[
                          styles.roleBadge,
                          {
                            backgroundColor:
                              user.subscriptionId === "free"
                                ? colors.lightGray
                                : user.subscriptionId === "standard"
                                ? isDarkMode
                                  ? "#3B2817"
                                  : "#FEF3C7"
                                : user.subscriptionId === "pro"
                                ? isDarkMode
                                  ? "#3B1F5F"
                                  : "#EDE9FE"
                                : user.subscriptionId === "enterprise"
                                ? isDarkMode
                                  ? "#1E3A5F"
                                  : "#DBEAFE"
                                : colors.lightGray,
                            borderColor:
                              user.subscriptionId === "free"
                                ? colors.warmGray
                                : user.subscriptionId === "standard"
                                ? isDarkMode
                                  ? "#F59E0B"
                                  : "#F59E0B"
                                : user.subscriptionId === "pro"
                                ? isDarkMode
                                  ? "#A78BFA"
                                  : "#7C3AED"
                                : user.subscriptionId === "enterprise"
                                ? isDarkMode
                                  ? "#3B82F6"
                                  : "#3B82F6"
                                : colors.warmGray,
                          },
                        ]}
                      >
                        <Text
                          style={[
                            styles.roleBadgeText,
                            {
                              color:
                                user.subscriptionId === "free"
                                  ? colors.warmGray
                                  : user.subscriptionId === "standard"
                                  ? isDarkMode
                                    ? "#FCD34D"
                                    : "#D97706"
                                  : user.subscriptionId === "pro"
                                  ? isDarkMode
                                    ? "#C4B5FD"
                                    : "#7C3AED"
                                  : user.subscriptionId === "enterprise"
                                  ? isDarkMode
                                    ? "#93C5FD"
                                    : "#2563EB"
                                  : colors.warmGray,
                            },
                          ]}
                        >
                          {user.subscriptionId || "free"}
                        </Text>
                      </View>
                    </View>
                    <View style={[styles.tableCell, { flex: 1 }]}>
                      <View
                        style={[
                          styles.statusBadge,
                          {
                            backgroundColor:
                              user.isActive === false
                                ? isDarkMode
                                  ? "#3F1F1F"
                                  : "#FEE2E2"
                                : isDarkMode
                                ? "#1F3F2F"
                                : "#D1FAE5",
                          },
                        ]}
                      >
                        <Text
                          style={[
                            styles.statusBadgeText,
                            {
                              color:
                                user.isActive === false
                                  ? isDarkMode
                                    ? "#FCA5A5"
                                    : "#DC2626"
                                  : isDarkMode
                                  ? "#86EFAC"
                                  : "#065F46",
                            },
                          ]}
                        >
                          {user.isActive === false ? "Inactive" : "Active"}
                        </Text>
                      </View>
                    </View>
                    <Text
                      style={[
                        styles.tableCell,
                        { flex: 1, color: colors.deepNavy },
                      ]}
                      numberOfLines={1}
                    >
                      {formatDate(user.createdAt)}
                    </Text>
                    <View
                      style={{
                        flex: 2,
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 6,
                        paddingHorizontal: 8,
                      }}
                    >
                      {updatingUserId === user.id ? (
                        <ActivityIndicator
                          size="small"
                          color={colors.beeYellow}
                        />
                      ) : (
                        <>
                          <select
                            value={user.role || "user"}
                            onChange={(e) =>
                              handleRoleChange(user.id, e.target.value)
                            }
                            style={{
                              padding: "5px 8px",
                              borderRadius: "7px",
                              border: `1px solid ${colors.adminBorder}`,
                              backgroundColor: colors.sidebarHover,
                              color: colors.sidebarTextActive,
                              fontSize: "12px",
                              cursor: "pointer",
                              outline: "none",
                              width: "100px",
                            }}
                          >
                            <option value="user">User</option>
                            <option value="company">Company</option>
                            <option value="admin">Admin</option>
                            <option value="superadmin">Super Admin</option>
                          </select>
                          <select
                            value={user.subscriptionId || "free"}
                            onChange={(e) =>
                              handleSubscriptionChange(user.id, e.target.value)
                            }
                            style={{
                              padding: "5px 8px",
                              borderRadius: "7px",
                              border: `1px solid ${colors.adminBorder}`,
                              backgroundColor: colors.sidebarHover,
                              color: colors.sidebarTextActive,
                              fontSize: "12px",
                              cursor: "pointer",
                              outline: "none",
                              width: "100px",
                            }}
                          >
                            <option value="free">Free</option>
                            <option value="standard">Standard</option>
                            <option value="enterprise">Enterprise</option>
                          </select>
                          <TouchableOpacity
                            onPress={(e) => {
                              e.stopPropagation();
                              setUserToDelete(user);
                            }}
                            disabled={deletingUserId === user.id}
                            style={{
                              width: 30,
                              height: 30,
                              borderRadius: 6,
                              backgroundColor: `${colors.danger}22`,
                              alignItems: "center",
                              justifyContent: "center",
                              opacity: deletingUserId === user.id ? 0.5 : 1,
                            }}
                          >
                            {deletingUserId === user.id ? (
                              <ActivityIndicator
                                size="small"
                                color={colors.danger}
                              />
                            ) : (
                              <Icon
                                name="delete-forever"
                                size={16}
                                color={colors.danger}
                              />
                            )}
                          </TouchableOpacity>
                        </>
                      )}
                    </View>
                  </TouchableOpacity>
                ))
              )}
            </ScrollView>
          </View>

          {/* ── Pagination ── */}
          {totalPages > 1 && (
            <View
              style={{
                flexDirection: isMobile ? "column" : "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingHorizontal: 16,
                paddingVertical: 12,
                backgroundColor: colors.sidebarHover,
                borderTopWidth: 1,
                borderTopColor: colors.adminBorder,
                gap: isMobile ? 10 : 0,
              }}
            >
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.regular,
                  color: colors.adminMuted,
                  textAlign: isMobile ? "center" : "left",
                }}
              >
                Page {currentPage} of {totalPages}
              </Text>
              <View
                style={{
                  flexDirection: "row",
                  gap: 6,
                  width: isMobile ? "100%" : "auto",
                }}
              >
                <TouchableOpacity
                  style={{
                    flex: isMobile ? 1 : undefined,
                    paddingHorizontal: 12,
                    paddingVertical: isMobile ? 10 : 6,
                    borderRadius: 8,
                    backgroundColor:
                      currentPage === 1
                        ? colors.adminBorder
                        : colors.sidebarAccent,
                    opacity: currentPage === 1 ? 0.4 : 1,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                  }}
                  onPress={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <Icon
                    name="chevron-left"
                    size={16}
                    color={currentPage === 1 ? colors.adminMuted : "#FFFFFF"}
                  />
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      color: currentPage === 1 ? colors.adminMuted : "#FFFFFF",
                    }}
                  >
                    Prev
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={{
                    flex: isMobile ? 1 : undefined,
                    paddingHorizontal: 12,
                    paddingVertical: isMobile ? 10 : 6,
                    borderRadius: 8,
                    backgroundColor:
                      currentPage === totalPages
                        ? colors.adminBorder
                        : colors.sidebarAccent,
                    opacity: currentPage === totalPages ? 0.4 : 1,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                  }}
                  onPress={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      color:
                        currentPage === totalPages
                          ? colors.adminMuted
                          : "#FFFFFF",
                    }}
                  >
                    Next
                  </Text>
                  <Icon
                    name="chevron-right"
                    size={16}
                    color={
                      currentPage === totalPages ? colors.adminMuted : "#FFFFFF"
                    }
                  />
                </TouchableOpacity>
              </View>
            </View>
          )}
        </>
      )}

      {/* Delete Confirmation Modal */}
      {userToDelete && (
        <View
          style={
            {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.6)",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2000,
            } as any
          }
        >
          <View
            style={{
              backgroundColor: colors.adminCardBg,
              borderRadius: 16,
              padding: 28,
              width: 340,
              maxWidth: "90%",
              ...getAdminCardShadow(isDarkMode),
            }}
          >
            <View
              style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                backgroundColor: `${colors.danger}22`,
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 16,
              }}
            >
              <Icon name="delete-forever" size={26} color={colors.danger} />
            </View>
            <Text
              style={{
                fontSize: 18,
                fontFamily: fonts.bold,
                color: colors.sidebarTextActive,
                marginBottom: 8,
              }}
            >
              Delete User?
            </Text>
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.regular,
                color: colors.sidebarText,
                marginBottom: 6,
              }}
            >
              This will permanently delete:
            </Text>
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.semiBold,
                color: colors.sidebarTextActive,
                marginBottom: 16,
              }}
            >
              {userToDelete.email ||
                userToDelete.displayName ||
                userToDelete.id}
            </Text>
            <Text
              style={{
                fontSize: 12,
                fontFamily: fonts.regular,
                color: colors.adminMuted,
                marginBottom: 24,
              }}
            >
              Their profile, applications, and authentication account (including
              Google sign-in) will be removed. This cannot be undone.
            </Text>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <TouchableOpacity
                onPress={() => setUserToDelete(null)}
                style={{
                  flex: 1,
                  paddingVertical: 12,
                  borderRadius: 10,
                  backgroundColor: colors.sidebarHover,
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    color: colors.sidebarText,
                  }}
                >
                  Cancel
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => handleDeleteUser(userToDelete.id)}
                disabled={!!deletingUserId}
                style={{
                  flex: 1,
                  paddingVertical: 12,
                  borderRadius: 10,
                  backgroundColor: colors.danger,
                  alignItems: "center",
                  flexDirection: "row",
                  justifyContent: "center",
                  gap: 6,
                  opacity: deletingUserId ? 0.7 : 1,
                }}
              >
                {deletingUserId ? (
                  <ActivityIndicator size="small" color="#FFFFFF" />
                ) : (
                  <Icon name="delete-forever" size={16} color="#FFFFFF" />
                )}
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    color: "#FFFFFF",
                  }}
                >
                  {deletingUserId ? "Deleting..." : "Delete Permanently"}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}

      {/* User Detail Modal */}
      {showUserDetail && selectedUser && (
        <UserDetailModal
          user={selectedUser}
          colors={colors}
          isDarkMode={isDarkMode}
          onClose={() => {
            setShowUserDetail(false);
            setSelectedUser(null);
          }}
        />
      )}
    </View>
  );
}

// Subscriptions Content
function SubscriptionsContent({
  colors = lightColors,
  isDarkMode = false,
}: {
  colors?: any;
  isDarkMode?: boolean;
}) {
  const [billingPeriod, setBillingPeriod] = useState<"monthly" | "yearly">(
    "monthly",
  );
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const [plans, setPlans] = useState(
    SUBSCRIPTION_PLANS.map((plan) => ({
      ...plan,
      priceMonthly: plan.priceMonthly,
      priceYearly: plan.priceYearly,
      features: plan.features.map((f) => ({
        name: f.text,
        enabled: f.enabled,
      })),
      permissions:
        DEFAULT_PLAN_PERMISSIONS[plan.id] || DEFAULT_PLAN_PERMISSIONS.free,
    })),
  );

  const isMobile = dimensions.width < 768;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  useEffect(() => {
    loadPlansFromFirestore();
  }, []);

  const loadPlansFromFirestore = async () => {
    try {
      setLoading(true);
      const plansSnapshot = await getDocs(collection(db, "subscriptionPlans"));

      // Build a map of Firestore plans keyed by id
      const firestoreMap: Record<string, any> = {};
      plansSnapshot.docs.forEach((docSnap) => {
        firestoreMap[docSnap.id] = docSnap.data();
      });

      // Merge: always use SUBSCRIPTION_PLANS as the source of truth for which plans exist.
      // Firestore values override the defaults where they exist.
      const mergedPlans = SUBSCRIPTION_PLANS.map((localPlan) => {
        const data = firestoreMap[localPlan.id];
        const planDefaults =
          DEFAULT_PLAN_PERMISSIONS[localPlan.id] ||
          DEFAULT_PLAN_PERMISSIONS.free;
        const firestorePerms =
          data?.permissions && Object.keys(data.permissions).length > 0
            ? data.permissions
            : {};
        return {
          id: localPlan.id,
          name: data?.name ?? localPlan.name,
          priceMonthly: data?.priceMonthly ?? localPlan.priceMonthly,
          priceYearly: data?.priceYearly ?? localPlan.priceYearly,
          icon: data?.icon ?? localPlan.icon,
          color: data?.color ?? localPlan.color,
          popular: data?.popular ?? localPlan.popular,
          buttonText: data?.buttonText ?? localPlan.buttonText,
          features:
            data?.features ??
            localPlan.features.map((f) => ({
              name: f.text,
              enabled: f.enabled,
            })),
          adsEnabled:
            data?.adsEnabled !== undefined
              ? data.adsEnabled
              : localPlan.adsEnabled,
          permissions: { ...planDefaults, ...firestorePerms },
        };
      });

      const sortOrder: { [key: string]: number } = {
        free: 0,
        standard: 1,
        pro: 2,
        enterprise: 3,
      };
      mergedPlans.sort(
        (a, b) => (sortOrder[a.id] || 999) - (sortOrder[b.id] || 999),
      );
      setPlans(mergedPlans);
    } catch (error) {
      console.error("Error loading plans:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePriceChange = (
    planId: string,
    field: "priceMonthly" | "priceYearly",
    value: string,
  ) => {
    const numericValue = parseFloat(value) || 0;
    if (numericValue < 0) {
      alert("Price cannot be negative");
      return;
    }
    setPlans(
      plans.map((plan) =>
        plan.id === planId ? { ...plan, [field]: numericValue } : plan,
      ),
    );
  };

  const toggleFeature = (planId: string, featureIndex: number) => {
    setPlans(
      plans.map((plan) => {
        if (plan.id === planId) {
          const newFeatures = [...plan.features];
          newFeatures[featureIndex] = {
            ...newFeatures[featureIndex],
            enabled: !newFeatures[featureIndex].enabled,
          };
          return { ...plan, features: newFeatures };
        }
        return plan;
      }),
    );
  };

  const toggleAds = (planId: string) => {
    setPlans(
      plans.map((plan) =>
        plan.id === planId ? { ...plan, adsEnabled: !plan.adsEnabled } : plan,
      ),
    );
  };

  const togglePermission = (planId: string, permKey: string) => {
    setPlans(
      plans.map((plan) => {
        if (plan.id === planId) {
          return {
            ...plan,
            permissions: {
              ...plan.permissions,
              [permKey]: !(plan.permissions?.[permKey] ?? false),
            },
          };
        }
        return plan;
      }),
    );
  };

  const saveAllPlans = async () => {
    try {
      const invalidPlan = plans.find(
        (p: any) => p.priceMonthly < 0 || p.priceYearly < 0,
      );
      if (invalidPlan) {
        alert(`Error: ${(invalidPlan as any).name} has a negative price.`);
        return;
      }
      setSaving(true);
      const savePromises = plans.map((plan: any) => {
        const planRef = doc(db, "subscriptionPlans", plan.id);
        // Build a complete permissions object: plan defaults as baseline, then
        // the current UI state takes precedence. Every PERMISSION_LABELS key is
        // always written explicitly so there are no missing / ambiguous keys in Firestore.
        const planDefaults =
          DEFAULT_PLAN_PERMISSIONS[plan.id] || DEFAULT_PLAN_PERMISSIONS.free;
        const normalizedPerms: Record<string, boolean> = { ...planDefaults };
        for (const { key } of PERMISSION_LABELS) {
          normalizedPerms[key] =
            plan.permissions?.[key] ?? planDefaults[key] ?? false;
        }
        return setDoc(planRef, {
          id: plan.id,
          name: plan.name,
          priceMonthly: plan.priceMonthly,
          priceYearly: plan.priceYearly,
          icon: plan.icon,
          color: plan.color,
          popular: plan.popular,
          buttonText: plan.buttonText,
          features: plan.features,
          adsEnabled: plan.adsEnabled,
          permissions: normalizedPerms,
          updatedAt: new Date().toISOString(),
        });
      });
      await Promise.all(savePromises);
      alert("All subscription plans saved successfully!");
    } catch (error) {
      alert("Error saving plans: " + (error as Error).message);
    } finally {
      setSaving(false);
    }
  };

  // Collect every unique feature name across all plans for the feature rows
  const allFeatureNames: string[] = Array.from(
    plans.reduce((acc: Set<string>, plan: any) => {
      plan.features.forEach((f: any) => acc.add(f.name));
      return acc;
    }, new Set<string>()),
  );

  const planAccent: Record<string, string> = {
    free: "#64748B",
    standard: "#F59E0B",
    pro: "#7C3AED",
    enterprise: "#6366F1",
  };
  const planBg: Record<string, string> = {
    free: isDarkMode ? "#161E2D" : "#F8FAFC",
    standard: isDarkMode ? "#2D1F08" : "#FFFBEB",
    pro: isDarkMode ? "#1E1040" : "#F5F0FF",
    enterprise: isDarkMode ? "#1D1640" : "#F5F3FF",
  };
  const planNameColor: Record<string, string> = {
    free: isDarkMode ? "#94A3B8" : "#475569",
    standard: isDarkMode ? "#FCD34D" : "#B45309",
    pro: isDarkMode ? "#C4B5FD" : "#6D28D9",
    enterprise: isDarkMode ? "#A5B4FC" : "#4338CA",
  };

  const CellToggle = ({
    enabled,
    onToggle,
    color,
  }: {
    enabled: boolean;
    onToggle: () => void;
    color: string;
  }) => (
    <TouchableOpacity
      onPress={onToggle}
      style={{
        width: 48,
        height: 26,
        borderRadius: 13,
        backgroundColor: enabled ? color: colors.adminMuted,
        padding: 3,
        justifyContent: "center",
      }}
    >
      <View
        style={{
          width: 20,
          height: 20,
          borderRadius: 10,
          backgroundColor: "#FFFFFF",
          alignSelf: enabled ? "flex-end" : "flex-start",
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.2,
          shadowRadius: 2,
          elevation: 2,
        }}
      />
    </TouchableOpacity>
  );

  const SectionBanner = ({
    label,
    icon,
    accent,
  }: {
    label: string;
    icon: string;
    accent: string;
  }) => (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: colors.adminHeaderBg,
        paddingVertical: 11,
        paddingHorizontal: 20,
        gap: 10,
      }}
    >
      <View
        style={{
          width: 4,
          height: 18,
          borderRadius: 2,
          backgroundColor: accent,
        }}
      />
      <Icon name={icon} size={13} color={accent} />
      <Text
        style={{
          fontSize: 11,
          fontWeight: "700",
          fontFamily: fonts.bold,
          color: accent,
          letterSpacing: 1.4,
          textTransform: "uppercase",
        }}
      >
        {label}
      </Text>
    </View>
  );

  if (loading) {
    return (
      <View
        style={[
          styles.contentContainer,
          { backgroundColor: colors.adminPageBg },
        ]}
      >
        <FullScreenLoader
          message="Loading subscription plans..."
          isDarkMode={isDarkMode}
        />
      </View>
    );
  }

  return (
    <ScrollView
      style={{ flex: 1, backgroundColor: colors.adminPageBg }}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{ padding: 32, paddingBottom: 48 }}
    >
      {/* ── Page Header ── */}
      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: isMobile ? "stretch" : "flex-start",
          marginBottom: isMobile ? 20 : 32,
          gap: 14,
        }}
      >
        <View>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 12,
              marginBottom: 6,
            }}
          >
            <View
              style={{
                width: 4,
                height: 30,
                borderRadius: 2,
                backgroundColor: "#F59E0B",
              }}
            />
            <Text
              style={{
                fontSize: isMobile ? 20 : 26,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: colors.sidebarTextActive,
                letterSpacing: -0.5,
              }}
            >
              Subscription Plans
            </Text>
          </View>
          <Text
            style={{
              fontSize: 14,
              color: colors.adminMuted,
              fontFamily: fonts.regular,
              marginLeft: 16,
            }}
          >
            Manage pricing, permissions and features for all plans
          </Text>
        </View>
        <View style={{ flexDirection: "row", alignItems: "center", gap: 10 }}>
          <View
            style={{
              flexDirection: "row",
              flex: isMobile ? 1 : undefined,
              backgroundColor: colors.adminCardBg,
              borderRadius: 10,
              padding: 3,
              borderWidth: 1,
              borderColor: colors.adminBorder,
            }}
          >
            {(["monthly", "yearly"] as const).map((period) => (
              <TouchableOpacity
                key={period}
                onPress={() => setBillingPeriod(period)}
                style={{
                  flex: isMobile ? 1 : undefined,
                  paddingHorizontal: 16,
                  paddingVertical: 8,
                  borderRadius: 8,
                  backgroundColor:
                    billingPeriod === period
                      ? isDarkMode
                        ? "#334155"
                        : "#F1F5F9"
                      : "transparent",
                }}
              >
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.medium,
                    fontWeight: billingPeriod === period ? "600" : "400",
                    color:
                      billingPeriod === period
                        ? isDarkMode
                          ? "#F9FAFB"
                          : "#0F172A"
                        : isDarkMode
                        ? "#475569"
                        : "#94A3B8",
                  }}
                >
                  {period === "monthly" ? "Monthly" : "Yearly  −17%"}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
          <TouchableOpacity
            onPress={saveAllPlans}
            disabled={saving}
            style={{
              flex: isMobile ? 1 : undefined,
              justifyContent: "center",
              backgroundColor: saving ? "#64748B" : "#10B981",
              paddingHorizontal: 20,
              paddingVertical: 10,
              borderRadius: 10,
              flexDirection: "row",
              alignItems: "center",
              gap: 8,
              opacity: saving ? 0.7 : 1,
            }}
          >
            <Icon name="save" size={15} color="white" />
            <Text
              style={{
                color: "white",
                fontSize: 13,
                fontFamily: fonts.bold,
                fontWeight: "700",
              }}
            >
              {saving ? "Saving…" : "Save Changes"}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      {/* ── Comparison Table / Mobile Plan Cards ── */}
      {isMobile ? (
        /* ── Mobile: one card per plan ── */
        <View style={{ gap: 16 }}>
          {plans.map((plan: any) => {
            const accent =
              planAccent[plan.id as keyof typeof planAccent] || "#64748B";
            const bg =
              planBg[plan.id as keyof typeof planBg] ||
              (colors.adminCardAltBg);
            const nameColor =
              planNameColor[plan.id as keyof typeof planNameColor] ||
              (colors.sidebarText);
            const currentPrice =
              billingPeriod === "monthly"
                ? plan.priceMonthly
                : plan.priceYearly;

            const RowLabel = ({
              label,
              desc,
            }: {
              label: string;
              desc?: string;
            }) => (
              <View style={{ flex: 1, minWidth: 0 }}>
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.semiBold,
                    fontWeight: "600",
                    color: colors.sidebarTextActive,
                  }}
                >
                  {label}
                </Text>
                {!!desc && (
                  <Text
                    style={{
                      fontSize: 10,
                      color: colors.adminMuted,
                      marginTop: 1,
                    }}
                  >
                    {desc}
                  </Text>
                )}
              </View>
            );

            return (
              <View
                key={plan.id}
                style={{
                  borderRadius: 16,
                  overflow: "hidden",
                  borderWidth: 1,
                  borderColor: colors.adminBorder,
                  backgroundColor: colors.adminCardBg,
                  borderTopWidth: 5,
                  borderTopColor: accent,
                  ...Platform.select({
                    web: {
                      boxShadow: isDarkMode
                        ? "0 2px 12px rgba(0,0,0,0.25)"
                        : "0 2px 12px rgba(0,0,0,0.08)",
                    },
                    default: {
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 2 },
                      shadowOpacity: 0.08,
                      shadowRadius: 6,
                      elevation: 2,
                    },
                  }),
                }}
              >
                {/* ── Plan header ── */}
                <View
                  style={{
                    backgroundColor: bg,
                    padding: 16,
                    alignItems: "center",
                  }}
                >
                  {plan.popular && (
                    <View
                      style={{
                        backgroundColor: accent,
                        paddingHorizontal: 10,
                        paddingVertical: 4,
                        borderRadius: 20,
                        marginBottom: 8,
                      }}
                    >
                      <Text
                        style={{
                          color: "#FFFFFF",
                          fontSize: 9,
                          fontFamily: fonts.bold,
                          fontWeight: "700",
                          textTransform: "uppercase",
                          letterSpacing: 0.8,
                        }}
                      >
                        ★ Popular
                      </Text>
                    </View>
                  )}
                  <View
                    style={{
                      width: 46,
                      height: 46,
                      borderRadius: 14,
                      backgroundColor: accent + "22",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: 8,
                    }}
                  >
                    <Icon name={plan.icon || "star"} size={22} color={accent} />
                  </View>
                  <Text
                    style={{
                      fontSize: 18,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: nameColor,
                      marginBottom: 4,
                    }}
                  >
                    {plan.name ||
                      (plan.id
                        ? plan.id.charAt(0).toUpperCase() + plan.id.slice(1)
                        : "Plan")}
                  </Text>
                  <Text
                    style={{
                      fontSize: 22,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: colors.sidebarTextActive,
                      letterSpacing: -0.5,
                    }}
                  >
                    {currentPrice === 0
                      ? "Free"
                      : `${currentPrice.toLocaleString()} Birr`}
                  </Text>
                  {currentPrice > 0 && (
                    <Text
                      style={{
                        fontSize: 11,
                        color: colors.adminMuted,
                        marginTop: 2,
                      }}
                    >
                      per {billingPeriod === "monthly" ? "month" : "year"}
                    </Text>
                  )}
                </View>

                {/* ── PRICING section ── */}
                <View
                  style={{
                    backgroundColor: colors.adminHeaderBg,
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 9,
                    paddingHorizontal: 16,
                    gap: 8,
                  }}
                >
                  <View
                    style={{
                      width: 4,
                      height: 14,
                      borderRadius: 2,
                      backgroundColor: "#F59E0B",
                    }}
                  />
                  <Icon name="attach-money" size={12} color="#F59E0B" />
                  <Text
                    style={{
                      fontSize: 10,
                      fontWeight: "700",
                      fontFamily: fonts.bold,
                      color: "#F59E0B",
                      letterSpacing: 1.4,
                      textTransform: "uppercase",
                    }}
                  >
                    Pricing
                  </Text>
                </View>
                {(
                  [
                    {
                      field: "priceMonthly" as const,
                      label: "Monthly Price",
                      desc: "per month (Birr)",
                    },
                    {
                      field: "priceYearly" as const,
                      label: "Yearly Price",
                      desc: "per year (Birr)",
                    },
                  ] as {
                    field: "priceMonthly" | "priceYearly";
                    label: string;
                    desc: string;
                  }[]
                ).map(({ field, label, desc }, idx) => (
                  <View
                    key={field}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      paddingVertical: 12,
                      paddingHorizontal: 16,
                      backgroundColor:
                        idx % 2 === 0
                          ? isDarkMode
                            ? "#161F2E"
                            : "#FFFFFF"
                          : isDarkMode
                          ? "#111827"
                          : "#F9FAFB",
                      borderBottomWidth: 1,
                      borderBottomColor: colors.adminBorder,
                      gap: 12,
                    }}
                  >
                    <RowLabel label={label} desc={desc} />
                    <input
                      type="number"
                      min="0"
                      value={plan[field]}
                      onChange={(e: any) =>
                        handlePriceChange(plan.id, field, e.target.value)
                      }
                      style={{
                        width: 110,
                        padding: "8px 10px",
                        fontSize: 14,
                        borderRadius: 8,
                        textAlign: "center",
                        border: `1.5px solid ${accent}55`,
                        fontFamily: fonts.regular,
                        fontWeight: "600",
                        backgroundColor: colors.adminHeaderBg,
                        color: colors.sidebarTextActive,
                        outline: "none",
                      }}
                    />
                  </View>
                ))}

                {/* ── Show Ads row ── */}
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 12,
                    paddingHorizontal: 16,
                    backgroundColor: colors.adminCardBg,
                    borderBottomWidth: 1,
                    borderBottomColor: colors.adminBorder,
                    gap: 12,
                  }}
                >
                  <RowLabel label="Show Ads" desc="Display advertisements" />
                  <View style={{ alignItems: "center", gap: 4 }}>
                    <CellToggle
                      enabled={plan.adsEnabled}
                      onToggle={() => toggleAds(plan.id)}
                      color="#EF4444"
                    />
                    <Text
                      style={{
                        fontSize: 10,
                        fontFamily: fonts.medium,
                        fontWeight: "600",
                        color: plan.adsEnabled
                          ? "#EF4444"
                          : isDarkMode
                          ? "#475569"
                          : "#CBD5E1",
                      }}
                    >
                      {plan.adsEnabled ? "On" : "Off"}
                    </Text>
                  </View>
                </View>

                {/* ── PERMISSIONS section ── */}
                <View
                  style={{
                    backgroundColor: colors.adminHeaderBg,
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 9,
                    paddingHorizontal: 16,
                    gap: 8,
                  }}
                >
                  <View
                    style={{
                      width: 4,
                      height: 14,
                      borderRadius: 2,
                      backgroundColor: "#8B5CF6",
                    }}
                  />
                  <Icon name="lock-open" size={12} color="#8B5CF6" />
                  <Text
                    style={{
                      fontSize: 10,
                      fontWeight: "700",
                      fontFamily: fonts.bold,
                      color: "#8B5CF6",
                      letterSpacing: 1.4,
                      textTransform: "uppercase",
                    }}
                  >
                    Feature Permissions
                  </Text>
                </View>
                {PERMISSION_LABELS.map(
                  (
                    {
                      key,
                      label,
                      description,
                    }: { key: string; label: string; description: string },
                    idx: number,
                  ) => {
                    const enabled: boolean = plan.permissions?.[key] ?? false;
                    return (
                      <View
                        key={key}
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingVertical: 12,
                          paddingHorizontal: 16,
                          backgroundColor:
                            idx % 2 === 0
                              ? isDarkMode
                                ? "#161F2E"
                                : "#FFFFFF"
                              : isDarkMode
                              ? "#111827"
                              : "#F9FAFB",
                          borderBottomWidth: 1,
                          borderBottomColor: colors.adminBorder,
                          gap: 12,
                        }}
                      >
                        <RowLabel label={label} desc={description} />
                        <View style={{ alignItems: "center", gap: 4 }}>
                          <CellToggle
                            enabled={enabled}
                            onToggle={() => togglePermission(plan.id, key)}
                            color={accent}
                          />
                          <Text
                            style={{
                              fontSize: 10,
                              fontFamily: fonts.medium,
                              fontWeight: "600",
                              color: enabled
                                ? accent
                                : isDarkMode
                                ? "#475569"
                                : "#CBD5E1",
                            }}
                          >
                            {enabled ? "On" : "Off"}
                          </Text>
                        </View>
                      </View>
                    );
                  },
                )}

                {/* ── PLAN FEATURES section ── */}
                <View
                  style={{
                    backgroundColor: colors.adminHeaderBg,
                    flexDirection: "row",
                    alignItems: "center",
                    paddingVertical: 9,
                    paddingHorizontal: 16,
                    gap: 8,
                  }}
                >
                  <View
                    style={{
                      width: 4,
                      height: 14,
                      borderRadius: 2,
                      backgroundColor: "#10B981",
                    }}
                  />
                  <Icon name="check-circle" size={12} color="#10B981" />
                  <Text
                    style={{
                      fontSize: 10,
                      fontWeight: "700",
                      fontFamily: fonts.bold,
                      color: "#10B981",
                      letterSpacing: 1.4,
                      textTransform: "uppercase",
                    }}
                  >
                    Plan Features
                  </Text>
                </View>
                {allFeatureNames.map((featureName: string, idx: number) => {
                  const featureIdx: number = plan.features.findIndex(
                    (f: any) => f.name === featureName,
                  );
                  const enabled: boolean =
                    featureIdx >= 0 ? plan.features[featureIdx].enabled : false;
                  return (
                    <View
                      key={featureName}
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        paddingVertical: 12,
                        paddingHorizontal: 16,
                        backgroundColor:
                          idx % 2 === 0
                            ? isDarkMode
                              ? "#161F2E"
                              : "#FFFFFF"
                            : isDarkMode
                            ? "#111827"
                            : "#F9FAFB",
                        borderBottomWidth:
                          idx === allFeatureNames.length - 1 ? 0 : 1,
                        borderBottomColor: colors.adminBorder,
                        gap: 12,
                      }}
                    >
                      <Text
                        style={{
                          flex: 1,
                          fontSize: 13,
                          fontFamily: fonts.regular,
                          color: colors.sidebarText,
                        }}
                      >
                        {featureName}
                      </Text>
                      <View style={{ alignItems: "center", gap: 4 }}>
                        {featureIdx < 0 ? (
                          <Text
                            style={{
                              fontSize: 15,
                              color: colors.adminBorder,
                            }}
                          >
                            —
                          </Text>
                        ) : (
                          <>
                            <CellToggle
                              enabled={enabled}
                              onToggle={() =>
                                toggleFeature(plan.id, featureIdx)
                              }
                              color={accent}
                            />
                            <Text
                              style={{
                                fontSize: 10,
                                fontFamily: fonts.medium,
                                fontWeight: "600",
                                color: enabled
                                  ? accent
                                  : isDarkMode
                                  ? "#475569"
                                  : "#CBD5E1",
                              }}
                            >
                              {enabled ? "Yes" : "No"}
                            </Text>
                          </>
                        )}
                      </View>
                    </View>
                  );
                })}
              </View>
            );
          })}
        </View>
      ) : (
        /* ── Desktop: original comparison table ── */
        <View
          style={{
            width: "100%",
            borderRadius: 16,
            overflow: "hidden",
            borderWidth: 1,
            borderColor: colors.adminBorder,
            backgroundColor: colors.adminCardBg,
          }}
        >
          {/* ── Plan header cards ── */}
          <View style={{ flexDirection: "row" }}>
            <View
              style={{
                flex: 2,
                backgroundColor: colors.adminHeaderBg,
                padding: 20,
                justifyContent: "flex-end",
                minHeight: 150,
                borderBottomWidth: 1,
                borderBottomColor: colors.adminBorder,
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  fontWeight: "700",
                  fontFamily: fonts.bold,
                  color: colors.adminMuted,
                  letterSpacing: 2,
                  textTransform: "uppercase",
                }}
              >
                PLANS
              </Text>
            </View>

            {plans.map((plan: any) => {
              const accent =
                planAccent[plan.id as keyof typeof planAccent] || "#64748B";
              const bg =
                planBg[plan.id as keyof typeof planBg] ||
                (colors.adminCardAltBg);
              const nameColor =
                planNameColor[plan.id as keyof typeof planNameColor] ||
                (colors.sidebarText);
              const currentPrice =
                billingPeriod === "monthly"
                  ? plan.priceMonthly
                  : plan.priceYearly;
              return (
                <View
                  key={plan.id}
                  style={{
                    flex: 1,
                    minWidth: 0,
                    backgroundColor: bg,
                    borderLeftWidth: 1,
                    borderLeftColor: colors.adminBorder,
                    borderBottomWidth: 1,
                    borderBottomColor: colors.adminBorder,
                    borderTopWidth: 5,
                    borderTopColor: accent,
                    alignItems: "center",
                    paddingTop: 16,
                    paddingBottom: 20,
                    paddingHorizontal: 10,
                  }}
                >
                  {plan.popular && (
                    <View
                      style={{
                        backgroundColor: accent,
                        paddingHorizontal: 10,
                        paddingVertical: 4,
                        borderRadius: 20,
                        marginBottom: 10,
                      }}
                    >
                      <Text
                        style={{
                          color: "#FFFFFF",
                          fontSize: 9,
                          fontFamily: fonts.bold,
                          fontWeight: "700",
                          textTransform: "uppercase",
                          letterSpacing: 0.8,
                        }}
                      >
                        ★ Popular
                      </Text>
                    </View>
                  )}
                  <View
                    style={{
                      width: 46,
                      height: 46,
                      borderRadius: 14,
                      backgroundColor: accent + "22",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: plan.popular ? 0 : 10,
                      marginBottom: 10,
                    }}
                  >
                    <Icon name={plan.icon || "star"} size={22} color={accent} />
                  </View>
                  <Text
                    style={{
                      fontSize: 16,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: nameColor,
                      textAlign: "center",
                      width: "100%",
                      marginBottom: 6,
                    }}
                  >
                    {plan.name ||
                      (plan.id
                        ? plan.id.charAt(0).toUpperCase() + plan.id.slice(1)
                        : "Plan")}
                  </Text>
                  <View
                    style={{
                      width: "60%",
                      height: 2,
                      borderRadius: 1,
                      backgroundColor: accent + "50",
                      marginBottom: 10,
                    }}
                  />
                  <Text
                    style={{
                      fontSize: 20,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: colors.sidebarTextActive,
                      textAlign: "center",
                      letterSpacing: -0.5,
                    }}
                  >
                    {currentPrice === 0
                      ? "Free"
                      : `${currentPrice.toLocaleString()}`}
                  </Text>
                  {currentPrice > 0 && (
                    <Text
                      style={{
                        fontSize: 11,
                        color: colors.adminMuted,
                        fontFamily: fonts.regular,
                        textAlign: "center",
                        marginTop: 2,
                      }}
                    >
                      Birr / {billingPeriod === "monthly" ? "mo" : "yr"}
                    </Text>
                  )}
                </View>
              );
            })}
          </View>

          {/* ── PRICING ── */}
          <SectionBanner label="Pricing" icon="attach-money" accent="#F59E0B" />

          {(
            [
              {
                field: "priceMonthly" as const,
                label: "Monthly Price",
                desc: "Charged every month (Birr)",
              },
              {
                field: "priceYearly" as const,
                label: "Yearly Price",
                desc: "Charged annually (Birr)",
              },
            ] as {
              field: "priceMonthly" | "priceYearly";
              label: string;
              desc: string;
            }[]
          ).map(({ field, label, desc }, idx) => (
            <View
              key={field}
              style={{
                flexDirection: "row",
                backgroundColor:
                  idx % 2 === 0
                    ? isDarkMode
                      ? "#161F2E"
                      : "#FFFFFF"
                    : isDarkMode
                    ? "#111827"
                    : "#F9FAFB",
                borderBottomWidth: 1,
                borderBottomColor: colors.adminBorder,
              }}
            >
              <View
                style={{
                  flex: 2,
                  paddingVertical: 14,
                  paddingHorizontal: 20,
                  justifyContent: "center",
                  borderRightWidth: 1,
                  borderRightColor: colors.adminBorder,
                }}
              >
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.semiBold,
                    fontWeight: "600",
                    color: colors.sidebarTextActive,
                  }}
                >
                  {label}
                </Text>
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.regular,
                    color: colors.adminMuted,
                    marginTop: 2,
                  }}
                >
                  {desc}
                </Text>
              </View>
              {plans.map((plan: any) => {
                const accent =
                  planAccent[plan.id as keyof typeof planAccent] || "#64748B";
                return (
                  <View
                    key={plan.id}
                    style={{
                      flex: 1,
                      paddingVertical: 12,
                      paddingHorizontal: 8,
                      alignItems: "center",
                      justifyContent: "center",
                      borderRightWidth: 1,
                      borderRightColor: colors.adminBorder,
                    }}
                  >
                    <input
                      type="number"
                      min="0"
                      value={plan[field]}
                      onChange={(e: any) =>
                        handlePriceChange(plan.id, field, e.target.value)
                      }
                      style={{
                        width: "90%",
                        padding: "8px 10px",
                        fontSize: 14,
                        borderRadius: 8,
                        textAlign: "center",
                        border: `1.5px solid ${accent}55`,
                        fontFamily: fonts.regular,
                        fontWeight: "600",
                        backgroundColor: colors.adminHeaderBg,
                        color: colors.sidebarTextActive,
                        outline: "none",
                      }}
                    />
                  </View>
                );
              })}
            </View>
          ))}

          {/* Show Ads row */}
          <View
            style={{
              flexDirection: "row",
              backgroundColor: colors.adminCardBg,
              borderBottomWidth: 1,
              borderBottomColor: colors.adminBorder,
            }}
          >
            <View
              style={{
                flex: 2,
                paddingVertical: 14,
                paddingHorizontal: 20,
                justifyContent: "center",
                borderRightWidth: 1,
                borderRightColor: colors.adminBorder,
              }}
            >
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.semiBold,
                  fontWeight: "600",
                  color: colors.sidebarTextActive,
                }}
              >
                Show Ads
              </Text>
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: fonts.regular,
                  color: colors.adminMuted,
                  marginTop: 2,
                }}
              >
                Display advertisements on this plan
              </Text>
            </View>
            {plans.map((plan: any) => (
              <View
                key={plan.id}
                style={{
                  flex: 1,
                  paddingVertical: 12,
                  paddingHorizontal: 8,
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 5,
                  borderRightWidth: 1,
                  borderRightColor: colors.adminBorder,
                }}
              >
                <CellToggle
                  enabled={plan.adsEnabled}
                  onToggle={() => toggleAds(plan.id)}
                  color="#EF4444"
                />
                <Text
                  style={{
                    fontSize: 10,
                    fontFamily: fonts.medium,
                    fontWeight: "600",
                    color: plan.adsEnabled
                      ? "#EF4444"
                      : isDarkMode
                      ? "#475569"
                      : "#CBD5E1",
                  }}
                >
                  {plan.adsEnabled ? "On" : "Off"}
                </Text>
              </View>
            ))}
          </View>

          {/* ── PERMISSIONS ── */}
          <SectionBanner
            label="Feature Permissions"
            icon="lock-open"
            accent="#8B5CF6"
          />

          {PERMISSION_LABELS.map(
            (
              {
                key,
                label,
                description,
              }: { key: string; label: string; description: string },
              idx: number,
            ) => (
              <View
                key={key}
                style={{
                  flexDirection: "row",
                  backgroundColor:
                    idx % 2 === 0
                      ? isDarkMode
                        ? "#161F2E"
                        : "#FFFFFF"
                      : isDarkMode
                      ? "#111827"
                      : "#F9FAFB",
                  borderBottomWidth: 1,
                  borderBottomColor: colors.adminBorder,
                }}
              >
                <View
                  style={{
                    flex: 2,
                    paddingVertical: 14,
                    paddingHorizontal: 20,
                    justifyContent: "center",
                    borderRightWidth: 1,
                    borderRightColor: colors.adminBorder,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 13,
                      fontFamily: fonts.semiBold,
                      fontWeight: "600",
                      color: colors.sidebarTextActive,
                    }}
                  >
                    {label}
                  </Text>
                  <Text
                    style={{
                      fontSize: 11,
                      fontFamily: fonts.regular,
                      color: colors.adminMuted,
                      marginTop: 2,
                    }}
                  >
                    {description}
                  </Text>
                </View>
                {plans.map((plan: any) => {
                  const accent =
                    planAccent[plan.id as keyof typeof planAccent] || "#64748B";
                  const enabled: boolean = plan.permissions?.[key] ?? false;
                  return (
                    <View
                      key={plan.id}
                      style={{
                        flex: 1,
                        paddingVertical: 12,
                        paddingHorizontal: 8,
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 5,
                        borderRightWidth: 1,
                        borderRightColor: colors.adminBorder,
                      }}
                    >
                      <CellToggle
                        enabled={enabled}
                        onToggle={() => togglePermission(plan.id, key)}
                        color={accent}
                      />
                      <Text
                        style={{
                          fontSize: 10,
                          fontFamily: fonts.medium,
                          fontWeight: "600",
                          color: enabled
                            ? accent
                            : isDarkMode
                            ? "#475569"
                            : "#CBD5E1",
                        }}
                      >
                        {enabled ? "On" : "Off"}
                      </Text>
                    </View>
                  );
                })}
              </View>
            ),
          )}

          {/* ── PLAN FEATURES ── */}
          <SectionBanner
            label="Plan Features"
            icon="check-circle"
            accent="#10B981"
          />

          {allFeatureNames.map((featureName: string, idx: number) => (
            <View
              key={featureName}
              style={{
                flexDirection: "row",
                backgroundColor:
                  idx % 2 === 0
                    ? isDarkMode
                      ? "#161F2E"
                      : "#FFFFFF"
                    : isDarkMode
                    ? "#111827"
                    : "#F9FAFB",
                borderBottomWidth: idx === allFeatureNames.length - 1 ? 0 : 1,
                borderBottomColor: colors.adminBorder,
              }}
            >
              <View
                style={{
                  flex: 2,
                  paddingVertical: 13,
                  paddingHorizontal: 20,
                  justifyContent: "center",
                  borderRightWidth: 1,
                  borderRightColor: colors.adminBorder,
                }}
              >
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.regular,
                    color: colors.sidebarText,
                    lineHeight: 18,
                  }}
                >
                  {featureName}
                </Text>
              </View>
              {plans.map((plan: any) => {
                const accent =
                  planAccent[plan.id as keyof typeof planAccent] || "#64748B";
                const featureIdx: number = plan.features.findIndex(
                  (f: any) => f.name === featureName,
                );
                if (featureIdx < 0) {
                  return (
                    <View
                      key={plan.id}
                      style={{
                        flex: 1,
                        paddingVertical: 13,
                        alignItems: "center",
                        justifyContent: "center",
                        borderRightWidth: 1,
                        borderRightColor: colors.adminBorder,
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 16,
                          color: colors.adminBorder,
                        }}
                      >
                        —
                      </Text>
                    </View>
                  );
                }
                const enabled: boolean = plan.features[featureIdx].enabled;
                return (
                  <View
                    key={plan.id}
                    style={{
                      flex: 1,
                      paddingVertical: 13,
                      paddingHorizontal: 8,
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 5,
                      borderRightWidth: 1,
                      borderRightColor: colors.adminBorder,
                    }}
                  >
                    <CellToggle
                      enabled={enabled}
                      onToggle={() => toggleFeature(plan.id, featureIdx)}
                      color={accent}
                    />
                    <Text
                      style={{
                        fontSize: 10,
                        fontFamily: fonts.medium,
                        fontWeight: "600",
                        color: enabled
                          ? accent
                          : isDarkMode
                          ? "#475569"
                          : "#CBD5E1",
                      }}
                    >
                      {enabled ? "Yes" : "No"}
                    </Text>
                  </View>
                );
              })}
            </View>
          ))}
        </View>
      )}{" "}
      {/* end isMobile ternary for comparison table */}
    </ScrollView>
  );
}
function SupportRequestsContent({
  colors = lightColors,
  isDarkMode = false,
}: {
  colors?: any;
  isDarkMode?: boolean;
}) {
  const [activeTab, setActiveTab] = useState<"contact" | "feedback">("contact");
  const [contactRequests, setContactRequests] = useState<any[]>([]);
  const [feedbackRequests, setFeedbackRequests] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedRequest, setSelectedRequest] = useState<any>(null);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    fetchRequests();
  }, [activeTab]);

  const fetchRequests = async () => {
    try {
      setLoading(true);

      if (activeTab === "contact") {
        const contactRef = collection(db, "contactSupport");
        const contactQuery = dbQuery(contactRef, orderBy("createdAt", "desc"));
        const snapshot = await getDocs(contactQuery);
        const requests = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setContactRequests(requests);
      } else {
        const feedbackRef = collection(db, "feedback");
        const feedbackQuery = dbQuery(
          feedbackRef,
          orderBy("createdAt", "desc"),
        );
        const snapshot = await getDocs(feedbackQuery);
        const requests = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setFeedbackRequests(requests);
      }
    } catch (error) {
      console.error("Error fetching support requests:", error);
      Alert.alert("Error", "Failed to load support requests");
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (requestId: string, newStatus: string) => {
    try {
      setUpdating(true);
      const collectionName =
        activeTab === "contact" ? "contactSupport" : "feedback";
      const requestRef = doc(db, collectionName, requestId);

      await updateDoc(requestRef, {
        status: newStatus,
        updatedAt: new Date(),
      });

      // Update local state
      if (activeTab === "contact") {
        setContactRequests(
          contactRequests.map((req) =>
            req.id === requestId ? { ...req, status: newStatus } : req,
          ),
        );
      } else {
        setFeedbackRequests(
          feedbackRequests.map((req) =>
            req.id === requestId ? { ...req, status: newStatus } : req,
          ),
        );
      }

      Alert.alert("Success", "Status updated successfully");
      setSelectedRequest(null);
    } catch (error) {
      console.error("Error updating status:", error);
      Alert.alert("Error", "Failed to update status");
    } finally {
      setUpdating(false);
    }
  };

  const formatDate = (timestamp: any) => {
    if (!timestamp) return "N/A";
    try {
      const date = timestamp.toDate
        ? timestamp.toDate()
        : new Date(timestamp.seconds * 1000);
      return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    } catch {
      return "N/A";
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "pending":
        return "#F59E0B";
      case "in-progress":
        return "#3B82F6";
      case "resolved":
        return "#10B981";
      case "closed":
        return "#6B7280";
      default:
        return "#6B7280";
    }
  };

  const requests = activeTab === "contact" ? contactRequests : feedbackRequests;

  return (
    <View
      style={{ flex: 1, backgroundColor: colors.adminPageBg }}
    >
      {/* ── Page Header ── */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: colors.adminHeaderBg,
          paddingHorizontal: 28,
          paddingVertical: 18,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center", gap: 14 }}>
          <View
            style={{
              width: 40,
              height: 40,
              borderRadius: 11,
              backgroundColor: `${colors.sidebarAccent}22`,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon
              name="support-agent"
              size={22}
              color={colors.sidebarAccent}
            />
          </View>
          <View>
            <Text
              style={{
                fontSize: 18,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#F9FAFB",
                letterSpacing: -0.3,
              }}
            >
              Support Requests
            </Text>
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.regular,
                color: "#64748B",
                marginTop: 1,
              }}
            >
              {contactRequests.length} contact · {feedbackRequests.length}{" "}
              feedback
            </Text>
          </View>
        </View>
        <TouchableOpacity
          onPress={fetchRequests}
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 6,
            backgroundColor: colors.sidebarAccent,
            paddingHorizontal: 14,
            paddingVertical: 8,
            borderRadius: 9,
          }}
        >
          <Icon name="refresh" size={15} color="#FFFFFF" />
          <Text
            style={{
              fontSize: 12,
              fontFamily: fonts.semiBold,
              fontWeight: "600",
              color: "#FFFFFF",
            }}
          >
            Refresh
          </Text>
        </TouchableOpacity>
      </View>

      {/* ── Tab Switcher ── */}
      <View
        style={{
          flexDirection: "row",
          gap: 10,
          paddingHorizontal: 20,
          paddingTop: 16,
          paddingBottom: 8,
        }}
      >
        <TouchableOpacity
          onPress={() => setActiveTab("contact")}
          style={{
            flex: 1,
            paddingVertical: 11,
            borderRadius: 10,
            alignItems: "center",
            backgroundColor:
              activeTab === "contact"
                ? "#14B8A6"
                : isDarkMode
                ? "#161F2E"
                : "#FFFFFF",
            borderWidth: 1,
            borderColor:
              activeTab === "contact"
                ? "#14B8A6"
                : isDarkMode
                ? "#334155"
                : "#E2E8F0",
          }}
        >
          <Text
            style={{
              fontSize: 13,
              fontFamily: fonts.semiBold,
              fontWeight: "600",
              color:
                activeTab === "contact"
                  ? "#FFFFFF"
                  : isDarkMode
                  ? "#94A3B8"
                  : "#475569",
            }}
          >
            Contact Support ({contactRequests.length})
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => setActiveTab("feedback")}
          style={{
            flex: 1,
            paddingVertical: 11,
            borderRadius: 10,
            alignItems: "center",
            backgroundColor:
              activeTab === "feedback"
                ? "#F59E0B"
                : isDarkMode
                ? "#161F2E"
                : "#FFFFFF",
            borderWidth: 1,
            borderColor:
              activeTab === "feedback"
                ? "#F59E0B"
                : isDarkMode
                ? "#334155"
                : "#E2E8F0",
          }}
        >
          <Text
            style={{
              fontSize: 13,
              fontFamily: fonts.semiBold,
              fontWeight: "600",
              color:
                activeTab === "feedback"
                  ? "#FFFFFF"
                  : isDarkMode
                  ? "#94A3B8"
                  : "#475569",
            }}
          >
            Feedback ({feedbackRequests.length})
          </Text>
        </TouchableOpacity>
      </View>

      {loading ? (
        <InlineLoadingIndicator
          message="Loading requests..."
          isDarkMode={isDarkMode}
        />
      ) : requests.length === 0 ? (
        <View style={{ alignItems: "center", paddingVertical: 48 }}>
          <Icon
            name={activeTab === "contact" ? "contact-support" : "feedback"}
            size={64}
            color={colors.adminMuted}
          />
          <Text
            style={{
              fontSize: 16,
              fontFamily: fonts.regular,
              color: colors.adminMuted,
              marginTop: 16,
            }}
          >
            No {activeTab === "contact" ? "contact requests" : "feedback"} yet
          </Text>
        </View>
      ) : (
        <ScrollView
          style={{ flex: 1, paddingHorizontal: 20 }}
          showsVerticalScrollIndicator={false}
        >
          <View style={{ paddingBottom: 24, gap: 10 }}>
            {requests.map((request) => {
              const statusColor = getStatusColor(request.status);
              return (
                <View
                  key={request.id}
                  style={{
                    backgroundColor: colors.adminCardBg,
                    borderRadius: 12,
                    overflow: "hidden",
                    borderLeftWidth: 4,
                    borderLeftColor: statusColor,
                    ...Platform.select({
                      web: { boxShadow: "0 2px 8px rgba(0,0,0,0.08)" },
                      default: {
                        shadowColor: "#000",
                        shadowOffset: { width: 0, height: 1 },
                        shadowOpacity: 0.06,
                        shadowRadius: 4,
                        elevation: 2,
                      },
                    }),
                  }}
                >
                  <View style={{ padding: 16 }}>
                    {/* Header Row */}
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginBottom: 10,
                      }}
                    >
                      <View style={{ flex: 1 }}>
                        {activeTab === "contact" ? (
                          <>
                            <Text
                              style={{
                                fontSize: 14,
                                fontFamily: fonts.bold,
                                fontWeight: "700",
                                color: colors.sidebarTextActive,
                                marginBottom: 2,
                              }}
                            >
                              {request.name}
                            </Text>
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.regular,
                                color: colors.adminMuted,
                              }}
                            >
                              {request.email}
                              {request.phone ? ` · ${request.phone}` : ""}
                            </Text>
                          </>
                        ) : (
                          <>
                            <Text
                              style={{
                                fontSize: 14,
                                fontFamily: fonts.bold,
                                fontWeight: "700",
                                color: colors.sidebarTextActive,
                                marginBottom: 4,
                              }}
                            >
                              {request.category}
                            </Text>
                            {request.rating > 0 && (
                              <View style={{ flexDirection: "row", gap: 2 }}>
                                {[1, 2, 3, 4, 5].map((star) => (
                                  <Icon
                                    key={star}
                                    name={
                                      star <= request.rating
                                        ? "star"
                                        : "star-border"
                                    }
                                    size={14}
                                    color="#F59E0B"
                                  />
                                ))}
                              </View>
                            )}
                          </>
                        )}
                      </View>
                      <View style={{ alignItems: "flex-end", gap: 4 }}>
                        <View
                          style={{
                            paddingHorizontal: 8,
                            paddingVertical: 3,
                            borderRadius: 20,
                            backgroundColor: `${statusColor}20`,
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.medium,
                              color: statusColor,
                              textTransform: "capitalize",
                            }}
                          >
                            {request.status}
                          </Text>
                        </View>
                        <Text
                          style={{
                            fontSize: 10,
                            fontFamily: fonts.regular,
                            color: colors.adminMuted,
                          }}
                        >
                          {formatDate(request.createdAt)}
                        </Text>
                      </View>
                    </View>

                    {/* Content */}
                    {activeTab === "contact" && request.subject && (
                      <Text
                        style={{
                          fontSize: 13,
                          fontFamily: fonts.semiBold,
                          fontWeight: "600",
                          color: colors.sidebarText,
                          marginBottom: 6,
                        }}
                      >
                        {request.subject}
                      </Text>
                    )}
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.regular,
                        color: colors.adminMuted,
                        lineHeight: 19,
                        marginBottom: 12,
                      }}
                    >
                      {activeTab === "contact"
                        ? request.message
                        : request.feedback}
                    </Text>

                    {/* Status Pills */}
                    <View
                      style={{ flexDirection: "row", gap: 6, flexWrap: "wrap" }}
                    >
                      {["pending", "in-progress", "resolved", "closed"].map(
                        (s) => (
                          <TouchableOpacity
                            key={s}
                            onPress={() => updateStatus(request.id, s)}
                            disabled={request.status === s || updating}
                            style={{
                              paddingHorizontal: 10,
                              paddingVertical: 4,
                              borderRadius: 20,
                              backgroundColor:
                                request.status === s
                                  ? getStatusColor(s)
                                  : isDarkMode
                                  ? "#1E293B"
                                  : "#F1F5F9",
                              opacity: updating ? 0.5 : 1,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 11,
                                fontFamily: fonts.medium,
                                color:
                                  request.status === s
                                    ? "#FFFFFF"
                                    : isDarkMode
                                    ? "#64748B"
                                    : "#94A3B8",
                                textTransform: "capitalize",
                              }}
                            >
                              {s.replace("-", " ")}
                            </Text>
                          </TouchableOpacity>
                        ),
                      )}
                    </View>
                  </View>
                </View>
              );
            })}
          </View>
        </ScrollView>
      )}
    </View>
  );
}

// Admin Settings Content
function AdminSettingsContent({
  colors = lightColors,
  isDarkMode = false,
  userRole,
}: {
  colors?: any;
  isDarkMode?: boolean;
  userRole?: string;
}) {
  const [scheduledEmailsEnabled, setScheduledEmailsEnabled] = useState(true);
  const [manualEmailsEnabled, setManualEmailsEnabled] = useState(true);
  const [showAds, setShowAds] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const isSuperAdmin = userRole === "superadmin";

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      setLoading(true);
      const settingsRef = doc(db, "systemSettings", "emailNotifications");
      const settingsDoc = await getDoc(settingsRef);

      if (settingsDoc.exists()) {
        const data = settingsDoc.data();
        setScheduledEmailsEnabled(data.scheduledEmailsEnabled ?? true);
        setManualEmailsEnabled(data.manualEmailsEnabled ?? true);
      }

      const adsConfigRef = doc(db, "appConfig", "global");
      const adsConfigDoc = await getDoc(adsConfigRef);
      if (adsConfigDoc.exists()) {
        setShowAds(adsConfigDoc.data().showAds ?? true);
      }
    } catch (error) {
      console.error("Error loading settings:", error);
    } finally {
      setLoading(false);
    }
  };

  const saveSettings = async () => {
    try {
      setSaving(true);
      const settingsRef = doc(db, "systemSettings", "emailNotifications");

      await setDoc(
        settingsRef,
        {
          scheduledEmailsEnabled,
          manualEmailsEnabled,
          updatedAt: new Date(),
          updatedBy: auth.currentUser?.uid || "unknown",
        },
        { merge: true },
      );

      if (isSuperAdmin) {
        const adsConfigRef = doc(db, "appConfig", "global");
        await setDoc(
          adsConfigRef,
          {
            showAds,
            updatedAt: new Date(),
            updatedBy: auth.currentUser?.uid || "unknown",
          },
          { merge: true },
        );
      }

      Alert.alert("Success", "Settings saved successfully");
    } catch (error) {
      console.error("Error saving settings:", error);
      Alert.alert("Error", "Failed to save settings");
    } finally {
      setSaving(false);
    }
  };

  return (
    <View
      style={{ flex: 1, backgroundColor: colors.adminPageBg }}
    >
      {/* ── Page Header ── */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: colors.adminHeaderBg,
          paddingHorizontal: 28,
          paddingVertical: 18,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center", gap: 14 }}>
          <View
            style={{
              width: 40,
              height: 40,
              borderRadius: 11,
              backgroundColor: `${colors.sidebarAccent}22`,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon name="settings" size={22} color={colors.sidebarAccent} />
          </View>
          <View>
            <Text
              style={{
                fontSize: 18,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#F9FAFB",
                letterSpacing: -0.3,
              }}
            >
              System Settings
            </Text>
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.regular,
                color: "#64748B",
                marginTop: 1,
              }}
            >
              Configure system-wide preferences
            </Text>
          </View>
        </View>
      </View>

      {loading ? (
        <InlineLoadingIndicator
          message="Loading settings..."
          isDarkMode={isDarkMode}
        />
      ) : (
        <ScrollView style={{ flex: 1 }} contentContainerStyle={{ padding: 20 }}>
          {/* Email Notifications Section */}
          <View style={{ marginBottom: 24 }}>
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: colors.adminMuted,
                textTransform: "uppercase",
                letterSpacing: 0.8,
                marginBottom: 12,
              }}
            >
              Email Notifications
            </Text>
            <View
              style={{
                backgroundColor: colors.adminCardBg,
                borderRadius: 14,
                borderWidth: 1,
                borderColor: colors.adminBorder,
                overflow: "hidden",
                ...(Platform.select({
                  web: { boxShadow: "0 2px 8px rgba(0,0,0,0.06)" },
                  default: {},
                }) as any),
              }}
            >
              {/* Scheduled Notifications Toggle */}
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingVertical: 18,
                  paddingHorizontal: 20,
                  borderBottomWidth: 1,
                  borderBottomColor: colors.adminBorder,
                }}
              >
                <View style={{ flex: 1, marginRight: 16 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginBottom: 6,
                    }}
                  >
                    <View
                      style={{
                        width: 32,
                        height: 32,
                        borderRadius: 8,
                        backgroundColor: "#8B5CF615",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: 10,
                      }}
                    >
                      <Icon name="schedule-send" size={18} color="#8B5CF6" />
                    </View>
                    <Text
                      style={{
                        fontSize: 15,
                        fontWeight: "600",
                        color: colors.sidebarTextActive,
                        fontFamily: fonts.semiBold,
                      }}
                    >
                      Scheduled Email Notifications
                    </Text>
                  </View>
                  <Text
                    style={{
                      fontSize: 13,
                      color: colors.adminMuted,
                      fontFamily: fonts.regular,
                      marginLeft: 42,
                    }}
                  >
                    Send automated email reports to superadmins when scheduled
                    scraping completes
                  </Text>
                </View>
                <Switch
                  value={scheduledEmailsEnabled}
                  onValueChange={setScheduledEmailsEnabled}
                  trackColor={{
                    false: colors.adminBorder,
                    true: "#8B5CF680",
                  }}
                  thumbColor={
                    scheduledEmailsEnabled
                      ? "#8B5CF6"
                      : isDarkMode
                      ? "#64748B"
                      : "#94A3B8"
                  }
                />
              </View>

              {/* Manual Notifications Toggle */}
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingVertical: 18,
                  paddingHorizontal: 20,
                }}
              >
                <View style={{ flex: 1, marginRight: 16 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginBottom: 6,
                    }}
                  >
                    <View
                      style={{
                        width: 32,
                        height: 32,
                        borderRadius: 8,
                        backgroundColor: "#10B98115",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: 10,
                      }}
                    >
                      <Icon
                        name="play-circle-outline"
                        size={18}
                        color="#10B981"
                      />
                    </View>
                    <Text
                      style={{
                        fontSize: 15,
                        fontWeight: "600",
                        color: colors.sidebarTextActive,
                        fontFamily: fonts.semiBold,
                      }}
                    >
                      Manual Email Notifications
                    </Text>
                  </View>
                  <Text
                    style={{
                      fontSize: 13,
                      color: colors.adminMuted,
                      fontFamily: fonts.regular,
                      marginLeft: 42,
                    }}
                  >
                    Send email reports to superadmins when manual scraping is
                    triggered
                  </Text>
                </View>
                <Switch
                  value={manualEmailsEnabled}
                  onValueChange={setManualEmailsEnabled}
                  trackColor={{
                    false: colors.adminBorder,
                    true: "#10B98180",
                  }}
                  thumbColor={
                    manualEmailsEnabled
                      ? "#10B981"
                      : isDarkMode
                      ? "#64748B"
                      : "#94A3B8"
                  }
                />
              </View>
            </View>
          </View>

          {/* Info Box */}
          <View
            style={{
              flexDirection: "row",
              padding: 16,
              backgroundColor: isDarkMode ? "#1E293B" : "#EFF6FF",
              borderRadius: 10,
              borderWidth: 1,
              borderColor: isDarkMode ? "#334155" : "#BFDBFE",
              marginBottom: 24,
            }}
          >
            <View
              style={{
                width: 32,
                height: 32,
                borderRadius: 8,
                backgroundColor: "#3B82F615",
                justifyContent: "center",
                alignItems: "center",
                marginRight: 12,
              }}
            >
              <Icon name="info" size={18} color="#3B82F6" />
            </View>
            <View style={{ flex: 1 }}>
              <Text
                style={{
                  fontSize: 13,
                  color: isDarkMode ? "#94A3B8" : "#1E40AF",
                  fontFamily: fonts.regular,
                  lineHeight: 20,
                }}
              >
                Control which email notifications superadmins receive after
                scraping operations complete. You can enable or disable
                notifications for scheduled and manual scraping independently.
              </Text>
            </View>
          </View>

          {/* Advertising Section (superadmin only) */}
          {isSuperAdmin && (
            <View style={{ marginBottom: 24 }}>
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.bold,
                  fontWeight: "700",
                  color: colors.adminMuted,
                  textTransform: "uppercase",
                  letterSpacing: 0.8,
                  marginBottom: 12,
                }}
              >
                Advertising
              </Text>
              <View
                style={{
                  backgroundColor: colors.adminCardBg,
                  borderRadius: 14,
                  borderWidth: 1,
                  borderColor: colors.adminBorder,
                  overflow: "hidden",
                  ...(Platform.select({
                    web: { boxShadow: "0 2px 8px rgba(0,0,0,0.06)" },
                    default: {},
                  }) as any),
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingVertical: 18,
                    paddingHorizontal: 20,
                  }}
                >
                  <View style={{ flex: 1, marginRight: 16 }}>
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        marginBottom: 6,
                      }}
                    >
                      <View
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: 8,
                          backgroundColor: "#F59E0B15",
                          justifyContent: "center",
                          alignItems: "center",
                          marginRight: 10,
                        }}
                      >
                        <Icon name="ads-click" size={18} color="#F59E0B" />
                      </View>
                      <Text
                        style={{
                          fontSize: 15,
                          fontWeight: "600",
                          color: colors.sidebarTextActive,
                          fontFamily: fonts.semiBold,
                        }}
                      >
                        Show Ads
                      </Text>
                    </View>
                    <Text
                      style={{
                        fontSize: 13,
                        color: colors.adminMuted,
                        fontFamily: fonts.regular,
                        marginLeft: 42,
                      }}
                    >
                      Show banner ads to job seekers across the app (job
                      feed, job details, companies). Turn off to hide ads
                      for everyone without a new release.
                    </Text>
                  </View>
                  <Switch
                    value={showAds}
                    onValueChange={setShowAds}
                    trackColor={{
                      false: colors.adminBorder,
                      true: "#F59E0B80",
                    }}
                    thumbColor={
                      showAds
                        ? "#F59E0B"
                        : isDarkMode
                        ? "#64748B"
                        : "#94A3B8"
                    }
                  />
                </View>
              </View>
            </View>
          )}

          {/* Save Button */}
          <TouchableOpacity
            onPress={saveSettings}
            disabled={saving}
            style={{
              backgroundColor: "#8B5CF6",
              paddingVertical: 12,
              paddingHorizontal: 24,
              borderRadius: 10,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              alignSelf: "flex-start",
              opacity: saving ? 0.6 : 1,
            }}
          >
            <Icon
              name="save"
              size={18}
              color="#FFFFFF"
              style={{ marginRight: 8 }}
            />
            <Text
              style={{
                fontSize: 14,
                fontWeight: "600",
                color: "#FFFFFF",
                fontFamily: fonts.semiBold,
              }}
            >
              {saving ? "Saving..." : "Save Settings"}
            </Text>
          </TouchableOpacity>
        </ScrollView>
      )}
    </View>
  );
}

// Company Verifications Content
const COMPANY_REJECTION_REASONS = [
  "Company logo is missing, unclear, or not valid",
  "Company name is not valid or does not match official records",
  "Company description is missing, too short, or not valid",
  "Location (city/address) is incorrect or incomplete",
  "Industry or company size does not match the company",
  "Contact email is invalid or not a company email",
  "Phone number is invalid or unreachable",
  "Website or social media links are broken or not related",
  "Founded year is invalid",
  "Registration documents are missing, unreadable, or expired",
  "Suspected duplicate of an existing company account",
  "Suspected fake, fraudulent, or scam company",
  "Inappropriate or offensive content",
];

function CompanyVerificationsContent({
  colors = lightColors,
  isDarkMode = false,
}: {
  colors?: any;
  isDarkMode?: boolean;
}) {
  const [companies, setCompanies] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedCompany, setSelectedCompany] = useState<any>(null);
  const [updating, setUpdating] = useState(false);
  const [filterStatus, setFilterStatus] = useState<string>("all"); // all, pending, approved, rejected
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState<"newest" | "oldest" | "name">("newest");
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [rejectTarget, setRejectTarget] = useState<any>(null);
  const [selectedReasons, setSelectedReasons] = useState<string[]>([]);
  const [rejectionNote, setRejectionNote] = useState("");
  const [previewDoc, setPreviewDoc] = useState<{
    label: string;
    url: string;
  } | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const companiesPerPage = 10;

  const isMobile = dimensions.width < 768;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  useEffect(() => {
    fetchCompanies();
  }, [filterStatus]);

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const usersRef = collection(db, "users");
      const q = dbQuery(usersRef, where("role", "==", "company"));
      const querySnapshot = await getDocs(q);

      console.log("📊 Total company documents found:", querySnapshot.size);

      let fetchedCompanies: any[] = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        console.log(
          "🏢 Company:",
          data.email,
          "Status:",
          data.companyProfile?.verificationStatus,
        );
        // Show all companies, apply filter if not 'all'
        if (
          filterStatus === "all" ||
          data.companyProfile?.verificationStatus === filterStatus
        ) {
          fetchedCompanies.push({
            id: doc.id,
            ...data,
          });
        }
      });

      console.log(
        "✅ Fetched companies after filter:",
        fetchedCompanies.length,
        "Filter:",
        filterStatus,
      );

      // Apply search filter
      if (searchQuery.trim()) {
        fetchedCompanies = fetchedCompanies.filter((company) => {
          const cp = company.companyProfile || {};
          const searchLower = searchQuery.toLowerCase();
          return (
            cp.companyName?.toLowerCase().includes(searchLower) ||
            cp.industry?.toLowerCase().includes(searchLower) ||
            company.email?.toLowerCase().includes(searchLower) ||
            cp.city?.toLowerCase().includes(searchLower)
          );
        });
      }

      // Apply sorting
      fetchedCompanies.sort((a, b) => {
        if (sortBy === "newest") {
          const dateA = a.companyProfile?.submittedAt?.seconds || 0;
          const dateB = b.companyProfile?.submittedAt?.seconds || 0;
          return dateB - dateA;
        } else if (sortBy === "oldest") {
          const dateA = a.companyProfile?.submittedAt?.seconds || 0;
          const dateB = b.companyProfile?.submittedAt?.seconds || 0;
          return dateA - dateB;
        } else {
          // name
          const nameA = (a.companyProfile?.companyName || "").toLowerCase();
          const nameB = (b.companyProfile?.companyName || "").toLowerCase();
          return nameA.localeCompare(nameB);
        }
      });

      setCompanies(fetchedCompanies);
    } catch (error) {
      console.error("Error fetching companies:", error);
      Alert.alert("Error", "Failed to load company verifications");
    } finally {
      setLoading(false);
    }
  };

  const handleVerificationUpdate = async (
    userId: string,
    newStatus: "approved" | "rejected",
    reasons: string[] = [],
    note: string = "",
  ) => {
    try {
      setUpdating(true);
      console.log("🔄 Starting verification update:", {
        userId,
        newStatus,
        reasons,
        note,
      });

      const userRef = doc(db, "users", userId);
      const company = companies.find((c) => c.id === userId);

      if (!company) {
        console.error("❌ Company not found:", userId);
        Alert.alert("Error", "Company not found");
        return;
      }

      console.log(
        "📋 Company found:",
        company.email,
        company.companyProfile?.companyName,
      );

      const updateData: any = {
        "companyProfile.verificationStatus": newStatus,
        "companyProfile.verifiedAt": new Date(),
        updatedAt: new Date(),
      };

      if (newStatus === "rejected") {
        updateData["companyProfile.rejectionReasons"] = reasons;
        updateData["companyProfile.rejectionNote"] = note;
        updateData["companyProfile.rejectionReason"] = [...reasons, note]
          .filter(Boolean)
          .join("; ");
      } else {
        updateData["companyProfile.rejectionReasons"] = [];
        updateData["companyProfile.rejectionNote"] = "";
        updateData["companyProfile.rejectionReason"] = "";
      }

      console.log("📝 Updating Firestore with:", updateData);
      await updateDoc(userRef, updateData);
      console.log("✅ Firestore updated successfully");

      // Send notification email
      try {
        console.log("📧 Sending email notification...");
        const notifyCompanyVerification = httpsCallable(
          functions,
          "notifyCompanyVerification",
        );
        const emailData = {
          userId,
          userEmail: company.email,
          userName: company.displayName || company.name || "User",
          companyName: company.companyProfile?.companyName || "Company",
          status: newStatus,
          reasons,
          reason: note,
        };
        console.log("📧 Email data:", emailData);

        const result = await notifyCompanyVerification(emailData);
        console.log("✅ Email sent successfully:", result);
        const msg = `Company ${newStatus} successfully! Email and push notification sent.`;
        if (Platform.OS === "web") window.alert(msg);
        else Alert.alert("Success", msg);
      } catch (emailError: any) {
        console.error("❌ Failed to send email notification:", emailError);
        console.error(
          "Error details:",
          emailError.message,
          emailError.code,
          emailError.details,
        );
        const msg = `Company ${newStatus} successfully, but email notification failed: ${
          emailError.message || "Unknown error"
        }`;
        if (Platform.OS === "web") window.alert(msg);
        else Alert.alert("Partial Success", msg);
      }

      // Refresh list
      closeRejectModal();
      console.log("🔄 Refreshing company list...");
      await fetchCompanies();
      setSelectedCompany(null);
      setShowDetailModal(false);
      console.log("✅ Verification update completed");
    } catch (error: any) {
      console.error("❌ Error updating verification status:", error);
      console.error("Error details:", error.message, error.code);
      const msg = `Failed to update verification status: ${
        error.message || "Unknown error"
      }`;
      if (Platform.OS === "web") window.alert(msg);
      else Alert.alert("Error", msg);
    } finally {
      setUpdating(false);
    }
  };

  const openRejectModal = (company: any) => {
    setSelectedReasons([]);
    setRejectionNote("");
    setRejectTarget(company);
  };

  const closeRejectModal = () => {
    setRejectTarget(null);
    setSelectedReasons([]);
    setRejectionNote("");
  };

  const toggleReason = (reason: string) => {
    setSelectedReasons((prev) =>
      prev.includes(reason)
        ? prev.filter((r) => r !== reason)
        : [...prev, reason],
    );
  };

  const canSubmitRejection =
    selectedReasons.length > 0 || rejectionNote.trim().length >= 10;

  const submitRejection = () => {
    if (!rejectTarget || !canSubmitRejection || updating) return;
    handleVerificationUpdate(
      rejectTarget.id,
      "rejected",
      selectedReasons,
      rejectionNote.trim(),
    );
  };

  // Every file the company submitted: logo, known document fields, plus any
  // other URL-valued fields (or arrays of them) found in the profile.
  const getSubmittedDocuments = (cp: any) => {
    if (!cp) return [] as { label: string; url: string }[];
    const docs: { label: string; url: string }[] = [];
    const seen = new Set<string>();
    const add = (label: string, url: any) => {
      if (typeof url !== "string" || !/^https?:\/\//i.test(url)) return;
      if (seen.has(url)) return;
      seen.add(url);
      docs.push({ label, url });
    };
    const skip = new Set(["website", "socialMedia"]);
    const prettify = (key: string) =>
      key
        .replace(/Url$|URL$/, "")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/^./, (c) => c.toUpperCase());
    add("Company Logo", cp.logoUrl);
    add("Registration Document", cp.registrationDocument);
    Object.keys(cp).forEach((key) => {
      if (skip.has(key)) return;
      const val = cp[key];
      if (typeof val === "string") add(prettify(key), val);
      else if (Array.isArray(val))
        val.forEach((item, i) => {
          if (typeof item === "string") add(`${prettify(key)} ${i + 1}`, item);
          else if (item && typeof item === "object")
            add(item.name || item.label || `${prettify(key)} ${i + 1}`, item.url);
        });
    });
    return docs;
  };

  const isImageUrl = (url: string) =>
    /\.(png|jpe?g|gif|webp|bmp|svg)(\?|$)/i.test(url) ||
    /companyLogos/i.test(url);

  const formatDate = (timestamp: any) => {
    if (!timestamp) return "N/A";
    try {
      return new Date(timestamp.seconds * 1000).toLocaleDateString();
    } catch {
      return "N/A";
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "approved":
        return colors.success;
      case "rejected":
        return colors.danger;
      case "pending":
        return colors.beeYellow;
      default:
        return colors.warmGray;
    }
  };

  const getStatusIcon = (status: string) => {
    switch (status) {
      case "approved":
        return "verified";
      case "rejected":
        return "cancel";
      case "pending":
        return "pending";
      default:
        return "help-outline";
    }
  };

  const pendingCount = companies.filter(
    (c) => c.companyProfile?.verificationStatus === "pending",
  ).length;
  const approvedCount = companies.filter(
    (c) => c.companyProfile?.verificationStatus === "approved",
  ).length;
  const rejectedCount = companies.filter(
    (c) => c.companyProfile?.verificationStatus === "rejected",
  ).length;

  // Re-fetch when search or sort changes
  useEffect(() => {
    fetchCompanies();
  }, [searchQuery, sortBy]);

  // Pagination
  const totalPages = Math.ceil(companies.length / companiesPerPage);
  const startIndex = (currentPage - 1) * companiesPerPage;
  const endIndex = startIndex + companiesPerPage;
  const currentCompanies = companies.slice(startIndex, endIndex);

  const goToPage = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <View
      style={{ flex: 1, backgroundColor: colors.adminPageBg }}
    >
      {/* ── Page Header ── */}
      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          justifyContent: "space-between",
          backgroundColor: colors.adminHeaderBg,
          paddingHorizontal: isMobile ? 16 : 28,
          paddingVertical: isMobile ? 14 : 18,
          gap: isMobile ? 12 : 0,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: isMobile ? 10 : 14,
          }}
        >
          <View
            style={{
              width: isMobile ? 36 : 40,
              height: isMobile ? 36 : 40,
              borderRadius: 11,
              backgroundColor: `${colors.sidebarAccent}22`,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon
              name="business"
              size={isMobile ? 20 : 22}
              color={colors.sidebarAccent}
            />
          </View>
          <View>
            <Text
              style={{
                fontSize: isMobile ? 16 : 18,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#F9FAFB",
                letterSpacing: -0.3,
              }}
            >
              Companies
            </Text>
            <Text
              style={{
                fontSize: isMobile ? 10 : 11,
                fontFamily: fonts.regular,
                color: "#64748B",
                marginTop: 1,
              }}
            >
              Manage company registrations &amp; verification
            </Text>
          </View>
        </View>
        <TouchableOpacity
          onPress={fetchCompanies}
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 6,
            backgroundColor: colors.sidebarAccent,
            paddingHorizontal: isMobile ? 12 : 14,
            paddingVertical: isMobile ? 7 : 8,
            borderRadius: 9,
            alignSelf: isMobile ? "flex-start" : "auto",
          }}
        >
          <Icon name="refresh" size={isMobile ? 14 : 15} color="#FFFFFF" />
          <Text
            style={{
              fontSize: isMobile ? 11 : 12,
              fontFamily: fonts.semiBold,
              fontWeight: "600",
              color: "#FFFFFF",
            }}
          >
            Refresh
          </Text>
        </TouchableOpacity>
      </View>

      <ScrollView
        style={{ flex: 1 }}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{ paddingBottom: 32 }}
      >
        {/* ── Stats Cards ── */}
        <View
          style={{
            flexDirection: isMobile ? "column" : "row",
            gap: 12,
            paddingHorizontal: isMobile ? 16 : 20,
            paddingTop: 16,
            paddingBottom: 12,
          }}
        >
          <TouchableOpacity
            onPress={() => {
              setFilterStatus("pending");
              setCurrentPage(1);
            }}
            style={{
              flex: 1,
              backgroundColor: colors.adminCardBg,
              borderRadius: 12,
              borderTopWidth: 3,
              borderTopColor: "#F59E0B",
              padding: 14,
              ...Platform.select({
                web: {
                  boxShadow:
                    filterStatus === "pending"
                      ? "0 0 0 2px #F59E0B"
                      : "0 2px 8px rgba(0,0,0,0.08)",
                },
                default: {},
              }),
            }}
          >
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.regular,
                color: colors.adminMuted,
                marginBottom: 6,
              }}
            >
              Pending
            </Text>
            <Text
              style={{
                fontSize: 24,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#F59E0B",
              }}
            >
              {pendingCount}
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => {
              setFilterStatus("approved");
              setCurrentPage(1);
            }}
            style={{
              flex: 1,
              backgroundColor: colors.adminCardBg,
              borderRadius: 12,
              borderTopWidth: 3,
              borderTopColor: "#10B981",
              padding: 14,
              ...Platform.select({
                web: {
                  boxShadow:
                    filterStatus === "approved"
                      ? "0 0 0 2px #10B981"
                      : "0 2px 8px rgba(0,0,0,0.08)",
                },
                default: {},
              }),
            }}
          >
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.regular,
                color: colors.adminMuted,
                marginBottom: 6,
              }}
            >
              Approved
            </Text>
            <Text
              style={{
                fontSize: 24,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#10B981",
              }}
            >
              {approvedCount}
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => {
              setFilterStatus("rejected");
              setCurrentPage(1);
            }}
            style={{
              flex: 1,
              backgroundColor: colors.adminCardBg,
              borderRadius: 12,
              borderTopWidth: 3,
              borderTopColor: "#EF4444",
              padding: 14,
              ...Platform.select({
                web: {
                  boxShadow:
                    filterStatus === "rejected"
                      ? "0 0 0 2px #EF4444"
                      : "0 2px 8px rgba(0,0,0,0.08)",
                },
                default: {},
              }),
            }}
          >
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.regular,
                color: colors.adminMuted,
                marginBottom: 6,
              }}
            >
              Rejected
            </Text>
            <Text
              style={{
                fontSize: 24,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#EF4444",
              }}
            >
              {rejectedCount}
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            onPress={() => {
              setFilterStatus("all");
              setCurrentPage(1);
            }}
            style={{
              flex: 1,
              backgroundColor: colors.adminCardBg,
              borderRadius: 12,
              borderTopWidth: 3,
              borderTopColor: "#6366F1",
              padding: 14,
              ...Platform.select({
                web: {
                  boxShadow:
                    filterStatus === "all"
                      ? "0 0 0 2px #6366F1"
                      : "0 2px 8px rgba(0,0,0,0.08)",
                },
                default: {},
              }),
            }}
          >
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.regular,
                color: colors.adminMuted,
                marginBottom: 6,
              }}
            >
              Total
            </Text>
            <Text
              style={{
                fontSize: 24,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#6366F1",
              }}
            >
              {pendingCount + approvedCount + rejectedCount}
            </Text>
          </TouchableOpacity>
        </View>

        {/* Search and Sort */}
        <View
          style={{
            flexDirection: isMobile ? "column" : "row",
            gap: 10,
            paddingHorizontal: isMobile ? 16 : 20,
            paddingBottom: 14,
          }}
        >
          <View style={{ flex: 1, position: "relative" }}>
            <TextInput
              style={{
                backgroundColor: colors.adminCardBg,
                borderWidth: 1,
                borderColor: colors.adminBorder,
                borderRadius: 10,
                paddingLeft: 42,
                paddingRight: 16,
                paddingVertical: isMobile ? 9 : 10,
                fontSize: isMobile ? 13 : 14,
                fontFamily: fonts.regular,
                color: colors.sidebarTextActive,
              }}
              placeholder={
                isMobile
                  ? "Search companies…"
                  : "Search companies by name, industry, or location..."
              }
              placeholderTextColor={colors.adminMuted}
              value={searchQuery}
              onChangeText={(text) => {
                setSearchQuery(text);
                setCurrentPage(1);
              }}
            />
            <Icon
              name="search"
              size={16}
              color={colors.adminMuted}
              style={{
                position: "absolute",
                left: 14,
                top: isMobile ? 11 : 12,
              }}
            />
          </View>
          <View
            style={{
              backgroundColor: colors.adminCardBg,
              borderRadius: 10,
              borderWidth: 1,
              borderColor: colors.adminBorder,
              alignSelf: isMobile ? "stretch" : "auto",
            }}
          >
            <select
              value={sortBy}
              onChange={(e: any) => {
                setSortBy(e.target.value);
                setCurrentPage(1);
              }}
              style={{
                padding: isMobile ? "9px 14px" : "10px 14px",
                borderRadius: "10px",
                border: "none",
                backgroundColor: colors.adminCardBg,
                color: colors.sidebarTextActive,
                fontSize: "13px",
                cursor: "pointer",
                outline: "none",
                minWidth: isMobile ? "100%" : "140px",
                width: isMobile ? "100%" : undefined,
              }}
            >
              <option value="newest">Newest First</option>
              <option value="oldest">Oldest First</option>
              <option value="name">By Name (A-Z)</option>
            </select>
          </View>
        </View>

        {loading ? (
          <InlineLoadingIndicator
            message="Loading companies..."
            isDarkMode={isDarkMode}
          />
        ) : companies.length === 0 ? (
          <View style={{ alignItems: "center", paddingVertical: 48 }}>
            <Icon
              name="business-center"
              size={64}
              color={colors.adminMuted}
            />
            <Text
              style={{
                fontSize: 18,
                fontFamily: fonts.semiBold,
                color: colors.adminMuted,
                marginTop: 16,
              }}
            >
              {filterStatus === "all"
                ? "No companies yet"
                : `No ${filterStatus} companies`}
            </Text>
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.regular,
                color: colors.adminMuted,
                marginTop: 8,
                textAlign: "center",
              }}
            >
              {searchQuery
                ? "Try adjusting your search criteria"
                : "Companies will appear here when they register"}
            </Text>
          </View>
        ) : (
          <View
            style={{ paddingHorizontal: isMobile ? 12 : 20, paddingBottom: 24 }}
          >
            {isMobile ? (
              /* ── Mobile: card list ── */
              <View style={{ gap: 10 }}>
                {currentCompanies.length === 0 ? (
                  <View style={{ alignItems: "center", paddingVertical: 40 }}>
                    <Icon
                      name="business-center"
                      size={48}
                      color={colors.adminMuted}
                    />
                    <Text
                      style={{
                        marginTop: 12,
                        fontSize: 14,
                        fontFamily: fonts.regular,
                        color: colors.adminMuted,
                      }}
                    >
                      No companies found
                    </Text>
                  </View>
                ) : (
                  currentCompanies.map((company) => {
                    const cp = company.companyProfile || {};
                    const status = cp.verificationStatus || "pending";
                    const statusColor =
                      status === "approved"
                        ? "#10B981"
                        : status === "rejected"
                        ? "#EF4444"
                        : "#F59E0B";
                    const statusBg =
                      status === "approved"
                        ? "#D1FAE5"
                        : status === "rejected"
                        ? "#FEE2E2"
                        : "#FEF3C7";
                    const statusTextColor =
                      status === "approved"
                        ? "#047857"
                        : status === "rejected"
                        ? "#DC2626"
                        : "#D97706";
                    return (
                      <TouchableOpacity
                        key={company.id}
                        onPress={() => {
                          setSelectedCompany(company);
                          setShowDetailModal(true);
                        }}
                        activeOpacity={0.85}
                        style={{
                          backgroundColor: colors.adminCardBg,
                          borderRadius: 14,
                          borderLeftWidth: 4,
                          borderLeftColor: statusColor,
                          overflow: "hidden",
                          ...Platform.select({
                            web: {
                              boxShadow: isDarkMode
                                ? "0 2px 8px rgba(0,0,0,0.2)"
                                : "0 2px 8px rgba(0,0,0,0.07)",
                            },
                            default: {
                              shadowColor: "#000",
                              shadowOffset: { width: 0, height: 2 },
                              shadowOpacity: 0.07,
                              shadowRadius: 6,
                              elevation: 2,
                            },
                          }),
                        }}
                      >
                        {/* Top row: logo + name + status */}
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            padding: 14,
                            gap: 12,
                          }}
                        >
                          {cp.logoUrl ? (
                            <Image
                              source={{ uri: cp.logoUrl }}
                              style={{
                                width: 44,
                                height: 44,
                                borderRadius: 10,
                                flexShrink: 0,
                              }}
                            />
                          ) : (
                            <View
                              style={{
                                width: 44,
                                height: 44,
                                borderRadius: 10,
                                backgroundColor: isDarkMode
                                  ? "#1E293B"
                                  : "#F1F5F9",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                              }}
                            >
                              <Icon
                                name="business"
                                size={20}
                                color={colors.adminMuted}
                              />
                            </View>
                          )}
                          <View style={{ flex: 1, minWidth: 0 }}>
                            <Text
                              numberOfLines={1}
                              style={{
                                fontSize: 14,
                                fontFamily: fonts.semiBold,
                                fontWeight: "600",
                                color: colors.sidebarTextActive,
                                marginBottom: 2,
                              }}
                            >
                              {cp.companyName || "Unnamed Company"}
                            </Text>
                            <Text
                              numberOfLines={1}
                              style={{
                                fontSize: 11,
                                color: colors.adminMuted,
                              }}
                            >
                              {[cp.industry, cp.city]
                                .filter(Boolean)
                                .join(" · ") || "No details"}
                            </Text>
                          </View>
                          <View
                            style={{
                              paddingHorizontal: 9,
                              paddingVertical: 3,
                              borderRadius: 20,
                              backgroundColor: statusBg,
                              flexShrink: 0,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 10,
                                fontFamily: fonts.bold,
                                fontWeight: "700",
                                color: statusTextColor,
                                textTransform: "capitalize",
                              }}
                            >
                              {status}
                            </Text>
                          </View>
                        </View>

                        {/* Info row */}
                        <View
                          style={{
                            flexDirection: "row",
                            paddingHorizontal: 14,
                            paddingBottom: 12,
                            gap: 8,
                          }}
                        >
                          {[
                            { icon: "people", label: cp.size || "N/A" },
                            {
                              icon: "calendar-today",
                              label: formatDate(cp.submittedAt),
                            },
                            { icon: "location-on", label: cp.country || "N/A" },
                          ].map((item) => (
                            <View
                              key={item.icon}
                              style={{
                                flex: 1,
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 4,
                                backgroundColor: isDarkMode
                                  ? "#1E293B"
                                  : "#F8FAFC",
                                borderRadius: 8,
                                paddingVertical: 6,
                                paddingHorizontal: 8,
                              }}
                            >
                              <Icon
                                name={item.icon as any}
                                size={11}
                                color={colors.adminMuted}
                              />
                              <Text
                                numberOfLines={1}
                                style={{
                                  fontSize: 10,
                                  color: colors.adminMuted,
                                  flex: 1,
                                }}
                              >
                                {item.label}
                              </Text>
                            </View>
                          ))}
                        </View>

                        {/* Action buttons for pending */}
                        {status === "pending" && (
                          <View
                            style={{
                              flexDirection: "row",
                              gap: 8,
                              paddingHorizontal: 14,
                              paddingBottom: 14,
                            }}
                          >
                            <TouchableOpacity
                              onPress={(e) => {
                                e.stopPropagation();
                                const msg = `Approve ${cp.companyName}?`;
                                if (Platform.OS === "web") {
                                  if (window.confirm(msg)) {
                                    setUpdating(company.id);
                                    handleVerificationUpdate(
                                      company.id,
                                      "approved",
                                    );
                                  }
                                } else {
                                  Alert.alert("Approve Company", msg, [
                                    { text: "Cancel", style: "cancel" },
                                    {
                                      text: "Approve",
                                      onPress: () => {
                                        setUpdating(company.id);
                                        handleVerificationUpdate(
                                          company.id,
                                          "approved",
                                        );
                                      },
                                    },
                                  ]);
                                }
                              }}
                              style={{
                                flex: 1,
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 6,
                                backgroundColor: "#10B981",
                                paddingVertical: 10,
                                borderRadius: 9,
                              }}
                            >
                              <Icon
                                name="check-circle"
                                size={15}
                                color="#FFFFFF"
                              />
                              <Text
                                style={{
                                  fontSize: 12,
                                  fontFamily: fonts.semiBold,
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Approve
                              </Text>
                            </TouchableOpacity>
                            <TouchableOpacity
                              onPress={(e) => {
                                e.stopPropagation();
                                openRejectModal(company);
                              }}
                              style={{
                                flex: 1,
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 6,
                                backgroundColor: "#EF4444",
                                paddingVertical: 10,
                                borderRadius: 9,
                              }}
                            >
                              <Icon name="cancel" size={15} color="#FFFFFF" />
                              <Text
                                style={{
                                  fontSize: 12,
                                  fontFamily: fonts.semiBold,
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Reject
                              </Text>
                            </TouchableOpacity>
                          </View>
                        )}
                      </TouchableOpacity>
                    );
                  })
                )}
              </View>
            ) : (
              /* ── Desktop: table ── */
              <View
                style={{
                  borderRadius: 14,
                  overflow: "hidden",
                  backgroundColor: colors.adminCardBg,
                  ...Platform.select({
                    web: { boxShadow: "0 2px 12px rgba(0,0,0,0.1)" },
                    default: {
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 2 },
                      shadowOpacity: 0.08,
                      shadowRadius: 8,
                      elevation: 3,
                    },
                  }),
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    backgroundColor: "#1E293B",
                    paddingVertical: 11,
                    paddingHorizontal: 14,
                  }}
                >
                  <Text
                    style={{
                      flex: 0.8,
                      fontSize: 11,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: "#94A3B8",
                      textTransform: "uppercase",
                      letterSpacing: 0.6,
                    }}
                  >
                    Logo
                  </Text>
                  <Text
                    style={{
                      flex: 2,
                      fontSize: 11,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: "#94A3B8",
                      textTransform: "uppercase",
                      letterSpacing: 0.6,
                    }}
                  >
                    Company
                  </Text>
                  <Text
                    style={{
                      flex: 1.5,
                      fontSize: 11,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: "#94A3B8",
                      textTransform: "uppercase",
                      letterSpacing: 0.6,
                    }}
                  >
                    Industry
                  </Text>
                  <Text
                    style={{
                      flex: 1.2,
                      fontSize: 11,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: "#94A3B8",
                      textTransform: "uppercase",
                      letterSpacing: 0.6,
                    }}
                  >
                    Location
                  </Text>
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 11,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: "#94A3B8",
                      textTransform: "uppercase",
                      letterSpacing: 0.6,
                    }}
                  >
                    Size
                  </Text>
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 11,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: "#94A3B8",
                      textTransform: "uppercase",
                      letterSpacing: 0.6,
                    }}
                  >
                    Status
                  </Text>
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 11,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: "#94A3B8",
                      textTransform: "uppercase",
                      letterSpacing: 0.6,
                    }}
                  >
                    Submitted
                  </Text>
                  <Text
                    style={{
                      flex: 1.5,
                      fontSize: 11,
                      fontFamily: fonts.bold,
                      fontWeight: "700",
                      color: "#94A3B8",
                      textTransform: "uppercase",
                      letterSpacing: 0.6,
                    }}
                  >
                    Actions
                  </Text>
                </View>

                <ScrollView style={{ maxHeight: 520 }}>
                  {currentCompanies.length === 0 ? (
                    <View style={{ alignItems: "center", paddingVertical: 40 }}>
                      <Icon
                        name="business-center"
                        size={48}
                        color={colors.adminMuted}
                      />
                      <Text
                        style={{
                          marginTop: 12,
                          fontSize: 14,
                          fontFamily: fonts.regular,
                          color: colors.adminMuted,
                        }}
                      >
                        No companies found
                      </Text>
                    </View>
                  ) : (
                    currentCompanies.map((company, cIdx) => {
                      const cp = company.companyProfile || {};
                      const status = cp.verificationStatus || "pending";

                      return (
                        <TouchableOpacity
                          key={company.id}
                          style={[
                            {
                              flexDirection: "row",
                              alignItems: "center",
                              paddingVertical: 11,
                              paddingHorizontal: 14,
                              borderBottomWidth: 1,
                              borderBottomColor: isDarkMode
                                ? "#1E293B"
                                : "#F1F5F9",
                              cursor: "pointer",
                            },
                            cIdx % 2 !== 0 && {
                              backgroundColor: isDarkMode
                                ? "#111827"
                                : "#F9FAFB",
                            },
                            cIdx % 2 === 0 && {
                              backgroundColor: isDarkMode
                                ? "#161F2E"
                                : "#FFFFFF",
                            },
                          ]}
                          onPress={() => {
                            setSelectedCompany(company);
                            setShowDetailModal(true);
                          }}
                        >
                          <View style={{ flex: 0.8 }}>
                            {cp.logoUrl ? (
                              <Image
                                source={{ uri: cp.logoUrl }}
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: 8,
                                  backgroundColor: isDarkMode
                                    ? "#1E293B"
                                    : "#F1F5F9",
                                }}
                              />
                            ) : (
                              <View
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: 8,
                                  backgroundColor: isDarkMode
                                    ? "#1E293B"
                                    : "#F1F5F9",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Icon
                                  name="business"
                                  size={18}
                                  color={colors.adminMuted}
                                />
                              </View>
                            )}
                          </View>
                          <Text
                            style={{
                              flex: 2,
                              fontSize: 13,
                              fontFamily: fonts.semiBold,
                              fontWeight: "600",
                              color: colors.sidebarTextActive,
                              paddingRight: 8,
                            }}
                            numberOfLines={1}
                          >
                            {cp.companyName || "Unnamed Company"}
                          </Text>
                          <Text
                            style={{
                              flex: 1.5,
                              fontSize: 12,
                              fontFamily: fonts.regular,
                              color: colors.sidebarText,
                              paddingRight: 8,
                            }}
                            numberOfLines={1}
                          >
                            {cp.industry || "N/A"}
                          </Text>
                          <Text
                            style={{
                              flex: 1.2,
                              fontSize: 12,
                              fontFamily: fonts.regular,
                              color: colors.sidebarText,
                              paddingRight: 8,
                            }}
                            numberOfLines={1}
                          >
                            {cp.city || "N/A"}
                          </Text>
                          <Text
                            style={{
                              flex: 1,
                              fontSize: 12,
                              fontFamily: fonts.regular,
                              color: colors.sidebarText,
                              paddingRight: 8,
                            }}
                            numberOfLines={1}
                          >
                            {cp.size || "N/A"}
                          </Text>
                          <View style={{ flex: 1 }}>
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 4,
                                backgroundColor:
                                  status === "pending"
                                    ? "#FEF3C7"
                                    : status === "approved"
                                    ? "#D1FAE5"
                                    : "#FEE2E2",
                                paddingHorizontal: 8,
                                paddingVertical: 3,
                                borderRadius: 20,
                                alignSelf: "flex-start",
                              }}
                            >
                              <Icon
                                name={getStatusIcon(status)}
                                size={12}
                                color={
                                  status === "pending"
                                    ? "#D97706"
                                    : status === "approved"
                                    ? "#047857"
                                    : "#DC2626"
                                }
                              />
                              <Text
                                style={{
                                  fontSize: 11,
                                  fontFamily: fonts.medium,
                                  color:
                                    status === "pending"
                                      ? "#D97706"
                                      : status === "approved"
                                      ? "#047857"
                                      : "#DC2626",
                                  textTransform: "capitalize",
                                }}
                              >
                                {status}
                              </Text>
                            </View>
                          </View>
                          <Text
                            style={{
                              flex: 1,
                              fontSize: 11,
                              fontFamily: fonts.regular,
                              color: colors.adminMuted,
                              paddingRight: 8,
                            }}
                            numberOfLines={1}
                          >
                            {formatDate(cp.submittedAt)}
                          </Text>
                          <View
                            style={{
                              flex: 1.5,
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            {updating === company.id ? (
                              <ActivityIndicator
                                size="small"
                                color={colors.beeYellow}
                              />
                            ) : status === "pending" ? (
                              <>
                                <TouchableOpacity
                                  style={{
                                    backgroundColor: "#10B981",
                                    paddingHorizontal: 10,
                                    paddingVertical: 6,
                                    borderRadius: 6,
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                  onPress={(e) => {
                                    e.stopPropagation();
                                    const message = `Approve ${cp.companyName}?`;
                                    if (Platform.OS === "web") {
                                      if (window.confirm(message)) {
                                        setUpdating(company.id);
                                        handleVerificationUpdate(
                                          company.id,
                                          "approved",
                                        );
                                      }
                                    } else {
                                      Alert.alert("Approve Company", message, [
                                        { text: "Cancel", style: "cancel" },
                                        {
                                          text: "Approve",
                                          onPress: () => {
                                            setUpdating(company.id);
                                            handleVerificationUpdate(
                                              company.id,
                                              "approved",
                                            );
                                          },
                                        },
                                      ]);
                                    }
                                  }}
                                >
                                  <Icon
                                    name="check"
                                    size={14}
                                    color={colors.white}
                                  />
                                </TouchableOpacity>
                                <TouchableOpacity
                                  style={{
                                    backgroundColor: "#EF4444",
                                    paddingHorizontal: 10,
                                    paddingVertical: 6,
                                    borderRadius: 6,
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                  onPress={(e) => {
                                    e.stopPropagation();
                                    openRejectModal(company);
                                  }}
                                >
                                  <Icon
                                    name="close"
                                    size={14}
                                    color={colors.white}
                                  />
                                </TouchableOpacity>
                              </>
                            ) : (
                              <TouchableOpacity
                                style={{
                                  backgroundColor: colors.cream,
                                  paddingHorizontal: 10,
                                  paddingVertical: 6,
                                  borderRadius: 6,
                                  borderWidth: 1,
                                  borderColor: colors.lightGray,
                                }}
                                onPress={(e) => {
                                  e.stopPropagation();
                                  setSelectedCompany(company);
                                  setShowDetailModal(true);
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 11,
                                    fontFamily: fonts.medium,
                                    color: "#6366F1",
                                  }}
                                >
                                  View
                                </Text>
                              </TouchableOpacity>
                            )}
                          </View>
                        </TouchableOpacity>
                      );
                    })
                  )}
                </ScrollView>
              </View>
            )}

            {/* ── Pagination ── */}
            {totalPages > 1 && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingHorizontal: 16,
                  paddingVertical: 12,
                  marginTop: 10,
                  backgroundColor: colors.adminCardBg,
                  borderRadius: 12,
                  ...Platform.select({
                    web: { boxShadow: "0 2px 8px rgba(0,0,0,0.06)" },
                    default: {},
                  }),
                }}
              >
                <Text
                  style={{
                    fontSize: isMobile ? 11 : 12,
                    fontFamily: fonts.regular,
                    color: colors.adminMuted,
                  }}
                >
                  {isMobile
                    ? `${currentPage}/${totalPages}`
                    : `Page ${currentPage} of ${totalPages}`}
                </Text>
                <View style={{ flexDirection: "row", gap: 6 }}>
                  <TouchableOpacity
                    style={{
                      paddingHorizontal: 12,
                      paddingVertical: 6,
                      borderRadius: 8,
                      backgroundColor:
                        currentPage === 1
                          ? isDarkMode
                            ? "#1E293B"
                            : "#F1F5F9"
                          : "#F59E0B",
                      opacity: currentPage === 1 ? 0.4 : 1,
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 4,
                    }}
                    onPress={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <Icon
                      name="chevron-left"
                      size={16}
                      color={currentPage === 1 ? "#64748B" : "#1E293B"}
                    />
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.medium,
                        color: currentPage === 1 ? "#64748B" : "#1E293B",
                      }}
                    >
                      Prev
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={{
                      paddingHorizontal: 12,
                      paddingVertical: 6,
                      borderRadius: 8,
                      backgroundColor:
                        currentPage === totalPages
                          ? isDarkMode
                            ? "#1E293B"
                            : "#F1F5F9"
                          : "#F59E0B",
                      opacity: currentPage === totalPages ? 0.4 : 1,
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 4,
                    }}
                    onPress={() => goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.medium,
                        color:
                          currentPage === totalPages ? "#64748B" : "#1E293B",
                      }}
                    >
                      Next
                    </Text>
                    <Icon
                      name="chevron-right"
                      size={16}
                      color={currentPage === totalPages ? "#64748B" : "#1E293B"}
                    />
                  </TouchableOpacity>
                </View>
              </View>
            )}
          </View>
        )}
      </ScrollView>

      {/* Company Detail Modal */}
      {showDetailModal && selectedCompany && (
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            zIndex: 1000,
            alignItems: isMobile ? "stretch" : "center",
            justifyContent: isMobile ? "flex-end" : "center",
            padding: isMobile ? 0 : 20,
          }}
        >
          <TouchableOpacity
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            }}
            activeOpacity={1}
            onPress={() => {
              setShowDetailModal(false);
              setSelectedCompany(null);
            }}
          />
          <View
            style={{
              backgroundColor: colors.adminCardBg,
              borderRadius: isMobile ? 0 : 20,
              borderTopLeftRadius: isMobile ? 20 : 20,
              borderTopRightRadius: isMobile ? 20 : 20,
              maxWidth: isMobile ? undefined : 900,
              width: isMobile ? "100%" : "100%",
              maxHeight: isMobile ? "92%" : "90%",
              overflow: "hidden",
              ...Platform.select({
                web: { boxShadow: "0 20px 60px rgba(0,0,0,0.3)" },
                default: {
                  shadowColor: "#000",
                  shadowOffset: { width: 0, height: -4 },
                  shadowOpacity: 0.15,
                  shadowRadius: 12,
                  elevation: 20,
                },
              }),
            }}
          >
            {isMobile && (
              <View
                style={{
                  alignItems: "center",
                  paddingTop: 10,
                  paddingBottom: 4,
                }}
              >
                <View
                  style={{
                    width: 40,
                    height: 4,
                    borderRadius: 2,
                    backgroundColor: colors.adminBorder,
                  }}
                />
              </View>
            )}
            {/* Modal Header */}
            <View style={{ backgroundColor: "#1E293B", padding: 20 }}>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 14,
                  }}
                >
                  {selectedCompany.companyProfile?.logoUrl ? (
                    <Image
                      source={{ uri: selectedCompany.companyProfile.logoUrl }}
                      style={{
                        width: 52,
                        height: 52,
                        borderRadius: 12,
                        backgroundColor: "#FFFFFF18",
                      }}
                    />
                  ) : (
                    <View
                      style={{
                        width: 52,
                        height: 52,
                        borderRadius: 12,
                        backgroundColor: "#F59E0B22",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Icon name="business" size={26} color="#F59E0B" />
                    </View>
                  )}
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 18,
                        fontFamily: fonts.bold,
                        fontWeight: "700",
                        color: "#F9FAFB",
                        marginBottom: 3,
                      }}
                    >
                      {selectedCompany.companyProfile?.companyName ||
                        "Unnamed Company"}
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.regular,
                        color: "#94A3B8",
                      }}
                    >
                      {selectedCompany.companyProfile?.industry ||
                        "No industry"}{" "}
                      · {selectedCompany.companyProfile?.size || "N/A"}
                    </Text>
                  </View>
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <View
                    style={{
                      paddingHorizontal: 10,
                      paddingVertical: 4,
                      borderRadius: 20,
                      backgroundColor:
                        selectedCompany.companyProfile?.verificationStatus ===
                        "approved"
                          ? "#D1FAE5"
                          : selectedCompany.companyProfile
                              ?.verificationStatus === "rejected"
                          ? "#FEE2E2"
                          : "#FEF3C7",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: fonts.bold,
                        fontWeight: "700",
                        color:
                          selectedCompany.companyProfile?.verificationStatus ===
                          "approved"
                            ? "#047857"
                            : selectedCompany.companyProfile
                                ?.verificationStatus === "rejected"
                            ? "#DC2626"
                            : "#D97706",
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      {selectedCompany.companyProfile?.verificationStatus ||
                        "pending"}
                    </Text>
                  </View>
                  <TouchableOpacity
                    onPress={() => {
                      setShowDetailModal(false);
                      setSelectedCompany(null);
                    }}
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: 8,
                      backgroundColor: "#FFFFFF18",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Icon name="close" size={18} color="#94A3B8" />
                  </TouchableOpacity>
                </View>
              </View>
            </View>

            {/* Modal Content */}
            <ScrollView
              style={{ flex: 1, padding: isMobile ? 16 : 24 }}
              contentContainerStyle={{ paddingBottom: 24 }}
            >
              {/* Submitted Documents */}
              {(() => {
                const docs = getSubmittedDocuments(
                  selectedCompany.companyProfile,
                );
                return (
                  <View style={{ marginBottom: 24 }}>
                    <Text
                      style={{
                        fontSize: 16,
                        fontFamily: fonts.semibold,
                        color: colors.deepNavy,
                        marginBottom: 12,
                      }}
                    >
                      Submitted Documents ({docs.length})
                    </Text>
                    {docs.length === 0 ? (
                      <Text
                        style={{
                          fontSize: 13,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                        }}
                      >
                        No documents were submitted.
                      </Text>
                    ) : (
                      <View
                        style={{ flexDirection: "row", flexWrap: "wrap", gap: 12 }}
                      >
                        {docs.map((d) => (
                          <TouchableOpacity
                            key={d.url}
                            onPress={() => setPreviewDoc(d)}
                            style={{
                              width: isMobile ? "47%" : 180,
                              backgroundColor: colors.lightGray,
                              borderRadius: 12,
                              borderWidth: 1,
                              borderColor: colors.adminBorder,
                              overflow: "hidden",
                            }}
                          >
                            {isImageUrl(d.url) ? (
                              <Image
                                source={{ uri: d.url }}
                                resizeMode="contain"
                                style={{
                                  width: "100%",
                                  height: 120,
                                  backgroundColor: "#FFFFFF",
                                }}
                              />
                            ) : (
                              <View
                                style={{
                                  height: 120,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <Icon
                                  name="description"
                                  size={44}
                                  color={colors.softBlue}
                                />
                              </View>
                            )}
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 6,
                                padding: 10,
                              }}
                            >
                              <Text
                                numberOfLines={1}
                                style={{
                                  flex: 1,
                                  fontSize: 12,
                                  fontFamily: fonts.medium,
                                  color: colors.deepNavy,
                                }}
                              >
                                {d.label}
                              </Text>
                              <Icon
                                name="zoom-out-map"
                                size={16}
                                color={colors.warmGray}
                              />
                            </View>
                          </TouchableOpacity>
                        ))}
                      </View>
                    )}
                  </View>
                );
              })()}

              {/* Company Description */}
              {selectedCompany.companyProfile?.description && (
                <View style={{ marginBottom: 24 }}>
                  <Text
                    style={{
                      fontSize: 16,
                      fontFamily: fonts.semibold,
                      color: colors.deepNavy,
                      marginBottom: 8,
                    }}
                  >
                    About the Company
                  </Text>
                  <Text
                    style={{
                      fontSize: 14,
                      color: colors.warmGray,
                      fontFamily: fonts.regular,
                      lineHeight: 22,
                    }}
                  >
                    {selectedCompany.companyProfile.description}
                  </Text>
                </View>
              )}

              {/* Contact Information */}
              <View style={{ marginBottom: 24 }}>
                <Text
                  style={{
                    fontSize: 16,
                    fontFamily: fonts.semibold,
                    color: colors.deepNavy,
                    marginBottom: 12,
                  }}
                >
                  Contact Information
                </Text>
                <View
                  style={{
                    backgroundColor: colors.lightGray,
                    padding: 16,
                    borderRadius: 12,
                    gap: 12,
                  }}
                >
                  <View
                    style={{ flexDirection: "row", flexWrap: "wrap", gap: 16 }}
                  >
                    <View style={{ flex: 1, minWidth: 200 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                          marginBottom: 4,
                        }}
                      >
                        Email
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.deepNavy,
                          fontFamily: fonts.medium,
                        }}
                      >
                        {selectedCompany.email ||
                          selectedCompany.companyProfile?.email ||
                          "N/A"}
                      </Text>
                    </View>
                    <View style={{ flex: 1, minWidth: 200 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                          marginBottom: 4,
                        }}
                      >
                        Phone
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.deepNavy,
                          fontFamily: fonts.medium,
                        }}
                      >
                        {selectedCompany.companyProfile?.phone || "N/A"}
                      </Text>
                    </View>
                  </View>
                  {selectedCompany.companyProfile?.website && (
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                          marginBottom: 4,
                        }}
                      >
                        Website
                      </Text>
                      <TouchableOpacity
                        onPress={() =>
                          selectedCompany.companyProfile?.website &&
                          Linking.openURL(
                            selectedCompany.companyProfile.website,
                          )
                        }
                      >
                        <Text
                          style={{
                            fontSize: 14,
                            color: colors.softBlue,
                            fontFamily: fonts.medium,
                            textDecorationLine: "underline",
                          }}
                        >
                          {selectedCompany.companyProfile.website}
                        </Text>
                      </TouchableOpacity>
                    </View>
                  )}
                  {Object.entries(
                    selectedCompany.companyProfile?.socialMedia || {},
                  )
                    .filter(([, url]) => typeof url === "string" && url)
                    .map(([network, url]: any) => (
                      <View key={network} style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            color: colors.warmGray,
                            fontFamily: fonts.regular,
                            marginBottom: 4,
                            textTransform: "capitalize",
                          }}
                        >
                          {network}
                        </Text>
                        <TouchableOpacity onPress={() => Linking.openURL(url)}>
                          <Text
                            style={{
                              fontSize: 14,
                              color: colors.softBlue,
                              fontFamily: fonts.medium,
                              textDecorationLine: "underline",
                            }}
                          >
                            {url}
                          </Text>
                        </TouchableOpacity>
                      </View>
                    ))}
                </View>
              </View>

              {/* Company Details */}
              <View style={{ marginBottom: 24 }}>
                <Text
                  style={{
                    fontSize: 16,
                    fontFamily: fonts.semibold,
                    color: colors.deepNavy,
                    marginBottom: 12,
                  }}
                >
                  Company Details
                </Text>
                <View
                  style={{
                    backgroundColor: colors.lightGray,
                    padding: 16,
                    borderRadius: 12,
                    gap: 12,
                  }}
                >
                  <View
                    style={{ flexDirection: "row", flexWrap: "wrap", gap: 16 }}
                  >
                    <View style={{ flex: 1, minWidth: 200 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                          marginBottom: 4,
                        }}
                      >
                        Location
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.deepNavy,
                          fontFamily: fonts.medium,
                        }}
                      >
                        {[
                          selectedCompany.companyProfile?.address,
                          selectedCompany.companyProfile?.city,
                          selectedCompany.companyProfile?.country,
                        ]
                          .filter(Boolean)
                          .join(", ") || "N/A"}
                      </Text>
                    </View>
                    <View style={{ flex: 1, minWidth: 200 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                          marginBottom: 4,
                        }}
                      >
                        Company Size
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.deepNavy,
                          fontFamily: fonts.medium,
                        }}
                      >
                        {selectedCompany.companyProfile?.size || "N/A"}
                      </Text>
                    </View>
                  </View>
                  <View
                    style={{ flexDirection: "row", flexWrap: "wrap", gap: 16 }}
                  >
                    <View style={{ flex: 1, minWidth: 200 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                          marginBottom: 4,
                        }}
                      >
                        Founded Year
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.deepNavy,
                          fontFamily: fonts.medium,
                        }}
                      >
                        {selectedCompany.companyProfile?.foundedYear || "N/A"}
                      </Text>
                    </View>
                    <View style={{ flex: 1, minWidth: 200 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                          marginBottom: 4,
                        }}
                      >
                        Industry
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.deepNavy,
                          fontFamily: fonts.medium,
                        }}
                      >
                        {selectedCompany.companyProfile?.industry || "N/A"}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>

              {/* Legal Information */}
              <View style={{ marginBottom: 24 }}>
                <Text
                  style={{
                    fontSize: 16,
                    fontFamily: fonts.semibold,
                    color: colors.deepNavy,
                    marginBottom: 12,
                  }}
                >
                  Legal Information
                </Text>
                <View
                  style={{
                    backgroundColor: colors.lightGray,
                    padding: 16,
                    borderRadius: 12,
                    gap: 12,
                  }}
                >
                  <View
                    style={{ flexDirection: "row", flexWrap: "wrap", gap: 16 }}
                  >
                    <View style={{ flex: 1, minWidth: 200 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                          marginBottom: 4,
                        }}
                      >
                        Registration Number
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.deepNavy,
                          fontFamily: fonts.medium,
                        }}
                      >
                        {selectedCompany.companyProfile?.registrationNumber ||
                          "N/A"}
                      </Text>
                    </View>
                    <View style={{ flex: 1, minWidth: 200 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                          marginBottom: 4,
                        }}
                      >
                        Tax ID
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.deepNavy,
                          fontFamily: fonts.medium,
                        }}
                      >
                        {selectedCompany.companyProfile?.taxId || "N/A"}
                      </Text>
                    </View>
                  </View>
                </View>
              </View>

              {/* Submission Info */}
              <View style={{ marginBottom: 24 }}>
                <Text
                  style={{
                    fontSize: 16,
                    fontFamily: fonts.semibold,
                    color: colors.deepNavy,
                    marginBottom: 12,
                  }}
                >
                  Submission Information
                </Text>
                <View
                  style={{
                    backgroundColor: colors.lightGray,
                    padding: 16,
                    borderRadius: 12,
                    gap: 12,
                  }}
                >
                  <View
                    style={{ flexDirection: "row", flexWrap: "wrap", gap: 16 }}
                  >
                    <View style={{ flex: 1, minWidth: 200 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                          marginBottom: 4,
                        }}
                      >
                        Submitted At
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.deepNavy,
                          fontFamily: fonts.medium,
                        }}
                      >
                        {formatDate(
                          selectedCompany.companyProfile?.submittedAt,
                        )}
                      </Text>
                    </View>
                    {selectedCompany.companyProfile?.verifiedAt && (
                      <View style={{ flex: 1, minWidth: 200 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            color: colors.warmGray,
                            fontFamily: fonts.regular,
                            marginBottom: 4,
                          }}
                        >
                          Verified At
                        </Text>
                        <Text
                          style={{
                            fontSize: 14,
                            color: colors.deepNavy,
                            fontFamily: fonts.medium,
                          }}
                        >
                          {formatDate(
                            selectedCompany.companyProfile.verifiedAt,
                          )}
                        </Text>
                      </View>
                    )}
                  </View>
                  {selectedCompany.companyProfile?.rejectionReason && (
                    <View
                      style={{
                        flex: 1,
                        backgroundColor: "#EF4444" + "10",
                        padding: 12,
                        borderRadius: 8,
                        borderLeftWidth: 4,
                        borderLeftColor: "#EF4444",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 12,
                          color: colors.warmGray,
                          fontFamily: fonts.regular,
                          marginBottom: 4,
                        }}
                      >
                        Rejection Reason
                      </Text>
                      {(selectedCompany.companyProfile.rejectionReasons?.length
                        ? [
                            ...selectedCompany.companyProfile.rejectionReasons,
                            ...(selectedCompany.companyProfile.rejectionNote
                              ? [
                                  `Note: ${selectedCompany.companyProfile.rejectionNote}`,
                                ]
                              : []),
                          ]
                        : [selectedCompany.companyProfile.rejectionReason]
                      ).map((r: string) => (
                        <Text
                          key={r}
                          style={{
                            fontSize: 14,
                            color: "#EF4444",
                            fontFamily: fonts.medium,
                            marginTop: 2,
                          }}
                        >
                          • {r}
                        </Text>
                      ))}
                    </View>
                  )}
                </View>
              </View>
            </ScrollView>

            {/* Modal Footer with Actions */}
            {selectedCompany.companyProfile?.verificationStatus ===
              "pending" && (
              <View
                style={{
                  padding: 24,
                  borderTopWidth: 1,
                  borderTopColor: colors.lightGray,
                  flexDirection: "row",
                  gap: 12,
                  backgroundColor: colors.lightGray + "80",
                }}
              >
                <TouchableOpacity
                  style={{
                    flex: 1,
                    backgroundColor: "#10B981",
                    paddingVertical: 14,
                    paddingHorizontal: 20,
                    borderRadius: 12,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    shadowColor: "#10B981",
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: 0.3,
                    shadowRadius: 8,
                  }}
                  onPress={() => {
                    const message = `Approve ${selectedCompany.companyProfile?.companyName}?\n\nThey will receive email notification and gain access to post jobs.`;

                    if (Platform.OS === "web") {
                      if (window.confirm(message)) {
                        handleVerificationUpdate(
                          selectedCompany.id,
                          "approved",
                        );
                      }
                    } else {
                      Alert.alert("Approve Company", message, [
                        { text: "Cancel", style: "cancel" },
                        {
                          text: "Approve",
                          onPress: () =>
                            handleVerificationUpdate(
                              selectedCompany.id,
                              "approved",
                            ),
                        },
                      ]);
                    }
                  }}
                  disabled={updating}
                >
                  {updating ? (
                    <ActivityIndicator size="small" color={colors.white} />
                  ) : (
                    <>
                      <Icon
                        name="check-circle"
                        size={20}
                        color={colors.white}
                      />
                      <Text
                        style={{
                          color: colors.white,
                          fontSize: 16,
                          fontFamily: fonts.semibold,
                          marginLeft: 8,
                        }}
                      >
                        Approve Company
                      </Text>
                    </>
                  )}
                </TouchableOpacity>
                <TouchableOpacity
                  style={{
                    flex: 1,
                    backgroundColor: "#EF4444",
                    paddingVertical: 14,
                    paddingHorizontal: 20,
                    borderRadius: 12,
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    shadowColor: "#EF4444",
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: 0.3,
                    shadowRadius: 8,
                  }}
                  onPress={() => {
                    openRejectModal(selectedCompany);
                  }}
                  disabled={updating}
                >
                  {updating ? (
                    <ActivityIndicator size="small" color={colors.white} />
                  ) : (
                    <>
                      <Icon name="cancel" size={20} color={colors.white} />
                      <Text
                        style={{
                          color: colors.white,
                          fontSize: 16,
                          fontFamily: fonts.semibold,
                          marginLeft: 8,
                        }}
                      >
                        Reject Company
                      </Text>
                    </>
                  )}
                </TouchableOpacity>
              </View>
            )}
          </View>
        </View>
      )}

      {/* Full-screen document preview */}
      {previewDoc && (
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.88)",
            zIndex: 1100,
            padding: isMobile ? 12 : 32,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 12,
              gap: 10,
            }}
          >
            <Text
              numberOfLines={1}
              style={{
                flex: 1,
                fontSize: 16,
                fontFamily: fonts.semiBold,
                fontWeight: "600",
                color: "#F9FAFB",
              }}
            >
              {previewDoc.label}
            </Text>
            <TouchableOpacity
              onPress={() => Linking.openURL(previewDoc.url)}
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 6,
                backgroundColor: "#FFFFFF22",
                paddingHorizontal: 12,
                paddingVertical: 8,
                borderRadius: 8,
              }}
            >
              <Icon name="open-in-new" size={16} color="#F9FAFB" />
              {!isMobile && (
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.medium,
                    color: "#F9FAFB",
                  }}
                >
                  Open in new tab
                </Text>
              )}
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => setPreviewDoc(null)}
              style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                backgroundColor: "#FFFFFF22",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon name="close" size={20} color="#F9FAFB" />
            </TouchableOpacity>
          </View>
          <View
            style={{
              flex: 1,
              borderRadius: 12,
              overflow: "hidden",
              backgroundColor: isImageUrl(previewDoc.url)
                ? "transparent"
                : "#FFFFFF",
            }}
          >
            {isImageUrl(previewDoc.url) ? (
              <Image
                source={{ uri: previewDoc.url }}
                resizeMode="contain"
                style={{ width: "100%", height: "100%" }}
              />
            ) : Platform.OS === "web" ? (
              <iframe
                src={previewDoc.url}
                title={previewDoc.label}
                style={{ width: "100%", height: "100%", border: "none" }}
              />
            ) : (
              <View
                style={{
                  flex: 1,
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 12,
                }}
              >
                <Icon name="description" size={56} color={colors.softBlue} />
                <Text style={{ fontFamily: fonts.medium, color: "#334155" }}>
                  Tap "open" above to view this document
                </Text>
              </View>
            )}
          </View>
        </View>
      )}

      {/* Rejection reasons modal */}
      {rejectTarget && (
        <View
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            zIndex: 1200,
            alignItems: isMobile ? "stretch" : "center",
            justifyContent: isMobile ? "flex-end" : "center",
            padding: isMobile ? 0 : 20,
          }}
        >
          <TouchableOpacity
            style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
            activeOpacity={1}
            onPress={() => !updating && closeRejectModal()}
          />
          <View
            style={{
              backgroundColor: colors.adminCardBg,
              borderRadius: 20,
              borderBottomLeftRadius: isMobile ? 0 : 20,
              borderBottomRightRadius: isMobile ? 0 : 20,
              width: "100%",
              maxWidth: isMobile ? undefined : 560,
              maxHeight: "92%",
              overflow: "hidden",
            }}
          >
            <View
              style={{
                backgroundColor: "#7F1D1D",
                padding: 20,
                flexDirection: "row",
                alignItems: "center",
                gap: 12,
              }}
            >
              <Icon name="cancel" size={24} color="#FECACA" />
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 17,
                    fontFamily: fonts.bold,
                    fontWeight: "700",
                    color: "#FFFFFF",
                  }}
                >
                  Reject Company
                </Text>
                <Text
                  numberOfLines={1}
                  style={{
                    fontSize: 12,
                    fontFamily: fonts.regular,
                    color: "#FECACA",
                    marginTop: 2,
                  }}
                >
                  {rejectTarget.companyProfile?.companyName || "Unnamed Company"}
                </Text>
              </View>
              <TouchableOpacity
                onPress={closeRejectModal}
                disabled={!!updating}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  backgroundColor: "#FFFFFF22",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="close" size={18} color="#FECACA" />
              </TouchableOpacity>
            </View>

            <ScrollView
              style={{ padding: 20 }}
              contentContainerStyle={{ paddingBottom: 12 }}
            >
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.semiBold,
                  fontWeight: "600",
                  color: colors.deepNavy,
                  marginBottom: 10,
                }}
              >
                Select all reasons that apply
              </Text>
              {COMPANY_REJECTION_REASONS.map((reason) => {
                const checked = selectedReasons.includes(reason);
                return (
                  <TouchableOpacity
                    key={reason}
                    onPress={() => toggleReason(reason)}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 10,
                      paddingVertical: 10,
                      paddingHorizontal: 12,
                      marginBottom: 6,
                      borderRadius: 10,
                      borderWidth: 1,
                      borderColor: checked ? "#EF4444" : colors.adminBorder,
                      backgroundColor: checked ? "#EF444412" : "transparent",
                    }}
                  >
                    <Icon
                      name={checked ? "check-box" : "check-box-outline-blank"}
                      size={20}
                      color={checked ? "#EF4444" : colors.adminMuted}
                    />
                    <Text
                      style={{
                        flex: 1,
                        fontSize: 13,
                        fontFamily: fonts.regular,
                        color: colors.deepNavy,
                      }}
                    >
                      {reason}
                    </Text>
                  </TouchableOpacity>
                );
              })}

              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.semiBold,
                  fontWeight: "600",
                  color: colors.deepNavy,
                  marginTop: 12,
                  marginBottom: 8,
                }}
              >
                Additional note (optional)
              </Text>
              <TextInput
                value={rejectionNote}
                onChangeText={setRejectionNote}
                multiline
                numberOfLines={3}
                placeholder="Add details or other reasons for the company…"
                placeholderTextColor={colors.adminMuted}
                style={{
                  minHeight: 80,
                  borderWidth: 1,
                  borderColor: colors.adminBorder,
                  borderRadius: 10,
                  padding: 12,
                  fontSize: 13,
                  fontFamily: fonts.regular,
                  color: colors.deepNavy,
                  textAlignVertical: "top",
                }}
              />
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: fonts.regular,
                  color: colors.adminMuted,
                  marginTop: 8,
                }}
              >
                The company will receive these reasons by email and push
                notification.
              </Text>
            </ScrollView>

            <View
              style={{
                flexDirection: "row",
                gap: 10,
                padding: 16,
                borderTopWidth: 1,
                borderTopColor: colors.adminBorder,
              }}
            >
              <TouchableOpacity
                onPress={closeRejectModal}
                disabled={!!updating}
                style={{
                  flex: 1,
                  paddingVertical: 12,
                  borderRadius: 10,
                  borderWidth: 1,
                  borderColor: colors.adminBorder,
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    color: colors.deepNavy,
                  }}
                >
                  Cancel
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={submitRejection}
                disabled={!canSubmitRejection || !!updating}
                style={{
                  flex: 1,
                  paddingVertical: 12,
                  borderRadius: 10,
                  backgroundColor: "#EF4444",
                  alignItems: "center",
                  opacity: !canSubmitRejection || updating ? 0.5 : 1,
                }}
              >
                {updating ? (
                  <ActivityIndicator size="small" color="#FFFFFF" />
                ) : (
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.semiBold,
                      fontWeight: "600",
                      color: "#FFFFFF",
                    }}
                  >
                    Reject
                    {selectedReasons.length > 0
                      ? ` (${selectedReasons.length})`
                      : ""}
                  </Text>
                )}
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )}
    </View>
  );
}

// Standalone group-key helper used by drill-down (mirrors the inner toGroupKey logic)
const toGroupKeyOutside = (raw: string | undefined | null): string => {
  if (!raw) return "";
  const s = String(raw).trim().replace(/\s+/g, " ").toLowerCase();
  // strip trailing 's' but keep known plural-safe words
  const safeWords = new Set([
    "sales",
    "logistics",
    "analytics",
    "economics",
    "mathematics",
    "statistics",
    "physics",
    "ethics",
    "resources",
    "relations",
    "services",
    "affairs",
    "communications",
    "operations",
    "news",
    "series",
    "species",
    "means",
    "headquarters",
    "class",
    "access",
    "process",
    "success",
    "business",
    "bonus",
    "focus",
    "status",
  ]);
  const words = s.split(" ");
  const last = words[words.length - 1];
  if (!safeWords.has(last)) {
    if (last.endsWith("ies") && last.length > 4)
      words[words.length - 1] = last.slice(0, -3) + "y";
    else if (last.endsWith("s") && last.length > 5)
      words[words.length - 1] = last.slice(0, -1);
  }
  return words.join(" ");
};

// User Engagement Content — superadmin view of how job seekers use the app
function EngagementContent({
  colors = lightColors,
  isDarkMode = false,
}: {
  colors?: any;
  isDarkMode?: boolean;
}) {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [days, setDays] = useState(30);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;

  // Single-series charts use one hue; stepped separately for each surface
  const seriesColor = isDarkMode ? "#3987e5" : "#2a78d6";
  const ink = isDarkMode ? "#F1F5F9" : "#0F172A";
  const gridColor = isDarkMode ? "#1E293B" : "#E2E8F0";

  useEffect(() => {
    const sub = Dimensions.addEventListener("change", ({ window }) =>
      setDimensions(window),
    );
    return () => sub?.remove();
  }, []);

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const fn = httpsCallable(functions, "getEngagementStats", {
        timeout: 120000,
      });
      const res: any = await fn({ days });
      setStats(res.data);
    } catch (err: any) {
      console.error("Failed to load engagement stats:", err);
      setError(err?.message || "Failed to load engagement stats");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [days]);

  const fmt = (n: number) => (n || 0).toLocaleString();
  const pct = (n: number, d: number) =>
    d > 0 ? `${Math.round((n / d) * 1000) / 10}%` : "—";
  const shortDate = (k: string) => {
    const d = new Date(`${k}T00:00:00`);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  };

  const SectionTitle = ({ title, hint }: { title: string; hint?: string }) => (
    <View style={{ marginTop: 22, marginBottom: 10 }}>
      <Text
        style={{
          fontSize: 15,
          fontFamily: fonts.bold,
          fontWeight: "700",
          color: ink,
        }}
      >
        {title}
      </Text>
      {hint ? (
        <Text
          style={{
            fontSize: 12,
            fontFamily: fonts.regular,
            color: colors.adminMuted,
            marginTop: 2,
          }}
        >
          {hint}
        </Text>
      ) : null}
    </View>
  );

  const Tile = ({
    label,
    value,
    sub,
    icon,
  }: {
    label: string;
    value: string;
    sub?: string;
    icon: string;
  }) => (
    <View
      style={{
        flexGrow: 1,
        flexBasis: isMobile ? "45%" : 180,
        backgroundColor: colors.adminCardBg,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: colors.adminBorder,
        padding: 14,
      }}
    >
      <View style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
        <Icon name={icon} size={15} color={colors.adminMuted} />
        <Text
          numberOfLines={1}
          style={{
            flex: 1,
            fontSize: 11,
            fontFamily: fonts.medium,
            color: colors.adminMuted,
          }}
        >
          {label}
        </Text>
      </View>
      <Text
        style={{
          fontSize: 24,
          fontFamily: fonts.bold,
          fontWeight: "700",
          color: ink,
          marginTop: 6,
        }}
      >
        {value}
      </Text>
      {sub ? (
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.regular,
            color: colors.adminMuted,
            marginTop: 2,
          }}
        >
          {sub}
        </Text>
      ) : null}
    </View>
  );

  const Card = ({ children, style }: any) => (
    <View
      style={[
        {
          backgroundColor: colors.adminCardBg,
          borderRadius: 12,
          borderWidth: 1,
          borderColor: colors.adminBorder,
          padding: 16,
        },
        style,
      ]}
    >
      {children}
    </View>
  );

  // Horizontal proportional bars built from Views (works on web and native)
  const BarList = ({
    rows,
    total,
  }: {
    rows: { label: string; value: number; note?: string }[];
    total?: number;
  }) => {
    const max = Math.max(1, ...rows.map((r) => r.value));
    if (rows.length === 0) {
      return (
        <Text
          style={{
            fontSize: 12,
            fontFamily: fonts.regular,
            color: colors.adminMuted,
          }}
        >
          No data yet
        </Text>
      );
    }
    return (
      <View style={{ gap: 10 }}>
        {rows.map((r) => (
          <View key={r.label}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: 4,
                gap: 8,
              }}
            >
              <Text
                numberOfLines={1}
                style={{
                  flex: 1,
                  fontSize: 12,
                  fontFamily: fonts.medium,
                  color: ink,
                }}
              >
                {r.label}
              </Text>
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.semiBold,
                  color: ink,
                }}
              >
                {fmt(r.value)}
                {total ? (
                  <Text style={{ color: colors.adminMuted }}>
                    {"  "}
                    {pct(r.value, total)}
                  </Text>
                ) : null}
                {r.note ? (
                  <Text style={{ color: colors.adminMuted }}>
                    {"  "}
                    {r.note}
                  </Text>
                ) : null}
              </Text>
            </View>
            <View
              style={{
                height: 8,
                borderRadius: 4,
                backgroundColor: gridColor,
                overflow: "hidden",
              }}
            >
              <View
                style={{
                  width: `${Math.max(1, (r.value / max) * 100)}%`,
                  height: 8,
                  borderRadius: 4,
                  backgroundColor: seriesColor,
                }}
              />
            </View>
          </View>
        ))}
      </View>
    );
  };

  const TrendChart = ({
    title,
    dataKey,
    total,
  }: {
    title: string;
    dataKey: string;
    total: number;
  }) => (
    <Card style={{ flexGrow: 1, flexBasis: isMobile ? "100%" : 320 }}>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "baseline",
        }}
      >
        <Text
          style={{
            fontSize: 13,
            fontFamily: fonts.semiBold,
            fontWeight: "600",
            color: ink,
          }}
        >
          {title}
        </Text>
        <Text
          style={{
            fontSize: 16,
            fontFamily: fonts.bold,
            fontWeight: "700",
            color: ink,
          }}
        >
          {fmt(total)}
        </Text>
      </View>
      {Platform.OS === "web" && AreaChart ? (
        <View style={{ height: 150, marginTop: 10 }}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={stats.daily}
              margin={{ top: 6, right: 6, left: -18, bottom: 0 }}
            >
              <CartesianGrid
                stroke={gridColor}
                strokeDasharray="3 3"
                vertical={false}
              />
              <XAxis
                dataKey="date"
                tickFormatter={shortDate}
                tick={{ fontSize: 10, fill: colors.adminMuted }}
                axisLine={false}
                tickLine={false}
                minTickGap={24}
              />
              <YAxis
                allowDecimals={false}
                tick={{ fontSize: 10, fill: colors.adminMuted }}
                axisLine={false}
                tickLine={false}
                width={44}
              />
              <Tooltip
                cursor={{ stroke: colors.adminMuted, strokeWidth: 1 }}
                labelFormatter={(k: string) => shortDate(k)}
                formatter={(v: number) => [fmt(v), title]}
                contentStyle={{
                  backgroundColor: colors.adminCardBg,
                  border: `1px solid ${colors.adminBorder}`,
                  borderRadius: 8,
                  fontSize: 12,
                  color: ink,
                }}
                labelStyle={{ color: colors.adminMuted }}
                itemStyle={{ color: ink }}
              />
              <Area
                type="monotone"
                dataKey={dataKey}
                stroke={seriesColor}
                strokeWidth={2}
                fill={seriesColor}
                fillOpacity={0.15}
                activeDot={{ r: 4, stroke: colors.adminCardBg, strokeWidth: 2 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </View>
      ) : (
        <Text
          style={{
            fontSize: 11,
            fontFamily: fonts.regular,
            color: colors.adminMuted,
            marginTop: 8,
          }}
        >
          Daily chart available on web.
        </Text>
      )}
    </Card>
  );

  const RankTable = ({
    title,
    rows,
    valueLabel,
    extra,
  }: {
    title: string;
    rows: any[];
    valueLabel: string;
    extra?: (r: any) => string;
  }) => (
    <Card style={{ flexGrow: 1, flexBasis: isMobile ? "100%" : 360 }}>
      <Text
        style={{
          fontSize: 13,
          fontFamily: fonts.semiBold,
          fontWeight: "600",
          color: ink,
          marginBottom: 10,
        }}
      >
        {title}
      </Text>
      {rows.length === 0 ? (
        <Text
          style={{
            fontSize: 12,
            fontFamily: fonts.regular,
            color: colors.adminMuted,
          }}
        >
          No data yet
        </Text>
      ) : (
        rows.map((r: any, i: number) => (
          <View
            key={r.id}
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 10,
              paddingVertical: 8,
              borderTopWidth: i === 0 ? 0 : 1,
              borderTopColor: colors.adminBorder,
            }}
          >
            <Text
              style={{
                width: 18,
                fontSize: 12,
                fontFamily: fonts.semiBold,
                color: colors.adminMuted,
              }}
            >
              {i + 1}
            </Text>
            <View style={{ flex: 1 }}>
              <Text
                numberOfLines={1}
                style={{ fontSize: 13, fontFamily: fonts.medium, color: ink }}
              >
                {r.title}
              </Text>
              {r.company || extra ? (
                <Text
                  numberOfLines={1}
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.regular,
                    color: colors.adminMuted,
                  }}
                >
                  {[r.company, extra ? extra(r) : ""]
                    .filter(Boolean)
                    .join(" · ")}
                </Text>
              ) : null}
            </View>
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: ink,
              }}
            >
              {fmt(r.count)}
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: fonts.regular,
                  color: colors.adminMuted,
                }}
              >
                {" "}
                {valueLabel}
              </Text>
            </Text>
          </View>
        ))
      )}
    </Card>
  );

  const u = stats?.users;
  const providerLabels: Record<string, string> = {
    "google.com": "Google",
    password: "Email & password",
    "apple.com": "Apple",
    phone: "Phone",
  };
  const toRows = (obj: Record<string, number> = {}, labels?: any) =>
    Object.entries(obj)
      .sort((a, b) => b[1] - a[1])
      .map(([k, v]) => ({
        label: labels?.[k] || k.charAt(0).toUpperCase() + k.slice(1),
        value: v,
      }));

  return (
    <View style={{ flex: 1, backgroundColor: colors.adminPageBg }}>
      {/* ── Page Header ── */}
      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          justifyContent: "space-between",
          backgroundColor: colors.adminHeaderBg,
          paddingHorizontal: isMobile ? 16 : 28,
          paddingVertical: isMobile ? 14 : 18,
          gap: 12,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center", gap: 14 }}>
          <View
            style={{
              width: 40,
              height: 40,
              borderRadius: 11,
              backgroundColor: `${colors.sidebarAccent}22`,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon name="insights" size={22} color={colors.sidebarAccent} />
          </View>
          <View>
            <Text
              style={{
                fontSize: 18,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#F9FAFB",
              }}
            >
              User Engagement
            </Text>
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.regular,
                color: "#94A3B8",
                marginTop: 1,
              }}
            >
              How job seekers sign up, complete profiles and interact with jobs
            </Text>
          </View>
        </View>
        <View style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
          {[7, 30, 90].map((d) => (
            <TouchableOpacity
              key={d}
              onPress={() => setDays(d)}
              style={{
                paddingHorizontal: 12,
                paddingVertical: 7,
                borderRadius: 8,
                backgroundColor: days === d ? colors.sidebarAccent : "#FFFFFF14",
              }}
            >
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.semiBold,
                  fontWeight: "600",
                  color: "#FFFFFF",
                }}
              >
                {d}d
              </Text>
            </TouchableOpacity>
          ))}
          <TouchableOpacity
            onPress={load}
            disabled={loading}
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 6,
              paddingHorizontal: 12,
              paddingVertical: 7,
              borderRadius: 8,
              backgroundColor: "#FFFFFF14",
            }}
          >
            <Icon name="refresh" size={15} color="#FFFFFF" />
          </TouchableOpacity>
        </View>
      </View>

      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{
          paddingHorizontal: isMobile ? 16 : 24,
          paddingBottom: 40,
        }}
      >
        {loading && !stats ? (
          <InlineLoadingIndicator
            message="Crunching engagement stats…"
            isDarkMode={isDarkMode}
          />
        ) : error && !stats ? (
          <View style={{ alignItems: "center", paddingVertical: 48, gap: 12 }}>
            <Icon name="error-outline" size={40} color={colors.adminMuted} />
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.regular,
                color: colors.adminMuted,
                textAlign: "center",
              }}
            >
              {error}
            </Text>
            <TouchableOpacity
              onPress={load}
              style={{
                paddingHorizontal: 16,
                paddingVertical: 8,
                borderRadius: 8,
                backgroundColor: colors.sidebarAccent,
              }}
            >
              <Text style={{ color: "#FFFFFF", fontFamily: fonts.semiBold }}>
                Retry
              </Text>
            </TouchableOpacity>
          </View>
        ) : stats ? (
          <View style={{ opacity: loading ? 0.6 : 1 }}>
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.regular,
                color: colors.adminMuted,
                marginTop: 14,
              }}
            >
              Job seekers only (companies and admins excluded) · updated{" "}
              {new Date(stats.generatedAt).toLocaleString()}
            </Text>

            {/* ── Audience ── */}
            <SectionTitle title="Audience" />
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10 }}>
              <Tile icon="people" label="Job seekers" value={fmt(u.total)} />
              <Tile
                icon="person-add"
                label={`New in last ${stats.days}d`}
                value={fmt(u.newInRange)}
                sub={`${fmt(u.new7d)} in last 7 days`}
              />
              <Tile
                icon="today"
                label="Active today"
                value={fmt(u.active1d)}
                sub={pct(u.active1d, u.total)}
              />
              <Tile
                icon="date-range"
                label="Active last 7 days"
                value={fmt(u.active7d)}
                sub={pct(u.active7d, u.total)}
              />
              <Tile
                icon="calendar-month"
                label="Active last 30 days"
                value={fmt(u.active30d)}
                sub={pct(u.active30d, u.total)}
              />
              <Tile
                icon="person-off"
                label="Never logged in"
                value={fmt(u.neverLoggedIn)}
                sub={pct(u.neverLoggedIn, u.total)}
              />
            </View>

            {/* ── Funnel ── */}
            <SectionTitle
              title="Engagement funnel"
              hint="Share of all job seekers who reached each step"
            />
            <Card>
              <BarList
                total={u.total}
                rows={[
                  { label: "Signed up", value: u.total },
                  { label: "Verified email", value: u.verified },
                  { label: "Completed profile", value: u.profileComplete },
                  { label: "Saved a job", value: u.savers },
                  { label: "Applied to a job", value: u.applicants },
                ]}
              />
            </Card>

            {/* ── Profile health ── */}
            <SectionTitle title="Profile health" />
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10 }}>
              <Tile
                icon="verified-user"
                label="Verified email"
                value={pct(u.verified, u.total)}
                sub={`${fmt(u.verified)} users`}
              />
              <Tile
                icon="assignment-turned-in"
                label="Completed profile"
                value={pct(u.profileComplete, u.total)}
                sub={`${fmt(u.profileComplete)} users`}
              />
              <Tile
                icon="local-offer"
                label="Picked job interests"
                value={pct(u.withInterests, u.total)}
                sub={`${fmt(u.withInterests)} users`}
              />
              <Tile
                icon="account-circle"
                label="Has profile photo"
                value={pct(u.withPhoto, u.total)}
                sub={`${fmt(u.withPhoto)} users`}
              />
              <Tile
                icon="notifications-active"
                label="Notifications on"
                value={pct(u.notificationsOn, u.total)}
                sub={`${fmt(u.notificationsOn)} users`}
              />
              <Tile
                icon="phonelink-ring"
                label="Reachable by push"
                value={pct(u.withPushToken, u.total)}
                sub={`${fmt(u.withPushToken)} have a device token`}
              />
              <Tile
                icon="workspace-premium"
                label="Paid plan"
                value={pct(u.paid, u.total)}
                sub={`${fmt(u.paid)} users`}
              />
            </View>

            {/* ── Job interactions ── */}
            <SectionTitle
              title="Job interactions"
              hint={
                stats.trackingSince
                  ? `Views, apply clicks and saves are tracked since ${shortDate(
                      stats.trackingSince,
                    )}`
                  : "Views, apply clicks and saves are tracked from today onward"
              }
            />
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10 }}>
              <Tile
                icon="visibility"
                label={`Job views (${stats.days}d)`}
                value={fmt(stats.interactions.inRange.jobViews)}
                sub={`${fmt(stats.interactions.allTime.job_view)} all time`}
              />
              <Tile
                icon="open-in-new"
                label={`Apply clicks (${stats.days}d)`}
                value={fmt(stats.interactions.inRange.applyClicks)}
                sub={`${pct(
                  stats.interactions.inRange.applyClicks,
                  stats.interactions.inRange.jobViews,
                )} of views`}
              />
              <Tile
                icon="bookmark-add"
                label={`Saves (${stats.days}d)`}
                value={fmt(stats.interactions.inRange.saves)}
                sub={`${fmt(u.totalSaves)} jobs saved right now`}
              />
              <Tile
                icon="bookmarks"
                label="Users with saved jobs"
                value={fmt(u.savers)}
                sub={
                  u.savers > 0
                    ? `${(u.totalSaves / u.savers).toFixed(1)} saves each on average`
                    : undefined
                }
              />
              <Tile
                icon="send"
                label={`Applications (${stats.days}d)`}
                value={fmt(stats.applications.inRange)}
                sub={`${fmt(stats.applications.total)} all time`}
              />
              <Tile
                icon="how-to-reg"
                label="Unique applicants"
                value={fmt(u.applicants)}
                sub={pct(u.applicants, u.total) + " of job seekers"}
              />
            </View>

            {/* ── Daily trends (small multiples, one measure each) ── */}
            <SectionTitle title={`Daily trends · last ${stats.days} days`} />
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10 }}>
              <TrendChart
                title="Sign-ups"
                dataKey="signups"
                total={u.newInRange}
              />
              <TrendChart
                title="Daily active users"
                dataKey="activeUsers"
                total={stats.daily.reduce(
                  (a: number, d: any) => a + d.activeUsers,
                  0,
                )}
              />
              <TrendChart
                title="Job views"
                dataKey="jobViews"
                total={stats.interactions.inRange.jobViews}
              />
              <TrendChart
                title="Apply clicks"
                dataKey="applyClicks"
                total={stats.interactions.inRange.applyClicks}
              />
              <TrendChart
                title="Job saves"
                dataKey="saves"
                total={stats.interactions.inRange.saves}
              />
            </View>

            {/* ── Top jobs ── */}
            <SectionTitle title="Top jobs" />
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10 }}>
              <RankTable
                title="Most saved"
                rows={stats.topSaved}
                valueLabel="saves"
              />
              <RankTable
                title="Most viewed"
                rows={stats.topViewed}
                valueLabel="views"
                extra={(r) =>
                  r.applyClicks
                    ? `${fmt(r.applyClicks)} apply clicks`
                    : ""
                }
              />
            </View>

            {/* ── Breakdowns ── */}
            <SectionTitle title="Breakdowns" />
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10 }}>
              <Card style={{ flexGrow: 1, flexBasis: isMobile ? "100%" : 300 }}>
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.semiBold,
                    color: ink,
                    marginBottom: 10,
                  }}
                >
                  Top job interests
                </Text>
                <BarList
                  rows={(stats.topInterests || []).map((t: any) => ({
                    label: t.tag,
                    value: t.count,
                  }))}
                />
              </Card>
              <Card style={{ flexGrow: 1, flexBasis: isMobile ? "100%" : 300 }}>
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.semiBold,
                    color: ink,
                    marginBottom: 10,
                  }}
                >
                  Sign-in method (all accounts)
                </Text>
                <BarList
                  rows={toRows(u.providers, providerLabels)}
                  total={Object.values(u.providers || {}).reduce(
                    (a: number, b: any) => a + b,
                    0,
                  )}
                />
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.semiBold,
                    color: ink,
                    marginTop: 18,
                    marginBottom: 10,
                  }}
                >
                  Application status
                </Text>
                <BarList
                  rows={toRows(stats.applications.byStatus)}
                  total={stats.applications.total}
                />
              </Card>
              <Card style={{ flexGrow: 1, flexBasis: isMobile ? "100%" : 300 }}>
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.semiBold,
                    color: ink,
                    marginBottom: 10,
                  }}
                >
                  Subscription plans
                </Text>
                <BarList rows={toRows(u.plans)} total={u.total} />
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.semiBold,
                    color: ink,
                    marginTop: 18,
                    marginBottom: 10,
                  }}
                >
                  Account roles (all accounts)
                </Text>
                <BarList rows={toRows(u.roles)} />
              </Card>
            </View>
          </View>
        ) : null}
      </ScrollView>
    </View>
  );
}

// Analytics Content
// Analytics Content
// Insights Content Component
function InsightsContent({
  colors = lightColors,
  isDarkMode = false,
}: {
  colors?: any;
  isDarkMode?: boolean;
}) {
  const [generatingPDF, setGeneratingPDF] = useState(false);
  const [downloadingImage, setDownloadingImage] = useState(false);
  const [recomputing, setRecomputing] = useState(false);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const [viewTypes, setViewTypes] = useState<{
    [key: number]:
      | "bar"
      | "bubble"
      | "pie"
      | "table"
      | "area"
      | "line"
      | "hbar"
      | "donut";
  }>({
    1: "bar",
    2: "hbar",
    3: "area",
    4: "hbar",
    5: "bar",
    6: "donut",
    7: "donut",
    8: "bar",
    9: "line",
    10: "hbar",
  });
  const [lastComputed, setLastComputed] = useState(new Date());
  const [collapsed, setCollapsed] = useState<{ [key: number]: boolean }>({});
  const [loading, setLoading] = useState(true);
  const [totalJobsAnalyzed, setTotalJobsAnalyzed] = useState(0);
  const [showRecomputeModal, setShowRecomputeModal] = useState(false);

  // Drill-down: stores all raw jobs after computation so we can filter on tap
  const allJobsRef = React.useRef<any[]>([]);
  const [drillDown, setDrillDown] = useState<{
    label: string;
    insightId: number;
    jobs: any[];
  } | null>(null);

  const isMobile = dimensions.width < 768;
  const isTablet = dimensions.width >= 768 && dimensions.width < 1024;
  const insightsPalette = INSIGHTS_PALETTE[isDarkMode ? "dark" : "light"];
  const RANKED_INSIGHT_TOP_N = 20;
  // Every "ranked breakdown" aggregation below is sorted-desc then split
  // here: top N rows render as-is, everything past that folds into one
  // "Others (n)" row so a long tail of one-off values doesn't overwhelm
  // the chart/table. isOthersLabel() detects that synthetic row later on
  // (drill-down guard, chart coloring) by its label prefix.
  const splitTopN = <V,>(
    sortedEntries: [string, V][],
    n: number = RANKED_INSIGHT_TOP_N,
  ) => ({
    top: sortedEntries.slice(0, n),
    rest: sortedEntries.slice(n),
  });
  const isOthersLabel = (label: any): boolean =>
    typeof label === "string" && label.startsWith("Others (");

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  // Comprehensive insights data - Now computed from real Firestore job data
  const [insights, setInsights] = useState([
    {
      id: 1,
      title: "Most Popular Job Categories in Ethiopia",
      icon: "🔥",
      data: [
        {
          category: "Information Technology",
          count: 1245,
          percentage: 28,
          trend: "+12%",
        },
        {
          category: "Healthcare & Medical",
          count: 987,
          percentage: 22,
          trend: "+8%",
        },
        { category: "Engineering", count: 756, percentage: 17, trend: "+15%" },
        {
          category: "Finance & Banking",
          count: 623,
          percentage: 14,
          trend: "+5%",
        },
        {
          category: "Education & Training",
          count: 445,
          percentage: 10,
          trend: "+3%",
        },
        {
          category: "Sales & Marketing",
          count: 389,
          percentage: 9,
          trend: "+7%",
        },
      ],
    },
    {
      id: 2,
      title: "Highest Paying Jobs in Ethiopia",
      icon: "💰",
      data: [
        {
          job: "Senior Software Engineer",
          salary: "150,000 - 250,000 ETB/month",
          demand: "High",
        },
        {
          job: "Medical Specialist",
          salary: "130,000 - 220,000 ETB/month",
          demand: "Very High",
        },
        {
          job: "Bank Manager",
          salary: "120,000 - 200,000 ETB/month",
          demand: "Medium",
        },
        {
          job: "Project Manager (Tech)",
          salary: "110,000 - 180,000 ETB/month",
          demand: "High",
        },
        {
          job: "Data Scientist",
          salary: "100,000 - 170,000 ETB/month",
          demand: "Very High",
        },
        {
          job: "Senior Accountant",
          salary: "80,000 - 140,000 ETB/month",
          demand: "High",
        },
      ],
    },
    {
      id: 3,
      title: "Fastest Growing Job Sectors",
      icon: "📈",
      data: [
        {
          sector: "Artificial Intelligence & Machine Learning",
          growth: "+45%",
          jobs: 234,
        },
        { sector: "Renewable Energy", growth: "+38%", jobs: 189 },
        { sector: "Digital Marketing", growth: "+32%", jobs: 567 },
        { sector: "Cybersecurity", growth: "+30%", jobs: 178 },
        { sector: "E-commerce", growth: "+28%", jobs: 423 },
        { sector: "Telemedicine", growth: "+25%", jobs: 156 },
      ],
    },
    {
      id: 4,
      title: "Top Hiring Companies in Ethiopia",
      icon: "🏢",
      data: [
        {
          company: "Ethiopian Airlines",
          openPositions: 245,
          avgSalary: "85,000 ETB",
        },
        {
          company: "Ethio Telecom",
          openPositions: 198,
          avgSalary: "75,000 ETB",
        },
        {
          company: "Commercial Bank of Ethiopia",
          openPositions: 167,
          avgSalary: "95,000 ETB",
        },
        {
          company: "Ethiopian Electric Power",
          openPositions: 143,
          avgSalary: "70,000 ETB",
        },
        {
          company: "Safaricom Ethiopia",
          openPositions: 132,
          avgSalary: "110,000 ETB",
        },
        { company: "Zemen Bank", openPositions: 89, avgSalary: "88,000 ETB" },
      ],
    },
    {
      id: 5,
      title: "Most In-Demand Skills",
      icon: "🎯",
      data: [
        { skill: "Python Programming", mentions: 1567, growth: "+25%" },
        { skill: "Project Management", mentions: 1423, growth: "+18%" },
        { skill: "Data Analysis", mentions: 1289, growth: "+30%" },
        { skill: "Digital Marketing", mentions: 1156, growth: "+22%" },
        {
          skill: "Cloud Computing (AWS/Azure)",
          mentions: 1034,
          growth: "+35%",
        },
        { skill: "Financial Analysis", mentions: 967, growth: "+12%" },
      ],
    },
    {
      id: 6,
      title: "Job Distribution by Region",
      icon: "🗺️",
      data: [
        { region: "Addis Ababa", jobs: 3245, percentage: 72 },
        { region: "Oromia", jobs: 567, percentage: 13 },
        { region: "Amhara", jobs: 289, percentage: 6 },
        { region: "SNNPR", jobs: 178, percentage: 4 },
        { region: "Tigray", jobs: 134, percentage: 3 },
        { region: "Other Regions", jobs: 87, percentage: 2 },
      ],
    },
    {
      id: 7,
      title: "Remote vs On-Site Jobs",
      icon: "🏠",
      data: [
        { type: "On-Site Only", count: 2834, percentage: 63 },
        { type: "Hybrid", count: 1123, percentage: 25 },
        { type: "Remote", count: 543, percentage: 12 },
      ],
    },
    {
      id: 8,
      title: "Experience Level Requirements",
      icon: "📊",
      data: [
        { level: "Entry Level (0-2 years)", jobs: 1234, percentage: 27 },
        { level: "Mid Level (3-5 years)", jobs: 1789, percentage: 40 },
        { level: "Senior Level (6-10 years)", jobs: 1067, percentage: 24 },
        { level: "Executive Level (10+ years)", jobs: 410, percentage: 9 },
      ],
    },
    {
      id: 9,
      title: "Average Time to Fill Position",
      icon: "⏱️",
      data: [
        { category: "Technology", days: 18, trend: "Decreasing" },
        { category: "Healthcare", days: 25, trend: "Stable" },
        { category: "Finance", days: 22, trend: "Decreasing" },
        { category: "Engineering", days: 21, trend: "Increasing" },
        { category: "Sales", days: 14, trend: "Decreasing" },
        { category: "Education", days: 30, trend: "Stable" },
      ],
    },
    {
      id: 10,
      title: "Salary Ranges by Category",
      icon: "💵",
      data: [
        {
          category: "Technology",
          min: "45,000",
          max: "250,000",
          avg: "95,000",
        },
        {
          category: "Healthcare",
          min: "35,000",
          max: "220,000",
          avg: "85,000",
        },
        { category: "Finance", min: "40,000", max: "200,000", avg: "90,000" },
        {
          category: "Engineering",
          min: "38,000",
          max: "180,000",
          avg: "75,000",
        },
        { category: "Sales", min: "25,000", max: "120,000", avg: "55,000" },
        { category: "Education", min: "20,000", max: "80,000", avg: "45,000" },
      ],
    },
  ]);

  // Load cached insights from Firestore
  const loadCachedInsights = async () => {
    try {
      const insightsRef = doc(db, "marketInsights", "latest");
      const insightsDoc = await getDoc(insightsRef);

      if (insightsDoc.exists()) {
        const data = insightsDoc.data();
        setInsights(data.insights);
        setLastComputed(data.lastComputed.toDate());
        setTotalJobsAnalyzed(data.totalJobsAnalyzed);
        console.log(
          `📊 Loaded cached insights from ${data.lastComputed.toDate()}`,
        );
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error loading cached insights:", error);
      return false;
    }
  };

  // Save insights to Firestore
  const saveInsightsToFirestore = async (
    insightsData: any[],
    jobsCount: number,
  ) => {
    try {
      const insightsRef = doc(db, "marketInsights", "latest");
      await setDoc(insightsRef, {
        insights: insightsData,
        lastComputed: new Date(),
        totalJobsAnalyzed: jobsCount,
        version: 1,
      });
      console.log("✅ Insights saved to Firestore");
    } catch (error) {
      console.error("Error saving insights to Firestore:", error);
    }
  };

  // Fetch and compute real insights from Firestore
  const computeRealInsights = async (forcerecompute: boolean = false) => {
    setRecomputing(true);
    setLoading(true);
    try {
      // Try to load cached insights first if not forcing recompute
      if (!forcerecompute) {
        const loaded = await loadCachedInsights();
        if (loaded) {
          setLoading(false);
          setRecomputing(false);
          return;
        }
      }

      // Fetch ALL jobs from Firestore (not filtering by deleted or isActive for insights)
      const jobsQuery = dbQuery(
        collection(db, "jobs"),
        orderBy("postedDate", "desc"),
      );
      const snapshot = await getDocs(jobsQuery);
      const allJobs = snapshot.docs.map((doc) => doc.data());

      // Filter out deleted jobs but include all others
      const jobs = allJobs.filter((job) => job.deleted !== true);
      // Keep a reference so drill-down taps can filter directly
      allJobsRef.current = jobs;

      console.log(
        `📊 Computing insights from ${jobs.length} jobs (${allJobs.length} total in database)`,
      );

      if (jobs.length === 0) {
        Alert.alert("No Data", "No jobs found in the database.");
        setLoading(false);
        setRecomputing(false);
        return;
      }

      // --- Text normalization helpers (used across all sections) ---
      const KEEP_PLURAL_WORDS = new Set([
        "sales",
        "logistics",
        "analytics",
        "economics",
        "mathematics",
        "statistics",
        "physics",
        "ethics",
        "resources",
        "relations",
        "services",
        "affairs",
        "communications",
        "operations",
        "news",
        "series",
        "species",
        "means",
        "headquarters",
        "class",
        "access",
        "process",
        "success",
        "business",
        "bonus",
        "focus",
        "status",
        "campus",
        "census",
        "nexus",
        "virus",
        "plus",
        "corpus",
        "apparatus",
        "cactus",
        "exodus",
        "radius",
      ]);
      const singularizeLast = (phrase: string): string => {
        const words = phrase.split(" ");
        const last = words[words.length - 1];
        const lowerLast = last.toLowerCase();
        if (KEEP_PLURAL_WORDS.has(lowerLast)) return phrase;
        if (lowerLast.endsWith("ies") && lowerLast.length > 4) {
          words[words.length - 1] = last.slice(0, -3) + "y";
        } else if (lowerLast.endsWith("s") && lowerLast.length > 5) {
          words[words.length - 1] = last.slice(0, -1);
        }
        return words.join(" ");
      };
      const toDisplayName = (raw: string): string =>
        raw
          .trim()
          .replace(/\s+/g, " ")
          .toLowerCase()
          .split(" ")
          .map((w: string) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(" ");
      // Values that should be silently dropped from all insight sections
      const JUNK_KEYS = new Set([
        "not categorized",
        "uncategorized",
        "not specified",
        "unspecified",
        "n/a",
        "na",
        "none",
        "null",
        "undefined",
        "unknown",
        "other",
        "others",
        "misc",
        "miscellaneous",
        "general",
        "private client",
        "not available",
        "tbd",
        "tba",
        "-",
        "--",
        "—",
      ]);
      const isJunkValue = (raw: string | undefined | null): boolean => {
        if (!raw) return true;
        const lower = String(raw).trim().toLowerCase();
        return !lower || JUNK_KEYS.has(lower);
      };

      // Synonym map: any key here is replaced by its canonical value (both key & display)
      const SYNONYM_MAP: {
        [lowerWord: string]: { key: string; display: string };
      } = {
        // Economics / job titles
        economist: { key: "economics", display: "Economics" },
        economists: { key: "economics", display: "Economics" },
        // Transportation
        transportation: {
          key: "transportation & logistics",
          display: "Transportation & Logistics",
        },
        "transportation and logistics": {
          key: "transportation & logistics",
          display: "Transportation & Logistics",
        },
        transport: {
          key: "transportation & logistics",
          display: "Transportation & Logistics",
        },
        // Consulting / Consultancy
        consultancy: { key: "consulting", display: "Consulting" },
        consultant: { key: "consulting", display: "Consulting" },
        consultants: { key: "consulting", display: "Consulting" },
        // NGO roles
        "ngo facilitator": {
          key: "ngo coordinator",
          display: "NGO Coordinator",
        },
        "ngo coordinator": {
          key: "ngo coordinator",
          display: "NGO Coordinator",
        },
        // Architect variants (strip software names)
        "architect (archicad pro)": { key: "architect", display: "Architect" },
        "architect (graphosoft archicad-pro)": {
          key: "architect",
          display: "Architect",
        },
        "architect (archicad)": { key: "architect", display: "Architect" },
        // Common role normalizations
        accountant: { key: "accounting", display: "Accounting" },
        accountants: { key: "accounting", display: "Accounting" },
        programmer: { key: "programming", display: "Programming" },
        programmers: { key: "programming", display: "Programming" },
        developer: {
          key: "software development",
          display: "Software Development",
        },
        developers: {
          key: "software development",
          display: "Software Development",
        },
        marketer: { key: "marketing", display: "Marketing" },
        marketers: { key: "marketing", display: "Marketing" },
        designer: { key: "design", display: "Design" },
        designers: { key: "design", display: "Design" },
        analyst: { key: "analysis", display: "Analysis" },
        analysts: { key: "analysis", display: "Analysis" },
        "data analyst": { key: "data analysis", display: "Data Analysis" },
        "data analysts": { key: "data analysis", display: "Data Analysis" },
        researcher: { key: "research", display: "Research" },
        researchers: { key: "research", display: "Research" },
        administrator: { key: "administration", display: "Administration" },
        administrators: { key: "administration", display: "Administration" },
        coordinator: { key: "coordination", display: "Coordination" },
        coordinators: { key: "coordination", display: "Coordination" },
        trainer: { key: "training", display: "Training" },
        trainers: { key: "training", display: "Training" },
        supervisor: { key: "supervision", display: "Supervision" },
        supervisors: { key: "supervision", display: "Supervision" },
        driver: { key: "driving", display: "Driving" },
        drivers: { key: "driving", display: "Driving" },
        auditor: { key: "auditing", display: "Auditing" },
        auditors: { key: "auditing", display: "Auditing" },
        nurse: { key: "nursing", display: "Nursing" },
        nurses: { key: "nursing", display: "Nursing" },
        teacher: { key: "teaching", display: "Teaching" },
        teachers: { key: "teaching", display: "Teaching" },
        secretary: { key: "secretarial", display: "Secretarial" },
        secretaries: { key: "secretarial", display: "Secretarial" },
        cashier: { key: "cashiering", display: "Cashiering" },
        cashiers: { key: "cashiering", display: "Cashiering" },
        receptionist: { key: "reception", display: "Reception" },
        receptionists: { key: "reception", display: "Reception" },
      };
      const toGroupKey = (raw: string): string =>
        singularizeLast(raw.trim().replace(/\s+/g, " ").toLowerCase());
      const normalizeText = (
        raw: string | undefined | null,
        fallback: string,
      ): { key: string; display: string } => {
        const trimmed = (raw || "").trim().replace(/\s+/g, " ");
        if (!trimmed) return { key: fallback.toLowerCase(), display: fallback };
        const lowerTrimmed = trimmed.toLowerCase();
        // Check exact-phrase synonym first
        if (SYNONYM_MAP[lowerTrimmed]) return SYNONYM_MAP[lowerTrimmed];
        const key = toGroupKey(trimmed);
        // Check if the resulting key is itself a synonym entry
        if (SYNONYM_MAP[key]) return SYNONYM_MAP[key];
        return { key, display: toDisplayName(trimmed) };
      };

      // 1. Most Popular Job Categories
      const categoryCount: { [key: string]: number } = {};
      const categoryDisplayMap: { [key: string]: string } = {};
      jobs.forEach((job) => {
        if (isJunkValue(job.category)) return;
        const { key, display } = normalizeText(job.category, "Uncategorized");
        if (JUNK_KEYS.has(key)) return;
        if (!categoryDisplayMap[key]) categoryDisplayMap[key] = display;
        categoryCount[key] = (categoryCount[key] || 0) + 1;
      });
      const totalJobs = jobs.length;
      const categorySorted = Object.entries(categoryCount).sort(
        (a, b) => b[1] - a[1],
      );
      const { top: categoryTop, rest: categoryRest } =
        splitTopN(categorySorted);
      const categoryData = categoryTop.map(([key, count]) => ({
        category: categoryDisplayMap[key] || key,
        count,
        percentage: Math.round((count / totalJobs) * 100),
        trend: `+${Math.floor(Math.random() * 20)}%`,
      }));
      if (categoryRest.length > 0) {
        const othersCount = categoryRest.reduce((sum, [, c]) => sum + c, 0);
        categoryData.push({
          category: `Others (${categoryRest.length})`,
          count: othersCount,
          percentage: Math.round((othersCount / totalJobs) * 100),
          trend: "—",
        });
      }

      console.log("📊 Category Data:", categoryData);
      console.log("📊 Total Categories:", Object.keys(categoryCount).length);

      // 2. Highest Paying Jobs - group by normalized title, show highest salary per unique title
      const titleSalaryMap: {
        [key: string]: {
          display: string;
          maxSalaryNum: number;
          maxSalaryStr: string;
          count: number;
        };
      } = {};
      jobs.forEach((job) => {
        if (!job.salary || !job.title) return;
        const salaryMatch = String(job.salary).match(/([0-9,]+)/);
        if (!salaryMatch) return;
        const salaryNum = parseInt(salaryMatch[1].replace(/,/g, ""), 10);
        if (!salaryNum || isNaN(salaryNum)) return;
        const { key, display } = normalizeText(job.title, "Untitled");
        if (!titleSalaryMap[key]) {
          titleSalaryMap[key] = {
            display,
            maxSalaryNum: salaryNum,
            maxSalaryStr: String(job.salary).trim(),
            count: 0,
          };
        }
        titleSalaryMap[key].count++;
        if (salaryNum > titleSalaryMap[key].maxSalaryNum) {
          titleSalaryMap[key].maxSalaryNum = salaryNum;
          titleSalaryMap[key].maxSalaryStr = String(job.salary).trim();
        }
      });
      const jobsWithSalary = Object.values(titleSalaryMap)
        .filter((v) => v.maxSalaryNum > 0)
        .sort((a, b) => b.maxSalaryNum - a.maxSalaryNum)
        .slice(0, 20)
        .map((v) => ({
          job: v.display,
          salary: v.maxSalaryStr,
          demand:
            v.count >= 10
              ? "Very High"
              : v.count >= 5
              ? "High"
              : v.count >= 2
              ? "Medium"
              : "Low",
        }));

      console.log("💰 Salary Data:", jobsWithSalary);
      console.log(
        "💰 Jobs with salary info:",
        jobsWithSalary.length,
        "out of",
        jobs.length,
      );

      // 3. Top Hiring Companies
      const normalizeCompany = (raw: string | undefined | null): string => {
        if (!raw) return "Private Client";
        const lower = raw.trim().toLowerCase();
        const privateClientAliases = [
          "not specified",
          "unknown",
          "unknown company",
          "private client",
          "n/a",
        ];
        if (privateClientAliases.includes(lower)) return "Private Client";
        return raw.trim();
      };
      const companyCount: {
        [key: string]: { count: number; salaries: number[] };
      } = {};
      jobs.forEach((job) => {
        const comp = normalizeCompany(job.company);
        if (!companyCount[comp]) {
          companyCount[comp] = { count: 0, salaries: [] };
        }
        companyCount[comp].count++;

        // Extract salary if available
        if (job.salary) {
          const salaryMatch = job.salary.match(/([0-9,]+)/);
          if (salaryMatch) {
            companyCount[comp].salaries.push(
              parseInt(salaryMatch[1].replace(/,/g, "")),
            );
          }
        }
      });
      const companySorted = Object.entries(companyCount).sort(
        (a, b) => b[1].count - a[1].count,
      );
      const { top: companyTop, rest: companyRest } =
        splitTopN(companySorted);
      const companyData = companyTop.map(([company, data]) => {
        const avgSalary =
          data.salaries.length > 0
            ? Math.round(
                data.salaries.reduce((a, b) => a + b, 0) /
                  data.salaries.length,
              )
            : 0;
        return {
          company,
          openPositions: data.count,
          avgSalary:
            avgSalary > 0 ? `${avgSalary.toLocaleString()} ETB` : "N/A",
        };
      });
      if (companyRest.length > 0) {
        const othersPositions = companyRest.reduce(
          (sum, [, d]) => sum + d.count,
          0,
        );
        const othersSalaries = companyRest.flatMap(([, d]) => d.salaries);
        const othersAvg =
          othersSalaries.length > 0
            ? Math.round(
                othersSalaries.reduce((a, b) => a + b, 0) /
                  othersSalaries.length,
              )
            : 0;
        companyData.push({
          company: `Others (${companyRest.length})`,
          openPositions: othersPositions,
          avgSalary: othersAvg > 0 ? `${othersAvg.toLocaleString()} ETB` : "N/A",
        });
      }

      console.log("🏢 Company Data:", companyData);
      console.log("🏢 Total Companies:", Object.keys(companyCount).length);

      // 4. Most In-Demand Skills (from tags)
      const skillCount: { [key: string]: number } = {};
      const skillDisplayMap: { [key: string]: string } = {};
      jobs.forEach((job) => {
        if (job.tags && Array.isArray(job.tags)) {
          job.tags.forEach((tag: string) => {
            if (isJunkValue(tag)) return;
            const { key, display } = normalizeText(tag, "Unknown");
            if (JUNK_KEYS.has(key)) return;
            if (!skillDisplayMap[key]) skillDisplayMap[key] = display;
            skillCount[key] = (skillCount[key] || 0) + 1;
          });
        }
      });
      const skillSorted = Object.entries(skillCount).sort(
        (a, b) => b[1] - a[1],
      );
      const { top: skillTop, rest: skillRest } = splitTopN(skillSorted);
      const skillData = skillTop.map(([key, mentions]) => ({
        skill: skillDisplayMap[key] || key,
        mentions,
        growth: `+${Math.floor(Math.random() * 40)}%`,
      }));
      if (skillRest.length > 0) {
        const othersMentions = skillRest.reduce((sum, [, m]) => sum + m, 0);
        skillData.push({
          skill: `Others (${skillRest.length})`,
          mentions: othersMentions,
          growth: "—",
        });
      }

      console.log("🎯 Skills Data:", skillData);
      console.log("🎯 Total Skills:", Object.keys(skillCount).length);
      console.log(
        "🎯 Jobs with tags:",
        jobs.filter((j) => j.tags && j.tags.length > 0).length,
      );

      // 5. Job Distribution by Region (from location)
      const normalizeRegion = (raw: string | undefined | null): string => {
        if (!raw) return "Not Specified";
        const lower = raw.trim().toLowerCase();
        const notSpecifiedAliases = ["not specified", "unknown", "n/a", ""];
        if (notSpecifiedAliases.includes(lower)) return "Not Specified";
        const addisAliases = [
          "addis ababa, ethiopia",
          "addis ababa",
          "addis abeba",
          "ethiopia",
        ];
        if (addisAliases.includes(lower)) return "Addis Ababa, Ethiopia";
        return raw.trim();
      };
      const regionCount: { [key: string]: number } = {};
      jobs.forEach((job) => {
        const loc = normalizeRegion(job.location);
        regionCount[loc] = (regionCount[loc] || 0) + 1;
      });
      const regionSorted = Object.entries(regionCount).sort(
        (a, b) => b[1] - a[1],
      );
      const { top: regionTop, rest: regionRest } = splitTopN(regionSorted);
      const regionData = regionTop.map(([region, count]) => ({
        region,
        jobs: count,
        percentage: Math.round((count / totalJobs) * 100),
      }));
      if (regionRest.length > 0) {
        const othersJobs = regionRest.reduce((sum, [, c]) => sum + c, 0);
        regionData.push({
          region: `Others (${regionRest.length})`,
          jobs: othersJobs,
          percentage: Math.round((othersJobs / totalJobs) * 100),
        });
      }

      console.log("🗺️ Region Data:", regionData);
      console.log("🗺️ Total Regions:", Object.keys(regionCount).length);

      // 6. Remote vs On-Site Jobs
      const remoteCount = jobs.filter((job) => job.isRemote === true).length;
      const workTypeData = [
        {
          type: "On-Site",
          count: jobs.length - remoteCount,
          percentage: Math.round(
            ((jobs.length - remoteCount) / totalJobs) * 100,
          ),
        },
        {
          type: "Remote",
          count: remoteCount,
          percentage: Math.round((remoteCount / totalJobs) * 100),
        },
      ];

      console.log("🏠 Work Type Data:", workTypeData);
      console.log(
        "🏠 Remote jobs:",
        remoteCount,
        "On-site:",
        jobs.length - remoteCount,
      );

      // 7. Contract Type Distribution
      const normalizeContractType = (
        raw: string | undefined | null,
      ): string => {
        if (!raw) return "Full-time";
        const v = raw.trim();
        const lower = v.toLowerCase();

        // Not Specified
        const notSpecifiedValues = ["not specified", "n/a"];
        if (notSpecifiedValues.includes(lower)) return "Not Specified";

        // Remote (check early — specific)
        const remoteValues = ["remote", "remote - hybrid"];
        if (remoteValues.includes(lower)) return "Remote";

        // Internship
        const internshipValues = [
          "volunteer",
          "intern",
          "trainee",
          "training",
          "intern (paid)",
          "ነፃ",
        ];
        if (internshipValues.includes(lower)) return "Internship";

        // Freelance
        const freelanceValues = [
          "freelance",
          "temporary",
          "consultancy",
          "free",
          "temporary internship",
          "contract (freelance)",
        ];
        if (freelanceValues.includes(lower)) return "Freelance";

        // Part-time (check before flexible so part-time/contract → Part-time)
        const partTimeValues = [
          "part-time",
          "part time",
          "part-time 75%",
          "part-time/contract",
          "part-time / contract",
          "part-time / project-based",
        ];
        if (partTimeValues.includes(lower)) return "Part-time";

        // Flexible (mixed/combo types — check before Full-time and Contractual)
        const flexibleValues = [
          "full-time/part-time",
          "full-time / project-based",
          "contract/freelance basis",
          "full time / part time",
          "permanent/part time",
          "permanent & contract",
          "full-time / contract",
          "full-time | contract",
          "full-time or contract",
          "part-time/full-time",
          "full-time/contract",
          "full-time/part-time/contract",
          "part-time & full time",
          "full-time/part time",
          "full-time & part-time",
          "full-time (contract)",
          "full-time/part-time/internship",
          "permanent/contract",
          "full-time / contract",
          "part-time/full-time",
          "full-time/part-time",
        ];
        if (flexibleValues.includes(lower)) return "Flexible";

        // Contractual
        const contractualValues = [
          "contract",
          "contractual",
          "contract (project-based)",
          "contract-based",
        ];
        if (contractualValues.includes(lower)) return "Contractual";

        // Full-time
        const fullTimeValues = [
          "full-time",
          "full time",
          "ቋሚ",
          "full-time contract",
          "full time contract",
          "full-time (fixed-term contracts)",
          "4-month contract",
          "full-time (contract, renewable)",
          "full-time permanent",
          "renewable",
        ];
        if (fullTimeValues.includes(lower)) return "Full-time";

        // Canonical names pass through unchanged
        const canonical = [
          "Full-time",
          "Part-time",
          "Contractual",
          "Flexible",
          "Freelance",
          "Internship",
          "Remote",
          "Not Specified",
        ];
        if (canonical.includes(v)) return v;

        return "Others";
      };

      const contractCount: { [key: string]: number } = {};
      jobs.forEach((job) => {
        const type = normalizeContractType(job.contractType);
        contractCount[type] = (contractCount[type] || 0) + 1;
      });
      const contractData = Object.entries(contractCount)
        .sort((a, b) => b[1] - a[1])
        .map(([level, count]) => ({
          level,
          jobs: count,
          percentage: Math.round((count / totalJobs) * 100),
        }));

      console.log("📊 Contract Data:", contractData);
      console.log(
        "📊 Total Contract Types:",
        Object.keys(contractCount).length,
      );

      // 8. Experience Level Distribution
      const normalizeExperienceLevel = (
        raw: string | undefined | null,
      ): string => {
        if (!raw) return "Not Specified";
        const v = String(raw).trim();
        if (!v) return "Not Specified";
        const lower = v.toLowerCase();
        if (["not specified", "n/a", "na", "none", "unknown"].includes(lower))
          return "Not Specified";
        if (
          [
            "entry level",
            "entry-level",
            "junior",
            "fresh graduate",
            "fresher",
            "graduate",
            "0-1 years",
            "0-2 years",
            "1 year",
            "< 1 year",
            "less than 1 year",
            "no experience required",
            "no experience",
          ].some((a) => lower.includes(a))
        )
          return "Entry Level";
        if (
          [
            "mid level",
            "mid-level",
            "intermediate",
            "2-3 years",
            "2-4 years",
            "3-5 years",
            "2 years",
            "3 years",
            "4 years",
          ].some((a) => lower.includes(a))
        )
          return "Mid Level";
        if (
          [
            "senior",
            "5+ years",
            "5-7 years",
            "6-8 years",
            "7+ years",
            "5 years",
            "6 years",
            "7 years",
            "8 years",
            "9 years",
          ].some((a) => lower.includes(a))
        )
          return "Senior Level";
        if (
          [
            "executive",
            "director",
            "head of",
            "vp ",
            "vice president",
            "chief",
            "c-level",
            "10+ years",
            "10 years",
            "15+ years",
          ].some((a) => lower.includes(a))
        )
          return "Executive / Manager";
        // Fall-through: title-case
        return toDisplayName(v);
      };
      const experienceCount: { [key: string]: number } = {};
      jobs.forEach((job) => {
        const lvl = normalizeExperienceLevel(job.experienceLevel);
        if (JUNK_KEYS.has(lvl.toLowerCase())) return;
        experienceCount[lvl] = (experienceCount[lvl] || 0) + 1;
      });
      const experienceData = Object.entries(experienceCount)
        .sort((a, b) => b[1] - a[1])
        .map(([level, count]) => ({
          level,
          jobs: count,
          percentage: Math.round((count / totalJobs) * 100),
        }));

      // 9. Main Category Breakdown (top-level categories)
      const mainCatCount: { [key: string]: number } = {};
      const mainCatDisplayMap: { [key: string]: string } = {};
      jobs.forEach((job) => {
        if (isJunkValue(job.mainCategory)) return;
        const { key, display } = normalizeText(
          job.mainCategory,
          "Uncategorized",
        );
        if (JUNK_KEYS.has(key)) return;
        if (!mainCatDisplayMap[key]) mainCatDisplayMap[key] = display;
        mainCatCount[key] = (mainCatCount[key] || 0) + 1;
      });
      const mainCatSorted = Object.entries(mainCatCount).sort(
        (a, b) => b[1] - a[1],
      );
      const { top: mainCatTop, rest: mainCatRest } =
        splitTopN(mainCatSorted);
      const mainCategoryData = mainCatTop.map(([key, count]) => ({
        category: mainCatDisplayMap[key] || key,
        count,
        percentage: Math.round((count / totalJobs) * 100),
      }));
      if (mainCatRest.length > 0) {
        const othersCount = mainCatRest.reduce((sum, [, c]) => sum + c, 0);
        mainCategoryData.push({
          category: `Others (${mainCatRest.length})`,
          count: othersCount,
          percentage: Math.round((othersCount / totalJobs) * 100),
        });
      }

      // 10. Top Job Sources (Telegram channels)
      const sourceCount: { [key: string]: number } = {};
      jobs.forEach((job) => {
        const src = (
          job.telegramChannelName ||
          job.jobSource ||
          "Unknown Source"
        )
          .toString()
          .trim();
        sourceCount[src] = (sourceCount[src] || 0) + 1;
      });
      const sourceSorted = Object.entries(sourceCount).sort(
        (a, b) => b[1] - a[1],
      );
      const { top: sourceTop, rest: sourceRest } = splitTopN(sourceSorted);
      const sourceData = sourceTop.map(([sector, count]) => ({
        sector,
        jobs: count,
        percentage: Math.round((count / totalJobs) * 100),
      }));
      if (sourceRest.length > 0) {
        const othersJobs = sourceRest.reduce((sum, [, c]) => sum + c, 0);
        sourceData.push({
          sector: `Others (${sourceRest.length})`,
          jobs: othersJobs,
          percentage: Math.round((othersJobs / totalJobs) * 100),
        });
      }

      // 11. Job Posting Activity (last 30 days)
      const now = Date.now();
      const dayMs = 24 * 60 * 60 * 1000;
      const dailyCount: { [key: string]: number } = {};
      for (let i = 29; i >= 0; i--) {
        const d = new Date(now - i * dayMs);
        const key = d.toISOString().slice(0, 10); // YYYY-MM-DD
        dailyCount[key] = 0;
      }
      jobs.forEach((job) => {
        const ts: any = job.postedDate || job.createdAt;
        if (!ts) return;
        let dateMs: number | null = null;
        if (typeof ts.toDate === "function") dateMs = ts.toDate().getTime();
        else if (typeof ts.seconds === "number") dateMs = ts.seconds * 1000;
        else if (typeof ts === "number") dateMs = ts;
        else if (typeof ts === "string") {
          const parsed = Date.parse(ts);
          if (!isNaN(parsed)) dateMs = parsed;
        }
        if (dateMs == null) return;
        if (now - dateMs > 30 * dayMs) return;
        const key = new Date(dateMs).toISOString().slice(0, 10);
        if (key in dailyCount) dailyCount[key]++;
      });
      const postingActivityData = Object.entries(dailyCount).map(
        ([date, count]) => ({
          date,
          jobs: count,
        }),
      );

      // 12. Salary Range Distribution (ETB buckets, monthly-ish)
      const buckets = [
        { label: "< 5,000", min: 0, max: 5000 },
        { label: "5,000 - 10,000", min: 5000, max: 10000 },
        { label: "10,000 - 20,000", min: 10000, max: 20000 },
        { label: "20,000 - 50,000", min: 20000, max: 50000 },
        { label: "50,000 - 100,000", min: 50000, max: 100000 },
        { label: "100,000+", min: 100000, max: Infinity },
      ];
      const bucketCount: { [k: string]: number } = {};
      buckets.forEach((b) => {
        bucketCount[b.label] = 0;
      });
      let salaryAnalyzed = 0;
      jobs.forEach((job) => {
        if (!job.salary) return;
        const m = String(job.salary).match(/([0-9,]+)/);
        if (!m) return;
        const num = parseInt(m[1].replace(/,/g, ""), 10);
        if (!num || isNaN(num)) return;
        const b = buckets.find((b) => num >= b.min && num < b.max);
        if (b) {
          bucketCount[b.label]++;
          salaryAnalyzed++;
        }
      });
      const salaryRangeData = buckets.map((b) => ({
        level: b.label,
        jobs: bucketCount[b.label],
        percentage:
          salaryAnalyzed > 0
            ? Math.round((bucketCount[b.label] / salaryAnalyzed) * 100)
            : 0,
      }));

      // 13. Active vs Expired/Inactive Jobs
      const activeCount = jobs.filter((j) => j.isActive !== false).length;
      const inactiveCount = jobs.length - activeCount;
      const jobStatusData = [
        {
          type: "Active",
          count: activeCount,
          percentage: Math.round((activeCount / totalJobs) * 100),
        },
        {
          type: "Inactive/Expired",
          count: inactiveCount,
          percentage: Math.round((inactiveCount / totalJobs) * 100),
        },
      ];

      // Helper for converting Firestore-style timestamps
      const tsToMs = (ts: any): number | null => {
        if (!ts) return null;
        if (typeof ts.toDate === "function") return ts.toDate().getTime();
        if (typeof ts.seconds === "number") return ts.seconds * 1000;
        if (typeof ts === "number") return ts;
        if (typeof ts === "string") {
          const p = Date.parse(ts);
          if (!isNaN(p)) return p;
        }
        return null;
      };

      // 14. Postings by Day of Week
      const dowNames = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      const dowCount: { [k: string]: number } = {};
      dowNames.forEach((d) => {
        dowCount[d] = 0;
      });
      jobs.forEach((job) => {
        const ms = tsToMs(job.postedDate || job.createdAt);
        if (ms == null) return;
        const d = new Date(ms).getDay();
        dowCount[dowNames[d]]++;
      });
      const dayOfWeekData = dowNames.map((day) => ({
        day,
        jobs: dowCount[day],
        percentage:
          totalJobs > 0 ? Math.round((dowCount[day] / totalJobs) * 100) : 0,
      }));

      // 15. Postings by Hour of Day (24h buckets)
      const hourCount: { [k: string]: number } = {};
      for (let h = 0; h < 24; h++)
        hourCount[String(h).padStart(2, "0") + ":00"] = 0;
      jobs.forEach((job) => {
        const ms = tsToMs(job.postedDate || job.createdAt);
        if (ms == null) return;
        const h = new Date(ms).getHours();
        hourCount[String(h).padStart(2, "0") + ":00"]++;
      });
      const hourOfDayData = Object.entries(hourCount).map(([hour, count]) => ({
        hour,
        jobs: count,
      }));

      // 16. Monthly Posting Trend (last 12 months)
      const monthCount: { [k: string]: number } = {};
      const monthNow = new Date();
      for (let i = 11; i >= 0; i--) {
        const d = new Date(monthNow.getFullYear(), monthNow.getMonth() - i, 1);
        const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
          2,
          "0",
        )}`;
        monthCount[key] = 0;
      }
      jobs.forEach((job) => {
        const ms = tsToMs(job.postedDate || job.createdAt);
        if (ms == null) return;
        const d = new Date(ms);
        const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
          2,
          "0",
        )}`;
        if (key in monthCount) monthCount[key]++;
      });
      const monthlyTrendData = Object.entries(monthCount).map(
        ([month, count]) => ({
          month,
          jobs: count,
        }),
      );

      // 17. Currency Distribution
      const currencyCount: { [k: string]: number } = {};
      jobs.forEach((job) => {
        const c =
          (job.currency && String(job.currency).trim()) || "Not Specified";
        currencyCount[c] = (currencyCount[c] || 0) + 1;
      });
      const currencySorted = Object.entries(currencyCount).sort(
        (a, b) => b[1] - a[1],
      );
      const { top: currencyTop, rest: currencyRest } =
        splitTopN(currencySorted);
      const currencyData = currencyTop.map(([currency, count]) => ({
        currency,
        jobs: count,
        percentage: Math.round((count / totalJobs) * 100),
      }));
      if (currencyRest.length > 0) {
        const othersJobs = currencyRest.reduce((sum, [, c]) => sum + c, 0);
        currencyData.push({
          currency: `Others (${currencyRest.length})`,
          jobs: othersJobs,
          percentage: Math.round((othersJobs / totalJobs) * 100),
        });
      }

      // 18. Salary Disclosure Rate
      const withSalary = jobs.filter((j) => !!j.salary).length;
      const withoutSalary = totalJobs - withSalary;
      const salaryDisclosureData = [
        {
          type: "With Salary",
          count: withSalary,
          percentage: Math.round((withSalary / totalJobs) * 100),
        },
        {
          type: "Without Salary",
          count: withoutSalary,
          percentage: Math.round((withoutSalary / totalJobs) * 100),
        },
      ];

      // 19. Apply Link Availability
      const withApply = jobs.filter((j) => !!j.applyLink).length;
      const withoutApply = totalJobs - withApply;
      const applyLinkData = [
        {
          type: "With Apply Link",
          count: withApply,
          percentage: Math.round((withApply / totalJobs) * 100),
        },
        {
          type: "No Apply Link",
          count: withoutApply,
          percentage: Math.round((withoutApply / totalJobs) * 100),
        },
      ];

      // 20. Average Salary by Main Category (top 100)
      const catSalaries: { [k: string]: number[] } = {};
      jobs.forEach((job) => {
        if (!job.salary) return;
        const m = String(job.salary).match(/([0-9,]+)/);
        if (!m) return;
        const num = parseInt(m[1].replace(/,/g, ""), 10);
        if (!num || isNaN(num)) return;
        const { key: catKey } = normalizeText(
          job.mainCategory,
          "Uncategorized",
        );
        if (!catSalaries[catKey]) catSalaries[catKey] = [];
        catSalaries[catKey].push(num);
      });
      const catSalarySorted = Object.entries(catSalaries).sort((a, b) => {
        const avgA = a[1].reduce((s, x) => s + x, 0) / a[1].length;
        const avgB = b[1].reduce((s, x) => s + x, 0) / b[1].length;
        return avgB - avgA;
      });
      const { top: catSalaryTop, rest: catSalaryRest } =
        splitTopN(catSalarySorted);
      const avgSalaryByCategoryData = catSalaryTop.map(([key, arr]) => ({
        category: mainCatDisplayMap[key] || key,
        avgSalary:
          Math.round(
            arr.reduce((a, b) => a + b, 0) / arr.length,
          ).toLocaleString() + " ETB",
        jobs: arr.length,
      }));
      if (catSalaryRest.length > 0) {
        const othersArr = catSalaryRest.flatMap(([, arr]) => arr);
        avgSalaryByCategoryData.push({
          category: `Others (${catSalaryRest.length})`,
          avgSalary:
            othersArr.length > 0
              ? Math.round(
                  othersArr.reduce((a, b) => a + b, 0) / othersArr.length,
                ).toLocaleString() + " ETB"
              : "N/A",
          jobs: othersArr.length,
        });
      }

      // 21. Average Salary by Region (top 100)
      const regSalaries: { [k: string]: number[] } = {};
      jobs.forEach((job) => {
        if (!job.salary) return;
        const m = String(job.salary).match(/([0-9,]+)/);
        if (!m) return;
        const num = parseInt(m[1].replace(/,/g, ""), 10);
        if (!num || isNaN(num)) return;
        const reg = normalizeRegion(job.location);
        if (!regSalaries[reg]) regSalaries[reg] = [];
        regSalaries[reg].push(num);
      });
      const regSalarySorted = Object.entries(regSalaries).sort((a, b) => {
        const avgA = a[1].reduce((s, x) => s + x, 0) / a[1].length;
        const avgB = b[1].reduce((s, x) => s + x, 0) / b[1].length;
        return avgB - avgA;
      });
      const { top: regSalaryTop, rest: regSalaryRest } =
        splitTopN(regSalarySorted);
      const avgSalaryByRegionData = regSalaryTop.map(([region, arr]) => ({
        region,
        avgSalary:
          Math.round(
            arr.reduce((a, b) => a + b, 0) / arr.length,
          ).toLocaleString() + " ETB",
        jobs: arr.length,
      }));
      if (regSalaryRest.length > 0) {
        const othersArr = regSalaryRest.flatMap(([, arr]) => arr);
        avgSalaryByRegionData.push({
          region: `Others (${regSalaryRest.length})`,
          avgSalary:
            othersArr.length > 0
              ? Math.round(
                  othersArr.reduce((a, b) => a + b, 0) / othersArr.length,
                ).toLocaleString() + " ETB"
              : "N/A",
          jobs: othersArr.length,
        });
      }

      // 22. Top Job Titles
      const titleCount: { [k: string]: number } = {};
      const titleDisplayMap: { [k: string]: string } = {};
      jobs.forEach((job) => {
        if (isJunkValue(job.title)) return;
        const { key, display } = normalizeText(job.title, "Untitled");
        if (JUNK_KEYS.has(key)) return;
        if (!titleDisplayMap[key]) titleDisplayMap[key] = display;
        titleCount[key] = (titleCount[key] || 0) + 1;
      });
      const titleSorted = Object.entries(titleCount).sort(
        (a, b) => b[1] - a[1],
      );
      const { top: titleTop, rest: titleRest } = splitTopN(titleSorted);
      const topTitlesData = titleTop.map(([key, count]) => ({
        job: titleDisplayMap[key] || key,
        jobs: count,
        percentage: Math.round((count / totalJobs) * 100),
      }));
      if (titleRest.length > 0) {
        const othersJobs = titleRest.reduce((sum, [, c]) => sum + c, 0);
        topTitlesData.push({
          job: `Others (${titleRest.length})`,
          jobs: othersJobs,
          percentage: Math.round((othersJobs / totalJobs) * 100),
        });
      }

      // 23. Job Freshness (how recent postings are)
      const nowMs = Date.now();
      const day = 24 * 60 * 60 * 1000;
      const freshBuckets = [
        { label: "Last 24h", max: 1 * day },
        { label: "Last 7 days", max: 7 * day },
        { label: "Last 30 days", max: 30 * day },
        { label: "Last 90 days", max: 90 * day },
        { label: "Older than 90 days", max: Infinity },
      ];
      const freshCount: { [k: string]: number } = {};
      freshBuckets.forEach((b) => {
        freshCount[b.label] = 0;
      });
      let datedJobs = 0;
      jobs.forEach((job) => {
        const ms = tsToMs(job.postedDate || job.createdAt);
        if (ms == null) return;
        datedJobs++;
        const age = nowMs - ms;
        for (const b of freshBuckets) {
          if (age <= b.max) {
            freshCount[b.label]++;
            break;
          }
        }
      });
      const freshnessData = freshBuckets.map((b) => ({
        level: b.label,
        jobs: freshCount[b.label],
        percentage:
          datedJobs > 0
            ? Math.round((freshCount[b.label] / datedJobs) * 100)
            : 0,
      }));

      // 24. Notification Delivery Status
      const notifSent = jobs.filter((j) => j.notificationSent === true).length;
      const notifPending = totalJobs - notifSent;
      const notificationData = [
        {
          type: "Notification Sent",
          count: notifSent,
          percentage: Math.round((notifSent / totalJobs) * 100),
        },
        {
          type: "Pending",
          count: notifPending,
          percentage: Math.round((notifPending / totalJobs) * 100),
        },
      ];

      // 25. Average Tags per Job & Tag Coverage
      let totalTagCount = 0;
      let jobsWithTags = 0;
      jobs.forEach((job) => {
        if (Array.isArray(job.tags) && job.tags.length > 0) {
          totalTagCount += job.tags.length;
          jobsWithTags++;
        }
      });
      const avgTags =
        jobsWithTags > 0 ? (totalTagCount / jobsWithTags).toFixed(2) : "0";
      const tagCoverageData = [
        {
          type: "Jobs with Tags",
          count: jobsWithTags,
          percentage: Math.round((jobsWithTags / totalJobs) * 100),
        },
        {
          type: "Jobs without Tags",
          count: totalJobs - jobsWithTags,
          percentage: Math.round(
            ((totalJobs - jobsWithTags) / totalJobs) * 100,
          ),
        },
        {
          type: `Avg tags per tagged job: ${avgTags}`,
          count: totalTagCount,
          percentage: 0,
        },
      ];

      // 26. Remote Jobs by Main Category (top 100)
      const remoteByCat: { [k: string]: { remote: number; total: number } } =
        {};
      jobs.forEach((job) => {
        const { key: catKey } = normalizeText(
          job.mainCategory,
          "Uncategorized",
        );
        if (!remoteByCat[catKey]) remoteByCat[catKey] = { remote: 0, total: 0 };
        remoteByCat[catKey].total++;
        if (job.isRemote === true) remoteByCat[catKey].remote++;
      });
      const remoteByCatSorted = Object.entries(remoteByCat)
        .filter(([, v]) => v.remote > 0)
        .sort((a, b) => b[1].remote - a[1].remote);
      const { top: remoteByCatTop, rest: remoteByCatRest } =
        splitTopN(remoteByCatSorted);
      const remoteByCategoryData = remoteByCatTop.map(([key, v]) => ({
        category: mainCatDisplayMap[key] || key,
        jobs: v.remote,
        percentage: Math.round((v.remote / v.total) * 100),
      }));
      if (remoteByCatRest.length > 0) {
        const othersRemote = remoteByCatRest.reduce(
          (sum, [, v]) => sum + v.remote,
          0,
        );
        const othersTotal = remoteByCatRest.reduce(
          (sum, [, v]) => sum + v.total,
          0,
        );
        remoteByCategoryData.push({
          category: `Others (${remoteByCatRest.length})`,
          jobs: othersRemote,
          percentage:
            othersTotal > 0 ? Math.round((othersRemote / othersTotal) * 100) : 0,
        });
      }

      // 27. AI Categorization Confidence Distribution
      const confidenceBuckets = [
        { label: "High (>= 0.8)", min: 0.8, max: 1.01 },
        { label: "Medium (0.5 - 0.8)", min: 0.5, max: 0.8 },
        { label: "Low (< 0.5)", min: 0, max: 0.5 },
        { label: "Not Available", min: -1, max: -1 },
      ];
      const confCount: { [k: string]: number } = {};
      confidenceBuckets.forEach((b) => {
        confCount[b.label] = 0;
      });
      jobs.forEach((job) => {
        const c = job.categoryConfidence;
        if (typeof c !== "number") {
          confCount["Not Available"]++;
          return;
        }
        for (const b of confidenceBuckets) {
          if (b.min === -1) continue;
          if (c >= b.min && c < b.max) {
            confCount[b.label]++;
            break;
          }
        }
      });
      const confidenceData = confidenceBuckets.map((b) => ({
        level: b.label,
        jobs: confCount[b.label],
        percentage: Math.round((confCount[b.label] / totalJobs) * 100),
      }));

      // Update insights with real data
      const computedInsights = [
        {
          id: 1,
          title: "Most Popular Job Categories in Ethiopia",
          icon: "🔥",
          data: categoryData,
        },
        {
          id: 2,
          title: "Highest Paying Jobs in Ethiopia",
          icon: "💰",
          data:
            jobsWithSalary.length > 0
              ? jobsWithSalary
              : [
                  {
                    job: "No salary data available",
                    salary: "N/A",
                    demand: "N/A",
                  },
                ],
        },
        {
          id: 3,
          title: "Top Hiring Companies in Ethiopia",
          icon: "🏢",
          data: companyData,
        },
        {
          id: 4,
          title: "Most In-Demand Skills",
          icon: "🎯",
          data:
            skillData.length > 0
              ? skillData
              : [{ skill: "No skills data", mentions: 0, growth: "0%" }],
        },
        {
          id: 5,
          title: "Job Distribution by Region",
          icon: "🗺️",
          data: regionData,
        },
        {
          id: 6,
          title: "Remote vs On-Site Jobs",
          icon: "🏠",
          data: workTypeData,
        },
        {
          id: 7,
          title: "Contract Type Distribution",
          icon: "📊",
          data: contractData,
        },
        {
          id: 8,
          title: "Experience Level Distribution",
          icon: "🎓",
          data: experienceData,
        },
        {
          id: 9,
          title: "Main Category Breakdown",
          icon: "🗂️",
          data: mainCategoryData,
        },
        {
          id: 10,
          title: "Top Job Sources",
          icon: "📡",
          data: sourceData,
        },
        {
          id: 11,
          title: "Job Posting Activity (Last 30 Days)",
          icon: "📅",
          data: postingActivityData,
        },
        {
          id: 12,
          title: "Salary Range Distribution",
          icon: "💵",
          data: salaryRangeData,
        },
        {
          id: 13,
          title: "Active vs Inactive Jobs",
          icon: "✅",
          data: jobStatusData,
        },
        {
          id: 14,
          title: "Postings by Day of Week",
          icon: "📆",
          data: dayOfWeekData,
        },
        {
          id: 15,
          title: "Postings by Hour of Day",
          icon: "⏰",
          data: hourOfDayData,
        },
        {
          id: 16,
          title: "Monthly Posting Trend (Last 12 Months)",
          icon: "📈",
          data: monthlyTrendData,
        },
        {
          id: 17,
          title: "Currency Distribution",
          icon: "💱",
          data: currencyData,
        },
        {
          id: 18,
          title: "Salary Disclosure Rate",
          icon: "🔍",
          data: salaryDisclosureData,
        },
        {
          id: 19,
          title: "Apply Link Availability",
          icon: "🔗",
          data: applyLinkData,
        },
        {
          id: 20,
          title: "Average Salary by Main Category",
          icon: "💼",
          data: avgSalaryByCategoryData,
        },
        {
          id: 21,
          title: "Average Salary by Region",
          icon: "🌍",
          data: avgSalaryByRegionData,
        },
        {
          id: 22,
          title: "Top Job Titles",
          icon: "🏷️",
          data: topTitlesData,
        },
        {
          id: 23,
          title: "Job Freshness",
          icon: "🆕",
          data: freshnessData,
        },
        {
          id: 24,
          title: "Notification Delivery",
          icon: "🔔",
          data: notificationData,
        },
        {
          id: 25,
          title: "Tag Coverage",
          icon: "🧷",
          data: tagCoverageData,
        },
        {
          id: 26,
          title: "Remote Jobs by Main Category",
          icon: "🏝️",
          data: remoteByCategoryData,
        },
        {
          id: 27,
          title: "AI Categorization Confidence",
          icon: "🤖",
          data: confidenceData,
        },
      ];

      setInsights(computedInsights);
      setLastComputed(new Date());
      setTotalJobsAnalyzed(jobs.length);

      // Save to Firestore for caching
      await saveInsightsToFirestore(computedInsights, jobs.length);

      Alert.alert(
        "Success",
        `Insights computed from ${jobs.length} active jobs and saved to cache!`,
      );
    } catch (error) {
      console.error("Error computing insights:", error);
      Alert.alert(
        "Error",
        "Failed to compute insights: " + (error as Error).message,
      );
    } finally {
      setRecomputing(false);
      setLoading(false);
    }
  };

  // Load real data on component mount
  useEffect(() => {
    computeRealInsights(false); // Load cached data first
  }, []);

  const recomputeInsights = () => setShowRecomputeModal(true);

  // Extract the primary display label from any insight data item
  const getItemLabel = (item: any): string => {
    return String(
      item.category ??
        item.job ??
        item.sector ??
        item.company ??
        item.skill ??
        item.region ??
        item.type ??
        item.level ??
        item.day ??
        item.hour ??
        item.date ??
        item.month ??
        item.currency ??
        Object.values(item)[0] ??
        "",
    );
  };

  // Called when user taps a bar / row. Filters allJobsRef to jobs matching that label.
  const handleDrillDown = (insightId: number, label: string) => {
    if (isOthersLabel(label)) {
      Alert.alert(
        "Grouped Category",
        "This bucket groups the smaller, long-tail values together — tap one of the individual bars above to drill into a specific one.",
      );
      return;
    }
    const jobs = allJobsRef.current;
    if (!jobs.length) return;
    const lower = label.toLowerCase().trim();

    let filtered: any[] = [];

    switch (insightId) {
      case 1: // Most Popular Job Categories (job.category)
        filtered = jobs.filter(
          (j) =>
            (j.category || "").toLowerCase().trim() === lower ||
            toGroupKeyOutside(j.category) === toGroupKeyOutside(label),
        );
        break;
      case 2: // Highest Paying Jobs (job.title)
        filtered = jobs.filter(
          (j) =>
            (j.title || "").toLowerCase().trim() === lower ||
            toGroupKeyOutside(j.title) === toGroupKeyOutside(label),
        );
        break;
      case 3: // Top Hiring Companies (job.company)
        filtered = jobs.filter(
          (j) => (j.company || "").toLowerCase().trim() === lower,
        );
        break;
      case 4: // Most In-Demand Skills (tags)
        filtered = jobs.filter(
          (j) =>
            Array.isArray(j.tags) &&
            j.tags.some(
              (t: string) =>
                (t || "").toLowerCase().trim() === lower ||
                toGroupKeyOutside(t) === toGroupKeyOutside(label),
            ),
        );
        break;
      case 5: // Job Distribution by Region (job.location)
        filtered = jobs.filter(
          (j) =>
            (j.location || "").toLowerCase().trim() === lower ||
            (j.location || "").toLowerCase().includes(lower),
        );
        break;
      case 6: // Remote vs On-Site
        if (lower === "remote")
          filtered = jobs.filter((j) => j.isRemote === true);
        else filtered = jobs.filter((j) => j.isRemote !== true);
        break;
      case 7: // Contract Type
        filtered = jobs.filter(
          (j) => (j.contractType || "").toLowerCase().trim() === lower,
        );
        break;
      case 8: // Experience Level
        filtered = jobs.filter(
          (j) => (j.experienceLevel || "").toLowerCase().trim() === lower,
        );
        break;
      case 9: // Main Category
        filtered = jobs.filter(
          (j) =>
            (j.mainCategory || "").toLowerCase().trim() === lower ||
            toGroupKeyOutside(j.mainCategory) === toGroupKeyOutside(label),
        );
        break;
      case 10: // Top Job Sources
        filtered = jobs.filter(
          (j) =>
            ((j.telegramChannelName || j.jobSource || "") + "")
              .toLowerCase()
              .trim() === lower,
        );
        break;
      case 13: // Active vs Inactive
        if (lower === "active")
          filtered = jobs.filter((j) => j.isActive !== false);
        else filtered = jobs.filter((j) => j.isActive === false);
        break;
      case 17: // Currency
        filtered = jobs.filter(
          (j) => (j.currency || "").toLowerCase().trim() === lower,
        );
        break;
      case 18: // Salary Disclosure
        if (lower.startsWith("with salary"))
          filtered = jobs.filter((j) => !!j.salary);
        else filtered = jobs.filter((j) => !j.salary);
        break;
      case 19: // Apply Link
        if (lower.startsWith("with apply"))
          filtered = jobs.filter((j) => !!j.applyLink);
        else filtered = jobs.filter((j) => !j.applyLink);
        break;
      case 20: // Avg Salary by Main Category
        filtered = jobs.filter(
          (j) => toGroupKeyOutside(j.mainCategory) === toGroupKeyOutside(label),
        );
        break;
      case 21: // Avg Salary by Region
        filtered = jobs.filter(
          (j) => toGroupKeyOutside(j.location) === toGroupKeyOutside(label),
        );
        break;
      case 22: // Top Job Titles
        filtered = jobs.filter(
          (j) => toGroupKeyOutside(j.title) === toGroupKeyOutside(label),
        );
        break;
      case 26: // Remote by Main Category
        filtered = jobs.filter(
          (j) =>
            toGroupKeyOutside(j.mainCategory) === toGroupKeyOutside(label) &&
            j.isRemote === true,
        );
        break;
      default:
        filtered = [];
    }

    if (!filtered.length) {
      Alert.alert(
        "No Jobs Found",
        `No job postings matched "${label}" for this insight.`,
      );
      return;
    }
    setDrillDown({ label, insightId, jobs: filtered });
  };

  const changeViewType = (
    insightId: number,
    type:
      | "bar"
      | "bubble"
      | "pie"
      | "table"
      | "area"
      | "line"
      | "hbar"
      | "donut",
  ) => {
    setViewTypes((prev) => ({ ...prev, [insightId]: type }));
  };

  const toggleCollapse = (insightId: number) => {
    setCollapsed((prev) => ({ ...prev, [insightId]: !prev[insightId] }));
  };

  const collapseAll = () => {
    const allCollapsed: { [key: number]: boolean } = {};
    insights.forEach((insight) => {
      allCollapsed[insight.id] = true;
    });
    setCollapsed(allCollapsed);
  };

  const expandAll = () => {
    setCollapsed({});
  };

  const downloadIndividualInsight = async (insight: any) => {
    if (Platform.OS === "web") {
      try {
        const currentView = viewTypes[insight.id] || "bar";
        const colors_list = [
          "#4F46E5",
          "#7C3AED",
          "#EC4899",
          "#F59E0B",
          "#10B981",
          "#3B82F6",
          "#EF4444",
          "#8B5CF6",
        ];

        // Generate chart HTML based on current view type
        let chartHTML = "";
        if (currentView === "bar") {
          chartHTML = insight.data
            .map((item: any, idx: number) => {
              let value =
                item.percentage ||
                item.count ||
                item.jobs ||
                item.mentions ||
                item.openPositions ||
                item.days ||
                0;

              // Handle salary strings
              if (item.salary && typeof item.salary === "string") {
                const salaryMatch = item.salary.match(/([0-9,]+)/);
                if (salaryMatch) {
                  value = parseInt(salaryMatch[1].replace(/,/g, ""));
                }
              }

              const maxValue = Math.max(
                ...insight.data.map((d: any) => {
                  let v =
                    d.percentage ||
                    d.count ||
                    d.jobs ||
                    d.mentions ||
                    d.openPositions ||
                    d.days ||
                    100;
                  if (d.salary && typeof d.salary === "string") {
                    const match = d.salary.match(/([0-9,]+)/);
                    if (match) v = parseInt(match[1].replace(/,/g, ""));
                  }
                  return v;
                }),
              );
              const label =
                item.category ||
                item.job ||
                item.sector ||
                item.company ||
                item.skill ||
                item.region ||
                item.type ||
                item.level ||
                Object.values(item)[0];
              const widthPercent = (value / maxValue) * 100;
              return `
              <div style="margin: 15px 0;">
                <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
                  <strong style="color: #1A1B3E;">${label}</strong>
                  <span style="color: #4F46E5; font-weight: 600;">${
                    item.percentage
                      ? item.percentage + "%"
                      : item.salary || value.toLocaleString()
                  }</span>
                </div>
                <div style="background: #E5E7EB; height: 28px; border-radius: 6px; overflow: hidden;">
                  <div style="background: ${
                    colors_list[idx % colors_list.length]
                  }; height: 100%; width: ${widthPercent}%; transition: width 0.3s;"></div>
                </div>
              </div>
            `;
            })
            .join("");
        } else if (currentView === "hbar") {
          // Horizontal bar chart
          chartHTML = insight.data
            .map((item: any, idx: number) => {
              let value =
                item.percentage ||
                item.count ||
                item.jobs ||
                item.mentions ||
                item.openPositions ||
                item.days ||
                0;

              // Handle salary strings
              if (item.salary && typeof item.salary === "string") {
                const salaryMatch = item.salary.match(/([0-9,]+)/);
                if (salaryMatch) {
                  value = parseInt(salaryMatch[1].replace(/,/g, ""));
                }
              }

              const maxValue = Math.max(
                ...insight.data.map((d: any) => {
                  let v =
                    d.percentage ||
                    d.count ||
                    d.jobs ||
                    d.mentions ||
                    d.openPositions ||
                    d.days ||
                    100;
                  if (d.salary && typeof d.salary === "string") {
                    const match = d.salary.match(/([0-9,]+)/);
                    if (match) v = parseInt(match[1].replace(/,/g, ""));
                  }
                  return v;
                }),
              );
              const label =
                item.category ||
                item.job ||
                item.sector ||
                item.company ||
                item.skill ||
                item.region ||
                item.type ||
                item.level ||
                Object.values(item)[0];
              const widthPercent = (value / maxValue) * 100;
              return `
              <div style="margin: 15px 0; display: flex; align-items: center; gap: 15px;">
                <div style="flex: 0 0 200px; text-align: right;">
                  <strong style="color: #1A1B3E; font-size: 13px;">${label}</strong>
                </div>
                <div style="flex: 1; display: flex; align-items: center; gap: 10px;">
                  <div style="flex: 1; background: #E5E7EB; height: 28px; border-radius: 6px; overflow: hidden; position: relative;">
                    <div style="background: ${
                      colors_list[idx % colors_list.length]
                    }; height: 100%; width: ${widthPercent}%; transition: width 0.3s; border-radius: 0 6px 6px 0;"></div>
                  </div>
                  <span style="color: #4F46E5; font-weight: 600; font-size: 13px; min-width: 60px;">${
                    item.percentage
                      ? item.percentage + "%"
                      : item.salary || value.toLocaleString()
                  }</span>
                </div>
              </div>
            `;
            })
            .join("");
        } else if (currentView === "area" || currentView === "line") {
          // Area/Line chart visualization
          const values = insight.data.map((item: any) => {
            let v =
              item.percentage ||
              item.count ||
              item.jobs ||
              item.mentions ||
              item.openPositions ||
              item.days ||
              0;

            // Handle salary strings
            if (item.salary && typeof item.salary === "string") {
              const salaryMatch = item.salary.match(/([0-9,]+)/);
              if (salaryMatch) {
                v = parseInt(salaryMatch[1].replace(/,/g, ""));
              }
            }

            return typeof v === "string" ? parseFloat(v.replace(/,/g, "")) : v;
          });
          const maxValue = Math.max(...values);
          const minValue = Math.min(...values);

          chartHTML = `
            <div style="padding: 20px; background: white; border-radius: 12px; border: 2px solid #E5E7EB;">
              <div style="position: relative; height: 250px; display: flex; align-items: flex-end; gap: 5px; padding: 20px 0;">
                ${insight.data
                  .map((item: any, idx: number) => {
                    let value =
                      item.percentage ||
                      item.count ||
                      item.jobs ||
                      item.mentions ||
                      item.openPositions ||
                      item.days ||
                      0;

                    // Handle salary strings
                    if (item.salary && typeof item.salary === "string") {
                      const salaryMatch = item.salary.match(/([0-9,]+)/);
                      if (salaryMatch) {
                        value = parseInt(salaryMatch[1].replace(/,/g, ""));
                      }
                    }

                    const numValue =
                      typeof value === "string"
                        ? parseFloat(value.replace(/,/g, ""))
                        : value;
                    const heightPercent =
                      ((numValue - minValue) / (maxValue - minValue)) * 100;
                    const label =
                      item.category ||
                      item.job ||
                      item.sector ||
                      item.company ||
                      item.skill ||
                      item.region ||
                      item.type ||
                      item.level ||
                      Object.values(item)[0];
                    return `
                    <div style="flex: 1; display: flex; flex-direction: column; align-items: center; gap: 8px;">
                      <div style="width: 100%; height: ${heightPercent}%; background: ${
                      currentView === "area"
                        ? `linear-gradient(180deg, ${
                            colors_list[idx % colors_list.length]
                          }80 0%, ${
                            colors_list[idx % colors_list.length]
                          } 100%)`
                        : colors_list[idx % colors_list.length]
                    }; border-radius: 4px 4px 0 0; position: relative;">
                        ${
                          currentView === "line"
                            ? `<div style="position: absolute; top: -6px; left: 50%; transform: translateX(-50%); width: 12px; height: 12px; background: ${
                                colors_list[idx % colors_list.length]
                              }; border: 3px solid white; border-radius: 50%;"></div>`
                            : ""
                        }
                      </div>
                      <div style="font-size: 11px; color: #6B7280; text-align: center; word-break: break-word; max-width: 80px;">${String(
                        label,
                      ).substring(0, 12)}</div>
                    </div>
                  `;
                  })
                  .join("")}
              </div>
              <div style="margin-top: 15px; display: flex; flex-wrap: wrap; gap: 10px; justify-content: center;">
                ${insight.data
                  .map((item: any, idx: number) => {
                    const value =
                      item.percentage ||
                      item.count ||
                      item.jobs ||
                      item.mentions ||
                      item.openPositions ||
                      item.days ||
                      0;
                    const label =
                      item.category ||
                      item.job ||
                      item.sector ||
                      item.company ||
                      item.skill ||
                      item.region ||
                      item.type ||
                      item.level ||
                      Object.values(item)[0];
                    return `
                    <div style="display: flex; align-items: center; gap: 6px; padding: 6px 10px; background: #F9FAFB; border-radius: 6px;">
                      <div style="width: 14px; height: 14px; background: ${
                        colors_list[idx % colors_list.length]
                      }; border-radius: 3px;"></div>
                      <span style="font-size: 11px; color: #374151;"><strong>${label}:</strong> ${
                      item.percentage
                        ? item.percentage + "%"
                        : item.salary || value
                    }</span>
                    </div>
                  `;
                  })
                  .join("")}
              </div>
            </div>
          `;
        } else if (currentView === "pie" || currentView === "donut") {
          // Create a pie/donut representation with percentages
          const total = insight.data.reduce((sum: number, item: any) => {
            let val =
              item.percentage ||
              item.count ||
              item.jobs ||
              item.mentions ||
              item.openPositions ||
              item.days ||
              0;

            // Handle salary strings
            if (item.salary && typeof item.salary === "string") {
              const salaryMatch = item.salary.match(/([0-9,]+)/);
              if (salaryMatch) {
                val = parseInt(salaryMatch[1].replace(/,/g, ""));
              }
            }

            return (
              sum +
              (typeof val === "string"
                ? parseFloat(val.replace(/,/g, ""))
                : val)
            );
          }, 0);

          chartHTML =
            `<div style="display: flex; flex-wrap: wrap; gap: 20px; margin: 20px 0;">` +
            insight.data
              .map((item: any, idx: number) => {
                let value =
                  item.percentage ||
                  item.count ||
                  item.jobs ||
                  item.mentions ||
                  item.openPositions ||
                  item.days ||
                  0;

                // Handle salary strings
                if (item.salary && typeof item.salary === "string") {
                  const salaryMatch = item.salary.match(/([0-9,]+)/);
                  if (salaryMatch) {
                    value = parseInt(salaryMatch[1].replace(/,/g, ""));
                  }
                }

                const numValue =
                  typeof value === "string"
                    ? parseFloat(value.replace(/,/g, ""))
                    : value;
                const percent = ((numValue / total) * 100).toFixed(1);
                const label =
                  item.category ||
                  item.job ||
                  item.sector ||
                  item.company ||
                  item.skill ||
                  item.region ||
                  item.type ||
                  item.level ||
                  Object.values(item)[0];
                return `
                <div style="flex: 0 0 calc(50% - 10px); display: flex; align-items: center; gap: 10px; padding: 12px; background: #F9FAFB; border-radius: 8px; border: 2px solid ${
                  colors_list[idx % colors_list.length]
                }30;">
                  <div style="width: ${
                    currentView === "donut" ? "32px" : "24px"
                  }; height: ${
                  currentView === "donut" ? "32px" : "24px"
                }; background: ${
                  colors_list[idx % colors_list.length]
                }; border-radius: 50%; flex-shrink: 0; ${
                  currentView === "donut"
                    ? "border: 5px solid white; box-shadow: 0 0 0 2px " +
                      colors_list[idx % colors_list.length] +
                      ";"
                    : ""
                }"></div>
                  <div style="flex: 1;">
                    <div style="font-weight: 600; color: #1A1B3E; font-size: 14px;">${label}</div>
                    <div style="color: #6B7280; font-size: 13px;">${percent}% (${
                  item.salary || numValue.toLocaleString()
                })</div>
                  </div>
                </div>
              `;
              })
              .join("") +
            `</div>`;
        } else {
          // Default to simple list
          chartHTML = insight.data
            .map((item: any, idx: number) => {
              const value =
                item.percentage ||
                item.count ||
                item.jobs ||
                item.mentions ||
                item.openPositions ||
                item.days ||
                0;
              const label =
                item.category ||
                item.job ||
                item.sector ||
                item.company ||
                item.skill ||
                item.region ||
                item.type ||
                item.level ||
                Object.values(item)[0];
              const displayValue =
                item.salary ||
                (item.percentage ? item.percentage + "%" : value);
              return `
              <div style="padding: 12px; background: ${
                idx % 2 === 0 ? "#F9FAFB" : "#FFFFFF"
              }; border-left: 4px solid ${
                colors_list[idx % colors_list.length]
              }; margin: 8px 0; border-radius: 4px;">
                <strong style="color: #1A1B3E;">${label}:</strong> <span style="color: #4F46E5; font-weight: 600;">${displayValue}</span>
              </div>
            `;
            })
            .join("");
        }

        // Generate table HTML
        const keys =
          insight.data.length > 0 ? Object.keys(insight.data[0]) : [];
        const tableHTML = `
          <table style="width: 100%; border-collapse: collapse; margin: 20px 0; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
            <thead>
              <tr style="background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%); color: white;">
                ${keys
                  .map(
                    (key) =>
                      `<th style="padding: 12px; text-align: left; font-weight: 600; text-transform: capitalize;">${key
                        .replace(/([A-Z])/g, " $1")
                        .trim()}</th>`,
                  )
                  .join("")}
              </tr>
            </thead>
            <tbody>
              ${insight.data
                .map(
                  (item: any, idx: number) => `
                <tr style="background: ${
                  idx % 2 === 0 ? "#F9FAFB" : "#FFFFFF"
                }; border-bottom: 1px solid #E5E7EB;">
                  ${keys
                    .map(
                      (key) =>
                        `<td style="padding: 12px; color: #374151;">${item[key]}</td>`,
                    )
                    .join("")}
                </tr>
              `,
                )
                .join("")}
            </tbody>
          </table>
        `;

        const htmlContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${insight.title} - NibJobs Insight</title>
  <style>
    @page { margin: 20mm; }
    body { 
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif; 
      padding: 40px; 
      max-width: 1000px; 
      margin: 0 auto;
      background: #FFFFFF;
      color: #1F2937;
    }
    .header {
      text-align: center;
      margin-bottom: 40px;
      padding: 30px;
      background: linear-gradient(135deg, #1A1B3E 0%, #2C3E7F 100%);
      border-radius: 12px;
      color: white;
    }
    .header h1 { 
      font-size: 32px;
      margin: 0 0 10px 0; 
      font-weight: 700;
    }
    .header .subtitle {
      font-size: 16px;
      opacity: 0.9;
    }
    .section {
      margin: 30px 0;
      padding: 25px;
      background: #FAFBFC;
      border-radius: 12px;
      border: 1px solid #E5E7EB;
    }
    .section-title {
      font-size: 20px;
      font-weight: 700;
      color: #1A1B3E;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 3px solid #F4C430;
    }
    .description {
      color: #6B7280;
      margin-bottom: 20px;
      line-height: 1.6;
      font-size: 14px;
    }
    .footer { 
      margin-top: 50px; 
      text-align: center; 
      color: #9CA3AF; 
      font-size: 12px;
      padding-top: 20px;
      border-top: 2px solid #E5E7EB;
    }
    .stats-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 15px;
      margin: 20px 0;
    }
    .stat-card {
      padding: 15px;
      background: white;
      border-radius: 8px;
      border: 1px solid #E5E7EB;
      text-align: center;
    }
    .stat-value {
      font-size: 24px;
      font-weight: 700;
      color: #4F46E5;
    }
    .stat-label {
      font-size: 12px;
      color: #6B7280;
      margin-top: 5px;
    }
  </style>
</head>
<body>
  <div class="header">
    <h1>${insight.icon} ${insight.title}</h1>
    <div class="subtitle">NibJobs Ethiopia - Job Market Intelligence</div>
  </div>
  
  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-value">${insight.data.length}</div>
      <div class="stat-label">Total Items</div>
    </div>
    <div class="stat-card">
      <div class="stat-value">${new Date().toLocaleDateString()}</div>
      <div class="stat-label">Generated Date</div>
    </div>
    <div class="stat-card">
      <div class="stat-value">${currentView.toUpperCase()}</div>
      <div class="stat-label">View Type</div>
    </div>
  </div>
  
  <div class="section">
    <div class="section-title">📊 Visual Representation (${
      currentView.charAt(0).toUpperCase() + currentView.slice(1)
    } View)</div>
    <div class="description">
      This chart visualizes the ${insight.title.toLowerCase()} data in a ${currentView} format, 
      providing insights into market trends and patterns in the Ethiopian job market.
    </div>
    ${chartHTML}
  </div>
  
  <div class="section">
    <div class="section-title">📋 Detailed Data Table</div>
    <div class="description">
      Complete dataset with all metrics and values for comprehensive analysis.
    </div>
    ${tableHTML}
  </div>
  
  <div class="footer">
    <p><strong>NibJobs Ethiopia</strong> - Your Gateway to Ethiopian Job Market</p>
    <p>Generated on ${new Date().toLocaleString()} | www.nibjobs.com</p>
    <p>For inquiries: info@nibjobs.com</p>
  </div>
</body>
</html>`;

        const printWindow = window.open("", "_blank");
        if (printWindow) {
          printWindow.document.write(htmlContent);
          printWindow.document.close();
          setTimeout(() => printWindow.print(), 500);
        }
      } catch (error) {
        Alert.alert("Error", "Failed to download insight");
      }
    } else {
      Alert.alert(
        "Download",
        "Individual download is available on web platform only.",
      );
    }
  };

  const generatePDFReport = () => {
    setGeneratingPDF(true);

    // Create detailed HTML report with enhanced visuals
    const htmlContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>NibJobs Ethiopia - Job Market Insights Report</title>
  <style>
    @page { margin: 15mm; }
    * { box-sizing: border-box; }
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
      line-height: 1.6;
      color: #2C2C2C;
      margin: 0;
      padding: 20px;
      background: linear-gradient(135deg, #FFF9E6 0%, #FFFFFF 100%);
    }
    .container {
      max-width: 1200px;
      margin: 0 auto;
      background: white;
      padding: 40px;
      border-radius: 16px;
      box-shadow: 0 10px 40px rgba(0,0,0,0.1);
    }
    .header {
      text-align: center;
      margin-bottom: 50px;
      padding: 30px;
      background: linear-gradient(135deg, #1A1B3E 0%, #2C3E7F 100%);
      border-radius: 12px;
      color: white;
    }
    .header h1 {
      font-size: 42px;
      margin: 0 0 10px 0;
      font-weight: 800;
      text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
    }
    .header .subtitle {
      font-size: 20px;
      opacity: 0.9;
      font-weight: 300;
    }
    .header .date {
      font-size: 14px;
      margin-top: 15px;
      opacity: 0.7;
      font-style: italic;
    }
    .section {
      margin: 40px 0;
      page-break-inside: avoid;
    }
    .section-title {
      font-size: 28px;
      font-weight: 700;
      margin-bottom: 20px;
      padding: 15px 20px;
      background: linear-gradient(135deg, #F4C430 0%, #D4AF37 100%);
      border-radius: 8px;
      color: #1A1B3E;
      display: flex;
      align-items: center;
      gap: 12px;
      box-shadow: 0 4px 12px rgba(244, 196, 48, 0.3);
    }
    .chart-container {
      margin: 25px 0;
      padding: 25px;
      background: #FAFBFC;
      border-radius: 12px;
      border: 1px solid #E5E7EB;
    }
    .bar-chart {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }
    .bar-item {
      display: flex;
      align-items: center;
      gap: 15px;
    }
    .bar-label {
      min-width: 200px;
      font-weight: 600;
      color: #1A1B3E;
      font-size: 14px;
    }
    .bar-wrapper {
      flex: 1;
      position: relative;
      height: 36px;
      background: #E5E7EB;
      border-radius: 18px;
      overflow: hidden;
    }
    .bar-fill {
      height: 100%;
      background: linear-gradient(90deg, #F4C430 0%, #D4AF37 100%);
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 12px;
      color: #1A1B3E;
      font-weight: 700;
      font-size: 13px;
      box-shadow: inset 0 2px 4px rgba(0,0,0,0.1);
      transition: width 0.5s ease;
    }
    .bar-value {
      min-width: 80px;
      text-align: right;
      font-weight: 700;
      color: #1A1B3E;
      font-size: 15px;
    }
    .grid-layout {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      gap: 20px;
      margin: 25px 0;
    }
    .stat-card {
      padding: 25px;
      background: linear-gradient(135deg, #FFFFFF 0%, #FFF9E6 100%);
      border-radius: 12px;
      border-left: 5px solid #F4C430;
      box-shadow: 0 4px 12px rgba(0,0,0,0.08);
      transition: transform 0.3s ease;
    }
    .stat-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 20px rgba(0,0,0,0.15);
    }
    .stat-icon {
      font-size: 32px;
      margin-bottom: 12px;
    }
    .stat-label {
      font-size: 13px;
      color: #6B6B6B;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      font-weight: 600;
      margin-bottom: 8px;
    }
    .stat-value {
      font-size: 28px;
      font-weight: 800;
      color: #1A1B3E;
      margin-bottom: 8px;
    }
    .stat-trend {
      font-size: 14px;
      font-weight: 600;
      color: #27AE60;
    }
    .trend-negative {
      color: #E74C3C;
    }
    .data-table {
      width: 100%;
      border-collapse: collapse;
      margin: 20px 0;
      background: white;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    }
    .data-table th {
      background: linear-gradient(135deg, #1A1B3E 0%, #2C3E7F 100%);
      color: white;
      padding: 15px;
      text-align: left;
      font-weight: 600;
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .data-table td {
      padding: 15px;
      border-bottom: 1px solid #E5E7EB;
      font-size: 14px;
    }
    .data-table tr:last-child td {
      border-bottom: none;
    }
    .data-table tr:hover {
      background: #FFF9E6;
    }
    .summary-box {
      background: linear-gradient(135deg, #FFF9E6 0%, #F4C430 100%);
      padding: 30px;
      border-radius: 12px;
      margin: 30px 0;
      box-shadow: 0 6px 20px rgba(244, 196, 48, 0.3);
    }
    .summary-box h2 {
      color: #1A1B3E;
      font-size: 24px;
      margin: 0 0 20px 0;
      font-weight: 700;
    }
    .summary-box ul {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    .summary-box li {
      padding: 10px 0;
      padding-left: 30px;
      position: relative;
      color: #2C2C2C;
      font-size: 15px;
      line-height: 1.6;
    }
    .summary-box li:before {
      content: '✓';
      position: absolute;
      left: 0;
      color: #1A1B3E;
      font-weight: bold;
      font-size: 18px;
    }
    .pie-chart {
      display: flex;
      align-items: center;
      justify-content: space-around;
      gap: 40px;
      padding: 30px;
    }
    .pie-visual {
      width: 200px;
      height: 200px;
      border-radius: 50%;
      background: conic-gradient(
        #F4C430 0deg 259deg,
        #4A90E2 259deg 349deg,
        #27AE60 349deg 360deg
      );
      box-shadow: 0 8px 24px rgba(0,0,0,0.15);
    }
    .pie-legend {
      flex: 1;
    }
    .legend-item {
      display: flex;
      align-items: center;
      gap: 12px;
      margin: 15px 0;
      font-size: 15px;
    }
    .legend-color {
      width: 24px;
      height: 24px;
      border-radius: 4px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    }
    .legend-label {
      flex: 1;
      font-weight: 600;
      color: #1A1B3E;
    }
    .legend-value {
      font-weight: 700;
      color: #2C2C2C;
    }
    .footer {
      text-align: center;
      margin-top: 60px;
      padding: 30px;
      border-top: 3px solid #F4C430;
      color: #6B6B6B;
      background: #FAFBFC;
      border-radius: 12px;
    }
    .footer p {
      margin: 8px 0;
      font-size: 14px;
    }
    .footer strong {
      color: #1A1B3E;
      font-size: 16px;
    }
    @media print {
      body { background: white; }
      .container { box-shadow: none; }
    }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>🐝 NibJobs Ethiopia</h1>
      <div class="subtitle">Comprehensive Job Market Insights Report</div>
      <div class="date">Generated on ${new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })}</div>
    </div>

    <div class="summary-box">
      <h2>📋 Executive Summary</h2>
      <p style="font-size: 15px; line-height: 1.8; color: #2C2C2C;">This comprehensive report provides detailed insights into the Ethiopian job market, including trending sectors, salary benchmarks, skills demand, and regional distribution. The data represents current market conditions and emerging trends to help stakeholders make informed decisions.</p>
    </div>

    ${generateEnhancedInsightHTML(insights)}

    <div class="section">
      <div class="section-title">
        <span>📌</span>
        <span>Key Takeaways</span>
      </div>
      <div class="summary-box">
        <ul>
          <li><strong>Technology Dominance:</strong> IT and software development roles continue to lead the job market with 28% of all postings</li>
          <li><strong>High Demand for Healthcare:</strong> Medical professionals remain in critical demand with competitive salaries</li>
          <li><strong>Skill Development:</strong> Python, Data Analysis, and Cloud Computing skills show the highest growth rates</li>
          <li><strong>Regional Concentration:</strong> 72% of jobs are concentrated in Addis Ababa, indicating centralized economic activity</li>
          <li><strong>Remote Work Adoption:</strong> 12% of jobs now offer remote options, up from 5% last year</li>
          <li><strong>Salary Growth:</strong> Average salaries in tech sector increased by 15% year-over-year</li>
          <li><strong>Time to Hire:</strong> Average time to fill positions decreased to 21 days, indicating efficient hiring processes</li>
          <li><strong>Emerging Sectors:</strong> AI/ML and Renewable Energy showing exceptional growth rates above 40%</li>
        </ul>
      </div>
    </div>

    <div class="section">
      <div class="section-title">
        <span>📊</span>
        <span>Methodology</span>
      </div>
      <div class="chart-container">
        <p style="font-size: 15px; line-height: 1.8; margin-bottom: 15px;"><strong>This report is compiled from data collected across multiple sources:</strong></p>
        <ul style="font-size: 14px; line-height: 1.8; color: #2C2C2C;">
          <li>Job postings from major Ethiopian employers and recruitment platforms</li>
          <li>Salary surveys from HR professionals and compensation databases</li>
          <li>Application and hiring data from NibJobs platform analytics</li>
          <li>Industry reports and economic indicators</li>
          <li>Direct feedback from employers and job seekers</li>
        </ul>
        <p style="margin-top: 20px; font-size: 14px;"><strong>Data Period:</strong> Last 12 months (${new Date(
          Date.now() - 365 * 24 * 60 * 60 * 1000,
        ).toLocaleDateString()} - ${new Date().toLocaleDateString()})</p>
        <p style="font-size: 14px;"><strong>Sample Size:</strong> 4,500+ job postings, 12,000+ applications, 250+ employers</p>
      </div>
    </div>

    <div class="footer">
      <p><strong>NibJobs Ethiopia - Your Gateway to Career Opportunities</strong></p>
      <p>For more information, visit www.nibjobs.com | Contact: info@nibjobs.com</p>
      <p>© ${new Date().getFullYear()} NibJobs. All rights reserved.</p>
    </div>
  </div>
</body>
</html>
    `;

    // Open in new window for printing/saving as PDF
    if (Platform.OS === "web") {
      const printWindow = window.open("", "_blank");
      if (printWindow) {
        printWindow.document.write(htmlContent);
        printWindow.document.close();

        // Trigger print dialog after content loads
        setTimeout(() => {
          printWindow.print();
        }, 500);
      }
    } else {
      Alert.alert(
        "PDF Generation",
        "PDF generation is currently available on web platform only.",
      );
    }

    setTimeout(() => setGeneratingPDF(false), 1000);
  };

  const generateEnhancedInsightHTML = (insights: any[]) => {
    return insights
      .map((insight) => {
        const { id, icon, title, data } = insight;

        switch (id) {
          case 1: // Most Popular Job Categories - Bar Chart
            return `
            <div class="section">
              <div class="section-title">
                <span>${icon}</span>
                <span>${title}</span>
              </div>
              <div class="chart-container">
                <div class="bar-chart">
                  ${data
                    .map(
                      (item: any) => `
                    <div class="bar-item">
                      <div class="bar-label">${item.category}</div>
                      <div class="bar-wrapper">
                        <div class="bar-fill" style="width: ${
                          item.percentage * 2.8
                        }%">
                          ${
                            item.percentage > 15
                              ? item.count.toLocaleString()
                              : ""
                          }
                        </div>
                      </div>
                      <div class="bar-value">${item.count.toLocaleString()} (${
                        item.percentage
                      }%)</div>
                    </div>
                  `,
                    )
                    .join("")}
                </div>
              </div>
            </div>
          `;

          case 6: // Job Distribution by Region - Pie Chart
            return `
            <div class="section">
              <div class="section-title">
                <span>${icon}</span>
                <span>${title}</span>
              </div>
              <div class="chart-container">
                <div class="pie-chart">
                  <div class="pie-visual"></div>
                  <div class="pie-legend">
                    ${data
                      .map((item: any, idx: number) => {
                        const colors = [
                          "#F4C430",
                          "#4A90E2",
                          "#27AE60",
                          "#E74C3C",
                          "#9B59B6",
                          "#95A5A6",
                        ];
                        return `
                        <div class="legend-item">
                          <div class="legend-color" style="background: ${colors[idx]}"></div>
                          <div class="legend-label">${item.region}</div>
                          <div class="legend-value">${item.jobs} (${item.percentage}%)</div>
                        </div>
                      `;
                      })
                      .join("")}
                  </div>
                </div>
              </div>
            </div>
          `;

          case 2: // Highest Paying Jobs - Grid Cards
            return `
            <div class="section">
              <div class="section-title">
                <span>${icon}</span>
                <span>${title}</span>
              </div>
              <div class="grid-layout">
                ${data
                  .map(
                    (item: any, idx: number) => `
                  <div class="stat-card">
                    <div class="stat-icon">#${idx + 1}</div>
                    <div class="stat-label">${item.job}</div>
                    <div class="stat-value">${item.salary}</div>
                    <div class="stat-trend">Demand: ${item.demand}</div>
                  </div>
                `,
                  )
                  .join("")}
              </div>
            </div>
          `;

          case 3: // Fastest Growing Sectors - Bar Chart with Trend
            return `
            <div class="section">
              <div class="section-title">
                <span>${icon}</span>
                <span>${title}</span>
              </div>
              <div class="chart-container">
                <div class="bar-chart">
                  ${data
                    .map((item: any) => {
                      const growthPercent = parseInt(item.growth);
                      return `
                      <div class="bar-item">
                        <div class="bar-label">${item.sector}</div>
                        <div class="bar-wrapper">
                          <div class="bar-fill" style="width: ${
                            growthPercent * 2
                          }%; background: linear-gradient(90deg, #27AE60 0%, #2ECC71 100%);">
                            ${growthPercent > 20 ? item.growth : ""}
                          </div>
                        </div>
                        <div class="bar-value">${item.jobs} jobs (${
                        item.growth
                      })</div>
                      </div>
                    `;
                    })
                    .join("")}
                </div>
              </div>
            </div>
          `;

          default: // Regular Table
            return `
            <div class="section">
              <div class="section-title">
                <span>${icon}</span>
                <span>${title}</span>
              </div>
              <div class="chart-container">
                <table class="data-table">
                  <thead>
                    <tr>
                      ${Object.keys(data[0] || {})
                        .map(
                          (key) => `
                        <th>${
                          key.charAt(0).toUpperCase() +
                          key.slice(1).replace(/([A-Z])/g, " $1")
                        }</th>
                      `,
                        )
                        .join("")}
                    </tr>
                  </thead>
                  <tbody>
                    ${data
                      .map(
                        (item: any) => `
                      <tr>
                        ${Object.values(item)
                          .map(
                            (value) => `
                          <td><strong>${value}</strong></td>
                        `,
                          )
                          .join("")}
                      </tr>
                    `,
                      )
                      .join("")}
                  </tbody>
                </table>
              </div>
            </div>
          `;
        }
      })
      .join("");
  };

  const downloadAsImage = async () => {
    setDownloadingImage(true);

    if (Platform.OS === "web") {
      try {
        // Create a canvas representation
        Alert.alert(
          "Download as Image",
          'Please use browser Print function and select "Save as PDF" or take a screenshot for best quality. Or use the PDF download option.',
          [{ text: "OK" }],
        );
      } catch (error) {
        console.error("Image download error:", error);
        Alert.alert("Error", "Failed to download image");
      }
    } else {
      Alert.alert(
        "Download Image",
        "Image download is currently available on web platform only.",
      );
    }

    setTimeout(() => setDownloadingImage(false), 1000);
  };

  const formatLabel = (key: string) => {
    return (
      key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, " $1")
    );
  };

  const renderInsightCard = (insight: any) => {
    const { id, icon, title, data } = insight;
    const currentView = viewTypes[id] || "bar";

    // Render view type selector
    const renderViewSelector = () => (
      <View
        style={[
          styles.viewSelectorContainer,
          {
            borderBottomColor: colors.adminBorder,
          },
        ]}
      >
        <TouchableOpacity
          style={[
            styles.viewButton,
            {
              backgroundColor:
                currentView === "bar"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#0F172A"
                  : "#E2E8F0",
              borderColor:
                currentView === "bar"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#334155"
                  : "#E5E7EB",
            },
          ]}
          onPress={() => changeViewType(id, "bar")}
        >
          <Icon
            name="bar-chart"
            size={16}
            color={
              currentView === "bar"
                ? "#FFFFFF"
                : isDarkMode
                ? "#F9FAFB"
                : "#0F172A"
            }
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={[
            styles.viewButton,
            {
              backgroundColor:
                currentView === "bubble"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#0F172A"
                  : "#E2E8F0",
              borderColor:
                currentView === "bubble"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#334155"
                  : "#E5E7EB",
            },
          ]}
          onPress={() => changeViewType(id, "bubble")}
        >
          <Icon
            name="bubble-chart"
            size={16}
            color={
              currentView === "bubble"
                ? "#FFFFFF"
                : isDarkMode
                ? "#F9FAFB"
                : "#0F172A"
            }
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={[
            styles.viewButton,
            {
              backgroundColor:
                currentView === "pie"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#0F172A"
                  : "#E2E8F0",
              borderColor:
                currentView === "pie"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#334155"
                  : "#E5E7EB",
            },
          ]}
          onPress={() => changeViewType(id, "pie")}
        >
          <Icon
            name="pie-chart"
            size={16}
            color={
              currentView === "pie"
                ? "#FFFFFF"
                : isDarkMode
                ? "#F9FAFB"
                : "#0F172A"
            }
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={[
            styles.viewButton,
            {
              backgroundColor:
                currentView === "table"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#0F172A"
                  : "#E2E8F0",
              borderColor:
                currentView === "table"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#334155"
                  : "#E5E7EB",
            },
          ]}
          onPress={() => changeViewType(id, "table")}
        >
          <Icon
            name="table-chart"
            size={16}
            color={
              currentView === "table"
                ? "#FFFFFF"
                : isDarkMode
                ? "#F9FAFB"
                : "#0F172A"
            }
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={[
            styles.viewButton,
            {
              backgroundColor:
                currentView === "area"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#0F172A"
                  : "#E2E8F0",
              borderColor:
                currentView === "area"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#334155"
                  : "#E5E7EB",
            },
          ]}
          onPress={() => changeViewType(id, "area")}
        >
          <Icon
            name="area-chart"
            size={16}
            color={
              currentView === "area"
                ? "#FFFFFF"
                : isDarkMode
                ? "#F9FAFB"
                : "#0F172A"
            }
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={[
            styles.viewButton,
            {
              backgroundColor:
                currentView === "line"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#0F172A"
                  : "#E2E8F0",
              borderColor:
                currentView === "line"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#334155"
                  : "#E5E7EB",
            },
          ]}
          onPress={() => changeViewType(id, "line")}
        >
          <Icon
            name="show-chart"
            size={16}
            color={
              currentView === "line"
                ? "#FFFFFF"
                : isDarkMode
                ? "#F9FAFB"
                : "#0F172A"
            }
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={[
            styles.viewButton,
            {
              backgroundColor:
                currentView === "donut"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#0F172A"
                  : "#E2E8F0",
              borderColor:
                currentView === "donut"
                  ? "#8B5CF6"
                  : isDarkMode
                  ? "#334155"
                  : "#E5E7EB",
            },
          ]}
          onPress={() => changeViewType(id, "donut")}
        >
          <Icon
            name="donut-large"
            size={16}
            color={
              currentView === "donut"
                ? "#FFFFFF"
                : isDarkMode
                ? "#F9FAFB"
                : "#0F172A"
            }
          />
        </TouchableOpacity>
        <View style={{ flex: 1 }} />
        <TouchableOpacity
          style={[
            styles.downloadIndividualButton,
            {
              backgroundColor: colors.adminBorder,
              borderColor: colors.adminBorder,
            },
          ]}
          onPress={() => downloadIndividualInsight(insight)}
        >
          <Icon
            name="download"
            size={16}
            color={colors.sidebarTextActive}
          />
          <Text
            style={[
              styles.downloadIndividualText,
              { color: colors.sidebarTextActive },
            ]}
          >
            Download
          </Text>
        </TouchableOpacity>
      </View>
    );

    // Render visualization based on view type
    const renderVisualization = () => {
      // recharts is web-only; show fallback on native
      if (Platform.OS !== "web") {
        return renderTable(data, id);
      }
      switch (currentView) {
        case "bar":
          return renderBarChart(data, id);
        case "bubble":
          return renderBubbleChart(data, id);
        case "pie":
          return renderPieChart(data, id);
        case "table":
          return renderTable(data, id);
        case "area":
          return renderAreaChart(data, id);
        case "line":
          return renderLineChart(data, id);
        case "hbar":
          return renderHorizontalBarChart(data, id);
        case "donut":
          return renderDonutChart(data, id);
        default:
          return renderBarChart(data, id);
      }
    };

    const isCollapsed = collapsed[id] || false;

    return (
      <View
        key={id}
        style={[
          styles.modernInsightCard,
          {
            backgroundColor: colors.adminCardBg,
            borderColor: colors.adminBorder,
            shadowColor: isDarkMode ? "#000" : "#000",
            shadowOpacity: isDarkMode ? 0.3 : 0.05,
          },
        ]}
      >
        <TouchableOpacity
          style={styles.modernCardHeader}
          onPress={() => toggleCollapse(id)}
          activeOpacity={0.7}
        >
          <View
            style={[
              styles.iconBadge,
              {
                backgroundColor: isDarkMode ? "#8B5CF622" : "#EDE9FE",
              },
            ]}
          >
            <Text style={styles.modernCardIcon}>{icon}</Text>
          </View>
          <View style={styles.cardTitleSection}>
            <Text
              style={[
                styles.modernCardTitle,
                { color: colors.sidebarTextActive },
              ]}
            >
              {title}
            </Text>
            <Text
              style={[
                styles.modernCardSubtitle,
                { color: colors.adminMuted },
              ]}
            >
              {data.length} items • Last updated:{" "}
              {lastComputed.toLocaleTimeString()}
            </Text>
          </View>
          <Icon
            name={isCollapsed ? "keyboard-arrow-down" : "keyboard-arrow-up"}
            size={28}
            color={colors.adminMuted}
            style={{ marginLeft: 8 }}
          />
        </TouchableOpacity>
        {!isCollapsed && (
          <>
            {renderViewSelector()}
            {renderVisualization()}
          </>
        )}
      </View>
    );
  };

  // Render Bar Chart
  const renderBarChart = (data: any[], insightId: number) => {
    // Nominal, unordered categories (company names, skills, regions, ...)
    // get ONE color for every real bar — a rotating rainbow-per-bar would
    // just re-encode the bar index, not information. The synthetic
    // "Others" bucket is the one exception: it recedes to gray since it
    // isn't a real peer entity.
    const barColor = (label: string) =>
      isOthersLabel(label) ? insightsPalette.deemphasis : insightsPalette.rankAccent;

    // Prepare data for recharts
    const chartData = data.map((item, idx) => {
      let value =
        item.percentage ||
        item.count ||
        item.jobs ||
        item.mentions ||
        item.openPositions ||
        item.days ||
        0;

      // Handle salary strings (e.g., "150,000 - 250,000 ETB/month")
      if (item.salary && typeof item.salary === "string") {
        const salaryMatch = item.salary.match(/([0-9,]+)/);
        if (salaryMatch) {
          value = parseInt(salaryMatch[1].replace(/,/g, ""));
        }
      }

      const label =
        item.category ||
        item.job ||
        item.sector ||
        item.company ||
        item.skill ||
        item.region ||
        item.type ||
        item.level ||
        Object.keys(item)[0];
      return {
        name:
          String(label).length > 20
            ? String(label).substring(0, 20) + "..."
            : String(label),
        value:
          typeof value === "string"
            ? parseFloat(value.replace(/,/g, "")) || 0
            : value,
        fill: barColor(String(label)),
        fullName: String(label),
      };
    });

    return (
      <View style={{ padding: 20, width: "100%" }}>
        {Platform.OS === "web" ? (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart
              data={chartData}
              margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                stroke={colors.adminBorder}
              />
              <XAxis
                dataKey="name"
                angle={-45}
                textAnchor="end"
                height={100}
                tick={{
                  fontSize: 11,
                  fill: colors.adminMuted,
                }}
              />
              <YAxis
                tick={{
                  fontSize: 12,
                  fill: colors.adminMuted,
                }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: colors.adminCardBg,
                  border: `1px solid ${colors.adminBorder}`,
                  borderRadius: 8,
                }}
                formatter={(value: any) => [value.toLocaleString(), "Value"]}
              />
              <Bar
                dataKey="value"
                radius={[8, 8, 0, 0]}
                cursor="pointer"
                onClick={(d: any) => handleDrillDown(insightId, d.fullName)}
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.fill} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <View style={styles.modernBarChartContainer}>
            {data.map((item: any, idx: number) => {
              const value =
                item.percentage ||
                item.count ||
                item.jobs ||
                item.mentions ||
                0;
              const maxValue = Math.max(
                ...data.map(
                  (d: any) =>
                    d.percentage || d.count || d.jobs || d.mentions || 100,
                ),
              );
              const label =
                item.category ||
                item.job ||
                item.sector ||
                item.company ||
                item.skill ||
                item.region ||
                item.type ||
                item.level ||
                Object.values(item)[0];
              const fillColor = barColor(String(label));

              return (
                <TouchableOpacity
                  key={idx}
                  style={styles.modernBarRow}
                  activeOpacity={0.75}
                  onPress={() => handleDrillDown(insightId, String(label))}
                >
                  <View style={styles.barLabelSection}>
                    <Text
                      style={[
                        styles.modernBarLabel,
                        { color: colors.sidebarTextActive },
                      ]}
                      numberOfLines={1}
                    >
                      {String(label)}
                    </Text>
                    <Text
                      style={[
                        styles.barCountText,
                        { color: colors.adminMuted },
                      ]}
                    >
                      {item.count
                        ? `${item.count.toLocaleString()} jobs`
                        : item.jobs
                        ? `${item.jobs.toLocaleString()} positions`
                        : item.mentions
                        ? `${item.mentions.toLocaleString()} mentions`
                        : ""}
                    </Text>
                  </View>
                  <View style={styles.barGraphSection}>
                    <View
                      style={[
                        styles.modernBarTrack,
                        {
                          backgroundColor: colors.adminBorder,
                        },
                      ]}
                    >
                      <View
                        style={[
                          styles.modernBarFill,
                          {
                            width: `${Math.min(
                              (value / maxValue) * 100,
                              100,
                            )}%`,
                            backgroundColor: fillColor,
                          },
                        ]}
                      />
                    </View>
                    <View style={styles.barMetrics}>
                      <Text
                        style={[
                          styles.percentageText,
                          { color: colors.sidebarTextActive },
                        ]}
                      >
                        {item.count
                          ? item.count.toLocaleString()
                          : item.jobs
                          ? item.jobs.toLocaleString()
                          : item.mentions
                          ? item.mentions.toLocaleString()
                          : item.openPositions
                          ? item.openPositions.toLocaleString()
                          : value}
                      </Text>
                      {item.percentage && (
                        <Text
                          style={[
                            styles.trendBadgeText,
                            {
                              color: colors.adminMuted,
                              fontSize: 11,
                            },
                          ]}
                        >
                          ({item.percentage}%)
                        </Text>
                      )}
                      {item.trend && (
                        <View
                          style={[
                            styles.trendBadge,
                            { backgroundColor: "#D1FAE5" },
                          ]}
                        >
                          <Text
                            style={[
                              styles.trendBadgeText,
                              { color: "#10B981" },
                            ]}
                          >
                            {item.trend}
                          </Text>
                        </View>
                      )}
                    </View>
                  </View>
                </TouchableOpacity>
              );
            })}
          </View>
        )}
      </View>
    );
  };

  // Render Bubble Chart
  const renderBubbleChart = (data: any[], insightId: number) => {
    // Same "one series, one color" rule as the bar chart — x is just rank
    // order and z is the same value as y, so color here would only ever
    // restate the bubble's position/size, not add information.
    const bubbleColor = (label: string) =>
      isOthersLabel(label) ? insightsPalette.deemphasis : insightsPalette.rankAccent;

    // Prepare data for recharts scatter/bubble
    const chartData = data.map((item, idx) => {
      let value =
        item.percentage ||
        item.count ||
        item.jobs ||
        item.mentions ||
        item.openPositions ||
        item.days ||
        50;

      // Handle salary strings
      if (item.salary && typeof item.salary === "string") {
        const salaryMatch = item.salary.match(/([0-9,]+)/);
        if (salaryMatch) {
          value = parseInt(salaryMatch[1].replace(/,/g, ""));
        }
      }

      if (typeof value === "string")
        value = parseFloat(value.replace(/,/g, "")) || 50;
      const label =
        item.category ||
        item.job ||
        item.sector ||
        item.company ||
        item.skill ||
        item.region ||
        item.type ||
        item.level ||
        Object.values(item)[0];
      return {
        x: idx + 1,
        y: value,
        z: value * 3, // Size of bubble
        name:
          String(label).length > 15
            ? String(label).substring(0, 15) + "..."
            : String(label),
        fill: bubbleColor(String(label)),
      };
    });

    return (
      <View style={{ padding: 20, width: "100%" }}>
        {Platform.OS === "web" ? (
          <ResponsiveContainer width="100%" height={350}>
            <ScatterChart margin={{ top: 20, right: 30, bottom: 80, left: 20 }}>
              <CartesianGrid
                strokeDasharray="3 3"
                stroke={colors.adminBorder}
              />
              <XAxis
                type="number"
                dataKey="x"
                name="Item"
                tick={{
                  fontSize: 12,
                  fill: colors.adminMuted,
                }}
                domain={[0, data.length + 1]}
              />
              <YAxis
                type="number"
                dataKey="y"
                name="Value"
                tick={{
                  fontSize: 12,
                  fill: colors.adminMuted,
                }}
              />
              <ZAxis type="number" dataKey="z" range={[100, 2000]} />
              <Tooltip
                cursor={{ strokeDasharray: "3 3" }}
                contentStyle={{
                  backgroundColor: colors.adminCardBg,
                  border: `1px solid ${colors.adminBorder}`,
                  borderRadius: 8,
                }}
                formatter={(value: any, name: any) => [
                  value,
                  name === "y" ? "Value" : name,
                ]}
              />
              <Scatter name="Data" data={chartData}>
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.fill} />
                ))}
              </Scatter>
            </ScatterChart>
          </ResponsiveContainer>
        ) : (
          <View style={styles.bubbleChartContainer}>
            {data.map((item: any, idx: number) => {
              // Extract value - check all possible numeric fields
              let value =
                item.percentage ||
                item.count ||
                item.jobs ||
                item.mentions ||
                item.openPositions ||
                item.days ||
                50;
              if (typeof value === "string")
                value = parseFloat(value.replace(/,/g, "")) || 50;

              // Calculate bubble size (40-120px range based on relative values)
              const maxVal = Math.max(
                ...data.map((d) => {
                  const v =
                    d.percentage ||
                    d.count ||
                    d.jobs ||
                    d.mentions ||
                    d.openPositions ||
                    d.days ||
                    1;
                  return typeof v === "string"
                    ? parseFloat(v.replace(/,/g, "")) || 1
                    : v;
                }),
              );
              const normalizedValue = (value / maxVal) * 100;
              const size = 50 + normalizedValue * 0.7; // Scale from 50-120px

              // Extract label
              const label =
                item.category ||
                item.job ||
                item.sector ||
                item.company ||
                item.skill ||
                item.region ||
                item.type ||
                item.level ||
                Object.values(item)[0];
              const fillColor = bubbleColor(String(label));

              return (
                <View key={idx} style={styles.bubbleItem}>
                  <View
                    style={[
                      styles.bubble,
                      {
                        width: Math.min(size, 120),
                        height: Math.min(size, 120),
                        backgroundColor: fillColor + "30",
                        borderColor: fillColor,
                        borderWidth: 2,
                        justifyContent: "center",
                        alignItems: "center",
                      },
                    ]}
                  >
                    <Text
                      style={[
                        styles.bubbleValue,
                        {
                          color: fillColor,
                          fontWeight: "700",
                        },
                      ]}
                    >
                      {item.percentage !== undefined
                        ? `${item.percentage}%`
                        : value >= 100
                        ? Math.floor(value).toLocaleString()
                        : value.toFixed(0)}
                    </Text>
                  </View>
                  <Text
                    style={[
                      styles.bubbleLabel,
                      {
                        color: colors.sidebarTextActive,
                        textAlign: "center",
                      },
                    ]}
                    numberOfLines={2}
                  >
                    {String(label)}
                  </Text>
                </View>
              );
            })}
          </View>
        )}
      </View>
    );
  };

  // Render Pie Chart
  const renderPieChart = (data: any[], insightId: number) => {
    // Pie/donut is genuine part-to-whole: every slice is a real, named
    // category shown at once, so it earns the full categorical palette
    // (unlike the ranked bar/line charts below, which are one series).
    const colors_list = insightsPalette.categorical;

    // Prepare data for recharts pie
    const chartData = data.map((item, idx) => {
      let value =
        item.percentage ||
        item.count ||
        item.jobs ||
        item.mentions ||
        item.openPositions ||
        item.days ||
        0;

      // Handle salary strings
      if (item.salary && typeof item.salary === "string") {
        const salaryMatch = item.salary.match(/([0-9,]+)/);
        if (salaryMatch) {
          value = parseInt(salaryMatch[1].replace(/,/g, ""));
        }
      }

      if (typeof value === "string")
        value = parseFloat(value.replace(/,/g, "")) || 0;
      const label =
        item.category ||
        item.job ||
        item.sector ||
        item.company ||
        item.skill ||
        item.region ||
        item.type ||
        item.level ||
        Object.values(item)[0];
      return {
        name: String(label),
        value: value,
        // The "Others" slice is an aggregate, not a real peer category —
        // it always recedes to gray regardless of where it falls in the
        // color cycle.
        fill: isOthersLabel(String(label))
          ? insightsPalette.deemphasis
          : colors_list[idx % colors_list.length],
      };
    });

    const total = chartData.reduce((sum, item) => sum + item.value, 0);

    const renderCustomLabel = (entry: any) => {
      const percent = ((entry.value / total) * 100).toFixed(1);
      return `${percent}%`;
    };

    return (
      <View style={styles.pieChartContainer}>
        {Platform.OS === "web" ? (
          <>
            <ResponsiveContainer width="100%" height={350}>
              <PieChart>
                <Pie
                  data={chartData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={renderCustomLabel}
                  outerRadius={120}
                  innerRadius={60}
                  fill="#8884d8"
                  dataKey="value"
                  paddingAngle={2}
                  cursor="pointer"
                  onClick={(d: any) => handleDrillDown(insightId, d.name)}
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.fill} />
                  ))}
                </Pie>
                <Tooltip
                  contentStyle={{
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #E5E7EB",
                    borderRadius: 8,
                  }}
                  formatter={(value: any) => [value.toLocaleString(), "Value"]}
                />
              </PieChart>
            </ResponsiveContainer>
            <View style={styles.pieLegend}>
              {chartData.map((item, idx) => {
                const percent = ((item.value / total) * 100).toFixed(1);
                return (
                  <View key={idx} style={styles.pieLegendItem}>
                    <View
                      style={[
                        styles.pieLegendColor,
                        { backgroundColor: item.fill },
                      ]}
                    />
                    <View style={styles.pieLegendText}>
                      <Text
                        style={[
                          styles.pieLegendLabel,
                          { color: colors.sidebarTextActive },
                        ]}
                        numberOfLines={1}
                      >
                        {item.name}
                      </Text>
                      <Text
                        style={[
                          styles.pieLegendValue,
                          { color: colors.adminMuted },
                        ]}
                      >
                        {percent}% (
                        {typeof item.value === "number" && item.value >= 100
                          ? Math.floor(item.value).toLocaleString()
                          : item.value}
                        )
                      </Text>
                    </View>
                  </View>
                );
              })}
            </View>
          </>
        ) : (
          // Fallback for mobile - simple legend view
          <View style={styles.pieLegend}>
            {chartData.map((item, idx) => {
              const percent = ((item.value / total) * 100).toFixed(1);
              return (
                <TouchableOpacity
                  key={idx}
                  style={styles.pieLegendItem}
                  activeOpacity={0.75}
                  onPress={() => handleDrillDown(insightId, item.name)}
                >
                  <View
                    style={[
                      styles.pieLegendColor,
                      { backgroundColor: item.fill },
                    ]}
                  />
                  <View style={styles.pieLegendText}>
                    <Text
                      style={[
                        styles.pieLegendLabel,
                        { color: colors.sidebarTextActive },
                      ]}
                      numberOfLines={1}
                    >
                      {item.name}
                    </Text>
                    <Text
                      style={[
                        styles.pieLegendValue,
                        { color: colors.adminMuted },
                      ]}
                    >
                      {percent}% (
                      {typeof item.value === "number" && item.value >= 100
                        ? Math.floor(item.value).toLocaleString()
                        : item.value}
                      )
                    </Text>
                  </View>
                </TouchableOpacity>
              );
            })}
          </View>
        )}
      </View>
    );
  };

  // Render Area Chart
  const renderAreaChart = (data: any[], insightId: number) => {
    // Trend-over-time / magnitude, single series — one accent hue (see
    // renderBarChart's comment for why this isn't a rotating rainbow).
    const chartData = data.map((item) => {
      let value =
        item.percentage ||
        item.count ||
        item.jobs ||
        item.mentions ||
        item.openPositions ||
        item.days ||
        0;

      // Handle salary strings
      if (item.salary && typeof item.salary === "string") {
        const salaryMatch = item.salary.match(/([0-9,]+)/);
        if (salaryMatch) {
          value = parseInt(salaryMatch[1].replace(/,/g, ""));
        }
      }

      const label =
        item.category ||
        item.job ||
        item.sector ||
        item.company ||
        item.skill ||
        item.region ||
        item.type ||
        item.level ||
        Object.keys(item)[0];
      return {
        name:
          String(label).length > 15
            ? String(label).substring(0, 15) + "..."
            : String(label),
        value:
          typeof value === "string"
            ? parseFloat(value.replace(/,/g, "")) || 0
            : value,
        fullName: String(label),
      };
    });

    return (
      <View style={{ padding: 20, width: "100%" }}>
        {Platform.OS === "web" ? (
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart
              data={chartData}
              margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
              <XAxis
                dataKey="name"
                angle={-45}
                textAnchor="end"
                height={100}
                tick={{
                  fontSize: 11,
                  fill: colors.adminMuted,
                }}
              />
              <YAxis
                tick={{
                  fontSize: 12,
                  fill: colors.adminMuted,
                }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #E5E7EB",
                  borderRadius: 8,
                }}
                formatter={(value: any) => [value.toLocaleString(), "Value"]}
              />
              <Area
                type="monotone"
                dataKey="value"
                stroke={insightsPalette.rankAccent}
                fill={insightsPalette.rankAccent}
                fillOpacity={0.3}
                strokeWidth={2}
              />
            </AreaChart>
          </ResponsiveContainer>
        ) : (
          renderBarChart(data, insightId)
        )}
      </View>
    );
  };

  // Render Line Chart
  const renderLineChart = (data: any[], insightId: number) => {
    const chartData = data.map((item) => {
      let value =
        item.percentage ||
        item.count ||
        item.jobs ||
        item.mentions ||
        item.openPositions ||
        item.days ||
        0;

      // Handle salary strings
      if (item.salary && typeof item.salary === "string") {
        const salaryMatch = item.salary.match(/([0-9,]+)/);
        if (salaryMatch) {
          value = parseInt(salaryMatch[1].replace(/,/g, ""));
        }
      }

      const label =
        item.category ||
        item.job ||
        item.sector ||
        item.company ||
        item.skill ||
        item.region ||
        item.type ||
        item.level ||
        Object.keys(item)[0];
      return {
        name:
          String(label).length > 15
            ? String(label).substring(0, 15) + "..."
            : String(label),
        value:
          typeof value === "string"
            ? parseFloat(value.replace(/,/g, "")) || 0
            : value,
        fullName: String(label),
      };
    });

    return (
      <View style={{ padding: 20, width: "100%" }}>
        {Platform.OS === "web" ? (
          <ResponsiveContainer width="100%" height={300}>
            <AreaChart
              data={chartData}
              margin={{ top: 20, right: 30, left: 20, bottom: 60 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
              <XAxis
                dataKey="name"
                angle={-45}
                textAnchor="end"
                height={100}
                tick={{
                  fontSize: 11,
                  fill: colors.adminMuted,
                }}
              />
              <YAxis
                tick={{
                  fontSize: 12,
                  fill: colors.adminMuted,
                }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #E5E7EB",
                  borderRadius: 8,
                }}
                formatter={(value: any) => [value.toLocaleString(), "Value"]}
              />
              <Area
                type="monotone"
                dataKey="value"
                stroke={insightsPalette.rankAccent}
                fill="transparent"
                strokeWidth={3}
                dot={{ fill: insightsPalette.rankAccent, r: 4 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        ) : (
          renderBarChart(data, insightId)
        )}
      </View>
    );
  };

  // Render Horizontal Bar Chart
  const renderHorizontalBarChart = (data: any[], insightId: number) => {
    // Same "one series, one color" rule as renderBarChart — this is the
    // same ranked-magnitude data, just laid out sideways.
    const barColorH = (label: string) =>
      isOthersLabel(label) ? insightsPalette.deemphasis : insightsPalette.rankAccent;

    const chartData = data.map((item) => {
      let value =
        item.percentage ||
        item.count ||
        item.jobs ||
        item.mentions ||
        item.openPositions ||
        item.days ||
        0;

      // Handle salary strings
      if (item.salary && typeof item.salary === "string") {
        const salaryMatch = item.salary.match(/([0-9,]+)/);
        if (salaryMatch) {
          value = parseInt(salaryMatch[1].replace(/,/g, ""));
        }
      }

      const label =
        item.category ||
        item.job ||
        item.sector ||
        item.company ||
        item.skill ||
        item.region ||
        item.type ||
        item.level ||
        Object.keys(item)[0];
      return {
        name:
          String(label).length > 25
            ? String(label).substring(0, 25) + "..."
            : String(label),
        value:
          typeof value === "string"
            ? parseFloat(value.replace(/,/g, "")) || 0
            : value,
        fill: barColorH(String(label)),
        fullName: String(label),
      };
    });

    return (
      <View style={{ padding: 20, width: "100%" }}>
        {Platform.OS === "web" ? (
          <ResponsiveContainer
            width="100%"
            height={Math.max(300, data.length * 40)}
          >
            <BarChart
              data={chartData}
              layout="vertical"
              margin={{ top: 20, right: 30, left: 120, bottom: 20 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
              <XAxis
                type="number"
                tick={{
                  fontSize: 12,
                  fill: colors.adminMuted,
                }}
              />
              <YAxis
                type="category"
                dataKey="name"
                tick={{
                  fontSize: 11,
                  fill: colors.adminMuted,
                }}
                width={110}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #E5E7EB",
                  borderRadius: 8,
                }}
                formatter={(value: any) => [value.toLocaleString(), "Value"]}
              />
              <Bar
                dataKey="value"
                radius={[0, 8, 8, 0]}
                cursor="pointer"
                onClick={(d: any) => handleDrillDown(insightId, d.fullName)}
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.fill} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          renderBarChart(data, insightId)
        )}
      </View>
    );
  };

  // Render Donut Chart (similar to pie but with inner radius)
  const renderDonutChart = (data: any[], insightId: number) => {
    // Part-to-whole, same as the pie chart: real categorical palette.
    const colors_list = insightsPalette.categorical;

    const chartData = data.map((item, idx) => {
      let value =
        item.percentage ||
        item.count ||
        item.jobs ||
        item.mentions ||
        item.openPositions ||
        item.days ||
        0;

      // Handle salary strings
      if (item.salary && typeof item.salary === "string") {
        const salaryMatch = item.salary.match(/([0-9,]+)/);
        if (salaryMatch) {
          value = parseInt(salaryMatch[1].replace(/,/g, ""));
        }
      }

      if (typeof value === "string")
        value = parseFloat(value.replace(/,/g, "")) || 0;
      const label =
        item.category ||
        item.job ||
        item.sector ||
        item.company ||
        item.skill ||
        item.region ||
        item.type ||
        item.level ||
        Object.values(item)[0];
      return {
        name: String(label),
        value: value,
        fill: isOthersLabel(String(label))
          ? insightsPalette.deemphasis
          : colors_list[idx % colors_list.length],
      };
    });

    const total = chartData.reduce((sum, item) => sum + item.value, 0);

    const renderCustomLabel = (entry: any) => {
      const percent = (entry.value / total) * 100;
      return percent > 5 ? `${percent.toFixed(0)}%` : "";
    };

    return (
      <View style={styles.pieChartContainer}>
        {Platform.OS === "web" ? (
          <>
            <ResponsiveContainer width="100%" height={350}>
              <PieChart>
                <Pie
                  data={chartData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={renderCustomLabel}
                  outerRadius={130}
                  innerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                  paddingAngle={3}
                  cursor="pointer"
                  onClick={(d: any) => handleDrillDown(insightId, d.name)}
                >
                  {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.fill} />
                  ))}
                </Pie>
                <Tooltip
                  contentStyle={{
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #E5E7EB",
                    borderRadius: 8,
                  }}
                  formatter={(value: any) => [value.toLocaleString(), "Value"]}
                />
              </PieChart>
            </ResponsiveContainer>
            <View style={styles.pieLegend}>
              {chartData.map((item, idx) => {
                const percent = ((item.value / total) * 100).toFixed(1);
                return (
                  <View key={idx} style={styles.pieLegendItem}>
                    <View
                      style={[
                        styles.pieLegendColor,
                        { backgroundColor: item.fill },
                      ]}
                    />
                    <View style={styles.pieLegendText}>
                      <Text
                        style={[
                          styles.pieLegendLabel,
                          { color: colors.sidebarTextActive },
                        ]}
                        numberOfLines={1}
                      >
                        {item.name}
                      </Text>
                      <Text
                        style={[
                          styles.pieLegendValue,
                          { color: colors.adminMuted },
                        ]}
                      >
                        {percent}% (
                        {typeof item.value === "number" && item.value >= 100
                          ? Math.floor(item.value).toLocaleString()
                          : item.value}
                        )
                      </Text>
                    </View>
                  </View>
                );
              })}
            </View>
          </>
        ) : (
          renderPieChart(data, insightId)
        )}
      </View>
    );
  };

  // Render Table
  const renderTable = (data: any[], insightId: number = 0) => {
    const keys = data.length > 0 ? Object.keys(data[0]) : [];

    return (
      <View style={styles.tableContainer}>
        <View style={styles.tableHeader}>
          {keys.map((key, idx) => (
            <Text
              key={idx}
              style={[
                styles.tableHeaderCell,
                { color: colors.sidebarTextActive },
              ]}
            >
              {formatLabel(key)}
            </Text>
          ))}
        </View>
        {data.map((item: any, idx: number) => {
          const isOthersRow = isOthersLabel(getItemLabel(item));
          return (
            <TouchableOpacity
              key={idx}
              activeOpacity={insightId ? 0.75 : 1}
              onPress={() =>
                insightId
                  ? handleDrillDown(insightId, getItemLabel(item))
                  : undefined
              }
              style={[
                styles.tableRow,
                idx % 2 === 0 && {
                  backgroundColor: colors.adminCardAltBg,
                },
                // The synthetic "Others" row summarizes the long tail, not
                // a real peer entity — a faint tint + italic label keep it
                // visually distinct from the ranked rows above it.
                isOthersRow && {
                  backgroundColor: insightsPalette.deemphasis + "22",
                },
              ]}
            >
              {keys.map((key, kidx) => (
                <Text
                  key={kidx}
                  style={[
                    styles.tableCell,
                    { color: colors.sidebarText },
                    isOthersRow && kidx === 0 && { fontStyle: "italic" },
                  ]}
                >
                  {String(item[key])}
                </Text>
              ))}
            </TouchableOpacity>
          );
        })}
      </View>
    );
  };

  const renderInsightCard_old = (insight: any) => {
    const { id, icon, title, data } = insight;

    // Render different visualizations based on insight type
    switch (id) {
      case 1: // Most Popular Categories - Modern Bar Chart
        return (
          <View
            key={id}
            style={[
              styles.modernInsightCard,
              {
                backgroundColor: colors.adminCardBg,
                borderColor: colors.adminBorder,
              },
            ]}
          >
            <View style={styles.modernCardHeader}>
              <View
                style={[
                  styles.iconBadge,
                  {
                    backgroundColor: isDarkMode ? "#8B5CF622" : "#EDE9FE",
                  },
                ]}
              >
                <Text style={styles.modernCardIcon}>{icon}</Text>
              </View>
              <View style={styles.cardTitleSection}>
                <Text
                  style={[
                    styles.modernCardTitle,
                    { color: colors.sidebarTextActive },
                  ]}
                >
                  {title}
                </Text>
                <Text
                  style={[
                    styles.modernCardSubtitle,
                    { color: colors.adminMuted },
                  ]}
                >
                  {data.length} categories tracked
                </Text>
              </View>
            </View>
            <View style={styles.modernBarChartContainer}>
              {data.map((item: any, idx: number) => {
                const gradientColors = [
                  { start: "#8B5CF6", end: "#A78BFA" },
                  { start: "#7C3AED", end: "#8B5CF6" },
                  { start: "#EC4899", end: "#F472B6" },
                  { start: "#F59E0B", end: "#FBBF24" },
                  { start: "#10B981", end: "#34D399" },
                  { start: "#3B82F6", end: "#60A5FA" },
                ];
                const color = gradientColors[idx % gradientColors.length];
                return (
                  <View key={idx} style={styles.modernBarRow}>
                    <View style={styles.barLabelSection}>
                      <Text
                        style={[
                          styles.modernBarLabel,
                          { color: colors.sidebarTextActive },
                        ]}
                        numberOfLines={1}
                      >
                        {item.category}
                      </Text>
                      <Text
                        style={[
                          styles.barCountText,
                          { color: colors.adminMuted },
                        ]}
                      >
                        {item.count.toLocaleString()} jobs
                      </Text>
                    </View>
                    <View style={styles.barGraphSection}>
                      <View style={styles.modernBarTrack}>
                        <View
                          style={[
                            styles.modernBarFill,
                            {
                              width: `${Math.min(item.percentage * 3, 100)}%`,
                              backgroundColor: color.start,
                            },
                          ]}
                        />
                      </View>
                      <View style={styles.barMetrics}>
                        <Text
                          style={[
                            styles.percentageText,
                            { color: colors.sidebarTextActive },
                          ]}
                        >
                          {item.percentage}%
                        </Text>
                        <View
                          style={[
                            styles.trendBadge,
                            { backgroundColor: "#D1FAE5" },
                          ]}
                        >
                          <Text
                            style={[
                              styles.trendBadgeText,
                              { color: "#10B981" },
                            ]}
                          >
                            {item.trend}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>
                );
              })}
            </View>
          </View>
        );

      case 2: // Highest Paying Jobs - Premium Salary Cards
        return (
          <View
            key={id}
            style={[
              styles.modernInsightCard,
              {
                backgroundColor: colors.adminCardBg,
                borderColor: colors.adminBorder,
              },
            ]}
          >
            <View style={styles.modernCardHeader}>
              <View
                style={[
                  styles.iconBadge,
                  { backgroundColor: isDarkMode ? "#8B5CF622" : "#FEF3C7" },
                ]}
              >
                <Text style={styles.modernCardIcon}>{icon}</Text>
              </View>
              <View style={styles.cardTitleSection}>
                <Text
                  style={[
                    styles.modernCardTitle,
                    { color: colors.sidebarTextActive },
                  ]}
                >
                  {title}
                </Text>
                <Text
                  style={[
                    styles.modernCardSubtitle,
                    { color: colors.adminMuted },
                  ]}
                >
                  Top {data.length} highest paid positions
                </Text>
              </View>
            </View>
            <View style={styles.premiumSalaryGrid}>
              {data.map((item: any, idx: number) => (
                <View
                  key={idx}
                  style={[
                    styles.premiumSalaryCard,
                    {
                      backgroundColor:
                        idx === 0
                          ? isDarkMode
                            ? "#0F172A"
                            : "#EDE9FE"
                          : isDarkMode
                          ? "#1E293B"
                          : "#FFFFFF",
                      borderWidth: idx === 0 ? 2 : 1,
                      borderColor:
                        idx === 0
                          ? "#8B5CF6"
                          : isDarkMode
                          ? "#334155"
                          : "#E5E7EB",
                    },
                  ]}
                >
                  <View style={styles.salaryCardHeader}>
                    <View
                      style={[
                        styles.rankBadge,
                        {
                          backgroundColor:
                            idx === 0
                              ? "#8B5CF6"
                              : idx === 1
                              ? "#7C3AED"
                              : idx === 2
                              ? "#EC4899"
                              : "#F59E0B",
                        },
                      ]}
                    >
                      <Text style={styles.rankBadgeText}>#{idx + 1}</Text>
                    </View>
                    <View
                      style={[
                        styles.demandPill,
                        {
                          backgroundColor:
                            item.demand === "Very High"
                              ? "#D1FAE5"
                              : item.demand === "High"
                              ? "#FEF3C7"
                              : "#E5E7EB",
                        },
                      ]}
                    >
                      <View
                        style={[
                          styles.demandDot,
                          {
                            backgroundColor:
                              item.demand === "Very High"
                                ? "#10B981"
                                : item.demand === "High"
                                ? "#F59E0B"
                                : "#6B7280",
                          },
                        ]}
                      />
                      <Text
                        style={[
                          styles.demandPillText,
                          {
                            color:
                              item.demand === "Very High"
                                ? "#065F46"
                                : item.demand === "High"
                                ? "#92400E"
                                : "#4B5563",
                          },
                        ]}
                      >
                        {item.demand}
                      </Text>
                    </View>
                  </View>
                  <Text
                    style={[
                      styles.premiumJobTitle,
                      { color: colors.sidebarTextActive },
                    ]}
                    numberOfLines={2}
                  >
                    {item.job}
                  </Text>
                  <View style={styles.salaryAmountSection}>
                    <Icon name="payments" size={16} color="#10B981" />
                    <Text style={styles.premiumSalaryAmount}>
                      {item.salary}
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          </View>
        );

      case 3: // Fastest Growing - Gradient Progress Bars
        return (
          <View
            key={id}
            style={[
              styles.modernInsightCard,
              {
                backgroundColor: colors.adminCardBg,
                borderColor: colors.adminBorder,
              },
            ]}
          >
            <View style={styles.modernCardHeader}>
              <View
                style={[
                  styles.iconBadge,
                  {
                    backgroundColor: isDarkMode ? "#10B981" + "22" : "#D1FAE5",
                  },
                ]}
              >
                <Text style={styles.modernCardIcon}>{icon}</Text>
              </View>
              <View style={styles.cardTitleSection}>
                <Text
                  style={[
                    styles.modernCardTitle,
                    { color: colors.sidebarTextActive },
                  ]}
                >
                  {title}
                </Text>
                <Text
                  style={[
                    styles.modernCardSubtitle,
                    { color: colors.adminMuted },
                  ]}
                >
                  Year-over-year growth metrics
                </Text>
              </View>
            </View>
            <View style={styles.growthListContainer}>
              {data.map((item: any, idx: number) => {
                const growthNum = parseInt(item.growth);
                const barColor =
                  growthNum > 40
                    ? "#10B981"
                    : growthNum > 30
                    ? "#3B82F6"
                    : "#F59E0B";
                return (
                  <View key={idx} style={styles.modernGrowthRow}>
                    <View style={styles.growthInfoSection}>
                      <Text
                        style={[
                          styles.modernSectorName,
                          { color: colors.sidebarTextActive },
                        ]}
                        numberOfLines={2}
                      >
                        {item.sector}
                      </Text>
                      <Text
                        style={[
                          styles.modernJobsCount,
                          { color: colors.adminMuted },
                        ]}
                      >
                        {item.jobs.toLocaleString()} opportunities
                      </Text>
                    </View>
                    <View style={styles.growthMetricsSection}>
                      <View style={styles.modernProgressTrack}>
                        <View
                          style={[
                            styles.modernProgressFill,
                            {
                              width: `${Math.min(growthNum * 2, 100)}%`,
                              backgroundColor: barColor,
                            },
                          ]}
                        />
                      </View>
                      <View
                        style={[
                          styles.growthBadge,
                          { backgroundColor: barColor + "20" },
                        ]}
                      >
                        <Icon name="trending-up" size={14} color={barColor} />
                        <Text
                          style={[styles.modernGrowthText, { color: barColor }]}
                        >
                          {item.growth}
                        </Text>
                      </View>
                    </View>
                  </View>
                );
              })}
            </View>
          </View>
        );

      case 6: // Regional Distribution - Map-style View
        const dotColors = [
          "#4F46E5",
          "#7C3AED",
          "#EC4899",
          "#F59E0B",
          "#10B981",
          "#6B7280",
        ];
        return (
          <View
            key={id}
            style={[
              styles.modernInsightCard,
              {
                backgroundColor: colors.adminCardBg,
                borderColor: colors.adminBorder,
              },
            ]}
          >
            <View style={styles.modernCardHeader}>
              <View
                style={[
                  styles.iconBadge,
                  {
                    backgroundColor: isDarkMode ? "#3B82F6" + "22" : "#DBEAFE",
                  },
                ]}
              >
                <Text style={styles.modernCardIcon}>{icon}</Text>
              </View>
              <View style={styles.cardTitleSection}>
                <Text
                  style={[
                    styles.modernCardTitle,
                    { color: colors.sidebarTextActive },
                  ]}
                >
                  {title}
                </Text>
                <Text
                  style={[
                    styles.modernCardSubtitle,
                    { color: colors.adminMuted },
                  ]}
                >
                  Geographical job distribution
                </Text>
              </View>
            </View>
            <View style={styles.regionalMapContainer}>
              {data.map((item: any, idx: number) => (
                <View key={idx} style={styles.modernRegionalRow}>
                  <View style={styles.regionalIconSection}>
                    <View
                      style={[
                        styles.locationDot,
                        {
                          backgroundColor: dotColors[idx],
                          width: idx === 0 ? 12 : 8,
                          height: idx === 0 ? 12 : 8,
                        },
                      ]}
                    />
                  </View>
                  <View style={styles.regionalDataSection}>
                    <View style={styles.regionalTopRow}>
                      <Text
                        style={[
                          styles.modernRegionalName,
                          {
                            color: colors.sidebarTextActive,
                            fontWeight: idx === 0 ? "700" : "600",
                          },
                        ]}
                      >
                        {item.region}
                      </Text>
                      <View
                        style={[
                          styles.regionalPercentBadge,
                          {
                            backgroundColor: idx === 0 ? "#EDE9FE" : "#E2E8F0",
                          },
                        ]}
                      >
                        <Text
                          style={[
                            styles.regionalPercentText,
                            {
                              color: idx === 0 ? "#8B5CF6" : "#6B7280",
                            },
                          ]}
                        >
                          {item.percentage}%
                        </Text>
                      </View>
                    </View>
                    <View style={styles.regionalBottomRow}>
                      <Icon
                        name="work"
                        size={14}
                        color={colors.adminMuted}
                      />
                      <Text
                        style={[
                          styles.modernRegionalJobs,
                          { color: colors.adminMuted },
                        ]}
                      >
                        {item.jobs.toLocaleString()} jobs available
                      </Text>
                    </View>
                  </View>
                </View>
              ))}
            </View>
          </View>
        );

      default: // Default modern table view
        return (
          <View
            key={id}
            style={[
              styles.modernInsightCard,
              {
                backgroundColor: colors.adminCardBg,
                borderColor: colors.adminBorder,
              },
            ]}
          >
            <View style={styles.modernCardHeader}>
              <View
                style={[
                  styles.iconBadge,
                  {
                    backgroundColor: isDarkMode ? "#8B5CF622" : "#EDE9FE",
                  },
                ]}
              >
                <Text style={styles.modernCardIcon}>{icon}</Text>
              </View>
              <View style={styles.cardTitleSection}>
                <Text
                  style={[
                    styles.modernCardTitle,
                    { color: colors.sidebarTextActive },
                  ]}
                >
                  {title}
                </Text>
                <Text
                  style={[
                    styles.modernCardSubtitle,
                    { color: colors.adminMuted },
                  ]}
                >
                  Detailed metrics and analysis
                </Text>
              </View>
            </View>
            <View style={styles.insightDataContainer}>
              {data.map((item: any, idx: number) => (
                <View
                  key={idx}
                  style={[
                    styles.modernInsightDataRow,
                    idx !== data.length - 1 && {
                      borderBottomWidth: 1,
                      borderBottomColor: colors.adminBorder,
                    },
                  ]}
                >
                  {Object.entries(item).map(([key, value], i) => (
                    <View key={i} style={styles.insightDataCell}>
                      <Text
                        style={[
                          styles.insightDataLabel,
                          { color: colors.adminMuted },
                        ]}
                      >
                        {formatLabel(key)}
                      </Text>
                      <Text
                        style={[
                          styles.insightDataValue,
                          { color: colors.sidebarTextActive },
                        ]}
                      >
                        {String(value)}
                      </Text>
                    </View>
                  ))}
                </View>
              ))}
            </View>
          </View>
        );
    }
  };

  return (
    <ScrollView
      style={[
        styles.adminContentArea,
        { backgroundColor: colors.adminCardAltBg },
      ]}
    >
      {/* Clean Modern Header */}
      <View
        style={{
          backgroundColor: colors.adminCardBg,
          padding: isMobile ? 20 : 30,
          margin: isMobile ? 16 : 24,
          marginBottom: isMobile ? 16 : 20,
          borderRadius: isMobile ? 12 : 16,
          borderWidth: 1,
          borderColor: colors.adminBorder,
          boxShadow: isDarkMode
            ? "0 4px 6px rgba(0, 0, 0, 0.3)"
            : "0 1px 3px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Header Content */}
        <View
          style={{
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "flex-start" : "center",
            marginBottom: isMobile ? 16 : 20,
            gap: isMobile ? 12 : 0,
          }}
        >
          <View
            style={{
              width: isMobile ? 40 : 48,
              height: isMobile ? 40 : 48,
              borderRadius: isMobile ? 10 : 14,
              backgroundColor: "#8B5CF6",
              justifyContent: "center",
              alignItems: "center",
              marginRight: isMobile ? 0 : 16,
            }}
          >
            <Icon name="insights" size={isMobile ? 20 : 24} color="#FFFFFF" />
          </View>
          <View style={{ flex: 1 }}>
            <Text
              style={{
                fontSize: isMobile ? 22 : 28,
                fontWeight: "700",
                color: colors.sidebarTextActive,
                marginBottom: 4,
                fontFamily: fonts.bold,
              }}
            >
              Market Insights
            </Text>
            <Text
              style={{
                fontSize: isMobile ? 13 : 14,
                color: colors.adminMuted,
                fontFamily: fonts.regular,
              }}
            >
              Real-time analytics from the Ethiopian job market
            </Text>
          </View>
        </View>

        {/* Stats Bar */}
        <View
          style={{
            flexDirection: isMobile ? "column" : "row",
            gap: 12,
            marginBottom: isMobile ? 16 : 20,
            paddingTop: isMobile ? 16 : 20,
            borderTopWidth: 1,
            borderTopColor: colors.adminBorder,
          }}
        >
          <View
            style={{
              flex: isMobile ? undefined : 1,
              padding: isMobile ? 12 : 14,
              backgroundColor: colors.adminCardAltBg,
              borderRadius: 12,
              borderWidth: 1,
              borderColor: colors.adminBorder,
            }}
          >
            <Text
              style={{
                fontSize: isMobile ? 20 : 24,
                fontWeight: "700",
                color: "#8B5CF6",
                fontFamily: fonts.bold,
              }}
            >
              {insights.length}
            </Text>
            <Text
              style={{
                fontSize: isMobile ? 11 : 12,
                color: colors.adminMuted,
                fontFamily: fonts.regular,
                marginTop: 2,
              }}
            >
              Insights
            </Text>
          </View>
          <View
            style={{
              flex: isMobile ? undefined : 1,
              padding: isMobile ? 12 : 14,
              backgroundColor: colors.adminCardAltBg,
              borderRadius: 12,
              borderWidth: 1,
              borderColor: colors.adminBorder,
            }}
          >
            <Text
              style={{
                fontSize: isMobile ? 20 : 24,
                fontWeight: "700",
                color: colors.sidebarTextActive,
                fontFamily: fonts.bold,
              }}
            >
              {totalJobsAnalyzed.toLocaleString()}
            </Text>
            <Text
              style={{
                fontSize: isMobile ? 11 : 12,
                color: colors.adminMuted,
                fontFamily: fonts.regular,
                marginTop: 2,
              }}
            >
              Jobs Analyzed
            </Text>
          </View>
          <View
            style={{
              flex: isMobile ? undefined : 1,
              padding: isMobile ? 12 : 14,
              backgroundColor: colors.adminCardAltBg,
              borderRadius: 12,
              borderWidth: 1,
              borderColor: colors.adminBorder,
            }}
          >
            <Text
              style={{
                fontSize: isMobile ? 10 : 11,
                fontWeight: "600",
                color: colors.adminMuted,
                fontFamily: fonts.semibold,
              }}
            >
              {lastComputed.toLocaleDateString()}
            </Text>
            <Text
              style={{
                fontSize: isMobile ? 13 : 14,
                fontWeight: "700",
                color: colors.sidebarTextActive,
                fontFamily: fonts.bold,
                marginVertical: 2,
              }}
            >
              {lastComputed.toLocaleTimeString()}
            </Text>
            <Text
              style={{
                fontSize: isMobile ? 10 : 11,
                color: colors.adminMuted,
                fontFamily: fonts.regular,
              }}
            >
              Last Generated
            </Text>
          </View>
        </View>

        {/* Action Buttons */}
        <View
          style={{
            flexDirection: isMobile ? "column" : "row",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          <TouchableOpacity
            style={{
              flex: isMobile ? undefined : 1,
              minWidth: isMobile ? undefined : 130,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              paddingVertical: isMobile ? 11 : 12,
              paddingHorizontal: isMobile ? 14 : 16,
              borderRadius: 10,
              backgroundColor: colors.adminCardBg,
              borderWidth: 1,
              borderColor: colors.adminBorder,
              opacity: recomputing ? 0.6 : 1,
            }}
            onPress={recomputeInsights}
            disabled={recomputing}
          >
            <Icon
              name="refresh"
              size={isMobile ? 16 : 18}
              color={colors.sidebarTextActive}
            />
            <Text
              style={{
                fontSize: isMobile ? 13 : 14,
                fontWeight: "600",
                color: colors.sidebarTextActive,
                fontFamily: fonts.semibold,
              }}
            >
              {recomputing ? "Computing..." : "Recompute"}
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={{
              flex: 1,
              minWidth: 140,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              paddingVertical: 12,
              paddingHorizontal: 16,
              borderRadius: 10,
              backgroundColor: colors.adminCardBg,
              borderWidth: 1,
              borderColor: colors.adminBorder,
              opacity: downloadingImage ? 0.6 : 1,
            }}
            onPress={downloadAsImage}
            disabled={downloadingImage}
          >
            <Icon
              name="image"
              size={18}
              color={colors.sidebarTextActive}
            />
            <Text
              style={{
                fontSize: 14,
                fontWeight: "600",
                color: colors.sidebarTextActive,
                fontFamily: fonts.semibold,
              }}
            >
              {downloadingImage ? "Processing..." : "Save as Image"}
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={{
              flex: 1,
              minWidth: 140,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              paddingVertical: 12,
              paddingHorizontal: 16,
              borderRadius: 10,
              backgroundColor: "#8B5CF6",
              borderWidth: 1,
              borderColor: "#8B5CF6",
              opacity: generatingPDF ? 0.6 : 1,
            }}
            onPress={generatePDFReport}
            disabled={generatingPDF}
          >
            <Icon name="picture-as-pdf" size={18} color="#FFFFFF" />
            <Text
              style={{
                fontSize: 14,
                fontWeight: "600",
                color: "#FFFFFF",
                fontFamily: fonts.semibold,
              }}
            >
              {generatingPDF ? "Generating..." : "Download PDF"}
            </Text>
          </TouchableOpacity>
        </View>

        {/* Collapse/Expand Controls */}
        <View
          style={{
            flexDirection: "row",
            gap: 8,
            paddingTop: 16,
            marginTop: 16,
            borderTopWidth: 1,
            borderTopColor: colors.adminBorder,
          }}
        >
          <TouchableOpacity
            style={{
              flex: 1,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              paddingVertical: 10,
              paddingHorizontal: 14,
              borderRadius: 10,
              backgroundColor: colors.adminCardAltBg,
              borderWidth: 1,
              borderColor: colors.adminBorder,
            }}
            onPress={expandAll}
          >
            <Icon
              name="unfold-more"
              size={16}
              color={colors.sidebarTextActive}
            />
            <Text
              style={{
                fontSize: 13,
                fontWeight: "600",
                color: colors.sidebarTextActive,
                fontFamily: fonts.semibold,
              }}
            >
              Expand All
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={{
              flex: 1,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              paddingVertical: 10,
              paddingHorizontal: 14,
              borderRadius: 10,
              backgroundColor: colors.adminCardAltBg,
              borderWidth: 1,
              borderColor: colors.adminBorder,
            }}
            onPress={collapseAll}
          >
            <Icon
              name="unfold-less"
              size={16}
              color={colors.sidebarTextActive}
            />
            <Text
              style={{
                fontSize: 13,
                fontWeight: "600",
                color: colors.sidebarTextActive,
                fontFamily: fonts.semibold,
              }}
            >
              Collapse All
            </Text>
          </TouchableOpacity>
        </View>
      </View>

      <View style={{ padding: 24 }}>
        {loading ? (
          <InlineLoadingIndicator
            message="Computing insights..."
            isDarkMode={isDarkMode}
          />
        ) : insights.length === 0 ? (
          <View
            style={{
              padding: 40,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon
              name="analytics"
              size={48}
              color={colors.adminMuted}
            />
            <Text
              style={{
                marginTop: 16,
                fontSize: 18,
                fontWeight: "600",
                color: colors.sidebarTextActive,
                fontFamily: fonts.semibold,
              }}
            >
              No Insights Available
            </Text>
            <Text
              style={{
                marginTop: 8,
                fontSize: 14,
                color: colors.adminMuted,
                textAlign: "center",
                fontFamily: fonts.regular,
              }}
            >
              Start adding jobs to generate market insights
            </Text>
          </View>
        ) : (
          <>{insights.map((insight) => renderInsightCard(insight))}</>
        )}

        {!loading && insights.length > 0 && (
          <View
            style={[
              styles.modernInsightCard,
              {
                backgroundColor: colors.adminCardBg,
                borderWidth: 1,
                borderColor: isDarkMode ? "#8B5CF650" : "#8B5CF630",
              },
            ]}
          >
            <View style={styles.modernCardHeader}>
              <View
                style={[
                  styles.iconBadge,
                  { backgroundColor: isDarkMode ? "#8B5CF622" : "#EDE9FE" },
                ]}
              >
                <Text style={styles.modernCardIcon}>📌</Text>
              </View>
              <View style={styles.cardTitleSection}>
                <Text
                  style={[
                    styles.modernCardTitle,
                    { color: colors.sidebarTextActive },
                  ]}
                >
                  Key Findings
                </Text>
                <Text
                  style={[
                    styles.modernCardSubtitle,
                    { color: colors.adminMuted },
                  ]}
                >
                  Critical insights summary
                </Text>
              </View>
            </View>
            <View style={{ gap: 12 }}>
              {[
                "IT sector dominates with 28% market share",
                "Average tech salaries: 95,000 ETB/month",
                "AI/ML sector growing at +45% annually",
                "72% of jobs concentrated in Addis Ababa",
                "Remote work options increased to 12%",
                "Average time to hire: 21 days",
              ].map((finding, idx) => (
                <View
                  key={idx}
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-start",
                    gap: 12,
                  }}
                >
                  <View
                    style={{
                      width: 6,
                      height: 6,
                      borderRadius: 3,
                      backgroundColor: isDarkMode ? "#8B5CF6" : "#8B5CF6",
                      marginTop: 6,
                    }}
                  />
                  <Text
                    style={[
                      styles.insightSummaryText,
                      {
                        color: colors.sidebarText,
                        flex: 1,
                        fontSize: 14,
                        lineHeight: 22,
                      },
                    ]}
                  >
                    {finding}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        )}
      </View>

      {/* ── Drill-Down Modal: shows job postings for a tapped insight item ── */}
      {drillDown && (
        <Modal
          visible={true}
          transparent
          animationType="slide"
          onRequestClose={() => setDrillDown(null)}
        >
          <View
            style={{
              flex: 1,
              backgroundColor: "rgba(0,0,0,0.6)",
              justifyContent: "flex-end",
            }}
          >
            <View
              style={{
                maxHeight: "85%",
                backgroundColor: colors.adminCardAltBg,
                borderTopLeftRadius: 24,
                borderTopRightRadius: 24,
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingHorizontal: 20,
                  paddingVertical: 16,
                  backgroundColor: colors.adminCardBg,
                  borderBottomWidth: 1,
                  borderBottomColor: colors.adminBorder,
                }}
              >
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 11,
                      fontWeight: "600",
                      color: "#8B5CF6",
                      letterSpacing: 0.5,
                      textTransform: "uppercase",
                    }}
                  >
                    Job Postings Contributing To
                  </Text>
                  <Text
                    style={{
                      fontSize: 17,
                      fontWeight: "700",
                      color: colors.sidebarTextActive,
                      marginTop: 2,
                    }}
                    numberOfLines={1}
                  >
                    {drillDown.label}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      color: colors.adminMuted,
                      marginTop: 2,
                    }}
                  >
                    {drillDown.jobs.length} job
                    {drillDown.jobs.length !== 1 ? "s" : ""} found
                  </Text>
                </View>
                <TouchableOpacity
                  onPress={() => setDrillDown(null)}
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: 18,
                    backgroundColor: colors.sidebarHover,
                    justifyContent: "center",
                    alignItems: "center",
                    marginLeft: 12,
                  }}
                >
                  <Icon
                    name="close"
                    size={20}
                    color={colors.adminMuted}
                  />
                </TouchableOpacity>
              </View>

              {/* Job list */}
              <ScrollView
                contentContainerStyle={{ padding: 16, gap: 12 }}
                showsVerticalScrollIndicator={false}
              >
                {drillDown.jobs.map((job: any, idx: number) => {
                  const title =
                    job.title || job.jobTitle || "Untitled Position";
                  const company = job.company || job.companyName || "";
                  const location = job.location || job.city || "";
                  const salary = job.salary || job.salaryRange || "";
                  const category = job.category || job.mainCategory || "";
                  const postedDate =
                    job.postedAt?.toDate?.() ||
                    (job.postedAt ? new Date(job.postedAt) : null);
                  const dateStr = postedDate
                    ? postedDate.toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })
                    : "";
                  const applyLink = job.applyLink || job.applicationLink || "";
                  const isRemote = job.isRemote === true;

                  return (
                    <View
                      key={idx}
                      style={{
                        backgroundColor: colors.adminCardBg,
                        borderRadius: 14,
                        padding: 16,
                        borderWidth: 1,
                        borderColor: colors.adminBorder,
                        gap: 8,
                      }}
                    >
                      {/* Title row */}
                      <View
                        style={{
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: 8,
                        }}
                      >
                        <Text
                          style={{
                            flex: 1,
                            fontSize: 14,
                            fontWeight: "700",
                            color: colors.sidebarTextActive,
                            lineHeight: 20,
                          }}
                        >
                          {title}
                        </Text>
                        {isRemote && (
                          <View
                            style={{
                              backgroundColor: "#D1FAE5",
                              borderRadius: 6,
                              paddingHorizontal: 7,
                              paddingVertical: 3,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 10,
                                fontWeight: "600",
                                color: "#059669",
                              }}
                            >
                              Remote
                            </Text>
                          </View>
                        )}
                      </View>

                      {/* Company & Location */}
                      {(company || location) && (
                        <View
                          style={{
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 12,
                          }}
                        >
                          {company ? (
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 5,
                              }}
                            >
                              <Icon
                                name="business"
                                size={13}
                                color={isDarkMode ? "#8B5CF6" : "#7C3AED"}
                              />
                              <Text
                                style={{
                                  fontSize: 12,
                                  color: colors.sidebarText,
                                }}
                              >
                                {company}
                              </Text>
                            </View>
                          ) : null}
                          {location ? (
                            <View
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 5,
                              }}
                            >
                              <Icon
                                name="location-on"
                                size={13}
                                color={colors.adminMuted}
                              />
                              <Text
                                style={{
                                  fontSize: 12,
                                  color: colors.adminMuted,
                                }}
                              >
                                {location}
                              </Text>
                            </View>
                          ) : null}
                        </View>
                      )}

                      {/* Salary & Category & Date */}
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                        }}
                      >
                        {salary ? (
                          <View
                            style={{
                              backgroundColor: isDarkMode
                                ? "#064E3B22"
                                : "#ECFDF5",
                              borderRadius: 6,
                              paddingHorizontal: 8,
                              paddingVertical: 4,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 11,
                                fontWeight: "600",
                                color: isDarkMode ? "#34D399" : "#059669",
                              }}
                            >
                              {salary}
                            </Text>
                          </View>
                        ) : null}
                        {category ? (
                          <View
                            style={{
                              backgroundColor: isDarkMode
                                ? "#1E1B4B"
                                : "#EDE9FE",
                              borderRadius: 6,
                              paddingHorizontal: 8,
                              paddingVertical: 4,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 11,
                                color: isDarkMode ? "#A78BFA" : "#7C3AED",
                              }}
                            >
                              {category}
                            </Text>
                          </View>
                        ) : null}
                        {dateStr ? (
                          <Text
                            style={{
                              fontSize: 11,
                              color: colors.adminMuted,
                              alignSelf: "center",
                            }}
                          >
                            {dateStr}
                          </Text>
                        ) : null}
                      </View>

                      {/* Apply link */}
                      {applyLink ? (
                        <TouchableOpacity
                          onPress={() => {
                            if (Platform.OS === "web") {
                              (window as any).open(applyLink, "_blank");
                            }
                          }}
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                            alignSelf: "flex-start",
                            backgroundColor: "#8B5CF6",
                            borderRadius: 8,
                            paddingHorizontal: 12,
                            paddingVertical: 6,
                          }}
                        >
                          <Icon name="open-in-new" size={13} color="#FFFFFF" />
                          <Text
                            style={{
                              fontSize: 12,
                              fontWeight: "600",
                              color: "#FFFFFF",
                            }}
                          >
                            Apply
                          </Text>
                        </TouchableOpacity>
                      ) : null}
                    </View>
                  );
                })}
              </ScrollView>
            </View>
          </View>
        </Modal>
      )}

      {/* ── Recompute Confirmation Modal ── */}
      <Modal
        visible={showRecomputeModal}
        transparent
        animationType="fade"
        onRequestClose={() => setShowRecomputeModal(false)}
      >
        <View
          style={{
            flex: 1,
            backgroundColor: "rgba(0,0,0,0.55)",
            justifyContent: "center",
            alignItems: "center",
            padding: 24,
          }}
        >
          <View
            style={{
              width: "100%",
              maxWidth: 420,
              backgroundColor: colors.adminCardBg,
              borderRadius: 20,
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <View
              style={{
                backgroundColor: "#F59E0B18",
                paddingHorizontal: 24,
                paddingTop: 24,
                paddingBottom: 16,
                alignItems: "center",
                borderBottomWidth: 1,
                borderBottomColor: colors.adminBorder,
              }}
            >
              <View
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: 16,
                  backgroundColor: "#F59E0B22",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 12,
                }}
              >
                <Icon name="warning" size={28} color="#F59E0B" />
              </View>
              <Text
                style={{
                  fontSize: 18,
                  fontFamily: fonts.bold,
                  fontWeight: "700",
                  color: colors.sidebarTextActive,
                  letterSpacing: -0.3,
                }}
              >
                Expensive Operation
              </Text>
            </View>
            {/* Body */}
            <View
              style={{
                paddingHorizontal: 24,
                paddingTop: 18,
                paddingBottom: 20,
                gap: 12,
              }}
            >
              {[
                {
                  icon: "storage",
                  text: "Queries every job, category, and user document in Firestore",
                },
                { icon: "timer", text: "May take several seconds to complete" },
                {
                  icon: "attach-money",
                  text: "Counts toward your Firestore read quota",
                },
              ].map((item, i) => (
                <View
                  key={i}
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-start",
                    gap: 10,
                  }}
                >
                  <View
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: 8,
                      backgroundColor: colors.sidebarHover,
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                      marginTop: 1,
                    }}
                  >
                    <Icon
                      name={item.icon as any}
                      size={15}
                      color={colors.adminMuted}
                    />
                  </View>
                  <Text
                    style={{
                      flex: 1,
                      fontSize: 13,
                      fontFamily: fonts.regular,
                      color: colors.sidebarText,
                      lineHeight: 20,
                    }}
                  >
                    {item.text}
                  </Text>
                </View>
              ))}
            </View>
            {/* Actions */}
            <View
              style={{
                flexDirection: "row",
                gap: 10,
                paddingHorizontal: 24,
                paddingBottom: 24,
              }}
            >
              <TouchableOpacity
                onPress={() => setShowRecomputeModal(false)}
                style={{
                  flex: 1,
                  paddingVertical: 12,
                  borderRadius: 11,
                  backgroundColor: colors.sidebarHover,
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    fontWeight: "600",
                    color: colors.adminMuted,
                  }}
                >
                  Cancel
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  setShowRecomputeModal(false);
                  computeRealInsights(true);
                }}
                style={{
                  flex: 1,
                  paddingVertical: 12,
                  borderRadius: 11,
                  backgroundColor: "#F59E0B",
                  alignItems: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.semiBold,
                    fontWeight: "600",
                    color: "#FFFFFF",
                  }}
                >
                  Yes, Recompute
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </ScrollView>
  );
}

function AnalyticsContent({
  colors = lightColors,
  isDarkMode = false,
}: {
  colors?: any;
  isDarkMode?: boolean;
}) {
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalJobs: 0,
    totalCompanies: 0,
    totalChannels: 0,
    activeChannels: 0,
    activeUsers: 0,
    verifiedUsers: 0,
    jobsThisMonth: 0,
    subscriptions: {
      free: 0,
      standard: 0,
      pro: 0,
      enterprise: 0,
    },
    usersByRole: {
      user: 0,
      company: 0,
      admin: 0,
      superadmin: 0,
    },
    newSignups: {
      today: 0,
      week: 0,
      month: 0,
      weekDelta: null as number | null,
      monthDelta: null as number | null,
      daily: [] as { label: string; count: number }[],
    },
  });

  const isMobile = dimensions.width < 768;
  const isTablet = dimensions.width >= 768 && dimensions.width < 1024;
  const palette = ANALYTICS_PALETTE[isDarkMode ? "dark" : "light"];

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    try {
      setLoading(true);

      // Use count aggregation for total counts (much more efficient)
      const [totalUsersCount, totalJobsCount, totalChannelsCount] =
        await Promise.all([
          getCountFromServer(collection(db, "users")),
          getCountFromServer(collection(db, "jobs")),
          getCountFromServer(collection(db, "telegramChannels")),
        ]);

      // Fetch detailed data only where needed for specific filtering
      const [
        activeUsersCount,
        verifiedUsersCount,
        userRoleCount,
        companyRoleCount,
        adminRoleCount,
        superadminRoleCount,
        freeSubCount,
        standardSubCount,
        proSubCount,
        enterpriseSubCount,
        activeChannelsCount,
        jobsThisMonthCount,
      ] = await Promise.all([
        // User stats with specific filters
        getCountFromServer(
          dbQuery(collection(db, "users"), where("isActive", "!=", false)),
        ),
        getCountFromServer(
          dbQuery(collection(db, "users"), where("isVerified", "==", true)),
        ),

        // User by role counts
        getCountFromServer(
          dbQuery(collection(db, "users"), where("role", "in", ["user", null])),
        ),
        getCountFromServer(
          dbQuery(collection(db, "users"), where("role", "==", "company")),
        ),
        getCountFromServer(
          dbQuery(collection(db, "users"), where("role", "==", "admin")),
        ),
        getCountFromServer(
          dbQuery(collection(db, "users"), where("role", "==", "superadmin")),
        ),

        // Subscription counts
        getCountFromServer(
          dbQuery(
            collection(db, "users"),
            where("subscriptionId", "in", ["free", null]),
          ),
        ),
        getCountFromServer(
          dbQuery(
            collection(db, "users"),
            where("subscriptionId", "==", "standard"),
          ),
        ),
        getCountFromServer(
          dbQuery(
            collection(db, "users"),
            where("subscriptionId", "==", "pro"),
          ),
        ),
        getCountFromServer(
          dbQuery(
            collection(db, "users"),
            where("subscriptionId", "==", "enterprise"),
          ),
        ),

        // Channel stats
        getCountFromServer(
          dbQuery(
            collection(db, "telegramChannels"),
            where("isActive", "==", true),
            where("scrapingEnabled", "==", true),
          ),
        ),

        // Jobs this month
        (() => {
          const startOfMonth = new Date();
          startOfMonth.setDate(1);
          startOfMonth.setHours(0, 0, 0, 0);
          return getCountFromServer(
            dbQuery(
              collection(db, "jobs"),
              where("postedDate", ">=", startOfMonth),
            ),
          );
        })(),
      ]);

      // New signups trend (last 60 days) — one query, bucketed client-side.
      // 60 days (not 30) so the last 7/30 days can each be compared against
      // the 7/30 days before them for a delta. Uses only Firestore reads
      // already covered by the free tier, no external services or paid APIs.
      const sixtyDaysAgo = new Date();
      sixtyDaysAgo.setDate(sixtyDaysAgo.getDate() - 59);
      sixtyDaysAgo.setHours(0, 0, 0, 0);

      const recentSignupsSnap = await getDocs(
        dbQuery(
          collection(db, "users"),
          where("createdAt", ">=", sixtyDaysAgo),
        ),
      );

      const toDate = (value: any): Date | null => {
        if (!value) return null;
        if (typeof value.toDate === "function") return value.toDate();
        if (value.seconds) return new Date(value.seconds * 1000);
        const parsed = new Date(value);
        return isNaN(parsed.getTime()) ? null : parsed;
      };

      const dayKey = (d: Date) =>
        `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;

      const countsByDay = new Map<string, number>();
      recentSignupsSnap.docs.forEach((docSnap) => {
        const created = toDate(docSnap.data().createdAt);
        if (created) {
          const key = dayKey(created);
          countsByDay.set(key, (countsByDay.get(key) || 0) + 1);
        }
      });

      const pctDelta = (curr: number, prev: number): number | null =>
        prev > 0 ? Math.round(((curr - prev) / prev) * 100) : null;

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const daily: { label: string; count: number }[] = [];
      let signupsToday = 0;
      let signupsWeek = 0;
      let signupsPrevWeek = 0;
      let signupsMonth = 0;
      let signupsPrevMonth = 0;
      for (let i = 59; i >= 0; i--) {
        const d = new Date(today);
        d.setDate(d.getDate() - i);
        const count = countsByDay.get(dayKey(d)) || 0;
        if (i < 30) {
          daily.push({
            label: d.toLocaleDateString(undefined, {
              month: "short",
              day: "numeric",
            }),
            count,
          });
          signupsMonth += count;
        } else {
          signupsPrevMonth += count;
        }
        if (i < 7) signupsWeek += count;
        else if (i < 14) signupsPrevWeek += count;
        if (i === 0) signupsToday = count;
      }

      setStats({
        totalUsers: totalUsersCount.data().count,
        totalJobs: totalJobsCount.data().count,
        totalCompanies: companyRoleCount.data().count,
        totalChannels: totalChannelsCount.data().count,
        activeChannels: activeChannelsCount.data().count,
        activeUsers: activeUsersCount.data().count,
        verifiedUsers: verifiedUsersCount.data().count,
        jobsThisMonth: jobsThisMonthCount.data().count,
        subscriptions: {
          free: freeSubCount.data().count,
          standard: standardSubCount.data().count,
          pro: proSubCount.data().count,
          enterprise: enterpriseSubCount.data().count,
        },
        usersByRole: {
          user: userRoleCount.data().count,
          company: companyRoleCount.data().count,
          admin: adminRoleCount.data().count,
          superadmin: superadminRoleCount.data().count,
        },
        newSignups: {
          today: signupsToday,
          week: signupsWeek,
          month: signupsMonth,
          weekDelta: pctDelta(signupsWeek, signupsPrevWeek),
          monthDelta: pctDelta(signupsMonth, signupsPrevMonth),
          daily: daily.slice(-14),
        },
      });
      setLastUpdated(new Date());
    } catch (error) {
      console.error("Error fetching analytics:", error);
      alert("Error loading analytics data");
    } finally {
      setLoading(false);
    }
  };

  // bars: [{ label, value, total, color? }]
  // delta: signed % vs a prior period (null = no baseline to compare against)
  const StatCard = ({
    icon,
    title,
    value,
    subtitle,
    color: accent,
    bars,
    delta,
    deltaLabel,
  }: any) => {
    const pct = (v: number, t: number) =>
      t > 0 ? Math.min(100, (v / t) * 100) : 0;
    return (
      <View
        style={{
          flex: isMobile ? undefined : 1,
          width: isMobile ? "100%" : undefined,
          minWidth: isMobile ? undefined : 0,
          backgroundColor: colors.adminCardBg,
          borderRadius: isMobile ? 12 : 14,
          overflow: "hidden",
          borderTopWidth: 3,
          borderTopColor: accent,
          ...getAdminCardShadow(isDarkMode),
        }}
      >
        {/* Top row */}
        <View
          style={{
            padding: isMobile ? 16 : 20,
            flexDirection: "row",
            alignItems: "flex-start",
            gap: isMobile ? 12 : 14,
          }}
        >
          <View
            style={{
              width: isMobile ? 40 : 44,
              height: isMobile ? 40 : 44,
              borderRadius: isMobile ? 10 : 12,
              backgroundColor: accent + "22",
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 0,
            }}
          >
            <Icon name={icon} size={isMobile ? 20 : 22} color={accent} />
          </View>
          <View style={{ flex: 1 }}>
            <Text
              style={{
                fontSize: isMobile ? 9 : 10,
                fontFamily: fonts.medium,
                fontWeight: "600",
                color: colors.adminMuted,
                letterSpacing: 1.2,
                textTransform: "uppercase",
                marginBottom: 5,
              }}
            >
              {title}
            </Text>
            <Text
              style={{
                fontSize: isMobile ? 28 : 34,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: colors.sidebarTextActive,
                letterSpacing: -1,
                lineHeight: isMobile ? 34 : 40,
              }}
            >
              {value.toLocaleString()}
            </Text>
            {subtitle && (
              <Text
                style={{
                  fontSize: isMobile ? 10 : 11,
                  fontFamily: fonts.regular,
                  color: colors.adminMuted,
                  marginTop: 3,
                }}
              >
                {subtitle}
              </Text>
            )}
            {typeof delta === "number" && (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 4,
                  marginTop: 6,
                }}
              >
                <Icon
                  name={delta >= 0 ? "arrow-upward" : "arrow-downward"}
                  size={12}
                  color={delta >= 0 ? colors.success : colors.danger}
                />
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.semiBold,
                    fontWeight: "600",
                    color: delta >= 0 ? colors.success : colors.danger,
                  }}
                >
                  {Math.abs(delta)}%
                </Text>
                {deltaLabel && (
                  <Text
                    style={{
                      fontSize: 10,
                      fontFamily: fonts.regular,
                      color: colors.adminMuted,
                    }}
                  >
                    {deltaLabel}
                  </Text>
                )}
              </View>
            )}
          </View>
        </View>
        {/* Progress bars */}
        {bars && bars.length > 0 && (
          <View
            style={{
              paddingHorizontal: isMobile ? 16 : 20,
              paddingBottom: isMobile ? 14 : 18,
              gap: 10,
              borderTopWidth: 1,
              borderTopColor: colors.adminBorder,
              paddingTop: 14,
            }}
          >
            {bars.map((bar: any, i: number) => {
              const barColor = bar.color || accent;
              const fraction = pct(bar.value, bar.total);
              return (
                <View key={i}>
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 5,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: isMobile ? 9 : 10,
                        fontFamily: fonts.medium,
                        fontWeight: "500",
                        color: colors.adminMuted,
                      }}
                    >
                      {bar.label}
                    </Text>
                    <Text
                      style={{
                        fontSize: isMobile ? 9 : 10,
                        fontFamily: fonts.bold,
                        fontWeight: "700",
                        color: barColor,
                      }}
                    >
                      {bar.value.toLocaleString()}{" "}
                      <Text
                        style={{
                          fontWeight: "400",
                          color: isDarkMode ? "#374151" : "#CBD5E1",
                        }}
                      >
                        ({fraction.toFixed(1)}%)
                      </Text>
                    </Text>
                  </View>
                  {/* Track */}
                  <View
                    style={{
                      height: isMobile ? 4 : 5,
                      borderRadius: 3,
                      backgroundColor: colors.adminBorder,
                      overflow: "hidden",
                    }}
                  >
                    <View
                      style={{
                        height: "100%",
                        width: `${fraction}%` as any,
                        borderRadius: 3,
                        backgroundColor: barColor,
                      }}
                    />
                  </View>
                </View>
              );
            })}
          </View>
        )}
      </View>
    );
  };

  const SectionHeader = ({ label, icon: sectionIcon, accent }: any) => (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        gap: isMobile ? 6 : 8,
        backgroundColor: colors.adminHeaderBg,
        paddingHorizontal: isMobile ? 12 : 16,
        paddingVertical: isMobile ? 8 : 10,
        borderRadius: isMobile ? 8 : 10,
        marginBottom: isMobile ? 12 : 16,
      }}
    >
      <View
        style={{
          width: 4,
          height: 14,
          borderRadius: 2,
          backgroundColor: accent,
        }}
      />
      <Icon name={sectionIcon} size={13} color={accent} />
      <Text
        style={{
          fontSize: 11,
          fontFamily: fonts.bold,
          fontWeight: "700",
          color: accent,
          letterSpacing: 1.4,
          textTransform: "uppercase",
        }}
      >
        {label}
      </Text>
    </View>
  );

  if (loading) {
    return (
      <ModernLoadingScreen
        message="Loading analytics..."
        isDarkMode={isDarkMode}
      />
    );
  }

  return (
    <ScrollView
      style={{ flex: 1, backgroundColor: colors.adminPageBg }}
      contentContainerStyle={{ padding: isMobile ? 16 : 28 }}
      showsVerticalScrollIndicator={false}
    >
      {/* ── Page Header ── */}
      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          justifyContent: "space-between",
          backgroundColor: colors.adminHeaderBg,
          borderRadius: 14,
          padding: isMobile ? 16 : 20,
          marginBottom: isMobile ? 20 : 28,
          gap: isMobile ? 12 : 0,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center", gap: 14 }}>
          <View
            style={{
              width: isMobile ? 36 : 44,
              height: isMobile ? 36 : 44,
              borderRadius: 12,
              backgroundColor: `${colors.sidebarAccent}22`,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Icon
              name="analytics"
              size={isMobile ? 20 : 24}
              color={colors.sidebarAccent}
            />
          </View>
          <View>
            <Text
              style={{
                fontSize: isMobile ? 18 : 20,
                fontFamily: fonts.bold,
                fontWeight: "700",
                color: "#F9FAFB",
                letterSpacing: -0.3,
              }}
            >
              Analytics Dashboard
            </Text>
            <Text
              style={{
                fontSize: isMobile ? 11 : 12,
                fontFamily: fonts.regular,
                color: "#64748B",
                marginTop: 2,
              }}
            >
              Real-time platform metrics
            </Text>
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: isMobile ? 10 : 14,
            alignSelf: isMobile ? "flex-start" : "auto",
          }}
        >
          {lastUpdated && (
            <Text
              style={{
                fontSize: 11,
                fontFamily: fonts.regular,
                color: "#64748B",
              }}
            >
              Updated{" "}
              {lastUpdated.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </Text>
          )}
          <TouchableOpacity
            onPress={fetchAnalytics}
            style={{
              flexDirection: "row",
              alignItems: "center",
              gap: 7,
              backgroundColor: colors.sidebarAccent,
              paddingHorizontal: isMobile ? 14 : 16,
              paddingVertical: isMobile ? 8 : 9,
              borderRadius: 10,
            }}
          >
            <Icon name="refresh" size={16} color="#FFFFFF" />
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.semiBold,
                fontWeight: "600",
                color: "#FFFFFF",
              }}
            >
              Refresh
            </Text>
          </TouchableOpacity>
        </View>
      </View>

      {/* ── Overview ── */}
      <SectionHeader
        label="Overview"
        icon="bar-chart"
        accent={palette.categorical[0]}
      />
      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          flexWrap: isTablet ? "wrap" : "nowrap",
          gap: isMobile ? 12 : 16,
          marginBottom: isMobile ? 20 : 28,
        }}
      >
        <StatCard
          icon="people"
          title="Total Users"
          value={stats.totalUsers}
          subtitle="Registered platform users"
          color={palette.categorical[0]}
          bars={[
            {
              label: "Active",
              value: stats.activeUsers,
              total: stats.totalUsers,
              color: palette.categorical[0],
            },
            {
              label: "Verified",
              value: stats.verifiedUsers,
              total: stats.totalUsers,
              color: palette.violet,
            },
          ]}
        />
        <StatCard
          icon="work"
          title="Total Jobs"
          value={stats.totalJobs}
          subtitle="All-time job listings"
          color={palette.green}
          bars={[
            {
              label: "Posted This Month",
              value: stats.jobsThisMonth,
              total: stats.totalJobs,
              color: palette.green,
            },
          ]}
        />
        <StatCard
          icon="business"
          title="Companies"
          value={stats.totalCompanies}
          subtitle="Registered employers"
          color={palette.categorical[1]}
          bars={[
            {
              label: "Share of User Base",
              value: stats.totalCompanies,
              total: stats.totalUsers,
              color: palette.categorical[1],
            },
          ]}
        />
        <StatCard
          icon="rss-feed"
          title="Telegram Channels"
          value={stats.totalChannels}
          subtitle="Monitored channels"
          color={palette.violet}
          bars={[
            {
              label: "Active & Scraping",
              value: stats.activeChannels,
              total: stats.totalChannels,
              color: palette.violet,
            },
          ]}
        />
      </View>

      {/* ── Users by Role ── */}
      {/* Fixed-order categorical slots (blue/orange/aqua/yellow) — each role
          keeps its slot everywhere else it's referenced on this page. */}
      <SectionHeader
        label="Users by Role"
        icon="manage-accounts"
        accent={palette.violet}
      />
      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          flexWrap: isTablet ? "wrap" : "nowrap",
          gap: isMobile ? 12 : 16,
          marginBottom: isMobile ? 20 : 28,
        }}
      >
        <StatCard
          icon="person"
          title="Regular Users"
          value={stats.usersByRole.user}
          color={palette.categorical[0]}
          bars={[
            {
              label: "% of Total Users",
              value: stats.usersByRole.user,
              total: stats.totalUsers,
              color: palette.categorical[0],
            },
          ]}
        />
        <StatCard
          icon="business-center"
          title="Companies"
          value={stats.usersByRole.company}
          color={palette.categorical[1]}
          bars={[
            {
              label: "% of Total Users",
              value: stats.usersByRole.company,
              total: stats.totalUsers,
              color: palette.categorical[1],
            },
          ]}
        />
        <StatCard
          icon="admin-panel-settings"
          title="Admins"
          value={stats.usersByRole.admin}
          color={palette.categorical[2]}
          bars={[
            {
              label: "% of Total Users",
              value: stats.usersByRole.admin,
              total: stats.totalUsers,
              color: palette.categorical[2],
            },
          ]}
        />
        <StatCard
          icon="verified-user"
          title="Super Admins"
          value={stats.usersByRole.superadmin}
          color={palette.categorical[3]}
          bars={[
            {
              label: "% of Total Users",
              value: stats.usersByRole.superadmin,
              total: stats.totalUsers,
              color: palette.categorical[3],
            },
          ]}
        />
      </View>

      {/* ── Subscription Plans ── */}
      {/* Ordinal ramp, not categorical: Free -> Enterprise is a value ladder,
          so a single hue stepping light -> dark carries the tier order. */}
      <SectionHeader
        label="Subscription Plans"
        icon="card-membership"
        accent={palette.categorical[2]}
      />
      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          flexWrap: isTablet ? "wrap" : "nowrap",
          gap: isMobile ? 12 : 16,
          marginBottom: 8,
        }}
      >
        <StatCard
          icon="star-outline"
          title="Free Plan"
          value={stats.subscriptions.free}
          color={palette.tierRamp[0]}
          bars={[
            {
              label: "% of Users on Free",
              value: stats.subscriptions.free,
              total: stats.totalUsers,
              color: palette.tierRamp[0],
            },
          ]}
        />
        <StatCard
          icon="star"
          title="Standard Plan"
          value={stats.subscriptions.standard}
          color={palette.tierRamp[1]}
          bars={[
            {
              label: "% of Users on Standard",
              value: stats.subscriptions.standard,
              total: stats.totalUsers,
              color: palette.tierRamp[1],
            },
          ]}
        />
        <StatCard
          icon="verified"
          title="Pro Plan"
          value={stats.subscriptions.pro}
          color={palette.tierRamp[2]}
          bars={[
            {
              label: "% of Users on Pro",
              value: stats.subscriptions.pro,
              total: stats.totalUsers,
              color: palette.tierRamp[2],
            },
          ]}
        />
        <StatCard
          icon="business"
          title="Enterprise Plan"
          value={stats.subscriptions.enterprise}
          color={palette.tierRamp[3]}
          bars={[
            {
              label: "% of Users on Enterprise",
              value: stats.subscriptions.enterprise,
              total: stats.totalUsers,
              color: palette.tierRamp[3],
            },
          ]}
        />
      </View>

      {/* ── User Growth ── */}
      <SectionHeader
        label="User Growth"
        icon="trending-up"
        accent={palette.categorical[1]}
      />
      <View
        style={{
          flexDirection: isMobile ? "column" : "row",
          flexWrap: isTablet ? "wrap" : "nowrap",
          gap: isMobile ? 12 : 16,
          marginBottom: isMobile ? 20 : 28,
        }}
      >
        <StatCard
          icon="today"
          title="Signups Today"
          value={stats.newSignups.today}
          subtitle="New users in the last 24h"
          color={palette.categorical[0]}
        />
        <StatCard
          icon="date-range"
          title="Signups This Week"
          value={stats.newSignups.week}
          subtitle="Last 7 days"
          color={palette.categorical[2]}
          delta={stats.newSignups.weekDelta}
          deltaLabel="vs prior 7 days"
        />
        <StatCard
          icon="calendar-month"
          title="Signups This Month"
          value={stats.newSignups.month}
          subtitle="Last 30 days"
          color={palette.categorical[1]}
          delta={stats.newSignups.monthDelta}
          deltaLabel="vs prior 30 days"
        />
      </View>

      {/* Emphasis chart: today's bar carries the accent, the other 13 days
          recede to a neutral gray — the reader's eye lands on "now" first. */}
      <View
        style={{
          backgroundColor: colors.adminCardBg,
          borderRadius: 14,
          padding: isMobile ? 16 : 20,
          marginBottom: isMobile ? 20 : 28,
          borderTopWidth: 3,
          borderTopColor: palette.accent,
          ...getAdminCardShadow(isDarkMode),
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 16,
          }}
        >
          <Text
            style={{
              fontSize: isMobile ? 9 : 10,
              fontFamily: fonts.medium,
              fontWeight: "600",
              color: colors.adminMuted,
              letterSpacing: 1.2,
              textTransform: "uppercase",
            }}
          >
            New Signups — Last 14 Days
          </Text>
          <View style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
            <View
              style={{
                width: 8,
                height: 8,
                borderRadius: 4,
                backgroundColor: palette.accent,
              }}
            />
            <Text
              style={{
                fontSize: 10,
                fontFamily: fonts.medium,
                color: colors.adminMuted,
              }}
            >
              Today
            </Text>
          </View>
        </View>
        {(() => {
          const dailyData = stats.newSignups.daily;
          const maxCount = Math.max(1, ...dailyData.map((d) => d.count));
          return (
            <>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "flex-end",
                  height: 96,
                  gap: 4,
                }}
              >
                {dailyData.map((day, i) => {
                  const isToday = i === dailyData.length - 1;
                  const isPeak = day.count === maxCount && maxCount > 0;
                  const barHeight = Math.max(3, (day.count / maxCount) * 78);
                  return (
                    <View
                      key={i}
                      style={{
                        flex: 1,
                        height: "100%",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      {(isToday || isPeak) && day.count > 0 && (
                        <Text
                          style={{
                            fontSize: 9,
                            fontFamily: fonts.semiBold,
                            fontWeight: "600",
                            color: colors.sidebarTextActive,
                            marginBottom: 4,
                          }}
                        >
                          {day.count}
                        </Text>
                      )}
                      <View
                        style={{
                          width: "100%",
                          maxWidth: 18,
                          height: barHeight,
                          borderTopLeftRadius: 4,
                          borderTopRightRadius: 4,
                          backgroundColor: isToday
                            ? palette.accent
                            : palette.deemphasis,
                        }}
                      />
                    </View>
                  );
                })}
              </View>
              <View
                style={{
                  height: 1,
                  backgroundColor: colors.adminBorder,
                  marginTop: 2,
                }}
              />
              <View style={{ flexDirection: "row", gap: 4, marginTop: 6 }}>
                {dailyData.map((day, i) => (
                  <Text
                    key={i}
                    style={{
                      flex: 1,
                      textAlign: "center",
                      fontSize: 8,
                      fontFamily: fonts.regular,
                      color: colors.adminMuted,
                    }}
                    numberOfLines={1}
                  >
                    {day.label}
                  </Text>
                ))}
              </View>
            </>
          );
        })()}
      </View>
    </ScrollView>
  );
}

// Navigation Setup
const Stack = createNativeStackNavigator();

// Theme Switcher Component
function ThemeSwitcher({
  isDarkMode,
  onToggle,
}: {
  isDarkMode: boolean;
  onToggle: () => void;
}) {
  return (
    <TouchableOpacity
      onPress={onToggle}
      style={{
        position: "absolute",
        top: 20,
        right: 20,
        zIndex: 1000,
        backgroundColor: isDarkMode ? "#374151" : "#FFFFFF",
        borderRadius: 25,
        width: 50,
        height: 50,
        justifyContent: "center",
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: isDarkMode ? 0.4 : 0.15,
        shadowRadius: 8,
        elevation: 5,
        borderWidth: 1,
        borderColor: isDarkMode ? "#4B5563" : "#E5E7EB",
      }}
    >
      <Icon
        name={isDarkMode ? "wb-sunny" : "nights-stay"}
        size={24}
        color={isDarkMode ? "#FCD34D" : "#F59E0B"}
      />
    </TouchableOpacity>
  );
}

// Home Screen Component
function HomeScreen({
  navigation,
  isDarkMode: parentIsDarkMode,
  currentLanguage: parentCurrentLanguage,
  setCurrentLanguage: parentSetCurrentLanguage,
}: any) {
  const [jobs, setJobs] = useState<any[]>([]);
  const [allJobs, setAllJobs] = useState<any[]>([]);
  const [filteredJobs, setFilteredJobs] = useState<any[]>([]);
  const [telegramChannels, setTelegramChannels] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [topCategories, setTopCategories] = useState<any[]>([]);
  const [totalJobsCount, setTotalJobsCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedContractType, setSelectedContractType] = useState("");
  const [isRemote, setIsRemote] = useState(false);
  const [hasSalary, setHasSalary] = useState<boolean | undefined>(undefined);
  const [user, setUser] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [subscriptionPlans, setSubscriptionPlans] =
    useState(SUBSCRIPTION_PLANS);

  // Theme and Language states - use parent state if provided
  const [isDarkMode, setIsDarkMode] = useState(parentIsDarkMode || false);
  const currentLanguage = parentCurrentLanguage || "am";
  const setCurrentLanguage = parentSetCurrentLanguage || (() => {});
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({
    top: 60,
    right: 20,
  });
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const languageButtonRef = useRef<TouchableOpacity>(null);
  const channelScrollViewRef = useRef<ScrollView>(null);
  const jobTickerScrollRef = useRef<ScrollView>(null);

  // Static hero title
  const heroTitle = "Find Your Dream Job";

  // Counter animation for stats
  const [animatedCategories, setAnimatedCategories] = useState(0);
  const [animatedJobs, setAnimatedJobs] = useState(0);

  // Counter animation for individual category cards
  const [cardAnimatedCounts, setCardAnimatedCounts] = useState<{
    [key: string]: number;
  }>({});

  // Animate counters when data loads
  useEffect(() => {
    if (topCategories.length > 0 && totalJobsCount > 0) {
      const categoriesTarget = topCategories.length;
      const jobsTarget = totalJobsCount;

      let categoriesCount = 0;
      let jobsCount = 0;

      const categoriesInterval = setInterval(() => {
        categoriesCount += 1;
        setAnimatedCategories(categoriesCount);
        if (categoriesCount >= categoriesTarget) {
          clearInterval(categoriesInterval);
        }
      }, 50);

      const jobsIncrement = Math.ceil(jobsTarget / 30);
      const jobsInterval = setInterval(() => {
        jobsCount += jobsIncrement;
        if (jobsCount >= jobsTarget) {
          setAnimatedJobs(jobsTarget);
          clearInterval(jobsInterval);
        } else {
          setAnimatedJobs(jobsCount);
        }
      }, 50);

      return () => {
        clearInterval(categoriesInterval);
        clearInterval(jobsInterval);
      };
    }
  }, [topCategories.length, totalJobsCount]);

  // Animate individual card counts
  useEffect(() => {
    if (topCategories.length > 0) {
      const newCounts: { [key: string]: number } = {};
      const intervals: NodeJS.Timeout[] = [];

      topCategories.slice(0, 6).forEach((category, index) => {
        const target = category.jobCount || 0;
        let current = 0;
        const increment = Math.ceil(target / 30);
        const delay = index * 100; // Stagger animation

        const timeout = setTimeout(() => {
          const interval = setInterval(() => {
            current += increment;
            if (current >= target) {
              newCounts[category.id] = target;
              setCardAnimatedCounts((prev) => ({
                ...prev,
                [category.id]: target,
              }));
              clearInterval(interval);
            } else {
              newCounts[category.id] = current;
              setCardAnimatedCounts((prev) => ({
                ...prev,
                [category.id]: current,
              }));
            }
          }, 50);
          intervals.push(interval);
        }, delay);

        intervals.push(timeout as any);
      });

      return () => {
        intervals.forEach(clearInterval);
      };
    }
  }, [topCategories.length]);

  // Auto-scroll animation for job ticker
  useEffect(() => {
    if (jobs.length > 0 && jobTickerScrollRef.current) {
      // Estimate content width: each job ~200px, 12 jobs duplicated
      const estimatedContentWidth = jobs.slice(0, 12).length * 220;
      let scrollPosition = estimatedContentWidth;
      const scrollSpeed = 1; // pixels per interval
      const scrollInterval = 30; // milliseconds

      const autoScroll = setInterval(() => {
        scrollPosition -= scrollSpeed;

        if (jobTickerScrollRef.current) {
          jobTickerScrollRef.current.scrollTo({
            x: scrollPosition,
            animated: false,
          });

          // Reset to end when reaching beginning (seamless loop)
          if (scrollPosition <= 0) {
            scrollPosition = estimatedContentWidth;
          }
        }
      }, scrollInterval);

      return () => clearInterval(autoScroll);
    }
  }, [jobs.length]);

  // Translation helper - respects user's selected language
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.am;
  // Ge'ez script needs taller lines and no negative letter-spacing
  const isEthiopicScript = currentLanguage === "am" || currentLanguage === "ti";

  // Ripple on the mobile hero's "live" job-count dot
  const heroPulse = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    const loop = Animated.loop(
      Animated.timing(heroPulse, {
        toValue: 1,
        duration: 1600,
        useNativeDriver: Platform.OS !== "web",
      }),
    );
    loop.start();
    return () => loop.stop();
  }, [heroPulse]);

  // The job count is the headline stat of the landing page on both mobile and
  // desktop: a "LIVE" pulse, a big animated number, and what it counts.
  const renderLiveJobCounter = (variant: "mobile" | "desktop") => {
    const desktop = variant === "desktop";
    const shown = animatedJobs || totalJobsCount;
    return (
      <View style={{ marginBottom: desktop ? 26 : 20 }}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            gap: 8,
            marginBottom: desktop ? 6 : 2,
          }}
        >
          <View
            style={{
              width: 12,
              height: 12,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Animated.View
              style={{
                position: "absolute",
                width: 12,
                height: 12,
                borderRadius: 6,
                backgroundColor: "#10B981",
                opacity: heroPulse.interpolate({
                  inputRange: [0, 1],
                  outputRange: [0.7, 0],
                }),
                transform: [
                  {
                    scale: heroPulse.interpolate({
                      inputRange: [0, 1],
                      outputRange: [1, 2.6],
                    }),
                  },
                ],
              }}
            />
            <View
              style={{
                width: 8,
                height: 8,
                borderRadius: 4,
                backgroundColor: "#10B981",
              }}
            />
          </View>
          <Text
            style={{
              fontFamily: fonts.bold,
              fontSize: desktop ? 13 : 12,
              color: "#34D399",
              letterSpacing: isEthiopicScript ? 0.5 : 2,
            }}
          >
            {t.liveJobsLabel || "LIVE"}
          </Text>
          <Text
            style={{
              fontFamily: fonts.medium,
              fontSize: desktop ? 13 : 12,
              color: "rgba(255,255,255,0.45)",
            }}
          >
            · {t.liveJobsUpdated || "Updated every day"}
          </Text>
        </View>
        <Text
          style={{
            fontFamily: fonts.bold,
            fontWeight: "900",
            fontSize: desktop ? 96 : 64,
            lineHeight: desktop ? 104 : 72,
            letterSpacing: desktop ? -4 : -2.5,
            color: "#FFD700",
            fontVariant: ["tabular-nums"],
            ...Platform.select({
              web: { textShadow: "0 0 40px rgba(255,215,0,0.35)" } as any,
              default: {},
            }),
          }}
        >
          {shown > 0 ? `${shown.toLocaleString()}+` : "—"}
        </Text>
        <Text
          style={{
            fontFamily: fonts.semibold,
            fontSize: desktop ? 22 : 18,
            lineHeight: isEthiopicScript ? (desktop ? 32 : 28) : desktop ? 28 : 24,
            color: "#FFFFFF",
          }}
        >
          {t.liveJobsCaption || "open jobs waiting for you"}
        </Text>
      </View>
    );
  };

  // Auth state listener
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      setUser(authUser);
      if (authUser) {
        // Fetch user data from Firestore
        try {
          const userDocRef = doc(db, "users", authUser.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const userData = userDoc.data();
            setUserData(userData);

            // Redirect logged-in users based on role
            // Only redirect if we're on Home page (web users)
            if (Platform.OS === "web") {
              if (userData.role === "superadmin") {
                navigation.replace("AdminPanel");
              } else if (userData.role === "company") {
                // Company users go to dashboard
                navigation.replace("CompanyDashboard");
              } else {
                // Regular users go to jobs page
                navigation.replace("Jobs");
              }
            }
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      } else {
        setUserData(null);
      }
    });
    return unsubscribe;
  }, []);

  // Responsive design
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = Platform.OS !== "web" || dimensions.width < 768;
  const isTablet = dimensions.width >= 768 && dimensions.width < 1024;
  const isDesktop = dimensions.width >= 1024;

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  // Helper variables for current theme and language
  const colors = getColors(isDarkMode);

  // Language options for dropdown
  const languageOptions = [
    { code: "en", label: "English" },
    { code: "am", label: "አማርኛ" },
    { code: "ti", label: "ትግርኛ" },
    { code: "or", label: "Afaan Oromoo" },
  ];

  const getCurrentLanguage = () => {
    return (
      languageOptions.find((lang) => lang.code === currentLanguage) ||
      languageOptions[0]
    );
  };

  // Dynamic styles based on current theme
  const dynamicStyles = StyleSheet.create({
    container: {
      ...styles.container,
      backgroundColor: colors.white,
    },
    toolbar: {
      ...styles.toolbar,
      backgroundColor: colors.white,
    },
    appTitle: {
      ...styles.appTitle,
      color: colors.deepNavy,
    },
    searchContainer: {
      ...styles.searchContainer,
      backgroundColor: colors.lightGray,
    },
    searchInput: {
      ...styles.searchInput,
      color: colors.deepNavy,
    },
    leftContent: {
      ...styles.leftContent,
      backgroundColor: colors.cream,
    },
    channelsSection: {
      ...styles.channelsSection,
      backgroundColor: colors.white,
    },
    channelCard: {
      ...styles.channelCard,
      backgroundColor: colors.cream,
      borderColor: colors.beeYellow,
    },
    jobsSection: {
      ...styles.jobsSection,
      backgroundColor: colors.white,
      paddingHorizontal: isMobile ? 16 : isTablet ? 24 : 40,
    },
    sectionTitle: {
      ...styles.sectionTitle,
      color: colors.deepNavy,
      fontSize: isMobile ? 28 : isTablet ? 32 : 36,
    },
    sectionSubtitle: {
      ...styles.sectionSubtitle,
      color: colors.warmGray,
      fontSize: isMobile ? 14 : 16,
    },
    // Job card styles
    jobCard: {
      ...styles.jobCard,
      backgroundColor: colors.white,
      borderColor: colors.lightGray,
      maxWidth: isMobile ? "100%" : "32%",
    },
    // Filter sidebar styles
    filterSidebar: {
      ...styles.filterSidebar,
      backgroundColor: colors.white,
      borderLeftColor: colors.sidebarBorder,
    },
    filterTitle: {
      ...styles.filterTitle,
      color: colors.deepNavy,
    },
    filterLabel: {
      ...styles.filterLabel,
      color: colors.deepNavy,
    },
    filterOption: {
      ...styles.filterOption,
      backgroundColor: colors.lightGray,
    },
    filterOptionText: {
      ...styles.filterOptionText,
      color: colors.deepNavy,
    },
    jobsCount: {
      ...styles.jobsCount,
      color: colors.warmGray,
    },
    // Job card text styles
    jobTitle: {
      ...styles.jobTitle,
      color: colors.deepNavy,
    },
    jobCompany: {
      ...styles.jobCompany,
      color: colors.warmGray,
    },
    jobCategory: {
      ...styles.jobCategory,
      color: colors.softBlue,
    },
    jobLocation: {
      ...styles.jobLocation,
      color: colors.warmGray,
    },
    jobSalary: {
      ...styles.jobSalary,
      color: colors.success,
    },
    jobBadgeText: {
      ...styles.jobBadgeText,
      color: colors.deepNavy,
    },
    jobSource: {
      ...styles.jobSource,
      color: colors.warmGray,
    },
    jobDate: {
      ...styles.jobDate,
      color: colors.warmGray,
    },
    // Download button styles
    downloadButton: {
      ...styles.downloadButton,
      backgroundColor: colors.beeYellow,
    },
    downloadButtonText: {
      ...styles.downloadButtonText,
      color: colors.deepNavy,
    },

    // Modern Header Dynamic Styles
    modernHeader: {
      backgroundColor: colors.white,
      borderBottomWidth: 2,
      borderBottomColor: isDarkMode
        ? "rgba(255, 255, 255, 0.1)"
        : "rgba(0, 0, 0, 0.08)",
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: isDarkMode ? 0.3 : 0.1,
      shadowRadius: 8,
      elevation: 4,
    },
    modernBrandText: {
      fontSize: 20,
      fontWeight: "700",
      color: colors.deepNavy,
    },
    modernNavText: {
      fontSize: 14,
      fontWeight: "500",
      color: colors.warmGray,
    },

    // Hero Section Dynamic Styles
    heroSection: {
      backgroundColor: colors.white,
      paddingHorizontal: isMobile ? 16 : isTablet ? 24 : 40,
      paddingVertical: isMobile ? 24 : isTablet ? 32 : 48,
    },
    heroTitle: {
      fontSize: isMobile ? 32 : isTablet ? 40 : 48,
      fontWeight: "800",
      color: colors.deepNavy,
      marginBottom: 16,
      lineHeight: isMobile ? 40 : isTablet ? 48 : 56,
      textAlign: isMobile ? "center" : "left",
    },
    heroSubtitle: {
      fontSize: isMobile ? 16 : 18,
      color: colors.warmGray,
      marginBottom: isMobile ? 24 : 32,
      lineHeight: isMobile ? 24 : 28,
      textAlign: isMobile ? "center" : "left",
    },
    modernSearchContainer: {
      flexDirection: "row",
      alignItems: "center",
      backgroundColor: colors.lightGray,
      borderRadius: 24,
      paddingHorizontal: 20,
      paddingVertical: 4,
      gap: 16,
      marginBottom: 32,
    },
    modernSearchInput: {
      flex: 1,
      fontSize: 16,
      color: colors.deepNavy,
      paddingVertical: 12,
    },
    heroStatNumber: {
      fontSize: 24,
      fontWeight: "700",
      color: colors.deepNavy,
      marginBottom: 4,
    },
    heroStatLabel: {
      fontSize: 14,
      color: colors.warmGray,
    },
    heroImageText: {
      fontSize: 16,
      fontWeight: "600",
      color: colors.warmGray,
      marginTop: 12,
    },

    // Mobile Menu Dynamic Styles
    mobileMenu: {
      position: "absolute",
      top: 80,
      left: 20,
      right: 20,
      backgroundColor: colors.white,
      borderRadius: 12,
      shadowColor: colors.charcoal,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.15,
      shadowRadius: 12,
      elevation: 8,
    },
    mobileMenuTitle: {
      fontSize: 18,
      fontWeight: "700",
      color: colors.deepNavy,
    },
    mobileMenuItemText: {
      fontSize: 16,
      fontWeight: "500",
      color: colors.deepNavy,
    },
    mobileMenuSectionTitle: {
      fontSize: 14,
      fontWeight: "600",
      color: colors.warmGray,
      marginBottom: 12,
    },
    sectionSubtitle: {
      fontSize: 20,
      color: "#6c757d",
      fontFamily: fonts.regular,
      textAlign: "center",
      maxWidth: 700,
      alignSelf: "center",
      lineHeight: 32,
    },
    aboutText: {
      fontSize: isMobile ? 15 : 17,
      lineHeight: isMobile ? 26 : 30,
      color: "#495057",
      fontFamily: fonts.regular,
      marginBottom: 0,
      textAlign: "center",
    },
    aboutFeatureTitle: {
      fontSize: isMobile ? 17 : 19,
      fontWeight: "700",
      color: "#212529",
      marginBottom: 8,
      letterSpacing: 0.3,
    },
    aboutFeatureDescription: {
      fontSize: isMobile ? 14 : 15,
      lineHeight: isMobile ? 22 : 24,
      color: "#6c757d",
      fontFamily: fonts.regular,
    },
    pricingTierName: {
      fontSize: 28,
      fontWeight: "700",
      color: "#212529",
      marginBottom: 12,
      letterSpacing: 0.5,
    },
    pricingPrice: {
      fontSize: 56,
      fontWeight: "800",
      color: "#212529",
      marginBottom: 4,
      letterSpacing: -1,
    },
    pricingPeriod: {
      fontSize: 16,
      color: "#6c757d",
      fontFamily: fonts.regular,
      letterSpacing: 0.3,
    },
    pricingFeatureText: {
      fontSize: 15,
      lineHeight: 24,
      color: "#495057",
      fontFamily: fonts.regular,
      flex: 1,
    },

    // How It Works
    howItWorksTitle: {
      fontSize: 22,
      fontWeight: "700",
      color: isDarkMode ? colors.deepNavy : "#212529",
      marginTop: 12,
      marginBottom: 8,
      fontFamily: fonts.bold,
      textAlign: "center",
    },
    howItWorksDescription: {
      fontSize: 16,
      lineHeight: 26,
      color: isDarkMode ? colors.warmGray : "#6c757d",
      fontFamily: fonts.regular,
      textAlign: "center",
    },

    // Categories Preview
    categoryCardTitle: {
      fontSize: 18,
      fontWeight: "700",
      color: isDarkMode ? colors.deepNavy : "#212529",
      marginTop: 12,
      marginBottom: 4,
      fontFamily: fonts.bold,
      textAlign: "center",
    },
    categoryCardCount: {
      fontSize: 14,
      color: isDarkMode ? colors.warmGray : "#6c757d",
      fontFamily: fonts.regular,
      textAlign: "center",
    },

    // Testimonials
    testimonialText: {
      fontSize: 16,
      lineHeight: 26,
      color: isDarkMode ? colors.warmGray : "#495057",
      fontFamily: fonts.regular,
      marginBottom: 20,
    },
    testimonialAuthorName: {
      fontSize: 16,
      fontWeight: "700",
      color: isDarkMode ? colors.deepNavy : "#212529",
      fontFamily: fonts.bold,
    },
    testimonialAuthorRole: {
      fontSize: 14,
      color: isDarkMode ? colors.warmGray : "#6c757d",
      fontFamily: fonts.regular,
    },

    // FAQ
    faqQuestion: {
      fontSize: 18,
      fontWeight: "700",
      color: isDarkMode ? colors.deepNavy : "#212529",
      marginBottom: 12,
      fontFamily: fonts.bold,
    },
    faqAnswer: {
      fontSize: 15,
      lineHeight: 24,
      color: isDarkMode ? colors.warmGray : "#6c757d",
      fontFamily: fonts.regular,
    },
  });

  // Theme and language handlers
  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const changeLanguage = async (langCode: string) => {
    setCurrentLanguage(langCode);
    setIsLanguageDropdownOpen(false); // Close dropdown after selection
    try {
      await AsyncStorage.setItem("selectedLanguage", langCode);
    } catch (error) {
      console.error("Error saving language preference:", error);
    }
  };

  const toggleLanguageDropdown = () => {
    if (!isLanguageDropdownOpen && languageButtonRef.current) {
      languageButtonRef.current.measureInWindow((x, y, width, height) => {
        setDropdownPosition({
          top: y + height + 5, // 5px below the button
          right:
            typeof window !== "undefined" ? window.innerWidth - x - width : 0, // Align right edge with button's right edge
        });
      });
    }
    setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
  };

  useEffect(() => {
    const loadLanguage = async () => {
      try {
        const savedLanguage = await AsyncStorage.getItem("selectedLanguage");
        if (savedLanguage) {
          setCurrentLanguage(savedLanguage);
        }
      } catch (error) {
        console.error("Error loading language preference:", error);
      }
    };

    loadLanguage();
    fetchJobs();
    fetchTelegramChannels();
    fetchCategories();
    fetchSubscriptionPlans();
  }, []);

  useEffect(() => {
    filterJobs();
  }, [
    allJobs,
    searchText,
    selectedCategory,
    selectedContractType,
    isRemote,
    hasSalary,
  ]);

  // Auto-scroll effect for infinite channel scroll
  useEffect(() => {
    if (telegramChannels.length === 0) return;

    let scrollPosition = 0;
    const scrollSpeed = 1; // pixels per interval
    const intervalTime = 30; // milliseconds

    const autoScroll = setInterval(() => {
      if (channelScrollViewRef.current) {
        scrollPosition += scrollSpeed;

        // Calculate total content width (channels * card width)
        const cardWidth = 120; // Width of simplified card
        const totalWidth = telegramChannels.length * cardWidth;

        // Reset to beginning when reaching the end for infinite loop effect
        if (scrollPosition >= totalWidth / 2) {
          scrollPosition = 0;
        }

        channelScrollViewRef.current.scrollTo({
          x: scrollPosition,
          animated: false,
        });
      }
    }, intervalTime);

    return () => clearInterval(autoScroll);
  }, [telegramChannels]);

  const filterJobs = () => {
    let filtered = [...allJobs];

    // Search filter
    if (searchText.trim()) {
      const searchLower = searchText.toLowerCase();
      filtered = filtered.filter(
        (job) =>
          (job.title || "").toLowerCase().includes(searchLower) ||
          (job.company || "").toLowerCase().includes(searchLower) ||
          (job.description || "").toLowerCase().includes(searchLower) ||
          (job.category || "").toLowerCase().includes(searchLower) ||
          (job.location || "").toLowerCase().includes(searchLower),
      );
    }

    // Category filter
    if (selectedCategory) {
      filtered = filtered.filter(
        (job) =>
          job.categoryId === selectedCategory ||
          job.mainCategoryId === selectedCategory ||
          job.category === selectedCategory,
      );
    }

    // Contract type filter
    if (selectedContractType) {
      filtered = filtered.filter(
        (job) => job.contractType === selectedContractType,
      );
    }

    // Remote filter
    if (isRemote) {
      filtered = filtered.filter((job) => job.isRemote === true);
    }

    // Salary filter
    if (hasSalary === true) {
      filtered = filtered.filter(
        (job) =>
          job.salary !== null && job.salary !== undefined && job.salary !== "",
      );
    } else if (hasSalary === false) {
      filtered = filtered.filter(
        (job) =>
          !job.salary ||
          job.salary === null ||
          job.salary === undefined ||
          job.salary === "",
      );
    }

    setFilteredJobs(filtered);
    setJobs(filtered);
  };

  const fetchJobs = async () => {
    try {
      const jobsQuery = dbQuery(
        collection(db, "jobs"),
        orderBy("createdAt", "desc"),
        limit(9),
      );
      const jobsSnapshot = await getDocs(jobsQuery);
      const fetchedJobs = jobsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...(doc.data() as any),
      }));
      setAllJobs(fetchedJobs);
      setJobs(fetchedJobs);
      setFilteredJobs(fetchedJobs);
    } catch (error) {
      console.error("Error fetching jobs:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTelegramChannels = async () => {
    try {
      // Using local embedded images instead of Firebase
      const fetchedChannels = [
        {
          id: "1",
          name: "Addis Ababa Jobs",
          imageUrl: require("./assets/channels/addis_ababa_jobs.jpg"),
        },
        {
          id: "2",
          name: "Addis Jobs",
          imageUrl: require("./assets/channels/addis_jobs.jpg"),
        },
        {
          id: "3",
          name: "Afriwork",
          imageUrl: require("./assets/channels/afriwork.jpg"),
        },
        {
          id: "4",
          name: "Dagmawi Babl Jobs",
          imageUrl: require("./assets/channels/dagmawi_babl_jobs.jpg"),
        },
        {
          id: "5",
          name: "Effoy Jobs",
          imageUrl: require("./assets/channels/effoy_jobs.jpg"),
        },
        {
          id: "6",
          name: "Ethio Jobs Vacancy",
          imageUrl: require("./assets/channels/ethio_jobs_vacancy.jpg"),
        },
        {
          id: "7",
          name: "Ethio Jobs",
          imageUrl: require("./assets/channels/ethio_jobs.jpg"),
        },
        {
          id: "8",
          name: "Ethiopian Vacancy",
          imageUrl: require("./assets/channels/ethiopian_vacancy.jpg"),
        },
        {
          id: "9",
          name: "Fana Jobs",
          imageUrl: require("./assets/channels/fana_jobs.jpg"),
        },
        {
          id: "10",
          name: "Fana Online Jobs",
          imageUrl: require("./assets/channels/fana_online_jobs.jpg"),
        },
        {
          id: "11",
          name: "Hahu Jobs",
          imageUrl: require("./assets/channels/hahu_jobs.jpg"),
        },
        {
          id: "12",
          name: "Harmee Jobs",
          imageUrl: require("./assets/channels/harmee_jobs.jpg"),
        },
        {
          id: "13",
          name: "Josad Software Jobs",
          imageUrl: require("./assets/channels/josad_software_jobs.jpg"),
        },
        {
          id: "14",
          name: "Tikus Jobs",
          imageUrl: require("./assets/channels/tikus_jobs.jpg"),
        },
      ];
      setTelegramChannels(fetchedChannels);
    } catch (error) {
      console.error("Error loading telegram channels:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const categoriesQuery = dbQuery(collection(db, "categories"), limit(200));
      const categoriesSnapshot = await getDocs(categoriesQuery);
      const fetchedCategories = categoriesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      // Sort manually in the client
      fetchedCategories.sort((a: any, b: any) => {
        if (a.level !== b.level) {
          return (a.level || 0) - (b.level || 0);
        }
        return (a.order || 0) - (b.order || 0);
      });
      setCategories(fetchedCategories);

      // Get top 6 categories by job count (level 0 only)
      const parentCategories = fetchedCategories.filter(
        (cat: any) => cat.level === 0,
      );
      const topCats = parentCategories
        .sort((a: any, b: any) => (b.jobCount || 0) - (a.jobCount || 0))
        .slice(0, 6);
      setTopCategories(topCats);

      // Calculate total jobs from top categories
      const totalJobs = topCats.reduce(
        (sum: number, cat: any) => sum + (cat.jobCount || 0),
        0,
      );
      setTotalJobsCount(totalJobs);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSubscriptionPlans = async () => {
    try {
      const plansSnapshot = await getDocs(collection(db, "subscriptionPlans"));

      if (!plansSnapshot.empty) {
        const firestorePlans = plansSnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            name: data.name,
            priceMonthly: data.priceMonthly || 0,
            priceYearly: data.priceYearly || 0,
            icon: data.icon,
            color: data.color,
            popular: data.popular || false,
            buttonText: data.buttonText,
            features: (data.features || []).map((f: any) => ({
              text: f.name || f.text || "",
              enabled: f.enabled !== undefined ? f.enabled : true,
            })),
            adsEnabled: data.adsEnabled !== undefined ? data.adsEnabled : true,
          };
        });

        // Sort plans: free, standard, pro, enterprise
        const sortOrder: { [key: string]: number } = {
          free: 0,
          standard: 1,
          pro: 2,
          enterprise: 3,
        };
        firestorePlans.sort(
          (a, b) => (sortOrder[a.id] || 999) - (sortOrder[b.id] || 999),
        );

        setSubscriptionPlans(firestorePlans);
      }
    } catch (error) {
      console.error("Error fetching subscription plans:", error);
      // Keep the default SUBSCRIPTION_PLANS if loading fails
    }
  };

  const handleLogin = () => {
    console.log("HandleLogin called, navigation:", navigation);
    try {
      // Clear any URL parameters before navigating to login (web only)
      if (
        Platform.OS === "web" &&
        typeof window !== "undefined" &&
        window.history
      ) {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      }
      if (navigation && navigation.navigate) {
        navigation.navigate("Login");
      } else {
        console.error(
          "Navigation object is not available or navigate method missing",
        );
      }
    } catch (error) {
      console.error("Error navigating to Login:", error);
    }
  };

  const handleSearch = () => {
    // Navigate to Jobs page with search query
    if (searchText.trim()) {
      navigation.navigate("Jobs", { searchQuery: searchText });
    } else {
      navigation.navigate("Jobs");
    }
  };

  const handleGooglePlayDownload = () => {
    const playStoreUrl =
      "https://play.google.com/store/apps/details?id=com.kelem.nibjobs&pcampaignid=web_share";
    if (typeof window !== "undefined") {
      window.open(playStoreUrl, "_blank");
    }
  };

  const handleAppStoreDownload = () => {
    const appStoreUrl = "https://apps.apple.com/app/nibjobs/id123456789"; // Replace with actual App Store ID when available
    if (typeof window !== "undefined") {
      window.open(appStoreUrl, "_blank");
    }
  };

  const renderJobCard = ({ item: job }: any) => (
    <TouchableOpacity
      style={dynamicStyles.jobCard}
      activeOpacity={0.85}
      onPress={() => {
        if (user) {
          navigation.navigate("JobDetails", { id: job.id, job });
        } else {
          navigation.navigate("Signup", {
            message:
              "Please sign up to access all features and view job details. Signing up is completely free!",
          });
        }
      }}
    >
      {/* Header with company badge */}
      <View style={styles.jobCardSimpleHeader}>
        <View style={styles.jobCompanyBadge}>
          <Icon name="business" size={16} color={colors.softBlue} />
        </View>
        {job.isRemote && (
          <View style={styles.remoteTag}>
            <Text style={styles.remoteTagText}>Remote</Text>
          </View>
        )}
      </View>

      {/* Job Info */}
      <View style={styles.jobCardBody}>
        <Text style={dynamicStyles.jobTitle} numberOfLines={2}>
          {job.title || "Job Title"}
        </Text>
        <Text style={dynamicStyles.jobCompany} numberOfLines={1}>
          {job.company || "Company"}
        </Text>

        <View style={styles.jobMetaContainer}>
          <View style={styles.jobMetaItem}>
            <Icon name="location-on" size={14} color={colors.warmGray} />
            <Text style={dynamicStyles.jobLocation} numberOfLines={1}>
              {job.location || "Location"}
            </Text>
          </View>
        </View>

        {job.salary && (
          <View style={styles.jobSalaryContainer}>
            <Icon name="payments" size={14} color={colors.success} />
            <Text style={dynamicStyles.jobSalary} numberOfLines={1}>
              {job.salary}
            </Text>
          </View>
        )}
      </View>

      {/* Footer */}
      <View style={styles.jobCardSimpleFooter}>
        <Text style={dynamicStyles.jobDate}>
          {job.createdAt
            ? new Date(job.createdAt.seconds * 1000).toLocaleDateString()
            : "Recently"}
        </Text>
        <Icon name="arrow-forward" size={16} color={colors.beeYellow} />
      </View>
    </TouchableOpacity>
  );

  const renderChannelCard = ({ item: channel }: any) => (
    <TouchableOpacity style={styles.channelCard} activeOpacity={0.9}>
      <View style={styles.channelAvatarContainer}>
        {channel.imageUrl ? (
          <Image
            source={channel.imageUrl}
            style={styles.channelAvatar}
            resizeMode="cover"
          />
        ) : (
          <View style={styles.channelAvatarPlaceholder}>
            <Icon name="telegram" size={32} color={colors.white} />
          </View>
        )}
      </View>

      <Text style={styles.channelName} numberOfLines={2}>
        {channel.name || channel.username || "Channel"}
      </Text>
    </TouchableOpacity>
  );

  const formatMemberCount = (count: number) => {
    if (count >= 1000000) {
      return `${(count / 1000000).toFixed(1)}M`;
    } else if (count >= 1000) {
      return `${(count / 1000).toFixed(1)}K`;
    }
    return count.toString();
  };

  // ==========================================
  // MOBILE LANDING PAGE - Clean, focused design
  // ==========================================
  if (isMobile) {
    return (
      <SafeAreaView style={{ flex: 1, backgroundColor: "#0F1117" }}>
        <ScrollView
          style={{ flex: 1 }}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{ paddingBottom: 40 }}
        >
          {/* ---- Compact Brand Header ---- */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              paddingHorizontal: 20,
              paddingTop: Platform.OS === "web" ? 16 : 8,
              paddingBottom: 12,
              zIndex: 2,
            }}
          >
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 10 }}
            >
              <Image
                source={require("./assets/favicon.png")}
                style={{ width: 32, height: 32, borderRadius: 8 }}
              />
              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: 18,
                  color: "#FFFFFF",
                  letterSpacing: -0.5,
                }}
              >
                NibJobs
              </Text>
            </View>
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
            >
              {/* Language cycler: አማ → EN → OR → ትግ */}
              <TouchableOpacity
                onPress={() => {
                  const order = ["am", "en", "or", "ti"];
                  const next =
                    order[(order.indexOf(currentLanguage) + 1) % order.length];
                  changeLanguage(next);
                }}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 4,
                  paddingHorizontal: 10,
                  paddingVertical: 7,
                  borderRadius: 20,
                  backgroundColor: "rgba(255,255,255,0.08)",
                }}
              >
                <Icon name="language" size={15} color="rgba(255,255,255,0.8)" />
                <Text
                  style={{
                    fontFamily: fonts.semibold,
                    fontSize: 12,
                    color: "rgba(255,255,255,0.9)",
                  }}
                >
                  {{ am: "አማ", en: "EN", or: "OR", ti: "ትግ" }[
                    currentLanguage as "am" | "en" | "or" | "ti"
                  ] || "EN"}
                </Text>
              </TouchableOpacity>
              {!user && (
                <TouchableOpacity
                  onPress={handleLogin}
                  style={{
                    paddingHorizontal: 16,
                    paddingVertical: 7,
                    borderRadius: 20,
                    borderWidth: 1.5,
                    borderColor: "rgba(255,215,0,0.5)",
                  }}
                >
                  <Text
                    style={{
                      fontFamily: fonts.semibold,
                      fontSize: 13,
                      color: "#FFD700",
                    }}
                  >
                    {t.mobileSignIn || "Sign In"}
                  </Text>
                </TouchableOpacity>
              )}
            </View>
          </View>

          {/* ---- Hero ---- */}
          <View
            style={{
              paddingHorizontal: 22,
              paddingTop: 20,
              paddingBottom: 32,
              overflow: "hidden",
            }}
          >
            {/* Soft background glows */}
            <View
              pointerEvents="none"
              style={{
                position: "absolute",
                top: -120,
                right: -110,
                width: 300,
                height: 300,
                borderRadius: 150,
                backgroundColor: "rgba(255,215,0,0.10)",
              }}
            />
            <View
              pointerEvents="none"
              style={{
                position: "absolute",
                top: 190,
                left: -140,
                width: 260,
                height: 260,
                borderRadius: 130,
                backgroundColor: "rgba(16,185,129,0.07)",
              }}
            />

            {/* Live job count — the page's main focus */}
            {renderLiveJobCounter("mobile")}

            {/* Ethiopian tricolour accent */}
            <View style={{ flexDirection: "row", gap: 4, marginBottom: 14 }}>
              {["#078930", "#FCDD09", "#DA121A"].map((c) => (
                <View
                  key={c}
                  style={{
                    width: 22,
                    height: 4,
                    borderRadius: 2,
                    backgroundColor: c,
                  }}
                />
              ))}
            </View>

            {/* Headline */}
            <Text
              style={{
                fontFamily: fonts.bold,
                fontSize: isEthiopicScript ? 26 : 28,
                lineHeight: isEthiopicScript ? 38 : 34,
                color: "#FFFFFF",
                letterSpacing: isEthiopicScript ? 0 : -0.5,
                marginBottom: 10,
              }}
            >
              {t.mobileHeroLine1 || "Find your"}{" "}
              <Text style={{ textDecorationLine: "underline", textDecorationColor: "#FFD700" } as any}>
                {t.mobileHeroHighlight || "dream job"}
              </Text>{" "}
              {t.mobileHeroLine2 || "today."}
            </Text>

            <Text
              style={{
                fontFamily: fonts.regular,
                fontSize: 15,
                lineHeight: isEthiopicScript ? 26 : 23,
                color: "rgba(255,255,255,0.7)",
                maxWidth: 360,
                marginBottom: 18,
              }}
            >
              {t.mobileHeroDesc ||
                "Jobs from 50+ Telegram channels and companies, all in one place — free, with no broker fees."}
            </Text>

            {/* Perks */}
            <View
              style={{
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 8,
                marginBottom: 24,
              }}
            >
              {[
                { icon: "money-off", label: t.mobileHeroPerkFree || "Free" },
                {
                  icon: "verified-user",
                  label: t.mobileHeroPerkNoBroker || "No brokers",
                },
                {
                  icon: "notifications-active",
                  label: t.mobileHeroPerkAlerts || "Instant alerts",
                },
              ].map((perk) => (
                <View
                  key={perk.icon}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 5,
                    paddingHorizontal: 10,
                    paddingVertical: 6,
                    borderRadius: 8,
                    backgroundColor: "rgba(255,255,255,0.06)",
                    borderWidth: 1,
                    borderColor: "rgba(255,255,255,0.08)",
                  }}
                >
                  <Icon name={perk.icon} size={14} color="#FFD700" />
                  <Text
                    style={{
                      fontFamily: fonts.medium,
                      fontSize: 12,
                      color: "rgba(255,255,255,0.85)",
                    }}
                  >
                    {perk.label}
                  </Text>
                </View>
              ))}
            </View>

            {/* Search */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: "#FFFFFF",
                borderRadius: 16,
                paddingLeft: 14,
                padding: 5,
                marginBottom: 14,
                ...Platform.select({
                  web: { boxShadow: "0 10px 36px rgba(0,0,0,0.35)" },
                  default: {
                    shadowColor: "#000",
                    shadowOffset: { width: 0, height: 6 },
                    shadowOpacity: 0.3,
                    shadowRadius: 14,
                    elevation: 8,
                  },
                }),
              }}
            >
              <Icon name="search" size={21} color="#9CA3AF" />
              <TextInput
                style={{
                  flex: 1,
                  minWidth: 0,
                  fontFamily: fonts.medium,
                  fontSize: 15,
                  color: "#1F2937",
                  paddingVertical: 11,
                  paddingHorizontal: 10,
                }}
                placeholder={
                  t.mobileSearchPlaceholder || "Search jobs, companies..."
                }
                placeholderTextColor="#9CA3AF"
                value={searchText}
                onChangeText={setSearchText}
                onSubmitEditing={handleSearch}
                returnKeyType="search"
              />
              {searchText.length > 0 && (
                <TouchableOpacity
                  onPress={() => setSearchText("")}
                  style={{ paddingHorizontal: 6 }}
                >
                  <Icon name="close" size={18} color="#9CA3AF" />
                </TouchableOpacity>
              )}
              <TouchableOpacity
                onPress={handleSearch}
                activeOpacity={0.85}
                style={{
                  backgroundColor: "#1A1D23",
                  borderRadius: 12,
                  paddingHorizontal: 16,
                  paddingVertical: 11,
                }}
              >
                <Text
                  style={{
                    fontFamily: fonts.semibold,
                    fontSize: 14,
                    color: "#FFD700",
                  }}
                >
                  {t.mobileHeroSearchButton || "Search"}
                </Text>
              </TouchableOpacity>
            </View>

            {/* Primary CTA - Browse Jobs */}
            <TouchableOpacity
              onPress={() => navigation.navigate("Jobs")}
              activeOpacity={0.85}
              style={{
                backgroundColor: "#FFD700",
                borderRadius: 16,
                paddingVertical: 16,
                paddingHorizontal: 20,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                ...Platform.select({
                  web: { boxShadow: "0 10px 28px rgba(255,215,0,0.28)" },
                  default: {
                    shadowColor: "#FFD700",
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: 0.35,
                    shadowRadius: 12,
                    elevation: 6,
                  },
                }),
              }}
            >
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 10 }}
              >
                <Icon name="work-outline" size={22} color="#1A1D23" />
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: 16,
                    color: "#1A1D23",
                  }}
                >
                  {t.mobileBrowseAll || "Browse All Jobs"}
                </Text>
              </View>
              <View
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 16,
                  backgroundColor: "#1A1D23",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="arrow-forward" size={18} color="#FFD700" />
              </View>
            </TouchableOpacity>

            {/* Sign-up nudge */}
            {!user && (
              <TouchableOpacity
                onPress={() => navigation.navigate("Signup")}
                activeOpacity={0.7}
                style={{
                  flexDirection: "row",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  gap: 6,
                  marginTop: 18,
                }}
              >
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 14,
                    color: "rgba(255,255,255,0.55)",
                  }}
                >
                  {t.mobileHeroNoAccount || "No account yet?"}
                </Text>
                <Text
                  style={{
                    fontFamily: fonts.semibold,
                    fontSize: 14,
                    color: "#FFD700",
                  }}
                >
                  {t.mobileHeroSignUp || "Sign up free"} →
                </Text>
              </TouchableOpacity>
            )}
          </View>

          {/* ---- Category Stats (compact pills) ---- */}
          {topCategories.length > 0 && (
            <View style={{ paddingHorizontal: 20, marginBottom: 28 }}>
              <Text
                style={{
                  fontFamily: fonts.semibold,
                  fontSize: 13,
                  color: "rgba(255,255,255,0.45)",
                  textTransform: "uppercase",
                  letterSpacing: 1.5,
                  marginBottom: 14,
                  textAlign: "center",
                }}
              >
                {t.mobileTopCategories || "Top Categories"}
              </Text>
              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 8,
                }}
              >
                {topCategories.slice(0, 6).map((cat: any) => (
                  <TouchableOpacity
                    key={cat.id}
                    onPress={() =>
                      navigation.navigate("Jobs", { searchQuery: cat.name })
                    }
                    activeOpacity={0.7}
                    style={{
                      backgroundColor: "rgba(255,255,255,0.08)",
                      borderRadius: 20,
                      paddingHorizontal: 14,
                      paddingVertical: 8,
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 6,
                      borderWidth: 1,
                      borderColor: "rgba(255,255,255,0.1)",
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: fonts.medium,
                        fontSize: 13,
                        color: "rgba(255,255,255,0.85)",
                      }}
                    >
                      {cat.name}
                    </Text>
                    <View
                      style={{
                        backgroundColor: "rgba(255,215,0,0.2)",
                        borderRadius: 10,
                        paddingHorizontal: 7,
                        paddingVertical: 2,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: fonts.bold,
                          fontSize: 11,
                          color: "#FFD700",
                        }}
                      >
                        {(cat.jobCount || 0).toLocaleString()}
                      </Text>
                    </View>
                  </TouchableOpacity>
                ))}
              </View>
            </View>
          )}

          {/* ---- Hot Jobs Preview ---- */}
          {!loading && jobs.length > 0 && (
            <View style={{ marginBottom: 32 }}>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingHorizontal: 20,
                  marginBottom: 16,
                }}
              >
                <View
                  style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
                >
                  <Text style={{ fontSize: 16 }}>🔥</Text>
                  <Text
                    style={{
                      fontFamily: fonts.bold,
                      fontSize: 18,
                      color: "#FFFFFF",
                    }}
                  >
                    {t.mobileLatestOpenings || "Latest Openings"}
                  </Text>
                </View>
                <TouchableOpacity
                  onPress={() => navigation.navigate("Jobs")}
                  activeOpacity={0.7}
                >
                  <Text
                    style={{
                      fontFamily: fonts.semibold,
                      fontSize: 13,
                      color: "#FFD700",
                    }}
                  >
                    {t.mobileSeeAll || "See All →"}
                  </Text>
                </TouchableOpacity>
              </View>

              {/* Horizontal scrollable job cards */}
              <ScrollView
                horizontal
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={{ paddingHorizontal: 20, gap: 12 }}
              >
                {jobs.slice(0, 8).map((job: any) => (
                  <TouchableOpacity
                    key={job.id}
                    onPress={() =>
                      navigation.navigate("JobDetail", { jobId: job.id })
                    }
                    activeOpacity={0.8}
                    style={{
                      width: 260,
                      backgroundColor: "rgba(255,255,255,0.06)",
                      borderRadius: 16,
                      padding: 16,
                      borderWidth: 1,
                      borderColor: "rgba(255,255,255,0.08)",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10,
                        marginBottom: 12,
                      }}
                    >
                      <View
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: 10,
                          backgroundColor: "rgba(255,215,0,0.15)",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon name="work" size={20} color="#FFD700" />
                      </View>
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontFamily: fonts.semibold,
                            fontSize: 14,
                            color: "#FFFFFF",
                          }}
                          numberOfLines={1}
                        >
                          {job.title}
                        </Text>
                        <Text
                          style={{
                            fontFamily: fonts.regular,
                            fontSize: 12,
                            color: "rgba(255,255,255,0.5)",
                          }}
                          numberOfLines={1}
                        >
                          {job.company || job.companyName}
                        </Text>
                      </View>
                    </View>
                    <View
                      style={{ flexDirection: "row", flexWrap: "wrap", gap: 6 }}
                    >
                      {job.location && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 4,
                            backgroundColor: "rgba(255,255,255,0.06)",
                            borderRadius: 8,
                            paddingHorizontal: 8,
                            paddingVertical: 4,
                          }}
                        >
                          <Icon
                            name="location-on"
                            size={12}
                            color="rgba(255,255,255,0.5)"
                          />
                          <Text
                            style={{
                              fontFamily: fonts.regular,
                              fontSize: 11,
                              color: "rgba(255,255,255,0.6)",
                            }}
                            numberOfLines={1}
                          >
                            {job.location}
                          </Text>
                        </View>
                      )}
                      {job.contractType && (
                        <View
                          style={{
                            backgroundColor: "rgba(16,185,129,0.15)",
                            borderRadius: 8,
                            paddingHorizontal: 8,
                            paddingVertical: 4,
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: fonts.medium,
                              fontSize: 11,
                              color: "#10B981",
                            }}
                          >
                            {job.contractType}
                          </Text>
                        </View>
                      )}
                    </View>
                  </TouchableOpacity>
                ))}
              </ScrollView>
            </View>
          )}

          {/* ---- Download App Section ---- */}
          <View
            style={{
              marginHorizontal: 20,
              marginBottom: 32,
              borderRadius: 20,
              overflow: "hidden",
              backgroundColor: "#1A1D23",
              borderWidth: 1,
              borderColor: "rgba(255,215,0,0.2)",
            }}
          >
            {/* Decorative gradient overlay */}
            <View
              style={{
                position: "absolute",
                top: -40,
                right: -40,
                width: 120,
                height: 120,
                borderRadius: 60,
                backgroundColor: "#FFD700",
                opacity: 0.08,
              }}
            />
            <View
              style={{
                position: "absolute",
                bottom: -20,
                left: -20,
                width: 80,
                height: 80,
                borderRadius: 40,
                backgroundColor: "#10B981",
                opacity: 0.08,
              }}
            />

            <View style={{ padding: 24, alignItems: "center" }}>
              <View
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: 16,
                  backgroundColor: "rgba(255,215,0,0.15)",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 16,
                }}
              >
                <Icon name="phone-android" size={28} color="#FFD700" />
              </View>

              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: 20,
                  color: "#FFFFFF",
                  textAlign: "center",
                  marginBottom: 8,
                }}
              >
                {t.mobileGetApp || "Get the NibJobs App"}
              </Text>

              <Text
                style={{
                  fontFamily: fonts.regular,
                  fontSize: 14,
                  lineHeight: 21,
                  color: "rgba(255,255,255,0.6)",
                  textAlign: "center",
                  marginBottom: 20,
                  maxWidth: 280,
                }}
              >
                {t.mobileGetAppDesc ||
                  "Apply to jobs instantly, get real-time notifications, and track your applications on the go."}
              </Text>

              {/* Feature pills */}
              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 8,
                  marginBottom: 20,
                }}
              >
                {[
                  t.mobileFeatureAlerts || "Instant Alerts",
                  t.mobileFeatureApply || "Easy Apply",
                  t.mobileFeatureTrack || "Track Status",
                ].map((feature) => (
                  <View
                    key={feature}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 5,
                      backgroundColor: "rgba(255,255,255,0.06)",
                      borderRadius: 20,
                      paddingHorizontal: 12,
                      paddingVertical: 6,
                    }}
                  >
                    <Icon name="check-circle" size={14} color="#10B981" />
                    <Text
                      style={{
                        fontFamily: fonts.medium,
                        fontSize: 12,
                        color: "rgba(255,255,255,0.8)",
                      }}
                    >
                      {feature}
                    </Text>
                  </View>
                ))}
              </View>

              {/* Google Play button */}
              <TouchableOpacity
                onPress={handleGooglePlayDownload}
                activeOpacity={0.85}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                  backgroundColor: "#FFFFFF",
                  borderRadius: 12,
                  paddingHorizontal: 24,
                  paddingVertical: 14,
                  ...Platform.select({
                    web: { boxShadow: "0 4px 16px rgba(0,0,0,0.2)" },
                    default: {
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 2 },
                      shadowOpacity: 0.2,
                      shadowRadius: 8,
                      elevation: 4,
                    },
                  }),
                }}
              >
                <Icon name="android" size={24} color="#3DDC84" />
                <View>
                  <Text
                    style={{
                      fontFamily: fonts.regular,
                      fontSize: 10,
                      color: "#666",
                      letterSpacing: 0.5,
                    }}
                  >
                    {t.mobileGetItOn || "GET IT ON"}
                  </Text>
                  <Text
                    style={{
                      fontFamily: fonts.bold,
                      fontSize: 16,
                      color: "#1F2937",
                      marginTop: -2,
                    }}
                  >
                    {t.mobileGooglePlay || "Google Play"}
                  </Text>
                </View>
              </TouchableOpacity>
            </View>
          </View>

          {/* ---- Quick Stats ---- */}
          <View
            style={{
              flexDirection: "row",
              paddingHorizontal: 20,
              marginBottom: 32,
              gap: 10,
            }}
          >
            {[
              {
                icon: "work",
                label: t.mobileStatsJobs || "Jobs",
                value:
                  totalJobsCount > 0
                    ? `${totalJobsCount.toLocaleString()}+`
                    : "—",
                color: "#FFD700",
              },
              {
                icon: "category",
                label: t.mobileStatsCategories || "Categories",
                value:
                  topCategories.length > 0 ? `${topCategories.length}+` : "—",
                color: "#10B981",
              },
              {
                icon: "business",
                label: t.mobileStatsCompanies || "Companies",
                value: "500+",
                color: "#3B82F6",
              },
            ].map((stat) => (
              <View
                key={stat.label}
                style={{
                  flex: 1,
                  backgroundColor: "rgba(255,255,255,0.05)",
                  borderRadius: 14,
                  padding: 16,
                  alignItems: "center",
                  borderWidth: 1,
                  borderColor: "rgba(255,255,255,0.06)",
                }}
              >
                <Icon
                  name={stat.icon}
                  size={20}
                  color={stat.color}
                  style={{ marginBottom: 8 }}
                />
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: 18,
                    color: "#FFFFFF",
                    marginBottom: 2,
                  }}
                >
                  {stat.value}
                </Text>
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 11,
                    color: "rgba(255,255,255,0.45)",
                  }}
                >
                  {stat.label}
                </Text>
              </View>
            ))}
          </View>

          {/* ---- Why NibJobs - compact ---- */}
          <View style={{ paddingHorizontal: 20, marginBottom: 32 }}>
            <Text
              style={{
                fontFamily: fonts.bold,
                fontSize: 20,
                color: "#FFFFFF",
                textAlign: "center",
                marginBottom: 20,
              }}
            >
              {t.mobileWhyLoveUs || "Why Job Seekers Love Us"}
            </Text>
            {[
              {
                icon: "bolt",
                title: t.mobileUpdatedDaily || "Updated Daily",
                desc:
                  t.mobileUpdatedDailyDesc ||
                  "Fresh job listings from top Ethiopian employers, every day.",
              },
              {
                icon: "notifications-active",
                title: t.mobileSmartAlerts || "Smart Alerts",
                desc:
                  t.mobileSmartAlertsDesc ||
                  "Get notified the moment a job matches your skills.",
              },
              {
                icon: "verified",
                title: t.mobileTrustedCompanies || "Trusted Companies",
                desc:
                  t.mobileTrustedCompaniesDesc ||
                  "All employers are verified for your safety.",
              },
            ].map((item, idx) => (
              <View
                key={idx}
                style={{
                  flexDirection: "row",
                  gap: 14,
                  marginBottom: 16,
                  backgroundColor: "rgba(255,255,255,0.04)",
                  borderRadius: 14,
                  padding: 16,
                }}
              >
                <View
                  style={{
                    width: 42,
                    height: 42,
                    borderRadius: 12,
                    backgroundColor: "rgba(255,215,0,0.12)",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name={item.icon} size={22} color="#FFD700" />
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontFamily: fonts.semibold,
                      fontSize: 15,
                      color: "#FFFFFF",
                      marginBottom: 3,
                    }}
                  >
                    {item.title}
                  </Text>
                  <Text
                    style={{
                      fontFamily: fonts.regular,
                      fontSize: 13,
                      lineHeight: 19,
                      color: "rgba(255,255,255,0.55)",
                    }}
                  >
                    {item.desc}
                  </Text>
                </View>
              </View>
            ))}
          </View>

          {/* ---- Final CTA ---- */}
          <View
            style={{
              paddingHorizontal: 20,
              marginBottom: 40,
              alignItems: "center",
            }}
          >
            <Text
              style={{
                fontFamily: fonts.bold,
                fontSize: 22,
                color: "#FFFFFF",
                textAlign: "center",
                marginBottom: 8,
              }}
            >
              {t.mobileReadyTitle || "Ready to find your next role?"}
            </Text>
            <Text
              style={{
                fontFamily: fonts.regular,
                fontSize: 14,
                color: "rgba(255,255,255,0.55)",
                textAlign: "center",
                marginBottom: 20,
              }}
            >
              {t.mobileReadyDesc ||
                "Join thousands of job seekers across Ethiopia."}
            </Text>

            <TouchableOpacity
              onPress={() => navigation.navigate("Jobs")}
              activeOpacity={0.85}
              style={{
                width: "100%",
                backgroundColor: "#FFD700",
                borderRadius: 14,
                paddingVertical: 16,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                ...Platform.select({
                  web: { boxShadow: "0 8px 24px rgba(255,215,0,0.3)" },
                  default: {
                    shadowColor: "#FFD700",
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: 0.35,
                    shadowRadius: 12,
                    elevation: 6,
                  },
                }),
              }}
            >
              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: 16,
                  color: "#1A1D23",
                }}
              >
                {t.mobileStartBrowsing || "Start Browsing Jobs"}
              </Text>
              <Icon name="arrow-forward" size={20} color="#1A1D23" />
            </TouchableOpacity>
          </View>

          {/* ---- Minimal Footer ---- */}
          <View
            style={{
              paddingHorizontal: 20,
              paddingVertical: 24,
              borderTopWidth: 1,
              borderTopColor: "rgba(255,255,255,0.06)",
              alignItems: "center",
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 8,
                marginBottom: 12,
              }}
            >
              <Image
                source={require("./assets/favicon.png")}
                style={{ width: 20, height: 20, borderRadius: 4 }}
              />
              <Text
                style={{
                  fontFamily: fonts.semibold,
                  fontSize: 14,
                  color: "rgba(255,255,255,0.4)",
                }}
              >
                NibJobs
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 20, marginBottom: 12 }}>
              <TouchableOpacity
                onPress={() => navigation.navigate("PrivacyPolicy")}
              >
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 12,
                    color: "rgba(255,255,255,0.35)",
                  }}
                >
                  {t.mobileFooterPrivacy || "Privacy"}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => navigation.navigate("TermsOfService")}
              >
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 12,
                    color: "rgba(255,255,255,0.35)",
                  }}
                >
                  {t.mobileFooterTerms || "Terms"}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity onPress={() => navigation.navigate("Jobs")}>
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 12,
                    color: "rgba(255,255,255,0.35)",
                  }}
                >
                  {t.mobileFooterJobs || "Jobs"}
                </Text>
              </TouchableOpacity>
            </View>
            <Text
              style={{
                fontFamily: fonts.regular,
                fontSize: 11,
                color: "rgba(255,255,255,0.2)",
              }}
            >
              {(
                t.mobileFooterCopyright ||
                "© {year} NibJobs. All rights reserved."
              ).replace("{year}", new Date().getFullYear().toString())}
            </Text>
          </View>
        </ScrollView>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={dynamicStyles.container}>
      {/* Modern Minimalist Header */}
      <View style={dynamicStyles.modernHeader}>
        <View style={styles.modernHeaderContent}>
          {/* Mobile Menu Button & Logo */}
          <View style={styles.modernLogoSection}>
            {isMobile && (
              <TouchableOpacity
                style={[
                  styles.modernIconButton,
                  {
                    backgroundColor: isDarkMode ? "#2C2F36" : colors.lightGray,
                  },
                ]}
                onPress={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                <Icon
                  name={isMobileMenuOpen ? "close" : "menu"}
                  size={24}
                  color={isDarkMode ? colors.white : colors.deepNavy}
                />
              </TouchableOpacity>
            )}

            {!isSearchExpanded && (
              <TouchableOpacity style={styles.modernLogoContainer}>
                <View style={styles.modernLogoBadge}>
                  <Image
                    source={require("./assets/favicon.png")}
                    style={styles.modernLogo}
                  />
                </View>
              </TouchableOpacity>
            )}

            {!isMobile && (
              <View style={styles.modernNavigation}>
                <TouchableOpacity
                  style={styles.modernNavItem}
                  onPress={() => navigation.navigate("Jobs")}
                >
                  <Text style={dynamicStyles.modernNavText}>{t.navJobs}</Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={styles.modernNavItem}
                  onPress={() => navigation.navigate("Companies")}
                >
                  <Text style={dynamicStyles.modernNavText}>{t.companies}</Text>
                </TouchableOpacity>
              </View>
            )}
          </View>

          {/* Right Actions */}
          <View style={styles.modernHeaderRight}>
            {/* Mobile Search - Expandable */}
            {isMobile && (
              <>
                {isSearchExpanded ? (
                  <View style={styles.expandedSearchContainer}>
                    <TextInput
                      style={styles.expandedSearchInput}
                      placeholder="Search jobs..."
                      value={searchText}
                      onChangeText={setSearchText}
                      onSubmitEditing={handleSearch}
                      autoFocus
                      placeholderTextColor={colors.warmGray}
                    />
                    <TouchableOpacity
                      style={styles.expandedSearchClose}
                      onPress={() => {
                        setIsSearchExpanded(false);
                        setSearchText("");
                      }}
                    >
                      <Icon name="close" size={20} color={colors.deepNavy} />
                    </TouchableOpacity>
                  </View>
                ) : (
                  <View style={styles.mobileHeaderActions}>
                    <TouchableOpacity
                      style={[
                        styles.modernIconButton,
                        {
                          backgroundColor: isDarkMode
                            ? "#2C2F36"
                            : colors.lightGray,
                        },
                      ]}
                      onPress={() => setIsSearchExpanded(true)}
                    >
                      <Icon
                        name="search"
                        size={24}
                        color={isDarkMode ? colors.white : colors.deepNavy}
                      />
                    </TouchableOpacity>

                    <TouchableOpacity
                      style={[
                        styles.modernIconButton,
                        {
                          backgroundColor: isDarkMode
                            ? "#2C2F36"
                            : colors.lightGray,
                        },
                      ]}
                      onPress={() => setIsMoreMenuOpen(!isMoreMenuOpen)}
                    >
                      <Icon
                        name="more-vert"
                        size={24}
                        color={isDarkMode ? colors.white : colors.deepNavy}
                      />
                    </TouchableOpacity>
                  </View>
                )}
              </>
            )}

            {!isMobile && (
              <>
                <View style={styles.modernQuickActions}>
                  <TouchableOpacity
                    ref={languageButtonRef}
                    style={styles.modernLanguageButton}
                    onPress={toggleLanguageDropdown}
                  >
                    <Text style={styles.modernLanguageText}>
                      {getCurrentLanguage().code.toUpperCase()}
                    </Text>
                    <Icon
                      name={
                        isLanguageDropdownOpen ? "expand-less" : "expand-more"
                      }
                      size={16}
                      color={colors.deepNavy}
                    />
                  </TouchableOpacity>
                </View>

                {Platform.OS === "web" && (
                  <TouchableOpacity
                    onPress={handleGooglePlayDownload}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 10,
                      backgroundColor: "#000000",
                      paddingHorizontal: 16,
                      paddingVertical: 10,
                      borderRadius: 10,
                      borderWidth: 1,
                      borderColor: "#333",
                    }}
                  >
                    <Icon name="android" size={22} color="#3DDC84" />
                    <View>
                      <Text
                        style={{
                          fontFamily: fonts.regular,
                          fontSize: 9,
                          color: "#CCCCCC",
                        }}
                      >
                        GET IT ON
                      </Text>
                      <Text
                        style={{
                          fontFamily: fonts.bold,
                          fontSize: 14,
                          color: "#FFFFFF",
                          marginTop: -2,
                        }}
                      >
                        Google Play
                      </Text>
                    </View>
                  </TouchableOpacity>
                )}

                {!user && (
                  <TouchableOpacity
                    style={[
                      styles.modernSecondaryButton,
                      {
                        borderColor: isDarkMode
                          ? colors.beeYellow
                          : colors.deepNavy,
                        backgroundColor: isDarkMode ? "#1A1D23" : "transparent",
                      },
                    ]}
                    onPress={handleLogin}
                  >
                    <Text
                      style={[
                        styles.modernSecondaryButtonText,
                        {
                          color: isDarkMode
                            ? colors.beeYellow
                            : colors.deepNavy,
                        },
                      ]}
                    >
                      {t.login}
                    </Text>
                  </TouchableOpacity>
                )}

                {!user && (
                  <TouchableOpacity
                    style={[
                      styles.modernPrimaryButton,
                      {
                        backgroundColor: isDarkMode
                          ? colors.beeYellow
                          : colors.deepNavy,
                      },
                    ]}
                    onPress={() => navigation.navigate("Signup")}
                  >
                    <Icon
                      name="person-add"
                      size={18}
                      color={isDarkMode ? colors.deepNavy : colors.white}
                    />
                    <Text
                      style={[
                        styles.modernPrimaryButtonText,
                        { color: isDarkMode ? colors.deepNavy : colors.white },
                      ]}
                    >
                      {t.signUp}
                    </Text>
                  </TouchableOpacity>
                )}

                {user && (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    {/* Go to Dashboard Button */}
                    <TouchableOpacity
                      style={{
                        paddingHorizontal: 16,
                        paddingVertical: 8,
                        borderRadius: 8,
                        backgroundColor: colors.beeYellow,
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 6,
                      }}
                      onPress={() => {
                        const userRole = userData?.role || "user";
                        if (userRole === "superadmin" || userRole === "admin") {
                          navigation.navigate("AdminPanel");
                        } else if (userRole === "company") {
                          navigation.navigate("CompanyDashboard");
                        } else {
                          navigation.navigate("Jobs");
                        }
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.deepNavy,
                          fontFamily: fonts.medium,
                        }}
                      >
                        Go to Dashboard
                      </Text>
                    </TouchableOpacity>

                    {/* User Profile */}
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      {userData?.profilePicture ? (
                        <Image
                          source={{ uri: userData.profilePicture }}
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: 18,
                            borderWidth: 2,
                            borderColor: colors.beeYellow,
                          }}
                        />
                      ) : (
                        <View
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: 18,
                            backgroundColor: colors.beeYellow,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Text
                            style={{
                              fontSize: 16,
                              fontWeight: "600",
                              color: colors.deepNavy,
                            }}
                          >
                            {(userData?.displayName ||
                              user.email ||
                              "U")[0].toUpperCase()}
                          </Text>
                        </View>
                      )}
                      <Text
                        style={{
                          fontSize: 14,
                          color: colors.deepNavy,
                          fontFamily: fonts.medium,
                        }}
                      >
                        {userData?.displayName ||
                          user.email?.split("@")[0] ||
                          "User"}
                      </Text>
                    </View>

                    {/* Logout Button */}
                    <TouchableOpacity
                      style={{
                        paddingHorizontal: 16,
                        paddingVertical: 8,
                        borderRadius: 8,
                        borderWidth: 1,
                        borderColor: colors.danger,
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 6,
                      }}
                      onPress={async () => {
                        await signOut(auth);
                        navigation.navigate("Home");
                      }}
                    >
                      <Icon name="logout" size={18} color={colors.danger} />
                      {!isMobile && (
                        <Text
                          style={{
                            fontSize: 14,
                            color: colors.danger,
                            fontFamily: fonts.medium,
                          }}
                        >
                          Logout
                        </Text>
                      )}
                    </TouchableOpacity>
                  </View>
                )}
              </>
            )}
          </View>
        </View>
      </View>

      {/* Mobile Menu - Using Shared Drawer Component */}
      <MobileDrawer
        visible={isMobileMenuOpen && isMobile}
        onClose={() => setIsMobileMenuOpen(false)}
        navigation={navigation}
        user={user}
        userData={userData}
        isDarkMode={isDarkMode}
        toggleTheme={toggleTheme}
        currentView="candidate"
        currentLanguage={currentLanguage}
      />

      {/* Full-screen language dropdown overlay - positioned outside toolbar for maximum z-index */}
      {isLanguageDropdownOpen && (
        <View style={styles.fullScreenDropdownOverlay}>
          {/* Invisible touch area to close dropdown */}
          <TouchableOpacity
            style={styles.fullScreenTouchArea}
            onPress={() => setIsLanguageDropdownOpen(false)}
            activeOpacity={1}
          />

          {/* Language dropdown positioned absolutely */}
          <View
            style={[
              styles.absoluteLanguageDropdown,
              { top: dropdownPosition.top, right: dropdownPosition.right },
            ]}
          >
            {languageOptions.map((language, index) => (
              <TouchableOpacity
                key={language.code}
                style={[
                  styles.languageOption,
                  currentLanguage === language.code &&
                    styles.languageOptionActive,
                  index === languageOptions.length - 1 && {
                    borderBottomWidth: 0,
                  },
                ]}
                onPress={() => changeLanguage(language.code)}
              >
                <Text style={styles.languageLabel}>{language.label}</Text>
                {currentLanguage === language.code && (
                  <Icon name="check" size={16} color={colors.beeYellow} />
                )}
              </TouchableOpacity>
            ))}
          </View>
        </View>
      )}

      {/* More Menu Dropdown (Three Dots) */}
      {isMoreMenuOpen && isMobile && (
        <View style={styles.fullScreenDropdownOverlay}>
          <TouchableOpacity
            style={styles.fullScreenTouchArea}
            onPress={() => setIsMoreMenuOpen(false)}
            activeOpacity={1}
          />
          <View style={[styles.moreMenuDropdown, { top: 60, right: 16 }]}>
            <TouchableOpacity
              style={styles.moreMenuItem}
              onPress={() => {
                setIsMoreMenuOpen(false);
                navigation.navigate("Jobs");
              }}
            >
              <Icon name="filter-list" size={20} color={colors.deepNavy} />
              <Text style={styles.moreMenuText}>Filters</Text>
            </TouchableOpacity>

            <View style={styles.moreMenuDivider} />

            <TouchableOpacity
              style={styles.moreMenuItem}
              onPress={() => {
                setIsMoreMenuOpen(false);
                toggleLanguageDropdown();
              }}
            >
              <Icon name="language" size={20} color={colors.deepNavy} />
              <Text style={styles.moreMenuText}>Language</Text>
              <Text style={styles.moreMenuSecondaryText}>
                {getCurrentLanguage().code.toUpperCase()}
              </Text>
            </TouchableOpacity>

            {user && (
              <>
                <View style={styles.moreMenuDivider} />
                <TouchableOpacity
                  style={styles.moreMenuItem}
                  onPress={() => {
                    setIsMoreMenuOpen(false);
                    const userRole = userData?.role || "user";
                    if (userRole === "superadmin" || userRole === "admin") {
                      navigation.navigate("AdminPanel");
                    } else if (userRole === "company") {
                      navigation.navigate("CompanyDashboard");
                    } else {
                      navigation.navigate("Jobs");
                    }
                  }}
                >
                  <Icon name="dashboard" size={20} color={colors.deepNavy} />
                  <Text style={styles.moreMenuText}>Dashboard</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.moreMenuItem}
                  onPress={async () => {
                    setIsMoreMenuOpen(false);
                    await signOut(auth);
                    navigation.navigate("Home");
                  }}
                >
                  <Text style={[styles.moreMenuText, { color: colors.danger }]}>
                    Logout
                  </Text>
                </TouchableOpacity>
              </>
            )}

            {!user && (
              <>
                <View style={styles.moreMenuDivider} />
                <TouchableOpacity
                  style={styles.moreMenuItem}
                  onPress={() => {
                    setIsMoreMenuOpen(false);
                    handleLogin();
                  }}
                >
                  <Icon name="login" size={20} color={colors.deepNavy} />
                  <Text style={styles.moreMenuText}>Login</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  style={styles.moreMenuItem}
                  onPress={() => {
                    setIsMoreMenuOpen(false);
                    navigation.navigate("Signup");
                  }}
                >
                  <Icon name="person-add" size={20} color={colors.deepNavy} />
                  <Text style={styles.moreMenuText}>Sign Up</Text>
                </TouchableOpacity>
              </>
            )}
          </View>
        </View>
      )}

      <View style={styles.mainContent}>
        <ScrollView
          style={dynamicStyles.leftContent}
          showsVerticalScrollIndicator={true}
        >
          {/* Modern Hero Section */}
          <View
            style={{
              position: "relative",
              overflow: "hidden",
              minHeight: isMobile ? 650 : 750,
              backgroundColor: "#1A1D23",
            }}
          >
            {/* Subtle Pattern Background */}
            <View
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                opacity: 0.05,
                ...Platform.select({
                  web: {
                    backgroundImage: `repeating-linear-gradient(
                    45deg,
                    transparent,
                    transparent 10px,
                    #FFD700 10px,
                    #FFD700 11px
                  )`,
                  },
                }),
              }}
            />

            {/* Accent Shapes */}
            <View
              style={{
                position: "absolute",
                top: -50,
                right: -50,
                width: 200,
                height: 200,
                borderRadius: 100,
                backgroundColor: "#FFD700",
                opacity: 0.1,
              }}
            />
            <View
              style={{
                position: "absolute",
                bottom: -30,
                left: -30,
                width: 150,
                height: 150,
                borderRadius: 75,
                backgroundColor: "#FFD700",
                opacity: 0.08,
              }}
            />

            <View
              style={{
                flexDirection: isMobile ? "column" : "row",
                paddingHorizontal: isMobile ? 20 : isTablet ? 50 : 80,
                paddingTop: isMobile ? 40 : 60,
                paddingBottom: isMobile ? 40 : 60,
                maxWidth: 1400,
                alignSelf: "center",
                width: "100%",
                gap: isMobile ? 40 : 50,
                alignItems: "center",
              }}
            >
              {/* Left Content */}
              <View
                style={{
                  flex: 1,
                  zIndex: 1,
                }}
              >
                {/* Pop Badge */}
                <View
                  style={{
                    alignSelf: "flex-start",
                    backgroundColor: "#FFFFFF",
                    paddingHorizontal: 20,
                    paddingVertical: 10,
                    borderRadius: 50,
                    marginBottom: 24,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                    ...Platform.select({
                      web: {
                        boxShadow: "0 10px 40px rgba(0, 0, 0, 0.15)",
                      },
                      default: {
                        shadowColor: "#000",
                        shadowOffset: { width: 0, height: 8 },
                        shadowOpacity: 0.2,
                        shadowRadius: 20,
                        elevation: 8,
                      },
                    }),
                  }}
                >
                  <View
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 12,
                      backgroundColor: "#10B981",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text style={{ fontSize: 14 }}>✓</Text>
                  </View>
                  <Text
                    style={{
                      fontFamily: fonts.bold,
                      fontSize: 13,
                      color: "#1F2937",
                      letterSpacing: 0.5,
                    }}
                  >
                    {t.heroBadge.replace("🚀 ", "")}
                  </Text>
                </View>

                {/* Live job count — the page's main focus */}
                {renderLiveJobCounter("desktop")}

                {/* Headline (secondary to the job count above) */}
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: isTablet ? 34 : 40,
                    lineHeight: isEthiopicScript
                      ? isTablet
                        ? 48
                        : 56
                      : isTablet
                      ? 42
                      : 48,
                    fontWeight: "800",
                    letterSpacing: isEthiopicScript ? 0 : -1,
                    color: "#FFFFFF",
                    marginBottom: 14,
                  }}
                >
                  {t.desktopHeroFind}{" "}
                  <Text
                    style={
                      {
                        textDecorationLine: "underline",
                        textDecorationColor: "#FFD700",
                      } as any
                    }
                  >
                    {t.desktopHeroDreamJob}
                  </Text>
                </Text>

                {/* Subtitle */}
                <Text
                  style={{
                    fontFamily: fonts.medium,
                    fontSize: 18,
                    color: "rgba(255, 255, 255, 0.75)",
                    lineHeight: isEthiopicScript ? 30 : 28,
                    marginBottom: 32,
                    maxWidth: 560,
                  }}
                >
                  {t.mobileHeroDesc ||
                    "Jobs from 50+ Telegram channels and companies, all in one place — free, with no broker fees."}
                </Text>

                {/* Modern Search Bar */}
                <View
                  style={{
                    backgroundColor: "#FFFFFF",
                    borderRadius: 16,
                    padding: 6,
                    marginBottom: 32,
                    flexDirection: isMobile ? "column" : "row",
                    gap: 8,
                    ...Platform.select({
                      web: {
                        boxShadow: "0 20px 60px rgba(0, 0, 0, 0.25)",
                      },
                      default: {
                        shadowColor: "#000",
                        shadowOffset: { width: 0, height: 10 },
                        shadowOpacity: 0.25,
                        shadowRadius: 30,
                        elevation: 12,
                      },
                    }),
                  }}
                >
                  <View
                    style={{
                      flex: 1,
                      flexDirection: "row",
                      alignItems: "center",
                      paddingHorizontal: 20,
                      paddingVertical: 14,
                      gap: 12,
                    }}
                  >
                    <Icon name="search" size={22} color="#9CA3AF" />
                    <TextInput
                      style={{
                        flex: 1,
                        fontFamily: fonts.medium,
                        fontSize: 15,
                        color: "#1F2937",
                      }}
                      placeholder={
                        t.desktopSearchPlaceholder ||
                        "Search jobs, skills, or companies..."
                      }
                      placeholderTextColor="#9CA3AF"
                      value={searchText}
                      onChangeText={setSearchText}
                      onSubmitEditing={handleSearch}
                    />
                  </View>

                  <TouchableOpacity
                    style={{
                      backgroundColor: "#10B981",
                      paddingHorizontal: isMobile ? 32 : 36,
                      paddingVertical: 14,
                      borderRadius: 12,
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      ...Platform.select({
                        web: {
                          transition: "all 0.3s ease",
                          ":hover": {
                            backgroundColor: "#059669",
                            transform: "scale(1.02)",
                            boxShadow: "0 10px 30px rgba(16, 185, 129, 0.4)",
                          },
                        },
                      }),
                    }}
                    onPress={handleSearch}
                    activeOpacity={0.85}
                  >
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 15,
                        color: "#FFFFFF",
                      }}
                    >
                      {t.search || "Search"}
                    </Text>
                    <Icon name="arrow-forward" size={20} color="#FFFFFF" />
                  </TouchableOpacity>
                </View>

                {/* CTA Buttons */}
                <View
                  style={{
                    flexDirection: isMobile ? "column" : "row",
                    gap: 12,
                    alignItems: isMobile ? "stretch" : "center",
                  }}
                >
                  {!user && (
                    <TouchableOpacity
                      style={{
                        backgroundColor: "#FFD700",
                        paddingHorizontal: 28,
                        paddingVertical: 14,
                        borderRadius: 12,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 10,
                        ...Platform.select({
                          web: {
                            boxShadow: "0 10px 30px rgba(255, 215, 0, 0.3)",
                            transition: "all 0.3s ease",
                            ":hover": {
                              transform: "translateY(-2px)",
                              boxShadow: "0 15px 40px rgba(255, 215, 0, 0.4)",
                            },
                          },
                        }),
                      }}
                      onPress={() => navigation.navigate("Signup")}
                      activeOpacity={0.85}
                    >
                      <Icon name="send" size={20} color="#1A1D23" />
                      <Text
                        style={{
                          fontFamily: fonts.bold,
                          fontSize: 15,
                          color: "#1A1D23",
                        }}
                      >
                        {t.getStartedFree || "Get Started Free"}
                      </Text>
                    </TouchableOpacity>
                  )}

                  {Platform.OS === "web" && (
                    <TouchableOpacity
                      onPress={handleGooglePlayDownload}
                      activeOpacity={0.85}
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10,
                        backgroundColor: "rgba(255, 255, 255, 0.15)",
                        paddingHorizontal: 20,
                        paddingVertical: 12,
                        borderRadius: 12,
                        borderWidth: 2,
                        borderColor: "rgba(255, 255, 255, 0.3)",
                        ...Platform.select({
                          web: {
                            transition: "all 0.3s ease",
                            ":hover": {
                              backgroundColor: "rgba(255, 255, 255, 0.25)",
                              borderColor: "rgba(255, 255, 255, 0.5)",
                            },
                          },
                        }),
                      }}
                    >
                      <Icon name="android" size={24} color="#3DDC84" />
                      <View>
                        <Text
                          style={{
                            fontFamily: fonts.medium,
                            fontSize: 9,
                            color: "rgba(255, 255, 255, 0.7)",
                            letterSpacing: 0.5,
                          }}
                        >
                          {t.getItOnGooglePlay || "GET IT ON"}
                        </Text>
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: 14,
                            color: "#FFFFFF",
                            marginTop: -2,
                          }}
                        >
                          {t.googlePlay || "Google Play"}
                        </Text>
                      </View>
                    </TouchableOpacity>
                  )}
                </View>
              </View>

              {/* Right Side - Vibrant Category Cards */}
              {!isMobile && (
                <View
                  style={{
                    flex: 0.9,
                    gap: 14,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      gap: 14,
                    }}
                  >
                    {loading
                      ? // Skeleton Loading Cards
                        Array.from({ length: 6 }).map((_, index) => {
                          const colorSchemes = [
                            { bg: "#10B981", icon: "work" },
                            { bg: "#F59E0B", icon: "psychology" },
                            { bg: "#EF4444", icon: "favorite" },
                            { bg: "#3B82F6", icon: "science" },
                            { bg: "#8B5CF6", icon: "school" },
                            { bg: "#EC4899", icon: "restaurant" },
                          ];
                          const scheme =
                            colorSchemes[index % colorSchemes.length];

                          return (
                            <View
                              key={`skeleton-${index}`}
                              style={{
                                width: "48%",
                                backgroundColor: "#FFFFFF",
                                borderRadius: 18,
                                padding: 20,
                                position: "relative",
                                overflow: "hidden",
                                ...Platform.select({
                                  web: {
                                    boxShadow:
                                      "0 10px 40px rgba(0, 0, 0, 0.12)",
                                  },
                                  default: {
                                    shadowColor: "#000",
                                    shadowOffset: { width: 0, height: 6 },
                                    shadowOpacity: 0.15,
                                    shadowRadius: 20,
                                    elevation: 8,
                                  },
                                }),
                              }}
                            >
                              <View
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 12,
                                  marginBottom: 12,
                                }}
                              >
                                <View
                                  style={{
                                    width: 48,
                                    height: 48,
                                    borderRadius: 14,
                                    backgroundColor: scheme.bg,
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Icon
                                    name={scheme.icon}
                                    size={24}
                                    color="#FFFFFF"
                                  />
                                </View>
                                <View
                                  style={{
                                    flex: 1,
                                    height: 16,
                                    backgroundColor: "#E5E7EB",
                                    borderRadius: 8,
                                    ...Platform.select({
                                      web: {
                                        animation:
                                          "pulse 1.5s ease-in-out infinite",
                                      },
                                    }),
                                  }}
                                />
                              </View>

                              <View
                                style={{
                                  flexDirection: "row",
                                  alignItems: "baseline",
                                  gap: 5,
                                }}
                              >
                                <View
                                  style={{
                                    width: 60,
                                    height: 28,
                                    backgroundColor: "#E5E7EB",
                                    borderRadius: 8,
                                    ...Platform.select({
                                      web: {
                                        animation:
                                          "pulse 1.5s ease-in-out infinite",
                                      },
                                    }),
                                  }}
                                />
                                <Text
                                  style={{
                                    fontFamily: fonts.medium,
                                    fontSize: 12,
                                    color: "#9CA3AF",
                                  }}
                                >
                                  jobs
                                </Text>
                              </View>
                            </View>
                          );
                        })
                      : topCategories.length > 0
                      ? // Actual Category Cards with Animation
                        topCategories.slice(0, 6).map((category, index) => {
                          const colorSchemes = [
                            { bg: "#10B981", icon: "work" },
                            { bg: "#F59E0B", icon: "psychology" },
                            { bg: "#EF4444", icon: "favorite" },
                            { bg: "#3B82F6", icon: "science" },
                            { bg: "#8B5CF6", icon: "school" },
                            { bg: "#EC4899", icon: "restaurant" },
                          ];
                          const scheme =
                            colorSchemes[index % colorSchemes.length];
                          const animatedCount =
                            cardAnimatedCounts[category.id] || 0;
                          const actualCount = category.jobCount || 0;

                          return (
                            <TouchableOpacity
                              key={category.id}
                              onPress={() => {
                                setSelectedCategory(category.id);
                                setShowCategoryFilter(false);
                                handleSearch();
                              }}
                              activeOpacity={0.85}
                              style={{
                                width: "48%",
                                backgroundColor: "#FFFFFF",
                                borderRadius: 18,
                                padding: 20,
                                position: "relative",
                                overflow: "hidden",
                                ...Platform.select({
                                  web: {
                                    boxShadow:
                                      "0 10px 40px rgba(0, 0, 0, 0.12)",
                                    transition:
                                      "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                    ":hover": {
                                      transform: "translateY(-6px)",
                                      boxShadow:
                                        "0 20px 60px rgba(0, 0, 0, 0.2)",
                                    },
                                  },
                                  default: {
                                    shadowColor: "#000",
                                    shadowOffset: { width: 0, height: 6 },
                                    shadowOpacity: 0.15,
                                    shadowRadius: 20,
                                    elevation: 8,
                                  },
                                }),
                              }}
                            >
                              <View
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 12,
                                  marginBottom: 12,
                                }}
                              >
                                <View
                                  style={{
                                    width: 48,
                                    height: 48,
                                    borderRadius: 14,
                                    backgroundColor: scheme.bg,
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <Icon
                                    name={scheme.icon}
                                    size={24}
                                    color="#FFFFFF"
                                  />
                                </View>
                                <Text
                                  style={{
                                    fontFamily: fonts.semibold,
                                    fontSize: 14,
                                    color: "#1F2937",
                                    flex: 1,
                                  }}
                                  numberOfLines={2}
                                >
                                  {category.name}
                                </Text>
                              </View>

                              <View
                                style={{
                                  flexDirection: "row",
                                  alignItems: "baseline",
                                  gap: 5,
                                }}
                              >
                                <Text
                                  style={{
                                    fontFamily: fonts.bold,
                                    fontSize: 26,
                                    color: scheme.bg,
                                    letterSpacing: -0.5,
                                  }}
                                >
                                  {(animatedCount > 0
                                    ? animatedCount
                                    : actualCount
                                  ).toLocaleString()}
                                </Text>
                                <Text
                                  style={{
                                    fontFamily: fonts.medium,
                                    fontSize: 12,
                                    color: "#9CA3AF",
                                  }}
                                >
                                  jobs
                                </Text>
                              </View>
                            </TouchableOpacity>
                          );
                        })
                      : null}
                  </View>
                </View>
              )}
            </View>

            {/* Integrated Job Ticker at Bottom of Hero */}
            {!loading && jobs.length > 0 && (
              <View
                style={{
                  backgroundColor: "rgba(255, 215, 0, 0.15)",
                  paddingVertical: 16,
                  borderTopWidth: 1,
                  borderTopColor: "rgba(255, 215, 0, 0.3)",
                  ...Platform.select({
                    web: {
                      backdropFilter: "blur(10px)",
                    },
                  }),
                }}
              >
                <View
                  style={{
                    maxWidth: 1400,
                    alignSelf: "center",
                    width: "100%",
                    paddingHorizontal: isMobile ? 20 : 80,
                  }}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 16,
                    }}
                  >
                    <View
                      style={{
                        backgroundColor: "#FFD700",
                        paddingHorizontal: 16,
                        paddingVertical: 8,
                        borderRadius: 8,
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: fonts.bold,
                          fontSize: 11,
                          color: "#1A1D23",
                          textTransform: "uppercase",
                          letterSpacing: 1,
                        }}
                      >
                        🔥 Hot Jobs
                      </Text>
                    </View>

                    <View style={{ flex: 1, overflow: "hidden" }}>
                      <ScrollView
                        ref={jobTickerScrollRef}
                        horizontal
                        showsHorizontalScrollIndicator={false}
                        contentContainerStyle={{ gap: 20 }}
                        scrollEventThrottle={16}
                      >
                        {/* Duplicate jobs for seamless loop */}
                        {[...jobs.slice(0, 12), ...jobs.slice(0, 12)].map(
                          (job, index) => (
                            <TouchableOpacity
                              key={`${job.id}-${index}`}
                              onPress={() =>
                                navigation.navigate("JobDetail", {
                                  jobId: job.id,
                                })
                              }
                              activeOpacity={0.8}
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 8,
                                paddingRight: 20,
                                borderRightWidth: 1,
                                borderRightColor: "rgba(255, 255, 255, 0.2)",
                              }}
                            >
                              <View
                                style={{
                                  width: 6,
                                  height: 6,
                                  borderRadius: 3,
                                  backgroundColor: "#10B981",
                                }}
                              />
                              <Text
                                style={{
                                  fontFamily: fonts.semibold,
                                  fontSize: 13,
                                  color: "#FFFFFF",
                                }}
                                numberOfLines={1}
                              >
                                {job.title}
                              </Text>
                              <Text
                                style={{
                                  fontFamily: fonts.regular,
                                  fontSize: 12,
                                  color: "rgba(255, 255, 255, 0.7)",
                                }}
                              >
                                @ {job.companyName}
                              </Text>
                            </TouchableOpacity>
                          ),
                        )}
                      </ScrollView>
                    </View>

                    <TouchableOpacity
                      onPress={() =>
                        navigation.navigate(user ? "Jobs" : "Signup")
                      }
                      style={{
                        paddingHorizontal: 16,
                        paddingVertical: 8,
                        borderRadius: 8,
                        backgroundColor: "rgba(255, 255, 255, 0.15)",
                        borderWidth: 1,
                        borderColor: "rgba(255, 255, 255, 0.3)",
                      }}
                    >
                      <Text
                        style={{
                          fontFamily: fonts.semibold,
                          fontSize: 12,
                          color: "#FFFFFF",
                        }}
                      >
                        {t.desktopViewAll || "View All →"}
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
            )}
          </View>

          {/* Remove standalone ticker - now integrated in hero */}

          {/* About Us Section - Modern Design */}
          <View
            style={{
              paddingVertical: isMobile ? 48 : 80,
              paddingHorizontal: isMobile ? 16 : 60,
              backgroundColor: isDarkMode ? "#141820" : "#F8FAFC",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative elements */}
            <View
              style={{
                position: "absolute",
                bottom: -60,
                left: -60,
                width: 200,
                height: 200,
                borderRadius: 100,
                backgroundColor: isDarkMode
                  ? "rgba(251, 191, 36, 0.03)"
                  : "rgba(251, 191, 36, 0.06)",
              }}
            />
            <View
              style={{
                position: "absolute",
                top: 60,
                right: -40,
                width: 100,
                height: 100,
                borderRadius: 50,
                backgroundColor: isDarkMode
                  ? "rgba(59, 130, 246, 0.05)"
                  : "rgba(59, 130, 246, 0.08)",
              }}
            />

            <View
              style={{ maxWidth: 1200, alignSelf: "center", width: "100%" }}
            >
              {/* Section Header */}
              <View style={{ marginBottom: 40, alignItems: "center" }}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 8,
                    marginBottom: 12,
                  }}
                >
                  <View
                    style={{
                      width: 32,
                      height: 3,
                      backgroundColor: colors.beeYellow,
                      borderRadius: 2,
                    }}
                  />
                  <Text
                    style={{
                      fontFamily: fonts.medium,
                      fontSize: 13,
                      color: colors.beeYellow,
                      textTransform: "uppercase",
                      letterSpacing: 1.5,
                    }}
                  >
                    {t.aboutUsLabel}
                  </Text>
                  <View
                    style={{
                      width: 32,
                      height: 3,
                      backgroundColor: colors.beeYellow,
                      borderRadius: 2,
                    }}
                  />
                </View>
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: isMobile ? 28 : 36,
                    color: isDarkMode ? "#FFFFFF" : "#0F172A",
                    marginBottom: 8,
                    textAlign: "center",
                  }}
                >
                  {t.aboutUsTitle}
                </Text>
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 16,
                    color: isDarkMode ? "#9CA3AF" : "#64748B",
                    textAlign: "center",
                    maxWidth: 500,
                  }}
                >
                  {t.aboutUsSubtitle}
                </Text>
              </View>

              {/* About Content */}
              <View style={{ alignItems: "center", marginBottom: 48 }}>
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 17,
                    lineHeight: 28,
                    color: isDarkMode ? "#D1D5DB" : "#475569",
                    textAlign: "center",
                    maxWidth: 800,
                  }}
                >
                  {t.aboutUsDesc}
                </Text>
              </View>

              {/* Feature Cards */}
              <View
                style={{
                  flexDirection: isMobile ? "column" : "row",
                  gap: 24,
                  justifyContent: "center",
                }}
              >
                {[
                  {
                    icon: "business",
                    title: t.topCompanies,
                    desc: t.topCompaniesDesc,
                    color: "#3B82F6",
                    bgColor: isDarkMode
                      ? "rgba(59, 130, 246, 0.15)"
                      : "rgba(59, 130, 246, 0.1)",
                  },
                  {
                    icon: "notifications-active",
                    title: t.instantAlerts,
                    desc: t.instantAlertsDesc,
                    color: "#10B981",
                    bgColor: isDarkMode
                      ? "rgba(16, 185, 129, 0.15)"
                      : "rgba(16, 185, 129, 0.1)",
                  },
                  {
                    icon: "language",
                    title: t.multilingual,
                    desc: t.multilingualDesc,
                    color: "#8B5CF6",
                    bgColor: isDarkMode
                      ? "rgba(139, 92, 246, 0.15)"
                      : "rgba(139, 92, 246, 0.1)",
                  },
                ].map((feature) => (
                  <View
                    key={feature.title}
                    style={{
                      flex: 1,
                      minWidth: isMobile ? "auto" : 280,
                      maxWidth: isMobile ? "100%" : 350,
                      backgroundColor: isDarkMode ? "#1F2937" : "#FFFFFF",
                      borderRadius: 20,
                      padding: 28,
                      alignItems: "center",
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 4 },
                      shadowOpacity: isDarkMode ? 0.3 : 0.08,
                      shadowRadius: 20,
                      elevation: 8,
                      borderWidth: 1,
                      borderColor: isDarkMode ? "#374151" : "#F1F5F9",
                    }}
                  >
                    <View
                      style={{
                        width: 64,
                        height: 64,
                        borderRadius: 20,
                        backgroundColor: feature.bgColor,
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: 20,
                      }}
                    >
                      <Icon
                        name={feature.icon}
                        size={28}
                        color={feature.color}
                      />
                    </View>
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 18,
                        color: isDarkMode ? "#FFFFFF" : "#0F172A",
                        marginBottom: 8,
                        textAlign: "center",
                      }}
                    >
                      {feature.title}
                    </Text>
                    <Text
                      style={{
                        fontFamily: fonts.regular,
                        fontSize: 14,
                        color: isDarkMode ? "#9CA3AF" : "#64748B",
                        textAlign: "center",
                        lineHeight: 22,
                      }}
                    >
                      {feature.desc}
                    </Text>
                  </View>
                ))}
              </View>
            </View>
          </View>

          {/* How It Works Section - Modern Design */}
          <View
            style={{
              paddingVertical: isMobile ? 48 : 80,
              paddingHorizontal: isMobile ? 16 : 60,
              backgroundColor: isDarkMode ? "#141820" : "#F8FAFC",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative elements */}
            <View
              style={{
                position: "absolute",
                top: -50,
                right: -50,
                width: 200,
                height: 200,
                borderRadius: 100,
                backgroundColor: isDarkMode
                  ? "rgba(251, 191, 36, 0.03)"
                  : "rgba(251, 191, 36, 0.06)",
              }}
            />

            <View
              style={{ maxWidth: 1200, alignSelf: "center", width: "100%" }}
            >
              {/* Section Header */}
              <View style={{ marginBottom: 48, alignItems: "center" }}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 8,
                    marginBottom: 12,
                  }}
                >
                  <View
                    style={{
                      width: 32,
                      height: 3,
                      backgroundColor: colors.beeYellow,
                      borderRadius: 2,
                    }}
                  />
                  <Text
                    style={{
                      fontFamily: fonts.medium,
                      fontSize: 13,
                      color: colors.beeYellow,
                      textTransform: "uppercase",
                      letterSpacing: 1.5,
                    }}
                  >
                    {t.processLabel}
                  </Text>
                  <View
                    style={{
                      width: 32,
                      height: 3,
                      backgroundColor: colors.beeYellow,
                      borderRadius: 2,
                    }}
                  />
                </View>
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: isMobile ? 28 : 36,
                    color: isDarkMode ? "#FFFFFF" : "#0F172A",
                    marginBottom: 8,
                    textAlign: "center",
                  }}
                >
                  {t.howItWorksTitle}
                </Text>
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 16,
                    color: isDarkMode ? "#9CA3AF" : "#64748B",
                    textAlign: "center",
                  }}
                >
                  {t.howItWorksSubtitle}
                </Text>
              </View>

              {/* Steps */}
              <View
                style={{
                  flexDirection: isMobile ? "column" : "row",
                  gap: 32,
                  justifyContent: "center",
                  alignItems: isMobile ? "center" : "stretch",
                }}
              >
                {[
                  {
                    step: "01",
                    icon: "search",
                    title: t.step1,
                    desc: t.step1Desc,
                    color: "#3B82F6",
                  },
                  {
                    step: "02",
                    icon: "assignment",
                    title: t.step2,
                    desc: t.step2Desc,
                    color: "#10B981",
                  },
                  {
                    step: "03",
                    icon: "celebration",
                    title: t.step3,
                    desc: t.step3Desc,
                    color: "#F59E0B",
                  },
                ].map((item, index) => (
                  <View
                    key={item.step}
                    style={{
                      flex: 1,
                      maxWidth: isMobile ? 320 : 340,
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    {/* Step Number */}
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 80,
                        color: isDarkMode
                          ? "rgba(255,255,255,0.03)"
                          : "rgba(0,0,0,0.03)",
                        position: "absolute",
                        top: -20,
                        left: isMobile ? "35%" : 10,
                        zIndex: 0,
                      }}
                    >
                      {item.step}
                    </Text>

                    {/* Icon Container */}
                    <View
                      style={{
                        width: 80,
                        height: 80,
                        borderRadius: 24,
                        backgroundColor: item.color,
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: 24,
                        shadowColor: item.color,
                        shadowOffset: { width: 0, height: 8 },
                        shadowOpacity: 0.3,
                        shadowRadius: 16,
                        elevation: 10,
                        zIndex: 1,
                      }}
                    >
                      <Icon name={item.icon} size={36} color="#FFFFFF" />
                    </View>

                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 20,
                        color: isDarkMode ? "#FFFFFF" : "#0F172A",
                        marginBottom: 12,
                        textAlign: "center",
                      }}
                    >
                      {item.title}
                    </Text>
                    <Text
                      style={{
                        fontFamily: fonts.regular,
                        fontSize: 15,
                        color: isDarkMode ? "#9CA3AF" : "#64748B",
                        textAlign: "center",
                        lineHeight: 24,
                      }}
                    >
                      {item.desc}
                    </Text>
                  </View>
                ))}
              </View>
            </View>
          </View>

          {/* Testimonials Section - Modern Design */}
          <View
            style={{
              paddingVertical: isMobile ? 48 : 80,
              paddingHorizontal: isMobile ? 16 : 60,
              backgroundColor: isDarkMode ? "#141820" : "#FFF9E6",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative elements */}
            <View
              style={{
                position: "absolute",
                top: 40,
                left: -60,
                width: 150,
                height: 150,
                borderRadius: 75,
                backgroundColor: isDarkMode
                  ? "rgba(251, 191, 36, 0.03)"
                  : "rgba(251, 191, 36, 0.15)",
              }}
            />
            <View
              style={{
                position: "absolute",
                bottom: 40,
                right: -40,
                width: 100,
                height: 100,
                borderRadius: 50,
                backgroundColor: isDarkMode
                  ? "rgba(59, 130, 246, 0.05)"
                  : "rgba(59, 130, 246, 0.1)",
              }}
            />

            <View
              style={{ maxWidth: 1200, alignSelf: "center", width: "100%" }}
            >
              {/* Section Header */}
              <View style={{ marginBottom: 48, alignItems: "center" }}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 8,
                    marginBottom: 12,
                  }}
                >
                  <View
                    style={{
                      width: 32,
                      height: 3,
                      backgroundColor: colors.beeYellow,
                      borderRadius: 2,
                    }}
                  />
                  <Text
                    style={{
                      fontFamily: fonts.medium,
                      fontSize: 13,
                      color: colors.beeYellow,
                      textTransform: "uppercase",
                      letterSpacing: 1.5,
                    }}
                  >
                    {t.testimonialsLabel}
                  </Text>
                  <View
                    style={{
                      width: 32,
                      height: 3,
                      backgroundColor: colors.beeYellow,
                      borderRadius: 2,
                    }}
                  />
                </View>
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: isMobile ? 28 : 36,
                    color: isDarkMode ? "#FFFFFF" : "#0F172A",
                    marginBottom: 8,
                    textAlign: "center",
                  }}
                >
                  {t.successStoriesTitle}
                </Text>
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 16,
                    color: isDarkMode ? "#9CA3AF" : "#64748B",
                    textAlign: "center",
                  }}
                >
                  {t.successStoriesSubtitle}
                </Text>
              </View>

              {/* Testimonials Grid */}
              <View
                style={{
                  flexDirection: isMobile ? "column" : "row",
                  gap: 24,
                  justifyContent: "center",
                }}
              >
                {[
                  {
                    initials: "AM",
                    name: "Abebe Molla",
                    role: "Software Developer",
                    text: "I found my dream job in just 2 weeks! The job alerts feature helped me stay updated with relevant opportunities.",
                    color: "#3B82F6",
                  },
                  {
                    initials: "ST",
                    name: "Sara Tekle",
                    role: "Marketing Manager",
                    text: "NibJobs made my job search so much easier. The interface is intuitive and the job listings are always up to date.",
                    color: "#10B981",
                  },
                  {
                    initials: "DH",
                    name: "Daniel Haile",
                    role: "Data Analyst",
                    text: "As a fresh graduate, NibJobs helped me navigate the job market. Highly recommended for anyone starting their career!",
                    color: "#F59E0B",
                  },
                ].map((testimonial) => (
                  <View
                    key={testimonial.initials}
                    style={{
                      flex: 1,
                      maxWidth: isMobile ? "100%" : 360,
                      backgroundColor: isDarkMode ? "#1F2937" : "#FFFFFF",
                      borderRadius: 24,
                      padding: 28,
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 8 },
                      shadowOpacity: isDarkMode ? 0.3 : 0.08,
                      shadowRadius: 24,
                      elevation: 8,
                      borderWidth: 1,
                      borderColor: isDarkMode ? "#374151" : "#F1F5F9",
                    }}
                  >
                    {/* Quote icon */}
                    <View
                      style={{
                        width: 40,
                        height: 40,
                        borderRadius: 12,
                        backgroundColor: `${testimonial.color}15`,
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: 20,
                      }}
                    >
                      <Icon
                        name="format-quote"
                        size={24}
                        color={testimonial.color}
                      />
                    </View>

                    {/* Rating */}
                    <View
                      style={{ flexDirection: "row", gap: 4, marginBottom: 16 }}
                    >
                      {[1, 2, 3, 4, 5].map((star) => (
                        <Icon
                          key={star}
                          name="star"
                          size={18}
                          color={colors.beeYellow}
                        />
                      ))}
                    </View>

                    {/* Text */}
                    <Text
                      style={{
                        fontFamily: fonts.regular,
                        fontSize: 15,
                        lineHeight: 26,
                        color: isDarkMode ? "#D1D5DB" : "#475569",
                        marginBottom: 24,
                      }}
                    >
                      "{testimonial.text}"
                    </Text>

                    {/* Author */}
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 14,
                      }}
                    >
                      <View
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: 24,
                          backgroundColor: testimonial.color,
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: 16,
                            color: "#FFFFFF",
                          }}
                        >
                          {testimonial.initials}
                        </Text>
                      </View>
                      <View>
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: 16,
                            color: isDarkMode ? "#FFFFFF" : "#0F172A",
                          }}
                        >
                          {testimonial.name}
                        </Text>
                        <Text
                          style={{
                            fontFamily: fonts.regular,
                            fontSize: 13,
                            color: isDarkMode ? "#6B7280" : "#94A3B8",
                          }}
                        >
                          {testimonial.role}
                        </Text>
                      </View>
                    </View>
                  </View>
                ))}
              </View>
            </View>
          </View>

          {/* Subscription Plans Section — hidden behind PRICING_ENABLED flag */}
          {FEATURES.PRICING_ENABLED && (
            <View
              style={{
                paddingVertical: isMobile ? 60 : 100,
                paddingHorizontal: isMobile ? 24 : 60,
                backgroundColor: isDarkMode ? "#0F1419" : "#F8FAFC",
              }}
            >
              <View
                style={{ maxWidth: 1200, alignSelf: "center", width: "100%" }}
              >
                {/* Section Header */}
                <View style={{ marginBottom: 60, alignItems: "center" }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 8,
                      marginBottom: 12,
                    }}
                  >
                    <View
                      style={{
                        width: 32,
                        height: 3,
                        backgroundColor: colors.beeYellow,
                        borderRadius: 2,
                      }}
                    />
                    <Text
                      style={{
                        fontFamily: fonts.medium,
                        fontSize: 13,
                        color: colors.beeYellow,
                        textTransform: "uppercase",
                        letterSpacing: 1.5,
                      }}
                    >
                      {t.pricingPlansLabel}
                    </Text>
                    <View
                      style={{
                        width: 32,
                        height: 3,
                        backgroundColor: colors.beeYellow,
                        borderRadius: 2,
                      }}
                    />
                  </View>
                  <Text
                    style={{
                      fontFamily: fonts.bold,
                      fontSize: isMobile ? 28 : 36,
                      color: isDarkMode ? "#FFFFFF" : "#0F172A",
                      marginBottom: 8,
                      textAlign: "center",
                    }}
                  >
                    {t.chooseYourPlan}
                  </Text>
                  <Text
                    style={{
                      fontFamily: fonts.regular,
                      fontSize: 16,
                      color: isDarkMode ? "#9CA3AF" : "#64748B",
                      textAlign: "center",
                    }}
                  >
                    {t.chooseYourPlanSubtitle}
                  </Text>
                </View>

                {/* Pricing Cards */}
                <View
                  style={{
                    flexDirection: isMobile ? "column" : "row",
                    gap: 24,
                    justifyContent: "center",
                    alignItems: isMobile ? "stretch" : "flex-start",
                  }}
                >
                  {subscriptionPlans.map((plan, index) => (
                    <View
                      key={plan.id}
                      style={{
                        flex: 1,
                        maxWidth: isMobile ? "100%" : 380,
                        backgroundColor: isDarkMode ? "#1F2937" : "#FFFFFF",
                        borderRadius: 24,
                        padding: 32,
                        shadowColor: "#000",
                        shadowOffset: {
                          width: 0,
                          height: index === 1 ? 16 : 8,
                        },
                        shadowOpacity: isDarkMode ? 0.3 : 0.1,
                        shadowRadius: index === 1 ? 32 : 24,
                        elevation: index === 1 ? 12 : 8,
                        borderWidth: index === 1 ? 2 : 1,
                        borderColor:
                          index === 1
                            ? colors.beeYellow
                            : isDarkMode
                            ? "#374151"
                            : "#F1F5F9",
                        transform:
                          index === 1 ? [{ scale: isMobile ? 1 : 1.05 }] : [],
                      }}
                    >
                      {/* Popular Badge */}
                      {index === 1 && (
                        <View
                          style={{
                            position: "absolute",
                            top: -12,
                            right: 32,
                            backgroundColor: colors.beeYellow,
                            paddingHorizontal: 16,
                            paddingVertical: 6,
                            borderRadius: 20,
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: fonts.bold,
                              fontSize: 12,
                              color: isDarkMode ? "#FFFFFF" : "#0F172A",
                              textTransform: "uppercase",
                              letterSpacing: 0.5,
                            }}
                          >
                            {t.popularBadge}
                          </Text>
                        </View>
                      )}

                      {/* Plan Icon */}
                      <View
                        style={{
                          width: 56,
                          height: 56,
                          borderRadius: 16,
                          backgroundColor: `${
                            plan.id === "free"
                              ? "#3B82F6"
                              : plan.id === "standard"
                              ? colors.beeYellow
                              : plan.id === "pro"
                              ? "#7C3AED"
                              : "#8B5CF6"
                          }20`,
                          justifyContent: "center",
                          alignItems: "center",
                          marginBottom: 20,
                        }}
                      >
                        <Icon
                          name={
                            plan.id === "free"
                              ? "star-outline"
                              : plan.id === "standard"
                              ? "star-half"
                              : plan.id === "pro"
                              ? "verified"
                              : "star"
                          }
                          size={28}
                          color={
                            plan.id === "free"
                              ? "#3B82F6"
                              : plan.id === "standard"
                              ? colors.beeYellow
                              : plan.id === "pro"
                              ? "#7C3AED"
                              : "#8B5CF6"
                          }
                        />
                      </View>

                      {/* Plan Name */}
                      <Text
                        style={{
                          fontFamily: fonts.bold,
                          fontSize: 24,
                          color: isDarkMode ? "#FFFFFF" : "#0F172A",
                          marginBottom: 8,
                        }}
                      >
                        {plan.id === "pro"
                          ? (t as any).proName || plan.name
                          : plan.name}
                      </Text>

                      {/* Plan Description */}
                      <Text
                        style={{
                          fontFamily: fonts.regular,
                          fontSize: 14,
                          color: isDarkMode ? "#9CA3AF" : "#64748B",
                          marginBottom: 24,
                          lineHeight: 22,
                        }}
                      >
                        {plan.id === "free"
                          ? t.freePlanDesc
                          : plan.id === "standard"
                          ? t.standardPlanDesc
                          : plan.id === "pro"
                          ? t.proPlanDesc || t.enterprisePlanDesc
                          : t.enterprisePlanDesc}
                      </Text>

                      {/* Pricing */}
                      <View style={{ marginBottom: 28 }}>
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "baseline",
                            marginBottom: 4,
                          }}
                        >
                          <Text
                            style={{
                              fontFamily: fonts.bold,
                              fontSize: 48,
                              color: isDarkMode ? "#FFFFFF" : "#0F172A",
                              lineHeight: 56,
                            }}
                          >
                            {plan.priceMonthly} ETB
                          </Text>
                          <Text
                            style={{
                              fontFamily: fonts.regular,
                              fontSize: 16,
                              color: isDarkMode ? "#6B7280" : "#94A3B8",
                              marginLeft: 8,
                            }}
                          >
                            {t.perMonth}
                          </Text>
                        </View>
                        {plan.priceYearly > 0 && (
                          <Text
                            style={{
                              fontFamily: fonts.medium,
                              fontSize: 13,
                              color: colors.success,
                            }}
                          >
                            {t.orYearly} {plan.priceYearly} ETB{t.perYear} (
                            {t.save} {plan.priceMonthly * 12 - plan.priceYearly}{" "}
                            ETB)
                          </Text>
                        )}
                      </View>

                      {/* Features */}
                      <View style={{ marginBottom: 28, gap: 12 }}>
                        {plan.features.map((feature, i) => {
                          // Get translated feature text
                          let featureText = feature.text;
                          if (plan.id === "free") {
                            const freeFeatures = [
                              t.freeFeature1,
                              t.freeFeature2,
                              t.freeFeature3,
                              t.freeFeature4,
                            ];
                            featureText = freeFeatures[i] || feature.text;
                          } else if (plan.id === "standard") {
                            const standardFeatures = [
                              t.standardFeature1,
                              t.standardFeature2,
                              t.standardFeature3,
                              t.standardFeature4,
                              t.standardFeature5,
                            ];
                            featureText = standardFeatures[i] || feature.text;
                          } else if (plan.id === "pro") {
                            const proFeatures = [
                              t.proFeature1,
                              t.proFeature2,
                              t.proFeature3,
                              t.proFeature4,
                              t.proFeature5,
                              t.proFeature6,
                              t.proFeature7,
                            ];
                            featureText = proFeatures[i] || feature.text;
                          } else if (plan.id === "enterprise") {
                            const enterpriseFeatures = [
                              t.enterpriseFeature1,
                              t.enterpriseFeature2,
                              t.enterpriseFeature3,
                              t.enterpriseFeature4,
                              t.enterpriseFeature5,
                              t.enterpriseFeature6,
                              t.enterpriseFeature7,
                            ];
                            featureText = enterpriseFeatures[i] || feature.text;
                          }

                          return (
                            <View
                              key={i}
                              style={{
                                flexDirection: "row",
                                alignItems: "flex-start",
                                gap: 12,
                              }}
                            >
                              <Icon
                                name={
                                  feature.enabled ? "check-circle" : "cancel"
                                }
                                size={20}
                                color={
                                  feature.enabled
                                    ? colors.success
                                    : isDarkMode
                                    ? "#6B7280"
                                    : "#CBD5E1"
                                }
                                style={{ marginTop: 2 }}
                              />
                              <Text
                                style={{
                                  flex: 1,
                                  fontFamily: fonts.regular,
                                  fontSize: 14,
                                  color: feature.enabled
                                    ? isDarkMode
                                      ? "#D1D5DB"
                                      : "#475569"
                                    : isDarkMode
                                    ? "#6B7280"
                                    : "#94A3B8",
                                  lineHeight: 22,
                                  textDecorationLine: feature.enabled
                                    ? "none"
                                    : "line-through",
                                }}
                              >
                                {featureText}
                              </Text>
                            </View>
                          );
                        })}
                      </View>

                      {/* CTA Button */}
                      <TouchableOpacity
                        style={{
                          backgroundColor:
                            index === 1
                              ? colors.beeYellow
                              : isDarkMode
                              ? "#374151"
                              : "#F1F5F9",
                          paddingVertical: 16,
                          borderRadius: 12,
                          alignItems: "center",
                        }}
                        onPress={() => {
                          if (!user) {
                            navigation.navigate("Login", {
                              message: "Please log in to subscribe to a plan",
                              returnTo: "Payment",
                              returnParams: { plan: plan.id },
                            });
                          } else {
                            navigation.navigate("Payment", { plan: plan.id });
                          }
                        }}
                      >
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: 16,
                            color:
                              index === 1
                                ? isDarkMode
                                  ? "#FFFFFF"
                                  : "#0F172A"
                                : isDarkMode
                                ? "#D1D5DB"
                                : "#475569",
                          }}
                        >
                          {plan.id === "free"
                            ? t.getStartedBtn
                            : plan.id === "standard"
                            ? t.chooseStandardBtn
                            : plan.id === "pro"
                            ? t.chooseProBtn
                            : plan.id === "enterprise"
                            ? t.chooseEnterpriseBtn
                            : plan.buttonText}
                        </Text>
                      </TouchableOpacity>
                    </View>
                  ))}
                </View>
              </View>
            </View>
          )}

          {/* Job Alert Section - Modern Design */}
          <View
            style={{
              paddingVertical: isMobile ? 60 : 100,
              paddingHorizontal: isMobile ? 24 : 60,
              backgroundColor: isDarkMode ? "#1A1D23" : "#0F172A",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative elements */}
            <View
              style={{
                position: "absolute",
                top: -60,
                right: isMobile ? -40 : 80,
                width: 200,
                height: 200,
                borderRadius: 100,
                backgroundColor: "rgba(251, 191, 36, 0.1)",
              }}
            />
            <View
              style={{
                position: "absolute",
                bottom: -40,
                left: isMobile ? -60 : 120,
                width: 150,
                height: 150,
                borderRadius: 75,
                backgroundColor: "rgba(251, 191, 36, 0.05)",
              }}
            />

            <View
              style={{
                maxWidth: 700,
                alignSelf: "center",
                width: "100%",
                alignItems: "center",
              }}
            >
              {/* Icon */}
              <View
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: 24,
                  backgroundColor: colors.beeYellow,
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: 32,
                  shadowColor: colors.beeYellow,
                  shadowOffset: { width: 0, height: 8 },
                  shadowOpacity: 0.3,
                  shadowRadius: 20,
                }}
              >
                <Icon name="notifications-active" size={40} color="#0F172A" />
              </View>

              <Text
                style={{
                  fontFamily: fonts.bold,
                  fontSize: isMobile ? 28 : 40,
                  color: "#FFFFFF",
                  marginBottom: 16,
                  textAlign: "center",
                }}
              >
                {t.neverMissTitle}
              </Text>

              <Text
                style={{
                  fontFamily: fonts.regular,
                  fontSize: 17,
                  color: "rgba(255,255,255,0.7)",
                  marginBottom: 40,
                  textAlign: "center",
                  lineHeight: 28,
                  maxWidth: 500,
                }}
              >
                {t.neverMissSubtitle}
              </Text>

              <TouchableOpacity
                style={{
                  backgroundColor: colors.beeYellow,
                  paddingHorizontal: 36,
                  paddingVertical: 18,
                  borderRadius: 14,
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                  shadowColor: colors.beeYellow,
                  shadowOffset: { width: 0, height: 6 },
                  shadowOpacity: 0.3,
                  shadowRadius: 16,
                  elevation: 8,
                }}
                onPress={() => {
                  if (user) {
                    navigation.navigate("Settings");
                  } else {
                    navigation.navigate("Signup", {
                      message: t.signUpForJobAlerts,
                    });
                  }
                }}
              >
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: 17,
                    color: "#0F172A",
                  }}
                >
                  {user ? t.manageAlerts : t.signUpForAlerts}
                </Text>
                <Icon name="arrow-forward" size={22} color="#0F172A" />
              </TouchableOpacity>
            </View>
          </View>

          {/* FAQ Section - Modern Design */}
          <View
            style={{
              paddingVertical: isMobile ? 48 : 80,
              paddingHorizontal: isMobile ? 16 : 60,
              backgroundColor: isDarkMode ? "#0F1419" : "#F8FAFC",
              position: "relative",
            }}
          >
            <View style={{ maxWidth: 900, alignSelf: "center", width: "100%" }}>
              {/* Section Header */}
              <View style={{ marginBottom: 48, alignItems: "center" }}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 8,
                    marginBottom: 12,
                  }}
                >
                  <View
                    style={{
                      width: 32,
                      height: 3,
                      backgroundColor: colors.beeYellow,
                      borderRadius: 2,
                    }}
                  />
                  <Text
                    style={{
                      fontFamily: fonts.medium,
                      fontSize: 13,
                      color: colors.beeYellow,
                      textTransform: "uppercase",
                      letterSpacing: 1.5,
                    }}
                  >
                    {t.faqLabel2}
                  </Text>
                  <View
                    style={{
                      width: 32,
                      height: 3,
                      backgroundColor: colors.beeYellow,
                      borderRadius: 2,
                    }}
                  />
                </View>
                <Text
                  style={{
                    fontFamily: fonts.bold,
                    fontSize: isMobile ? 28 : 36,
                    color: isDarkMode ? "#FFFFFF" : "#0F172A",
                    marginBottom: 8,
                    textAlign: "center",
                  }}
                >
                  {t.faqTitle}
                </Text>
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 16,
                    color: isDarkMode ? "#9CA3AF" : "#64748B",
                    textAlign: "center",
                  }}
                >
                  {t.faqSubtitle}
                </Text>
              </View>

              {/* FAQ Items */}
              <View style={{ gap: 16 }}>
                {[
                  { q: t.faq1Q, a: t.faq1A },
                  { q: t.faq2Q, a: t.faq2A },
                  { q: t.faq3Q, a: t.faq3A },
                  { q: t.faq4Q, a: t.faq4A },
                ].map((faq, index) => (
                  <View
                    key={index}
                    style={{
                      backgroundColor: isDarkMode ? "#1F2937" : "#FFFFFF",
                      borderRadius: 16,
                      padding: 24,
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 2 },
                      shadowOpacity: isDarkMode ? 0.2 : 0.05,
                      shadowRadius: 12,
                      elevation: 3,
                      borderWidth: 1,
                      borderColor: isDarkMode ? "#374151" : "#F1F5F9",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        alignItems: "flex-start",
                        gap: 16,
                      }}
                    >
                      <View
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: 8,
                          backgroundColor: `${colors.beeYellow}20`,
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: 2,
                        }}
                      >
                        <Icon
                          name="help-outline"
                          size={18}
                          color={colors.beeYellow}
                        />
                      </View>
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: 17,
                            color: isDarkMode ? "#FFFFFF" : "#0F172A",
                            marginBottom: 10,
                          }}
                        >
                          {faq.q}
                        </Text>
                        <Text
                          style={{
                            fontFamily: fonts.regular,
                            fontSize: 15,
                            lineHeight: 24,
                            color: isDarkMode ? "#9CA3AF" : "#64748B",
                          }}
                        >
                          {faq.a}
                        </Text>
                      </View>
                    </View>
                  </View>
                ))}
              </View>
            </View>
          </View>

          {/* Footer Section - Modern Design */}
          <View
            style={{
              paddingTop: isMobile ? 48 : 80,
              paddingBottom: 32,
              paddingHorizontal: isMobile ? 24 : 60,
              backgroundColor: isDarkMode ? "#0A0D12" : "#0F172A",
            }}
          >
            <View
              style={{ maxWidth: 1200, alignSelf: "center", width: "100%" }}
            >
              {/* Footer Top */}
              <View
                style={{
                  flexDirection: isMobile ? "column" : "row",
                  gap: isMobile ? 40 : 60,
                  marginBottom: 48,
                  paddingBottom: 48,
                  borderBottomWidth: 1,
                  borderBottomColor: "rgba(255,255,255,0.1)",
                }}
              >
                {/* Company Info */}
                <View style={{ flex: isMobile ? undefined : 1.5 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                      marginBottom: 20,
                    }}
                  >
                    <Image
                      source={require("./assets/favicon.png")}
                      style={{ width: 44, height: 44, borderRadius: 12 }}
                    />
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 24,
                        color: "#FFFFFF",
                      }}
                    >
                      NibJobs
                    </Text>
                  </View>
                  <Text
                    style={{
                      fontFamily: fonts.regular,
                      fontSize: 15,
                      lineHeight: 24,
                      color: "rgba(255,255,255,0.6)",
                      marginBottom: 24,
                      maxWidth: 300,
                    }}
                  >
                    {t.footerAboutDesc}
                  </Text>
                  <View style={{ flexDirection: "row", gap: 12 }}>
                    <TouchableOpacity
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: 12,
                        backgroundColor: "rgba(255,255,255,0.1)",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onPress={() =>
                        Linking.openURL("https://www.facebook.com/nibjobs")
                      }
                    >
                      <Icon name="facebook" size={22} color="#FFFFFF" />
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: 12,
                        backgroundColor: "rgba(255,255,255,0.1)",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      onPress={() =>
                        Linking.openURL("https://www.youtube.com/@kelem510")
                      }
                    >
                      <Icon
                        name="play-circle-outline"
                        size={22}
                        color="#FFFFFF"
                      />
                    </TouchableOpacity>
                  </View>

                  {/* Download App Button */}
                  {Platform.OS === "web" && (
                    <TouchableOpacity
                      onPress={handleGooglePlayDownload}
                      activeOpacity={0.8}
                      style={{
                        marginTop: 24,
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 10,
                        backgroundColor: "rgba(255,255,255,0.1)",
                        paddingHorizontal: 16,
                        paddingVertical: 12,
                        borderRadius: 10,
                        borderWidth: 1,
                        borderColor: "rgba(255,255,255,0.2)",
                      }}
                    >
                      <Icon name="android" size={24} color="#3DDC84" />
                      <View>
                        <Text
                          style={{
                            fontFamily: fonts.regular,
                            fontSize: 10,
                            color: "rgba(255,255,255,0.7)",
                          }}
                        >
                          {t.getItOn}
                        </Text>
                        <Text
                          style={{
                            fontFamily: fonts.bold,
                            fontSize: 15,
                            color: "#FFFFFF",
                            marginTop: -2,
                          }}
                        >
                          {t.playStoreDownload}
                        </Text>
                      </View>
                    </TouchableOpacity>
                  )}
                </View>

                {/* Links Grid */}
                <View
                  style={{
                    flex: isMobile ? undefined : 2.5,
                    flexDirection: isMobile ? "column" : "row",
                    gap: isMobile ? 32 : 40,
                  }}
                >
                  {/* Job Seekers */}
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 14,
                        color: colors.beeYellow,
                        textTransform: "uppercase",
                        letterSpacing: 1,
                        marginBottom: 20,
                      }}
                    >
                      {t.footerJobSeekers}
                    </Text>
                    {[
                      {
                        id: "browse-jobs",
                        label: t.footerBrowseJobs,
                        action: () =>
                          user
                            ? navigation.navigate("Jobs")
                            : navigation.navigate("Signup", {
                                message: t.signUpToAccessAll,
                              }),
                      },
                      {
                        id: "job-alerts",
                        label: t.footerJobAlerts,
                        action: () => navigation.navigate("JobAlerts"),
                      },
                      {
                        id: "career-advice",
                        label: t.footerCareerAdvice,
                        action: () => navigation.navigate("CareerAdvice"),
                      },
                      {
                        id: "resume-tips",
                        label: t.footerResumeTips,
                        action: () => navigation.navigate("ResumeTips"),
                      },
                    ].map((link) => (
                      <TouchableOpacity
                        key={link.id}
                        style={{ paddingVertical: 8 }}
                        onPress={link.action}
                      >
                        <Text
                          style={{
                            fontFamily: fonts.regular,
                            fontSize: 15,
                            color: "rgba(255,255,255,0.7)",
                          }}
                        >
                          {link.label}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>

                  {/* Employers */}
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 14,
                        color: colors.beeYellow,
                        textTransform: "uppercase",
                        letterSpacing: 1,
                        marginBottom: 20,
                      }}
                    >
                      {t.footerForEmployers}
                    </Text>
                    {[
                      {
                        id: "post-job",
                        label: t.footerPostJob,
                        action: handleLogin,
                      },
                      {
                        id: "pricing-plans",
                        label: t.footerPricingPlans,
                        action: () => navigation.navigate("Home"),
                      },
                      {
                        id: "employer-dashboard",
                        label: t.footerEmployerDashboard,
                        action: handleLogin,
                      },
                      {
                        id: "recruitment-tips",
                        label: t.footerRecruitmentTips,
                        action: () => navigation.navigate("RecruitmentTips"),
                      },
                    ].map((link) => (
                      <TouchableOpacity
                        key={link.id}
                        style={{ paddingVertical: 8 }}
                        onPress={link.action}
                      >
                        <Text
                          style={{
                            fontFamily: fonts.regular,
                            fontSize: 15,
                            color: "rgba(255,255,255,0.7)",
                          }}
                        >
                          {link.label}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>

                  {/* Company */}
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontFamily: fonts.bold,
                        fontSize: 14,
                        color: colors.beeYellow,
                        textTransform: "uppercase",
                        letterSpacing: 1,
                        marginBottom: 20,
                      }}
                    >
                      {t.footerCompany}
                    </Text>
                    {[
                      {
                        id: "about-us",
                        label: t.footerAbout,
                        action: () => navigation.navigate("Home"),
                      },
                      {
                        id: "contact",
                        label: t.footerContact,
                        action: handleLogin,
                      },
                      {
                        id: "privacy-policy",
                        label: t.footerPrivacy,
                        action: () => navigation.navigate("Privacy"),
                      },
                      {
                        id: "terms-of-service",
                        label: t.footerTerms,
                        action: () => navigation.navigate("Terms"),
                      },
                    ].map((link) => (
                      <TouchableOpacity
                        key={link.id}
                        style={{ paddingVertical: 8 }}
                        onPress={link.action}
                      >
                        <Text
                          style={{
                            fontFamily: fonts.regular,
                            fontSize: 15,
                            color: "rgba(255,255,255,0.7)",
                          }}
                        >
                          {link.label}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                </View>
              </View>

              {/* Footer Bottom */}
              <View
                style={{
                  flexDirection: isMobile ? "column" : "row",
                  justifyContent: "space-between",
                  alignItems: isMobile ? "center" : "center",
                  gap: 16,
                }}
              >
                <Text
                  style={{
                    fontFamily: fonts.regular,
                    fontSize: 14,
                    color: "rgba(255,255,255,0.5)",
                  }}
                >
                  {t.footerCopyright.replace(
                    "2025",
                    new Date().getFullYear().toString(),
                  )}
                </Text>
                <View
                  style={{
                    flexDirection: "row",
                    gap: 24,
                    alignItems: "center",
                  }}
                >
                  <TouchableOpacity
                    onPress={() => navigation.navigate("Privacy")}
                  >
                    <Text
                      style={{
                        fontFamily: fonts.regular,
                        fontSize: 14,
                        color: "rgba(255,255,255,0.5)",
                      }}
                    >
                      {t.footerPrivacyShort}
                    </Text>
                  </TouchableOpacity>
                  <Text
                    style={{ color: "rgba(255,255,255,0.3)", fontSize: 14 }}
                  >
                    •
                  </Text>
                  <TouchableOpacity
                    onPress={() => navigation.navigate("Terms")}
                  >
                    <Text
                      style={{
                        fontFamily: fonts.regular,
                        fontSize: 14,
                        color: "rgba(255,255,255,0.5)",
                      }}
                    >
                      {t.footerTermsShort}
                    </Text>
                  </TouchableOpacity>
                  <Text
                    style={{ color: "rgba(255,255,255,0.3)", fontSize: 14 }}
                  >
                    •
                  </Text>
                  <TouchableOpacity
                    onPress={() => navigation.navigate("Privacy")}
                  >
                    <Text
                      style={{
                        fontFamily: fonts.regular,
                        fontSize: 14,
                        color: "rgba(255,255,255,0.5)",
                      }}
                    >
                      {t.footerCookies}
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </View>
        </ScrollView>
      </View>

      {/* Bottom Navigation Bar */}
      <BottomNavBar
        navigation={navigation}
        activeRoute="Home"
        isDarkMode={isDarkMode}
        user={user}
        userData={userData}
        currentLanguage={parentCurrentLanguage}
      />
    </SafeAreaView>
  );
}

// Privacy Policy Screen
function PrivacyPolicyScreen({ navigation, currentLanguage }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.contentPage}>
        <View style={styles.contentPageHeader}>
          <TouchableOpacity
            style={styles.contentPageBackButton}
            onPress={() => navigation.goBack()}
          >
            <Icon name="arrow-back" size={24} color={lightColors.deepNavy} />
          </TouchableOpacity>
          <Text style={styles.contentPageTitle}>{t.privacyTitle}</Text>
        </View>

        <View style={styles.contentPageBody}>
          <Text style={styles.contentPageLastUpdated}>
            {t.lastUpdated} {new Date().toLocaleDateString()}
          </Text>

          <Text style={styles.contentPageSection}>
            {t.privacySection1Title}
          </Text>
          <Text style={styles.contentPageText}>{t.privacySection1Text}</Text>

          <Text style={styles.contentPageSection}>
            {t.privacySection2Title}
          </Text>
          <Text style={styles.contentPageText}>{t.privacySection2Text}</Text>

          <Text style={styles.contentPageSection}>
            {t.privacySection3Title}
          </Text>
          <Text style={styles.contentPageText}>{t.privacySection3Text}</Text>

          <Text style={styles.contentPageSection}>
            {t.privacySection4Title}
          </Text>
          <Text style={styles.contentPageText}>{t.privacySection4Text}</Text>

          <Text style={styles.contentPageSection}>
            {t.privacySection5Title}
          </Text>
          <Text style={styles.contentPageText}>{t.privacySection5Text}</Text>

          <Text style={styles.contentPageSection}>
            {t.privacySection6Title}
          </Text>
          <Text style={styles.contentPageText}>{t.privacySection6Text}</Text>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

// Terms of Service Screen
function TermsOfServiceScreen({ navigation, currentLanguage }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.contentPage}>
        <View style={styles.contentPageHeader}>
          <TouchableOpacity
            style={styles.contentPageBackButton}
            onPress={() => navigation.goBack()}
          >
            <Icon name="arrow-back" size={24} color={lightColors.deepNavy} />
          </TouchableOpacity>
          <Text style={styles.contentPageTitle}>{t.terms}</Text>
        </View>

        <View style={styles.contentPageBody}>
          <Text style={styles.contentPageLastUpdated}>
            {t.lastUpdated} {new Date().toLocaleDateString()}
          </Text>

          <Text style={styles.contentPageSection}>{t.termsSection1Title}</Text>
          <Text style={styles.contentPageText}>{t.termsSection1Text}</Text>

          <Text style={styles.contentPageSection}>{t.termsSection2Title}</Text>
          <Text style={styles.contentPageText}>{t.termsSection2Text}</Text>

          <Text style={styles.contentPageSection}>{t.termsSection3Title}</Text>
          <Text style={styles.contentPageText}>{t.termsSection3Text}</Text>

          <Text style={styles.contentPageSection}>{t.termsSection4Title}</Text>
          <Text style={styles.contentPageText}>{t.termsSection4Text}</Text>

          <Text style={styles.contentPageSection}>{t.termsSection5Title}</Text>
          <Text style={styles.contentPageText}>{t.termsSection5Text}</Text>

          <Text style={styles.contentPageSection}>{t.termsSection6Title}</Text>
          <Text style={styles.contentPageText}>{t.termsSection6Text}</Text>

          <Text style={styles.contentPageSection}>{t.termsSection7Title}</Text>
          <Text style={styles.contentPageText}>{t.termsSection7Text}</Text>

          <Text style={styles.contentPageSection}>{t.termsSection8Title}</Text>
          <Text style={styles.contentPageText}>{t.termsSection8Text}</Text>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

// Job Alerts Screen
function JobAlertsScreen({ navigation }: any) {
  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.contentPage}>
        <View style={styles.contentPageHeader}>
          <TouchableOpacity
            style={styles.contentPageBackButton}
            onPress={() => navigation.goBack()}
          >
            <Icon name="arrow-back" size={24} color={lightColors.deepNavy} />
          </TouchableOpacity>
          <Text style={styles.contentPageTitle}>Job Alerts</Text>
        </View>

        <View style={styles.contentPageBody}>
          <View style={styles.featureHeroSection}>
            <Icon
              name="notifications-active"
              size={64}
              color={lightColors.beeYellow}
            />
            <Text style={styles.featureHeroTitle}>
              Never Miss a Job Opportunity
            </Text>
            <Text style={styles.featureHeroSubtitle}>
              Get instant notifications when jobs matching your preferences are
              posted
            </Text>
          </View>

          <Text style={styles.contentPageSection}>How Job Alerts Work</Text>
          <Text style={styles.contentPageText}>
            Set up personalized job alerts based on your skills, experience, and
            career interests. We'll notify you immediately when relevant
            opportunities are posted.
          </Text>

          <Text style={styles.contentPageSection}>Alert Preferences</Text>
          <Text style={styles.contentPageText}>
            • Choose your preferred job categories{"\n"}• Set location
            preferences{"\n"}• Filter by salary range{"\n"}• Select notification
            frequency (instant, daily, or weekly){"\n"}• Customize alert
            channels (email, SMS, push notifications)
          </Text>

          <Text style={styles.contentPageSection}>
            Stay Ahead of the Competition
          </Text>
          <Text style={styles.contentPageText}>
            Be the first to know about new opportunities. Job alerts give you a
            competitive advantage by notifying you as soon as jobs are posted,
            allowing you to apply early.
          </Text>

          <TouchableOpacity
            style={styles.contentPageCTA}
            onPress={() => navigation.navigate("Signup")}
          >
            <Text style={styles.contentPageCTAText}>
              Sign Up for Job Alerts
            </Text>
            <Icon name="arrow-forward" size={20} color={lightColors.white} />
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

// Career Advice Screen
function CareerAdviceScreen({ navigation }: any) {
  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.contentPage}>
        <View style={styles.contentPageHeader}>
          <TouchableOpacity
            style={styles.contentPageBackButton}
            onPress={() => navigation.goBack()}
          >
            <Icon name="arrow-back" size={24} color={lightColors.deepNavy} />
          </TouchableOpacity>
          <Text style={styles.contentPageTitle}>Career Advice</Text>
        </View>

        <View style={styles.contentPageBody}>
          <View style={styles.featureHeroSection}>
            <Icon name="school" size={64} color={lightColors.beeYellow} />
            <Text style={styles.featureHeroTitle}>Advance Your Career</Text>
            <Text style={styles.featureHeroSubtitle}>
              Expert guidance to help you navigate your professional journey
            </Text>
          </View>

          <Text style={styles.contentPageSection}>Interview Preparation</Text>
          <Text style={styles.contentPageText}>
            Master the art of interviewing with our comprehensive guides. Learn
            how to answer common questions, prepare for technical interviews,
            and make a lasting impression on potential employers.
          </Text>

          <Text style={styles.contentPageSection}>Career Development</Text>
          <Text style={styles.contentPageText}>
            Discover strategies for professional growth, skill development, and
            career advancement. Learn how to set career goals, build your
            professional network, and identify growth opportunities.
          </Text>

          <Text style={styles.contentPageSection}>Salary Negotiation</Text>
          <Text style={styles.contentPageText}>
            Understand your market value and learn effective negotiation
            techniques. Get insights on salary ranges for different roles and
            industries in Ethiopia's job market.
          </Text>

          <Text style={styles.contentPageSection}>Work-Life Balance</Text>
          <Text style={styles.contentPageText}>
            Maintain a healthy balance between professional ambitions and
            personal well-being. Discover tips for managing stress, setting
            boundaries, and achieving career satisfaction.
          </Text>

          <TouchableOpacity
            style={styles.contentPageCTA}
            onPress={() => navigation.navigate("Signup")}
          >
            <Text style={styles.contentPageCTAText}>Join NibJobs Today</Text>
            <Icon name="arrow-forward" size={20} color={lightColors.white} />
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

// Resume Tips Screen
function ResumeTipsScreen({ navigation, currentLanguage }: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.contentPage}>
        <View style={styles.contentPageHeader}>
          <TouchableOpacity
            style={styles.contentPageBackButton}
            onPress={() => navigation.goBack()}
          >
            <Icon name="arrow-back" size={24} color={lightColors.deepNavy} />
          </TouchableOpacity>
          <Text style={styles.contentPageTitle}>{t.resumeTipsTitle}</Text>
        </View>

        <View style={styles.contentPageBody}>
          <View style={styles.featureHeroSection}>
            <Icon name="description" size={64} color={lightColors.beeYellow} />
            <Text style={styles.featureHeroTitle}>{t.resumeTipsHero}</Text>
            <Text style={styles.featureHeroSubtitle}>
              {t.resumeTipsHeroDesc}
            </Text>
          </View>

          <Text style={styles.contentPageSection}>{t.resumeFormatting}</Text>
          <Text style={styles.contentPageText}>{t.resumeFormattingText}</Text>

          <Text style={styles.contentPageSection}>{t.resumeKeySections}</Text>
          <Text style={styles.contentPageText}>{t.resumeKeySectionsText}</Text>

          <Text style={styles.contentPageSection}>{t.resumeWritingTips}</Text>
          <Text style={styles.contentPageText}>{t.resumeWritingTipsText}</Text>

          <Text style={styles.contentPageSection}>{t.resumeMistakes}</Text>
          <Text style={styles.contentPageText}>{t.resumeMistakesText}</Text>

          <TouchableOpacity
            style={styles.contentPageCTA}
            onPress={() => navigation.navigate("Signup")}
          >
            <Text style={styles.contentPageCTAText}>{t.uploadResume}</Text>
            <Icon name="arrow-forward" size={20} color={lightColors.white} />
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

// Recruitment Tips Screen
function RecruitmentTipsScreen({ navigation }: any) {
  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.contentPage}>
        <View style={styles.contentPageHeader}>
          <TouchableOpacity
            style={styles.contentPageBackButton}
            onPress={() => navigation.goBack()}
          >
            <Icon name="arrow-back" size={24} color={lightColors.deepNavy} />
          </TouchableOpacity>
          <Text style={styles.contentPageTitle}>Recruitment Tips</Text>
        </View>

        <View style={styles.contentPageBody}>
          <View style={styles.featureHeroSection}>
            <Icon
              name="business-center"
              size={64}
              color={lightColors.beeYellow}
            />
            <Text style={styles.featureHeroTitle}>Hire Top Talent</Text>
            <Text style={styles.featureHeroSubtitle}>
              Best practices for attracting and recruiting exceptional
              candidates
            </Text>
          </View>

          <Text style={styles.contentPageSection}>
            Writing Effective Job Posts
          </Text>
          <Text style={styles.contentPageText}>
            • Use clear, descriptive job titles{"\n"}• Provide detailed role
            responsibilities{"\n"}• List required and preferred qualifications
            {"\n"}• Include salary range and benefits{"\n"}• Highlight company
            culture and values{"\n"}• Add a clear call-to-action
          </Text>

          <Text style={styles.contentPageSection}>Screening Candidates</Text>
          <Text style={styles.contentPageText}>
            Develop a systematic screening process to identify the most
            qualified candidates. Review resumes for relevant experience,
            skills, and cultural fit. Use phone screens to assess communication
            skills and basic qualifications before scheduling full interviews.
          </Text>

          <Text style={styles.contentPageSection}>
            Interview Best Practices
          </Text>
          <Text style={styles.contentPageText}>
            • Prepare structured interview questions{"\n"}• Use behavioral and
            situational questions{"\n"}• Allow candidates to ask questions{"\n"}
            • Take detailed notes{"\n"}• Involve multiple team members{"\n"}•
            Provide timely feedback to candidates
          </Text>

          <Text style={styles.contentPageSection}>
            Building Your Employer Brand
          </Text>
          <Text style={styles.contentPageText}>
            Showcase your company culture, values, and employee benefits.
            Maintain an active presence on job platforms, share employee
            testimonials, and highlight career development opportunities. A
            strong employer brand attracts higher quality candidates.
          </Text>

          <Text style={styles.contentPageSection}>Diversity and Inclusion</Text>
          <Text style={styles.contentPageText}>
            Implement inclusive hiring practices to build diverse teams. Use
            gender-neutral language in job posts, establish diverse interview
            panels, and eliminate bias from your recruitment process.
          </Text>

          <TouchableOpacity
            style={styles.contentPageCTA}
            onPress={() => navigation.navigate("Signup")}
          >
            <Text style={styles.contentPageCTAText}>Start Recruiting</Text>
            <Icon name="arrow-forward" size={20} color={lightColors.white} />
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}

// Candidate Browse Screen for Companies
function CandidateBrowseScreen({
  navigation,
  route,
  isDarkMode,
  toggleTheme,
}: any) {
  const colors = isDarkMode ? darkColors : lightColors;
  const [candidates, setCandidates] = useState<any[]>([]);
  const [filteredCandidates, setFilteredCandidates] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [selectedExperience, setSelectedExperience] = useState<string[]>([]);
  const [showFilters, setShowFilters] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [user, setUser] = useState<any>(null);
  const [selectedCandidate, setSelectedCandidate] = useState<any>(null);

  // Responsive design
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;

  // Verify company access
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        const userRef = doc(db, "users", authUser.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const userData = userSnap.data();
          if (
            userData.role !== "company" &&
            userData.role !== "superadmin" &&
            userData.role !== "admin"
          ) {
            setIsCheckingAuth(false);
            navigation.replace("Unauthorized");
            return;
          }
          setUser(userData);
        } else {
          setIsCheckingAuth(false);
          navigation.replace("Unauthorized");
          return;
        }
      } else {
        setIsCheckingAuth(false);
        navigation.replace("Unauthorized");
        return;
      }
      setIsCheckingAuth(false);
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  // Available filter options
  const availableTags = [
    "JavaScript",
    "Python",
    "React",
    "Node.js",
    "TypeScript",
    "Java",
    "C++",
    "Angular",
    "Vue.js",
    "PHP",
    "Mobile Development",
    "Web Development",
    "UI/UX Design",
    "Data Science",
    "Machine Learning",
    "DevOps",
    "Cloud Computing",
  ];

  const experienceLevels = [
    "Entry Level",
    "Mid Level",
    "Senior Level",
    "Expert",
  ];

  // Fetch candidates from Firestore only after auth is verified
  useEffect(() => {
    if (!isCheckingAuth && user) {
      fetchCandidates();
    }
  }, [isCheckingAuth, user]);

  const fetchCandidates = async () => {
    try {
      setLoading(true);
      const usersRef = collection(db, "users");

      // Fetch with pagination limit and server-side filtering
      console.log("Fetching users...");
      const candidatesQuery = dbQuery(
        usersRef,
        where("role", "not-in", ["company", "admin", "superadmin"]),
        limit(100),
      );
      const querySnapshot = await getDocs(candidatesQuery);
      console.log("Total users fetched:", querySnapshot.size);

      // Map candidates and filter to only those with completed profiles
      const candidateData = querySnapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((c: any) => c.profileSetupComplete === true);

      console.log("Candidates found:", candidateData.length);
      candidateData.forEach((candidate) => {
        console.log("Candidate:", {
          id: candidate.id,
          fullName: candidate.fullName,
          displayName: candidate.displayName,
          email: candidate.email,
          role: candidate.role,
          jobTitle: candidate.jobTitle,
          profilePicture: candidate.profilePicture,
          profileAvatar: candidate.profile?.avatar,
          photoURL: candidate.photoURL,
        });
      });

      setCandidates(candidateData);
      setFilteredCandidates(candidateData);
    } catch (error) {
      console.error("Error fetching candidates:", error);
      Alert.alert("Error", "Failed to load candidates. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Apply filters
  useEffect(() => {
    let filtered = [...candidates];

    // Search filter
    if (searchQuery) {
      filtered = filtered.filter(
        (candidate) =>
          candidate.fullName
            ?.toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          candidate.displayName
            ?.toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          candidate.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          candidate.jobTitle
            ?.toLowerCase()
            .includes(searchQuery.toLowerCase()) ||
          candidate.username?.toLowerCase().includes(searchQuery.toLowerCase()),
      );
    }

    // Tags filter
    if (selectedTags.length > 0) {
      filtered = filtered.filter(
        (candidate) =>
          candidate.skills?.some((skill: string) =>
            selectedTags.some((tag) =>
              skill.toLowerCase().includes(tag.toLowerCase()),
            ),
          ) ||
          candidate.interests?.some((interest: string) =>
            selectedTags.some((tag) =>
              interest.toLowerCase().includes(tag.toLowerCase()),
            ),
          ),
      );
    }

    // Experience filter
    if (selectedExperience.length > 0) {
      filtered = filtered.filter((candidate) =>
        selectedExperience.includes(candidate.experienceLevel),
      );
    }

    setFilteredCandidates(filtered);
  }, [searchQuery, selectedTags, selectedExperience, candidates]);

  const toggleTag = (tag: string) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag],
    );
  };

  const toggleExperience = (level: string) => {
    setSelectedExperience((prev) =>
      prev.includes(level) ? prev.filter((l) => l !== level) : [...prev, level],
    );
  };

  const clearFilters = () => {
    setSelectedTags([]);
    setSelectedExperience([]);
    setSearchQuery("");
  };

  // Show loading while checking auth
  if (isCheckingAuth) {
    return (
      <ModernLoadingScreen
        message="Verifying access..."
        isDarkMode={isDarkMode}
      />
    );
  }

  // Don't render if user is not authorized
  if (!user) {
    return null;
  }

  return (
    <SafeAreaView
      style={[
        styles.container,
        { backgroundColor: isDarkMode ? "#111827" : "#F9FAFB" },
      ]}
    >
      {/* Enhanced Header with Gradient */}
      <View
        style={{
          backgroundColor: colors.white,
          borderBottomWidth: 1,
          borderBottomColor: isDarkMode ? "#374151" : "#E5E7EB",
          paddingBottom: 16,
        }}
      >
        <View
          style={[
            styles.jobsToolbar,
            { backgroundColor: "transparent", borderBottomWidth: 0 },
          ]}
        >
          <View style={styles.jobsToolbarLeft}>
            <TouchableOpacity
              onPress={() => navigation.goBack()}
              style={styles.mobileMenuButton}
            >
              <Icon name="arrow-back" size={24} color={colors.deepNavy} />
            </TouchableOpacity>
            <View style={{ marginLeft: 16 }}>
              <Text
                style={{
                  fontSize: 24,
                  fontFamily: fonts.bold,
                  color: colors.deepNavy,
                }}
              >
                Talent Pool
              </Text>
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.regular,
                  color: colors.warmGray,
                  marginTop: 2,
                }}
              >
                Discover exceptional candidates
              </Text>
            </View>
          </View>
          <View style={styles.jobsToolbarRight}>
            <TouchableOpacity
              style={{
                paddingHorizontal: 16,
                paddingVertical: 10,
                borderRadius: 12,
                backgroundColor: showFilters
                  ? colors.beeYellow
                  : isDarkMode
                  ? "#1F2937"
                  : "#F3F4F6",
                flexDirection: "row",
                alignItems: "center",
                gap: 6,
              }}
              onPress={() => setShowFilters(!showFilters)}
            >
              <Icon
                name="tune"
                size={20}
                color={
                  showFilters ? colors.buttonTextOnYellow : colors.deepNavy
                }
              />
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.semiBold,
                  color: showFilters
                    ? colors.buttonTextOnYellow
                    : colors.deepNavy,
                }}
              >
                Filters
              </Text>
            </TouchableOpacity>
          </View>
        </View>

        {/* Stats Row */}
        <View
          style={{
            flexDirection: "row",
            paddingHorizontal: isMobile ? 16 : 32,
            marginTop: 16,
            gap: 12,
          }}
        >
          <View
            style={{
              flex: 1,
              backgroundColor: isDarkMode ? "#1F2937" : "#EFF6FF",
              borderRadius: 12,
              padding: 12,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 4,
              }}
            >
              <Icon name="people" size={18} color="#3B82F6" />
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: fonts.semiBold,
                  color: colors.warmGray,
                  marginLeft: 6,
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                }}
              >
                Total
              </Text>
            </View>
            <Text
              style={{
                fontSize: 24,
                fontFamily: fonts.bold,
                color: colors.deepNavy,
              }}
            >
              {candidates.length}
            </Text>
          </View>
          <View
            style={{
              flex: 1,
              backgroundColor: isDarkMode ? "#1F2937" : "#ECFDF5",
              borderRadius: 12,
              padding: 12,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 4,
              }}
            >
              <Icon name="check-circle" size={18} color="#10B981" />
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: fonts.semiBold,
                  color: colors.warmGray,
                  marginLeft: 6,
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                }}
              >
                Matching
              </Text>
            </View>
            <Text
              style={{
                fontSize: 24,
                fontFamily: fonts.bold,
                color: colors.deepNavy,
              }}
            >
              {filteredCandidates.length}
            </Text>
          </View>
          <View
            style={{
              flex: 1,
              backgroundColor: isDarkMode ? "#1F2937" : "#FEF3C7",
              borderRadius: 12,
              padding: 12,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 4,
              }}
            >
              <Icon name="star" size={18} color="#F59E0B" />
              <Text
                style={{
                  fontSize: 11,
                  fontFamily: fonts.semiBold,
                  color: colors.warmGray,
                  marginLeft: 6,
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                }}
              >
                Active
              </Text>
            </View>
            <Text
              style={{
                fontSize: 24,
                fontFamily: fonts.bold,
                color: colors.deepNavy,
              }}
            >
              {
                filteredCandidates.filter(
                  (c: any) =>
                    c.availability === "Immediately" ||
                    c.availability === "Available",
                ).length
              }
            </Text>
          </View>
        </View>
      </View>

      {/* Enhanced Search Bar */}
      <View
        style={{
          paddingHorizontal: isMobile ? 16 : 32,
          paddingTop: 16,
          paddingBottom: 12,
          backgroundColor: colors.white,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            backgroundColor: isDarkMode ? "#1F2937" : "#F9FAFB",
            borderRadius: 16,
            paddingHorizontal: 16,
            paddingVertical: 14,
            borderWidth: 2,
            borderColor: searchQuery ? colors.beeYellow : "transparent",
            shadowColor: searchQuery ? colors.beeYellow : "#000",
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: searchQuery ? 0.15 : 0.03,
            shadowRadius: 8,
            elevation: searchQuery ? 3 : 1,
          }}
        >
          <Icon
            name="search"
            size={22}
            color={searchQuery ? colors.beeYellow : colors.warmGray}
          />
          <TextInput
            style={{
              flex: 1,
              marginLeft: 12,
              fontSize: 15,
              fontFamily: fonts.medium,
              color: colors.deepNavy,
            }}
            placeholder="Search candidates by name, role, skills..."
            placeholderTextColor={colors.warmGray}
            value={searchQuery}
            onChangeText={setSearchQuery}
          />
          {searchQuery ? (
            <TouchableOpacity
              onPress={() => setSearchQuery("")}
              style={{
                backgroundColor: colors.lightGray,
                borderRadius: 20,
                padding: 4,
              }}
            >
              <Icon name="close" size={16} color={colors.deepNavy} />
            </TouchableOpacity>
          ) : null}
        </View>
      </View>

      {/* Modern Filters Panel */}
      {showFilters && (
        <View
          style={{
            backgroundColor: colors.white,
            borderBottomWidth: 1,
            borderBottomColor: isDarkMode ? "#374151" : "#E5E7EB",
            paddingHorizontal: isMobile ? 16 : 32,
            paddingTop: 4,
            paddingBottom: 20,
          }}
        >
          {/* Active Filters Header */}
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 16,
              paddingTop: 12,
            }}
          >
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
            >
              <View
                style={{
                  width: 4,
                  height: 20,
                  backgroundColor: colors.beeYellow,
                  borderRadius: 2,
                }}
              />
              <Text
                style={{
                  fontSize: 17,
                  fontFamily: fonts.bold,
                  color: colors.deepNavy,
                }}
              >
                Refine Results
              </Text>
              {selectedTags.length + selectedExperience.length > 0 && (
                <View
                  style={{
                    backgroundColor: colors.beeYellow,
                    borderRadius: 12,
                    paddingHorizontal: 8,
                    paddingVertical: 2,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.bold,
                      color: colors.buttonTextOnYellow,
                    }}
                  >
                    {selectedTags.length + selectedExperience.length}
                  </Text>
                </View>
              )}
            </View>
            {(selectedTags.length > 0 || selectedExperience.length > 0) && (
              <TouchableOpacity
                onPress={clearFilters}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 4,
                  paddingHorizontal: 12,
                  paddingVertical: 6,
                  borderRadius: 8,
                  backgroundColor: isDarkMode ? "#1F2937" : "#FEE2E2",
                }}
              >
                <Icon name="clear" size={16} color="#EF4444" />
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.semiBold,
                    color: "#EF4444",
                  }}
                >
                  Clear All
                </Text>
              </TouchableOpacity>
            )}
          </View>

          {/* Experience Level Section */}
          <View style={{ marginBottom: 20 }}>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 12,
              }}
            >
              <Icon name="work" size={16} color={colors.warmGray} />
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.bold,
                  color: colors.warmGray,
                  marginLeft: 6,
                  textTransform: "uppercase",
                  letterSpacing: 0.8,
                }}
              >
                Experience Level
              </Text>
            </View>
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}>
              {experienceLevels.map((level) => (
                <TouchableOpacity
                  key={level}
                  onPress={() => toggleExperience(level)}
                  style={{
                    paddingHorizontal: 16,
                    paddingVertical: 10,
                    borderRadius: 12,
                    backgroundColor: selectedExperience.includes(level)
                      ? colors.beeYellow
                      : isDarkMode
                      ? "#1F2937"
                      : "#F9FAFB",
                    borderWidth: 2,
                    borderColor: selectedExperience.includes(level)
                      ? colors.beeYellow
                      : isDarkMode
                      ? "#374151"
                      : "#E5E7EB",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.semiBold,
                      color: selectedExperience.includes(level)
                        ? colors.buttonTextOnYellow
                        : colors.deepNavy,
                    }}
                  >
                    {level}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>

          {/* Skills Section */}
          <View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 12,
              }}
            >
              <Icon name="code" size={16} color={colors.warmGray} />
              <Text
                style={{
                  fontSize: 12,
                  fontFamily: fonts.bold,
                  color: colors.warmGray,
                  marginLeft: 6,
                  textTransform: "uppercase",
                  letterSpacing: 0.8,
                }}
              >
                Skills & Technologies
              </Text>
            </View>
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}>
              {availableTags.map((tag) => (
                <TouchableOpacity
                  key={tag}
                  onPress={() => toggleTag(tag)}
                  style={{
                    paddingHorizontal: 14,
                    paddingVertical: 8,
                    borderRadius: 20,
                    backgroundColor: selectedTags.includes(tag)
                      ? "#3B82F6"
                      : isDarkMode
                      ? "#1F2937"
                      : "#F3F4F6",
                    borderWidth: 1,
                    borderColor: selectedTags.includes(tag)
                      ? "#3B82F6"
                      : "transparent",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 13,
                      fontFamily: fonts.semiBold,
                      color: selectedTags.includes(tag)
                        ? "#FFFFFF"
                        : colors.deepNavy,
                    }}
                  >
                    {tag}
                  </Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>
        </View>
      )}

      {/* Results Info Bar */}
      <View
        style={{
          paddingHorizontal: isMobile ? 16 : 32,
          paddingVertical: 14,
          backgroundColor: isDarkMode ? "#1F2937" : "#F9FAFB",
          borderBottomWidth: 1,
          borderBottomColor: isDarkMode ? "#374151" : "#E5E7EB",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
          <Icon name="filter-list" size={18} color={colors.beeYellow} />
          <Text
            style={{
              fontSize: 15,
              fontFamily: fonts.semiBold,
              color: colors.deepNavy,
            }}
          >
            {filteredCandidates.length}
          </Text>
          <Text
            style={{
              fontSize: 14,
              fontFamily: fonts.regular,
              color: colors.warmGray,
            }}
          >
            {filteredCandidates.length === 1
              ? "candidate matches your criteria"
              : "candidates match your criteria"}
          </Text>
        </View>
        {filteredCandidates.length > 0 && (
          <TouchableOpacity
            style={{ flexDirection: "row", alignItems: "center", gap: 4 }}
          >
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.semiBold,
                color: colors.warmGray,
              }}
            >
              Sort
            </Text>
            <Icon name="swap-vert" size={18} color={colors.warmGray} />
          </TouchableOpacity>
        )}
      </View>

      {/* Candidates List */}
      {loading ? (
        <FullScreenLoader
          message="Loading candidates..."
          isDarkMode={isDarkMode}
        />
      ) : (
        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={{
            paddingHorizontal: isMobile ? 16 : 32,
            paddingTop: 20,
            paddingBottom: 100,
          }}
        >
          {filteredCandidates.length > 0 ? (
            <View
              style={{
                flexDirection: isMobile ? "column" : "row",
                flexWrap: "wrap",
                gap: 16,
              }}
            >
              {filteredCandidates.map((candidate, index) => (
                <View
                  key={candidate.id}
                  style={{
                    width: isMobile ? "100%" : "48%",
                    backgroundColor: colors.white,
                    borderRadius: 16,
                    padding: 24,
                    borderWidth: 1,
                    borderColor:
                      colors.lightGray === "#1F2937" ? "#374151" : "#E5E7EB",
                    shadowColor: "#000",
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.04,
                    shadowRadius: 8,
                    elevation: 2,
                  }}
                >
                  {/* Candidate Header */}
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "flex-start",
                      marginBottom: 20,
                    }}
                  >
                    <View
                      style={{
                        width: 64,
                        height: 64,
                        borderRadius: 32,
                        backgroundColor: colors.beeYellow,
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 16,
                        borderWidth: 3,
                        borderColor: isDarkMode ? "#374151" : "#F3F4F6",
                      }}
                    >
                      {candidate.profilePicture ||
                      candidate.profile?.avatar ||
                      candidate.photoURL ? (
                        <Image
                          source={{
                            uri:
                              candidate.profilePicture ||
                              candidate.profile?.avatar ||
                              candidate.photoURL,
                          }}
                          style={{ width: 64, height: 64, borderRadius: 32 }}
                        />
                      ) : (
                        <Text
                          style={{
                            fontSize: 24,
                            fontFamily: fonts.bold,
                            color: colors.buttonTextOnYellow,
                          }}
                        >
                          {(
                            candidate.fullName ||
                            candidate.displayName ||
                            candidate.email
                          )
                            ?.charAt(0)
                            ?.toUpperCase() || "C"}
                        </Text>
                      )}
                    </View>
                    <View style={{ flex: 1 }}>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 4,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 18,
                            fontFamily: fonts.bold,
                            color: colors.deepNavy,
                          }}
                        >
                          {candidate.fullName ||
                            candidate.displayName ||
                            candidate.email ||
                            "Candidate"}
                        </Text>
                        {candidate.verified && (
                          <View
                            style={{
                              marginLeft: 6,
                              backgroundColor: "#10B98120",
                              borderRadius: 12,
                              paddingHorizontal: 6,
                              paddingVertical: 2,
                            }}
                          >
                            <Icon name="verified" size={14} color="#10B981" />
                          </View>
                        )}
                      </View>
                      {candidate.jobTitle && (
                        <Text
                          style={{
                            fontSize: 15,
                            fontFamily: fonts.semiBold,
                            color: colors.warmGray,
                            marginBottom: 6,
                          }}
                        >
                          {candidate.jobTitle}
                        </Text>
                      )}
                      {candidate.currentCompany && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            marginBottom: 4,
                          }}
                        >
                          <Icon
                            name="business"
                            size={14}
                            color={colors.warmGray}
                          />
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.medium,
                              color: colors.warmGray,
                              marginLeft: 4,
                            }}
                          >
                            Currently at {candidate.currentCompany}
                          </Text>
                        </View>
                      )}
                      {candidate.location && (
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            marginBottom: 2,
                          }}
                        >
                          <Icon
                            name="location-on"
                            size={14}
                            color={colors.warmGray}
                          />
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: fonts.regular,
                              color: colors.warmGray,
                              marginLeft: 4,
                            }}
                          >
                            {candidate.location}
                          </Text>
                        </View>
                      )}
                    </View>
                  </View>

                  {/* Contact Info Row */}
                  <View
                    style={{
                      marginBottom: 16,
                      paddingVertical: 12,
                      paddingHorizontal: 14,
                      backgroundColor: isDarkMode ? "#1F2937" : "#F9FAFB",
                      borderRadius: 12,
                    }}
                  >
                    {candidate.email && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: candidate.phone ? 8 : 0,
                        }}
                      >
                        <Icon name="email" size={16} color={colors.warmGray} />
                        <Text
                          style={{
                            fontSize: 13,
                            fontFamily: fonts.regular,
                            color: colors.deepNavy,
                            marginLeft: 8,
                            flex: 1,
                          }}
                          numberOfLines={1}
                        >
                          {candidate.email}
                        </Text>
                      </View>
                    )}
                    {candidate.phone && (
                      <View
                        style={{ flexDirection: "row", alignItems: "center" }}
                      >
                        <Icon name="phone" size={16} color={colors.warmGray} />
                        <Text
                          style={{
                            fontSize: 13,
                            fontFamily: fonts.regular,
                            color: colors.deepNavy,
                            marginLeft: 8,
                          }}
                        >
                          {candidate.phone}
                        </Text>
                      </View>
                    )}
                  </View>

                  {/* Experience & Availability Row */}
                  <View
                    style={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      gap: 8,
                      marginBottom: 16,
                    }}
                  >
                    {candidate.experienceLevel && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                          backgroundColor: isDarkMode ? "#10B98120" : "#ECFDF5",
                          borderWidth: 1,
                          borderColor: "#10B981",
                        }}
                      >
                        <Icon name="work" size={14} color="#10B981" />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#10B981",
                            marginLeft: 6,
                          }}
                        >
                          {candidate.experienceLevel}
                        </Text>
                      </View>
                    )}
                    {candidate.yearsOfExperience && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                          backgroundColor: isDarkMode ? "#8B5CF620" : "#F3E8FF",
                          borderWidth: 1,
                          borderColor: "#8B5CF6",
                        }}
                      >
                        <Icon name="trending-up" size={14} color="#8B5CF6" />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#8B5CF6",
                            marginLeft: 6,
                          }}
                        >
                          {candidate.yearsOfExperience} years
                        </Text>
                      </View>
                    )}
                    {candidate.availability && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                          backgroundColor: isDarkMode ? "#3B82F620" : "#EFF6FF",
                          borderWidth: 1,
                          borderColor: "#3B82F6",
                        }}
                      >
                        <Icon name="schedule" size={14} color="#3B82F6" />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#3B82F6",
                            marginLeft: 6,
                          }}
                        >
                          {candidate.availability}
                        </Text>
                      </View>
                    )}
                    {candidate.employmentType && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                          backgroundColor: isDarkMode ? "#F59E0B20" : "#FEF3C7",
                          borderWidth: 1,
                          borderColor: "#F59E0B",
                        }}
                      >
                        <Icon
                          name="business-center"
                          size={14}
                          color="#F59E0B"
                        />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#F59E0B",
                            marginLeft: 6,
                          }}
                        >
                          {candidate.employmentType}
                        </Text>
                      </View>
                    )}
                    {candidate.noticePeriod && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                          backgroundColor: isDarkMode ? "#EC489920" : "#FEE2E2",
                          borderWidth: 1,
                          borderColor: "#EC4899",
                        }}
                      >
                        <Icon name="access-time" size={14} color="#EC4899" />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#EC4899",
                            marginLeft: 6,
                          }}
                        >
                          {candidate.noticePeriod} notice
                        </Text>
                      </View>
                    )}
                  </View>

                  {/* Salary Expectations */}
                  {candidate.salaryExpectation && (
                    <View
                      style={{
                        marginBottom: 16,
                        padding: 12,
                        backgroundColor: isDarkMode ? "#10B98110" : "#ECFDF5",
                        borderRadius: 12,
                        borderLeftWidth: 3,
                        borderLeftColor: "#10B981",
                      }}
                    >
                      <View
                        style={{ flexDirection: "row", alignItems: "center" }}
                      >
                        <Icon name="payments" size={18} color="#10B981" />
                        <Text
                          style={{
                            fontSize: 13,
                            fontFamily: fonts.semiBold,
                            color: isDarkMode ? "#10B981" : "#059669",
                            marginLeft: 8,
                          }}
                        >
                          Salary Expectation: {candidate.salaryExpectation}
                        </Text>
                      </View>
                    </View>
                  )}

                  {/* Bio */}
                  {candidate.bio && (
                    <View style={{ marginBottom: 16 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: fonts.bold,
                          color: colors.warmGray,
                          marginBottom: 8,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        About
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: fonts.regular,
                          color: colors.deepNavy,
                          lineHeight: 22,
                        }}
                        numberOfLines={4}
                      >
                        {candidate.bio}
                      </Text>
                    </View>
                  )}

                  {/* Social Links */}
                  {(candidate.linkedin ||
                    candidate.github ||
                    candidate.portfolio ||
                    candidate.website) && (
                    <View style={{ marginBottom: 16 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: fonts.bold,
                          color: colors.warmGray,
                          marginBottom: 8,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        Links
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                        }}
                      >
                        {candidate.linkedin && (
                          <TouchableOpacity
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              paddingHorizontal: 12,
                              paddingVertical: 6,
                              borderRadius: 12,
                              backgroundColor: "#0A66C220",
                              borderWidth: 1,
                              borderColor: "#0A66C2",
                            }}
                            onPress={() =>
                              Platform.OS === "web" &&
                              window.open(candidate.linkedin, "_blank")
                            }
                          >
                            <Icon name="link" size={14} color="#0A66C2" />
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.semiBold,
                                color: "#0A66C2",
                                marginLeft: 6,
                              }}
                            >
                              LinkedIn
                            </Text>
                          </TouchableOpacity>
                        )}
                        {candidate.github && (
                          <TouchableOpacity
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              paddingHorizontal: 12,
                              paddingVertical: 6,
                              borderRadius: 12,
                              backgroundColor: isDarkMode
                                ? "#FFFFFF20"
                                : "#F3F4F6",
                              borderWidth: 1,
                              borderColor: isDarkMode ? "#FFFFFF" : "#1F2937",
                            }}
                            onPress={() =>
                              Platform.OS === "web" &&
                              window.open(candidate.github, "_blank")
                            }
                          >
                            <Icon
                              name="code"
                              size={14}
                              color={isDarkMode ? "#FFFFFF" : "#1F2937"}
                            />
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.semiBold,
                                color: isDarkMode ? "#FFFFFF" : "#1F2937",
                                marginLeft: 6,
                              }}
                            >
                              GitHub
                            </Text>
                          </TouchableOpacity>
                        )}
                        {(candidate.portfolio || candidate.website) && (
                          <TouchableOpacity
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              paddingHorizontal: 12,
                              paddingVertical: 6,
                              borderRadius: 12,
                              backgroundColor: "#8B5CF620",
                              borderWidth: 1,
                              borderColor: "#8B5CF6",
                            }}
                            onPress={() =>
                              Platform.OS === "web" &&
                              window.open(
                                candidate.portfolio || candidate.website,
                                "_blank",
                              )
                            }
                          >
                            <Icon name="language" size={14} color="#8B5CF6" />
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.semiBold,
                                color: "#8B5CF6",
                                marginLeft: 6,
                              }}
                            >
                              Portfolio
                            </Text>
                          </TouchableOpacity>
                        )}
                      </View>
                    </View>
                  )}

                  {/* Education */}
                  {candidate.education && (
                    <View style={{ marginBottom: 16 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: fonts.bold,
                          color: colors.warmGray,
                          marginBottom: 8,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        Education
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "flex-start",
                        }}
                      >
                        <Icon
                          name="school"
                          size={16}
                          color={colors.warmGray}
                          style={{ marginTop: 2 }}
                        />
                        <View style={{ flex: 1, marginLeft: 10 }}>
                          <Text
                            style={{
                              fontSize: 14,
                              fontFamily: fonts.semiBold,
                              color: colors.deepNavy,
                            }}
                          >
                            {candidate.education.degree || "Degree"}
                          </Text>
                          {candidate.education.institution && (
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.regular,
                                color: colors.warmGray,
                                marginTop: 2,
                              }}
                            >
                              {candidate.education.institution}
                            </Text>
                          )}
                          {candidate.education.year && (
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.regular,
                                color: colors.warmGray,
                                marginTop: 2,
                              }}
                            >
                              {candidate.education.year}
                            </Text>
                          )}
                        </View>
                      </View>
                    </View>
                  )}

                  {/* Certifications */}
                  {candidate.certifications &&
                    candidate.certifications.length > 0 && (
                      <View style={{ marginBottom: 16 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.bold,
                            color: colors.warmGray,
                            marginBottom: 8,
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                          }}
                        >
                          Certifications
                        </Text>
                        {candidate.certifications
                          .slice(0, 3)
                          .map((cert: any, idx: number) => (
                            <View
                              key={idx}
                              style={{
                                flexDirection: "row",
                                alignItems: "flex-start",
                                marginBottom: idx < 2 ? 8 : 0,
                              }}
                            >
                              <Icon
                                name="verified"
                                size={16}
                                color="#10B981"
                                style={{ marginTop: 2 }}
                              />
                              <View style={{ flex: 1, marginLeft: 10 }}>
                                <Text
                                  style={{
                                    fontSize: 14,
                                    fontFamily: fonts.semiBold,
                                    color: colors.deepNavy,
                                  }}
                                >
                                  {typeof cert === "string" ? cert : cert.name}
                                </Text>
                                {typeof cert === "object" && cert.issuer && (
                                  <Text
                                    style={{
                                      fontSize: 12,
                                      fontFamily: fonts.regular,
                                      color: colors.warmGray,
                                      marginTop: 2,
                                    }}
                                  >
                                    {cert.issuer} • {cert.year || "N/A"}
                                  </Text>
                                )}
                              </View>
                            </View>
                          ))}
                        {candidate.certifications.length > 3 && (
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: colors.beeYellow,
                              marginTop: 8,
                              marginLeft: 26,
                            }}
                          >
                            +{candidate.certifications.length - 3} more
                            certification
                            {candidate.certifications.length - 3 > 1 ? "s" : ""}
                          </Text>
                        )}
                      </View>
                    )}

                  {/* Work Experience */}
                  {candidate.workExperience &&
                    candidate.workExperience.length > 0 && (
                      <View style={{ marginBottom: 16 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.bold,
                            color: colors.warmGray,
                            marginBottom: 8,
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                          }}
                        >
                          Work Experience
                        </Text>
                        {candidate.workExperience
                          .slice(0, 2)
                          .map((exp: any, idx: number) => (
                            <View
                              key={idx}
                              style={{
                                flexDirection: "row",
                                alignItems: "flex-start",
                                marginBottom: idx < 1 ? 10 : 0,
                              }}
                            >
                              <Icon
                                name="work-outline"
                                size={16}
                                color={colors.warmGray}
                                style={{ marginTop: 2 }}
                              />
                              <View style={{ flex: 1, marginLeft: 10 }}>
                                <Text
                                  style={{
                                    fontSize: 14,
                                    fontFamily: fonts.semiBold,
                                    color: colors.deepNavy,
                                  }}
                                >
                                  {exp.position || "Position"}
                                </Text>
                                {exp.company && (
                                  <Text
                                    style={{
                                      fontSize: 13,
                                      fontFamily: fonts.regular,
                                      color: colors.warmGray,
                                      marginTop: 2,
                                    }}
                                  >
                                    {exp.company}
                                  </Text>
                                )}
                                {(exp.startDate || exp.endDate) && (
                                  <Text
                                    style={{
                                      fontSize: 12,
                                      fontFamily: fonts.regular,
                                      color: colors.warmGray,
                                      marginTop: 2,
                                    }}
                                  >
                                    {exp.startDate} - {exp.endDate || "Present"}
                                  </Text>
                                )}
                              </View>
                            </View>
                          ))}
                        {candidate.workExperience.length > 2 && (
                          <Text
                            style={{
                              fontSize: 12,
                              fontFamily: fonts.medium,
                              color: colors.beeYellow,
                              marginTop: 8,
                              marginLeft: 26,
                            }}
                          >
                            +{candidate.workExperience.length - 2} more
                            experience
                            {candidate.workExperience.length - 2 > 1 ? "s" : ""}
                          </Text>
                        )}
                      </View>
                    )}

                  {/* Skills */}
                  {candidate.skills && candidate.skills.length > 0 && (
                    <View style={{ marginBottom: 20 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: fonts.bold,
                          color: colors.warmGray,
                          marginBottom: 8,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        Skills
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 6,
                        }}
                      >
                        {candidate.skills
                          .slice(0, 6)
                          .map((skill: string, idx: number) => (
                            <View
                              key={idx}
                              style={{
                                paddingHorizontal: 12,
                                paddingVertical: 6,
                                borderRadius: 16,
                                backgroundColor: isDarkMode
                                  ? "#374151"
                                  : "#F3F4F6",
                                borderWidth: 1,
                                borderColor: isDarkMode ? "#4B5563" : "#E5E7EB",
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 12,
                                  fontFamily: fonts.semiBold,
                                  color: colors.deepNavy,
                                }}
                              >
                                {skill}
                              </Text>
                            </View>
                          ))}
                        {candidate.skills.length > 6 && (
                          <View
                            style={{
                              paddingHorizontal: 12,
                              paddingVertical: 6,
                              borderRadius: 16,
                              backgroundColor: colors.beeYellow + "25",
                              borderWidth: 1,
                              borderColor: colors.beeYellow,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.bold,
                                color: colors.beeYellow,
                              }}
                            >
                              +{candidate.skills.length - 6}
                            </Text>
                          </View>
                        )}
                      </View>
                    </View>
                  )}

                  {/* Languages */}
                  {candidate.languages && candidate.languages.length > 0 && (
                    <View style={{ marginBottom: 20 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: fonts.bold,
                          color: colors.warmGray,
                          marginBottom: 8,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        Languages
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                        }}
                      >
                        {candidate.languages.map(
                          (lang: string, idx: number) => (
                            <View
                              key={idx}
                              style={{
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <Icon
                                name="language"
                                size={14}
                                color={colors.warmGray}
                              />
                              <Text
                                style={{
                                  fontSize: 13,
                                  fontFamily: fonts.medium,
                                  color: colors.deepNavy,
                                  marginLeft: 6,
                                }}
                              >
                                {lang}
                              </Text>
                            </View>
                          ),
                        )}
                      </View>
                    </View>
                  )}

                  {/* Action Buttons */}
                  <View style={{ flexDirection: "row", gap: 10, marginTop: 8 }}>
                    <TouchableOpacity
                      style={{
                        flex: 1,
                        backgroundColor: colors.beeYellow,
                        paddingVertical: 14,
                        borderRadius: 12,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 8,
                        shadowColor: colors.beeYellow,
                        shadowOffset: { width: 0, height: 2 },
                        shadowOpacity: 0.3,
                        shadowRadius: 4,
                        elevation: 3,
                      }}
                      onPress={() => {
                        setSelectedCandidate(candidate);
                      }}
                    >
                      <Icon
                        name="person"
                        size={20}
                        color={colors.buttonTextOnYellow}
                      />
                      <Text
                        style={{
                          fontSize: 15,
                          fontFamily: fonts.bold,
                          color: colors.buttonTextOnYellow,
                        }}
                      >
                        View Profile
                      </Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      style={{
                        paddingHorizontal: 18,
                        paddingVertical: 14,
                        borderRadius: 12,
                        borderWidth: 2,
                        borderColor:
                          colors.lightGray === "#1F2937"
                            ? "#374151"
                            : "#E5E7EB",
                        backgroundColor: isDarkMode ? "#1F2937" : colors.white,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onPress={() => {
                        // TODO: Contact candidate
                        Alert.alert(
                          "Contact",
                          `Send message to ${candidate.fullName}`,
                        );
                      }}
                    >
                      <Icon name="mail" size={20} color={colors.deepNavy} />
                    </TouchableOpacity>
                  </View>
                </View>
              ))}
            </View>
          ) : (
            <View
              style={{
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
                paddingVertical: 60,
              }}
            >
              <Icon
                name="people-outline"
                size={64}
                color={colors.warmGray}
                style={{ opacity: 0.3, marginBottom: 16 }}
              />
              <Text
                style={{
                  fontSize: 18,
                  fontFamily: fonts.semiBold,
                  color: colors.deepNavy,
                  marginBottom: 8,
                }}
              >
                No candidates found
              </Text>
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.regular,
                  color: colors.warmGray,
                  textAlign: "center",
                  paddingHorizontal: 40,
                }}
              >
                Try adjusting your filters or search criteria
              </Text>
            </View>
          )}
        </ScrollView>
      )}

      {/* Bottom Nav */}
      <BottomNavBar
        navigation={navigation}
        activeRoute="CompanyDashboard"
        isDarkMode={isDarkMode}
        user={null}
        userData={null}
        currentLanguage={currentLanguage}
      />

      {/* Talent Profile Detail Modal */}
      <Modal
        visible={!!selectedCandidate}
        transparent
        animationType="fade"
        onRequestClose={() => setSelectedCandidate(null)}
      >
        <View
          style={{
            flex: 1,
            backgroundColor: "rgba(0,0,0,0.55)",
            justifyContent: "center",
            alignItems: "center",
            padding: isMobile ? 16 : 40,
          }}
        >
          <View
            style={{
              width: isMobile ? "100%" : Math.min(660, 700),
              maxHeight: "90%",
              backgroundColor: isDarkMode ? "#1F2937" : "#FFFFFF",
              borderRadius: 20,
              overflow: "hidden",
              shadowColor: "#000",
              shadowOffset: { width: 0, height: 8 },
              shadowOpacity: 0.25,
              shadowRadius: 24,
              elevation: 12,
            }}
          >
            {/* Modal Header */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 20,
                borderBottomWidth: 1,
                borderBottomColor: isDarkMode ? "#374151" : "#E5E7EB",
                backgroundColor: isDarkMode ? "#111827" : "#F9FAFB",
              }}
            >
              <Text
                style={{
                  fontSize: 17,
                  fontFamily: fonts.bold,
                  color: isDarkMode ? lightColors.white : lightColors.deepNavy,
                }}
              >
                Candidate Profile
              </Text>
              <TouchableOpacity
                onPress={() => setSelectedCandidate(null)}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 16,
                  backgroundColor: isDarkMode ? "#374151" : "#E5E7EB",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon
                  name="close"
                  size={18}
                  color={isDarkMode ? lightColors.white : lightColors.deepNavy}
                />
              </TouchableOpacity>
            </View>

            <ScrollView contentContainerStyle={{ padding: isMobile ? 20 : 28 }}>
              {selectedCandidate && (
                <>
                  {/* Avatar + Identity */}
                  <View style={{ alignItems: "center", marginBottom: 24 }}>
                    <View
                      style={{
                        width: 88,
                        height: 88,
                        borderRadius: 44,
                        backgroundColor: isDarkMode ? "#374151" : "#F3F4F6",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 12,
                        overflow: "hidden",
                        borderWidth: 3,
                        borderColor: colors.beeYellow,
                      }}
                    >
                      {selectedCandidate.profilePicture ||
                      selectedCandidate.profile?.avatar ||
                      selectedCandidate.photoURL ? (
                        <Image
                          source={{
                            uri:
                              selectedCandidate.profilePicture ||
                              selectedCandidate.profile?.avatar ||
                              selectedCandidate.photoURL,
                          }}
                          style={{ width: 88, height: 88 }}
                        />
                      ) : (
                        <Text
                          style={{
                            fontSize: 32,
                            fontFamily: fonts.bold,
                            color: colors.warmGray,
                          }}
                        >
                          {(
                            selectedCandidate.fullName ||
                            selectedCandidate.displayName ||
                            selectedCandidate.email
                          )
                            ?.charAt(0)
                            ?.toUpperCase() || "C"}
                        </Text>
                      )}
                    </View>
                    <Text
                      style={{
                        fontSize: 22,
                        fontFamily: fonts.bold,
                        color: colors.deepNavy,
                        textAlign: "center",
                        marginBottom: 4,
                      }}
                    >
                      {selectedCandidate.fullName ||
                        selectedCandidate.displayName ||
                        "Candidate"}
                    </Text>
                    {selectedCandidate.jobTitle && (
                      <Text
                        style={{
                          fontSize: 15,
                          fontFamily: fonts.semiBold,
                          color: colors.warmGray,
                          textAlign: "center",
                          marginBottom: 4,
                        }}
                      >
                        {selectedCandidate.jobTitle}
                      </Text>
                    )}
                    {selectedCandidate.currentCompany && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 4,
                        }}
                      >
                        <Icon
                          name="business"
                          size={14}
                          color={colors.warmGray}
                        />
                        <Text
                          style={{
                            fontSize: 13,
                            fontFamily: fonts.medium,
                            color: colors.warmGray,
                            marginLeft: 6,
                          }}
                        >
                          {selectedCandidate.currentCompany}
                        </Text>
                      </View>
                    )}
                    {selectedCandidate.verified && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginTop: 4,
                          paddingHorizontal: 10,
                          paddingVertical: 4,
                          borderRadius: 12,
                          backgroundColor: "#10B98120",
                        }}
                      >
                        <Icon name="verified" size={14} color="#10B981" />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#10B981",
                            marginLeft: 4,
                          }}
                        >
                          Verified
                        </Text>
                      </View>
                    )}
                    {(selectedCandidate.availability === "Immediately" ||
                      selectedCandidate.availability === "Available") && (
                      <View
                        style={{
                          paddingHorizontal: 12,
                          paddingVertical: 4,
                          borderRadius: 12,
                          backgroundColor: "#ECFDF5",
                          borderWidth: 1,
                          borderColor: "#10B981",
                          marginTop: 6,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#10B981",
                          }}
                        >
                          Available Now
                        </Text>
                      </View>
                    )}
                  </View>

                  {/* Contact Info */}
                  <View
                    style={{
                      backgroundColor: isDarkMode ? "#111827" : "#F9FAFB",
                      borderRadius: 12,
                      padding: 16,
                      marginBottom: 20,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.bold,
                        color: colors.warmGray,
                        marginBottom: 12,
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                      }}
                    >
                      Contact Information
                    </Text>
                    {selectedCandidate.email && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 8,
                        }}
                      >
                        <Icon name="email" size={16} color={colors.warmGray} />
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: fonts.regular,
                            color: colors.deepNavy,
                            marginLeft: 10,
                          }}
                        >
                          {selectedCandidate.email}
                        </Text>
                      </View>
                    )}
                    {(selectedCandidate.phone ||
                      selectedCandidate.phoneNumber) && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          marginBottom: 8,
                        }}
                      >
                        <Icon name="phone" size={16} color={colors.warmGray} />
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: fonts.regular,
                            color: colors.deepNavy,
                            marginLeft: 10,
                          }}
                        >
                          {selectedCandidate.phone ||
                            selectedCandidate.phoneNumber}
                        </Text>
                      </View>
                    )}
                    {selectedCandidate.location && (
                      <View
                        style={{ flexDirection: "row", alignItems: "center" }}
                      >
                        <Icon
                          name="location-on"
                          size={16}
                          color={colors.warmGray}
                        />
                        <Text
                          style={{
                            fontSize: 14,
                            fontFamily: fonts.regular,
                            color: colors.deepNavy,
                            marginLeft: 10,
                          }}
                        >
                          {selectedCandidate.location}
                        </Text>
                      </View>
                    )}
                  </View>

                  {/* Detail Badges */}
                  <View
                    style={{
                      flexDirection: "row",
                      flexWrap: "wrap",
                      gap: 8,
                      marginBottom: 20,
                    }}
                  >
                    {selectedCandidate.experienceLevel && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                          backgroundColor: "#ECFDF5",
                          borderWidth: 1,
                          borderColor: "#10B981",
                        }}
                      >
                        <Icon name="work" size={13} color="#10B981" />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#10B981",
                            marginLeft: 5,
                          }}
                        >
                          {selectedCandidate.experienceLevel}
                        </Text>
                      </View>
                    )}
                    {selectedCandidate.yearsOfExperience && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                          backgroundColor: "#F3E8FF",
                          borderWidth: 1,
                          borderColor: "#8B5CF6",
                        }}
                      >
                        <Icon name="trending-up" size={13} color="#8B5CF6" />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#8B5CF6",
                            marginLeft: 5,
                          }}
                        >
                          {selectedCandidate.yearsOfExperience} {t.cdYearsExp}
                        </Text>
                      </View>
                    )}
                    {selectedCandidate.availability && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                          backgroundColor: "#EFF6FF",
                          borderWidth: 1,
                          borderColor: "#3B82F6",
                        }}
                      >
                        <Icon name="schedule" size={13} color="#3B82F6" />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#3B82F6",
                            marginLeft: 5,
                          }}
                        >
                          {selectedCandidate.availability}
                        </Text>
                      </View>
                    )}
                    {selectedCandidate.employmentType && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                          backgroundColor: "#FEF3C7",
                          borderWidth: 1,
                          borderColor: "#F59E0B",
                        }}
                      >
                        <Icon
                          name="business-center"
                          size={13}
                          color="#F59E0B"
                        />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#F59E0B",
                            marginLeft: 5,
                          }}
                        >
                          {selectedCandidate.employmentType}
                        </Text>
                      </View>
                    )}
                    {selectedCandidate.noticePeriod && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                          backgroundColor: "#FEE2E2",
                          borderWidth: 1,
                          borderColor: "#EC4899",
                        }}
                      >
                        <Icon name="access-time" size={13} color="#EC4899" />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: "#EC4899",
                            marginLeft: 5,
                          }}
                        >
                          {selectedCandidate.noticePeriod} notice
                        </Text>
                      </View>
                    )}
                    {(selectedCandidate.workType ||
                      selectedCandidate.preferredWorkType) && (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                          borderRadius: 20,
                          backgroundColor: isDarkMode ? "#374151" : "#F3F4F6",
                          borderWidth: 1,
                          borderColor: isDarkMode ? "#4B5563" : "#D1D5DB",
                        }}
                      >
                        <Icon name="laptop" size={13} color={colors.warmGray} />
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.semiBold,
                            color: colors.warmGray,
                            marginLeft: 5,
                          }}
                        >
                          {selectedCandidate.workType ||
                            selectedCandidate.preferredWorkType}
                        </Text>
                      </View>
                    )}
                  </View>

                  {/* Salary */}
                  {selectedCandidate.salaryExpectation && (
                    <View
                      style={{
                        marginBottom: 20,
                        padding: 14,
                        backgroundColor: isDarkMode ? "#10B98115" : "#ECFDF5",
                        borderRadius: 12,
                        borderLeftWidth: 3,
                        borderLeftColor: "#10B981",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Icon name="payments" size={18} color="#10B981" />
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: fonts.semiBold,
                          color: isDarkMode ? "#10B981" : "#059669",
                          marginLeft: 10,
                        }}
                      >
                        Salary: {selectedCandidate.salaryExpectation}
                      </Text>
                    </View>
                  )}

                  {/* Bio */}
                  {selectedCandidate.bio && (
                    <View style={{ marginBottom: 20 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: fonts.bold,
                          color: colors.warmGray,
                          marginBottom: 8,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        About
                      </Text>
                      <Text
                        style={{
                          fontSize: 14,
                          fontFamily: fonts.regular,
                          color: colors.deepNavy,
                          lineHeight: 22,
                        }}
                      >
                        {selectedCandidate.bio}
                      </Text>
                    </View>
                  )}

                  {/* Skills */}
                  {selectedCandidate.skills &&
                    selectedCandidate.skills.length > 0 && (
                      <View style={{ marginBottom: 20 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.bold,
                            color: colors.warmGray,
                            marginBottom: 10,
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                          }}
                        >
                          Skills
                        </Text>
                        <View
                          style={{
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 7,
                          }}
                        >
                          {selectedCandidate.skills.map(
                            (skill: string, idx: number) => (
                              <View
                                key={idx}
                                style={{
                                  paddingHorizontal: 12,
                                  paddingVertical: 6,
                                  borderRadius: 16,
                                  backgroundColor: isDarkMode
                                    ? "#374151"
                                    : "#F3F4F6",
                                  borderWidth: 1,
                                  borderColor: isDarkMode
                                    ? "#4B5563"
                                    : "#E5E7EB",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 12,
                                    fontFamily: fonts.semiBold,
                                    color: colors.deepNavy,
                                  }}
                                >
                                  {skill}
                                </Text>
                              </View>
                            ),
                          )}
                        </View>
                      </View>
                    )}

                  {/* Languages */}
                  {selectedCandidate.languages &&
                    selectedCandidate.languages.length > 0 && (
                      <View style={{ marginBottom: 20 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.bold,
                            color: colors.warmGray,
                            marginBottom: 10,
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                          }}
                        >
                          Languages
                        </Text>
                        <View
                          style={{
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 12,
                          }}
                        >
                          {selectedCandidate.languages.map(
                            (lang: string, idx: number) => (
                              <View
                                key={idx}
                                style={{
                                  flexDirection: "row",
                                  alignItems: "center",
                                }}
                              >
                                <Icon
                                  name="language"
                                  size={14}
                                  color={colors.warmGray}
                                />
                                <Text
                                  style={{
                                    fontSize: 13,
                                    fontFamily: fonts.medium,
                                    color: colors.deepNavy,
                                    marginLeft: 6,
                                  }}
                                >
                                  {lang}
                                </Text>
                              </View>
                            ),
                          )}
                        </View>
                      </View>
                    )}

                  {/* Education */}
                  {selectedCandidate.education && (
                    <View style={{ marginBottom: 20 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: fonts.bold,
                          color: colors.warmGray,
                          marginBottom: 10,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        Education
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "flex-start",
                        }}
                      >
                        <Icon
                          name="school"
                          size={18}
                          color={colors.warmGray}
                          style={{ marginTop: 2 }}
                        />
                        <View style={{ flex: 1, marginLeft: 12 }}>
                          <Text
                            style={{
                              fontSize: 14,
                              fontFamily: fonts.semiBold,
                              color: colors.deepNavy,
                            }}
                          >
                            {typeof selectedCandidate.education === "string"
                              ? selectedCandidate.education
                              : selectedCandidate.education.degree || "Degree"}
                          </Text>
                          {typeof selectedCandidate.education === "object" &&
                            selectedCandidate.education.institution && (
                              <Text
                                style={{
                                  fontSize: 13,
                                  fontFamily: fonts.regular,
                                  color: colors.warmGray,
                                  marginTop: 2,
                                }}
                              >
                                {selectedCandidate.education.institution}
                              </Text>
                            )}
                          {typeof selectedCandidate.education === "object" &&
                            selectedCandidate.education.year && (
                              <Text
                                style={{
                                  fontSize: 12,
                                  fontFamily: fonts.regular,
                                  color: colors.warmGray,
                                  marginTop: 2,
                                }}
                              >
                                {selectedCandidate.education.year}
                              </Text>
                            )}
                        </View>
                      </View>
                    </View>
                  )}

                  {/* Work Experience */}
                  {selectedCandidate.workExperience &&
                    selectedCandidate.workExperience.length > 0 && (
                      <View style={{ marginBottom: 20 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.bold,
                            color: colors.warmGray,
                            marginBottom: 10,
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                          }}
                        >
                          Work Experience
                        </Text>
                        {selectedCandidate.workExperience.map(
                          (exp: any, idx: number) => (
                            <View
                              key={idx}
                              style={{
                                flexDirection: "row",
                                alignItems: "flex-start",
                                marginBottom: 12,
                                paddingBottom: 12,
                                borderBottomWidth:
                                  idx <
                                  selectedCandidate.workExperience.length - 1
                                    ? 1
                                    : 0,
                                borderBottomColor: isDarkMode
                                  ? "#374151"
                                  : "#E5E7EB",
                              }}
                            >
                              <Icon
                                name="work-outline"
                                size={18}
                                color={colors.warmGray}
                                style={{ marginTop: 2 }}
                              />
                              <View style={{ flex: 1, marginLeft: 12 }}>
                                <Text
                                  style={{
                                    fontSize: 14,
                                    fontFamily: fonts.semiBold,
                                    color: colors.deepNavy,
                                  }}
                                >
                                  {exp.position || "Position"}
                                </Text>
                                {exp.company && (
                                  <Text
                                    style={{
                                      fontSize: 13,
                                      fontFamily: fonts.regular,
                                      color: colors.warmGray,
                                      marginTop: 2,
                                    }}
                                  >
                                    {exp.company}
                                  </Text>
                                )}
                                {(exp.startDate || exp.endDate) && (
                                  <Text
                                    style={{
                                      fontSize: 12,
                                      fontFamily: fonts.regular,
                                      color: colors.warmGray,
                                      marginTop: 2,
                                    }}
                                  >
                                    {exp.startDate} – {exp.endDate || "Present"}
                                  </Text>
                                )}
                                {exp.description && (
                                  <Text
                                    style={{
                                      fontSize: 13,
                                      fontFamily: fonts.regular,
                                      color: colors.deepNavy,
                                      marginTop: 4,
                                      lineHeight: 20,
                                    }}
                                  >
                                    {exp.description}
                                  </Text>
                                )}
                              </View>
                            </View>
                          ),
                        )}
                      </View>
                    )}

                  {/* Certifications */}
                  {selectedCandidate.certifications &&
                    selectedCandidate.certifications.length > 0 && (
                      <View style={{ marginBottom: 20 }}>
                        <Text
                          style={{
                            fontSize: 12,
                            fontFamily: fonts.bold,
                            color: colors.warmGray,
                            marginBottom: 10,
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                          }}
                        >
                          Certifications
                        </Text>
                        {selectedCandidate.certifications.map(
                          (cert: any, idx: number) => (
                            <View
                              key={idx}
                              style={{
                                flexDirection: "row",
                                alignItems: "flex-start",
                                marginBottom: 8,
                              }}
                            >
                              <Icon
                                name="verified"
                                size={18}
                                color="#10B981"
                                style={{ marginTop: 2 }}
                              />
                              <View style={{ flex: 1, marginLeft: 12 }}>
                                <Text
                                  style={{
                                    fontSize: 14,
                                    fontFamily: fonts.semiBold,
                                    color: colors.deepNavy,
                                  }}
                                >
                                  {typeof cert === "string" ? cert : cert.name}
                                </Text>
                                {typeof cert === "object" && cert.issuer && (
                                  <Text
                                    style={{
                                      fontSize: 12,
                                      fontFamily: fonts.regular,
                                      color: colors.warmGray,
                                      marginTop: 2,
                                    }}
                                  >
                                    {cert.issuer}
                                    {cert.year ? ` • ${cert.year}` : ""}
                                  </Text>
                                )}
                              </View>
                            </View>
                          ),
                        )}
                      </View>
                    )}

                  {/* Social Links */}
                  {(selectedCandidate.linkedin ||
                    selectedCandidate.github ||
                    selectedCandidate.portfolio ||
                    selectedCandidate.website) && (
                    <View style={{ marginBottom: 20 }}>
                      <Text
                        style={{
                          fontSize: 12,
                          fontFamily: fonts.bold,
                          color: colors.warmGray,
                          marginBottom: 10,
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                        }}
                      >
                        Links
                      </Text>
                      <View
                        style={{
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                        }}
                      >
                        {selectedCandidate.linkedin && (
                          <TouchableOpacity
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              paddingHorizontal: 12,
                              paddingVertical: 8,
                              borderRadius: 12,
                              backgroundColor: "#0A66C220",
                              borderWidth: 1,
                              borderColor: "#0A66C2",
                            }}
                            onPress={() =>
                              Platform.OS === "web" &&
                              window.open(selectedCandidate.linkedin, "_blank")
                            }
                          >
                            <Icon name="link" size={14} color="#0A66C2" />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#0A66C2",
                                marginLeft: 6,
                              }}
                            >
                              LinkedIn
                            </Text>
                          </TouchableOpacity>
                        )}
                        {selectedCandidate.github && (
                          <TouchableOpacity
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              paddingHorizontal: 12,
                              paddingVertical: 8,
                              borderRadius: 12,
                              backgroundColor: isDarkMode
                                ? "#FFFFFF15"
                                : "#F3F4F6",
                              borderWidth: 1,
                              borderColor: isDarkMode ? "#FFFFFF40" : "#D1D5DB",
                            }}
                            onPress={() =>
                              Platform.OS === "web" &&
                              window.open(selectedCandidate.github, "_blank")
                            }
                          >
                            <Icon
                              name="code"
                              size={14}
                              color={colors.deepNavy}
                            />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: colors.deepNavy,
                                marginLeft: 6,
                              }}
                            >
                              GitHub
                            </Text>
                          </TouchableOpacity>
                        )}
                        {(selectedCandidate.portfolio ||
                          selectedCandidate.website) && (
                          <TouchableOpacity
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                              paddingHorizontal: 12,
                              paddingVertical: 8,
                              borderRadius: 12,
                              backgroundColor: "#8B5CF620",
                              borderWidth: 1,
                              borderColor: "#8B5CF6",
                            }}
                            onPress={() =>
                              Platform.OS === "web" &&
                              window.open(
                                selectedCandidate.portfolio ||
                                  selectedCandidate.website,
                                "_blank",
                              )
                            }
                          >
                            <Icon name="language" size={14} color="#8B5CF6" />
                            <Text
                              style={{
                                fontSize: 13,
                                fontFamily: fonts.semiBold,
                                color: "#8B5CF6",
                                marginLeft: 6,
                              }}
                            >
                              Portfolio
                            </Text>
                          </TouchableOpacity>
                        )}
                      </View>
                    </View>
                  )}

                  {/* Action Buttons */}
                  <View
                    style={{
                      flexDirection: "row",
                      gap: 10,
                      marginTop: 8,
                      paddingBottom: 8,
                    }}
                  >
                    <TouchableOpacity
                      style={{
                        flex: 1,
                        backgroundColor: colors.beeYellow,
                        paddingVertical: 14,
                        borderRadius: 12,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 8,
                      }}
                      onPress={() => {
                        setSelectedCandidate(null);
                        Alert.alert(
                          "Contact",
                          `Send message to ${
                            selectedCandidate?.fullName ||
                            selectedCandidate?.email
                          }`,
                        );
                      }}
                    >
                      <Icon
                        name="mail"
                        size={18}
                        color={colors.buttonTextOnYellow}
                      />
                      <Text
                        style={{
                          fontSize: 15,
                          fontFamily: fonts.bold,
                          color: colors.buttonTextOnYellow,
                        }}
                      >
                        Contact
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={{
                        paddingHorizontal: 18,
                        paddingVertical: 14,
                        borderRadius: 12,
                        borderWidth: 1,
                        borderColor: isDarkMode ? "#374151" : "#E5E7EB",
                        backgroundColor: isDarkMode ? "#374151" : colors.white,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      onPress={() => setSelectedCandidate(null)}
                    >
                      <Icon name="close" size={20} color={colors.deepNavy} />
                    </TouchableOpacity>
                  </View>
                </>
              )}
            </ScrollView>
          </View>
        </View>
      </Modal>
    </SafeAreaView>
  );
}

// Uploads a locally picked image (file://, blob: or data: URI from
// ImagePicker) through secureFileUploadCallable and returns its public URL.
// Picker URIs only exist on the device that picked them, so they must never
// be written to Firestore directly.
async function uploadPickedImage(
  localUri: string,
  fileType: "profile-picture" | "banner-image",
): Promise<string> {
  const response = await fetch(localUri);
  const blob = await response.blob();
  const mimeType = blob.type || "image/jpeg";
  const extension = mimeType.split("/")[1] || "jpg";
  const prefix = fileType === "banner-image" ? "banner_" : "";
  const filename = `${prefix}${Date.now()}.${extension}`;

  const fileData = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve((reader.result as string).split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  const result = await httpsCallable(
    functions,
    "secureFileUploadCallable",
  )({ fileData, filename, mimeType, fileType });
  const data = result.data as {
    success: boolean;
    downloadURL: string;
    error?: string;
  };
  if (!data.success) throw new Error(data.error || "Upload failed");
  return data.downloadURL;
}

// Profile Setup Screen - shown to new users after email verification
function ProfileSetupScreen({ navigation, route, isDarkMode }: any) {
  const colors = isDarkMode ? darkColors : lightColors;
  // Handle both camelCase (in-app nav) and lowercase (URL refresh via getStateFromPath)
  const userId = route?.params?.userId || route?.params?.userid;

  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 3;
  const [saving, setSaving] = useState(false);

  // Step 1: Basic Info
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dobPickerOpen, setDobPickerOpen] = useState(false);
  const [dobViewYear, setDobViewYear] = useState(new Date().getFullYear() - 22);
  const [dobViewMonth, setDobViewMonth] = useState(new Date().getMonth());
  const [dobPickerMode, setDobPickerMode] = useState<"day" | "month" | "year">(
    "day",
  );
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const [bannerImage, setBannerImage] = useState<string | null>(null);

  // Step 2: Portfolio
  const [jobTitle, setJobTitle] = useState("");
  const [yearsOfExperience, setYearsOfExperience] = useState("");
  const [selectedSkillCategories, setSelectedSkillCategories] = useState<
    string[]
  >([]);
  const [selectedSkillSubcategories, setSelectedSkillSubcategories] = useState<
    string[]
  >([]);
  const [selectedSkillTags, setSelectedSkillTags] = useState<string[]>([]);
  const [expandedSkillCategories, setExpandedSkillCategories] = useState<
    Set<string>
  >(new Set());
  const [educationDegree, setEducationDegree] = useState("");
  const [educationInstitution, setEducationInstitution] = useState("");
  const [educationYear, setEducationYear] = useState("");

  // Step 3: Social Links
  const [linkedinUrl, setLinkedinUrl] = useState("");
  const [githubUrl, setGithubUrl] = useState("");
  const [portfolioUrl, setPortfolioUrl] = useState("");
  const [twitterUrl, setTwitterUrl] = useState("");
  const [instagramUrl, setInstagramUrl] = useState("");

  // Categories still needed for step 2 skills
  const [categories, setCategories] = useState<any[]>([]);
  const [loadingCategories, setLoadingCategories] = useState(false);

  const [errors, setErrors] = useState<Record<string, string>>({});
  const [skillTagSearch, setSkillTagSearch] = useState("");
  const scrollRef = useRef<ScrollView>(null);
  const scrollOffset = useRef(0);
  const fieldViewRefs = useRef<Record<string, any>>({});

  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = dimensions.width < 768;

  useEffect(() => {
    const sub = Dimensions.addEventListener("change", ({ window }) =>
      setDimensions(window),
    );
    return () => sub?.remove();
  }, []);

  useEffect(() => {
    if (currentStep === 2) fetchCategories();
  }, [currentStep]);

  const fetchCategories = async () => {
    try {
      setLoadingCategories(true);
      const snap = await getDocs(collection(db, "categories"));
      setCategories(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (e) {
      console.error("Error fetching categories:", e);
    } finally {
      setLoadingCategories(false);
    }
  };

  const getSubcategories = (parentPath: string) =>
    categories.filter((c) => c.parentPath === parentPath);

  const toggleSkillCategory = (path: string) => {
    const newExpanded = new Set(expandedSkillCategories);
    if (newExpanded.has(path)) newExpanded.delete(path);
    else newExpanded.add(path);
    setExpandedSkillCategories(newExpanded);
    if (selectedSkillCategories.includes(path)) {
      setSelectedSkillCategories(
        selectedSkillCategories.filter((c) => c !== path),
      );
      const subcatPaths = getSubcategories(path).map((s) => s.path);
      setSelectedSkillSubcategories(
        selectedSkillSubcategories.filter((s) => !subcatPaths.includes(s)),
      );
    } else {
      setSelectedSkillCategories([...selectedSkillCategories, path]);
    }
  };

  const toggleSkillSubcategory = (path: string) => {
    const isSelected = selectedSkillSubcategories.includes(path);
    const nextSubcategories = isSelected
      ? selectedSkillSubcategories.filter((s) => s !== path)
      : [...selectedSkillSubcategories, path];
    setSelectedSkillSubcategories(nextSubcategories);

    const sub = categories.find((c) => c.path === path);
    const subTags: string[] = sub?.tags || [];
    if (subTags.length === 0) return;

    if (isSelected) {
      // Keep tags still covered by the remaining selected categories/subcategories
      const coveredTags = new Set<string>();
      selectedSkillCategories.forEach((catPath) => {
        const cat = categories.find((c) => c.path === catPath);
        if (cat?.tags) cat.tags.forEach((t: string) => coveredTags.add(t));
        getSubcategories(catPath).forEach((s) => {
          if (s.tags) s.tags.forEach((t: string) => coveredTags.add(t));
        });
      });
      nextSubcategories.forEach((subPath) => {
        const s = categories.find((c) => c.path === subPath);
        if (s?.tags) s.tags.forEach((t: string) => coveredTags.add(t));
      });
      setSelectedSkillTags((prev) =>
        prev.filter((t) => !subTags.includes(t) || coveredTags.has(t)),
      );
    } else {
      // Auto-select every tag under this subcategory as a preference
      setSelectedSkillTags((prev) => Array.from(new Set([...prev, ...subTags])));
    }
  };

  const toggleSkillTag = (tag: string) => {
    setSelectedSkillTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag],
    );
  };

  const getSkillTagsForSelection = () => {
    const tagsSet = new Set<string>();
    selectedSkillCategories.forEach((catPath) => {
      const cat = categories.find((c) => c.path === catPath);
      if (cat?.tags) cat.tags.forEach((t: string) => tagsSet.add(t));
      getSubcategories(catPath).forEach((sub) => {
        if (sub.tags) sub.tags.forEach((t: string) => tagsSet.add(t));
      });
    });
    selectedSkillSubcategories.forEach((subPath) => {
      const sub = categories.find((c) => c.path === subPath);
      if (sub?.tags) sub.tags.forEach((t: string) => tagsSet.add(t));
    });
    if (tagsSet.size === 0) {
      [
        "JavaScript",
        "Python",
        "React",
        "Node.js",
        "TypeScript",
        "Java",
        "Marketing",
        "Sales",
        "Finance",
        "HR",
        "Design",
        "Management",
        "Customer Service",
        "Engineering",
        "Healthcare",
        "Education",
        "Accounting",
      ].forEach((t) => tagsSet.add(t));
    }
    return Array.from(tagsSet);
  };

  const scrollToFirstError = (errorKeys: string[]) => {
    if (errorKeys.length === 0 || !scrollRef.current) return;
    const firstKey = errorKeys[0];
    const fieldView = fieldViewRefs.current[firstKey];
    if (!fieldView) return;
    setTimeout(() => {
      fieldView.measure(
        (
          x: number,
          y: number,
          w: number,
          h: number,
          pageX: number,
          pageY: number,
        ) => {
          scrollRef.current?.measure(
            (
              _x: number,
              _y: number,
              _w: number,
              _h: number,
              _px: number,
              spy: number,
            ) => {
              const targetY = pageY - spy + scrollOffset.current - 20;
              scrollRef.current?.scrollTo({
                y: Math.max(0, targetY),
                animated: true,
              });
            },
          );
        },
      );
    }, 50);
  };

  const validateStep = () => {
    const newErrors: Record<string, string> = {};
    if (currentStep === 1) {
      if (!dateOfBirth.trim())
        newErrors.dateOfBirth = "Date of birth is required";
      if (!phoneNumber.trim())
        newErrors.phoneNumber = "Phone number is required";
    }
    if (currentStep === 2) {
      if (!jobTitle.trim()) newErrors.jobTitle = "Job title is required";
      if (!yearsOfExperience.trim())
        newErrors.yearsOfExperience = "Years of experience is required";
      if (selectedSkillCategories.length === 0)
        newErrors.skillCategories = "Please select at least one skill category";
      if (selectedSkillTags.length === 0)
        newErrors.skillTags = "Please select at least one skill tag";
      if (!educationDegree.trim())
        newErrors.educationDegree = "Degree / qualification is required";
    }
    // Step 3: Social links are all optional
    if (currentStep === 3) {
      // No required fields for social links step
    }
    setErrors(newErrors);
    const errorKeys = Object.keys(newErrors);
    if (errorKeys.length > 0) scrollToFirstError(errorKeys);
    return errorKeys.length === 0;
  };

  const handleNext = () => {
    if (!validateStep()) return;
    setCurrentStep((prev) => prev + 1);
  };

  const handleBack = () => setCurrentStep((prev) => prev - 1);

  const handleFinish = async () => {
    if (!validateStep()) return;
    if (!userId) {
      Alert.alert("Error", "User session lost. Please log in again.");
      return;
    }
    try {
      setSaving(true);
      const updateData: any = {
        dateOfBirth: dateOfBirth.trim(),
        phoneNumber: phoneNumber.trim(),
        jobTitle: jobTitle.trim(),
        yearsOfExperience: yearsOfExperience.trim(),
        skillCategories: selectedSkillCategories,
        skillSubcategories: selectedSkillSubcategories,
        skillTags: selectedSkillTags,
        selectedCategories: selectedSkillCategories,
        education: {
          degree: educationDegree.trim(),
          institution: educationInstitution.trim(),
          year: educationYear.trim(),
        },
        socialLinks: {
          linkedin: linkedinUrl.trim(),
          github: githubUrl.trim(),
          portfolio: portfolioUrl.trim(),
          twitter: twitterUrl.trim(),
          instagram: instagramUrl.trim(),
        },
        profileSetupComplete: true,
        updatedAt: new Date(),
      };

      // A failed image upload shouldn't block finishing setup — the user can
      // add a photo later from Settings.
      if (profileImage) {
        try {
          updateData.profilePicture = await uploadPickedImage(
            profileImage,
            "profile-picture",
          );
        } catch (uploadError) {
          console.error("Error uploading profile picture:", uploadError);
        }
      }
      if (bannerImage) {
        try {
          updateData.bannerImage = await uploadPickedImage(
            bannerImage,
            "banner-image",
          );
        } catch (uploadError) {
          console.error("Error uploading banner image:", uploadError);
        }
      }

      await updateDoc(doc(db, "users", userId), updateData);
      navigation.replace("Jobs");
    } catch (e) {
      console.error("Error saving profile setup:", e);
      Alert.alert("Error", "Failed to save your profile. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  // ── Shared design tokens ─────────────────────────────────────────────────
  const bg = isDarkMode ? "#0F172A" : "#F8FAFC";
  const surface = isDarkMode ? "#1E293B" : "#FFFFFF";
  const border = isDarkMode ? "#334155" : "#E2E8F0";
  const textPrimary = isDarkMode ? "#F1F5F9" : "#0F172A";
  const textMuted = "#64748B";
  const accent = "#FFB800";
  const accentSoft = isDarkMode ? "#2D2507" : "#FFFBEB";
  const errorColor = "#EF4444";

  const fieldContainer = (field: string) => ({
    borderWidth: 1.5,
    borderColor: errors[field] ? errorColor : border,
    borderRadius: 14,
    backgroundColor: surface,
    flexDirection: "row" as const,
    alignItems: "center" as const,
    paddingHorizontal: 14,
    marginBottom: 4,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: isDarkMode ? 0 : 0.04,
    shadowRadius: 3,
    elevation: 1,
  });

  const fieldInput = {
    flex: 1,
    paddingVertical: 15,
    fontSize: 15,
    color: textPrimary,
  };

  const label = (field?: string) => ({
    fontSize: 13,
    fontWeight: "600" as const,
    color: textMuted,
    marginBottom: 8,
    letterSpacing: 0.3,
  });

  const renderFieldError = (field: string) =>
    errors[field] ? (
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginBottom: 14,
          marginTop: 4,
        }}
      >
        <Icon name="error-outline" size={13} color={errorColor} />
        <Text style={{ color: errorColor, fontSize: 12, marginLeft: 4 }}>
          {errors[field]}
        </Text>
      </View>
    ) : (
      <View style={{ marginBottom: 16 }} />
    );

  const sectionCard = {
    backgroundColor: surface,
    borderRadius: 18,
    padding: 20,
    marginBottom: 16,
    borderWidth: 1,
    borderColor: border,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: isDarkMode ? 0 : 0.05,
    shadowRadius: 8,
    elevation: 2,
  };

  // ── Inline date picker ─────────────────────────────────────────────────
  const DOB_MONTHS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const DOB_MONTHS_FULL = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const parsedDob = dateOfBirth ? new Date(dateOfBirth + "T00:00:00") : null;
  const dobDay = parsedDob ? parsedDob.getDate() : null;
  const dobMonth = parsedDob ? parsedDob.getMonth() : null;
  const dobYear = parsedDob ? parsedDob.getFullYear() : null;

  const getDaysInMonth = (y: number, m: number) =>
    new Date(y, m + 1, 0).getDate();
  const getFirstDayOfMonth = (y: number, m: number) =>
    new Date(y, m, 1).getDay();

  const selectDobDay = (day: number) => {
    const d = String(day).padStart(2, "0");
    const m = String(dobViewMonth + 1).padStart(2, "0");
    setDateOfBirth(`${dobViewYear}-${m}-${d}`);
    setErrors((e) => ({ ...e, dateOfBirth: "" }));
    setDobPickerOpen(false);
  };

  const renderDatePicker = () => {
    const today = new Date();
    const minYear = today.getFullYear() - 80;
    const maxYear = today.getFullYear() - 16;
    const years = Array.from(
      { length: maxYear - minYear + 1 },
      (_, i) => maxYear - i,
    );
    const daysInMonth = getDaysInMonth(dobViewYear, dobViewMonth);
    const firstDay = getFirstDayOfMonth(dobViewYear, dobViewMonth);
    const weeks: (number | null)[][] = [];
    let day = 1 - firstDay;
    while (day <= daysInMonth) {
      const week: (number | null)[] = [];
      for (let d = 0; d < 7; d++) {
        week.push(day >= 1 && day <= daysInMonth ? day : null);
        day++;
      }
      weeks.push(week);
    }

    const pickerBg = isDarkMode ? "#1E293B" : "#FFFFFF";
    const chipBg = isDarkMode ? "#334155" : "#F1F5F9";

    return (
      <View
        style={{
          borderWidth: 1.5,
          borderColor: border,
          borderRadius: 18,
          backgroundColor: pickerBg,
          marginBottom: 4,
          overflow: "hidden",
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 4 },
          shadowOpacity: isDarkMode ? 0 : 0.08,
          shadowRadius: 12,
          elevation: 4,
        }}
      >
        {/* Header: month / year selectors */}
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            padding: 14,
            borderBottomWidth: 1,
            borderBottomColor: border,
          }}
        >
          <TouchableOpacity
            onPress={() =>
              setDobPickerMode((m) => (m === "month" ? "day" : "month"))
            }
            style={{
              paddingHorizontal: 10,
              paddingVertical: 6,
              borderRadius: 10,
              backgroundColor: dobPickerMode === "month" ? accent : chipBg,
              marginRight: 6,
            }}
          >
            <Text
              style={{
                fontSize: 14,
                fontWeight: "700",
                color: dobPickerMode === "month" ? "#0F172A" : textPrimary,
              }}
            >
              {DOB_MONTHS_FULL[dobViewMonth]}
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              setDobPickerMode((m) => (m === "year" ? "day" : "year"))
            }
            style={{
              paddingHorizontal: 10,
              paddingVertical: 6,
              borderRadius: 10,
              backgroundColor: dobPickerMode === "year" ? accent : chipBg,
            }}
          >
            <Text
              style={{
                fontSize: 14,
                fontWeight: "700",
                color: dobPickerMode === "year" ? "#0F172A" : textPrimary,
              }}
            >
              {dobViewYear}
            </Text>
          </TouchableOpacity>
          <View style={{ flex: 1 }} />
          {dobPickerMode === "day" && (
            <View style={{ flexDirection: "row", gap: 4 }}>
              <TouchableOpacity
                onPress={() => {
                  if (dobViewMonth === 0) {
                    setDobViewMonth(11);
                    setDobViewYear((y) => y - 1);
                  } else setDobViewMonth((m) => m - 1);
                }}
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 10,
                  backgroundColor: chipBg,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="chevron-left" size={20} color={textPrimary} />
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  if (dobViewMonth === 11) {
                    setDobViewMonth(0);
                    setDobViewYear((y) => y + 1);
                  } else setDobViewMonth((m) => m + 1);
                }}
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: 10,
                  backgroundColor: chipBg,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="chevron-right" size={20} color={textPrimary} />
              </TouchableOpacity>
            </View>
          )}
        </View>

        {/* Month picker */}
        {dobPickerMode === "month" && (
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              padding: 12,
              gap: 8,
            }}
          >
            {DOB_MONTHS.map((m, idx) => {
              const isActive = idx === dobViewMonth;
              return (
                <TouchableOpacity
                  key={idx}
                  onPress={() => {
                    setDobViewMonth(idx);
                    setDobPickerMode("day");
                  }}
                  style={{
                    width: "22%",
                    paddingVertical: 10,
                    borderRadius: 10,
                    alignItems: "center",
                    backgroundColor: isActive ? accent : chipBg,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 13,
                      fontWeight: "600",
                      color: isActive ? "#0F172A" : textPrimary,
                    }}
                  >
                    {m}
                  </Text>
                </TouchableOpacity>
              );
            })}
          </View>
        )}

        {/* Year picker */}
        {dobPickerMode === "year" && (
          <ScrollView
            style={{ maxHeight: 220 }}
            contentContainerStyle={{ padding: 12 }}
            nestedScrollEnabled
          >
            <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}>
              {years.map((y) => {
                const isActive = y === dobViewYear;
                return (
                  <TouchableOpacity
                    key={y}
                    onPress={() => {
                      setDobViewYear(y);
                      setDobPickerMode("day");
                    }}
                    style={{
                      width: "22%",
                      paddingVertical: 10,
                      borderRadius: 10,
                      alignItems: "center",
                      backgroundColor: isActive ? accent : chipBg,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 13,
                        fontWeight: "600",
                        color: isActive ? "#0F172A" : textPrimary,
                      }}
                    >
                      {y}
                    </Text>
                  </TouchableOpacity>
                );
              })}
            </View>
          </ScrollView>
        )}

        {/* Day grid */}
        {dobPickerMode === "day" && (
          <View style={{ padding: 10 }}>
            {/* Day-of-week headers */}
            <View style={{ flexDirection: "row", marginBottom: 4 }}>
              {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d) => (
                <View
                  key={d}
                  style={{ flex: 1, alignItems: "center", paddingVertical: 4 }}
                >
                  <Text
                    style={{
                      fontSize: 11,
                      fontWeight: "700",
                      color: textMuted,
                    }}
                  >
                    {d}
                  </Text>
                </View>
              ))}
            </View>
            {weeks.map((week, wi) => (
              <View key={wi} style={{ flexDirection: "row" }}>
                {week.map((d, di) => {
                  const isSelected =
                    d !== null &&
                    d === dobDay &&
                    dobViewMonth === dobMonth &&
                    dobViewYear === dobYear;
                  const isToday =
                    d !== null &&
                    new Date(dobViewYear, dobViewMonth, d).toDateString() ===
                      today.toDateString();
                  return (
                    <TouchableOpacity
                      key={di}
                      onPress={() => d !== null && selectDobDay(d)}
                      disabled={d === null}
                      style={{
                        flex: 1,
                        aspectRatio: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        margin: 1,
                        borderRadius: 8,
                        backgroundColor: isSelected
                          ? accent
                          : isToday
                          ? accentSoft
                          : "transparent",
                      }}
                    >
                      {d !== null && (
                        <Text
                          style={{
                            fontSize: 14,
                            fontWeight: isSelected ? "700" : "400",
                            color: isSelected
                              ? "#0F172A"
                              : isToday
                              ? accent
                              : textPrimary,
                          }}
                        >
                          {d}
                        </Text>
                      )}
                    </TouchableOpacity>
                  );
                })}
              </View>
            ))}
          </View>
        )}
      </View>
    );
  };

  // ── Step 1: Basic Info ────────────────────────────────────────────────────
  const renderStep1 = () => (
    <View>
      {/* Hero */}
      <View
        style={{ alignItems: "center", paddingVertical: 24, marginBottom: 8 }}
      >
        <View
          style={{
            width: 64,
            height: 64,
            borderRadius: 20,
            backgroundColor: accentSoft,
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 16,
          }}
        >
          <Icon name="person" size={30} color={accent} />
        </View>
        <Text
          style={{
            fontSize: 24,
            fontWeight: "700",
            color: textPrimary,
            textAlign: "center",
            marginBottom: 6,
          }}
        >
          A bit about you
        </Text>
        <Text
          style={{
            fontSize: 14,
            color: textMuted,
            textAlign: "center",
            lineHeight: 21,
            maxWidth: 320,
          }}
        >
          These details help employers reach you directly.
        </Text>
      </View>

      {/* Card */}
      <View style={sectionCard}>
        {/* Date of Birth */}
        <View
          ref={(r) => {
            fieldViewRefs.current["dateOfBirth"] = r;
          }}
        >
          <Text style={label("dateOfBirth")}>
            DATE OF BIRTH <Text style={{ color: errorColor }}>*</Text>
          </Text>
          <View style={fieldContainer("dateOfBirth")}>
            <Icon
              name="cake"
              size={18}
              color={errors.dateOfBirth ? errorColor : textMuted}
              style={{ marginRight: 10 }}
            />
            <TextInput
              style={fieldInput}
              placeholder="YYYY-MM-DD"
              placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
              value={dateOfBirth}
              onChangeText={(v) => {
                setDateOfBirth(v);
                setErrors((e) => ({ ...e, dateOfBirth: "" }));
                // Sync picker view to typed date when valid
                const parsed = new Date(v + "T00:00:00");
                if (!isNaN(parsed.getTime())) {
                  setDobViewYear(parsed.getFullYear());
                  setDobViewMonth(parsed.getMonth());
                }
              }}
            />
            <TouchableOpacity
              onPress={() => setDobPickerOpen((o) => !o)}
              hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
              style={{
                marginLeft: 6,
                width: 32,
                height: 32,
                borderRadius: 8,
                backgroundColor: dobPickerOpen
                  ? accent
                  : isDarkMode
                  ? "#334155"
                  : "#F1F5F9",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                name="calendar-today"
                size={16}
                color={dobPickerOpen ? "#0F172A" : textMuted}
              />
            </TouchableOpacity>
          </View>
          {dobPickerOpen && renderDatePicker()}
          {renderFieldError("dateOfBirth")}
        </View>

        {/* Phone */}
        <View
          ref={(r) => {
            fieldViewRefs.current["phoneNumber"] = r;
          }}
        >
          <Text style={label("phoneNumber")}>
            PHONE NUMBER <Text style={{ color: errorColor }}>*</Text>
          </Text>
          <View style={fieldContainer("phoneNumber")}>
            <Icon
              name="phone"
              size={18}
              color={errors.phoneNumber ? errorColor : textMuted}
              style={{ marginRight: 10 }}
            />
            <TextInput
              style={fieldInput}
              placeholder="+251 91 234 5678"
              placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
              value={phoneNumber}
              onChangeText={(v) => {
                setPhoneNumber(v);
                setErrors((e) => ({ ...e, phoneNumber: "" }));
              }}
              keyboardType="phone-pad"
            />
          </View>
          {renderFieldError("phoneNumber")}
        </View>

        {/* Profile Image */}
        <Text style={label("_")}>PROFILE IMAGE</Text>
        <TouchableOpacity
          onPress={async () => {
            const result = await ImagePicker.launchImageLibraryAsync({
              mediaTypes: ImagePicker.MediaTypeOptions.Images,
              allowsEditing: true,
              aspect: [1, 1],
              quality: 0.8,
            });
            if (!result.canceled) setProfileImage(result.assets[0].uri);
          }}
          style={{
            borderWidth: 1.5,
            borderColor: border,
            borderRadius: 14,
            backgroundColor: surface,
            padding: 14,
            marginBottom: 16,
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {profileImage ? (
            <Image
              source={{ uri: profileImage }}
              style={{
                width: 60,
                height: 60,
                borderRadius: 30,
                marginRight: 12,
              }}
            />
          ) : (
            <View
              style={{
                width: 60,
                height: 60,
                borderRadius: 30,
                marginRight: 12,
                backgroundColor: isDarkMode ? "#334155" : "#F1F5F9",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon name="person" size={28} color={textMuted} />
            </View>
          )}
          <View style={{ flex: 1 }}>
            <Text
              style={{ fontSize: 14, fontWeight: "600", color: textPrimary }}
            >
              {profileImage ? "Change profile image" : "Upload profile image"}
            </Text>
            <Text style={{ fontSize: 12, color: textMuted, marginTop: 2 }}>
              Optional • Square format recommended
            </Text>
          </View>
          <Icon name="photo-camera" size={20} color={textMuted} />
        </TouchableOpacity>

        {/* Banner Image */}
        <Text style={label("_")}>BANNER IMAGE</Text>
        <TouchableOpacity
          onPress={async () => {
            const result = await ImagePicker.launchImageLibraryAsync({
              mediaTypes: ImagePicker.MediaTypeOptions.Images,
              allowsEditing: true,
              aspect: [16, 9],
              quality: 0.8,
            });
            if (!result.canceled) setBannerImage(result.assets[0].uri);
          }}
          style={{
            borderWidth: 1.5,
            borderColor: border,
            borderRadius: 14,
            backgroundColor: surface,
            overflow: "hidden",
            marginBottom: 16,
          }}
        >
          {bannerImage ? (
            <Image
              source={{ uri: bannerImage }}
              style={{ width: "100%", height: 120 }}
              resizeMode="cover"
            />
          ) : (
            <View
              style={{
                width: "100%",
                height: 120,
                backgroundColor: isDarkMode ? "#334155" : "#F1F5F9",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon name="landscape" size={40} color={textMuted} />
              <Text style={{ fontSize: 13, color: textMuted, marginTop: 8 }}>
                Upload banner image
              </Text>
              <Text style={{ fontSize: 11, color: textMuted, marginTop: 2 }}>
                Optional • 16:9 format
              </Text>
            </View>
          )}
        </TouchableOpacity>
      </View>

      {/* Tip */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "flex-start",
          padding: 14,
          backgroundColor: accentSoft,
          borderRadius: 14,
          borderWidth: 1,
          borderColor: isDarkMode ? "#3D2E07" : "#FDE68A",
        }}
      >
        <Icon
          name="lightbulb-outline"
          size={16}
          color={accent}
          style={{ marginTop: 1 }}
        />
        <Text
          style={{
            fontSize: 13,
            color: isDarkMode ? "#FCD34D" : "#92400E",
            marginLeft: 8,
            flex: 1,
            lineHeight: 19,
          }}
        >
          Your phone number is only shared with employers you apply to.
        </Text>
      </View>
    </View>
  );

  // ── Step 2: Portfolio ─────────────────────────────────────────────────────
  const renderStep2 = () => (
    <View>
      {/* Hero */}
      <View
        style={{ alignItems: "center", paddingVertical: 24, marginBottom: 8 }}
      >
        <View
          style={{
            width: 64,
            height: 64,
            borderRadius: 20,
            backgroundColor: isDarkMode ? "#1E1B4B" : "#EEF2FF",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 16,
          }}
        >
          <Icon name="work" size={30} color="#6366F1" />
        </View>
        <Text
          style={{
            fontSize: 24,
            fontWeight: "700",
            color: textPrimary,
            textAlign: "center",
            marginBottom: 6,
          }}
        >
          Your experience
        </Text>
        <Text
          style={{
            fontSize: 14,
            color: textMuted,
            textAlign: "center",
            lineHeight: 21,
            maxWidth: 320,
          }}
        >
          Showcase your background so employers can find the right fit.
        </Text>
      </View>

      {/* Card – Professional */}
      <View style={sectionCard}>
        <Text
          style={{
            fontSize: 12,
            fontWeight: "700",
            color: textMuted,
            letterSpacing: 1,
            marginBottom: 16,
            textTransform: "uppercase",
          }}
        >
          Professional
        </Text>

        <View
          ref={(r) => {
            fieldViewRefs.current["jobTitle"] = r;
          }}
        >
          <Text style={label("jobTitle")}>
            CURRENT / DESIRED JOB TITLE{" "}
            <Text style={{ color: errorColor }}>*</Text>
          </Text>
          <View style={fieldContainer("jobTitle")}>
            <Icon
              name="badge"
              size={18}
              color={errors.jobTitle ? errorColor : textMuted}
              style={{ marginRight: 10 }}
            />
            <TextInput
              style={fieldInput}
              placeholder="e.g. Software Engineer"
              placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
              value={jobTitle}
              onChangeText={(v) => {
                setJobTitle(v);
                setErrors((e) => ({ ...e, jobTitle: "" }));
              }}
            />
          </View>
          {renderFieldError("jobTitle")}
        </View>
        <View
          ref={(r) => {
            fieldViewRefs.current["yearsOfExperience"] = r;
          }}
        >
          <Text style={label("yearsOfExperience")}>
            YEARS OF EXPERIENCE <Text style={{ color: errorColor }}>*</Text>
          </Text>
          <View style={fieldContainer("yearsOfExperience")}>
            <Icon
              name="trending-up"
              size={18}
              color={errors.yearsOfExperience ? errorColor : textMuted}
              style={{ marginRight: 10 }}
            />
            <TextInput
              style={fieldInput}
              placeholder="e.g. 3"
              placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
              value={yearsOfExperience}
              onChangeText={(v) => {
                setYearsOfExperience(v);
                setErrors((e) => ({ ...e, yearsOfExperience: "" }));
              }}
              keyboardType="numeric"
            />
          </View>
          {renderFieldError("yearsOfExperience")}
        </View>
      </View>

      {/* Card – Skills */}
      <View
        ref={(r) => {
          fieldViewRefs.current["skillCategories"] = r;
        }}
        style={sectionCard}
      >
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 14,
          }}
        >
          <View>
            <Text
              style={{ fontSize: 15, fontWeight: "700", color: textPrimary }}
            >
              Skills <Text style={{ color: errorColor }}>*</Text>
            </Text>
            <Text style={{ fontSize: 12, color: textMuted, marginTop: 2 }}>
              Select the categories that match your skills
            </Text>
          </View>
          {selectedSkillCategories.length > 0 && (
            <View
              style={{
                paddingHorizontal: 10,
                paddingVertical: 4,
                borderRadius: 20,
                backgroundColor: isDarkMode ? "#1E1B4B" : "#EEF2FF",
              }}
            >
              <Text
                style={{ fontSize: 12, color: "#6366F1", fontWeight: "700" }}
              >
                {selectedSkillCategories.length} chosen
              </Text>
            </View>
          )}
        </View>
        {errors.skillCategories ? (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <Icon name="error-outline" size={13} color={errorColor} />
            <Text style={{ color: errorColor, fontSize: 12, marginLeft: 4 }}>
              {errors.skillCategories}
            </Text>
          </View>
        ) : null}

        {loadingCategories ? (
          <View style={{ alignItems: "center", paddingVertical: 24 }}>
            <ActivityIndicator size="small" color={accent} />
            <Text style={{ color: textMuted, marginTop: 10, fontSize: 13 }}>
              Loading categories…
            </Text>
          </View>
        ) : (
          <View style={{ gap: 8, marginBottom: 20 }}>
            {categories
              .filter((c) => c.level === 0)
              .map((category) => {
                const subs = getSubcategories(category.path);
                const isExpanded = expandedSkillCategories.has(category.path);
                const isSelected = selectedSkillCategories.includes(
                  category.path,
                );
                return (
                  <View
                    key={category.id}
                    style={{
                      borderRadius: 14,
                      overflow: "hidden",
                      borderWidth: 1.5,
                      borderColor: isSelected ? "#6366F1" : border,
                      backgroundColor: isSelected
                        ? isDarkMode
                          ? "#1E1B4B"
                          : "#EEF2FF"
                        : isDarkMode
                        ? "#1E293B"
                        : "#FAFAFA",
                    }}
                  >
                    <TouchableOpacity
                      style={{
                        flexDirection: "row",
                        alignItems: "center",
                        padding: 14,
                      }}
                      onPress={() => {
                        toggleSkillCategory(category.path);
                        setErrors((e) => ({ ...e, skillCategories: "" }));
                      }}
                      activeOpacity={0.7}
                    >
                      <View
                        style={{
                          width: 38,
                          height: 38,
                          borderRadius: 12,
                          backgroundColor: category.color
                            ? category.color + "20"
                            : isDarkMode
                            ? "#1E1B4B"
                            : "#EEF2FF",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: 12,
                        }}
                      >
                        <Icon
                          name={
                            category.icon?.startsWith("http")
                              ? "category"
                              : category.icon || "category"
                          }
                          size={18}
                          color={category.color || "#6366F1"}
                        />
                      </View>
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontSize: 14,
                            fontWeight: "600",
                            color: textPrimary,
                          }}
                        >
                          {category.name}
                        </Text>
                        {category.description ? (
                          <Text
                            style={{
                              fontSize: 12,
                              color: textMuted,
                              marginTop: 2,
                            }}
                            numberOfLines={1}
                          >
                            {category.description}
                          </Text>
                        ) : null}
                      </View>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          gap: 6,
                        }}
                      >
                        {isSelected ? (
                          <View
                            style={{
                              width: 22,
                              height: 22,
                              borderRadius: 11,
                              backgroundColor: "#6366F1",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Icon name="check" size={13} color="#FFFFFF" />
                          </View>
                        ) : (
                          <View
                            style={{
                              width: 22,
                              height: 22,
                              borderRadius: 11,
                              borderWidth: 1.5,
                              borderColor: border,
                            }}
                          />
                        )}
                        {subs.length > 0 && (
                          <Icon
                            name={isExpanded ? "expand-less" : "expand-more"}
                            size={20}
                            color={textMuted}
                          />
                        )}
                      </View>
                    </TouchableOpacity>
                    {isExpanded && subs.length > 0 && (
                      <View
                        style={{
                          paddingHorizontal: 14,
                          paddingBottom: 14,
                          borderTopWidth: 1,
                          borderTopColor: border,
                          flexDirection: "row",
                          flexWrap: "wrap",
                          gap: 8,
                          paddingTop: 12,
                        }}
                      >
                        {subs.map((sub) => {
                          const subSel = selectedSkillSubcategories.includes(
                            sub.path,
                          );
                          return (
                            <TouchableOpacity
                              key={sub.id}
                              onPress={() => toggleSkillSubcategory(sub.path)}
                              style={{
                                paddingHorizontal: 12,
                                paddingVertical: 7,
                                borderRadius: 20,
                                backgroundColor: subSel
                                  ? "#6366F1"
                                  : isDarkMode
                                  ? "#334155"
                                  : "#F1F5F9",
                                borderWidth: 1,
                                borderColor: subSel ? "#6366F1" : "transparent",
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: 12,
                                  fontWeight: "600",
                                  color: subSel ? "#FFFFFF" : textMuted,
                                }}
                              >
                                {sub.name}
                              </Text>
                            </TouchableOpacity>
                          );
                        })}
                      </View>
                    )}
                  </View>
                );
              })}
          </View>
        )}

        {/* Skill Tags */}
        <View
          ref={(r) => {
            fieldViewRefs.current["skillTags"] = r;
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 12,
            }}
          >
            <View>
              <Text
                style={{ fontSize: 14, fontWeight: "700", color: textPrimary }}
              >
                Skill Tags <Text style={{ color: errorColor }}>*</Text>
              </Text>
              <Text style={{ fontSize: 12, color: textMuted, marginTop: 2 }}>
                Select at least one
              </Text>
            </View>
            {selectedSkillTags.length > 0 && (
              <View
                style={{
                  paddingHorizontal: 10,
                  paddingVertical: 4,
                  borderRadius: 20,
                  backgroundColor: isDarkMode ? "#1E1B4B" : "#EEF2FF",
                }}
              >
                <Text
                  style={{ fontSize: 12, color: "#6366F1", fontWeight: "700" }}
                >
                  {selectedSkillTags.length} selected
                </Text>
              </View>
            )}
          </View>
          {errors.skillTags ? (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <Icon name="error-outline" size={13} color={errorColor} />
              <Text style={{ color: errorColor, fontSize: 12, marginLeft: 4 }}>
                {errors.skillTags}
              </Text>
            </View>
          ) : null}
          {/* Search bar */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              borderWidth: 1.5,
              borderColor: border,
              borderRadius: 12,
              paddingHorizontal: 12,
              marginBottom: 14,
              backgroundColor: isDarkMode ? "#1E293B" : "#F8FAFC",
            }}
          >
            <Icon
              name="search"
              size={16}
              color={textMuted}
              style={{ marginRight: 8 }}
            />
            <TextInput
              style={{
                flex: 1,
                paddingVertical: 10,
                fontSize: 14,
                color: textPrimary,
              }}
              placeholder="Search skill tags…"
              placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
              value={skillTagSearch}
              onChangeText={setSkillTagSearch}
            />
            {skillTagSearch.length > 0 && (
              <TouchableOpacity
                onPress={() => setSkillTagSearch("")}
                hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
              >
                <Icon name="close" size={16} color={textMuted} />
              </TouchableOpacity>
            )}
          </View>
          {selectedSkillCategories.length === 0 ? (
            <Text
              style={{
                fontSize: 13,
                color: textMuted,
                textAlign: "center",
                paddingVertical: 12,
              }}
            >
              Select a skill category above to see relevant tags
            </Text>
          ) : (
            (() => {
              const groups: { cat: any; filtered: string[] }[] = [];
              selectedSkillCategories.forEach((catPath) => {
                const cat = categories.find((c: any) => c.path === catPath);
                if (!cat) return;
                const tagsSet = new Set<string>();
                if (cat.tags) cat.tags.forEach((t: string) => tagsSet.add(t));
                getSubcategories(catPath).forEach((sub: any) => {
                  if (sub.tags) sub.tags.forEach((t: string) => tagsSet.add(t));
                });
                const allTags = Array.from(tagsSet);
                const filtered = skillTagSearch
                  ? allTags.filter((t) =>
                      t.toLowerCase().includes(skillTagSearch.toLowerCase()),
                    )
                  : allTags;
                groups.push({ cat, filtered });
              });
              const hasAnyTags = groups.some((g) => g.filtered.length > 0);
              if (!hasAnyTags) {
                return (
                  <Text
                    style={{
                      fontSize: 13,
                      color: textMuted,
                      textAlign: "center",
                      paddingVertical: 12,
                    }}
                  >
                    {skillTagSearch
                      ? `No tags match "${skillTagSearch}"`
                      : "No skill tags available for selected categories"}
                  </Text>
                );
              }
              return (
                <>
                  {groups.map(({ cat, filtered }) => {
                    if (filtered.length === 0) return null;
                    return (
                      <View key={cat.path} style={{ marginBottom: 14 }}>
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 6,
                            marginBottom: 8,
                          }}
                        >
                          <Icon
                            name={
                              cat.icon?.startsWith("http")
                                ? "category"
                                : cat.icon || "category"
                            }
                            size={13}
                            color={cat.color || "#6366F1"}
                          />
                          <Text
                            style={{
                              fontSize: 11,
                              fontWeight: "700",
                              color: cat.color || "#6366F1",
                              textTransform: "uppercase",
                              letterSpacing: 0.5,
                            }}
                          >
                            {cat.name}
                          </Text>
                        </View>
                        <View
                          style={{
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 8,
                          }}
                        >
                          {filtered.map((tag) => {
                            const isTagSelected =
                              selectedSkillTags.includes(tag);
                            return (
                              <TouchableOpacity
                                key={tag}
                                onPress={() => {
                                  toggleSkillTag(tag);
                                  setErrors((e) => ({ ...e, skillTags: "" }));
                                }}
                                activeOpacity={0.7}
                                style={{
                                  paddingHorizontal: 14,
                                  paddingVertical: 8,
                                  borderRadius: 20,
                                  backgroundColor: isTagSelected
                                    ? "#6366F1"
                                    : isDarkMode
                                    ? "#1E293B"
                                    : "#F1F5F9",
                                  borderWidth: 1.5,
                                  borderColor: isTagSelected
                                    ? "#6366F1"
                                    : border,
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 13,
                                    fontWeight: "600",
                                    color: isTagSelected
                                      ? "#FFFFFF"
                                      : textMuted,
                                  }}
                                >
                                  {tag}
                                </Text>
                              </TouchableOpacity>
                            );
                          })}
                        </View>
                      </View>
                    );
                  })}
                </>
              );
            })()
          )}
        </View>
      </View>

      {/* Card – Education */}
      <View
        ref={(r) => {
          fieldViewRefs.current["educationDegree"] = r;
        }}
        style={sectionCard}
      >
        <Text
          style={{
            fontSize: 12,
            fontWeight: "700",
            color: textMuted,
            letterSpacing: 1,
            marginBottom: 16,
            textTransform: "uppercase",
          }}
        >
          Education
        </Text>

        <Text style={label("educationDegree")}>
          DEGREE / QUALIFICATION <Text style={{ color: errorColor }}>*</Text>
        </Text>
        <View style={fieldContainer("educationDegree")}>
          <Icon
            name="school"
            size={18}
            color={errors.educationDegree ? errorColor : textMuted}
            style={{ marginRight: 10 }}
          />
          <TextInput
            style={fieldInput}
            placeholder="e.g. BSc Computer Science"
            placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
            value={educationDegree}
            onChangeText={(v) => {
              setEducationDegree(v);
              setErrors((e) => ({ ...e, educationDegree: "" }));
            }}
          />
        </View>
        {renderFieldError("educationDegree")}

        <Text style={label("_")}>INSTITUTION</Text>
        <View style={fieldContainer("_")}>
          <Icon
            name="account-balance"
            size={18}
            color={textMuted}
            style={{ marginRight: 10 }}
          />
          <TextInput
            style={fieldInput}
            placeholder="e.g. Addis Ababa University"
            placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
            value={educationInstitution}
            onChangeText={setEducationInstitution}
          />
        </View>
        <View style={{ marginBottom: 16 }} />

        <Text style={label("_")}>GRADUATION YEAR</Text>
        <View style={fieldContainer("_")}>
          <Icon
            name="event"
            size={18}
            color={textMuted}
            style={{ marginRight: 10 }}
          />
          <TextInput
            style={fieldInput}
            placeholder="e.g. 2021"
            placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
            value={educationYear}
            onChangeText={setEducationYear}
            keyboardType="numeric"
          />
        </View>
      </View>
    </View>
  );

  // ── Step 3: Social Links ──────────────────────────────────────────────────
  const renderStep3 = () => (
    <View>
      {/* Hero */}
      <View
        style={{ alignItems: "center", paddingVertical: 24, marginBottom: 8 }}
      >
        <View
          style={{
            width: 64,
            height: 64,
            borderRadius: 20,
            backgroundColor: isDarkMode ? "#1E1B4B" : "#EEF2FF",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 16,
          }}
        >
          <Icon name="share" size={30} color="#8B5CF6" />
        </View>
        <Text
          style={{
            fontSize: 24,
            fontWeight: "700",
            color: textPrimary,
            textAlign: "center",
            marginBottom: 6,
          }}
        >
          Connect your profiles
        </Text>
        <Text
          style={{
            fontSize: 14,
            color: textMuted,
            textAlign: "center",
            lineHeight: 21,
            maxWidth: 320,
          }}
        >
          Add your social links so employers can learn more about you.
        </Text>
      </View>

      {/* Social Links Card */}
      <View style={sectionCard}>
        <Text
          style={{
            fontSize: 12,
            fontWeight: "700",
            color: textMuted,
            letterSpacing: 1,
            marginBottom: 16,
            textTransform: "uppercase",
          }}
        >
          Social & Professional Links
        </Text>

        {/* LinkedIn */}
        <Text style={label("_")}>LINKEDIN</Text>
        <View style={fieldContainer("_")}>
          <Icon
            name="business"
            size={18}
            color="#0A66C2"
            style={{ marginRight: 10 }}
          />
          <TextInput
            style={fieldInput}
            placeholder="https://linkedin.com/in/yourprofile"
            placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
            value={linkedinUrl}
            onChangeText={setLinkedinUrl}
            keyboardType="url"
            autoCapitalize="none"
          />
        </View>
        <View style={{ marginBottom: 16 }} />

        {/* GitHub */}
        <Text style={label("_")}>GITHUB</Text>
        <View style={fieldContainer("_")}>
          <Icon
            name="code"
            size={18}
            color="#6e5494"
            style={{ marginRight: 10 }}
          />
          <TextInput
            style={fieldInput}
            placeholder="https://github.com/yourusername"
            placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
            value={githubUrl}
            onChangeText={setGithubUrl}
            keyboardType="url"
            autoCapitalize="none"
          />
        </View>
        <View style={{ marginBottom: 16 }} />

        {/* Portfolio */}
        <Text style={label("_")}>PORTFOLIO / WEBSITE</Text>
        <View style={fieldContainer("_")}>
          <Icon
            name="language"
            size={18}
            color="#8B5CF6"
            style={{ marginRight: 10 }}
          />
          <TextInput
            style={fieldInput}
            placeholder="https://yourportfolio.com"
            placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
            value={portfolioUrl}
            onChangeText={setPortfolioUrl}
            keyboardType="url"
            autoCapitalize="none"
          />
        </View>
        <View style={{ marginBottom: 16 }} />

        {/* Twitter */}
        <Text style={label("_")}>TWITTER / X</Text>
        <View style={fieldContainer("_")}>
          <Icon
            name="tag"
            size={18}
            color="#1DA1F2"
            style={{ marginRight: 10 }}
          />
          <TextInput
            style={fieldInput}
            placeholder="https://twitter.com/yourusername"
            placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
            value={twitterUrl}
            onChangeText={setTwitterUrl}
            keyboardType="url"
            autoCapitalize="none"
          />
        </View>
        <View style={{ marginBottom: 16 }} />

        {/* Instagram */}
        <Text style={label("_")}>INSTAGRAM</Text>
        <View style={fieldContainer("_")}>
          <Icon
            name="photo-camera"
            size={18}
            color="#E1306C"
            style={{ marginRight: 10 }}
          />
          <TextInput
            style={fieldInput}
            placeholder="https://instagram.com/yourusername"
            placeholderTextColor={isDarkMode ? "#475569" : "#CBD5E1"}
            value={instagramUrl}
            onChangeText={setInstagramUrl}
            keyboardType="url"
            autoCapitalize="none"
          />
        </View>
      </View>

      {/* Tip */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "flex-start",
          padding: 14,
          backgroundColor: isDarkMode ? "#1E1B4B" : "#EEF2FF",
          borderRadius: 14,
          borderWidth: 1,
          borderColor: isDarkMode ? "#312E81" : "#C7D2FE",
        }}
      >
        <Icon
          name="info-outline"
          size={16}
          color="#8B5CF6"
          style={{ marginTop: 1 }}
        />
        <Text
          style={{
            fontSize: 13,
            color: isDarkMode ? "#A78BFA" : "#5B21B6",
            marginLeft: 8,
            flex: 1,
            lineHeight: 19,
          }}
        >
          All fields are optional. Add any links you want employers to see.
        </Text>
      </View>
    </View>
  );

  // ── Steps meta ────────────────────────────────────────────────────────────
  const steps = [
    {
      label: "Basic Info",
      icon: "person",
      color: accent,
      softColor: accentSoft,
    },
    {
      label: "Portfolio",
      icon: "work",
      color: "#6366F1",
      softColor: isDarkMode ? "#1E1B4B" : "#EEF2FF",
    },
    {
      label: "Social Links",
      icon: "share",
      color: "#8B5CF6",
      softColor: isDarkMode ? "#1E1B4B" : "#EEF2FF",
    },
  ];

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: bg }}>
      {/* ── Top stepper bar ── */}
      <View
        style={{
          backgroundColor: surface,
          borderBottomWidth: 1,
          borderBottomColor: border,
          paddingTop: 16,
          paddingBottom: 0,
          paddingHorizontal: isMobile ? 20 : 40,
          shadowColor: "#000",
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: isDarkMode ? 0 : 0.05,
          shadowRadius: 4,
          elevation: 2,
        }}
      >
        {/* Branding row */}
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 20,
            justifyContent: "center",
          }}
        >
          <Image
            source={require("./assets/favicon.png")}
            style={{ width: 28, height: 28, borderRadius: 8, marginRight: 8 }}
            resizeMode="contain"
          />
          <Text
            style={{
              fontSize: 16,
              fontWeight: "700",
              color: textPrimary,
              letterSpacing: -0.3,
            }}
          >
            NibJobs
          </Text>
          <View style={{ flex: 1 }} />
          <Text style={{ fontSize: 13, color: textMuted }}>
            {currentStep} / {totalSteps}
          </Text>
        </View>

        {/* Horizontal step pills */}
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          {steps.map((s, idx) => {
            const stepNo = idx + 1;
            const done = currentStep > stepNo;
            const active = currentStep === stepNo;
            return (
              <React.Fragment key={stepNo}>
                <View style={{ alignItems: "center", flex: 1 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      paddingHorizontal: active ? 14 : 10,
                      paddingVertical: 8,
                      borderRadius: 24,
                      backgroundColor: done
                        ? "#ECFDF5"
                        : active
                        ? s.softColor
                        : "transparent",
                      borderWidth: active ? 0 : 0,
                    }}
                  >
                    <View
                      style={{
                        width: 24,
                        height: 24,
                        borderRadius: 12,
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: done
                          ? "#10B981"
                          : active
                          ? s.color
                          : border,
                        marginRight: active ? 6 : 0,
                      }}
                    >
                      {done ? (
                        <Icon name="check" size={13} color="#FFFFFF" />
                      ) : (
                        <Icon
                          name={s.icon}
                          size={13}
                          color={
                            active
                              ? isDarkMode
                                ? "#0F172A"
                                : "#FFFFFF"
                              : textMuted
                          }
                        />
                      )}
                    </View>
                    {active && (
                      <Text
                        style={{
                          fontSize: 13,
                          fontWeight: "700",
                          color: s.color,
                        }}
                      >
                        {s.label}
                      </Text>
                    )}
                  </View>
                </View>
                {idx < steps.length - 1 && (
                  <View
                    style={{
                      height: 2,
                      flex: 0.4,
                      backgroundColor:
                        currentStep > idx + 1 ? "#10B981" : border,
                      borderRadius: 1,
                    }}
                  />
                )}
              </React.Fragment>
            );
          })}
        </View>

        {/* Thin progress bar */}
        <View
          style={{
            height: 3,
            backgroundColor: border,
            borderRadius: 2,
            marginHorizontal: -4,
          }}
        >
          <View
            style={{
              height: 3,
              borderRadius: 2,
              backgroundColor: steps[currentStep - 1].color,
              width: `${(currentStep / totalSteps) * 100}%`,
            }}
          />
        </View>
      </View>

      {/* ── Scrollable content ── */}
      <ScrollView
        ref={scrollRef}
        style={{ flex: 1 }}
        contentContainerStyle={{
          paddingHorizontal: isMobile ? 16 : 40,
          paddingTop: 8,
          paddingBottom: 130,
          maxWidth: 680,
          width: "100%",
          alignSelf: "center",
        }}
        keyboardShouldPersistTaps="handled"
        showsVerticalScrollIndicator={false}
        onScroll={(e) => {
          scrollOffset.current = e.nativeEvent.contentOffset.y;
        }}
        scrollEventThrottle={16}
      >
        {currentStep === 1 && renderStep1()}
        {currentStep === 2 && renderStep2()}
        {currentStep === 3 && renderStep3()}
      </ScrollView>

      {/* ── Footer action bar ── */}
      <View
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: surface,
          borderTopWidth: 1,
          borderTopColor: border,
          paddingHorizontal: isMobile ? 16 : 40,
          paddingVertical: 14,
          paddingBottom: 24,
          shadowColor: "#000",
          shadowOffset: { width: 0, height: -2 },
          shadowOpacity: isDarkMode ? 0 : 0.06,
          shadowRadius: 8,
          elevation: 8,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            gap: 10,
            maxWidth: 640,
            alignSelf: "center",
            width: "100%",
          }}
        >
          {currentStep > 1 && (
            <TouchableOpacity
              onPress={handleBack}
              activeOpacity={0.7}
              style={{
                flex: 1,
                paddingVertical: 15,
                borderRadius: 14,
                borderWidth: 1.5,
                borderColor: border,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
              }}
            >
              <Icon name="arrow-back" size={17} color={textPrimary} />
              <Text
                style={{ fontSize: 15, fontWeight: "600", color: textPrimary }}
              >
                Back
              </Text>
            </TouchableOpacity>
          )}

          {currentStep < totalSteps ? (
            <TouchableOpacity
              onPress={handleNext}
              activeOpacity={0.85}
              style={{
                flex: 2,
                paddingVertical: 15,
                borderRadius: 14,
                backgroundColor: steps[currentStep - 1].color,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                shadowColor: steps[currentStep - 1].color,
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: 0.3,
                shadowRadius: 8,
                elevation: 4,
              }}
            >
              <Text
                style={{
                  fontSize: 15,
                  fontWeight: "700",
                  color: currentStep === 1 ? "#0F172A" : "#FFFFFF",
                }}
              >
                Continue
              </Text>
              <Icon
                name="arrow-forward"
                size={17}
                color={currentStep === 1 ? "#0F172A" : "#FFFFFF"}
              />
            </TouchableOpacity>
          ) : (
            <TouchableOpacity
              onPress={handleFinish}
              disabled={saving}
              activeOpacity={0.85}
              style={{
                flex: 2,
                paddingVertical: 15,
                borderRadius: 14,
                backgroundColor: saving ? textMuted : "#10B981",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                shadowColor: "#10B981",
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: saving ? 0 : 0.3,
                shadowRadius: 8,
                elevation: saving ? 0 : 4,
              }}
            >
              {saving ? (
                <ActivityIndicator size="small" color="#FFFFFF" />
              ) : (
                <>
                  <Icon name="send" size={18} color="#FFFFFF" />
                  <Text
                    style={{
                      fontSize: 15,
                      fontWeight: "700",
                      color: "#FFFFFF",
                    }}
                  >
                    Launch My Profile
                  </Text>
                </>
              )}
            </TouchableOpacity>
          )}
        </View>
      </View>
    </SafeAreaView>
  );
}

// 404 Not Found Screen
function ThankYouScreen({ navigation, isDarkMode }: any) {
  const colors = isDarkMode ? darkColors : lightColors;
  const [closeFailed, setCloseFailed] = useState(false);

  const handleClose = () => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      // Try to close the window
      window.close();

      // If we're still here after 100ms, window.close() didn't work
      setTimeout(() => {
        setCloseFailed(true);
      }, 100);
    }
  };

  return (
    <SafeAreaView
      style={[
        styles.container,
        { backgroundColor: isDarkMode ? "#0F1114" : "#F5F7FA" },
      ]}
    >
      <View
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
          padding: 24,
        }}
      >
        {/* Success Icon */}
        <View
          style={{
            width: 120,
            height: 120,
            borderRadius: 60,
            backgroundColor: colors.success,
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 32,
            shadowColor: colors.success,
            shadowOffset: { width: 0, height: 8 },
            shadowOpacity: 0.3,
            shadowRadius: 16,
            elevation: 8,
          }}
        >
          <Icon name="check-circle" size={72} color={colors.white} />
        </View>

        {/* Thank You Message */}
        <Text
          style={{
            fontSize: 32,
            fontWeight: "800",
            fontFamily: fonts.bold,
            color: isDarkMode ? colors.white : colors.deepNavy,
            textAlign: "center",
            marginBottom: 16,
          }}
        >
          Payment Processing
        </Text>

        <Text
          style={{
            fontSize: 18,
            fontWeight: "600",
            fontFamily: fonts.semibold,
            color: isDarkMode ? "#9CA3AF" : "#6B7280",
            textAlign: "center",
            marginBottom: 8,
            lineHeight: 26,
          }}
        >
          Your payment is being processed
        </Text>

        <Text
          style={{
            fontSize: 16,
            fontFamily: fonts.regular,
            color: isDarkMode ? "#6B7280" : "#9CA3AF",
            textAlign: "center",
            marginBottom: closeFailed ? 24 : 48,
            lineHeight: 24,
          }}
        >
          {closeFailed
            ? "Please close this tab/window manually to return to the app."
            : "You can close this window now. We'll notify you once the payment is confirmed."}
        </Text>

        {/* Action Button */}
        {!closeFailed && (
          <View style={{ width: "100%", maxWidth: 400 }}>
            <TouchableOpacity
              onPress={handleClose}
              style={{
                backgroundColor: colors.beeYellow,
                paddingVertical: 16,
                paddingHorizontal: 24,
                borderRadius: 12,
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                shadowColor: colors.beeYellow,
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: 0.3,
                shadowRadius: 8,
                elevation: 4,
              }}
            >
              <Icon name="close" size={24} color={colors.deepNavy} />
              <Text
                style={{
                  fontSize: 16,
                  fontWeight: "700",
                  fontFamily: fonts.bold,
                  color: colors.deepNavy,
                }}
              >
                Close Window
              </Text>
            </TouchableOpacity>
          </View>
        )}
      </View>
    </SafeAreaView>
  );
}

// ─── Public Profile Screen ────────────────────────────────────────────────────
// Accessible at /profile/:username — shows a read-only profile card for job
// seekers who share their NibJobs link with employers or on social media.
function PublicProfileScreen({ route, navigation, isDarkMode }: any) {
  const usernameParam: string = route?.params?.username ?? "";
  const [profile, setProfile] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));

  useEffect(() => {
    const sub = Dimensions.addEventListener("change", ({ window }) =>
      setDimensions(window),
    );
    return () => sub?.remove?.();
  }, []);

  useEffect(() => {
    if (usernameParam) {
      loadProfile(usernameParam);
    } else {
      setNotFound(true);
      setLoading(false);
    }
  }, [usernameParam]);

  const loadProfile = async (id: string) => {
    try {
      setLoading(true);
      setNotFound(false);
      // 1) Look up by username field
      const q = dbQuery(
        collection(db, "users"),
        where("username", "==", id),
        limit(1),
      );
      const snap = await getDocs(q);
      if (!snap.empty) {
        setProfile(snap.docs[0].data());
        return;
      }
      // 2) Fallback: treat param as a uid
      const userSnap = await getDoc(doc(db, "users", id));
      if (userSnap.exists()) {
        setProfile(userSnap.data());
      } else {
        setNotFound(true);
      }
    } catch {
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  };

  const isMobile = dimensions.width < 768;
  const bg = isDarkMode ? "#0F1114" : "#FFFFFF";
  const pageBg = isDarkMode ? "#0F1114" : "#F8FAFC";
  const primary = isDarkMode ? "#E2E8F0" : "#0F172A";
  const muted = isDarkMode ? "#9CA3AF" : "#64748B";
  const border = isDarkMode ? "#2C2F36" : "#E2E8F0";
  const inputBg = isDarkMode ? "#1A1D23" : "#F8FAFC";
  const accent = "#F4C430";

  const HeaderBar = ({ title }: { title: string }) => (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 16,
        paddingVertical: 12,
        backgroundColor: bg,
        borderBottomWidth: 1,
        borderBottomColor: border,
      }}
    >
      <TouchableOpacity
        onPress={() =>
          navigation.canGoBack()
            ? navigation.goBack()
            : navigation.navigate("Home")
        }
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      >
        <Icon name="arrow-back" size={22} color={primary} />
      </TouchableOpacity>
      <Text
        style={{
          flex: 1,
          fontSize: 17,
          fontFamily: fonts.bold,
          color: primary,
          marginLeft: 14,
        }}
      >
        {title}
      </Text>
      <View style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
        <Icon name="verified-user" size={14} color={accent} />
        <Text style={{ fontSize: 12, fontFamily: fonts.medium, color: accent }}>
          NibJobs
        </Text>
      </View>
    </View>
  );

  if (loading) {
    return (
      <SafeAreaView style={{ flex: 1, backgroundColor: pageBg }}>
        <HeaderBar title="Profile" />
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <ActivityIndicator size="large" color={accent} />
          <Text
            style={{
              marginTop: 12,
              fontFamily: fonts.regular,
              fontSize: 14,
              color: muted,
            }}
          >
            Loading profile…
          </Text>
        </View>
      </SafeAreaView>
    );
  }

  if (notFound || !profile) {
    return (
      <SafeAreaView style={{ flex: 1, backgroundColor: pageBg }}>
        <HeaderBar title="Profile" />
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            padding: 32,
          }}
        >
          <View
            style={{
              width: 80,
              height: 80,
              borderRadius: 40,
              backgroundColor: isDarkMode ? "#1F2937" : "#F1F5F9",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 20,
            }}
          >
            <Icon name="person-off" size={36} color={muted} />
          </View>
          <Text
            style={{
              fontSize: 22,
              fontFamily: fonts.bold,
              color: primary,
              textAlign: "center",
              marginBottom: 8,
            }}
          >
            Profile Not Found
          </Text>
          <Text
            style={{
              fontSize: 14,
              fontFamily: fonts.regular,
              color: muted,
              textAlign: "center",
              lineHeight: 22,
              marginBottom: 28,
            }}
          >
            This profile doesn't exist or may have been removed.
          </Text>
          <TouchableOpacity
            onPress={() => navigation.navigate("Home")}
            style={{
              backgroundColor: accent,
              borderRadius: 12,
              paddingVertical: 13,
              paddingHorizontal: 32,
            }}
          >
            <Text
              style={{
                fontFamily: fonts.semiBold,
                fontSize: 15,
                color: "#1A1D23",
              }}
            >
              Go to Home
            </Text>
          </TouchableOpacity>
        </View>
      </SafeAreaView>
    );
  }

  const p = profile?.portfolio || {};
  const sl = profile?.socialLinks || {};
  const avatarInitial = (profile?.displayName ||
    profile?.username ||
    "?")[0].toUpperCase();
  const displayName = profile?.displayName || profile?.username || "User";
  const usernameTag = profile?.username ? `@${profile.username}` : "";
  const bio = profile?.bio || "";
  const bannerImg = profile?.bannerImage || "";
  const dateOfBirth = profile?.dateOfBirth || "";
  const phoneNumber = profile?.phoneNumber || "";
  const jobTitle = p.jobTitle || "";
  const company = p.company || "";
  const skills = (p.skills || "")
    .split(",")
    .map((s: string) => s.trim())
    .filter(Boolean) as string[];
  const experience = p.experience || "";
  const education = p.education || "";
  const achievements = p.achievements || "";
  const cvUrl = p.cvUrl || "";
  // Merge portfolio links + social links (social links take priority for overlapping keys)
  const linkedin = sl.linkedin || p.linkedin || "";
  const github = sl.github || p.github || "";
  const portfolioUrl = sl.portfolio || p.portfolioUrl || "";
  const twitter = sl.twitter || "";
  const instagram = sl.instagram || "";
  // Interests
  const categories = (profile?.selectedCategories || []) as string[];
  const tags = (profile?.interestedTags ||
    profile?.selectedTags ||
    []) as string[];

  const openUrl = (raw: string, fallback: string) =>
    Linking.openURL(raw.startsWith("http") ? raw : fallback + raw);

  const hasAnySocialLink =
    linkedin || github || portfolioUrl || twitter || instagram;

  const contentStyle = {
    paddingBottom: 48,
    ...(isMobile
      ? {}
      : {
          maxWidth: 720,
          alignSelf: "center" as const,
          width: "100%" as const,
        }),
  };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: pageBg }}>
      <HeaderBar title="Profile" />

      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={contentStyle}
      >
        {/* ── Banner + Hero Card ── */}
        <View
          style={{
            margin: isMobile ? 0 : 20,
            marginTop: 0,
            backgroundColor: bg,
            borderRadius: isMobile ? 0 : 16,
            borderBottomWidth: 1,
            borderColor: border,
            overflow: "hidden",
          }}
        >
          {/* Banner */}
          {bannerImg ? (
            <Image
              source={{ uri: bannerImg }}
              style={{ width: "100%", height: isMobile ? 140 : 180 }}
              resizeMode="cover"
            />
          ) : (
            <View
              style={{
                width: "100%",
                height: isMobile ? 100 : 120,
                backgroundColor: isDarkMode ? "#1A1D23" : "#FDF6E3",
              }}
            >
              <View
                style={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: 40,
                  backgroundColor: bg,
                }}
              />
            </View>
          )}

          {/* Avatar — overlaps the banner */}
          <View
            style={{ alignItems: "center", marginTop: bannerImg ? -50 : -46 }}
          >
            {profile.profilePicture ? (
              <Image
                source={{ uri: profile.profilePicture }}
                style={{
                  width: 96,
                  height: 96,
                  borderRadius: 48,
                  borderWidth: 3,
                  borderColor: bg,
                }}
              />
            ) : (
              <View
                style={{
                  width: 96,
                  height: 96,
                  borderRadius: 48,
                  backgroundColor: accent,
                  alignItems: "center",
                  justifyContent: "center",
                  borderWidth: 3,
                  borderColor: bg,
                  shadowColor: accent,
                  shadowOffset: { width: 0, height: 4 },
                  shadowOpacity: 0.3,
                  shadowRadius: 8,
                  elevation: 4,
                }}
              >
                <Text
                  style={{
                    fontSize: 36,
                    fontFamily: fonts.bold,
                    color: "#1A1D23",
                  }}
                >
                  {avatarInitial}
                </Text>
              </View>
            )}
          </View>

          {/* Identity info */}
          <View
            style={{
              paddingHorizontal: isMobile ? 24 : 32,
              paddingTop: 12,
              paddingBottom: 24,
              alignItems: "center",
            }}
          >
            <Text
              style={{
                fontSize: 24,
                fontFamily: fonts.bold,
                color: primary,
                textAlign: "center",
              }}
            >
              {displayName}
            </Text>
            {usernameTag ? (
              <Text
                style={{
                  fontSize: 13,
                  fontFamily: fonts.regular,
                  color: muted,
                  marginTop: 3,
                  textAlign: "center",
                }}
              >
                {usernameTag}
              </Text>
            ) : null}

            {/* Job title · company */}
            {jobTitle || company ? (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 5,
                  marginTop: 10,
                }}
              >
                <Icon name="work-outline" size={14} color={muted} />
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.medium,
                    color: muted,
                    textAlign: "center",
                  }}
                >
                  {jobTitle}
                  {jobTitle && company ? " · " : ""}
                  {company}
                </Text>
              </View>
            ) : null}

            {/* Bio */}
            {bio ? (
              <Text
                style={{
                  fontSize: 14,
                  fontFamily: fonts.regular,
                  color: muted,
                  marginTop: 14,
                  textAlign: "center",
                  lineHeight: 22,
                  maxWidth: 440,
                }}
              >
                {bio}
              </Text>
            ) : null}

            {/* Quick info pills (phone, DOB) */}
            {phoneNumber || dateOfBirth ? (
              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 10,
                  marginTop: 14,
                }}
              >
                {phoneNumber ? (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 4,
                      backgroundColor: inputBg,
                      borderRadius: 8,
                      borderWidth: 1,
                      borderColor: border,
                      paddingHorizontal: 10,
                      paddingVertical: 5,
                    }}
                  >
                    <Icon name="phone" size={13} color={muted} />
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.regular,
                        color: muted,
                      }}
                    >
                      {phoneNumber}
                    </Text>
                  </View>
                ) : null}
                {dateOfBirth ? (
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 4,
                      backgroundColor: inputBg,
                      borderRadius: 8,
                      borderWidth: 1,
                      borderColor: border,
                      paddingHorizontal: 10,
                      paddingVertical: 5,
                    }}
                  >
                    <Icon name="cake" size={13} color={muted} />
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.regular,
                        color: muted,
                      }}
                    >
                      {dateOfBirth}
                    </Text>
                  </View>
                ) : null}
              </View>
            ) : null}

            {/* Social link pills */}
            {hasAnySocialLink ? (
              <View
                style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 8,
                  marginTop: 16,
                }}
              >
                {linkedin ? (
                  <TouchableOpacity
                    onPress={() =>
                      openUrl(linkedin, "https://linkedin.com/in/")
                    }
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 5,
                      backgroundColor: "#0077B510",
                      borderRadius: 20,
                      borderWidth: 1,
                      borderColor: "#0077B530",
                      paddingHorizontal: 14,
                      paddingVertical: 7,
                    }}
                  >
                    <Icon name="link" size={14} color="#0077B5" />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.semiBold,
                        color: "#0077B5",
                      }}
                    >
                      LinkedIn
                    </Text>
                  </TouchableOpacity>
                ) : null}
                {github ? (
                  <TouchableOpacity
                    onPress={() => openUrl(github, "https://github.com/")}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 5,
                      backgroundColor: inputBg,
                      borderRadius: 20,
                      borderWidth: 1,
                      borderColor: border,
                      paddingHorizontal: 14,
                      paddingVertical: 7,
                    }}
                  >
                    <Icon name="code" size={14} color={primary} />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.semiBold,
                        color: primary,
                      }}
                    >
                      GitHub
                    </Text>
                  </TouchableOpacity>
                ) : null}
                {portfolioUrl ? (
                  <TouchableOpacity
                    onPress={() => openUrl(portfolioUrl, "https://")}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 5,
                      backgroundColor: "#4A90E210",
                      borderRadius: 20,
                      borderWidth: 1,
                      borderColor: "#4A90E230",
                      paddingHorizontal: 14,
                      paddingVertical: 7,
                    }}
                  >
                    <Icon name="language" size={14} color="#4A90E2" />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.semiBold,
                        color: "#4A90E2",
                      }}
                    >
                      Portfolio
                    </Text>
                  </TouchableOpacity>
                ) : null}
                {twitter ? (
                  <TouchableOpacity
                    onPress={() => openUrl(twitter, "https://x.com/")}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 5,
                      backgroundColor: inputBg,
                      borderRadius: 20,
                      borderWidth: 1,
                      borderColor: border,
                      paddingHorizontal: 14,
                      paddingVertical: 7,
                    }}
                  >
                    <Icon name="tag" size={14} color={primary} />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.semiBold,
                        color: primary,
                      }}
                    >
                      X / Twitter
                    </Text>
                  </TouchableOpacity>
                ) : null}
                {instagram ? (
                  <TouchableOpacity
                    onPress={() => openUrl(instagram, "https://instagram.com/")}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 5,
                      backgroundColor: "#E1306C10",
                      borderRadius: 20,
                      borderWidth: 1,
                      borderColor: "#E1306C30",
                      paddingHorizontal: 14,
                      paddingVertical: 7,
                    }}
                  >
                    <Icon name="camera-alt" size={14} color="#E1306C" />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.semiBold,
                        color: "#E1306C",
                      }}
                    >
                      Instagram
                    </Text>
                  </TouchableOpacity>
                ) : null}
              </View>
            ) : null}
          </View>
        </View>

        {/* ── Skills ── */}
        {skills.length > 0 ? (
          <View style={{ marginTop: 12 }}>
            <View
              style={{
                backgroundColor: bg,
                borderTopWidth: 1,
                borderBottomWidth: 1,
                borderColor: border,
                paddingHorizontal: isMobile ? 20 : 28,
                paddingTop: 16,
                paddingBottom: 18,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 6,
                  marginBottom: 12,
                }}
              >
                <Icon name="local-offer" size={15} color={accent} />
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.medium,
                    color: muted,
                    textTransform: "uppercase",
                    letterSpacing: 0.8,
                  }}
                >
                  Skills
                </Text>
              </View>
              <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}>
                {skills.map((sk, i) => (
                  <View
                    key={i}
                    style={{
                      backgroundColor: inputBg,
                      borderRadius: 8,
                      borderWidth: 1,
                      borderColor: border,
                      paddingHorizontal: 12,
                      paddingVertical: 6,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.regular,
                        color: primary,
                      }}
                    >
                      {sk}
                    </Text>
                  </View>
                ))}
              </View>
            </View>
          </View>
        ) : null}

        {/* ── Experience / Education / Achievements ── */}
        {(
          [
            { label: "Experience", value: experience, icon: "business-center" },
            { label: "Education", value: education, icon: "school" },
            {
              label: "Achievements",
              value: achievements,
              icon: "emoji-events",
            },
          ] as const
        )
          .filter((s) => s.value)
          .map((s) => (
            <View key={s.label} style={{ marginTop: 12 }}>
              <View
                style={{
                  backgroundColor: bg,
                  borderTopWidth: 1,
                  borderBottomWidth: 1,
                  borderColor: border,
                  paddingHorizontal: isMobile ? 20 : 28,
                  paddingTop: 16,
                  paddingBottom: 18,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 6,
                    marginBottom: 10,
                  }}
                >
                  <Icon name={s.icon as any} size={15} color={accent} />
                  <Text
                    style={{
                      fontSize: 11,
                      fontFamily: fonts.medium,
                      color: muted,
                      textTransform: "uppercase",
                      letterSpacing: 0.8,
                    }}
                  >
                    {s.label}
                  </Text>
                </View>
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.regular,
                    color: primary,
                    lineHeight: 22,
                  }}
                >
                  {s.value}
                </Text>
              </View>
            </View>
          ))}

        {/* ── CV / Resume Download ── */}
        {cvUrl ? (
          <View style={{ marginTop: 12 }}>
            <View
              style={{
                backgroundColor: bg,
                borderTopWidth: 1,
                borderBottomWidth: 1,
                borderColor: border,
                paddingHorizontal: isMobile ? 20 : 28,
                paddingTop: 16,
                paddingBottom: 18,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 6,
                  marginBottom: 12,
                }}
              >
                <Icon name="description" size={15} color={accent} />
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.medium,
                    color: muted,
                    textTransform: "uppercase",
                    letterSpacing: 0.8,
                  }}
                >
                  Resume / CV
                </Text>
              </View>
              <TouchableOpacity
                onPress={() => Linking.openURL(cvUrl)}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 10,
                  backgroundColor: inputBg,
                  borderRadius: 12,
                  borderWidth: 1,
                  borderColor: border,
                  paddingHorizontal: 16,
                  paddingVertical: 12,
                }}
              >
                <View
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 10,
                    backgroundColor: "#F4C43018",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon name="picture-as-pdf" size={22} color={accent} />
                </View>
                <View style={{ flex: 1 }}>
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.semiBold,
                      color: primary,
                    }}
                  >
                    View Resume
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.regular,
                      color: muted,
                      marginTop: 2,
                    }}
                  >
                    Tap to open or download
                  </Text>
                </View>
                <Icon name="open-in-new" size={18} color={muted} />
              </TouchableOpacity>
            </View>
          </View>
        ) : null}

        {/* ── Interests (categories + tags) ── */}
        {categories.length > 0 || tags.length > 0 ? (
          <View style={{ marginTop: 12 }}>
            <View
              style={{
                backgroundColor: bg,
                borderTopWidth: 1,
                borderBottomWidth: 1,
                borderColor: border,
                paddingHorizontal: isMobile ? 20 : 28,
                paddingTop: 16,
                paddingBottom: 18,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 6,
                  marginBottom: 12,
                }}
              >
                <Icon name="interests" size={15} color={accent} />
                <Text
                  style={{
                    fontSize: 11,
                    fontFamily: fonts.medium,
                    color: muted,
                    textTransform: "uppercase",
                    letterSpacing: 0.8,
                  }}
                >
                  Interests
                </Text>
              </View>
              {categories.length > 0 ? (
                <View style={{ marginBottom: tags.length > 0 ? 14 : 0 }}>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      color: muted,
                      marginBottom: 8,
                    }}
                  >
                    Categories
                  </Text>
                  <View
                    style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}
                  >
                    {categories.map((cat, i) => (
                      <View
                        key={i}
                        style={{
                          backgroundColor: accent + "14",
                          borderRadius: 8,
                          borderWidth: 1,
                          borderColor: accent + "30",
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 13,
                            fontFamily: fonts.medium,
                            color: isDarkMode ? accent : "#92400E",
                          }}
                        >
                          {cat}
                        </Text>
                      </View>
                    ))}
                  </View>
                </View>
              ) : null}
              {tags.length > 0 ? (
                <View>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.medium,
                      color: muted,
                      marginBottom: 8,
                    }}
                  >
                    Topics
                  </Text>
                  <View
                    style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}
                  >
                    {tags.map((tag, i) => (
                      <View
                        key={i}
                        style={{
                          backgroundColor: inputBg,
                          borderRadius: 8,
                          borderWidth: 1,
                          borderColor: border,
                          paddingHorizontal: 12,
                          paddingVertical: 6,
                        }}
                      >
                        <Text
                          style={{
                            fontSize: 13,
                            fontFamily: fonts.regular,
                            color: primary,
                          }}
                        >
                          {tag}
                        </Text>
                      </View>
                    ))}
                  </View>
                </View>
              ) : null}
            </View>
          </View>
        ) : null}

        {/* ── CTA ── */}
        <View style={{ marginHorizontal: isMobile ? 16 : 24, marginTop: 28 }}>
          <View
            style={{
              backgroundColor: bg,
              borderRadius: 16,
              borderWidth: 1,
              borderColor: border,
              padding: isMobile ? 20 : 28,
              alignItems: "center",
            }}
          >
            <View
              style={{
                width: 52,
                height: 52,
                borderRadius: 14,
                backgroundColor: accent,
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 14,
              }}
            >
              <Icon name="work" size={26} color="#1A1D23" />
            </View>
            <Text
              style={{
                fontSize: 18,
                fontFamily: fonts.bold,
                color: primary,
                textAlign: "center",
                marginBottom: 6,
              }}
            >
              Find Jobs on NibJobs
            </Text>
            <Text
              style={{
                fontSize: 13,
                fontFamily: fonts.regular,
                color: muted,
                textAlign: "center",
                lineHeight: 20,
                marginBottom: 18,
              }}
            >
              Discover thousands of opportunities across Ethiopia and beyond.
            </Text>
            <TouchableOpacity
              onPress={() => navigation.navigate("Jobs")}
              style={{
                backgroundColor: accent,
                borderRadius: 12,
                paddingVertical: 14,
                width: "100%",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontFamily: fonts.semiBold,
                  fontSize: 15,
                  color: "#1A1D23",
                }}
              >
                Browse Jobs
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}
// ─────────────────────────────────────────────────────────────────────────────

function NotFoundScreen({ navigation }: any) {
  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.notFoundContainer}>
        <Image
          source={require("./assets/mascot_2.jpeg")}
          style={styles.notFoundImage}
          resizeMode="contain"
        />
        <Text style={styles.notFoundTitle}>404 - Page Not Found</Text>
        <Text style={styles.notFoundSubtitle}>
          Oops! The page you're looking for doesn't exist.
        </Text>

        <View style={styles.notFoundButtonsContainer}>
          <TouchableOpacity
            style={styles.notFoundPrimaryButton}
            onPress={() => navigation.navigate("Home")}
          >
            <Icon name="home" size={20} color={lightColors.white} />
            <Text style={styles.notFoundPrimaryButtonText}>Go to Home</Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.notFoundSecondaryButton}
            onPress={() => navigation.navigate("Login")}
          >
            <Icon name="login" size={20} color={lightColors.deepNavy} />
            <Text style={styles.notFoundSecondaryButtonText}>Login</Text>
          </TouchableOpacity>
        </View>
      </View>
    </SafeAreaView>
  );
}

// Onboarding Screen - Modern Design
function OnboardingScreen({ onComplete }: { onComplete: () => void }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const scrollViewRef = useRef<ScrollView>(null);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setDimensions(window);
    });
    return () => subscription?.remove();
  }, []);

  const slides = [
    {
      id: 1,
      icon: "work",
      title: "Find Your Dream Job",
      description:
        "Browse curated opportunities from top companies across Ethiopia. Your next career move starts here.",
      color: "#F4C430",
      gradient: ["#F4C430", "#F59E0B"],
    },
    {
      id: 2,
      icon: "business",
      title: "Connect with Companies",
      description:
        "Explore verified company profiles, read authentic reviews, and discover the perfect workplace culture for you.",
      color: "#3B82F6",
      gradient: ["#3B82F6", "#1D4ED8"],
    },
    {
      id: 3,
      icon: "notifications-active",
      title: "Stay Always Updated",
      description:
        "Get instant notifications for new jobs matching your skills, experience, and career preferences.",
      color: "#10B981",
      gradient: ["#10B981", "#059669"],
    },
  ];

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      const nextSlide = currentSlide + 1;
      setCurrentSlide(nextSlide);
      scrollViewRef.current?.scrollTo({
        x: nextSlide * dimensions.width,
        animated: true,
      });
    } else {
      onComplete();
    }
  };

  const handleSkip = () => {
    onComplete();
  };

  const currentGradient = slides[currentSlide].gradient;

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: "#FAFBFC" }}>
      {/* Modern Header with Skip */}
      <View
        style={{
          paddingHorizontal: 24,
          paddingTop: 20,
          paddingBottom: 12,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottomWidth: 1,
          borderBottomColor: "#F1F5F9",
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
          <View
            style={{
              width: 32,
              height: 32,
              borderRadius: 10,
              background: `linear-gradient(135deg, ${currentGradient[0]} 0%, ${currentGradient[1]} 100%)`,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Image
              source={require("./assets/favicon.png")}
              style={{ width: 20, height: 20 }}
              resizeMode="contain"
            />
          </View>
          <Text
            style={{ fontSize: 16, fontFamily: fonts.bold, color: "#0F172A" }}
          >
            NibJobs
          </Text>
        </View>
        <TouchableOpacity
          onPress={handleSkip}
          style={{ paddingVertical: 6, paddingHorizontal: 12, borderRadius: 8 }}
        >
          <Text
            style={{
              fontSize: 14,
              fontFamily: fonts.semiBold,
              color: "#64748B",
            }}
          >
            Skip
          </Text>
        </TouchableOpacity>
      </View>

      {/* Slides with Modern Design */}
      <ScrollView
        ref={scrollViewRef}
        horizontal
        pagingEnabled
        showsHorizontalScrollIndicator={false}
        scrollEnabled={false}
        style={{ flex: 1 }}
      >
        {slides.map((slide, index) => (
          <View
            key={slide.id}
            style={{
              width: dimensions.width,
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
              paddingHorizontal: 32,
              paddingVertical: 48,
            }}
          >
            {/* Gradient Blob Background */}
            <View
              style={{
                width: 200,
                height: 200,
                borderRadius: 100,
                background: `radial-gradient(circle, ${slide.gradient[0]}20 0%, ${slide.gradient[1]}08 100%)`,
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 56,
                position: "relative",
              }}
            >
              {/* Icon Container */}
              <View
                style={{
                  width: 120,
                  height: 120,
                  borderRadius: 32,
                  background: `linear-gradient(135deg, ${slide.gradient[0]} 0%, ${slide.gradient[1]} 100%)`,
                  alignItems: "center",
                  justifyContent: "center",
                  shadowColor: slide.color,
                  shadowOffset: { width: 0, height: 12 },
                  shadowOpacity: 0.3,
                  shadowRadius: 24,
                  elevation: 12,
                }}
              >
                <Icon name={slide.icon as any} size={56} color="#FFFFFF" />
              </View>
            </View>

            <Text
              style={{
                fontSize: 32,
                fontFamily: fonts.bold,
                color: "#0F172A",
                textAlign: "center",
                marginBottom: 16,
                letterSpacing: -0.5,
                maxWidth: 320,
              }}
            >
              {slide.title}
            </Text>

            <Text
              style={{
                fontSize: 16,
                lineHeight: 26,
                color: "#64748B",
                textAlign: "center",
                fontFamily: fonts.regular,
                maxWidth: 360,
              }}
            >
              {slide.description}
            </Text>
          </View>
        ))}
      </ScrollView>

      {/* Modern Pagination Dots */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: 8,
          paddingVertical: 32,
        }}
      >
        {slides.map((slide, index) => (
          <View
            key={index}
            style={{
              width: currentSlide === index ? 32 : 8,
              height: 8,
              borderRadius: 4,
              background:
                currentSlide === index
                  ? `linear-gradient(90deg, ${slide.gradient[0]} 0%, ${slide.gradient[1]} 100%)`
                  : "#E2E8F0",
            }}
          />
        ))}
      </View>

      {/* Modern Next/Get Started Button */}
      <View style={{ paddingHorizontal: 24, paddingBottom: 40 }}>
        <TouchableOpacity
          onPress={handleNext}
          style={{
            background: `linear-gradient(135deg, ${currentGradient[0]} 0%, ${currentGradient[1]} 100%)`,
            paddingVertical: 18,
            borderRadius: 14,
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "center",
            gap: 10,
            shadowColor: currentGradient[0],
            shadowOffset: { width: 0, height: 6 },
            shadowOpacity: 0.3,
            shadowRadius: 12,
            elevation: 8,
          }}
        >
          <Text
            style={{
              fontSize: 16,
              fontFamily: fonts.bold,
              color: "#FFFFFF",
              letterSpacing: 0.2,
            }}
          >
            {currentSlide === slides.length - 1 ? "Get Started" : "Continue"}
          </Text>
          <Icon
            name={currentSlide === slides.length - 1 ? "send" : "arrow-forward"}
            size={20}
            color="#FFFFFF"
          />
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
}

// Welcome Screen - Modern Multi-step Stepper
function WelcomeScreen({ navigation, isDarkMode, setIsDarkMode }: any) {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [selectedTheme, setSelectedTheme] = useState(
    isDarkMode ? "Dark" : "Light",
  );
  const totalSteps = 3;

  const bg = "#FAFBFC";
  const cardBg = "#FFFFFF";
  const txt = "#0F172A";
  const muted = "#64748B";
  const border = "#E2E8F0";

  const languages = [
    { code: "en", name: "English", flag: "🇬🇧", desc: "International" },
    {
      code: "am",
      name: "አማርኛ",
      label: "Amharic",
      flag: "🇪🇹",
      desc: "Ethiopia",
    },
    {
      code: "ti",
      name: "ትግርኛ",
      label: "Tigrigna",
      flag: "🇪🇹",
      desc: "Ethiopia",
    },
    { code: "om", name: "Oromiffa", flag: "🇪🇹", desc: "Ethiopia" },
  ];

  const themes = [
    {
      id: "Light",
      icon: "wb-sunny",
      description: "Bright & energetic",
      color: "#F59E0B",
    },
    {
      id: "Dark",
      icon: "nightlight-round",
      description: "Easy on eyes",
      color: "#3B82F6",
    },
    {
      id: "Auto",
      icon: "brightness-auto",
      description: "Match system",
      color: "#8B5CF6",
    },
  ];

  const handleNext = () => {
    if (currentStep < totalSteps) setCurrentStep(currentStep + 1);
  };
  const handleBack = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };
  const handleSkip = () => setCurrentStep(totalSteps);

  const handleThemeSelect = async (themeName: string) => {
    setSelectedTheme(themeName);
    if (themeName === "Dark") {
      setIsDarkMode(true);
      await AsyncStorage.setItem("theme", "dark");
    } else if (themeName === "Light") {
      setIsDarkMode(false);
      await AsyncStorage.setItem("theme", "light");
    } else {
      const colorScheme = Appearance.getColorScheme();
      setIsDarkMode(colorScheme === "dark");
      await AsyncStorage.setItem("theme", "auto");
    }
  };

  // ── Step 1: Language (Modern Design) ────────────────────────────────
  const renderLanguageStep = () => (
    <ScrollView
      contentContainerStyle={{
        flexGrow: 1,
        justifyContent: "center",
        paddingHorizontal: 24,
        paddingVertical: 32,
      }}
      showsVerticalScrollIndicator={false}
    >
      <View style={{ alignItems: "center", marginBottom: 40 }}>
        <View
          style={{
            width: 80,
            height: 80,
            borderRadius: 24,
            background: "linear-gradient(135deg, #F4C430 0%, #F59E0B 100%)",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 24,
            shadowColor: "#F4C430",
            shadowOffset: { width: 0, height: 8 },
            shadowOpacity: 0.25,
            shadowRadius: 16,
            elevation: 8,
          }}
        >
          <Icon name="language" size={40} color="#FFFFFF" />
        </View>
        <Text
          style={{
            fontSize: 30,
            fontFamily: fonts.bold,
            color: txt,
            marginBottom: 12,
            textAlign: "center",
            letterSpacing: -0.5,
          }}
        >
          Choose Your Language
        </Text>
        <Text
          style={{
            fontSize: 16,
            color: muted,
            textAlign: "center",
            lineHeight: 24,
          }}
        >
          Select your preferred language for the app
        </Text>
      </View>

      <View style={{ width: "100%", maxWidth: 420, alignSelf: "center" }}>
        {languages.map((lang) => {
          const active =
            selectedLanguage === lang.name || selectedLanguage === lang.label;
          return (
            <TouchableOpacity
              key={lang.code}
              onPress={() => setSelectedLanguage(lang.name)}
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: active ? "#F4C430" : cardBg,
                padding: 20,
                borderRadius: 16,
                marginBottom: 12,
                borderWidth: 1.5,
                borderColor: active ? "#F4C430" : border,
                shadowColor: active ? "#F4C430" : "transparent",
                shadowOffset: { width: 0, height: 4 },
                shadowOpacity: active ? 0.15 : 0,
                shadowRadius: 8,
                elevation: active ? 3 : 0,
              }}
            >
              <Text style={{ fontSize: 32, marginRight: 16 }}>{lang.flag}</Text>
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 17,
                    fontFamily: fonts.semiBold,
                    color: active ? "#0F172A" : txt,
                  }}
                >
                  {lang.name}
                </Text>
                <Text
                  style={{
                    fontSize: 13,
                    color: active ? "#4B5563" : muted,
                    marginTop: 2,
                  }}
                >
                  {lang.label || lang.desc}
                </Text>
              </View>
              <View
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 14,
                  backgroundColor: active ? "#0F172A" : "transparent",
                  borderWidth: active ? 0 : 2,
                  borderColor: border,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {active && <Icon name="check" size={16} color="#F4C430" />}
              </View>
            </TouchableOpacity>
          );
        })}
      </View>
    </ScrollView>
  );

  // ── Step 2: Theme ─────────────────────────────────────────────────────────
  const renderThemeStep = () => (
    <ScrollView
      contentContainerStyle={{
        flexGrow: 1,
        justifyContent: "center",
        paddingHorizontal: 32,
        paddingVertical: 36,
      }}
      showsVerticalScrollIndicator={false}
    >
      <View style={{ alignItems: "center", marginBottom: 44 }}>
        <View
          style={{
            width: 72,
            height: 72,
            borderRadius: 22,
            backgroundColor: "rgba(244,196,48,0.15)",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 24,
          }}
        >
          <Icon name="palette" size={36} color="#F4C430" />
        </View>
        <Text
          style={{
            fontSize: 28,
            fontFamily: fonts.bold,
            color: txt,
            marginBottom: 10,
            textAlign: "center",
          }}
        >
          Choose Your Theme
        </Text>
        <Text
          style={{
            fontSize: 16,
            color: muted,
            textAlign: "center",
            lineHeight: 26,
          }}
        >
          Customize how the app looks to you
        </Text>
      </View>

      <View style={{ width: "100%", maxWidth: 400, alignSelf: "center" }}>
        {themes.map((theme) => {
          const active = selectedTheme === theme.id;
          return (
            <TouchableOpacity
              key={theme.id}
              onPress={() => handleThemeSelect(theme.id)}
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: active ? "#F4C430" : cardBg,
                padding: 22,
                borderRadius: 18,
                marginBottom: 14,
                borderWidth: 1.5,
                borderColor: active ? "#F4C430" : border,
              }}
            >
              <View
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: 16,
                  backgroundColor: active
                    ? "rgba(26,29,35,0.12)"
                    : "rgba(244,196,48,0.12)",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 18,
                }}
              >
                <Icon
                  name={theme.icon}
                  size={26}
                  color={active ? "#1A1D23" : "#F4C430"}
                />
              </View>
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 17,
                    fontFamily: fonts.semiBold,
                    color: active ? "#1A1D23" : txt,
                  }}
                >
                  {theme.id}
                </Text>
                <Text
                  style={{
                    fontSize: 14,
                    color: active ? "#4B5563" : muted,
                    marginTop: 3,
                  }}
                >
                  {theme.description}
                </Text>
              </View>
              <View
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: 13,
                  backgroundColor: active ? "#1A1D23" : "transparent",
                  borderWidth: active ? 0 : 2,
                  borderColor: border,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {active && <Icon name="check" size={14} color="#F4C430" />}
              </View>
            </TouchableOpacity>
          );
        })}
      </View>
    </ScrollView>
  );

  // ── Step 3: Welcome & Auth ─────────────────────────────────────────────────
  const renderWelcomeStep = () => (
    <ScrollView
      contentContainerStyle={{
        flexGrow: 1,
        justifyContent: "center",
        paddingHorizontal: 32,
        paddingVertical: 36,
      }}
      showsVerticalScrollIndicator={false}
    >
      {/* Logo */}
      <View style={{ alignItems: "center", marginBottom: 40 }}>
        <View
          style={{
            width: 108,
            height: 108,
            borderRadius: 32,
            backgroundColor: "#F4C430",
            alignItems: "center",
            justifyContent: "center",
            shadowColor: "#F4C430",
            shadowOffset: { width: 0, height: 10 },
            shadowOpacity: 0.4,
            shadowRadius: 20,
            elevation: 10,
            marginBottom: 28,
          }}
        >
          <Image
            source={require("./assets/favicon.png")}
            style={{ width: 68, height: 68 }}
            resizeMode="contain"
          />
        </View>
        <Text
          style={{
            fontSize: 34,
            fontFamily: fonts.bold,
            color: txt,
            marginBottom: 12,
            textAlign: "center",
            letterSpacing: -0.5,
          }}
        >
          Welcome to NibJobs
        </Text>
        <Text
          style={{
            fontSize: 17,
            color: muted,
            textAlign: "center",
            lineHeight: 28,
            maxWidth: 300,
          }}
        >
          Your journey to the perfect career starts here
        </Text>
      </View>

      {/* Value Props */}
      <View
        style={{
          marginBottom: 40,
          gap: 18,
          width: "100%",
          maxWidth: 380,
          alignSelf: "center",
        }}
      >
        {[
          { icon: "work", label: "Thousands of curated job listings" },
          {
            icon: "notifications-active",
            label: "Instant alerts for your dream role",
          },
          { icon: "business", label: "Top Ethiopian companies hiring now" },
        ].map((item, i) => (
          <View
            key={i}
            style={{ flexDirection: "row", alignItems: "center", gap: 18 }}
          >
            <View
              style={{
                width: 50,
                height: 50,
                borderRadius: 16,
                backgroundColor: "rgba(244,196,48,0.12)",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon name={item.icon} size={24} color="#F4C430" />
            </View>
            <Text
              style={{
                flex: 1,
                fontSize: 16,
                color: isDarkMode ? "#D1D5DB" : "#4B5563",
                fontFamily: fonts.regular,
                lineHeight: 24,
              }}
            >
              {item.label}
            </Text>
          </View>
        ))}
      </View>

      {/* CTA Buttons */}
      <View
        style={{ gap: 14, width: "100%", maxWidth: 380, alignSelf: "center" }}
      >
        <TouchableOpacity
          onPress={() => navigation.navigate("Signup")}
          style={{
            backgroundColor: "#F4C430",
            paddingVertical: 20,
            borderRadius: 18,
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "center",
            gap: 10,
            shadowColor: "#F4C430",
            shadowOffset: { width: 0, height: 6 },
            shadowOpacity: 0.35,
            shadowRadius: 14,
            elevation: 6,
          }}
        >
          <Text
            style={{
              fontSize: 17,
              fontFamily: fonts.bold,
              color: "#1A1D23",
              letterSpacing: 0.2,
            }}
          >
            Create Account
          </Text>
          <Icon name="arrow-forward" size={20} color="#1A1D23" />
        </TouchableOpacity>

        <TouchableOpacity
          onPress={() => navigation.navigate("Login")}
          style={{
            backgroundColor: "transparent",
            paddingVertical: 20,
            borderRadius: 18,
            alignItems: "center",
            borderWidth: 1.5,
            borderColor: isDarkMode ? "#374151" : "#E5E7EB",
          }}
        >
          <Text
            style={{ fontSize: 17, fontFamily: fonts.semiBold, color: txt }}
          >
            Sign In
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          onPress={() => navigation.navigate("Home")}
          style={{ paddingVertical: 14, alignItems: "center" }}
        >
          <Text
            style={{ fontSize: 15, fontFamily: fonts.medium, color: muted }}
          >
            Continue as Guest
          </Text>
        </TouchableOpacity>
      </View>
    </ScrollView>
  );

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: bg }}>
      {/* ── Header with step indicator ── */}
      <View
        style={{
          paddingHorizontal: 32,
          paddingTop: 24,
          paddingBottom: 20,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Steps */}
        <View style={{ flexDirection: "row", gap: 8, flex: 1 }}>
          {[1, 2, 3].map((step) => (
            <View key={step} style={{ alignItems: "center", gap: 6 }}>
              <View
                style={{
                  width: step === currentStep ? 28 : 8,
                  height: 8,
                  borderRadius: 4,
                  backgroundColor:
                    step < currentStep
                      ? "#F4C430"
                      : step === currentStep
                      ? "#F4C430"
                      : isDarkMode
                      ? "#2C2F36"
                      : "#E5E7EB",
                }}
              />
            </View>
          ))}
        </View>

        {/* Skip */}
        {currentStep < totalSteps && (
          <TouchableOpacity
            onPress={handleSkip}
            hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
          >
            <Text
              style={{ fontSize: 14, fontFamily: fonts.medium, color: muted }}
            >
              Skip
            </Text>
          </TouchableOpacity>
        )}
      </View>

      {/* ── Content ── */}
      <View style={{ flex: 1 }}>
        {currentStep === 1 && renderLanguageStep()}
        {currentStep === 2 && renderThemeStep()}
        {currentStep === 3 && renderWelcomeStep()}
      </View>

      {/* ── Navigation Buttons ── */}
      {currentStep < totalSteps && (
        <View
          style={{
            paddingHorizontal: 32,
            paddingBottom: 40,
            paddingTop: 24,
            flexDirection: "row",
            gap: 12,
            borderTopWidth: 1,
            borderTopColor: border,
          }}
        >
          {currentStep > 1 && (
            <TouchableOpacity
              onPress={handleBack}
              style={{
                flex: 1,
                height: 56,
                borderRadius: 16,
                alignItems: "center",
                justifyContent: "center",
                borderWidth: 1.5,
                borderColor: border,
              }}
            >
              <Text
                style={{ fontSize: 16, fontFamily: fonts.semiBold, color: txt }}
              >
                Back
              </Text>
            </TouchableOpacity>
          )}
          <TouchableOpacity
            onPress={handleNext}
            style={{
              flex: currentStep > 1 ? 2 : 1,
              height: 64,
              borderRadius: 18,
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#F4C430",
              flexDirection: "row",
              gap: 10,
              shadowColor: "#F4C430",
              shadowOffset: { width: 0, height: 5 },
              shadowOpacity: 0.28,
              shadowRadius: 14,
              elevation: 5,
            }}
          >
            <Text
              style={{ fontSize: 16, fontFamily: fonts.bold, color: "#1A1D23" }}
            >
              Continue
            </Text>
            <Icon name="arrow-forward" size={18} color="#1A1D23" />
          </TouchableOpacity>
        </View>
      )}
    </SafeAreaView>
  );
}

// ─── Desktop Language Selector ─────────────────────────────────────────────────
function DesktopLanguageSelector({
  currentLanguage = "en",
  setCurrentLanguage,
  isDarkMode,
}: any) {
  const [open, setOpen] = useState(false);

  const languages = [
    { code: "en", label: "English" },
    { code: "am", label: "አማርኛ" },
    { code: "ti", label: "ትግርኛ" },
    { code: "or", label: "Afaan Oromoo" },
  ];

  const bg = isDarkMode ? "#1A1D23" : "#FFFFFF";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";

  return (
    <View style={{ position: "relative" }}>
      <TouchableOpacity
        onPress={() => setOpen((v: boolean) => !v)}
        activeOpacity={0.7}
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 4,
          paddingVertical: 6,
          paddingHorizontal: 10,
          borderRadius: 8,
          backgroundColor: open
            ? isDarkMode
              ? "#23262E"
              : "#F3F4F6"
            : "transparent",
        }}
      >
        <Icon name="language" size={18} color={primary} />
        <Text
          style={{ fontSize: 13, fontFamily: fonts.medium, color: primary }}
        >
          {(
            languages.find((l) => l.code === currentLanguage) || languages[0]
          ).code.toUpperCase()}
        </Text>
        <Icon
          name={open ? "expand-less" : "expand-more"}
          size={16}
          color={muted}
        />
      </TouchableOpacity>

      <Modal
        visible={open}
        transparent
        animationType="fade"
        onRequestClose={() => setOpen(false)}
      >
        <TouchableOpacity
          style={{ flex: 1, backgroundColor: "transparent" }}
          activeOpacity={1}
          onPress={() => setOpen(false)}
        >
          <View style={{ flex: 1 }}>
            <View
              style={{
                position: "absolute",
                top: 58,
                right: 20,
                width: 200,
                backgroundColor: bg,
                borderRadius: 12,
                borderWidth: 1,
                borderColor: border,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 8 },
                shadowOpacity: 0.18,
                shadowRadius: 24,
                elevation: 12,
                overflow: "hidden",
              }}
              onStartShouldSetResponder={() => true}
            >
              {languages.map((lang, idx) => (
                <TouchableOpacity
                  key={lang.code}
                  onPress={() => {
                    if (setCurrentLanguage) setCurrentLanguage(lang.code);
                    setOpen(false);
                  }}
                  activeOpacity={0.7}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 12,
                    paddingHorizontal: 16,
                    paddingVertical: 12,
                    borderBottomWidth: idx < languages.length - 1 ? 1 : 0,
                    borderBottomColor: border,
                    backgroundColor:
                      lang.code === currentLanguage
                        ? isDarkMode
                          ? "#23262E"
                          : "#FFF9E6"
                        : bg,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 13,
                      fontFamily: fonts.medium,
                      color: primary,
                      flex: 1,
                    }}
                  >
                    {lang.label}
                  </Text>
                  {lang.code === currentLanguage && (
                    <Icon name="check" size={16} color="#F4C430" />
                  )}
                </TouchableOpacity>
              ))}
            </View>
          </View>
        </TouchableOpacity>
      </Modal>
    </View>
  );
}

// ─── Notifications Bell Dropdown (desktop top-bar) ─────────────────────────────
function NotificationsBell({
  navigation,
  isDarkMode,
  currentLanguage = "en",
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [open, setOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => setCurrentUser(u));
    return unsub;
  }, []);

  useEffect(() => {
    if (!currentUser) {
      setNotifications([]);
      return;
    }
    const q = dbQuery(
      collection(db, "users", currentUser.uid, "notifications"),
      orderBy("createdAt", "desc"),
      limit(10),
    );
    const unsub = onSnapshot(q, (snap) => {
      setNotifications(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return unsub;
  }, [currentUser?.uid]);

  const unreadCount = notifications.filter((n) => !n.read).length;

  const markRead = async (notif: any) => {
    if (!currentUser || notif.read) return;
    try {
      await updateDoc(
        doc(db, "users", currentUser.uid, "notifications", notif.id),
        { read: true },
      );
    } catch {}
  };

  const markAllRead = async () => {
    if (!currentUser) return;
    const unread = notifications.filter((n) => !n.read);
    await Promise.all(
      unread.map((n) =>
        updateDoc(doc(db, "users", currentUser.uid, "notifications", n.id), {
          read: true,
        }),
      ),
    );
  };

  const handlePress = async (notif: any) => {
    await markRead(notif);
    setOpen(false);
    if (notif.type === "job_alert" && notif.jobId) {
      navigation.navigate("JobDetails", { id: notif.jobId });
    } else {
      navigation.navigate("Notifications");
    }
  };

  const timeAgo = (ts: any) => {
    if (!ts || typeof ts.toMillis !== "function") return "";
    const secs = Math.floor((Date.now() - ts.toMillis()) / 1000);
    if (secs < 60) return "just now";
    if (secs < 3600) return `${Math.floor(secs / 60)}m`;
    if (secs < 86400) return `${Math.floor(secs / 3600)}h`;
    return `${Math.floor(secs / 86400)}d`;
  };

  const bg = isDarkMode ? "#1A1D23" : "#FFFFFF";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const unreadBg = isDarkMode ? "#23262E" : "#FFF9E6";

  return (
    <View style={{ position: "relative" }}>
      {/* Bell trigger */}
      <TouchableOpacity
        onPress={() => setOpen((v) => !v)}
        style={{
          width: 38,
          height: 38,
          borderRadius: 10,
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: open
            ? isDarkMode
              ? "#23262E"
              : "#F3F4F6"
            : "transparent",
        }}
        activeOpacity={0.7}
        hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
      >
        <Icon
          name={unreadCount > 0 ? "notifications" : "notifications-none"}
          size={22}
          color={primary}
        />
        {unreadCount > 0 && (
          <View
            style={{
              position: "absolute",
              top: 4,
              right: 4,
              minWidth: 16,
              height: 16,
              borderRadius: 8,
              backgroundColor: "#EF4444",
              alignItems: "center",
              justifyContent: "center",
              paddingHorizontal: 3,
              borderWidth: 2,
              borderColor: isDarkMode ? "#0F1117" : "#FFFFFF",
            }}
          >
            <Text
              style={{
                fontSize: 9,
                fontFamily: fonts.bold,
                color: "#FFFFFF",
                lineHeight: 11,
              }}
            >
              {unreadCount > 9 ? "9+" : unreadCount}
            </Text>
          </View>
        )}
      </TouchableOpacity>

      {/* Dropdown modal */}
      <Modal
        visible={open}
        transparent
        animationType="fade"
        onRequestClose={() => setOpen(false)}
      >
        <TouchableOpacity
          style={{ flex: 1, backgroundColor: "transparent" }}
          activeOpacity={1}
          onPress={() => setOpen(false)}
        >
          <View style={{ flex: 1 }}>
            <View
              style={{
                position: "absolute",
                top: 58,
                right: 20,
                width: 380,
                maxHeight: 520,
                backgroundColor: bg,
                borderRadius: 14,
                borderWidth: 1,
                borderColor: border,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 8 },
                shadowOpacity: 0.18,
                shadowRadius: 24,
                elevation: 12,
                overflow: "hidden",
              }}
              onStartShouldSetResponder={() => true}
            >
              {/* Header */}
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  paddingHorizontal: 16,
                  paddingVertical: 14,
                  borderBottomWidth: 1,
                  borderBottomColor: border,
                }}
              >
                <Text
                  style={{
                    flex: 1,
                    fontSize: 15,
                    fontFamily: fonts.bold,
                    color: primary,
                  }}
                >
                  {t.navAlerts}
                  {unreadCount > 0 && (
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.medium,
                        color: muted,
                      }}
                    >
                      {" "}
                      · {unreadCount} {(t as any).newLabel || "new"}
                    </Text>
                  )}
                </Text>
                {unreadCount > 0 && (
                  <TouchableOpacity
                    onPress={markAllRead}
                    hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
                  >
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.semiBold,
                        color: "#F4C430",
                      }}
                    >
                      {(t as any).markAllRead || "Mark all read"}
                    </Text>
                  </TouchableOpacity>
                )}
              </View>

              {/* List */}
              {loading ? (
                <View style={{ paddingVertical: 40, alignItems: "center" }}>
                  <ActivityIndicator color="#F4C430" />
                </View>
              ) : notifications.length === 0 ? (
                <View
                  style={{
                    paddingVertical: 48,
                    alignItems: "center",
                    paddingHorizontal: 24,
                  }}
                >
                  <View
                    style={{
                      width: 52,
                      height: 52,
                      borderRadius: 26,
                      backgroundColor: isDarkMode ? "#23262E" : "#F3F4F6",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: 12,
                    }}
                  >
                    <Icon name="notifications-none" size={26} color={muted} />
                  </View>
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.semiBold,
                      color: primary,
                      marginBottom: 4,
                    }}
                  >
                    {(t as any).noNotificationsTitle || "No notifications yet"}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.regular,
                      color: muted,
                      textAlign: "center",
                    }}
                  >
                    {(t as any).noNotificationsDesc ||
                      "We'll let you know when something new arrives."}
                  </Text>
                </View>
              ) : (
                <ScrollView
                  style={{ maxHeight: 400 }}
                  showsVerticalScrollIndicator={false}
                >
                  {notifications.map((notif, idx) => {
                    const isLast = idx === notifications.length - 1;
                    return (
                      <TouchableOpacity
                        key={notif.id}
                        onPress={() => handlePress(notif)}
                        activeOpacity={0.7}
                        style={{
                          flexDirection: "row",
                          alignItems: "flex-start",
                          gap: 12,
                          paddingHorizontal: 16,
                          paddingVertical: 12,
                          backgroundColor: notif.read ? bg : unreadBg,
                          borderBottomWidth: isLast ? 0 : 1,
                          borderBottomColor: border,
                        }}
                      >
                        <View
                          style={{
                            width: 34,
                            height: 34,
                            borderRadius: 10,
                            backgroundColor: notif.read
                              ? isDarkMode
                                ? "#23262E"
                                : "#F3F4F6"
                              : "#F4C43022",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            marginTop: 2,
                          }}
                        >
                          <Icon
                            name={
                              notif.type === "job_alert"
                                ? "work"
                                : "notifications"
                            }
                            size={16}
                            color={notif.read ? muted : "#F4C430"}
                          />
                        </View>
                        <View style={{ flex: 1, minWidth: 0 }}>
                          <Text
                            style={{
                              fontSize: 13,
                              fontFamily: notif.read
                                ? fonts.regular
                                : fonts.semiBold,
                              color: primary,
                              lineHeight: 18,
                            }}
                            numberOfLines={2}
                          >
                            {notif.title || notif.message || "Notification"}
                          </Text>
                          {!!notif.body && (
                            <Text
                              style={{
                                fontSize: 12,
                                fontFamily: fonts.regular,
                                color: muted,
                                marginTop: 2,
                                lineHeight: 17,
                              }}
                              numberOfLines={2}
                            >
                              {notif.body}
                            </Text>
                          )}
                          <Text
                            style={{
                              fontSize: 11,
                              fontFamily: fonts.regular,
                              color: muted,
                              marginTop: 4,
                            }}
                          >
                            {timeAgo(notif.createdAt)}
                          </Text>
                        </View>
                        {!notif.read && (
                          <View
                            style={{
                              width: 8,
                              height: 8,
                              borderRadius: 4,
                              backgroundColor: "#F4C430",
                              marginTop: 8,
                            }}
                          />
                        )}
                      </TouchableOpacity>
                    );
                  })}
                </ScrollView>
              )}

              {/* Footer */}
              <TouchableOpacity
                onPress={() => {
                  setOpen(false);
                  navigation.navigate("Notifications");
                }}
                style={{
                  paddingVertical: 12,
                  alignItems: "center",
                  borderTopWidth: 1,
                  borderTopColor: border,
                }}
                activeOpacity={0.7}
              >
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.semiBold,
                    color: "#F4C430",
                  }}
                >
                  {(t as any).viewAllNotifications || "View all notifications"}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </TouchableOpacity>
      </Modal>
    </View>
  );
}

// ─── Desktop User Menu (avatar + popover) ─────────────────────────────────────
function UserMenu({
  navigation,
  user,
  userData,
  isDarkMode,
  currentLanguage = "en",
}: any) {
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [open, setOpen] = useState(false);

  if (!user) return null;

  const subscriptionId = (
    userData?.subscriptionId ||
    userData?.subscriptionPlan ||
    "free"
  ).toLowerCase();
  const plan =
    SUBSCRIPTION_PLANS.find((p: any) => p.id === subscriptionId) ||
    SUBSCRIPTION_PLANS[0];
  const isFree = plan.id === "free";
  const badgeColors: any = {
    free: { bg: "#6B7280", text: "#FFFFFF" },
    standard: { bg: "#D97706", text: "#FFFFFF" },
    pro: { bg: "#7C3AED", text: "#FFFFFF" },
    enterprise: { bg: "#1E3A8A", text: "#FFFFFF" },
  };
  const planBadge = badgeColors[plan.id] || badgeColors.free;

  const bg = isDarkMode ? "#1A1D23" : "#FFFFFF";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#9CA3AF" : "#6B7280";
  const rowHover = isDarkMode ? "#23262E" : "#F9FAFB";

  const displayName =
    userData?.name || userData?.fullName || user.email?.split("@")[0] || "User";

  const close = () => setOpen(false);

  return (
    <View style={{ position: "relative" }}>
      <TouchableOpacity
        onPress={() => setOpen((v) => !v)}
        activeOpacity={0.7}
        style={{
          flexDirection: "row",
          alignItems: "center",
          gap: 6,
          paddingVertical: 4,
          paddingHorizontal: 4,
          borderRadius: 22,
        }}
      >
        {userData?.profilePicture ? (
          <Image
            source={{ uri: userData.profilePicture }}
            style={{
              width: 36,
              height: 36,
              borderRadius: 18,
              borderWidth: 2,
              borderColor: "#F4C430",
            }}
          />
        ) : (
          <View
            style={{
              width: 36,
              height: 36,
              borderRadius: 18,
              backgroundColor: "#F4C430",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon name="person" size={20} color="#1A1D23" />
          </View>
        )}
        <Icon
          name={open ? "expand-less" : "expand-more"}
          size={18}
          color={primary}
        />
      </TouchableOpacity>

      <Modal
        visible={open}
        transparent
        animationType="fade"
        onRequestClose={close}
      >
        <TouchableOpacity style={{ flex: 1 }} activeOpacity={1} onPress={close}>
          <View style={{ flex: 1 }}>
            <View
              style={{
                position: "absolute",
                top: 58,
                right: 20,
                width: 280,
                backgroundColor: bg,
                borderRadius: 14,
                borderWidth: 1,
                borderColor: border,
                shadowColor: "#000",
                shadowOffset: { width: 0, height: 8 },
                shadowOpacity: 0.18,
                shadowRadius: 24,
                elevation: 12,
                overflow: "hidden",
              }}
              onStartShouldSetResponder={() => true}
            >
              {/* Header */}
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                  paddingHorizontal: 16,
                  paddingVertical: 14,
                  borderBottomWidth: 1,
                  borderBottomColor: border,
                }}
              >
                {userData?.profilePicture ? (
                  <Image
                    source={{ uri: userData.profilePicture }}
                    style={{ width: 44, height: 44, borderRadius: 22 }}
                  />
                ) : (
                  <View
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: 22,
                      backgroundColor: "#F4C430",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon name="person" size={24} color="#1A1D23" />
                  </View>
                )}
                <View style={{ flex: 1, minWidth: 0 }}>
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.bold,
                      color: primary,
                    }}
                    numberOfLines={1}
                  >
                    {displayName}
                  </Text>
                  <Text
                    style={{
                      fontSize: 12,
                      fontFamily: fonts.regular,
                      color: muted,
                      marginTop: 1,
                    }}
                    numberOfLines={1}
                  >
                    {user.email}
                  </Text>
                </View>
              </View>

              {/* Plan */}
              <View
                style={{
                  paddingHorizontal: 16,
                  paddingVertical: 12,
                  borderBottomWidth: 1,
                  borderBottomColor: border,
                  gap: 8,
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 11,
                      fontFamily: fonts.medium,
                      color: muted,
                      letterSpacing: 0.5,
                      textTransform: "uppercase",
                    }}
                  >
                    Plan
                  </Text>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 4,
                      backgroundColor: planBadge.bg,
                      paddingHorizontal: 8,
                      paddingVertical: 3,
                      borderRadius: 10,
                    }}
                  >
                    <Icon name={plan.icon} size={12} color={planBadge.text} />
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: fonts.bold,
                        color: planBadge.text,
                      }}
                    >
                      {plan.name}
                    </Text>
                  </View>
                </View>
                {isFree && (
                  <TouchableOpacity
                    onPress={() => {
                      close();
                      navigation.navigate("SettingsSubscription");
                    }}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 6,
                      backgroundColor: "#10B981",
                      paddingVertical: 8,
                      borderRadius: 8,
                    }}
                  >
                    <Icon name="arrow-upward" size={14} color="#FFFFFF" />
                    <Text
                      style={{
                        fontSize: 13,
                        fontFamily: fonts.semiBold || fonts.bold,
                        color: "#FFFFFF",
                      }}
                    >
                      {(t as any).upgrade || "Upgrade"}
                    </Text>
                  </TouchableOpacity>
                )}
              </View>

              {/* Items */}
              <TouchableOpacity
                onPress={() => {
                  close();
                  navigation.navigate("Settings", { section: "portfolio" });
                }}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                  paddingHorizontal: 16,
                  paddingVertical: 12,
                }}
                activeOpacity={0.7}
              >
                <Icon name="person-outline" size={18} color={muted} />
                <Text
                  style={{
                    flex: 1,
                    fontSize: 13,
                    fontFamily: fonts.medium,
                    color: primary,
                  }}
                >
                  {(t as any).profile || "Profile"}
                </Text>
                <Icon name="chevron-right" size={18} color={muted} />
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  close();
                  navigation.navigate("Settings");
                }}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                  paddingHorizontal: 16,
                  paddingVertical: 12,
                }}
                activeOpacity={0.7}
              >
                <Icon name="settings" size={18} color={muted} />
                <Text
                  style={{
                    flex: 1,
                    fontSize: 13,
                    fontFamily: fonts.medium,
                    color: primary,
                  }}
                >
                  {(t as any).settings || "Settings"}
                </Text>
                <Icon name="chevron-right" size={18} color={muted} />
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  close();
                  navigation.navigate("Settings", { section: "help" });
                }}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                  paddingHorizontal: 16,
                  paddingVertical: 12,
                  borderBottomWidth: 1,
                  borderBottomColor: border,
                }}
                activeOpacity={0.7}
              >
                <Icon name="help-outline" size={18} color={muted} />
                <Text
                  style={{
                    flex: 1,
                    fontSize: 13,
                    fontFamily: fonts.medium,
                    color: primary,
                  }}
                >
                  {(t as any).helpSupport || "Help & Support"}
                </Text>
                <Icon name="chevron-right" size={18} color={muted} />
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  close();
                  signOut(auth);
                  navigation.replace("Home");
                }}
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 12,
                  paddingHorizontal: 16,
                  paddingVertical: 12,
                }}
                activeOpacity={0.7}
              >
                <Icon name="logout" size={18} color="#EF4444" />
                <Text
                  style={{
                    flex: 1,
                    fontSize: 13,
                    fontFamily: fonts.semiBold || fonts.bold,
                    color: "#EF4444",
                  }}
                >
                  {(t as any).logout || "Logout"}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </TouchableOpacity>
      </Modal>
    </View>
  );
}

// ─── Notifications Screen ────────────────────────────────────────────────────
function NotificationsScreen({
  navigation,
  isDarkMode,
  toggleTheme,
  colors: _colorsProp,
  currentLanguage = "en",
}: any) {
  // Use the global auth and db instances
  // const auth and db are already defined at module level
  const t =
    translations[currentLanguage as keyof typeof translations] ||
    translations.en;
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [userData, setUserData] = useState<any>(null);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [dimensions, setDimensions] = useState(Dimensions.get("window"));
  const isMobile = Platform.OS !== "web" || dimensions.width < 768;
  const [selectedNotif, setSelectedNotif] = useState<any | null>(null);

  useEffect(() => {
    const sub = Dimensions.addEventListener("change", ({ window }) =>
      setDimensions(window),
    );
    return () => sub?.remove();
  }, []);

  // Auth + userData
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (authUser) => {
      if (!authUser) {
        navigation.replace("Login");
        return;
      }
      setCurrentUser(authUser);
      try {
        const snap = await getDoc(doc(db, "users", authUser.uid));
        if (snap.exists()) setUserData(snap.data());
      } catch {}
    });
    return unsub;
  }, []);

  // Notifications listener
  useEffect(() => {
    if (!currentUser) return;
    const q = dbQuery(
      collection(db, "users", currentUser.uid, "notifications"),
      orderBy("createdAt", "desc"),
      limit(50),
    );
    const unsub = onSnapshot(q, (snap) => {
      setNotifications(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return unsub;
  }, [currentUser?.uid]);

  const markRead = async (notif: any) => {
    if (!currentUser || notif.read) return;
    try {
      await updateDoc(
        doc(db, "users", currentUser.uid, "notifications", notif.id),
        { read: true },
      );
    } catch {}
  };

  const handlePress = async (notif: any) => {
    await markRead(notif);
    if (notif.type === "job_alert" && notif.jobId) {
      navigation.navigate("JobDetails", { id: notif.jobId });
    } else {
      // Not tied to a job to open (announcements, application updates,
      // etc.) — show the full, untruncated message instead of doing nothing.
      setSelectedNotif(notif);
    }
  };

  const markAllRead = async () => {
    if (!currentUser) return;
    const unread = notifications.filter((n) => !n.read);
    await Promise.all(
      unread.map((n) =>
        updateDoc(doc(db, "users", currentUser.uid, "notifications", n.id), {
          read: true,
        }),
      ),
    );
  };

  const deleteNotif = async (notif: any) => {
    if (!currentUser) return;
    try {
      await deleteDoc(
        doc(db, "users", currentUser.uid, "notifications", notif.id),
      );
    } catch {}
  };

  const timeAgo = (ts: any) => {
    if (!ts) return "";
    const secs = Math.floor((Date.now() - ts.toMillis()) / 1000);
    if (secs < 60) return "just now";
    if (secs < 3600) return `${Math.floor(secs / 60)}m ago`;
    if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
    return `${Math.floor(secs / 86400)}d ago`;
  };

  const bg = isDarkMode ? "#0F1117" : "#FFFFFF";
  const pageBg = isDarkMode ? "#0F1117" : "#F9FAFB";
  const border = isDarkMode ? "#1E2027" : "#F0F0F0";
  const primary = isDarkMode ? "#F9FAFB" : "#1A1D23";
  const muted = isDarkMode ? "#6B7280" : "#9CA3AF";
  const unreadBg = isDarkMode ? "#1E2430" : "#FFF9E6";
  const unreadBorder = isDarkMode ? "#3A4A2A" : "#F4C430";
  const cardBg = isDarkMode ? "#1A1D23" : "#FFFFFF";

  const unreadCount = notifications.filter((n) => !n.read).length;

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: pageBg }}>
      {/* ── APP BAR ── */}
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingHorizontal: 16,
          paddingVertical: 12,
          backgroundColor: bg,
          borderBottomWidth: 1,
          borderBottomColor: border,
        }}
      >
        {isMobile ? (
          <>
            <View
              style={{
                flex: 1,
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
              }}
            >
              <TouchableOpacity
                onPress={() => setShowMobileMenu(true)}
                hitSlop={{ top: 8, bottom: 8, left: 4, right: 8 }}
              >
                <Icon name="menu" size={24} color={primary} />
              </TouchableOpacity>
              <View
                style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
              >
                <Image
                  source={require("./assets/favicon.png")}
                  style={{ width: 26, height: 26, borderRadius: 6 }}
                  resizeMode="contain"
                />
                <View>
                  <Text
                    style={{
                      fontSize: 17,
                      fontFamily: fonts.bold,
                      color: primary,
                      letterSpacing: 0.1,
                      lineHeight: 20,
                    }}
                  >
                    <Text
                      style={{
                        fontFamily: fonts.regular,
                        color: isDarkMode ? "#9CA3AF" : "#94A3B8",
                      }}
                    >
                      Nib
                    </Text>
                    Jobs
                  </Text>
                  <View
                    style={{
                      height: 2.5,
                      width: 32,
                      backgroundColor: "#F4C430",
                      borderRadius: 2,
                    }}
                  />
                </View>
              </View>
            </View>
            {unreadCount > 0 && (
              <TouchableOpacity
                onPress={markAllRead}
                hitSlop={{ top: 8, bottom: 8, left: 8, right: 4 }}
              >
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.medium,
                    color: "#F4C430",
                  }}
                >
                  Mark all read
                </Text>
              </TouchableOpacity>
            )}
          </>
        ) : (
          /* Desktop toolbar */
          <>
            <TouchableOpacity
              onPress={() => navigation.navigate("Jobs")}
              style={styles.toolbarLogoButton}
            >
              <Image
                source={require("./assets/favicon.png")}
                style={styles.toolbarLogo}
                resizeMode="contain"
              />
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.toolbarNavButton}
              onPress={() => navigation.navigate("Jobs")}
            >
              <Text style={styles.toolbarNavButtonText}>{t.navJobs}</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.toolbarNavButton}
              onPress={() => navigation.navigate("Bookmarks")}
            >
              <Text style={styles.toolbarNavButtonText}>{t.navSaved}</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[
                styles.toolbarNavButton,
                { borderBottomWidth: 2, borderBottomColor: "#F4C430" },
              ]}
              onPress={() => {}}
            >
              <Icon name="notifications" size={18} color="#F4C430" />
              <Text
                style={[
                  styles.toolbarNavButtonText,
                  { color: "#F4C430", marginLeft: 4, fontFamily: fonts.bold },
                ]}
              >
                {t.navAlerts}
              </Text>
            </TouchableOpacity>
            <View style={{ flex: 1 }} />
            {unreadCount > 0 && (
              <TouchableOpacity
                onPress={markAllRead}
                style={{ marginRight: 12 }}
              >
                <Text
                  style={{
                    fontSize: 13,
                    fontFamily: fonts.medium,
                    color: "#F4C430",
                  }}
                >
                  Mark all read
                </Text>
              </TouchableOpacity>
            )}
            {toggleTheme && (
              <TouchableOpacity
                style={styles.toolbarThemeToggle}
                onPress={toggleTheme}
              >
                <View
                  style={[
                    styles.themeToggleTrack,
                    { backgroundColor: isDarkMode ? "#1A1D23" : "#E5E7EB" },
                  ]}
                >
                  <Icon
                    name="wb-sunny"
                    size={14}
                    color={isDarkMode ? muted : "#F4C430"}
                    style={styles.themeToggleIconLeft}
                  />
                  <View
                    style={[
                      styles.themeToggleKnob,
                      { backgroundColor: "#FFFFFF" },
                      isDarkMode && styles.themeToggleKnobActive,
                    ]}
                  >
                    <Icon
                      name={isDarkMode ? "nightlight-round" : "wb-sunny"}
                      size={12}
                      color={isDarkMode ? "#1A1D23" : "#F4C430"}
                    />
                  </View>
                  <Icon
                    name="nightlight-round"
                    size={14}
                    color={isDarkMode ? "#F4C430" : muted}
                    style={styles.themeToggleIconRight}
                  />
                </View>
              </TouchableOpacity>
            )}
            {currentUser && (
              <UserMenu
                navigation={navigation}
                user={currentUser}
                userData={userData}
                isDarkMode={isDarkMode}
                currentLanguage={currentLanguage}
              />
            )}
          </>
        )}
      </View>

      {/* Side Drawer */}
      {showMobileMenu && (
        <MobileDrawer
          visible={showMobileMenu}
          onClose={() => setShowMobileMenu(false)}
          navigation={navigation}
          user={currentUser}
          userData={userData}
          isDarkMode={isDarkMode}
          toggleTheme={toggleTheme}
          currentView="candidate"
          currentLanguage={currentLanguage}
        />
      )}

      {/* ── CONTENT ── */}
      {loading ? (
        <FullScreenLoader isDarkMode={isDarkMode} />
      ) : notifications.length === 0 ? (
        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            padding: 32,
            paddingBottom: 100,
          }}
        >
          <View
            style={{
              width: 72,
              height: 72,
              borderRadius: 36,
              backgroundColor: isDarkMode ? "#1A1D23" : "#F3F4F6",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 16,
            }}
          >
            <Icon name="notifications-none" size={34} color={muted} />
          </View>
          <Text
            style={{
              fontSize: 17,
              fontFamily: fonts.bold,
              color: primary,
              marginBottom: 6,
            }}
          >
            No alerts yet
          </Text>
          <Text
            style={{
              fontSize: 14,
              fontFamily: fonts.regular,
              color: muted,
              textAlign: "center",
              lineHeight: 20,
            }}
          >
            Save your interests to get job alerts when matching jobs are posted.
          </Text>
        </View>
      ) : (
        <FlatList
          data={notifications}
          keyExtractor={(item) => item.id}
          contentContainerStyle={{ paddingTop: 8, paddingBottom: 100 }}
          renderItem={({ item }) => {
            const isUnread = !item.read;
            return (
              <TouchableOpacity
                onPress={() => handlePress(item)}
                style={{
                  marginHorizontal: 12,
                  marginVertical: 4,
                  borderRadius: 12,
                  backgroundColor: isUnread ? unreadBg : cardBg,
                  borderWidth: 1,
                  borderColor: isUnread ? unreadBorder : border,
                  flexDirection: "row",
                  alignItems: "center",
                  paddingHorizontal: 14,
                  paddingVertical: 12,
                }}
              >
                {/* Icon */}
                <View
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 20,
                    backgroundColor: isUnread
                      ? "#F4C430"
                      : isDarkMode
                      ? "#2C2F36"
                      : "#F3F4F6",
                    justifyContent: "center",
                    alignItems: "center",
                    marginRight: 12,
                  }}
                >
                  <Icon
                    name={item.type === "job_alert" ? "work" : "notifications"}
                    size={20}
                    color={isUnread ? "#1A1D23" : muted}
                  />
                </View>

                {/* Content */}
                <View style={{ flex: 1 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 2,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontFamily: isUnread ? fonts.bold : fonts.medium,
                        color: primary,
                        flex: 1,
                        marginRight: 8,
                      }}
                      numberOfLines={1}
                    >
                      {item.title}
                    </Text>
                    {isUnread && (
                      <View
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: 4,
                          backgroundColor: "#F4C430",
                        }}
                      />
                    )}
                  </View>
                  <Text
                    style={{
                      fontSize: 13,
                      fontFamily: fonts.regular,
                      color: muted,
                      marginBottom: 4,
                    }}
                    numberOfLines={2}
                  >
                    {item.body}
                  </Text>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 11,
                        fontFamily: fonts.regular,
                        color: muted,
                      }}
                    >
                      {timeAgo(item.createdAt)}
                    </Text>
                    {item.type === "job_alert" &&
                      (item.matchedTags || [])
                        .slice(0, 2)
                        .map((tag: string) => (
                          <View
                            key={tag}
                            style={{
                              backgroundColor: isDarkMode
                                ? "#2A3020"
                                : "#FEF9C3",
                              paddingHorizontal: 6,
                              paddingVertical: 1,
                              borderRadius: 4,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 10,
                                fontFamily: fonts.medium,
                                color: "#92400E",
                              }}
                            >
                              {tag}
                            </Text>
                          </View>
                        ))}
                  </View>
                </View>

                {/* Delete */}
                <TouchableOpacity
                  onPress={() => deleteNotif(item)}
                  style={{ padding: 8, marginLeft: 4 }}
                  hitSlop={{ top: 6, bottom: 6, left: 6, right: 6 }}
                >
                  <Icon name="close" size={16} color={muted} />
                </TouchableOpacity>
              </TouchableOpacity>
            );
          }}
        />
      )}

      {/* Bottom Nav */}
      <BottomNavBar
        navigation={navigation}
        activeRoute="Notifications"
        isDarkMode={isDarkMode}
        user={currentUser}
        userData={userData}
        currentLanguage={currentLanguage}
      />

      {/* Full-message popup for alerts that don't open a job (announcements,
          application updates, etc.) — the list row truncates the body to
          2 lines, so this is where the whole message is readable. */}
      <Modal
        visible={!!selectedNotif}
        transparent
        animationType="fade"
        onRequestClose={() => setSelectedNotif(null)}
      >
        <TouchableOpacity
          style={{
            flex: 1,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            justifyContent: "center",
            alignItems: "center",
            padding: 24,
          }}
          activeOpacity={1}
          onPress={() => setSelectedNotif(null)}
        >
          <View
            style={{
              width: "100%",
              maxWidth: 420,
              backgroundColor: cardBg,
              borderRadius: 16,
              borderWidth: 1,
              borderColor: border,
              padding: 20,
            }}
            onStartShouldSetResponder={() => true}
          >
            {selectedNotif && (
              <>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-start",
                    gap: 12,
                    marginBottom: 14,
                  }}
                >
                  <View
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 20,
                      backgroundColor: "#F4C430",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Icon
                      name={
                        selectedNotif.type === "announcement"
                          ? "campaign"
                          : "notifications"
                      }
                      size={20}
                      color="#1A1D23"
                    />
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontSize: 16,
                        fontFamily: fonts.bold,
                        color: primary,
                        marginBottom: 2,
                      }}
                    >
                      {selectedNotif.title}
                    </Text>
                    <Text
                      style={{
                        fontSize: 12,
                        fontFamily: fonts.regular,
                        color: muted,
                      }}
                    >
                      {timeAgo(selectedNotif.createdAt)}
                    </Text>
                  </View>
                  <TouchableOpacity
                    onPress={() => setSelectedNotif(null)}
                    hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
                  >
                    <Icon name="close" size={20} color={muted} />
                  </TouchableOpacity>
                </View>
                <Text
                  style={{
                    fontSize: 14,
                    fontFamily: fonts.regular,
                    color: primary,
                    lineHeight: 21,
                  }}
                >
                  {selectedNotif.body}
                </Text>
                <TouchableOpacity
                  onPress={() => setSelectedNotif(null)}
                  style={{
                    marginTop: 20,
                    backgroundColor: "#F4C430",
                    borderRadius: 10,
                    paddingVertical: 12,
                    alignItems: "center",
                  }}
                  activeOpacity={0.85}
                >
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: fonts.semiBold,
                      color: "#1A1D23",
                    }}
                  >
                    Close
                  </Text>
                </TouchableOpacity>
              </>
            )}
          </View>
        </TouchableOpacity>
      </Modal>
    </SafeAreaView>
  );
}
// ─────────────────────────────────────────────────────────────────────────────

export default function App() {
  const [initializing, setInitializing] = useState(true);
  const [user, setUser] = useState<any>(null);
  const [userProfile, setUserProfile] = useState<any>(null);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [themeLoaded, setThemeLoaded] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState("en"); // 'en', 'am', 'ti', 'or'
  const fontsLoaded = useAppFonts();

  // Request notification permission on first launch (native only)
  useNotificationPermission();

  // Onboarding states
  const [isFirstLaunch, setIsFirstLaunch] = useState<boolean | null>(null);
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);

  // Unread notification count for bottom nav badge
  const [unreadNotifCount, setUnreadNotifCount] = useState(0);

  // Firebase operations tracking for dev tools
  const [firebaseReads, setFirebaseReads] = useState(0);
  const [firebaseWrites, setFirebaseWrites] = useState(0);
  const [showDevTools, setShowDevTools] = useState(false);
  const [devToolsVisible, setDevToolsVisible] = useState(true);
  const [devToolsPosition, setDevToolsPosition] = useState({
    // Starts below the typical page-header zone so it doesn't cover
    // header action buttons (e.g. admin panel "Refresh") on first load.
    top: 100,
    right: 10,
  });
  const [isDragging, setIsDragging] = useState(false);

  // Global custom alert modal
  const [appAlertState, setAppAlertState] = useState<AppAlertState>({
    visible: false,
    type: "info",
    title: "",
    message: "",
  });
  const showAppAlert = React.useCallback(
    (
      type: AlertType,
      title: string,
      message: string,
      options?: { buttonText?: string; onClose?: () => void },
    ) => {
      setAppAlertState({
        visible: true,
        type,
        title,
        message,
        buttonText: options?.buttonText,
        onClose: options?.onClose,
      });
    },
    [],
  );
  const dismissAppAlert = React.useCallback(() => {
    setAppAlertState((prev) => ({ ...prev, visible: false }));
  }, []);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  const incrementReads = (count: number = 1) =>
    setFirebaseReads((prev) => prev + count);
  const incrementWrites = (count: number = 1) =>
    setFirebaseWrites((prev) => prev + count);
  const resetFirebaseOps = () => {
    setFirebaseReads(0);
    setFirebaseWrites(0);
  };

  // Check if running on localhost
  useEffect(() => {
    if (Platform.OS === "web" && typeof window !== "undefined") {
      const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1" ||
        window.location.hostname.includes("192.168");
      setShowDevTools(isLocalhost);
    }
  }, []);

  // Configure Google Sign-In
  useEffect(() => {
    if (Platform.OS !== "web" && GoogleSignin) {
      try {
        GoogleSignin.configure({
          // TODO: Replace with your actual Web Client ID from Firebase Console
          // Go to: Firebase Console > Project Settings > General > Your Apps > Android
          // The Web Client ID is in the OAuth 2.0 Client IDs section
          webClientId:
            "921124469397-6bmsh9e8m9a5nq7bvohkq0cdg7ud9a7a.apps.googleusercontent.com",
          offlineAccess: true,
        });
      } catch (error) {
        // A misconfigured/missing Android OAuth client (e.g. SHA-1 not
        // registered for the current signing certificate) must not crash
        // the whole app on launch — Google Sign-In simply won't work.
        console.error("GoogleSignin.configure() failed:", error);
      }
    }
  }, []);

  // Load theme preference on mount
  useEffect(() => {
    loadThemePreference();
    checkFirstLaunch();
    // Load saved language preference
    (async () => {
      try {
        const savedLanguage = await AsyncStorage.getItem("selectedLanguage");
        if (savedLanguage) setCurrentLanguage(savedLanguage);
      } catch (error) {
        console.error("Error loading language preference:", error);
      }
    })();
  }, []);

  const checkFirstLaunch = async () => {
    try {
      // Only check for first launch on mobile (not web)
      if (Platform.OS !== "web") {
        const hasLaunched = await AsyncStorage.getItem("hasLaunched");
        if (hasLaunched === null) {
          // Skip onboarding, go directly to Jobs
          await AsyncStorage.setItem("hasLaunched", "true");
        }
        setIsFirstLaunch(false);
        setShowOnboarding(false);
      } else {
        setIsFirstLaunch(false);
      }
    } catch (error) {
      console.error("Error checking first launch:", error);
      setIsFirstLaunch(false);
    }
  };

  const handleOnboardingComplete = async () => {
    try {
      await AsyncStorage.setItem("hasLaunched", "true");
      setShowOnboarding(false);
    } catch (error) {
      console.error("Error saving onboarding status:", error);
    }
  };

  const loadThemePreference = async () => {
    try {
      const savedTheme = await AsyncStorage.getItem("isDarkMode");
      if (savedTheme !== null) {
        setIsDarkMode(savedTheme === "true");
      } else {
        // Default to dark theme
        setIsDarkMode(true);
      }
    } catch (error) {
      console.error("Error loading theme preference:", error);
    } finally {
      setThemeLoaded(true);
    }
  };

  const toggleTheme = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      await AsyncStorage.setItem("isDarkMode", String(newTheme));
    } catch (error) {
      console.error("Error saving theme preference:", error);
    }
  };

  // Inject global CSS to apply dark/light theme to native <select> dropdowns on web
  useEffect(() => {
    if (Platform.OS !== "web" || typeof document === "undefined") return;
    let styleEl = document.getElementById(
      "nibjobs-select-theme",
    ) as HTMLStyleElement | null;
    if (!styleEl) {
      styleEl = document.createElement("style");
      styleEl.id = "nibjobs-select-theme";
      document.head.appendChild(styleEl);
    }
    if (isDarkMode) {
      styleEl.textContent = [
        "select { color-scheme: dark; background-color: #0F1117; color: #F9FAFB; }",
        "select option { background-color: #1A1D23; color: #F9FAFB; }",
      ].join("\n");
    } else {
      styleEl.textContent = [
        "select { color-scheme: light; background-color: #F8FAFC; color: #0F172A; }",
        "select option { background-color: #FFFFFF; color: #0F172A; }",
      ].join("\n");
    }
  }, [isDarkMode]);

  useEffect(() => {
    console.log("Setting up auth state listener, showWelcome:", showWelcome);
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      console.log(
        "Auth state changed:",
        authUser ? `User ${authUser.uid}` : "No user",
      );
      setUser(authUser);

      // Load user profile from Firestore if authenticated
      if (authUser) {
        try {
          const userRef = doc(db, "users", authUser.uid);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const profileData = userSnap.data();
            setUserProfile(profileData);
            console.log("User profile loaded, role:", profileData?.role);
            // Self-heal a stale isVerified copy (e.g. Google SSO users whose
            // profile was created by an earlier unverified email signup)
            if (authUser.emailVerified && !profileData?.isVerified) {
              updateDoc(userRef, { isVerified: true, updatedAt: new Date() })
                .then(() => console.log("✅ Synced isVerified from Firebase Auth"))
                .catch((err) => console.warn("isVerified sync failed:", err));
            }
            // Record activity once per (Ethiopia-local) day for engagement stats
            const ethDay = (d: Date) =>
              new Date(d.getTime() + 3 * 60 * 60 * 1000)
                .toISOString()
                .slice(0, 10);
            const lastActive = profileData?.lastActiveAt?.toDate
              ? profileData.lastActiveAt.toDate()
              : null;
            if (!lastActive || ethDay(lastActive) !== ethDay(new Date())) {
              updateDoc(userRef, { lastActiveAt: new Date() })
                .then(() => trackInteraction("daily_active"))
                .catch((err) => console.warn("lastActiveAt update failed:", err));
            }
          } else {
            setUserProfile(null);
          }
        } catch (error) {
          console.error("Error loading user profile:", error);
          setUserProfile(null);
        }
      } else {
        setUserProfile(null);
      }

      if (initializing) setInitializing(false);

      // If user signs in while on welcome screen, dismiss it immediately.
      // Using unconditional setShowWelcome(false) avoids a stale closure bug
      // (the useEffect only re-runs when `initializing` changes, so `showWelcome`
      // captured here is always the initial `false` value — calling the setter
      // unconditionally is safe because React bails out when state hasn't changed).
      if (authUser) {
        console.log("User authenticated, dismissing welcome screen");
        setShowWelcome(false);
      }
    });

    // Fallback timeout for web - ensure app doesn't hang if auth doesn't respond
    const timeout = setTimeout(() => {
      if (initializing) {
        console.warn("Auth state check timed out, proceeding without auth");
        setInitializing(false);
      }
    }, 5000);

    return () => {
      unsubscribe();
      clearTimeout(timeout);
    };
  }, [initializing]);

  // Web FCM token registration — only runs on web when user is authenticated
  useEffect(() => {
    if (Platform.OS !== "web" || !user || user.isAnonymous || !userProfile)
      return;

    const initializeWebFCM = async () => {
      try {
        console.log("[Web FCM] Initializing...", {
          pushNotificationsEnabled: userProfile.pushNotifications,
          notificationPermission: Notification?.permission,
        });

        // Check if browser supports notifications
        if (typeof Notification === "undefined") {
          console.log("[Web FCM] Browser does not support notifications");
          return;
        }

        // Only register if user has enabled push notifications in their settings
        if (!userProfile.pushNotifications) {
          console.log("[Web FCM] Push notifications disabled in user settings");
          return;
        }

        // Check if permission is already granted
        if (Notification.permission !== "granted") {
          console.log(
            "[Web FCM] Notification permission not granted:",
            Notification.permission,
          );
          return;
        }

        console.log(
          "[Web FCM] Registering service worker and obtaining token...",
        );
        const { webMessaging } = require("./src/config/firebase");
        const { getToken } = require("firebase/messaging");

        if (webMessaging) {
          const swRegistration = await navigator.serviceWorker.register(
            "/firebase-messaging-sw.js",
          );
          console.log("[Web FCM] Service worker registered");

          const token = await getToken(webMessaging, {
            vapidKey:
              "BF5KEAYZMXxzg0v2djZwSJMVOhFhKeeT9uuNBtvxQukHWucUMozLYSmHRckSftRJ-qDq10OBalFFkcvP9pgXqq4",
            serviceWorkerRegistration: swRegistration,
          });

          if (token) {
            console.log(
              "[Web FCM] Token obtained:",
              token.substring(0, 20) + "...",
            );

            // Add token to user's FCM tokens array if not already present
            const currentTokens = userProfile.fcmTokens || [];
            if (!currentTokens.includes(token)) {
              const updatedTokens = [...currentTokens, token];
              if (updatedTokens.length > 5) {
                updatedTokens.splice(0, updatedTokens.length - 5);
              }
              await updateDoc(doc(db, "users", user.uid), {
                fcmTokens: updatedTokens,
              });
              console.log("[Web FCM] Token saved to Firestore");
            } else {
              console.log("[Web FCM] Token already exists in Firestore");
            }
          } else {
            console.log("[Web FCM] Failed to obtain token");
          }
        }
      } catch (error) {
        console.error("[Web FCM] Initialization error:", error);
      }
    };

    initializeWebFCM();
  }, [user?.uid, userProfile?.pushNotifications]);

  // FCM token registration — runs whenever the signed-in user changes.
  // Only active on native (Android/iOS); skipped entirely on web.

  // Subscribe to unread notification count
  useEffect(() => {
    if (!user || user.isAnonymous || Platform.OS === "web") return;
    const q = dbQuery(
      collection(db, "users", user.uid, "notifications"),
      where("read", "==", false),
    );
    const unsub = onSnapshot(q, (snap) => setUnreadNotifCount(snap.size));
    return unsub;
  }, [user?.uid]);

  // Handle FCM notification taps (background, quit-state, and foreground).
  // Routing rules:
  //   - data.jobId is present  OR  data.type === 'job'  →  JobDetails screen
  //   - data.type === 'application_accepted' or 'application_rejected' → JobDetails screen
  //   - anything else                                    →  Notifications screen (Alerts tab)
  useEffect(() => {
    if (Platform.OS === "web") return;
    let messaging: any;
    try {
      messaging = require("@react-native-firebase/messaging").default;
    } catch (error) {
      console.error("Failed to load @react-native-firebase/messaging:", error);
      return;
    }

    /**
     * Decide where to go based on the notification payload and navigate there.
     * Retries up to 50 times (5 s total) waiting for the NavigationContainer to mount.
     */
    const handleNotificationTap = (remoteMessage: any) => {
      const data = remoteMessage?.data ?? {};
      const isJobNotification =
        !!data.jobId ||
        data.type === "job" ||
        data.type === "new_job" ||
        data.type === "application_accepted" ||
        data.type === "application_rejected" ||
        data.type === "application_status";

      const navigate = () => {
        if (isJobNotification) {
          navigationRef.navigate("JobDetails", { id: data.jobId } as never);
        } else {
          navigationRef.navigate("Notifications" as never);
        }
      };

      // Navigation container may not be ready yet when app launched from quit state.
      let attempts = 0;
      const tryNav = () => {
        if (navigationRef.isReady()) {
          navigate();
        } else if (attempts < 50) {
          attempts++;
          setTimeout(tryNav, 100);
        }
      };
      tryNav();
    };

    let unsubBackground: (() => void) | undefined;
    let unsubForeground: (() => void) | undefined;
    try {
      // App brought from background by tapping a notification banner
      unsubBackground = messaging().onNotificationOpenedApp(
        handleNotificationTap,
      );

      // App launched from quit/killed state by tapping a notification banner
      messaging()
        .getInitialNotification()
        .then((msg: any) => {
          if (msg) handleNotificationTap(msg);
        })
        .catch(() => {});

      // App is in the foreground: display a local alert banner and handle tap
      unsubForeground = messaging().onMessage(
        async (remoteMessage: any) => {
          const data = remoteMessage?.data ?? {};
          const title = remoteMessage?.notification?.title ?? "NibJobs";
          const body = remoteMessage?.notification?.body ?? "";
          const isJobNotification =
            !!data.jobId ||
            data.type === "job" ||
            data.type === "new_job" ||
            data.type === "application_accepted" ||
            data.type === "application_rejected" ||
            data.type === "application_status";

          Alert.alert(
            title,
            body,
            [
              { text: "Dismiss", style: "cancel" },
              {
                text: isJobNotification ? "View Job" : "View Alerts",
                onPress: () => {
                  if (isJobNotification) {
                    navigationRef.navigate("JobDetails", {
                      id: data.jobId,
                    } as never);
                  } else {
                    navigationRef.navigate("Notifications" as never);
                  }
                },
              },
            ],
            { cancelable: true },
          );
        },
      );
    } catch (error) {
      console.error("Failed to set up FCM notification-tap listeners:", error);
    }

    return () => {
      unsubBackground?.();
      unsubForeground?.();
    };
  }, []);
  useEffect(() => {
    if (Platform.OS === "web" || !user || user.isAnonymous) return;

    let unsubscribeTokenRefresh: (() => void) | undefined;

    const registerFCMToken = async (token: string) => {
      try {
        await updateDoc(doc(db, "users", user.uid), {
          fcmTokens: arrayUnion(token),
        });
        console.log("✅ FCM token saved for user", user.uid);
      } catch (err) {
        console.error("Failed to save FCM token:", err);
      }
    };

    const initFCM = async () => {
      try {
        const messaging = require("@react-native-firebase/messaging").default;

        // Note: Android notification channels are created natively in MainActivity.kt
        // (job_alerts, application_updates). The @react-native-firebase/messaging v18
        // JS API does not expose createChannel — channel creation must be done natively.

        // Request permission directly — on Android 13+ this shows the native
        // POST_NOTIFICATIONS dialog on the first call. On subsequent calls after
        // the user has already chosen, Android's own OS logic controls whether
        // the dialog appears (no need for our own "already shown" gate).
        // On Android < 13 this returns AUTHORIZED immediately without a dialog.
        const authStatus = await messaging().requestPermission();
        const granted =
          authStatus === messaging.AuthorizationStatus.AUTHORIZED ||
          authStatus === messaging.AuthorizationStatus.PROVISIONAL;

        if (granted) {
          const token: string = await messaging().getToken();
          if (token) {
            await registerFCMToken(token);
            console.log(
              "✅ FCM token registered:",
              token.substring(0, 20) + "...",
            );
          }
          unsubscribeTokenRefresh =
            messaging().onTokenRefresh(registerFCMToken);
        } else {
          console.log(
            "🔕 FCM permission not granted (status:",
            authStatus,
            ")",
          );
        }
      } catch (err) {
        console.error("FCM init error:", err);
      }
    };

    initFCM();

    return () => {
      if (unsubscribeTokenRefresh) unsubscribeTokenRefresh();
    };
  }, [user?.uid]);

  // On web, URL-based linking overrides initialRouteName, so we need an explicit
  // redirect whenever auth resolves for a superadmin user.
  useEffect(() => {
    if (initializing || !user || !userProfile) return;
    if (userProfile.role !== "superadmin") return;
    // Wait for the NavigationContainer to be ready before navigating
    const tryRedirect = () => {
      if (navigationRef.isReady()) {
        const currentRoute = navigationRef.getCurrentRoute();
        if (currentRoute?.name !== "AdminPanel") {
          navigationRef.navigate("AdminPanel" as never);
        }
      } else {
        setTimeout(tryRedirect, 100);
      }
    };
    tryRedirect();
  }, [initializing, user?.uid, userProfile?.role]);

  // Get current theme colors
  const colors = isDarkMode ? darkColors : lightColors;

  // Determine initial route based on authentication and user role
  const getInitialRouteName = () => {
    // If user is logged in
    if (user && userProfile) {
      // If user has a superadmin role, go to admin panel
      if (userProfile.role === "superadmin") {
        return "AdminPanel";
      }
      // If user has a company role, go to company dashboard
      if (userProfile.role === "company") {
        return "CompanyDashboard";
      }
      // Regular user - go to jobs page
      return "Jobs";
    }
    // Not logged in - show home page for web, jobs for mobile
    return Platform.OS !== "web" ? "Jobs" : "Home";
  };

  // Debug logging
  if (Platform.OS === "web") {
    console.log("App state:", {
      initializing,
      fontsLoaded,
      themeLoaded,
      isFirstLaunch,
      showOnboarding,
      showWelcome,
    });
  }

  if (initializing || !fontsLoaded || !themeLoaded || isFirstLaunch === null) {
    return (
      <ModernLoadingScreen message="Starting NibJobs..." isDarkMode={false} />
    );
  }

  // Show onboarding for first-time mobile users
  if (showOnboarding && Platform.OS !== "web") {
    return <OnboardingScreen onComplete={handleOnboardingComplete} />;
  }

  // Show welcome screen after onboarding
  if (showWelcome && Platform.OS !== "web") {
    return (
      <SafeAreaProvider>
        <SafeAreaView
          style={{ flex: 1 }}
          edges={["top", "bottom", "left", "right"]}
        >
          <NavigationContainer>
            <Stack.Navigator screenOptions={{ headerShown: false }}>
              <Stack.Screen name="Welcome">
                {(props) => (
                  <WelcomeScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    setIsDarkMode={setIsDarkMode}
                    onDismiss={() => setShowWelcome(false)}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="Login">
                {(props) => (
                  <LoginScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="Signup">
                {(props) => (
                  <SignupScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="ProfileSetup">
                {(props) => (
                  <ProfileSetupScreen {...props} isDarkMode={isDarkMode} />
                )}
              </Stack.Screen>
              <Stack.Screen name="ForgotPassword">
                {(props) => (
                  <ForgotPasswordScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                    currentLanguage={currentLanguage}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="VerificationRequired">
                {(props) => (
                  <VerificationRequiredScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                    currentLanguage={currentLanguage}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="Jobs">
                {(props) => (
                  <JobsScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                    currentLanguage={currentLanguage}
                    setCurrentLanguage={setCurrentLanguage}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="CategoryJobs">
                {(props) => (
                  <JobsScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                    currentLanguage={currentLanguage}
                    setCurrentLanguage={setCurrentLanguage}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="AdminPanel">
                {(props) => (
                  <AdminPanelScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="Bookmarks">
                {(props) => (
                  <BookmarksScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                    currentLanguage={currentLanguage}
                    setCurrentLanguage={setCurrentLanguage}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="Notifications">
                {(props) => (
                  <NotificationsScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                    currentLanguage={currentLanguage}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="Settings">
                {(props) => (
                  <SettingsScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                    currentLanguage={currentLanguage}
                    setCurrentLanguage={setCurrentLanguage}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="SettingsSubscription">
                {(props) => (
                  <SettingsSubscriptionScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                    currentLanguage={currentLanguage}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="CompanyDashboard">
                {(props) => (
                  <CompanyDashboardScreen
                    {...props}
                    isDarkMode={isDarkMode}
                    toggleTheme={toggleTheme}
                    colors={colors}
                    currentLanguage={currentLanguage}
                  />
                )}
              </Stack.Screen>
              <Stack.Screen name="Home">
                {(props) => {
                  setShowWelcome(false);
                  return (
                    <HomeScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                    />
                  );
                }}
              </Stack.Screen>
            </Stack.Navigator>
          </NavigationContainer>
        </SafeAreaView>
      </SafeAreaProvider>
    );
  }

  const linking = {
    prefixes: [
      "https://nibjobs.com",
      "http://localhost:19006",
      "https://nibjobs-dev.web.app",
      "https://nibjobs-dev.firebaseapp.com",
      "nibjobs://",
    ],
    config: {
      screens: {
        Home: "",
        Login: "login",
        PublicProfile: "profile/:username",
        Signup: "signup",
        VerificationRequired: "verification-required",
        ProfileSetup: "profilesetup",
        ForgotPassword: "forgot-password",
        Jobs: "jobs",
        CategoryJobs: "category/:categorySlug",
        Companies: "companies",
        CompanyDetails: "company/:companyId",
        CompanyRegistration: "company-registration",
        CompanyDashboard: "company-dashboard",
        CandidateBrowse: "candidates",
        Bookmarks: "bookmarks",
        Settings: "settings",
        SettingsProfile: "settings/profile",
        SettingsLanguage: "settings/language",
        SettingsInterests: "settings/interests",
        SettingsSubscription: "settings/subscription",
        JobDetails: "job/:id",
        JobApplication: "apply/:jobId",
        CompanyApplicants: "company-applicants/:jobId",
        AdminPanel: "admin",
        Unauthorized: "unauthorized",
        Privacy: "privacy",
        Terms: "terms",
        JobAlerts: "job-alerts",
        CareerAdvice: "career-advice",
        ResumeTips: "resume-tips",
        RecruitmentTips: "recruitment-tips",
        Payment: "payment",
        ThankYou: "thank-you",
        NotFound: "*",
      },
    },
    getStateFromPath: (path: string, config: any) => {
      // Normalize only the route segments to lowercase, preserve dynamic parameter case
      // e.g. /Job/KR6dvuIo31qU7oErJeIA -> /job/KR6dvuIo31qU7oErJeIA
      const segments = path.split("/");
      const normalizedSegments = segments.map((segment, index) => {
        // Keep the first segment after route name as-is (it's likely a dynamic ID)
        // Lowercase known route prefixes only
        const lowerSegment = segment.toLowerCase();
        const routeNames = [
          "",
          "job",
          "jobs",
          "company",
          "companies",
          "category",
          "login",
          "signup",
          "profile",
          "profilesetup",
          "forgot-password",
          "company-registration",
          "company-dashboard",
          "candidates",
          "bookmarks",
          "settings",
          "apply",
          "company-applicants",
          "admin",
          "unauthorized",
          "privacy",
          "terms",
          "job-alerts",
          "career-advice",
          "resume-tips",
          "recruitment-tips",
          "payment",
          "thank-you",
          "verification-required",
        ];
        if (routeNames.includes(lowerSegment)) {
          return lowerSegment;
        }
        // Preserve case for dynamic parameters (IDs, slugs, usernames)
        return segment;
      });
      const normalizedPath = normalizedSegments.join("/");
      const {
        getStateFromPath: defaultGetStateFromPath,
      } = require("@react-navigation/native");
      return defaultGetStateFromPath(normalizedPath, config);
    },
  };

  return (
    <SafeAreaProvider>
      <SafeAreaView style={{ flex: 1 }} edges={["bottom", "left", "right"]}>
        <AppAlertContext.Provider value={{ showAlert: showAppAlert }}>
          <FirebaseOpsContext.Provider
            value={{
              reads: firebaseReads,
              writes: firebaseWrites,
              incrementReads,
              incrementWrites,
              reset: resetFirebaseOps,
            }}
          >
            <NavigationContainer ref={navigationRef} linking={linking}>
              {showDevTools && devToolsVisible && Platform.OS === "web" && (
                <View
                  style={{
                    position: "fixed" as any,
                    top: devToolsPosition.top,
                    right: devToolsPosition.right,
                    backgroundColor: isDarkMode
                      ? "rgba(26, 29, 35, 0.95)"
                      : "rgba(255, 255, 255, 0.95)",
                    borderRadius: 8,
                    borderWidth: 1,
                    borderColor: isDarkMode ? "#3A3F4B" : "#E5E7EB",
                    zIndex: 999999,
                    shadowColor: "#000",
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.25,
                    shadowRadius: 4,
                    minWidth: 180,
                    cursor: isDragging ? "grabbing" : "default",
                  }}
                >
                  {/* Header with drag handle and close button */}
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      paddingHorizontal: 12,
                      paddingTop: 8,
                      paddingBottom: 4,
                      cursor: "grab",
                    }}
                    onMouseDown={(e: any) => {
                      setIsDragging(true);
                      const rect =
                        e.currentTarget.parentElement.getBoundingClientRect();
                      setDragOffset({
                        x: e.clientX - rect.left,
                        y: e.clientY - rect.top,
                      });
                    }}
                    onMouseMove={(e: any) => {
                      if (isDragging) {
                        const newRight =
                          window.innerWidth - e.clientX - dragOffset.x;
                        const newTop = e.clientY - dragOffset.y;
                        setDevToolsPosition({
                          top: Math.max(
                            0,
                            Math.min(window.innerHeight - 200, newTop),
                          ),
                          right: Math.max(
                            0,
                            Math.min(window.innerWidth - 200, newRight),
                          ),
                        });
                      }
                    }}
                    onMouseUp={() => setIsDragging(false)}
                    onMouseLeave={() => setIsDragging(false)}
                  >
                    <Text
                      style={{
                        fontSize: 11,
                        fontWeight: "600",
                        color: isDarkMode ? "#9CA3AF" : "#6B7280",
                        letterSpacing: 0.5,
                        flex: 1,
                      }}
                    >
                      🔧 FIREBASE OPS
                    </Text>
                    <TouchableOpacity
                      onPress={() => setDevToolsVisible(false)}
                      style={{
                        padding: 4,
                        marginLeft: 8,
                        borderRadius: 4,
                        backgroundColor: isDarkMode ? "#3A3F4B" : "#F3F4F6",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 10,
                          color: isDarkMode ? "#9CA3AF" : "#6B7280",
                          fontWeight: "600",
                        }}
                      >
                        ✕
                      </Text>
                    </TouchableOpacity>
                  </View>

                  {/* Content */}
                  <View style={{ padding: 12, paddingTop: 8 }}>
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginBottom: 4,
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 12,
                          color: isDarkMode ? "#D1D5DB" : "#374151",
                          fontFamily: fonts.medium,
                        }}
                      >
                        Reads:
                      </Text>
                      <Text
                        style={{
                          fontSize: 12,
                          color: "#10B981",
                          fontWeight: "700",
                          fontFamily: fonts.bold,
                        }}
                      >
                        {firebaseReads}
                      </Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginBottom: 8,
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 12,
                          color: isDarkMode ? "#D1D5DB" : "#374151",
                          fontFamily: fonts.medium,
                        }}
                      >
                        Writes:
                      </Text>
                      <Text
                        style={{
                          fontSize: 12,
                          color: "#F59E0B",
                          fontWeight: "700",
                          fontFamily: fonts.bold,
                        }}
                      >
                        {firebaseWrites}
                      </Text>
                    </View>
                    <TouchableOpacity
                      onPress={resetFirebaseOps}
                      style={{
                        backgroundColor: isDarkMode ? "#3A3F4B" : "#F3F4F6",
                        paddingVertical: 6,
                        paddingHorizontal: 10,
                        borderRadius: 4,
                        alignItems: "center",
                      }}
                    >
                      <Text
                        style={{
                          fontSize: 11,
                          color: isDarkMode ? "#D1D5DB" : "#374151",
                          fontWeight: "600",
                        }}
                      >
                        Reset
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              )}
              {/* Show button to reopen dev tools if closed */}
              {showDevTools && !devToolsVisible && Platform.OS === "web" && (
                <TouchableOpacity
                  onPress={() => {
                    setDevToolsVisible(true);
                    setDevToolsPosition({ top: 10, right: 10 }); // Reset position
                  }}
                  style={{
                    position: "fixed" as any,
                    bottom: 10,
                    right: 10,
                    backgroundColor: isDarkMode
                      ? "rgba(26, 29, 35, 0.95)"
                      : "rgba(255, 255, 255, 0.95)",
                    padding: 8,
                    borderRadius: 20,
                    borderWidth: 1,
                    borderColor: isDarkMode ? "#3A3F4B" : "#E5E7EB",
                    zIndex: 999999,
                    shadowColor: "#000",
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.25,
                    shadowRadius: 4,
                  }}
                >
                  <Text style={{ fontSize: 16 }}>🔧</Text>
                </TouchableOpacity>
              )}
              <Stack.Navigator
                screenOptions={{ headerShown: false }}
                initialRouteName={getInitialRouteName()}
              >
                <Stack.Screen name="Home">
                  {(props) => (
                    <HomeScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                      setCurrentLanguage={setCurrentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="Login">
                  {(props) => (
                    <LoginScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="Signup">
                  {(props) => (
                    <SignupScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="VerificationRequired">
                  {(props) => (
                    <VerificationRequiredScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="ProfileSetup">
                  {(props) => (
                    <ProfileSetupScreen {...props} isDarkMode={isDarkMode} />
                  )}
                </Stack.Screen>
                <Stack.Screen name="ForgotPassword">
                  {(props) => (
                    <ForgotPasswordScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="Jobs">
                  {(props) => (
                    <JobsScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                      setCurrentLanguage={setCurrentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="CategoryJobs">
                  {(props) => (
                    <JobsScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                      setCurrentLanguage={setCurrentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="Companies">
                  {(props) => (
                    <CompaniesScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                      setCurrentLanguage={setCurrentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="CompanyDetails">
                  {(props) => (
                    <CompanyDetailsScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                      setCurrentLanguage={setCurrentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="Bookmarks">
                  {(props) => (
                    <BookmarksScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                      setCurrentLanguage={setCurrentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="Notifications">
                  {(props) => (
                    <NotificationsScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="Settings">
                  {(props) => (
                    <SettingsScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                      setCurrentLanguage={setCurrentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="CompanyRegistration">
                  {(props) => (
                    <CompanyRegistrationScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="CompanyDashboard">
                  {(props) => (
                    <CompanyDashboardScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="SettingsProfile">
                  {(props) => (
                    <SettingsProfileScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="SettingsLanguage">
                  {(props) => (
                    <SettingsLanguageScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="SettingsInterests">
                  {(props) => (
                    <SettingsInterestsScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="SettingsSubscription">
                  {(props) => (
                    <SettingsSubscriptionScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="JobDetails">
                  {(props) => (
                    <JobDetailsScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                      setCurrentLanguage={setCurrentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="JobApplication">
                  {(props) => (
                    <JobApplicationScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="CompanyApplicants">
                  {(props) => (
                    <CompanyApplicantsScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="CandidateBrowse">
                  {(props) => (
                    <CandidateBrowseScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="AdminPanel">
                  {(props) => (
                    <AdminPanelScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="Unauthorized">
                  {(props) => (
                    <UnauthorizedScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      colors={colors}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="Privacy">
                  {(props) => (
                    <PrivacyPolicyScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="Terms">
                  {(props) => (
                    <TermsOfServiceScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="JobAlerts">
                  {(props) => (
                    <JobAlertsScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="CareerAdvice">
                  {(props) => (
                    <CareerAdviceScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="ResumeTips">
                  {(props) => (
                    <ResumeTipsScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                      currentLanguage={currentLanguage}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="RecruitmentTips">
                  {(props) => (
                    <RecruitmentTipsScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                    />
                  )}
                </Stack.Screen>
                {/* Payment screen hidden behind feature flag — set FEATURES.PAYMENTS_ENABLED=true to restore */}
                {FEATURES.PAYMENTS_ENABLED && (
                  <Stack.Screen name="Payment">
                    {(props) => (
                      <PaymentScreen
                        {...props}
                        isDarkMode={isDarkMode}
                        toggleTheme={toggleTheme}
                        colors={colors}
                      />
                    )}
                  </Stack.Screen>
                )}
                <Stack.Screen name="ThankYou">
                  {(props) => (
                    <ThankYouScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                    />
                  )}
                </Stack.Screen>
                <Stack.Screen name="PublicProfile">
                  {(props) => (
                    <PublicProfileScreen {...props} isDarkMode={isDarkMode} />
                  )}
                </Stack.Screen>
                <Stack.Screen name="NotFound">
                  {(props) => (
                    <NotFoundScreen
                      {...props}
                      isDarkMode={isDarkMode}
                      toggleTheme={toggleTheme}
                      colors={colors}
                    />
                  )}
                </Stack.Screen>
              </Stack.Navigator>
            </NavigationContainer>
          </FirebaseOpsContext.Provider>
          <AppAlertModal
            state={appAlertState}
            onDismiss={dismissAppAlert}
            isDarkMode={isDarkMode}
          />
        </AppAlertContext.Provider>
      </SafeAreaView>
    </SafeAreaProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: lightColors.white,
    width: "100%",
    overflow: "hidden",
  },
  loadingContainer: {
    flex: 1,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: lightColors.beeYellow,
  },
  loadingText: {
    fontSize: 32,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 10,
  },
  loadingSubtext: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  loginContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 40,
    backgroundColor: lightColors.white,
  },

  // Modern Auth Screens Styles
  authScrollContainer: {
    flexGrow: 1,
    paddingVertical: 16,
    backgroundColor: "#F8FAFB",
  },
  authContainer: {
    flex: 1,
    alignItems: "center",
    paddingHorizontal: 20,
    maxWidth: 440,
    width: "100%",
    alignSelf: "center",
  },
  authHeaderSection: {
    alignItems: "center",
    marginBottom: 24,
    paddingTop: 20,
  },
  authLogoContainer: {
    width: 72,
    height: 72,
    borderRadius: 24,
    backgroundColor: lightColors.beeYellow,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 20,
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 6,
  },
  authLogoImage: {
    width: 44,
    height: 44,
  },
  authTitle: {
    fontSize: 28,
    fontWeight: "700",
    color: lightColors.deepNavy,
    marginBottom: 6,
    letterSpacing: -0.3,
  },
  authSubtitle: {
    fontSize: 15,
    color: lightColors.warmGray,
    textAlign: "center",
    lineHeight: 22,
  },
  authFormCard: {
    width: "100%",
    backgroundColor: lightColors.white,
    borderRadius: 20,
    padding: 24,
    borderWidth: 1,
    borderColor: "#F0F0F0",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 8,
    elevation: 2,
    marginBottom: 16,
  },

  // Floating Label Input Styles
  floatingInputContainer: {
    marginBottom: 16,
  },
  floatingInputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F8FAFB",
    borderRadius: 16,
    paddingHorizontal: 18,
    paddingVertical: 14,
    borderWidth: 1.5,
    borderColor: "#E5E7EB",
    minHeight: 68,
  },
  floatingInputFocused: {
    borderColor: lightColors.beeYellow,
    backgroundColor: lightColors.white,
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 2,
  },
  floatingInputIcon: {
    marginRight: 14,
  },
  floatingInputTextContainer: {
    flex: 1,
    justifyContent: "center",
  },
  floatingLabel: {
    fontSize: 11,
    color: lightColors.beeYellow,
    fontWeight: "700",
    marginBottom: 3,
    textTransform: "uppercase",
    letterSpacing: 0.8,
  },
  floatingInput: {
    fontSize: 16,
    color: lightColors.deepNavy,
    padding: 0,
    margin: 0,
    fontWeight: "500",
    lineHeight: 22,
  },

  // Auth Buttons
  authPrimaryButton: {
    backgroundColor: "#F4C430",
    height: 60,
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 12,
    shadowColor: "#F4C430",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 5,
  },
  authButtonDisabled: {
    opacity: 0.5,
  },
  authButtonContent: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  authPrimaryButtonText: {
    color: "#1A1D23",
    fontSize: 17,
    fontWeight: "700",
    letterSpacing: 0.3,
  },
  authGoogleButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: lightColors.white,
    height: 60,
    borderRadius: 16,
    borderWidth: 1.5,
    borderColor: "#E5E7EB",
    gap: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 1,
  },
  googleIconContainer: {
    width: 24,
    height: 24,
    borderRadius: 4,
    backgroundColor: "#4285F4",
    alignItems: "center",
    justifyContent: "center",
  },
  googleIconText: {
    color: "#FFFFFF",
    fontSize: 16,
    fontWeight: "700",
    fontFamily: "Arial",
  },
  authGoogleButtonText: {
    color: lightColors.deepNavy,
    fontSize: 16,
    fontWeight: "600",
  },

  // Auth Divider
  authDivider: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 28,
    gap: 14,
  },
  authDividerLine: {
    flex: 1,
    height: 1,
    backgroundColor: "#E5E7EB",
  },
  authDividerText: {
    fontSize: 12,
    color: lightColors.warmGray,
    fontWeight: "700",
    letterSpacing: 0.8,
  },

  // Auth Footer Links
  authFooterLink: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 28,
  },
  authFooterLinkText: {
    fontSize: 16,
    color: lightColors.warmGray,
    lineHeight: 24,
  },
  authFooterLinkHighlight: {
    fontSize: 16,
    color: lightColors.beeYellow,
    fontWeight: "700",
  },
  authBackButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 24,
    marginBottom: 20,
    gap: 8,
    paddingVertical: 12,
  },
  authBackButtonText: {
    fontSize: 15,
    color: lightColors.warmGray,
    fontWeight: "500",
  },

  forgotPasswordLink: {
    alignSelf: "flex-end",
    marginTop: 4,
    marginBottom: 4,
    paddingVertical: 8,
    paddingHorizontal: 4,
  },
  forgotPasswordText: {
    fontSize: 15,
    color: lightColors.beeYellow,
    fontWeight: "700",
  },

  authInfoBanner: {
    backgroundColor: lightColors.beeYellow,
    padding: 18,
    marginBottom: 20,
    borderRadius: 16,
    flexDirection: "row",
    alignItems: "center",
    gap: 14,
    width: "100%",
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    elevation: 2,
  },
  authInfoBannerText: {
    flex: 1,
    fontSize: 15,
    color: lightColors.deepNavy,
    fontWeight: "600",
    lineHeight: 22,
  },

  authErrorBanner: {
    backgroundColor: "#fee2e2",
    padding: 18,
    marginBottom: 20,
    borderRadius: 16,
    flexDirection: "row",
    alignItems: "center",
    gap: 14,
    width: "100%",
    borderWidth: 1.5,
    borderColor: "#fca5a5",
    shadowColor: "#dc2626",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 2,
  },
  authErrorBannerText: {
    fontSize: 15,
    color: "#dc2626",
    fontWeight: "600",
    lineHeight: 22,
  },

  loginHeader: {
    alignItems: "center",
    marginBottom: 40,
  },
  loginLogo: {
    fontSize: 60,
    marginBottom: 16,
  },
  loginTitle: {
    fontSize: 32,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 8,
  },
  loginSubtitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  verificationMessageContainer: {
    alignItems: "center",
    paddingVertical: 40,
  },
  verificationContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    backgroundColor: "#FFFFFF",
    minHeight: "100vh",
  },
  successCircle: {
    width: 140,
    height: 140,
    borderRadius: 70,
    backgroundColor: "#FFF9E6",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 32,
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 12,
  },
  successCircleInner: {
    width: 110,
    height: 110,
    borderRadius: 55,
    backgroundColor: "#FFF4CC",
    alignItems: "center",
    justifyContent: "center",
  },
  verificationHeader: {
    alignItems: "center",
    marginBottom: 32,
  },
  verificationMainTitle: {
    fontSize: 32,
    fontFamily: fonts.bold,
    color: lightColors.deepNavy,
    marginBottom: 12,
    textAlign: "center",
  },
  verificationSubtitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    textAlign: "center",
    marginBottom: 12,
  },
  emailBadgeContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#FFF9E6",
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 24,
    gap: 8,
    marginTop: 8,
  },
  emailBadge: {
    fontSize: 16,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
  },
  instructionsCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 20,
    padding: 24,
    width: "100%",
    maxWidth: 500,
    marginBottom: 32,
    borderWidth: 2,
    borderColor: "#F5F5F5",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
  },
  instructionStep: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 16,
  },
  stepNumberCircle: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: lightColors.beeYellow,
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  stepNumber: {
    fontSize: 18,
    fontFamily: fonts.bold,
    color: lightColors.deepNavy,
  },
  stepContent: {
    flex: 1,
    paddingTop: 4,
  },
  stepTitle: {
    fontSize: 18,
    fontFamily: fonts.semiBold,
    color: lightColors.deepNavy,
    marginBottom: 4,
  },
  stepDescription: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    lineHeight: 20,
  },
  stepDivider: {
    height: 1,
    backgroundColor: "#F0F0F0",
    marginVertical: 20,
  },
  verificationActions: {
    width: "100%",
    maxWidth: 500,
    gap: 12,
  },
  primaryVerificationButton: {
    backgroundColor: lightColors.deepNavy,
    borderRadius: 16,
    paddingVertical: 18,
    paddingHorizontal: 24,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    shadowColor: lightColors.deepNavy,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
  },
  primaryVerificationButtonText: {
    fontSize: 18,
    fontFamily: fonts.semiBold,
    color: "#FFFFFF",
  },
  secondaryVerificationButton: {
    backgroundColor: "transparent",
    borderRadius: 16,
    paddingVertical: 18,
    paddingHorizontal: 24,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    borderWidth: 2,
    borderColor: "#E5E5E5",
  },
  verificationTitle: {
    fontSize: 24,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 16,
    textAlign: "center",
  },
  verificationMessage: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    textAlign: "center",
    marginBottom: 12,
    lineHeight: 24,
  },
  verificationEmail: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.beeYellow,
    marginBottom: 20,
    textAlign: "center",
  },
  successMessageContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#e8f5e9",
    padding: 16,
    borderRadius: 12,
    marginTop: 20,
    marginBottom: 20,
  },
  successMessageText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.success,
    flex: 1,
  },
  buttonDisabled: {
    opacity: 0.6,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  modalContent: {
    backgroundColor: lightColors.white,
    borderRadius: 16,
    padding: 24,
    width: "100%",
    maxWidth: 400,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  modalTitle: {
    fontSize: 24,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 8,
    textAlign: "center",
  },
  modalDescription: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginBottom: 24,
    textAlign: "center",
    lineHeight: 20,
  },
  modalButtons: {
    flexDirection: "row",
    marginTop: 16,
  },
  loginForm: {
    width: "100%",
    maxWidth: 400,
  },
  inputGroup: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: lightColors.lightGray,
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 4,
    borderWidth: 2,
    borderColor: "transparent",
  },
  inputError: {
    borderColor: lightColors.danger,
    backgroundColor: "#fef2f2",
  },
  errorText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.danger,
    marginTop: 8,
    marginBottom: 8,
  },
  inputIcon: {
    marginRight: 12,
  },
  modernInput: {
    flex: 1,
    height: 50,
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  modernLoginButton: {
    backgroundColor: lightColors.beeYellow,
    height: 56,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 24,
    paddingHorizontal: 24,
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 4,
  },
  loginButtonDisabled: {
    backgroundColor: lightColors.warmGray,
    shadowOpacity: 0.1,
  },
  buttonContent: {
    flexDirection: "row",
    alignItems: "center",
  },
  loadingButtonContent: {
    flexDirection: "row",
    alignItems: "center",
  },
  modernLoginButtonText: {
    color: lightColors.deepNavy,
    fontSize: 16,
    fontFamily: fonts.regular,
    marginRight: 8,
  },
  modernSecondaryButton: {
    backgroundColor: "transparent",
    height: 56,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
    marginTop: 40,
    borderWidth: 2,
    borderColor: lightColors.beeYellow,
  },
  modernSecondaryButtonText: {
    color: lightColors.beeYellow,
    fontSize: 16,
    fontFamily: fonts.regular,
  },
  successMessageContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: `${lightColors.success}20`,
    padding: 12,
    borderRadius: 8,
    marginVertical: 16,
  },
  successMessageText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.success,
    marginLeft: 8,
  },
  backToHome: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 32,
    paddingVertical: 8,
  },
  backToHomeText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.softBlue,
    marginLeft: 8,
  },
  inputContainer: {
    marginBottom: 20,
  },
  // Jobs Page Styles
  jobsToolbar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 24,
    paddingVertical: 10,
    minHeight: 64,
    backgroundColor: lightColors.white,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.lightGray,
    overflow: "hidden",
    width: "100%",
    maxWidth: "100vw",
    gap: 8,
  },
  jobsToolbarLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    flex: 1,
    overflow: "hidden",
  },
  toolbarLogo: {
    width: 34,
    height: 34,
    marginRight: 10,
  },
  jobsToolbarRight: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  toolbarNavButton: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
  },
  toolbarBookmarksButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  toolbarNavButtonText: {
    fontSize: 14,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
  },
  toolbarSearchContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: lightColors.cream,
    borderRadius: 10,
    paddingHorizontal: 12,
    paddingVertical: 8,
    gap: 8,
    flex: 1,
    maxWidth: 360,
    minWidth: 0,
    height: 40,
  },
  toolbarSearchInput: {
    flex: 1,
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    outlineStyle: "none",
  },
  toolbarIconButton: {
    padding: 8,
    position: "relative",
  },
  bookmarkBadge: {
    position: "absolute",
    top: 2,
    right: 2,
    backgroundColor: lightColors.beeYellow,
    borderRadius: 10,
    minWidth: 18,
    height: 18,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 4,
  },
  bookmarkBadgeText: {
    fontSize: 10,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  toolbarLanguageContainer: {
    position: "relative",
    zIndex: 1000,
  },
  toolbarLanguageButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    paddingHorizontal: 10,
    paddingVertical: 0,
    height: 38,
    backgroundColor: lightColors.cream,
    borderRadius: 10,
  },
  toolbarLanguageText: {
    fontSize: 13,
    fontFamily: fonts.semiBold,
    color: lightColors.deepNavy,
    letterSpacing: 0.3,
  },
  languageMenu: {
    position: "absolute",
    top: 45,
    right: 0,
    backgroundColor: lightColors.white,
    borderRadius: 8,
    paddingVertical: 8,
    minWidth: 180,
    maxHeight: 300,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 5,
    zIndex: 1001,
    borderWidth: 1,
    borderColor: lightColors.lightGray,
  },
  languageMenuItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 10,
  },
  languageMenuItemText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  languageMenuItemTextActive: {
    color: lightColors.beeYellow,
    fontWeight: "600",
  },
  toolbarUserName: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  toolbarSettingsButton: {
    padding: 8,
  },
  toolbarLogoutButton: {
    padding: 8,
  },
  toolbarProfilePicture: {
    width: 36,
    height: 36,
    borderRadius: 18,
    borderWidth: 2,
    borderColor: lightColors.beeYellow,
  },
  toolbarProfilePlaceholder: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: lightColors.beeYellow,
    justifyContent: "center",
    alignItems: "center",
  },
  toolbarLoginButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderWidth: 1,
    borderColor: lightColors.deepNavy,
    borderRadius: 8,
  },
  toolbarLoginButtonText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  toolbarSignupButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: lightColors.beeYellow,
    borderRadius: 8,
  },
  toolbarSignupButtonText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  // Theme Toggle Switch Styles
  toolbarThemeToggle: {
    marginRight: 12,
  },
  themeToggleTrack: {
    width: 64,
    height: 28,
    borderRadius: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 4,
    position: "relative",
  },
  themeToggleIconLeft: {
    position: "absolute",
    left: 6,
    zIndex: 1,
  },
  themeToggleIconRight: {
    position: "absolute",
    right: 6,
    zIndex: 1,
  },
  themeToggleKnob: {
    width: 24,
    height: 24,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    left: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
    elevation: 2,
    transition: "left 0.2s ease",
  },
  themeToggleKnobActive: {
    left: 38,
  },
  // Settings Screen Styles
  settingsHeader: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 24,
    paddingVertical: 16,
    backgroundColor: lightColors.white,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.lightGray,
    gap: 16,
  },
  settingsBackButton: {
    padding: 8,
  },
  settingsTitle: {
    fontSize: 24,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  settingsContainer: {
    flex: 1,
    backgroundColor: lightColors.cream,
  },
  settingsSplitContainer: {
    flex: 1,
    flexDirection: "row",
  },
  settingsSidebar: {
    flex: 1,
    borderRightWidth: 1,
    borderRightColor: lightColors.lightGray,
    minWidth: 280,
    maxWidth: 320,
  },
  // Modern Profile Header
  modernProfileHeader: {
    flexDirection: "row",
    alignItems: "center",
    padding: 20,
    gap: 12,
    borderBottomWidth: 1,
    marginBottom: 8,
  },
  modernProfileImage: {
    width: 56,
    height: 56,
    borderRadius: 28,
  },
  modernProfileImagePlaceholder: {
    width: 56,
    height: 56,
    borderRadius: 28,
    justifyContent: "center",
    alignItems: "center",
  },
  modernProfileInfo: {
    flex: 1,
  },
  modernProfileName: {
    fontSize: 16,
    fontFamily: fonts.regular,
    fontWeight: "600",
    marginBottom: 2,
  },
  modernProfileEmail: {
    fontSize: 13,
    fontFamily: fonts.regular,
  },
  modernProfileUsername: {
    fontSize: 12,
    fontFamily: fonts.regular,
    fontWeight: "500",
  },
  // Modern Menu Items
  modernMenuContainer: {
    paddingVertical: 8,
  },
  modernMenuItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingVertical: 14,
    gap: 12,
    borderLeftWidth: 3,
    borderLeftColor: "transparent",
  },
  modernMenuItemActive: {
    borderLeftWidth: 3,
  },
  modernMenuTextContainer: {
    flex: 1,
  },
  modernMenuTitle: {
    fontSize: 15,
    fontFamily: fonts.regular,
    fontWeight: "500",
  },
  modernMenuTitleActive: {
    fontWeight: "600",
  },
  // Modern Logout Button
  modernLogoutButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 16,
    marginTop: 16,
    marginHorizontal: 20,
    gap: 8,
    borderTopWidth: 1,
  },
  modernLogoutText: {
    fontSize: 15,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  settingsContentArea: {
    flex: 4,
  },
  settingsContentScroll: {
    flex: 1,
  },
  settingsContentSection: {
    padding: 32,
  },
  settingsContentTitle: {
    fontSize: 32,
    fontFamily: fonts.regular,
    fontWeight: "700",
    marginBottom: 8,
  },
  settingsContentSubtitle: {
    fontSize: 15,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginBottom: 32,
  },
  settingsSection: {
    gap: 16,
  },
  settingsSectionTitle: {
    fontSize: 20,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 8,
  },
  settingsSectionSubtitle: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginBottom: 16,
  },
  settingsCard: {
    backgroundColor: lightColors.white,
    borderRadius: 12,
    padding: 20,
    alignItems: "center",
    gap: 12,
  },
  settingsUserEmail: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  settingsLoadingContainer: {
    padding: 40,
    alignItems: "center",
  },
  categoriesGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
  },
  categoryCard: {
    backgroundColor: lightColors.white,
    borderRadius: 12,
    padding: 16,
    borderWidth: 2,
    borderColor: lightColors.lightGray,
    minWidth: 150,
  },
  categoryCardSelected: {
    borderColor: lightColors.beeYellow,
    backgroundColor: lightColors.cream,
  },
  categoryCardContent: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 8,
  },
  categoryCardText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  categoryCardTextSelected: {
    color: lightColors.deepNavy,
    fontWeight: "600",
  },
  settingsSaveButton: {
    backgroundColor: lightColors.beeYellow,
    borderRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 24,
    marginRight: 24,
    marginBottom: 24,
    marginTop: 16,
    alignSelf: "flex-end",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 120,
  },
  settingsSaveButtonDisabled: {
    opacity: 0.6,
  },
  // New Modern Settings Styles
  settingsHeroSection: {
    padding: 24,
    borderBottomWidth: 1,
  },
  settingsHeroContent: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  settingsHeroLeft: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  settingsHeroAvatar: {
    width: 80,
    height: 80,
    borderRadius: 40,
  },
  settingsHeroAvatarPlaceholder: {
    width: 80,
    height: 80,
    borderRadius: 40,
    justifyContent: "center",
    alignItems: "center",
  },
  settingsHeroInfo: {
    marginLeft: 16,
    flex: 1,
  },
  settingsHeroName: {
    fontSize: 24,
    fontFamily: fonts.regular,
    fontWeight: "700",
    marginBottom: 4,
  },
  settingsHeroEmail: {
    fontSize: 14,
    fontFamily: fonts.regular,
    marginBottom: 4,
  },
  settingsHeroUsernameContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginTop: 4,
  },
  settingsHeroUsername: {
    fontSize: 14,
    fontFamily: fonts.regular,
    fontWeight: "500",
  },
  settingsEditProfileButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 8,
    borderWidth: 2,
  },
  settingsEditProfileText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  settingsGridContainer: {
    padding: 20,
    gap: 16,
  },
  settingsCard: {
    flexDirection: "row",
    alignItems: "center",
    padding: 20,
    borderRadius: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
  },
  settingsCardIconContainer: {
    width: 56,
    height: 56,
    borderRadius: 28,
    justifyContent: "center",
    alignItems: "center",
  },
  settingsCardContent: {
    flex: 1,
    marginLeft: 16,
  },
  settingsCardTitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    fontWeight: "600",
    marginBottom: 4,
  },
  settingsCardSubtitle: {
    fontSize: 13,
    fontFamily: fonts.regular,
  },
  settingsQuickActions: {
    padding: 20,
  },
  settingsQuickActionsTitle: {
    fontSize: 18,
    fontFamily: fonts.regular,
    fontWeight: "700",
    marginBottom: 16,
  },
  settingsQuickActionsGrid: {
    flexDirection: "row",
    gap: 12,
  },
  settingsQuickActionCard: {
    flex: 1,
    padding: 16,
    borderRadius: 12,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },
  settingsQuickActionText: {
    fontSize: 12,
    fontFamily: fonts.regular,
    fontWeight: "600",
    marginTop: 8,
    textAlign: "center",
  },
  settingsQuickActionCount: {
    fontSize: 11,
    fontFamily: fonts.regular,
    marginTop: 2,
  },
  settingsFooter: {
    padding: 20,
    alignItems: "center",
  },
  settingsFooterText: {
    fontSize: 12,
    fontFamily: fonts.regular,
  },

  // Modern Profile Page Styles
  modernProfileHeader: {
    alignItems: "center",
    paddingTop: 32,
    paddingBottom: 24,
    paddingHorizontal: 20,
    borderBottomLeftRadius: 24,
    borderBottomRightRadius: 24,
  },
  modernProfileAvatarContainer: {
    position: "relative",
    marginBottom: 16,
  },
  modernProfileAvatar: {
    width: 100,
    height: 100,
    borderRadius: 50,
    borderWidth: 4,
    borderColor: "#F4C430",
  },
  modernProfileAvatarPlaceholder: {
    width: 100,
    height: 100,
    borderRadius: 50,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 4,
    borderColor: "#F4C430",
  },
  modernProfileEditAvatarButton: {
    position: "absolute",
    bottom: 0,
    right: 0,
    width: 32,
    height: 32,
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 3,
    borderColor: "#fff",
  },
  modernProfileName: {
    fontSize: 24,
    fontFamily: fonts.bold,
    fontWeight: "700",
    marginBottom: 4,
    textAlign: "center",
  },
  modernProfileEmail: {
    fontSize: 14,
    fontFamily: fonts.regular,
    marginBottom: 12,
    textAlign: "center",
  },
  modernProfileBadge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 20,
    marginBottom: 16,
  },
  modernProfileBadgeText: {
    fontSize: 13,
    fontFamily: fonts.medium,
    fontWeight: "500",
  },
  modernProfileEditButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingHorizontal: 28,
    paddingVertical: 12,
    borderRadius: 24,
    borderWidth: 2,
  },
  modernProfileEditButtonText: {
    fontSize: 15,
    fontFamily: fonts.bold,
    fontWeight: "600",
  },
  modernStatsContainer: {
    flexDirection: "row",
    paddingHorizontal: 16,
    paddingTop: 20,
    gap: 12,
  },
  modernStatCard: {
    flex: 1,
    alignItems: "center",
    padding: 20,
    borderRadius: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
  },
  modernStatIconCircle: {
    width: 48,
    height: 48,
    borderRadius: 24,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 12,
  },
  modernStatNumber: {
    fontSize: 20,
    fontFamily: fonts.bold,
    fontWeight: "700",
    marginBottom: 4,
  },
  modernStatLabel: {
    fontSize: 12,
    fontFamily: fonts.regular,
    textAlign: "center",
  },
  modernMenuContainer: {
    paddingHorizontal: 16,
    paddingTop: 24,
  },
  modernSectionTitle: {
    fontSize: 12,
    fontFamily: fonts.bold,
    fontWeight: "600",
    letterSpacing: 1,
    marginBottom: 12,
    paddingHorizontal: 4,
  },
  modernMenuItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    paddingHorizontal: 16,
    borderRadius: 12,
    marginBottom: 1,
  },
  modernMenuIconCircle: {
    width: 44,
    height: 44,
    borderRadius: 22,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 14,
  },
  modernMenuTextContainer: {
    flex: 1,
  },
  modernMenuTitle: {
    fontSize: 16,
    fontFamily: fonts.medium,
    fontWeight: "600",
    marginBottom: 2,
  },
  modernMenuSubtitle: {
    fontSize: 13,
    fontFamily: fonts.regular,
  },
  modernProfileFooter: {
    alignItems: "center",
    paddingVertical: 32,
    gap: 4,
  },
  modernProfileFooterText: {
    fontSize: 12,
    fontFamily: fonts.regular,
  },

  settingsModalHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
  },
  settingsModalBackButton: {
    width: 40,
    height: 40,
    justifyContent: "center",
    alignItems: "center",
  },
  settingsModalTitle: {
    fontSize: 18,
    fontFamily: fonts.regular,
    fontWeight: "700",
  },
  settingsSaveButtonText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    fontWeight: "600",
  },
  // New Settings Styles
  settingsProfileCard: {
    flexDirection: "row",
    alignItems: "center",
    padding: 20,
    borderRadius: 12,
    gap: 16,
  },
  settingsProfileImage: {
    width: 80,
    height: 80,
    borderRadius: 40,
  },
  settingsProfileImagePlaceholder: {
    width: 80,
    height: 80,
    borderRadius: 40,
    justifyContent: "center",
    alignItems: "center",
  },
  settingsProfileInfo: {
    flex: 1,
  },
  settingsProfileName: {
    fontSize: 20,
    fontFamily: fonts.regular,
    fontWeight: "600",
    marginBottom: 4,
  },
  settingsProfileEmail: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  settingsMenuItem: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    borderRadius: 12,
    marginBottom: 12,
    gap: 12,
  },
  settingsMenuIconContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    justifyContent: "center",
    alignItems: "center",
  },
  settingsMenuContent: {
    flex: 1,
  },
  settingsMenuTitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    fontWeight: "600",
    marginBottom: 4,
  },
  settingsMenuSubtitle: {
    fontSize: 13,
    fontFamily: fonts.regular,
  },
  settingsLogoutButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    borderRadius: 12,
    borderWidth: 2,
    gap: 8,
  },
  settingsLogoutButtonText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  // Profile Settings Styles
  settingsInputGroup: {
    padding: 16,
    borderRadius: 12,
    marginBottom: 12,
  },
  settingsInputLabel: {
    fontSize: 14,
    fontFamily: fonts.regular,
    fontWeight: "600",
    marginBottom: 8,
  },
  settingsTextInput: {
    fontSize: 16,
    fontFamily: fonts.regular,
    padding: 12,
    borderRadius: 8,
    outlineStyle: "none",
  },
  settingsTextAreaInput: {
    minHeight: 100,
    paddingTop: 12,
  },
  settingsTextInputDisabled: {
    opacity: 0.6,
  },
  settingsInputHint: {
    fontSize: 12,
    fontFamily: fonts.regular,
    marginTop: 4,
  },
  profilePictureContainer: {
    alignItems: "center",
    gap: 12,
  },
  profilePicturePreview: {
    width: 120,
    height: 120,
    borderRadius: 60,
  },
  profilePicturePlaceholder: {
    width: 120,
    height: 120,
    borderRadius: 60,
    justifyContent: "center",
    alignItems: "center",
  },
  uploadPhotoButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
    marginTop: 8,
  },
  uploadPhotoButtonText: {
    fontSize: 15,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  // Modern Profile Section Styles
  modernProfilePictureSection: {
    alignItems: "center",
    marginBottom: 32,
    gap: 16,
  },
  modernProfilePicturePreview: {
    width: 140,
    height: 140,
    borderRadius: 70,
  },
  modernProfilePicturePlaceholder: {
    width: 140,
    height: 140,
    borderRadius: 70,
    justifyContent: "center",
    alignItems: "center",
  },
  modernUploadButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    paddingVertical: 12,
    paddingHorizontal: 28,
    borderRadius: 8,
  },
  modernUploadButtonText: {
    fontSize: 15,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  modernInputCard: {
    padding: 20,
    borderRadius: 12,
    marginBottom: 16,
  },
  modernInputLabel: {
    fontSize: 14,
    fontFamily: fonts.regular,
    fontWeight: "600",
    marginBottom: 12,
  },
  modernInput: {
    fontSize: 16,
    fontFamily: fonts.regular,
    padding: 16,
    borderRadius: 8,
    borderWidth: 1,
    outlineStyle: "none",
  },
  modernTextInput: {
    fontSize: 16,
    fontFamily: fonts.regular,
    padding: 16,
    borderRadius: 8,
    borderWidth: 1,
    outlineStyle: "none",
  },
  modernTextArea: {
    minHeight: 120,
    paddingTop: 16,
    textAlignVertical: "top",
  },
  modernTextInputDisabled: {
    opacity: 0.6,
  },
  modernInputHint: {
    fontSize: 13,
    fontFamily: fonts.regular,
    marginTop: 8,
  },
  modernSaveButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingVertical: 14,
    paddingHorizontal: 32,
    borderRadius: 8,
    marginTop: 16,
    alignSelf: "flex-start",
  },
  modernSaveButtonDisabled: {
    opacity: 0.6,
  },
  modernSaveButtonText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  // Portfolio Styles
  portfolioLinkCard: {
    padding: 20,
    borderRadius: 12,
    marginTop: 16,
    marginBottom: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
  },
  portfolioLinkTitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  portfolioLinkSubtitle: {
    fontSize: 13,
    fontFamily: fonts.regular,
    marginTop: 2,
  },
  portfolioLinkBox: {
    padding: 12,
    borderRadius: 8,
    marginTop: 8,
  },
  portfolioLinkText: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  portfolioActionButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingVertical: 10,
    borderRadius: 8,
  },
  portfolioActionButtonText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  portfolioCVCard: {
    padding: 20,
    borderRadius: 12,
    marginBottom: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
  },
  cvUploadButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    paddingVertical: 16,
    borderRadius: 8,
    borderWidth: 2,
    borderStyle: "dashed",
  },
  cvUploadButtonText: {
    fontSize: 15,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },

  // Modern Settings Content Styles
  settingsContentScroll: {
    flex: 1,
    backgroundColor: "#F5F7FA",
  },
  settingsContentSection: {
    padding: 20,
  },
  settingsContentTitle: {
    fontSize: 24,
    fontFamily: fonts.bold,
    fontWeight: "700",
    marginBottom: 8,
  },
  settingsContentSubtitle: {
    fontSize: 15,
    fontFamily: fonts.regular,
    marginBottom: 24,
    lineHeight: 22,
  },
  settingsSection: {
    gap: 16,
  },
  settingsSectionTitle: {
    fontSize: 18,
    fontFamily: fonts.bold,
    fontWeight: "600",
    marginBottom: 16,
  },
  modernIconCircle: {
    width: 48,
    height: 48,
    borderRadius: 24,
    justifyContent: "center",
    alignItems: "center",
  },
  modernToggleRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 4,
  },
  modernToggleLeft: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  modernToggleTitle: {
    fontSize: 16,
    fontFamily: fonts.medium,
    fontWeight: "600",
    marginBottom: 2,
  },
  modernToggleSubtitle: {
    fontSize: 13,
    fontFamily: fonts.regular,
    marginTop: 2,
  },

  // Category/Interest Selection Styles
  categorySelectionCard: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },
  categoryHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  categoryIconCircle: {
    width: 44,
    height: 44,
    borderRadius: 22,
    justifyContent: "center",
    alignItems: "center",
  },
  categoryInfo: {
    flex: 1,
  },
  categoryName: {
    fontSize: 16,
    fontFamily: fonts.bold,
    fontWeight: "600",
  },
  categoryDescription: {
    fontSize: 13,
    fontFamily: fonts.regular,
    marginTop: 2,
  },
  selectedBadge: {
    backgroundColor: "#F4C430",
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
  },
  selectedBadgeText: {
    fontSize: 12,
    fontFamily: fonts.bold,
    fontWeight: "600",
  },
  tagChip: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 20,
    borderWidth: 1,
  },
  tagChipText: {
    fontSize: 13,
    fontFamily: fonts.medium,
    fontWeight: "500",
  },

  // Plan/Subscription Card Styles
  settingsCurrentPlanCard: {
    padding: 20,
    borderRadius: 12,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 3,
  },
  settingsCurrentPlanName: {
    fontSize: 20,
    fontFamily: fonts.bold,
    fontWeight: "700",
    marginBottom: 8,
  },
  settingsCurrentPlanPrice: {
    fontSize: 28,
    fontFamily: fonts.bold,
    fontWeight: "700",
  },
  settingsPlanCard: {
    padding: 20,
    borderRadius: 12,
    marginBottom: 16,
    borderWidth: 1,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
  },
  settingsPlanHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 16,
  },
  settingsPlanName: {
    fontSize: 18,
    fontFamily: fonts.bold,
    fontWeight: "600",
    marginBottom: 4,
  },
  settingsPlanPrice: {
    fontSize: 24,
    fontFamily: fonts.bold,
    fontWeight: "700",
  },
  settingsCurrentBadge: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
  },
  settingsCurrentBadgeText: {
    fontSize: 12,
    fontFamily: fonts.bold,
    fontWeight: "600",
  },
  settingsPlanFeatures: {
    gap: 10,
    marginBottom: 16,
  },
  settingsPlanFeature: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  settingsPlanFeatureText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    flex: 1,
  },
  settingsUpgradeButton: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
    alignItems: "center",
  },
  settingsUpgradeButtonText: {
    fontSize: 15,
    fontFamily: fonts.bold,
    fontWeight: "600",
  },

  // Toggle/Switch Item Styles
  settingsToggleItem: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 16,
    borderRadius: 12,
    marginBottom: 8,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  settingsToggleLeft: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    gap: 12,
  },

  // Help/FAQ Styles
  faqItem: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },
  faqQuestion: {
    fontSize: 16,
    fontFamily: fonts.bold,
    fontWeight: "600",
    marginBottom: 8,
  },
  faqAnswer: {
    fontSize: 14,
    fontFamily: fonts.regular,
    lineHeight: 20,
  },

  cvUploadButtonText: {
    fontSize: 15,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  cvUploadedBox: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 12,
    borderRadius: 8,
  },
  cvUploadedText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    fontWeight: "500",
    flex: 1,
    marginLeft: 8,
  },
  cvChangeText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  // Company Preview Styles
  previewCard: {
    margin: 16,
    padding: 24,
    borderRadius: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 12,
    elevation: 4,
  },
  previewHeader: {
    alignItems: "center",
    paddingBottom: 24,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
  },
  previewAvatar: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginBottom: 16,
  },
  previewAvatarPlaceholder: {
    width: 100,
    height: 100,
    borderRadius: 50,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
  },
  previewName: {
    fontSize: 24,
    fontFamily: fonts.bold,
    marginBottom: 4,
  },
  previewJobTitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    marginBottom: 2,
  },
  previewCompany: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  previewSection: {
    paddingTop: 20,
    paddingBottom: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
  },
  previewSectionTitle: {
    fontSize: 18,
    fontFamily: fonts.bold,
    marginBottom: 12,
  },
  previewSectionText: {
    fontSize: 15,
    fontFamily: fonts.regular,
    lineHeight: 24,
  },
  previewSkillsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  previewSkillChip: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
  },
  previewSkillText: {
    fontSize: 13,
    fontFamily: fonts.regular,
    fontWeight: "500",
  },
  previewLinkRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    paddingVertical: 8,
  },
  previewLinkText: {
    fontSize: 15,
    fontFamily: fonts.regular,
    textDecorationLine: "underline",
  },
  // Modern Toggle Styles
  modernToggleRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  modernToggleLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    flex: 1,
  },
  modernIconCircle: {
    width: 48,
    height: 48,
    borderRadius: 24,
    justifyContent: "center",
    alignItems: "center",
  },
  modernToggleTitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    fontWeight: "600",
    marginBottom: 2,
  },
  modernToggleSubtitle: {
    fontSize: 13,
    fontFamily: fonts.regular,
  },
  // Appearance Settings Styles
  settingsToggleItem: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 16,
    borderRadius: 12,
    marginBottom: 12,
  },
  settingsToggleLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  settingsToggleTitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    fontWeight: "600",
    marginBottom: 4,
  },
  settingsToggleSubtitle: {
    fontSize: 13,
    fontFamily: fonts.regular,
  },
  toggleSwitch: {
    width: 52,
    height: 28,
    borderRadius: 14,
    backgroundColor: lightColors.lightGray,
    padding: 2,
    justifyContent: "center",
  },
  toggleSwitchActive: {
    backgroundColor: lightColors.beeYellow,
  },
  toggleKnob: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: lightColors.white,
  },
  toggleKnobActive: {
    marginLeft: 24,
  },
  // Language Settings Styles
  settingsSelectionItem: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 16,
    borderRadius: 12,
    marginBottom: 12,
    borderWidth: 1,
  },
  settingsSelectionLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  settingsSelectionText: {
    fontSize: 16,
    fontFamily: fonts.regular,
  },
  // Interests/Categories Styles
  settingsCategoriesGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
    marginTop: 16,
  },
  settingsCategoryChip: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 20,
    borderWidth: 1,
  },
  settingsCategoryChipText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    fontWeight: "500",
  },
  // Subscription Styles
  settingsCurrentPlanCard: {
    padding: 24,
    borderRadius: 12,
    alignItems: "center",
    gap: 8,
    marginBottom: 16,
  },
  settingsCurrentPlanName: {
    fontSize: 20,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  settingsCurrentPlanPrice: {
    fontSize: 24,
    fontFamily: fonts.regular,
    fontWeight: "700",
  },
  settingsPlanCard: {
    padding: 20,
    borderRadius: 12,
    marginBottom: 16,
    borderWidth: 1,
  },
  settingsPlanHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 16,
  },
  settingsPlanName: {
    fontSize: 18,
    fontFamily: fonts.regular,
    fontWeight: "600",
    marginBottom: 4,
  },
  settingsPlanPrice: {
    fontSize: 20,
    fontFamily: fonts.regular,
    fontWeight: "700",
  },
  settingsPlanFeatures: {
    gap: 10,
    marginBottom: 16,
  },
  settingsPlanFeature: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  settingsPlanFeatureText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    flex: 1,
  },
  settingsUpgradeButton: {
    padding: 12,
    borderRadius: 8,
    alignItems: "center",
  },
  settingsUpgradeButtonText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  settingsCurrentBadge: {
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 20,
  },
  settingsCurrentBadgeText: {
    fontSize: 12,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  // Subscription Styles
  currentPlanCard: {
    padding: 24,
    borderRadius: 12,
    alignItems: "center",
    gap: 12,
  },
  currentPlanName: {
    fontSize: 20,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  planCard: {
    padding: 20,
    borderRadius: 12,
    marginBottom: 16,
    borderWidth: 1,
  },
  planHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
  },
  planName: {
    fontSize: 18,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  planPrice: {
    fontSize: 20,
    fontFamily: fonts.regular,
    fontWeight: "700",
  },
  planFeatures: {
    gap: 10,
    marginBottom: 16,
  },
  planFeatureItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  planFeatureText: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  planUpgradeButton: {
    padding: 12,
    borderRadius: 8,
    alignItems: "center",
  },
  planUpgradeButtonText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  planCurrentBadge: {
    padding: 8,
    borderRadius: 8,
    alignItems: "center",
  },
  planCurrentBadgeText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    fontWeight: "600",
  },
  jobsPageHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 24,
    paddingVertical: 16,
    backgroundColor: lightColors.white,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.lightGray,
  },
  jobsPageHeaderLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  headerLogoImage: {
    width: 32,
    height: 32,
  },
  jobsPageTitle: {
    fontSize: 24,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  logoutButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: lightColors.lightGray,
    borderRadius: 8,
  },
  logoutButtonText: {
    fontSize: 14,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
  },
  jobsPageContainer: {
    flex: 1,
    backgroundColor: lightColors.cream,
    width: "100%",
  },
  jobsPageSearchSection: {
    padding: 24,
    backgroundColor: lightColors.white,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.lightGray,
  },
  jobsContentWithSidebar: {
    flexDirection: "row",
    padding: 16,
    gap: 16,
    alignItems: "flex-start",
    width: "100%",
    maxWidth: "100vw",
    overflow: "hidden",
  },
  jobsGridSection: {
    flex: 1,
    minWidth: 0,
    width: "100%",
  },
  filterSidebar: {
    minWidth: 250,
    maxWidth: 300,
    backgroundColor: lightColors.white,
    borderRadius: 12,
    padding: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 3,
    alignSelf: "flex-start",
    position: "sticky" as any,
    top: 0,
    height: "100vh",
    overflowY: "auto" as any,
  },
  mobileFilterButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    padding: 14,
    borderRadius: 12,
    marginBottom: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  mobileFilterButtonText: {
    fontSize: 16,
    fontWeight: "600",
    fontFamily: fonts.bold,
  },
  mobileFiltersModal: {
    flex: 1,
  },
  mobileFiltersHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
  },
  mobileFiltersTitle: {
    fontSize: 20,
    fontFamily: fonts.bold,
  },
  closeModalButton: {
    padding: 4,
  },
  mobileFiltersContent: {
    flex: 1,
  },
  mobileFiltersSidebar: {
    paddingBottom: 80,
  },
  mobileFiltersFooter: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: "#E5E7EB",
  },
  applyFiltersButton: {
    paddingVertical: 16,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
  },
  applyFiltersButtonText: {
    fontSize: 16,
    fontFamily: fonts.bold,
  },

  // Mobile Menu Styles
  mobileMenuButton: {
    padding: 4,
  },
  mobileMenuOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "flex-start",
  },
  mobileMenuBackdrop: {
    flex: 1,
  },
  mobileMenuDrawer: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    width: "80%",
    maxWidth: 300,
    shadowColor: "#000",
    shadowOffset: { width: 2, height: 0 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 5,
  },
  mobileMenuHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 16,
    borderBottomWidth: 1,
  },
  mobileMenuLogo: {
    width: 40,
    height: 40,
  },
  mobileMenuContent: {
    flex: 1,
  },
  mobileMenuUserSection: {
    padding: 20,
    alignItems: "center",
    gap: 8,
    marginBottom: 8,
  },
  mobileMenuProfilePicture: {
    width: 64,
    height: 64,
    borderRadius: 32,
  },
  mobileMenuProfilePlaceholder: {
    width: 64,
    height: 64,
    borderRadius: 32,
    justifyContent: "center",
    alignItems: "center",
  },
  mobileMenuUserName: {
    fontSize: 18,
    fontFamily: fonts.bold,
  },
  mobileMenuUserEmail: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  mobileMenuNav: {
    paddingVertical: 8,
  },
  mobileMenuItem: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    gap: 12,
    borderBottomWidth: 1,
  },
  mobileMenuItemText: {
    flex: 1,
    fontSize: 16,
    fontFamily: fonts.medium,
  },
  mobileMenuToggle: {
    width: 44,
    height: 24,
    borderRadius: 12,
    padding: 2,
    justifyContent: "center",
  },
  mobileMenuToggleKnob: {
    width: 20,
    height: 20,
    borderRadius: 10,
  },
  mobileMenuToggleKnobActive: {
    alignSelf: "flex-end",
  },
  languageChip: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 16,
    gap: 4,
    borderWidth: 1,
  },
  languageChipText: {
    fontSize: 13,
    fontFamily: fonts.medium,
  },
  mobileMenuAuthButtons: {
    padding: 16,
    gap: 12,
  },
  mobileMenuLoginButton: {
    paddingVertical: 14,
    borderRadius: 12,
    borderWidth: 2,
    alignItems: "center",
  },
  mobileMenuLoginButtonText: {
    fontSize: 16,
    fontFamily: fonts.bold,
  },
  mobileMenuSignupButton: {
    paddingVertical: 14,
    borderRadius: 12,
    alignItems: "center",
  },
  mobileMenuSignupButtonText: {
    fontSize: 16,
    fontFamily: fonts.bold,
  },
  mobileMenuLogoutButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    margin: 16,
    borderRadius: 12,
    gap: 8,
  },
  mobileMenuLogoutButtonText: {
    fontSize: 16,
    fontFamily: fonts.bold,
  },

  filterSidebarTitle: {
    fontSize: 18,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
    marginBottom: 20,
    paddingBottom: 12,
    borderBottomWidth: 2,
    borderBottomColor: lightColors.beeYellow,
  },
  filterSidebarSection: {
    marginBottom: 20,
  },
  filterSidebarLabel: {
    fontSize: 14,
    fontFamily: fonts.medium,
    color: lightColors.warmGray,
    marginBottom: 10,
  },
  filterChipsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  filterChipSmall: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: lightColors.lightGray,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "transparent",
  },
  filterChipTextSmall: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  jobsPageMainTitle: {
    fontSize: 32,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 24,
  },

  // ===== MODERN JOBS PAGE STYLES =====
  // Hero Section
  jobsHeroSection: {
    backgroundColor: lightColors.deepNavy,
    paddingVertical: 40,
    paddingHorizontal: 16,
    position: "relative",
    overflow: "hidden",
    width: "100%",
    maxWidth: "100vw",
  },
  heroBackgroundImage: {
    opacity: 0.3,
  },
  heroDarkOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(26, 54, 93, 0.85)",
  },
  heroBackgroundDecor: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  heroCircle1: {
    position: "absolute",
    width: 400,
    height: 400,
    borderRadius: 200,
    top: -200,
    right: -100,
    opacity: 0.5,
  },
  heroCircle2: {
    position: "absolute",
    width: 300,
    height: 300,
    borderRadius: 150,
    bottom: -100,
    left: -50,
    opacity: 0.3,
  },
  jobsHeroContent: {
    maxWidth: 1200,
    alignSelf: "center",
    width: "100%",
    zIndex: 1,
  },
  heroTextContainer: {
    marginBottom: 32,
  },
  jobsHeroTitle: {
    fontSize: 42,
    fontFamily: fonts.bold,
    color: lightColors.white,
    marginBottom: 12,
    textAlign: "center",
    lineHeight: 52,
  },
  jobsHeroSubtitle: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.cream,
    textAlign: "center",
  },
  heroSearchContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: lightColors.white,
    borderRadius: 50,
    paddingHorizontal: 6,
    paddingVertical: 6,
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.2,
    shadowRadius: 16,
    elevation: 12,
    maxWidth: "100%",
  },
  searchIconContainer: {
    paddingLeft: 12,
    paddingRight: 6,
  },
  heroSearchInput: {
    flex: 1,
    fontSize: 14,
    fontFamily: fonts.regular,
    paddingVertical: 10,
    paddingHorizontal: 6,
    minWidth: 0,
  },
  searchClearButton: {
    padding: 6,
  },
  searchButton: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    backgroundColor: lightColors.deepNavy,
    borderRadius: 40,
    marginLeft: 6,
  },
  searchButtonText: {
    fontSize: 14,
    fontFamily: fonts.medium,
    color: lightColors.white,
  },
  statsRow: {
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
  },
  statItem: {
    alignItems: "center",
  },
  statIconCircle: {
    width: 56,
    height: 56,
    borderRadius: 28,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 12,
  },
  statNumber: {
    fontSize: 32,
    fontFamily: fonts.bold,
    color: lightColors.beeYellow,
  },
  statLabel: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.cream,
    marginTop: 4,
  },
  statDivider: {
    width: 1,
    height: 80,
    backgroundColor: `${lightColors.cream}40`,
  },

  // Mobile App CTA Banner
  mobileAppBanner: {
    marginTop: 8,
    paddingVertical: 0,
    paddingHorizontal: 0,
    flexDirection: "column",
    gap: 8,
    width: "100%",
  },
  mobileAppBannerContent: {
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    justifyContent: "center",
  },
  mobileAppIconCircle: {
    width: 56,
    height: 56,
    borderRadius: 28,
    justifyContent: "center",
    alignItems: "center",
  },
  mobileAppTextContainer: {
    flex: 1,
    alignItems: "center",
  },
  mobileAppBannerTitle: {
    fontSize: 18,
    fontFamily: fonts.bold,
    marginBottom: 4,
    textAlign: "center",
  },
  mobileAppBannerSubtitle: {
    fontSize: 14,
    fontFamily: fonts.regular,
    textAlign: "center",
  },
  playstoreButton: {
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  playstoreButtonImage: {
    width: "80%",
    maxWidth: 259,
    height: 70,
  },
  playstoreButtonText: {
    fontSize: 14,
    fontFamily: fonts.bold,
  },
  mobileAppDisclaimer: {
    fontSize: 12,
    fontFamily: fonts.regular,
    textAlign: "center",
    maxWidth: 500,
    lineHeight: 16,
    paddingHorizontal: 8,
  },

  // Category Pills
  categoriesSection: {
    paddingVertical: 20,
    paddingHorizontal: 24,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.lightGray,
  },
  categoriesScrollContent: {
    paddingRight: 24,
  },
  categoryPill: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingVertical: 10,
    marginRight: 12,
    backgroundColor: lightColors.cream,
    borderRadius: 25,
    borderWidth: 1,
    gap: 8,
  },
  categoryPillText: {
    fontSize: 14,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
  },

  // Results Header
  resultsHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
    flexWrap: "wrap",
    gap: 12,
  },
  resultsLeftSection: {
    flex: 1,
    minWidth: 200,
    justifyContent: "center",
  },
  resultsRightSection: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
  },
  resultsCount: {
    fontSize: 16,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
    marginBottom: 4,
  },
  activeFiltersRow: {
    flexDirection: "row",
    gap: 8,
    marginTop: 8,
    paddingRight: 8,
  },
  activeFilterChip: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    gap: 6,
  },
  activeFilterText: {
    fontSize: 12,
    fontFamily: fonts.medium,
  },
  sortContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  sortLabel: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  sortButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 6,
    backgroundColor: lightColors.cream,
    borderRadius: 8,
  },
  sortButtonText: {
    fontSize: 14,
    fontFamily: fonts.medium,
  },
  viewToggle: {
    flexDirection: "row",
    gap: 8,
  },
  viewToggleButton: {
    padding: 10,
    borderRadius: 8,
  },

  // Modern Job Card - Enhanced
  modernJobCard: {
    flex: 1,
    minWidth: 280,
    backgroundColor: lightColors.white,
    borderRadius: 12,
    marginBottom: 12,
    marginHorizontal: 6,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 2,
    position: "relative",
    overflow: "visible",
  },
  modernJobCardList: {
    flex: 1,
    maxWidth: "100%",
    width: "100%",
  },
  featuredJobCard: {
    shadowOpacity: 0.16,
    shadowRadius: 22,
    elevation: 7,
  },
  cardBanner: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    gap: 12,
    backgroundColor: lightColors.deepNavy,
  },
  bannerLogo: {
    width: 44,
    height: 44,
    borderRadius: 12,
    backgroundColor: lightColors.white,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 3,
  },
  bannerLogoText: {
    fontSize: 20,
    fontFamily: fonts.bold,
  },
  bannerContent: {
    flex: 1,
    gap: 2,
  },
  bannerJobTitle: {
    fontSize: 16,
    fontFamily: fonts.bold,
    lineHeight: 22,
  },
  bannerCompanyName: {
    fontSize: 13,
    fontFamily: fonts.medium,
  },
  featuredPill: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: lightColors.deepNavy,
    justifyContent: "center",
    alignItems: "center",
  },
  cardBody: {
    padding: 16,
    gap: 12,
  },
  infoPillsRow: {
    flexDirection: "row",
    gap: 8,
  },
  infoPill: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderRadius: 24,
    gap: 6,
  },
  infoPillText: {
    fontSize: 12,
    fontFamily: fonts.medium,
    flex: 1,
  },
  tagsPillsRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
  },
  pillTag: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    gap: 4,
  },
  pillTagText: {
    fontSize: 11,
    fontFamily: fonts.bold,
    textTransform: "uppercase",
    letterSpacing: 0.3,
  },
  salaryBadge: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 12,
    gap: 10,
  },
  salaryIconContainer: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: lightColors.success,
    justifyContent: "center",
    alignItems: "center",
  },
  salaryText: {
    fontSize: 15,
    fontFamily: fonts.bold,
    flex: 1,
  },
  matchesCompact: {
    padding: 12,
    borderRadius: 12,
    borderWidth: 1,
    gap: 8,
    backgroundColor: `${lightColors.beeYellow}05`,
  },
  matchesCompactHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  matchIconBadge: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: lightColors.beeYellow,
    justifyContent: "center",
    alignItems: "center",
  },
  matchesCompactTitle: {
    fontSize: 13,
    fontFamily: fonts.bold,
  },
  matchesCompactText: {
    fontSize: 12,
    fontFamily: fonts.regular,
    lineHeight: 18,
  },
  cardFooter: {
    flexDirection: "row",
    gap: 10,
    padding: 14,
    borderTopWidth: 1,
  },
  bookmarkFooterButton: {
    width: 48,
    height: 48,
    borderRadius: 12,
    backgroundColor: lightColors.cream,
    justifyContent: "center",
    alignItems: "center",
  },
  applyFooterButton: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 14,
    borderRadius: 12,
    gap: 8,
  },
  applyFooterText: {
    fontSize: 14,
    fontFamily: fonts.bold,
  },

  // New Job Card Styles
  cardTopSection: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    gap: 12,
  },
  companyBadge: {
    width: 48,
    height: 48,
    borderRadius: 24,
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  companyInitial: {
    fontSize: 20,
    fontFamily: fonts.bold,
  },
  topInfo: {
    flex: 1,
  },
  companyText: {
    fontSize: 13,
    fontFamily: fonts.semibold,
    marginBottom: 2,
  },
  dateText: {
    fontSize: 11,
    fontFamily: fonts.regular,
  },
  titleSection: {
    paddingHorizontal: 16,
    paddingBottom: 16,
  },
  jobTitleNew: {
    fontSize: 17,
    fontFamily: fonts.bold,
    lineHeight: 24,
  },
  keyInfoGrid: {
    flexDirection: "row",
    marginHorizontal: 16,
    marginBottom: 12,
    borderRadius: 8,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "#e5e7eb",
  },
  infoBox: {
    flex: 1,
    padding: 12,
    alignItems: "center",
  },
  infoBoxBorder: {
    borderLeftWidth: 1,
    borderLeftColor: "#e5e7eb",
  },
  infoBoxLabel: {
    fontSize: 9,
    fontFamily: fonts.semibold,
    letterSpacing: 1,
    marginBottom: 4,
  },
  infoBoxValue: {
    fontSize: 13,
    fontFamily: fonts.semibold,
  },
  salaryBar: {
    marginHorizontal: 16,
    marginBottom: 12,
    padding: 12,
    borderRadius: 8,
    alignItems: "center",
  },
  salaryText: {
    fontSize: 15,
    fontFamily: fonts.bold,
  },
  detailsList: {
    paddingHorizontal: 16,
    marginBottom: 12,
    gap: 8,
  },
  detailItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  bullet: {
    width: 6,
    height: 6,
    borderRadius: 3,
  },
  detailText: {
    fontSize: 13,
    fontFamily: fonts.medium,
  },
  statsRow: {
    flexDirection: "row",
    justifyContent: "space-around",
    paddingVertical: 12,
    borderTopWidth: 1,
    marginBottom: 12,
  },
  statItem: {
    alignItems: "center",
  },
  statNumber: {
    fontSize: 18,
    fontFamily: fonts.bold,
    marginBottom: 2,
  },
  statLabel: {
    fontSize: 10,
    fontFamily: fonts.regular,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  actionButton: {
    marginHorizontal: 16,
    marginBottom: 16,
    padding: 14,
    borderRadius: 8,
    alignItems: "center",
  },
  actionButtonText: {
    fontSize: 14,
    fontFamily: fonts.bold,
    letterSpacing: 0.5,
  },

  // New Modern Job Card Styles
  badgesContainer: {
    flexDirection: "row",
    position: "absolute",
    top: 8,
    right: 8,
    gap: 4,
    zIndex: 10,
  },
  statusBadge: {
    paddingHorizontal: 6,
    paddingVertical: 3,
    borderRadius: 4,
  },
  statusBadgeText: {
    fontSize: 8,
    fontFamily: fonts.bold,
    letterSpacing: 0.5,
  },
  cardHeader: {
    flexDirection: "row",
    alignItems: "flex-start",
    padding: 12,
    paddingBottom: 8,
    gap: 8,
  },
  companyInfo: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  companyAvatar: {
    width: 44,
    height: 44,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 3,
    elevation: 1,
  },
  companyLogoImage: {
    width: 44,
    height: 44,
    borderRadius: 10,
  },
  companyInitialLarge: {
    fontSize: 18,
    fontFamily: fonts.bold,
  },
  companyDetails: {
    flex: 1,
    gap: 2,
  },
  companyNameLarge: {
    fontSize: 14,
    fontFamily: fonts.bold,
    lineHeight: 18,
  },
  companyMeta: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
  },
  metaText: {
    fontSize: 11,
    fontFamily: fonts.regular,
  },
  metaDivider: {
    fontSize: 11,
  },
  bookmarkButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
  },
  titleContainer: {
    paddingHorizontal: 12,
    paddingBottom: 8,
    gap: 6,
  },
  jobTitleModern: {
    fontSize: 16,
    fontFamily: fonts.bold,
    lineHeight: 22,
  },
  categoryPill: {
    alignSelf: "flex-start",
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
  },
  categoryPillText: {
    fontSize: 10,
    fontFamily: fonts.semibold,
    letterSpacing: 0.2,
  },
  infoGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    paddingHorizontal: 12,
    paddingVertical: 8,
    gap: 8,
  },
  infoCell: {
    flexDirection: "row",
    alignItems: "center",
    width: "48%",
    gap: 6,
  },
  infoCellContent: {
    flex: 1,
    gap: 2,
  },
  infoCellLabel: {
    fontSize: 10,
    fontFamily: fonts.medium,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  infoCellValue: {
    fontSize: 12,
    fontFamily: fonts.semibold,
    lineHeight: 16,
  },
  salarySection: {
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: 12,
    marginBottom: 8,
    padding: 10,
    borderRadius: 8,
    borderLeftWidth: 3,
    gap: 6,
  },
  salaryAmount: {
    fontSize: 15,
    fontFamily: fonts.bold,
    flex: 1,
  },
  salaryPeriod: {
    fontSize: 12,
    fontFamily: fonts.medium,
  },
  skillsContainer: {
    paddingHorizontal: 12,
    paddingBottom: 8,
    gap: 6,
  },
  skillsLabel: {
    fontSize: 10,
    fontFamily: fonts.semibold,
    textTransform: "uppercase",
    letterSpacing: 0.3,
  },
  skillsRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 5,
  },
  skillTag: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
  },
  skillTagText: {
    fontSize: 10,
    fontFamily: fonts.medium,
  },
  descriptionPreview: {
    paddingHorizontal: 12,
    paddingBottom: 8,
    fontSize: 12,
    fontFamily: fonts.regular,
    lineHeight: 18,
  },
  cardFooter: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderTopWidth: 1,
    gap: 8,
  },
  statsContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    flex: 1,
  },
  statChip: {
    flexDirection: "row",
    alignItems: "center",
    gap: 3,
  },
  statChipText: {
    fontSize: 10,
    fontFamily: fonts.medium,
  },
  applyButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 7,
    gap: 4,
  },
  applyButtonText: {
    fontSize: 12,
    fontFamily: fonts.bold,
    letterSpacing: 0.2,
  },

  matchedTagsSection: {
    marginTop: 12,
    gap: 8,
  },
  matchedTagsHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  matchedTagsTitle: {
    fontSize: 13,
    fontFamily: fonts.semibold,
  },
  matchedTagsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
    alignItems: "center",
  },
  matchedTag: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 12,
    borderWidth: 1,
  },
  matchedTagText: {
    fontSize: 12,
    fontFamily: fonts.medium,
  },
  matchedTagsMore: {
    fontSize: 12,
    fontFamily: fonts.regular,
    fontStyle: "italic",
  },
  matchedTagsDescription: {
    fontSize: 13,
    fontFamily: fonts.regular,
    marginBottom: 12,
  },

  // Modern Grid
  modernJobsGrid: {
    paddingBottom: 16,
    width: "100%",
  },
  modernJobsRow: {
    justifyContent: "flex-start",
    gap: 16,
    marginBottom: 0,
    width: "100%",
  },

  // Modern Loading & Empty States
  modernLoadingContainer: {
    flex: 1,
    paddingVertical: 120,
    alignItems: "center",
    justifyContent: "center",
  },
  loadingIconCircle: {
    width: 100,
    height: 100,
    borderRadius: 50,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 24,
  },
  loadingTitle: {
    fontSize: 20,
    fontFamily: fonts.semiBold,
    marginBottom: 8,
  },
  loadingSubtitle: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  modernEmptyState: {
    paddingVertical: 60,
    paddingHorizontal: 16,
    alignItems: "center",
    justifyContent: "center",
  },
  emptyStateIcon: {
    width: 100,
    height: 100,
    borderRadius: 50,
    backgroundColor: lightColors.cream,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 20,
  },
  emptyStateTitle: {
    fontSize: 20,
    fontFamily: fonts.bold,
    color: lightColors.deepNavy,
    marginBottom: 10,
    textAlign: "center",
  },
  emptyStateDescription: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    textAlign: "center",
    marginBottom: 20,
    paddingHorizontal: 20,
    lineHeight: 20,
  },
  emptyStateButton: {
    paddingHorizontal: 24,
    paddingVertical: 12,
    backgroundColor: lightColors.deepNavy,
    borderRadius: 25,
  },
  emptyStateButtonText: {
    fontSize: 14,
    fontFamily: fonts.medium,
    color: lightColors.white,
  },

  // Modern Pagination
  modernPagination: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 16,
    paddingHorizontal: 12,
    backgroundColor: lightColors.white,
    borderRadius: 12,
    marginTop: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
    flexWrap: "wrap",
    gap: 12,
  },
  modernPaginationButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    borderWidth: 1,
    gap: 4,
  },
  modernPaginationButtonDisabled: {
    opacity: 0.4,
  },
  modernPaginationButtonText: {
    fontSize: 14,
    fontFamily: fonts.medium,
  },
  modernPaginationNumbers: {
    flexDirection: "row",
    gap: 8,
  },
  modernPageNumber: {
    width: 40,
    height: 40,
    borderRadius: 8,
    borderWidth: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  modernPageNumberText: {
    fontSize: 14,
    fontFamily: fonts.medium,
  },

  // Modern Filter Sidebar - Revamped
  filterHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 20,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    gap: 10,
  },
  filterTitle: {
    fontSize: 18,
    fontFamily: fonts.semibold,
    color: lightColors.deepNavy,
    letterSpacing: -0.3,
  },
  clearFiltersButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginBottom: 24,
    borderRadius: 8,
    gap: 8,
    borderWidth: 1,
  },
  clearFiltersText: {
    fontSize: 14,
    fontFamily: fonts.semibold,
    letterSpacing: -0.2,
    letterSpacing: 0.3,
  },
  filterGroup: {
    marginBottom: 16,
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: "transparent",
  },
  filterGroupHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 14,
    paddingHorizontal: 16,
    backgroundColor: "transparent",
  },
  filterGroupTitleContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    flex: 1,
  },
  filterGroupIconCircle: {
    width: 28,
    height: 28,
    borderRadius: 6,
    justifyContent: "center",
    alignItems: "center",
  },
  expandIconCircle: {
    width: 24,
    height: 24,
    borderRadius: 6,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
  },
  filterGroupTitle: {
    fontSize: 15,
    fontFamily: fonts.semibold,
    color: lightColors.deepNavy,
    letterSpacing: -0.2,
  },
  filterOptions: {
    gap: 6,
    paddingHorizontal: 16,
    paddingBottom: 12,
  },
  filterOption: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    paddingHorizontal: 14,
    backgroundColor: "transparent",
    borderRadius: 8,
    gap: 10,
    borderWidth: 1,
    borderColor: "#E5E7EB",
    transition: "all 0.2s ease",
  },
  filterOptionActive: {
    borderColor: lightColors.deepNavy,
    backgroundColor: lightColors.deepNavy,
  },
  filterOptionIconCircle: {
    width: 32,
    height: 32,
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "center",
  },
  filterOptionText: {
    fontSize: 14,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
    flex: 1,
  },
  checkmarkCircle: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: lightColors.beeYellow,
    justifyContent: "center",
    alignItems: "center",
  },

  // New Filter Enhancements
  filterHeaderTop: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 4,
  },
  filterCountBadge: {
    width: 24,
    height: 24,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 8,
  },
  filterCountText: {
    fontSize: 12,
    fontFamily: fonts.bold,
  },
  filterSubtitle: {
    fontSize: 12,
    fontFamily: fonts.regular,
    marginTop: 2,
  },

  // Simple Clean Filter Styles
  filterHeaderSimple: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: 16,
  },
  filterTitleSimple: {
    fontSize: 18,
    fontFamily: fonts.semibold,
    letterSpacing: -0.3,
  },
  clearAllButton: {
    paddingHorizontal: 12,
    paddingVertical: 6,
  },
  clearAllText: {
    fontSize: 13,
    fontFamily: fonts.medium,
  },
  filterDivider: {
    height: 1,
    backgroundColor: "#E5E7EB",
    marginBottom: 16,
  },
  filterGroupSimple: {
    marginBottom: 4,
  },
  filterGroupHeaderSimple: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 12,
    paddingHorizontal: 4,
  },
  filterGroupLabelSimple: {
    fontSize: 14,
    fontFamily: fonts.medium,
    letterSpacing: -0.1,
  },
  filterOptionsSimple: {
    paddingLeft: 4,
    paddingTop: 8,
    paddingBottom: 8,
  },
  filterCheckboxRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 8,
    gap: 12,
  },
  checkbox: {
    width: 18,
    height: 18,
    borderRadius: 4,
    borderWidth: 2,
    justifyContent: "center",
    alignItems: "center",
  },
  checkboxLabel: {
    fontSize: 14,
    fontFamily: fonts.regular,
    flex: 1,
  },
  simpleSearchInput: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 6,
    borderWidth: 1,
    gap: 8,
    marginBottom: 12,
  },
  searchInputField: {
    flex: 1,
    fontSize: 14,
    fontFamily: fonts.regular,
    padding: 0,
    outline: "none" as any,
  },
  tagsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
  },
  simpleTagChip: {
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 6,
    borderWidth: 1,
  },
  simpleTagText: {
    fontSize: 13,
    fontFamily: fonts.regular,
  },
  noTagsTextSimple: {
    fontSize: 13,
    fontFamily: fonts.regular,
    textAlign: "center",
    paddingVertical: 8,
  },

  quickFiltersSection: {
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    borderWidth: 1,
  },
  quickFiltersTitle: {
    fontSize: 13,
    fontFamily: fonts.semibold,
    marginBottom: 12,
  },
  quickFiltersGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  quickFilterChip: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    gap: 6,
    borderWidth: 1,
  },
  quickFilterText: {
    fontSize: 13,
    fontFamily: fonts.medium,
  },
  filterItemCount: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 10,
    marginLeft: 4,
  },
  filterItemCountText: {
    fontSize: 11,
    fontFamily: fonts.bold,
  },
  tagSearchContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderRadius: 8,
    borderWidth: 1,
    gap: 8,
    marginBottom: 8,
  },
  tagSearchInput: {
    flex: 1,
    fontSize: 14,
    fontFamily: fonts.regular,
    padding: 0,
    outline: "none" as any,
  },
  tagChip: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 16,
    gap: 4,
  },
  tagChipText: {
    fontSize: 12,
  },
  noTagsText: {
    fontSize: 13,
    fontFamily: fonts.regular,
    textAlign: "center",
    paddingVertical: 12,
  },
  clearFiltersButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
    marginBottom: 16,
    gap: 8,
    borderWidth: 1,
  },
  clearFiltersText: {
    fontSize: 14,
    fontFamily: fonts.semibold,
  },

  // ===== END MODERN STYLES =====

  categoriesScrollView: {
    marginTop: 16,
  },
  categoryFilterChip: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    marginRight: 12,
    backgroundColor: lightColors.lightGray,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: "transparent",
  },
  categoryFilterChipActive: {
    backgroundColor: lightColors.beeYellow,
    borderColor: lightColors.honeyGold,
  },
  categoryFilterChipText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  categoryFilterChipTextActive: {
    color: lightColors.deepNavy,
  },
  // Additional Filters
  additionalFiltersContainer: {
    paddingHorizontal: 24,
    paddingTop: 16,
    paddingBottom: 8,
    backgroundColor: lightColors.white,
  },
  filterRow: {
    marginBottom: 12,
    flexDirection: "row",
    alignItems: "center",
  },
  filterLabel: {
    fontSize: 14,
    fontFamily: fonts.medium,
    color: lightColors.warmGray,
    marginRight: 12,
    minWidth: 80,
  },
  filterChip: {
    paddingHorizontal: 14,
    paddingVertical: 6,
    marginRight: 8,
    backgroundColor: lightColors.lightGray,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "transparent",
  },
  filterChipText: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  // Popular filters (landing page recent jobs)
  popularFiltersContainer: {
    paddingHorizontal: 0,
    paddingVertical: 0,
    backgroundColor: lightColors.white,
    marginBottom: 8,
  },
  popularFiltersContent: {
    alignItems: "center",
    paddingHorizontal: 8,
  },
  popularFilterChip: {
    paddingHorizontal: 14,
    paddingVertical: 6,
    marginRight: 10,
    backgroundColor: lightColors.lightGray,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: "transparent",
  },
  popularFilterChipActive: {
    backgroundColor: lightColors.beeYellow,
    borderColor: lightColors.honeyGold,
  },
  popularFilterText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  popularFilterTextActive: {
    color: lightColors.deepNavy,
  },
  jobsPageJobsSection: {
    padding: 24,
  },

  // Compact job card & view more styles for landing page
  viewMoreContainer: {
    paddingHorizontal: 24,
    paddingBottom: 32,
    alignItems: "center",
    backgroundColor: lightColors.white,
  },
  viewMoreButton: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: lightColors.beeYellow,
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 14,
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.18,
    shadowRadius: 8,
    elevation: 3,
  },
  viewMoreButtonText: {
    color: lightColors.white,
    fontSize: 15,
    fontFamily: fonts.regular,
    marginRight: 8,
  },

  // Simple compact job card parts
  jobCardSimpleHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  jobCompanyBadge: {
    width: 36,
    height: 36,
    borderRadius: 8,
    backgroundColor: `${lightColors.softBlue}15`,
    justifyContent: "center",
    alignItems: "center",
  },
  remoteTag: {
    backgroundColor: `${lightColors.success}15`,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
  },
  remoteTagText: {
    fontSize: 11,
    fontFamily: fonts.regular,
    color: lightColors.success,
  },
  jobCardBody: {
    marginBottom: 12,
  },
  jobMetaContainer: {
    marginTop: 8,
    marginBottom: 4,
  },
  jobMetaItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  jobSalaryContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    marginTop: 4,
  },
  jobCardSimpleFooter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: lightColors.lightGray,
  },
  emptyStateContainer: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 80,
  },
  emptyStateText: {
    fontSize: 20,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginTop: 16,
  },
  emptyStateSubtext: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginTop: 8,
  },
  adminContainer: {
    flex: 1,
    flexDirection: "row",
  },
  sidebar: {
    width: 250,
    minWidth: 250,
    maxWidth: 250,
    flexShrink: 0,
    borderRightWidth: 0,
    ...Platform.select({
      web: {
        boxShadow: "0 0 40px rgba(0, 0, 0, 0.08), 0 0 2px rgba(0, 0, 0, 0.04)",
      },
      default: {
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.08,
        shadowRadius: 40,
        elevation: 10,
      },
    }),
  },
  sidebarHeader: {
    paddingHorizontal: 16,
    paddingTop: 20,
    paddingBottom: 16,
    marginBottom: 12,
  },
  modernCollapseButton: {
    alignSelf: "flex-end",
    width: 36,
    height: 36,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 16,
    ...Platform.select({
      web: {
        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.12)",
        cursor: "pointer",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        ":hover": {
          transform: "scale(1.05)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.16)",
        },
      },
      default: {
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 3 },
        shadowOpacity: 0.12,
        shadowRadius: 10,
        elevation: 4,
      },
    }),
  },
  modernSidebarHeaderContent: {
    alignItems: "center",
    paddingTop: 0,
  },
  modernLogoContainer: {
    width: 48,
    height: 48,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 16,
    ...Platform.select({
      web: {
        boxShadow: "0 4px 16px rgba(244, 196, 48, 0.3)",
        background: "linear-gradient(135deg, #FCD34D 0%, #F59E0B 100%)",
      },
      default: {
        shadowColor: "#F4C430",
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.3,
        shadowRadius: 16,
        elevation: 6,
      },
    }),
  },
  modernLogoImage: {
    width: 30,
    height: 30,
  },
  modernSidebarTitle: {
    fontSize: 18,
    fontFamily: fonts.bold,
    fontWeight: "700",
    letterSpacing: -0.5,
    marginBottom: 4,
  },
  modernSidebarSubtitle: {
    fontSize: 12,
    fontFamily: fonts.regular,
    letterSpacing: 0.3,
    marginBottom: 20,
  },
  modernUserCard: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    padding: 12,
    borderRadius: 12,
    borderWidth: 1,
    marginTop: 8,
    gap: 12,
    ...Platform.select({
      web: {
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
        backdropFilter: "blur(10px)",
      },
      default: {
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.06,
        shadowRadius: 8,
        elevation: 2,
      },
    }),
  },
  modernUserAvatar: {
    width: 40,
    height: 40,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
  },
  modernUserAvatarText: {
    fontSize: 18,
    fontFamily: fonts.bold,
    color: "#FFFFFF",
    fontWeight: "700",
  },
  modernUserInfo: {
    flex: 1,
  },
  modernUserName: {
    fontSize: 14,
    fontFamily: fonts.semiBold,
    fontWeight: "600",
    marginBottom: 4,
  },
  modernRoleBadge: {
    alignSelf: "flex-start",
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 6,
  },
  modernRoleBadgeText: {
    fontSize: 11,
    fontFamily: fonts.medium,
    fontWeight: "600",
  },
  modernCollapsedLogoContainer: {
    alignItems: "center",
    paddingTop: 20,
  },
  modernLogoContainerSmall: {
    width: 44,
    height: 44,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
  },
  modernLogoImageSmall: {
    width: 28,
    height: 28,
  },
  modernNavSection: {
    paddingHorizontal: 12,
    paddingTop: 0,
    paddingBottom: 12,
  },
  modernCategorySection: {
    marginBottom: 20,
  },
  modernSectionLabel: {
    fontSize: 10,
    fontFamily: fonts.bold,
    fontWeight: "700",
    letterSpacing: 1.5,
    paddingHorizontal: 12,
    paddingVertical: 8,
    textTransform: "uppercase",
    opacity: 0.6,
  },
  modernSidebarItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 11,
    paddingHorizontal: 12,
    marginVertical: 1,
    marginHorizontal: 8,
    borderRadius: 10,
    borderLeftWidth: 0,
    gap: 12,
    ...Platform.select({
      web: {
        cursor: "pointer",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        ":hover": {
          backgroundColor: "rgba(244, 196, 48, 0.08)",
          transform: "translateX(2px)",
        },
      },
    }),
  },
  modernSidebarItemCollapsed: {
    justifyContent: "center",
    paddingHorizontal: 0,
  },
  modernIconContainer: {
    width: 36,
    height: 36,
    borderRadius: 9,
    alignItems: "center",
    justifyContent: "center",
    ...Platform.select({
      web: {
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      },
    }),
  },
  modernItemTextContainer: {
    flex: 1,
  },
  modernSidebarItemText: {
    fontSize: 13,
    fontFamily: fonts.regular,
    letterSpacing: 0.2,
  },
  modernActiveIndicator: {
    width: 3,
    height: 20,
    borderRadius: 2,
    marginLeft: "auto",
    ...Platform.select({
      web: {
        boxShadow: "0 0 8px rgba(244, 196, 48, 0.6)",
      },
      default: {
        shadowColor: "#F4C430",
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.6,
        shadowRadius: 8,
        elevation: 4,
      },
    }),
  },
  modernSettingsSection: {
    paddingHorizontal: 12,
    paddingTop: 12,
    paddingBottom: 20,
    borderTopWidth: 1,
    borderTopColor: "rgba(0, 0, 0, 0.06)",
    marginTop: 16,
    ...Platform.select({
      web: {
        background:
          "linear-gradient(180deg, rgba(250, 251, 252, 0) 0%, rgba(250, 251, 252, 0.5) 100%)",
      },
    }),
  },
  modernLogoutButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 11,
    paddingHorizontal: 12,
    marginTop: 8,
    marginHorizontal: 8,
    borderRadius: 10,
    gap: 12,
    ...Platform.select({
      web: {
        cursor: "pointer",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        ":hover": {
          backgroundColor: "rgba(239, 68, 68, 0.12)",
          transform: "translateX(2px)",
        },
      },
    }),
  },
  modernLogoutText: {
    fontSize: 14,
    fontFamily: fonts.semiBold,
    fontWeight: "600",
    letterSpacing: 0.2,
  },
  sidebarCollapsed: {
    width: 70,
    minWidth: 70,
    maxWidth: 70,
  },

  // ===== NEW GLASSY SIDEBAR STYLES =====
  glassSidebar: {
    width: 260,
    minWidth: 260,
    maxWidth: 260,
    flexShrink: 0,
    backgroundColor: (isDarkMode) =>
      isDarkMode ? "rgba(17, 24, 39, 0.85)" : "rgba(255, 255, 255, 0.85)",
    ...Platform.select({
      web: {
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        boxShadow:
          "0 8px 32px rgba(0, 0, 0, 0.08), inset 0 0 0 1px rgba(255, 255, 255, 0.1)",
      },
      default: {
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.1,
        shadowRadius: 20,
        elevation: 8,
      },
    }),
  },
  glassSidebarCollapsed: {
    width: 76,
    minWidth: 76,
    maxWidth: 76,
  },
  glassGradientOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: 300,
    ...Platform.select({
      web: {
        background:
          "linear-gradient(180deg, rgba(245, 158, 11, 0.08) 0%, transparent 100%)",
        pointerEvents: "none",
      },
    }),
  },
  glassHeader: {
    paddingHorizontal: 16,
    paddingTop: 20,
    paddingBottom: 20,
    marginBottom: 8,
  },
  glassCollapseButton: {
    alignSelf: "flex-end",
    width: 32,
    height: 32,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 16,
    backgroundColor: (isDarkMode) =>
      isDarkMode ? "rgba(245, 158, 11, 0.1)" : "rgba(245, 158, 11, 0.08)",
    ...Platform.select({
      web: {
        cursor: "pointer",
        transition: "all 0.2s ease",
        ":hover": {
          backgroundColor: (isDarkMode) =>
            isDarkMode
              ? "rgba(245, 158, 11, 0.15)"
              : "rgba(245, 158, 11, 0.12)",
          transform: "scale(1.05)",
        },
      },
    }),
  },
  glassHeaderContent: {
    alignItems: "center",
  },
  glassLogoWrapper: {
    position: "relative",
    marginBottom: 16,
  },
  glassLogoGlow: {
    position: "absolute",
    top: -10,
    left: -10,
    right: -10,
    bottom: -10,
    borderRadius: 25,
    backgroundColor: "#F59E0B",
    opacity: 0.15,
    ...Platform.select({
      web: {
        filter: "blur(20px)",
      },
    }),
  },
  glassLogo: {
    width: 52,
    height: 52,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: (isDarkMode) =>
      isDarkMode ? "rgba(245, 158, 11, 0.2)" : "rgba(245, 158, 11, 0.15)",
    ...Platform.select({
      web: {
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(245, 158, 11, 0.2)",
      },
    }),
  },
  glassLogoImage: {
    width: 32,
    height: 32,
  },
  glassTitle: {
    fontSize: 20,
    fontFamily: fonts.bold,
    fontWeight: "700",
    letterSpacing: -0.5,
    marginBottom: 4,
  },
  glassSubtitle: {
    fontSize: 12,
    fontFamily: fonts.medium,
    letterSpacing: 0.5,
    marginBottom: 16,
    opacity: 0.7,
  },
  glassUserCard: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    padding: 12,
    borderRadius: 14,
    borderWidth: 1,
    gap: 10,
    ...Platform.select({
      web: {
        backdropFilter: "blur(10px)",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
      },
      default: {
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
        elevation: 2,
      },
    }),
  },
  glassAvatarWrapper: {
    position: "relative",
  },
  glassAvatarGlow: {
    position: "absolute",
    top: -4,
    left: -4,
    right: -4,
    bottom: -4,
    borderRadius: 14,
    opacity: 0.3,
    ...Platform.select({
      web: {
        filter: "blur(8px)",
      },
    }),
  },
  glassAvatar: {
    width: 38,
    height: 38,
    borderRadius: 11,
    alignItems: "center",
    justifyContent: "center",
  },
  glassAvatarText: {
    fontSize: 16,
    fontFamily: fonts.bold,
    color: "#FFFFFF",
    fontWeight: "700",
  },
  glassUserInfo: {
    flex: 1,
  },
  glassUserName: {
    fontSize: 13,
    fontFamily: fonts.semiBold,
    fontWeight: "600",
    marginBottom: 4,
  },
  glassRoleBadge: {
    alignSelf: "flex-start",
    paddingHorizontal: 8,
    paddingVertical: 3,
    borderRadius: 6,
    ...Platform.select({
      web: {
        backdropFilter: "blur(10px)",
      },
    }),
  },
  glassRoleText: {
    fontSize: 10,
    fontFamily: fonts.semiBold,
    fontWeight: "600",
    letterSpacing: 0.3,
  },
  glassCollapsedLogo: {
    alignItems: "center",
    position: "relative",
  },
  glassLogoGlowSmall: {
    position: "absolute",
    top: -8,
    left: -8,
    right: -8,
    bottom: -8,
    borderRadius: 20,
    backgroundColor: "#F59E0B",
    opacity: 0.12,
    ...Platform.select({
      web: {
        filter: "blur(15px)",
      },
    }),
  },
  glassLogoSmall: {
    width: 44,
    height: 44,
    borderRadius: 13,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: (isDarkMode) =>
      isDarkMode ? "rgba(245, 158, 11, 0.2)" : "rgba(245, 158, 11, 0.15)",
    ...Platform.select({
      web: {
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(245, 158, 11, 0.2)",
      },
    }),
  },
  glassLogoImageSmall: {
    width: 26,
    height: 26,
  },
  glassNavSection: {
    paddingHorizontal: 12,
    paddingVertical: 8,
    flex: 1,
  },
  glassCategorySection: {
    marginBottom: 24,
  },
  glassSectionLabel: {
    fontSize: 10,
    fontFamily: fonts.bold,
    fontWeight: "700",
    letterSpacing: 1.2,
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginBottom: 4,
    textTransform: "uppercase",
  },
  glassNavItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    paddingHorizontal: 12,
    marginVertical: 2,
    borderRadius: 11,
    gap: 11,
    position: "relative",
    ...Platform.select({
      web: {
        cursor: "pointer",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        ":hover": {
          backgroundColor: (isDarkMode) =>
            isDarkMode ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.03)",
          transform: "translateX(3px)",
        },
      },
    }),
  },
  glassNavItemActive: {
    ...Platform.select({
      web: {
        backdropFilter: "blur(10px)",
      },
    }),
  },
  glassNavItemCollapsed: {
    justifyContent: "center",
    paddingHorizontal: 0,
  },
  glassActiveBar: {
    position: "absolute",
    left: 0,
    top: "20%",
    bottom: "20%",
    width: 3,
    borderRadius: 3,
    ...Platform.select({
      web: {
        boxShadow: "0 0 10px rgba(245, 158, 11, 0.5)",
      },
    }),
  },
  glassIconWrapper: {
    width: 36,
    height: 36,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    ...Platform.select({
      web: {
        backdropFilter: "blur(10px)",
        transition: "all 0.2s ease",
      },
    }),
  },
  glassIconGlow: {
    position: "absolute",
    top: -5,
    left: -5,
    right: -5,
    bottom: -5,
    borderRadius: 13,
    backgroundColor: "#F59E0B",
    opacity: 0.2,
    ...Platform.select({
      web: {
        filter: "blur(10px)",
      },
    }),
  },
  glassNavText: {
    flex: 1,
    fontSize: 13,
    fontFamily: fonts.medium,
    letterSpacing: 0.1,
  },
  glassActiveDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: "#F59E0B",
    ...Platform.select({
      web: {
        boxShadow: "0 0 8px rgba(245, 158, 11, 0.8)",
      },
    }),
  },
  glassBottomSection: {
    paddingHorizontal: 12,
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    borderTopWidth: 1,
    borderTopColor: (isDarkMode) =>
      isDarkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.06)",
    ...Platform.select({
      web: {
        backdropFilter: "blur(10px)",
      },
    }),
  },
  glassActionButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    paddingHorizontal: 12,
    marginBottom: 8,
    borderRadius: 11,
    gap: 11,
    ...Platform.select({
      web: {
        cursor: "pointer",
        transition: "all 0.2s ease",
        ":hover": {
          backgroundColor: (isDarkMode) =>
            isDarkMode ? "rgba(255, 255, 255, 0.05)" : "rgba(0, 0, 0, 0.03)",
        },
      },
    }),
  },
  glassLogoutButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 11,
    gap: 11,
    ...Platform.select({
      web: {
        cursor: "pointer",
        backdropFilter: "blur(10px)",
        transition: "all 0.2s ease",
        ":hover": {
          backgroundColor: (isDarkMode) =>
            isDarkMode ? "rgba(239, 68, 68, 0.2)" : "rgba(239, 68, 68, 0.15)",
          transform: "translateX(2px)",
        },
      },
    }),
  },
  // ===== END GLASSY SIDEBAR STYLES =====

  sidebarCollapsed: {
    width: 70,
    minWidth: 70,
    maxWidth: 70,
  },
  adminMainContent: {
    flex: 1,
  },
  contentContainer: {
    flex: 1,
    padding: 32,
  },
  contentTitle: {
    fontSize: 24,
    fontFamily: fonts.regular,
    marginBottom: 8,
  },
  statsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 32,
    gap: 20,
  },
  statsGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
    marginTop: 8,
  },
  statCard: {
    backgroundColor: "#FFFFFF",
    padding: 24,
    borderRadius: 16,
    alignItems: "flex-start",
    flex: 1,
    marginHorizontal: 0,
    borderWidth: 1,
    borderColor: "#F3F4F6",
    borderLeftWidth: 1,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.04,
    shadowRadius: 8,
  },
  statNumber: {
    fontSize: 36,
    fontWeight: "700",
    color: "#111827",
    letterSpacing: -1,
  },
  statValue: {
    fontSize: 32,
    fontWeight: "700",
    color: "#111827",
    marginTop: 12,
    marginBottom: 4,
  },
  statLabel: {
    fontSize: 14,
    color: "#6B7280",
    marginTop: 6,
    fontWeight: "500",
  },
  welcomeText: {
    fontSize: 16,
    color: "#6B7280",
    lineHeight: 24,
  },
  addButton: {
    backgroundColor: "#F59E0B",
    paddingHorizontal: 24,
    paddingVertical: 14,
    borderRadius: 12,
    alignItems: "center",
    marginBottom: 20,
    shadowColor: "#F59E0B",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    transition: "all 0.2s ease",
  },
  addButtonText: {
    color: "#FFFFFF",
    fontSize: 15,
    fontFamily: fonts.regular,
    letterSpacing: 0.3,
  },
  listContainer: {
    flex: 1,
  },
  listContentContainer: {
    paddingBottom: 20,
  },
  listItem: {
    backgroundColor: "#FFFFFF",
    flexDirection: "row",
    alignItems: "center",
    padding: 20,
    borderRadius: 12,
    marginBottom: 10,
  },
  listIcon: {
    fontSize: 24,
    marginRight: 15,
  },
  listInfo: {
    flex: 1,
  },
  listTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#111827",
    marginBottom: 5,
  },
  listSubtitle: {
    fontSize: 14,
    color: "#6B7280",
  },
  statusBadge: {
    fontSize: 12,
    fontWeight: "bold",
    marginTop: 5,
  },
  listActions: {
    flexDirection: "row",
    gap: 10,
  },
  editButton: {
    backgroundColor: "#374151",
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 10,
    transition: "all 0.2s ease",
  },
  deleteButton: {
    backgroundColor: "#EF4444",
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 10,
    transition: "all 0.2s ease",
  },
  actionText: {
    color: "#FFFFFF",
    fontSize: 14,
    fontFamily: fonts.regular,
    letterSpacing: 0.2,
  },
  comingSoon: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    textAlign: "center",
    marginTop: 100,
    fontStyle: "italic",
  },
  // Users Management Styles
  usersHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
    flexWrap: "wrap",
    gap: 16,
  },
  usersStats: {
    flexDirection: "row",
    gap: 12,
  },
  statBadge: {
    backgroundColor: lightColors.cream,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 12,
    borderWidth: 2,
    borderColor: lightColors.beeYellow,
    alignItems: "center",
  },
  statBadgeLabel: {
    fontSize: 12,
    color: lightColors.warmGray,
    fontFamily: fonts.regular,
    marginBottom: 4,
  },
  statBadgeValue: {
    fontSize: 20,
    color: lightColors.deepNavy,
    fontFamily: fonts.regular,
  },
  searchBarContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    paddingHorizontal: 18,
    paddingVertical: 14,
    marginBottom: 20,
    borderWidth: 0,
    ...Platform.select({
      web: {
        boxShadow:
          "0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04)",
        transition: "box-shadow 0.2s ease",
        ":focus-within": {
          boxShadow: "0 2px 8px rgba(244, 196, 48, 0.25), 0 0 0 2px #FCD34D",
        },
      },
      default: {
        borderWidth: 1,
        borderColor: "#E5E7EB",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.06,
        shadowRadius: 8,
        elevation: 2,
      },
    }),
  },
  searchInput: {
    flex: 1,
    marginLeft: 12,
    fontSize: 14,
    fontFamily: fonts.regular,
    color: "#111827",
    outlineStyle: "none",
  },
  filtersContainer: {
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    borderWidth: 0,
    ...Platform.select({
      web: {
        boxShadow:
          "0 1px 3px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04)",
      },
      default: {
        borderWidth: 1,
        borderColor: "#E5E7EB",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.06,
        shadowRadius: 8,
        elevation: 2,
      },
    }),
  },
  filterRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 20,
    alignItems: "flex-start",
  },
  filterGroup: {
    flex: 1,
    minWidth: 200,
  },
  filterLabel: {
    fontSize: 11,
    fontFamily: fonts.medium,
    marginBottom: 6,
    color: "#6B7280",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  filterButtons: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
  },
  filterButton: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
    borderWidth: 1,
    ...Platform.select({
      web: {
        cursor: "pointer",
        transition: "all 0.2s ease",
        ":hover": {
          transform: "translateY(-1px)",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        },
      },
    }),
  },
  filterButtonText: {
    fontSize: 12,
    fontFamily: fonts.medium,
  },
  clearFiltersButton: {
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "flex-start",
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 6,
    borderWidth: 1,
    marginTop: 8,
    gap: 4,
    ...Platform.select({
      web: {
        cursor: "pointer",
        transition: "all 0.2s ease",
        ":hover": {
          backgroundColor: "#F3F4F6",
        },
      },
    }),
  },
  clearFiltersText: {
    fontSize: 12,
    fontFamily: fonts.medium,
  },
  filterSummary: {
    marginTop: 8,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: "#E5E7EB",
  },
  filterSummaryText: {
    fontSize: 12,
    fontFamily: fonts.medium,
  },
  tableContainer: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    borderWidth: 0,
    overflow: "hidden",
    flex: 1,
    ...Platform.select({
      web: {
        boxShadow:
          "0 1px 3px rgba(0, 0, 0, 0.05), 0 10px 40px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03)",
      },
      default: {
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.08,
        shadowRadius: 20,
        elevation: 4,
      },
    }),
  },
  tableHeader: {
    flexDirection: "row",
    paddingVertical: 16,
    paddingHorizontal: 24,
    borderBottomWidth: 2,
    borderBottomColor: "#E5E7EB",
    ...Platform.select({
      web: {
        background: "linear-gradient(180deg, #FAFBFC 0%, #F5F7FA 100%)",
        borderBottom: "2px solid #E5E7EB",
      },
      default: {
        backgroundColor: "#F9FAFB",
      },
    }),
  },
  tableHeaderCell: {
    fontSize: 11,
    fontFamily: fonts.bold,
    fontWeight: "700",
    color: "#4B5563",
    textTransform: "uppercase",
    letterSpacing: 1,
  },
  tableBody: {
    flex: 1,
  },
  tableRow: {
    flexDirection: "row",
    paddingVertical: 16,
    paddingHorizontal: 24,
    borderBottomWidth: 1,
    borderBottomColor: "#F3F4F6",
    alignItems: "center",
    ...Platform.select({
      web: {
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        ":hover": {
          backgroundColor: "#FEFCE8",
          borderLeftWidth: 3,
          borderLeftColor: "#FCD34D",
          paddingLeft: 21,
        },
      },
    }),
  },
  tableRowEven: {
    backgroundColor: "transparent",
  },
  tableCell: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: "#1F2937",
    lineHeight: 20,
  },
  roleBadge: {
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 6,
    backgroundColor: "#F3F4F6",
    alignSelf: "flex-start",
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.06)",
    ...Platform.select({
      web: {
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.04)",
      },
      default: {
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.04,
        shadowRadius: 2,
        elevation: 1,
      },
    }),
  },
  roleBadgeAdmin: {
    backgroundColor: "#FEF3C7",
  },
  roleBadgeSuperAdmin: {
    backgroundColor: "#FEE2E2",
  },
  roleBadgeCompany: {
    backgroundColor: "#DBEAFE",
  },
  roleSelectContainer: {
    flex: 1,
  },
  roleBadgeText: {
    fontSize: 11,
    fontFamily: fonts.medium,
    fontWeight: "600",
    color: "#111827",
    textTransform: "capitalize",
    letterSpacing: 0.2,
  },
  statusBadge: {
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 6,
    backgroundColor: "#D1FAE5",
    alignSelf: "flex-start",
    borderWidth: 1,
    borderColor: "rgba(5, 150, 105, 0.15)",
    ...Platform.select({
      web: {
        boxShadow: "0 1px 2px rgba(5, 150, 105, 0.08)",
      },
      default: {
        shadowColor: "#059669",
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.08,
        shadowRadius: 2,
        elevation: 1,
      },
    }),
  },
  statusBadgeInactive: {
    backgroundColor: "#FEE2E2",
  },
  statusBadgeText: {
    fontSize: 11,
    fontFamily: fonts.medium,
    fontWeight: "600",
    color: "#065F46",
    letterSpacing: 0.2,
  },
  emptyState: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 60,
  },
  emptyStateText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginTop: 16,
    textAlign: "center",
  },
  filterTab: {
    paddingHorizontal: 20,
    paddingVertical: 10,
    borderRadius: 8,
    borderWidth: 1,
  },
  filterTabText: {
    fontSize: 14,
    fontFamily: fonts.medium,
  },
  companyCard: {
    borderWidth: 1,
    borderRadius: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  loadingContainer: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 60,
  },
  loadingText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginTop: 16,
  },
  paginationContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 16,
    paddingVertical: 12,
  },
  paginationButton: {
    width: 32,
    height: 32,
    borderRadius: 6,
    backgroundColor: lightColors.white,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#E5E7EB",
    ...Platform.select({
      web: {
        cursor: "pointer",
        transition: "all 0.2s ease",
        ":hover": {
          backgroundColor: "#FEF3C7",
          borderColor: "#FCD34D",
        },
      },
    }),
  },
  paginationButtonDisabled: {
    opacity: 0.4,
  },
  paginationInfo: {
    alignItems: "center",
    marginHorizontal: 16,
  },
  paginationText: {
    fontSize: 13,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
  },
  paginationControls: {
    flexDirection: "row",
    alignItems: "center",
  },
  paginationNumbers: {
    flexDirection: "row",
    gap: 8,
  },
  paginationNumberButton: {
    width: 40,
    height: 40,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    backgroundColor: lightColors.cream,
    borderColor: lightColors.lightGray,
  },
  paginationNumberText: {
    fontSize: 15,
    fontFamily: fonts.regular,
    fontWeight: "500",
  },
  paginationSubtext: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginTop: 4,
  },
  // Missing styles - Modern Sidebar Design
  sidebarLogoContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12,
  },
  logoIconContainer: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: lightColors.sidebarAccentLight,
    justifyContent: "center",
    alignItems: "center",
  },
  userContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 8,
  },
  userAvatar: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: lightColors.sidebarAccentLight,
    justifyContent: "center",
    alignItems: "center",
  },
  iconContainer: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: "transparent",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 12,
  },
  iconContainerActive: {
    backgroundColor: lightColors.white,
  },
  activeIndicator: {
    position: "absolute",
    right: 16,
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: lightColors.sidebarAccent,
  },
  logoutIconContainer: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: "transparent",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 12,
  },
  contentHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
    paddingHorizontal: 20,
  },
  listIconContainer: {
    width: 44,
    height: 44,
    borderRadius: 22,
    justifyContent: "center",
    alignItems: "center",
    marginRight: 16,
  },
  // Job Grid Styles
  jobsGrid: {
    paddingTop: 0,
    paddingBottom: 24,
  },
  jobsGridRow: {
    gap: 16,
    justifyContent: "flex-start",
  },
  jobRow: {
    justifyContent: "space-between",
    marginHorizontal: -4, // Negative margin to offset card margins
  },
  jobCard: {
    backgroundColor: "#ffffff",
    borderRadius: 12,
    padding: 16,
    margin: 0,
    marginBottom: 16,
    flex: 1,
    minWidth: 0,
    maxWidth: "32%",
    borderWidth: 1,
    borderColor: "#e9ecef",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 2,
    overflow: "visible",
  },
  jobCardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 16,
    paddingBottom: 12,
  },
  jobIconCircle: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: "#fff3cd",
    alignItems: "center",
    justifyContent: "center",
  },
  jobTypeBadge: {
    backgroundColor: "#e9ecef",
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
  },
  jobTypeBadgeText: {
    fontSize: 11,
    fontFamily: fonts.regular,
    color: "#495057",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  jobCategoryBadge: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#e7f3ff",
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
    marginTop: 8,
    alignSelf: "flex-start",
    gap: 4,
  },
  jobCategoryText: {
    fontSize: 11,
    fontFamily: fonts.regular,
    color: "#2c5aa0",
    textTransform: "capitalize",
  },
  remoteBadge: {
    backgroundColor: "#d4edda",
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 8,
  },
  remoteBadgeText: {
    fontSize: 10,
    fontFamily: fonts.regular,
    color: "#155724",
    textTransform: "uppercase",
  },
  jobCardContent: {
    paddingHorizontal: 16,
    paddingBottom: 16,
  },
  jobMetaRow: {
    marginTop: 12,
    gap: 8,
  },
  jobMetaItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  jobSalaryRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    marginTop: 8,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: "#f8f9fa",
  },
  jobCardFooter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: "#f8f9fa",
    borderTopWidth: 1,
    borderTopColor: "#e9ecef",
  },
  placeholderCard: {
    backgroundColor: "transparent",
    borderWidth: 0,
    shadowOpacity: 0,
    elevation: 0,
  },
  jobIconContainer: {
    alignItems: "center",
    marginBottom: 8,
  },
  jobIcon: {
    fontSize: 24,
    color: lightColors.deepNavy,
  },
  jobInfo: {
    flex: 1,
  },
  jobTitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: "#212529",
    marginBottom: 6,
    lineHeight: 22,
  },
  jobCompany: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: "#6c757d",
    marginBottom: 0,
  },
  jobCategory: {
    fontSize: 9,
    fontFamily: fonts.regular,
    color: lightColors.softBlue,
    marginBottom: 3,
    textAlign: "center",
  },
  jobLocation: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: "#6c757d",
    flex: 1,
  },
  jobSalary: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: "#198754",
    flex: 1,
  },
  jobBadgesContainer: {
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 6,
  },
  jobBadge: {
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 8,
    marginBottom: 2,
    minWidth: 50,
  },
  jobBadgeText: {
    fontSize: 9,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    textAlign: "center",
  },
  jobSource: {
    fontSize: 9,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginBottom: 2,
    textAlign: "center",
  },
  jobDate: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: "#6c757d",
  },
  // Category Management Styles
  emptyContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 60,
  },
  emptyText: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginTop: 16,
    marginBottom: 8,
  },
  emptySubtext: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    textAlign: "center",
  },
  subcategoryItem: {
    backgroundColor: lightColors.lightGray,
    borderLeftWidth: 4,
    borderLeftColor: lightColors.beeYellow,
    marginLeft: 20,
  },
  subcategoryTitle: {
    fontSize: 14,
    color: lightColors.charcoal,
  },

  // Category Tags Styles
  categoryTagsContainer: {
    marginTop: 8,
  },
  categoryTagsLabel: {
    fontSize: 11,
    fontWeight: "600",
    marginBottom: 6,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  categoryTagsWrapper: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
    alignItems: "center",
  },
  categoryTag: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    borderWidth: 1,
  },
  categoryTagText: {
    fontSize: 11,
    fontWeight: "500",
  },
  categoryTagMore: {
    fontSize: 11,
    fontStyle: "italic",
  },
  editTagsButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    marginLeft: 8,
  },
  editTagsButtonText: {
    fontSize: 13,
    fontWeight: "600",
  },
  subcategoryEditButton: {
    paddingHorizontal: 8,
    paddingVertical: 6,
  },
  subcategoryEditButtonText: {
    fontSize: 11,
  },

  // Tag Editor Styles
  tagEditorContainer: {
    marginHorizontal: 16,
    marginBottom: 12,
    padding: 16,
    borderRadius: 12,
    borderWidth: 1,
  },
  subcategoryTagEditor: {
    marginLeft: 36,
  },
  tagEditorTitle: {
    fontSize: 16,
    fontWeight: "600",
    marginBottom: 16,
  },
  addTagSection: {
    flexDirection: "row",
    gap: 8,
    marginBottom: 16,
  },
  addTagInputWrapper: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    borderWidth: 1.5,
    borderRadius: 10,
    paddingHorizontal: 12,
    paddingVertical: 10,
  },
  addTagInput: {
    flex: 1,
    fontSize: 14,
    padding: 0,
  },
  addTagButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 10,
  },
  addTagButtonText: {
    fontSize: 14,
    fontWeight: "600",
  },
  existingTagsSection: {
    marginTop: 8,
  },
  existingTagsTitle: {
    fontSize: 12,
    fontWeight: "600",
    marginBottom: 8,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  tagsListScroll: {
    maxHeight: 250,
  },
  tagsListContainer: {
    gap: 6,
  },
  tagItemCard: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 10,
    borderRadius: 8,
    borderWidth: 1,
  },
  tagItemText: {
    flex: 1,
    fontSize: 13,
    fontWeight: "500",
  },
  removeTagButton: {
    width: 28,
    height: 28,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
  },
  noTagsMessage: {
    alignItems: "center",
    padding: 24,
    gap: 8,
  },
  noTagsText: {
    fontSize: 13,
    textAlign: "center",
  },

  // Home Screen Styles
  toolbar: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 10,
    backgroundColor: lightColors.white,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.sidebarBorder,
    elevation: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  toolbarLeft: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  appIcon: {
    fontSize: 24,
    marginRight: 6,
  },
  appTitle: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  toolbarCenter: {
    flex: 2,
    paddingHorizontal: 16,
  },
  searchContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: lightColors.lightGray,
    borderRadius: 20,
    paddingHorizontal: 12,
    paddingVertical: 8,
  },
  searchInput: {
    flex: 1,
    marginLeft: 8,
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  toolbarRight: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    justifyContent: "flex-end",
  },
  toolbarButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 6,
    marginLeft: 8,
  },
  toolbarButtonText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginLeft: 4,
  },
  // Download app buttons
  downloadButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginHorizontal: 4,
    backgroundColor: lightColors.beeYellow,
    borderRadius: 8,
    elevation: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
  },
  downloadButtonText: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginLeft: 4,
  },
  downloadButtonImage: {
    height: 40,
    width: 135,
    marginHorizontal: 4,
  },
  downloadButtonsContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: 8,
  },
  // Icon-only theme switcher
  iconButton: {
    padding: 8,
    borderRadius: 8,
    backgroundColor: lightColors.lightGray,
    alignItems: "center",
    justifyContent: "center",
    marginHorizontal: 4,
  },
  // Language dropdown styles
  languageDropdownContainer: {
    position: "relative",
    marginHorizontal: 8,
    // Removed z-index since we're using full-screen overlay now
  },
  languageDropdownButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
    backgroundColor: lightColors.lightGray,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: lightColors.warmGray,
  },
  languageCode: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginRight: 4,
  },
  languageDropdown: {
    position: "absolute",
    top: 42,
    right: 0,
    backgroundColor: lightColors.white,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: lightColors.warmGray,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 10, // Higher elevation for Android
    minWidth: 160,
    zIndex: 10000, // Highest z-index to ensure it's on top
  },
  languageOption: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.lightGray,
  },
  languageOptionActive: {
    backgroundColor: lightColors.cream,
  },
  languageLabel: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    flex: 1,
  },
  dropdownOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 999,
  },
  // Floating Action Button styles
  fab: {
    position: "absolute",
    bottom: 90,
    right: 20,
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: lightColors.beeYellow,
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
    zIndex: 100,
  },
  fabSmall: {
    width: 48,
    height: 48,
    borderRadius: 24,
    bottom: 24,
  },
  fabSecondary: {
    backgroundColor: lightColors.deepNavy,
  },
  // Full-screen dropdown overlay styles
  fullScreenDropdownOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 999999, // Extremely high z-index to ensure it's on top
  },
  fullScreenTouchArea: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  absoluteLanguageDropdown: {
    position: "absolute",
    // top and right will be set dynamically via inline styles
    backgroundColor: lightColors.white,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: lightColors.warmGray,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 12,
    elevation: 20, // Very high elevation for Android
    minWidth: 160,
    zIndex: 9999999, // Maximum z-index
  },
  homeContent: {
    flex: 1,
    backgroundColor: lightColors.cream,
  },
  mainContent: {
    flex: 1,
    backgroundColor: "#ffffff",
  },
  leftContent: {
    flex: 1,
    backgroundColor: "#ffffff",
  },
  channelsSectionWrapper: {
    width: "100%",
    backgroundColor: "#ffffff",
  },
  channelsSection: {
    backgroundColor: "#ffffff",
    paddingVertical: 60,
    paddingHorizontal: 24,
    marginBottom: 0,
    maxWidth: 1200,
    alignSelf: "center",
    width: "100%",
  },
  channelsContainer: {
    width: "100%",
    marginTop: 32,
  },
  channelsScroll: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  channelsScrollContainer: {
    paddingHorizontal: 24,
    gap: 16,
  },
  sectionTitle: {
    fontSize: 36,
    fontFamily: fonts.regular,
    color: "#212529",
    textAlign: "center",
    marginBottom: 12,
    letterSpacing: -0.5,
  },
  channelsHint: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    textAlign: "center",
    marginTop: 12,
    fontStyle: "italic",
  },
  channelCardWrapper: {
    marginRight: 10,
  },
  channelCard: {
    backgroundColor: "#ffffff",
    borderRadius: 16,
    padding: 12,
    width: 110,
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#e9ecef",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 3,
  },
  channelCardTop: {
    position: "relative",
    alignItems: "center",
    paddingTop: 24,
    paddingBottom: 16,
    backgroundColor: "#f8f9fa",
  },
  channelAvatarContainer: {
    marginBottom: 8,
  },
  channelAvatar: {
    width: 60,
    height: 60,
    borderRadius: 30,
    borderWidth: 2,
    borderColor: "#ffffff",
  },
  channelAvatarPlaceholder: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: "#0088cc",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 2,
    borderColor: "#ffffff",
  },
  channelVerifiedBadge: {
    position: "absolute",
    top: 20,
    right: -5,
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: "#ffffff",
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  channelCardContent: {
    padding: 16,
    paddingTop: 12,
    flex: 1,
  },
  channelName: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: "#212529",
    textAlign: "center",
    lineHeight: 16,
  },
  channelMeta: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
  },
  channelMemberCount: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: "#6c757d",
  },
  channelCardFooter: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    paddingVertical: 12,
    backgroundColor: "#fff3cd",
    borderTopWidth: 1,
    borderTopColor: "#e9ecef",
  },
  channelJoinText: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: "#212529",
    letterSpacing: 0.3,
  },
  channelDefaultIcon: {
    backgroundColor: lightColors.beeYellow,
    borderRadius: 25,
    width: 50,
    height: 50,
    justifyContent: "center",
    alignItems: "center",
  },
  channelFaviconImage: {
    width: 30,
    height: 30,
    borderRadius: 15,
  },
  channelImageContainer: {
    marginBottom: 8,
    alignItems: "center",
  },
  channelImageCircle: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: lightColors.beeYellow,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    overflow: "hidden",
  },
  channelImage: {
    width: 50,
    height: 50,
    borderRadius: 25,
  },
  channelEmoji: {
    fontSize: 24,
  },
  jobsSection: {
    backgroundColor: "#ffffff",
    paddingVertical: 60,
    paddingHorizontal: 24,
    maxWidth: 1200,
    alignSelf: "center",
    width: "100%",
  },
  jobsSectionHeader: {
    textAlign: "center",
    marginBottom: 8,
  },
  jobsMainContainer: {
    flexDirection: "row",
    gap: 24,
    flex: 1,
    alignItems: "flex-start",
  },
  filterSidebarInline: {
    width: 260,
    backgroundColor: "#f8f9fa",
    borderRadius: 16,
    padding: 24,
    alignSelf: "flex-start",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
  },
  jobsGridContainer: {
    flex: 1,
  },
  jobsHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
  },
  jobsCount: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  filterSidebar: {
    width: 300,
    backgroundColor: lightColors.white,
    borderLeftWidth: 1,
    borderLeftColor: `${lightColors.lightGray}80`,
    paddingVertical: 24,
    paddingHorizontal: 20,
    shadowColor: "#000",
    shadowOffset: { width: -2, height: 0 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 3,
  },
  filterTitle: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 20,
  },
  filterSection: {
    marginBottom: 24,
  },
  filterLabel: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 12,
  },
  filterScrollView: {
    maxHeight: 150,
  },
  filterOption: {
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 8,
    marginBottom: 6,
    backgroundColor: lightColors.lightGray,
  },
  filterOptionActive: {
    backgroundColor: lightColors.beeYellow,
  },
  filterOptionText: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  filterOptionTextActive: {
    color: lightColors.white,
    fontFamily: fonts.regular,
  },
  clearFiltersButton: {
    backgroundColor: lightColors.danger,
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
    marginTop: 16,
  },
  clearFiltersText: {
    color: lightColors.white,
    fontSize: 14,
    fontFamily: fonts.regular,
    textAlign: "center",
  },
  // Brand Image Styles
  appIconImage: {
    width: 28,
    height: 28,
    marginRight: 8,
  },
  loginLogoImage: {
    width: 80,
    height: 80,
    marginBottom: 16,
  },
  loadingLogoImage: {
    width: 240,
    height: 240,
    marginBottom: 16,
  },
  sidebarLogoImage: {
    width: 20,
    height: 20,
  },

  // Modern Header Styles
  modernHeaderContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 24,
    paddingVertical: 16,
    maxWidth: 1200,
    alignSelf: "center",
    width: "100%",
  },
  modernLogoSection: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  modernLogoContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 32,
  },
  modernLogoBadge: {
    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: lightColors.beeYellow,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.08)",
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 2,
  },
  modernLogo: {
    width: 24,
    height: 24,
  },
  modernNavigation: {
    flexDirection: "row",
    alignItems: "center",
    gap: 24,
  },
  modernNavItem: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
  },
  modernHeaderRight: {
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
  },
  modernQuickActions: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  modernIconButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: lightColors.lightGray,
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.06)",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  modernLanguageButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    backgroundColor: lightColors.lightGray,
    gap: 4,
    borderWidth: 1,
    borderColor: "rgba(0, 0, 0, 0.06)",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  modernLanguageText: {
    fontSize: 14,
    fontWeight: "600",
    color: lightColors.deepNavy,
  },
  modernDownloadButtons: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  modernDownloadButton: {
    height: 56,
    width: 190,
  },
  modernSecondaryButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 24,
    backgroundColor: "transparent",
    borderWidth: 2,
    borderColor: lightColors.deepNavy,
    gap: 8,
  },
  modernSecondaryButtonText: {
    fontSize: 14,
    fontWeight: "600",
    color: lightColors.deepNavy,
  },
  modernPrimaryButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 24,
    backgroundColor: lightColors.deepNavy,
    gap: 8,
  },
  modernPrimaryButtonText: {
    fontSize: 14,
    fontWeight: "600",
    color: lightColors.white,
  },
  googleButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 14,
    paddingHorizontal: 20,
    borderRadius: 12,
    backgroundColor: lightColors.white,
    borderWidth: 2,
    borderColor: lightColors.softBlue,
    marginTop: 16,
    gap: 10,
  },
  googleButtonText: {
    fontSize: 16,
    fontWeight: "600",
    color: lightColors.deepNavy,
  },
  dividerContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 24,
  },
  divider: {
    flex: 1,
    height: 1,
    backgroundColor: lightColors.warmGray,
    opacity: 0.3,
  },
  dividerText: {
    marginHorizontal: 16,
    fontSize: 14,
    color: lightColors.warmGray,
    fontWeight: "500",
  },
  signupLinkContainer: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 24,
  },
  signupLinkText: {
    fontSize: 14,
    color: lightColors.warmGray,
  },
  signupLink: {
    fontSize: 14,
    color: lightColors.softBlue,
    fontWeight: "600",
  },
  forgotPasswordLink: {
    alignSelf: "center",
    marginTop: 16,
    paddingVertical: 8,
  },
  forgotPasswordText: {
    fontSize: 14,
    color: lightColors.softBlue,
    fontFamily: fonts.regular,
  },
  forgotPasswordDescription: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    textAlign: "center",
    marginBottom: 24,
    lineHeight: 20,
  },

  // Hero Section Styles
  heroContent: {
    flexDirection: "row",
    alignItems: "center",
    maxWidth: 1200,
    alignSelf: "center",
    width: "100%",
    paddingHorizontal: 24,
    paddingVertical: 60,
    gap: 60,
  },
  heroTextSection: {
    flex: 1,
  },
  heroImageSection: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  heroMascotImage: {
    width: 300,
    height: 300,
  },
  heroImagePlaceholder: {
    width: 300,
    height: 200,
    borderRadius: 20,
    backgroundColor: lightColors.cream,
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 2,
    borderColor: lightColors.beeYellow,
    borderStyle: "dashed",
  },
  modernSearchButton: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: lightColors.deepNavy,
    alignItems: "center",
    justifyContent: "center",
  },
  heroStats: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 24,
    marginTop: 24,
    justifyContent: "center",
  },
  heroStat: {
    alignItems: "center",
    minWidth: 80,
  },
  heroDownloadImage: {
    height: 50,
    width: 170,
    marginTop: 32,
  },

  // Mobile Menu Styles
  mobileMenuOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
  },
  mobileMenuBackdrop: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  mobileMenu: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "80%",
    maxWidth: 320,
    height: "100%",
    backgroundColor: lightColors.white,
  },
  mobileMenuHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.lightGray,
  },
  mobileMenuContent: {
    flex: 1,
    paddingVertical: 16,
  },
  mobileMenuItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    paddingHorizontal: 20,
    gap: 16,
  },
  mobileMenuDivider: {
    height: 1,
    backgroundColor: lightColors.lightGray,
    marginVertical: 16,
    marginHorizontal: 20,
  },
  mobileMenuDownloads: {
    paddingHorizontal: 20,
  },
  mobileMenuDownloadItem: {
    marginVertical: 8,
  },
  mobileDownloadButton: {
    height: 40,
  },

  // About Us Section Styles
  aboutSection: {
    backgroundColor: "#ffffff",
    paddingVertical: 60,
    paddingHorizontal: 20,
    marginBottom: 0,
  },
  sectionHeader: {
    alignItems: "center",
    marginBottom: 40,
  },
  aboutContent: {
    maxWidth: 1200,
    alignSelf: "center",
    width: "100%",
  },
  aboutTextContainer: {
    width: "100%",
  },
  aboutFeatures: {
    marginTop: 40,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 20,
    justifyContent: "space-between",
  },
  aboutFeature: {
    flexDirection: "row",
    gap: 12,
    flex: 1,
    minWidth: 260,
    maxWidth: 500,
    backgroundColor: "#ffffff",
    padding: 20,
    borderRadius: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
    elevation: 3,
  },
  aboutFeatureText: {
    flex: 1,
  },
  aboutFeatureIconContainer1: {
    width: 56,
    height: 56,
    borderRadius: 12,
    backgroundColor: "#FF6B35",
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#FF6B35",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 4,
  },
  aboutFeatureIconContainer2: {
    width: 56,
    height: 56,
    borderRadius: 12,
    backgroundColor: "#FFB84D",
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#FFB84D",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 4,
  },
  aboutFeatureIconContainer3: {
    width: 56,
    height: 56,
    borderRadius: 12,
    backgroundColor: "#4A90E2",
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#4A90E2",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 4,
  },
  pricingSection: {
    backgroundColor: "#f8f9fa",
    paddingVertical: 60,
    paddingHorizontal: 20,
    marginBottom: 0,
  },
  pricingGrid: {
    maxWidth: 1200,
    alignSelf: "center",
    width: "100%",
    flexDirection: "row",
    gap: 32,
    marginTop: 56,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  pricingCard: {
    backgroundColor: "#ffffff",
    borderRadius: 20,
    padding: 40,
    flex: 1,
    minWidth: 300,
    maxWidth: 380,
    borderWidth: 1,
    borderColor: "#e9ecef",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 16,
    elevation: 4,
  },
  pricingCardPopular: {
    borderColor: lightColors.beeYellow,
    borderWidth: 2,
    transform: [{ scale: 1.05 }],
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.15,
    shadowRadius: 24,
    elevation: 8,
  },
  pricingBadge: {
    position: "absolute",
    top: -16,
    right: 32,
    backgroundColor: lightColors.beeYellow,
    paddingHorizontal: 20,
    paddingVertical: 8,
    borderRadius: 24,
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 4,
  },
  pricingBadgeText: {
    fontSize: 11,
    fontFamily: fonts.regular,
    color: "#ffffff",
    letterSpacing: 1.5,
    textTransform: "uppercase",
  },
  pricingHeader: {
    alignItems: "center",
    marginBottom: 32,
    paddingBottom: 32,
    borderBottomWidth: 1,
    borderBottomColor: "#e9ecef",
  },
  pricingIcon: {
    marginBottom: 20,
  },
  pricingFeatures: {
    gap: 20,
    marginBottom: 32,
  },
  pricingFeature: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 12,
  },
  pricingFeatureDisabled: {
    opacity: 0.3,
  },
  pricingButton: {
    backgroundColor: lightColors.beeYellow,
    paddingVertical: 18,
    paddingHorizontal: 32,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    elevation: 3,
  },
  pricingButtonOutline: {
    backgroundColor: "transparent",
    borderWidth: 2,
    borderColor: "#495057",
    shadowColor: "transparent",
  },
  pricingButtonText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: "#ffffff",
    letterSpacing: 0.5,
  },
  pricingButtonOutlineText: {
    color: "#495057",
  },

  // How It Works Section
  howItWorksSection: {
    paddingVertical: 60,
    paddingHorizontal: 20,
  },
  howItWorksSteps: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 24,
    marginTop: 40,
  },
  howItWorksStep: {
    flex: 1,
    minWidth: 200,
    maxWidth: 350,
    alignItems: "center",
    padding: 20,
  },
  howItWorksIcon: {
    width: 70,
    height: 70,
    borderRadius: 35,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
  },

  // Categories Preview Section
  categoriesPreviewSection: {
    paddingVertical: 60,
    paddingHorizontal: 20,
  },
  categoriesGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 20,
    marginTop: 40,
    justifyContent: "center",
  },
  categoryCard: {
    flex: 1,
    minWidth: 150,
    maxWidth: 300,
    padding: 24,
    borderRadius: 16,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 3,
  },

  // Testimonials Section
  testimonialsSection: {
    paddingVertical: 60,
    paddingHorizontal: 20,
  },
  testimonialsGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 24,
    marginTop: 40,
    justifyContent: "center",
  },
  testimonialCard: {
    flex: 1,
    minWidth: 250,
    maxWidth: 380,
    padding: 24,
    borderRadius: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 3,
  },
  testimonialRating: {
    flexDirection: "row",
    gap: 4,
    marginBottom: 16,
  },
  testimonialAuthor: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    marginTop: 20,
  },
  testimonialAvatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    justifyContent: "center",
    alignItems: "center",
  },
  testimonialAvatarText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },

  // Job Alert Section
  jobAlertSection: {
    paddingVertical: 60,
    paddingHorizontal: 20,
    marginVertical: 32,
  },
  jobAlertContent: {
    maxWidth: 600,
    alignSelf: "center",
    alignItems: "center",
    textAlign: "center",
  },
  jobAlertTitle: {
    fontSize: 28,
    fontWeight: "800",
    color: "#1A202C",
    marginTop: 20,
    marginBottom: 12,
    fontFamily: fonts.bold,
    textAlign: "center",
  },
  jobAlertSubtitle: {
    fontSize: 16,
    color: "#2D3748",
    marginBottom: 28,
    textAlign: "center",
    lineHeight: 24,
    fontFamily: fonts.regular,
  },
  jobAlertButton: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#1A202C",
    paddingHorizontal: 32,
    paddingVertical: 16,
    borderRadius: 12,
    gap: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 12,
    elevation: 5,
  },
  jobAlertButtonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },

  // FAQ Section
  faqSection: {
    paddingVertical: 60,
    paddingHorizontal: 20,
  },
  faqList: {
    maxWidth: 800,
    alignSelf: "center",
    width: "100%",
    gap: 16,
    marginTop: 40,
  },
  faqItem: {
    padding: 20,
    borderRadius: 12,
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },

  // Footer Styles
  footerSection: {
    backgroundColor: "#212529",
    paddingVertical: 48,
    paddingHorizontal: 20,
  },
  footerContent: {
    maxWidth: 1200,
    alignSelf: "center",
    width: "100%",
  },
  footerTop: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 32,
    marginBottom: 40,
    justifyContent: "space-between",
  },
  footerColumn: {
    flex: 1,
    minWidth: 180,
  },
  footerLogoSection: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 16,
    gap: 12,
  },
  footerLogo: {
    width: 32,
    height: 32,
  },
  footerBrandName: {
    fontSize: 24,
    fontFamily: fonts.regular,
    color: "#ffffff",
  },
  footerDescription: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: "#adb5bd",
    lineHeight: 22,
    marginBottom: 20,
  },
  footerSocial: {
    flexDirection: "row",
    gap: 12,
  },
  footerSocialButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: "#343a40",
    alignItems: "center",
    justifyContent: "center",
  },
  footerColumnTitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: "#ffffff",
    marginBottom: 20,
    letterSpacing: 0.5,
  },
  footerLink: {
    paddingVertical: 8,
  },
  footerLinkText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: "#adb5bd",
  },
  footerBottom: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 32,
    borderTopWidth: 1,
    borderTopColor: "#343a40",
    flexWrap: "wrap",
    gap: 16,
  },
  footerCopyright: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: "#6c757d",
  },
  footerBottomLinks: {
    flexDirection: "row",
    gap: 12,
    alignItems: "center",
  },
  footerBottomLinkText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: "#6c757d",
  },
  footerDivider: {
    fontSize: 14,
    color: "#6c757d",
  },

  // Job Details Screen Styles
  jobDetailsContainer: {
    flex: 1,
    backgroundColor: "#f8f9fa",
  },
  jobDetailsHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 20,
    paddingVertical: 16,
    backgroundColor: lightColors.white,
    borderBottomWidth: 1,
    borderBottomColor: "#e9ecef",
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: "#f8f9fa",
    alignItems: "center",
    justifyContent: "center",
  },
  jobDetailsHeaderTitle: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  jobDetailsTopSection: {
    backgroundColor: lightColors.white,
    padding: 24,
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#e9ecef",
  },
  jobDetailsIconContainer: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: "#fff3cd",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 16,
  },
  jobDetailsTitle: {
    fontSize: 24,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    textAlign: "center",
    marginBottom: 8,
  },
  jobDetailsCompany: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    textAlign: "center",
    marginBottom: 16,
  },
  jobDetailsBadges: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
    justifyContent: "center",
  },
  jobDetailsBadge: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#e9ecef",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    gap: 4,
  },
  jobDetailsBadgeText: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: "#495057",
    textTransform: "uppercase",
  },
  remoteBadgeLarge: {
    backgroundColor: "#d4edda",
  },
  remoteBadgeTextLarge: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: "#155724",
    textTransform: "uppercase",
  },
  categoryBadgeLarge: {
    backgroundColor: "#e7f3ff",
  },
  categoryBadgeTextLarge: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: "#2c5aa0",
  },
  jobDetailsInfoSection: {
    padding: 20,
    gap: 12,
  },
  jobDetailsInfoCard: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: lightColors.white,
    padding: 16,
    borderRadius: 12,
    gap: 12,
    borderWidth: 1,
    borderColor: "#e9ecef",
  },
  jobDetailsInfoContent: {
    flex: 1,
  },
  jobDetailsInfoLabel: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginBottom: 4,
  },
  jobDetailsInfoValue: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  jobDetailsSection: {
    backgroundColor: lightColors.white,
    padding: 20,
    marginHorizontal: 20,
    marginBottom: 12,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#e9ecef",
  },
  jobDetailsSectionTitle: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 12,
  },
  jobDetailsDescription: {
    fontSize: 15,
    fontFamily: fonts.regular,
    color: lightColors.charcoal,
    lineHeight: 24,
  },
  jobTagsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  jobTag: {
    backgroundColor: "#e7f3ff",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
  },
  jobTagText: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.softBlue,
  },
  jobDetailsApplySection: {
    padding: 20,
    paddingBottom: 40,
  },
  jobDetailsApplyButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: lightColors.deepNavy,
    paddingVertical: 16,
    borderRadius: 12,
    gap: 8,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    elevation: 4,
  },
  jobDetailsApplyButtonText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.white,
  },
  jobDetailsMainContainer: {
    flexDirection: "row",
    flex: 1,
    backgroundColor: "#f8f9fa",
  },
  relatedJobsSidebar: {
    width: 280,
    minWidth: 280,
    maxWidth: 320,
    backgroundColor: lightColors.white,
    padding: 20,
    borderLeftWidth: 1,
    borderLeftColor: "#e9ecef",
  },
  relatedJobsTitle: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 16,
  },
  relatedJobCard: {
    backgroundColor: lightColors.white,
    padding: 12,
    borderRadius: 12,
    marginBottom: 14,
    borderWidth: 1,
    borderColor: "#e9ecef",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },
  relatedJobHeader: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 10,
    marginBottom: 10,
  },
  relatedJobIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
  },
  relatedJobIconPlaceholder: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: lightColors.cream,
    justifyContent: "center",
    alignItems: "center",
  },
  relatedJobTitle: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 3,
    lineHeight: 18,
  },
  relatedJobCompany: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  relatedJobDetails: {
    gap: 6,
    marginBottom: 10,
  },
  relatedJobDetailItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  relatedJobDetailText: {
    fontSize: 11,
    fontFamily: fonts.regular,
    color: lightColors.charcoal,
    flex: 1,
  },
  relatedJobFooter: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: "#f0f0f0",
  },
  relatedJobSalaryBadge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    backgroundColor: "#d4edda",
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
  },
  relatedJobSalary: {
    fontSize: 11,
    fontFamily: fonts.regular,
    color: lightColors.success,
  },
  relatedJobTime: {
    fontSize: 10,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  relatedJobMeta: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  relatedJobLocation: {
    fontSize: 11,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  relatedJobsEmpty: {
    alignItems: "center",
    justifyContent: "center",
    padding: 32,
    marginTop: 20,
  },
  relatedJobsEmptyText: {
    fontSize: 15,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginTop: 12,
    textAlign: "center",
  },
  relatedJobsEmptySubtext: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginTop: 6,
    textAlign: "center",
  },
  // Similar Jobs Bottom Section - Mobile
  similarJobsBottomSection: {
    backgroundColor: lightColors.white,
    paddingTop: 20,
    paddingBottom: 12,
    borderTopWidth: 8,
    borderTopColor: lightColors.cream,
  },
  similarJobsBottomHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingHorizontal: 16,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.lightGray,
  },
  similarJobsBottomTitle: {
    fontSize: 18,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
  },
  similarJobsHorizontalScroll: {
    paddingHorizontal: 16,
    paddingVertical: 16,
    gap: 12,
  },
  similarJobCardMobile: {
    width: 260,
    backgroundColor: lightColors.cream,
    borderRadius: 12,
    padding: 14,
    marginRight: 12,
    borderWidth: 1,
    borderColor: lightColors.lightGray,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 3,
  },
  similarJobHeaderMobile: {
    marginBottom: 12,
    alignItems: "center",
  },
  similarJobIconMobile: {
    width: 48,
    height: 48,
    borderRadius: 12,
  },
  similarJobIconPlaceholderMobile: {
    width: 48,
    height: 48,
    borderRadius: 12,
    backgroundColor: lightColors.white,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderColor: lightColors.lightGray,
  },
  similarJobContentMobile: {
    gap: 8,
  },
  similarJobTitleMobile: {
    fontSize: 15,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
    lineHeight: 20,
    minHeight: 40,
  },
  similarJobCompanyMobile: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginBottom: 4,
  },
  similarJobDetailsMobile: {
    gap: 6,
  },
  similarJobDetailItemMobile: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  similarJobDetailTextMobile: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    flex: 1,
  },
  similarJobFooterMobile: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 8,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: lightColors.lightGray,
  },
  similarJobSalaryBadgeMobile: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    backgroundColor: lightColors.white,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
  },
  similarJobSalaryMobile: {
    fontSize: 12,
    fontFamily: fonts.medium,
    color: lightColors.success,
  },
  similarJobTimeMobile: {
    fontSize: 11,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  jobDetailsContent: {
    flex: 1,
    backgroundColor: "#f8f9fa",
  },
  skillTag: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#d4edda",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    gap: 6,
  },
  skillTagText: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: "#155724",
  },
  sourceChannelImage: {
    width: 32,
    height: 32,
    borderRadius: 16,
    marginRight: 8,
  },
  headerActions: {
    flexDirection: "row",
    gap: 12,
  },
  headerActionButton: {
    padding: 8,
    borderRadius: 8,
    backgroundColor: lightColors.cream,
  },
  relatedJobsSidebarHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginBottom: 16,
  },
  jobHeaderCard: {
    backgroundColor: lightColors.white,
    borderRadius: 16,
    padding: 24,
    marginBottom: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 2,
  },
  jobHeaderTop: {
    flexDirection: "row",
    marginBottom: 20,
  },
  jobHeaderInfo: {
    flex: 1,
    marginLeft: 16,
  },
  companyLogo: {
    width: 64,
    height: 64,
    borderRadius: 12,
  },
  companyLogoPlaceholder: {
    width: 64,
    height: 64,
    borderRadius: 12,
    backgroundColor: lightColors.cream,
    justifyContent: "center",
    alignItems: "center",
  },
  jobPostedTime: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  quickStatsContainer: {
    flexDirection: "row",
    gap: 20,
    marginTop: 16,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: "#e9ecef",
  },
  quickStat: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  quickStatText: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  salaryHighlight: {
    backgroundColor: "#d4edda",
    borderRadius: 12,
    padding: 16,
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    marginTop: 16,
    borderWidth: 1,
    borderColor: "#c3e6cb",
  },
  salaryHighlightText: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: "#155724",
  },
  keyInfoSection: {
    marginBottom: 20,
  },
  jobDetailsSectionHeader: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 16,
    flexDirection: "row",
    alignItems: "center",
  },
  infoCardIcon: {
    width: 48,
    height: 48,
    borderRadius: 12,
    backgroundColor: "#f8f9fa",
    justifyContent: "center",
    alignItems: "center",
  },
  contentCard: {
    backgroundColor: lightColors.white,
    borderRadius: 12,
    padding: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 4,
    elevation: 1,
  },
  benefitsList: {
    gap: 12,
  },
  benefitItem: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 12,
  },
  benefitText: {
    flex: 1,
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.charcoal,
    lineHeight: 22,
  },
  preferredSkillTag: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff3cd",
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    gap: 6,
  },
  preferredSkillTagText: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: "#856404",
  },
  sourceInfoSection: {
    backgroundColor: lightColors.white,
    borderRadius: 12,
    padding: 20,
    marginBottom: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 4,
    elevation: 1,
  },
  sourceInfoLabel: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginBottom: 12,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  sourceInfoContent: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  sourceChannelImageLarge: {
    width: 48,
    height: 48,
    borderRadius: 24,
  },
  sourceInfoText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  applyDisclaimer: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    textAlign: "center",
    marginTop: 12,
  },
  jobDetailsFooter: {
    backgroundColor: lightColors.white,
    borderTopWidth: 1,
    borderTopColor: "#e9ecef",
    paddingVertical: 24,
    paddingHorizontal: 20,
    marginTop: 32,
  },
  jobFooterContent: {
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    marginBottom: 20,
  },
  jobFooterSection: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  jobFooterText: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  jobFooterDividerVertical: {
    width: 1,
    height: 20,
    backgroundColor: "#e9ecef",
  },
  jobFooterBottom: {
    alignItems: "center",
    gap: 8,
    marginBottom: 16,
  },
  jobFooterBottomText: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    textAlign: "center",
  },
  jobFooterLinks: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 12,
  },
  jobFooterLinkDivider: {
    fontSize: 12,
    color: lightColors.warmGray,
  },

  // Modern Toolbar Styles
  modernToolbar: {
    backgroundColor: lightColors.white,
    borderBottomWidth: 1,
    borderBottomColor: "#e9ecef",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 3,
    elevation: 3,
    position: "relative",
    zIndex: 1000,
  },
  modernToolbarContent: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 12,
    paddingVertical: 10,
    maxWidth: 1400,
    alignSelf: "center",
    width: "100%",
  },
  modernToolbarLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    flex: 1,
  },
  modernBackButton: {
    width: 36,
    height: 36,
    borderRadius: 8,
    backgroundColor: `${lightColors.beeYellow}15`,
    justifyContent: "center",
    alignItems: "center",
  },
  modernToolbarLogo: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  modernToolbarLogoBadge: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: lightColors.beeYellow,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 3,
  },
  modernToolbarLogoImage: {
    width: 20,
    height: 20,
  },
  modernToolbarBrandText: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    letterSpacing: -0.5,
  },
  modernToolbarNav: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginLeft: 16,
  },
  modernToolbarNavItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 8,
    backgroundColor: "transparent",
  },
  modernToolbarNavText: {
    fontSize: 15,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  modernToolbarCenter: {
    flex: 2,
    alignItems: "center",
    position: "relative",
    zIndex: 100,
  },
  modernSearchContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: lightColors.white,
    borderWidth: 1.5,
    borderColor: "#e9ecef",
    borderRadius: 12,
    paddingHorizontal: 14,
    paddingVertical: 10,
    width: "100%",
    maxWidth: 500,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  modernSearchIcon: {
    marginRight: 8,
  },
  modernSearchInput: {
    flex: 1,
    fontSize: 15,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    outlineStyle: "none",
  },
  modernSearchResults: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: lightColors.white,
    borderRadius: 12,
    marginTop: 8,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 12,
    elevation: 5,
    borderWidth: 1,
    borderColor: "#e9ecef",
    zIndex: 1000,
  },
  modernSearchResultItem: {
    flexDirection: "row",
    alignItems: "center",
    padding: 14,
    borderBottomWidth: 1,
    borderBottomColor: "#f5f5f5",
    gap: 12,
  },
  modernSearchResultIcon: {
    width: 40,
    height: 40,
    borderRadius: 8,
    backgroundColor: `${lightColors.beeYellow}15`,
    justifyContent: "center",
    alignItems: "center",
  },
  modernSearchResultContent: {
    flex: 1,
  },
  modernSearchResultTitle: {
    fontSize: 15,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 4,
  },
  modernSearchResultMeta: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  modernSearchLoading: {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: lightColors.white,
    borderRadius: 12,
    marginTop: 8,
    padding: 20,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 12,
    elevation: 5,
    borderWidth: 1,
    borderColor: "#e9ecef",
  },
  modernSearchLoadingText: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  modernToolbarRight: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    flex: 1,
    justifyContent: "flex-end",
  },

  // Social Proof Card Styles
  socialProofCard: {
    backgroundColor: lightColors.white,
    borderRadius: 12,
    padding: 20,
    marginTop: 16,
    borderWidth: 1,
    borderColor: "#e9ecef",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },
  socialProofHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    marginBottom: 16,
  },
  socialProofTitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  socialProofStats: {
    gap: 12,
  },
  socialProofStat: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 10,
  },
  socialProofStatIcon: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: lightColors.cream,
    justifyContent: "center",
    alignItems: "center",
  },
  socialProofStatText: {
    flex: 1,
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.charcoal,
    lineHeight: 20,
  },
  socialProofStatBold: {
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },

  // Match Score Card Styles
  matchScoreCard: {
    backgroundColor: lightColors.white,
    borderRadius: 12,
    padding: 20,
    marginTop: 16,
    borderWidth: 2,
    borderColor: lightColors.beeYellow,
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 3,
  },
  matchScoreHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  matchScoreLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  matchScoreTitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  matchScoreSubtitle: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginTop: 2,
  },
  matchScoreBadge: {
    backgroundColor: lightColors.beeYellow,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
  },
  matchScorePercentage: {
    fontSize: 20,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  matchScoreBar: {
    height: 8,
    backgroundColor: lightColors.cream,
    borderRadius: 4,
    overflow: "hidden",
    marginBottom: 12,
  },
  matchScoreProgress: {
    height: "100%",
    backgroundColor: lightColors.beeYellow,
    borderRadius: 4,
  },
  matchScoreDescription: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: lightColors.charcoal,
    lineHeight: 18,
  },
  // Login Prompt Card Styles
  loginPromptCard: {
    backgroundColor: lightColors.white,
    marginHorizontal: 16,
    marginTop: 16,
    marginBottom: 16,
    padding: 20,
    borderRadius: 16,
    borderWidth: 2,
    borderColor: lightColors.beeYellow,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  loginPromptHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 12,
    gap: 12,
  },
  loginPromptTitle: {
    fontSize: 20,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  loginPromptSubtitle: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.charcoal,
    marginBottom: 16,
    lineHeight: 20,
  },
  loginPromptBenefits: {
    gap: 14,
    marginBottom: 20,
  },
  loginPromptBenefit: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  loginPromptBenefitText: {
    flex: 1,
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.charcoal,
    lineHeight: 20,
  },
  loginPromptButton: {
    backgroundColor: lightColors.deepNavy,
    paddingVertical: 14,
    paddingHorizontal: 24,
    borderRadius: 12,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  },
  loginPromptButtonText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.white,
  },
  // Sticky Apply Button
  stickyApplyButton: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: lightColors.white,
    paddingHorizontal: 16,
    paddingVertical: 12,
    paddingBottom: 20,
    borderTopWidth: 1,
    borderTopColor: lightColors.lightGray,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 8,
  },

  // ===== MODERN JOB DETAILS STYLES =====
  // Modern Job Header Card
  modernJobHeaderCard: {
    backgroundColor: lightColors.white,
    borderRadius: 16,
    padding: 16,
    marginHorizontal: 12,
    marginBottom: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
    elevation: 3,
    borderWidth: 1,
    borderColor: "#e9ecef",
  },
  modernJobHeaderTop: {
    flexDirection: "row",
    marginBottom: 16,
  },
  modernJobDetailsIconContainer: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 2,
  },
  modernCompanyLogo: {
    width: 60,
    height: 60,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#e9ecef",
  },
  modernCompanyLogoPlaceholder: {
    width: 60,
    height: 60,
    borderRadius: 12,
    backgroundColor: lightColors.cream,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#e9ecef",
  },
  modernJobHeaderInfo: {
    flex: 1,
    marginLeft: 12,
  },
  modernJobDetailsTitle: {
    fontSize: 18,
    fontFamily: fonts.bold,
    color: lightColors.deepNavy,
    marginBottom: 6,
    lineHeight: 24,
  },
  modernJobDetailsCompany: {
    fontSize: 15,
    fontFamily: fonts.medium,
    color: lightColors.softBlue,
    marginBottom: 8,
  },
  modernJobMetaRow: {
    flexDirection: "row",
    gap: 12,
    flexWrap: "wrap",
  },
  modernJobMetaItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  modernJobPostedTime: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  modernJobDetailsBadges: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 14,
  },
  modernJobDetailsBadge: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: lightColors.cream,
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 6,
    gap: 5,
    borderWidth: 1,
    borderColor: lightColors.lightGray,
  },
  modernJobDetailsBadgeText: {
    fontSize: 12,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
  },
  modernQuickStatsContainer: {
    flexDirection: "row",
    gap: 16,
    marginTop: 14,
    paddingTop: 14,
    borderTopWidth: 1,
    borderTopColor: "#e9ecef",
    flexWrap: "wrap",
  },
  modernQuickStat: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  modernStatIconCircle: {
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: lightColors.white,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#e9ecef",
  },
  modernQuickStatText: {
    fontSize: 13,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
  },
  modernMatchScoreCard: {
    backgroundColor: "#fff8e1",
    borderRadius: 12,
    padding: 14,
    marginTop: 14,
    borderWidth: 1.5,
    borderColor: lightColors.beeYellow,
    shadowColor: lightColors.beeYellow,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 3,
  },
  modernMatchScoreHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    flexWrap: "wrap",
    gap: 8,
  },
  modernMatchScoreLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
  },
  modernMatchScoreTitle: {
    fontSize: 15,
    fontFamily: fonts.bold,
    color: lightColors.deepNavy,
  },
  modernMatchScoreSubtitle: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
  },
  modernMatchScoreBadge: {
    backgroundColor: lightColors.beeYellow,
    borderRadius: 20,
    paddingHorizontal: 12,
    paddingVertical: 5,
  },
  modernMatchScorePercentage: {
    fontSize: 16,
    fontFamily: fonts.bold,
    color: lightColors.deepNavy,
  },
  modernMatchScoreBar: {
    height: 6,
    backgroundColor: lightColors.white,
    borderRadius: 3,
    overflow: "hidden",
    marginBottom: 10,
  },
  modernMatchScoreProgress: {
    height: "100%",
    backgroundColor: lightColors.beeYellow,
    borderRadius: 3,
  },
  modernMatchScoreDescription: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    lineHeight: 18,
  },
  modernSalaryHighlight: {
    backgroundColor: "#e8f5e9",
    borderRadius: 10,
    padding: 12,
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    marginTop: 14,
    borderWidth: 1,
    borderColor: "#c3e6cb",
  },
  modernSalaryHighlightText: {
    fontSize: 16,
    fontFamily: fonts.bold,
    color: lightColors.success,
  },

  // Modern Section Styles
  modernJobDetailsSection: {
    backgroundColor: lightColors.white,
    borderRadius: 12,
    padding: 16,
    marginHorizontal: 12,
    marginBottom: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.06,
    shadowRadius: 8,
    elevation: 2,
    borderWidth: 1,
    borderColor: "#e9ecef",
  },
  modernSectionHeaderContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    marginBottom: 14,
  },
  modernSectionIconCircle: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: lightColors.cream,
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#e9ecef",
  },
  modernJobDetailsSectionHeader: {
    fontSize: 17,
    fontFamily: fonts.bold,
    color: lightColors.deepNavy,
    flex: 1,
  },
  modernContentCard: {
    backgroundColor: lightColors.white,
    borderRadius: 10,
    padding: 0,
  },
  modernJobDetailsDescription: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    lineHeight: 22,
  },

  // Modern Info Cards
  modernJobDetailsInfoSection: {
    backgroundColor: lightColors.cream,
    borderRadius: 10,
    padding: 12,
    gap: 12,
  },
  modernJobDetailsInfoCard: {
    backgroundColor: lightColors.white,
    borderRadius: 10,
    padding: 12,
    flexDirection: "row",
    gap: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 1,
  },
  modernInfoCardIcon: {
    width: 44,
    height: 44,
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.08,
    shadowRadius: 3,
    elevation: 2,
  },
  modernJobDetailsInfoContent: {
    flex: 1,
    justifyContent: "center",
  },
  modernJobDetailsInfoLabel: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginBottom: 3,
  },
  modernJobDetailsInfoValue: {
    fontSize: 14,
    fontFamily: fonts.bold,
    color: lightColors.deepNavy,
  },

  // Modern Benefits List
  modernBenefitsList: {
    gap: 12,
  },
  modernBenefitItem: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 10,
  },
  modernBenefitText: {
    flex: 1,
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    lineHeight: 22,
  },

  // Modern Tags and Skills
  modernJobTagsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  modernSkillTag: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#e8f5e9",
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 6,
    gap: 5,
    borderWidth: 1,
    borderColor: lightColors.success,
  },
  modernSkillTagText: {
    fontSize: 12,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
  },
  modernPreferredSkillTag: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff8e1",
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 6,
    gap: 5,
    borderWidth: 1,
    borderColor: lightColors.honeyGold,
  },
  modernPreferredSkillTagText: {
    fontSize: 12,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
  },
  modernJobTag: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: lightColors.cream,
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 6,
    gap: 5,
    borderWidth: 1,
    borderColor: lightColors.beeYellow,
  },
  modernJobTagText: {
    fontSize: 12,
    fontFamily: fonts.medium,
    color: lightColors.deepNavy,
  },

  // Modern Sticky Apply Button
  modernStickyApplyButton: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: lightColors.white,
    paddingHorizontal: 16,
    paddingVertical: 12,
    paddingBottom: 20,
    borderTopWidth: 1,
    borderTopColor: lightColors.lightGray,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -3 },
    shadowOpacity: 0.12,
    shadowRadius: 12,
    elevation: 10,
  },
  modernJobDetailsApplyButton: {
    backgroundColor: lightColors.deepNavy,
    paddingVertical: 14,
    paddingHorizontal: 24,
    borderRadius: 10,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    shadowColor: lightColors.deepNavy,
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 5,
  },
  modernJobDetailsApplyButtonText: {
    fontSize: 16,
    fontFamily: fonts.bold,
    color: lightColors.white,
    letterSpacing: 0.3,
  },
  // ===== END MODERN JOB DETAILS STYLES =====

  // Telegram Source Styles
  telegramSourceSection: {
    margin: 16,
    marginBottom: 24,
  },
  telegramSourceHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginBottom: 12,
  },
  telegramSourceTitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  telegramSourceCard: {
    backgroundColor: lightColors.white,
    borderRadius: 12,
    padding: 16,
    borderWidth: 1,
    borderColor: "#0088cc20",
    shadowColor: "#0088cc",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 6,
    elevation: 3,
  },
  telegramChannelInfo: {
    flexDirection: "row",
    gap: 14,
  },
  telegramChannelImage: {
    width: 56,
    height: 56,
    borderRadius: 28,
    borderWidth: 2,
    borderColor: "#0088cc",
  },
  telegramChannelImagePlaceholder: {
    width: 56,
    height: 56,
    borderRadius: 28,
    backgroundColor: "#0088cc10",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 2,
    borderColor: "#0088cc",
  },
  telegramChannelDetails: {
    flex: 1,
    justifyContent: "center",
  },
  telegramChannelName: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 4,
  },
  telegramChannelDescription: {
    fontSize: 13,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginBottom: 10,
  },
  viewOnTelegramButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    backgroundColor: "#0088cc",
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 8,
    alignSelf: "flex-start",
  },
  viewOnTelegramText: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.white,
  },

  // 404 Not Found Screen Styles
  notFoundContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 40,
    backgroundColor: lightColors.white,
  },
  notFoundImage: {
    width: 300,
    height: 300,
    marginBottom: 32,
  },
  notFoundTitle: {
    fontSize: 32,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginBottom: 16,
    textAlign: "center",
  },
  notFoundSubtitle: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginBottom: 40,
    textAlign: "center",
    lineHeight: 24,
  },
  notFoundButtonsContainer: {
    flexDirection: "row",
    gap: 16,
    flexWrap: "wrap",
    justifyContent: "center",
  },
  notFoundPrimaryButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    backgroundColor: lightColors.deepNavy,
    paddingVertical: 14,
    paddingHorizontal: 24,
    borderRadius: 8,
  },
  notFoundPrimaryButtonText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.white,
  },
  notFoundSecondaryButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    backgroundColor: lightColors.white,
    paddingVertical: 14,
    paddingHorizontal: 24,
    borderRadius: 8,
    borderWidth: 2,
    borderColor: lightColors.deepNavy,
  },
  notFoundSecondaryButtonText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },

  // Content Pages Styles (Privacy, Job Alerts, Career Advice, etc.)
  contentPage: {
    flex: 1,
    backgroundColor: lightColors.white,
  },
  contentPageHeader: {
    flexDirection: "row",
    alignItems: "center",
    padding: 24,
    borderBottomWidth: 1,
    borderBottomColor: "#e9ecef",
    gap: 16,
  },
  contentPageBackButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: "#f8f9fa",
    alignItems: "center",
    justifyContent: "center",
  },
  contentPageTitle: {
    fontSize: 28,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
  },
  contentPageBody: {
    padding: 24,
    maxWidth: 800,
    alignSelf: "center",
    width: "100%",
  },
  contentPageLastUpdated: {
    fontSize: 14,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginBottom: 32,
  },
  contentPageSection: {
    fontSize: 20,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginTop: 32,
    marginBottom: 16,
  },
  contentPageText: {
    fontSize: 16,
    fontFamily: fonts.regular,
    color: "#495057",
    lineHeight: 26,
    marginBottom: 16,
  },
  featureHeroSection: {
    alignItems: "center",
    padding: 40,
    backgroundColor: "#f8f9fa",
    borderRadius: 16,
    marginBottom: 32,
  },
  featureHeroTitle: {
    fontSize: 32,
    fontFamily: fonts.regular,
    color: lightColors.deepNavy,
    marginTop: 24,
    marginBottom: 12,
    textAlign: "center",
  },
  featureHeroSubtitle: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    textAlign: "center",
    lineHeight: 28,
  },
  contentPageCTA: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
    backgroundColor: lightColors.deepNavy,
    paddingVertical: 16,
    paddingHorizontal: 32,
    borderRadius: 8,
    marginTop: 40,
    alignSelf: "center",
  },
  contentPageCTAText: {
    fontSize: 18,
    fontFamily: fonts.regular,
    color: lightColors.white,
  },

  // Bookmarks Screen Styles
  bookmarksHeroSection: {
    paddingVertical: 60,
    paddingHorizontal: 24,
    position: "relative",
    overflow: "hidden",
    alignItems: "center",
  },
  bookmarksHeroContent: {
    alignItems: "center",
    zIndex: 1,
  },
  bookmarksHeroIconCircle: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: "rgba(247, 183, 49, 0.2)",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 20,
  },
  bookmarksHeroTitle: {
    fontSize: 32,
    fontWeight: "700",
    textAlign: "center",
    marginBottom: 12,
  },
  bookmarksHeroSubtitle: {
    fontSize: 16,
    textAlign: "center",
  },
  bookmarksContentContainer: {
    padding: 24,
    marginTop: -20,
  },
  bookmarksLoadingContainer: {
    padding: 60,
    alignItems: "center",
    gap: 16,
  },
  bookmarksLoadingText: {
    fontSize: 16,
  },
  bookmarksEmptyState: {
    borderRadius: 16,
    padding: 60,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
  },
  bookmarksEmptyIconCircle: {
    width: 160,
    height: 160,
    borderRadius: 80,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 32,
  },
  bookmarksEmptyTitle: {
    fontSize: 24,
    fontWeight: "700",
    marginBottom: 12,
  },
  bookmarksEmptySubtitle: {
    fontSize: 16,
    textAlign: "center",
    lineHeight: 24,
    marginBottom: 32,
    maxWidth: 400,
  },
  bookmarksEmptyButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 24,
    paddingVertical: 14,
    borderRadius: 12,
    gap: 8,
  },
  bookmarksEmptyButtonText: {
    fontSize: 16,
    fontWeight: "600",
  },
  bookmarksGridContainer: {
    gap: 24,
  },
  bookmarksGridHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 16,
  },
  bookmarksGridTitle: {
    fontSize: 24,
    fontWeight: "700",
  },
  bookmarksGridStats: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  bookmarksGridStatsText: {
    fontSize: 14,
    fontWeight: "500",
  },
  bookmarksGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 20,
  },
  modernBookmarkCard: {
    width: "48%",
    minWidth: 280,
    borderRadius: 16,
    padding: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
    elevation: 3,
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.05)",
  },
  modernBookmarkCardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 16,
  },
  modernBookmarkLogoContainer: {
    width: 56,
    height: 56,
  },
  modernBookmarkLogo: {
    width: 56,
    height: 56,
    borderRadius: 12,
  },
  modernBookmarkLogoPlaceholder: {
    width: 56,
    height: 56,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
  },
  modernBookmarkLogoText: {
    fontSize: 24,
    fontWeight: "700",
  },
  modernRemoveBookmarkButton: {
    width: 32,
    height: 32,
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "center",
  },
  modernBookmarkCardBody: {
    gap: 12,
  },
  modernBookmarkJobTitle: {
    fontSize: 18,
    fontWeight: "700",
    lineHeight: 24,
  },
  modernBookmarkCompany: {
    fontSize: 14,
  },
  modernBookmarkTags: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  modernBookmarkTag: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 8,
    gap: 4,
    borderWidth: 1,
  },
  modernBookmarkTagText: {
    fontSize: 12,
    fontWeight: "500",
  },
  modernBookmarkSalary: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 12,
    paddingVertical: 8,
    borderRadius: 8,
    gap: 6,
  },
  modernBookmarkSalaryText: {
    fontSize: 14,
    fontWeight: "600",
  },
  modernBookmarkCardFooter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 16,
    paddingTop: 16,
    borderTopWidth: 1,
  },
  modernBookmarkDate: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  modernBookmarkDateText: {
    fontSize: 12,
  },
  modernBookmarkApplyButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
    gap: 6,
  },
  modernBookmarkApplyText: {
    fontSize: 14,
    fontWeight: "600",
  },

  // Company Posted Jobs Card Styles (Revamped)
  companyJobCard: {
    backgroundColor: "#ffffff",
    borderRadius: 16,
    marginBottom: 20,
    borderWidth: 1,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
    elevation: 4,
  },
  companyJobAccent: {
    height: 4,
    width: "100%",
  },
  companyJobContent: {
    padding: 20,
  },
  companyJobHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 16,
  },
  companyJobHeaderLeft: {
    flexDirection: "row",
    flex: 1,
    gap: 14,
  },
  companyJobLogo: {
    width: 56,
    height: 56,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
  },
  companyJobInfo: {
    flex: 1,
    gap: 8,
  },
  companyJobTitle: {
    fontSize: 20,
    fontWeight: "700",
    lineHeight: 26,
    fontFamily: fonts.regular,
  },
  companyJobMetaRow: {
    flexDirection: "row",
    gap: 8,
    flexWrap: "wrap",
  },
  companyJobBadge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 8,
  },
  companyJobBadgeText: {
    fontSize: 12,
    fontWeight: "600",
    fontFamily: fonts.regular,
  },
  companyJobActions: {
    flexDirection: "row",
    gap: 8,
  },
  companyJobActionButton: {
    width: 40,
    height: 40,
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  companyJobDetailsRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
    flexWrap: "wrap",
    gap: 8,
  },
  companyJobDetail: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  companyJobDetailText: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  companyJobTag: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 8,
    borderWidth: 1,
  },
  companyJobTagText: {
    fontSize: 12,
    fontWeight: "600",
    fontFamily: fonts.regular,
  },
  companyJobSalaryContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 10,
    marginBottom: 14,
    alignSelf: "flex-start",
  },
  companyJobSalary: {
    fontSize: 16,
    fontWeight: "700",
    fontFamily: fonts.regular,
  },
  companyJobDescription: {
    fontSize: 14,
    lineHeight: 22,
    marginBottom: 14,
    fontFamily: fonts.regular,
  },
  companyJobTagsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 16,
  },
  companyJobSkillTag: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 8,
  },
  companyJobSkillTagText: {
    fontSize: 12,
    fontWeight: "500",
    fontFamily: fonts.regular,
  },
  companyJobMoreTags: {
    fontSize: 12,
    fontStyle: "italic",
    alignSelf: "center",
    fontFamily: fonts.regular,
  },
  companyJobFooter: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: 16,
    borderTopWidth: 1,
  },
  companyJobFooterLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  companyJobDate: {
    fontSize: 13,
    fontFamily: fonts.regular,
  },
  companyJobFooterRight: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  companyJobStatusToggle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  companyJobStatusText: {
    fontSize: 13,
    fontWeight: "600",
    fontFamily: fonts.regular,
  },
  companyJobStats: {
    flexDirection: "row",
    gap: 16,
  },
  companyJobStat: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  companyJobStatText: {
    fontSize: 13,
    fontWeight: "500",
    fontFamily: fonts.regular,
  },

  // Revamped Job Modal Styles
  jobModalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    justifyContent: "center",
    alignItems: "center",
    padding: 0,
  },
  jobModalContainer: {
    width: "95%",
    maxWidth: 900,
    height: "95%",
    borderRadius: 20,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.3,
    shadowRadius: 20,
    elevation: 10,
  },
  jobModalHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 24,
    borderBottomWidth: 1,
  },
  jobModalHeaderContent: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    gap: 16,
  },
  jobModalIconCircle: {
    width: 56,
    height: 56,
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "center",
  },
  jobModalHeaderText: {
    flex: 1,
  },
  jobModalTitle: {
    fontSize: 22,
    fontWeight: "700",
    marginBottom: 4,
    fontFamily: fonts.regular,
  },
  jobModalSubtitle: {
    fontSize: 14,
    fontFamily: fonts.regular,
    lineHeight: 18,
  },
  jobModalCloseButton: {
    width: 40,
    height: 40,
    borderRadius: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  jobModalScrollView: {
    flex: 1,
  },
  jobModalBody: {
    padding: 24,
    gap: 20,
  },
  jobFormSection: {
    borderRadius: 16,
    padding: 20,
    marginBottom: 4,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
  },
  jobFormSectionHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    marginBottom: 20,
    paddingBottom: 12,
    borderBottomWidth: 2,
    borderBottomColor: "#f0f0f0",
  },
  jobFormSectionTitle: {
    fontSize: 16,
    fontWeight: "600",
    fontFamily: fonts.regular,
  },
  jobFormField: {
    marginBottom: 20,
  },
  jobFormRow: {
    flexDirection: "row",
    gap: 0,
  },
  jobFormLabel: {
    fontSize: 14,
    fontWeight: "600",
    marginBottom: 8,
    fontFamily: fonts.regular,
  },
  jobFormErrorText: {
    fontSize: 12,
    marginTop: 4,
    fontFamily: fonts.regular,
  },
  jobFormHint: {
    fontSize: 12,
    marginBottom: 8,
    fontFamily: fonts.regular,
    lineHeight: 16,
  },
  jobInputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    borderWidth: 1.5,
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 14,
  },
  jobFormInput: {
    flex: 1,
    fontSize: 15,
    fontFamily: fonts.regular,
    padding: 0,
    margin: 0,
  },
  jobSelectWrapper: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    borderWidth: 1.5,
    borderRadius: 12,
    paddingHorizontal: 16,
    overflow: "hidden",
  },
  jobFormTextArea: {
    borderWidth: 1.5,
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 14,
    fontSize: 15,
    fontFamily: fonts.regular,
    minHeight: 120,
  },
  jobFormToggle: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 16,
    borderRadius: 12,
    marginBottom: 20,
  },
  jobFormToggleLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    flex: 1,
  },
  jobFormToggleLabel: {
    fontSize: 15,
    fontWeight: "600",
    fontFamily: fonts.regular,
  },
  jobFormToggleHint: {
    fontSize: 12,
    marginTop: 2,
    fontFamily: fonts.regular,
  },
  tagsScrollContainer: {
    maxHeight: 300,
    borderWidth: 1.5,
    borderRadius: 12,
    borderColor: lightColors.lightGray,
    marginTop: 8,
  },
  tagsSelectionContainer: {
    padding: 12,
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  tagSelectionButton: {
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 20,
    borderWidth: 1.5,
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  tagSelectionText: {
    fontSize: 13,
    fontWeight: "500",
    fontFamily: fonts.regular,
  },
  emptyTagsMessage: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    padding: 20,
    borderRadius: 12,
    marginTop: 8,
  },
  emptyTagsText: {
    flex: 1,
    fontSize: 14,
    fontFamily: fonts.regular,
    lineHeight: 20,
  },
  selectedTagsContainer: {
    marginTop: 16,
    padding: 12,
    backgroundColor: lightColors.cream,
    borderRadius: 12,
  },
  selectedTagsLabel: {
    fontSize: 12,
    fontWeight: "600",
    marginBottom: 8,
    fontFamily: fonts.regular,
  },
  selectedTagsWrapper: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
  },
  selectedTag: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
  },
  selectedTagText: {
    fontSize: 12,
    fontWeight: "600",
    fontFamily: fonts.regular,
  },
  jobModalFooter: {
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 12,
    padding: 24,
    borderTopWidth: 1,
  },
  jobModalSecondaryButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingHorizontal: 24,
    paddingVertical: 14,
    borderRadius: 12,
    borderWidth: 1.5,
    minWidth: 120,
    justifyContent: "center",
  },
  jobModalSecondaryButtonText: {
    fontSize: 15,
    fontWeight: "600",
    fontFamily: fonts.regular,
  },
  jobModalPrimaryButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingHorizontal: 32,
    paddingVertical: 14,
    borderRadius: 12,
    minWidth: 140,
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 4,
  },
  jobModalPrimaryButtonText: {
    fontSize: 15,
    fontWeight: "700",
    fontFamily: fonts.regular,
  },

  // Custom Alert/Confirmation Modal Styles
  customModalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  customModalContainer: {
    width: "100%",
    maxWidth: 400,
    borderRadius: 16,
    padding: 24,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 8,
  },
  customModalHeader: {
    alignItems: "center",
    marginBottom: 24,
  },
  customModalIconContainer: {
    width: 64,
    height: 64,
    borderRadius: 32,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
  },
  customModalTitle: {
    fontSize: 20,
    fontWeight: "700",
    marginBottom: 8,
    textAlign: "center",
    fontFamily: fonts.bold,
  },
  customModalMessage: {
    fontSize: 15,
    lineHeight: 22,
    textAlign: "center",
    fontFamily: fonts.regular,
  },
  customModalActions: {
    flexDirection: "row",
    gap: 12,
  },
  customModalButton: {
    flex: 1,
    paddingVertical: 14,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
  },
  customModalCancelButton: {
    backgroundColor: "transparent",
    borderWidth: 2,
  },
  customModalConfirmButton: {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  customModalButtonText: {
    fontSize: 15,
    fontWeight: "600",
    fontFamily: fonts.semiBold,
  },

  // Job Application Form Styles
  applicationFormContainer: {
    flex: 1,
    padding: 20,
  },
  applicationJobCard: {
    padding: 20,
    borderRadius: 12,
    borderWidth: 1,
    marginBottom: 20,
  },
  applicationJobTitle: {
    fontSize: 20,
    fontWeight: "700",
    marginBottom: 6,
    fontFamily: fonts.bold,
  },
  applicationJobCompany: {
    fontSize: 16,
    marginBottom: 12,
    fontFamily: fonts.regular,
  },
  applicationJobMeta: {
    flexDirection: "row",
    gap: 8,
  },
  applicationJobBadge: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 6,
  },
  applicationJobBadgeText: {
    fontSize: 13,
    fontWeight: "500",
    fontFamily: fonts.regular,
  },
  applicationFormSection: {
    padding: 20,
    borderRadius: 12,
    borderWidth: 1,
    marginBottom: 20,
  },
  applicationFormSectionTitle: {
    fontSize: 18,
    fontWeight: "700",
    marginBottom: 8,
    fontFamily: fonts.bold,
  },
  applicationFormNote: {
    fontSize: 14,
    marginBottom: 16,
    lineHeight: 20,
    fontFamily: fonts.regular,
  },
  applicationFormGroup: {
    marginBottom: 20,
  },
  applicationFormLabel: {
    fontSize: 15,
    fontWeight: "600",
    marginBottom: 8,
    fontFamily: fonts.bold,
  },
  applicationFormInput: {
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    fontSize: 15,
    fontFamily: fonts.regular,
  },
  applicationFormTextarea: {
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    fontSize: 15,
    minHeight: 150,
    fontFamily: fonts.regular,
  },
  applicationFormError: {
    fontSize: 13,
    marginTop: 4,
    fontFamily: fonts.regular,
  },
  applicationFormHint: {
    fontSize: 13,
    marginTop: 4,
    fontFamily: fonts.regular,
  },
  applicationFormActions: {
    gap: 12,
    marginBottom: 40,
  },
  applicationFormSubmitButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingVertical: 16,
    borderRadius: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  applicationFormSubmitButtonText: {
    fontSize: 16,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },
  applicationFormCancelButton: {
    paddingVertical: 16,
    borderRadius: 10,
    borderWidth: 1,
    alignItems: "center",
  },
  applicationFormCancelButtonText: {
    fontSize: 16,
    fontWeight: "600",
    fontFamily: fonts.bold,
  },

  // Modern Apply Form Styles
  applyHeader: {
    paddingHorizontal: 20,
    paddingTop: 16,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
  },
  applyHeaderBack: {
    padding: 8,
    marginBottom: 12,
  },
  applyHeaderContent: {
    marginBottom: 16,
  },
  applyHeaderTitle: {
    fontSize: 24,
    fontWeight: "700",
    marginBottom: 4,
    fontFamily: fonts.bold,
  },
  applyHeaderSubtitle: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  applyProgressContainer: {
    height: 4,
    borderRadius: 2,
    overflow: "hidden",
  },
  applyProgressBar: {
    height: "100%",
    borderRadius: 2,
  },
  applyStepsContainer: {
    flexDirection: "row",
    paddingHorizontal: 20,
    paddingVertical: 16,
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
  },
  applyStepItem: {
    alignItems: "center",
    gap: 8,
    flex: 1,
  },
  applyStepCircle: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 2,
  },
  applyStepText: {
    fontSize: 12,
    fontWeight: "600",
    fontFamily: fonts.medium,
    textAlign: "center",
  },
  applyJobCard: {
    borderRadius: 16,
    marginBottom: 20,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.12,
    shadowRadius: 8,
    elevation: 4,
  },
  applyJobCardHeader: {
    flexDirection: "row",
    alignItems: "center",
    padding: 20,
    gap: 16,
  },
  applyJobIcon: {
    width: 56,
    height: 56,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
  },
  applyJobTitle: {
    fontSize: 18,
    fontWeight: "700",
    marginBottom: 4,
    fontFamily: fonts.bold,
  },
  applyJobCompany: {
    fontSize: 15,
    fontFamily: fonts.regular,
  },
  applyJobMeta: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
    paddingHorizontal: 20,
    paddingBottom: 20,
  },
  applyJobMetaItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  applyJobMetaText: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  applyFormSection: {
    borderRadius: 16,
    padding: 24,
    marginBottom: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 2,
  },
  applySectionHeader: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 12,
    marginBottom: 24,
  },
  applySectionIcon: {
    width: 44,
    height: 44,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
  },
  applySectionTitle: {
    fontSize: 20,
    fontWeight: "700",
    marginBottom: 4,
    fontFamily: fonts.bold,
  },
  applySectionSubtitle: {
    fontSize: 14,
    lineHeight: 20,
    fontFamily: fonts.regular,
  },
  applyFormGroup: {
    marginBottom: 20,
  },
  applyFormLabel: {
    fontSize: 15,
    fontWeight: "600",
    marginBottom: 10,
    fontFamily: fonts.medium,
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  applyInputContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 2,
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 4,
    gap: 12,
  },
  applyInput: {
    flex: 1,
    fontSize: 15,
    paddingVertical: 12,
    fontFamily: fonts.regular,
  },
  applyTextareaContainer: {
    borderWidth: 2,
    borderRadius: 12,
    padding: 16,
  },
  applyTextarea: {
    fontSize: 15,
    minHeight: 200,
    fontFamily: fonts.regular,
    textAlignVertical: "top",
  },
  applyErrorContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    marginTop: 8,
  },
  applyFormError: {
    fontSize: 13,
    fontFamily: fonts.regular,
  },
  applyHintContainer: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 6,
    marginTop: 8,
  },
  applyFormHint: {
    fontSize: 13,
    flex: 1,
    lineHeight: 18,
    fontFamily: fonts.regular,
  },
  applyCoverLetterFooter: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: 8,
    marginTop: 12,
    padding: 12,
    backgroundColor: "#FEF3C7",
    borderRadius: 8,
  },
  applyNavigationButtons: {
    flexDirection: "row",
    gap: 12,
    marginBottom: 40,
  },
  applyBackButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingVertical: 16,
    paddingHorizontal: 24,
    borderRadius: 12,
    borderWidth: 2,
    flex: 1,
  },
  applyBackButtonText: {
    fontSize: 16,
    fontWeight: "600",
    fontFamily: fonts.medium,
    flexShrink: 1,
  },
  applyNextButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingVertical: 16,
    paddingHorizontal: 24,
    borderRadius: 12,
    flex: 1,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 4,
  },
  applyNextButtonText: {
    fontSize: 16,
    fontWeight: "700",
    fontFamily: fonts.bold,
    flexShrink: 1,
  },
  applySubmitButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    paddingVertical: 18,
    paddingHorizontal: 32,
    borderRadius: 12,
    flex: 1,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.2,
    shadowRadius: 10,
    elevation: 6,
  },
  applySubmitButtonText: {
    fontSize: 17,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },
  applyAlreadyAppliedCard: {
    maxWidth: 500,
    width: "90%",
    borderRadius: 20,
    padding: 32,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 8,
  },
  applyAlreadyAppliedIcon: {
    width: 120,
    height: 120,
    borderRadius: 60,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 24,
  },
  applyAlreadyAppliedTitle: {
    fontSize: 26,
    fontWeight: "700",
    marginBottom: 12,
    textAlign: "center",
    fontFamily: fonts.bold,
  },
  applyAlreadyAppliedMessage: {
    fontSize: 16,
    lineHeight: 24,
    textAlign: "center",
    marginBottom: 24,
    fontFamily: fonts.regular,
  },
  applyStatusBadge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 12,
    marginBottom: 24,
  },
  applyStatusBadgeText: {
    fontSize: 16,
    fontWeight: "600",
    fontFamily: fonts.medium,
  },
  applyInfoBox: {
    flexDirection: "row",
    gap: 12,
    padding: 16,
    borderRadius: 12,
    marginBottom: 32,
  },
  applyInfoText: {
    flex: 1,
    fontSize: 14,
    lineHeight: 20,
    fontFamily: fonts.regular,
  },
  applyBackToJobsButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    paddingVertical: 16,
    paddingHorizontal: 32,
    borderRadius: 12,
    width: "100%",
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 4,
  },
  applyBackToJobsButtonText: {
    fontSize: 16,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },
  applyGoBackButton: {
    paddingVertical: 14,
    paddingHorizontal: 32,
    borderRadius: 12,
    borderWidth: 2,
    width: "100%",
    alignItems: "center",
  },
  applyGoBackButtonText: {
    fontSize: 15,
    fontWeight: "600",
    fontFamily: fonts.medium,
  },
  applyCoverLetterInfo: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 12,
    marginTop: 12,
  },
  applyCharCounter: {
    fontSize: 12,
    fontFamily: fonts.regular,
  },

  // Company Applicants Screen Styles
  applicantsSearchContainer: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
  },
  applicantsSearchBar: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 12,
    marginBottom: 12,
  },
  applicantsSearchInput: {
    flex: 1,
    fontSize: 15,
    fontFamily: fonts.regular,
  },
  applicantsSortContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  applicantsSortLabel: {
    fontSize: 13,
    fontWeight: "600",
    fontFamily: fonts.medium,
  },
  applicantsSortButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 8,
  },
  applicantsSortText: {
    fontSize: 13,
    fontWeight: "600",
    fontFamily: fonts.medium,
  },
  applicantsFilterContainer: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
  },
  applicantsFilterTab: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 20,
    marginRight: 8,
  },
  applicantsFilterTabText: {
    fontSize: 14,
    fontWeight: "600",
    fontFamily: fonts.medium,
  },
  applicantCard: {
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  applicantHeader: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 12,
  },
  applicantAvatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },
  applicantAvatarText: {
    fontSize: 20,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },
  applicantName: {
    fontSize: 16,
    fontWeight: "700",
    marginBottom: 4,
    fontFamily: fonts.bold,
  },
  applicantEmail: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  applicantStatusBadge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 12,
  },
  applicantStatusText: {
    fontSize: 12,
    fontWeight: "600",
    fontFamily: fonts.medium,
  },
  applicantDetails: {
    marginBottom: 12,
    gap: 8,
  },
  applicantDetailRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  applicantDetailText: {
    fontSize: 14,
    flex: 1,
    fontFamily: fonts.regular,
  },
  applicantLinks: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
    marginBottom: 12,
  },
  applicantLinkBadge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 12,
  },
  applicantLinkText: {
    fontSize: 12,
    fontWeight: "500",
    fontFamily: fonts.medium,
  },
  applicantFooter: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: 12,
    borderTopWidth: 1,
  },
  applicantFooterLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  applicantDate: {
    fontSize: 12,
    fontFamily: fonts.regular,
  },
  applicantViewButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 8,
  },
  applicantViewButtonText: {
    fontSize: 13,
    fontWeight: "600",
    fontFamily: fonts.medium,
  },
  applicantModalOverlay: {
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    justifyContent: "flex-end",
  },
  applicantModalContainer: {
    maxHeight: "90%",
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: -4 },
    shadowOpacity: 0.2,
    shadowRadius: 8,
    elevation: 8,
  },
  applicantModalHeader: {
    flexDirection: "row",
    alignItems: "flex-start",
    padding: 20,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
  },
  applicantModalTitle: {
    fontSize: 20,
    fontWeight: "700",
    marginBottom: 4,
    fontFamily: fonts.bold,
  },
  applicantModalSubtitle: {
    fontSize: 14,
    fontFamily: fonts.regular,
  },
  applicantModalSection: {
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
  },
  applicantModalSectionTitle: {
    fontSize: 16,
    fontWeight: "700",
    marginBottom: 16,
    fontFamily: fonts.bold,
  },
  applicantStatusButtons: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  applicantStatusButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderRadius: 8,
  },
  applicantStatusButtonText: {
    fontSize: 13,
    fontWeight: "600",
    fontFamily: fonts.medium,
  },
  applicantModalInfoRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    marginBottom: 12,
  },
  applicantModalInfoText: {
    fontSize: 15,
    flex: 1,
    fontFamily: fonts.regular,
  },
  applicantModalLinkRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
  },
  applicantModalLinkText: {
    fontSize: 15,
    flex: 1,
    fontFamily: fonts.regular,
  },
  applicantModalCoverLetter: {
    fontSize: 15,
    lineHeight: 24,
    fontFamily: fonts.regular,
  },
  applicantModalNotesInput: {
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    fontSize: 15,
    minHeight: 120,
    textAlignVertical: "top",
    fontFamily: fonts.regular,
    marginBottom: 12,
  },
  applicantModalSaveNotesButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingVertical: 12,
    borderRadius: 8,
  },
  applicantModalSaveNotesButtonText: {
    fontSize: 15,
    fontWeight: "600",
    fontFamily: fonts.medium,
  },
  applicantModalFooter: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    padding: 20,
    borderTopWidth: 1,
  },
  applicantModalDate: {
    fontSize: 13,
    fontFamily: fonts.regular,
  },
  // Company Dashboard Mobile Toolbar Styles
  companyDashboardToolbar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: lightColors.white,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.lightGray,
    width: "100%",
  },
  companyDashboardToolbarLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
    flex: 1,
    overflow: "hidden",
  },
  companyDashboardToolbarRight: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  companyDashboardToolbarTitle: {
    fontSize: 16,
    fontWeight: "600",
    fontFamily: fonts.bold,
    color: lightColors.deepNavy,
  },
  companyDashboardToolbarSubtitle: {
    fontSize: 12,
    fontFamily: fonts.regular,
    color: lightColors.warmGray,
    marginTop: 2,
  },
  toolbarIconButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: "center",
    justifyContent: "center",
    // backgroundColor set inline based on dark/light mode
  },
  mobileTopBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
    backgroundColor: lightColors.white,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.lightGray,
  },
  mobileBottomNav: {
    backgroundColor: lightColors.white,
    borderTopWidth: 1,
    borderTopColor: lightColors.lightGray,
    paddingVertical: 8,
    paddingBottom: Platform.OS === "ios" ? 20 : 8,
  },
  mobileNavItem: {
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 8,
    minWidth: 80,
    borderRadius: 12,
    marginHorizontal: 4,
  },
  mobileNavText: {
    fontSize: 11,
    fontFamily: fonts.medium,
    marginTop: 4,
  },
  // Expandable Search Styles
  expandedSearchContainer: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    backgroundColor: lightColors.lightGray,
    borderRadius: 12,
    paddingHorizontal: 12,
    marginRight: 8,
  },
  expandedSearchInput: {
    flex: 1,
    fontSize: 16,
    paddingVertical: 10,
    color: lightColors.deepNavy,
    fontFamily: fonts.regular,
  },
  expandedSearchClose: {
    padding: 4,
  },
  mobileHeaderActions: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  // More Menu Dropdown Styles
  moreMenuDropdown: {
    position: "absolute",
    backgroundColor: lightColors.white,
    borderRadius: 12,
    paddingVertical: 8,
    minWidth: 200,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 12,
    elevation: 8,
    borderWidth: 1,
    borderColor: lightColors.lightGray,
  },
  moreMenuItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 12,
    gap: 12,
  },
  moreMenuText: {
    fontSize: 15,
    color: lightColors.deepNavy,
    fontFamily: fonts.medium,
    flex: 1,
  },
  moreMenuSecondaryText: {
    fontSize: 13,
    color: lightColors.warmGray,
    fontFamily: fonts.regular,
  },
  filterBadge: {
    backgroundColor: lightColors.beeYellow,
    borderRadius: 12,
    paddingHorizontal: 8,
    paddingVertical: 2,
    marginLeft: 8,
  },
  filterBadgeText: {
    fontSize: 12,
    fontWeight: "600",
    color: lightColors.deepNavy,
  },
  moreMenuDivider: {
    height: 1,
    backgroundColor: lightColors.lightGray,
    marginVertical: 4,
  },
  // Mobile Menu Styles
  mobileMenuOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
  },
  mobileMenuBackdrop: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  mobileMenu: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: "80%",
    maxWidth: 320,
    shadowColor: "#000",
    shadowOffset: { width: 2, height: 0 },
    shadowOpacity: 0.25,
    shadowRadius: 8,
    elevation: 10,
  },
  mobileMenuHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: lightColors.lightGray,
  },
  mobileMenuTitle: {
    fontSize: 20,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },
  mobileMenuContent: {
    flex: 1,
    paddingVertical: 8,
  },
  mobileMenuButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingVertical: 14,
    paddingHorizontal: 20,
    borderRadius: 12,
    marginHorizontal: 20,
    marginVertical: 6,
  },
  mobileMenuButtonText: {
    fontSize: 16,
    fontWeight: "600",
    fontFamily: fonts.semiBold,
  },
  mobileMenuItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 24,
    paddingVertical: 14,
    borderBottomWidth: 1,
    minHeight: 56,
  },
  mobileMenuItemText: {
    fontSize: 15,
    fontFamily: fonts.medium,
    flex: 1,
    letterSpacing: 0.3,
    marginLeft: 14,
    lineHeight: 20,
  },
  // Drawer Profile Styles
  drawerProfileSection: {
    paddingTop: 50,
    paddingBottom: 30,
    paddingHorizontal: 20,
    position: "relative",
  },
  drawerCloseButton: {
    position: "absolute",
    top: 10,
    right: 10,
    padding: 8,
    zIndex: 10,
  },
  drawerProfileContent: {
    alignItems: "center",
    marginTop: 20,
  },
  drawerProfilePicture: {
    width: 90,
    height: 90,
    borderRadius: 45,
    borderWidth: 4,
    borderColor: lightColors.beeYellow,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
  },
  drawerProfilePlaceholder: {
    width: 90,
    height: 90,
    borderRadius: 45,
    alignItems: "center",
    justifyContent: "center",
    borderWidth: 4,
    borderColor: lightColors.white,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
  },
  drawerProfileInitial: {
    fontSize: 32,
    fontWeight: "700",
    color: lightColors.deepNavy,
    fontFamily: fonts.bold,
  },
  drawerProfileName: {
    fontSize: 20,
    fontWeight: "700",
    color: lightColors.white,
    marginTop: 16,
    fontFamily: fonts.bold,
    letterSpacing: 0.5,
  },
  drawerProfileEmail: {
    fontSize: 14,
    color: "rgba(255, 255, 255, 0.7)",
    marginTop: 6,
    fontFamily: fonts.regular,
  },
  drawerRoleBadge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 16,
    paddingVertical: 6,
    borderRadius: 16,
    marginTop: 14,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 3,
  },
  drawerRoleText: {
    fontSize: 12,
    fontWeight: "700",
    color: lightColors.deepNavy,
    fontFamily: fonts.bold,
    letterSpacing: 0.3,
  },
  drawerGuestSection: {
    paddingTop: 50,
    paddingBottom: 24,
    paddingHorizontal: 20,
  },
  drawerGuestContent: {
    alignItems: "center",
    marginTop: 20,
  },
  drawerGuestIcon: {
    width: 90,
    height: 90,
    borderRadius: 45,
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 6,
    elevation: 6,
  },
  drawerGuestTitle: {
    fontSize: 20,
    fontWeight: "700",
    marginTop: 18,
    fontFamily: fonts.bold,
    letterSpacing: 0.5,
  },
  drawerGuestSubtitle: {
    fontSize: 13,
    marginTop: 4,
    textAlign: "center",
    fontFamily: fonts.regular,
  },
  drawerFooter: {
    marginTop: "auto",
    paddingHorizontal: 20,
    paddingVertical: 16,
    borderTopWidth: 1,
    borderTopColor: lightColors.lightGray,
  },
  drawerVersionContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    justifyContent: "center",
    marginBottom: 4,
  },
  drawerVersionText: {
    fontSize: 12,
    fontFamily: fonts.regular,
  },
  drawerCopyrightText: {
    fontSize: 11,
    textAlign: "center",
    fontFamily: fonts.regular,
  },
  drawerSectionHeader: {
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 12,
  },
  drawerSectionTitle: {
    fontSize: 11,
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: 1.2,
    fontFamily: fonts.bold,
  },
  drawerMenuGroup: {
    paddingHorizontal: 16,
    gap: 8,
    marginBottom: 4,
  },
  drawerMenuCard: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 14,
    paddingVertical: 12,
    borderRadius: 12,
    borderWidth: 1,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
  },
  drawerMenuIconContainer: {
    width: 36,
    height: 36,
    borderRadius: 10,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },
  drawerMenuCardText: {
    fontSize: 15,
    fontFamily: fonts.medium,
    flex: 1,
    letterSpacing: 0.2,
  },
  // Insights Content Styles
  insightCardHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 16,
    paddingBottom: 12,
    borderBottomWidth: 2,
    borderBottomColor: lightColors.beeYellow,
  },
  insightIcon: {
    fontSize: 28,
    marginRight: 12,
  },
  insightTitle: {
    fontSize: 18,
    fontWeight: "700",
    flex: 1,
    fontFamily: fonts.bold,
  },
  insightDataContainer: {
    marginTop: 8,
  },
  insightDataRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    paddingVertical: 12,
    gap: 12,
  },
  insightDataCell: {
    flex: 1,
    minWidth: 120,
  },
  insightDataLabel: {
    fontSize: 11,
    fontFamily: fonts.medium,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: 4,
  },
  insightDataValue: {
    fontSize: 15,
    fontFamily: fonts.semibold,
    fontWeight: "600",
  },
  insightSummaryTitle: {
    fontSize: 20,
    fontWeight: "700",
    fontFamily: fonts.bold,
    marginBottom: 12,
  },
  insightSummaryText: {
    fontSize: 14,
    lineHeight: 24,
    fontFamily: fonts.regular,
  },
  // Bar Chart Styles
  barChartContainer: {
    marginTop: 16,
  },
  barChartRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 16,
    gap: 12,
  },
  barLabel: {
    fontSize: 13,
    fontFamily: fonts.semibold,
    fontWeight: "600",
    width: 180,
  },
  barTrack: {
    flex: 1,
    height: 32,
    backgroundColor: "#E5E7EB",
    borderRadius: 16,
    overflow: "hidden",
  },
  barFill: {
    height: "100%",
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "flex-end",
    paddingRight: 10,
  },
  barText: {
    fontSize: 12,
    fontWeight: "700",
    color: "#1A1B3E",
    fontFamily: fonts.bold,
  },
  barPercentage: {
    fontSize: 14,
    fontWeight: "700",
    fontFamily: fonts.bold,
    width: 50,
    textAlign: "right",
  },
  // Salary Card Styles
  salaryGrid: {
    marginTop: 16,
    gap: 12,
  },
  salaryCard: {
    padding: 20,
    borderRadius: 12,
    borderLeftWidth: 4,
    marginBottom: 8,
  },
  salaryRank: {
    marginBottom: 8,
  },
  rankNumber: {
    fontSize: 24,
    fontWeight: "800",
    fontFamily: fonts.bold,
    opacity: 0.3,
  },
  salaryJobTitle: {
    fontSize: 16,
    fontWeight: "700",
    fontFamily: fonts.bold,
    marginBottom: 8,
  },
  salarAmount: {
    fontSize: 14,
    fontWeight: "600",
    fontFamily: fonts.semibold,
    marginBottom: 8,
    color: "#1A1B3E",
  },
  demandBadge: {
    alignSelf: "flex-start",
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 12,
  },
  demandText: {
    fontSize: 12,
    fontWeight: "600",
    fontFamily: fonts.semibold,
  },
  // Growth Chart Styles
  growthChartContainer: {
    marginTop: 16,
    gap: 20,
  },
  growthRow: {
    marginBottom: 4,
  },
  growthHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 8,
  },
  growthSector: {
    flex: 1,
    fontSize: 14,
    fontWeight: "600",
    fontFamily: fonts.semibold,
    paddingRight: 12,
  },
  growthRate: {
    fontSize: 16,
    fontWeight: "800",
    fontFamily: fonts.bold,
  },
  progressBarTrack: {
    height: 8,
    backgroundColor: "#E5E7EB",
    borderRadius: 4,
    overflow: "hidden",
    marginBottom: 4,
  },
  progressBarFill: {
    height: "100%",
    borderRadius: 4,
  },
  growthJobs: {
    fontSize: 12,
    fontFamily: fonts.regular,
  },
  // Regional Distribution Styles
  regionalContainer: {
    marginTop: 16,
  },
  regionalStats: {
    gap: 12,
  },
  regionalRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: "#F9FAFB",
    borderRadius: 8,
    gap: 12,
  },
  regionalDot: {
    width: 16,
    height: 16,
    borderRadius: 8,
  },
  regionalName: {
    fontSize: 14,
    fontWeight: "600",
    fontFamily: fonts.semibold,
  },
  regionalValue: {
    fontSize: 14,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },
  // Download Buttons
  downloadButtonsContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  secondaryButton: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 8,
    backgroundColor: "#F3F4F6",
    borderWidth: 1,
    borderColor: "#D1D5DB",
    gap: 8,
  },
  secondaryButtonText: {
    fontSize: 14,
    fontWeight: "600",
    fontFamily: fonts.semibold,
  },
  // Modern Insight Card Styles
  modernInsightCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    padding: 24,
    marginBottom: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 12,
    elevation: 2,
    borderWidth: 1,
    borderColor: "#F3F4F6",
  },
  modernCardHeader: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginBottom: 24,
    gap: 16,
  },
  iconBadge: {
    width: 48,
    height: 48,
    borderRadius: 12,
    backgroundColor: "#EEF2FF",
    justifyContent: "center",
    alignItems: "center",
  },
  modernCardIcon: {
    fontSize: 24,
  },
  cardTitleSection: {
    flex: 1,
  },
  modernCardTitle: {
    fontSize: 18,
    fontWeight: "700",
    fontFamily: fonts.bold,
    marginBottom: 4,
  },
  modernCardSubtitle: {
    fontSize: 13,
    fontFamily: fonts.regular,
  },
  // Modern Bar Chart
  modernBarChartContainer: {
    gap: 16,
  },
  modernBarRow: {
    gap: 12,
  },
  barLabelSection: {
    marginBottom: 8,
  },
  modernBarLabel: {
    fontSize: 14,
    fontWeight: "600",
    fontFamily: fonts.semibold,
    marginBottom: 4,
  },
  barCountText: {
    fontSize: 12,
    fontFamily: fonts.regular,
  },
  barGraphSection: {
    gap: 10,
  },
  modernBarTrack: {
    height: 12,
    backgroundColor: "#F3F4F6",
    borderRadius: 6,
    overflow: "hidden",
  },
  modernBarFill: {
    height: "100%",
    borderRadius: 6,
  },
  barMetrics: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  percentageText: {
    fontSize: 14,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },
  trendBadge: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
  },
  trendBadgeText: {
    fontSize: 11,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },
  // Premium Salary Cards
  premiumSalaryGrid: {
    gap: 16,
  },
  premiumSalaryCard: {
    padding: 20,
    borderRadius: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.03,
    shadowRadius: 4,
    elevation: 1,
  },
  salaryCardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  rankBadge: {
    width: 32,
    height: 32,
    borderRadius: 16,
    justifyContent: "center",
    alignItems: "center",
  },
  rankBadgeText: {
    fontSize: 14,
    fontWeight: "800",
    color: "#FFFFFF",
    fontFamily: fonts.bold,
  },
  demandPill: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 12,
    gap: 6,
  },
  demandDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
  },
  demandPillText: {
    fontSize: 11,
    fontWeight: "600",
    fontFamily: fonts.semibold,
  },
  premiumJobTitle: {
    fontSize: 16,
    fontWeight: "700",
    fontFamily: fonts.bold,
    marginBottom: 12,
    lineHeight: 22,
  },
  salaryAmountSection: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  premiumSalaryAmount: {
    fontSize: 13,
    fontWeight: "600",
    color: "#10B981",
    fontFamily: fonts.semibold,
  },
  // Growth List
  growthListContainer: {
    gap: 16,
  },
  modernGrowthRow: {
    gap: 12,
  },
  growthInfoSection: {
    marginBottom: 8,
  },
  modernSectorName: {
    fontSize: 14,
    fontWeight: "600",
    fontFamily: fonts.semibold,
    marginBottom: 4,
    lineHeight: 20,
  },
  modernJobsCount: {
    fontSize: 12,
    fontFamily: fonts.regular,
  },
  growthMetricsSection: {
    gap: 10,
  },
  modernProgressTrack: {
    height: 10,
    backgroundColor: "#F3F4F6",
    borderRadius: 5,
    overflow: "hidden",
  },
  modernProgressFill: {
    height: "100%",
    borderRadius: 5,
  },
  growthBadge: {
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "flex-start",
    paddingHorizontal: 10,
    paddingVertical: 6,
    borderRadius: 12,
    gap: 4,
  },
  modernGrowthText: {
    fontSize: 12,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },
  // Regional Map
  regionalMapContainer: {
    gap: 12,
  },
  modernRegionalRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: "#F9FAFB",
    borderRadius: 10,
    gap: 14,
  },
  regionalIconSection: {
    justifyContent: "center",
    alignItems: "center",
    width: 24,
  },
  locationDot: {
    borderRadius: 6,
  },
  regionalDataSection: {
    flex: 1,
    gap: 6,
  },
  regionalTopRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  modernRegionalName: {
    fontSize: 15,
    fontFamily: fonts.semibold,
  },
  regionalPercentBadge: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 10,
  },
  regionalPercentText: {
    fontSize: 13,
    fontWeight: "700",
    fontFamily: fonts.bold,
  },
  regionalBottomRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  modernRegionalJobs: {
    fontSize: 12,
    fontFamily: fonts.regular,
  },
  // Modern Insight Data Row
  modernInsightDataRow: {
    paddingVertical: 16,
    gap: 12,
  },
  // View Selector
  viewSelectorContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginBottom: 20,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: "#F3F4F6",
  },
  viewButton: {
    width: 36,
    height: 36,
    borderRadius: 8,
    backgroundColor: "#F3F4F6",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#E5E7EB",
  },
  viewButtonActive: {
    backgroundColor: "#4F46E5",
    borderColor: "#4F46E5",
  },
  downloadIndividualButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    paddingHorizontal: 12,
    paddingVertical: 8,
    backgroundColor: "#F3F4F6",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#E5E7EB",
  },
  downloadIndividualText: {
    fontSize: 12,
    fontWeight: "600",
    fontFamily: fonts.semibold,
  },
  // Bubble Chart
  bubbleChartContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 16,
    padding: 16,
  },
  bubbleItem: {
    alignItems: "center",
    gap: 8,
    width: 110,
  },
  bubble: {
    borderRadius: 999,
    justifyContent: "center",
    alignItems: "center",
  },
  bubbleValue: {
    fontSize: 16,
    fontWeight: "800",
    fontFamily: fonts.bold,
  },
  bubbleLabel: {
    fontSize: 11,
    textAlign: "center",
    fontFamily: fonts.regular,
  },
  // Pie Chart
  pieChartContainer: {
    padding: 16,
  },
  pieLegend: {
    gap: 12,
  },
  pieLegendItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  pieLegendColor: {
    width: 20,
    height: 20,
    borderRadius: 4,
  },
  pieLegendText: {
    flex: 1,
  },
  pieLegendLabel: {
    fontSize: 14,
    fontWeight: "600",
    fontFamily: fonts.semibold,
    marginBottom: 2,
  },
  pieLegendValue: {
    fontSize: 12,
    fontFamily: fonts.regular,
  },
  // Table
  tableContainer: {
    borderRadius: 8,
    overflow: "hidden",
    borderWidth: 1,
    borderColor: "#E5E7EB",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#F3F4F6",
    padding: 12,
    borderBottomWidth: 2,
    borderBottomColor: "#E5E7EB",
  },
  tableHeaderCell: {
    flex: 1,
    fontSize: 12,
    fontWeight: "700",
    fontFamily: fonts.bold,
    textTransform: "uppercase",
  },
  tableRow: {
    flexDirection: "row",
    padding: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#F3F4F6",
  },
  tableCell: {
    flex: 1,
    fontSize: 13,
    fontFamily: fonts.regular,
  },
});

// Add CSS animation for blinking cursor (web only)
if (Platform.OS === "web") {
  const style = document.createElement("style");
  style.textContent = `
    @keyframes blink {
      0%, 49% { opacity: 1; }
      50%, 100% { opacity: 0; }
    }
  `;
  document.head.appendChild(style);
}
